/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(667);
	module.exports = __webpack_require__(688);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var core = __webpack_require__(39);
	var hide = __webpack_require__(31);
	var redefine = __webpack_require__(32);
	var ctx = __webpack_require__(40);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(88);


/***/ },
/* 3 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 6 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(723)();
	}


/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 11 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(114)('wks');
	var uid = __webpack_require__(73);
	var Symbol = __webpack_require__(6).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 14 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 15 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 16 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(189);
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 18 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _getPrototypeOf(o);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(100);
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  Object.defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(101)["default"];
	function _getRequireWildcardCache(e) {
	  if ("function" != typeof WeakMap) return null;
	  var r = new WeakMap(),
	    t = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
	    return e ? t : r;
	  })(e);
	}
	function _interopRequireWildcard(e, r) {
	  if (!r && e && e.__esModule) return e;
	  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
	    "default": e
	  };
	  var t = _getRequireWildcardCache(r);
	  if (t && t.has(e)) return t.get(e);
	  var n = {
	      __proto__: null
	    },
	    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
	    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
	    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
	  }
	  return n["default"] = e, t && t.set(e, n), n;
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(101)["default"];
	var assertThisInitialized = __webpack_require__(15);
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return assertThisInitialized(self);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(8)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(5);
	var IE8_DOM_DEFINE = __webpack_require__(204);
	var toPrimitive = __webpack_require__(48);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(22) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(47);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var DOMProperty = __webpack_require__(83);
	var ReactDOMComponentFlags = __webpack_require__(245);
	
	var invariant = __webpack_require__(4);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(45);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(729);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(23);
	var createDesc = __webpack_require__(69);
	module.exports = __webpack_require__(22) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var hide = __webpack_require__(31);
	var has = __webpack_require__(34);
	var SRC = __webpack_require__(73)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(39).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var fails = __webpack_require__(8);
	var defined = __webpack_require__(45);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 34 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(92);
	var createDesc = __webpack_require__(69);
	var toIObject = __webpack_require__(37);
	var toPrimitive = __webpack_require__(48);
	var has = __webpack_require__(34);
	var IE8_DOM_DEFINE = __webpack_require__(204);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(22) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(34);
	var toObject = __webpack_require__(26);
	var IE_PROTO = __webpack_require__(147)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(91);
	var defined = __webpack_require__(45);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 38 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 39 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.6' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(28);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(8);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 42 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(40);
	var IObject = __webpack_require__(91);
	var toObject = __webpack_require__(26);
	var toLength = __webpack_require__(24);
	var asc = __webpack_require__(132);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 45 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1);
	var core = __webpack_require__(39);
	var fails = __webpack_require__(8);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 47 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(9);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var CallbackQueue = __webpack_require__(243);
	var PooledClass = __webpack_require__(75);
	var ReactFeatureFlags = __webpack_require__(248);
	var ReactReconciler = __webpack_require__(84);
	var Transaction = __webpack_require__(123);
	
	var invariant = __webpack_require__(4);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTime = formatTime;
	exports.isVideoChild = isVideoChild;
	exports.mergeAndSortChildren = mergeAndSortChildren;
	exports.deprecatedWarning = deprecatedWarning;
	exports.throttle = throttle;
	exports.mediaProperties = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(188));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(58));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(130));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	// NaN is the only value in javascript which is not equal to itself.
	// eslint-disable-next-line no-self-compare
	var isNaN = Number.isNaN || function (value) {
	  return value !== value;
	};
	/**
	 * @file format-time.js
	 *
	 * Format seconds as a time string, H:MM:SS or M:SS
	 * Supplying a guide (in seconds) will force a number of leading zeros
	 * to cover the length of the guide
	 *
	 * @param  {Number} seconds Number of seconds to be turned into a string
	 * @param  {Number} guide   Number (in seconds) to model the string after
	 * @return {String}         Time formatted as H:MM:SS or M:SS
	 * @private
	 * @function formatTime
	 */
	
	
	function formatTime() {
	  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
	  var s = Math.floor(seconds % 60);
	  var m = Math.floor(seconds / 60 % 60);
	  var h = Math.floor(seconds / 3600);
	  var gm = Math.floor(guide / 60 % 60);
	  var gh = Math.floor(guide / 3600); // handle invalid times
	
	  if (isNaN(seconds) || seconds === Infinity) {
	    // '-' is false for all relational operators (e.g. <, >=) so this setting
	    // will add the minimum number of fields specified by the guide
	    h = '-';
	    m = '-';
	    s = '-';
	  } // Check if we need to show hours
	
	
	  h = h > 0 || gh > 0 ? "".concat(h, ":") : ''; // If hours are showing, we may need to add a leading zero.
	  // Always show at least one digit of minutes.
	
	  m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":"); // Check if leading zero is need for seconds
	
	  s = s < 10 ? "0".concat(s) : s;
	  return h + m + s;
	} // Check if the element belongs to a video element
	// only accept <source />, <track />,
	// <MyComponent isVideoChild />
	// elements
	
	
	function isVideoChild(c) {
	  if (c.props && c.props.isVideoChild) {
	    return true;
	  }
	
	  return c.type === 'source' || c.type === 'track';
	}
	
	var find = function find(elements, func) {
	  return elements.filter(func)[0];
	}; // check if two components are the same type
	
	
	var isTypeEqual = function isTypeEqual(component1, component2) {
	  var type1 = component1.type;
	  var type2 = component2.type;
	
	  if (typeof type1 === 'string' || typeof type2 === 'string') {
	    return type1 === type2;
	  }
	
	  if (typeof type1 === 'function' && typeof type2 === 'function') {
	    return type1.displayName === type2.displayName;
	  }
	
	  return false;
	}; // merge default children
	// sort them by `order` property
	// filter them by `disabled` property
	
	
	function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
	  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	  var children = _react["default"].Children.toArray(_children);
	
	  var order = _parentProps.order,
	      parentProps = (0, _objectWithoutProperties2["default"])(_parentProps, ["order"]); // ignore order from parent
	
	  return children.filter(function (e) {
	    return !e.props.disabled;
	  }) // filter the disabled components
	  .concat(defaultChildren.filter(function (c) {
	    return !find(children, function (component) {
	      return isTypeEqual(component, c);
	    });
	  })).map(function (element) {
	    var defaultComponent = find(defaultChildren, function (c) {
	      return isTypeEqual(c, element);
	    });
	    var defaultProps = defaultComponent ? defaultComponent.props : {};
	    var props = (0, _objectSpread2["default"])({}, parentProps, defaultProps, element.props);
	
	    var e = _react["default"].cloneElement(element, props, element.props.children);
	
	    return e;
	  }).sort(function (a, b) {
	    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
	  });
	}
	/**
	 * Temporary utility for generating the warnings
	 */
	
	
	function deprecatedWarning(oldMethodCall, newMethodCall) {
	  // eslint-disable-next-line no-console
	  console.warn("WARNING: ".concat(oldMethodCall, " will be deprecated soon! Please use ").concat(newMethodCall, " instead."));
	}
	
	function throttle(callback, limit) {
	  var _arguments = arguments;
	  var wait = false;
	  return function () {
	    if (!wait) {
	      // eslint-disable-next-line prefer-rest-params
	      callback.apply(void 0, (0, _toConsumableArray2["default"])(_arguments));
	      wait = true;
	      setTimeout(function () {
	        wait = false;
	      }, limit);
	    }
	  };
	}
	
	var mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];
	exports.mediaProperties = mediaProperties;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(225);
	var $export = __webpack_require__(1);
	var shared = __webpack_require__(114)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(228))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(22)) {
	  var LIBRARY = __webpack_require__(60);
	  var global = __webpack_require__(6);
	  var fails = __webpack_require__(8);
	  var $export = __webpack_require__(1);
	  var $typed = __webpack_require__(116);
	  var $buffer = __webpack_require__(153);
	  var ctx = __webpack_require__(40);
	  var anInstance = __webpack_require__(64);
	  var propertyDesc = __webpack_require__(69);
	  var hide = __webpack_require__(31);
	  var redefineAll = __webpack_require__(70);
	  var toInteger = __webpack_require__(47);
	  var toLength = __webpack_require__(24);
	  var toIndex = __webpack_require__(223);
	  var toAbsoluteIndex = __webpack_require__(72);
	  var toPrimitive = __webpack_require__(48);
	  var has = __webpack_require__(34);
	  var classof = __webpack_require__(90);
	  var isObject = __webpack_require__(9);
	  var toObject = __webpack_require__(26);
	  var isArrayIter = __webpack_require__(139);
	  var create = __webpack_require__(66);
	  var getPrototypeOf = __webpack_require__(36);
	  var gOPN = __webpack_require__(67).f;
	  var getIterFn = __webpack_require__(155);
	  var uid = __webpack_require__(73);
	  var wks = __webpack_require__(13);
	  var createArrayMethod = __webpack_require__(44);
	  var createArrayIncludes = __webpack_require__(103);
	  var speciesConstructor = __webpack_require__(115);
	  var ArrayIterators = __webpack_require__(156);
	  var Iterators = __webpack_require__(77);
	  var $iterDetect = __webpack_require__(109);
	  var setSpecies = __webpack_require__(71);
	  var arrayFill = __webpack_require__(131);
	  var arrayCopyWithin = __webpack_require__(196);
	  var $DP = __webpack_require__(23);
	  var $GOPD = __webpack_require__(35);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 54 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(75);
	
	var emptyFunction = __webpack_require__(42);
	var warning = __webpack_require__(10);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 57 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(99);
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? Object(arguments[i]) : {};
	    var ownKeys = Object.keys(source);
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	  return target;
	}
	module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(13)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(31)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 60 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(73)('meta');
	var isObject = __webpack_require__(9);
	var has = __webpack_require__(34);
	var setDesc = __webpack_require__(23).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(8)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reverseBytes = exports.sliceBytes = exports.bytesMatch = exports.concatTypedArrays = exports.stringToBytes = exports.bytesToString = exports.numberToBytes = exports.bytesToNumber = exports.IS_LITTLE_ENDIAN = exports.IS_BIG_ENDIAN = exports.ENDIANNESS = exports.toBinaryString = exports.toHexString = exports.toUint8 = exports.isTypedArray = exports.isArrayBufferView = exports.padStart = exports.countBytes = exports.countBits = void 0;
	
	var _window = _interopRequireDefault(__webpack_require__(54));
	
	// const log2 = Math.log2 ? Math.log2 : (x) => (Math.log(x) / Math.log(2));
	var repeat = function repeat(str, len) {
	  var acc = '';
	
	  while (len--) {
	    acc += str;
	  }
	
	  return acc;
	}; // count the number of bits it would take to represent a number
	// we used to do this with log2 but BigInt does not support builtin math
	// Math.ceil(log2(x));
	
	
	var countBits = function countBits(x) {
	  return x.toString(2).length;
	}; // count the number of whole bytes it would take to represent a number
	
	
	exports.countBits = countBits;
	
	var countBytes = function countBytes(x) {
	  return Math.ceil(countBits(x) / 8);
	};
	
	exports.countBytes = countBytes;
	
	var padStart = function padStart(b, len, str) {
	  if (str === void 0) {
	    str = ' ';
	  }
	
	  return (repeat(str, len) + b.toString()).slice(-len);
	};
	
	exports.padStart = padStart;
	
	var isArrayBufferView = function isArrayBufferView(obj) {
	  if (ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(obj);
	  }
	
	  return obj && obj.buffer instanceof ArrayBuffer;
	};
	
	exports.isArrayBufferView = isArrayBufferView;
	
	var isTypedArray = function isTypedArray(obj) {
	  return isArrayBufferView(obj);
	};
	
	exports.isTypedArray = isTypedArray;
	
	var toUint8 = function toUint8(bytes) {
	  if (bytes instanceof Uint8Array) {
	    return bytes;
	  }
	
	  if (!Array.isArray(bytes) && !isTypedArray(bytes) && !(bytes instanceof ArrayBuffer)) {
	    // any non-number or NaN leads to empty uint8array
	    // eslint-disable-next-line
	    if (typeof bytes !== 'number' || typeof bytes === 'number' && bytes !== bytes) {
	      bytes = 0;
	    } else {
	      bytes = [bytes];
	    }
	  }
	
	  return new Uint8Array(bytes && bytes.buffer || bytes, bytes && bytes.byteOffset || 0, bytes && bytes.byteLength || 0);
	};
	
	exports.toUint8 = toUint8;
	
	var toHexString = function toHexString(bytes) {
	  bytes = toUint8(bytes);
	  var str = '';
	
	  for (var i = 0; i < bytes.length; i++) {
	    str += padStart(bytes[i].toString(16), 2, '0');
	  }
	
	  return str;
	};
	
	exports.toHexString = toHexString;
	
	var toBinaryString = function toBinaryString(bytes) {
	  bytes = toUint8(bytes);
	  var str = '';
	
	  for (var i = 0; i < bytes.length; i++) {
	    str += padStart(bytes[i].toString(2), 8, '0');
	  }
	
	  return str;
	};
	
	exports.toBinaryString = toBinaryString;
	var BigInt = _window.default.BigInt || Number;
	var BYTE_TABLE = [BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000')];
	
	var ENDIANNESS = function () {
	  var a = new Uint16Array([0xFFCC]);
	  var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
	
	  if (b[0] === 0xFF) {
	    return 'big';
	  }
	
	  if (b[0] === 0xCC) {
	    return 'little';
	  }
	
	  return 'unknown';
	}();
	
	exports.ENDIANNESS = ENDIANNESS;
	var IS_BIG_ENDIAN = ENDIANNESS === 'big';
	exports.IS_BIG_ENDIAN = IS_BIG_ENDIAN;
	var IS_LITTLE_ENDIAN = ENDIANNESS === 'little';
	exports.IS_LITTLE_ENDIAN = IS_LITTLE_ENDIAN;
	
	var bytesToNumber = function bytesToNumber(bytes, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$signed = _ref.signed,
	      signed = _ref$signed === void 0 ? false : _ref$signed,
	      _ref$le = _ref.le,
	      le = _ref$le === void 0 ? false : _ref$le;
	
	  bytes = toUint8(bytes);
	  var fn = le ? 'reduce' : 'reduceRight';
	  var obj = bytes[fn] ? bytes[fn] : Array.prototype[fn];
	  var number = obj.call(bytes, function (total, byte, i) {
	    var exponent = le ? i : Math.abs(i + 1 - bytes.length);
	    return total + BigInt(byte) * BYTE_TABLE[exponent];
	  }, BigInt(0));
	
	  if (signed) {
	    var max = BYTE_TABLE[bytes.length] / BigInt(2) - BigInt(1);
	    number = BigInt(number);
	
	    if (number > max) {
	      number -= max;
	      number -= max;
	      number -= BigInt(2);
	    }
	  }
	
	  return Number(number);
	};
	
	exports.bytesToNumber = bytesToNumber;
	
	var numberToBytes = function numberToBytes(number, _temp2) {
	  var _ref2 = _temp2 === void 0 ? {} : _temp2,
	      _ref2$le = _ref2.le,
	      le = _ref2$le === void 0 ? false : _ref2$le;
	
	  // eslint-disable-next-line
	  if (typeof number !== 'bigint' && typeof number !== 'number' || typeof number === 'number' && number !== number) {
	    number = 0;
	  }
	
	  number = BigInt(number);
	  var byteCount = countBytes(number);
	  var bytes = new Uint8Array(new ArrayBuffer(byteCount));
	
	  for (var i = 0; i < byteCount; i++) {
	    var byteIndex = le ? i : Math.abs(i + 1 - bytes.length);
	    bytes[byteIndex] = Number(number / BYTE_TABLE[i] & BigInt(0xFF));
	
	    if (number < 0) {
	      bytes[byteIndex] = Math.abs(~bytes[byteIndex]);
	      bytes[byteIndex] -= i === 0 ? 1 : 2;
	    }
	  }
	
	  return bytes;
	};
	
	exports.numberToBytes = numberToBytes;
	
	var bytesToString = function bytesToString(bytes) {
	  if (!bytes) {
	    return '';
	  } // TODO: should toUint8 handle cases where we only have 8 bytes
	  // but report more since this is a Uint16+ Array?
	
	
	  bytes = Array.prototype.slice.call(bytes);
	  var string = String.fromCharCode.apply(null, toUint8(bytes));
	
	  try {
	    return decodeURIComponent(escape(string));
	  } catch (e) {// if decodeURIComponent/escape fails, we are dealing with partial
	    // or full non string data. Just return the potentially garbled string.
	  }
	
	  return string;
	};
	
	exports.bytesToString = bytesToString;
	
	var stringToBytes = function stringToBytes(string, stringIsBytes) {
	  if (typeof string !== 'string' && string && typeof string.toString === 'function') {
	    string = string.toString();
	  }
	
	  if (typeof string !== 'string') {
	    return new Uint8Array();
	  } // If the string already is bytes, we don't have to do this
	  // otherwise we do this so that we split multi length characters
	  // into individual bytes
	
	
	  if (!stringIsBytes) {
	    string = unescape(encodeURIComponent(string));
	  }
	
	  var view = new Uint8Array(string.length);
	
	  for (var i = 0; i < string.length; i++) {
	    view[i] = string.charCodeAt(i);
	  }
	
	  return view;
	};
	
	exports.stringToBytes = stringToBytes;
	
	var concatTypedArrays = function concatTypedArrays() {
	  for (var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++) {
	    buffers[_key] = arguments[_key];
	  }
	
	  buffers = buffers.filter(function (b) {
	    return b && (b.byteLength || b.length) && typeof b !== 'string';
	  });
	
	  if (buffers.length <= 1) {
	    // for 0 length we will return empty uint8
	    // for 1 length we return the first uint8
	    return toUint8(buffers[0]);
	  }
	
	  var totalLen = buffers.reduce(function (total, buf, i) {
	    return total + (buf.byteLength || buf.length);
	  }, 0);
	  var tempBuffer = new Uint8Array(totalLen);
	  var offset = 0;
	  buffers.forEach(function (buf) {
	    buf = toUint8(buf);
	    tempBuffer.set(buf, offset);
	    offset += buf.byteLength;
	  });
	  return tempBuffer;
	};
	/**
	 * Check if the bytes "b" are contained within bytes "a".
	 *
	 * @param {Uint8Array|Array} a
	 *        Bytes to check in
	 *
	 * @param {Uint8Array|Array} b
	 *        Bytes to check for
	 *
	 * @param {Object} options
	 *        options
	 *
	 * @param {Array|Uint8Array} [offset=0]
	 *        offset to use when looking at bytes in a
	 *
	 * @param {Array|Uint8Array} [mask=[]]
	 *        mask to use on bytes before comparison.
	 *
	 * @return {boolean}
	 *         If all bytes in b are inside of a, taking into account
	 *         bit masks.
	 */
	
	
	exports.concatTypedArrays = concatTypedArrays;
	
	var bytesMatch = function bytesMatch(a, b, _temp3) {
	  var _ref3 = _temp3 === void 0 ? {} : _temp3,
	      _ref3$offset = _ref3.offset,
	      offset = _ref3$offset === void 0 ? 0 : _ref3$offset,
	      _ref3$mask = _ref3.mask,
	      mask = _ref3$mask === void 0 ? [] : _ref3$mask;
	
	  a = toUint8(a);
	  b = toUint8(b); // ie 11 does not support uint8 every
	
	  var fn = b.every ? b.every : Array.prototype.every;
	  return b.length && a.length - offset >= b.length && // ie 11 doesn't support every on uin8
	  fn.call(b, function (bByte, i) {
	    var aByte = mask[i] ? mask[i] & a[offset + i] : a[offset + i];
	    return bByte === aByte;
	  });
	};
	
	exports.bytesMatch = bytesMatch;
	
	var sliceBytes = function sliceBytes(src, start, end) {
	  if (Uint8Array.prototype.slice) {
	    return Uint8Array.prototype.slice.call(src, start, end);
	  }
	
	  return new Uint8Array(Array.prototype.slice.call(src, start, end));
	};
	
	exports.sliceBytes = sliceBytes;
	
	var reverseBytes = function reverseBytes(src) {
	  if (src.reverse) {
	    return src.reverse();
	  }
	
	  return Array.prototype.reverse.call(src);
	};
	
	exports.reverseBytes = reverseBytes;

/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(40);
	var call = __webpack_require__(207);
	var isArrayIter = __webpack_require__(139);
	var anObject = __webpack_require__(5);
	var toLength = __webpack_require__(24);
	var getIterFn = __webpack_require__(155);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(5);
	var dPs = __webpack_require__(213);
	var enumBugKeys = __webpack_require__(135);
	var IE_PROTO = __webpack_require__(147)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(134)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(137).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(215);
	var hiddenKeys = __webpack_require__(135).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(215);
	var enumBugKeys = __webpack_require__(135);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(32);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(6);
	var dP = __webpack_require__(23);
	var DESCRIPTORS = __webpack_require__(22);
	var SPECIES = __webpack_require__(13)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(47);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 73 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 75 */
[733, 11],
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(2);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 77 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(23).f;
	var has = __webpack_require__(34);
	var TAG = __webpack_require__(13)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var defined = __webpack_require__(45);
	var fails = __webpack_require__(8);
	var spaces = __webpack_require__(151);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(163);
	var setInnerHTML = __webpack_require__(125);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(171);
	var setTextContent = __webpack_require__(261);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(4);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(615);
	var ReactInstrumentation = __webpack_require__(43);
	
	var warning = __webpack_require__(10);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(644);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(689);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(229);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(642);
	
	var _HelmetConstants = __webpack_require__(263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(62);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(179);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(86);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(653);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(264);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(647);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(666);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(648);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(649);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(265);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(651);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(646);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(650);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(652);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(665);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(126);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(654);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(663);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(270);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(656);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(657);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(661);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(267);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactBaseClasses = __webpack_require__(271);
	var ReactChildren = __webpack_require__(692);
	var ReactDOMFactories = __webpack_require__(693);
	var ReactElement = __webpack_require__(89);
	var ReactPropTypes = __webpack_require__(694);
	var ReactVersion = __webpack_require__(695);
	
	var createReactClass = __webpack_require__(696);
	var onlyChild = __webpack_require__(700);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(56);
	
	var warning = __webpack_require__(10);
	var canDefineProperty = __webpack_require__(275);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(273);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(38);
	var TAG = __webpack_require__(13)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(38);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 92 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(564);
	module.exports = self.fetch.bind(self);


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var EventPluginRegistry = __webpack_require__(164);
	var EventPluginUtils = __webpack_require__(165);
	var ReactErrorUtils = __webpack_require__(169);
	
	var accumulateInto = __webpack_require__(254);
	var forEachAccumulated = __webpack_require__(255);
	var invariant = __webpack_require__(4);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(94);
	var EventPluginUtils = __webpack_require__(165);
	
	var accumulateInto = __webpack_require__(254);
	var forEachAccumulated = __webpack_require__(255);
	var warning = __webpack_require__(10);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	var getEventTarget = __webpack_require__(174);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 98 */
11,
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(189);
	function _defineProperty(obj, key, value) {
	  key = toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 100 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 101 */
/***/ function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 102 */
/***/ function(module, exports) {

	'use strict'
	
	/**
	 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
	 *
	 * Works with anything that has a `length` property and index access properties, including NodeList.
	 *
	 * @template {unknown} T
	 * @param {Array<T> | ({length:number, [number]: T})} list
	 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
	 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
	 * 				allows injecting a custom implementation in tests
	 * @returns {T | undefined}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
	 */
	function find(list, predicate, ac) {
		if (ac === undefined) {
			ac = Array.prototype;
		}
		if (list && typeof ac.find === 'function') {
			return ac.find.call(list, predicate);
		}
		for (var i = 0; i < list.length; i++) {
			if (Object.prototype.hasOwnProperty.call(list, i)) {
				var item = list[i];
				if (predicate.call(undefined, item, i, list)) {
					return item;
				}
			}
		}
	}
	
	/**
	 * "Shallow freezes" an object to render it immutable.
	 * Uses `Object.freeze` if available,
	 * otherwise the immutability is only in the type.
	 *
	 * Is used to create "enum like" objects.
	 *
	 * @template T
	 * @param {T} object the object to freeze
	 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
	 * 				allows to inject custom object constructor for tests
	 * @returns {Readonly<T>}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
	 */
	function freeze(object, oc) {
		if (oc === undefined) {
			oc = Object
		}
		return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object
	}
	
	/**
	 * Since we can not rely on `Object.assign` we provide a simplified version
	 * that is sufficient for our needs.
	 *
	 * @param {Object} target
	 * @param {Object | null | undefined} source
	 *
	 * @returns {Object} target
	 * @throws TypeError if target is not an object
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
	 */
	function assign(target, source) {
		if (target === null || typeof target !== 'object') {
			throw new TypeError('target is not an object')
		}
		for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key]
			}
		}
		return target
	}
	
	/**
	 * All mime types that are allowed as input to `DOMParser.parseFromString`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
	 * @see DOMParser.prototype.parseFromString
	 */
	var MIME_TYPE = freeze({
		/**
		 * `text/html`, the only mime type that triggers treating an XML document as HTML.
		 *
		 * @see DOMParser.SupportedType.isHTML
		 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
		 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
		 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
		 */
		HTML: 'text/html',
	
		/**
		 * Helper method to check a mime type if it indicates an HTML document
		 *
		 * @param {string} [value]
		 * @returns {boolean}
		 *
		 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
		 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
		 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
		isHTML: function (value) {
			return value === MIME_TYPE.HTML
		},
	
		/**
		 * `application/xml`, the standard mime type for XML documents.
		 *
		 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
		 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
		 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
		 */
		XML_APPLICATION: 'application/xml',
	
		/**
		 * `text/html`, an alias for `application/xml`.
		 *
		 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
		 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
		 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
		 */
		XML_TEXT: 'text/xml',
	
		/**
		 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
		 * but is parsed as an XML document.
		 *
		 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
		 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
		 */
		XML_XHTML_APPLICATION: 'application/xhtml+xml',
	
		/**
		 * `image/svg+xml`,
		 *
		 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
		 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
		 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
		 */
		XML_SVG_IMAGE: 'image/svg+xml',
	})
	
	/**
	 * Namespaces that are used in this code base.
	 *
	 * @see http://www.w3.org/TR/REC-xml-names
	 */
	var NAMESPACE = freeze({
		/**
		 * The XHTML namespace.
		 *
		 * @see http://www.w3.org/1999/xhtml
		 */
		HTML: 'http://www.w3.org/1999/xhtml',
	
		/**
		 * Checks if `uri` equals `NAMESPACE.HTML`.
		 *
		 * @param {string} [uri]
		 *
		 * @see NAMESPACE.HTML
		 */
		isHTML: function (uri) {
			return uri === NAMESPACE.HTML
		},
	
		/**
		 * The SVG namespace.
		 *
		 * @see http://www.w3.org/2000/svg
		 */
		SVG: 'http://www.w3.org/2000/svg',
	
		/**
		 * The `xml:` namespace.
		 *
		 * @see http://www.w3.org/XML/1998/namespace
		 */
		XML: 'http://www.w3.org/XML/1998/namespace',
	
		/**
		 * The `xmlns:` namespace
		 *
		 * @see https://www.w3.org/2000/xmlns/
		 */
		XMLNS: 'http://www.w3.org/2000/xmlns/',
	})
	
	exports.assign = assign;
	exports.find = find;
	exports.freeze = freeze;
	exports.MIME_TYPE = MIME_TYPE;
	exports.NAMESPACE = NAMESPACE;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(37);
	var toLength = __webpack_require__(24);
	var toAbsoluteIndex = __webpack_require__(72);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(6);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(32);
	var redefineAll = __webpack_require__(70);
	var meta = __webpack_require__(61);
	var forOf = __webpack_require__(65);
	var anInstance = __webpack_require__(64);
	var isObject = __webpack_require__(9);
	var fails = __webpack_require__(8);
	var $iterDetect = __webpack_require__(109);
	var setToStringTag = __webpack_require__(78);
	var inheritIfRequired = __webpack_require__(138);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(31);
	var redefine = __webpack_require__(32);
	var fails = __webpack_require__(8);
	var defined = __webpack_require__(45);
	var wks = __webpack_require__(13);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(5);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(38);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(9);
	var cof = __webpack_require__(38);
	var MATCH = __webpack_require__(13)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(13)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(60) || !__webpack_require__(8)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(6)[K];
	});


/***/ },
/* 111 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(28);
	var ctx = __webpack_require__(40);
	var forOf = __webpack_require__(65);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(39);
	var global = __webpack_require__(6);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(60) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(5);
	var aFunction = __webpack_require__(28);
	var SPECIES = __webpack_require__(13)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var hide = __webpack_require__(31);
	var uid = __webpack_require__(73);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(577);
	
	var _runTransitionHook = __webpack_require__(161);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(74);
	
	var _deprecate = __webpack_require__(160);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var EventPluginRegistry = __webpack_require__(164);
	var ReactEventEmitterMixin = __webpack_require__(607);
	var ViewportMetrics = __webpack_require__(253);
	
	var getVendorPrefixedEventName = __webpack_require__(639);
	var isEventSupported = __webpack_require__(175);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(97);
	var ViewportMetrics = __webpack_require__(253);
	
	var getEventModifierState = __webpack_require__(173);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(4);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 124 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	var DOMNamespaces = __webpack_require__(163);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(171);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(127);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(660);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleFullscreenChange = handleFullscreenChange;
	exports.activate = activate;
	exports.userActivate = userActivate;
	exports.play = play;
	exports.pause = pause;
	exports.togglePlay = togglePlay;
	exports.seek = seek;
	exports.forward = forward;
	exports.replay = replay;
	exports.changeRate = changeRate;
	exports.changeVolume = changeVolume;
	exports.mute = mute;
	exports.toggleFullscreen = toggleFullscreen;
	exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = void 0;
	
	var _fullscreen = _interopRequireDefault(__webpack_require__(301));
	
	var OPERATE = 'video-react/OPERATE';
	exports.OPERATE = OPERATE;
	var FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
	exports.FULLSCREEN_CHANGE = FULLSCREEN_CHANGE;
	var PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
	exports.PLAYER_ACTIVATE = PLAYER_ACTIVATE;
	var USER_ACTIVATE = 'video-react/USER_ACTIVATE';
	exports.USER_ACTIVATE = USER_ACTIVATE;
	
	function handleFullscreenChange(isFullscreen) {
	  return {
	    type: FULLSCREEN_CHANGE,
	    isFullscreen: isFullscreen
	  };
	}
	
	function activate(activity) {
	  return {
	    type: PLAYER_ACTIVATE,
	    activity: activity
	  };
	}
	
	function userActivate(activity) {
	  return {
	    type: USER_ACTIVATE,
	    activity: activity
	  };
	}
	
	function play() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'play',
	    source: ''
	  };
	  this.video.play();
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function pause() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'pause',
	    source: ''
	  };
	  this.video.pause();
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function togglePlay() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'toggle-play',
	    source: ''
	  };
	  this.video.togglePlay();
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	} // seek video by time
	
	
	function seek(time) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'seek',
	    source: ''
	  };
	  this.video.seek(time);
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	} // jump forward x seconds
	
	
	function forward(seconds) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: "forward-".concat(seconds),
	    source: ''
	  };
	  this.video.forward(seconds);
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	} // jump back x seconds
	
	
	function replay(seconds) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: "replay-".concat(seconds),
	    source: ''
	  };
	  this.video.replay(seconds);
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function changeRate(rate) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'change-rate',
	    source: ''
	  };
	  this.video.playbackRate = rate;
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function changeVolume(volume) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'change-volume',
	    source: ''
	  };
	  var v = volume;
	
	  if (volume < 0) {
	    v = 0;
	  }
	
	  if (volume > 1) {
	    v = 1;
	  }
	
	  this.video.volume = v;
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function mute(muted) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: muted ? 'muted' : 'unmuted',
	    source: ''
	  };
	  this.video.muted = muted;
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function toggleFullscreen(player) {
	  if (_fullscreen["default"].enabled) {
	    if (_fullscreen["default"].isFullscreen) {
	      _fullscreen["default"].exit();
	    } else {
	      _fullscreen["default"].request(this.rootElement);
	    }
	
	    return {
	      type: OPERATE,
	      operation: {
	        action: 'toggle-fullscreen',
	        source: ''
	      }
	    };
	  }
	
	  return {
	    type: FULLSCREEN_CHANGE,
	    isFullscreen: !player.isFullscreen
	  };
	}

/***/ },
/* 129 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findElPosition = findElPosition;
	exports.getPointerPosition = getPointerPosition;
	exports.blurNode = blurNode;
	exports.focusNode = focusNode;
	exports.hasClass = hasClass;
	
	/**
	 * Offset Left
	 * getBoundingClientRect technique from
	 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
	 *
	 * @function findElPosition
	 * @param {ReactNodeRef} el React Node ref from which to get offset
	 * @return {Object}
	 */
	function findElPosition(el) {
	  var box;
	
	  if (el.getBoundingClientRect && el.parentNode) {
	    box = el.getBoundingClientRect();
	  }
	
	  if (!box) {
	    return {
	      left: 0,
	      top: 0
	    };
	  }
	
	  var _document = document,
	      body = _document.body,
	      docEl = _document.documentElement;
	  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	  var scrollLeft = window.pageXOffset || body.scrollLeft;
	  var left = box.left + scrollLeft - clientLeft;
	  var clientTop = docEl.clientTop || body.clientTop || 0;
	  var scrollTop = window.pageYOffset || body.scrollTop;
	  var top = box.top + scrollTop - clientTop; // Android sometimes returns slightly off decimal values, so need to round
	
	  return {
	    left: Math.round(left),
	    top: Math.round(top)
	  };
	}
	/**
	 * Get pointer position in a React Node ref
	 * Returns an object with x and y coordinates.
	 * The base on the coordinates are the bottom left of the element.
	 *
	 * @function getPointerPosition
	 * @param {ReactNodeRef} el React Node ref on which to get the pointer position on
	 * @param {Event} event Event object
	 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
	 */
	
	
	function getPointerPosition(el, event) {
	  var position = {};
	  var box = findElPosition(el);
	  var boxW = el.offsetWidth;
	  var boxH = el.offsetHeight;
	  var boxY = box.top;
	  var boxX = box.left;
	  var evtPageY = event.pageY;
	  var evtPageX = event.pageX;
	
	  if (event.changedTouches) {
	    evtPageX = event.changedTouches[0].pageX;
	    evtPageY = event.changedTouches[0].pageY;
	  }
	
	  position.y = Math.max(0, Math.min(1, (boxY - evtPageY + boxH) / boxH));
	  position.x = Math.max(0, Math.min(1, (evtPageX - boxX) / boxW));
	  return position;
	} // blur an element
	
	
	function blurNode(reactNode) {
	  if (reactNode && reactNode.blur) {
	    reactNode.blur();
	  }
	} // focus an element
	
	
	function focusNode(reactNode) {
	  if (reactNode && reactNode.focus) {
	    reactNode.focus();
	  }
	} // check if an element has a class name
	
	
	function hasClass(elm, cls) {
	  var classes = elm.className.split(' ');
	
	  for (var i = 0; i < classes.length; i++) {
	    if (classes[i].toLowerCase() === cls.toLowerCase()) {
	      return true;
	    }
	  }
	
	  return false;
	}

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(309);
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	  return target;
	}
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(26);
	var toAbsoluteIndex = __webpack_require__(72);
	var toLength = __webpack_require__(24);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(334);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(23);
	var createDesc = __webpack_require__(69);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	var document = __webpack_require__(6).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 135 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(13)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(6).document;
	module.exports = document && document.documentElement;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	var setPrototypeOf = __webpack_require__(146).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(77);
	var ITERATOR = __webpack_require__(13)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(66);
	var descriptor = __webpack_require__(69);
	var setToStringTag = __webpack_require__(78);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(31)(IteratorPrototype, __webpack_require__(13)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(60);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(32);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(77);
	var $iterCreate = __webpack_require__(140);
	var setToStringTag = __webpack_require__(78);
	var getPrototypeOf = __webpack_require__(36);
	var ITERATOR = __webpack_require__(13)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 142 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 143 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var macrotask = __webpack_require__(152).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(38)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(28);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(9);
	var anObject = __webpack_require__(5);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(40)(Function.call, __webpack_require__(35).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(114)('keys');
	var uid = __webpack_require__(73);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(47);
	var defined = __webpack_require__(45);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(108);
	var defined = __webpack_require__(45);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(47);
	var defined = __webpack_require__(45);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 151 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(40);
	var invoke = __webpack_require__(205);
	var html = __webpack_require__(137);
	var cel = __webpack_require__(134);
	var global = __webpack_require__(6);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(38)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(6);
	var DESCRIPTORS = __webpack_require__(22);
	var LIBRARY = __webpack_require__(60);
	var $typed = __webpack_require__(116);
	var hide = __webpack_require__(31);
	var redefineAll = __webpack_require__(70);
	var fails = __webpack_require__(8);
	var anInstance = __webpack_require__(64);
	var toInteger = __webpack_require__(47);
	var toLength = __webpack_require__(24);
	var toIndex = __webpack_require__(223);
	var gOPN = __webpack_require__(67).f;
	var dP = __webpack_require__(23).f;
	var arrayFill = __webpack_require__(131);
	var setToStringTag = __webpack_require__(78);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var core = __webpack_require__(39);
	var LIBRARY = __webpack_require__(60);
	var wksExt = __webpack_require__(224);
	var defineProperty = __webpack_require__(23).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(90);
	var ITERATOR = __webpack_require__(13)('iterator');
	var Iterators = __webpack_require__(77);
	module.exports = __webpack_require__(39).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(59);
	var step = __webpack_require__(208);
	var Iterators = __webpack_require__(77);
	var toIObject = __webpack_require__(37);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(141)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 157 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(82);
	var Danger = __webpack_require__(584);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactInstrumentation = __webpack_require__(43);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(171);
	var setInnerHTML = __webpack_require__(125);
	var setTextContent = __webpack_require__(261);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactErrorUtils = __webpack_require__(169);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(10);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 166 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactPropTypesSecret = __webpack_require__(613);
	var propTypesFactory = __webpack_require__(241);
	
	var React = __webpack_require__(88);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(10);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(4);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(56);
	var ReactInstanceMap = __webpack_require__(96);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(50);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(10);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 174 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 176 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var emptyFunction = __webpack_require__(42);
	var warning = __webpack_require__(10);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 178 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(2);
	
	var _deprecateObjectProperties = __webpack_require__(127);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(76);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(658);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(655);
	
	var _isActive2 = __webpack_require__(662);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(659);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(664);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleLoadStart = handleLoadStart;
	exports.handleCanPlay = handleCanPlay;
	exports.handleWaiting = handleWaiting;
	exports.handleCanPlayThrough = handleCanPlayThrough;
	exports.handlePlaying = handlePlaying;
	exports.handlePlay = handlePlay;
	exports.handlePause = handlePause;
	exports.handleEnd = handleEnd;
	exports.handleSeeking = handleSeeking;
	exports.handleSeeked = handleSeeked;
	exports.handleDurationChange = handleDurationChange;
	exports.handleTimeUpdate = handleTimeUpdate;
	exports.handleVolumeChange = handleVolumeChange;
	exports.handleProgressChange = handleProgressChange;
	exports.handleRateChange = handleRateChange;
	exports.handleSuspend = handleSuspend;
	exports.handleAbort = handleAbort;
	exports.handleEmptied = handleEmptied;
	exports.handleStalled = handleStalled;
	exports.handleLoadedMetaData = handleLoadedMetaData;
	exports.handleLoadedData = handleLoadedData;
	exports.handleResize = handleResize;
	exports.handleError = handleError;
	exports.handleSeekingTime = handleSeekingTime;
	exports.handleEndSeeking = handleEndSeeking;
	exports.activateTextTrack = activateTextTrack;
	exports.ACTIVATE_TEXT_TRACK = exports.ERROR = exports.RESIZE = exports.LOADED_DATA = exports.LOADED_META_DATA = exports.STALLED = exports.EMPTIED = exports.ABORT = exports.SUSPEND = exports.RATE_CHANGE = exports.PROGRESS_CHANGE = exports.VOLUME_CHANGE = exports.TIME_UPDATE = exports.DURATION_CHANGE = exports.END_SEEKING = exports.SEEKING_TIME = exports.SEEKED = exports.SEEKING = exports.END = exports.PAUSE = exports.PLAY = exports.PLAYING = exports.CAN_PLAY_THROUGH = exports.WAITING = exports.CAN_PLAY = exports.LOAD_START = void 0;
	var LOAD_START = 'video-react/LOAD_START';
	exports.LOAD_START = LOAD_START;
	var CAN_PLAY = 'video-react/CAN_PLAY';
	exports.CAN_PLAY = CAN_PLAY;
	var WAITING = 'video-react/WAITING';
	exports.WAITING = WAITING;
	var CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
	exports.CAN_PLAY_THROUGH = CAN_PLAY_THROUGH;
	var PLAYING = 'video-react/PLAYING';
	exports.PLAYING = PLAYING;
	var PLAY = 'video-react/PLAY';
	exports.PLAY = PLAY;
	var PAUSE = 'video-react/PAUSE';
	exports.PAUSE = PAUSE;
	var END = 'video-react/END';
	exports.END = END;
	var SEEKING = 'video-react/SEEKING';
	exports.SEEKING = SEEKING;
	var SEEKED = 'video-react/SEEKED';
	exports.SEEKED = SEEKED;
	var SEEKING_TIME = 'video-react/SEEKING_TIME';
	exports.SEEKING_TIME = SEEKING_TIME;
	var END_SEEKING = 'video-react/END_SEEKING';
	exports.END_SEEKING = END_SEEKING;
	var DURATION_CHANGE = 'video-react/DURATION_CHANGE';
	exports.DURATION_CHANGE = DURATION_CHANGE;
	var TIME_UPDATE = 'video-react/TIME_UPDATE';
	exports.TIME_UPDATE = TIME_UPDATE;
	var VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
	exports.VOLUME_CHANGE = VOLUME_CHANGE;
	var PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
	exports.PROGRESS_CHANGE = PROGRESS_CHANGE;
	var RATE_CHANGE = 'video-react/RATE_CHANGE';
	exports.RATE_CHANGE = RATE_CHANGE;
	var SUSPEND = 'video-react/SUSPEND';
	exports.SUSPEND = SUSPEND;
	var ABORT = 'video-react/ABORT';
	exports.ABORT = ABORT;
	var EMPTIED = 'video-react/EMPTIED';
	exports.EMPTIED = EMPTIED;
	var STALLED = 'video-react/STALLED';
	exports.STALLED = STALLED;
	var LOADED_META_DATA = 'video-react/LOADED_META_DATA';
	exports.LOADED_META_DATA = LOADED_META_DATA;
	var LOADED_DATA = 'video-react/LOADED_DATA';
	exports.LOADED_DATA = LOADED_DATA;
	var RESIZE = 'video-react/RESIZE';
	exports.RESIZE = RESIZE;
	var ERROR = 'video-react/ERROR';
	exports.ERROR = ERROR;
	var ACTIVATE_TEXT_TRACK = 'video-react/ACTIVATE_TEXT_TRACK';
	exports.ACTIVATE_TEXT_TRACK = ACTIVATE_TEXT_TRACK;
	
	function handleLoadStart(videoProps) {
	  return {
	    type: LOAD_START,
	    videoProps: videoProps
	  };
	}
	
	function handleCanPlay(videoProps) {
	  return {
	    type: CAN_PLAY,
	    videoProps: videoProps
	  };
	}
	
	function handleWaiting(videoProps) {
	  return {
	    type: WAITING,
	    videoProps: videoProps
	  };
	}
	
	function handleCanPlayThrough(videoProps) {
	  return {
	    type: CAN_PLAY_THROUGH,
	    videoProps: videoProps
	  };
	}
	
	function handlePlaying(videoProps) {
	  return {
	    type: PLAYING,
	    videoProps: videoProps
	  };
	}
	
	function handlePlay(videoProps) {
	  return {
	    type: PLAY,
	    videoProps: videoProps
	  };
	}
	
	function handlePause(videoProps) {
	  return {
	    type: PAUSE,
	    videoProps: videoProps
	  };
	}
	
	function handleEnd(videoProps) {
	  return {
	    type: END,
	    videoProps: videoProps
	  };
	}
	
	function handleSeeking(videoProps) {
	  return {
	    type: SEEKING,
	    videoProps: videoProps
	  };
	}
	
	function handleSeeked(videoProps) {
	  return {
	    type: SEEKED,
	    videoProps: videoProps
	  };
	}
	
	function handleDurationChange(videoProps) {
	  return {
	    type: DURATION_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleTimeUpdate(videoProps) {
	  return {
	    type: TIME_UPDATE,
	    videoProps: videoProps
	  };
	}
	
	function handleVolumeChange(videoProps) {
	  return {
	    type: VOLUME_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleProgressChange(videoProps) {
	  return {
	    type: PROGRESS_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleRateChange(videoProps) {
	  return {
	    type: RATE_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleSuspend(videoProps) {
	  return {
	    type: SUSPEND,
	    videoProps: videoProps
	  };
	}
	
	function handleAbort(videoProps) {
	  return {
	    type: ABORT,
	    videoProps: videoProps
	  };
	}
	
	function handleEmptied(videoProps) {
	  return {
	    type: EMPTIED,
	    videoProps: videoProps
	  };
	}
	
	function handleStalled(videoProps) {
	  return {
	    type: STALLED,
	    videoProps: videoProps
	  };
	}
	
	function handleLoadedMetaData(videoProps) {
	  return {
	    type: LOADED_META_DATA,
	    videoProps: videoProps
	  };
	}
	
	function handleLoadedData(videoProps) {
	  return {
	    type: LOADED_DATA,
	    videoProps: videoProps
	  };
	}
	
	function handleResize(videoProps) {
	  return {
	    type: RESIZE,
	    videoProps: videoProps
	  };
	}
	
	function handleError(videoProps) {
	  return {
	    type: ERROR,
	    videoProps: videoProps
	  };
	}
	
	function handleSeekingTime(time) {
	  return {
	    type: SEEKING_TIME,
	    time: time
	  };
	}
	
	function handleEndSeeking(time) {
	  return {
	    type: END_SEEKING,
	    time: time
	  };
	}
	
	function activateTextTrack(textTrack) {
	  return {
	    type: ACTIVATE_TEXT_TRACK,
	    textTrack: textTrack
	  };
	}

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var Dom = _interopRequireWildcard(__webpack_require__(129));
	
	var propTypes = {
	  className: _propTypes["default"].string,
	  onMouseDown: _propTypes["default"].func,
	  onMouseMove: _propTypes["default"].func,
	  stepForward: _propTypes["default"].func,
	  stepBack: _propTypes["default"].func,
	  sliderActive: _propTypes["default"].func,
	  sliderInactive: _propTypes["default"].func,
	  onMouseUp: _propTypes["default"].func,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  getPercent: _propTypes["default"].func,
	  vertical: _propTypes["default"].bool,
	  children: _propTypes["default"].node,
	  label: _propTypes["default"].string,
	  valuenow: _propTypes["default"].string,
	  valuetext: _propTypes["default"].string
	};
	
	var Slider =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Slider, _Component);
	
	  function Slider(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Slider);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Slider).call(this, props, context));
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.calculateDistance = _this.calculateDistance.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getProgress = _this.getProgress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.state = {
	      active: false
	    };
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Slider, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousemove', this.handleMouseMove, true);
	      document.removeEventListener('mouseup', this.handleMouseUp, true);
	      document.removeEventListener('touchmove', this.handleMouseMove, true);
	      document.removeEventListener('touchend', this.handleMouseUp, true);
	      document.removeEventListener('keydown', this.handleKeyPress, true);
	    }
	  }, {
	    key: "getProgress",
	    value: function getProgress() {
	      var getPercent = this.props.getPercent;
	
	      if (!getPercent) {
	        return 0;
	      }
	
	      var progress = getPercent(); // Protect against no duration and other division issues
	
	      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
	        progress = 0;
	      }
	
	      return progress;
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(event) {
	      var onMouseDown = this.props.onMouseDown; // event.preventDefault();
	      // event.stopPropagation();
	
	      document.addEventListener('mousemove', this.handleMouseMove, true);
	      document.addEventListener('mouseup', this.handleMouseUp, true);
	      document.addEventListener('touchmove', this.handleMouseMove, true);
	      document.addEventListener('touchend', this.handleMouseUp, true);
	      this.setState({
	        active: true
	      });
	
	      if (this.props.sliderActive) {
	        this.props.sliderActive(event);
	      }
	
	      this.handleMouseMove(event);
	
	      if (onMouseDown) {
	        onMouseDown(event);
	      }
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      var onMouseMove = this.props.onMouseMove;
	
	      if (onMouseMove) {
	        onMouseMove(event);
	      }
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(event) {
	      // On iOS safari, a subsequent mouseup event will be fired after touchend.
	      // Its weird event positions make the player seek a wrong time.
	      // calling preventDefault (at touchend phase) will prevent the mouseup event
	      event.preventDefault();
	      var onMouseUp = this.props.onMouseUp;
	      document.removeEventListener('mousemove', this.handleMouseMove, true);
	      document.removeEventListener('mouseup', this.handleMouseUp, true);
	      document.removeEventListener('touchmove', this.handleMouseMove, true);
	      document.removeEventListener('touchend', this.handleMouseUp, true);
	      this.setState({
	        active: false
	      });
	
	      if (this.props.sliderInactive) {
	        this.props.sliderInactive(event);
	      }
	
	      if (onMouseUp) {
	        onMouseUp(event);
	      }
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(e) {
	      document.addEventListener('keydown', this.handleKeyPress, true);
	
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(e) {
	      document.removeEventListener('keydown', this.handleKeyPress, true);
	
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault(); // event.stopPropagation();
	
	      if (this.props.onClick) {
	        this.props.onClick(event);
	      }
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(event) {
	      if (event.which === 37 || event.which === 40) {
	        // Left and Down Arrows
	        event.preventDefault();
	        event.stopPropagation();
	        this.stepBack();
	      } else if (event.which === 38 || event.which === 39) {
	        // Up and Right Arrows
	        event.preventDefault();
	        event.stopPropagation();
	        this.stepForward();
	      }
	    }
	  }, {
	    key: "stepForward",
	    value: function stepForward() {
	      if (this.props.stepForward) {
	        this.props.stepForward();
	      }
	    }
	  }, {
	    key: "stepBack",
	    value: function stepBack() {
	      if (this.props.stepBack) {
	        this.props.stepBack();
	      }
	    }
	  }, {
	    key: "calculateDistance",
	    value: function calculateDistance(event) {
	      var node = this.slider;
	      var position = Dom.getPointerPosition(node, event);
	
	      if (this.props.vertical) {
	        return position.y;
	      }
	
	      return position.x;
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren() {
	      var progress = this.getProgress();
	      var percentage = "".concat((progress * 100).toFixed(2), "%");
	      return _react["default"].Children.map(this.props.children, function (child) {
	        return _react["default"].cloneElement(child, {
	          progress: progress,
	          percentage: percentage
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          vertical = _this$props.vertical,
	          label = _this$props.label,
	          valuenow = _this$props.valuenow,
	          valuetext = _this$props.valuetext;
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])(this.props.className, {
	          'video-react-slider-vertical': vertical,
	          'video-react-slider-horizontal': !vertical,
	          'video-react-sliding': this.state.active
	        }, 'video-react-slider'),
	        ref: function ref(c) {
	          _this2.slider = c;
	        },
	        tabIndex: "0",
	        role: "slider",
	        onMouseDown: this.handleMouseDown,
	        onTouchStart: this.handleMouseDown,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        "aria-label": label || '',
	        "aria-valuenow": valuenow || '',
	        "aria-valuetext": valuetext || '',
	        "aria-valuemin": 0,
	        "aria-valuemax": 100
	      }, this.renderChildren());
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	exports["default"] = Slider;
	Slider.propTypes = propTypes;
	Slider.displayName = 'Slider';

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _MenuButton = _interopRequireDefault(__webpack_require__(184));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  rates: _propTypes["default"].array,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
	};
	
	var PlaybackRateMenuButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PlaybackRateMenuButton, _Component);
	
	  function PlaybackRateMenuButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PlaybackRateMenuButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRateMenuButton).call(this, props, context));
	    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PlaybackRateMenuButton, [{
	    key: "handleSelectItem",
	    value: function handleSelectItem(index) {
	      var _this$props = this.props,
	          rates = _this$props.rates,
	          actions = _this$props.actions;
	
	      if (index >= 0 && index < rates.length) {
	        actions.changeRate(rates[index]);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          rates = _this$props2.rates,
	          player = _this$props2.player;
	      var items = rates.map(function (rate) {
	        return {
	          label: "".concat(rate, "x"),
	          value: rate
	        };
	      });
	      var selectedIndex = rates.indexOf(player.playbackRate) || 0;
	      return _react["default"].createElement(_MenuButton["default"], {
	        className: (0, _classnames["default"])('video-react-playback-rate', this.props.className),
	        onSelectItem: this.handleSelectItem,
	        items: items,
	        selectedIndex: selectedIndex
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Playback Rate"), _react["default"].createElement("div", {
	        className: "video-react-playback-rate-value"
	      }, "".concat(player.playbackRate.toFixed(2), "x")));
	    }
	  }]);
	  return PlaybackRateMenuButton;
	}(_react.Component);
	
	PlaybackRateMenuButton.propTypes = propTypes;
	PlaybackRateMenuButton.defaultProps = defaultProps;
	PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
	var _default = PlaybackRateMenuButton;
	exports["default"] = _default;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Menu = _interopRequireDefault(__webpack_require__(713));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(714));
	
	var _ClickableComponent = _interopRequireDefault(__webpack_require__(279));
	
	var propTypes = {
	  inline: _propTypes["default"].bool,
	  items: _propTypes["default"].array,
	  className: _propTypes["default"].string,
	  onSelectItem: _propTypes["default"].func,
	  children: _propTypes["default"].any,
	  selectedIndex: _propTypes["default"].number
	};
	
	var MenuButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(MenuButton, _Component);
	
	  function MenuButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, MenuButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuButton).call(this, props, context));
	    _this.state = {
	      active: false,
	      activateIndex: props.selectedIndex || 0
	    };
	    _this.commitSelection = _this.commitSelection.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.activateMenuItem = _this.activateMenuItem.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleUpArrow = _this.handleUpArrow.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleDownArrow = _this.handleDownArrow.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleReturn = _this.handleReturn.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleIndexChange = _this.handleIndexChange.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(MenuButton, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.selectedIndex !== this.props.selectedIndex) {
	        this.activateMenuItem(this.props.selectedIndex);
	      }
	    }
	  }, {
	    key: "commitSelection",
	    value: function commitSelection(index) {
	      this.setState({
	        activateIndex: index
	      });
	      this.handleIndexChange(index);
	    }
	  }, {
	    key: "activateMenuItem",
	    value: function activateMenuItem(index) {
	      this.setState({
	        activateIndex: index
	      });
	      this.handleIndexChange(index);
	    }
	  }, {
	    key: "handleIndexChange",
	    value: function handleIndexChange(index) {
	      var onSelectItem = this.props.onSelectItem;
	      onSelectItem(index);
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick() {
	      this.setState(function (prevState) {
	        return {
	          active: !prevState.active
	        };
	      });
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      document.addEventListener('keydown', this.handleKeyPress);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.setState({
	        active: false
	      });
	      document.removeEventListener('keydown', this.handleKeyPress);
	    }
	  }, {
	    key: "handleUpArrow",
	    value: function handleUpArrow(e) {
	      var items = this.props.items;
	
	      if (this.state.active) {
	        e.preventDefault();
	        var newIndex = this.state.activateIndex - 1;
	
	        if (newIndex < 0) {
	          newIndex = items.length ? items.length - 1 : 0;
	        }
	
	        this.activateMenuItem(newIndex);
	      }
	    }
	  }, {
	    key: "handleDownArrow",
	    value: function handleDownArrow(e) {
	      var items = this.props.items;
	
	      if (this.state.active) {
	        e.preventDefault();
	        var newIndex = this.state.activateIndex + 1;
	
	        if (newIndex >= items.length) {
	          newIndex = 0;
	        }
	
	        this.activateMenuItem(newIndex);
	      }
	    }
	  }, {
	    key: "handleTab",
	    value: function handleTab(e) {
	      if (this.state.active) {
	        e.preventDefault();
	        this.commitSelection(this.state.activateIndex);
	      }
	    }
	  }, {
	    key: "handleReturn",
	    value: function handleReturn(e) {
	      e.preventDefault();
	
	      if (this.state.active) {
	        this.commitSelection(this.state.activateIndex);
	      } else {
	        this.setState({
	          active: true
	        });
	      }
	    }
	  }, {
	    key: "handleEscape",
	    value: function handleEscape() {
	      this.setState({
	        active: false,
	        activateIndex: 0
	      });
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(event) {
	      // Escape (27) key
	      if (event.which === 27) {
	        this.handleEscape(event);
	      } else if (event.which === 9) {
	        // Tab (9) key
	        this.handleTab(event);
	      } else if (event.which === 13) {
	        // Enter (13) key
	        this.handleReturn(event);
	      } else if (event.which === 38) {
	        // Up (38) key
	        this.handleUpArrow(event);
	      } else if (event.which === 40) {
	        // Down (40) key press
	        this.handleDownArrow(event);
	      }
	    }
	  }, {
	    key: "handleSelectItem",
	    value: function handleSelectItem(i) {
	      this.commitSelection(i);
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	
	      var items = this.props.items;
	      return _react["default"].createElement(_Menu["default"], null, items.map(function (item, i) {
	        return _react["default"].createElement(_MenuItem["default"], {
	          item: item,
	          index: i,
	          onSelectItem: _this2.handleSelectItem,
	          activateIndex: _this2.state.activateIndex,
	          key: "item-".concat(i++)
	        });
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _this$props = this.props,
	          inline = _this$props.inline,
	          className = _this$props.className;
	      return _react["default"].createElement(_ClickableComponent["default"], {
	        className: (0, _classnames["default"])(className, {
	          'video-react-menu-button-inline': !!inline,
	          'video-react-menu-button-popup': !inline,
	          'video-react-menu-button-active': this.state.active
	        }, 'video-react-control video-react-button video-react-menu-button'),
	        role: "button",
	        tabIndex: "0",
	        ref: function ref(c) {
	          _this3.menuButton = c;
	        },
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, this.props.children, this.renderMenu());
	    }
	  }]);
	  return MenuButton;
	}(_react.Component);
	
	exports["default"] = MenuButton;
	MenuButton.propTypes = propTypes;
	MenuButton.displayName = 'MenuButton';

/***/ },
/* 185 */
/***/ function(module, exports) {

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	  return arr2;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(100);
	var isNativeReflectConstruct = __webpack_require__(305);
	function _construct(t, e, r) {
	  if (isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
	  var o = [null];
	  o.push.apply(o, e);
	  var p = new (t.bind.apply(t, o))();
	  return r && setPrototypeOf(p, r.prototype), p;
	}
	module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(100);
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(303);
	var iterableToArray = __webpack_require__(306);
	var unsupportedIterableToArray = __webpack_require__(311);
	var nonIterableSpread = __webpack_require__(307);
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
	}
	module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(101)["default"];
	var toPrimitive = __webpack_require__(310);
	function toPropertyKey(t) {
	  var i = toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : String(i);
	}
	module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHvcCodec = exports.getAvcCodec = exports.getAv1Codec = void 0;
	
	var _byteHelpers = __webpack_require__(63);
	
	// https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
	// https://developer.mozilla.org/en-US/docs/Web/Media/Formats/codecs_parameter#AV1
	var getAv1Codec = function getAv1Codec(bytes) {
	  var codec = '';
	  var profile = bytes[1] >>> 3;
	  var level = bytes[1] & 0x1F;
	  var tier = bytes[2] >>> 7;
	  var highBitDepth = (bytes[2] & 0x40) >> 6;
	  var twelveBit = (bytes[2] & 0x20) >> 5;
	  var monochrome = (bytes[2] & 0x10) >> 4;
	  var chromaSubsamplingX = (bytes[2] & 0x08) >> 3;
	  var chromaSubsamplingY = (bytes[2] & 0x04) >> 2;
	  var chromaSamplePosition = bytes[2] & 0x03;
	  codec += profile + "." + (0, _byteHelpers.padStart)(level, 2, '0');
	
	  if (tier === 0) {
	    codec += 'M';
	  } else if (tier === 1) {
	    codec += 'H';
	  }
	
	  var bitDepth;
	
	  if (profile === 2 && highBitDepth) {
	    bitDepth = twelveBit ? 12 : 10;
	  } else {
	    bitDepth = highBitDepth ? 10 : 8;
	  }
	
	  codec += "." + (0, _byteHelpers.padStart)(bitDepth, 2, '0'); // TODO: can we parse color range??
	
	  codec += "." + monochrome;
	  codec += "." + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition;
	  return codec;
	};
	
	exports.getAv1Codec = getAv1Codec;
	
	var getAvcCodec = function getAvcCodec(bytes) {
	  var profileId = (0, _byteHelpers.toHexString)(bytes[1]);
	  var constraintFlags = (0, _byteHelpers.toHexString)(bytes[2] & 0xFC);
	  var levelId = (0, _byteHelpers.toHexString)(bytes[3]);
	  return "" + profileId + constraintFlags + levelId;
	};
	
	exports.getAvcCodec = getAvcCodec;
	
	var getHvcCodec = function getHvcCodec(bytes) {
	  var codec = '';
	  var profileSpace = bytes[1] >> 6;
	  var profileId = bytes[1] & 0x1F;
	  var tierFlag = (bytes[1] & 0x20) >> 5;
	  var profileCompat = bytes.subarray(2, 6);
	  var constraintIds = bytes.subarray(6, 12);
	  var levelId = bytes[12];
	
	  if (profileSpace === 1) {
	    codec += 'A';
	  } else if (profileSpace === 2) {
	    codec += 'B';
	  } else if (profileSpace === 3) {
	    codec += 'C';
	  }
	
	  codec += profileId + "."; // ffmpeg does this in big endian
	
	  var profileCompatVal = parseInt((0, _byteHelpers.toBinaryString)(profileCompat).split('').reverse().join(''), 2); // apple does this in little endian...
	
	  if (profileCompatVal > 255) {
	    profileCompatVal = parseInt((0, _byteHelpers.toBinaryString)(profileCompat), 2);
	  }
	
	  codec += profileCompatVal.toString(16) + ".";
	
	  if (tierFlag === 0) {
	    codec += 'L';
	  } else {
	    codec += 'H';
	  }
	
	  codec += levelId;
	  var constraints = '';
	
	  for (var i = 0; i < constraintIds.length; i++) {
	    var v = constraintIds[i];
	
	    if (v) {
	      if (constraints) {
	        constraints += '.';
	      }
	
	      constraints += v.toString(16);
	    }
	  }
	
	  if (constraints) {
	    codec += "." + constraints;
	  }
	
	  return codec;
	};
	
	exports.getHvcCodec = getHvcCodec;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = decodeB64ToUint8Array;
	
	var _window = _interopRequireDefault(__webpack_require__(54));
	
	var atob = function atob(s) {
	  return _window.default.atob ? _window.default.atob(s) : Buffer.from(s, 'base64').toString('binary');
	};
	
	function decodeB64ToUint8Array(b64Text) {
	  var decodedString = atob(b64Text);
	  var array = new Uint8Array(decodedString.length);
	
	  for (var i = 0; i < decodedString.length; i++) {
	    array[i] = decodedString.charCodeAt(i);
	  }
	
	  return array;
	}
	
	module.exports = exports.default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(332).Buffer))

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getId3Offset = exports.getId3Size = void 0;
	
	var _byteHelpers = __webpack_require__(63);
	
	var ID3 = (0, _byteHelpers.toUint8)([0x49, 0x44, 0x33]);
	
	var getId3Size = function getId3Size(bytes, offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var flags = bytes[offset + 5];
	  var returnSize = bytes[offset + 6] << 21 | bytes[offset + 7] << 14 | bytes[offset + 8] << 7 | bytes[offset + 9];
	  var footerPresent = (flags & 16) >> 4;
	
	  if (footerPresent) {
	    return returnSize + 20;
	  }
	
	  return returnSize + 10;
	};
	
	exports.getId3Size = getId3Size;
	
	var getId3Offset = function getId3Offset(bytes, offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	
	  if (bytes.length - offset < 10 || !(0, _byteHelpers.bytesMatch)(bytes, ID3, {
	    offset: offset
	  })) {
	    return offset;
	  }
	
	  offset += getId3Size(bytes, offset); // recursive check for id3 tags as some files
	  // have multiple ID3 tag sections even though
	  // they should not.
	
	  return getId3Offset(bytes, offset);
	};
	
	exports.getId3Offset = getId3Offset;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _urlToolkit = _interopRequireDefault(__webpack_require__(708));
	
	var _window = _interopRequireDefault(__webpack_require__(54));
	
	var DEFAULT_LOCATION = 'http://example.com';
	
	var resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
	  // return early if we don't need to resolve
	  if (/^[a-z]+:/i.test(relativeUrl)) {
	    return relativeUrl;
	  } // if baseUrl is a data URI, ignore it and resolve everything relative to window.location
	
	
	  if (/^data:/.test(baseUrl)) {
	    baseUrl = _window.default.location && _window.default.location.href || '';
	  } // IE11 supports URL but not the URL constructor
	  // feature detect the behavior we want
	
	
	  var nativeURL = typeof _window.default.URL === 'function';
	  var protocolLess = /^\/\//.test(baseUrl); // remove location if window.location isn't available (i.e. we're in node)
	  // and if baseUrl isn't an absolute url
	
	  var removeLocation = !_window.default.location && !/\/\//i.test(baseUrl); // if the base URL is relative then combine with the current location
	
	  if (nativeURL) {
	    baseUrl = new _window.default.URL(baseUrl, _window.default.location || DEFAULT_LOCATION);
	  } else if (!/\/\//i.test(baseUrl)) {
	    baseUrl = _urlToolkit.default.buildAbsoluteURL(_window.default.location && _window.default.location.href || '', baseUrl);
	  }
	
	  if (nativeURL) {
	    var newUrl = new URL(relativeUrl, baseUrl); // if we're a protocol-less url, remove the protocol
	    // and if we're location-less, remove the location
	    // otherwise, return the url unmodified
	
	    if (removeLocation) {
	      return newUrl.href.slice(DEFAULT_LOCATION.length);
	    } else if (protocolLess) {
	      return newUrl.href.slice(newUrl.protocol.length);
	    }
	
	    return newUrl.href;
	  }
	
	  return _urlToolkit.default.buildAbsoluteURL(baseUrl, relativeUrl);
	};
	
	var _default = resolveUrl;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var conventions = __webpack_require__(102);
	
	var find = conventions.find;
	var NAMESPACE = conventions.NAMESPACE;
	
	/**
	 * A prerequisite for `[].filter`, to drop elements that are empty
	 * @param {string} input
	 * @returns {boolean}
	 */
	function notEmptyString (input) {
		return input !== ''
	}
	/**
	 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
	 * @see https://infra.spec.whatwg.org/#ascii-whitespace
	 *
	 * @param {string} input
	 * @returns {string[]} (can be empty)
	 */
	function splitOnASCIIWhitespace(input) {
		// U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
		return input ? input.split(/[\t\n\f\r ]+/).filter(notEmptyString) : []
	}
	
	/**
	 * Adds element as a key to current if it is not already present.
	 *
	 * @param {Record<string, boolean | undefined>} current
	 * @param {string} element
	 * @returns {Record<string, boolean | undefined>}
	 */
	function orderedSetReducer (current, element) {
		if (!current.hasOwnProperty(element)) {
			current[element] = true;
		}
		return current;
	}
	
	/**
	 * @see https://infra.spec.whatwg.org/#ordered-set
	 * @param {string} input
	 * @returns {string[]}
	 */
	function toOrderedSet(input) {
		if (!input) return [];
		var list = splitOnASCIIWhitespace(input);
		return Object.keys(list.reduce(orderedSetReducer, {}))
	}
	
	/**
	 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
	 * which we can not rely on being available.
	 *
	 * @param {any[]} list
	 * @returns {function(any): boolean}
	 */
	function arrayIncludes (list) {
		return function(element) {
			return list && list.indexOf(element) !== -1;
		}
	}
	
	function copy(src,dest){
		for(var p in src){
			if (Object.prototype.hasOwnProperty.call(src, p)) {
				dest[p] = src[p];
			}
		}
	}
	
	/**
	^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
	^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
	 */
	function _extends(Class,Super){
		var pt = Class.prototype;
		if(!(pt instanceof Super)){
			function t(){};
			t.prototype = Super.prototype;
			t = new t();
			copy(pt,t);
			Class.prototype = pt = t;
		}
		if(pt.constructor != Class){
			if(typeof Class != 'function'){
				console.error("unknown Class:"+Class)
			}
			pt.constructor = Class
		}
	}
	
	// Node Types
	var NodeType = {}
	var ELEMENT_NODE                = NodeType.ELEMENT_NODE                = 1;
	var ATTRIBUTE_NODE              = NodeType.ATTRIBUTE_NODE              = 2;
	var TEXT_NODE                   = NodeType.TEXT_NODE                   = 3;
	var CDATA_SECTION_NODE          = NodeType.CDATA_SECTION_NODE          = 4;
	var ENTITY_REFERENCE_NODE       = NodeType.ENTITY_REFERENCE_NODE       = 5;
	var ENTITY_NODE                 = NodeType.ENTITY_NODE                 = 6;
	var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
	var COMMENT_NODE                = NodeType.COMMENT_NODE                = 8;
	var DOCUMENT_NODE               = NodeType.DOCUMENT_NODE               = 9;
	var DOCUMENT_TYPE_NODE          = NodeType.DOCUMENT_TYPE_NODE          = 10;
	var DOCUMENT_FRAGMENT_NODE      = NodeType.DOCUMENT_FRAGMENT_NODE      = 11;
	var NOTATION_NODE               = NodeType.NOTATION_NODE               = 12;
	
	// ExceptionCode
	var ExceptionCode = {}
	var ExceptionMessage = {};
	var INDEX_SIZE_ERR              = ExceptionCode.INDEX_SIZE_ERR              = ((ExceptionMessage[1]="Index size error"),1);
	var DOMSTRING_SIZE_ERR          = ExceptionCode.DOMSTRING_SIZE_ERR          = ((ExceptionMessage[2]="DOMString size error"),2);
	var HIERARCHY_REQUEST_ERR       = ExceptionCode.HIERARCHY_REQUEST_ERR       = ((ExceptionMessage[3]="Hierarchy request error"),3);
	var WRONG_DOCUMENT_ERR          = ExceptionCode.WRONG_DOCUMENT_ERR          = ((ExceptionMessage[4]="Wrong document"),4);
	var INVALID_CHARACTER_ERR       = ExceptionCode.INVALID_CHARACTER_ERR       = ((ExceptionMessage[5]="Invalid character"),5);
	var NO_DATA_ALLOWED_ERR         = ExceptionCode.NO_DATA_ALLOWED_ERR         = ((ExceptionMessage[6]="No data allowed"),6);
	var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ((ExceptionMessage[7]="No modification allowed"),7);
	var NOT_FOUND_ERR               = ExceptionCode.NOT_FOUND_ERR               = ((ExceptionMessage[8]="Not found"),8);
	var NOT_SUPPORTED_ERR           = ExceptionCode.NOT_SUPPORTED_ERR           = ((ExceptionMessage[9]="Not supported"),9);
	var INUSE_ATTRIBUTE_ERR         = ExceptionCode.INUSE_ATTRIBUTE_ERR         = ((ExceptionMessage[10]="Attribute in use"),10);
	//level2
	var INVALID_STATE_ERR        	= ExceptionCode.INVALID_STATE_ERR        	= ((ExceptionMessage[11]="Invalid state"),11);
	var SYNTAX_ERR               	= ExceptionCode.SYNTAX_ERR               	= ((ExceptionMessage[12]="Syntax error"),12);
	var INVALID_MODIFICATION_ERR 	= ExceptionCode.INVALID_MODIFICATION_ERR 	= ((ExceptionMessage[13]="Invalid modification"),13);
	var NAMESPACE_ERR            	= ExceptionCode.NAMESPACE_ERR           	= ((ExceptionMessage[14]="Invalid namespace"),14);
	var INVALID_ACCESS_ERR       	= ExceptionCode.INVALID_ACCESS_ERR      	= ((ExceptionMessage[15]="Invalid access"),15);
	
	/**
	 * DOM Level 2
	 * Object DOMException
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
	 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
	 */
	function DOMException(code, message) {
		if(message instanceof Error){
			var error = message;
		}else{
			error = this;
			Error.call(this, ExceptionMessage[code]);
			this.message = ExceptionMessage[code];
			if(Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
		}
		error.code = code;
		if(message) this.message = this.message + ": " + message;
		return error;
	};
	DOMException.prototype = Error.prototype;
	copy(ExceptionCode,DOMException)
	
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
	 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
	 * The items in the NodeList are accessible via an integral index, starting from 0.
	 */
	function NodeList() {
	};
	NodeList.prototype = {
		/**
		 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
		 * @standard level1
		 */
		length:0,
		/**
		 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
		 * @standard level1
		 * @param index  unsigned long
		 *   Index into the collection.
		 * @return Node
		 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
		 */
		item: function(index) {
			return index >= 0 && index < this.length ? this[index] : null;
		},
		toString:function(isHTML,nodeFilter){
			for(var buf = [], i = 0;i<this.length;i++){
				serializeToString(this[i],buf,isHTML,nodeFilter);
			}
			return buf.join('');
		},
		/**
		 * @private
		 * @param {function (Node):boolean} predicate
		 * @returns {Node[]}
		 */
		filter: function (predicate) {
			return Array.prototype.filter.call(this, predicate);
		},
		/**
		 * @private
		 * @param {Node} item
		 * @returns {number}
		 */
		indexOf: function (item) {
			return Array.prototype.indexOf.call(this, item);
		},
	};
	
	function LiveNodeList(node,refresh){
		this._node = node;
		this._refresh = refresh
		_updateLiveList(this);
	}
	function _updateLiveList(list){
		var inc = list._node._inc || list._node.ownerDocument._inc;
		if (list._inc !== inc) {
			var ls = list._refresh(list._node);
			__set__(list,'length',ls.length);
			if (!list.$$length || ls.length < list.$$length) {
				for (var i = ls.length; i in list; i++) {
					if (Object.prototype.hasOwnProperty.call(list, i)) {
						delete list[i];
					}
				}
			}
			copy(ls,list);
			list._inc = inc;
		}
	}
	LiveNodeList.prototype.item = function(i){
		_updateLiveList(this);
		return this[i] || null;
	}
	
	_extends(LiveNodeList,NodeList);
	
	/**
	 * Objects implementing the NamedNodeMap interface are used
	 * to represent collections of nodes that can be accessed by name.
	 * Note that NamedNodeMap does not inherit from NodeList;
	 * NamedNodeMaps are not maintained in any particular order.
	 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
	 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
	 * and does not imply that the DOM specifies an order to these Nodes.
	 * NamedNodeMap objects in the DOM are live.
	 * used for attributes or DocumentType entities
	 */
	function NamedNodeMap() {
	};
	
	function _findNodeIndex(list,node){
		var i = list.length;
		while(i--){
			if(list[i] === node){return i}
		}
	}
	
	function _addNamedNode(el,list,newAttr,oldAttr){
		if(oldAttr){
			list[_findNodeIndex(list,oldAttr)] = newAttr;
		}else{
			list[list.length++] = newAttr;
		}
		if(el){
			newAttr.ownerElement = el;
			var doc = el.ownerDocument;
			if(doc){
				oldAttr && _onRemoveAttribute(doc,el,oldAttr);
				_onAddAttribute(doc,el,newAttr);
			}
		}
	}
	function _removeNamedNode(el,list,attr){
		//console.log('remove attr:'+attr)
		var i = _findNodeIndex(list,attr);
		if(i>=0){
			var lastIndex = list.length-1
			while(i<lastIndex){
				list[i] = list[++i]
			}
			list.length = lastIndex;
			if(el){
				var doc = el.ownerDocument;
				if(doc){
					_onRemoveAttribute(doc,el,attr);
					attr.ownerElement = null;
				}
			}
		}else{
			throw new DOMException(NOT_FOUND_ERR,new Error(el.tagName+'@'+attr))
		}
	}
	NamedNodeMap.prototype = {
		length:0,
		item:NodeList.prototype.item,
		getNamedItem: function(key) {
	//		if(key.indexOf(':')>0 || key == 'xmlns'){
	//			return null;
	//		}
			//console.log()
			var i = this.length;
			while(i--){
				var attr = this[i];
				//console.log(attr.nodeName,key)
				if(attr.nodeName == key){
					return attr;
				}
			}
		},
		setNamedItem: function(attr) {
			var el = attr.ownerElement;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			var oldAttr = this.getNamedItem(attr.nodeName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
		/* returns Node */
		setNamedItemNS: function(attr) {// raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
			var el = attr.ownerElement, oldAttr;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			oldAttr = this.getNamedItemNS(attr.namespaceURI,attr.localName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
	
		/* returns Node */
		removeNamedItem: function(key) {
			var attr = this.getNamedItem(key);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
	
	
		},// raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
	
		//for level2
		removeNamedItemNS:function(namespaceURI,localName){
			var attr = this.getNamedItemNS(namespaceURI,localName);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
		},
		getNamedItemNS: function(namespaceURI, localName) {
			var i = this.length;
			while(i--){
				var node = this[i];
				if(node.localName == localName && node.namespaceURI == namespaceURI){
					return node;
				}
			}
			return null;
		}
	};
	
	/**
	 * The DOMImplementation interface represents an object providing methods
	 * which are not dependent on any particular document.
	 * Such an object is returned by the `Document.implementation` property.
	 *
	 * __The individual methods describe the differences compared to the specs.__
	 *
	 * @constructor
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
	 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
	 */
	function DOMImplementation() {
	}
	
	DOMImplementation.prototype = {
		/**
		 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
		 * The different implementations fairly diverged in what kind of features were reported.
		 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
		 *
		 * @deprecated It is deprecated and modern browsers return true in all cases.
		 *
		 * @param {string} feature
		 * @param {string} [version]
		 * @returns {boolean} always true
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
		 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
		 */
		hasFeature: function(feature, version) {
				return true;
		},
		/**
		 * Creates an XML Document object of the specified type with its document element.
		 *
		 * __It behaves slightly different from the description in the living standard__:
		 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
		 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
		 * - this implementation is not validating names or qualified names
		 *   (when parsing XML strings, the SAX parser takes care of that)
		 *
		 * @param {string|null} namespaceURI
		 * @param {string} qualifiedName
		 * @param {DocumentType=null} doctype
		 * @returns {Document}
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
		 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
		 *
		 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
		 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
		 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
		 */
		createDocument: function(namespaceURI,  qualifiedName, doctype){
			var doc = new Document();
			doc.implementation = this;
			doc.childNodes = new NodeList();
			doc.doctype = doctype || null;
			if (doctype){
				doc.appendChild(doctype);
			}
			if (qualifiedName){
				var root = doc.createElementNS(namespaceURI, qualifiedName);
				doc.appendChild(root);
			}
			return doc;
		},
		/**
		 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
		 *
		 * __This behavior is slightly different from the in the specs__:
		 * - this implementation is not validating names or qualified names
		 *   (when parsing XML strings, the SAX parser takes care of that)
		 *
		 * @param {string} qualifiedName
		 * @param {string} [publicId]
		 * @param {string} [systemId]
		 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
		 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
		 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
		 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
		 *
		 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
		 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
		 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
		 */
		createDocumentType: function(qualifiedName, publicId, systemId){
			var node = new DocumentType();
			node.name = qualifiedName;
			node.nodeName = qualifiedName;
			node.publicId = publicId || '';
			node.systemId = systemId || '';
	
			return node;
		}
	};
	
	
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
	 */
	
	function Node() {
	};
	
	Node.prototype = {
		firstChild : null,
		lastChild : null,
		previousSibling : null,
		nextSibling : null,
		attributes : null,
		parentNode : null,
		childNodes : null,
		ownerDocument : null,
		nodeValue : null,
		namespaceURI : null,
		prefix : null,
		localName : null,
		// Modified in DOM Level 2:
		insertBefore:function(newChild, refChild){//raises
			return _insertBefore(this,newChild,refChild);
		},
		replaceChild:function(newChild, oldChild){//raises
			_insertBefore(this, newChild,oldChild, assertPreReplacementValidityInDocument);
			if(oldChild){
				this.removeChild(oldChild);
			}
		},
		removeChild:function(oldChild){
			return _removeChild(this,oldChild);
		},
		appendChild:function(newChild){
			return this.insertBefore(newChild,null);
		},
		hasChildNodes:function(){
			return this.firstChild != null;
		},
		cloneNode:function(deep){
			return cloneNode(this.ownerDocument||this,this,deep);
		},
		// Modified in DOM Level 2:
		normalize:function(){
			var child = this.firstChild;
			while(child){
				var next = child.nextSibling;
				if(next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE){
					this.removeChild(next);
					child.appendData(next.data);
				}else{
					child.normalize();
					child = next;
				}
			}
		},
	  	// Introduced in DOM Level 2:
		isSupported:function(feature, version){
			return this.ownerDocument.implementation.hasFeature(feature,version);
		},
	    // Introduced in DOM Level 2:
	    hasAttributes:function(){
	    	return this.attributes.length>0;
	    },
		/**
		 * Look up the prefix associated to the given namespace URI, starting from this node.
		 * **The default namespace declarations are ignored by this method.**
		 * See Namespace Prefix Lookup for details on the algorithm used by this method.
		 *
		 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
		 *
		 * @param {string | null} namespaceURI
		 * @returns {string | null}
		 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
		 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
		 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
		 * @see https://github.com/xmldom/xmldom/issues/322
		 */
	    lookupPrefix:function(namespaceURI){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			for(var n in map){
							if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) {
								return n;
							}
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    lookupNamespaceURI:function(prefix){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			if(Object.prototype.hasOwnProperty.call(map, prefix)){
	    				return map[prefix] ;
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    isDefaultNamespace:function(namespaceURI){
	    	var prefix = this.lookupPrefix(namespaceURI);
	    	return prefix == null;
	    }
	};
	
	
	function _xmlEncoder(c){
		return c == '<' && '&lt;' ||
	         c == '>' && '&gt;' ||
	         c == '&' && '&amp;' ||
	         c == '"' && '&quot;' ||
	         '&#'+c.charCodeAt()+';'
	}
	
	
	copy(NodeType,Node);
	copy(NodeType,Node.prototype);
	
	/**
	 * @param callback return true for continue,false for break
	 * @return boolean true: break visit;
	 */
	function _visitNode(node,callback){
		if(callback(node)){
			return true;
		}
		if(node = node.firstChild){
			do{
				if(_visitNode(node,callback)){return true}
	        }while(node=node.nextSibling)
	    }
	}
	
	
	
	function Document(){
		this.ownerDocument = this;
	}
	
	function _onAddAttribute(doc,el,newAttr){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns === NAMESPACE.XMLNS){
			//update namespace
			el._nsMap[newAttr.prefix?newAttr.localName:''] = newAttr.value
		}
	}
	
	function _onRemoveAttribute(doc,el,newAttr,remove){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns === NAMESPACE.XMLNS){
			//update namespace
			delete el._nsMap[newAttr.prefix?newAttr.localName:'']
		}
	}
	
	/**
	 * Updates `el.childNodes`, updating the indexed items and it's `length`.
	 * Passing `newChild` means it will be appended.
	 * Otherwise it's assumed that an item has been removed,
	 * and `el.firstNode` and it's `.nextSibling` are used
	 * to walk the current list of child nodes.
	 *
	 * @param {Document} doc
	 * @param {Node} el
	 * @param {Node} [newChild]
	 * @private
	 */
	function _onUpdateChild (doc, el, newChild) {
		if(doc && doc._inc){
			doc._inc++;
			//update childNodes
			var cs = el.childNodes;
			if (newChild) {
				cs[cs.length++] = newChild;
			} else {
				var child = el.firstChild;
				var i = 0;
				while (child) {
					cs[i++] = child;
					child = child.nextSibling;
				}
				cs.length = i;
				delete cs[cs.length];
			}
		}
	}
	
	/**
	 * Removes the connections between `parentNode` and `child`
	 * and any existing `child.previousSibling` or `child.nextSibling`.
	 *
	 * @see https://github.com/xmldom/xmldom/issues/135
	 * @see https://github.com/xmldom/xmldom/issues/145
	 *
	 * @param {Node} parentNode
	 * @param {Node} child
	 * @returns {Node} the child that was removed.
	 * @private
	 */
	function _removeChild (parentNode, child) {
		var previous = child.previousSibling;
		var next = child.nextSibling;
		if (previous) {
			previous.nextSibling = next;
		} else {
			parentNode.firstChild = next;
		}
		if (next) {
			next.previousSibling = previous;
		} else {
			parentNode.lastChild = previous;
		}
		child.parentNode = null;
		child.previousSibling = null;
		child.nextSibling = null;
		_onUpdateChild(parentNode.ownerDocument, parentNode);
		return child;
	}
	
	/**
	 * Returns `true` if `node` can be a parent for insertion.
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function hasValidParentNodeType(node) {
		return (
			node &&
			(node.nodeType === Node.DOCUMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node.ELEMENT_NODE)
		);
	}
	
	/**
	 * Returns `true` if `node` can be inserted according to it's `nodeType`.
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function hasInsertableNodeType(node) {
		return (
			node &&
			(isElementNode(node) ||
				isTextNode(node) ||
				isDocTypeNode(node) ||
				node.nodeType === Node.DOCUMENT_FRAGMENT_NODE ||
				node.nodeType === Node.COMMENT_NODE ||
				node.nodeType === Node.PROCESSING_INSTRUCTION_NODE)
		);
	}
	
	/**
	 * Returns true if `node` is a DOCTYPE node
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function isDocTypeNode(node) {
		return node && node.nodeType === Node.DOCUMENT_TYPE_NODE;
	}
	
	/**
	 * Returns true if the node is an element
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function isElementNode(node) {
		return node && node.nodeType === Node.ELEMENT_NODE;
	}
	/**
	 * Returns true if `node` is a text node
	 * @param {Node} node
	 * @returns {boolean}
	 */
	function isTextNode(node) {
		return node && node.nodeType === Node.TEXT_NODE;
	}
	
	/**
	 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
	 * according to the presence and position of a doctype node on the same level.
	 *
	 * @param {Document} doc The document node
	 * @param {Node} child the node that would become the nextSibling if the element would be inserted
	 * @returns {boolean} `true` if an element can be inserted before child
	 * @private
	 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 */
	function isElementInsertionPossible(doc, child) {
		var parentChildNodes = doc.childNodes || [];
		if (find(parentChildNodes, isElementNode) || isDocTypeNode(child)) {
			return false;
		}
		var docTypeNode = find(parentChildNodes, isDocTypeNode);
		return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
	}
	
	/**
	 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
	 * according to the presence and position of a doctype node on the same level.
	 *
	 * @param {Node} doc The document node
	 * @param {Node} child the node that would become the nextSibling if the element would be inserted
	 * @returns {boolean} `true` if an element can be inserted before child
	 * @private
	 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 */
	function isElementReplacementPossible(doc, child) {
		var parentChildNodes = doc.childNodes || [];
	
		function hasElementChildThatIsNotChild(node) {
			return isElementNode(node) && node !== child;
		}
	
		if (find(parentChildNodes, hasElementChildThatIsNotChild)) {
			return false;
		}
		var docTypeNode = find(parentChildNodes, isDocTypeNode);
		return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
	}
	
	/**
	 * @private
	 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
	 *
	 * @param {Node} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node=} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 * @see https://dom.spec.whatwg.org/#concept-node-replace
	 */
	function assertPreInsertionValidity1to5(parent, node, child) {
		// 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
		if (!hasValidParentNodeType(parent)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
		}
		// 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
		// not implemented!
		// 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
		if (child && child.parentNode !== parent) {
			throw new DOMException(NOT_FOUND_ERR, 'child not in parent');
		}
		if (
			// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
			!hasInsertableNodeType(node) ||
			// 5. If either `node` is a Text node and `parent` is a document,
			// the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
			// || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
			// or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
			(isDocTypeNode(node) && parent.nodeType !== Node.DOCUMENT_NODE)
		) {
			throw new DOMException(
				HIERARCHY_REQUEST_ERR,
				'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType
			);
		}
	}
	
	/**
	 * @private
	 * Step 6 of the checks before inserting and before replacing a child are different.
	 *
	 * @param {Document} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 * @see https://dom.spec.whatwg.org/#concept-node-replace
	 */
	function assertPreInsertionValidityInDocument(parent, node, child) {
		var parentChildNodes = parent.childNodes || [];
		var nodeChildNodes = node.childNodes || [];
	
		// DocumentFragment
		if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
			var nodeChildElements = nodeChildNodes.filter(isElementNode);
			// If node has more than one element child or has a Text node child.
			if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
			}
			// Otherwise, if `node` has one element child and either `parent` has an element child,
			// `child` is a doctype, or `child` is non-null and a doctype is following `child`.
			if (nodeChildElements.length === 1 && !isElementInsertionPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
			}
		}
		// Element
		if (isElementNode(node)) {
			// `parent` has an element child, `child` is a doctype,
			// or `child` is non-null and a doctype is following `child`.
			if (!isElementInsertionPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
			}
		}
		// DocumentType
		if (isDocTypeNode(node)) {
			// `parent` has a doctype child,
			if (find(parentChildNodes, isDocTypeNode)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
			}
			var parentElementChild = find(parentChildNodes, isElementNode);
			// `child` is non-null and an element is preceding `child`,
			if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
			}
			// or `child` is null and `parent` has an element child.
			if (!child && parentElementChild) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
			}
		}
	}
	
	/**
	 * @private
	 * Step 6 of the checks before inserting and before replacing a child are different.
	 *
	 * @param {Document} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 * @see https://dom.spec.whatwg.org/#concept-node-replace
	 */
	function assertPreReplacementValidityInDocument(parent, node, child) {
		var parentChildNodes = parent.childNodes || [];
		var nodeChildNodes = node.childNodes || [];
	
		// DocumentFragment
		if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
			var nodeChildElements = nodeChildNodes.filter(isElementNode);
			// If `node` has more than one element child or has a Text node child.
			if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
			}
			// Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
			if (nodeChildElements.length === 1 && !isElementReplacementPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
			}
		}
		// Element
		if (isElementNode(node)) {
			// `parent` has an element child that is not `child` or a doctype is following `child`.
			if (!isElementReplacementPossible(parent, child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
			}
		}
		// DocumentType
		if (isDocTypeNode(node)) {
			function hasDoctypeChildThatIsNotChild(node) {
				return isDocTypeNode(node) && node !== child;
			}
	
			// `parent` has a doctype child that is not `child`,
			if (find(parentChildNodes, hasDoctypeChildThatIsNotChild)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
			}
			var parentElementChild = find(parentChildNodes, isElementNode);
			// or an element is preceding `child`.
			if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
				throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
			}
		}
	}
	
	/**
	 * @private
	 * @param {Node} parent the parent node to insert `node` into
	 * @param {Node} node the node to insert
	 * @param {Node=} child the node that should become the `nextSibling` of `node`
	 * @returns {Node}
	 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
	 * @throws DOMException if `child` is provided but is not a child of `parent`.
	 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
	 */
	function _insertBefore(parent, node, child, _inDocumentAssertion) {
		// To ensure pre-insertion validity of a node into a parent before a child, run these steps:
		assertPreInsertionValidity1to5(parent, node, child);
	
		// If parent is a document, and any of the statements below, switched on the interface node implements,
		// are true, then throw a "HierarchyRequestError" DOMException.
		if (parent.nodeType === Node.DOCUMENT_NODE) {
			(_inDocumentAssertion || assertPreInsertionValidityInDocument)(parent, node, child);
		}
	
		var cp = node.parentNode;
		if(cp){
			cp.removeChild(node);//remove and update
		}
		if(node.nodeType === DOCUMENT_FRAGMENT_NODE){
			var newFirst = node.firstChild;
			if (newFirst == null) {
				return node;
			}
			var newLast = node.lastChild;
		}else{
			newFirst = newLast = node;
		}
		var pre = child ? child.previousSibling : parent.lastChild;
	
		newFirst.previousSibling = pre;
		newLast.nextSibling = child;
	
	
		if(pre){
			pre.nextSibling = newFirst;
		}else{
			parent.firstChild = newFirst;
		}
		if(child == null){
			parent.lastChild = newLast;
		}else{
			child.previousSibling = newLast;
		}
		do{
			newFirst.parentNode = parent;
		}while(newFirst !== newLast && (newFirst= newFirst.nextSibling))
		_onUpdateChild(parent.ownerDocument||parent, parent);
		//console.log(parent.lastChild.nextSibling == null)
		if (node.nodeType == DOCUMENT_FRAGMENT_NODE) {
			node.firstChild = node.lastChild = null;
		}
		return node;
	}
	
	/**
	 * Appends `newChild` to `parentNode`.
	 * If `newChild` is already connected to a `parentNode` it is first removed from it.
	 *
	 * @see https://github.com/xmldom/xmldom/issues/135
	 * @see https://github.com/xmldom/xmldom/issues/145
	 * @param {Node} parentNode
	 * @param {Node} newChild
	 * @returns {Node}
	 * @private
	 */
	function _appendSingleChild (parentNode, newChild) {
		if (newChild.parentNode) {
			newChild.parentNode.removeChild(newChild);
		}
		newChild.parentNode = parentNode;
		newChild.previousSibling = parentNode.lastChild;
		newChild.nextSibling = null;
		if (newChild.previousSibling) {
			newChild.previousSibling.nextSibling = newChild;
		} else {
			parentNode.firstChild = newChild;
		}
		parentNode.lastChild = newChild;
		_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
		return newChild;
	}
	
	Document.prototype = {
		//implementation : null,
		nodeName :  '#document',
		nodeType :  DOCUMENT_NODE,
		/**
		 * The DocumentType node of the document.
		 *
		 * @readonly
		 * @type DocumentType
		 */
		doctype :  null,
		documentElement :  null,
		_inc : 1,
	
		insertBefore :  function(newChild, refChild){//raises
			if(newChild.nodeType == DOCUMENT_FRAGMENT_NODE){
				var child = newChild.firstChild;
				while(child){
					var next = child.nextSibling;
					this.insertBefore(child,refChild);
					child = next;
				}
				return newChild;
			}
			_insertBefore(this, newChild, refChild);
			newChild.ownerDocument = this;
			if (this.documentElement === null && newChild.nodeType === ELEMENT_NODE) {
				this.documentElement = newChild;
			}
	
			return newChild;
		},
		removeChild :  function(oldChild){
			if(this.documentElement == oldChild){
				this.documentElement = null;
			}
			return _removeChild(this,oldChild);
		},
		replaceChild: function (newChild, oldChild) {
			//raises
			_insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
			newChild.ownerDocument = this;
			if (oldChild) {
				this.removeChild(oldChild);
			}
			if (isElementNode(newChild)) {
				this.documentElement = newChild;
			}
		},
		// Introduced in DOM Level 2:
		importNode : function(importedNode,deep){
			return importNode(this,importedNode,deep);
		},
		// Introduced in DOM Level 2:
		getElementById :	function(id){
			var rtv = null;
			_visitNode(this.documentElement,function(node){
				if(node.nodeType == ELEMENT_NODE){
					if(node.getAttribute('id') == id){
						rtv = node;
						return true;
					}
				}
			})
			return rtv;
		},
	
		/**
		 * The `getElementsByClassName` method of `Document` interface returns an array-like object
		 * of all child elements which have **all** of the given class name(s).
		 *
		 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
		 *
		 *
		 * Warning: This is a live LiveNodeList.
		 * Changes in the DOM will reflect in the array as the changes occur.
		 * If an element selected by this array no longer qualifies for the selector,
		 * it will automatically be removed. Be aware of this for iteration purposes.
		 *
		 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
		 *
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
		 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
		 */
		getElementsByClassName: function(classNames) {
			var classNamesSet = toOrderedSet(classNames)
			return new LiveNodeList(this, function(base) {
				var ls = [];
				if (classNamesSet.length > 0) {
					_visitNode(base.documentElement, function(node) {
						if(node !== base && node.nodeType === ELEMENT_NODE) {
							var nodeClassNames = node.getAttribute('class')
							// can be null if the attribute does not exist
							if (nodeClassNames) {
								// before splitting and iterating just compare them for the most common case
								var matches = classNames === nodeClassNames;
								if (!matches) {
									var nodeClassNamesSet = toOrderedSet(nodeClassNames)
									matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet))
								}
								if(matches) {
									ls.push(node);
								}
							}
						}
					});
				}
				return ls;
			});
		},
	
		//document factory method:
		createElement :	function(tagName){
			var node = new Element();
			node.ownerDocument = this;
			node.nodeName = tagName;
			node.tagName = tagName;
			node.localName = tagName;
			node.childNodes = new NodeList();
			var attrs	= node.attributes = new NamedNodeMap();
			attrs._ownerElement = node;
			return node;
		},
		createDocumentFragment :	function(){
			var node = new DocumentFragment();
			node.ownerDocument = this;
			node.childNodes = new NodeList();
			return node;
		},
		createTextNode :	function(data){
			var node = new Text();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createComment :	function(data){
			var node = new Comment();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createCDATASection :	function(data){
			var node = new CDATASection();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createProcessingInstruction :	function(target,data){
			var node = new ProcessingInstruction();
			node.ownerDocument = this;
			node.tagName = node.nodeName = node.target = target;
			node.nodeValue = node.data = data;
			return node;
		},
		createAttribute :	function(name){
			var node = new Attr();
			node.ownerDocument	= this;
			node.name = name;
			node.nodeName	= name;
			node.localName = name;
			node.specified = true;
			return node;
		},
		createEntityReference :	function(name){
			var node = new EntityReference();
			node.ownerDocument	= this;
			node.nodeName	= name;
			return node;
		},
		// Introduced in DOM Level 2:
		createElementNS :	function(namespaceURI,qualifiedName){
			var node = new Element();
			var pl = qualifiedName.split(':');
			var attrs	= node.attributes = new NamedNodeMap();
			node.childNodes = new NodeList();
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.tagName = qualifiedName;
			node.namespaceURI = namespaceURI;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			attrs._ownerElement = node;
			return node;
		},
		// Introduced in DOM Level 2:
		createAttributeNS :	function(namespaceURI,qualifiedName){
			var node = new Attr();
			var pl = qualifiedName.split(':');
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.name = qualifiedName;
			node.namespaceURI = namespaceURI;
			node.specified = true;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			return node;
		}
	};
	_extends(Document,Node);
	
	
	function Element() {
		this._nsMap = {};
	};
	Element.prototype = {
		nodeType : ELEMENT_NODE,
		hasAttribute : function(name){
			return this.getAttributeNode(name)!=null;
		},
		getAttribute : function(name){
			var attr = this.getAttributeNode(name);
			return attr && attr.value || '';
		},
		getAttributeNode : function(name){
			return this.attributes.getNamedItem(name);
		},
		setAttribute : function(name, value){
			var attr = this.ownerDocument.createAttribute(name);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		removeAttribute : function(name){
			var attr = this.getAttributeNode(name)
			attr && this.removeAttributeNode(attr);
		},
	
		//four real opeartion method
		appendChild:function(newChild){
			if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
				return this.insertBefore(newChild,null);
			}else{
				return _appendSingleChild(this,newChild);
			}
		},
		setAttributeNode : function(newAttr){
			return this.attributes.setNamedItem(newAttr);
		},
		setAttributeNodeNS : function(newAttr){
			return this.attributes.setNamedItemNS(newAttr);
		},
		removeAttributeNode : function(oldAttr){
			//console.log(this == oldAttr.ownerElement)
			return this.attributes.removeNamedItem(oldAttr.nodeName);
		},
		//get real attribute name,and remove it by removeAttributeNode
		removeAttributeNS : function(namespaceURI, localName){
			var old = this.getAttributeNodeNS(namespaceURI, localName);
			old && this.removeAttributeNode(old);
		},
	
		hasAttributeNS : function(namespaceURI, localName){
			return this.getAttributeNodeNS(namespaceURI, localName)!=null;
		},
		getAttributeNS : function(namespaceURI, localName){
			var attr = this.getAttributeNodeNS(namespaceURI, localName);
			return attr && attr.value || '';
		},
		setAttributeNS : function(namespaceURI, qualifiedName, value){
			var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		getAttributeNodeNS : function(namespaceURI, localName){
			return this.attributes.getNamedItemNS(namespaceURI, localName);
		},
	
		getElementsByTagName : function(tagName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)){
						ls.push(node);
					}
				});
				return ls;
			});
		},
		getElementsByTagNameNS : function(namespaceURI, localName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)){
						ls.push(node);
					}
				});
				return ls;
	
			});
		}
	};
	Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
	Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
	
	
	_extends(Element,Node);
	function Attr() {
	};
	Attr.prototype.nodeType = ATTRIBUTE_NODE;
	_extends(Attr,Node);
	
	
	function CharacterData() {
	};
	CharacterData.prototype = {
		data : '',
		substringData : function(offset, count) {
			return this.data.substring(offset, offset+count);
		},
		appendData: function(text) {
			text = this.data+text;
			this.nodeValue = this.data = text;
			this.length = text.length;
		},
		insertData: function(offset,text) {
			this.replaceData(offset,0,text);
	
		},
		appendChild:function(newChild){
			throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR])
		},
		deleteData: function(offset, count) {
			this.replaceData(offset,count,"");
		},
		replaceData: function(offset, count, text) {
			var start = this.data.substring(0,offset);
			var end = this.data.substring(offset+count);
			text = start + text + end;
			this.nodeValue = this.data = text;
			this.length = text.length;
		}
	}
	_extends(CharacterData,Node);
	function Text() {
	};
	Text.prototype = {
		nodeName : "#text",
		nodeType : TEXT_NODE,
		splitText : function(offset) {
			var text = this.data;
			var newText = text.substring(offset);
			text = text.substring(0, offset);
			this.data = this.nodeValue = text;
			this.length = text.length;
			var newNode = this.ownerDocument.createTextNode(newText);
			if(this.parentNode){
				this.parentNode.insertBefore(newNode, this.nextSibling);
			}
			return newNode;
		}
	}
	_extends(Text,CharacterData);
	function Comment() {
	};
	Comment.prototype = {
		nodeName : "#comment",
		nodeType : COMMENT_NODE
	}
	_extends(Comment,CharacterData);
	
	function CDATASection() {
	};
	CDATASection.prototype = {
		nodeName : "#cdata-section",
		nodeType : CDATA_SECTION_NODE
	}
	_extends(CDATASection,CharacterData);
	
	
	function DocumentType() {
	};
	DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
	_extends(DocumentType,Node);
	
	function Notation() {
	};
	Notation.prototype.nodeType = NOTATION_NODE;
	_extends(Notation,Node);
	
	function Entity() {
	};
	Entity.prototype.nodeType = ENTITY_NODE;
	_extends(Entity,Node);
	
	function EntityReference() {
	};
	EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
	_extends(EntityReference,Node);
	
	function DocumentFragment() {
	};
	DocumentFragment.prototype.nodeName =	"#document-fragment";
	DocumentFragment.prototype.nodeType =	DOCUMENT_FRAGMENT_NODE;
	_extends(DocumentFragment,Node);
	
	
	function ProcessingInstruction() {
	}
	ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
	_extends(ProcessingInstruction,Node);
	function XMLSerializer(){}
	XMLSerializer.prototype.serializeToString = function(node,isHtml,nodeFilter){
		return nodeSerializeToString.call(node,isHtml,nodeFilter);
	}
	Node.prototype.toString = nodeSerializeToString;
	function nodeSerializeToString(isHtml,nodeFilter){
		var buf = [];
		var refNode = this.nodeType == 9 && this.documentElement || this;
		var prefix = refNode.prefix;
		var uri = refNode.namespaceURI;
	
		if(uri && prefix == null){
			//console.log(prefix)
			var prefix = refNode.lookupPrefix(uri);
			if(prefix == null){
				//isHTML = true;
				var visibleNamespaces=[
				{namespace:uri,prefix:null}
				//{namespace:uri,prefix:''}
				]
			}
		}
		serializeToString(this,buf,isHtml,nodeFilter,visibleNamespaces);
		//console.log('###',this.nodeType,uri,prefix,buf.join(''))
		return buf.join('');
	}
	
	function needNamespaceDefine(node, isHTML, visibleNamespaces) {
		var prefix = node.prefix || '';
		var uri = node.namespaceURI;
		// According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
		// and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
		// > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
		// in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
		// and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
		// > [...] Furthermore, the attribute value [...] must not be an empty string.
		// so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
		if (!uri) {
			return false;
		}
		if (prefix === "xml" && uri === NAMESPACE.XML || uri === NAMESPACE.XMLNS) {
			return false;
		}
	
		var i = visibleNamespaces.length
		while (i--) {
			var ns = visibleNamespaces[i];
			// get namespace prefix
			if (ns.prefix === prefix) {
				return ns.namespace !== uri;
			}
		}
		return true;
	}
	/**
	 * Well-formed constraint: No < in Attribute Values
	 * > The replacement text of any entity referred to directly or indirectly
	 * > in an attribute value must not contain a <.
	 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
	 * @see https://www.w3.org/TR/xml11/#NT-AttValue
	 *
	 * Literal whitespace other than space that appear in attribute values
	 * are serialized as their entity references, so they will be preserved.
	 * (In contrast to whitespace literals in the input which are normalized to spaces)
	 * @see https://www.w3.org/TR/xml11/#AVNormalize
	 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
	 */
	function addSerializedAttribute(buf, qualifiedName, value) {
		buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"')
	}
	
	function serializeToString(node,buf,isHTML,nodeFilter,visibleNamespaces){
		if (!visibleNamespaces) {
			visibleNamespaces = [];
		}
	
		if(nodeFilter){
			node = nodeFilter(node);
			if(node){
				if(typeof node == 'string'){
					buf.push(node);
					return;
				}
			}else{
				return;
			}
			//buf.sort.apply(attrs, attributeSorter);
		}
	
		switch(node.nodeType){
		case ELEMENT_NODE:
			var attrs = node.attributes;
			var len = attrs.length;
			var child = node.firstChild;
			var nodeName = node.tagName;
	
			isHTML = NAMESPACE.isHTML(node.namespaceURI) || isHTML
	
			var prefixedNodeName = nodeName
			if (!isHTML && !node.prefix && node.namespaceURI) {
				var defaultNS
				// lookup current default ns from `xmlns` attribute
				for (var ai = 0; ai < attrs.length; ai++) {
					if (attrs.item(ai).name === 'xmlns') {
						defaultNS = attrs.item(ai).value
						break
					}
				}
				if (!defaultNS) {
					// lookup current default ns in visibleNamespaces
					for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
						var namespace = visibleNamespaces[nsi]
						if (namespace.prefix === '' && namespace.namespace === node.namespaceURI) {
							defaultNS = namespace.namespace
							break
						}
					}
				}
				if (defaultNS !== node.namespaceURI) {
					for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
						var namespace = visibleNamespaces[nsi]
						if (namespace.namespace === node.namespaceURI) {
							if (namespace.prefix) {
								prefixedNodeName = namespace.prefix + ':' + nodeName
							}
							break
						}
					}
				}
			}
	
			buf.push('<', prefixedNodeName);
	
			for(var i=0;i<len;i++){
				// add namespaces for attributes
				var attr = attrs.item(i);
				if (attr.prefix == 'xmlns') {
					visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
				}else if(attr.nodeName == 'xmlns'){
					visibleNamespaces.push({ prefix: '', namespace: attr.value });
				}
			}
	
			for(var i=0;i<len;i++){
				var attr = attrs.item(i);
				if (needNamespaceDefine(attr,isHTML, visibleNamespaces)) {
					var prefix = attr.prefix||'';
					var uri = attr.namespaceURI;
					addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
					visibleNamespaces.push({ prefix: prefix, namespace:uri });
				}
				serializeToString(attr,buf,isHTML,nodeFilter,visibleNamespaces);
			}
	
			// add namespace for current node
			if (nodeName === prefixedNodeName && needNamespaceDefine(node, isHTML, visibleNamespaces)) {
				var prefix = node.prefix||'';
				var uri = node.namespaceURI;
				addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
				visibleNamespaces.push({ prefix: prefix, namespace:uri });
			}
	
			if(child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)){
				buf.push('>');
				//if is cdata child node
				if(isHTML && /^script$/i.test(nodeName)){
					while(child){
						if(child.data){
							buf.push(child.data);
						}else{
							serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
						}
						child = child.nextSibling;
					}
				}else
				{
					while(child){
						serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
						child = child.nextSibling;
					}
				}
				buf.push('</',prefixedNodeName,'>');
			}else{
				buf.push('/>');
			}
			// remove added visible namespaces
			//visibleNamespaces.length = startVisibleNamespaces;
			return;
		case DOCUMENT_NODE:
		case DOCUMENT_FRAGMENT_NODE:
			var child = node.firstChild;
			while(child){
				serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
				child = child.nextSibling;
			}
			return;
		case ATTRIBUTE_NODE:
			return addSerializedAttribute(buf, node.name, node.value);
		case TEXT_NODE:
			/**
			 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
			 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
			 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
			 * `&amp;` and `&lt;` respectively.
			 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
			 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
			 * when that string is not marking the end of a CDATA section.
			 *
			 * In the content of elements, character data is any string of characters
			 * which does not contain the start-delimiter of any markup
			 * and does not include the CDATA-section-close delimiter, `]]>`.
			 *
			 * @see https://www.w3.org/TR/xml/#NT-CharData
			 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
			 */
			return buf.push(node.data
				.replace(/[<&>]/g,_xmlEncoder)
			);
		case CDATA_SECTION_NODE:
			return buf.push( '<![CDATA[',node.data,']]>');
		case COMMENT_NODE:
			return buf.push( "<!--",node.data,"-->");
		case DOCUMENT_TYPE_NODE:
			var pubid = node.publicId;
			var sysid = node.systemId;
			buf.push('<!DOCTYPE ',node.name);
			if(pubid){
				buf.push(' PUBLIC ', pubid);
				if (sysid && sysid!='.') {
					buf.push(' ', sysid);
				}
				buf.push('>');
			}else if(sysid && sysid!='.'){
				buf.push(' SYSTEM ', sysid, '>');
			}else{
				var sub = node.internalSubset;
				if(sub){
					buf.push(" [",sub,"]");
				}
				buf.push(">");
			}
			return;
		case PROCESSING_INSTRUCTION_NODE:
			return buf.push( "<?",node.target," ",node.data,"?>");
		case ENTITY_REFERENCE_NODE:
			return buf.push( '&',node.nodeName,';');
		//case ENTITY_NODE:
		//case NOTATION_NODE:
		default:
			buf.push('??',node.nodeName);
		}
	}
	function importNode(doc,node,deep){
		var node2;
		switch (node.nodeType) {
		case ELEMENT_NODE:
			node2 = node.cloneNode(false);
			node2.ownerDocument = doc;
			//var attrs = node2.attributes;
			//var len = attrs.length;
			//for(var i=0;i<len;i++){
				//node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
			//}
		case DOCUMENT_FRAGMENT_NODE:
			break;
		case ATTRIBUTE_NODE:
			deep = true;
			break;
		//case ENTITY_REFERENCE_NODE:
		//case PROCESSING_INSTRUCTION_NODE:
		////case TEXT_NODE:
		//case CDATA_SECTION_NODE:
		//case COMMENT_NODE:
		//	deep = false;
		//	break;
		//case DOCUMENT_NODE:
		//case DOCUMENT_TYPE_NODE:
		//cannot be imported.
		//case ENTITY_NODE:
		//case NOTATION_NODE：
		//can not hit in level3
		//default:throw e;
		}
		if(!node2){
			node2 = node.cloneNode(false);//false
		}
		node2.ownerDocument = doc;
		node2.parentNode = null;
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(importNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	//
	//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
	//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
	function cloneNode(doc,node,deep){
		var node2 = new node.constructor();
		for (var n in node) {
			if (Object.prototype.hasOwnProperty.call(node, n)) {
				var v = node[n];
				if (typeof v != "object") {
					if (v != node2[n]) {
						node2[n] = v;
					}
				}
			}
		}
		if(node.childNodes){
			node2.childNodes = new NodeList();
		}
		node2.ownerDocument = doc;
		switch (node2.nodeType) {
		case ELEMENT_NODE:
			var attrs	= node.attributes;
			var attrs2	= node2.attributes = new NamedNodeMap();
			var len = attrs.length
			attrs2._ownerElement = node2;
			for(var i=0;i<len;i++){
				node2.setAttributeNode(cloneNode(doc,attrs.item(i),true));
			}
			break;;
		case ATTRIBUTE_NODE:
			deep = true;
		}
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(cloneNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	
	function __set__(object,key,value){
		object[key] = value
	}
	//do dynamic
	try{
		if(Object.defineProperty){
			Object.defineProperty(LiveNodeList.prototype,'length',{
				get:function(){
					_updateLiveList(this);
					return this.$$length;
				}
			});
	
			Object.defineProperty(Node.prototype,'textContent',{
				get:function(){
					return getTextContent(this);
				},
	
				set:function(data){
					switch(this.nodeType){
					case ELEMENT_NODE:
					case DOCUMENT_FRAGMENT_NODE:
						while(this.firstChild){
							this.removeChild(this.firstChild);
						}
						if(data || String(data)){
							this.appendChild(this.ownerDocument.createTextNode(data));
						}
						break;
	
					default:
						this.data = data;
						this.value = data;
						this.nodeValue = data;
					}
				}
			})
	
			function getTextContent(node){
				switch(node.nodeType){
				case ELEMENT_NODE:
				case DOCUMENT_FRAGMENT_NODE:
					var buf = [];
					node = node.firstChild;
					while(node){
						if(node.nodeType!==7 && node.nodeType !==8){
							buf.push(getTextContent(node));
						}
						node = node.nextSibling;
					}
					return buf.join('');
				default:
					return node.nodeValue;
				}
			}
	
			__set__ = function(object,key,value){
				//console.log(value)
				object['$$'+key] = value
			}
		}
	}catch(e){//ie8
	}
	
	//if(typeof require == 'function'){
		exports.DocumentType = DocumentType;
		exports.DOMException = DOMException;
		exports.DOMImplementation = DOMImplementation;
		exports.Element = Element;
		exports.Node = Node;
		exports.NodeList = NodeList;
		exports.XMLSerializer = XMLSerializer;
	//}


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(38);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(26);
	var toAbsoluteIndex = __webpack_require__(72);
	var toLength = __webpack_require__(24);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(65);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(28);
	var toObject = __webpack_require__(26);
	var IObject = __webpack_require__(91);
	var toLength = __webpack_require__(24);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(28);
	var isObject = __webpack_require__(9);
	var invoke = __webpack_require__(205);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(23).f;
	var create = __webpack_require__(66);
	var redefineAll = __webpack_require__(70);
	var ctx = __webpack_require__(40);
	var anInstance = __webpack_require__(64);
	var forOf = __webpack_require__(65);
	var $iterDefine = __webpack_require__(141);
	var step = __webpack_require__(208);
	var setSpecies = __webpack_require__(71);
	var DESCRIPTORS = __webpack_require__(22);
	var fastKey = __webpack_require__(61).fastKey;
	var validate = __webpack_require__(80);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(90);
	var from = __webpack_require__(197);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(70);
	var getWeak = __webpack_require__(61).getWeak;
	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(9);
	var anInstance = __webpack_require__(64);
	var forOf = __webpack_require__(65);
	var createArrayMethod = __webpack_require__(44);
	var $has = __webpack_require__(34);
	var validate = __webpack_require__(80);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(107);
	var isObject = __webpack_require__(9);
	var toLength = __webpack_require__(24);
	var ctx = __webpack_require__(40);
	var IS_CONCAT_SPREADABLE = __webpack_require__(13)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(22) && !__webpack_require__(8)(function () {
	  return Object.defineProperty(__webpack_require__(134)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 205 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(9);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(5);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 208 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(143);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 210 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 211 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(68);
	var gOPS = __webpack_require__(111);
	var pIE = __webpack_require__(92);
	var toObject = __webpack_require__(26);
	var IObject = __webpack_require__(91);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(8)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(23);
	var anObject = __webpack_require__(5);
	var getKeys = __webpack_require__(68);
	
	module.exports = __webpack_require__(22) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(37);
	var gOPN = __webpack_require__(67).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(34);
	var toIObject = __webpack_require__(37);
	var arrayIndexOf = __webpack_require__(103)(false);
	var IE_PROTO = __webpack_require__(147)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(68);
	var toIObject = __webpack_require__(37);
	var isEnum = __webpack_require__(92).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(67);
	var gOPS = __webpack_require__(111);
	var anObject = __webpack_require__(5);
	var Reflect = __webpack_require__(6).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(6).parseFloat;
	var $trim = __webpack_require__(79).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(151) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(6).parseInt;
	var $trim = __webpack_require__(79).trim;
	var ws = __webpack_require__(151);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 220 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(9);
	var newPromiseCapability = __webpack_require__(145);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(24);
	var repeat = __webpack_require__(150);
	var defined = __webpack_require__(45);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(47);
	var toLength = __webpack_require__(24);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(13);


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(200);
	var validate = __webpack_require__(80);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(104)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(22) && /./g.flags != 'g') __webpack_require__(23).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(106)
	});


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(200);
	var validate = __webpack_require__(80);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(104)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(44)(0);
	var redefine = __webpack_require__(32);
	var meta = __webpack_require__(61);
	var assign = __webpack_require__(212);
	var weak = __webpack_require__(202);
	var isObject = __webpack_require__(9);
	var fails = __webpack_require__(8);
	var validate = __webpack_require__(80);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(104)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(535);
	var isArguments = __webpack_require__(534);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 232 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var topLevel = typeof global !== 'undefined' ? global :
	    typeof window !== 'undefined' ? window : {}
	var minDoc = __webpack_require__(732);
	
	var doccy;
	
	if (typeof document !== 'undefined') {
	    doccy = document;
	} else {
	    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
	
	    if (!doccy) {
	        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
	    }
	}
	
	module.exports = doccy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(119);
	
	var _DOMUtils = __webpack_require__(159);
	
	var _createHistory = __webpack_require__(237);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(81);
	
	var _PathUtils = __webpack_require__(74);
	
	var _ExecutionEnvironment = __webpack_require__(119);
	
	var _DOMUtils = __webpack_require__(159);
	
	var _DOMStateStorage = __webpack_require__(234);
	
	var _createDOMHistory = __webpack_require__(235);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(229);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(74);
	
	var _AsyncUtils = __webpack_require__(556);
	
	var _Actions = __webpack_require__(81);
	
	var _createLocation2 = __webpack_require__(558);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(161);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(160);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(119);
	
	var _PathUtils = __webpack_require__(74);
	
	var _runTransitionHook = __webpack_require__(161);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(160);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(328);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(575);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 242 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(75);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(83);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactInstrumentation = __webpack_require__(43);
	
	var quoteAttributeValueForBrowser = __webpack_require__(640);
	var warning = __webpack_require__(10);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 245 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var LinkedValueUtils = __webpack_require__(167);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactUpdates = __webpack_require__(50);
	
	var warning = __webpack_require__(10);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 247 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 248 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(4);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(600);
	
	var containsNode = __webpack_require__(546);
	var focusNode = __webpack_require__(231);
	var getActiveElement = __webpack_require__(232);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var DOMLazyTree = __webpack_require__(82);
	var DOMProperty = __webpack_require__(83);
	var React = __webpack_require__(88);
	var ReactBrowserEventEmitter = __webpack_require__(121);
	var ReactCurrentOwner = __webpack_require__(56);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactDOMContainerInfo = __webpack_require__(594);
	var ReactDOMFeatureFlags = __webpack_require__(596);
	var ReactFeatureFlags = __webpack_require__(248);
	var ReactInstanceMap = __webpack_require__(96);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactMarkupChecksum = __webpack_require__(610);
	var ReactReconciler = __webpack_require__(84);
	var ReactUpdateQueue = __webpack_require__(170);
	var ReactUpdates = __webpack_require__(50);
	
	var emptyObject = __webpack_require__(118);
	var instantiateReactComponent = __webpack_require__(259);
	var invariant = __webpack_require__(4);
	var setInnerHTML = __webpack_require__(125);
	var shouldUpdateReactComponent = __webpack_require__(176);
	var warning = __webpack_require__(10);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var React = __webpack_require__(88);
	
	var invariant = __webpack_require__(4);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 253 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 255 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(252);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(25);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var ReactCompositeComponent = __webpack_require__(591);
	var ReactEmptyComponent = __webpack_require__(247);
	var ReactHostComponent = __webpack_require__(249);
	
	var getNextDebugID = __webpack_require__(698);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(10);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 260 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	var escapeTextContentForBrowser = __webpack_require__(124);
	var setInnerHTML = __webpack_require__(125);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(56);
	var REACT_ELEMENT_TYPE = __webpack_require__(606);
	
	var getIteratorFn = __webpack_require__(637);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(166);
	var warning = __webpack_require__(10);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 263 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _PatternUtils = __webpack_require__(86);
	
	var _InternalPropTypes = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(127);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(120);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(238);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(559);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(270);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(127);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(120);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(238);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(98),
	    _assign = __webpack_require__(14);
	
	var ReactNoopUpdateQueue = __webpack_require__(274);
	
	var canDefineProperty = __webpack_require__(275);
	var emptyObject = __webpack_require__(118);
	var invariant = __webpack_require__(4);
	var lowPriorityWarning = __webpack_require__(699);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(98);
	
	var ReactCurrentOwner = __webpack_require__(56);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(10);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 273 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(10);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 276 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  manager: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var Bezel =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Bezel, _Component);
	
	  function Bezel(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Bezel);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bezel).call(this, props, context));
	    _this.timer = null;
	    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
	    _this.state = {
	      hidden: true,
	      operation: {}
	    };
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Bezel, [{
	    key: "handleStateChange",
	    value: function handleStateChange(state, prevState) {
	      var _this2 = this;
	
	      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
	        if (this.timer) {
	          // previous animation is not finished
	          clearTimeout(this.timer); // cancel it
	
	          this.timer = null;
	        } // show it
	        // update operation
	
	
	        this.setState({
	          hidden: false,
	          count: state.count,
	          operation: state.operation
	        }); // hide it after 0.5s
	
	        this.timer = setTimeout(function () {
	          _this2.setState({
	            hidden: true
	          });
	
	          _this2.timer = null;
	        }, 500);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      // only displays for shortcut so far
	      if (this.state.operation.source !== 'shortcut') {
	        return null;
	      }
	
	      var style = this.state.hidden ? {
	        display: 'none'
	      } : null;
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])({
	          'video-react-bezel': true,
	          'video-react-bezel-animation': this.state.count % 2 === 0,
	          'video-react-bezel-animation-alt': this.state.count % 2 === 1
	        }, this.props.className),
	        style: style,
	        role: "status",
	        "aria-label": this.state.operation.action
	      }, _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('video-react-bezel-icon', "video-react-bezel-icon-".concat(this.state.operation.action))
	      }));
	    }
	  }]);
	  return Bezel;
	}(_react.Component);
	
	exports["default"] = Bezel;
	Bezel.propTypes = propTypes;
	Bezel.displayName = 'Bezel';

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  position: _propTypes["default"].string,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  position: 'left'
	};
	
	var BigPlayButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(BigPlayButton, _Component);
	
	  function BigPlayButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, BigPlayButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BigPlayButton).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(BigPlayButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "handleClick",
	    value: function handleClick() {
	      var actions = this.props.actions;
	      actions.play();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          position = _this$props.position;
	      return _react["default"].createElement("button", {
	        className: (0, _classnames["default"])('video-react-big-play-button', "video-react-big-play-button-".concat(position), this.props.className, {
	          'big-play-button-hide': player.hasStarted || !player.currentSrc
	        }),
	        type: "button",
	        "aria-live": "polite",
	        tabIndex: "0",
	        onClick: this.handleClick
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Play Video"));
	    }
	  }]);
	  return BigPlayButton;
	}(_react.Component);
	
	exports["default"] = BigPlayButton;
	BigPlayButton.propTypes = propTypes;
	BigPlayButton.defaultProps = defaultProps;
	BigPlayButton.displayName = 'BigPlayButton';

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(57));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  tagName: _propTypes["default"].string,
	  onClick: _propTypes["default"].func.isRequired,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  tagName: 'div'
	};
	
	var ClickableComponent =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ClickableComponent, _Component);
	
	  function ClickableComponent(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ClickableComponent);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClickableComponent).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ClickableComponent, [{
	    key: "handleKeypress",
	    value: function handleKeypress(event) {
	      // Support Space (32) or Enter (13) key operation to fire a click event
	      if (event.which === 32 || event.which === 13) {
	        event.preventDefault();
	        this.handleClick(event);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      var onClick = this.props.onClick;
	      onClick(event);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(e) {
	      document.addEventListener('keydown', this.handleKeypress);
	
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(e) {
	      document.removeEventListener('keydown', this.handleKeypress);
	
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var Tag = this.props.tagName;
	      var props = (0, _objectSpread2["default"])({}, this.props);
	      delete props.tagName;
	      delete props.className;
	      return _react["default"].createElement(Tag, (0, _extends2["default"])({
	        className: (0, _classnames["default"])(this.props.className),
	        role: "button",
	        tabIndex: "0",
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, props));
	    }
	  }]);
	  return ClickableComponent;
	}(_react.Component);
	
	exports["default"] = ClickableComponent;
	ClickableComponent.propTypes = propTypes;
	ClickableComponent.defaultProps = defaultProps;
	ClickableComponent.displayName = 'ClickableComponent';

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = LoadingSpinner;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function LoadingSpinner(_ref) {
	  var player = _ref.player,
	      className = _ref.className;
	
	  if (player.error) {
	    return null;
	  }
	
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-loading-spinner', className)
	  });
	}
	
	LoadingSpinner.propTypes = propTypes;
	LoadingSpinner.displayName = 'LoadingSpinner';

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  poster: _propTypes["default"].string,
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function PosterImage(_ref) {
	  var poster = _ref.poster,
	      player = _ref.player,
	      actions = _ref.actions,
	      className = _ref.className;
	
	  if (!poster || player.hasStarted) {
	    return null;
	  }
	
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-poster', className),
	    style: {
	      backgroundImage: "url(\"".concat(poster, "\")")
	    },
	    onClick: function onClick() {
	      if (player.paused) {
	        actions.play();
	      }
	    }
	  });
	}
	
	PosterImage.propTypes = propTypes;
	PosterImage.displayName = 'PosterImage';
	var _default = PosterImage;
	exports["default"] = _default;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(99));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(188));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = __webpack_require__(2);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _dom = __webpack_require__(129);
	
	var propTypes = {
	  clickable: _propTypes["default"].bool,
	  dblclickable: _propTypes["default"].bool,
	  manager: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  shortcuts: _propTypes["default"].array
	};
	var defaultProps = {
	  clickable: true,
	  dblclickable: true
	};
	
	var Shortcut =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Shortcut, _Component);
	
	  function Shortcut(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Shortcut);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Shortcut).call(this, props, context));
	    _this.defaultShortcuts = [{
	      keyCode: 32,
	      // spacebar
	      handle: _this.togglePlay
	    }, {
	      keyCode: 75,
	      // k
	      handle: _this.togglePlay
	    }, {
	      keyCode: 70,
	      // f
	      handle: _this.toggleFullscreen
	    }, {
	      keyCode: 37,
	      // Left arrow
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.replay(5, {
	          action: 'replay-5',
	          source: 'shortcut'
	        }); // Go back 5 seconds
	      }
	    }, {
	      keyCode: 74,
	      // j
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.replay(10, {
	          action: 'replay-10',
	          source: 'shortcut'
	        }); // Go back 10 seconds
	      }
	    }, {
	      keyCode: 39,
	      // Right arrow
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.forward(5, {
	          action: 'forward-5',
	          source: 'shortcut'
	        }); // Go forward 5 seconds
	      }
	    }, {
	      keyCode: 76,
	      // l
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.forward(10, {
	          action: 'forward-10',
	          source: 'shortcut'
	        }); // Go forward 10 seconds
	      }
	    }, {
	      keyCode: 36,
	      // Home
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	
	        actions.seek(0); // Go to beginning of video
	      }
	    }, {
	      keyCode: 35,
	      // End
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        } // Go to end of video
	
	
	        actions.seek(player.duration);
	      }
	    }, {
	      keyCode: 38,
	      // Up arrow
	      handle: function handle(player, actions) {
	        // Increase volume 5%
	        var v = player.volume + 0.05;
	
	        if (v > 1) {
	          v = 1;
	        }
	
	        actions.changeVolume(v, {
	          action: 'volume-up',
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 40,
	      // Down arrow
	      handle: function handle(player, actions) {
	        // Decrease volume 5%
	        var v = player.volume - 0.05;
	
	        if (v < 0) {
	          v = 0;
	        }
	
	        var action = v > 0 ? 'volume-down' : 'volume-off';
	        actions.changeVolume(v, {
	          action: action,
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 190,
	      // Shift + >
	      shift: true,
	      handle: function handle(player, actions) {
	        // Increase speed
	        var playbackRate = player.playbackRate;
	
	        if (playbackRate >= 1.5) {
	          playbackRate = 2;
	        } else if (playbackRate >= 1.25) {
	          playbackRate = 1.5;
	        } else if (playbackRate >= 1.0) {
	          playbackRate = 1.25;
	        } else if (playbackRate >= 0.5) {
	          playbackRate = 1.0;
	        } else if (playbackRate >= 0.25) {
	          playbackRate = 0.5;
	        } else if (playbackRate >= 0) {
	          playbackRate = 0.25;
	        }
	
	        actions.changeRate(playbackRate, {
	          action: 'fast-forward',
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 188,
	      // Shift + <
	      shift: true,
	      handle: function handle(player, actions) {
	        // Decrease speed
	        var playbackRate = player.playbackRate;
	
	        if (playbackRate <= 0.5) {
	          playbackRate = 0.25;
	        } else if (playbackRate <= 1.0) {
	          playbackRate = 0.5;
	        } else if (playbackRate <= 1.25) {
	          playbackRate = 1.0;
	        } else if (playbackRate <= 1.5) {
	          playbackRate = 1.25;
	        } else if (playbackRate <= 2) {
	          playbackRate = 1.5;
	        }
	
	        actions.changeRate(playbackRate, {
	          action: 'fast-rewind',
	          source: 'shortcut'
	        });
	      }
	    }];
	    _this.shortcuts = (0, _toConsumableArray2["default"])(_this.defaultShortcuts);
	    _this.mergeShortcuts = _this.mergeShortcuts.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleDoubleClick = _this.handleDoubleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Shortcut, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mergeShortcuts();
	      document.addEventListener('keydown', this.handleKeyPress);
	      document.addEventListener('click', this.handleClick);
	      document.addEventListener('dblclick', this.handleDoubleClick);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.shortcuts !== this.props.shortcuts) {
	        this.mergeShortcuts();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.handleKeyPress);
	      document.removeEventListener('click', this.handleClick);
	      document.removeEventListener('dblclick', this.handleDoubleClick);
	    } // merge the shortcuts from props
	
	  }, {
	    key: "mergeShortcuts",
	    value: function mergeShortcuts() {
	      var getShortcutKey = function getShortcutKey(_ref) {
	        var _ref$keyCode = _ref.keyCode,
	            keyCode = _ref$keyCode === void 0 ? 0 : _ref$keyCode,
	            _ref$ctrl = _ref.ctrl,
	            ctrl = _ref$ctrl === void 0 ? false : _ref$ctrl,
	            _ref$shift = _ref.shift,
	            shift = _ref$shift === void 0 ? false : _ref$shift,
	            _ref$alt = _ref.alt,
	            alt = _ref$alt === void 0 ? false : _ref$alt;
	        return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
	      };
	
	      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
	        return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
	      }, {});
	      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
	        var keyCode = shortcut.keyCode,
	            handle = shortcut.handle;
	
	        if (keyCode && typeof handle === 'function') {
	          return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
	        }
	
	        return shortcuts;
	      }, defaultShortcuts);
	
	      var gradeShortcut = function gradeShortcut(s) {
	        var score = 0;
	        var ps = ['ctrl', 'shift', 'alt'];
	        ps.forEach(function (key) {
	          if (s[key]) {
	            score++;
	          }
	        });
	        return score;
	      };
	
	      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
	        return mergedShortcuts[key];
	      }).sort(function (a, b) {
	        return gradeShortcut(b) - gradeShortcut(a);
	      });
	    }
	  }, {
	    key: "togglePlay",
	    value: function togglePlay(player, actions) {
	      if (player.paused) {
	        actions.play({
	          action: 'play',
	          source: 'shortcut'
	        });
	      } else {
	        actions.pause({
	          action: 'pause',
	          source: 'shortcut'
	        });
	      }
	    }
	  }, {
	    key: "toggleFullscreen",
	    value: function toggleFullscreen(player, actions) {
	      actions.toggleFullscreen(player);
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(e) {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	
	      if (!player.isActive) {
	        return;
	      }
	
	      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active') // || hasClass(document.activeElement, 'video-react-slider')
	      || (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
	        return;
	      }
	
	      var keyCode = e.keyCode || e.which;
	      var ctrl = e.ctrlKey || e.metaKey;
	      var shift = e.shiftKey;
	      var alt = e.altKey;
	      var shortcut = this.shortcuts.filter(function (s) {
	        if (!s.keyCode || s.keyCode - keyCode !== 0) {
	          return false;
	        }
	
	        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
	          return false;
	        }
	
	        return true;
	      })[0];
	
	      if (shortcut) {
	        shortcut.handle(player, actions);
	        e.preventDefault();
	      }
	    } // only if player is active and player is ready
	
	  }, {
	    key: "canBeClicked",
	    value: function canBeClicked(player, e) {
	      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(e) {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions,
	          clickable = _this$props2.clickable;
	
	      if (!this.canBeClicked(player, e) || !clickable) {
	        return;
	      }
	
	      this.togglePlay(player, actions); // e.preventDefault();
	    }
	  }, {
	    key: "handleDoubleClick",
	    value: function handleDoubleClick(e) {
	      var _this$props3 = this.props,
	          player = _this$props3.player,
	          actions = _this$props3.actions,
	          dblclickable = _this$props3.dblclickable;
	
	      if (!this.canBeClicked(player, e) || !dblclickable) {
	        return;
	      }
	
	      this.toggleFullscreen(player, actions); // e.preventDefault();
	    } // this component dose not render anything
	    // it's just for the key down event
	
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	  return Shortcut;
	}(_react.Component);
	
	exports["default"] = Shortcut;
	Shortcut.propTypes = propTypes;
	Shortcut.defaultProps = defaultProps;
	Shortcut.displayName = 'Shortcut';

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(51);
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  children: _propTypes["default"].any,
	  startTime: _propTypes["default"].number,
	  loop: _propTypes["default"].bool,
	  muted: _propTypes["default"].bool,
	  autoPlay: _propTypes["default"].bool,
	  playsInline: _propTypes["default"].bool,
	  src: _propTypes["default"].string,
	  poster: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
	  crossOrigin: _propTypes["default"].string,
	  onLoadStart: _propTypes["default"].func,
	  onWaiting: _propTypes["default"].func,
	  onCanPlay: _propTypes["default"].func,
	  onCanPlayThrough: _propTypes["default"].func,
	  onPlaying: _propTypes["default"].func,
	  onEnded: _propTypes["default"].func,
	  onSeeking: _propTypes["default"].func,
	  onSeeked: _propTypes["default"].func,
	  onPlay: _propTypes["default"].func,
	  onPause: _propTypes["default"].func,
	  onProgress: _propTypes["default"].func,
	  onDurationChange: _propTypes["default"].func,
	  onError: _propTypes["default"].func,
	  onSuspend: _propTypes["default"].func,
	  onAbort: _propTypes["default"].func,
	  onEmptied: _propTypes["default"].func,
	  onStalled: _propTypes["default"].func,
	  onLoadedMetadata: _propTypes["default"].func,
	  onLoadedData: _propTypes["default"].func,
	  onTimeUpdate: _propTypes["default"].func,
	  onRateChange: _propTypes["default"].func,
	  onVolumeChange: _propTypes["default"].func,
	  onResize: _propTypes["default"].func
	};
	
	var Video =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Video, _Component);
	
	  function Video(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Video);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Video).call(this, props));
	    _this.video = null; // the html5 video
	
	    _this.play = _this.play.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.pause = _this.pause.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.seek = _this.seek.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.forward = _this.forward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.replay = _this.replay.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.toggleFullscreen = _this.toggleFullscreen.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getProperties = _this.getProperties.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleLoadStart = _this.handleLoadStart.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleCanPlay = _this.handleCanPlay.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePlaying = _this.handlePlaying.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleEnded = _this.handleEnded.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleWaiting = _this.handleWaiting.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSeeking = _this.handleSeeking.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSeeked = _this.handleSeeked.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFullscreenChange = _this.handleFullscreenChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSuspend = _this.handleSuspend.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleAbort = _this.handleAbort.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleEmptied = _this.handleEmptied.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleStalled = _this.handleStalled.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleLoadedData = _this.handleLoadedData.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleTimeUpdate = _this.handleTimeUpdate.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleRateChange = _this.handleRateChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleVolumeChange = _this.handleVolumeChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleDurationChange = _this.handleDurationChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind((0, _assertThisInitialized2["default"])(_this)), 250);
	    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleTextTrackChange = _this.handleTextTrackChange.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Video, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.forceUpdate(); // make sure the children can get the video property
	
	      if (this.video && this.video.textTracks) {
	        this.video.textTracks.onaddtrack = this.handleTextTrackChange;
	        this.video.textTracks.onremovetrack = this.handleTextTrackChange;
	      }
	    } // get all video properties
	
	  }, {
	    key: "getProperties",
	    value: function getProperties() {
	      var _this2 = this;
	
	      if (!this.video) {
	        return null;
	      }
	
	      return _utils.mediaProperties.reduce(function (properties, key) {
	        properties[key] = _this2.video[key];
	        return properties;
	      }, {});
	    } // get playback rate
	
	  }, {
	    key: "handleTextTrackChange",
	    value: function handleTextTrackChange() {
	      var _this$props = this.props,
	          actions = _this$props.actions,
	          player = _this$props.player;
	
	      if (this.video && this.video.textTracks) {
	        var activeTextTrack = Array.from(this.video.textTracks).find(function (textTrack) {
	          return textTrack.mode === 'showing';
	        });
	
	        if (activeTextTrack !== player.activeTextTrack) {
	          actions.activateTextTrack(activeTextTrack);
	        }
	      }
	    } // play the video
	
	  }, {
	    key: "play",
	    value: function play() {
	      var promise = this.video.play();
	
	      if (promise !== undefined) {
	        promise["catch"](function () {}).then(function () {});
	      }
	    } // pause the video
	
	  }, {
	    key: "pause",
	    value: function pause() {
	      var promise = this.video.pause();
	
	      if (promise !== undefined) {
	        promise["catch"](function () {}).then(function () {});
	      }
	    } // Change the video source and re-load the video:
	
	  }, {
	    key: "load",
	    value: function load() {
	      this.video.load();
	    } // Add a new text track to the video
	
	  }, {
	    key: "addTextTrack",
	    value: function addTextTrack() {
	      var _this$video;
	
	      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
	    } // Check if your browser can play different types of video:
	
	  }, {
	    key: "canPlayType",
	    value: function canPlayType() {
	      var _this$video2;
	
	      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
	    } // toggle play
	
	  }, {
	    key: "togglePlay",
	    value: function togglePlay() {
	      if (this.video.paused) {
	        this.play();
	      } else {
	        this.pause();
	      }
	    } // seek video by time
	
	  }, {
	    key: "seek",
	    value: function seek(time) {
	      try {
	        this.video.currentTime = time;
	      } catch (e) {// console.log(e, 'Video is not ready.')
	      }
	    } // jump forward x seconds
	
	  }, {
	    key: "forward",
	    value: function forward(seconds) {
	      this.seek(this.video.currentTime + seconds);
	    } // jump back x seconds
	
	  }, {
	    key: "replay",
	    value: function replay(seconds) {
	      this.forward(-seconds);
	    } // enter or exist full screen
	
	  }, {
	    key: "toggleFullscreen",
	    value: function toggleFullscreen() {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions;
	      actions.toggleFullscreen(player);
	    } // Fired when the user agent
	    // begins looking for media data
	
	  }, {
	    key: "handleLoadStart",
	    value: function handleLoadStart() {
	      var _this$props3 = this.props,
	          actions = _this$props3.actions,
	          onLoadStart = _this$props3.onLoadStart;
	      actions.handleLoadStart(this.getProperties());
	
	      if (onLoadStart) {
	        onLoadStart.apply(void 0, arguments);
	      }
	    } // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: "handleCanPlay",
	    value: function handleCanPlay() {
	      var _this$props4 = this.props,
	          actions = _this$props4.actions,
	          onCanPlay = _this$props4.onCanPlay;
	      actions.handleCanPlay(this.getProperties());
	
	      if (onCanPlay) {
	        onCanPlay.apply(void 0, arguments);
	      }
	    } // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: "handleCanPlayThrough",
	    value: function handleCanPlayThrough() {
	      var _this$props5 = this.props,
	          actions = _this$props5.actions,
	          onCanPlayThrough = _this$props5.onCanPlayThrough;
	      actions.handleCanPlayThrough(this.getProperties());
	
	      if (onCanPlayThrough) {
	        onCanPlayThrough.apply(void 0, arguments);
	      }
	    } // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: "handlePlaying",
	    value: function handlePlaying() {
	      var _this$props6 = this.props,
	          actions = _this$props6.actions,
	          onPlaying = _this$props6.onPlaying;
	      actions.handlePlaying(this.getProperties());
	
	      if (onPlaying) {
	        onPlaying.apply(void 0, arguments);
	      }
	    } // Fired whenever the media has been started
	
	  }, {
	    key: "handlePlay",
	    value: function handlePlay() {
	      var _this$props7 = this.props,
	          actions = _this$props7.actions,
	          onPlay = _this$props7.onPlay;
	      actions.handlePlay(this.getProperties());
	
	      if (onPlay) {
	        onPlay.apply(void 0, arguments);
	      }
	    } // Fired whenever the media has been paused
	
	  }, {
	    key: "handlePause",
	    value: function handlePause() {
	      var _this$props8 = this.props,
	          actions = _this$props8.actions,
	          onPause = _this$props8.onPause;
	      actions.handlePause(this.getProperties());
	
	      if (onPause) {
	        onPause.apply(void 0, arguments);
	      }
	    } // Fired when the duration of
	    // the media resource is first known or changed
	
	  }, {
	    key: "handleDurationChange",
	    value: function handleDurationChange() {
	      var _this$props9 = this.props,
	          actions = _this$props9.actions,
	          onDurationChange = _this$props9.onDurationChange;
	      actions.handleDurationChange(this.getProperties());
	
	      if (onDurationChange) {
	        onDurationChange.apply(void 0, arguments);
	      }
	    } // Fired while the user agent
	    // is downloading media data
	
	  }, {
	    key: "handleProgress",
	    value: function handleProgress() {
	      var _this$props10 = this.props,
	          actions = _this$props10.actions,
	          onProgress = _this$props10.onProgress;
	
	      if (this.video) {
	        actions.handleProgressChange(this.getProperties());
	      }
	
	      if (onProgress) {
	        onProgress.apply(void 0, arguments);
	      }
	    } // Fired when the end of the media resource
	    // is reached (currentTime == duration)
	
	  }, {
	    key: "handleEnded",
	    value: function handleEnded() {
	      var _this$props11 = this.props,
	          loop = _this$props11.loop,
	          player = _this$props11.player,
	          actions = _this$props11.actions,
	          onEnded = _this$props11.onEnded;
	
	      if (loop) {
	        this.seek(0);
	        this.play();
	      } else if (!player.paused) {
	        this.pause();
	      }
	
	      actions.handleEnd(this.getProperties());
	
	      if (onEnded) {
	        onEnded.apply(void 0, arguments);
	      }
	    } // Fired whenever the media begins waiting
	
	  }, {
	    key: "handleWaiting",
	    value: function handleWaiting() {
	      var _this$props12 = this.props,
	          actions = _this$props12.actions,
	          onWaiting = _this$props12.onWaiting;
	      actions.handleWaiting(this.getProperties());
	
	      if (onWaiting) {
	        onWaiting.apply(void 0, arguments);
	      }
	    } // Fired whenever the player
	    // is jumping to a new time
	
	  }, {
	    key: "handleSeeking",
	    value: function handleSeeking() {
	      var _this$props13 = this.props,
	          actions = _this$props13.actions,
	          onSeeking = _this$props13.onSeeking;
	      actions.handleSeeking(this.getProperties());
	
	      if (onSeeking) {
	        onSeeking.apply(void 0, arguments);
	      }
	    } // Fired when the player has
	    // finished jumping to a new time
	
	  }, {
	    key: "handleSeeked",
	    value: function handleSeeked() {
	      var _this$props14 = this.props,
	          actions = _this$props14.actions,
	          onSeeked = _this$props14.onSeeked;
	      actions.handleSeeked(this.getProperties());
	
	      if (onSeeked) {
	        onSeeked.apply(void 0, arguments);
	      }
	    } // Handle Fullscreen Change
	
	  }, {
	    key: "handleFullscreenChange",
	    value: function handleFullscreenChange() {} // Fires when the browser is
	    // intentionally not getting media data
	
	  }, {
	    key: "handleSuspend",
	    value: function handleSuspend() {
	      var _this$props15 = this.props,
	          actions = _this$props15.actions,
	          onSuspend = _this$props15.onSuspend;
	      actions.handleSuspend(this.getProperties());
	
	      if (onSuspend) {
	        onSuspend.apply(void 0, arguments);
	      }
	    } // Fires when the loading of an audio/video is aborted
	
	  }, {
	    key: "handleAbort",
	    value: function handleAbort() {
	      var _this$props16 = this.props,
	          actions = _this$props16.actions,
	          onAbort = _this$props16.onAbort;
	      actions.handleAbort(this.getProperties());
	
	      if (onAbort) {
	        onAbort.apply(void 0, arguments);
	      }
	    } // Fires when the current playlist is empty
	
	  }, {
	    key: "handleEmptied",
	    value: function handleEmptied() {
	      var _this$props17 = this.props,
	          actions = _this$props17.actions,
	          onEmptied = _this$props17.onEmptied;
	      actions.handleEmptied(this.getProperties());
	
	      if (onEmptied) {
	        onEmptied.apply(void 0, arguments);
	      }
	    } // Fires when the browser is trying to
	    // get media data, but data is not available
	
	  }, {
	    key: "handleStalled",
	    value: function handleStalled() {
	      var _this$props18 = this.props,
	          actions = _this$props18.actions,
	          onStalled = _this$props18.onStalled;
	      actions.handleStalled(this.getProperties());
	
	      if (onStalled) {
	        onStalled.apply(void 0, arguments);
	      }
	    } // Fires when the browser has loaded
	    // meta data for the audio/video
	
	  }, {
	    key: "handleLoadedMetaData",
	    value: function handleLoadedMetaData() {
	      var _this$props19 = this.props,
	          actions = _this$props19.actions,
	          onLoadedMetadata = _this$props19.onLoadedMetadata,
	          startTime = _this$props19.startTime;
	
	      if (startTime && startTime > 0) {
	        this.video.currentTime = startTime;
	      }
	
	      actions.handleLoadedMetaData(this.getProperties());
	
	      if (onLoadedMetadata) {
	        onLoadedMetadata.apply(void 0, arguments);
	      }
	    } // Fires when the browser has loaded
	    // the current frame of the audio/video
	
	  }, {
	    key: "handleLoadedData",
	    value: function handleLoadedData() {
	      var _this$props20 = this.props,
	          actions = _this$props20.actions,
	          onLoadedData = _this$props20.onLoadedData;
	      actions.handleLoadedData(this.getProperties());
	
	      if (onLoadedData) {
	        onLoadedData.apply(void 0, arguments);
	      }
	    } // Fires when the current
	    // playback position has changed
	
	  }, {
	    key: "handleTimeUpdate",
	    value: function handleTimeUpdate() {
	      var _this$props21 = this.props,
	          actions = _this$props21.actions,
	          onTimeUpdate = _this$props21.onTimeUpdate;
	      actions.handleTimeUpdate(this.getProperties());
	
	      if (onTimeUpdate) {
	        onTimeUpdate.apply(void 0, arguments);
	      }
	    }
	    /**
	     * Fires when the playing speed of the audio/video is changed
	     */
	
	  }, {
	    key: "handleRateChange",
	    value: function handleRateChange() {
	      var _this$props22 = this.props,
	          actions = _this$props22.actions,
	          onRateChange = _this$props22.onRateChange;
	      actions.handleRateChange(this.getProperties());
	
	      if (onRateChange) {
	        onRateChange.apply(void 0, arguments);
	      }
	    } // Fires when the volume has been changed
	
	  }, {
	    key: "handleVolumeChange",
	    value: function handleVolumeChange() {
	      var _this$props23 = this.props,
	          actions = _this$props23.actions,
	          onVolumeChange = _this$props23.onVolumeChange;
	      actions.handleVolumeChange(this.getProperties());
	
	      if (onVolumeChange) {
	        onVolumeChange.apply(void 0, arguments);
	      }
	    } // Fires when an error occurred
	    // during the loading of an audio/video
	
	  }, {
	    key: "handleError",
	    value: function handleError() {
	      var _this$props24 = this.props,
	          actions = _this$props24.actions,
	          onError = _this$props24.onError;
	      actions.handleError(this.getProperties());
	
	      if (onError) {
	        onError.apply(void 0, arguments);
	      }
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize() {
	      var _this$props25 = this.props,
	          actions = _this$props25.actions,
	          onResize = _this$props25.onResize;
	      actions.handleResize(this.getProperties());
	
	      if (onResize) {
	        onResize.apply(void 0, arguments);
	      }
	    }
	  }, {
	    key: "handleKeypress",
	    value: function handleKeypress() {}
	  }, {
	    key: "renderChildren",
	    value: function renderChildren() {
	      var _this3 = this;
	
	      var props = (0, _objectSpread2["default"])({}, this.props, {
	        video: this.video
	      }); // to make sure the children can get video property
	
	      if (!this.video) {
	        return null;
	      } // only keep <source />, <track />, <MyComponent isVideoChild /> elements
	
	
	      return _react["default"].Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
	        var cprops;
	
	        if (typeof c.type === 'string') {
	          // add onError to <source />
	          if (c.type === 'source') {
	            cprops = (0, _objectSpread2["default"])({}, c.props);
	            var preOnError = cprops.onError;
	
	            cprops.onError = function () {
	              if (preOnError) {
	                preOnError.apply(void 0, arguments);
	              }
	
	              _this3.handleError.apply(_this3, arguments);
	            };
	          }
	        } else {
	          cprops = props;
	        }
	
	        return _react["default"].cloneElement(c, cprops);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _this$props26 = this.props,
	          loop = _this$props26.loop,
	          poster = _this$props26.poster,
	          preload = _this$props26.preload,
	          src = _this$props26.src,
	          autoPlay = _this$props26.autoPlay,
	          playsInline = _this$props26.playsInline,
	          muted = _this$props26.muted,
	          crossOrigin = _this$props26.crossOrigin,
	          videoId = _this$props26.videoId;
	      return _react["default"].createElement("video", {
	        className: (0, _classnames["default"])('video-react-video', this.props.className),
	        id: videoId,
	        crossOrigin: crossOrigin,
	        ref: function ref(c) {
	          _this4.video = c;
	        },
	        muted: muted,
	        preload: preload,
	        loop: loop,
	        playsInline: playsInline,
	        autoPlay: autoPlay,
	        poster: poster,
	        src: src,
	        onLoadStart: this.handleLoadStart,
	        onWaiting: this.handleWaiting,
	        onCanPlay: this.handleCanPlay,
	        onCanPlayThrough: this.handleCanPlayThrough,
	        onPlaying: this.handlePlaying,
	        onEnded: this.handleEnded,
	        onSeeking: this.handleSeeking,
	        onSeeked: this.handleSeeked,
	        onPlay: this.handlePlay,
	        onPause: this.handlePause,
	        onProgress: this.handleProgress,
	        onDurationChange: this.handleDurationChange,
	        onError: this.handleError,
	        onSuspend: this.handleSuspend,
	        onAbort: this.handleAbort,
	        onEmptied: this.handleEmptied,
	        onStalled: this.handleStalled,
	        onLoadedMetadata: this.handleLoadedMetaData,
	        onLoadedData: this.handleLoadedData,
	        onTimeUpdate: this.handleTimeUpdate,
	        onRateChange: this.handleRateChange,
	        onVolumeChange: this.handleVolumeChange,
	        tabIndex: "-1"
	      }, this.renderChildren());
	    }
	  }, {
	    key: "playbackRate",
	    get: function get() {
	      return this.video.playbackRate;
	    } // set playback rate
	    // speed of video
	    ,
	    set: function set(rate) {
	      this.video.playbackRate = rate;
	    }
	  }, {
	    key: "muted",
	    get: function get() {
	      return this.video.muted;
	    },
	    set: function set(val) {
	      this.video.muted = val;
	    }
	  }, {
	    key: "volume",
	    get: function get() {
	      return this.video.volume;
	    },
	    set: function set(val) {
	      if (val > 1) {
	        val = 1;
	      }
	
	      if (val < 0) {
	        val = 0;
	      }
	
	      this.video.volume = val;
	    } // video width
	
	  }, {
	    key: "videoWidth",
	    get: function get() {
	      return this.video.videoWidth;
	    } // video height
	
	  }, {
	    key: "videoHeight",
	    get: function get() {
	      return this.video.videoHeight;
	    }
	  }]);
	  return Video;
	}(_react.Component);
	
	exports["default"] = Video;
	Video.propTypes = propTypes;
	Video.displayName = 'Video';

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(130));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ProgressControl = _interopRequireDefault(__webpack_require__(292));
	
	var _PlayToggle = _interopRequireDefault(__webpack_require__(291));
	
	var _ForwardControl = _interopRequireDefault(__webpack_require__(285));
	
	var _ReplayControl = _interopRequireDefault(__webpack_require__(293));
	
	var _FullscreenToggle = _interopRequireDefault(__webpack_require__(287));
	
	var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(298));
	
	var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(296));
	
	var _DurationDisplay = _interopRequireDefault(__webpack_require__(297));
	
	var _TimeDivider = _interopRequireDefault(__webpack_require__(299));
	
	var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(295));
	
	var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(183));
	
	var _utils = __webpack_require__(51);
	
	var propTypes = {
	  children: _propTypes["default"].any,
	  autoHide: _propTypes["default"].bool,
	  autoHideTime: _propTypes["default"].number,
	  // used in Player
	  disableDefaultControls: _propTypes["default"].bool,
	  disableCompletely: _propTypes["default"].bool,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  autoHide: true,
	  disableCompletely: false
	};
	
	var ControlBar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ControlBar, _Component);
	
	  function ControlBar(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ControlBar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ControlBar).call(this, props));
	    _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getFullChildren = _this.getFullChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ControlBar, [{
	    key: "getDefaultChildren",
	    value: function getDefaultChildren() {
	      return [_react["default"].createElement(_PlayToggle["default"], {
	        key: "play-toggle",
	        order: 1
	      }), _react["default"].createElement(_VolumeMenuButton["default"], {
	        key: "volume-menu-button",
	        order: 4
	      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
	        key: "current-time-display",
	        order: 5.1
	      }), _react["default"].createElement(_TimeDivider["default"], {
	        key: "time-divider",
	        order: 5.2
	      }), _react["default"].createElement(_DurationDisplay["default"], {
	        key: "duration-display",
	        order: 5.3
	      }), _react["default"].createElement(_ProgressControl["default"], {
	        key: "progress-control",
	        order: 6
	      }), _react["default"].createElement(_FullscreenToggle["default"], {
	        key: "fullscreen-toggle",
	        order: 8
	      })];
	    }
	  }, {
	    key: "getFullChildren",
	    value: function getFullChildren() {
	      return [_react["default"].createElement(_PlayToggle["default"], {
	        key: "play-toggle",
	        order: 1
	      }), _react["default"].createElement(_ReplayControl["default"], {
	        key: "replay-control",
	        order: 2
	      }), _react["default"].createElement(_ForwardControl["default"], {
	        key: "forward-control",
	        order: 3
	      }), _react["default"].createElement(_VolumeMenuButton["default"], {
	        key: "volume-menu-button",
	        order: 4
	      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
	        key: "current-time-display",
	        order: 5
	      }), _react["default"].createElement(_TimeDivider["default"], {
	        key: "time-divider",
	        order: 6
	      }), _react["default"].createElement(_DurationDisplay["default"], {
	        key: "duration-display",
	        order: 7
	      }), _react["default"].createElement(_ProgressControl["default"], {
	        key: "progress-control",
	        order: 8
	      }), _react["default"].createElement(_RemainingTimeDisplay["default"], {
	        key: "remaining-time-display",
	        order: 9
	      }), _react["default"].createElement(_PlaybackRateMenuButton["default"], {
	        rates: [1, 1.25, 1.5, 2],
	        key: "playback-rate",
	        order: 10
	      }), _react["default"].createElement(_FullscreenToggle["default"], {
	        key: "fullscreen-toggle",
	        order: 11
	      })];
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren() {
	      var children = _react["default"].Children.toArray(this.props.children);
	
	      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
	      var _this$props = this.props,
	          className = _this$props.className,
	          parentProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className"]); // remove className
	
	      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          autoHide = _this$props2.autoHide,
	          className = _this$props2.className,
	          disableCompletely = _this$props2.disableCompletely;
	      var children = this.getChildren();
	      return disableCompletely ? null : _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('video-react-control-bar', {
	          'video-react-control-bar-auto-hide': autoHide
	        }, className)
	      }, children);
	    }
	  }]);
	  return ControlBar;
	}(_react.Component);
	
	exports["default"] = ControlBar;
	ControlBar.propTypes = propTypes;
	ControlBar.defaultProps = defaultProps;
	ControlBar.displayName = 'ControlBar';

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(286));
	
	// Pass mode into parent function
	var ForwardControl = (0, _ForwardReplayControl["default"])('forward');
	ForwardControl.displayName = 'ForwardControl';
	var _default = ForwardControl;
	exports["default"] = _default;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  seconds: _propTypes["default"].oneOf([5, 10, 30])
	};
	var defaultProps = {
	  seconds: 10
	};
	
	var _default = function _default(mode) {
	  var ForwardReplayControl =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inherits2["default"])(ForwardReplayControl, _Component);
	
	    function ForwardReplayControl(props, context) {
	      var _this;
	
	      (0, _classCallCheck2["default"])(this, ForwardReplayControl);
	      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ForwardReplayControl).call(this, props, context));
	      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	      return _this;
	    }
	
	    (0, _createClass2["default"])(ForwardReplayControl, [{
	      key: "handleClick",
	      value: function handleClick() {
	        var _this$props = this.props,
	            actions = _this$props.actions,
	            seconds = _this$props.seconds; // Depends mode to implement different actions
	
	        if (mode === 'forward') {
	          actions.forward(seconds);
	        } else {
	          actions.replay(seconds);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            seconds = _this$props2.seconds,
	            className = _this$props2.className;
	        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
	        classNames.push("video-react-icon-".concat(mode, "-").concat(seconds), "video-react-".concat(mode, "-control"));
	
	        if (className) {
	          classNames.push(className);
	        }
	
	        return _react["default"].createElement("button", {
	          ref: function ref(c) {
	            _this2.button = c;
	          },
	          className: classNames.join(' '),
	          type: "button",
	          onClick: this.handleClick
	        }, _react["default"].createElement("span", {
	          className: "video-react-control-text"
	        }, "".concat(mode, " ").concat(seconds, " seconds")));
	      }
	    }]);
	    return ForwardReplayControl;
	  }(_react.Component);
	
	  ForwardReplayControl.propTypes = propTypes;
	  ForwardReplayControl.defaultProps = defaultProps;
	  return ForwardReplayControl;
	};
	
	exports["default"] = _default;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var FullscreenToggle =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(FullscreenToggle, _Component);
	
	  function FullscreenToggle(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, FullscreenToggle);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FullscreenToggle).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(FullscreenToggle, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	      actions.toggleFullscreen(player);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          className = _this$props2.className;
	      return _react["default"].createElement("button", {
	        className: (0, _classnames["default"])(className, {
	          'video-react-icon-fullscreen-exit': player.isFullscreen,
	          'video-react-icon-fullscreen': !player.isFullscreen
	        }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
	        ref: function ref(c) {
	          _this2.button = c;
	        },
	        type: "button",
	        tabIndex: "0",
	        onClick: this.handleClick
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Non-Fullscreen"));
	    }
	  }]);
	  return FullscreenToggle;
	}(_react.Component);
	
	exports["default"] = FullscreenToggle;
	FullscreenToggle.propTypes = propTypes;
	FullscreenToggle.displayName = 'FullscreenToggle';

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = LoadProgressBar;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  duration: _propTypes["default"].number,
	  buffered: _propTypes["default"].object,
	  className: _propTypes["default"].string
	}; // Shows load progress
	
	function LoadProgressBar(_ref) {
	  var buffered = _ref.buffered,
	      duration = _ref.duration,
	      className = _ref.className;
	
	  if (!buffered || !buffered.length) {
	    return null;
	  }
	
	  var bufferedEnd = buffered.end(buffered.length - 1);
	  var style = {};
	
	  if (bufferedEnd > duration) {
	    bufferedEnd = duration;
	  } // get the percent width of a time compared to the total end
	
	
	  function percentify(time, end) {
	    var percent = time / end || 0; // no NaN
	
	    return "".concat((percent >= 1 ? 1 : percent) * 100, "%");
	  } // the width of the progress bar
	
	
	  style.width = percentify(bufferedEnd, duration);
	  var parts = []; // add child elements to represent the individual buffered time ranges
	
	  for (var i = 0; i < buffered.length; i++) {
	    var start = buffered.start(i);
	    var end = buffered.end(i); // set the percent based on the width of the progress bar (bufferedEnd)
	
	    var part = _react["default"].createElement("div", {
	      style: {
	        left: percentify(start, bufferedEnd),
	        width: percentify(end - start, bufferedEnd)
	      },
	      key: "part-".concat(i)
	    });
	
	    parts.push(part);
	  }
	
	  if (parts.length === 0) {
	    parts = null;
	  }
	
	  return _react["default"].createElement("div", {
	    style: style,
	    className: (0, _classnames["default"])('video-react-load-progress', className)
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Loaded: 0%"), parts);
	}
	
	LoadProgressBar.propTypes = propTypes;
	LoadProgressBar.displayName = 'LoadProgressBar';

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(51);
	
	function MouseTimeDisplay(_ref) {
	  var duration = _ref.duration,
	      mouseTime = _ref.mouseTime,
	      className = _ref.className,
	      text = _ref.text;
	
	  if (!mouseTime.time) {
	    return null;
	  }
	
	  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-mouse-display', className),
	    style: {
	      left: "".concat(mouseTime.position, "px")
	    },
	    "data-current-time": time
	  });
	}
	
	MouseTimeDisplay.propTypes = {
	  duration: _propTypes["default"].number,
	  mouseTime: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	MouseTimeDisplay.displayName = 'MouseTimeDisplay';
	var _default = MouseTimeDisplay;
	exports["default"] = _default;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = PlayProgressBar;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(51);
	
	var propTypes = {
	  currentTime: _propTypes["default"].number,
	  duration: _propTypes["default"].number,
	  percentage: _propTypes["default"].string,
	  className: _propTypes["default"].string
	}; // Shows play progress
	
	function PlayProgressBar(_ref) {
	  var currentTime = _ref.currentTime,
	      duration = _ref.duration,
	      percentage = _ref.percentage,
	      className = _ref.className;
	  return _react["default"].createElement("div", {
	    "data-current-time": (0, _utils.formatTime)(currentTime, duration),
	    className: (0, _classnames["default"])('video-react-play-progress video-react-slider-bar', className),
	    style: {
	      width: percentage
	    }
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Progress: ".concat(percentage)));
	}
	
	PlayProgressBar.propTypes = propTypes;
	PlayProgressBar.displayName = 'PlayProgressBar';

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var PlayToggle =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PlayToggle, _Component);
	
	  function PlayToggle(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PlayToggle);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlayToggle).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PlayToggle, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          actions = _this$props.actions,
	          player = _this$props.player;
	
	      if (player.paused) {
	        actions.play();
	      } else {
	        actions.pause();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          className = _this$props2.className;
	      var controlText = player.paused ? 'Play' : 'Pause';
	      return _react["default"].createElement("button", {
	        ref: function ref(c) {
	          _this2.button = c;
	        },
	        className: (0, _classnames["default"])(className, {
	          'video-react-play-control': true,
	          'video-react-control': true,
	          'video-react-button': true,
	          'video-react-paused': player.paused,
	          'video-react-playing': !player.paused
	        }),
	        type: "button",
	        tabIndex: "0",
	        onClick: this.handleClick
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, controlText));
	    }
	  }]);
	  return PlayToggle;
	}(_react.Component);
	
	exports["default"] = PlayToggle;
	PlayToggle.propTypes = propTypes;
	PlayToggle.displayName = 'PlayToggle';

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var Dom = _interopRequireWildcard(__webpack_require__(129));
	
	var _SeekBar = _interopRequireDefault(__webpack_require__(294));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var ProgressControl =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ProgressControl, _Component);
	
	  function ProgressControl(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ProgressControl);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProgressControl).call(this, props, context));
	    _this.state = {
	      mouseTime: {
	        time: null,
	        position: 0
	      }
	    };
	    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ProgressControl, [{
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      if (!event.pageX) {
	        return;
	      }
	
	      var duration = this.props.player.duration;
	      var node = this.seekBar;
	      var newTime = Dom.getPointerPosition(node, event).x * duration;
	      var position = event.pageX - Dom.findElPosition(node).left;
	      this.setState({
	        mouseTime: {
	          time: newTime,
	          position: position
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var className = this.props.className;
	      return _react["default"].createElement("div", {
	        onMouseMove: this.handleMouseMoveThrottle,
	        className: (0, _classnames["default"])('video-react-progress-control video-react-control', className)
	      }, _react["default"].createElement(_SeekBar["default"], (0, _extends2["default"])({
	        mouseTime: this.state.mouseTime,
	        ref: function ref(c) {
	          _this2.seekBar = c;
	        }
	      }, this.props)));
	    }
	  }]);
	  return ProgressControl;
	}(_react.Component);
	
	exports["default"] = ProgressControl;
	ProgressControl.propTypes = propTypes;
	ProgressControl.displayName = 'ProgressControl';

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(286));
	
	// Pass mode into parent function
	var ReplayControl = (0, _ForwardReplayControl["default"])('replay');
	ReplayControl.displayName = 'ReplayControl';
	var _default = ReplayControl;
	exports["default"] = _default;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Slider = _interopRequireDefault(__webpack_require__(182));
	
	var _PlayProgressBar = _interopRequireDefault(__webpack_require__(290));
	
	var _LoadProgressBar = _interopRequireDefault(__webpack_require__(288));
	
	var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(289));
	
	var _utils = __webpack_require__(51);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  mouseTime: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	var SeekBar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(SeekBar, _Component);
	
	  function SeekBar(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, SeekBar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SeekBar).call(this, props, context));
	    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getNewTime = _this.getNewTime.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(SeekBar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {}
	    /**
	     * Get percentage of video played
	     *
	     * @return {Number} Percentage played
	     * @method getPercent
	     */
	
	  }, {
	    key: "getPercent",
	    value: function getPercent() {
	      var _this$props$player = this.props.player,
	          currentTime = _this$props$player.currentTime,
	          seekingTime = _this$props$player.seekingTime,
	          duration = _this$props$player.duration;
	      var time = seekingTime || currentTime;
	      var percent = time / duration;
	      return percent >= 1 ? 1 : percent;
	    }
	  }, {
	    key: "getNewTime",
	    value: function getNewTime(event) {
	      var duration = this.props.player.duration;
	      var distance = this.slider.calculateDistance(event);
	      var newTime = distance * duration; // Don't let video end while scrubbing.
	
	      return newTime === duration ? newTime - 0.1 : newTime;
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown() {}
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(event) {
	      var actions = this.props.actions;
	      var newTime = this.getNewTime(event); // Set new time (tell video to seek to new time)
	
	      actions.seek(newTime);
	      actions.handleEndSeeking(newTime);
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      var actions = this.props.actions;
	      var newTime = this.getNewTime(event);
	      actions.handleSeekingTime(newTime);
	    }
	  }, {
	    key: "stepForward",
	    value: function stepForward() {
	      var actions = this.props.actions;
	      actions.forward(5);
	    }
	  }, {
	    key: "stepBack",
	    value: function stepBack() {
	      var actions = this.props.actions;
	      actions.replay(5);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          _this$props$player2 = _this$props.player,
	          currentTime = _this$props$player2.currentTime,
	          seekingTime = _this$props$player2.seekingTime,
	          duration = _this$props$player2.duration,
	          buffered = _this$props$player2.buffered,
	          mouseTime = _this$props.mouseTime;
	      var time = seekingTime || currentTime;
	      return _react["default"].createElement(_Slider["default"], {
	        ref: function ref(input) {
	          _this2.slider = input;
	        },
	        label: "video progress bar",
	        className: (0, _classnames["default"])('video-react-progress-holder', this.props.className),
	        valuenow: (this.getPercent() * 100).toFixed(2),
	        valuetext: (0, _utils.formatTime)(time, duration),
	        onMouseDown: this.handleMouseDown,
	        onMouseMove: this.handleMouseMove,
	        onMouseUp: this.handleMouseUp,
	        getPercent: this.getPercent,
	        stepForward: this.stepForward,
	        stepBack: this.stepBack
	      }, _react["default"].createElement(_LoadProgressBar["default"], {
	        buffered: buffered,
	        currentTime: time,
	        duration: duration
	      }), _react["default"].createElement(_MouseTimeDisplay["default"], {
	        duration: duration,
	        mouseTime: mouseTime
	      }), _react["default"].createElement(_PlayProgressBar["default"], {
	        currentTime: time,
	        duration: duration
	      }));
	    }
	  }]);
	  return SeekBar;
	}(_react.Component);
	
	exports["default"] = SeekBar;
	SeekBar.propTypes = propTypes;
	SeekBar.displayName = 'SeekBar';

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _PopupButton = _interopRequireDefault(__webpack_require__(716));
	
	var _VolumeBar = _interopRequireDefault(__webpack_require__(717));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  vertical: _propTypes["default"].bool,
	  className: _propTypes["default"].string,
	  alwaysShowVolume: _propTypes["default"].bool
	};
	var defaultProps = {
	  vertical: false
	};
	
	var VolumeMenuButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(VolumeMenuButton, _Component);
	
	  function VolumeMenuButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, VolumeMenuButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeMenuButton).call(this, props, context));
	    _this.state = {
	      active: false
	    };
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(VolumeMenuButton, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	      actions.mute(!player.muted);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      this.setState({
	        active: true
	      });
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.setState({
	        active: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          vertical = _this$props2.vertical,
	          player = _this$props2.player,
	          className = _this$props2.className;
	      var inline = !vertical;
	      var level = this.volumeLevel;
	      return _react["default"].createElement(_PopupButton["default"], {
	        className: (0, _classnames["default"])(className, {
	          'video-react-volume-menu-button-vertical': vertical,
	          'video-react-volume-menu-button-horizontal': !vertical,
	          'video-react-vol-muted': player.muted,
	          'video-react-vol-0': level === 0 && !player.muted,
	          'video-react-vol-1': level === 1,
	          'video-react-vol-2': level === 2,
	          'video-react-vol-3': level === 3,
	          'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
	          'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
	        }, 'video-react-volume-menu-button'),
	        onClick: this.handleClick,
	        inline: inline
	      }, _react["default"].createElement(_VolumeBar["default"], (0, _extends2["default"])({
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, this.props)));
	    }
	  }, {
	    key: "volumeLevel",
	    get: function get() {
	      var _this$props$player = this.props.player,
	          volume = _this$props$player.volume,
	          muted = _this$props$player.muted;
	      var level = 3;
	
	      if (volume === 0 || muted) {
	        level = 0;
	      } else if (volume < 0.33) {
	        level = 1;
	      } else if (volume < 0.67) {
	        level = 2;
	      }
	
	      return level;
	    }
	  }]);
	  return VolumeMenuButton;
	}(_react.Component);
	
	VolumeMenuButton.propTypes = propTypes;
	VolumeMenuButton.defaultProps = defaultProps;
	VolumeMenuButton.displayName = 'VolumeMenuButton';
	var _default = VolumeMenuButton;
	exports["default"] = _default;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(51);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function CurrentTimeDisplay(_ref) {
	  var _ref$player = _ref.player,
	      currentTime = _ref$player.currentTime,
	      duration = _ref$player.duration,
	      className = _ref.className;
	  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-current-time video-react-time-control video-react-control', className)
	  }, _react["default"].createElement("div", {
	    className: "video-react-current-time-display",
	    "aria-live": "off"
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Current Time "), formattedTime));
	}
	
	CurrentTimeDisplay.propTypes = propTypes;
	CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
	var _default = CurrentTimeDisplay;
	exports["default"] = _default;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(51);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function DurationDisplay(_ref) {
	  var duration = _ref.player.duration,
	      className = _ref.className;
	  var formattedTime = (0, _utils.formatTime)(duration);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])(className, 'video-react-duration video-react-time-control video-react-control')
	  }, _react["default"].createElement("div", {
	    className: "video-react-duration-display",
	    "aria-live": "off"
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Duration Time "), formattedTime));
	}
	
	DurationDisplay.propTypes = propTypes;
	DurationDisplay.displayName = 'DurationDisplay';
	var _default = DurationDisplay;
	exports["default"] = _default;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(51);
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string
	};
	
	function RemainingTimeDisplay(_ref) {
	  var _ref$player = _ref.player,
	      currentTime = _ref$player.currentTime,
	      duration = _ref$player.duration,
	      className = _ref.className;
	  var remainingTime = duration - currentTime;
	  var formattedTime = (0, _utils.formatTime)(remainingTime);
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-remaining-time video-react-time-control video-react-control', className)
	  }, _react["default"].createElement("div", {
	    className: "video-react-remaining-time-display",
	    "aria-live": "off"
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }, "Remaining Time "), "-".concat(formattedTime)));
	}
	
	RemainingTimeDisplay.propTypes = propTypes;
	RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
	var _default = RemainingTimeDisplay;
	exports["default"] = _default;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = TimeDivider;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  separator: _propTypes["default"].string,
	  className: _propTypes["default"].string
	};
	
	function TimeDivider(_ref) {
	  var separator = _ref.separator,
	      className = _ref.className;
	  var separatorText = separator || '/';
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])('video-react-time-control video-react-time-divider', className),
	    dir: "ltr"
	  }, _react["default"].createElement("div", null, _react["default"].createElement("span", null, separatorText)));
	}
	
	TimeDivider.propTypes = propTypes;
	TimeDivider.displayName = 'TimeDivider';

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	exports.operationReducer = exports.playerReducer = void 0;
	
	var _player = _interopRequireDefault(__webpack_require__(721));
	
	var _operation = _interopRequireDefault(__webpack_require__(720));
	
	function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	  return {
	    player: (0, _player["default"])(state.player, action),
	    operation: (0, _operation["default"])(state.operation, action)
	  };
	}
	
	var playerReducer = _player["default"];
	exports.playerReducer = playerReducer;
	var operationReducer = _operation["default"];
	exports.operationReducer = operationReducer;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var Fullscreen =
	/*#__PURE__*/
	function () {
	  function Fullscreen() {
	    (0, _classCallCheck2["default"])(this, Fullscreen);
	  }
	
	  (0, _createClass2["default"])(Fullscreen, [{
	    key: "request",
	    value: function request(elm) {
	      if (elm.requestFullscreen) {
	        elm.requestFullscreen();
	      } else if (elm.webkitRequestFullscreen) {
	        elm.webkitRequestFullscreen();
	      } else if (elm.mozRequestFullScreen) {
	        elm.mozRequestFullScreen();
	      } else if (elm.msRequestFullscreen) {
	        elm.msRequestFullscreen();
	      }
	    }
	  }, {
	    key: "exit",
	    value: function exit() {
	      if (document.exitFullscreen) {
	        document.exitFullscreen();
	      } else if (document.webkitExitFullscreen) {
	        document.webkitExitFullscreen();
	      } else if (document.mozCancelFullScreen) {
	        document.mozCancelFullScreen();
	      } else if (document.msExitFullscreen) {
	        document.msExitFullscreen();
	      }
	    }
	  }, {
	    key: "addEventListener",
	    value: function addEventListener(handler) {
	      document.addEventListener('fullscreenchange', handler);
	      document.addEventListener('webkitfullscreenchange', handler);
	      document.addEventListener('mozfullscreenchange', handler);
	      document.addEventListener('MSFullscreenChange', handler);
	    }
	  }, {
	    key: "removeEventListener",
	    value: function removeEventListener(handler) {
	      document.removeEventListener('fullscreenchange', handler);
	      document.removeEventListener('webkitfullscreenchange', handler);
	      document.removeEventListener('mozfullscreenchange', handler);
	      document.removeEventListener('MSFullscreenChange', handler);
	    }
	  }, {
	    key: "isFullscreen",
	    get: function get() {
	      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
	    }
	  }, {
	    key: "enabled",
	    get: function get() {
	      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
	    }
	  }]);
	  return Fullscreen;
	}();
	
	var _default = new Fullscreen();
	
	exports["default"] = _default;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * @license
	 * Video.js 7.21.5 <http://videojs.com/>
	 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
	 * Available under Apache License Version 2.0
	 * <https://github.com/videojs/video.js/blob/main/LICENSE>
	 *
	 * Includes vtt.js <https://github.com/mozilla/vtt.js>
	 * Available under Apache License Version 2.0
	 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
	 */
	
	'use strict';
	
	var window$1 = __webpack_require__(54);
	var document = __webpack_require__(233);
	var _extends = __webpack_require__(57);
	var keycode = __webpack_require__(565);
	var _assertThisInitialized = __webpack_require__(15);
	var _inheritsLoose = __webpack_require__(187);
	var safeParseTuple = __webpack_require__(704);
	var XHR = __webpack_require__(323);
	var vtt = __webpack_require__(725);
	var _construct = __webpack_require__(186);
	var _inherits = __webpack_require__(19);
	var _resolveUrl = __webpack_require__(193);
	var m3u8Parser = __webpack_require__(567);
	var codecs_js = __webpack_require__(313);
	var mediaTypes_js = __webpack_require__(317);
	var byteHelpers = __webpack_require__(63);
	var mpdParser = __webpack_require__(568);
	var parseSidx = __webpack_require__(569);
	var id3Helpers = __webpack_require__(192);
	var containers = __webpack_require__(314);
	var clock = __webpack_require__(570);
	var _wrapNativeSuper = __webpack_require__(312);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var window__default = /*#__PURE__*/_interopDefaultLegacy(window$1);
	var document__default = /*#__PURE__*/_interopDefaultLegacy(document);
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var keycode__default = /*#__PURE__*/_interopDefaultLegacy(keycode);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var safeParseTuple__default = /*#__PURE__*/_interopDefaultLegacy(safeParseTuple);
	var XHR__default = /*#__PURE__*/_interopDefaultLegacy(XHR);
	var vtt__default = /*#__PURE__*/_interopDefaultLegacy(vtt);
	var _construct__default = /*#__PURE__*/_interopDefaultLegacy(_construct);
	var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
	var _resolveUrl__default = /*#__PURE__*/_interopDefaultLegacy(_resolveUrl);
	var parseSidx__default = /*#__PURE__*/_interopDefaultLegacy(parseSidx);
	var _wrapNativeSuper__default = /*#__PURE__*/_interopDefaultLegacy(_wrapNativeSuper);
	
	var version$5 = "7.21.5";
	
	/**
	 * An Object that contains lifecycle hooks as keys which point to an array
	 * of functions that are run when a lifecycle is triggered
	 *
	 * @private
	 */
	var hooks_ = {};
	/**
	 * Get a list of hooks for a specific lifecycle
	 *
	 * @param  {string} type
	 *         the lifecyle to get hooks from
	 *
	 * @param  {Function|Function[]} [fn]
	 *         Optionally add a hook (or hooks) to the lifecycle that your are getting.
	 *
	 * @return {Array}
	 *         an array of hooks, or an empty array if there are none.
	 */
	
	var hooks = function hooks(type, fn) {
	  hooks_[type] = hooks_[type] || [];
	
	  if (fn) {
	    hooks_[type] = hooks_[type].concat(fn);
	  }
	
	  return hooks_[type];
	};
	/**
	 * Add a function hook to a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle to hook the function to.
	 *
	 * @param {Function|Function[]}
	 *        The function or array of functions to attach.
	 */
	
	
	var hook = function hook(type, fn) {
	  hooks(type, fn);
	};
	/**
	 * Remove a hook from a specific videojs lifecycle.
	 *
	 * @param  {string} type
	 *         the lifecycle that the function hooked to
	 *
	 * @param  {Function} fn
	 *         The hooked function to remove
	 *
	 * @return {boolean}
	 *         The function that was removed or undef
	 */
	
	
	var removeHook = function removeHook(type, fn) {
	  var index = hooks(type).indexOf(fn);
	
	  if (index <= -1) {
	    return false;
	  }
	
	  hooks_[type] = hooks_[type].slice();
	  hooks_[type].splice(index, 1);
	  return true;
	};
	/**
	 * Add a function hook that will only run once to a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle to hook the function to.
	 *
	 * @param {Function|Function[]}
	 *        The function or array of functions to attach.
	 */
	
	
	var hookOnce = function hookOnce(type, fn) {
	  hooks(type, [].concat(fn).map(function (original) {
	    var wrapper = function wrapper() {
	      removeHook(type, wrapper);
	      return original.apply(void 0, arguments);
	    };
	
	    return wrapper;
	  }));
	};
	
	/**
	 * @file fullscreen-api.js
	 * @module fullscreen-api
	 * @private
	 */
	/**
	 * Store the browser-specific methods for the fullscreen API.
	 *
	 * @type {Object}
	 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
	 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
	 */
	
	var FullscreenApi = {
	  prefixed: true
	}; // browser API methods
	
	var apiMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror', 'fullscreen'], // WebKit
	['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror', '-webkit-full-screen'], // Mozilla
	['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror', '-moz-full-screen'], // Microsoft
	['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError', '-ms-fullscreen']];
	var specApi = apiMap[0];
	var browserApi; // determine the supported set of functions
	
	for (var i = 0; i < apiMap.length; i++) {
	  // check for exitFullscreen function
	  if (apiMap[i][1] in document__default['default']) {
	    browserApi = apiMap[i];
	    break;
	  }
	} // map the browser API names to the spec API names
	
	
	if (browserApi) {
	  for (var _i = 0; _i < browserApi.length; _i++) {
	    FullscreenApi[specApi[_i]] = browserApi[_i];
	  }
	
	  FullscreenApi.prefixed = browserApi[0] !== specApi[0];
	}
	
	/**
	 * @file create-logger.js
	 * @module create-logger
	 */
	
	var history = [];
	/**
	 * Log messages to the console and history based on the type of message
	 *
	 * @private
	 * @param  {string} type
	 *         The name of the console method to use.
	 *
	 * @param  {Array} args
	 *         The arguments to be passed to the matching console method.
	 */
	
	var LogByTypeFactory = function LogByTypeFactory(name, log) {
	  return function (type, level, args) {
	    var lvl = log.levels[level];
	    var lvlRegExp = new RegExp("^(" + lvl + ")$");
	
	    if (type !== 'log') {
	      // Add the type to the front of the message when it's not "log".
	      args.unshift(type.toUpperCase() + ':');
	    } // Add console prefix after adding to history.
	
	
	    args.unshift(name + ':'); // Add a clone of the args at this point to history.
	
	    if (history) {
	      history.push([].concat(args)); // only store 1000 history entries
	
	      var splice = history.length - 1000;
	      history.splice(0, splice > 0 ? splice : 0);
	    } // If there's no console then don't try to output messages, but they will
	    // still be stored in history.
	
	
	    if (!window__default['default'].console) {
	      return;
	    } // Was setting these once outside of this function, but containing them
	    // in the function makes it easier to test cases where console doesn't exist
	    // when the module is executed.
	
	
	    var fn = window__default['default'].console[type];
	
	    if (!fn && type === 'debug') {
	      // Certain browsers don't have support for console.debug. For those, we
	      // should default to the closest comparable log.
	      fn = window__default['default'].console.info || window__default['default'].console.log;
	    } // Bail out if there's no console or if this type is not allowed by the
	    // current logging level.
	
	
	    if (!fn || !lvl || !lvlRegExp.test(type)) {
	      return;
	    }
	
	    fn[Array.isArray(args) ? 'apply' : 'call'](window__default['default'].console, args);
	  };
	};
	
	function createLogger$1(name) {
	  // This is the private tracking variable for logging level.
	  var level = 'info'; // the curried logByType bound to the specific log and history
	
	  var logByType;
	  /**
	   * Logs plain debug messages. Similar to `console.log`.
	   *
	   * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
	   * of our JSDoc template, we cannot properly document this as both a function
	   * and a namespace, so its function signature is documented here.
	   *
	   * #### Arguments
	   * ##### *args
	   * Mixed[]
	   *
	   * Any combination of values that could be passed to `console.log()`.
	   *
	   * #### Return Value
	   *
	   * `undefined`
	   *
	   * @namespace
	   * @param    {Mixed[]} args
	   *           One or more messages or objects that should be logged.
	   */
	
	  var log = function log() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    logByType('log', level, args);
	  }; // This is the logByType helper that the logging methods below use
	
	
	  logByType = LogByTypeFactory(name, log);
	  /**
	   * Create a new sublogger which chains the old name to the new name.
	   *
	   * For example, doing `videojs.log.createLogger('player')` and then using that logger will log the following:
	   * ```js
	   *  mylogger('foo');
	   *  // > VIDEOJS: player: foo
	   * ```
	   *
	   * @param {string} name
	   *        The name to add call the new logger
	   * @return {Object}
	   */
	
	  log.createLogger = function (subname) {
	    return createLogger$1(name + ': ' + subname);
	  };
	  /**
	   * Enumeration of available logging levels, where the keys are the level names
	   * and the values are `|`-separated strings containing logging methods allowed
	   * in that logging level. These strings are used to create a regular expression
	   * matching the function name being called.
	   *
	   * Levels provided by Video.js are:
	   *
	   * - `off`: Matches no calls. Any value that can be cast to `false` will have
	   *   this effect. The most restrictive.
	   * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
	   *   `log.warn`, and `log.error`).
	   * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
	   * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
	   * - `warn`: Matches `log.warn` and `log.error` calls.
	   * - `error`: Matches only `log.error` calls.
	   *
	   * @type {Object}
	   */
	
	
	  log.levels = {
	    all: 'debug|log|warn|error',
	    off: '',
	    debug: 'debug|log|warn|error',
	    info: 'log|warn|error',
	    warn: 'warn|error',
	    error: 'error',
	    DEFAULT: level
	  };
	  /**
	   * Get or set the current logging level.
	   *
	   * If a string matching a key from {@link module:log.levels} is provided, acts
	   * as a setter.
	   *
	   * @param  {string} [lvl]
	   *         Pass a valid level to set a new logging level.
	   *
	   * @return {string}
	   *         The current logging level.
	   */
	
	  log.level = function (lvl) {
	    if (typeof lvl === 'string') {
	      if (!log.levels.hasOwnProperty(lvl)) {
	        throw new Error("\"" + lvl + "\" in not a valid log level");
	      }
	
	      level = lvl;
	    }
	
	    return level;
	  };
	  /**
	   * Returns an array containing everything that has been logged to the history.
	   *
	   * This array is a shallow clone of the internal history record. However, its
	   * contents are _not_ cloned; so, mutating objects inside this array will
	   * mutate them in history.
	   *
	   * @return {Array}
	   */
	
	
	  log.history = function () {
	    return history ? [].concat(history) : [];
	  };
	  /**
	   * Allows you to filter the history by the given logger name
	   *
	   * @param {string} fname
	   *        The name to filter by
	   *
	   * @return {Array}
	   *         The filtered list to return
	   */
	
	
	  log.history.filter = function (fname) {
	    return (history || []).filter(function (historyItem) {
	      // if the first item in each historyItem includes `fname`, then it's a match
	      return new RegExp(".*" + fname + ".*").test(historyItem[0]);
	    });
	  };
	  /**
	   * Clears the internal history tracking, but does not prevent further history
	   * tracking.
	   */
	
	
	  log.history.clear = function () {
	    if (history) {
	      history.length = 0;
	    }
	  };
	  /**
	   * Disable history tracking if it is currently enabled.
	   */
	
	
	  log.history.disable = function () {
	    if (history !== null) {
	      history.length = 0;
	      history = null;
	    }
	  };
	  /**
	   * Enable history tracking if it is currently disabled.
	   */
	
	
	  log.history.enable = function () {
	    if (history === null) {
	      history = [];
	    }
	  };
	  /**
	   * Logs error messages. Similar to `console.error`.
	   *
	   * @param {Mixed[]} args
	   *        One or more messages or objects that should be logged as an error
	   */
	
	
	  log.error = function () {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return logByType('error', level, args);
	  };
	  /**
	   * Logs warning messages. Similar to `console.warn`.
	   *
	   * @param {Mixed[]} args
	   *        One or more messages or objects that should be logged as a warning.
	   */
	
	
	  log.warn = function () {
	    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return logByType('warn', level, args);
	  };
	  /**
	   * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
	   * log if `console.debug` is not available
	   *
	   * @param {Mixed[]} args
	   *        One or more messages or objects that should be logged as debug.
	   */
	
	
	  log.debug = function () {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return logByType('debug', level, args);
	  };
	
	  return log;
	}
	
	/**
	 * @file log.js
	 * @module log
	 */
	var log$1 = createLogger$1('VIDEOJS');
	var createLogger = log$1.createLogger;
	
	/**
	 * @file obj.js
	 * @module obj
	 */
	
	/**
	 * @callback obj:EachCallback
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 */
	
	/**
	 * @callback obj:ReduceCallback
	 *
	 * @param {Mixed} accum
	 *        The value that is accumulating over the reduce loop.
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 *
	 * @return {Mixed}
	 *         The new accumulated value.
	 */
	var toString = Object.prototype.toString;
	/**
	 * Get the keys of an Object
	 *
	 * @param {Object}
	 *        The Object to get the keys from
	 *
	 * @return {string[]}
	 *         An array of the keys from the object. Returns an empty array if the
	 *         object passed in was invalid or had no keys.
	 *
	 * @private
	 */
	
	var keys = function keys(object) {
	  return isObject(object) ? Object.keys(object) : [];
	};
	/**
	 * Array-like iteration for objects.
	 *
	 * @param {Object} object
	 *        The object to iterate over
	 *
	 * @param {obj:EachCallback} fn
	 *        The callback function which is called for each key in the object.
	 */
	
	
	function each(object, fn) {
	  keys(object).forEach(function (key) {
	    return fn(object[key], key);
	  });
	}
	/**
	 * Array-like reduce for objects.
	 *
	 * @param {Object} object
	 *        The Object that you want to reduce.
	 *
	 * @param {Function} fn
	 *         A callback function which is called for each key in the object. It
	 *         receives the accumulated value and the per-iteration value and key
	 *         as arguments.
	 *
	 * @param {Mixed} [initial = 0]
	 *        Starting value
	 *
	 * @return {Mixed}
	 *         The final accumulated value.
	 */
	
	function reduce(object, fn, initial) {
	  if (initial === void 0) {
	    initial = 0;
	  }
	
	  return keys(object).reduce(function (accum, key) {
	    return fn(accum, object[key], key);
	  }, initial);
	}
	/**
	 * Object.assign-style object shallow merge/extend.
	 *
	 * @param  {Object} target
	 * @param  {Object} ...sources
	 * @return {Object}
	 */
	
	function assign(target) {
	  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    sources[_key - 1] = arguments[_key];
	  }
	
	  if (Object.assign) {
	    return _extends__default['default'].apply(void 0, [target].concat(sources));
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    each(source, function (value, key) {
	      target[key] = value;
	    });
	  });
	  return target;
	}
	/**
	 * Returns whether a value is an object of any kind - including DOM nodes,
	 * arrays, regular expressions, etc. Not functions, though.
	 *
	 * This avoids the gotcha where using `typeof` on a `null` value
	 * results in `'object'`.
	 *
	 * @param  {Object} value
	 * @return {boolean}
	 */
	
	function isObject(value) {
	  return !!value && typeof value === 'object';
	}
	/**
	 * Returns whether an object appears to be a "plain" object - that is, a
	 * direct instance of `Object`.
	 *
	 * @param  {Object} value
	 * @return {boolean}
	 */
	
	function isPlain(value) {
	  return isObject(value) && toString.call(value) === '[object Object]' && value.constructor === Object;
	}
	
	/**
	 * @file computed-style.js
	 * @module computed-style
	 */
	/**
	 * A safe getComputedStyle.
	 *
	 * This is needed because in Firefox, if the player is loaded in an iframe with
	 * `display:none`, then `getComputedStyle` returns `null`, so, we do a
	 * null-check to make sure that the player doesn't break in these cases.
	 *
	 * @function
	 * @param    {Element} el
	 *           The element you want the computed style of
	 *
	 * @param    {string} prop
	 *           The property name you want
	 *
	 * @see      https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	
	function computedStyle(el, prop) {
	  if (!el || !prop) {
	    return '';
	  }
	
	  if (typeof window__default['default'].getComputedStyle === 'function') {
	    var computedStyleValue;
	
	    try {
	      computedStyleValue = window__default['default'].getComputedStyle(el);
	    } catch (e) {
	      return '';
	    }
	
	    return computedStyleValue ? computedStyleValue.getPropertyValue(prop) || computedStyleValue[prop] : '';
	  }
	
	  return '';
	}
	
	/**
	 * @file browser.js
	 * @module browser
	 */
	var USER_AGENT = window__default['default'].navigator && window__default['default'].navigator.userAgent || '';
	var webkitVersionMap = /AppleWebKit\/([\d.]+)/i.exec(USER_AGENT);
	var appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
	/**
	 * Whether or not this device is an iPod.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_IPOD = /iPod/i.test(USER_AGENT);
	/**
	 * The detected iOS version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {string|null}
	 */
	
	var IOS_VERSION = function () {
	  var match = USER_AGENT.match(/OS (\d+)_/i);
	
	  if (match && match[1]) {
	    return match[1];
	  }
	
	  return null;
	}();
	/**
	 * Whether or not this is an Android device.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_ANDROID = /Android/i.test(USER_AGENT);
	/**
	 * The detected Android version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {number|string|null}
	 */
	
	var ANDROID_VERSION = function () {
	  // This matches Android Major.Minor.Patch versions
	  // ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
	  var match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
	
	  if (!match) {
	    return null;
	  }
	
	  var major = match[1] && parseFloat(match[1]);
	  var minor = match[2] && parseFloat(match[2]);
	
	  if (major && minor) {
	    return parseFloat(match[1] + '.' + match[2]);
	  } else if (major) {
	    return major;
	  }
	
	  return null;
	}();
	/**
	 * Whether or not this is a native Android browser.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_NATIVE_ANDROID = IS_ANDROID && ANDROID_VERSION < 5 && appleWebkitVersion < 537;
	/**
	 * Whether or not this is Mozilla Firefox.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_FIREFOX = /Firefox/i.test(USER_AGENT);
	/**
	 * Whether or not this is Microsoft Edge.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_EDGE = /Edg/i.test(USER_AGENT);
	/**
	 * Whether or not this is Google Chrome.
	 *
	 * This will also be `true` for Chrome on iOS, which will have different support
	 * as it is actually Safari under the hood.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_CHROME = !IS_EDGE && (/Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT));
	/**
	 * The detected Google Chrome version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {number|null}
	 */
	
	var CHROME_VERSION = function () {
	  var match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);
	
	  if (match && match[2]) {
	    return parseFloat(match[2]);
	  }
	
	  return null;
	}();
	/**
	 * The detected Internet Explorer version - or `null`.
	 *
	 * @static
	 * @const
	 * @type {number|null}
	 */
	
	var IE_VERSION = function () {
	  var result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
	  var version = result && parseFloat(result[1]);
	
	  if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) {
	    // IE 11 has a different user agent string than other IE versions
	    version = 11.0;
	  }
	
	  return version;
	}();
	/**
	 * Whether or not this is desktop Safari.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_SAFARI = /Safari/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE;
	/**
	 * Whether or not this is a Windows machine.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_WINDOWS = /Windows/i.test(USER_AGENT);
	/**
	 * Whether or not this device is touch-enabled.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var TOUCH_ENABLED = Boolean(isReal() && ('ontouchstart' in window__default['default'] || window__default['default'].navigator.maxTouchPoints || window__default['default'].DocumentTouch && window__default['default'].document instanceof window__default['default'].DocumentTouch));
	/**
	 * Whether or not this device is an iPad.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_IPAD = /iPad/i.test(USER_AGENT) || IS_SAFARI && TOUCH_ENABLED && !/iPhone/i.test(USER_AGENT);
	/**
	 * Whether or not this device is an iPhone.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	// The Facebook app's UIWebView identifies as both an iPhone and iPad, so
	// to identify iPhones, we need to exclude iPads.
	// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
	
	var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	/**
	 * Whether or not this is an iOS device.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
	/**
	 * Whether or not this is any flavor of Safari - including iOS.
	 *
	 * @static
	 * @const
	 * @type {Boolean}
	 */
	
	var IS_ANY_SAFARI = (IS_SAFARI || IS_IOS) && !IS_CHROME;
	
	var browser = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  IS_IPOD: IS_IPOD,
	  IOS_VERSION: IOS_VERSION,
	  IS_ANDROID: IS_ANDROID,
	  ANDROID_VERSION: ANDROID_VERSION,
	  IS_NATIVE_ANDROID: IS_NATIVE_ANDROID,
	  IS_FIREFOX: IS_FIREFOX,
	  IS_EDGE: IS_EDGE,
	  IS_CHROME: IS_CHROME,
	  CHROME_VERSION: CHROME_VERSION,
	  IE_VERSION: IE_VERSION,
	  IS_SAFARI: IS_SAFARI,
	  IS_WINDOWS: IS_WINDOWS,
	  TOUCH_ENABLED: TOUCH_ENABLED,
	  IS_IPAD: IS_IPAD,
	  IS_IPHONE: IS_IPHONE,
	  IS_IOS: IS_IOS,
	  IS_ANY_SAFARI: IS_ANY_SAFARI
	});
	
	/**
	 * @file dom.js
	 * @module dom
	 */
	/**
	 * Detect if a value is a string with any non-whitespace characters.
	 *
	 * @private
	 * @param  {string} str
	 *         The string to check
	 *
	 * @return {boolean}
	 *         Will be `true` if the string is non-blank, `false` otherwise.
	 *
	 */
	
	function isNonBlankString(str) {
	  // we use str.trim as it will trim any whitespace characters
	  // from the front or back of non-whitespace characters. aka
	  // Any string that contains non-whitespace characters will
	  // still contain them after `trim` but whitespace only strings
	  // will have a length of 0, failing this check.
	  return typeof str === 'string' && Boolean(str.trim());
	}
	/**
	 * Throws an error if the passed string has whitespace. This is used by
	 * class methods to be relatively consistent with the classList API.
	 *
	 * @private
	 * @param  {string} str
	 *         The string to check for whitespace.
	 *
	 * @throws {Error}
	 *         Throws an error if there is whitespace in the string.
	 */
	
	
	function throwIfWhitespace(str) {
	  // str.indexOf instead of regex because str.indexOf is faster performance wise.
	  if (str.indexOf(' ') >= 0) {
	    throw new Error('class has illegal whitespace characters');
	  }
	}
	/**
	 * Produce a regular expression for matching a className within an elements className.
	 *
	 * @private
	 * @param  {string} className
	 *         The className to generate the RegExp for.
	 *
	 * @return {RegExp}
	 *         The RegExp that will check for a specific `className` in an elements
	 *         className.
	 */
	
	
	function classRegExp(className) {
	  return new RegExp('(^|\\s)' + className + '($|\\s)');
	}
	/**
	 * Whether the current DOM interface appears to be real (i.e. not simulated).
	 *
	 * @return {boolean}
	 *         Will be `true` if the DOM appears to be real, `false` otherwise.
	 */
	
	
	function isReal() {
	  // Both document and window will never be undefined thanks to `global`.
	  return document__default['default'] === window__default['default'].document;
	}
	/**
	 * Determines, via duck typing, whether or not a value is a DOM element.
	 *
	 * @param  {Mixed} value
	 *         The value to check.
	 *
	 * @return {boolean}
	 *         Will be `true` if the value is a DOM element, `false` otherwise.
	 */
	
	function isEl(value) {
	  return isObject(value) && value.nodeType === 1;
	}
	/**
	 * Determines if the current DOM is embedded in an iframe.
	 *
	 * @return {boolean}
	 *         Will be `true` if the DOM is embedded in an iframe, `false`
	 *         otherwise.
	 */
	
	function isInFrame() {
	  // We need a try/catch here because Safari will throw errors when attempting
	  // to get either `parent` or `self`
	  try {
	    return window__default['default'].parent !== window__default['default'].self;
	  } catch (x) {
	    return true;
	  }
	}
	/**
	 * Creates functions to query the DOM using a given method.
	 *
	 * @private
	 * @param   {string} method
	 *          The method to create the query with.
	 *
	 * @return  {Function}
	 *          The query method
	 */
	
	function createQuerier(method) {
	  return function (selector, context) {
	    if (!isNonBlankString(selector)) {
	      return document__default['default'][method](null);
	    }
	
	    if (isNonBlankString(context)) {
	      context = document__default['default'].querySelector(context);
	    }
	
	    var ctx = isEl(context) ? context : document__default['default'];
	    return ctx[method] && ctx[method](selector);
	  };
	}
	/**
	 * Creates an element and applies properties, attributes, and inserts content.
	 *
	 * @param  {string} [tagName='div']
	 *         Name of tag to be created.
	 *
	 * @param  {Object} [properties={}]
	 *         Element properties to be applied.
	 *
	 * @param  {Object} [attributes={}]
	 *         Element attributes to be applied.
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor object.
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	
	
	function createEl(tagName, properties, attributes, content) {
	  if (tagName === void 0) {
	    tagName = 'div';
	  }
	
	  if (properties === void 0) {
	    properties = {};
	  }
	
	  if (attributes === void 0) {
	    attributes = {};
	  }
	
	  var el = document__default['default'].createElement(tagName);
	  Object.getOwnPropertyNames(properties).forEach(function (propName) {
	    var val = properties[propName]; // See #2176
	    // We originally were accepting both properties and attributes in the
	    // same object, but that doesn't work so well.
	
	    if (propName.indexOf('aria-') !== -1 || propName === 'role' || propName === 'type') {
	      log$1.warn('Setting attributes in the second argument of createEl()\n' + 'has been deprecated. Use the third argument instead.\n' + ("createEl(type, properties, attributes). Attempting to set " + propName + " to " + val + "."));
	      el.setAttribute(propName, val); // Handle textContent since it's not supported everywhere and we have a
	      // method for it.
	    } else if (propName === 'textContent') {
	      textContent(el, val);
	    } else if (el[propName] !== val || propName === 'tabIndex') {
	      el[propName] = val;
	    }
	  });
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    el.setAttribute(attrName, attributes[attrName]);
	  });
	
	  if (content) {
	    appendContent(el, content);
	  }
	
	  return el;
	}
	/**
	 * Injects text into an element, replacing any existing contents entirely.
	 *
	 * @param  {Element} el
	 *         The element to add text content into
	 *
	 * @param  {string} text
	 *         The text content to add.
	 *
	 * @return {Element}
	 *         The element with added text content.
	 */
	
	function textContent(el, text) {
	  if (typeof el.textContent === 'undefined') {
	    el.innerText = text;
	  } else {
	    el.textContent = text;
	  }
	
	  return el;
	}
	/**
	 * Insert an element as the first child node of another
	 *
	 * @param {Element} child
	 *        Element to insert
	 *
	 * @param {Element} parent
	 *        Element to insert child into
	 */
	
	function prependTo(child, parent) {
	  if (parent.firstChild) {
	    parent.insertBefore(child, parent.firstChild);
	  } else {
	    parent.appendChild(child);
	  }
	}
	/**
	 * Check if an element has a class name.
	 *
	 * @param  {Element} element
	 *         Element to check
	 *
	 * @param  {string} classToCheck
	 *         Class name to check for
	 *
	 * @return {boolean}
	 *         Will be `true` if the element has a class, `false` otherwise.
	 *
	 * @throws {Error}
	 *         Throws an error if `classToCheck` has white space.
	 */
	
	function hasClass(element, classToCheck) {
	  throwIfWhitespace(classToCheck);
	
	  if (element.classList) {
	    return element.classList.contains(classToCheck);
	  }
	
	  return classRegExp(classToCheck).test(element.className);
	}
	/**
	 * Add a class name to an element.
	 *
	 * @param  {Element} element
	 *         Element to add class name to.
	 *
	 * @param  {string} classToAdd
	 *         Class name to add.
	 *
	 * @return {Element}
	 *         The DOM element with the added class name.
	 */
	
	function addClass(element, classToAdd) {
	  if (element.classList) {
	    element.classList.add(classToAdd); // Don't need to `throwIfWhitespace` here because `hasElClass` will do it
	    // in the case of classList not being supported.
	  } else if (!hasClass(element, classToAdd)) {
	    element.className = (element.className + ' ' + classToAdd).trim();
	  }
	
	  return element;
	}
	/**
	 * Remove a class name from an element.
	 *
	 * @param  {Element} element
	 *         Element to remove a class name from.
	 *
	 * @param  {string} classToRemove
	 *         Class name to remove
	 *
	 * @return {Element}
	 *         The DOM element with class name removed.
	 */
	
	function removeClass(element, classToRemove) {
	  // Protect in case the player gets disposed
	  if (!element) {
	    log$1.warn("removeClass was called with an element that doesn't exist");
	    return null;
	  }
	
	  if (element.classList) {
	    element.classList.remove(classToRemove);
	  } else {
	    throwIfWhitespace(classToRemove);
	    element.className = element.className.split(/\s+/).filter(function (c) {
	      return c !== classToRemove;
	    }).join(' ');
	  }
	
	  return element;
	}
	/**
	 * The callback definition for toggleClass.
	 *
	 * @callback module:dom~PredicateCallback
	 * @param    {Element} element
	 *           The DOM element of the Component.
	 *
	 * @param    {string} classToToggle
	 *           The `className` that wants to be toggled
	 *
	 * @return   {boolean|undefined}
	 *           If `true` is returned, the `classToToggle` will be added to the
	 *           `element`. If `false`, the `classToToggle` will be removed from
	 *           the `element`. If `undefined`, the callback will be ignored.
	 */
	
	/**
	 * Adds or removes a class name to/from an element depending on an optional
	 * condition or the presence/absence of the class name.
	 *
	 * @param  {Element} element
	 *         The element to toggle a class name on.
	 *
	 * @param  {string} classToToggle
	 *         The class that should be toggled.
	 *
	 * @param  {boolean|module:dom~PredicateCallback} [predicate]
	 *         See the return value for {@link module:dom~PredicateCallback}
	 *
	 * @return {Element}
	 *         The element with a class that has been toggled.
	 */
	
	function toggleClass(element, classToToggle, predicate) {
	  // This CANNOT use `classList` internally because IE11 does not support the
	  // second parameter to the `classList.toggle()` method! Which is fine because
	  // `classList` will be used by the add/remove functions.
	  var has = hasClass(element, classToToggle);
	
	  if (typeof predicate === 'function') {
	    predicate = predicate(element, classToToggle);
	  }
	
	  if (typeof predicate !== 'boolean') {
	    predicate = !has;
	  } // If the necessary class operation matches the current state of the
	  // element, no action is required.
	
	
	  if (predicate === has) {
	    return;
	  }
	
	  if (predicate) {
	    addClass(element, classToToggle);
	  } else {
	    removeClass(element, classToToggle);
	  }
	
	  return element;
	}
	/**
	 * Apply attributes to an HTML element.
	 *
	 * @param {Element} el
	 *        Element to add attributes to.
	 *
	 * @param {Object} [attributes]
	 *        Attributes to be applied.
	 */
	
	function setAttributes(el, attributes) {
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    var attrValue = attributes[attrName];
	
	    if (attrValue === null || typeof attrValue === 'undefined' || attrValue === false) {
	      el.removeAttribute(attrName);
	    } else {
	      el.setAttribute(attrName, attrValue === true ? '' : attrValue);
	    }
	  });
	}
	/**
	 * Get an element's attribute values, as defined on the HTML tag.
	 *
	 * Attributes are not the same as properties. They're defined on the tag
	 * or with setAttribute.
	 *
	 * @param  {Element} tag
	 *         Element from which to get tag attributes.
	 *
	 * @return {Object}
	 *         All attributes of the element. Boolean attributes will be `true` or
	 *         `false`, others will be strings.
	 */
	
	function getAttributes(tag) {
	  var obj = {}; // known boolean attributes
	  // we can check for matching boolean properties, but not all browsers
	  // and not all tags know about these attributes, so, we still want to check them manually
	
	  var knownBooleans = ',' + 'autoplay,controls,playsinline,loop,muted,default,defaultMuted' + ',';
	
	  if (tag && tag.attributes && tag.attributes.length > 0) {
	    var attrs = tag.attributes;
	
	    for (var i = attrs.length - 1; i >= 0; i--) {
	      var attrName = attrs[i].name;
	      var attrVal = attrs[i].value; // check for known booleans
	      // the matching element property will return a value for typeof
	
	      if (typeof tag[attrName] === 'boolean' || knownBooleans.indexOf(',' + attrName + ',') !== -1) {
	        // the value of an included boolean attribute is typically an empty
	        // string ('') which would equal false if we just check for a false value.
	        // we also don't want support bad code like autoplay='false'
	        attrVal = attrVal !== null ? true : false;
	      }
	
	      obj[attrName] = attrVal;
	    }
	  }
	
	  return obj;
	}
	/**
	 * Get the value of an element's attribute.
	 *
	 * @param {Element} el
	 *        A DOM element.
	 *
	 * @param {string} attribute
	 *        Attribute to get the value of.
	 *
	 * @return {string}
	 *         The value of the attribute.
	 */
	
	function getAttribute(el, attribute) {
	  return el.getAttribute(attribute);
	}
	/**
	 * Set the value of an element's attribute.
	 *
	 * @param {Element} el
	 *        A DOM element.
	 *
	 * @param {string} attribute
	 *        Attribute to set.
	 *
	 * @param {string} value
	 *        Value to set the attribute to.
	 */
	
	function setAttribute(el, attribute, value) {
	  el.setAttribute(attribute, value);
	}
	/**
	 * Remove an element's attribute.
	 *
	 * @param {Element} el
	 *        A DOM element.
	 *
	 * @param {string} attribute
	 *        Attribute to remove.
	 */
	
	function removeAttribute(el, attribute) {
	  el.removeAttribute(attribute);
	}
	/**
	 * Attempt to block the ability to select text.
	 */
	
	function blockTextSelection() {
	  document__default['default'].body.focus();
	
	  document__default['default'].onselectstart = function () {
	    return false;
	  };
	}
	/**
	 * Turn off text selection blocking.
	 */
	
	function unblockTextSelection() {
	  document__default['default'].onselectstart = function () {
	    return true;
	  };
	}
	/**
	 * Identical to the native `getBoundingClientRect` function, but ensures that
	 * the method is supported at all (it is in all browsers we claim to support)
	 * and that the element is in the DOM before continuing.
	 *
	 * This wrapper function also shims properties which are not provided by some
	 * older browsers (namely, IE8).
	 *
	 * Additionally, some browsers do not support adding properties to a
	 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
	 * properties (except `x` and `y` which are not widely supported). This helps
	 * avoid implementations where keys are non-enumerable.
	 *
	 * @param  {Element} el
	 *         Element whose `ClientRect` we want to calculate.
	 *
	 * @return {Object|undefined}
	 *         Always returns a plain object - or `undefined` if it cannot.
	 */
	
	function getBoundingClientRect(el) {
	  if (el && el.getBoundingClientRect && el.parentNode) {
	    var rect = el.getBoundingClientRect();
	    var result = {};
	    ['bottom', 'height', 'left', 'right', 'top', 'width'].forEach(function (k) {
	      if (rect[k] !== undefined) {
	        result[k] = rect[k];
	      }
	    });
	
	    if (!result.height) {
	      result.height = parseFloat(computedStyle(el, 'height'));
	    }
	
	    if (!result.width) {
	      result.width = parseFloat(computedStyle(el, 'width'));
	    }
	
	    return result;
	  }
	}
	/**
	 * Represents the position of a DOM element on the page.
	 *
	 * @typedef  {Object} module:dom~Position
	 *
	 * @property {number} left
	 *           Pixels to the left.
	 *
	 * @property {number} top
	 *           Pixels from the top.
	 */
	
	/**
	 * Get the position of an element in the DOM.
	 *
	 * Uses `getBoundingClientRect` technique from John Resig.
	 *
	 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
	 *
	 * @param  {Element} el
	 *         Element from which to get offset.
	 *
	 * @return {module:dom~Position}
	 *         The position of the element that was passed in.
	 */
	
	function findPosition(el) {
	  if (!el || el && !el.offsetParent) {
	    return {
	      left: 0,
	      top: 0,
	      width: 0,
	      height: 0
	    };
	  }
	
	  var width = el.offsetWidth;
	  var height = el.offsetHeight;
	  var left = 0;
	  var top = 0;
	
	  while (el.offsetParent && el !== document__default['default'][FullscreenApi.fullscreenElement]) {
	    left += el.offsetLeft;
	    top += el.offsetTop;
	    el = el.offsetParent;
	  }
	
	  return {
	    left: left,
	    top: top,
	    width: width,
	    height: height
	  };
	}
	/**
	 * Represents x and y coordinates for a DOM element or mouse pointer.
	 *
	 * @typedef  {Object} module:dom~Coordinates
	 *
	 * @property {number} x
	 *           x coordinate in pixels
	 *
	 * @property {number} y
	 *           y coordinate in pixels
	 */
	
	/**
	 * Get the pointer position within an element.
	 *
	 * The base on the coordinates are the bottom left of the element.
	 *
	 * @param  {Element} el
	 *         Element on which to get the pointer position on.
	 *
	 * @param  {EventTarget~Event} event
	 *         Event object.
	 *
	 * @return {module:dom~Coordinates}
	 *         A coordinates object corresponding to the mouse position.
	 *
	 */
	
	function getPointerPosition(el, event) {
	  var translated = {
	    x: 0,
	    y: 0
	  };
	
	  if (IS_IOS) {
	    var item = el;
	
	    while (item && item.nodeName.toLowerCase() !== 'html') {
	      var transform = computedStyle(item, 'transform');
	
	      if (/^matrix/.test(transform)) {
	        var values = transform.slice(7, -1).split(/,\s/).map(Number);
	        translated.x += values[4];
	        translated.y += values[5];
	      } else if (/^matrix3d/.test(transform)) {
	        var _values = transform.slice(9, -1).split(/,\s/).map(Number);
	
	        translated.x += _values[12];
	        translated.y += _values[13];
	      }
	
	      item = item.parentNode;
	    }
	  }
	
	  var position = {};
	  var boxTarget = findPosition(event.target);
	  var box = findPosition(el);
	  var boxW = box.width;
	  var boxH = box.height;
	  var offsetY = event.offsetY - (box.top - boxTarget.top);
	  var offsetX = event.offsetX - (box.left - boxTarget.left);
	
	  if (event.changedTouches) {
	    offsetX = event.changedTouches[0].pageX - box.left;
	    offsetY = event.changedTouches[0].pageY + box.top;
	
	    if (IS_IOS) {
	      offsetX -= translated.x;
	      offsetY -= translated.y;
	    }
	  }
	
	  position.y = 1 - Math.max(0, Math.min(1, offsetY / boxH));
	  position.x = Math.max(0, Math.min(1, offsetX / boxW));
	  return position;
	}
	/**
	 * Determines, via duck typing, whether or not a value is a text node.
	 *
	 * @param  {Mixed} value
	 *         Check if this value is a text node.
	 *
	 * @return {boolean}
	 *         Will be `true` if the value is a text node, `false` otherwise.
	 */
	
	function isTextNode(value) {
	  return isObject(value) && value.nodeType === 3;
	}
	/**
	 * Empties the contents of an element.
	 *
	 * @param  {Element} el
	 *         The element to empty children from
	 *
	 * @return {Element}
	 *         The element with no children
	 */
	
	function emptyEl(el) {
	  while (el.firstChild) {
	    el.removeChild(el.firstChild);
	  }
	
	  return el;
	}
	/**
	 * This is a mixed value that describes content to be injected into the DOM
	 * via some method. It can be of the following types:
	 *
	 * Type       | Description
	 * -----------|-------------
	 * `string`   | The value will be normalized into a text node.
	 * `Element`  | The value will be accepted as-is.
	 * `TextNode` | The value will be accepted as-is.
	 * `Array`    | A one-dimensional array of strings, elements, text nodes, or functions. These functions should return a string, element, or text node (any other return value, like an array, will be ignored).
	 * `Function` | A function, which is expected to return a string, element, text node, or array - any of the other possible values described above. This means that a content descriptor could be a function that returns an array of functions, but those second-level functions must return strings, elements, or text nodes.
	 *
	 * @typedef {string|Element|TextNode|Array|Function} module:dom~ContentDescriptor
	 */
	
	/**
	 * Normalizes content for eventual insertion into the DOM.
	 *
	 * This allows a wide range of content definition methods, but helps protect
	 * from falling into the trap of simply writing to `innerHTML`, which could
	 * be an XSS concern.
	 *
	 * The content for an element can be passed in multiple types and
	 * combinations, whose behavior is as follows:
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor value.
	 *
	 * @return {Array}
	 *         All of the content that was passed in, normalized to an array of
	 *         elements or text nodes.
	 */
	
	function normalizeContent(content) {
	  // First, invoke content if it is a function. If it produces an array,
	  // that needs to happen before normalization.
	  if (typeof content === 'function') {
	    content = content();
	  } // Next up, normalize to an array, so one or many items can be normalized,
	  // filtered, and returned.
	
	
	  return (Array.isArray(content) ? content : [content]).map(function (value) {
	    // First, invoke value if it is a function to produce a new value,
	    // which will be subsequently normalized to a Node of some kind.
	    if (typeof value === 'function') {
	      value = value();
	    }
	
	    if (isEl(value) || isTextNode(value)) {
	      return value;
	    }
	
	    if (typeof value === 'string' && /\S/.test(value)) {
	      return document__default['default'].createTextNode(value);
	    }
	  }).filter(function (value) {
	    return value;
	  });
	}
	/**
	 * Normalizes and appends content to an element.
	 *
	 * @param  {Element} el
	 *         Element to append normalized content to.
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor value.
	 *
	 * @return {Element}
	 *         The element with appended normalized content.
	 */
	
	function appendContent(el, content) {
	  normalizeContent(content).forEach(function (node) {
	    return el.appendChild(node);
	  });
	  return el;
	}
	/**
	 * Normalizes and inserts content into an element; this is identical to
	 * `appendContent()`, except it empties the element first.
	 *
	 * @param {Element} el
	 *        Element to insert normalized content into.
	 *
	 * @param {module:dom~ContentDescriptor} content
	 *        A content descriptor value.
	 *
	 * @return {Element}
	 *         The element with inserted normalized content.
	 */
	
	function insertContent(el, content) {
	  return appendContent(emptyEl(el), content);
	}
	/**
	 * Check if an event was a single left click.
	 *
	 * @param  {EventTarget~Event} event
	 *         Event object.
	 *
	 * @return {boolean}
	 *         Will be `true` if a single left click, `false` otherwise.
	 */
	
	function isSingleLeftClick(event) {
	  // Note: if you create something draggable, be sure to
	  // call it on both `mousedown` and `mousemove` event,
	  // otherwise `mousedown` should be enough for a button
	  if (event.button === undefined && event.buttons === undefined) {
	    // Why do we need `buttons` ?
	    // Because, middle mouse sometimes have this:
	    // e.button === 0 and e.buttons === 4
	    // Furthermore, we want to prevent combination click, something like
	    // HOLD middlemouse then left click, that would be
	    // e.button === 0, e.buttons === 5
	    // just `button` is not gonna work
	    // Alright, then what this block does ?
	    // this is for chrome `simulate mobile devices`
	    // I want to support this as well
	    return true;
	  }
	
	  if (event.button === 0 && event.buttons === undefined) {
	    // Touch screen, sometimes on some specific device, `buttons`
	    // doesn't have anything (safari on ios, blackberry...)
	    return true;
	  } // `mouseup` event on a single left click has
	  // `button` and `buttons` equal to 0
	
	
	  if (event.type === 'mouseup' && event.button === 0 && event.buttons === 0) {
	    return true;
	  }
	
	  if (event.button !== 0 || event.buttons !== 1) {
	    // This is the reason we have those if else block above
	    // if any special case we can catch and let it slide
	    // we do it above, when get to here, this definitely
	    // is-not-left-click
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Finds a single DOM element matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param  {string} selector
	 *         A valid CSS selector, which will be passed to `querySelector`.
	 *
	 * @param  {Element|String} [context=document]
	 *         A DOM element within which to query. Can also be a selector
	 *         string in which case the first matching element will be used
	 *         as context. If missing (or no element matches selector), falls
	 *         back to `document`.
	 *
	 * @return {Element|null}
	 *         The element that was found or null.
	 */
	
	var $ = createQuerier('querySelector');
	/**
	 * Finds a all DOM elements matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param  {string} selector
	 *         A valid CSS selector, which will be passed to `querySelectorAll`.
	 *
	 * @param  {Element|String} [context=document]
	 *         A DOM element within which to query. Can also be a selector
	 *         string in which case the first matching element will be used
	 *         as context. If missing (or no element matches selector), falls
	 *         back to `document`.
	 *
	 * @return {NodeList}
	 *         A element list of elements that were found. Will be empty if none
	 *         were found.
	 *
	 */
	
	var $$ = createQuerier('querySelectorAll');
	
	var Dom = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  isReal: isReal,
	  isEl: isEl,
	  isInFrame: isInFrame,
	  createEl: createEl,
	  textContent: textContent,
	  prependTo: prependTo,
	  hasClass: hasClass,
	  addClass: addClass,
	  removeClass: removeClass,
	  toggleClass: toggleClass,
	  setAttributes: setAttributes,
	  getAttributes: getAttributes,
	  getAttribute: getAttribute,
	  setAttribute: setAttribute,
	  removeAttribute: removeAttribute,
	  blockTextSelection: blockTextSelection,
	  unblockTextSelection: unblockTextSelection,
	  getBoundingClientRect: getBoundingClientRect,
	  findPosition: findPosition,
	  getPointerPosition: getPointerPosition,
	  isTextNode: isTextNode,
	  emptyEl: emptyEl,
	  normalizeContent: normalizeContent,
	  appendContent: appendContent,
	  insertContent: insertContent,
	  isSingleLeftClick: isSingleLeftClick,
	  $: $,
	  $$: $$
	});
	
	/**
	 * @file setup.js - Functions for setting up a player without
	 * user interaction based on the data-setup `attribute` of the video tag.
	 *
	 * @module setup
	 */
	var _windowLoaded = false;
	var videojs$1;
	/**
	 * Set up any tags that have a data-setup `attribute` when the player is started.
	 */
	
	var autoSetup = function autoSetup() {
	  if (videojs$1.options.autoSetup === false) {
	    return;
	  }
	
	  var vids = Array.prototype.slice.call(document__default['default'].getElementsByTagName('video'));
	  var audios = Array.prototype.slice.call(document__default['default'].getElementsByTagName('audio'));
	  var divs = Array.prototype.slice.call(document__default['default'].getElementsByTagName('video-js'));
	  var mediaEls = vids.concat(audios, divs); // Check if any media elements exist
	
	  if (mediaEls && mediaEls.length > 0) {
	    for (var i = 0, e = mediaEls.length; i < e; i++) {
	      var mediaEl = mediaEls[i]; // Check if element exists, has getAttribute func.
	
	      if (mediaEl && mediaEl.getAttribute) {
	        // Make sure this player hasn't already been set up.
	        if (mediaEl.player === undefined) {
	          var options = mediaEl.getAttribute('data-setup'); // Check if data-setup attr exists.
	          // We only auto-setup if they've added the data-setup attr.
	
	          if (options !== null) {
	            // Create new video.js instance.
	            videojs$1(mediaEl);
	          }
	        } // If getAttribute isn't defined, we need to wait for the DOM.
	
	      } else {
	        autoSetupTimeout(1);
	        break;
	      }
	    } // No videos were found, so keep looping unless page is finished loading.
	
	  } else if (!_windowLoaded) {
	    autoSetupTimeout(1);
	  }
	};
	/**
	 * Wait until the page is loaded before running autoSetup. This will be called in
	 * autoSetup if `hasLoaded` returns false.
	 *
	 * @param {number} wait
	 *        How long to wait in ms
	 *
	 * @param {module:videojs} [vjs]
	 *        The videojs library function
	 */
	
	
	function autoSetupTimeout(wait, vjs) {
	  // Protect against breakage in non-browser environments
	  if (!isReal()) {
	    return;
	  }
	
	  if (vjs) {
	    videojs$1 = vjs;
	  }
	
	  window__default['default'].setTimeout(autoSetup, wait);
	}
	/**
	 * Used to set the internal tracking of window loaded state to true.
	 *
	 * @private
	 */
	
	
	function setWindowLoaded() {
	  _windowLoaded = true;
	  window__default['default'].removeEventListener('load', setWindowLoaded);
	}
	
	if (isReal()) {
	  if (document__default['default'].readyState === 'complete') {
	    setWindowLoaded();
	  } else {
	    /**
	     * Listen for the load event on window, and set _windowLoaded to true.
	     *
	     * We use a standard event listener here to avoid incrementing the GUID
	     * before any players are created.
	     *
	     * @listens load
	     */
	    window__default['default'].addEventListener('load', setWindowLoaded);
	  }
	}
	
	/**
	 * @file stylesheet.js
	 * @module stylesheet
	 */
	/**
	 * Create a DOM syle element given a className for it.
	 *
	 * @param {string} className
	 *        The className to add to the created style element.
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	
	var createStyleElement = function createStyleElement(className) {
	  var style = document__default['default'].createElement('style');
	  style.className = className;
	  return style;
	};
	/**
	 * Add text to a DOM element.
	 *
	 * @param {Element} el
	 *        The Element to add text content to.
	 *
	 * @param {string} content
	 *        The text to add to the element.
	 */
	
	var setTextContent = function setTextContent(el, content) {
	  if (el.styleSheet) {
	    el.styleSheet.cssText = content;
	  } else {
	    el.textContent = content;
	  }
	};
	
	/**
	 * @file guid.js
	 * @module guid
	 */
	// Default value for GUIDs. This allows us to reset the GUID counter in tests.
	//
	// The initial GUID is 3 because some users have come to rely on the first
	// default player ID ending up as `vjs_video_3`.
	//
	// See: https://github.com/videojs/video.js/pull/6216
	var _initialGuid = 3;
	/**
	 * Unique ID for an element or function
	 *
	 * @type {Number}
	 */
	
	var _guid = _initialGuid;
	/**
	 * Get a unique auto-incrementing ID by number that has not been returned before.
	 *
	 * @return {number}
	 *         A new unique ID.
	 */
	
	function newGUID() {
	  return _guid++;
	}
	
	/**
	 * @file dom-data.js
	 * @module dom-data
	 */
	var FakeWeakMap;
	
	if (!window__default['default'].WeakMap) {
	  FakeWeakMap = /*#__PURE__*/function () {
	    function FakeWeakMap() {
	      this.vdata = 'vdata' + Math.floor(window__default['default'].performance && window__default['default'].performance.now() || Date.now());
	      this.data = {};
	    }
	
	    var _proto = FakeWeakMap.prototype;
	
	    _proto.set = function set(key, value) {
	      var access = key[this.vdata] || newGUID();
	
	      if (!key[this.vdata]) {
	        key[this.vdata] = access;
	      }
	
	      this.data[access] = value;
	      return this;
	    };
	
	    _proto.get = function get(key) {
	      var access = key[this.vdata]; // we have data, return it
	
	      if (access) {
	        return this.data[access];
	      } // we don't have data, return nothing.
	      // return undefined explicitly as that's the contract for this method
	
	
	      log$1('We have no data for this element', key);
	      return undefined;
	    };
	
	    _proto.has = function has(key) {
	      var access = key[this.vdata];
	      return access in this.data;
	    };
	
	    _proto["delete"] = function _delete(key) {
	      var access = key[this.vdata];
	
	      if (access) {
	        delete this.data[access];
	        delete key[this.vdata];
	      }
	    };
	
	    return FakeWeakMap;
	  }();
	}
	/**
	 * Element Data Store.
	 *
	 * Allows for binding data to an element without putting it directly on the
	 * element. Ex. Event listeners are stored here.
	 * (also from jsninja.com, slightly modified and updated for closure compiler)
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	var DomData = window__default['default'].WeakMap ? new WeakMap() : new FakeWeakMap();
	
	/**
	 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
	 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
	 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
	 * robust as jquery's, so there's probably some differences.
	 *
	 * @file events.js
	 * @module events
	 */
	/**
	 * Clean up the listener cache and dispatchers
	 *
	 * @param {Element|Object} elem
	 *        Element to clean up
	 *
	 * @param {string} type
	 *        Type of event to clean up
	 */
	
	function _cleanUpEvents(elem, type) {
	  if (!DomData.has(elem)) {
	    return;
	  }
	
	  var data = DomData.get(elem); // Remove the events of a particular type if there are none left
	
	  if (data.handlers[type].length === 0) {
	    delete data.handlers[type]; // data.handlers[type] = null;
	    // Setting to null was causing an error with data.handlers
	    // Remove the meta-handler from the element
	
	    if (elem.removeEventListener) {
	      elem.removeEventListener(type, data.dispatcher, false);
	    } else if (elem.detachEvent) {
	      elem.detachEvent('on' + type, data.dispatcher);
	    }
	  } // Remove the events object if there are no types left
	
	
	  if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
	    delete data.handlers;
	    delete data.dispatcher;
	    delete data.disabled;
	  } // Finally remove the element data if there is no data left
	
	
	  if (Object.getOwnPropertyNames(data).length === 0) {
	    DomData["delete"](elem);
	  }
	}
	/**
	 * Loops through an array of event types and calls the requested method for each type.
	 *
	 * @param {Function} fn
	 *        The event method we want to use.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} callback
	 *        Event listener.
	 */
	
	
	function _handleMultipleEvents(fn, elem, types, callback) {
	  types.forEach(function (type) {
	    // Call the event method for each one of the types
	    fn(elem, type, callback);
	  });
	}
	/**
	 * Fix a native event to have standard property values
	 *
	 * @param {Object} event
	 *        Event object to fix.
	 *
	 * @return {Object}
	 *         Fixed event object.
	 */
	
	
	function fixEvent(event) {
	  if (event.fixed_) {
	    return event;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function returnFalse() {
	    return false;
	  } // Test if fixing up is needed
	  // Used to check if !event.stopPropagation instead of isPropagationStopped
	  // But native events return true for stopPropagation, but don't have
	  // other expected methods like isPropagationStopped. Seems to be a problem
	  // with the Javascript Ninja code. So we're just overriding all events now.
	
	
	  if (!event || !event.isPropagationStopped || !event.isImmediatePropagationStopped) {
	    var old = event || window__default['default'].event;
	    event = {}; // Clone the old object so that we can modify the values event = {};
	    // IE8 Doesn't like when you mess with native event properties
	    // Firefox returns false for event.hasOwnProperty('type') and other props
	    //  which makes copying more difficult.
	    // TODO: Probably best to create a whitelist of event props
	
	    for (var key in old) {
	      // Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
	      // Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
	      // and webkitMovementX/Y
	      // Lighthouse complains if Event.path is copied
	      if (key !== 'layerX' && key !== 'layerY' && key !== 'keyLocation' && key !== 'webkitMovementX' && key !== 'webkitMovementY' && key !== 'path') {
	        // Chrome 32+ warns if you try to copy deprecated returnValue, but
	        // we still want to if preventDefault isn't supported (IE8).
	        if (!(key === 'returnValue' && old.preventDefault)) {
	          event[key] = old[key];
	        }
	      }
	    } // The event occurred on this element
	
	
	    if (!event.target) {
	      event.target = event.srcElement || document__default['default'];
	    } // Handle which other element the event is related to
	
	
	    if (!event.relatedTarget) {
	      event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
	    } // Stop the default browser action
	
	
	    event.preventDefault = function () {
	      if (old.preventDefault) {
	        old.preventDefault();
	      }
	
	      event.returnValue = false;
	      old.returnValue = false;
	      event.defaultPrevented = true;
	    };
	
	    event.defaultPrevented = false; // Stop the event from bubbling
	
	    event.stopPropagation = function () {
	      if (old.stopPropagation) {
	        old.stopPropagation();
	      }
	
	      event.cancelBubble = true;
	      old.cancelBubble = true;
	      event.isPropagationStopped = returnTrue;
	    };
	
	    event.isPropagationStopped = returnFalse; // Stop the event from bubbling and executing other handlers
	
	    event.stopImmediatePropagation = function () {
	      if (old.stopImmediatePropagation) {
	        old.stopImmediatePropagation();
	      }
	
	      event.isImmediatePropagationStopped = returnTrue;
	      event.stopPropagation();
	    };
	
	    event.isImmediatePropagationStopped = returnFalse; // Handle mouse position
	
	    if (event.clientX !== null && event.clientX !== undefined) {
	      var doc = document__default['default'].documentElement;
	      var body = document__default['default'].body;
	      event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    } // Handle key presses
	
	
	    event.which = event.charCode || event.keyCode; // Fix button for mouse clicks:
	    // 0 == left; 1 == middle; 2 == right
	
	    if (event.button !== null && event.button !== undefined) {
	      // The following is disabled because it does not pass videojs-standard
	      // and... yikes.
	
	      /* eslint-disable */
	      event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
	      /* eslint-enable */
	    }
	  }
	
	  event.fixed_ = true; // Returns fixed-up instance
	
	  return event;
	}
	/**
	 * Whether passive event listeners are supported
	 */
	
	var _supportsPassive;
	
	var supportsPassive = function supportsPassive() {
	  if (typeof _supportsPassive !== 'boolean') {
	    _supportsPassive = false;
	
	    try {
	      var opts = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          _supportsPassive = true;
	        }
	      });
	      window__default['default'].addEventListener('test', null, opts);
	      window__default['default'].removeEventListener('test', null, opts);
	    } catch (e) {// disregard
	    }
	  }
	
	  return _supportsPassive;
	};
	/**
	 * Touch events Chrome expects to be passive
	 */
	
	
	var passiveEvents = ['touchstart', 'touchmove'];
	/**
	 * Add an event listener to element
	 * It stores the handler function in a separate cache object
	 * and adds a generic handler to the element's event,
	 * along with a unique id (guid) to the element.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string|string[]} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        Event listener.
	 */
	
	function on(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(on, elem, type, fn);
	  }
	
	  if (!DomData.has(elem)) {
	    DomData.set(elem, {});
	  }
	
	  var data = DomData.get(elem); // We need a place to store all our handler data
	
	  if (!data.handlers) {
	    data.handlers = {};
	  }
	
	  if (!data.handlers[type]) {
	    data.handlers[type] = [];
	  }
	
	  if (!fn.guid) {
	    fn.guid = newGUID();
	  }
	
	  data.handlers[type].push(fn);
	
	  if (!data.dispatcher) {
	    data.disabled = false;
	
	    data.dispatcher = function (event, hash) {
	      if (data.disabled) {
	        return;
	      }
	
	      event = fixEvent(event);
	      var handlers = data.handlers[event.type];
	
	      if (handlers) {
	        // Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
	        var handlersCopy = handlers.slice(0);
	
	        for (var m = 0, n = handlersCopy.length; m < n; m++) {
	          if (event.isImmediatePropagationStopped()) {
	            break;
	          } else {
	            try {
	              handlersCopy[m].call(elem, event, hash);
	            } catch (e) {
	              log$1.error(e);
	            }
	          }
	        }
	      }
	    };
	  }
	
	  if (data.handlers[type].length === 1) {
	    if (elem.addEventListener) {
	      var options = false;
	
	      if (supportsPassive() && passiveEvents.indexOf(type) > -1) {
	        options = {
	          passive: true
	        };
	      }
	
	      elem.addEventListener(type, data.dispatcher, options);
	    } else if (elem.attachEvent) {
	      elem.attachEvent('on' + type, data.dispatcher);
	    }
	  }
	}
	/**
	 * Removes event listeners from an element
	 *
	 * @param {Element|Object} elem
	 *        Object to remove listeners from.
	 *
	 * @param {string|string[]} [type]
	 *        Type of listener to remove. Don't include to remove all events from element.
	 *
	 * @param {EventTarget~EventListener} [fn]
	 *        Specific listener to remove. Don't include to remove listeners for an event
	 *        type.
	 */
	
	function off(elem, type, fn) {
	  // Don't want to add a cache object through getElData if not needed
	  if (!DomData.has(elem)) {
	    return;
	  }
	
	  var data = DomData.get(elem); // If no events exist, nothing to unbind
	
	  if (!data.handlers) {
	    return;
	  }
	
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(off, elem, type, fn);
	  } // Utility function
	
	
	  var removeType = function removeType(el, t) {
	    data.handlers[t] = [];
	
	    _cleanUpEvents(el, t);
	  }; // Are we removing all bound events?
	
	
	  if (type === undefined) {
	    for (var t in data.handlers) {
	      if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t)) {
	        removeType(elem, t);
	      }
	    }
	
	    return;
	  }
	
	  var handlers = data.handlers[type]; // If no handlers exist, nothing to unbind
	
	  if (!handlers) {
	    return;
	  } // If no listener was provided, remove all listeners for type
	
	
	  if (!fn) {
	    removeType(elem, type);
	    return;
	  } // We're only removing a single handler
	
	
	  if (fn.guid) {
	    for (var n = 0; n < handlers.length; n++) {
	      if (handlers[n].guid === fn.guid) {
	        handlers.splice(n--, 1);
	      }
	    }
	  }
	
	  _cleanUpEvents(elem, type);
	}
	/**
	 * Trigger an event for an element
	 *
	 * @param {Element|Object} elem
	 *        Element to trigger an event on
	 *
	 * @param {EventTarget~Event|string} event
	 *        A string (the type) or an event object with a type attribute
	 *
	 * @param {Object} [hash]
	 *        data hash to pass along with the event
	 *
	 * @return {boolean|undefined}
	 *         Returns the opposite of `defaultPrevented` if default was
	 *         prevented. Otherwise, returns `undefined`
	 */
	
	function trigger(elem, event, hash) {
	  // Fetches element data and a reference to the parent (for bubbling).
	  // Don't want to add a data object to cache for every parent,
	  // so checking hasElData first.
	  var elemData = DomData.has(elem) ? DomData.get(elem) : {};
	  var parent = elem.parentNode || elem.ownerDocument; // type = event.type || event,
	  // handler;
	  // If an event name was passed as a string, creates an event out of it
	
	  if (typeof event === 'string') {
	    event = {
	      type: event,
	      target: elem
	    };
	  } else if (!event.target) {
	    event.target = elem;
	  } // Normalizes the event properties.
	
	
	  event = fixEvent(event); // If the passed element has a dispatcher, executes the established handlers.
	
	  if (elemData.dispatcher) {
	    elemData.dispatcher.call(elem, event, hash);
	  } // Unless explicitly stopped or the event does not bubble (e.g. media events)
	  // recursively calls this function to bubble the event up the DOM.
	
	
	  if (parent && !event.isPropagationStopped() && event.bubbles === true) {
	    trigger.call(null, parent, event, hash); // If at the top of the DOM, triggers the default action unless disabled.
	  } else if (!parent && !event.defaultPrevented && event.target && event.target[event.type]) {
	    if (!DomData.has(event.target)) {
	      DomData.set(event.target, {});
	    }
	
	    var targetData = DomData.get(event.target); // Checks if the target has a default action for this event.
	
	    if (event.target[event.type]) {
	      // Temporarily disables event dispatching on the target as we have already executed the handler.
	      targetData.disabled = true; // Executes the default action.
	
	      if (typeof event.target[event.type] === 'function') {
	        event.target[event.type]();
	      } // Re-enables event dispatching.
	
	
	      targetData.disabled = false;
	    }
	  } // Inform the triggerer if the default was prevented by returning false
	
	
	  return !event.defaultPrevented;
	}
	/**
	 * Trigger a listener only once for an event.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind to.
	 *
	 * @param {string|string[]} type
	 *        Name/type of event
	 *
	 * @param {Event~EventListener} fn
	 *        Event listener function
	 */
	
	function one(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(one, elem, type, fn);
	  }
	
	  var func = function func() {
	    off(elem, type, func);
	    fn.apply(this, arguments);
	  }; // copy the guid to the new function so it can removed using the original function's ID
	
	
	  func.guid = fn.guid = fn.guid || newGUID();
	  on(elem, type, func);
	}
	/**
	 * Trigger a listener only once and then turn if off for all
	 * configured events
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind to.
	 *
	 * @param {string|string[]} type
	 *        Name/type of event
	 *
	 * @param {Event~EventListener} fn
	 *        Event listener function
	 */
	
	function any(elem, type, fn) {
	  var func = function func() {
	    off(elem, type, func);
	    fn.apply(this, arguments);
	  }; // copy the guid to the new function so it can removed using the original function's ID
	
	
	  func.guid = fn.guid = fn.guid || newGUID(); // multiple ons, but one off for everything
	
	  on(elem, type, func);
	}
	
	var Events = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  fixEvent: fixEvent,
	  on: on,
	  off: off,
	  trigger: trigger,
	  one: one,
	  any: any
	});
	
	/**
	 * @file fn.js
	 * @module fn
	 */
	var UPDATE_REFRESH_INTERVAL = 30;
	/**
	 * Bind (a.k.a proxy or context). A simple method for changing the context of
	 * a function.
	 *
	 * It also stores a unique id on the function so it can be easily removed from
	 * events.
	 *
	 * @function
	 * @param    {Mixed} context
	 *           The object to bind as scope.
	 *
	 * @param    {Function} fn
	 *           The function to be bound to a scope.
	 *
	 * @param    {number} [uid]
	 *           An optional unique ID for the function to be set
	 *
	 * @return   {Function}
	 *           The new function that will be bound into the context given
	 */
	
	var bind = function bind(context, fn, uid) {
	  // Make sure the function has a unique ID
	  if (!fn.guid) {
	    fn.guid = newGUID();
	  } // Create the new function that changes the context
	
	
	  var bound = fn.bind(context); // Allow for the ability to individualize this function
	  // Needed in the case where multiple objects might share the same prototype
	  // IF both items add an event listener with the same function, then you try to remove just one
	  // it will remove both because they both have the same guid.
	  // when using this, you need to use the bind method when you remove the listener as well.
	  // currently used in text tracks
	
	  bound.guid = uid ? uid + '_' + fn.guid : fn.guid;
	  return bound;
	};
	/**
	 * Wraps the given function, `fn`, with a new function that only invokes `fn`
	 * at most once per every `wait` milliseconds.
	 *
	 * @function
	 * @param    {Function} fn
	 *           The function to be throttled.
	 *
	 * @param    {number}   wait
	 *           The number of milliseconds by which to throttle.
	 *
	 * @return   {Function}
	 */
	
	var throttle = function throttle(fn, wait) {
	  var last = window__default['default'].performance.now();
	
	  var throttled = function throttled() {
	    var now = window__default['default'].performance.now();
	
	    if (now - last >= wait) {
	      fn.apply(void 0, arguments);
	      last = now;
	    }
	  };
	
	  return throttled;
	};
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked.
	 *
	 * Inspired by lodash and underscore implementations.
	 *
	 * @function
	 * @param    {Function} func
	 *           The function to wrap with debounce behavior.
	 *
	 * @param    {number} wait
	 *           The number of milliseconds to wait after the last invocation.
	 *
	 * @param    {boolean} [immediate]
	 *           Whether or not to invoke the function immediately upon creation.
	 *
	 * @param    {Object} [context=window]
	 *           The "context" in which the debounced function should debounce. For
	 *           example, if this function should be tied to a Video.js player,
	 *           the player can be passed here. Alternatively, defaults to the
	 *           global `window` object.
	 *
	 * @return   {Function}
	 *           A debounced function.
	 */
	
	var debounce = function debounce(func, wait, immediate, context) {
	  if (context === void 0) {
	    context = window__default['default'];
	  }
	
	  var timeout;
	
	  var cancel = function cancel() {
	    context.clearTimeout(timeout);
	    timeout = null;
	  };
	  /* eslint-disable consistent-this */
	
	
	  var debounced = function debounced() {
	    var self = this;
	    var args = arguments;
	
	    var _later = function later() {
	      timeout = null;
	      _later = null;
	
	      if (!immediate) {
	        func.apply(self, args);
	      }
	    };
	
	    if (!timeout && immediate) {
	      func.apply(self, args);
	    }
	
	    context.clearTimeout(timeout);
	    timeout = context.setTimeout(_later, wait);
	  };
	  /* eslint-enable consistent-this */
	
	
	  debounced.cancel = cancel;
	  return debounced;
	};
	
	/**
	 * @file src/js/event-target.js
	 */
	/**
	 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
	 * adds shorthand functions that wrap around lengthy functions. For example:
	 * the `on` function is a wrapper around `addEventListener`.
	 *
	 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
	 * @class EventTarget
	 */
	
	var EventTarget$2 = function EventTarget() {};
	/**
	 * A Custom DOM event.
	 *
	 * @typedef {Object} EventTarget~Event
	 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
	 */
	
	/**
	 * All event listeners should follow the following format.
	 *
	 * @callback EventTarget~EventListener
	 * @this {EventTarget}
	 *
	 * @param {EventTarget~Event} event
	 *        the event that triggered this function
	 *
	 * @param {Object} [hash]
	 *        hash of data sent during the event
	 */
	
	/**
	 * An object containing event names as keys and booleans as values.
	 *
	 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
	 *         will have extra functionality. See that function for more information.
	 *
	 * @property EventTarget.prototype.allowedEvents_
	 * @private
	 */
	
	
	EventTarget$2.prototype.allowedEvents_ = {};
	/**
	 * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
	 * function that will get called when an event with a certain name gets triggered.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to call with `EventTarget`s
	 */
	
	EventTarget$2.prototype.on = function (type, fn) {
	  // Remove the addEventListener alias before calling Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	
	  on(this, type, fn);
	  this.addEventListener = ael;
	};
	/**
	 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#on}
	 */
	
	
	EventTarget$2.prototype.addEventListener = EventTarget$2.prototype.on;
	/**
	 * Removes an `event listener` for a specific event from an instance of `EventTarget`.
	 * This makes it so that the `event listener` will no longer get called when the
	 * named event happens.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to remove.
	 */
	
	EventTarget$2.prototype.off = function (type, fn) {
	  off(this, type, fn);
	};
	/**
	 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#off}
	 */
	
	
	EventTarget$2.prototype.removeEventListener = EventTarget$2.prototype.off;
	/**
	 * This function will add an `event listener` that gets triggered only once. After the
	 * first trigger it will get removed. This is like adding an `event listener`
	 * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to be called once for each event name.
	 */
	
	EventTarget$2.prototype.one = function (type, fn) {
	  // Remove the addEventListener aliasing Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	
	  one(this, type, fn);
	  this.addEventListener = ael;
	};
	
	EventTarget$2.prototype.any = function (type, fn) {
	  // Remove the addEventListener aliasing Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	
	  any(this, type, fn);
	  this.addEventListener = ael;
	};
	/**
	 * This function causes an event to happen. This will then cause any `event listeners`
	 * that are waiting for that event, to get called. If there are no `event listeners`
	 * for an event then nothing will happen.
	 *
	 * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
	 * Trigger will also call the `on` + `uppercaseEventName` function.
	 *
	 * Example:
	 * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
	 * `onClick` if it exists.
	 *
	 * @param {string|EventTarget~Event|Object} event
	 *        The name of the event, an `Event`, or an object with a key of type set to
	 *        an event name.
	 */
	
	
	EventTarget$2.prototype.trigger = function (event) {
	  var type = event.type || event; // deprecation
	  // In a future version we should default target to `this`
	  // similar to how we default the target to `elem` in
	  // `Events.trigger`. Right now the default `target` will be
	  // `document` due to the `Event.fixEvent` call.
	
	  if (typeof event === 'string') {
	    event = {
	      type: type
	    };
	  }
	
	  event = fixEvent(event);
	
	  if (this.allowedEvents_[type] && this['on' + type]) {
	    this['on' + type](event);
	  }
	
	  trigger(this, event);
	};
	/**
	 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#trigger}
	 */
	
	
	EventTarget$2.prototype.dispatchEvent = EventTarget$2.prototype.trigger;
	var EVENT_MAP;
	
	EventTarget$2.prototype.queueTrigger = function (event) {
	  var _this = this;
	
	  // only set up EVENT_MAP if it'll be used
	  if (!EVENT_MAP) {
	    EVENT_MAP = new Map();
	  }
	
	  var type = event.type || event;
	  var map = EVENT_MAP.get(this);
	
	  if (!map) {
	    map = new Map();
	    EVENT_MAP.set(this, map);
	  }
	
	  var oldTimeout = map.get(type);
	  map["delete"](type);
	  window__default['default'].clearTimeout(oldTimeout);
	  var timeout = window__default['default'].setTimeout(function () {
	    map["delete"](type); // if we cleared out all timeouts for the current target, delete its map
	
	    if (map.size === 0) {
	      map = null;
	      EVENT_MAP["delete"](_this);
	    }
	
	    _this.trigger(event);
	  }, 0);
	  map.set(type, timeout);
	};
	
	/**
	 * @file mixins/evented.js
	 * @module evented
	 */
	
	var objName = function objName(obj) {
	  if (typeof obj.name === 'function') {
	    return obj.name();
	  }
	
	  if (typeof obj.name === 'string') {
	    return obj.name;
	  }
	
	  if (obj.name_) {
	    return obj.name_;
	  }
	
	  if (obj.constructor && obj.constructor.name) {
	    return obj.constructor.name;
	  }
	
	  return typeof obj;
	};
	/**
	 * Returns whether or not an object has had the evented mixin applied.
	 *
	 * @param  {Object} object
	 *         An object to test.
	 *
	 * @return {boolean}
	 *         Whether or not the object appears to be evented.
	 */
	
	
	var isEvented = function isEvented(object) {
	  return object instanceof EventTarget$2 || !!object.eventBusEl_ && ['on', 'one', 'off', 'trigger'].every(function (k) {
	    return typeof object[k] === 'function';
	  });
	};
	/**
	 * Adds a callback to run after the evented mixin applied.
	 *
	 * @param  {Object} object
	 *         An object to Add
	 * @param  {Function} callback
	 *         The callback to run.
	 */
	
	
	var addEventedCallback = function addEventedCallback(target, callback) {
	  if (isEvented(target)) {
	    callback();
	  } else {
	    if (!target.eventedCallbacks) {
	      target.eventedCallbacks = [];
	    }
	
	    target.eventedCallbacks.push(callback);
	  }
	};
	/**
	 * Whether a value is a valid event type - non-empty string or array.
	 *
	 * @private
	 * @param  {string|Array} type
	 *         The type value to test.
	 *
	 * @return {boolean}
	 *         Whether or not the type is a valid event type.
	 */
	
	
	var isValidEventType = function isValidEventType(type) {
	  return (// The regex here verifies that the `type` contains at least one non-
	    // whitespace character.
	    typeof type === 'string' && /\S/.test(type) || Array.isArray(type) && !!type.length
	  );
	};
	/**
	 * Validates a value to determine if it is a valid event target. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the target does not appear to be a valid event target.
	 *
	 * @param  {Object} target
	 *         The object to test.
	 *
	 * @param  {Object} obj
	 *         The evented object we are validating for
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 */
	
	
	var validateTarget = function validateTarget(target, obj, fnName) {
	  if (!target || !target.nodeName && !isEvented(target)) {
	    throw new Error("Invalid target for " + objName(obj) + "#" + fnName + "; must be a DOM node or evented object.");
	  }
	};
	/**
	 * Validates a value to determine if it is a valid event target. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the type does not appear to be a valid event type.
	 *
	 * @param  {string|Array} type
	 *         The type to test.
	 *
	 * @param  {Object} obj
	*         The evented object we are validating for
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 */
	
	
	var validateEventType = function validateEventType(type, obj, fnName) {
	  if (!isValidEventType(type)) {
	    throw new Error("Invalid event type for " + objName(obj) + "#" + fnName + "; must be a non-empty string or array.");
	  }
	};
	/**
	 * Validates a value to determine if it is a valid listener. Throws if not.
	 *
	 * @private
	 * @throws {Error}
	 *         If the listener is not a function.
	 *
	 * @param  {Function} listener
	 *         The listener to test.
	 *
	 * @param  {Object} obj
	 *         The evented object we are validating for
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 */
	
	
	var validateListener = function validateListener(listener, obj, fnName) {
	  if (typeof listener !== 'function') {
	    throw new Error("Invalid listener for " + objName(obj) + "#" + fnName + "; must be a function.");
	  }
	};
	/**
	 * Takes an array of arguments given to `on()` or `one()`, validates them, and
	 * normalizes them into an object.
	 *
	 * @private
	 * @param  {Object} self
	 *         The evented object on which `on()` or `one()` was called. This
	 *         object will be bound as the `this` value for the listener.
	 *
	 * @param  {Array} args
	 *         An array of arguments passed to `on()` or `one()`.
	 *
	 * @param  {string} fnName
	 *         The name of the evented mixin function that called this.
	 *
	 * @return {Object}
	 *         An object containing useful values for `on()` or `one()` calls.
	 */
	
	
	var normalizeListenArgs = function normalizeListenArgs(self, args, fnName) {
	  // If the number of arguments is less than 3, the target is always the
	  // evented object itself.
	  var isTargetingSelf = args.length < 3 || args[0] === self || args[0] === self.eventBusEl_;
	  var target;
	  var type;
	  var listener;
	
	  if (isTargetingSelf) {
	    target = self.eventBusEl_; // Deal with cases where we got 3 arguments, but we are still listening to
	    // the evented object itself.
	
	    if (args.length >= 3) {
	      args.shift();
	    }
	
	    type = args[0];
	    listener = args[1];
	  } else {
	    target = args[0];
	    type = args[1];
	    listener = args[2];
	  }
	
	  validateTarget(target, self, fnName);
	  validateEventType(type, self, fnName);
	  validateListener(listener, self, fnName);
	  listener = bind(self, listener);
	  return {
	    isTargetingSelf: isTargetingSelf,
	    target: target,
	    type: type,
	    listener: listener
	  };
	};
	/**
	 * Adds the listener to the event type(s) on the target, normalizing for
	 * the type of target.
	 *
	 * @private
	 * @param  {Element|Object} target
	 *         A DOM node or evented object.
	 *
	 * @param  {string} method
	 *         The event binding method to use ("on" or "one").
	 *
	 * @param  {string|Array} type
	 *         One or more event type(s).
	 *
	 * @param  {Function} listener
	 *         A listener function.
	 */
	
	
	var listen = function listen(target, method, type, listener) {
	  validateTarget(target, target, method);
	
	  if (target.nodeName) {
	    Events[method](target, type, listener);
	  } else {
	    target[method](type, listener);
	  }
	};
	/**
	 * Contains methods that provide event capabilities to an object which is passed
	 * to {@link module:evented|evented}.
	 *
	 * @mixin EventedMixin
	 */
	
	
	var EventedMixin = {
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  on: function on() {
	    var _this = this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _normalizeListenArgs = normalizeListenArgs(this, args, 'on'),
	        isTargetingSelf = _normalizeListenArgs.isTargetingSelf,
	        target = _normalizeListenArgs.target,
	        type = _normalizeListenArgs.type,
	        listener = _normalizeListenArgs.listener;
	
	    listen(target, 'on', type, listener); // If this object is listening to another evented object.
	
	    if (!isTargetingSelf) {
	      // If this object is disposed, remove the listener.
	      var removeListenerOnDispose = function removeListenerOnDispose() {
	        return _this.off(target, type, listener);
	      }; // Use the same function ID as the listener so we can remove it later it
	      // using the ID of the original listener.
	
	
	      removeListenerOnDispose.guid = listener.guid; // Add a listener to the target's dispose event as well. This ensures
	      // that if the target is disposed BEFORE this object, we remove the
	      // removal listener that was just added. Otherwise, we create a memory leak.
	
	      var removeRemoverOnTargetDispose = function removeRemoverOnTargetDispose() {
	        return _this.off('dispose', removeListenerOnDispose);
	      }; // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	
	
	      removeRemoverOnTargetDispose.guid = listener.guid;
	      listen(this, 'on', 'dispose', removeListenerOnDispose);
	      listen(target, 'on', 'dispose', removeRemoverOnTargetDispose);
	    }
	  },
	
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object. The listener will be called once per event and then removed.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  one: function one() {
	    var _this2 = this;
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var _normalizeListenArgs2 = normalizeListenArgs(this, args, 'one'),
	        isTargetingSelf = _normalizeListenArgs2.isTargetingSelf,
	        target = _normalizeListenArgs2.target,
	        type = _normalizeListenArgs2.type,
	        listener = _normalizeListenArgs2.listener; // Targeting this evented object.
	
	
	    if (isTargetingSelf) {
	      listen(target, 'one', type, listener); // Targeting another evented object.
	    } else {
	      // TODO: This wrapper is incorrect! It should only
	      //       remove the wrapper for the event type that called it.
	      //       Instead all listners are removed on the first trigger!
	      //       see https://github.com/videojs/video.js/issues/5962
	      var wrapper = function wrapper() {
	        _this2.off(target, type, wrapper);
	
	        for (var _len3 = arguments.length, largs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          largs[_key3] = arguments[_key3];
	        }
	
	        listener.apply(null, largs);
	      }; // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	
	
	      wrapper.guid = listener.guid;
	      listen(target, 'one', type, wrapper);
	    }
	  },
	
	  /**
	   * Add a listener to an event (or events) on this object or another evented
	   * object. The listener will only be called once for the first event that is triggered
	   * then removed.
	   *
	   * @param  {string|Array|Element|Object} targetOrType
	   *         If this is a string or array, it represents the event type(s)
	   *         that will trigger the listener.
	   *
	   *         Another evented object can be passed here instead, which will
	   *         cause the listener to listen for events on _that_ object.
	   *
	   *         In either case, the listener's `this` value will be bound to
	   *         this object.
	   *
	   * @param  {string|Array|Function} typeOrListener
	   *         If the first argument was a string or array, this should be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function.
	   */
	  any: function any() {
	    var _this3 = this;
	
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    var _normalizeListenArgs3 = normalizeListenArgs(this, args, 'any'),
	        isTargetingSelf = _normalizeListenArgs3.isTargetingSelf,
	        target = _normalizeListenArgs3.target,
	        type = _normalizeListenArgs3.type,
	        listener = _normalizeListenArgs3.listener; // Targeting this evented object.
	
	
	    if (isTargetingSelf) {
	      listen(target, 'any', type, listener); // Targeting another evented object.
	    } else {
	      var wrapper = function wrapper() {
	        _this3.off(target, type, wrapper);
	
	        for (var _len5 = arguments.length, largs = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	          largs[_key5] = arguments[_key5];
	        }
	
	        listener.apply(null, largs);
	      }; // Use the same function ID as the listener so we can remove it later
	      // it using the ID of the original listener.
	
	
	      wrapper.guid = listener.guid;
	      listen(target, 'any', type, wrapper);
	    }
	  },
	
	  /**
	   * Removes listener(s) from event(s) on an evented object.
	   *
	   * @param  {string|Array|Element|Object} [targetOrType]
	   *         If this is a string or array, it represents the event type(s).
	   *
	   *         Another evented object can be passed here instead, in which case
	   *         ALL 3 arguments are _required_.
	   *
	   * @param  {string|Array|Function} [typeOrListener]
	   *         If the first argument was a string or array, this may be the
	   *         listener function. Otherwise, this is a string or array of event
	   *         type(s).
	   *
	   * @param  {Function} [listener]
	   *         If the first argument was another evented object, this will be
	   *         the listener function; otherwise, _all_ listeners bound to the
	   *         event type(s) will be removed.
	   */
	  off: function off$1(targetOrType, typeOrListener, listener) {
	    // Targeting this evented object.
	    if (!targetOrType || isValidEventType(targetOrType)) {
	      off(this.eventBusEl_, targetOrType, typeOrListener); // Targeting another evented object.
	    } else {
	      var target = targetOrType;
	      var type = typeOrListener; // Fail fast and in a meaningful way!
	
	      validateTarget(target, this, 'off');
	      validateEventType(type, this, 'off');
	      validateListener(listener, this, 'off'); // Ensure there's at least a guid, even if the function hasn't been used
	
	      listener = bind(this, listener); // Remove the dispose listener on this evented object, which was given
	      // the same guid as the event listener in on().
	
	      this.off('dispose', listener);
	
	      if (target.nodeName) {
	        off(target, type, listener);
	        off(target, 'dispose', listener);
	      } else if (isEvented(target)) {
	        target.off(type, listener);
	        target.off('dispose', listener);
	      }
	    }
	  },
	
	  /**
	   * Fire an event on this evented object, causing its listeners to be called.
	   *
	   * @param   {string|Object} event
	   *          An event type or an object with a type property.
	   *
	   * @param   {Object} [hash]
	   *          An additional object to pass along to listeners.
	   *
	   * @return {boolean}
	   *          Whether or not the default behavior was prevented.
	   */
	  trigger: function trigger$1(event, hash) {
	    validateTarget(this.eventBusEl_, this, 'trigger');
	    var type = event && typeof event !== 'string' ? event.type : event;
	
	    if (!isValidEventType(type)) {
	      var error = "Invalid event type for " + objName(this) + "#trigger; " + 'must be a non-empty string or object with a type key that has a non-empty value.';
	
	      if (event) {
	        (this.log || log$1).error(error);
	      } else {
	        throw new Error(error);
	      }
	    }
	
	    return trigger(this.eventBusEl_, event, hash);
	  }
	};
	/**
	 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
	 *
	 * @param  {Object} target
	 *         The object to which to add event methods.
	 *
	 * @param  {Object} [options={}]
	 *         Options for customizing the mixin behavior.
	 *
	 * @param  {string} [options.eventBusKey]
	 *         By default, adds a `eventBusEl_` DOM element to the target object,
	 *         which is used as an event bus. If the target object already has a
	 *         DOM element that should be used, pass its key here.
	 *
	 * @return {Object}
	 *         The target object.
	 */
	
	function evented(target, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      eventBusKey = _options.eventBusKey; // Set or create the eventBusEl_.
	
	  if (eventBusKey) {
	    if (!target[eventBusKey].nodeName) {
	      throw new Error("The eventBusKey \"" + eventBusKey + "\" does not refer to an element.");
	    }
	
	    target.eventBusEl_ = target[eventBusKey];
	  } else {
	    target.eventBusEl_ = createEl('span', {
	      className: 'vjs-event-bus'
	    });
	  }
	
	  assign(target, EventedMixin);
	
	  if (target.eventedCallbacks) {
	    target.eventedCallbacks.forEach(function (callback) {
	      callback();
	    });
	  } // When any evented object is disposed, it removes all its listeners.
	
	
	  target.on('dispose', function () {
	    target.off();
	    [target, target.el_, target.eventBusEl_].forEach(function (val) {
	      if (val && DomData.has(val)) {
	        DomData["delete"](val);
	      }
	    });
	    window__default['default'].setTimeout(function () {
	      target.eventBusEl_ = null;
	    }, 0);
	  });
	  return target;
	}
	
	/**
	 * @file mixins/stateful.js
	 * @module stateful
	 */
	/**
	 * Contains methods that provide statefulness to an object which is passed
	 * to {@link module:stateful}.
	 *
	 * @mixin StatefulMixin
	 */
	
	var StatefulMixin = {
	  /**
	   * A hash containing arbitrary keys and values representing the state of
	   * the object.
	   *
	   * @type {Object}
	   */
	  state: {},
	
	  /**
	   * Set the state of an object by mutating its
	   * {@link module:stateful~StatefulMixin.state|state} object in place.
	   *
	   * @fires   module:stateful~StatefulMixin#statechanged
	   * @param   {Object|Function} stateUpdates
	   *          A new set of properties to shallow-merge into the plugin state.
	   *          Can be a plain object or a function returning a plain object.
	   *
	   * @return {Object|undefined}
	   *          An object containing changes that occurred. If no changes
	   *          occurred, returns `undefined`.
	   */
	  setState: function setState(stateUpdates) {
	    var _this = this;
	
	    // Support providing the `stateUpdates` state as a function.
	    if (typeof stateUpdates === 'function') {
	      stateUpdates = stateUpdates();
	    }
	
	    var changes;
	    each(stateUpdates, function (value, key) {
	      // Record the change if the value is different from what's in the
	      // current state.
	      if (_this.state[key] !== value) {
	        changes = changes || {};
	        changes[key] = {
	          from: _this.state[key],
	          to: value
	        };
	      }
	
	      _this.state[key] = value;
	    }); // Only trigger "statechange" if there were changes AND we have a trigger
	    // function. This allows us to not require that the target object be an
	    // evented object.
	
	    if (changes && isEvented(this)) {
	      /**
	       * An event triggered on an object that is both
	       * {@link module:stateful|stateful} and {@link module:evented|evented}
	       * indicating that its state has changed.
	       *
	       * @event    module:stateful~StatefulMixin#statechanged
	       * @type     {Object}
	       * @property {Object} changes
	       *           A hash containing the properties that were changed and
	       *           the values they were changed `from` and `to`.
	       */
	      this.trigger({
	        changes: changes,
	        type: 'statechanged'
	      });
	    }
	
	    return changes;
	  }
	};
	/**
	 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
	 * object.
	 *
	 * If the target object is {@link module:evented|evented} and has a
	 * `handleStateChanged` method, that method will be automatically bound to the
	 * `statechanged` event on itself.
	 *
	 * @param   {Object} target
	 *          The object to be made stateful.
	 *
	 * @param   {Object} [defaultState]
	 *          A default set of properties to populate the newly-stateful object's
	 *          `state` property.
	 *
	 * @return {Object}
	 *          Returns the `target`.
	 */
	
	function stateful(target, defaultState) {
	  assign(target, StatefulMixin); // This happens after the mixing-in because we need to replace the `state`
	  // added in that step.
	
	  target.state = assign({}, target.state, defaultState); // Auto-bind the `handleStateChanged` method of the target object if it exists.
	
	  if (typeof target.handleStateChanged === 'function' && isEvented(target)) {
	    target.on('statechanged', target.handleStateChanged);
	  }
	
	  return target;
	}
	
	/**
	 * @file string-cases.js
	 * @module to-lower-case
	 */
	
	/**
	 * Lowercase the first letter of a string.
	 *
	 * @param {string} string
	 *        String to be lowercased
	 *
	 * @return {string}
	 *         The string with a lowercased first letter
	 */
	var toLowerCase = function toLowerCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.replace(/./, function (w) {
	    return w.toLowerCase();
	  });
	};
	/**
	 * Uppercase the first letter of a string.
	 *
	 * @param {string} string
	 *        String to be uppercased
	 *
	 * @return {string}
	 *         The string with an uppercased first letter
	 */
	
	var toTitleCase$1 = function toTitleCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.replace(/./, function (w) {
	    return w.toUpperCase();
	  });
	};
	/**
	 * Compares the TitleCase versions of the two strings for equality.
	 *
	 * @param {string} str1
	 *        The first string to compare
	 *
	 * @param {string} str2
	 *        The second string to compare
	 *
	 * @return {boolean}
	 *         Whether the TitleCase versions of the strings are equal
	 */
	
	var titleCaseEquals = function titleCaseEquals(str1, str2) {
	  return toTitleCase$1(str1) === toTitleCase$1(str2);
	};
	
	/**
	 * @file merge-options.js
	 * @module merge-options
	 */
	/**
	 * Merge two objects recursively.
	 *
	 * Performs a deep merge like
	 * {@link https://lodash.com/docs/4.17.10#merge|lodash.merge}, but only merges
	 * plain objects (not arrays, elements, or anything else).
	 *
	 * Non-plain object values will be copied directly from the right-most
	 * argument.
	 *
	 * @static
	 * @param   {Object[]} sources
	 *          One or more objects to merge into a new object.
	 *
	 * @return {Object}
	 *          A new object that is the merged result of all sources.
	 */
	
	function mergeOptions$3() {
	  var result = {};
	
	  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
	    sources[_key] = arguments[_key];
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    each(source, function (value, key) {
	      if (!isPlain(value)) {
	        result[key] = value;
	        return;
	      }
	
	      if (!isPlain(result[key])) {
	        result[key] = {};
	      }
	
	      result[key] = mergeOptions$3(result[key], value);
	    });
	  });
	  return result;
	}
	
	var MapSham = /*#__PURE__*/function () {
	  function MapSham() {
	    this.map_ = {};
	  }
	
	  var _proto = MapSham.prototype;
	
	  _proto.has = function has(key) {
	    return key in this.map_;
	  };
	
	  _proto["delete"] = function _delete(key) {
	    var has = this.has(key);
	    delete this.map_[key];
	    return has;
	  };
	
	  _proto.set = function set(key, value) {
	    this.map_[key] = value;
	    return this;
	  };
	
	  _proto.forEach = function forEach(callback, thisArg) {
	    for (var key in this.map_) {
	      callback.call(thisArg, this.map_[key], key, this);
	    }
	  };
	
	  return MapSham;
	}();
	
	var Map$1 = window__default['default'].Map ? window__default['default'].Map : MapSham;
	
	var SetSham = /*#__PURE__*/function () {
	  function SetSham() {
	    this.set_ = {};
	  }
	
	  var _proto = SetSham.prototype;
	
	  _proto.has = function has(key) {
	    return key in this.set_;
	  };
	
	  _proto["delete"] = function _delete(key) {
	    var has = this.has(key);
	    delete this.set_[key];
	    return has;
	  };
	
	  _proto.add = function add(key) {
	    this.set_[key] = 1;
	    return this;
	  };
	
	  _proto.forEach = function forEach(callback, thisArg) {
	    for (var key in this.set_) {
	      callback.call(thisArg, key, key, this);
	    }
	  };
	
	  return SetSham;
	}();
	
	var Set$1 = window__default['default'].Set ? window__default['default'].Set : SetSham;
	
	/**
	 * Player Component - Base class for all UI objects
	 *
	 * @file component.js
	 */
	/**
	 * Base class for all UI Components.
	 * Components are UI objects which represent both a javascript object and an element
	 * in the DOM. They can be children of other components, and can have
	 * children themselves.
	 *
	 * Components can also use methods from {@link EventTarget}
	 */
	
	var Component$1 = /*#__PURE__*/function () {
	  /**
	   * A callback that is called when a component is ready. Does not have any
	   * paramters and any callback value will be ignored.
	   *
	   * @callback Component~ReadyCallback
	   * @this Component
	   */
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of component options.
	   *
	   * @param {Object[]} [options.children]
	   *        An array of children objects to intialize this component with. Children objects have
	   *        a name property that will be used if more than one component of the same type needs to be
	   *        added.
	   *
	   * @param  {string} [options.className]
	   *         A class or space separated list of classes to add the component
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Function that gets called when the `Component` is ready.
	   */
	  function Component(player, options, ready) {
	    var _this = this;
	
	    // The component might be the player itself and we can't pass `this` to super
	    if (!player && this.play) {
	      this.player_ = player = this; // eslint-disable-line
	    } else {
	      this.player_ = player;
	    }
	
	    this.isDisposed_ = false; // Hold the reference to the parent component via `addChild` method
	
	    this.parentComponent_ = null; // Make a copy of prototype.options_ to protect against overriding defaults
	
	    this.options_ = mergeOptions$3({}, this.options_); // Updated options with supplied options
	
	    options = this.options_ = mergeOptions$3(this.options_, options); // Get ID from options or options element if one is supplied
	
	    this.id_ = options.id || options.el && options.el.id; // If there was no ID from the options, generate one
	
	    if (!this.id_) {
	      // Don't require the player ID function in the case of mock players
	      var id = player && player.id && player.id() || 'no_player';
	      this.id_ = id + "_component_" + newGUID();
	    }
	
	    this.name_ = options.name || null; // Create element if one wasn't provided in options
	
	    if (options.el) {
	      this.el_ = options.el;
	    } else if (options.createEl !== false) {
	      this.el_ = this.createEl();
	    }
	
	    if (options.className && this.el_) {
	      options.className.split(' ').forEach(function (c) {
	        return _this.addClass(c);
	      });
	    } // if evented is anything except false, we want to mixin in evented
	
	
	    if (options.evented !== false) {
	      // Make this an evented object and use `el_`, if available, as its event bus
	      evented(this, {
	        eventBusKey: this.el_ ? 'el_' : null
	      });
	      this.handleLanguagechange = this.handleLanguagechange.bind(this);
	      this.on(this.player_, 'languagechange', this.handleLanguagechange);
	    }
	
	    stateful(this, this.constructor.defaultState);
	    this.children_ = [];
	    this.childIndex_ = {};
	    this.childNameIndex_ = {};
	    this.setTimeoutIds_ = new Set$1();
	    this.setIntervalIds_ = new Set$1();
	    this.rafIds_ = new Set$1();
	    this.namedRafs_ = new Map$1();
	    this.clearingTimersOnDispose_ = false; // Add any child components in options
	
	    if (options.initChildren !== false) {
	      this.initChildren();
	    } // Don't want to trigger ready here or it will go before init is actually
	    // finished for all children that run this constructor
	
	
	    this.ready(ready);
	
	    if (options.reportTouchActivity !== false) {
	      this.enableTouchActivity();
	    }
	  }
	  /**
	   * Dispose of the `Component` and all child components.
	   *
	   * @fires Component#dispose
	   *
	   * @param {Object} options
	   * @param {Element} options.originalEl element with which to replace player element
	   */
	
	
	  var _proto = Component.prototype;
	
	  _proto.dispose = function dispose(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Bail out if the component has already been disposed.
	    if (this.isDisposed_) {
	      return;
	    }
	
	    if (this.readyQueue_) {
	      this.readyQueue_.length = 0;
	    }
	    /**
	     * Triggered when a `Component` is disposed.
	     *
	     * @event Component#dispose
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the dispose event does not
	     *           bubble up
	     */
	
	
	    this.trigger({
	      type: 'dispose',
	      bubbles: false
	    });
	    this.isDisposed_ = true; // Dispose all children.
	
	    if (this.children_) {
	      for (var i = this.children_.length - 1; i >= 0; i--) {
	        if (this.children_[i].dispose) {
	          this.children_[i].dispose();
	        }
	      }
	    } // Delete child references
	
	
	    this.children_ = null;
	    this.childIndex_ = null;
	    this.childNameIndex_ = null;
	    this.parentComponent_ = null;
	
	    if (this.el_) {
	      // Remove element from DOM
	      if (this.el_.parentNode) {
	        if (options.restoreEl) {
	          this.el_.parentNode.replaceChild(options.restoreEl, this.el_);
	        } else {
	          this.el_.parentNode.removeChild(this.el_);
	        }
	      }
	
	      this.el_ = null;
	    } // remove reference to the player after disposing of the element
	
	
	    this.player_ = null;
	  }
	  /**
	   * Determine whether or not this component has been disposed.
	   *
	   * @return {boolean}
	   *         If the component has been disposed, will be `true`. Otherwise, `false`.
	   */
	  ;
	
	  _proto.isDisposed = function isDisposed() {
	    return Boolean(this.isDisposed_);
	  }
	  /**
	   * Return the {@link Player} that the `Component` has attached to.
	   *
	   * @return {Player}
	   *         The player that this `Component` has attached to.
	   */
	  ;
	
	  _proto.player = function player() {
	    return this.player_;
	  }
	  /**
	   * Deep merge of options objects with new options.
	   * > Note: When both `obj` and `options` contain properties whose values are objects.
	   *         The two properties get merged using {@link module:mergeOptions}
	   *
	   * @param {Object} obj
	   *        The object that contains new options.
	   *
	   * @return {Object}
	   *         A new object of `this.options_` and `obj` merged together.
	   */
	  ;
	
	  _proto.options = function options(obj) {
	    if (!obj) {
	      return this.options_;
	    }
	
	    this.options_ = mergeOptions$3(this.options_, obj);
	    return this.options_;
	  }
	  /**
	   * Get the `Component`s DOM element
	   *
	   * @return {Element}
	   *         The DOM element for this `Component`.
	   */
	  ;
	
	  _proto.el = function el() {
	    return this.el_;
	  }
	  /**
	   * Create the `Component`s DOM element.
	   *
	   * @param {string} [tagName]
	   *        Element's DOM node type. e.g. 'div'
	   *
	   * @param {Object} [properties]
	   *        An object of properties that should be set.
	   *
	   * @param {Object} [attributes]
	   *        An object of attributes that should be set.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl$1(tagName, properties, attributes) {
	    return createEl(tagName, properties, attributes);
	  }
	  /**
	   * Localize a string given the string in english.
	   *
	   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
	   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
	   *
	   * If a `defaultValue` is provided, it'll use that over `string`,
	   * if a value isn't found in provided language files.
	   * This is useful if you want to have a descriptive key for token replacement
	   * but have a succinct localized string and not require `en.json` to be included.
	   *
	   * Currently, it is used for the progress bar timing.
	   * ```js
	   * {
	   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
	   * }
	   * ```
	   * It is then used like so:
	   * ```js
	   * this.localize('progress bar timing: currentTime={1} duration{2}',
	   *               [this.player_.currentTime(), this.player_.duration()],
	   *               '{1} of {2}');
	   * ```
	   *
	   * Which outputs something like: `01:23 of 24:56`.
	   *
	   *
	   * @param {string} string
	   *        The string to localize and the key to lookup in the language files.
	   * @param {string[]} [tokens]
	   *        If the current item has token replacements, provide the tokens here.
	   * @param {string} [defaultValue]
	   *        Defaults to `string`. Can be a default value to use for token replacement
	   *        if the lookup key is needed to be separate.
	   *
	   * @return {string}
	   *         The localized string or if no localization exists the english string.
	   */
	  ;
	
	  _proto.localize = function localize(string, tokens, defaultValue) {
	    if (defaultValue === void 0) {
	      defaultValue = string;
	    }
	
	    var code = this.player_.language && this.player_.language();
	    var languages = this.player_.languages && this.player_.languages();
	    var language = languages && languages[code];
	    var primaryCode = code && code.split('-')[0];
	    var primaryLang = languages && languages[primaryCode];
	    var localizedString = defaultValue;
	
	    if (language && language[string]) {
	      localizedString = language[string];
	    } else if (primaryLang && primaryLang[string]) {
	      localizedString = primaryLang[string];
	    }
	
	    if (tokens) {
	      localizedString = localizedString.replace(/\{(\d+)\}/g, function (match, index) {
	        var value = tokens[index - 1];
	        var ret = value;
	
	        if (typeof value === 'undefined') {
	          ret = match;
	        }
	
	        return ret;
	      });
	    }
	
	    return localizedString;
	  }
	  /**
	   * Handles language change for the player in components. Should be overriden by sub-components.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.handleLanguagechange = function handleLanguagechange() {}
	  /**
	   * Return the `Component`s DOM element. This is where children get inserted.
	   * This will usually be the the same as the element returned in {@link Component#el}.
	   *
	   * @return {Element}
	   *         The content element for this `Component`.
	   */
	  ;
	
	  _proto.contentEl = function contentEl() {
	    return this.contentEl_ || this.el_;
	  }
	  /**
	   * Get this `Component`s ID
	   *
	   * @return {string}
	   *         The id of this `Component`
	   */
	  ;
	
	  _proto.id = function id() {
	    return this.id_;
	  }
	  /**
	   * Get the `Component`s name. The name gets used to reference the `Component`
	   * and is set during registration.
	   *
	   * @return {string}
	   *         The name of this `Component`.
	   */
	  ;
	
	  _proto.name = function name() {
	    return this.name_;
	  }
	  /**
	   * Get an array of all child components
	   *
	   * @return {Array}
	   *         The children
	   */
	  ;
	
	  _proto.children = function children() {
	    return this.children_;
	  }
	  /**
	   * Returns the child `Component` with the given `id`.
	   *
	   * @param {string} id
	   *        The id of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `id` or undefined.
	   */
	  ;
	
	  _proto.getChildById = function getChildById(id) {
	    return this.childIndex_[id];
	  }
	  /**
	   * Returns the child `Component` with the given `name`.
	   *
	   * @param {string} name
	   *        The name of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `name` or undefined.
	   */
	  ;
	
	  _proto.getChild = function getChild(name) {
	    if (!name) {
	      return;
	    }
	
	    return this.childNameIndex_[name];
	  }
	  /**
	   * Returns the descendant `Component` following the givent
	   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
	   * try to get 'foo' on the current component, 'bar' on the 'foo'
	   * component and 'baz' on the 'bar' component and return undefined
	   * if any of those don't exist.
	   *
	   * @param {...string[]|...string} names
	   *        The name of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The descendant `Component` following the given descendant
	   *         `names` or undefined.
	   */
	  ;
	
	  _proto.getDescendant = function getDescendant() {
	    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
	      names[_key] = arguments[_key];
	    }
	
	    // flatten array argument into the main array
	    names = names.reduce(function (acc, n) {
	      return acc.concat(n);
	    }, []);
	    var currentChild = this;
	
	    for (var i = 0; i < names.length; i++) {
	      currentChild = currentChild.getChild(names[i]);
	
	      if (!currentChild || !currentChild.getChild) {
	        return;
	      }
	    }
	
	    return currentChild;
	  }
	  /**
	   * Add a child `Component` inside the current `Component`.
	   *
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @param {number} [index=this.children_.length]
	   *        The index to attempt to add a child into.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   */
	  ;
	
	  _proto.addChild = function addChild(child, options, index) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (index === void 0) {
	      index = this.children_.length;
	    }
	
	    var component;
	    var componentName; // If child is a string, create component with options
	
	    if (typeof child === 'string') {
	      componentName = toTitleCase$1(child);
	      var componentClassName = options.componentClass || componentName; // Set name through options
	
	      options.name = componentName; // Create a new object & element for this controls set
	      // If there's no .player_, this is a player
	
	      var ComponentClass = Component.getComponent(componentClassName);
	
	      if (!ComponentClass) {
	        throw new Error("Component " + componentClassName + " does not exist");
	      } // data stored directly on the videojs object may be
	      // misidentified as a component to retain
	      // backwards-compatibility with 4.x. check to make sure the
	      // component class can be instantiated.
	
	
	      if (typeof ComponentClass !== 'function') {
	        return null;
	      }
	
	      component = new ComponentClass(this.player_ || this, options); // child is a component instance
	    } else {
	      component = child;
	    }
	
	    if (component.parentComponent_) {
	      component.parentComponent_.removeChild(component);
	    }
	
	    this.children_.splice(index, 0, component);
	    component.parentComponent_ = this;
	
	    if (typeof component.id === 'function') {
	      this.childIndex_[component.id()] = component;
	    } // If a name wasn't used to create the component, check if we can use the
	    // name function of the component
	
	
	    componentName = componentName || component.name && toTitleCase$1(component.name());
	
	    if (componentName) {
	      this.childNameIndex_[componentName] = component;
	      this.childNameIndex_[toLowerCase(componentName)] = component;
	    } // Add the UI object's element to the container div (box)
	    // Having an element is not required
	
	
	    if (typeof component.el === 'function' && component.el()) {
	      // If inserting before a component, insert before that component's element
	      var refNode = null;
	
	      if (this.children_[index + 1]) {
	        // Most children are components, but the video tech is an HTML element
	        if (this.children_[index + 1].el_) {
	          refNode = this.children_[index + 1].el_;
	        } else if (isEl(this.children_[index + 1])) {
	          refNode = this.children_[index + 1];
	        }
	      }
	
	      this.contentEl().insertBefore(component.el(), refNode);
	    } // Return so it can stored on parent object if desired.
	
	
	    return component;
	  }
	  /**
	   * Remove a child `Component` from this `Component`s list of children. Also removes
	   * the child `Component`s element from this `Component`s element.
	   *
	   * @param {Component} component
	   *        The child `Component` to remove.
	   */
	  ;
	
	  _proto.removeChild = function removeChild(component) {
	    if (typeof component === 'string') {
	      component = this.getChild(component);
	    }
	
	    if (!component || !this.children_) {
	      return;
	    }
	
	    var childFound = false;
	
	    for (var i = this.children_.length - 1; i >= 0; i--) {
	      if (this.children_[i] === component) {
	        childFound = true;
	        this.children_.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!childFound) {
	      return;
	    }
	
	    component.parentComponent_ = null;
	    this.childIndex_[component.id()] = null;
	    this.childNameIndex_[toTitleCase$1(component.name())] = null;
	    this.childNameIndex_[toLowerCase(component.name())] = null;
	    var compEl = component.el();
	
	    if (compEl && compEl.parentNode === this.contentEl()) {
	      this.contentEl().removeChild(component.el());
	    }
	  }
	  /**
	   * Add and initialize default child `Component`s based upon options.
	   */
	  ;
	
	  _proto.initChildren = function initChildren() {
	    var _this2 = this;
	
	    var children = this.options_.children;
	
	    if (children) {
	      // `this` is `parent`
	      var parentOptions = this.options_;
	
	      var handleAdd = function handleAdd(child) {
	        var name = child.name;
	        var opts = child.opts; // Allow options for children to be set at the parent options
	        // e.g. videojs(id, { controlBar: false });
	        // instead of videojs(id, { children: { controlBar: false });
	
	        if (parentOptions[name] !== undefined) {
	          opts = parentOptions[name];
	        } // Allow for disabling default components
	        // e.g. options['children']['posterImage'] = false
	
	
	        if (opts === false) {
	          return;
	        } // Allow options to be passed as a simple boolean if no configuration
	        // is necessary.
	
	
	        if (opts === true) {
	          opts = {};
	        } // We also want to pass the original player options
	        // to each component as well so they don't need to
	        // reach back into the player for options later.
	
	
	        opts.playerOptions = _this2.options_.playerOptions; // Create and add the child component.
	        // Add a direct reference to the child by name on the parent instance.
	        // If two of the same component are used, different names should be supplied
	        // for each
	
	        var newChild = _this2.addChild(name, opts);
	
	        if (newChild) {
	          _this2[name] = newChild;
	        }
	      }; // Allow for an array of children details to passed in the options
	
	
	      var workingChildren;
	      var Tech = Component.getComponent('Tech');
	
	      if (Array.isArray(children)) {
	        workingChildren = children;
	      } else {
	        workingChildren = Object.keys(children);
	      }
	
	      workingChildren // children that are in this.options_ but also in workingChildren  would
	      // give us extra children we do not want. So, we want to filter them out.
	      .concat(Object.keys(this.options_).filter(function (child) {
	        return !workingChildren.some(function (wchild) {
	          if (typeof wchild === 'string') {
	            return child === wchild;
	          }
	
	          return child === wchild.name;
	        });
	      })).map(function (child) {
	        var name;
	        var opts;
	
	        if (typeof child === 'string') {
	          name = child;
	          opts = children[name] || _this2.options_[name] || {};
	        } else {
	          name = child.name;
	          opts = child;
	        }
	
	        return {
	          name: name,
	          opts: opts
	        };
	      }).filter(function (child) {
	        // we have to make sure that child.name isn't in the techOrder since
	        // techs are registerd as Components but can't aren't compatible
	        // See https://github.com/videojs/video.js/issues/2772
	        var c = Component.getComponent(child.opts.componentClass || toTitleCase$1(child.name));
	        return c && !Tech.isTech(c);
	      }).forEach(handleAdd);
	    }
	  }
	  /**
	   * Builds the default DOM class name. Should be overriden by sub-components.
	   *
	   * @return {string}
	   *         The DOM class name for this object.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    // Child classes can include a function that does:
	    // return 'CLASS NAME' + this._super();
	    return '';
	  }
	  /**
	   * Bind a listener to the component's ready state.
	   * Different from event listeners in that if the ready event has already happened
	   * it will trigger the function immediately.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	  ;
	
	  _proto.ready = function ready(fn, sync) {
	    if (sync === void 0) {
	      sync = false;
	    }
	
	    if (!fn) {
	      return;
	    }
	
	    if (!this.isReady_) {
	      this.readyQueue_ = this.readyQueue_ || [];
	      this.readyQueue_.push(fn);
	      return;
	    }
	
	    if (sync) {
	      fn.call(this);
	    } else {
	      // Call the function asynchronously by default for consistency
	      this.setTimeout(fn, 1);
	    }
	  }
	  /**
	   * Trigger all the ready listeners for this `Component`.
	   *
	   * @fires Component#ready
	   */
	  ;
	
	  _proto.triggerReady = function triggerReady() {
	    this.isReady_ = true; // Ensure ready is triggered asynchronously
	
	    this.setTimeout(function () {
	      var readyQueue = this.readyQueue_; // Reset Ready Queue
	
	      this.readyQueue_ = [];
	
	      if (readyQueue && readyQueue.length > 0) {
	        readyQueue.forEach(function (fn) {
	          fn.call(this);
	        }, this);
	      } // Allow for using event listeners also
	
	      /**
	       * Triggered when a `Component` is ready.
	       *
	       * @event Component#ready
	       * @type {EventTarget~Event}
	       */
	
	
	      this.trigger('ready');
	    }, 1);
	  }
	  /**
	   * Find a single DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelector`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {Element|null}
	   *         the dom element that was found, or null
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	  ;
	
	  _proto.$ = function $$1(selector, context) {
	    return $(selector, context || this.contentEl());
	  }
	  /**
	   * Finds all DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelectorAll`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {NodeList}
	   *         a list of dom elements that were found
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	  ;
	
	  _proto.$$ = function $$$1(selector, context) {
	    return $$(selector, context || this.contentEl());
	  }
	  /**
	   * Check if a component's element has a CSS class name.
	   *
	   * @param {string} classToCheck
	   *        CSS class name to check.
	   *
	   * @return {boolean}
	   *         - True if the `Component` has the class.
	   *         - False if the `Component` does not have the class`
	   */
	  ;
	
	  _proto.hasClass = function hasClass$1(classToCheck) {
	    return hasClass(this.el_, classToCheck);
	  }
	  /**
	   * Add a CSS class name to the `Component`s element.
	   *
	   * @param {string} classToAdd
	   *        CSS class name to add
	   */
	  ;
	
	  _proto.addClass = function addClass$1(classToAdd) {
	    addClass(this.el_, classToAdd);
	  }
	  /**
	   * Remove a CSS class name from the `Component`s element.
	   *
	   * @param {string} classToRemove
	   *        CSS class name to remove
	   */
	  ;
	
	  _proto.removeClass = function removeClass$1(classToRemove) {
	    removeClass(this.el_, classToRemove);
	  }
	  /**
	   * Add or remove a CSS class name from the component's element.
	   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
	   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
	   *
	   * @param  {string} classToToggle
	   *         The class to add or remove based on (@link Component#hasClass}
	   *
	   * @param  {boolean|Dom~predicate} [predicate]
	   *         An {@link Dom~predicate} function or a boolean
	   */
	  ;
	
	  _proto.toggleClass = function toggleClass$1(classToToggle, predicate) {
	    toggleClass(this.el_, classToToggle, predicate);
	  }
	  /**
	   * Show the `Component`s element if it is hidden by removing the
	   * 'vjs-hidden' class name from it.
	   */
	  ;
	
	  _proto.show = function show() {
	    this.removeClass('vjs-hidden');
	  }
	  /**
	   * Hide the `Component`s element if it is currently showing by adding the
	   * 'vjs-hidden` class name to it.
	   */
	  ;
	
	  _proto.hide = function hide() {
	    this.addClass('vjs-hidden');
	  }
	  /**
	   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
	   * class name to it. Used during fadeIn/fadeOut.
	   *
	   * @private
	   */
	  ;
	
	  _proto.lockShowing = function lockShowing() {
	    this.addClass('vjs-lock-showing');
	  }
	  /**
	   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
	   * class name from it. Used during fadeIn/fadeOut.
	   *
	   * @private
	   */
	  ;
	
	  _proto.unlockShowing = function unlockShowing() {
	    this.removeClass('vjs-lock-showing');
	  }
	  /**
	   * Get the value of an attribute on the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to get the value from.
	   *
	   * @return {string|null}
	   *         - The value of the attribute that was asked for.
	   *         - Can be an empty string on some browsers if the attribute does not exist
	   *           or has no value
	   *         - Most browsers will return null if the attibute does not exist or has
	   *           no value.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
	   */
	  ;
	
	  _proto.getAttribute = function getAttribute$1(attribute) {
	    return getAttribute(this.el_, attribute);
	  }
	  /**
	   * Set the value of an attribute on the `Component`'s element
	   *
	   * @param {string} attribute
	   *        Name of the attribute to set.
	   *
	   * @param {string} value
	   *        Value to set the attribute to.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
	   */
	  ;
	
	  _proto.setAttribute = function setAttribute$1(attribute, value) {
	    setAttribute(this.el_, attribute, value);
	  }
	  /**
	   * Remove an attribute from the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to remove.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
	   */
	  ;
	
	  _proto.removeAttribute = function removeAttribute$1(attribute) {
	    removeAttribute(this.el_, attribute);
	  }
	  /**
	   * Get or set the width of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The width that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the componentresize event trigger
	   *
	   * @return {number|string}
	   *         The width when getting, zero if there is no width. Can be a string
	   *           postpixed with '%' or 'px'.
	   */
	  ;
	
	  _proto.width = function width(num, skipListeners) {
	    return this.dimension('width', num, skipListeners);
	  }
	  /**
	   * Get or set the height of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The height that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the componentresize event trigger
	   *
	   * @return {number|string}
	   *         The width when getting, zero if there is no width. Can be a string
	   *         postpixed with '%' or 'px'.
	   */
	  ;
	
	  _proto.height = function height(num, skipListeners) {
	    return this.dimension('height', num, skipListeners);
	  }
	  /**
	   * Set both the width and height of the `Component` element at the same time.
	   *
	   * @param  {number|string} width
	   *         Width to set the `Component`s element to.
	   *
	   * @param  {number|string} height
	   *         Height to set the `Component`s element to.
	   */
	  ;
	
	  _proto.dimensions = function dimensions(width, height) {
	    // Skip componentresize listeners on width for optimization
	    this.width(width, true);
	    this.height(height);
	  }
	  /**
	   * Get or set width or height of the `Component` element. This is the shared code
	   * for the {@link Component#width} and {@link Component#height}.
	   *
	   * Things to know:
	   * - If the width or height in an number this will return the number postfixed with 'px'.
	   * - If the width/height is a percent this will return the percent postfixed with '%'
	   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
	   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
	   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
	   *   for more information
	   * - If you want the computed style of the component, use {@link Component#currentWidth}
	   *   and {@link {Component#currentHeight}
	   *
	   * @fires Component#componentresize
	   *
	   * @param {string} widthOrHeight
	   8        'width' or 'height'
	   *
	   * @param  {number|string} [num]
	   8         New dimension
	   *
	   * @param  {boolean} [skipListeners]
	   *         Skip componentresize event trigger
	   *
	   * @return {number}
	   *         The dimension when getting or 0 if unset
	   */
	  ;
	
	  _proto.dimension = function dimension(widthOrHeight, num, skipListeners) {
	    if (num !== undefined) {
	      // Set to zero if null or literally NaN (NaN !== NaN)
	      if (num === null || num !== num) {
	        num = 0;
	      } // Check if using css width/height (% or px) and adjust
	
	
	      if (('' + num).indexOf('%') !== -1 || ('' + num).indexOf('px') !== -1) {
	        this.el_.style[widthOrHeight] = num;
	      } else if (num === 'auto') {
	        this.el_.style[widthOrHeight] = '';
	      } else {
	        this.el_.style[widthOrHeight] = num + 'px';
	      } // skipListeners allows us to avoid triggering the resize event when setting both width and height
	
	
	      if (!skipListeners) {
	        /**
	         * Triggered when a component is resized.
	         *
	         * @event Component#componentresize
	         * @type {EventTarget~Event}
	         */
	        this.trigger('componentresize');
	      }
	
	      return;
	    } // Not setting a value, so getting it
	    // Make sure element exists
	
	
	    if (!this.el_) {
	      return 0;
	    } // Get dimension value from style
	
	
	    var val = this.el_.style[widthOrHeight];
	    var pxIndex = val.indexOf('px');
	
	    if (pxIndex !== -1) {
	      // Return the pixel value with no 'px'
	      return parseInt(val.slice(0, pxIndex), 10);
	    } // No px so using % or no style was set, so falling back to offsetWidth/height
	    // If component has display:none, offset will return 0
	    // TODO: handle display:none and no dimension style using px
	
	
	    return parseInt(this.el_['offset' + toTitleCase$1(widthOrHeight)], 10);
	  }
	  /**
	   * Get the computed width or the height of the component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @param {string} widthOrHeight
	   *        A string containing 'width' or 'height'. Whichever one you want to get.
	   *
	   * @return {number}
	   *         The dimension that gets asked for or 0 if nothing was set
	   *         for that dimension.
	   */
	  ;
	
	  _proto.currentDimension = function currentDimension(widthOrHeight) {
	    var computedWidthOrHeight = 0;
	
	    if (widthOrHeight !== 'width' && widthOrHeight !== 'height') {
	      throw new Error('currentDimension only accepts width or height value');
	    }
	
	    computedWidthOrHeight = computedStyle(this.el_, widthOrHeight); // remove 'px' from variable and parse as integer
	
	    computedWidthOrHeight = parseFloat(computedWidthOrHeight); // if the computed value is still 0, it's possible that the browser is lying
	    // and we want to check the offset values.
	    // This code also runs wherever getComputedStyle doesn't exist.
	
	    if (computedWidthOrHeight === 0 || isNaN(computedWidthOrHeight)) {
	      var rule = "offset" + toTitleCase$1(widthOrHeight);
	      computedWidthOrHeight = this.el_[rule];
	    }
	
	    return computedWidthOrHeight;
	  }
	  /**
	   * An object that contains width and height values of the `Component`s
	   * computed style. Uses `window.getComputedStyle`.
	   *
	   * @typedef {Object} Component~DimensionObject
	   *
	   * @property {number} width
	   *           The width of the `Component`s computed style.
	   *
	   * @property {number} height
	   *           The height of the `Component`s computed style.
	   */
	
	  /**
	   * Get an object that contains computed width and height values of the
	   * component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @return {Component~DimensionObject}
	   *         The computed dimensions of the component's element.
	   */
	  ;
	
	  _proto.currentDimensions = function currentDimensions() {
	    return {
	      width: this.currentDimension('width'),
	      height: this.currentDimension('height')
	    };
	  }
	  /**
	   * Get the computed width of the component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @return {number}
	   *         The computed width of the component's element.
	   */
	  ;
	
	  _proto.currentWidth = function currentWidth() {
	    return this.currentDimension('width');
	  }
	  /**
	   * Get the computed height of the component's element.
	   *
	   * Uses `window.getComputedStyle`.
	   *
	   * @return {number}
	   *         The computed height of the component's element.
	   */
	  ;
	
	  _proto.currentHeight = function currentHeight() {
	    return this.currentDimension('height');
	  }
	  /**
	   * Set the focus to this component
	   */
	  ;
	
	  _proto.focus = function focus() {
	    this.el_.focus();
	  }
	  /**
	   * Remove the focus from this component
	   */
	  ;
	
	  _proto.blur = function blur() {
	    this.el_.blur();
	  }
	  /**
	   * When this Component receives a `keydown` event which it does not process,
	   *  it passes the event to the Player for handling.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (this.player_) {
	      // We only stop propagation here because we want unhandled events to fall
	      // back to the browser. Exclude Tab for focus trapping.
	      if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	        event.stopPropagation();
	      }
	
	      this.player_.handleKeyDown(event);
	    }
	  }
	  /**
	   * Many components used to have a `handleKeyPress` method, which was poorly
	   * named because it listened to a `keydown` event. This method name now
	   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
	   * will not see their method calls stop working.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleKeyPress = function handleKeyPress(event) {
	    this.handleKeyDown(event);
	  }
	  /**
	   * Emit a 'tap' events when touch event support gets detected. This gets used to
	   * support toggling the controls through a tap on the video. They get enabled
	   * because every sub-component would have extra overhead otherwise.
	   *
	   * @private
	   * @fires Component#tap
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchleave
	   * @listens Component#touchcancel
	   * @listens Component#touchend
	    */
	  ;
	
	  _proto.emitTapEvents = function emitTapEvents() {
	    // Track the start time so we can determine how long the touch lasted
	    var touchStart = 0;
	    var firstTouch = null; // Maximum movement allowed during a touch event to still be considered a tap
	    // Other popular libs use anywhere from 2 (hammer.js) to 15,
	    // so 10 seems like a nice, round number.
	
	    var tapMovementThreshold = 10; // The maximum length a touch can be while still being considered a tap
	
	    var touchTimeThreshold = 200;
	    var couldBeTap;
	    this.on('touchstart', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length === 1) {
	        // Copy pageX/pageY from the object
	        firstTouch = {
	          pageX: event.touches[0].pageX,
	          pageY: event.touches[0].pageY
	        }; // Record start time so we can detect a tap vs. "touch and hold"
	
	        touchStart = window__default['default'].performance.now(); // Reset couldBeTap tracking
	
	        couldBeTap = true;
	      }
	    });
	    this.on('touchmove', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length > 1) {
	        couldBeTap = false;
	      } else if (firstTouch) {
	        // Some devices will throw touchmoves for all but the slightest of taps.
	        // So, if we moved only a small distance, this could still be a tap
	        var xdiff = event.touches[0].pageX - firstTouch.pageX;
	        var ydiff = event.touches[0].pageY - firstTouch.pageY;
	        var touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
	
	        if (touchDistance > tapMovementThreshold) {
	          couldBeTap = false;
	        }
	      }
	    });
	
	    var noTap = function noTap() {
	      couldBeTap = false;
	    }; // TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
	
	
	    this.on('touchleave', noTap);
	    this.on('touchcancel', noTap); // When the touch ends, measure how long it took and trigger the appropriate
	    // event
	
	    this.on('touchend', function (event) {
	      firstTouch = null; // Proceed only if the touchmove/leave/cancel event didn't happen
	
	      if (couldBeTap === true) {
	        // Measure how long the touch lasted
	        var touchTime = window__default['default'].performance.now() - touchStart; // Make sure the touch was less than the threshold to be considered a tap
	
	        if (touchTime < touchTimeThreshold) {
	          // Don't let browser turn this into a click
	          event.preventDefault();
	          /**
	           * Triggered when a `Component` is tapped.
	           *
	           * @event Component#tap
	           * @type {EventTarget~Event}
	           */
	
	          this.trigger('tap'); // It may be good to copy the touchend event object and change the
	          // type to tap, if the other event properties aren't exact after
	          // Events.fixEvent runs (e.g. event.target)
	        }
	      }
	    });
	  }
	  /**
	   * This function reports user activity whenever touch events happen. This can get
	   * turned off by any sub-components that wants touch events to act another way.
	   *
	   * Report user touch activity when touch events occur. User activity gets used to
	   * determine when controls should show/hide. It is simple when it comes to mouse
	   * events, because any mouse event should show the controls. So we capture mouse
	   * events that bubble up to the player and report activity when that happens.
	   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
	   * controls. So touch events can't help us at the player level either.
	   *
	   * User activity gets checked asynchronously. So what could happen is a tap event
	   * on the video turns the controls off. Then the `touchend` event bubbles up to
	   * the player. Which, if it reported user activity, would turn the controls right
	   * back on. We also don't want to completely block touch events from bubbling up.
	   * Furthermore a `touchmove` event and anything other than a tap, should not turn
	   * controls back on.
	   *
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchend
	   * @listens Component#touchcancel
	   */
	  ;
	
	  _proto.enableTouchActivity = function enableTouchActivity() {
	    // Don't continue if the root player doesn't support reporting user activity
	    if (!this.player() || !this.player().reportUserActivity) {
	      return;
	    } // listener for reporting that the user is active
	
	
	    var report = bind(this.player(), this.player().reportUserActivity);
	    var touchHolding;
	    this.on('touchstart', function () {
	      report(); // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	
	      this.clearInterval(touchHolding); // report at the same interval as activityCheck
	
	      touchHolding = this.setInterval(report, 250);
	    });
	
	    var touchEnd = function touchEnd(event) {
	      report(); // stop the interval that maintains activity if the touch is holding
	
	      this.clearInterval(touchHolding);
	    };
	
	    this.on('touchmove', report);
	    this.on('touchend', touchEnd);
	    this.on('touchcancel', touchEnd);
	  }
	  /**
	   * A callback that has no parameters and is bound into `Component`s context.
	   *
	   * @callback Component~GenericCallback
	   * @this Component
	   */
	
	  /**
	   * Creates a function that runs after an `x` millisecond timeout. This function is a
	   * wrapper around `window.setTimeout`. There are a few reasons to use this one
	   * instead though:
	   * 1. It gets cleared via  {@link Component#clearTimeout} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
	   *
	   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
	   *         will cause its dispose listener not to get cleaned up! Please use
	   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function that will be run after `timeout`.
	   *
	   * @param {number} timeout
	   *        Timeout in milliseconds to delay before executing the specified function.
	   *
	   * @return {number}
	   *         Returns a timeout ID that gets used to identify the timeout. It can also
	   *         get used in {@link Component#clearTimeout} to clear the timeout that
	   *         was set.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
	   */
	  ;
	
	  _proto.setTimeout = function setTimeout(fn, timeout) {
	    var _this3 = this;
	
	    // declare as variables so they are properly available in timeout function
	    // eslint-disable-next-line
	    var timeoutId;
	    fn = bind(this, fn);
	    this.clearTimersOnDispose_();
	    timeoutId = window__default['default'].setTimeout(function () {
	      if (_this3.setTimeoutIds_.has(timeoutId)) {
	        _this3.setTimeoutIds_["delete"](timeoutId);
	      }
	
	      fn();
	    }, timeout);
	    this.setTimeoutIds_.add(timeoutId);
	    return timeoutId;
	  }
	  /**
	   * Clears a timeout that gets created via `window.setTimeout` or
	   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
	   * use this function instead of `window.clearTimout`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} timeoutId
	   *        The id of the timeout to clear. The return value of
	   *        {@link Component#setTimeout} or `window.setTimeout`.
	   *
	   * @return {number}
	   *         Returns the timeout id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
	   */
	  ;
	
	  _proto.clearTimeout = function clearTimeout(timeoutId) {
	    if (this.setTimeoutIds_.has(timeoutId)) {
	      this.setTimeoutIds_["delete"](timeoutId);
	      window__default['default'].clearTimeout(timeoutId);
	    }
	
	    return timeoutId;
	  }
	  /**
	   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
	   * around `window.setInterval`. There are a few reasons to use this one instead though.
	   * 1. It gets cleared via  {@link Component#clearInterval} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will be a {@link Component~GenericCallback}
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function to run every `x` seconds.
	   *
	   * @param {number} interval
	   *        Execute the specified function every `x` milliseconds.
	   *
	   * @return {number}
	   *         Returns an id that can be used to identify the interval. It can also be be used in
	   *         {@link Component#clearInterval} to clear the interval.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
	   */
	  ;
	
	  _proto.setInterval = function setInterval(fn, interval) {
	    fn = bind(this, fn);
	    this.clearTimersOnDispose_();
	    var intervalId = window__default['default'].setInterval(fn, interval);
	    this.setIntervalIds_.add(intervalId);
	    return intervalId;
	  }
	  /**
	   * Clears an interval that gets created via `window.setInterval` or
	   * {@link Component#setInterval}. If you set an inteval via {@link Component#setInterval}
	   * use this function instead of `window.clearInterval`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} intervalId
	   *        The id of the interval to clear. The return value of
	   *        {@link Component#setInterval} or `window.setInterval`.
	   *
	   * @return {number}
	   *         Returns the interval id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
	   */
	  ;
	
	  _proto.clearInterval = function clearInterval(intervalId) {
	    if (this.setIntervalIds_.has(intervalId)) {
	      this.setIntervalIds_["delete"](intervalId);
	      window__default['default'].clearInterval(intervalId);
	    }
	
	    return intervalId;
	  }
	  /**
	   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
	   * with a few extra bonuses:
	   *
	   * - Supports browsers that do not support rAF by falling back to
	   *   {@link Component#setTimeout}.
	   *
	   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
	   *   bound to the component).
	   *
	   * - Automatic cancellation of the rAF callback is handled if the component
	   *   is disposed before it is called.
	   *
	   * @param  {Component~GenericCallback} fn
	   *         A function that will be bound to this component and executed just
	   *         before the browser's next repaint.
	   *
	   * @return {number}
	   *         Returns an rAF ID that gets used to identify the timeout. It can
	   *         also be used in {@link Component#cancelAnimationFrame} to cancel
	   *         the animation frame callback.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
	   */
	  ;
	
	  _proto.requestAnimationFrame = function requestAnimationFrame(fn) {
	    var _this4 = this;
	
	    // Fall back to using a timer.
	    if (!this.supportsRaf_) {
	      return this.setTimeout(fn, 1000 / 60);
	    }
	
	    this.clearTimersOnDispose_(); // declare as variables so they are properly available in rAF function
	    // eslint-disable-next-line
	
	    var id;
	    fn = bind(this, fn);
	    id = window__default['default'].requestAnimationFrame(function () {
	      if (_this4.rafIds_.has(id)) {
	        _this4.rafIds_["delete"](id);
	      }
	
	      fn();
	    });
	    this.rafIds_.add(id);
	    return id;
	  }
	  /**
	   * Request an animation frame, but only one named animation
	   * frame will be queued. Another will never be added until
	   * the previous one finishes.
	   *
	   * @param {string} name
	   *        The name to give this requestAnimationFrame
	   *
	   * @param  {Component~GenericCallback} fn
	   *         A function that will be bound to this component and executed just
	   *         before the browser's next repaint.
	   */
	  ;
	
	  _proto.requestNamedAnimationFrame = function requestNamedAnimationFrame(name, fn) {
	    var _this5 = this;
	
	    if (this.namedRafs_.has(name)) {
	      return;
	    }
	
	    this.clearTimersOnDispose_();
	    fn = bind(this, fn);
	    var id = this.requestAnimationFrame(function () {
	      fn();
	
	      if (_this5.namedRafs_.has(name)) {
	        _this5.namedRafs_["delete"](name);
	      }
	    });
	    this.namedRafs_.set(name, id);
	    return name;
	  }
	  /**
	   * Cancels a current named animation frame if it exists.
	   *
	   * @param {string} name
	   *        The name of the requestAnimationFrame to cancel.
	   */
	  ;
	
	  _proto.cancelNamedAnimationFrame = function cancelNamedAnimationFrame(name) {
	    if (!this.namedRafs_.has(name)) {
	      return;
	    }
	
	    this.cancelAnimationFrame(this.namedRafs_.get(name));
	    this.namedRafs_["delete"](name);
	  }
	  /**
	   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
	   * (rAF).
	   *
	   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
	   * use this function instead of `window.cancelAnimationFrame`. If you don't,
	   * your dispose listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} id
	   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
	   *
	   * @return {number}
	   *         Returns the rAF ID that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
	   */
	  ;
	
	  _proto.cancelAnimationFrame = function cancelAnimationFrame(id) {
	    // Fall back to using a timer.
	    if (!this.supportsRaf_) {
	      return this.clearTimeout(id);
	    }
	
	    if (this.rafIds_.has(id)) {
	      this.rafIds_["delete"](id);
	      window__default['default'].cancelAnimationFrame(id);
	    }
	
	    return id;
	  }
	  /**
	   * A function to setup `requestAnimationFrame`, `setTimeout`,
	   * and `setInterval`, clearing on dispose.
	   *
	   * > Previously each timer added and removed dispose listeners on it's own.
	   * For better performance it was decided to batch them all, and use `Set`s
	   * to track outstanding timer ids.
	   *
	   * @private
	   */
	  ;
	
	  _proto.clearTimersOnDispose_ = function clearTimersOnDispose_() {
	    var _this6 = this;
	
	    if (this.clearingTimersOnDispose_) {
	      return;
	    }
	
	    this.clearingTimersOnDispose_ = true;
	    this.one('dispose', function () {
	      [['namedRafs_', 'cancelNamedAnimationFrame'], ['rafIds_', 'cancelAnimationFrame'], ['setTimeoutIds_', 'clearTimeout'], ['setIntervalIds_', 'clearInterval']].forEach(function (_ref) {
	        var idName = _ref[0],
	            cancelName = _ref[1];
	
	        // for a `Set` key will actually be the value again
	        // so forEach((val, val) =>` but for maps we want to use
	        // the key.
	        _this6[idName].forEach(function (val, key) {
	          return _this6[cancelName](key);
	        });
	      });
	      _this6.clearingTimersOnDispose_ = false;
	    });
	  }
	  /**
	   * Register a `Component` with `videojs` given the name and the component.
	   *
	   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
	   *         should be registered using {@link Tech.registerTech} or
	   *         {@link videojs:videojs.registerTech}.
	   *
	   * > NOTE: This function can also be seen on videojs as
	   *         {@link videojs:videojs.registerComponent}.
	   *
	   * @param {string} name
	   *        The name of the `Component` to register.
	   *
	   * @param {Component} ComponentToRegister
	   *        The `Component` class to register.
	   *
	   * @return {Component}
	   *         The `Component` that was registered.
	   */
	  ;
	
	  Component.registerComponent = function registerComponent(name, ComponentToRegister) {
	    if (typeof name !== 'string' || !name) {
	      throw new Error("Illegal component name, \"" + name + "\"; must be a non-empty string.");
	    }
	
	    var Tech = Component.getComponent('Tech'); // We need to make sure this check is only done if Tech has been registered.
	
	    var isTech = Tech && Tech.isTech(ComponentToRegister);
	    var isComp = Component === ComponentToRegister || Component.prototype.isPrototypeOf(ComponentToRegister.prototype);
	
	    if (isTech || !isComp) {
	      var reason;
	
	      if (isTech) {
	        reason = 'techs must be registered using Tech.registerTech()';
	      } else {
	        reason = 'must be a Component subclass';
	      }
	
	      throw new Error("Illegal component, \"" + name + "\"; " + reason + ".");
	    }
	
	    name = toTitleCase$1(name);
	
	    if (!Component.components_) {
	      Component.components_ = {};
	    }
	
	    var Player = Component.getComponent('Player');
	
	    if (name === 'Player' && Player && Player.players) {
	      var players = Player.players;
	      var playerNames = Object.keys(players); // If we have players that were disposed, then their name will still be
	      // in Players.players. So, we must loop through and verify that the value
	      // for each item is not null. This allows registration of the Player component
	      // after all players have been disposed or before any were created.
	
	      if (players && playerNames.length > 0 && playerNames.map(function (pname) {
	        return players[pname];
	      }).every(Boolean)) {
	        throw new Error('Can not register Player component after player has been created.');
	      }
	    }
	
	    Component.components_[name] = ComponentToRegister;
	    Component.components_[toLowerCase(name)] = ComponentToRegister;
	    return ComponentToRegister;
	  }
	  /**
	   * Get a `Component` based on the name it was registered with.
	   *
	   * @param {string} name
	   *        The Name of the component to get.
	   *
	   * @return {Component}
	   *         The `Component` that got registered under the given name.
	   */
	  ;
	
	  Component.getComponent = function getComponent(name) {
	    if (!name || !Component.components_) {
	      return;
	    }
	
	    return Component.components_[name];
	  };
	
	  return Component;
	}();
	/**
	 * Whether or not this component supports `requestAnimationFrame`.
	 *
	 * This is exposed primarily for testing purposes.
	 *
	 * @private
	 * @type {Boolean}
	 */
	
	
	Component$1.prototype.supportsRaf_ = typeof window__default['default'].requestAnimationFrame === 'function' && typeof window__default['default'].cancelAnimationFrame === 'function';
	Component$1.registerComponent('Component', Component$1);
	
	/**
	 * @file time-ranges.js
	 * @module time-ranges
	 */
	/**
	 * Returns the time for the specified index at the start or end
	 * of a TimeRange object.
	 *
	 * @typedef    {Function} TimeRangeIndex
	 *
	 * @param      {number} [index=0]
	 *             The range number to return the time for.
	 *
	 * @return     {number}
	 *             The time offset at the specified index.
	 *
	 * @deprecated The index argument must be provided.
	 *             In the future, leaving it out will throw an error.
	 */
	
	/**
	 * An object that contains ranges of time.
	 *
	 * @typedef  {Object} TimeRange
	 *
	 * @property {number} length
	 *           The number of time ranges represented by this object.
	 *
	 * @property {module:time-ranges~TimeRangeIndex} start
	 *           Returns the time offset at which a specified time range begins.
	 *
	 * @property {module:time-ranges~TimeRangeIndex} end
	 *           Returns the time offset at which a specified time range ends.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
	 */
	
	/**
	 * Check if any of the time ranges are over the maximum index.
	 *
	 * @private
	 * @param   {string} fnName
	 *          The function name to use for logging
	 *
	 * @param   {number} index
	 *          The index to check
	 *
	 * @param   {number} maxIndex
	 *          The maximum possible index
	 *
	 * @throws  {Error} if the timeRanges provided are over the maxIndex
	 */
	
	function rangeCheck(fnName, index, maxIndex) {
	  if (typeof index !== 'number' || index < 0 || index > maxIndex) {
	    throw new Error("Failed to execute '" + fnName + "' on 'TimeRanges': The index provided (" + index + ") is non-numeric or out of bounds (0-" + maxIndex + ").");
	  }
	}
	/**
	 * Get the time for the specified index at the start or end
	 * of a TimeRange object.
	 *
	 * @private
	 * @param      {string} fnName
	 *             The function name to use for logging
	 *
	 * @param      {string} valueIndex
	 *             The property that should be used to get the time. should be
	 *             'start' or 'end'
	 *
	 * @param      {Array} ranges
	 *             An array of time ranges
	 *
	 * @param      {Array} [rangeIndex=0]
	 *             The index to start the search at
	 *
	 * @return     {number}
	 *             The time that offset at the specified index.
	 *
	 * @deprecated rangeIndex must be set to a value, in the future this will throw an error.
	 * @throws     {Error} if rangeIndex is more than the length of ranges
	 */
	
	
	function getRange(fnName, valueIndex, ranges, rangeIndex) {
	  rangeCheck(fnName, rangeIndex, ranges.length - 1);
	  return ranges[rangeIndex][valueIndex];
	}
	/**
	 * Create a time range object given ranges of time.
	 *
	 * @private
	 * @param   {Array} [ranges]
	 *          An array of time ranges.
	 */
	
	
	function createTimeRangesObj(ranges) {
	  var timeRangesObj;
	
	  if (ranges === undefined || ranges.length === 0) {
	    timeRangesObj = {
	      length: 0,
	      start: function start() {
	        throw new Error('This TimeRanges object is empty');
	      },
	      end: function end() {
	        throw new Error('This TimeRanges object is empty');
	      }
	    };
	  } else {
	    timeRangesObj = {
	      length: ranges.length,
	      start: getRange.bind(null, 'start', 0, ranges),
	      end: getRange.bind(null, 'end', 1, ranges)
	    };
	  }
	
	  if (window__default['default'].Symbol && window__default['default'].Symbol.iterator) {
	    timeRangesObj[window__default['default'].Symbol.iterator] = function () {
	      return (ranges || []).values();
	    };
	  }
	
	  return timeRangesObj;
	}
	/**
	 * Create a `TimeRange` object which mimics an
	 * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|HTML5 TimeRanges instance}.
	 *
	 * @param {number|Array[]} start
	 *        The start of a single range (a number) or an array of ranges (an
	 *        array of arrays of two numbers each).
	 *
	 * @param {number} end
	 *        The end of a single range. Cannot be used with the array form of
	 *        the `start` argument.
	 */
	
	
	function createTimeRanges(start, end) {
	  if (Array.isArray(start)) {
	    return createTimeRangesObj(start);
	  } else if (start === undefined || end === undefined) {
	    return createTimeRangesObj();
	  }
	
	  return createTimeRangesObj([[start, end]]);
	}
	
	/**
	 * @file buffer.js
	 * @module buffer
	 */
	/**
	 * Compute the percentage of the media that has been buffered.
	 *
	 * @param {TimeRange} buffered
	 *        The current `TimeRange` object representing buffered time ranges
	 *
	 * @param {number} duration
	 *        Total duration of the media
	 *
	 * @return {number}
	 *         Percent buffered of the total duration in decimal form.
	 */
	
	function bufferedPercent(buffered, duration) {
	  var bufferedDuration = 0;
	  var start;
	  var end;
	
	  if (!duration) {
	    return 0;
	  }
	
	  if (!buffered || !buffered.length) {
	    buffered = createTimeRanges(0, 0);
	  }
	
	  for (var i = 0; i < buffered.length; i++) {
	    start = buffered.start(i);
	    end = buffered.end(i); // buffered end can be bigger than duration by a very small fraction
	
	    if (end > duration) {
	      end = duration;
	    }
	
	    bufferedDuration += end - start;
	  }
	
	  return bufferedDuration / duration;
	}
	
	/**
	 * @file media-error.js
	 */
	/**
	 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
	 *
	 * @param {number|string|Object|MediaError} value
	 *        This can be of multiple types:
	 *        - number: should be a standard error code
	 *        - string: an error message (the code will be 0)
	 *        - Object: arbitrary properties
	 *        - `MediaError` (native): used to populate a video.js `MediaError` object
	 *        - `MediaError` (video.js): will return itself if it's already a
	 *          video.js `MediaError` object.
	 *
	 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
	 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
	 *
	 * @class MediaError
	 */
	
	function MediaError(value) {
	  // Allow redundant calls to this constructor to avoid having `instanceof`
	  // checks peppered around the code.
	  if (value instanceof MediaError) {
	    return value;
	  }
	
	  if (typeof value === 'number') {
	    this.code = value;
	  } else if (typeof value === 'string') {
	    // default code is zero, so this is a custom error
	    this.message = value;
	  } else if (isObject(value)) {
	    // We assign the `code` property manually because native `MediaError` objects
	    // do not expose it as an own/enumerable property of the object.
	    if (typeof value.code === 'number') {
	      this.code = value.code;
	    }
	
	    assign(this, value);
	  }
	
	  if (!this.message) {
	    this.message = MediaError.defaultMessages[this.code] || '';
	  }
	}
	/**
	 * The error code that refers two one of the defined `MediaError` types
	 *
	 * @type {Number}
	 */
	
	
	MediaError.prototype.code = 0;
	/**
	 * An optional message that to show with the error. Message is not part of the HTML5
	 * video spec but allows for more informative custom errors.
	 *
	 * @type {String}
	 */
	
	MediaError.prototype.message = '';
	/**
	 * An optional status code that can be set by plugins to allow even more detail about
	 * the error. For example a plugin might provide a specific HTTP status code and an
	 * error message for that code. Then when the plugin gets that error this class will
	 * know how to display an error message for it. This allows a custom message to show
	 * up on the `Player` error overlay.
	 *
	 * @type {Array}
	 */
	
	MediaError.prototype.status = null;
	/**
	 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
	 * specification listed under {@link MediaError} for more information.
	 *
	 * @enum {array}
	 * @readonly
	 * @property {string} 0 - MEDIA_ERR_CUSTOM
	 * @property {string} 1 - MEDIA_ERR_ABORTED
	 * @property {string} 2 - MEDIA_ERR_NETWORK
	 * @property {string} 3 - MEDIA_ERR_DECODE
	 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
	 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
	 */
	
	MediaError.errorTypes = ['MEDIA_ERR_CUSTOM', 'MEDIA_ERR_ABORTED', 'MEDIA_ERR_NETWORK', 'MEDIA_ERR_DECODE', 'MEDIA_ERR_SRC_NOT_SUPPORTED', 'MEDIA_ERR_ENCRYPTED'];
	/**
	 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
	 *
	 * @type {Array}
	 * @constant
	 */
	
	MediaError.defaultMessages = {
	  1: 'You aborted the media playback',
	  2: 'A network error caused the media download to fail part-way.',
	  3: 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',
	  4: 'The media could not be loaded, either because the server or network failed or because the format is not supported.',
	  5: 'The media is encrypted and we do not have the keys to decrypt it.'
	}; // Add types as properties on MediaError
	// e.g. MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
	
	for (var errNum = 0; errNum < MediaError.errorTypes.length; errNum++) {
	  MediaError[MediaError.errorTypes[errNum]] = errNum; // values should be accessible on both the class and instance
	
	  MediaError.prototype[MediaError.errorTypes[errNum]] = errNum;
	} // jsdocs for instance/static members added above
	
	/**
	 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
	 *
	 * @param  {Object}  value
	 *         An object that may or may not be `Promise`-like.
	 *
	 * @return {boolean}
	 *         Whether or not the object is `Promise`-like.
	 */
	function isPromise(value) {
	  return value !== undefined && value !== null && typeof value.then === 'function';
	}
	/**
	 * Silence a Promise-like object.
	 *
	 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
	 * play promise" rejection error messages.
	 *
	 * @param  {Object} value
	 *         An object that may or may not be `Promise`-like.
	 */
	
	function silencePromise(value) {
	  if (isPromise(value)) {
	    value.then(null, function (e) {});
	  }
	}
	
	/**
	 * @file text-track-list-converter.js Utilities for capturing text track state and
	 * re-creating tracks based on a capture.
	 *
	 * @module text-track-list-converter
	 */
	
	/**
	 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
	 * represents the {@link TextTrack}'s state.
	 *
	 * @param {TextTrack} track
	 *        The text track to query.
	 *
	 * @return {Object}
	 *         A serializable javascript representation of the TextTrack.
	 * @private
	 */
	var trackToJson_ = function trackToJson_(track) {
	  var ret = ['kind', 'label', 'language', 'id', 'inBandMetadataTrackDispatchType', 'mode', 'src'].reduce(function (acc, prop, i) {
	    if (track[prop]) {
	      acc[prop] = track[prop];
	    }
	
	    return acc;
	  }, {
	    cues: track.cues && Array.prototype.map.call(track.cues, function (cue) {
	      return {
	        startTime: cue.startTime,
	        endTime: cue.endTime,
	        text: cue.text,
	        id: cue.id
	      };
	    })
	  });
	  return ret;
	};
	/**
	 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
	 * state of all {@link TextTrack}s currently configured. The return array is compatible with
	 * {@link text-track-list-converter:jsonToTextTracks}.
	 *
	 * @param {Tech} tech
	 *        The tech object to query
	 *
	 * @return {Array}
	 *         A serializable javascript representation of the {@link Tech}s
	 *         {@link TextTrackList}.
	 */
	
	
	var textTracksToJson = function textTracksToJson(tech) {
	  var trackEls = tech.$$('track');
	  var trackObjs = Array.prototype.map.call(trackEls, function (t) {
	    return t.track;
	  });
	  var tracks = Array.prototype.map.call(trackEls, function (trackEl) {
	    var json = trackToJson_(trackEl.track);
	
	    if (trackEl.src) {
	      json.src = trackEl.src;
	    }
	
	    return json;
	  });
	  return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function (track) {
	    return trackObjs.indexOf(track) === -1;
	  }).map(trackToJson_));
	};
	/**
	 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
	 * object {@link TextTrack} representations.
	 *
	 * @param {Array} json
	 *        An array of `TextTrack` representation objects, like those that would be
	 *        produced by `textTracksToJson`.
	 *
	 * @param {Tech} tech
	 *        The `Tech` to create the `TextTrack`s on.
	 */
	
	
	var jsonToTextTracks = function jsonToTextTracks(json, tech) {
	  json.forEach(function (track) {
	    var addedTrack = tech.addRemoteTextTrack(track).track;
	
	    if (!track.src && track.cues) {
	      track.cues.forEach(function (cue) {
	        return addedTrack.addCue(cue);
	      });
	    }
	  });
	  return tech.textTracks();
	};
	
	var textTrackConverter = {
	  textTracksToJson: textTracksToJson,
	  jsonToTextTracks: jsonToTextTracks,
	  trackToJson_: trackToJson_
	};
	
	var MODAL_CLASS_NAME = 'vjs-modal-dialog';
	/**
	 * The `ModalDialog` displays over the video and its controls, which blocks
	 * interaction with the player until it is closed.
	 *
	 * Modal dialogs include a "Close" button and will close when that button
	 * is activated - or when ESC is pressed anywhere.
	 *
	 * @extends Component
	 */
	
	var ModalDialog = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ModalDialog, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Mixed} [options.content=undefined]
	   *        Provide customized content for this modal.
	   *
	   * @param {string} [options.description]
	   *        A text description for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.fillAlways=false]
	   *        Normally, modals are automatically filled only the first time
	   *        they open. This tells the modal to refresh its content
	   *        every time it opens.
	   *
	   * @param {string} [options.label]
	   *        A text label for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.pauseOnOpen=true]
	   *        If `true`, playback will will be paused if playing when
	   *        the modal opens, and resumed when it closes.
	   *
	   * @param {boolean} [options.temporary=true]
	   *        If `true`, the modal can only be opened once; it will be
	   *        disposed as soon as it's closed.
	   *
	   * @param {boolean} [options.uncloseable=false]
	   *        If `true`, the user will not be able to close the modal
	   *        through the UI in the normal ways. Programmatic closing is
	   *        still possible.
	   */
	  function ModalDialog(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.handleKeyDown_ = function (e) {
	      return _this.handleKeyDown(e);
	    };
	
	    _this.close_ = function (e) {
	      return _this.close(e);
	    };
	
	    _this.opened_ = _this.hasBeenOpened_ = _this.hasBeenFilled_ = false;
	
	    _this.closeable(!_this.options_.uncloseable);
	
	    _this.content(_this.options_.content); // Make sure the contentEl is defined AFTER any children are initialized
	    // because we only want the contents of the modal in the contentEl
	    // (not the UI elements like the close button).
	
	
	    _this.contentEl_ = createEl('div', {
	      className: MODAL_CLASS_NAME + "-content"
	    }, {
	      role: 'document'
	    });
	    _this.descEl_ = createEl('p', {
	      className: MODAL_CLASS_NAME + "-description vjs-control-text",
	      id: _this.el().getAttribute('aria-describedby')
	    });
	    textContent(_this.descEl_, _this.description());
	
	    _this.el_.appendChild(_this.descEl_);
	
	    _this.el_.appendChild(_this.contentEl_);
	
	    return _this;
	  }
	  /**
	   * Create the `ModalDialog`'s DOM element
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	
	
	  var _proto = ModalDialog.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass(),
	      tabIndex: -1
	    }, {
	      'aria-describedby': this.id() + "_description",
	      'aria-hidden': 'true',
	      'aria-label': this.label(),
	      'role': 'dialog'
	    });
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.descEl_ = null;
	    this.previouslyActiveEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return MODAL_CLASS_NAME + " vjs-hidden " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Returns the label string for this modal. Primarily used for accessibility.
	   *
	   * @return {string}
	   *         the localized or raw label of this modal.
	   */
	  ;
	
	  _proto.label = function label() {
	    return this.localize(this.options_.label || 'Modal Window');
	  }
	  /**
	   * Returns the description string for this modal. Primarily used for
	   * accessibility.
	   *
	   * @return {string}
	   *         The localized or raw description of this modal.
	   */
	  ;
	
	  _proto.description = function description() {
	    var desc = this.options_.description || this.localize('This is a modal window.'); // Append a universal closeability message if the modal is closeable.
	
	    if (this.closeable()) {
	      desc += ' ' + this.localize('This modal can be closed by pressing the Escape key or activating the close button.');
	    }
	
	    return desc;
	  }
	  /**
	   * Opens the modal.
	   *
	   * @fires ModalDialog#beforemodalopen
	   * @fires ModalDialog#modalopen
	   */
	  ;
	
	  _proto.open = function open() {
	    if (!this.opened_) {
	      var player = this.player();
	      /**
	        * Fired just before a `ModalDialog` is opened.
	        *
	        * @event ModalDialog#beforemodalopen
	        * @type {EventTarget~Event}
	        */
	
	      this.trigger('beforemodalopen');
	      this.opened_ = true; // Fill content if the modal has never opened before and
	      // never been filled.
	
	      if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) {
	        this.fill();
	      } // If the player was playing, pause it and take note of its previously
	      // playing state.
	
	
	      this.wasPlaying_ = !player.paused();
	
	      if (this.options_.pauseOnOpen && this.wasPlaying_) {
	        player.pause();
	      }
	
	      this.on('keydown', this.handleKeyDown_); // Hide controls and note if they were enabled.
	
	      this.hadControls_ = player.controls();
	      player.controls(false);
	      this.show();
	      this.conditionalFocus_();
	      this.el().setAttribute('aria-hidden', 'false');
	      /**
	        * Fired just after a `ModalDialog` is opened.
	        *
	        * @event ModalDialog#modalopen
	        * @type {EventTarget~Event}
	        */
	
	      this.trigger('modalopen');
	      this.hasBeenOpened_ = true;
	    }
	  }
	  /**
	   * If the `ModalDialog` is currently open or closed.
	   *
	   * @param  {boolean} [value]
	   *         If given, it will open (`true`) or close (`false`) the modal.
	   *
	   * @return {boolean}
	   *         the current open state of the modaldialog
	   */
	  ;
	
	  _proto.opened = function opened(value) {
	    if (typeof value === 'boolean') {
	      this[value ? 'open' : 'close']();
	    }
	
	    return this.opened_;
	  }
	  /**
	   * Closes the modal, does nothing if the `ModalDialog` is
	   * not open.
	   *
	   * @fires ModalDialog#beforemodalclose
	   * @fires ModalDialog#modalclose
	   */
	  ;
	
	  _proto.close = function close() {
	    if (!this.opened_) {
	      return;
	    }
	
	    var player = this.player();
	    /**
	      * Fired just before a `ModalDialog` is closed.
	      *
	      * @event ModalDialog#beforemodalclose
	      * @type {EventTarget~Event}
	      */
	
	    this.trigger('beforemodalclose');
	    this.opened_ = false;
	
	    if (this.wasPlaying_ && this.options_.pauseOnOpen) {
	      player.play();
	    }
	
	    this.off('keydown', this.handleKeyDown_);
	
	    if (this.hadControls_) {
	      player.controls(true);
	    }
	
	    this.hide();
	    this.el().setAttribute('aria-hidden', 'true');
	    /**
	      * Fired just after a `ModalDialog` is closed.
	      *
	      * @event ModalDialog#modalclose
	      * @type {EventTarget~Event}
	      */
	
	    this.trigger('modalclose');
	    this.conditionalBlur_();
	
	    if (this.options_.temporary) {
	      this.dispose();
	    }
	  }
	  /**
	   * Check to see if the `ModalDialog` is closeable via the UI.
	   *
	   * @param  {boolean} [value]
	   *         If given as a boolean, it will set the `closeable` option.
	   *
	   * @return {boolean}
	   *         Returns the final value of the closable option.
	   */
	  ;
	
	  _proto.closeable = function closeable(value) {
	    if (typeof value === 'boolean') {
	      var closeable = this.closeable_ = !!value;
	      var close = this.getChild('closeButton'); // If this is being made closeable and has no close button, add one.
	
	      if (closeable && !close) {
	        // The close button should be a child of the modal - not its
	        // content element, so temporarily change the content element.
	        var temp = this.contentEl_;
	        this.contentEl_ = this.el_;
	        close = this.addChild('closeButton', {
	          controlText: 'Close Modal Dialog'
	        });
	        this.contentEl_ = temp;
	        this.on(close, 'close', this.close_);
	      } // If this is being made uncloseable and has a close button, remove it.
	
	
	      if (!closeable && close) {
	        this.off(close, 'close', this.close_);
	        this.removeChild(close);
	        close.dispose();
	      }
	    }
	
	    return this.closeable_;
	  }
	  /**
	   * Fill the modal's content element with the modal's "content" option.
	   * The content element will be emptied before this change takes place.
	   */
	  ;
	
	  _proto.fill = function fill() {
	    this.fillWith(this.content());
	  }
	  /**
	   * Fill the modal's content element with arbitrary content.
	   * The content element will be emptied before this change takes place.
	   *
	   * @fires ModalDialog#beforemodalfill
	   * @fires ModalDialog#modalfill
	   *
	   * @param {Mixed} [content]
	   *        The same rules apply to this as apply to the `content` option.
	   */
	  ;
	
	  _proto.fillWith = function fillWith(content) {
	    var contentEl = this.contentEl();
	    var parentEl = contentEl.parentNode;
	    var nextSiblingEl = contentEl.nextSibling;
	    /**
	      * Fired just before a `ModalDialog` is filled with content.
	      *
	      * @event ModalDialog#beforemodalfill
	      * @type {EventTarget~Event}
	      */
	
	    this.trigger('beforemodalfill');
	    this.hasBeenFilled_ = true; // Detach the content element from the DOM before performing
	    // manipulation to avoid modifying the live DOM multiple times.
	
	    parentEl.removeChild(contentEl);
	    this.empty();
	    insertContent(contentEl, content);
	    /**
	     * Fired just after a `ModalDialog` is filled with content.
	     *
	     * @event ModalDialog#modalfill
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('modalfill'); // Re-inject the re-filled content element.
	
	    if (nextSiblingEl) {
	      parentEl.insertBefore(contentEl, nextSiblingEl);
	    } else {
	      parentEl.appendChild(contentEl);
	    } // make sure that the close button is last in the dialog DOM
	
	
	    var closeButton = this.getChild('closeButton');
	
	    if (closeButton) {
	      parentEl.appendChild(closeButton.el_);
	    }
	  }
	  /**
	   * Empties the content element. This happens anytime the modal is filled.
	   *
	   * @fires ModalDialog#beforemodalempty
	   * @fires ModalDialog#modalempty
	   */
	  ;
	
	  _proto.empty = function empty() {
	    /**
	    * Fired just before a `ModalDialog` is emptied.
	    *
	    * @event ModalDialog#beforemodalempty
	    * @type {EventTarget~Event}
	    */
	    this.trigger('beforemodalempty');
	    emptyEl(this.contentEl());
	    /**
	    * Fired just after a `ModalDialog` is emptied.
	    *
	    * @event ModalDialog#modalempty
	    * @type {EventTarget~Event}
	    */
	
	    this.trigger('modalempty');
	  }
	  /**
	   * Gets or sets the modal content, which gets normalized before being
	   * rendered into the DOM.
	   *
	   * This does not update the DOM or fill the modal, but it is called during
	   * that process.
	   *
	   * @param  {Mixed} [value]
	   *         If defined, sets the internal content value to be used on the
	   *         next call(s) to `fill`. This value is normalized before being
	   *         inserted. To "clear" the internal content value, pass `null`.
	   *
	   * @return {Mixed}
	   *         The current content of the modal dialog
	   */
	  ;
	
	  _proto.content = function content(value) {
	    if (typeof value !== 'undefined') {
	      this.content_ = value;
	    }
	
	    return this.content_;
	  }
	  /**
	   * conditionally focus the modal dialog if focus was previously on the player.
	   *
	   * @private
	   */
	  ;
	
	  _proto.conditionalFocus_ = function conditionalFocus_() {
	    var activeEl = document__default['default'].activeElement;
	    var playerEl = this.player_.el_;
	    this.previouslyActiveEl_ = null;
	
	    if (playerEl.contains(activeEl) || playerEl === activeEl) {
	      this.previouslyActiveEl_ = activeEl;
	      this.focus();
	    }
	  }
	  /**
	   * conditionally blur the element and refocus the last focused element
	   *
	   * @private
	   */
	  ;
	
	  _proto.conditionalBlur_ = function conditionalBlur_() {
	    if (this.previouslyActiveEl_) {
	      this.previouslyActiveEl_.focus();
	      this.previouslyActiveEl_ = null;
	    }
	  }
	  /**
	   * Keydown handler. Attached when modal is focused.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Do not allow keydowns to reach out of the modal dialog.
	    event.stopPropagation();
	
	    if (keycode__default['default'].isEventKey(event, 'Escape') && this.closeable()) {
	      event.preventDefault();
	      this.close();
	      return;
	    } // exit early if it isn't a tab key
	
	
	    if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	      return;
	    }
	
	    var focusableEls = this.focusableEls_();
	    var activeEl = this.el_.querySelector(':focus');
	    var focusIndex;
	
	    for (var i = 0; i < focusableEls.length; i++) {
	      if (activeEl === focusableEls[i]) {
	        focusIndex = i;
	        break;
	      }
	    }
	
	    if (document__default['default'].activeElement === this.el_) {
	      focusIndex = 0;
	    }
	
	    if (event.shiftKey && focusIndex === 0) {
	      focusableEls[focusableEls.length - 1].focus();
	      event.preventDefault();
	    } else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
	      focusableEls[0].focus();
	      event.preventDefault();
	    }
	  }
	  /**
	   * get all focusable elements
	   *
	   * @private
	   */
	  ;
	
	  _proto.focusableEls_ = function focusableEls_() {
	    var allChildren = this.el_.querySelectorAll('*');
	    return Array.prototype.filter.call(allChildren, function (child) {
	      return (child instanceof window__default['default'].HTMLAnchorElement || child instanceof window__default['default'].HTMLAreaElement) && child.hasAttribute('href') || (child instanceof window__default['default'].HTMLInputElement || child instanceof window__default['default'].HTMLSelectElement || child instanceof window__default['default'].HTMLTextAreaElement || child instanceof window__default['default'].HTMLButtonElement) && !child.hasAttribute('disabled') || child instanceof window__default['default'].HTMLIFrameElement || child instanceof window__default['default'].HTMLObjectElement || child instanceof window__default['default'].HTMLEmbedElement || child.hasAttribute('tabindex') && child.getAttribute('tabindex') !== -1 || child.hasAttribute('contenteditable');
	    });
	  };
	
	  return ModalDialog;
	}(Component$1);
	/**
	 * Default options for `ModalDialog` default options.
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ModalDialog.prototype.options_ = {
	  pauseOnOpen: true,
	  temporary: true
	};
	Component$1.registerComponent('ModalDialog', ModalDialog);
	
	/**
	 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
	 * {@link VideoTrackList}
	 *
	 * @extends EventTarget
	 */
	
	var TrackList = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](TrackList, _EventTarget);
	
	  /**
	   * Create an instance of this class
	   *
	   * @param {Track[]} tracks
	   *        A list of tracks to initialize the list with.
	   *
	   * @abstract
	   */
	  function TrackList(tracks) {
	    var _this;
	
	    if (tracks === void 0) {
	      tracks = [];
	    }
	
	    _this = _EventTarget.call(this) || this;
	    _this.tracks_ = [];
	    /**
	     * @memberof TrackList
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     * @instance
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'length', {
	      get: function get() {
	        return this.tracks_.length;
	      }
	    });
	
	    for (var i = 0; i < tracks.length; i++) {
	      _this.addTrack(tracks[i]);
	    }
	
	    return _this;
	  }
	  /**
	   * Add a {@link Track} to the `TrackList`
	   *
	   * @param {Track} track
	   *        The audio, video, or text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  var _proto = TrackList.prototype;
	
	  _proto.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    var index = this.tracks_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get() {
	          return this.tracks_[index];
	        }
	      });
	    } // Do not add duplicate tracks
	
	
	    if (this.tracks_.indexOf(track) === -1) {
	      this.tracks_.push(track);
	      /**
	       * Triggered when a track is added to a track list.
	       *
	       * @event TrackList#addtrack
	       * @type {EventTarget~Event}
	       * @property {Track} track
	       *           A reference to track that was added.
	       */
	
	      this.trigger({
	        track: track,
	        type: 'addtrack',
	        target: this
	      });
	    }
	    /**
	     * Triggered when a track label is changed.
	     *
	     * @event TrackList#addtrack
	     * @type {EventTarget~Event}
	     * @property {Track} track
	     *           A reference to track that was added.
	     */
	
	
	    track.labelchange_ = function () {
	      _this2.trigger({
	        track: track,
	        type: 'labelchange',
	        target: _this2
	      });
	    };
	
	    if (isEvented(track)) {
	      track.addEventListener('labelchange', track.labelchange_);
	    }
	  }
	  /**
	   * Remove a {@link Track} from the `TrackList`
	   *
	   * @param {Track} rtrack
	   *        The audio, video, or text track to remove from the list.
	   *
	   * @fires TrackList#removetrack
	   */
	  ;
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    var track;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      if (this[i] === rtrack) {
	        track = this[i];
	
	        if (track.off) {
	          track.off();
	        }
	
	        this.tracks_.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!track) {
	      return;
	    }
	    /**
	     * Triggered when a track is removed from track list.
	     *
	     * @event TrackList#removetrack
	     * @type {EventTarget~Event}
	     * @property {Track} track
	     *           A reference to track that was removed.
	     */
	
	
	    this.trigger({
	      track: track,
	      type: 'removetrack',
	      target: this
	    });
	  }
	  /**
	   * Get a Track from the TrackList by a tracks id
	   *
	   * @param {string} id - the id of the track to get
	   * @method getTrackById
	   * @return {Track}
	   * @private
	   */
	  ;
	
	  _proto.getTrackById = function getTrackById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var track = this[i];
	
	      if (track.id === id) {
	        result = track;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TrackList;
	}(EventTarget$2);
	/**
	 * Triggered when a different track is selected/enabled.
	 *
	 * @event TrackList#change
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Events that can be called with on + eventName. See {@link EventHandler}.
	 *
	 * @property {Object} TrackList#allowedEvents_
	 * @private
	 */
	
	
	TrackList.prototype.allowedEvents_ = {
	  change: 'change',
	  addtrack: 'addtrack',
	  removetrack: 'removetrack',
	  labelchange: 'labelchange'
	}; // emulate attribute EventHandler support to allow for feature detection
	
	for (var event in TrackList.prototype.allowedEvents_) {
	  TrackList.prototype['on' + event] = null;
	}
	
	/**
	 * Anywhere we call this function we diverge from the spec
	 * as we only support one enabled audiotrack at a time
	 *
	 * @param {AudioTrackList} list
	 *        list to work on
	 *
	 * @param {AudioTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	
	var disableOthers$1 = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (!Object.keys(list[i]).length || track.id === list[i].id) {
	      continue;
	    } // another audio track is enabled, disable it
	
	
	    list[i].enabled = false;
	  }
	};
	/**
	 * The current list of {@link AudioTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
	 * @extends TrackList
	 */
	
	
	var AudioTrackList = /*#__PURE__*/function (_TrackList) {
	  _inheritsLoose__default['default'](AudioTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {AudioTrack[]} [tracks=[]]
	   *        A list of `AudioTrack` to instantiate the list with.
	   */
	  function AudioTrackList(tracks) {
	    var _this;
	
	    if (tracks === void 0) {
	      tracks = [];
	    }
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].enabled) {
	        disableOthers$1(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    _this = _TrackList.call(this, tracks) || this;
	    _this.changing_ = false;
	    return _this;
	  }
	  /**
	   * Add an {@link AudioTrack} to the `AudioTrackList`.
	   *
	   * @param {AudioTrack} track
	   *        The AudioTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  var _proto = AudioTrackList.prototype;
	
	  _proto.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    if (track.enabled) {
	      disableOthers$1(this, track);
	    }
	
	    _TrackList.prototype.addTrack.call(this, track); // native tracks don't have this
	
	
	    if (!track.addEventListener) {
	      return;
	    }
	
	    track.enabledChange_ = function () {
	      // when we are disabling other tracks (since we don't support
	      // more than one track at a time) we will set changing_
	      // to true so that we don't trigger additional change events
	      if (_this2.changing_) {
	        return;
	      }
	
	      _this2.changing_ = true;
	      disableOthers$1(_this2, track);
	      _this2.changing_ = false;
	
	      _this2.trigger('change');
	    };
	    /**
	     * @listens AudioTrack#enabledchange
	     * @fires TrackList#change
	     */
	
	
	    track.addEventListener('enabledchange', track.enabledChange_);
	  };
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    _TrackList.prototype.removeTrack.call(this, rtrack);
	
	    if (rtrack.removeEventListener && rtrack.enabledChange_) {
	      rtrack.removeEventListener('enabledchange', rtrack.enabledChange_);
	      rtrack.enabledChange_ = null;
	    }
	  };
	
	  return AudioTrackList;
	}(TrackList);
	
	/**
	 * Un-select all other {@link VideoTrack}s that are selected.
	 *
	 * @param {VideoTrackList} list
	 *        list to work on
	 *
	 * @param {VideoTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	
	var disableOthers = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (!Object.keys(list[i]).length || track.id === list[i].id) {
	      continue;
	    } // another video track is enabled, disable it
	
	
	    list[i].selected = false;
	  }
	};
	/**
	 * The current list of {@link VideoTrack} for a video.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
	 * @extends TrackList
	 */
	
	
	var VideoTrackList = /*#__PURE__*/function (_TrackList) {
	  _inheritsLoose__default['default'](VideoTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {VideoTrack[]} [tracks=[]]
	   *        A list of `VideoTrack` to instantiate the list with.
	   */
	  function VideoTrackList(tracks) {
	    var _this;
	
	    if (tracks === void 0) {
	      tracks = [];
	    }
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].selected) {
	        disableOthers(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    _this = _TrackList.call(this, tracks) || this;
	    _this.changing_ = false;
	    /**
	     * @member {number} VideoTrackList#selectedIndex
	     *         The current index of the selected {@link VideoTrack`}.
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'selectedIndex', {
	      get: function get() {
	        for (var _i = 0; _i < this.length; _i++) {
	          if (this[_i].selected) {
	            return _i;
	          }
	        }
	
	        return -1;
	      },
	      set: function set() {}
	    });
	    return _this;
	  }
	  /**
	   * Add a {@link VideoTrack} to the `VideoTrackList`.
	   *
	   * @param {VideoTrack} track
	   *        The VideoTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  var _proto = VideoTrackList.prototype;
	
	  _proto.addTrack = function addTrack(track) {
	    var _this2 = this;
	
	    if (track.selected) {
	      disableOthers(this, track);
	    }
	
	    _TrackList.prototype.addTrack.call(this, track); // native tracks don't have this
	
	
	    if (!track.addEventListener) {
	      return;
	    }
	
	    track.selectedChange_ = function () {
	      if (_this2.changing_) {
	        return;
	      }
	
	      _this2.changing_ = true;
	      disableOthers(_this2, track);
	      _this2.changing_ = false;
	
	      _this2.trigger('change');
	    };
	    /**
	     * @listens VideoTrack#selectedchange
	     * @fires TrackList#change
	     */
	
	
	    track.addEventListener('selectedchange', track.selectedChange_);
	  };
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    _TrackList.prototype.removeTrack.call(this, rtrack);
	
	    if (rtrack.removeEventListener && rtrack.selectedChange_) {
	      rtrack.removeEventListener('selectedchange', rtrack.selectedChange_);
	      rtrack.selectedChange_ = null;
	    }
	  };
	
	  return VideoTrackList;
	}(TrackList);
	
	/**
	 * The current list of {@link TextTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
	 * @extends TrackList
	 */
	
	var TextTrackList = /*#__PURE__*/function (_TrackList) {
	  _inheritsLoose__default['default'](TextTrackList, _TrackList);
	
	  function TextTrackList() {
	    return _TrackList.apply(this, arguments) || this;
	  }
	
	  var _proto = TextTrackList.prototype;
	
	  /**
	   * Add a {@link TextTrack} to the `TextTrackList`
	   *
	   * @param {TextTrack} track
	   *        The text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   */
	  _proto.addTrack = function addTrack(track) {
	    var _this = this;
	
	    _TrackList.prototype.addTrack.call(this, track);
	
	    if (!this.queueChange_) {
	      this.queueChange_ = function () {
	        return _this.queueTrigger('change');
	      };
	    }
	
	    if (!this.triggerSelectedlanguagechange) {
	      this.triggerSelectedlanguagechange_ = function () {
	        return _this.trigger('selectedlanguagechange');
	      };
	    }
	    /**
	     * @listens TextTrack#modechange
	     * @fires TrackList#change
	     */
	
	
	    track.addEventListener('modechange', this.queueChange_);
	    var nonLanguageTextTrackKind = ['metadata', 'chapters'];
	
	    if (nonLanguageTextTrackKind.indexOf(track.kind) === -1) {
	      track.addEventListener('modechange', this.triggerSelectedlanguagechange_);
	    }
	  };
	
	  _proto.removeTrack = function removeTrack(rtrack) {
	    _TrackList.prototype.removeTrack.call(this, rtrack); // manually remove the event handlers we added
	
	
	    if (rtrack.removeEventListener) {
	      if (this.queueChange_) {
	        rtrack.removeEventListener('modechange', this.queueChange_);
	      }
	
	      if (this.selectedlanguagechange_) {
	        rtrack.removeEventListener('modechange', this.triggerSelectedlanguagechange_);
	      }
	    }
	  };
	
	  return TextTrackList;
	}(TrackList);
	
	/**
	 * @file html-track-element-list.js
	 */
	
	/**
	 * The current list of {@link HtmlTrackElement}s.
	 */
	var HtmlTrackElementList = /*#__PURE__*/function () {
	  /**
	   * Create an instance of this class.
	   *
	   * @param {HtmlTrackElement[]} [tracks=[]]
	   *        A list of `HtmlTrackElement` to instantiate the list with.
	   */
	  function HtmlTrackElementList(trackElements) {
	    if (trackElements === void 0) {
	      trackElements = [];
	    }
	
	    this.trackElements_ = [];
	    /**
	     * @memberof HtmlTrackElementList
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     * @instance
	     */
	
	    Object.defineProperty(this, 'length', {
	      get: function get() {
	        return this.trackElements_.length;
	      }
	    });
	
	    for (var i = 0, length = trackElements.length; i < length; i++) {
	      this.addTrackElement_(trackElements[i]);
	    }
	  }
	  /**
	   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to add to the list.
	   *
	   * @private
	   */
	
	
	  var _proto = HtmlTrackElementList.prototype;
	
	  _proto.addTrackElement_ = function addTrackElement_(trackElement) {
	    var index = this.trackElements_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get() {
	          return this.trackElements_[index];
	        }
	      });
	    } // Do not add duplicate elements
	
	
	    if (this.trackElements_.indexOf(trackElement) === -1) {
	      this.trackElements_.push(trackElement);
	    }
	  }
	  /**
	   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
	   * {@link TextTrack}.
	   *
	   * @param {TextTrack} track
	   *        The track associated with a track element.
	   *
	   * @return {HtmlTrackElement|undefined}
	   *         The track element that was found or undefined.
	   *
	   * @private
	   */
	  ;
	
	  _proto.getTrackElementByTrack_ = function getTrackElementByTrack_(track) {
	    var trackElement_;
	
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (track === this.trackElements_[i].track) {
	        trackElement_ = this.trackElements_[i];
	        break;
	      }
	    }
	
	    return trackElement_;
	  }
	  /**
	   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to remove from the list.
	   *
	   * @private
	   */
	  ;
	
	  _proto.removeTrackElement_ = function removeTrackElement_(trackElement) {
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (trackElement === this.trackElements_[i]) {
	        if (this.trackElements_[i].track && typeof this.trackElements_[i].track.off === 'function') {
	          this.trackElements_[i].track.off();
	        }
	
	        if (typeof this.trackElements_[i].off === 'function') {
	          this.trackElements_[i].off();
	        }
	
	        this.trackElements_.splice(i, 1);
	        break;
	      }
	    }
	  };
	
	  return HtmlTrackElementList;
	}();
	
	/**
	 * @file text-track-cue-list.js
	 */
	
	/**
	 * @typedef {Object} TextTrackCueList~TextTrackCue
	 *
	 * @property {string} id
	 *           The unique id for this text track cue
	 *
	 * @property {number} startTime
	 *           The start time for this text track cue
	 *
	 * @property {number} endTime
	 *           The end time for this text track cue
	 *
	 * @property {boolean} pauseOnExit
	 *           Pause when the end time is reached if true.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
	 */
	
	/**
	 * A List of TextTrackCues.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
	 */
	var TextTrackCueList = /*#__PURE__*/function () {
	  /**
	   * Create an instance of this class..
	   *
	   * @param {Array} cues
	   *        A list of cues to be initialized with
	   */
	  function TextTrackCueList(cues) {
	    TextTrackCueList.prototype.setCues_.call(this, cues);
	    /**
	     * @memberof TextTrackCueList
	     * @member {number} length
	     *         The current number of `TextTrackCue`s in the TextTrackCueList.
	     * @instance
	     */
	
	    Object.defineProperty(this, 'length', {
	      get: function get() {
	        return this.length_;
	      }
	    });
	  }
	  /**
	   * A setter for cues in this list. Creates getters
	   * an an index for the cues.
	   *
	   * @param {Array} cues
	   *        An array of cues to set
	   *
	   * @private
	   */
	
	
	  var _proto = TextTrackCueList.prototype;
	
	  _proto.setCues_ = function setCues_(cues) {
	    var oldLength = this.length || 0;
	    var i = 0;
	    var l = cues.length;
	    this.cues_ = cues;
	    this.length_ = cues.length;
	
	    var defineProp = function defineProp(index) {
	      if (!('' + index in this)) {
	        Object.defineProperty(this, '' + index, {
	          get: function get() {
	            return this.cues_[index];
	          }
	        });
	      }
	    };
	
	    if (oldLength < l) {
	      i = oldLength;
	
	      for (; i < l; i++) {
	        defineProp.call(this, i);
	      }
	    }
	  }
	  /**
	   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
	   *
	   * @param {string} id
	   *        The id of the cue that should be searched for.
	   *
	   * @return {TextTrackCueList~TextTrackCue|null}
	   *         A single cue or null if none was found.
	   */
	  ;
	
	  _proto.getCueById = function getCueById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var cue = this[i];
	
	      if (cue.id === id) {
	        result = cue;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TextTrackCueList;
	}();
	
	/**
	 * @file track-kinds.js
	 */
	
	/**
	 * All possible `VideoTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
	 * @typedef VideoTrack~Kind
	 * @enum
	 */
	var VideoTrackKind = {
	  alternative: 'alternative',
	  captions: 'captions',
	  main: 'main',
	  sign: 'sign',
	  subtitles: 'subtitles',
	  commentary: 'commentary'
	};
	/**
	 * All possible `AudioTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
	 * @typedef AudioTrack~Kind
	 * @enum
	 */
	
	var AudioTrackKind = {
	  'alternative': 'alternative',
	  'descriptions': 'descriptions',
	  'main': 'main',
	  'main-desc': 'main-desc',
	  'translation': 'translation',
	  'commentary': 'commentary'
	};
	/**
	 * All possible `TextTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
	 * @typedef TextTrack~Kind
	 * @enum
	 */
	
	var TextTrackKind = {
	  subtitles: 'subtitles',
	  captions: 'captions',
	  descriptions: 'descriptions',
	  chapters: 'chapters',
	  metadata: 'metadata'
	};
	/**
	 * All possible `TextTrackMode`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
	 * @typedef TextTrack~Mode
	 * @enum
	 */
	
	var TextTrackMode = {
	  disabled: 'disabled',
	  hidden: 'hidden',
	  showing: 'showing'
	};
	
	/**
	 * A Track class that contains all of the common functionality for {@link AudioTrack},
	 * {@link VideoTrack}, and {@link TextTrack}.
	 *
	 * > Note: This class should not be used directly
	 *
	 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
	 * @extends EventTarget
	 * @abstract
	 */
	
	var Track = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](Track, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid kind for the track type you are creating.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @abstract
	   */
	  function Track(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	    var trackProps = {
	      id: options.id || 'vjs_track_' + newGUID(),
	      kind: options.kind || '',
	      language: options.language || ''
	    };
	    var label = options.label || '';
	    /**
	     * @memberof Track
	     * @member {string} id
	     *         The id of this track. Cannot be changed after creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    /**
	     * @memberof Track
	     * @member {string} kind
	     *         The kind of track that this is. Cannot be changed after creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    /**
	     * @memberof Track
	     * @member {string} language
	     *         The two letter language code for this track. Cannot be changed after
	     *         creation.
	     * @instance
	     *
	     * @readonly
	     */
	
	    var _loop = function _loop(key) {
	      Object.defineProperty(_assertThisInitialized__default['default'](_this), key, {
	        get: function get() {
	          return trackProps[key];
	        },
	        set: function set() {}
	      });
	    };
	
	    for (var key in trackProps) {
	      _loop(key);
	    }
	    /**
	     * @memberof Track
	     * @member {string} label
	     *         The label of this track. Cannot be changed after creation.
	     * @instance
	     *
	     * @fires Track#labelchange
	     */
	
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'label', {
	      get: function get() {
	        return label;
	      },
	      set: function set(newLabel) {
	        if (newLabel !== label) {
	          label = newLabel;
	          /**
	           * An event that fires when label changes on this track.
	           *
	           * > Note: This is not part of the spec!
	           *
	           * @event Track#labelchange
	           * @type {EventTarget~Event}
	           */
	
	          this.trigger('labelchange');
	        }
	      }
	    });
	    return _this;
	  }
	
	  return Track;
	}(EventTarget$2);
	
	/**
	 * @file url.js
	 * @module url
	 */
	/**
	 * @typedef {Object} url:URLObject
	 *
	 * @property {string} protocol
	 *           The protocol of the url that was parsed.
	 *
	 * @property {string} hostname
	 *           The hostname of the url that was parsed.
	 *
	 * @property {string} port
	 *           The port of the url that was parsed.
	 *
	 * @property {string} pathname
	 *           The pathname of the url that was parsed.
	 *
	 * @property {string} search
	 *           The search query of the url that was parsed.
	 *
	 * @property {string} hash
	 *           The hash of the url that was parsed.
	 *
	 * @property {string} host
	 *           The host of the url that was parsed.
	 */
	
	/**
	 * Resolve and parse the elements of a URL.
	 *
	 * @function
	 * @param    {String} url
	 *           The url to parse
	 *
	 * @return   {url:URLObject}
	 *           An object of url details
	 */
	
	var parseUrl = function parseUrl(url) {
	  // This entire method can be replace with URL once we are able to drop IE11
	  var props = ['protocol', 'hostname', 'port', 'pathname', 'search', 'hash', 'host']; // add the url to an anchor and let the browser parse the URL
	
	  var a = document__default['default'].createElement('a');
	  a.href = url; // Copy the specific URL properties to a new object
	  // This is also needed for IE because the anchor loses its
	  // properties when it's removed from the dom
	
	  var details = {};
	
	  for (var i = 0; i < props.length; i++) {
	    details[props[i]] = a[props[i]];
	  } // IE adds the port to the host property unlike everyone else. If
	  // a port identifier is added for standard ports, strip it.
	
	
	  if (details.protocol === 'http:') {
	    details.host = details.host.replace(/:80$/, '');
	  }
	
	  if (details.protocol === 'https:') {
	    details.host = details.host.replace(/:443$/, '');
	  }
	
	  if (!details.protocol) {
	    details.protocol = window__default['default'].location.protocol;
	  }
	  /* istanbul ignore if */
	
	
	  if (!details.host) {
	    details.host = window__default['default'].location.host;
	  }
	
	  return details;
	};
	/**
	 * Get absolute version of relative URL. Used to tell Flash the correct URL.
	 *
	 * @function
	 * @param    {string} url
	 *           URL to make absolute
	 *
	 * @return   {string}
	 *           Absolute URL
	 *
	 * @see      http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
	 */
	
	var getAbsoluteURL = function getAbsoluteURL(url) {
	  // Check if absolute URL
	  if (!url.match(/^https?:\/\//)) {
	    // Convert to absolute URL. Flash hosted off-site needs an absolute URL.
	    // add the url to an anchor and let the browser parse the URL
	    var a = document__default['default'].createElement('a');
	    a.href = url;
	    url = a.href;
	  }
	
	  return url;
	};
	/**
	 * Returns the extension of the passed file name. It will return an empty string
	 * if passed an invalid path.
	 *
	 * @function
	 * @param    {string} path
	 *           The fileName path like '/path/to/file.mp4'
	 *
	 * @return  {string}
	 *           The extension in lower case or an empty string if no
	 *           extension could be found.
	 */
	
	var getFileExtension = function getFileExtension(path) {
	  if (typeof path === 'string') {
	    var splitPathRe = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/;
	    var pathParts = splitPathRe.exec(path);
	
	    if (pathParts) {
	      return pathParts.pop().toLowerCase();
	    }
	  }
	
	  return '';
	};
	/**
	 * Returns whether the url passed is a cross domain request or not.
	 *
	 * @function
	 * @param    {string} url
	 *           The url to check.
	 *
	 * @param    {Object} [winLoc]
	 *           the domain to check the url against, defaults to window.location
	 *
	 * @param    {string} [winLoc.protocol]
	 *           The window location protocol defaults to window.location.protocol
	 *
	 * @param    {string} [winLoc.host]
	 *           The window location host defaults to window.location.host
	 *
	 * @return   {boolean}
	 *           Whether it is a cross domain request or not.
	 */
	
	var isCrossOrigin = function isCrossOrigin(url, winLoc) {
	  if (winLoc === void 0) {
	    winLoc = window__default['default'].location;
	  }
	
	  var urlInfo = parseUrl(url); // IE8 protocol relative urls will return ':' for protocol
	
	  var srcProtocol = urlInfo.protocol === ':' ? winLoc.protocol : urlInfo.protocol; // Check if url is for another domain/origin
	  // IE8 doesn't know location.origin, so we won't rely on it here
	
	  var crossOrigin = srcProtocol + urlInfo.host !== winLoc.protocol + winLoc.host;
	  return crossOrigin;
	};
	
	var Url = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  parseUrl: parseUrl,
	  getAbsoluteURL: getAbsoluteURL,
	  getFileExtension: getFileExtension,
	  isCrossOrigin: isCrossOrigin
	});
	
	/**
	 * Takes a webvtt file contents and parses it into cues
	 *
	 * @param {string} srcContent
	 *        webVTT file contents
	 *
	 * @param {TextTrack} track
	 *        TextTrack to add cues to. Cues come from the srcContent.
	 *
	 * @private
	 */
	
	var parseCues = function parseCues(srcContent, track) {
	  var parser = new window__default['default'].WebVTT.Parser(window__default['default'], window__default['default'].vttjs, window__default['default'].WebVTT.StringDecoder());
	  var errors = [];
	
	  parser.oncue = function (cue) {
	    track.addCue(cue);
	  };
	
	  parser.onparsingerror = function (error) {
	    errors.push(error);
	  };
	
	  parser.onflush = function () {
	    track.trigger({
	      type: 'loadeddata',
	      target: track
	    });
	  };
	
	  parser.parse(srcContent);
	
	  if (errors.length > 0) {
	    if (window__default['default'].console && window__default['default'].console.groupCollapsed) {
	      window__default['default'].console.groupCollapsed("Text Track parsing errors for " + track.src);
	    }
	
	    errors.forEach(function (error) {
	      return log$1.error(error);
	    });
	
	    if (window__default['default'].console && window__default['default'].console.groupEnd) {
	      window__default['default'].console.groupEnd();
	    }
	  }
	
	  parser.flush();
	};
	/**
	 * Load a `TextTrack` from a specified url.
	 *
	 * @param {string} src
	 *        Url to load track from.
	 *
	 * @param {TextTrack} track
	 *        Track to add cues to. Comes from the content at the end of `url`.
	 *
	 * @private
	 */
	
	
	var loadTrack = function loadTrack(src, track) {
	  var opts = {
	    uri: src
	  };
	  var crossOrigin = isCrossOrigin(src);
	
	  if (crossOrigin) {
	    opts.cors = crossOrigin;
	  }
	
	  var withCredentials = track.tech_.crossOrigin() === 'use-credentials';
	
	  if (withCredentials) {
	    opts.withCredentials = withCredentials;
	  }
	
	  XHR__default['default'](opts, bind(this, function (err, response, responseBody) {
	    if (err) {
	      return log$1.error(err, response);
	    }
	
	    track.loaded_ = true; // Make sure that vttjs has loaded, otherwise, wait till it finished loading
	    // NOTE: this is only used for the alt/video.novtt.js build
	
	    if (typeof window__default['default'].WebVTT !== 'function') {
	      if (track.tech_) {
	        // to prevent use before define eslint error, we define loadHandler
	        // as a let here
	        track.tech_.any(['vttjsloaded', 'vttjserror'], function (event) {
	          if (event.type === 'vttjserror') {
	            log$1.error("vttjs failed to load, stopping trying to process " + track.src);
	            return;
	          }
	
	          return parseCues(responseBody, track);
	        });
	      }
	    } else {
	      parseCues(responseBody, track);
	    }
	  }));
	};
	/**
	 * A representation of a single `TextTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
	 * @extends Track
	 */
	
	
	var TextTrack = /*#__PURE__*/function (_Track) {
	  _inheritsLoose__default['default'](TextTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this TextTrack.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        version of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function TextTrack(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!options.tech) {
	      throw new Error('A tech was not provided.');
	    }
	
	    var settings = mergeOptions$3(options, {
	      kind: TextTrackKind[options.kind] || 'subtitles',
	      language: options.language || options.srclang || ''
	    });
	    var mode = TextTrackMode[settings.mode] || 'disabled';
	    var default_ = settings["default"];
	
	    if (settings.kind === 'metadata' || settings.kind === 'chapters') {
	      mode = 'hidden';
	    }
	
	    _this = _Track.call(this, settings) || this;
	    _this.tech_ = settings.tech;
	    _this.cues_ = [];
	    _this.activeCues_ = [];
	    _this.preload_ = _this.tech_.preloadTextTracks !== false;
	    var cues = new TextTrackCueList(_this.cues_);
	    var activeCues = new TextTrackCueList(_this.activeCues_);
	    var changed = false;
	    _this.timeupdateHandler = bind(_assertThisInitialized__default['default'](_this), function (event) {
	      if (event === void 0) {
	        event = {};
	      }
	
	      if (this.tech_.isDisposed()) {
	        return;
	      }
	
	      if (!this.tech_.isReady_) {
	        if (event.type !== 'timeupdate') {
	          this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
	        }
	
	        return;
	      } // Accessing this.activeCues for the side-effects of updating itself
	      // due to its nature as a getter function. Do not remove or cues will
	      // stop updating!
	      // Use the setter to prevent deletion from uglify (pure_getters rule)
	
	
	      this.activeCues = this.activeCues;
	
	      if (changed) {
	        this.trigger('cuechange');
	        changed = false;
	      }
	
	      if (event.type !== 'timeupdate') {
	        this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
	      }
	    });
	
	    var disposeHandler = function disposeHandler() {
	      _this.stopTracking();
	    };
	
	    _this.tech_.one('dispose', disposeHandler);
	
	    if (mode !== 'disabled') {
	      _this.startTracking();
	    }
	
	    Object.defineProperties(_assertThisInitialized__default['default'](_this), {
	      /**
	       * @memberof TextTrack
	       * @member {boolean} default
	       *         If this track was set to be on or off by default. Cannot be changed after
	       *         creation.
	       * @instance
	       *
	       * @readonly
	       */
	      "default": {
	        get: function get() {
	          return default_;
	        },
	        set: function set() {}
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {string} mode
	       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
	       *         not be set if setting to an invalid mode.
	       * @instance
	       *
	       * @fires TextTrack#modechange
	       */
	      mode: {
	        get: function get() {
	          return mode;
	        },
	        set: function set(newMode) {
	          if (!TextTrackMode[newMode]) {
	            return;
	          }
	
	          if (mode === newMode) {
	            return;
	          }
	
	          mode = newMode;
	
	          if (!this.preload_ && mode !== 'disabled' && this.cues.length === 0) {
	            // On-demand load.
	            loadTrack(this.src, this);
	          }
	
	          this.stopTracking();
	
	          if (mode !== 'disabled') {
	            this.startTracking();
	          }
	          /**
	           * An event that fires when mode changes on this track. This allows
	           * the TextTrackList that holds this track to act accordingly.
	           *
	           * > Note: This is not part of the spec!
	           *
	           * @event TextTrack#modechange
	           * @type {EventTarget~Event}
	           */
	
	
	          this.trigger('modechange');
	        }
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {TextTrackCueList} cues
	       *         The text track cue list for this TextTrack.
	       * @instance
	       */
	      cues: {
	        get: function get() {
	          if (!this.loaded_) {
	            return null;
	          }
	
	          return cues;
	        },
	        set: function set() {}
	      },
	
	      /**
	       * @memberof TextTrack
	       * @member {TextTrackCueList} activeCues
	       *         The list text track cues that are currently active for this TextTrack.
	       * @instance
	       */
	      activeCues: {
	        get: function get() {
	          if (!this.loaded_) {
	            return null;
	          } // nothing to do
	
	
	          if (this.cues.length === 0) {
	            return activeCues;
	          }
	
	          var ct = this.tech_.currentTime();
	          var active = [];
	
	          for (var i = 0, l = this.cues.length; i < l; i++) {
	            var cue = this.cues[i];
	
	            if (cue.startTime <= ct && cue.endTime >= ct) {
	              active.push(cue);
	            } else if (cue.startTime === cue.endTime && cue.startTime <= ct && cue.startTime + 0.5 >= ct) {
	              active.push(cue);
	            }
	          }
	
	          changed = false;
	
	          if (active.length !== this.activeCues_.length) {
	            changed = true;
	          } else {
	            for (var _i = 0; _i < active.length; _i++) {
	              if (this.activeCues_.indexOf(active[_i]) === -1) {
	                changed = true;
	              }
	            }
	          }
	
	          this.activeCues_ = active;
	          activeCues.setCues_(this.activeCues_);
	          return activeCues;
	        },
	        // /!\ Keep this setter empty (see the timeupdate handler above)
	        set: function set() {}
	      }
	    });
	
	    if (settings.src) {
	      _this.src = settings.src;
	
	      if (!_this.preload_) {
	        // Tracks will load on-demand.
	        // Act like we're loaded for other purposes.
	        _this.loaded_ = true;
	      }
	
	      if (_this.preload_ || settings.kind !== 'subtitles' && settings.kind !== 'captions') {
	        loadTrack(_this.src, _assertThisInitialized__default['default'](_this));
	      }
	    } else {
	      _this.loaded_ = true;
	    }
	
	    return _this;
	  }
	
	  var _proto = TextTrack.prototype;
	
	  _proto.startTracking = function startTracking() {
	    // More precise cues based on requestVideoFrameCallback with a requestAnimationFram fallback
	    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler); // Also listen to timeupdate in case rVFC/rAF stops (window in background, audio in video el)
	
	    this.tech_.on('timeupdate', this.timeupdateHandler);
	  };
	
	  _proto.stopTracking = function stopTracking() {
	    if (this.rvf_) {
	      this.tech_.cancelVideoFrameCallback(this.rvf_);
	      this.rvf_ = undefined;
	    }
	
	    this.tech_.off('timeupdate', this.timeupdateHandler);
	  }
	  /**
	   * Add a cue to the internal list of cues.
	   *
	   * @param {TextTrack~Cue} cue
	   *        The cue to add to our internal list
	   */
	  ;
	
	  _proto.addCue = function addCue(originalCue) {
	    var cue = originalCue;
	
	    if (cue.constructor && cue.constructor.name !== 'VTTCue') {
	      cue = new window__default['default'].vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
	
	      for (var prop in originalCue) {
	        if (!(prop in cue)) {
	          cue[prop] = originalCue[prop];
	        }
	      } // make sure that `id` is copied over
	
	
	      cue.id = originalCue.id;
	      cue.originalCue_ = originalCue;
	    }
	
	    var tracks = this.tech_.textTracks();
	
	    for (var i = 0; i < tracks.length; i++) {
	      if (tracks[i] !== this) {
	        tracks[i].removeCue(cue);
	      }
	    }
	
	    this.cues_.push(cue);
	    this.cues.setCues_(this.cues_);
	  }
	  /**
	   * Remove a cue from our internal list
	   *
	   * @param {TextTrack~Cue} removeCue
	   *        The cue to remove from our internal list
	   */
	  ;
	
	  _proto.removeCue = function removeCue(_removeCue) {
	    var i = this.cues_.length;
	
	    while (i--) {
	      var cue = this.cues_[i];
	
	      if (cue === _removeCue || cue.originalCue_ && cue.originalCue_ === _removeCue) {
	        this.cues_.splice(i, 1);
	        this.cues.setCues_(this.cues_);
	        break;
	      }
	    }
	  };
	
	  return TextTrack;
	}(Track);
	/**
	 * cuechange - One or more cues in the track have become active or stopped being active.
	 */
	
	
	TextTrack.prototype.allowedEvents_ = {
	  cuechange: 'cuechange'
	};
	
	/**
	 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
	 * only one `AudioTrack` in the list will be enabled at a time.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
	 * @extends Track
	 */
	
	var AudioTrack = /*#__PURE__*/function (_Track) {
	  _inheritsLoose__default['default'](AudioTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {AudioTrack~Kind} [options.kind='']
	   *        A valid audio track kind
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.enabled]
	   *        If this track is the one that is currently playing. If this track is part of
	   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
	   */
	  function AudioTrack(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    var settings = mergeOptions$3(options, {
	      kind: AudioTrackKind[options.kind] || ''
	    });
	    _this = _Track.call(this, settings) || this;
	    var enabled = false;
	    /**
	     * @memberof AudioTrack
	     * @member {boolean} enabled
	     *         If this `AudioTrack` is enabled or not. When setting this will
	     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
	     * @instance
	     *
	     * @fires VideoTrack#selectedchange
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'enabled', {
	      get: function get() {
	        return enabled;
	      },
	      set: function set(newEnabled) {
	        // an invalid or unchanged value
	        if (typeof newEnabled !== 'boolean' || newEnabled === enabled) {
	          return;
	        }
	
	        enabled = newEnabled;
	        /**
	         * An event that fires when enabled changes on this track. This allows
	         * the AudioTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event AudioTrack#enabledchange
	         * @type {EventTarget~Event}
	         */
	
	        this.trigger('enabledchange');
	      }
	    }); // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	
	    if (settings.enabled) {
	      _this.enabled = settings.enabled;
	    }
	
	    _this.loaded_ = true;
	    return _this;
	  }
	
	  return AudioTrack;
	}(Track);
	
	/**
	 * A representation of a single `VideoTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
	 * @extends Track
	 */
	
	var VideoTrack = /*#__PURE__*/function (_Track) {
	  _inheritsLoose__default['default'](VideoTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid {@link VideoTrack~Kind}
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.selected]
	   *        If this track is the one that is currently playing.
	   */
	  function VideoTrack(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    var settings = mergeOptions$3(options, {
	      kind: VideoTrackKind[options.kind] || ''
	    });
	    _this = _Track.call(this, settings) || this;
	    var selected = false;
	    /**
	     * @memberof VideoTrack
	     * @member {boolean} selected
	     *         If this `VideoTrack` is selected or not. When setting this will
	     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
	     * @instance
	     *
	     * @fires VideoTrack#selectedchange
	     */
	
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'selected', {
	      get: function get() {
	        return selected;
	      },
	      set: function set(newSelected) {
	        // an invalid or unchanged value
	        if (typeof newSelected !== 'boolean' || newSelected === selected) {
	          return;
	        }
	
	        selected = newSelected;
	        /**
	         * An event that fires when selected changes on this track. This allows
	         * the VideoTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event VideoTrack#selectedchange
	         * @type {EventTarget~Event}
	         */
	
	        this.trigger('selectedchange');
	      }
	    }); // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	
	    if (settings.selected) {
	      _this.selected = settings.selected;
	    }
	
	    return _this;
	  }
	
	  return VideoTrack;
	}(Track);
	
	/**
	 * @memberof HTMLTrackElement
	 * @typedef {HTMLTrackElement~ReadyState}
	 * @enum {number}
	 */
	
	var NONE = 0;
	var LOADING = 1;
	var LOADED = 2;
	var ERROR = 3;
	/**
	 * A single track represented in the DOM.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
	 * @extends EventTarget
	 */
	
	var HTMLTrackElement = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](HTMLTrackElement, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this HTMLTrackElement.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        version of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function HTMLTrackElement(options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	    var readyState;
	    var track = new TextTrack(options);
	    _this.kind = track.kind;
	    _this.src = track.src;
	    _this.srclang = track.language;
	    _this.label = track.label;
	    _this["default"] = track["default"];
	    Object.defineProperties(_assertThisInitialized__default['default'](_this), {
	      /**
	       * @memberof HTMLTrackElement
	       * @member {HTMLTrackElement~ReadyState} readyState
	       *         The current ready state of the track element.
	       * @instance
	       */
	      readyState: {
	        get: function get() {
	          return readyState;
	        }
	      },
	
	      /**
	       * @memberof HTMLTrackElement
	       * @member {TextTrack} track
	       *         The underlying TextTrack object.
	       * @instance
	       *
	       */
	      track: {
	        get: function get() {
	          return track;
	        }
	      }
	    });
	    readyState = NONE;
	    /**
	     * @listens TextTrack#loadeddata
	     * @fires HTMLTrackElement#load
	     */
	
	    track.addEventListener('loadeddata', function () {
	      readyState = LOADED;
	
	      _this.trigger({
	        type: 'load',
	        target: _assertThisInitialized__default['default'](_this)
	      });
	    });
	    return _this;
	  }
	
	  return HTMLTrackElement;
	}(EventTarget$2);
	
	HTMLTrackElement.prototype.allowedEvents_ = {
	  load: 'load'
	};
	HTMLTrackElement.NONE = NONE;
	HTMLTrackElement.LOADING = LOADING;
	HTMLTrackElement.LOADED = LOADED;
	HTMLTrackElement.ERROR = ERROR;
	
	/*
	 * This file contains all track properties that are used in
	 * player.js, tech.js, html5.js and possibly other techs in the future.
	 */
	
	var NORMAL = {
	  audio: {
	    ListClass: AudioTrackList,
	    TrackClass: AudioTrack,
	    capitalName: 'Audio'
	  },
	  video: {
	    ListClass: VideoTrackList,
	    TrackClass: VideoTrack,
	    capitalName: 'Video'
	  },
	  text: {
	    ListClass: TextTrackList,
	    TrackClass: TextTrack,
	    capitalName: 'Text'
	  }
	};
	Object.keys(NORMAL).forEach(function (type) {
	  NORMAL[type].getterName = type + "Tracks";
	  NORMAL[type].privateName = type + "Tracks_";
	});
	var REMOTE = {
	  remoteText: {
	    ListClass: TextTrackList,
	    TrackClass: TextTrack,
	    capitalName: 'RemoteText',
	    getterName: 'remoteTextTracks',
	    privateName: 'remoteTextTracks_'
	  },
	  remoteTextEl: {
	    ListClass: HtmlTrackElementList,
	    TrackClass: HTMLTrackElement,
	    capitalName: 'RemoteTextTrackEls',
	    getterName: 'remoteTextTrackEls',
	    privateName: 'remoteTextTrackEls_'
	  }
	};
	
	var ALL = _extends__default['default']({}, NORMAL, REMOTE);
	
	REMOTE.names = Object.keys(REMOTE);
	NORMAL.names = Object.keys(NORMAL);
	ALL.names = [].concat(REMOTE.names).concat(NORMAL.names);
	
	/**
	 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
	 * that just contains the src url alone.
	 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
	   * `var SourceString = 'http://example.com/some-video.mp4';`
	 *
	 * @typedef {Object|string} Tech~SourceObject
	 *
	 * @property {string} src
	 *           The url to the source
	 *
	 * @property {string} type
	 *           The mime type of the source
	 */
	
	/**
	 * A function used by {@link Tech} to create a new {@link TextTrack}.
	 *
	 * @private
	 *
	 * @param {Tech} self
	 *        An instance of the Tech class.
	 *
	 * @param {string} kind
	 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	 *
	 * @param {string} [label]
	 *        Label to identify the text track
	 *
	 * @param {string} [language]
	 *        Two letter language abbreviation
	 *
	 * @param {Object} [options={}]
	 *        An object with additional text track options
	 *
	 * @return {TextTrack}
	 *          The text track that was created.
	 */
	
	function createTrackHelper(self, kind, label, language, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var tracks = self.textTracks();
	  options.kind = kind;
	
	  if (label) {
	    options.label = label;
	  }
	
	  if (language) {
	    options.language = language;
	  }
	
	  options.tech = self;
	  var track = new ALL.text.TrackClass(options);
	  tracks.addTrack(track);
	  return track;
	}
	/**
	 * This is the base class for media playback technology controllers, such as
	 * {@link HTML5}
	 *
	 * @extends Component
	 */
	
	
	var Tech = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Tech, _Component);
	
	  /**
	  * Create an instance of this Tech.
	  *
	  * @param {Object} [options]
	  *        The key/value store of player options.
	  *
	  * @param {Component~ReadyCallback} ready
	  *        Callback function to call when the `HTML5` Tech is ready.
	  */
	  function Tech(options, ready) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (ready === void 0) {
	      ready = function ready() {};
	    }
	
	    // we don't want the tech to report user activity automatically.
	    // This is done manually in addControlsListeners
	    options.reportTouchActivity = false;
	    _this = _Component.call(this, null, options, ready) || this;
	
	    _this.onDurationChange_ = function (e) {
	      return _this.onDurationChange(e);
	    };
	
	    _this.trackProgress_ = function (e) {
	      return _this.trackProgress(e);
	    };
	
	    _this.trackCurrentTime_ = function (e) {
	      return _this.trackCurrentTime(e);
	    };
	
	    _this.stopTrackingCurrentTime_ = function (e) {
	      return _this.stopTrackingCurrentTime(e);
	    };
	
	    _this.disposeSourceHandler_ = function (e) {
	      return _this.disposeSourceHandler(e);
	    };
	
	    _this.queuedHanders_ = new Set(); // keep track of whether the current source has played at all to
	    // implement a very limited played()
	
	    _this.hasStarted_ = false;
	
	    _this.on('playing', function () {
	      this.hasStarted_ = true;
	    });
	
	    _this.on('loadstart', function () {
	      this.hasStarted_ = false;
	    });
	
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	
	      if (options && options[props.getterName]) {
	        _this[props.privateName] = options[props.getterName];
	      }
	    }); // Manually track progress in cases where the browser/tech doesn't report it.
	
	    if (!_this.featuresProgressEvents) {
	      _this.manualProgressOn();
	    } // Manually track timeupdates in cases where the browser/tech doesn't report it.
	
	
	    if (!_this.featuresTimeupdateEvents) {
	      _this.manualTimeUpdatesOn();
	    }
	
	    ['Text', 'Audio', 'Video'].forEach(function (track) {
	      if (options["native" + track + "Tracks"] === false) {
	        _this["featuresNative" + track + "Tracks"] = false;
	      }
	    });
	
	    if (options.nativeCaptions === false || options.nativeTextTracks === false) {
	      _this.featuresNativeTextTracks = false;
	    } else if (options.nativeCaptions === true || options.nativeTextTracks === true) {
	      _this.featuresNativeTextTracks = true;
	    }
	
	    if (!_this.featuresNativeTextTracks) {
	      _this.emulateTextTracks();
	    }
	
	    _this.preloadTextTracks = options.preloadTextTracks !== false;
	    _this.autoRemoteTextTracks_ = new ALL.text.ListClass();
	
	    _this.initTrackListeners(); // Turn on component tap events only if not using native controls
	
	
	    if (!options.nativeControlsForTouch) {
	      _this.emitTapEvents();
	    }
	
	    if (_this.constructor) {
	      _this.name_ = _this.constructor.name || 'Unknown Tech';
	    }
	
	    return _this;
	  }
	  /**
	   * A special function to trigger source set in a way that will allow player
	   * to re-trigger if the player or tech are not ready yet.
	   *
	   * @fires Tech#sourceset
	   * @param {string} src The source string at the time of the source changing.
	   */
	
	
	  var _proto = Tech.prototype;
	
	  _proto.triggerSourceset = function triggerSourceset(src) {
	    var _this2 = this;
	
	    if (!this.isReady_) {
	      // on initial ready we have to trigger source set
	      // 1ms after ready so that player can watch for it.
	      this.one('ready', function () {
	        return _this2.setTimeout(function () {
	          return _this2.triggerSourceset(src);
	        }, 1);
	      });
	    }
	    /**
	     * Fired when the source is set on the tech causing the media element
	     * to reload.
	     *
	     * @see {@link Player#event:sourceset}
	     * @event Tech#sourceset
	     * @type {EventTarget~Event}
	     */
	
	
	    this.trigger({
	      src: src,
	      type: 'sourceset'
	    });
	  }
	  /* Fallbacks for unsupported event types
	  ================================================================================ */
	
	  /**
	   * Polyfill the `progress` event for browsers that don't support it natively.
	   *
	   * @see {@link Tech#trackProgress}
	   */
	  ;
	
	  _proto.manualProgressOn = function manualProgressOn() {
	    this.on('durationchange', this.onDurationChange_);
	    this.manualProgress = true; // Trigger progress watching when a source begins loading
	
	    this.one('ready', this.trackProgress_);
	  }
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   */
	  ;
	
	  _proto.manualProgressOff = function manualProgressOff() {
	    this.manualProgress = false;
	    this.stopTrackingProgress();
	    this.off('durationchange', this.onDurationChange_);
	  }
	  /**
	   * This is used to trigger a `progress` event when the buffered percent changes. It
	   * sets an interval function that will be called every 500 milliseconds to check if the
	   * buffer end percent has changed.
	   *
	   * > This function is called by {@link Tech#manualProgressOn}
	   *
	   * @param {EventTarget~Event} event
	   *        The `ready` event that caused this to run.
	   *
	   * @listens Tech#ready
	   * @fires Tech#progress
	   */
	  ;
	
	  _proto.trackProgress = function trackProgress(event) {
	    this.stopTrackingProgress();
	    this.progressInterval = this.setInterval(bind(this, function () {
	      // Don't trigger unless buffered amount is greater than last time
	      var numBufferedPercent = this.bufferedPercent();
	
	      if (this.bufferedPercent_ !== numBufferedPercent) {
	        /**
	         * See {@link Player#progress}
	         *
	         * @event Tech#progress
	         * @type {EventTarget~Event}
	         */
	        this.trigger('progress');
	      }
	
	      this.bufferedPercent_ = numBufferedPercent;
	
	      if (numBufferedPercent === 1) {
	        this.stopTrackingProgress();
	      }
	    }), 500);
	  }
	  /**
	   * Update our internal duration on a `durationchange` event by calling
	   * {@link Tech#duration}.
	   *
	   * @param {EventTarget~Event} event
	   *        The `durationchange` event that caused this to run.
	   *
	   * @listens Tech#durationchange
	   */
	  ;
	
	  _proto.onDurationChange = function onDurationChange(event) {
	    this.duration_ = this.duration();
	  }
	  /**
	   * Get and create a `TimeRange` object for buffering.
	   *
	   * @return {TimeRange}
	   *         The time range object that was created.
	   */
	  ;
	
	  _proto.buffered = function buffered() {
	    return createTimeRanges(0, 0);
	  }
	  /**
	   * Get the percentage of the current video that is currently buffered.
	   *
	   * @return {number}
	   *         A number from 0 to 1 that represents the decimal percentage of the
	   *         video that is buffered.
	   *
	   */
	  ;
	
	  _proto.bufferedPercent = function bufferedPercent$1() {
	    return bufferedPercent(this.buffered(), this.duration_);
	  }
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   * Stop manually tracking progress events by clearing the interval that was set in
	   * {@link Tech#trackProgress}.
	   */
	  ;
	
	  _proto.stopTrackingProgress = function stopTrackingProgress() {
	    this.clearInterval(this.progressInterval);
	  }
	  /**
	   * Polyfill the `timeupdate` event for browsers that don't support it.
	   *
	   * @see {@link Tech#trackCurrentTime}
	   */
	  ;
	
	  _proto.manualTimeUpdatesOn = function manualTimeUpdatesOn() {
	    this.manualTimeUpdates = true;
	    this.on('play', this.trackCurrentTime_);
	    this.on('pause', this.stopTrackingCurrentTime_);
	  }
	  /**
	   * Turn off the polyfill for `timeupdate` events that was created in
	   * {@link Tech#manualTimeUpdatesOn}
	   */
	  ;
	
	  _proto.manualTimeUpdatesOff = function manualTimeUpdatesOff() {
	    this.manualTimeUpdates = false;
	    this.stopTrackingCurrentTime();
	    this.off('play', this.trackCurrentTime_);
	    this.off('pause', this.stopTrackingCurrentTime_);
	  }
	  /**
	   * Sets up an interval function to track current time and trigger `timeupdate` every
	   * 250 milliseconds.
	   *
	   * @listens Tech#play
	   * @triggers Tech#timeupdate
	   */
	  ;
	
	  _proto.trackCurrentTime = function trackCurrentTime() {
	    if (this.currentTimeInterval) {
	      this.stopTrackingCurrentTime();
	    }
	
	    this.currentTimeInterval = this.setInterval(function () {
	      /**
	       * Triggered at an interval of 250ms to indicated that time is passing in the video.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({
	        type: 'timeupdate',
	        target: this,
	        manuallyTriggered: true
	      }); // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
	    }, 250);
	  }
	  /**
	   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
	   * `timeupdate` event is no longer triggered.
	   *
	   * @listens {Tech#pause}
	   */
	  ;
	
	  _proto.stopTrackingCurrentTime = function stopTrackingCurrentTime() {
	    this.clearInterval(this.currentTimeInterval); // #1002 - if the video ends right before the next timeupdate would happen,
	    // the progress bar won't make it all the way to the end
	
	    this.trigger({
	      type: 'timeupdate',
	      target: this,
	      manuallyTriggered: true
	    });
	  }
	  /**
	   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
	   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
	   *
	   * @fires Component#dispose
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    // clear out all tracks because we can't reuse them between techs
	    this.clearTracks(NORMAL.names); // Turn off any manual progress or timeupdate tracking
	
	    if (this.manualProgress) {
	      this.manualProgressOff();
	    }
	
	    if (this.manualTimeUpdates) {
	      this.manualTimeUpdatesOff();
	    }
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
	   *
	   * > Note: Techs without source handlers should call this between sources for `video`
	   *         & `audio` tracks. You don't want to use them between tracks!
	   *
	   * @param {string[]|string} types
	   *        TrackList names to clear, valid names are `video`, `audio`, and
	   *        `text`.
	   */
	  ;
	
	  _proto.clearTracks = function clearTracks(types) {
	    var _this3 = this;
	
	    types = [].concat(types); // clear out all tracks because we can't reuse them between techs
	
	    types.forEach(function (type) {
	      var list = _this3[type + "Tracks"]() || [];
	      var i = list.length;
	
	      while (i--) {
	        var track = list[i];
	
	        if (type === 'text') {
	          _this3.removeRemoteTextTrack(track);
	        }
	
	        list.removeTrack(track);
	      }
	    });
	  }
	  /**
	   * Remove any TextTracks added via addRemoteTextTrack that are
	   * flagged for automatic garbage collection
	   */
	  ;
	
	  _proto.cleanupAutoTextTracks = function cleanupAutoTextTracks() {
	    var list = this.autoRemoteTextTracks_ || [];
	    var i = list.length;
	
	    while (i--) {
	      var track = list[i];
	      this.removeRemoteTextTrack(track);
	    }
	  }
	  /**
	   * Reset the tech, which will removes all sources and reset the internal readyState.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.reset = function reset() {}
	  /**
	   * Get the value of `crossOrigin` from the tech.
	   *
	   * @abstract
	   *
	   * @see {Html5#crossOrigin}
	   */
	  ;
	
	  _proto.crossOrigin = function crossOrigin() {}
	  /**
	   * Set the value of `crossOrigin` on the tech.
	   *
	   * @abstract
	   *
	   * @param {string} crossOrigin the crossOrigin value
	   * @see {Html5#setCrossOrigin}
	   */
	  ;
	
	  _proto.setCrossOrigin = function setCrossOrigin() {}
	  /**
	   * Get or set an error on the Tech.
	   *
	   * @param {MediaError} [err]
	   *        Error to set on the Tech
	   *
	   * @return {MediaError|null}
	   *         The current error object on the tech, or null if there isn't one.
	   */
	  ;
	
	  _proto.error = function error(err) {
	    if (err !== undefined) {
	      this.error_ = new MediaError(err);
	      this.trigger('error');
	    }
	
	    return this.error_;
	  }
	  /**
	   * Returns the `TimeRange`s that have been played through for the current source.
	   *
	   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
	   *         It only checks whether the source has played at all or not.
	   *
	   * @return {TimeRange}
	   *         - A single time range if this video has played
	   *         - An empty set of ranges if not.
	   */
	  ;
	
	  _proto.played = function played() {
	    if (this.hasStarted_) {
	      return createTimeRanges(0, 0);
	    }
	
	    return createTimeRanges();
	  }
	  /**
	   * Start playback
	   *
	   * @abstract
	   *
	   * @see {Html5#play}
	   */
	  ;
	
	  _proto.play = function play() {}
	  /**
	   * Set whether we are scrubbing or not
	   *
	   * @abstract
	   *
	   * @see {Html5#setScrubbing}
	   */
	  ;
	
	  _proto.setScrubbing = function setScrubbing() {}
	  /**
	   * Get whether we are scrubbing or not
	   *
	   * @abstract
	   *
	   * @see {Html5#scrubbing}
	   */
	  ;
	
	  _proto.scrubbing = function scrubbing() {}
	  /**
	   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
	   * previously called.
	   *
	   * @fires Tech#timeupdate
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime() {
	    // improve the accuracy of manual timeupdates
	    if (this.manualTimeUpdates) {
	      /**
	       * A manual `timeupdate` event.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({
	        type: 'timeupdate',
	        target: this,
	        manuallyTriggered: true
	      });
	    }
	  }
	  /**
	   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
	   * {@link TextTrackList} events.
	   *
	   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
	   *
	   * @fires Tech#audiotrackchange
	   * @fires Tech#videotrackchange
	   * @fires Tech#texttrackchange
	   */
	  ;
	
	  _proto.initTrackListeners = function initTrackListeners() {
	    var _this4 = this;
	
	    /**
	      * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
	      *
	      * @event Tech#audiotrackchange
	      * @type {EventTarget~Event}
	      */
	
	    /**
	      * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
	      *
	      * @event Tech#videotrackchange
	      * @type {EventTarget~Event}
	      */
	
	    /**
	      * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
	      *
	      * @event Tech#texttrackchange
	      * @type {EventTarget~Event}
	      */
	    NORMAL.names.forEach(function (name) {
	      var props = NORMAL[name];
	
	      var trackListChanges = function trackListChanges() {
	        _this4.trigger(name + "trackchange");
	      };
	
	      var tracks = _this4[props.getterName]();
	
	      tracks.addEventListener('removetrack', trackListChanges);
	      tracks.addEventListener('addtrack', trackListChanges);
	
	      _this4.on('dispose', function () {
	        tracks.removeEventListener('removetrack', trackListChanges);
	        tracks.removeEventListener('addtrack', trackListChanges);
	      });
	    });
	  }
	  /**
	   * Emulate TextTracks using vtt.js if necessary
	   *
	   * @fires Tech#vttjsloaded
	   * @fires Tech#vttjserror
	   */
	  ;
	
	  _proto.addWebVttScript_ = function addWebVttScript_() {
	    var _this5 = this;
	
	    if (window__default['default'].WebVTT) {
	      return;
	    } // Initially, Tech.el_ is a child of a dummy-div wait until the Component system
	    // signals that the Tech is ready at which point Tech.el_ is part of the DOM
	    // before inserting the WebVTT script
	
	
	    if (document__default['default'].body.contains(this.el())) {
	      // load via require if available and vtt.js script location was not passed in
	      // as an option. novtt builds will turn the above require call into an empty object
	      // which will cause this if check to always fail.
	      if (!this.options_['vtt.js'] && isPlain(vtt__default['default']) && Object.keys(vtt__default['default']).length > 0) {
	        this.trigger('vttjsloaded');
	        return;
	      } // load vtt.js via the script location option or the cdn of no location was
	      // passed in
	
	
	      var script = document__default['default'].createElement('script');
	      script.src = this.options_['vtt.js'] || 'https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js';
	
	      script.onload = function () {
	        /**
	         * Fired when vtt.js is loaded.
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this5.trigger('vttjsloaded');
	      };
	
	      script.onerror = function () {
	        /**
	         * Fired when vtt.js was not loaded due to an error
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this5.trigger('vttjserror');
	      };
	
	      this.on('dispose', function () {
	        script.onload = null;
	        script.onerror = null;
	      }); // but have not loaded yet and we set it to true before the inject so that
	      // we don't overwrite the injected window.WebVTT if it loads right away
	
	      window__default['default'].WebVTT = true;
	      this.el().parentNode.appendChild(script);
	    } else {
	      this.ready(this.addWebVttScript_);
	    }
	  }
	  /**
	   * Emulate texttracks
	   *
	   */
	  ;
	
	  _proto.emulateTextTracks = function emulateTextTracks() {
	    var _this6 = this;
	
	    var tracks = this.textTracks();
	    var remoteTracks = this.remoteTextTracks();
	
	    var handleAddTrack = function handleAddTrack(e) {
	      return tracks.addTrack(e.track);
	    };
	
	    var handleRemoveTrack = function handleRemoveTrack(e) {
	      return tracks.removeTrack(e.track);
	    };
	
	    remoteTracks.on('addtrack', handleAddTrack);
	    remoteTracks.on('removetrack', handleRemoveTrack);
	    this.addWebVttScript_();
	
	    var updateDisplay = function updateDisplay() {
	      return _this6.trigger('texttrackchange');
	    };
	
	    var textTracksChanges = function textTracksChanges() {
	      updateDisplay();
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	        track.removeEventListener('cuechange', updateDisplay);
	
	        if (track.mode === 'showing') {
	          track.addEventListener('cuechange', updateDisplay);
	        }
	      }
	    };
	
	    textTracksChanges();
	    tracks.addEventListener('change', textTracksChanges);
	    tracks.addEventListener('addtrack', textTracksChanges);
	    tracks.addEventListener('removetrack', textTracksChanges);
	    this.on('dispose', function () {
	      remoteTracks.off('addtrack', handleAddTrack);
	      remoteTracks.off('removetrack', handleRemoveTrack);
	      tracks.removeEventListener('change', textTracksChanges);
	      tracks.removeEventListener('addtrack', textTracksChanges);
	      tracks.removeEventListener('removetrack', textTracksChanges);
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	        track.removeEventListener('cuechange', updateDisplay);
	      }
	    });
	  }
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	  ;
	
	  _proto.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!kind) {
	      throw new Error('TextTrack kind is required but was not provided');
	    }
	
	    return createTrackHelper(this, kind, label, language);
	  }
	  /**
	   * Create an emulated TextTrack for use by addRemoteTextTrack
	   *
	   * This is intended to be overridden by classes that inherit from
	   * Tech in order to create native or custom TextTracks.
	   *
	   * @param {Object} options
	   *        The object should contain the options to initialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label].
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	  ;
	
	  _proto.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    var track = mergeOptions$3(options, {
	      tech: this
	    });
	    return new REMOTE.remoteTextEl.TrackClass(track);
	  }
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
	   *
	   * @param {Object} options
	   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
	   *
	   * @param {boolean} [manualCleanup=true]
	   *        - When false: the TextTrack will be automatically removed from the video
	   *          element whenever the source changes
	   *        - When True: The TextTrack will have to be cleaned up manually
	   *
	   * @return {HTMLTrackElement}
	   *         An Html Track Element.
	   *
	   * @deprecated The default functionality for this function will be equivalent
	   *             to "manualCleanup=false" in the future. The manualCleanup parameter will
	   *             also be removed.
	   */
	  ;
	
	  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    var _this7 = this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    var htmlTrackElement = this.createRemoteTextTrack(options);
	
	    if (manualCleanup !== true && manualCleanup !== false) {
	      // deprecation warning
	      log$1.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js');
	      manualCleanup = true;
	    } // store HTMLTrackElement and TextTrack to remote list
	
	
	    this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
	    this.remoteTextTracks().addTrack(htmlTrackElement.track);
	
	    if (manualCleanup !== true) {
	      // create the TextTrackList if it doesn't exist
	      this.ready(function () {
	        return _this7.autoRemoteTextTracks_.addTrack(htmlTrackElement.track);
	      });
	    }
	
	    return htmlTrackElement;
	  }
	  /**
	   * Remove a remote text track from the remote `TextTrackList`.
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` to remove from the `TextTrackList`
	   */
	  ;
	
	  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    var trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track); // remove HTMLTrackElement and TextTrack from remote list
	
	    this.remoteTextTrackEls().removeTrackElement_(trackElement);
	    this.remoteTextTracks().removeTrack(track);
	    this.autoRemoteTextTracks_.removeTrack(track);
	  }
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return {};
	  }
	  /**
	   * Attempt to create a floating video window always on top of other windows
	   * so that users may continue consuming media while they interact with other
	   * content sites, or applications on their device.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @return {Promise|undefined}
	   *         A promise with a Picture-in-Picture window if the browser supports
	   *         Promises (or one was passed in as an option). It returns undefined
	   *         otherwise.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.requestPictureInPicture = function requestPictureInPicture() {
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      return PromiseClass.reject();
	    }
	  }
	  /**
	   * A method to check for the value of the 'disablePictureInPicture' <video> property.
	   * Defaults to true, as it should be considered disabled if the tech does not support pip
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.disablePictureInPicture = function disablePictureInPicture() {
	    return true;
	  }
	  /**
	   * A method to set or unset the 'disablePictureInPicture' <video> property.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.setDisablePictureInPicture = function setDisablePictureInPicture() {}
	  /**
	   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
	   *
	   * @param {function} cb
	   * @return {number} request id
	   */
	  ;
	
	  _proto.requestVideoFrameCallback = function requestVideoFrameCallback(cb) {
	    var _this8 = this;
	
	    var id = newGUID();
	
	    if (!this.isReady_ || this.paused()) {
	      this.queuedHanders_.add(id);
	      this.one('playing', function () {
	        if (_this8.queuedHanders_.has(id)) {
	          _this8.queuedHanders_["delete"](id);
	
	          cb();
	        }
	      });
	    } else {
	      this.requestNamedAnimationFrame(id, cb);
	    }
	
	    return id;
	  }
	  /**
	   * A fallback implementation of cancelVideoFrameCallback
	   *
	   * @param {number} id id of callback to be cancelled
	   */
	  ;
	
	  _proto.cancelVideoFrameCallback = function cancelVideoFrameCallback(id) {
	    if (this.queuedHanders_.has(id)) {
	      this.queuedHanders_["delete"](id);
	    } else {
	      this.cancelNamedAnimationFrame(id);
	    }
	  }
	  /**
	   * A method to set a poster from a `Tech`.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.setPoster = function setPoster() {}
	  /**
	   * A method to check for the presence of the 'playsinline' <video> attribute.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.playsinline = function playsinline() {}
	  /**
	   * A method to set or unset the 'playsinline' <video> attribute.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.setPlaysinline = function setPlaysinline() {}
	  /**
	   * Attempt to force override of native audio tracks.
	   *
	   * @param {boolean} override - If set to true native audio will be overridden,
	   * otherwise native audio will potentially be used.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.overrideNativeAudioTracks = function overrideNativeAudioTracks() {}
	  /**
	   * Attempt to force override of native video tracks.
	   *
	   * @param {boolean} override - If set to true native video will be overridden,
	   * otherwise native video will potentially be used.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.overrideNativeVideoTracks = function overrideNativeVideoTracks() {}
	  /*
	   * Check if the tech can support the given mime-type.
	   *
	   * The base tech does not support any type, but source handlers might
	   * overwrite this.
	   *
	   * @param  {string} type
	   *         The mimetype to check for support
	   *
	   * @return {string}
	   *         'probably', 'maybe', or empty string
	   *
	   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.canPlayType = function canPlayType() {
	    return '';
	  }
	  /**
	   * Check if the type is supported by this tech.
	   *
	   * The base tech does not support any type, but source handlers might
	   * overwrite this.
	   *
	   * @param {string} type
	   *        The media type to check
	   * @return {string} Returns the native video element's response
	   */
	  ;
	
	  Tech.canPlayType = function canPlayType() {
	    return '';
	  }
	  /**
	   * Check if the tech can support the given source
	   *
	   * @param {Object} srcObj
	   *        The source object
	   * @param {Object} options
	   *        The options passed to the tech
	   * @return {string} 'probably', 'maybe', or '' (empty string)
	   */
	  ;
	
	  Tech.canPlaySource = function canPlaySource(srcObj, options) {
	    return Tech.canPlayType(srcObj.type);
	  }
	  /*
	   * Return whether the argument is a Tech or not.
	   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
	   *
	   * @param {Object} component
	   *        The item to check
	   *
	   * @return {boolean}
	   *         Whether it is a tech or not
	   *         - True if it is a tech
	   *         - False if it is not
	   */
	  ;
	
	  Tech.isTech = function isTech(component) {
	    return component.prototype instanceof Tech || component instanceof Tech || component === Tech;
	  }
	  /**
	   * Registers a `Tech` into a shared list for videojs.
	   *
	   * @param {string} name
	   *        Name of the `Tech` to register.
	   *
	   * @param {Object} tech
	   *        The `Tech` class to register.
	   */
	  ;
	
	  Tech.registerTech = function registerTech(name, tech) {
	    if (!Tech.techs_) {
	      Tech.techs_ = {};
	    }
	
	    if (!Tech.isTech(tech)) {
	      throw new Error("Tech " + name + " must be a Tech");
	    }
	
	    if (!Tech.canPlayType) {
	      throw new Error('Techs must have a static canPlayType method on them');
	    }
	
	    if (!Tech.canPlaySource) {
	      throw new Error('Techs must have a static canPlaySource method on them');
	    }
	
	    name = toTitleCase$1(name);
	    Tech.techs_[name] = tech;
	    Tech.techs_[toLowerCase(name)] = tech;
	
	    if (name !== 'Tech') {
	      // camel case the techName for use in techOrder
	      Tech.defaultTechOrder_.push(name);
	    }
	
	    return tech;
	  }
	  /**
	   * Get a `Tech` from the shared list by name.
	   *
	   * @param {string} name
	   *        `camelCase` or `TitleCase` name of the Tech to get
	   *
	   * @return {Tech|undefined}
	   *         The `Tech` or undefined if there was no tech with the name requested.
	   */
	  ;
	
	  Tech.getTech = function getTech(name) {
	    if (!name) {
	      return;
	    }
	
	    if (Tech.techs_ && Tech.techs_[name]) {
	      return Tech.techs_[name];
	    }
	
	    name = toTitleCase$1(name);
	
	    if (window__default['default'] && window__default['default'].videojs && window__default['default'].videojs[name]) {
	      log$1.warn("The " + name + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)");
	      return window__default['default'].videojs[name];
	    }
	  };
	
	  return Tech;
	}(Component$1);
	/**
	 * Get the {@link VideoTrackList}
	 *
	 * @returns {VideoTrackList}
	 * @method Tech.prototype.videoTracks
	 */
	
	/**
	 * Get the {@link AudioTrackList}
	 *
	 * @returns {AudioTrackList}
	 * @method Tech.prototype.audioTracks
	 */
	
	/**
	 * Get the {@link TextTrackList}
	 *
	 * @returns {TextTrackList}
	 * @method Tech.prototype.textTracks
	 */
	
	/**
	 * Get the remote element {@link TextTrackList}
	 *
	 * @returns {TextTrackList}
	 * @method Tech.prototype.remoteTextTracks
	 */
	
	/**
	 * Get the remote element {@link HtmlTrackElementList}
	 *
	 * @returns {HtmlTrackElementList}
	 * @method Tech.prototype.remoteTextTrackEls
	 */
	
	
	ALL.names.forEach(function (name) {
	  var props = ALL[name];
	
	  Tech.prototype[props.getterName] = function () {
	    this[props.privateName] = this[props.privateName] || new props.ListClass();
	    return this[props.privateName];
	  };
	});
	/**
	 * List of associated text tracks
	 *
	 * @type {TextTrackList}
	 * @private
	 * @property Tech#textTracks_
	 */
	
	/**
	 * List of associated audio tracks.
	 *
	 * @type {AudioTrackList}
	 * @private
	 * @property Tech#audioTracks_
	 */
	
	/**
	 * List of associated video tracks.
	 *
	 * @type {VideoTrackList}
	 * @private
	 * @property Tech#videoTracks_
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresVolumeControl = true;
	/**
	 * Boolean indicating whether the `Tech` supports muting volume.
	 *
	 * @type {bolean}
	 * @default
	 */
	
	Tech.prototype.featuresMuteControl = true;
	/**
	 * Boolean indicating whether the `Tech` supports fullscreen resize control.
	 * Resizing plugins using request fullscreen reloads the plugin
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresFullscreenResize = false;
	/**
	 * Boolean indicating whether the `Tech` supports changing the speed at which the video
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresPlaybackRate = false;
	/**
	 * Boolean indicating whether the `Tech` supports the `progress` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualProgressOn} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresProgressEvents = false;
	/**
	 * Boolean indicating whether the `Tech` supports the `sourceset` event.
	 *
	 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
	 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
	 * a new source.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresSourceset = false;
	/**
	 * Boolean indicating whether the `Tech` supports the `timeupdate` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualTimeUpdates} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresTimeupdateEvents = false;
	/**
	 * Boolean indicating whether the `Tech` supports the native `TextTrack`s.
	 * This will help us integrate with native `TextTrack`s if the browser supports them.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresNativeTextTracks = false;
	/**
	 * Boolean indicating whether the `Tech` supports `requestVideoFrameCallback`.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Tech.prototype.featuresVideoFrameCallback = false;
	/**
	 * A functional mixin for techs that want to use the Source Handler pattern.
	 * Source handlers are scripts for handling specific formats.
	 * The source handler pattern is used for adaptive formats (HLS, DASH) that
	 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
	 * Example: `Tech.withSourceHandlers.call(MyTech);`
	 *
	 * @param {Tech} _Tech
	 *        The tech to add source handler functions to.
	 *
	 * @mixes Tech~SourceHandlerAdditions
	 */
	
	Tech.withSourceHandlers = function (_Tech) {
	  /**
	   * Register a source handler
	   *
	   * @param {Function} handler
	   *        The source handler class
	   *
	   * @param {number} [index]
	   *        Register it at the following index
	   */
	  _Tech.registerSourceHandler = function (handler, index) {
	    var handlers = _Tech.sourceHandlers;
	
	    if (!handlers) {
	      handlers = _Tech.sourceHandlers = [];
	    }
	
	    if (index === undefined) {
	      // add to the end of the list
	      index = handlers.length;
	    }
	
	    handlers.splice(index, 0, handler);
	  };
	  /**
	   * Check if the tech can support the given type. Also checks the
	   * Techs sourceHandlers.
	   *
	   * @param {string} type
	   *         The mimetype to check.
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	
	
	  _Tech.canPlayType = function (type) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canPlayType(type);
	
	      if (can) {
	        return can;
	      }
	    }
	
	    return '';
	  };
	  /**
	   * Returns the first source handler that supports the source.
	   *
	   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
	   *
	   * @param {Tech~SourceObject} source
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {SourceHandler|null}
	   *          The first source handler that supports the source or null if
	   *          no SourceHandler supports the source
	   */
	
	
	  _Tech.selectSourceHandler = function (source, options) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canHandleSource(source, options);
	
	      if (can) {
	        return handlers[i];
	      }
	    }
	
	    return null;
	  };
	  /**
	   * Check if the tech can support the given source.
	   *
	   * @param {Tech~SourceObject} srcObj
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	
	
	  _Tech.canPlaySource = function (srcObj, options) {
	    var sh = _Tech.selectSourceHandler(srcObj, options);
	
	    if (sh) {
	      return sh.canHandleSource(srcObj, options);
	    }
	
	    return '';
	  };
	  /**
	   * When using a source handler, prefer its implementation of
	   * any function normally provided by the tech.
	   */
	
	
	  var deferrable = ['seekable', 'seeking', 'duration'];
	  /**
	   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
	   * function if it exists, with a fallback to the Techs seekable function.
	   *
	   * @method _Tech.seekable
	   */
	
	  /**
	   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
	   * function if it exists, otherwise it will fallback to the techs duration function.
	   *
	   * @method _Tech.duration
	   */
	
	  deferrable.forEach(function (fnName) {
	    var originalFn = this[fnName];
	
	    if (typeof originalFn !== 'function') {
	      return;
	    }
	
	    this[fnName] = function () {
	      if (this.sourceHandler_ && this.sourceHandler_[fnName]) {
	        return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
	      }
	
	      return originalFn.apply(this, arguments);
	    };
	  }, _Tech.prototype);
	  /**
	   * Create a function for setting the source using a source object
	   * and source handlers.
	   * Should never be called unless a source handler was found.
	   *
	   * @param {Tech~SourceObject} source
	   *        A source object with src and type keys
	   */
	
	  _Tech.prototype.setSource = function (source) {
	    var sh = _Tech.selectSourceHandler(source, this.options_);
	
	    if (!sh) {
	      // Fall back to a native source hander when unsupported sources are
	      // deliberately set
	      if (_Tech.nativeSourceHandler) {
	        sh = _Tech.nativeSourceHandler;
	      } else {
	        log$1.error('No source handler found for the current source.');
	      }
	    } // Dispose any existing source handler
	
	
	    this.disposeSourceHandler();
	    this.off('dispose', this.disposeSourceHandler_);
	
	    if (sh !== _Tech.nativeSourceHandler) {
	      this.currentSource_ = source;
	    }
	
	    this.sourceHandler_ = sh.handleSource(source, this, this.options_);
	    this.one('dispose', this.disposeSourceHandler_);
	  };
	  /**
	   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
	   *
	   * @listens Tech#dispose
	   */
	
	
	  _Tech.prototype.disposeSourceHandler = function () {
	    // if we have a source and get another one
	    // then we are loading something new
	    // than clear all of our current tracks
	    if (this.currentSource_) {
	      this.clearTracks(['audio', 'video']);
	      this.currentSource_ = null;
	    } // always clean up auto-text tracks
	
	
	    this.cleanupAutoTextTracks();
	
	    if (this.sourceHandler_) {
	      if (this.sourceHandler_.dispose) {
	        this.sourceHandler_.dispose();
	      }
	
	      this.sourceHandler_ = null;
	    }
	  };
	}; // The base Tech class needs to be registered as a Component. It is the only
	// Tech that can be registered as a Component.
	
	
	Component$1.registerComponent('Tech', Tech);
	Tech.registerTech('Tech', Tech);
	/**
	 * A list of techs that should be added to techOrder on Players
	 *
	 * @private
	 */
	
	Tech.defaultTechOrder_ = [];
	
	/**
	 * @file middleware.js
	 * @module middleware
	 */
	var middlewares = {};
	var middlewareInstances = {};
	var TERMINATOR = {};
	/**
	 * A middleware object is a plain JavaScript object that has methods that
	 * match the {@link Tech} methods found in the lists of allowed
	 * {@link module:middleware.allowedGetters|getters},
	 * {@link module:middleware.allowedSetters|setters}, and
	 * {@link module:middleware.allowedMediators|mediators}.
	 *
	 * @typedef {Object} MiddlewareObject
	 */
	
	/**
	 * A middleware factory function that should return a
	 * {@link module:middleware~MiddlewareObject|MiddlewareObject}.
	 *
	 * This factory will be called for each player when needed, with the player
	 * passed in as an argument.
	 *
	 * @callback MiddlewareFactory
	 * @param {Player} player
	 *        A Video.js player.
	 */
	
	/**
	 * Define a middleware that the player should use by way of a factory function
	 * that returns a middleware object.
	 *
	 * @param  {string} type
	 *         The MIME type to match or `"*"` for all MIME types.
	 *
	 * @param  {MiddlewareFactory} middleware
	 *         A middleware factory function that will be executed for
	 *         matching types.
	 */
	
	function use(type, middleware) {
	  middlewares[type] = middlewares[type] || [];
	  middlewares[type].push(middleware);
	}
	/**
	 * Asynchronously sets a source using middleware by recursing through any
	 * matching middlewares and calling `setSource` on each, passing along the
	 * previous returned value each time.
	 *
	 * @param  {Player} player
	 *         A {@link Player} instance.
	 *
	 * @param  {Tech~SourceObject} src
	 *         A source object.
	 *
	 * @param  {Function}
	 *         The next middleware to run.
	 */
	
	function setSource(player, src, next) {
	  player.setTimeout(function () {
	    return setSourceHelper(src, middlewares[src.type], next, player);
	  }, 1);
	}
	/**
	 * When the tech is set, passes the tech to each middleware's `setTech` method.
	 *
	 * @param {Object[]} middleware
	 *        An array of middleware instances.
	 *
	 * @param {Tech} tech
	 *        A Video.js tech.
	 */
	
	function setTech(middleware, tech) {
	  middleware.forEach(function (mw) {
	    return mw.setTech && mw.setTech(tech);
	  });
	}
	/**
	 * Calls a getter on the tech first, through each middleware
	 * from right to left to the player.
	 *
	 * @param  {Object[]} middleware
	 *         An array of middleware instances.
	 *
	 * @param  {Tech} tech
	 *         The current tech.
	 *
	 * @param  {string} method
	 *         A method name.
	 *
	 * @return {Mixed}
	 *         The final value from the tech after middleware has intercepted it.
	 */
	
	function get(middleware, tech, method) {
	  return middleware.reduceRight(middlewareIterator(method), tech[method]());
	}
	/**
	 * Takes the argument given to the player and calls the setter method on each
	 * middleware from left to right to the tech.
	 *
	 * @param  {Object[]} middleware
	 *         An array of middleware instances.
	 *
	 * @param  {Tech} tech
	 *         The current tech.
	 *
	 * @param  {string} method
	 *         A method name.
	 *
	 * @param  {Mixed} arg
	 *         The value to set on the tech.
	 *
	 * @return {Mixed}
	 *         The return value of the `method` of the `tech`.
	 */
	
	function set(middleware, tech, method, arg) {
	  return tech[method](middleware.reduce(middlewareIterator(method), arg));
	}
	/**
	 * Takes the argument given to the player and calls the `call` version of the
	 * method on each middleware from left to right.
	 *
	 * Then, call the passed in method on the tech and return the result unchanged
	 * back to the player, through middleware, this time from right to left.
	 *
	 * @param  {Object[]} middleware
	 *         An array of middleware instances.
	 *
	 * @param  {Tech} tech
	 *         The current tech.
	 *
	 * @param  {string} method
	 *         A method name.
	 *
	 * @param  {Mixed} arg
	 *         The value to set on the tech.
	 *
	 * @return {Mixed}
	 *         The return value of the `method` of the `tech`, regardless of the
	 *         return values of middlewares.
	 */
	
	function mediate(middleware, tech, method, arg) {
	  if (arg === void 0) {
	    arg = null;
	  }
	
	  var callMethod = 'call' + toTitleCase$1(method);
	  var middlewareValue = middleware.reduce(middlewareIterator(callMethod), arg);
	  var terminated = middlewareValue === TERMINATOR; // deprecated. The `null` return value should instead return TERMINATOR to
	  // prevent confusion if a techs method actually returns null.
	
	  var returnValue = terminated ? null : tech[method](middlewareValue);
	  executeRight(middleware, method, returnValue, terminated);
	  return returnValue;
	}
	/**
	 * Enumeration of allowed getters where the keys are method names.
	 *
	 * @type {Object}
	 */
	
	var allowedGetters = {
	  buffered: 1,
	  currentTime: 1,
	  duration: 1,
	  muted: 1,
	  played: 1,
	  paused: 1,
	  seekable: 1,
	  volume: 1,
	  ended: 1
	};
	/**
	 * Enumeration of allowed setters where the keys are method names.
	 *
	 * @type {Object}
	 */
	
	var allowedSetters = {
	  setCurrentTime: 1,
	  setMuted: 1,
	  setVolume: 1
	};
	/**
	 * Enumeration of allowed mediators where the keys are method names.
	 *
	 * @type {Object}
	 */
	
	var allowedMediators = {
	  play: 1,
	  pause: 1
	};
	
	function middlewareIterator(method) {
	  return function (value, mw) {
	    // if the previous middleware terminated, pass along the termination
	    if (value === TERMINATOR) {
	      return TERMINATOR;
	    }
	
	    if (mw[method]) {
	      return mw[method](value);
	    }
	
	    return value;
	  };
	}
	
	function executeRight(mws, method, value, terminated) {
	  for (var i = mws.length - 1; i >= 0; i--) {
	    var mw = mws[i];
	
	    if (mw[method]) {
	      mw[method](terminated, value);
	    }
	  }
	}
	/**
	 * Clear the middleware cache for a player.
	 *
	 * @param  {Player} player
	 *         A {@link Player} instance.
	 */
	
	
	function clearCacheForPlayer(player) {
	  middlewareInstances[player.id()] = null;
	}
	/**
	 * {
	 *  [playerId]: [[mwFactory, mwInstance], ...]
	 * }
	 *
	 * @private
	 */
	
	function getOrCreateFactory(player, mwFactory) {
	  var mws = middlewareInstances[player.id()];
	  var mw = null;
	
	  if (mws === undefined || mws === null) {
	    mw = mwFactory(player);
	    middlewareInstances[player.id()] = [[mwFactory, mw]];
	    return mw;
	  }
	
	  for (var i = 0; i < mws.length; i++) {
	    var _mws$i = mws[i],
	        mwf = _mws$i[0],
	        mwi = _mws$i[1];
	
	    if (mwf !== mwFactory) {
	      continue;
	    }
	
	    mw = mwi;
	  }
	
	  if (mw === null) {
	    mw = mwFactory(player);
	    mws.push([mwFactory, mw]);
	  }
	
	  return mw;
	}
	
	function setSourceHelper(src, middleware, next, player, acc, lastRun) {
	  if (src === void 0) {
	    src = {};
	  }
	
	  if (middleware === void 0) {
	    middleware = [];
	  }
	
	  if (acc === void 0) {
	    acc = [];
	  }
	
	  if (lastRun === void 0) {
	    lastRun = false;
	  }
	
	  var _middleware = middleware,
	      mwFactory = _middleware[0],
	      mwrest = _middleware.slice(1); // if mwFactory is a string, then we're at a fork in the road
	
	
	  if (typeof mwFactory === 'string') {
	    setSourceHelper(src, middlewares[mwFactory], next, player, acc, lastRun); // if we have an mwFactory, call it with the player to get the mw,
	    // then call the mw's setSource method
	  } else if (mwFactory) {
	    var mw = getOrCreateFactory(player, mwFactory); // if setSource isn't present, implicitly select this middleware
	
	    if (!mw.setSource) {
	      acc.push(mw);
	      return setSourceHelper(src, mwrest, next, player, acc, lastRun);
	    }
	
	    mw.setSource(assign({}, src), function (err, _src) {
	      // something happened, try the next middleware on the current level
	      // make sure to use the old src
	      if (err) {
	        return setSourceHelper(src, mwrest, next, player, acc, lastRun);
	      } // we've succeeded, now we need to go deeper
	
	
	      acc.push(mw); // if it's the same type, continue down the current chain
	      // otherwise, we want to go down the new chain
	
	      setSourceHelper(_src, src.type === _src.type ? mwrest : middlewares[_src.type], next, player, acc, lastRun);
	    });
	  } else if (mwrest.length) {
	    setSourceHelper(src, mwrest, next, player, acc, lastRun);
	  } else if (lastRun) {
	    next(src, acc);
	  } else {
	    setSourceHelper(src, middlewares['*'], next, player, acc, true);
	  }
	}
	
	/**
	 * Mimetypes
	 *
	 * @see https://www.iana.org/assignments/media-types/media-types.xhtml
	 * @typedef Mimetypes~Kind
	 * @enum
	 */
	
	var MimetypesKind = {
	  opus: 'video/ogg',
	  ogv: 'video/ogg',
	  mp4: 'video/mp4',
	  mov: 'video/mp4',
	  m4v: 'video/mp4',
	  mkv: 'video/x-matroska',
	  m4a: 'audio/mp4',
	  mp3: 'audio/mpeg',
	  aac: 'audio/aac',
	  caf: 'audio/x-caf',
	  flac: 'audio/flac',
	  oga: 'audio/ogg',
	  wav: 'audio/wav',
	  m3u8: 'application/x-mpegURL',
	  mpd: 'application/dash+xml',
	  jpg: 'image/jpeg',
	  jpeg: 'image/jpeg',
	  gif: 'image/gif',
	  png: 'image/png',
	  svg: 'image/svg+xml',
	  webp: 'image/webp'
	};
	/**
	 * Get the mimetype of a given src url if possible
	 *
	 * @param {string} src
	 *        The url to the src
	 *
	 * @return {string}
	 *         return the mimetype if it was known or empty string otherwise
	 */
	
	var getMimetype = function getMimetype(src) {
	  if (src === void 0) {
	    src = '';
	  }
	
	  var ext = getFileExtension(src);
	  var mimetype = MimetypesKind[ext.toLowerCase()];
	  return mimetype || '';
	};
	/**
	 * Find the mime type of a given source string if possible. Uses the player
	 * source cache.
	 *
	 * @param {Player} player
	 *        The player object
	 *
	 * @param {string} src
	 *        The source string
	 *
	 * @return {string}
	 *         The type that was found
	 */
	
	var findMimetype = function findMimetype(player, src) {
	  if (!src) {
	    return '';
	  } // 1. check for the type in the `source` cache
	
	
	  if (player.cache_.source.src === src && player.cache_.source.type) {
	    return player.cache_.source.type;
	  } // 2. see if we have this source in our `currentSources` cache
	
	
	  var matchingSources = player.cache_.sources.filter(function (s) {
	    return s.src === src;
	  });
	
	  if (matchingSources.length) {
	    return matchingSources[0].type;
	  } // 3. look for the src url in source elements and use the type there
	
	
	  var sources = player.$$('source');
	
	  for (var i = 0; i < sources.length; i++) {
	    var s = sources[i];
	
	    if (s.type && s.src && s.src === src) {
	      return s.type;
	    }
	  } // 4. finally fallback to our list of mime types based on src url extension
	
	
	  return getMimetype(src);
	};
	
	/**
	 * @module filter-source
	 */
	/**
	 * Filter out single bad source objects or multiple source objects in an
	 * array. Also flattens nested source object arrays into a 1 dimensional
	 * array of source objects.
	 *
	 * @param {Tech~SourceObject|Tech~SourceObject[]} src
	 *        The src object to filter
	 *
	 * @return {Tech~SourceObject[]}
	 *         An array of sourceobjects containing only valid sources
	 *
	 * @private
	 */
	
	var filterSource = function filterSource(src) {
	  // traverse array
	  if (Array.isArray(src)) {
	    var newsrc = [];
	    src.forEach(function (srcobj) {
	      srcobj = filterSource(srcobj);
	
	      if (Array.isArray(srcobj)) {
	        newsrc = newsrc.concat(srcobj);
	      } else if (isObject(srcobj)) {
	        newsrc.push(srcobj);
	      }
	    });
	    src = newsrc;
	  } else if (typeof src === 'string' && src.trim()) {
	    // convert string into object
	    src = [fixSource({
	      src: src
	    })];
	  } else if (isObject(src) && typeof src.src === 'string' && src.src && src.src.trim()) {
	    // src is already valid
	    src = [fixSource(src)];
	  } else {
	    // invalid source, turn it into an empty array
	    src = [];
	  }
	
	  return src;
	};
	/**
	 * Checks src mimetype, adding it when possible
	 *
	 * @param {Tech~SourceObject} src
	 *        The src object to check
	 * @return {Tech~SourceObject}
	 *        src Object with known type
	 */
	
	
	function fixSource(src) {
	  if (!src.type) {
	    var mimetype = getMimetype(src.src);
	
	    if (mimetype) {
	      src.type = mimetype;
	    }
	  }
	
	  return src;
	}
	
	/**
	 * The `MediaLoader` is the `Component` that decides which playback technology to load
	 * when a player is initialized.
	 *
	 * @extends Component
	 */
	
	var MediaLoader = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MediaLoader, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function that is run when this component is ready.
	   */
	  function MediaLoader(player, options, ready) {
	    var _this;
	
	    // MediaLoader has no element
	    var options_ = mergeOptions$3({
	      createEl: false
	    }, options);
	    _this = _Component.call(this, player, options_, ready) || this; // If there are no sources when the player is initialized,
	    // load the first supported playback technology.
	
	    if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) {
	      for (var i = 0, j = options.playerOptions.techOrder; i < j.length; i++) {
	        var techName = toTitleCase$1(j[i]);
	        var tech = Tech.getTech(techName); // Support old behavior of techs being registered as components.
	        // Remove once that deprecated behavior is removed.
	
	        if (!techName) {
	          tech = Component$1.getComponent(techName);
	        } // Check if the browser supports this technology
	
	
	        if (tech && tech.isSupported()) {
	          player.loadTech_(techName);
	          break;
	        }
	      }
	    } else {
	      // Loop through playback technologies (e.g. HTML5) and check for support.
	      // Then load the best source.
	      // A few assumptions here:
	      //   All playback technologies respect preload false.
	      player.src(options.playerOptions.sources);
	    }
	
	    return _this;
	  }
	
	  return MediaLoader;
	}(Component$1);
	
	Component$1.registerComponent('MediaLoader', MediaLoader);
	
	/**
	 * Component which is clickable or keyboard actionable, but is not a
	 * native HTML button.
	 *
	 * @extends Component
	 */
	
	var ClickableComponent = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ClickableComponent, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of component options.
	   *
	   * @param  {function} [options.clickHandler]
	   *         The function to call when the button is clicked / activated
	   *
	   * @param  {string} [options.controlText]
	   *         The text to set on the button
	   *
	   * @param  {string} [options.className]
	   *         A class or space separated list of classes to add the component
	   *
	   */
	  function ClickableComponent(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    if (_this.options_.controlText) {
	      _this.controlText(_this.options_.controlText);
	    }
	
	    _this.handleMouseOver_ = function (e) {
	      return _this.handleMouseOver(e);
	    };
	
	    _this.handleMouseOut_ = function (e) {
	      return _this.handleMouseOut(e);
	    };
	
	    _this.handleClick_ = function (e) {
	      return _this.handleClick(e);
	    };
	
	    _this.handleKeyDown_ = function (e) {
	      return _this.handleKeyDown(e);
	    };
	
	    _this.emitTapEvents();
	
	    _this.enable();
	
	    return _this;
	  }
	  /**
	   * Create the `ClickableComponent`s DOM element.
	   *
	   * @param {string} [tag=div]
	   *        The element's node type.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  var _proto = ClickableComponent.prototype;
	
	  _proto.createEl = function createEl$1(tag, props, attributes) {
	    if (tag === void 0) {
	      tag = 'div';
	    }
	
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    props = assign({
	      className: this.buildCSSClass(),
	      tabIndex: 0
	    }, props);
	
	    if (tag === 'button') {
	      log$1.error("Creating a ClickableComponent with an HTML element of " + tag + " is not supported; use a Button instead.");
	    } // Add ARIA attributes for clickable element which is not a native HTML button
	
	
	    attributes = assign({
	      role: 'button'
	    }, attributes);
	    this.tabIndex_ = props.tabIndex;
	    var el = createEl(tag, props, attributes);
	    el.appendChild(createEl('span', {
	      className: 'vjs-icon-placeholder'
	    }, {
	      'aria-hidden': true
	    }));
	    this.createControlTextEl(el);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    // remove controlTextEl_ on dispose
	    this.controlTextEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Create a control text element on this `ClickableComponent`
	   *
	   * @param {Element} [el]
	   *        Parent element for the control text.
	   *
	   * @return {Element}
	   *         The control text element that gets created.
	   */
	  ;
	
	  _proto.createControlTextEl = function createControlTextEl(el) {
	    this.controlTextEl_ = createEl('span', {
	      className: 'vjs-control-text'
	    }, {
	      // let the screen reader user know that the text of the element may change
	      'aria-live': 'polite'
	    });
	
	    if (el) {
	      el.appendChild(this.controlTextEl_);
	    }
	
	    this.controlText(this.controlText_, el);
	    return this.controlTextEl_;
	  }
	  /**
	   * Get or set the localize text to use for the controls on the `ClickableComponent`.
	   *
	   * @param {string} [text]
	   *        Control text for element.
	   *
	   * @param {Element} [el=this.el()]
	   *        Element to set the title on.
	   *
	   * @return {string}
	   *         - The control text when getting
	   */
	  ;
	
	  _proto.controlText = function controlText(text, el) {
	    if (el === void 0) {
	      el = this.el();
	    }
	
	    if (text === undefined) {
	      return this.controlText_ || 'Need Text';
	    }
	
	    var localizedText = this.localize(text);
	    this.controlText_ = text;
	    textContent(this.controlTextEl_, localizedText);
	
	    if (!this.nonIconControl && !this.player_.options_.noUITitleAttributes) {
	      // Set title attribute if only an icon is shown
	      el.setAttribute('title', localizedText);
	    }
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-control vjs-button " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Enable this `ClickableComponent`
	   */
	  ;
	
	  _proto.enable = function enable() {
	    if (!this.enabled_) {
	      this.enabled_ = true;
	      this.removeClass('vjs-disabled');
	      this.el_.setAttribute('aria-disabled', 'false');
	
	      if (typeof this.tabIndex_ !== 'undefined') {
	        this.el_.setAttribute('tabIndex', this.tabIndex_);
	      }
	
	      this.on(['tap', 'click'], this.handleClick_);
	      this.on('keydown', this.handleKeyDown_);
	    }
	  }
	  /**
	   * Disable this `ClickableComponent`
	   */
	  ;
	
	  _proto.disable = function disable() {
	    this.enabled_ = false;
	    this.addClass('vjs-disabled');
	    this.el_.setAttribute('aria-disabled', 'true');
	
	    if (typeof this.tabIndex_ !== 'undefined') {
	      this.el_.removeAttribute('tabIndex');
	    }
	
	    this.off('mouseover', this.handleMouseOver_);
	    this.off('mouseout', this.handleMouseOut_);
	    this.off(['tap', 'click'], this.handleClick_);
	    this.off('keydown', this.handleKeyDown_);
	  }
	  /**
	   * Handles language change in ClickableComponent for the player in components
	   *
	   *
	   */
	  ;
	
	  _proto.handleLanguagechange = function handleLanguagechange() {
	    this.controlText(this.controlText_);
	  }
	  /**
	   * Event handler that is called when a `ClickableComponent` receives a
	   * `click` or `tap` event.
	   *
	   * @param {EventTarget~Event} event
	   *        The `tap` or `click` event that caused this function to be called.
	   *
	   * @listens tap
	   * @listens click
	   * @abstract
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.options_.clickHandler) {
	      this.options_.clickHandler.call(this, arguments);
	    }
	  }
	  /**
	   * Event handler that is called when a `ClickableComponent` receives a
	   * `keydown` event.
	   *
	   * By default, if the key is Space or Enter, it will trigger a `click` event.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Support Space or Enter key operation to fire a click event. Also,
	    // prevent the event from propagating through the DOM and triggering
	    // Player hotkeys.
	    if (keycode__default['default'].isEventKey(event, 'Space') || keycode__default['default'].isEventKey(event, 'Enter')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.trigger('click');
	    } else {
	      // Pass keypress handling up for unsupported keys
	      _Component.prototype.handleKeyDown.call(this, event);
	    }
	  };
	
	  return ClickableComponent;
	}(Component$1);
	
	Component$1.registerComponent('ClickableComponent', ClickableComponent);
	
	/**
	 * A `ClickableComponent` that handles showing the poster image for the player.
	 *
	 * @extends ClickableComponent
	 */
	
	var PosterImage = /*#__PURE__*/function (_ClickableComponent) {
	  _inheritsLoose__default['default'](PosterImage, _ClickableComponent);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PosterImage(player, options) {
	    var _this;
	
	    _this = _ClickableComponent.call(this, player, options) || this;
	
	    _this.update();
	
	    _this.update_ = function (e) {
	      return _this.update(e);
	    };
	
	    player.on('posterchange', _this.update_);
	    return _this;
	  }
	  /**
	   * Clean up and dispose of the `PosterImage`.
	   */
	
	
	  var _proto = PosterImage.prototype;
	
	  _proto.dispose = function dispose() {
	    this.player().off('posterchange', this.update_);
	
	    _ClickableComponent.prototype.dispose.call(this);
	  }
	  /**
	   * Create the `PosterImage`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl$1() {
	    var el = createEl('div', {
	      className: 'vjs-poster',
	      // Don't want poster to be tabbable.
	      tabIndex: -1
	    });
	    return el;
	  }
	  /**
	   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
	   *
	   * @listens Player#posterchange
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `Player#posterchange` event that triggered this function.
	   */
	  ;
	
	  _proto.update = function update(event) {
	    var url = this.player().poster();
	    this.setSrc(url); // If there's no poster source we should display:none on this component
	    // so it's not still clickable or right-clickable
	
	    if (url) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  }
	  /**
	   * Set the source of the `PosterImage` depending on the display method.
	   *
	   * @param {string} url
	   *        The URL to the source for the `PosterImage`.
	   */
	  ;
	
	  _proto.setSrc = function setSrc(url) {
	    var backgroundImage = ''; // Any falsy value should stay as an empty string, otherwise
	    // this will throw an extra error
	
	    if (url) {
	      backgroundImage = "url(\"" + url + "\")";
	    }
	
	    this.el_.style.backgroundImage = backgroundImage;
	  }
	  /**
	   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
	   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
	   *
	   * @listens tap
	   * @listens click
	   * @listens keydown
	   *
	   * @param {EventTarget~Event} event
	   +        The `click`, `tap` or `keydown` event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    // We don't want a click to trigger playback when controls are disabled
	    if (!this.player_.controls()) {
	      return;
	    }
	
	    var sourceIsEncrypted = this.player_.usingPlugin('eme') && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
	
	    if (this.player_.tech(true) && // We've observed a bug in IE and Edge when playing back DRM content where
	    // calling .focus() on the video element causes the video to go black,
	    // so we avoid it in that specific case
	    !((IE_VERSION || IS_EDGE) && sourceIsEncrypted)) {
	      this.player_.tech(true).focus();
	    }
	
	    if (this.player_.paused()) {
	      silencePromise(this.player_.play());
	    } else {
	      this.player_.pause();
	    }
	  };
	
	  return PosterImage;
	}(ClickableComponent);
	
	Component$1.registerComponent('PosterImage', PosterImage);
	
	var darkGray = '#222';
	var lightGray = '#ccc';
	var fontMap = {
	  monospace: 'monospace',
	  sansSerif: 'sans-serif',
	  serif: 'serif',
	  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
	  monospaceSerif: '"Courier New", monospace',
	  proportionalSansSerif: 'sans-serif',
	  proportionalSerif: 'serif',
	  casual: '"Comic Sans MS", Impact, fantasy',
	  script: '"Monotype Corsiva", cursive',
	  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
	};
	/**
	 * Construct an rgba color from a given hex color code.
	 *
	 * @param {number} color
	 *        Hex number for color, like #f0e or #f604e2.
	 *
	 * @param {number} opacity
	 *        Value for opacity, 0.0 - 1.0.
	 *
	 * @return {string}
	 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
	 */
	
	function constructColor(color, opacity) {
	  var hex;
	
	  if (color.length === 4) {
	    // color looks like "#f0e"
	    hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
	  } else if (color.length === 7) {
	    // color looks like "#f604e2"
	    hex = color.slice(1);
	  } else {
	    throw new Error('Invalid color code provided, ' + color + '; must be formatted as e.g. #f0e or #f604e2.');
	  }
	
	  return 'rgba(' + parseInt(hex.slice(0, 2), 16) + ',' + parseInt(hex.slice(2, 4), 16) + ',' + parseInt(hex.slice(4, 6), 16) + ',' + opacity + ')';
	}
	/**
	 * Try to update the style of a DOM element. Some style changes will throw an error,
	 * particularly in IE8. Those should be noops.
	 *
	 * @param {Element} el
	 *        The DOM element to be styled.
	 *
	 * @param {string} style
	 *        The CSS property on the element that should be styled.
	 *
	 * @param {string} rule
	 *        The style rule that should be applied to the property.
	 *
	 * @private
	 */
	
	function tryUpdateStyle(el, style, rule) {
	  try {
	    el.style[style] = rule;
	  } catch (e) {
	    // Satisfies linter.
	    return;
	  }
	}
	/**
	 * The component for displaying text track cues.
	 *
	 * @extends Component
	 */
	
	
	var TextTrackDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TextTrackDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when `TextTrackDisplay` is ready.
	   */
	  function TextTrackDisplay(player, options, ready) {
	    var _this;
	
	    _this = _Component.call(this, player, options, ready) || this;
	
	    var updateDisplayHandler = function updateDisplayHandler(e) {
	      return _this.updateDisplay(e);
	    };
	
	    player.on('loadstart', function (e) {
	      return _this.toggleDisplay(e);
	    });
	    player.on('texttrackchange', updateDisplayHandler);
	    player.on('loadedmetadata', function (e) {
	      return _this.preselectTrack(e);
	    }); // This used to be called during player init, but was causing an error
	    // if a track should show by default and the display hadn't loaded yet.
	    // Should probably be moved to an external track loader when we support
	    // tracks that don't need a display.
	
	    player.ready(bind(_assertThisInitialized__default['default'](_this), function () {
	      if (player.tech_ && player.tech_.featuresNativeTextTracks) {
	        this.hide();
	        return;
	      }
	
	      player.on('fullscreenchange', updateDisplayHandler);
	      player.on('playerresize', updateDisplayHandler);
	      window__default['default'].addEventListener('orientationchange', updateDisplayHandler);
	      player.on('dispose', function () {
	        return window__default['default'].removeEventListener('orientationchange', updateDisplayHandler);
	      });
	      var tracks = this.options_.playerOptions.tracks || [];
	
	      for (var i = 0; i < tracks.length; i++) {
	        this.player_.addRemoteTextTrack(tracks[i], true);
	      }
	
	      this.preselectTrack();
	    }));
	    return _this;
	  }
	  /**
	  * Preselect a track following this precedence:
	  * - matches the previously selected {@link TextTrack}'s language and kind
	  * - matches the previously selected {@link TextTrack}'s language only
	  * - is the first default captions track
	  * - is the first default descriptions track
	  *
	  * @listens Player#loadstart
	  */
	
	
	  var _proto = TextTrackDisplay.prototype;
	
	  _proto.preselectTrack = function preselectTrack() {
	    var modes = {
	      captions: 1,
	      subtitles: 1
	    };
	    var trackList = this.player_.textTracks();
	    var userPref = this.player_.cache_.selectedLanguage;
	    var firstDesc;
	    var firstCaptions;
	    var preferredTrack;
	
	    for (var i = 0; i < trackList.length; i++) {
	      var track = trackList[i];
	
	      if (userPref && userPref.enabled && userPref.language && userPref.language === track.language && track.kind in modes) {
	        // Always choose the track that matches both language and kind
	        if (track.kind === userPref.kind) {
	          preferredTrack = track; // or choose the first track that matches language
	        } else if (!preferredTrack) {
	          preferredTrack = track;
	        } // clear everything if offTextTrackMenuItem was clicked
	
	      } else if (userPref && !userPref.enabled) {
	        preferredTrack = null;
	        firstDesc = null;
	        firstCaptions = null;
	      } else if (track["default"]) {
	        if (track.kind === 'descriptions' && !firstDesc) {
	          firstDesc = track;
	        } else if (track.kind in modes && !firstCaptions) {
	          firstCaptions = track;
	        }
	      }
	    } // The preferredTrack matches the user preference and takes
	    // precedence over all the other tracks.
	    // So, display the preferredTrack before the first default track
	    // and the subtitles/captions track before the descriptions track
	
	
	    if (preferredTrack) {
	      preferredTrack.mode = 'showing';
	    } else if (firstCaptions) {
	      firstCaptions.mode = 'showing';
	    } else if (firstDesc) {
	      firstDesc.mode = 'showing';
	    }
	  }
	  /**
	   * Turn display of {@link TextTrack}'s from the current state into the other state.
	   * There are only two states:
	   * - 'shown'
	   * - 'hidden'
	   *
	   * @listens Player#loadstart
	   */
	  ;
	
	  _proto.toggleDisplay = function toggleDisplay() {
	    if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  }
	  /**
	   * Create the {@link Component}'s DOM element.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-text-track-display'
	    }, {
	      'translate': 'yes',
	      'aria-live': 'off',
	      'aria-atomic': 'true'
	    });
	  }
	  /**
	   * Clear all displayed {@link TextTrack}s.
	   */
	  ;
	
	  _proto.clearDisplay = function clearDisplay() {
	    if (typeof window__default['default'].WebVTT === 'function') {
	      window__default['default'].WebVTT.processCues(window__default['default'], [], this.el_);
	    }
	  }
	  /**
	   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
	   * a {@link Player#fullscreenchange} is fired.
	   *
	   * @listens Player#texttrackchange
	   * @listens Player#fullscreenchange
	   */
	  ;
	
	  _proto.updateDisplay = function updateDisplay() {
	    var tracks = this.player_.textTracks();
	    var allowMultipleShowingTracks = this.options_.allowMultipleShowingTracks;
	    this.clearDisplay();
	
	    if (allowMultipleShowingTracks) {
	      var showingTracks = [];
	
	      for (var _i = 0; _i < tracks.length; ++_i) {
	        var track = tracks[_i];
	
	        if (track.mode !== 'showing') {
	          continue;
	        }
	
	        showingTracks.push(track);
	      }
	
	      this.updateForTrack(showingTracks);
	      return;
	    } //  Track display prioritization model: if multiple tracks are 'showing',
	    //  display the first 'subtitles' or 'captions' track which is 'showing',
	    //  otherwise display the first 'descriptions' track which is 'showing'
	
	
	    var descriptionsTrack = null;
	    var captionsSubtitlesTrack = null;
	    var i = tracks.length;
	
	    while (i--) {
	      var _track = tracks[i];
	
	      if (_track.mode === 'showing') {
	        if (_track.kind === 'descriptions') {
	          descriptionsTrack = _track;
	        } else {
	          captionsSubtitlesTrack = _track;
	        }
	      }
	    }
	
	    if (captionsSubtitlesTrack) {
	      if (this.getAttribute('aria-live') !== 'off') {
	        this.setAttribute('aria-live', 'off');
	      }
	
	      this.updateForTrack(captionsSubtitlesTrack);
	    } else if (descriptionsTrack) {
	      if (this.getAttribute('aria-live') !== 'assertive') {
	        this.setAttribute('aria-live', 'assertive');
	      }
	
	      this.updateForTrack(descriptionsTrack);
	    }
	  }
	  /**
	   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
	   *
	   * @param {TextTrack} track
	   *        Text track object containing active cues to style.
	   */
	  ;
	
	  _proto.updateDisplayState = function updateDisplayState(track) {
	    var overrides = this.player_.textTrackSettings.getValues();
	    var cues = track.activeCues;
	    var i = cues.length;
	
	    while (i--) {
	      var cue = cues[i];
	
	      if (!cue) {
	        continue;
	      }
	
	      var cueDiv = cue.displayState;
	
	      if (overrides.color) {
	        cueDiv.firstChild.style.color = overrides.color;
	      }
	
	      if (overrides.textOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'color', constructColor(overrides.color || '#fff', overrides.textOpacity));
	      }
	
	      if (overrides.backgroundColor) {
	        cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
	      }
	
	      if (overrides.backgroundOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'backgroundColor', constructColor(overrides.backgroundColor || '#000', overrides.backgroundOpacity));
	      }
	
	      if (overrides.windowColor) {
	        if (overrides.windowOpacity) {
	          tryUpdateStyle(cueDiv, 'backgroundColor', constructColor(overrides.windowColor, overrides.windowOpacity));
	        } else {
	          cueDiv.style.backgroundColor = overrides.windowColor;
	        }
	      }
	
	      if (overrides.edgeStyle) {
	        if (overrides.edgeStyle === 'dropshadow') {
	          cueDiv.firstChild.style.textShadow = "2px 2px 3px " + darkGray + ", 2px 2px 4px " + darkGray + ", 2px 2px 5px " + darkGray;
	        } else if (overrides.edgeStyle === 'raised') {
	          cueDiv.firstChild.style.textShadow = "1px 1px " + darkGray + ", 2px 2px " + darkGray + ", 3px 3px " + darkGray;
	        } else if (overrides.edgeStyle === 'depressed') {
	          cueDiv.firstChild.style.textShadow = "1px 1px " + lightGray + ", 0 1px " + lightGray + ", -1px -1px " + darkGray + ", 0 -1px " + darkGray;
	        } else if (overrides.edgeStyle === 'uniform') {
	          cueDiv.firstChild.style.textShadow = "0 0 4px " + darkGray + ", 0 0 4px " + darkGray + ", 0 0 4px " + darkGray + ", 0 0 4px " + darkGray;
	        }
	      }
	
	      if (overrides.fontPercent && overrides.fontPercent !== 1) {
	        var fontSize = window__default['default'].parseFloat(cueDiv.style.fontSize);
	        cueDiv.style.fontSize = fontSize * overrides.fontPercent + 'px';
	        cueDiv.style.height = 'auto';
	        cueDiv.style.top = 'auto';
	      }
	
	      if (overrides.fontFamily && overrides.fontFamily !== 'default') {
	        if (overrides.fontFamily === 'small-caps') {
	          cueDiv.firstChild.style.fontVariant = 'small-caps';
	        } else {
	          cueDiv.firstChild.style.fontFamily = fontMap[overrides.fontFamily];
	        }
	      }
	    }
	  }
	  /**
	   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
	   *
	   * @param {TextTrack|TextTrack[]} tracks
	   *        Text track object or text track array to be added to the list.
	   */
	  ;
	
	  _proto.updateForTrack = function updateForTrack(tracks) {
	    if (!Array.isArray(tracks)) {
	      tracks = [tracks];
	    }
	
	    if (typeof window__default['default'].WebVTT !== 'function' || tracks.every(function (track) {
	      return !track.activeCues;
	    })) {
	      return;
	    }
	
	    var cues = []; // push all active track cues
	
	    for (var i = 0; i < tracks.length; ++i) {
	      var track = tracks[i];
	
	      for (var j = 0; j < track.activeCues.length; ++j) {
	        cues.push(track.activeCues[j]);
	      }
	    } // removes all cues before it processes new ones
	
	
	    window__default['default'].WebVTT.processCues(window__default['default'], cues, this.el_); // add unique class to each language text track & add settings styling if necessary
	
	    for (var _i2 = 0; _i2 < tracks.length; ++_i2) {
	      var _track2 = tracks[_i2];
	
	      for (var _j = 0; _j < _track2.activeCues.length; ++_j) {
	        var cueEl = _track2.activeCues[_j].displayState;
	        addClass(cueEl, 'vjs-text-track-cue');
	        addClass(cueEl, 'vjs-text-track-cue-' + (_track2.language ? _track2.language : _i2));
	
	        if (_track2.language) {
	          setAttribute(cueEl, 'lang', _track2.language);
	        }
	      }
	
	      if (this.player_.textTrackSettings) {
	        this.updateDisplayState(_track2);
	      }
	    }
	  };
	
	  return TextTrackDisplay;
	}(Component$1);
	
	Component$1.registerComponent('TextTrackDisplay', TextTrackDisplay);
	
	/**
	 * A loading spinner for use during waiting/loading events.
	 *
	 * @extends Component
	 */
	
	var LoadingSpinner = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LoadingSpinner, _Component);
	
	  function LoadingSpinner() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = LoadingSpinner.prototype;
	
	  /**
	   * Create the `LoadingSpinner`s DOM element.
	   *
	   * @return {Element}
	   *         The dom element that gets created.
	   */
	  _proto.createEl = function createEl$1() {
	    var isAudio = this.player_.isAudio();
	    var playerType = this.localize(isAudio ? 'Audio Player' : 'Video Player');
	    var controlText = createEl('span', {
	      className: 'vjs-control-text',
	      textContent: this.localize('{1} is loading.', [playerType])
	    });
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-loading-spinner',
	      dir: 'ltr'
	    });
	
	    el.appendChild(controlText);
	    return el;
	  };
	
	  return LoadingSpinner;
	}(Component$1);
	
	Component$1.registerComponent('LoadingSpinner', LoadingSpinner);
	
	/**
	 * Base class for all buttons.
	 *
	 * @extends ClickableComponent
	 */
	
	var Button = /*#__PURE__*/function (_ClickableComponent) {
	  _inheritsLoose__default['default'](Button, _ClickableComponent);
	
	  function Button() {
	    return _ClickableComponent.apply(this, arguments) || this;
	  }
	
	  var _proto = Button.prototype;
	
	  /**
	   * Create the `Button`s DOM element.
	   *
	   * @param {string} [tag="button"]
	   *        The element's node type. This argument is IGNORED: no matter what
	   *        is passed, it will always create a `button` element.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  _proto.createEl = function createEl$1(tag, props, attributes) {
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    tag = 'button';
	    props = assign({
	      className: this.buildCSSClass()
	    }, props); // Add attributes for button element
	
	    attributes = assign({
	      // Necessary since the default button type is "submit"
	      type: 'button'
	    }, attributes);
	
	    var el = createEl(tag, props, attributes);
	
	    el.appendChild(createEl('span', {
	      className: 'vjs-icon-placeholder'
	    }, {
	      'aria-hidden': true
	    }));
	    this.createControlTextEl(el);
	    return el;
	  }
	  /**
	   * Add a child `Component` inside of this `Button`.
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   *
	   * @deprecated since version 5
	   */
	  ;
	
	  _proto.addChild = function addChild(child, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var className = this.constructor.name;
	    log$1.warn("Adding an actionable (user controllable) child to a Button (" + className + ") is not supported; use a ClickableComponent instead."); // Avoid the error message generated by ClickableComponent's addChild method
	
	    return Component$1.prototype.addChild.call(this, child, options);
	  }
	  /**
	   * Enable the `Button` element so that it can be activated or clicked. Use this with
	   * {@link Button#disable}.
	   */
	  ;
	
	  _proto.enable = function enable() {
	    _ClickableComponent.prototype.enable.call(this);
	
	    this.el_.removeAttribute('disabled');
	  }
	  /**
	   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
	   * {@link Button#enable}.
	   */
	  ;
	
	  _proto.disable = function disable() {
	    _ClickableComponent.prototype.disable.call(this);
	
	    this.el_.setAttribute('disabled', 'disabled');
	  }
	  /**
	   * This gets called when a `Button` has focus and `keydown` is triggered via a key
	   * press.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to get called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Ignore Space or Enter key operation, which is handled by the browser for
	    // a button - though not for its super class, ClickableComponent. Also,
	    // prevent the event from propagating through the DOM and triggering Player
	    // hotkeys. We do not preventDefault here because we _want_ the browser to
	    // handle it.
	    if (keycode__default['default'].isEventKey(event, 'Space') || keycode__default['default'].isEventKey(event, 'Enter')) {
	      event.stopPropagation();
	      return;
	    } // Pass keypress handling up for unsupported keys
	
	
	    _ClickableComponent.prototype.handleKeyDown.call(this, event);
	  };
	
	  return Button;
	}(ClickableComponent);
	
	Component$1.registerComponent('Button', Button);
	
	/**
	 * The initial play button that shows before the video has played. The hiding of the
	 * `BigPlayButton` get done via CSS and `Player` states.
	 *
	 * @extends Button
	 */
	
	var BigPlayButton = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](BigPlayButton, _Button);
	
	  function BigPlayButton(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	    _this.mouseused_ = false;
	
	    _this.on('mousedown', function (e) {
	      return _this.handleMouseDown(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
	   */
	
	
	  var _proto = BigPlayButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-big-play-button';
	  }
	  /**
	   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    var playPromise = this.player_.play(); // exit early if clicked via the mouse
	
	    if (this.mouseused_ && event.clientX && event.clientY) {
	      var sourceIsEncrypted = this.player_.usingPlugin('eme') && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
	      silencePromise(playPromise);
	
	      if (this.player_.tech(true) && // We've observed a bug in IE and Edge when playing back DRM content where
	      // calling .focus() on the video element causes the video to go black,
	      // so we avoid it in that specific case
	      !((IE_VERSION || IS_EDGE) && sourceIsEncrypted)) {
	        this.player_.tech(true).focus();
	      }
	
	      return;
	    }
	
	    var cb = this.player_.getChild('controlBar');
	    var playToggle = cb && cb.getChild('playToggle');
	
	    if (!playToggle) {
	      this.player_.tech(true).focus();
	      return;
	    }
	
	    var playFocus = function playFocus() {
	      return playToggle.focus();
	    };
	
	    if (isPromise(playPromise)) {
	      playPromise.then(playFocus, function () {});
	    } else {
	      this.setTimeout(playFocus, 1);
	    }
	  };
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    this.mouseused_ = false;
	
	    _Button.prototype.handleKeyDown.call(this, event);
	  };
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    this.mouseused_ = true;
	  };
	
	  return BigPlayButton;
	}(Button);
	/**
	 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	BigPlayButton.prototype.controlText_ = 'Play Video';
	Component$1.registerComponent('BigPlayButton', BigPlayButton);
	
	/**
	 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
	 * it gets clicked.
	 *
	 * @extends Button
	 */
	
	var CloseButton = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](CloseButton, _Button);
	
	  /**
	  * Creates an instance of the this class.
	  *
	  * @param  {Player} player
	  *         The `Player` that this class should be attached to.
	  *
	  * @param  {Object} [options]
	  *         The key/value store of player options.
	  */
	  function CloseButton(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.controlText(options && options.controlText || _this.localize('Close'));
	
	    return _this;
	  }
	  /**
	  * Builds the default DOM `className`.
	  *
	  * @return {string}
	  *         The DOM `className` for this object.
	  */
	
	
	  var _proto = CloseButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-close-button " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * This gets called when a `CloseButton` gets clicked. See
	   * {@link ClickableComponent#handleClick} for more information on when
	   * this will be triggered
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   * @fires CloseButton#close
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    /**
	     * Triggered when the a `CloseButton` is clicked.
	     *
	     * @event CloseButton#close
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the close event does not
	     *           bubble up to parents if there is no listener
	     */
	    this.trigger({
	      type: 'close',
	      bubbles: false
	    });
	  }
	  /**
	   * Event handler that is called when a `CloseButton` receives a
	   * `keydown` event.
	   *
	   * By default, if the key is Esc, it will trigger a `click` event.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Esc button will trigger `click` event
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.trigger('click');
	    } else {
	      // Pass keypress handling up for unsupported keys
	      _Button.prototype.handleKeyDown.call(this, event);
	    }
	  };
	
	  return CloseButton;
	}(Button);
	
	Component$1.registerComponent('CloseButton', CloseButton);
	
	/**
	 * Button to toggle between play and pause.
	 *
	 * @extends Button
	 */
	
	var PlayToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](PlayToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function PlayToggle(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _Button.call(this, player, options) || this; // show or hide replay icon
	
	    options.replay = options.replay === undefined || options.replay;
	
	    _this.on(player, 'play', function (e) {
	      return _this.handlePlay(e);
	    });
	
	    _this.on(player, 'pause', function (e) {
	      return _this.handlePause(e);
	    });
	
	    if (options.replay) {
	      _this.on(player, 'ended', function (e) {
	        return _this.handleEnded(e);
	      });
	    }
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = PlayToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-play-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * This gets called when an `PlayToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.player_.paused()) {
	      silencePromise(this.player_.play());
	    } else {
	      this.player_.pause();
	    }
	  }
	  /**
	   * This gets called once after the video has ended and the user seeks so that
	   * we can change the replay button back to a play button.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#seeked
	   */
	  ;
	
	  _proto.handleSeeked = function handleSeeked(event) {
	    this.removeClass('vjs-ended');
	
	    if (this.player_.paused()) {
	      this.handlePause(event);
	    } else {
	      this.handlePlay(event);
	    }
	  }
	  /**
	   * Add the vjs-playing class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#play
	   */
	  ;
	
	  _proto.handlePlay = function handlePlay(event) {
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing'); // change the button text to "Pause"
	
	    this.controlText('Pause');
	  }
	  /**
	   * Add the vjs-paused class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#pause
	   */
	  ;
	
	  _proto.handlePause = function handlePause(event) {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused'); // change the button text to "Play"
	
	    this.controlText('Play');
	  }
	  /**
	   * Add the vjs-ended class to the element so it can change appearance
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#ended
	   */
	  ;
	
	  _proto.handleEnded = function handleEnded(event) {
	    var _this2 = this;
	
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-ended'); // change the button text to "Replay"
	
	    this.controlText('Replay'); // on the next seek remove the replay button
	
	    this.one(this.player_, 'seeked', function (e) {
	      return _this2.handleSeeked(e);
	    });
	  };
	
	  return PlayToggle;
	}(Button);
	/**
	 * The text that should display over the `PlayToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlayToggle.prototype.controlText_ = 'Play';
	Component$1.registerComponent('PlayToggle', PlayToggle);
	
	/**
	 * @file format-time.js
	 * @module format-time
	 */
	
	/**
	 * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
	 * seconds) will force a number of leading zeros to cover the length of the
	 * guide.
	 *
	 * @private
	 * @param  {number} seconds
	 *         Number of seconds to be turned into a string
	 *
	 * @param  {number} guide
	 *         Number (in seconds) to model the string after
	 *
	 * @return {string}
	 *         Time formatted as H:MM:SS or M:SS
	 */
	var defaultImplementation = function defaultImplementation(seconds, guide) {
	  seconds = seconds < 0 ? 0 : seconds;
	  var s = Math.floor(seconds % 60);
	  var m = Math.floor(seconds / 60 % 60);
	  var h = Math.floor(seconds / 3600);
	  var gm = Math.floor(guide / 60 % 60);
	  var gh = Math.floor(guide / 3600); // handle invalid times
	
	  if (isNaN(seconds) || seconds === Infinity) {
	    // '-' is false for all relational operators (e.g. <, >=) so this setting
	    // will add the minimum number of fields specified by the guide
	    h = m = s = '-';
	  } // Check if we need to show hours
	
	
	  h = h > 0 || gh > 0 ? h + ':' : ''; // If hours are showing, we may need to add a leading zero.
	  // Always show at least one digit of minutes.
	
	  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':'; // Check if leading zero is need for seconds
	
	  s = s < 10 ? '0' + s : s;
	  return h + m + s;
	}; // Internal pointer to the current implementation.
	
	
	var implementation = defaultImplementation;
	/**
	 * Replaces the default formatTime implementation with a custom implementation.
	 *
	 * @param {Function} customImplementation
	 *        A function which will be used in place of the default formatTime
	 *        implementation. Will receive the current time in seconds and the
	 *        guide (in seconds) as arguments.
	 */
	
	function setFormatTime(customImplementation) {
	  implementation = customImplementation;
	}
	/**
	 * Resets formatTime to the default implementation.
	 */
	
	function resetFormatTime() {
	  implementation = defaultImplementation;
	}
	/**
	 * Delegates to either the default time formatting function or a custom
	 * function supplied via `setFormatTime`.
	 *
	 * Formats seconds as a time string (H:MM:SS or M:SS). Supplying a
	 * guide (in seconds) will force a number of leading zeros to cover the
	 * length of the guide.
	 *
	 * @static
	 * @example  formatTime(125, 600) === "02:05"
	 * @param    {number} seconds
	 *           Number of seconds to be turned into a string
	 *
	 * @param    {number} guide
	 *           Number (in seconds) to model the string after
	 *
	 * @return   {string}
	 *           Time formatted as H:MM:SS or M:SS
	 */
	
	function formatTime(seconds, guide) {
	  if (guide === void 0) {
	    guide = seconds;
	  }
	
	  return implementation(seconds, guide);
	}
	
	/**
	 * Displays time information about the video
	 *
	 * @extends Component
	 */
	
	var TimeDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TimeDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.on(player, ['timeupdate', 'ended'], function (e) {
	      return _this.updateContent(e);
	    });
	
	    _this.updateTextNode_();
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = TimeDisplay.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var className = this.buildCSSClass();
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: className + " vjs-time-control vjs-control"
	    });
	
	    var span = createEl('span', {
	      className: 'vjs-control-text',
	      textContent: this.localize(this.labelText_) + "\xA0"
	    }, {
	      role: 'presentation'
	    });
	    el.appendChild(span);
	    this.contentEl_ = createEl('span', {
	      className: className + "-display"
	    }, {
	      // tell screen readers not to automatically read the time as it changes
	      'aria-live': 'off',
	      // span elements have no implicit role, but some screen readers (notably VoiceOver)
	      // treat them as a break between items in the DOM when using arrow keys
	      // (or left-to-right swipes on iOS) to read contents of a page. Using
	      // role='presentation' causes VoiceOver to NOT treat this span as a break.
	      'role': 'presentation'
	    });
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.textNode_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Updates the time display text node with a new time
	   *
	   * @param {number} [time=0] the time to update to
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateTextNode_ = function updateTextNode_(time) {
	    var _this2 = this;
	
	    if (time === void 0) {
	      time = 0;
	    }
	
	    time = formatTime(time);
	
	    if (this.formattedTime_ === time) {
	      return;
	    }
	
	    this.formattedTime_ = time;
	    this.requestNamedAnimationFrame('TimeDisplay#updateTextNode_', function () {
	      if (!_this2.contentEl_) {
	        return;
	      }
	
	      var oldNode = _this2.textNode_;
	
	      if (oldNode && _this2.contentEl_.firstChild !== oldNode) {
	        oldNode = null;
	        log$1.warn('TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.');
	      }
	
	      _this2.textNode_ = document__default['default'].createTextNode(_this2.formattedTime_);
	
	      if (!_this2.textNode_) {
	        return;
	      }
	
	      if (oldNode) {
	        _this2.contentEl_.replaceChild(_this2.textNode_, oldNode);
	      } else {
	        _this2.contentEl_.appendChild(_this2.textNode_);
	      }
	    });
	  }
	  /**
	   * To be filled out in the child class, should update the displayed time
	   * in accordance with the fact that the current time has changed.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate`  event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {};
	
	  return TimeDisplay;
	}(Component$1);
	/**
	 * The text that is added to the `TimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	TimeDisplay.prototype.labelText_ = 'Time';
	/**
	 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	TimeDisplay.prototype.controlText_ = 'Time';
	Component$1.registerComponent('TimeDisplay', TimeDisplay);
	
	/**
	 * Displays the current time
	 *
	 * @extends Component
	 */
	
	var CurrentTimeDisplay = /*#__PURE__*/function (_TimeDisplay) {
	  _inheritsLoose__default['default'](CurrentTimeDisplay, _TimeDisplay);
	
	  function CurrentTimeDisplay() {
	    return _TimeDisplay.apply(this, arguments) || this;
	  }
	
	  var _proto = CurrentTimeDisplay.prototype;
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-current-time';
	  }
	  /**
	   * Update current time display
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` event that caused this function to run.
	   *
	   * @listens Player#timeupdate
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {
	    // Allows for smooth scrubbing, when player can't keep up.
	    var time;
	
	    if (this.player_.ended()) {
	      time = this.player_.duration();
	    } else {
	      time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	    }
	
	    this.updateTextNode_(time);
	  };
	
	  return CurrentTimeDisplay;
	}(TimeDisplay);
	/**
	 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	CurrentTimeDisplay.prototype.labelText_ = 'Current Time';
	/**
	 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	CurrentTimeDisplay.prototype.controlText_ = 'Current Time';
	Component$1.registerComponent('CurrentTimeDisplay', CurrentTimeDisplay);
	
	/**
	 * Displays the duration
	 *
	 * @extends Component
	 */
	
	var DurationDisplay = /*#__PURE__*/function (_TimeDisplay) {
	  _inheritsLoose__default['default'](DurationDisplay, _TimeDisplay);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function DurationDisplay(player, options) {
	    var _this;
	
	    _this = _TimeDisplay.call(this, player, options) || this;
	
	    var updateContent = function updateContent(e) {
	      return _this.updateContent(e);
	    }; // we do not want to/need to throttle duration changes,
	    // as they should always display the changed duration as
	    // it has changed
	
	
	    _this.on(player, 'durationchange', updateContent); // Listen to loadstart because the player duration is reset when a new media element is loaded,
	    // but the durationchange on the user agent will not fire.
	    // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
	
	
	    _this.on(player, 'loadstart', updateContent); // Also listen for timeupdate (in the parent) and loadedmetadata because removing those
	    // listeners could have broken dependent applications/libraries. These
	    // can likely be removed for 7.0.
	
	
	    _this.on(player, 'loadedmetadata', updateContent);
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = DurationDisplay.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-duration';
	  }
	  /**
	   * Update duration time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
	   *        this function to be called.
	   *
	   * @listens Player#durationchange
	   * @listens Player#timeupdate
	   * @listens Player#loadedmetadata
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {
	    var duration = this.player_.duration();
	    this.updateTextNode_(duration);
	  };
	
	  return DurationDisplay;
	}(TimeDisplay);
	/**
	 * The text that is added to the `DurationDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	DurationDisplay.prototype.labelText_ = 'Duration';
	/**
	 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	DurationDisplay.prototype.controlText_ = 'Duration';
	Component$1.registerComponent('DurationDisplay', DurationDisplay);
	
	/**
	 * The separator between the current time and duration.
	 * Can be hidden if it's not needed in the design.
	 *
	 * @extends Component
	 */
	
	var TimeDivider = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TimeDivider, _Component);
	
	  function TimeDivider() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = TimeDivider.prototype;
	
	  /**
	   * Create the component's DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  _proto.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-time-control vjs-time-divider'
	    }, {
	      // this element and its contents can be hidden from assistive techs since
	      // it is made extraneous by the announcement of the control text
	      // for the current time and duration displays
	      'aria-hidden': true
	    });
	
	    var div = _Component.prototype.createEl.call(this, 'div');
	
	    var span = _Component.prototype.createEl.call(this, 'span', {
	      textContent: '/'
	    });
	
	    div.appendChild(span);
	    el.appendChild(div);
	    return el;
	  };
	
	  return TimeDivider;
	}(Component$1);
	
	Component$1.registerComponent('TimeDivider', TimeDivider);
	
	/**
	 * Displays the time left in the video
	 *
	 * @extends Component
	 */
	
	var RemainingTimeDisplay = /*#__PURE__*/function (_TimeDisplay) {
	  _inheritsLoose__default['default'](RemainingTimeDisplay, _TimeDisplay);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function RemainingTimeDisplay(player, options) {
	    var _this;
	
	    _this = _TimeDisplay.call(this, player, options) || this;
	
	    _this.on(player, 'durationchange', function (e) {
	      return _this.updateContent(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = RemainingTimeDisplay.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return 'vjs-remaining-time';
	  }
	  /**
	   * Create the `Component`'s DOM element with the "minus" characted prepend to the time
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl$1() {
	    var el = _TimeDisplay.prototype.createEl.call(this);
	
	    if (this.options_.displayNegative !== false) {
	      el.insertBefore(createEl('span', {}, {
	        'aria-hidden': true
	      }, '-'), this.contentEl_);
	    }
	
	    return el;
	  }
	  /**
	   * Update remaining time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `durationchange` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   * @listens Player#durationchange
	   */
	  ;
	
	  _proto.updateContent = function updateContent(event) {
	    if (typeof this.player_.duration() !== 'number') {
	      return;
	    }
	
	    var time; // @deprecated We should only use remainingTimeDisplay
	    // as of video.js 7
	
	    if (this.player_.ended()) {
	      time = 0;
	    } else if (this.player_.remainingTimeDisplay) {
	      time = this.player_.remainingTimeDisplay();
	    } else {
	      time = this.player_.remainingTime();
	    }
	
	    this.updateTextNode_(time);
	  };
	
	  return RemainingTimeDisplay;
	}(TimeDisplay);
	/**
	 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	RemainingTimeDisplay.prototype.labelText_ = 'Remaining Time';
	/**
	 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 *
	 * @deprecated in v7; controlText_ is not used in non-active display Components
	 */
	
	RemainingTimeDisplay.prototype.controlText_ = 'Remaining Time';
	Component$1.registerComponent('RemainingTimeDisplay', RemainingTimeDisplay);
	
	/**
	 * Displays the live indicator when duration is Infinity.
	 *
	 * @extends Component
	 */
	
	var LiveDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LiveDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LiveDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.updateShowing();
	
	    _this.on(_this.player(), 'durationchange', function (e) {
	      return _this.updateShowing(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = LiveDisplay.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-live-control vjs-control'
	    });
	
	    this.contentEl_ = createEl('div', {
	      className: 'vjs-live-display'
	    }, {
	      'aria-live': 'off'
	    });
	    this.contentEl_.appendChild(createEl('span', {
	      className: 'vjs-control-text',
	      textContent: this.localize('Stream Type') + "\xA0"
	    }));
	    this.contentEl_.appendChild(document__default['default'].createTextNode(this.localize('LIVE')));
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
	   * it accordingly
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#durationchange} event that caused this function to run.
	   *
	   * @listens Player#durationchange
	   */
	  ;
	
	  _proto.updateShowing = function updateShowing(event) {
	    if (this.player().duration() === Infinity) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  };
	
	  return LiveDisplay;
	}(Component$1);
	
	Component$1.registerComponent('LiveDisplay', LiveDisplay);
	
	/**
	 * Displays the live indicator when duration is Infinity.
	 *
	 * @extends Component
	 */
	
	var SeekToLive = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](SeekToLive, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function SeekToLive(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.updateLiveEdgeStatus();
	
	    if (_this.player_.liveTracker) {
	      _this.updateLiveEdgeStatusHandler_ = function (e) {
	        return _this.updateLiveEdgeStatus(e);
	      };
	
	      _this.on(_this.player_.liveTracker, 'liveedgechange', _this.updateLiveEdgeStatusHandler_);
	    }
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = SeekToLive.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _Button.prototype.createEl.call(this, 'button', {
	      className: 'vjs-seek-to-live-control vjs-control'
	    });
	
	    this.textEl_ = createEl('span', {
	      className: 'vjs-seek-to-live-text',
	      textContent: this.localize('LIVE')
	    }, {
	      'aria-hidden': 'true'
	    });
	    el.appendChild(this.textEl_);
	    return el;
	  }
	  /**
	   * Update the state of this button if we are at the live edge
	   * or not
	   */
	  ;
	
	  _proto.updateLiveEdgeStatus = function updateLiveEdgeStatus() {
	    // default to live edge
	    if (!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge()) {
	      this.setAttribute('aria-disabled', true);
	      this.addClass('vjs-at-live-edge');
	      this.controlText('Seek to live, currently playing live');
	    } else {
	      this.setAttribute('aria-disabled', false);
	      this.removeClass('vjs-at-live-edge');
	      this.controlText('Seek to live, currently behind live');
	    }
	  }
	  /**
	   * On click bring us as near to the live point as possible.
	   * This requires that we wait for the next `live-seekable-change`
	   * event which will happen every segment length seconds.
	   */
	  ;
	
	  _proto.handleClick = function handleClick() {
	    this.player_.liveTracker.seekToLiveEdge();
	  }
	  /**
	   * Dispose of the element and stop tracking
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    if (this.player_.liveTracker) {
	      this.off(this.player_.liveTracker, 'liveedgechange', this.updateLiveEdgeStatusHandler_);
	    }
	
	    this.textEl_ = null;
	
	    _Button.prototype.dispose.call(this);
	  };
	
	  return SeekToLive;
	}(Button);
	
	SeekToLive.prototype.controlText_ = 'Seek to live, currently playing live';
	Component$1.registerComponent('SeekToLive', SeekToLive);
	
	/**
	 * Keep a number between a min and a max value
	 *
	 * @param {number} number
	 *        The number to clamp
	 *
	 * @param {number} min
	 *        The minimum value
	 * @param {number} max
	 *        The maximum value
	 *
	 * @return {number}
	 *         the clamped number
	 */
	var clamp = function clamp(number, min, max) {
	  number = Number(number);
	  return Math.min(max, Math.max(min, isNaN(number) ? min : number));
	};
	
	/**
	 * The base functionality for a slider. Can be vertical or horizontal.
	 * For instance the volume bar or the seek bar on a video is a slider.
	 *
	 * @extends Component
	 */
	
	var Slider = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Slider, _Component);
	
	  /**
	  * Create an instance of this class
	  *
	  * @param {Player} player
	  *        The `Player` that this class should be attached to.
	  *
	  * @param {Object} [options]
	  *        The key/value store of player options.
	  */
	  function Slider(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    _this.handleMouseDown_ = function (e) {
	      return _this.handleMouseDown(e);
	    };
	
	    _this.handleMouseUp_ = function (e) {
	      return _this.handleMouseUp(e);
	    };
	
	    _this.handleKeyDown_ = function (e) {
	      return _this.handleKeyDown(e);
	    };
	
	    _this.handleClick_ = function (e) {
	      return _this.handleClick(e);
	    };
	
	    _this.handleMouseMove_ = function (e) {
	      return _this.handleMouseMove(e);
	    };
	
	    _this.update_ = function (e) {
	      return _this.update(e);
	    }; // Set property names to bar to match with the child Slider class is looking for
	
	
	    _this.bar = _this.getChild(_this.options_.barName); // Set a horizontal or vertical class on the slider depending on the slider type
	
	    _this.vertical(!!_this.options_.vertical);
	
	    _this.enable();
	
	    return _this;
	  }
	  /**
	   * Are controls are currently enabled for this slider or not.
	   *
	   * @return {boolean}
	   *         true if controls are enabled, false otherwise
	   */
	
	
	  var _proto = Slider.prototype;
	
	  _proto.enabled = function enabled() {
	    return this.enabled_;
	  }
	  /**
	   * Enable controls for this slider if they are disabled
	   */
	  ;
	
	  _proto.enable = function enable() {
	    if (this.enabled()) {
	      return;
	    }
	
	    this.on('mousedown', this.handleMouseDown_);
	    this.on('touchstart', this.handleMouseDown_);
	    this.on('keydown', this.handleKeyDown_);
	    this.on('click', this.handleClick_); // TODO: deprecated, controlsvisible does not seem to be fired
	
	    this.on(this.player_, 'controlsvisible', this.update);
	
	    if (this.playerEvent) {
	      this.on(this.player_, this.playerEvent, this.update);
	    }
	
	    this.removeClass('disabled');
	    this.setAttribute('tabindex', 0);
	    this.enabled_ = true;
	  }
	  /**
	   * Disable controls for this slider if they are enabled
	   */
	  ;
	
	  _proto.disable = function disable() {
	    if (!this.enabled()) {
	      return;
	    }
	
	    var doc = this.bar.el_.ownerDocument;
	    this.off('mousedown', this.handleMouseDown_);
	    this.off('touchstart', this.handleMouseDown_);
	    this.off('keydown', this.handleKeyDown_);
	    this.off('click', this.handleClick_);
	    this.off(this.player_, 'controlsvisible', this.update_);
	    this.off(doc, 'mousemove', this.handleMouseMove_);
	    this.off(doc, 'mouseup', this.handleMouseUp_);
	    this.off(doc, 'touchmove', this.handleMouseMove_);
	    this.off(doc, 'touchend', this.handleMouseUp_);
	    this.removeAttribute('tabindex');
	    this.addClass('disabled');
	
	    if (this.playerEvent) {
	      this.off(this.player_, this.playerEvent, this.update);
	    }
	
	    this.enabled_ = false;
	  }
	  /**
	   * Create the `Slider`s DOM element.
	   *
	   * @param {string} type
	   *        Type of element to create.
	   *
	   * @param {Object} [props={}]
	   *        List of properties in Object form.
	   *
	   * @param {Object} [attributes={}]
	   *        list of attributes in Object form.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl(type, props, attributes) {
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    // Add the slider element class to all sub classes
	    props.className = props.className + ' vjs-slider';
	    props = assign({
	      tabIndex: 0
	    }, props);
	    attributes = assign({
	      'role': 'slider',
	      'aria-valuenow': 0,
	      'aria-valuemin': 0,
	      'aria-valuemax': 100,
	      'tabIndex': 0
	    }, attributes);
	    return _Component.prototype.createEl.call(this, type, props, attributes);
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   * @fires Slider#slideractive
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.bar.el_.ownerDocument;
	
	    if (event.type === 'mousedown') {
	      event.preventDefault();
	    } // Do not call preventDefault() on touchstart in Chrome
	    // to avoid console warnings. Use a 'touch-action: none' style
	    // instead to prevent unintented scrolling.
	    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	
	    if (event.type === 'touchstart' && !IS_CHROME) {
	      event.preventDefault();
	    }
	
	    blockTextSelection();
	    this.addClass('vjs-sliding');
	    /**
	     * Triggered when the slider is in an active state
	     *
	     * @event Slider#slideractive
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('slideractive');
	    this.on(doc, 'mousemove', this.handleMouseMove_);
	    this.on(doc, 'mouseup', this.handleMouseUp_);
	    this.on(doc, 'touchmove', this.handleMouseMove_);
	    this.on(doc, 'touchend', this.handleMouseUp_);
	    this.handleMouseMove(event, true);
	  }
	  /**
	   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
	   * The `mousemove` and `touchmove` events will only only trigger this function during
	   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
	   * {@link Slider#handleMouseUp}.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
	   *        this function
	   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
	   *
	   * @listens mousemove
	   * @listens touchmove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {}
	  /**
	   * Handle `mouseup` or `touchend` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   * @fires Slider#sliderinactive
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp() {
	    var doc = this.bar.el_.ownerDocument;
	    unblockTextSelection();
	    this.removeClass('vjs-sliding');
	    /**
	     * Triggered when the slider is no longer in an active state.
	     *
	     * @event Slider#sliderinactive
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('sliderinactive');
	    this.off(doc, 'mousemove', this.handleMouseMove_);
	    this.off(doc, 'mouseup', this.handleMouseUp_);
	    this.off(doc, 'touchmove', this.handleMouseMove_);
	    this.off(doc, 'touchend', this.handleMouseUp_);
	    this.update();
	  }
	  /**
	   * Update the progress bar of the `Slider`.
	   *
	   * @return {number}
	   *          The percentage of progress the progress bar represents as a
	   *          number from 0 to 1.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this2 = this;
	
	    // In VolumeBar init we have a setTimeout for update that pops and update
	    // to the end of the execution stack. The player is destroyed before then
	    // update will cause an error
	    // If there's no bar...
	    if (!this.el_ || !this.bar) {
	      return;
	    } // clamp progress between 0 and 1
	    // and only round to four decimal places, as we round to two below
	
	
	    var progress = this.getProgress();
	
	    if (progress === this.progress_) {
	      return progress;
	    }
	
	    this.progress_ = progress;
	    this.requestNamedAnimationFrame('Slider#update', function () {
	      // Set the new bar width or height
	      var sizeKey = _this2.vertical() ? 'height' : 'width'; // Convert to a percentage for css value
	
	      _this2.bar.el().style[sizeKey] = (progress * 100).toFixed(2) + '%';
	    });
	    return progress;
	  }
	  /**
	   * Get the percentage of the bar that should be filled
	   * but clamped and rounded.
	   *
	   * @return {number}
	   *         percentage filled that the slider is
	   */
	  ;
	
	  _proto.getProgress = function getProgress() {
	    return Number(clamp(this.getPercent(), 0, 1).toFixed(4));
	  }
	  /**
	   * Calculate distance for slider
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @return {number}
	   *         The current position of the Slider.
	   *         - position.x for vertical `Slider`s
	   *         - position.y for horizontal `Slider`s
	   */
	  ;
	
	  _proto.calculateDistance = function calculateDistance(event) {
	    var position = getPointerPosition(this.el_, event);
	
	    if (this.vertical()) {
	      return position.y;
	    }
	
	    return position.x;
	  }
	  /**
	   * Handle a `keydown` event on the `Slider`. Watches for left, rigth, up, and down
	   * arrow keys. This function will only be called when the slider has focus. See
	   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
	   *
	   * @param {EventTarget~Event} event
	   *        the `keydown` event that caused this function to run.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Left and Down Arrows
	    if (keycode__default['default'].isEventKey(event, 'Left') || keycode__default['default'].isEventKey(event, 'Down')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepBack(); // Up and Right Arrows
	    } else if (keycode__default['default'].isEventKey(event, 'Right') || keycode__default['default'].isEventKey(event, 'Up')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepForward();
	    } else {
	      // Pass keydown handling up for unsupported keys
	      _Component.prototype.handleKeyDown.call(this, event);
	    }
	  }
	  /**
	   * Listener for click events on slider, used to prevent clicks
	   *   from bubbling up to parent elements like button menus.
	   *
	   * @param {Object} event
	   *        Event that caused this object to run
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    event.stopPropagation();
	    event.preventDefault();
	  }
	  /**
	   * Get/set if slider is horizontal for vertical
	   *
	   * @param {boolean} [bool]
	   *        - true if slider is vertical,
	   *        - false is horizontal
	   *
	   * @return {boolean}
	   *         - true if slider is vertical, and getting
	   *         - false if the slider is horizontal, and getting
	   */
	  ;
	
	  _proto.vertical = function vertical(bool) {
	    if (bool === undefined) {
	      return this.vertical_ || false;
	    }
	
	    this.vertical_ = !!bool;
	
	    if (this.vertical_) {
	      this.addClass('vjs-slider-vertical');
	    } else {
	      this.addClass('vjs-slider-horizontal');
	    }
	  };
	
	  return Slider;
	}(Component$1);
	
	Component$1.registerComponent('Slider', Slider);
	
	var percentify = function percentify(time, end) {
	  return clamp(time / end * 100, 0, 100).toFixed(2) + '%';
	};
	/**
	 * Shows loading progress
	 *
	 * @extends Component
	 */
	
	
	var LoadProgressBar = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LoadProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LoadProgressBar(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.partEls_ = [];
	
	    _this.on(player, 'progress', function (e) {
	      return _this.update(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = LoadProgressBar.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-load-progress'
	    });
	
	    var wrapper = createEl('span', {
	      className: 'vjs-control-text'
	    });
	    var loadedText = createEl('span', {
	      textContent: this.localize('Loaded')
	    });
	    var separator = document__default['default'].createTextNode(': ');
	    this.percentageEl_ = createEl('span', {
	      className: 'vjs-control-text-loaded-percentage',
	      textContent: '0%'
	    });
	    el.appendChild(wrapper);
	    wrapper.appendChild(loadedText);
	    wrapper.appendChild(separator);
	    wrapper.appendChild(this.percentageEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.partEls_ = null;
	    this.percentageEl_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Update progress bar
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `progress` event that caused this function to run.
	   *
	   * @listens Player#progress
	   */
	  ;
	
	  _proto.update = function update(event) {
	    var _this2 = this;
	
	    this.requestNamedAnimationFrame('LoadProgressBar#update', function () {
	      var liveTracker = _this2.player_.liveTracker;
	
	      var buffered = _this2.player_.buffered();
	
	      var duration = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : _this2.player_.duration();
	
	      var bufferedEnd = _this2.player_.bufferedEnd();
	
	      var children = _this2.partEls_;
	      var percent = percentify(bufferedEnd, duration);
	
	      if (_this2.percent_ !== percent) {
	        // update the width of the progress bar
	        _this2.el_.style.width = percent; // update the control-text
	
	        textContent(_this2.percentageEl_, percent);
	        _this2.percent_ = percent;
	      } // add child elements to represent the individual buffered time ranges
	
	
	      for (var i = 0; i < buffered.length; i++) {
	        var start = buffered.start(i);
	        var end = buffered.end(i);
	        var part = children[i];
	
	        if (!part) {
	          part = _this2.el_.appendChild(createEl());
	          children[i] = part;
	        } //  only update if changed
	
	
	        if (part.dataset.start === start && part.dataset.end === end) {
	          continue;
	        }
	
	        part.dataset.start = start;
	        part.dataset.end = end; // set the percent based on the width of the progress bar (bufferedEnd)
	
	        part.style.left = percentify(start, bufferedEnd);
	        part.style.width = percentify(end - start, bufferedEnd);
	      } // remove unused buffered range elements
	
	
	      for (var _i = children.length; _i > buffered.length; _i--) {
	        _this2.el_.removeChild(children[_i - 1]);
	      }
	
	      children.length = buffered.length;
	    });
	  };
	
	  return LoadProgressBar;
	}(Component$1);
	
	Component$1.registerComponent('LoadProgressBar', LoadProgressBar);
	
	/**
	 * Time tooltips display a time above the progress bar.
	 *
	 * @extends Component
	 */
	
	var TimeTooltip = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](TimeTooltip, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TimeTooltip(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the time tooltip DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = TimeTooltip.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-time-tooltip'
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Updates the position of the time tooltip relative to the `SeekBar`.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	  ;
	
	  _proto.update = function update(seekBarRect, seekBarPoint, content) {
	    var tooltipRect = findPosition(this.el_);
	    var playerRect = getBoundingClientRect(this.player_.el());
	    var seekBarPointPx = seekBarRect.width * seekBarPoint; // do nothing if either rect isn't available
	    // for example, if the player isn't in the DOM for testing
	
	    if (!playerRect || !tooltipRect) {
	      return;
	    } // This is the space left of the `seekBarPoint` available within the bounds
	    // of the player. We calculate any gap between the left edge of the player
	    // and the left edge of the `SeekBar` and add the number of pixels in the
	    // `SeekBar` before hitting the `seekBarPoint`
	
	
	    var spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx; // This is the space right of the `seekBarPoint` available within the bounds
	    // of the player. We calculate the number of pixels from the `seekBarPoint`
	    // to the right edge of the `SeekBar` and add to that any gap between the
	    // right edge of the `SeekBar` and the player.
	
	    var spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right); // This is the number of pixels by which the tooltip will need to be pulled
	    // further to the right to center it over the `seekBarPoint`.
	
	    var pullTooltipBy = tooltipRect.width / 2; // Adjust the `pullTooltipBy` distance to the left or right depending on
	    // the results of the space calculations above.
	
	    if (spaceLeftOfPoint < pullTooltipBy) {
	      pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
	    } else if (spaceRightOfPoint < pullTooltipBy) {
	      pullTooltipBy = spaceRightOfPoint;
	    } // Due to the imprecision of decimal/ratio based calculations and varying
	    // rounding behaviors, there are cases where the spacing adjustment is off
	    // by a pixel or two. This adds insurance to these calculations.
	
	
	    if (pullTooltipBy < 0) {
	      pullTooltipBy = 0;
	    } else if (pullTooltipBy > tooltipRect.width) {
	      pullTooltipBy = tooltipRect.width;
	    } // prevent small width fluctuations within 0.4px from
	    // changing the value below.
	    // This really helps for live to prevent the play
	    // progress time tooltip from jittering
	
	
	    pullTooltipBy = Math.round(pullTooltipBy);
	    this.el_.style.right = "-" + pullTooltipBy + "px";
	    this.write(content);
	  }
	  /**
	   * Write the time to the tooltip DOM element.
	   *
	   * @param {string} content
	   *        The formatted time for the tooltip.
	   */
	  ;
	
	  _proto.write = function write(content) {
	    textContent(this.el_, content);
	  }
	  /**
	   * Updates the position of the time tooltip relative to the `SeekBar`.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   *
	   * @param {number} time
	   *        The time to update the tooltip to, not used during live playback
	   *
	   * @param {Function} cb
	   *        A function that will be called during the request animation frame
	   *        for tooltips that need to do additional animations from the default
	   */
	  ;
	
	  _proto.updateTime = function updateTime(seekBarRect, seekBarPoint, time, cb) {
	    var _this2 = this;
	
	    this.requestNamedAnimationFrame('TimeTooltip#updateTime', function () {
	      var content;
	
	      var duration = _this2.player_.duration();
	
	      if (_this2.player_.liveTracker && _this2.player_.liveTracker.isLive()) {
	        var liveWindow = _this2.player_.liveTracker.liveWindow();
	
	        var secondsBehind = liveWindow - seekBarPoint * liveWindow;
	        content = (secondsBehind < 1 ? '' : '-') + formatTime(secondsBehind, liveWindow);
	      } else {
	        content = formatTime(time, duration);
	      }
	
	      _this2.update(seekBarRect, seekBarPoint, content);
	
	      if (cb) {
	        cb();
	      }
	    });
	  };
	
	  return TimeTooltip;
	}(Component$1);
	
	Component$1.registerComponent('TimeTooltip', TimeTooltip);
	
	/**
	 * Used by {@link SeekBar} to display media playback progress as part of the
	 * {@link ProgressControl}.
	 *
	 * @extends Component
	 */
	
	var PlayProgressBar = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](PlayProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlayProgressBar(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = PlayProgressBar.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-play-progress vjs-slider-bar'
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Enqueues updates to its own DOM as well as the DOM of its
	   * {@link TimeTooltip} child.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	  ;
	
	  _proto.update = function update(seekBarRect, seekBarPoint) {
	    var timeTooltip = this.getChild('timeTooltip');
	
	    if (!timeTooltip) {
	      return;
	    }
	
	    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	    timeTooltip.updateTime(seekBarRect, seekBarPoint, time);
	  };
	
	  return PlayProgressBar;
	}(Component$1);
	/**
	 * Default options for {@link PlayProgressBar}.
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	PlayProgressBar.prototype.options_ = {
	  children: []
	}; // Time tooltips should not be added to a player on mobile devices
	
	if (!IS_IOS && !IS_ANDROID) {
	  PlayProgressBar.prototype.options_.children.push('timeTooltip');
	}
	
	Component$1.registerComponent('PlayProgressBar', PlayProgressBar);
	
	/**
	 * The {@link MouseTimeDisplay} component tracks mouse movement over the
	 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
	 * indicating the time which is represented by a given point in the
	 * {@link ProgressControl}.
	 *
	 * @extends Component
	 */
	
	var MouseTimeDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MouseTimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MouseTimeDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = MouseTimeDisplay.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-mouse-display'
	    });
	  }
	  /**
	   * Enqueues updates to its own DOM as well as the DOM of its
	   * {@link TimeTooltip} child.
	   *
	   * @param {Object} seekBarRect
	   *        The `ClientRect` for the {@link SeekBar} element.
	   *
	   * @param {number} seekBarPoint
	   *        A number from 0 to 1, representing a horizontal reference point
	   *        from the left edge of the {@link SeekBar}
	   */
	  ;
	
	  _proto.update = function update(seekBarRect, seekBarPoint) {
	    var _this2 = this;
	
	    var time = seekBarPoint * this.player_.duration();
	    this.getChild('timeTooltip').updateTime(seekBarRect, seekBarPoint, time, function () {
	      _this2.el_.style.left = seekBarRect.width * seekBarPoint + "px";
	    });
	  };
	
	  return MouseTimeDisplay;
	}(Component$1);
	/**
	 * Default options for `MouseTimeDisplay`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	MouseTimeDisplay.prototype.options_ = {
	  children: ['timeTooltip']
	};
	Component$1.registerComponent('MouseTimeDisplay', MouseTimeDisplay);
	
	var STEP_SECONDS = 5; // The multiplier of STEP_SECONDS that PgUp/PgDown move the timeline.
	
	var PAGE_KEY_MULTIPLIER = 12;
	/**
	 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
	 * as its `bar`.
	 *
	 * @extends Slider
	 */
	
	var SeekBar = /*#__PURE__*/function (_Slider) {
	  _inheritsLoose__default['default'](SeekBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function SeekBar(player, options) {
	    var _this;
	
	    _this = _Slider.call(this, player, options) || this;
	
	    _this.setEventHandlers_();
	
	    return _this;
	  }
	  /**
	   * Sets the event handlers
	   *
	   * @private
	   */
	
	
	  var _proto = SeekBar.prototype;
	
	  _proto.setEventHandlers_ = function setEventHandlers_() {
	    var _this2 = this;
	
	    this.update_ = bind(this, this.update);
	    this.update = throttle(this.update_, UPDATE_REFRESH_INTERVAL);
	    this.on(this.player_, ['ended', 'durationchange', 'timeupdate'], this.update);
	
	    if (this.player_.liveTracker) {
	      this.on(this.player_.liveTracker, 'liveedgechange', this.update);
	    } // when playing, let's ensure we smoothly update the play progress bar
	    // via an interval
	
	
	    this.updateInterval = null;
	
	    this.enableIntervalHandler_ = function (e) {
	      return _this2.enableInterval_(e);
	    };
	
	    this.disableIntervalHandler_ = function (e) {
	      return _this2.disableInterval_(e);
	    };
	
	    this.on(this.player_, ['playing'], this.enableIntervalHandler_);
	    this.on(this.player_, ['ended', 'pause', 'waiting'], this.disableIntervalHandler_); // we don't need to update the play progress if the document is hidden,
	    // also, this causes the CPU to spike and eventually crash the page on IE11.
	
	    if ('hidden' in document__default['default'] && 'visibilityState' in document__default['default']) {
	      this.on(document__default['default'], 'visibilitychange', this.toggleVisibility_);
	    }
	  };
	
	  _proto.toggleVisibility_ = function toggleVisibility_(e) {
	    if (document__default['default'].visibilityState === 'hidden') {
	      this.cancelNamedAnimationFrame('SeekBar#update');
	      this.cancelNamedAnimationFrame('Slider#update');
	      this.disableInterval_(e);
	    } else {
	      if (!this.player_.ended() && !this.player_.paused()) {
	        this.enableInterval_();
	      } // we just switched back to the page and someone may be looking, so, update ASAP
	
	
	      this.update();
	    }
	  };
	
	  _proto.enableInterval_ = function enableInterval_() {
	    if (this.updateInterval) {
	      return;
	    }
	
	    this.updateInterval = this.setInterval(this.update, UPDATE_REFRESH_INTERVAL);
	  };
	
	  _proto.disableInterval_ = function disableInterval_(e) {
	    if (this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== 'ended') {
	      return;
	    }
	
	    if (!this.updateInterval) {
	      return;
	    }
	
	    this.clearInterval(this.updateInterval);
	    this.updateInterval = null;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-holder'
	    }, {
	      'aria-label': this.localize('Progress Bar')
	    });
	  }
	  /**
	   * This function updates the play progress bar and accessibility
	   * attributes to whatever is passed in.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `ended` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   *
	   * @return {number}
	   *          The current percent at a number from 0-1
	   */
	  ;
	
	  _proto.update = function update(event) {
	    var _this3 = this;
	
	    // ignore updates while the tab is hidden
	    if (document__default['default'].visibilityState === 'hidden') {
	      return;
	    }
	
	    var percent = _Slider.prototype.update.call(this);
	
	    this.requestNamedAnimationFrame('SeekBar#update', function () {
	      var currentTime = _this3.player_.ended() ? _this3.player_.duration() : _this3.getCurrentTime_();
	      var liveTracker = _this3.player_.liveTracker;
	
	      var duration = _this3.player_.duration();
	
	      if (liveTracker && liveTracker.isLive()) {
	        duration = _this3.player_.liveTracker.liveCurrentTime();
	      }
	
	      if (_this3.percent_ !== percent) {
	        // machine readable value of progress bar (percentage complete)
	        _this3.el_.setAttribute('aria-valuenow', (percent * 100).toFixed(2));
	
	        _this3.percent_ = percent;
	      }
	
	      if (_this3.currentTime_ !== currentTime || _this3.duration_ !== duration) {
	        // human readable value of progress bar (time complete)
	        _this3.el_.setAttribute('aria-valuetext', _this3.localize('progress bar timing: currentTime={1} duration={2}', [formatTime(currentTime, duration), formatTime(duration, duration)], '{1} of {2}'));
	
	        _this3.currentTime_ = currentTime;
	        _this3.duration_ = duration;
	      } // update the progress bar time tooltip with the current time
	
	
	      if (_this3.bar) {
	        _this3.bar.update(getBoundingClientRect(_this3.el()), _this3.getProgress());
	      }
	    });
	    return percent;
	  }
	  /**
	   * Prevent liveThreshold from causing seeks to seem like they
	   * are not happening from a user perspective.
	   *
	   * @param {number} ct
	   *        current time to seek to
	   */
	  ;
	
	  _proto.userSeek_ = function userSeek_(ct) {
	    if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
	      this.player_.liveTracker.nextSeekedFromUser();
	    }
	
	    this.player_.currentTime(ct);
	  }
	  /**
	   * Get the value of current time but allows for smooth scrubbing,
	   * when player can't keep up.
	   *
	   * @return {number}
	   *         The current time value to display
	   *
	   * @private
	   */
	  ;
	
	  _proto.getCurrentTime_ = function getCurrentTime_() {
	    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	  }
	  /**
	   * Get the percentage of media played so far.
	   *
	   * @return {number}
	   *         The percentage of media played so far (0 to 1).
	   */
	  ;
	
	  _proto.getPercent = function getPercent() {
	    var currentTime = this.getCurrentTime_();
	    var percent;
	    var liveTracker = this.player_.liveTracker;
	
	    if (liveTracker && liveTracker.isLive()) {
	      percent = (currentTime - liveTracker.seekableStart()) / liveTracker.liveWindow(); // prevent the percent from changing at the live edge
	
	      if (liveTracker.atLiveEdge()) {
	        percent = 1;
	      }
	    } else {
	      percent = currentTime / this.player_.duration();
	    }
	
	    return percent;
	  }
	  /**
	   * Handle mouse down on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousedown` event that caused this to run.
	   *
	   * @listens mousedown
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    } // Stop event propagation to prevent double fire in progress-control.js
	
	
	    event.stopPropagation();
	    this.videoWasPlaying = !this.player_.paused();
	    this.player_.pause();
	
	    _Slider.prototype.handleMouseDown.call(this, event);
	  }
	  /**
	   * Handle mouse move on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this to run.
	   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
	   *
	   * @listens mousemove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event, mouseDown) {
	    if (mouseDown === void 0) {
	      mouseDown = false;
	    }
	
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    if (!mouseDown && !this.player_.scrubbing()) {
	      this.player_.scrubbing(true);
	    }
	
	    var newTime;
	    var distance = this.calculateDistance(event);
	    var liveTracker = this.player_.liveTracker;
	
	    if (!liveTracker || !liveTracker.isLive()) {
	      newTime = distance * this.player_.duration(); // Don't let video end while scrubbing.
	
	      if (newTime === this.player_.duration()) {
	        newTime = newTime - 0.1;
	      }
	    } else {
	      if (distance >= 0.99) {
	        liveTracker.seekToLiveEdge();
	        return;
	      }
	
	      var seekableStart = liveTracker.seekableStart();
	      var seekableEnd = liveTracker.liveCurrentTime();
	      newTime = seekableStart + distance * liveTracker.liveWindow(); // Don't let video end while scrubbing.
	
	      if (newTime >= seekableEnd) {
	        newTime = seekableEnd;
	      } // Compensate for precision differences so that currentTime is not less
	      // than seekable start
	
	
	      if (newTime <= seekableStart) {
	        newTime = seekableStart + 0.1;
	      } // On android seekableEnd can be Infinity sometimes,
	      // this will cause newTime to be Infinity, which is
	      // not a valid currentTime.
	
	
	      if (newTime === Infinity) {
	        return;
	      }
	    } // Set new time (tell player to seek to new time)
	
	
	    this.userSeek_(newTime);
	  };
	
	  _proto.enable = function enable() {
	    _Slider.prototype.enable.call(this);
	
	    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');
	
	    if (!mouseTimeDisplay) {
	      return;
	    }
	
	    mouseTimeDisplay.show();
	  };
	
	  _proto.disable = function disable() {
	    _Slider.prototype.disable.call(this);
	
	    var mouseTimeDisplay = this.getChild('mouseTimeDisplay');
	
	    if (!mouseTimeDisplay) {
	      return;
	    }
	
	    mouseTimeDisplay.hide();
	  }
	  /**
	   * Handle mouse up on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseup` event that caused this to run.
	   *
	   * @listens mouseup
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp(event) {
	    _Slider.prototype.handleMouseUp.call(this, event); // Stop event propagation to prevent double fire in progress-control.js
	
	
	    if (event) {
	      event.stopPropagation();
	    }
	
	    this.player_.scrubbing(false);
	    /**
	     * Trigger timeupdate because we're done seeking and the time has changed.
	     * This is particularly useful for if the player is paused to time the time displays.
	     *
	     * @event Tech#timeupdate
	     * @type {EventTarget~Event}
	     */
	
	    this.player_.trigger({
	      type: 'timeupdate',
	      target: this,
	      manuallyTriggered: true
	    });
	
	    if (this.videoWasPlaying) {
	      silencePromise(this.player_.play());
	    } else {
	      // We're done seeking and the time has changed.
	      // If the player is paused, make sure we display the correct time on the seek bar.
	      this.update_();
	    }
	  }
	  /**
	   * Move more quickly fast forward for keyboard-only users
	   */
	  ;
	
	  _proto.stepForward = function stepForward() {
	    this.userSeek_(this.player_.currentTime() + STEP_SECONDS);
	  }
	  /**
	   * Move more quickly rewind for keyboard-only users
	   */
	  ;
	
	  _proto.stepBack = function stepBack() {
	    this.userSeek_(this.player_.currentTime() - STEP_SECONDS);
	  }
	  /**
	   * Toggles the playback state of the player
	   * This gets called when enter or space is used on the seekbar
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called
	   *
	   */
	  ;
	
	  _proto.handleAction = function handleAction(event) {
	    if (this.player_.paused()) {
	      this.player_.play();
	    } else {
	      this.player_.pause();
	    }
	  }
	  /**
	   * Called when this SeekBar has focus and a key gets pressed down.
	   * Supports the following keys:
	   *
	   *   Space or Enter key fire a click event
	   *   Home key moves to start of the timeline
	   *   End key moves to end of the timeline
	   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
	   *   PageDown key moves back a larger step than ArrowDown
	   *   PageUp key moves forward a large step
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    var liveTracker = this.player_.liveTracker;
	
	    if (keycode__default['default'].isEventKey(event, 'Space') || keycode__default['default'].isEventKey(event, 'Enter')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.handleAction(event);
	    } else if (keycode__default['default'].isEventKey(event, 'Home')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.userSeek_(0);
	    } else if (keycode__default['default'].isEventKey(event, 'End')) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      if (liveTracker && liveTracker.isLive()) {
	        this.userSeek_(liveTracker.liveCurrentTime());
	      } else {
	        this.userSeek_(this.player_.duration());
	      }
	    } else if (/^[0-9]$/.test(keycode__default['default'](event))) {
	      event.preventDefault();
	      event.stopPropagation();
	      var gotoFraction = (keycode__default['default'].codes[keycode__default['default'](event)] - keycode__default['default'].codes['0']) * 10.0 / 100.0;
	
	      if (liveTracker && liveTracker.isLive()) {
	        this.userSeek_(liveTracker.seekableStart() + liveTracker.liveWindow() * gotoFraction);
	      } else {
	        this.userSeek_(this.player_.duration() * gotoFraction);
	      }
	    } else if (keycode__default['default'].isEventKey(event, 'PgDn')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.userSeek_(this.player_.currentTime() - STEP_SECONDS * PAGE_KEY_MULTIPLIER);
	    } else if (keycode__default['default'].isEventKey(event, 'PgUp')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.userSeek_(this.player_.currentTime() + STEP_SECONDS * PAGE_KEY_MULTIPLIER);
	    } else {
	      // Pass keydown handling up for unsupported keys
	      _Slider.prototype.handleKeyDown.call(this, event);
	    }
	  };
	
	  _proto.dispose = function dispose() {
	    this.disableInterval_();
	    this.off(this.player_, ['ended', 'durationchange', 'timeupdate'], this.update);
	
	    if (this.player_.liveTracker) {
	      this.off(this.player_.liveTracker, 'liveedgechange', this.update);
	    }
	
	    this.off(this.player_, ['playing'], this.enableIntervalHandler_);
	    this.off(this.player_, ['ended', 'pause', 'waiting'], this.disableIntervalHandler_); // we don't need to update the play progress if the document is hidden,
	    // also, this causes the CPU to spike and eventually crash the page on IE11.
	
	    if ('hidden' in document__default['default'] && 'visibilityState' in document__default['default']) {
	      this.off(document__default['default'], 'visibilitychange', this.toggleVisibility_);
	    }
	
	    _Slider.prototype.dispose.call(this);
	  };
	
	  return SeekBar;
	}(Slider);
	/**
	 * Default options for the `SeekBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	SeekBar.prototype.options_ = {
	  children: ['loadProgressBar', 'playProgressBar'],
	  barName: 'playProgressBar'
	}; // MouseTimeDisplay tooltips should not be added to a player on mobile devices
	
	if (!IS_IOS && !IS_ANDROID) {
	  SeekBar.prototype.options_.children.splice(1, 0, 'mouseTimeDisplay');
	}
	
	Component$1.registerComponent('SeekBar', SeekBar);
	
	/**
	 * The Progress Control component contains the seek bar, load progress,
	 * and play progress.
	 *
	 * @extends Component
	 */
	
	var ProgressControl = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ProgressControl, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function ProgressControl(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.handleMouseMove = throttle(bind(_assertThisInitialized__default['default'](_this), _this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
	    _this.throttledHandleMouseSeek = throttle(bind(_assertThisInitialized__default['default'](_this), _this.handleMouseSeek), UPDATE_REFRESH_INTERVAL);
	
	    _this.handleMouseUpHandler_ = function (e) {
	      return _this.handleMouseUp(e);
	    };
	
	    _this.handleMouseDownHandler_ = function (e) {
	      return _this.handleMouseDown(e);
	    };
	
	    _this.enable();
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = ProgressControl.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-control vjs-control'
	    });
	  }
	  /**
	   * When the mouse moves over the `ProgressControl`, the pointer position
	   * gets passed down to the `MouseTimeDisplay` component.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this function to run.
	   *
	   * @listen mousemove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (!seekBar) {
	      return;
	    }
	
	    var playProgressBar = seekBar.getChild('playProgressBar');
	    var mouseTimeDisplay = seekBar.getChild('mouseTimeDisplay');
	
	    if (!playProgressBar && !mouseTimeDisplay) {
	      return;
	    }
	
	    var seekBarEl = seekBar.el();
	    var seekBarRect = findPosition(seekBarEl);
	    var seekBarPoint = getPointerPosition(seekBarEl, event).x; // The default skin has a gap on either side of the `SeekBar`. This means
	    // that it's possible to trigger this behavior outside the boundaries of
	    // the `SeekBar`. This ensures we stay within it at all times.
	
	    seekBarPoint = clamp(seekBarPoint, 0, 1);
	
	    if (mouseTimeDisplay) {
	      mouseTimeDisplay.update(seekBarRect, seekBarPoint);
	    }
	
	    if (playProgressBar) {
	      playProgressBar.update(seekBarRect, seekBar.getProgress());
	    }
	  }
	  /**
	   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
	   *
	   * @method ProgressControl#throttledHandleMouseSeek
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this function to run.
	   *
	   * @listen mousemove
	   * @listen touchmove
	   */
	
	  /**
	   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousemove
	   * @listens touchmove
	   */
	  ;
	
	  _proto.handleMouseSeek = function handleMouseSeek(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseMove(event);
	    }
	  }
	  /**
	   * Are controls are currently enabled for this progress control.
	   *
	   * @return {boolean}
	   *         true if controls are enabled, false otherwise
	   */
	  ;
	
	  _proto.enabled = function enabled() {
	    return this.enabled_;
	  }
	  /**
	   * Disable all controls on the progress control and its children
	   */
	  ;
	
	  _proto.disable = function disable() {
	    this.children().forEach(function (child) {
	      return child.disable && child.disable();
	    });
	
	    if (!this.enabled()) {
	      return;
	    }
	
	    this.off(['mousedown', 'touchstart'], this.handleMouseDownHandler_);
	    this.off(this.el_, 'mousemove', this.handleMouseMove);
	    this.removeListenersAddedOnMousedownAndTouchstart();
	    this.addClass('disabled');
	    this.enabled_ = false; // Restore normal playback state if controls are disabled while scrubbing
	
	    if (this.player_.scrubbing()) {
	      var seekBar = this.getChild('seekBar');
	      this.player_.scrubbing(false);
	
	      if (seekBar.videoWasPlaying) {
	        silencePromise(this.player_.play());
	      }
	    }
	  }
	  /**
	   * Enable all controls on the progress control and its children
	   */
	  ;
	
	  _proto.enable = function enable() {
	    this.children().forEach(function (child) {
	      return child.enable && child.enable();
	    });
	
	    if (this.enabled()) {
	      return;
	    }
	
	    this.on(['mousedown', 'touchstart'], this.handleMouseDownHandler_);
	    this.on(this.el_, 'mousemove', this.handleMouseMove);
	    this.removeClass('disabled');
	    this.enabled_ = true;
	  }
	  /**
	   * Cleanup listeners after the user finishes interacting with the progress controls
	   */
	  ;
	
	  _proto.removeListenersAddedOnMousedownAndTouchstart = function removeListenersAddedOnMousedownAndTouchstart() {
	    var doc = this.el_.ownerDocument;
	    this.off(doc, 'mousemove', this.throttledHandleMouseSeek);
	    this.off(doc, 'touchmove', this.throttledHandleMouseSeek);
	    this.off(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.off(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.el_.ownerDocument;
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseDown(event);
	    }
	
	    this.on(doc, 'mousemove', this.throttledHandleMouseSeek);
	    this.on(doc, 'touchmove', this.throttledHandleMouseSeek);
	    this.on(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.on(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp(event) {
	    var seekBar = this.getChild('seekBar');
	
	    if (seekBar) {
	      seekBar.handleMouseUp(event);
	    }
	
	    this.removeListenersAddedOnMousedownAndTouchstart();
	  };
	
	  return ProgressControl;
	}(Component$1);
	/**
	 * Default options for `ProgressControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ProgressControl.prototype.options_ = {
	  children: ['seekBar']
	};
	Component$1.registerComponent('ProgressControl', ProgressControl);
	
	/**
	 * Toggle Picture-in-Picture mode
	 *
	 * @extends Button
	 */
	
	var PictureInPictureToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](PictureInPictureToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @listens Player#enterpictureinpicture
	   * @listens Player#leavepictureinpicture
	   */
	  function PictureInPictureToggle(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.on(player, ['enterpictureinpicture', 'leavepictureinpicture'], function (e) {
	      return _this.handlePictureInPictureChange(e);
	    });
	
	    _this.on(player, ['disablepictureinpicturechanged', 'loadedmetadata'], function (e) {
	      return _this.handlePictureInPictureEnabledChange(e);
	    });
	
	    _this.on(player, ['loadedmetadata', 'audioonlymodechange', 'audiopostermodechange'], function () {
	      // This audio detection will not detect HLS or DASH audio-only streams because there was no reliable way to detect them at the time
	      var isSourceAudio = player.currentType().substring(0, 5) === 'audio';
	
	      if (isSourceAudio || player.audioPosterMode() || player.audioOnlyMode()) {
	        if (player.isInPictureInPicture()) {
	          player.exitPictureInPicture();
	        }
	
	        _this.hide();
	      } else {
	        _this.show();
	      }
	    }); // TODO: Deactivate button on player emptied event.
	
	
	    _this.disable();
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = PictureInPictureToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-picture-in-picture-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Enables or disables button based on document.pictureInPictureEnabled property value
	   * or on value returned by player.disablePictureInPicture() method.
	   */
	  ;
	
	  _proto.handlePictureInPictureEnabledChange = function handlePictureInPictureEnabledChange() {
	    if (document__default['default'].pictureInPictureEnabled && this.player_.disablePictureInPicture() === false) {
	      this.enable();
	    } else {
	      this.disable();
	    }
	  }
	  /**
	   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
	   *        called.
	   *
	   * @listens Player#enterpictureinpicture
	   * @listens Player#leavepictureinpicture
	   */
	  ;
	
	  _proto.handlePictureInPictureChange = function handlePictureInPictureChange(event) {
	    if (this.player_.isInPictureInPicture()) {
	      this.controlText('Exit Picture-in-Picture');
	    } else {
	      this.controlText('Picture-in-Picture');
	    }
	
	    this.handlePictureInPictureEnabledChange();
	  }
	  /**
	   * This gets called when an `PictureInPictureToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (!this.player_.isInPictureInPicture()) {
	      this.player_.requestPictureInPicture();
	    } else {
	      this.player_.exitPictureInPicture();
	    }
	  };
	
	  return PictureInPictureToggle;
	}(Button);
	/**
	 * The text that should display over the `PictureInPictureToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PictureInPictureToggle.prototype.controlText_ = 'Picture-in-Picture';
	Component$1.registerComponent('PictureInPictureToggle', PictureInPictureToggle);
	
	/**
	 * Toggle fullscreen video
	 *
	 * @extends Button
	 */
	
	var FullscreenToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](FullscreenToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function FullscreenToggle(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this;
	
	    _this.on(player, 'fullscreenchange', function (e) {
	      return _this.handleFullscreenChange(e);
	    });
	
	    if (document__default['default'][player.fsApi_.fullscreenEnabled] === false) {
	      _this.disable();
	    }
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = FullscreenToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-fullscreen-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Handles fullscreenchange on the player and change control text accordingly.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#fullscreenchange} event that caused this function to be
	   *        called.
	   *
	   * @listens Player#fullscreenchange
	   */
	  ;
	
	  _proto.handleFullscreenChange = function handleFullscreenChange(event) {
	    if (this.player_.isFullscreen()) {
	      this.controlText('Non-Fullscreen');
	    } else {
	      this.controlText('Fullscreen');
	    }
	  }
	  /**
	   * This gets called when an `FullscreenToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (!this.player_.isFullscreen()) {
	      this.player_.requestFullscreen();
	    } else {
	      this.player_.exitFullscreen();
	    }
	  };
	
	  return FullscreenToggle;
	}(Button);
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	FullscreenToggle.prototype.controlText_ = 'Fullscreen';
	Component$1.registerComponent('FullscreenToggle', FullscreenToggle);
	
	/**
	 * Check if volume control is supported and if it isn't hide the
	 * `Component` that was passed  using the `vjs-hidden` class.
	 *
	 * @param {Component} self
	 *        The component that should be hidden if volume is unsupported
	 *
	 * @param {Player} player
	 *        A reference to the player
	 *
	 * @private
	 */
	var checkVolumeSupport = function checkVolumeSupport(self, player) {
	  // hide volume controls when they're not supported by the current tech
	  if (player.tech_ && !player.tech_.featuresVolumeControl) {
	    self.addClass('vjs-hidden');
	  }
	
	  self.on(player, 'loadstart', function () {
	    if (!player.tech_.featuresVolumeControl) {
	      self.addClass('vjs-hidden');
	    } else {
	      self.removeClass('vjs-hidden');
	    }
	  });
	};
	
	/**
	 * Shows volume level
	 *
	 * @extends Component
	 */
	
	var VolumeLevel = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumeLevel, _Component);
	
	  function VolumeLevel() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = VolumeLevel.prototype;
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  _proto.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-level'
	    });
	
	    el.appendChild(_Component.prototype.createEl.call(this, 'span', {
	      className: 'vjs-control-text'
	    }));
	    return el;
	  };
	
	  return VolumeLevel;
	}(Component$1);
	
	Component$1.registerComponent('VolumeLevel', VolumeLevel);
	
	/**
	 * Volume level tooltips display a volume above or side by side the volume bar.
	 *
	 * @extends Component
	 */
	
	var VolumeLevelTooltip = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumeLevelTooltip, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function VolumeLevelTooltip(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the volume tooltip DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = VolumeLevelTooltip.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-tooltip'
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Updates the position of the tooltip relative to the `VolumeBar` and
	   * its content text.
	   *
	   * @param {Object} rangeBarRect
	   *        The `ClientRect` for the {@link VolumeBar} element.
	   *
	   * @param {number} rangeBarPoint
	   *        A number from 0 to 1, representing a horizontal/vertical reference point
	   *        from the left edge of the {@link VolumeBar}
	   *
	   * @param {boolean} vertical
	   *        Referees to the Volume control position
	   *        in the control bar{@link VolumeControl}
	   *
	   */
	  ;
	
	  _proto.update = function update(rangeBarRect, rangeBarPoint, vertical, content) {
	    if (!vertical) {
	      var tooltipRect = getBoundingClientRect(this.el_);
	      var playerRect = getBoundingClientRect(this.player_.el());
	      var volumeBarPointPx = rangeBarRect.width * rangeBarPoint;
	
	      if (!playerRect || !tooltipRect) {
	        return;
	      }
	
	      var spaceLeftOfPoint = rangeBarRect.left - playerRect.left + volumeBarPointPx;
	      var spaceRightOfPoint = rangeBarRect.width - volumeBarPointPx + (playerRect.right - rangeBarRect.right);
	      var pullTooltipBy = tooltipRect.width / 2;
	
	      if (spaceLeftOfPoint < pullTooltipBy) {
	        pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
	      } else if (spaceRightOfPoint < pullTooltipBy) {
	        pullTooltipBy = spaceRightOfPoint;
	      }
	
	      if (pullTooltipBy < 0) {
	        pullTooltipBy = 0;
	      } else if (pullTooltipBy > tooltipRect.width) {
	        pullTooltipBy = tooltipRect.width;
	      }
	
	      this.el_.style.right = "-" + pullTooltipBy + "px";
	    }
	
	    this.write(content + "%");
	  }
	  /**
	   * Write the volume to the tooltip DOM element.
	   *
	   * @param {string} content
	   *        The formatted volume for the tooltip.
	   */
	  ;
	
	  _proto.write = function write(content) {
	    textContent(this.el_, content);
	  }
	  /**
	   * Updates the position of the volume tooltip relative to the `VolumeBar`.
	   *
	   * @param {Object} rangeBarRect
	   *        The `ClientRect` for the {@link VolumeBar} element.
	   *
	   * @param {number} rangeBarPoint
	   *        A number from 0 to 1, representing a horizontal/vertical reference point
	   *        from the left edge of the {@link VolumeBar}
	   *
	   * @param {boolean} vertical
	   *        Referees to the Volume control position
	   *        in the control bar{@link VolumeControl}
	   *
	   * @param {number} volume
	   *        The volume level to update the tooltip to
	   *
	   * @param {Function} cb
	   *        A function that will be called during the request animation frame
	   *        for tooltips that need to do additional animations from the default
	   */
	  ;
	
	  _proto.updateVolume = function updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, cb) {
	    var _this2 = this;
	
	    this.requestNamedAnimationFrame('VolumeLevelTooltip#updateVolume', function () {
	      _this2.update(rangeBarRect, rangeBarPoint, vertical, volume.toFixed(0));
	
	      if (cb) {
	        cb();
	      }
	    });
	  };
	
	  return VolumeLevelTooltip;
	}(Component$1);
	
	Component$1.registerComponent('VolumeLevelTooltip', VolumeLevelTooltip);
	
	/**
	 * The {@link MouseVolumeLevelDisplay} component tracks mouse movement over the
	 * {@link VolumeControl}. It displays an indicator and a {@link VolumeLevelTooltip}
	 * indicating the volume level which is represented by a given point in the
	 * {@link VolumeBar}.
	 *
	 * @extends Component
	 */
	
	var MouseVolumeLevelDisplay = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MouseVolumeLevelDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The {@link Player} that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MouseVolumeLevelDisplay(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	    _this.update = throttle(bind(_assertThisInitialized__default['default'](_this), _this.update), UPDATE_REFRESH_INTERVAL);
	    return _this;
	  }
	  /**
	   * Create the DOM element for this class.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = MouseVolumeLevelDisplay.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-mouse-display'
	    });
	  }
	  /**
	   * Enquires updates to its own DOM as well as the DOM of its
	   * {@link VolumeLevelTooltip} child.
	   *
	   * @param {Object} rangeBarRect
	   *        The `ClientRect` for the {@link VolumeBar} element.
	   *
	   * @param {number} rangeBarPoint
	   *        A number from 0 to 1, representing a horizontal/vertical reference point
	   *        from the left edge of the {@link VolumeBar}
	   *
	   * @param {boolean} vertical
	   *        Referees to the Volume control position
	   *        in the control bar{@link VolumeControl}
	   *
	   */
	  ;
	
	  _proto.update = function update(rangeBarRect, rangeBarPoint, vertical) {
	    var _this2 = this;
	
	    var volume = 100 * rangeBarPoint;
	    this.getChild('volumeLevelTooltip').updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, function () {
	      if (vertical) {
	        _this2.el_.style.bottom = rangeBarRect.height * rangeBarPoint + "px";
	      } else {
	        _this2.el_.style.left = rangeBarRect.width * rangeBarPoint + "px";
	      }
	    });
	  };
	
	  return MouseVolumeLevelDisplay;
	}(Component$1);
	/**
	 * Default options for `MouseVolumeLevelDisplay`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	MouseVolumeLevelDisplay.prototype.options_ = {
	  children: ['volumeLevelTooltip']
	};
	Component$1.registerComponent('MouseVolumeLevelDisplay', MouseVolumeLevelDisplay);
	
	/**
	 * The bar that contains the volume level and can be clicked on to adjust the level
	 *
	 * @extends Slider
	 */
	
	var VolumeBar = /*#__PURE__*/function (_Slider) {
	  _inheritsLoose__default['default'](VolumeBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function VolumeBar(player, options) {
	    var _this;
	
	    _this = _Slider.call(this, player, options) || this;
	
	    _this.on('slideractive', function (e) {
	      return _this.updateLastVolume_(e);
	    });
	
	    _this.on(player, 'volumechange', function (e) {
	      return _this.updateARIAAttributes(e);
	    });
	
	    player.ready(function () {
	      return _this.updateARIAAttributes();
	    });
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = VolumeBar.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-bar vjs-slider-bar'
	    }, {
	      'aria-label': this.localize('Volume Level'),
	      'aria-live': 'polite'
	    });
	  }
	  /**
	   * Handle mouse down on volume bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousedown` event that caused this to run.
	   *
	   * @listens mousedown
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    _Slider.prototype.handleMouseDown.call(this, event);
	  }
	  /**
	   * Handle movement events on the {@link VolumeMenuButton}.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @listens mousemove
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {
	    var mouseVolumeLevelDisplay = this.getChild('mouseVolumeLevelDisplay');
	
	    if (mouseVolumeLevelDisplay) {
	      var volumeBarEl = this.el();
	      var volumeBarRect = getBoundingClientRect(volumeBarEl);
	      var vertical = this.vertical();
	      var volumeBarPoint = getPointerPosition(volumeBarEl, event);
	      volumeBarPoint = vertical ? volumeBarPoint.y : volumeBarPoint.x; // The default skin has a gap on either side of the `VolumeBar`. This means
	      // that it's possible to trigger this behavior outside the boundaries of
	      // the `VolumeBar`. This ensures we stay within it at all times.
	
	      volumeBarPoint = clamp(volumeBarPoint, 0, 1);
	      mouseVolumeLevelDisplay.update(volumeBarRect, volumeBarPoint, vertical);
	    }
	
	    if (!isSingleLeftClick(event)) {
	      return;
	    }
	
	    this.checkMuted();
	    this.player_.volume(this.calculateDistance(event));
	  }
	  /**
	   * If the player is muted unmute it.
	   */
	  ;
	
	  _proto.checkMuted = function checkMuted() {
	    if (this.player_.muted()) {
	      this.player_.muted(false);
	    }
	  }
	  /**
	   * Get percent of volume level
	   *
	   * @return {number}
	   *         Volume level percent as a decimal number.
	   */
	  ;
	
	  _proto.getPercent = function getPercent() {
	    if (this.player_.muted()) {
	      return 0;
	    }
	
	    return this.player_.volume();
	  }
	  /**
	   * Increase volume level for keyboard users
	   */
	  ;
	
	  _proto.stepForward = function stepForward() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() + 0.1);
	  }
	  /**
	   * Decrease volume level for keyboard users
	   */
	  ;
	
	  _proto.stepBack = function stepBack() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() - 0.1);
	  }
	  /**
	   * Update ARIA accessibility attributes
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `volumechange` event that caused this function to run.
	   *
	   * @listens Player#volumechange
	   */
	  ;
	
	  _proto.updateARIAAttributes = function updateARIAAttributes(event) {
	    var ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
	    this.el_.setAttribute('aria-valuenow', ariaValue);
	    this.el_.setAttribute('aria-valuetext', ariaValue + '%');
	  }
	  /**
	   * Returns the current value of the player volume as a percentage
	   *
	   * @private
	   */
	  ;
	
	  _proto.volumeAsPercentage_ = function volumeAsPercentage_() {
	    return Math.round(this.player_.volume() * 100);
	  }
	  /**
	   * When user starts dragging the VolumeBar, store the volume and listen for
	   * the end of the drag. When the drag ends, if the volume was set to zero,
	   * set lastVolume to the stored volume.
	   *
	   * @listens slideractive
	   * @private
	   */
	  ;
	
	  _proto.updateLastVolume_ = function updateLastVolume_() {
	    var _this2 = this;
	
	    var volumeBeforeDrag = this.player_.volume();
	    this.one('sliderinactive', function () {
	      if (_this2.player_.volume() === 0) {
	        _this2.player_.lastVolume_(volumeBeforeDrag);
	      }
	    });
	  };
	
	  return VolumeBar;
	}(Slider);
	/**
	 * Default options for the `VolumeBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeBar.prototype.options_ = {
	  children: ['volumeLevel'],
	  barName: 'volumeLevel'
	}; // MouseVolumeLevelDisplay tooltip should not be added to a player on mobile devices
	
	if (!IS_IOS && !IS_ANDROID) {
	  VolumeBar.prototype.options_.children.splice(0, 0, 'mouseVolumeLevelDisplay');
	}
	/**
	 * Call the update event for this Slider when this event happens on the player.
	 *
	 * @type {string}
	 */
	
	
	VolumeBar.prototype.playerEvent = 'volumechange';
	Component$1.registerComponent('VolumeBar', VolumeBar);
	
	/**
	 * The component for controlling the volume level
	 *
	 * @extends Component
	 */
	
	var VolumeControl = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumeControl, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumeControl(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    options.vertical = options.vertical || false; // Pass the vertical option down to the VolumeBar if
	    // the VolumeBar is turned on.
	
	    if (typeof options.volumeBar === 'undefined' || isPlain(options.volumeBar)) {
	      options.volumeBar = options.volumeBar || {};
	      options.volumeBar.vertical = options.vertical;
	    }
	
	    _this = _Component.call(this, player, options) || this; // hide this control if volume support is missing
	
	    checkVolumeSupport(_assertThisInitialized__default['default'](_this), player);
	    _this.throttledHandleMouseMove = throttle(bind(_assertThisInitialized__default['default'](_this), _this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
	
	    _this.handleMouseUpHandler_ = function (e) {
	      return _this.handleMouseUp(e);
	    };
	
	    _this.on('mousedown', function (e) {
	      return _this.handleMouseDown(e);
	    });
	
	    _this.on('touchstart', function (e) {
	      return _this.handleMouseDown(e);
	    });
	
	    _this.on('mousemove', function (e) {
	      return _this.handleMouseMove(e);
	    }); // while the slider is active (the mouse has been pressed down and
	    // is dragging) or in focus we do not want to hide the VolumeBar
	
	
	    _this.on(_this.volumeBar, ['focus', 'slideractive'], function () {
	      _this.volumeBar.addClass('vjs-slider-active');
	
	      _this.addClass('vjs-slider-active');
	
	      _this.trigger('slideractive');
	    });
	
	    _this.on(_this.volumeBar, ['blur', 'sliderinactive'], function () {
	      _this.volumeBar.removeClass('vjs-slider-active');
	
	      _this.removeClass('vjs-slider-active');
	
	      _this.trigger('sliderinactive');
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = VolumeControl.prototype;
	
	  _proto.createEl = function createEl() {
	    var orientationClass = 'vjs-volume-horizontal';
	
	    if (this.options_.vertical) {
	      orientationClass = 'vjs-volume-vertical';
	    }
	
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: "vjs-volume-control vjs-control " + orientationClass
	    });
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	  ;
	
	  _proto.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.el_.ownerDocument;
	    this.on(doc, 'mousemove', this.throttledHandleMouseMove);
	    this.on(doc, 'touchmove', this.throttledHandleMouseMove);
	    this.on(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.on(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   */
	  ;
	
	  _proto.handleMouseUp = function handleMouseUp(event) {
	    var doc = this.el_.ownerDocument;
	    this.off(doc, 'mousemove', this.throttledHandleMouseMove);
	    this.off(doc, 'touchmove', this.throttledHandleMouseMove);
	    this.off(doc, 'mouseup', this.handleMouseUpHandler_);
	    this.off(doc, 'touchend', this.handleMouseUpHandler_);
	  }
	  /**
	   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   */
	  ;
	
	  _proto.handleMouseMove = function handleMouseMove(event) {
	    this.volumeBar.handleMouseMove(event);
	  };
	
	  return VolumeControl;
	}(Component$1);
	/**
	 * Default options for the `VolumeControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeControl.prototype.options_ = {
	  children: ['volumeBar']
	};
	Component$1.registerComponent('VolumeControl', VolumeControl);
	
	/**
	 * Check if muting volume is supported and if it isn't hide the mute toggle
	 * button.
	 *
	 * @param {Component} self
	 *        A reference to the mute toggle button
	 *
	 * @param {Player} player
	 *        A reference to the player
	 *
	 * @private
	 */
	var checkMuteSupport = function checkMuteSupport(self, player) {
	  // hide mute toggle button if it's not supported by the current tech
	  if (player.tech_ && !player.tech_.featuresMuteControl) {
	    self.addClass('vjs-hidden');
	  }
	
	  self.on(player, 'loadstart', function () {
	    if (!player.tech_.featuresMuteControl) {
	      self.addClass('vjs-hidden');
	    } else {
	      self.removeClass('vjs-hidden');
	    }
	  });
	};
	
	/**
	 * A button component for muting the audio.
	 *
	 * @extends Button
	 */
	
	var MuteToggle = /*#__PURE__*/function (_Button) {
	  _inheritsLoose__default['default'](MuteToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MuteToggle(player, options) {
	    var _this;
	
	    _this = _Button.call(this, player, options) || this; // hide this control if volume support is missing
	
	    checkMuteSupport(_assertThisInitialized__default['default'](_this), player);
	
	    _this.on(player, ['loadstart', 'volumechange'], function (e) {
	      return _this.update(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = MuteToggle.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-mute-control " + _Button.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * This gets called when an `MuteToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    var vol = this.player_.volume();
	    var lastVolume = this.player_.lastVolume_();
	
	    if (vol === 0) {
	      var volumeToSet = lastVolume < 0.1 ? 0.1 : lastVolume;
	      this.player_.volume(volumeToSet);
	      this.player_.muted(false);
	    } else {
	      this.player_.muted(this.player_.muted() ? false : true);
	    }
	  }
	  /**
	   * Update the `MuteToggle` button based on the state of `volume` and `muted`
	   * on the player.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#loadstart} event if this function was called
	   *        through an event.
	   *
	   * @listens Player#loadstart
	   * @listens Player#volumechange
	   */
	  ;
	
	  _proto.update = function update(event) {
	    this.updateIcon_();
	    this.updateControlText_();
	  }
	  /**
	   * Update the appearance of the `MuteToggle` icon.
	   *
	   * Possible states (given `level` variable below):
	   * - 0: crossed out
	   * - 1: zero bars of volume
	   * - 2: one bar of volume
	   * - 3: two bars of volume
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateIcon_ = function updateIcon_() {
	    var vol = this.player_.volume();
	    var level = 3; // in iOS when a player is loaded with muted attribute
	    // and volume is changed with a native mute button
	    // we want to make sure muted state is updated
	
	    if (IS_IOS && this.player_.tech_ && this.player_.tech_.el_) {
	      this.player_.muted(this.player_.tech_.el_.muted);
	    }
	
	    if (vol === 0 || this.player_.muted()) {
	      level = 0;
	    } else if (vol < 0.33) {
	      level = 1;
	    } else if (vol < 0.67) {
	      level = 2;
	    } // TODO improve muted icon classes
	
	
	    for (var i = 0; i < 4; i++) {
	      removeClass(this.el_, "vjs-vol-" + i);
	    }
	
	    addClass(this.el_, "vjs-vol-" + level);
	  }
	  /**
	   * If `muted` has changed on the player, update the control text
	   * (`title` attribute on `vjs-mute-control` element and content of
	   * `vjs-control-text` element).
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateControlText_ = function updateControlText_() {
	    var soundOff = this.player_.muted() || this.player_.volume() === 0;
	    var text = soundOff ? 'Unmute' : 'Mute';
	
	    if (this.controlText() !== text) {
	      this.controlText(text);
	    }
	  };
	
	  return MuteToggle;
	}(Button);
	/**
	 * The text that should display over the `MuteToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	MuteToggle.prototype.controlText_ = 'Mute';
	Component$1.registerComponent('MuteToggle', MuteToggle);
	
	/**
	 * A Component to contain the MuteToggle and VolumeControl so that
	 * they can work together.
	 *
	 * @extends Component
	 */
	
	var VolumePanel = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VolumePanel, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumePanel(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (typeof options.inline !== 'undefined') {
	      options.inline = options.inline;
	    } else {
	      options.inline = true;
	    } // pass the inline option down to the VolumeControl as vertical if
	    // the VolumeControl is on.
	
	
	    if (typeof options.volumeControl === 'undefined' || isPlain(options.volumeControl)) {
	      options.volumeControl = options.volumeControl || {};
	      options.volumeControl.vertical = !options.inline;
	    }
	
	    _this = _Component.call(this, player, options) || this; // this handler is used by mouse handler methods below
	
	    _this.handleKeyPressHandler_ = function (e) {
	      return _this.handleKeyPress(e);
	    };
	
	    _this.on(player, ['loadstart'], function (e) {
	      return _this.volumePanelState_(e);
	    });
	
	    _this.on(_this.muteToggle, 'keyup', function (e) {
	      return _this.handleKeyPress(e);
	    });
	
	    _this.on(_this.volumeControl, 'keyup', function (e) {
	      return _this.handleVolumeControlKeyUp(e);
	    });
	
	    _this.on('keydown', function (e) {
	      return _this.handleKeyPress(e);
	    });
	
	    _this.on('mouseover', function (e) {
	      return _this.handleMouseOver(e);
	    });
	
	    _this.on('mouseout', function (e) {
	      return _this.handleMouseOut(e);
	    }); // while the slider is active (the mouse has been pressed down and
	    // is dragging) we do not want to hide the VolumeBar
	
	
	    _this.on(_this.volumeControl, ['slideractive'], _this.sliderActive_);
	
	    _this.on(_this.volumeControl, ['sliderinactive'], _this.sliderInactive_);
	
	    return _this;
	  }
	  /**
	   * Add vjs-slider-active class to the VolumePanel
	   *
	   * @listens VolumeControl#slideractive
	   * @private
	   */
	
	
	  var _proto = VolumePanel.prototype;
	
	  _proto.sliderActive_ = function sliderActive_() {
	    this.addClass('vjs-slider-active');
	  }
	  /**
	   * Removes vjs-slider-active class to the VolumePanel
	   *
	   * @listens VolumeControl#sliderinactive
	   * @private
	   */
	  ;
	
	  _proto.sliderInactive_ = function sliderInactive_() {
	    this.removeClass('vjs-slider-active');
	  }
	  /**
	   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
	   * depending on MuteToggle and VolumeControl state
	   *
	   * @listens Player#loadstart
	   * @private
	   */
	  ;
	
	  _proto.volumePanelState_ = function volumePanelState_() {
	    // hide volume panel if neither volume control or mute toggle
	    // are displayed
	    if (this.volumeControl.hasClass('vjs-hidden') && this.muteToggle.hasClass('vjs-hidden')) {
	      this.addClass('vjs-hidden');
	    } // if only mute toggle is visible we don't want
	    // volume panel expanding when hovered or active
	
	
	    if (this.volumeControl.hasClass('vjs-hidden') && !this.muteToggle.hasClass('vjs-hidden')) {
	      this.addClass('vjs-mute-toggle-only');
	    }
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    var orientationClass = 'vjs-volume-panel-horizontal';
	
	    if (!this.options_.inline) {
	      orientationClass = 'vjs-volume-panel-vertical';
	    }
	
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: "vjs-volume-panel vjs-control " + orientationClass
	    });
	  }
	  /**
	   * Dispose of the `volume-panel` and all child components.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.handleMouseOut();
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
	   * the volume panel and sets focus on `MuteToggle`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keyup` event that caused this function to be called.
	   *
	   * @listens keyup
	   */
	  ;
	
	  _proto.handleVolumeControlKeyUp = function handleVolumeControlKeyUp(event) {
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      this.muteToggle.focus();
	    }
	  }
	  /**
	   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
	   * Turns on listening for `mouseover` event. When they happen it
	   * calls `this.handleMouseOver`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseover` event that caused this function to be called.
	   *
	   * @listens mouseover
	   */
	  ;
	
	  _proto.handleMouseOver = function handleMouseOver(event) {
	    this.addClass('vjs-hover');
	    on(document__default['default'], 'keyup', this.handleKeyPressHandler_);
	  }
	  /**
	   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
	   * Turns on listening for `mouseout` event. When they happen it
	   * calls `this.handleMouseOut`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseout` event that caused this function to be called.
	   *
	   * @listens mouseout
	   */
	  ;
	
	  _proto.handleMouseOut = function handleMouseOut(event) {
	    this.removeClass('vjs-hover');
	    off(document__default['default'], 'keyup', this.handleKeyPressHandler_);
	  }
	  /**
	   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
	   * looking for ESC, which hides the `VolumeControl`.
	   *
	   * @param {EventTarget~Event} event
	   *        The keypress that triggered this event.
	   *
	   * @listens keydown | keyup
	   */
	  ;
	
	  _proto.handleKeyPress = function handleKeyPress(event) {
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      this.handleMouseOut();
	    }
	  };
	
	  return VolumePanel;
	}(Component$1);
	/**
	 * Default options for the `VolumeControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumePanel.prototype.options_ = {
	  children: ['muteToggle', 'volumeControl']
	};
	Component$1.registerComponent('VolumePanel', VolumePanel);
	
	/**
	 * The Menu component is used to build popup menus, including subtitle and
	 * captions selection menus.
	 *
	 * @extends Component
	 */
	
	var Menu = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Menu, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        the player that this component should attach to
	   *
	   * @param {Object} [options]
	   *        Object of option names and values
	   *
	   */
	  function Menu(player, options) {
	    var _this;
	
	    _this = _Component.call(this, player, options) || this;
	
	    if (options) {
	      _this.menuButton_ = options.menuButton;
	    }
	
	    _this.focusedChild_ = -1;
	
	    _this.on('keydown', function (e) {
	      return _this.handleKeyDown(e);
	    }); // All the menu item instances share the same blur handler provided by the menu container.
	
	
	    _this.boundHandleBlur_ = function (e) {
	      return _this.handleBlur(e);
	    };
	
	    _this.boundHandleTapClick_ = function (e) {
	      return _this.handleTapClick(e);
	    };
	
	    return _this;
	  }
	  /**
	   * Add event listeners to the {@link MenuItem}.
	   *
	   * @param {Object} component
	   *        The instance of the `MenuItem` to add listeners to.
	   *
	   */
	
	
	  var _proto = Menu.prototype;
	
	  _proto.addEventListenerForItem = function addEventListenerForItem(component) {
	    if (!(component instanceof Component$1)) {
	      return;
	    }
	
	    this.on(component, 'blur', this.boundHandleBlur_);
	    this.on(component, ['tap', 'click'], this.boundHandleTapClick_);
	  }
	  /**
	   * Remove event listeners from the {@link MenuItem}.
	   *
	   * @param {Object} component
	   *        The instance of the `MenuItem` to remove listeners.
	   *
	   */
	  ;
	
	  _proto.removeEventListenerForItem = function removeEventListenerForItem(component) {
	    if (!(component instanceof Component$1)) {
	      return;
	    }
	
	    this.off(component, 'blur', this.boundHandleBlur_);
	    this.off(component, ['tap', 'click'], this.boundHandleTapClick_);
	  }
	  /**
	   * This method will be called indirectly when the component has been added
	   * before the component adds to the new menu instance by `addItem`.
	   * In this case, the original menu instance will remove the component
	   * by calling `removeChild`.
	   *
	   * @param {Object} component
	   *        The instance of the `MenuItem`
	   */
	  ;
	
	  _proto.removeChild = function removeChild(component) {
	    if (typeof component === 'string') {
	      component = this.getChild(component);
	    }
	
	    this.removeEventListenerForItem(component);
	
	    _Component.prototype.removeChild.call(this, component);
	  }
	  /**
	   * Add a {@link MenuItem} to the menu.
	   *
	   * @param {Object|string} component
	   *        The name or instance of the `MenuItem` to add.
	   *
	   */
	  ;
	
	  _proto.addItem = function addItem(component) {
	    var childComponent = this.addChild(component);
	
	    if (childComponent) {
	      this.addEventListenerForItem(childComponent);
	    }
	  }
	  /**
	   * Create the `Menu`s DOM element.
	   *
	   * @return {Element}
	   *         the element that was created
	   */
	  ;
	
	  _proto.createEl = function createEl$1() {
	    var contentElType = this.options_.contentElType || 'ul';
	    this.contentEl_ = createEl(contentElType, {
	      className: 'vjs-menu-content'
	    });
	    this.contentEl_.setAttribute('role', 'menu');
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      append: this.contentEl_,
	      className: 'vjs-menu'
	    });
	
	    el.appendChild(this.contentEl_); // Prevent clicks from bubbling up. Needed for Menu Buttons,
	    // where a click on the parent is significant
	
	    on(el, 'click', function (event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    });
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.contentEl_ = null;
	    this.boundHandleBlur_ = null;
	    this.boundHandleTapClick_ = null;
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Called when a `MenuItem` loses focus.
	   *
	   * @param {EventTarget~Event} event
	   *        The `blur` event that caused this function to be called.
	   *
	   * @listens blur
	   */
	  ;
	
	  _proto.handleBlur = function handleBlur(event) {
	    var relatedTarget = event.relatedTarget || document__default['default'].activeElement; // Close menu popup when a user clicks outside the menu
	
	    if (!this.children().some(function (element) {
	      return element.el() === relatedTarget;
	    })) {
	      var btn = this.menuButton_;
	
	      if (btn && btn.buttonPressed_ && relatedTarget !== btn.el().firstChild) {
	        btn.unpressButton();
	      }
	    }
	  }
	  /**
	   * Called when a `MenuItem` gets clicked or tapped.
	   *
	   * @param {EventTarget~Event} event
	   *        The `click` or `tap` event that caused this function to be called.
	   *
	   * @listens click,tap
	   */
	  ;
	
	  _proto.handleTapClick = function handleTapClick(event) {
	    // Unpress the associated MenuButton, and move focus back to it
	    if (this.menuButton_) {
	      this.menuButton_.unpressButton();
	      var childComponents = this.children();
	
	      if (!Array.isArray(childComponents)) {
	        return;
	      }
	
	      var foundComponent = childComponents.filter(function (component) {
	        return component.el() === event.target;
	      })[0];
	
	      if (!foundComponent) {
	        return;
	      } // don't focus menu button if item is a caption settings item
	      // because focus will move elsewhere
	
	
	      if (foundComponent.name() !== 'CaptionSettingsMenuItem') {
	        this.menuButton_.focus();
	      }
	    }
	  }
	  /**
	   * Handle a `keydown` event on this menu. This listener is added in the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        A `keydown` event that happened on the menu.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Left and Down Arrows
	    if (keycode__default['default'].isEventKey(event, 'Left') || keycode__default['default'].isEventKey(event, 'Down')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepForward(); // Up and Right Arrows
	    } else if (keycode__default['default'].isEventKey(event, 'Right') || keycode__default['default'].isEventKey(event, 'Up')) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.stepBack();
	    }
	  }
	  /**
	   * Move to next (lower) menu item for keyboard users.
	   */
	  ;
	
	  _proto.stepForward = function stepForward() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ + 1;
	    }
	
	    this.focus(stepChild);
	  }
	  /**
	   * Move to previous (higher) menu item for keyboard users.
	   */
	  ;
	
	  _proto.stepBack = function stepBack() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ - 1;
	    }
	
	    this.focus(stepChild);
	  }
	  /**
	   * Set focus on a {@link MenuItem} in the `Menu`.
	   *
	   * @param {Object|string} [item=0]
	   *        Index of child item set focus on.
	   */
	  ;
	
	  _proto.focus = function focus(item) {
	    if (item === void 0) {
	      item = 0;
	    }
	
	    var children = this.children().slice();
	    var haveTitle = children.length && children[0].hasClass('vjs-menu-title');
	
	    if (haveTitle) {
	      children.shift();
	    }
	
	    if (children.length > 0) {
	      if (item < 0) {
	        item = 0;
	      } else if (item >= children.length) {
	        item = children.length - 1;
	      }
	
	      this.focusedChild_ = item;
	      children[item].el_.focus();
	    }
	  };
	
	  return Menu;
	}(Component$1);
	
	Component$1.registerComponent('Menu', Menu);
	
	/**
	 * A `MenuButton` class for any popup {@link Menu}.
	 *
	 * @extends Component
	 */
	
	var MenuButton = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](MenuButton, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function MenuButton(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _Component.call(this, player, options) || this;
	    _this.menuButton_ = new Button(player, options);
	
	    _this.menuButton_.controlText(_this.controlText_);
	
	    _this.menuButton_.el_.setAttribute('aria-haspopup', 'true'); // Add buildCSSClass values to the button, not the wrapper
	
	
	    var buttonClass = Button.prototype.buildCSSClass();
	    _this.menuButton_.el_.className = _this.buildCSSClass() + ' ' + buttonClass;
	
	    _this.menuButton_.removeClass('vjs-control');
	
	    _this.addChild(_this.menuButton_);
	
	    _this.update();
	
	    _this.enabled_ = true;
	
	    var handleClick = function handleClick(e) {
	      return _this.handleClick(e);
	    };
	
	    _this.handleMenuKeyUp_ = function (e) {
	      return _this.handleMenuKeyUp(e);
	    };
	
	    _this.on(_this.menuButton_, 'tap', handleClick);
	
	    _this.on(_this.menuButton_, 'click', handleClick);
	
	    _this.on(_this.menuButton_, 'keydown', function (e) {
	      return _this.handleKeyDown(e);
	    });
	
	    _this.on(_this.menuButton_, 'mouseenter', function () {
	      _this.addClass('vjs-hover');
	
	      _this.menu.show();
	
	      on(document__default['default'], 'keyup', _this.handleMenuKeyUp_);
	    });
	
	    _this.on('mouseleave', function (e) {
	      return _this.handleMouseLeave(e);
	    });
	
	    _this.on('keydown', function (e) {
	      return _this.handleSubmenuKeyDown(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Update the menu based on the current state of its items.
	   */
	
	
	  var _proto = MenuButton.prototype;
	
	  _proto.update = function update() {
	    var menu = this.createMenu();
	
	    if (this.menu) {
	      this.menu.dispose();
	      this.removeChild(this.menu);
	    }
	
	    this.menu = menu;
	    this.addChild(menu);
	    /**
	     * Track the state of the menu button
	     *
	     * @type {Boolean}
	     * @private
	     */
	
	    this.buttonPressed_ = false;
	    this.menuButton_.el_.setAttribute('aria-expanded', 'false');
	
	    if (this.items && this.items.length <= this.hideThreshold_) {
	      this.hide();
	      this.menu.contentEl_.removeAttribute('role');
	    } else {
	      this.show();
	      this.menu.contentEl_.setAttribute('role', 'menu');
	    }
	  }
	  /**
	   * Create the menu and add all items to it.
	   *
	   * @return {Menu}
	   *         The constructed menu
	   */
	  ;
	
	  _proto.createMenu = function createMenu() {
	    var menu = new Menu(this.player_, {
	      menuButton: this
	    });
	    /**
	     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
	     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
	     * it here because every time we run `createMenu` we need to reset the value.
	     *
	     * @protected
	     * @type {Number}
	     */
	
	    this.hideThreshold_ = 0; // Add a title list item to the top
	
	    if (this.options_.title) {
	      var titleEl = createEl('li', {
	        className: 'vjs-menu-title',
	        textContent: toTitleCase$1(this.options_.title),
	        tabIndex: -1
	      });
	      var titleComponent = new Component$1(this.player_, {
	        el: titleEl
	      });
	      menu.addItem(titleComponent);
	    }
	
	    this.items = this.createItems();
	
	    if (this.items) {
	      // Add menu items to the menu
	      for (var i = 0; i < this.items.length; i++) {
	        menu.addItem(this.items[i]);
	      }
	    }
	
	    return menu;
	  }
	  /**
	   * Create the list of menu items. Specific to each subclass.
	   *
	   * @abstract
	   */
	  ;
	
	  _proto.createItems = function createItems() {}
	  /**
	   * Create the `MenuButtons`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildWrapperCSSClass()
	    }, {});
	  }
	  /**
	   * Allow sub components to stack CSS class names for the wrapper element
	   *
	   * @return {string}
	   *         The constructed wrapper DOM `className`
	   */
	  ;
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    var menuButtonClass = 'vjs-menu-button'; // If the inline option is passed, we want to use different styles altogether.
	
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    } // TODO: Fix the CSS so that this isn't necessary
	
	
	    var buttonClass = Button.prototype.buildCSSClass();
	    return "vjs-menu-button " + menuButtonClass + " " + buttonClass + " " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    var menuButtonClass = 'vjs-menu-button'; // If the inline option is passed, we want to use different styles altogether.
	
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    }
	
	    return "vjs-menu-button " + menuButtonClass + " " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Get or set the localized control text that will be used for accessibility.
	   *
	   * > NOTE: This will come from the internal `menuButton_` element.
	   *
	   * @param {string} [text]
	   *        Control text for element.
	   *
	   * @param {Element} [el=this.menuButton_.el()]
	   *        Element to set the title on.
	   *
	   * @return {string}
	   *         - The control text when getting
	   */
	  ;
	
	  _proto.controlText = function controlText(text, el) {
	    if (el === void 0) {
	      el = this.menuButton_.el();
	    }
	
	    return this.menuButton_.controlText(text, el);
	  }
	  /**
	   * Dispose of the `menu-button` and all child components.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.handleMouseLeave();
	
	    _Component.prototype.dispose.call(this);
	  }
	  /**
	   * Handle a click on a `MenuButton`.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    if (this.buttonPressed_) {
	      this.unpressButton();
	    } else {
	      this.pressButton();
	    }
	  }
	  /**
	   * Handle `mouseleave` for `MenuButton`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseleave` event that caused this function to be called.
	   *
	   * @listens mouseleave
	   */
	  ;
	
	  _proto.handleMouseLeave = function handleMouseLeave(event) {
	    this.removeClass('vjs-hover');
	    off(document__default['default'], 'keyup', this.handleMenuKeyUp_);
	  }
	  /**
	   * Set the focus to the actual button, not to this element
	   */
	  ;
	
	  _proto.focus = function focus() {
	    this.menuButton_.focus();
	  }
	  /**
	   * Remove the focus from the actual button, not this element
	   */
	  ;
	
	  _proto.blur = function blur() {
	    this.menuButton_.blur();
	  }
	  /**
	   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
	   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    // Escape or Tab unpress the 'button'
	    if (keycode__default['default'].isEventKey(event, 'Esc') || keycode__default['default'].isEventKey(event, 'Tab')) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      } // Don't preventDefault for Tab key - we still want to lose focus
	
	
	      if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	        event.preventDefault(); // Set focus back to the menu button's button
	
	        this.menuButton_.focus();
	      } // Up Arrow or Down Arrow also 'press' the button to open the menu
	
	    } else if (keycode__default['default'].isEventKey(event, 'Up') || keycode__default['default'].isEventKey(event, 'Down')) {
	      if (!this.buttonPressed_) {
	        event.preventDefault();
	        this.pressButton();
	      }
	    }
	  }
	  /**
	   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
	   * the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        Key press event
	   *
	   * @listens keyup
	   */
	  ;
	
	  _proto.handleMenuKeyUp = function handleMenuKeyUp(event) {
	    // Escape hides popup menu
	    if (keycode__default['default'].isEventKey(event, 'Esc') || keycode__default['default'].isEventKey(event, 'Tab')) {
	      this.removeClass('vjs-hover');
	    }
	  }
	  /**
	   * This method name now delegates to `handleSubmenuKeyDown`. This means
	   * anyone calling `handleSubmenuKeyPress` will not see their method calls
	   * stop working.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleSubmenuKeyPress = function handleSubmenuKeyPress(event) {
	    this.handleSubmenuKeyDown(event);
	  }
	  /**
	   * Handle a `keydown` event on a sub-menu. The listener for this is added in
	   * the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        Key press event
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleSubmenuKeyDown = function handleSubmenuKeyDown(event) {
	    // Escape or Tab unpress the 'button'
	    if (keycode__default['default'].isEventKey(event, 'Esc') || keycode__default['default'].isEventKey(event, 'Tab')) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      } // Don't preventDefault for Tab key - we still want to lose focus
	
	
	      if (!keycode__default['default'].isEventKey(event, 'Tab')) {
	        event.preventDefault(); // Set focus back to the menu button's button
	
	        this.menuButton_.focus();
	      }
	    }
	  }
	  /**
	   * Put the current `MenuButton` into a pressed state.
	   */
	  ;
	
	  _proto.pressButton = function pressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = true;
	      this.menu.show();
	      this.menu.lockShowing();
	      this.menuButton_.el_.setAttribute('aria-expanded', 'true'); // set the focus into the submenu, except on iOS where it is resulting in
	      // undesired scrolling behavior when the player is in an iframe
	
	      if (IS_IOS && isInFrame()) {
	        // Return early so that the menu isn't focused
	        return;
	      }
	
	      this.menu.focus();
	    }
	  }
	  /**
	   * Take the current `MenuButton` out of a pressed state.
	   */
	  ;
	
	  _proto.unpressButton = function unpressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = false;
	      this.menu.unlockShowing();
	      this.menu.hide();
	      this.menuButton_.el_.setAttribute('aria-expanded', 'false');
	    }
	  }
	  /**
	   * Disable the `MenuButton`. Don't allow it to be clicked.
	   */
	  ;
	
	  _proto.disable = function disable() {
	    this.unpressButton();
	    this.enabled_ = false;
	    this.addClass('vjs-disabled');
	    this.menuButton_.disable();
	  }
	  /**
	   * Enable the `MenuButton`. Allow it to be clicked.
	   */
	  ;
	
	  _proto.enable = function enable() {
	    this.enabled_ = true;
	    this.removeClass('vjs-disabled');
	    this.menuButton_.enable();
	  };
	
	  return MenuButton;
	}(Component$1);
	
	Component$1.registerComponent('MenuButton', MenuButton);
	
	/**
	 * The base class for buttons that toggle specific  track types (e.g. subtitles).
	 *
	 * @extends MenuButton
	 */
	
	var TrackButton = /*#__PURE__*/function (_MenuButton) {
	  _inheritsLoose__default['default'](TrackButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TrackButton(player, options) {
	    var _this;
	
	    var tracks = options.tracks;
	    _this = _MenuButton.call(this, player, options) || this;
	
	    if (_this.items.length <= 1) {
	      _this.hide();
	    }
	
	    if (!tracks) {
	      return _assertThisInitialized__default['default'](_this);
	    }
	
	    var updateHandler = bind(_assertThisInitialized__default['default'](_this), _this.update);
	    tracks.addEventListener('removetrack', updateHandler);
	    tracks.addEventListener('addtrack', updateHandler);
	    tracks.addEventListener('labelchange', updateHandler);
	
	    _this.player_.on('ready', updateHandler);
	
	    _this.player_.on('dispose', function () {
	      tracks.removeEventListener('removetrack', updateHandler);
	      tracks.removeEventListener('addtrack', updateHandler);
	      tracks.removeEventListener('labelchange', updateHandler);
	    });
	
	    return _this;
	  }
	
	  return TrackButton;
	}(MenuButton);
	
	Component$1.registerComponent('TrackButton', TrackButton);
	
	/**
	 * @file menu-keys.js
	 */
	
	/**
	  * All keys used for operation of a menu (`MenuButton`, `Menu`, and `MenuItem`)
	  * Note that 'Enter' and 'Space' are not included here (otherwise they would
	  * prevent the `MenuButton` and `MenuItem` from being keyboard-clickable)
	  * @typedef MenuKeys
	  * @array
	  */
	var MenuKeys = ['Tab', 'Esc', 'Up', 'Down', 'Right', 'Left'];
	
	/**
	 * The component for a menu item. `<li>`
	 *
	 * @extends ClickableComponent
	 */
	
	var MenuItem = /*#__PURE__*/function (_ClickableComponent) {
	  _inheritsLoose__default['default'](MenuItem, _ClickableComponent);
	
	  /**
	   * Creates an instance of the this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   *
	   */
	  function MenuItem(player, options) {
	    var _this;
	
	    _this = _ClickableComponent.call(this, player, options) || this;
	    _this.selectable = options.selectable;
	    _this.isSelected_ = options.selected || false;
	    _this.multiSelectable = options.multiSelectable;
	
	    _this.selected(_this.isSelected_);
	
	    if (_this.selectable) {
	      if (_this.multiSelectable) {
	        _this.el_.setAttribute('role', 'menuitemcheckbox');
	      } else {
	        _this.el_.setAttribute('role', 'menuitemradio');
	      }
	    } else {
	      _this.el_.setAttribute('role', 'menuitem');
	    }
	
	    return _this;
	  }
	  /**
	   * Create the `MenuItem's DOM element
	   *
	   * @param {string} [type=li]
	   *        Element's node type, not actually used, always set to `li`.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element
	   *
	   * @param {Object} [attrs={}]
	   *        An object of attributes that should be set on the element
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  var _proto = MenuItem.prototype;
	
	  _proto.createEl = function createEl$1(type, props, attrs) {
	    // The control is textual, not just an icon
	    this.nonIconControl = true;
	
	    var el = _ClickableComponent.prototype.createEl.call(this, 'li', assign({
	      className: 'vjs-menu-item',
	      tabIndex: -1
	    }, props), attrs); // swap icon with menu item text.
	
	
	    el.replaceChild(createEl('span', {
	      className: 'vjs-menu-item-text',
	      textContent: this.localize(this.options_.label)
	    }), el.querySelector('.vjs-icon-placeholder'));
	    return el;
	  }
	  /**
	   * Ignore keys which are used by the menu, but pass any other ones up. See
	   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    if (!MenuKeys.some(function (key) {
	      return keycode__default['default'].isEventKey(event, key);
	    })) {
	      // Pass keydown handling up for unused keys
	      _ClickableComponent.prototype.handleKeyDown.call(this, event);
	    }
	  }
	  /**
	   * Any click on a `MenuItem` puts it into the selected state.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    this.selected(true);
	  }
	  /**
	   * Set the state for this menu item as selected or not.
	   *
	   * @param {boolean} selected
	   *        if the menu item is selected or not
	   */
	  ;
	
	  _proto.selected = function selected(_selected) {
	    if (this.selectable) {
	      if (_selected) {
	        this.addClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'true'); // aria-checked isn't fully supported by browsers/screen readers,
	        // so indicate selected state to screen reader in the control text.
	
	        this.controlText(', selected');
	        this.isSelected_ = true;
	      } else {
	        this.removeClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'false'); // Indicate un-selected state to screen reader
	
	        this.controlText('');
	        this.isSelected_ = false;
	      }
	    }
	  };
	
	  return MenuItem;
	}(ClickableComponent);
	
	Component$1.registerComponent('MenuItem', MenuItem);
	
	/**
	 * The specific menu item type for selecting a language within a text track kind
	 *
	 * @extends MenuItem
	 */
	
	var TextTrackMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](TextTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TextTrackMenuItem(player, options) {
	    var _this;
	
	    var track = options.track;
	    var tracks = player.textTracks(); // Modify options for parent MenuItem class's init.
	
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track.mode === 'showing';
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.track = track; // Determine the relevant kind(s) of tracks for this component and filter
	    // out empty kinds.
	
	    _this.kinds = (options.kinds || [options.kind || _this.track.kind]).filter(Boolean);
	
	    var changeHandler = function changeHandler() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.handleTracksChange.apply(_assertThisInitialized__default['default'](_this), args);
	    };
	
	    var selectedLanguageChangeHandler = function selectedLanguageChangeHandler() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      _this.handleSelectedLanguageChange.apply(_assertThisInitialized__default['default'](_this), args);
	    };
	
	    player.on(['loadstart', 'texttrackchange'], changeHandler);
	    tracks.addEventListener('change', changeHandler);
	    tracks.addEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
	
	    _this.on('dispose', function () {
	      player.off(['loadstart', 'texttrackchange'], changeHandler);
	      tracks.removeEventListener('change', changeHandler);
	      tracks.removeEventListener('selectedlanguagechange', selectedLanguageChangeHandler);
	    }); // iOS7 doesn't dispatch change events to TextTrackLists when an
	    // associated track's mode changes. Without something like
	    // Object.observe() (also not present on iOS7), it's not
	    // possible to detect changes to the mode attribute and polyfill
	    // the change event. As a poor substitute, we manually dispatch
	    // change events whenever the controls modify the mode.
	
	
	    if (tracks.onchange === undefined) {
	      var event;
	
	      _this.on(['tap', 'click'], function () {
	        if (typeof window__default['default'].Event !== 'object') {
	          // Android 2.3 throws an Illegal Constructor error for window.Event
	          try {
	            event = new window__default['default'].Event('change');
	          } catch (err) {// continue regardless of error
	          }
	        }
	
	        if (!event) {
	          event = document__default['default'].createEvent('Event');
	          event.initEvent('change', true, true);
	        }
	
	        tracks.dispatchEvent(event);
	      });
	    } // set the default state based on current tracks
	
	
	    _this.handleTracksChange();
	
	    return _this;
	  }
	  /**
	   * This gets called when an `TextTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = TextTrackMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    var referenceTrack = this.track;
	    var tracks = this.player_.textTracks();
	
	    _MenuItem.prototype.handleClick.call(this, event);
	
	    if (!tracks) {
	      return;
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i]; // If the track from the text tracks list is not of the right kind,
	      // skip it. We do not want to affect tracks of incompatible kind(s).
	
	      if (this.kinds.indexOf(track.kind) === -1) {
	        continue;
	      } // If this text track is the component's track and it is not showing,
	      // set it to showing.
	
	
	      if (track === referenceTrack) {
	        if (track.mode !== 'showing') {
	          track.mode = 'showing';
	        } // If this text track is not the component's track and it is not
	        // disabled, set it to disabled.
	
	      } else if (track.mode !== 'disabled') {
	        track.mode = 'disabled';
	      }
	    }
	  }
	  /**
	   * Handle text track list change
	   *
	   * @param {EventTarget~Event} event
	   *        The `change` event that caused this function to be called.
	   *
	   * @listens TextTrackList#change
	   */
	  ;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    var shouldBeSelected = this.track.mode === 'showing'; // Prevent redundant selected() calls because they may cause
	    // screen readers to read the appended control text unnecessarily
	
	    if (shouldBeSelected !== this.isSelected_) {
	      this.selected(shouldBeSelected);
	    }
	  };
	
	  _proto.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
	    if (this.track.mode === 'showing') {
	      var selectedLanguage = this.player_.cache_.selectedLanguage; // Don't replace the kind of track across the same language
	
	      if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) {
	        return;
	      }
	
	      this.player_.cache_.selectedLanguage = {
	        enabled: true,
	        language: this.track.language,
	        kind: this.track.kind
	      };
	    }
	  };
	
	  _proto.dispose = function dispose() {
	    // remove reference to track object on dispose
	    this.track = null;
	
	    _MenuItem.prototype.dispose.call(this);
	  };
	
	  return TextTrackMenuItem;
	}(MenuItem);
	
	Component$1.registerComponent('TextTrackMenuItem', TextTrackMenuItem);
	
	/**
	 * A special menu item for turning of a specific type of text track
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var OffTextTrackMenuItem = /*#__PURE__*/function (_TextTrackMenuItem) {
	  _inheritsLoose__default['default'](OffTextTrackMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function OffTextTrackMenuItem(player, options) {
	    // Create pseudo track info
	    // Requires options['kind']
	    options.track = {
	      player: player,
	      // it is no longer necessary to store `kind` or `kinds` on the track itself
	      // since they are now stored in the `kinds` property of all instances of
	      // TextTrackMenuItem, but this will remain for backwards compatibility
	      kind: options.kind,
	      kinds: options.kinds,
	      "default": false,
	      mode: 'disabled'
	    };
	
	    if (!options.kinds) {
	      options.kinds = [options.kind];
	    }
	
	    if (options.label) {
	      options.track.label = options.label;
	    } else {
	      options.track.label = options.kinds.join(' and ') + ' off';
	    } // MenuItem is selectable
	
	
	    options.selectable = true; // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	
	    options.multiSelectable = false;
	    return _TextTrackMenuItem.call(this, player, options) || this;
	  }
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   */
	
	
	  var _proto = OffTextTrackMenuItem.prototype;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var shouldBeSelected = true;
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === 'showing') {
	        shouldBeSelected = false;
	        break;
	      }
	    } // Prevent redundant selected() calls because they may cause
	    // screen readers to read the appended control text unnecessarily
	
	
	    if (shouldBeSelected !== this.isSelected_) {
	      this.selected(shouldBeSelected);
	    }
	  };
	
	  _proto.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
	    var tracks = this.player().textTracks();
	    var allHidden = true;
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (['captions', 'descriptions', 'subtitles'].indexOf(track.kind) > -1 && track.mode === 'showing') {
	        allHidden = false;
	        break;
	      }
	    }
	
	    if (allHidden) {
	      this.player_.cache_.selectedLanguage = {
	        enabled: false
	      };
	    }
	  };
	
	  return OffTextTrackMenuItem;
	}(TextTrackMenuItem);
	
	Component$1.registerComponent('OffTextTrackMenuItem', OffTextTrackMenuItem);
	
	/**
	 * The base class for buttons that toggle specific text track types (e.g. subtitles)
	 *
	 * @extends MenuButton
	 */
	
	var TextTrackButton = /*#__PURE__*/function (_TrackButton) {
	  _inheritsLoose__default['default'](TextTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function TextTrackButton(player, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    options.tracks = player.textTracks();
	    return _TrackButton.call(this, player, options) || this;
	  }
	  /**
	   * Create a menu item for each text track
	   *
	   * @param {TextTrackMenuItem[]} [items=[]]
	   *        Existing array of items to use during creation
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items that were created
	   */
	
	
	  var _proto = TextTrackButton.prototype;
	
	  _proto.createItems = function createItems(items, TrackMenuItem) {
	    if (items === void 0) {
	      items = [];
	    }
	
	    if (TrackMenuItem === void 0) {
	      TrackMenuItem = TextTrackMenuItem;
	    }
	
	    // Label is an override for the [track] off label
	    // USed to localise captions/subtitles
	    var label;
	
	    if (this.label_) {
	      label = this.label_ + " off";
	    } // Add an OFF menu item to turn all tracks off
	
	
	    items.push(new OffTextTrackMenuItem(this.player_, {
	      kinds: this.kinds_,
	      kind: this.kind_,
	      label: label
	    }));
	    this.hideThreshold_ += 1;
	    var tracks = this.player_.textTracks();
	
	    if (!Array.isArray(this.kinds_)) {
	      this.kinds_ = [this.kind_];
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i]; // only add tracks that are of an appropriate kind and have a label
	
	      if (this.kinds_.indexOf(track.kind) > -1) {
	        var item = new TrackMenuItem(this.player_, {
	          track: track,
	          kinds: this.kinds_,
	          kind: this.kind_,
	          // MenuItem is selectable
	          selectable: true,
	          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	          multiSelectable: false
	        });
	        item.addClass("vjs-" + track.kind + "-menu-item");
	        items.push(item);
	      }
	    }
	
	    return items;
	  };
	
	  return TextTrackButton;
	}(TrackButton);
	
	Component$1.registerComponent('TextTrackButton', TextTrackButton);
	
	/**
	 * The chapter track menu item
	 *
	 * @extends MenuItem
	 */
	
	var ChaptersTrackMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](ChaptersTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function ChaptersTrackMenuItem(player, options) {
	    var _this;
	
	    var track = options.track;
	    var cue = options.cue;
	    var currentTime = player.currentTime(); // Modify options for parent MenuItem class's init.
	
	    options.selectable = true;
	    options.multiSelectable = false;
	    options.label = cue.text;
	    options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.track = track;
	    _this.cue = cue;
	    return _this;
	  }
	  /**
	   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = ChaptersTrackMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	
	    this.player_.currentTime(this.cue.startTime);
	  };
	
	  return ChaptersTrackMenuItem;
	}(MenuItem);
	
	Component$1.registerComponent('ChaptersTrackMenuItem', ChaptersTrackMenuItem);
	
	/**
	 * The button component for toggling and selecting chapters
	 * Chapters act much differently than other text tracks
	 * Cues are navigation vs. other tracks of alternative languages
	 *
	 * @extends TextTrackButton
	 */
	
	var ChaptersButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](ChaptersButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this function is ready.
	   */
	  function ChaptersButton(player, options, ready) {
	    var _this;
	
	    _this = _TextTrackButton.call(this, player, options, ready) || this;
	
	    _this.selectCurrentItem_ = function () {
	      _this.items.forEach(function (item) {
	        item.selected(_this.track_.activeCues[0] === item.cue);
	      });
	    };
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = ChaptersButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-chapters-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-chapters-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Update the menu based on the current state of its items.
	   *
	   * @param {EventTarget~Event} [event]
	   *        An event that triggered this function to run.
	   *
	   * @listens TextTrackList#addtrack
	   * @listens TextTrackList#removetrack
	   * @listens TextTrackList#change
	   */
	  ;
	
	  _proto.update = function update(event) {
	    if (event && event.track && event.track.kind !== 'chapters') {
	      return;
	    }
	
	    var track = this.findChaptersTrack();
	
	    if (track !== this.track_) {
	      this.setTrack(track);
	
	      _TextTrackButton.prototype.update.call(this);
	    } else if (!this.items || track && track.cues && track.cues.length !== this.items.length) {
	      // Update the menu initially or if the number of cues has changed since set
	      _TextTrackButton.prototype.update.call(this);
	    }
	  }
	  /**
	   * Set the currently selected track for the chapters button.
	   *
	   * @param {TextTrack} track
	   *        The new track to select. Nothing will change if this is the currently selected
	   *        track.
	   */
	  ;
	
	  _proto.setTrack = function setTrack(track) {
	    if (this.track_ === track) {
	      return;
	    }
	
	    if (!this.updateHandler_) {
	      this.updateHandler_ = this.update.bind(this);
	    } // here this.track_ refers to the old track instance
	
	
	    if (this.track_) {
	      var remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (remoteTextTrackEl) {
	        remoteTextTrackEl.removeEventListener('load', this.updateHandler_);
	      }
	
	      this.track_.removeEventListener('cuechange', this.selectCurrentItem_);
	      this.track_ = null;
	    }
	
	    this.track_ = track; // here this.track_ refers to the new track instance
	
	    if (this.track_) {
	      this.track_.mode = 'hidden';
	
	      var _remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (_remoteTextTrackEl) {
	        _remoteTextTrackEl.addEventListener('load', this.updateHandler_);
	      }
	
	      this.track_.addEventListener('cuechange', this.selectCurrentItem_);
	    }
	  }
	  /**
	   * Find the track object that is currently in use by this ChaptersButton
	   *
	   * @return {TextTrack|undefined}
	   *         The current track or undefined if none was found.
	   */
	  ;
	
	  _proto.findChaptersTrack = function findChaptersTrack() {
	    var tracks = this.player_.textTracks() || [];
	
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      // We will always choose the last track as our chaptersTrack
	      var track = tracks[i];
	
	      if (track.kind === this.kind_) {
	        return track;
	      }
	    }
	  }
	  /**
	   * Get the caption for the ChaptersButton based on the track label. This will also
	   * use the current tracks localized kind as a fallback if a label does not exist.
	   *
	   * @return {string}
	   *         The tracks current label or the localized track kind.
	   */
	  ;
	
	  _proto.getMenuCaption = function getMenuCaption() {
	    if (this.track_ && this.track_.label) {
	      return this.track_.label;
	    }
	
	    return this.localize(toTitleCase$1(this.kind_));
	  }
	  /**
	   * Create menu from chapter track
	   *
	   * @return {Menu}
	   *         New menu for the chapter buttons
	   */
	  ;
	
	  _proto.createMenu = function createMenu() {
	    this.options_.title = this.getMenuCaption();
	    return _TextTrackButton.prototype.createMenu.call(this);
	  }
	  /**
	   * Create a menu item for each text track
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var items = [];
	
	    if (!this.track_) {
	      return items;
	    }
	
	    var cues = this.track_.cues;
	
	    if (!cues) {
	      return items;
	    }
	
	    for (var i = 0, l = cues.length; i < l; i++) {
	      var cue = cues[i];
	      var mi = new ChaptersTrackMenuItem(this.player_, {
	        track: this.track_,
	        cue: cue
	      });
	      items.push(mi);
	    }
	
	    return items;
	  };
	
	  return ChaptersButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	ChaptersButton.prototype.kind_ = 'chapters';
	/**
	 * The text that should display over the `ChaptersButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	ChaptersButton.prototype.controlText_ = 'Chapters';
	Component$1.registerComponent('ChaptersButton', ChaptersButton);
	
	/**
	 * The button component for toggling and selecting descriptions
	 *
	 * @extends TextTrackButton
	 */
	
	var DescriptionsButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](DescriptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function DescriptionsButton(player, options, ready) {
	    var _this;
	
	    _this = _TextTrackButton.call(this, player, options, ready) || this;
	    var tracks = player.textTracks();
	    var changeHandler = bind(_assertThisInitialized__default['default'](_this), _this.handleTracksChange);
	    tracks.addEventListener('change', changeHandler);
	
	    _this.on('dispose', function () {
	      tracks.removeEventListener('change', changeHandler);
	    });
	
	    return _this;
	  }
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   *
	   * @listens TextTrackList#change
	   */
	
	
	  var _proto = DescriptionsButton.prototype;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var disabled = false; // Check whether a track of a different kind is showing
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (track.kind !== this.kind_ && track.mode === 'showing') {
	        disabled = true;
	        break;
	      }
	    } // If another track is showing, disable this menu button
	
	
	    if (disabled) {
	      this.disable();
	    } else {
	      this.enable();
	    }
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-descriptions-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-descriptions-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  return DescriptionsButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	DescriptionsButton.prototype.kind_ = 'descriptions';
	/**
	 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	DescriptionsButton.prototype.controlText_ = 'Descriptions';
	Component$1.registerComponent('DescriptionsButton', DescriptionsButton);
	
	/**
	 * The button component for toggling and selecting subtitles
	 *
	 * @extends TextTrackButton
	 */
	
	var SubtitlesButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](SubtitlesButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function SubtitlesButton(player, options, ready) {
	    return _TextTrackButton.call(this, player, options, ready) || this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = SubtitlesButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-subtitles-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-subtitles-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  };
	
	  return SubtitlesButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	SubtitlesButton.prototype.kind_ = 'subtitles';
	/**
	 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	SubtitlesButton.prototype.controlText_ = 'Subtitles';
	Component$1.registerComponent('SubtitlesButton', SubtitlesButton);
	
	/**
	 * The menu item for caption track settings menu
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var CaptionSettingsMenuItem = /*#__PURE__*/function (_TextTrackMenuItem) {
	  _inheritsLoose__default['default'](CaptionSettingsMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function CaptionSettingsMenuItem(player, options) {
	    var _this;
	
	    options.track = {
	      player: player,
	      kind: options.kind,
	      label: options.kind + ' settings',
	      selectable: false,
	      "default": false,
	      mode: 'disabled'
	    }; // CaptionSettingsMenuItem has no concept of 'selected'
	
	    options.selectable = false;
	    options.name = 'CaptionSettingsMenuItem';
	    _this = _TextTrackMenuItem.call(this, player, options) || this;
	
	    _this.addClass('vjs-texttrack-settings');
	
	    _this.controlText(', opens ' + options.kind + ' settings dialog');
	
	    return _this;
	  }
	  /**
	   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = CaptionSettingsMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    this.player().getChild('textTrackSettings').open();
	  };
	
	  return CaptionSettingsMenuItem;
	}(TextTrackMenuItem);
	
	Component$1.registerComponent('CaptionSettingsMenuItem', CaptionSettingsMenuItem);
	
	/**
	 * The button component for toggling and selecting captions
	 *
	 * @extends TextTrackButton
	 */
	
	var CaptionsButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](CaptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function CaptionsButton(player, options, ready) {
	    return _TextTrackButton.call(this, player, options, ready) || this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = CaptionsButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-captions-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-captions-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create caption menu items
	   *
	   * @return {CaptionSettingsMenuItem[]}
	   *         The array of current menu items.
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var items = [];
	
	    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
	      items.push(new CaptionSettingsMenuItem(this.player_, {
	        kind: this.kind_
	      }));
	      this.hideThreshold_ += 1;
	    }
	
	    return _TextTrackButton.prototype.createItems.call(this, items);
	  };
	
	  return CaptionsButton;
	}(TextTrackButton);
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	CaptionsButton.prototype.kind_ = 'captions';
	/**
	 * The text that should display over the `CaptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	CaptionsButton.prototype.controlText_ = 'Captions';
	Component$1.registerComponent('CaptionsButton', CaptionsButton);
	
	/**
	 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
	 * in the SubsCapsMenu.
	 *
	 * @extends TextTrackMenuItem
	 */
	
	var SubsCapsMenuItem = /*#__PURE__*/function (_TextTrackMenuItem) {
	  _inheritsLoose__default['default'](SubsCapsMenuItem, _TextTrackMenuItem);
	
	  function SubsCapsMenuItem() {
	    return _TextTrackMenuItem.apply(this, arguments) || this;
	  }
	
	  var _proto = SubsCapsMenuItem.prototype;
	
	  _proto.createEl = function createEl$1(type, props, attrs) {
	    var el = _TextTrackMenuItem.prototype.createEl.call(this, type, props, attrs);
	
	    var parentSpan = el.querySelector('.vjs-menu-item-text');
	
	    if (this.options_.track.kind === 'captions') {
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-icon-placeholder'
	      }, {
	        'aria-hidden': true
	      }));
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-control-text',
	        // space added as the text will visually flow with the
	        // label
	        textContent: " " + this.localize('Captions')
	      }));
	    }
	
	    return el;
	  };
	
	  return SubsCapsMenuItem;
	}(TextTrackMenuItem);
	
	Component$1.registerComponent('SubsCapsMenuItem', SubsCapsMenuItem);
	
	/**
	 * The button component for toggling and selecting captions and/or subtitles
	 *
	 * @extends TextTrackButton
	 */
	
	var SubsCapsButton = /*#__PURE__*/function (_TextTrackButton) {
	  _inheritsLoose__default['default'](SubsCapsButton, _TextTrackButton);
	
	  function SubsCapsButton(player, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _TextTrackButton.call(this, player, options) || this; // Although North America uses "captions" in most cases for
	    // "captions and subtitles" other locales use "subtitles"
	
	    _this.label_ = 'subtitles';
	
	    if (['en', 'en-us', 'en-ca', 'fr-ca'].indexOf(_this.player_.language_) > -1) {
	      _this.label_ = 'captions';
	    }
	
	    _this.menuButton_.controlText(toTitleCase$1(_this.label_));
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = SubsCapsButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-subs-caps-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-subs-caps-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create caption/subtitles menu items
	   *
	   * @return {CaptionSettingsMenuItem[]}
	   *         The array of current menu items.
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var items = [];
	
	    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild('textTrackSettings')) {
	      items.push(new CaptionSettingsMenuItem(this.player_, {
	        kind: this.label_
	      }));
	      this.hideThreshold_ += 1;
	    }
	
	    items = _TextTrackButton.prototype.createItems.call(this, items, SubsCapsMenuItem);
	    return items;
	  };
	
	  return SubsCapsButton;
	}(TextTrackButton);
	/**
	 * `kind`s of TextTrack to look for to associate it with this menu.
	 *
	 * @type {array}
	 * @private
	 */
	
	
	SubsCapsButton.prototype.kinds_ = ['captions', 'subtitles'];
	/**
	 * The text that should display over the `SubsCapsButton`s controls.
	 *
	 *
	 * @type {string}
	 * @private
	 */
	
	SubsCapsButton.prototype.controlText_ = 'Subtitles';
	Component$1.registerComponent('SubsCapsButton', SubsCapsButton);
	
	/**
	 * An {@link AudioTrack} {@link MenuItem}
	 *
	 * @extends MenuItem
	 */
	
	var AudioTrackMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](AudioTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function AudioTrackMenuItem(player, options) {
	    var _this;
	
	    var track = options.track;
	    var tracks = player.audioTracks(); // Modify options for parent MenuItem class's init.
	
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track.enabled;
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.track = track;
	
	    _this.addClass("vjs-" + track.kind + "-menu-item");
	
	    var changeHandler = function changeHandler() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.handleTracksChange.apply(_assertThisInitialized__default['default'](_this), args);
	    };
	
	    tracks.addEventListener('change', changeHandler);
	
	    _this.on('dispose', function () {
	      tracks.removeEventListener('change', changeHandler);
	    });
	
	    return _this;
	  }
	
	  var _proto = AudioTrackMenuItem.prototype;
	
	  _proto.createEl = function createEl$1(type, props, attrs) {
	    var el = _MenuItem.prototype.createEl.call(this, type, props, attrs);
	
	    var parentSpan = el.querySelector('.vjs-menu-item-text');
	
	    if (this.options_.track.kind === 'main-desc') {
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-icon-placeholder'
	      }, {
	        'aria-hidden': true
	      }));
	      parentSpan.appendChild(createEl('span', {
	        className: 'vjs-control-text',
	        textContent: ' ' + this.localize('Descriptions')
	      }));
	    }
	
	    return el;
	  }
	  /**
	   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this, event); // the audio track list will automatically toggle other tracks
	    // off for us.
	
	
	    this.track.enabled = true; // when native audio tracks are used, we want to make sure that other tracks are turned off
	
	    if (this.player_.tech_.featuresNativeAudioTracks) {
	      var tracks = this.player_.audioTracks();
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i]; // skip the current track since we enabled it above
	
	        if (track === this.track) {
	          continue;
	        }
	
	        track.enabled = track === this.track;
	      }
	    }
	  }
	  /**
	   * Handle any {@link AudioTrack} change.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link AudioTrackList#change} event that caused this to run.
	   *
	   * @listens AudioTrackList#change
	   */
	  ;
	
	  _proto.handleTracksChange = function handleTracksChange(event) {
	    this.selected(this.track.enabled);
	  };
	
	  return AudioTrackMenuItem;
	}(MenuItem);
	
	Component$1.registerComponent('AudioTrackMenuItem', AudioTrackMenuItem);
	
	/**
	 * The base class for buttons that toggle specific {@link AudioTrack} types.
	 *
	 * @extends TrackButton
	 */
	
	var AudioTrackButton = /*#__PURE__*/function (_TrackButton) {
	  _inheritsLoose__default['default'](AudioTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function AudioTrackButton(player, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    options.tracks = player.audioTracks();
	    return _TrackButton.call(this, player, options) || this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  var _proto = AudioTrackButton.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-audio-button " + _TrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-audio-button " + _TrackButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create a menu item for each audio track
	   *
	   * @param {AudioTrackMenuItem[]} [items=[]]
	   *        An array of existing menu items to use.
	   *
	   * @return {AudioTrackMenuItem[]}
	   *         An array of menu items
	   */
	  ;
	
	  _proto.createItems = function createItems(items) {
	    if (items === void 0) {
	      items = [];
	    }
	
	    // if there's only one audio track, there no point in showing it
	    this.hideThreshold_ = 1;
	    var tracks = this.player_.audioTracks();
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	      items.push(new AudioTrackMenuItem(this.player_, {
	        track: track,
	        // MenuItem is selectable
	        selectable: true,
	        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
	        multiSelectable: false
	      }));
	    }
	
	    return items;
	  };
	
	  return AudioTrackButton;
	}(TrackButton);
	/**
	 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	AudioTrackButton.prototype.controlText_ = 'Audio Track';
	Component$1.registerComponent('AudioTrackButton', AudioTrackButton);
	
	/**
	 * The specific menu item type for selecting a playback rate.
	 *
	 * @extends MenuItem
	 */
	
	var PlaybackRateMenuItem = /*#__PURE__*/function (_MenuItem) {
	  _inheritsLoose__default['default'](PlaybackRateMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuItem(player, options) {
	    var _this;
	
	    var label = options.rate;
	    var rate = parseFloat(label, 10); // Modify options for parent MenuItem class's init.
	
	    options.label = label;
	    options.selected = rate === player.playbackRate();
	    options.selectable = true;
	    options.multiSelectable = false;
	    _this = _MenuItem.call(this, player, options) || this;
	    _this.label = label;
	    _this.rate = rate;
	
	    _this.on(player, 'ratechange', function (e) {
	      return _this.update(e);
	    });
	
	    return _this;
	  }
	  /**
	   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  var _proto = PlaybackRateMenuItem.prototype;
	
	  _proto.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	
	    this.player().playbackRate(this.rate);
	  }
	  /**
	   * Update the PlaybackRateMenuItem when the playbackrate changes.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `ratechange` event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	  ;
	
	  _proto.update = function update(event) {
	    this.selected(this.player().playbackRate() === this.rate);
	  };
	
	  return PlaybackRateMenuItem;
	}(MenuItem);
	/**
	 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuItem.prototype.contentElType = 'button';
	Component$1.registerComponent('PlaybackRateMenuItem', PlaybackRateMenuItem);
	
	/**
	 * The component for controlling the playback rate.
	 *
	 * @extends MenuButton
	 */
	
	var PlaybackRateMenuButton = /*#__PURE__*/function (_MenuButton) {
	  _inheritsLoose__default['default'](PlaybackRateMenuButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuButton(player, options) {
	    var _this;
	
	    _this = _MenuButton.call(this, player, options) || this;
	
	    _this.menuButton_.el_.setAttribute('aria-describedby', _this.labelElId_);
	
	    _this.updateVisibility();
	
	    _this.updateLabel();
	
	    _this.on(player, 'loadstart', function (e) {
	      return _this.updateVisibility(e);
	    });
	
	    _this.on(player, 'ratechange', function (e) {
	      return _this.updateLabel(e);
	    });
	
	    _this.on(player, 'playbackrateschange', function (e) {
	      return _this.handlePlaybackRateschange(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  var _proto = PlaybackRateMenuButton.prototype;
	
	  _proto.createEl = function createEl$1() {
	    var el = _MenuButton.prototype.createEl.call(this);
	
	    this.labelElId_ = 'vjs-playback-rate-value-label-' + this.id_;
	    this.labelEl_ = createEl('div', {
	      className: 'vjs-playback-rate-value',
	      id: this.labelElId_,
	      textContent: '1x'
	    });
	    el.appendChild(this.labelEl_);
	    return el;
	  };
	
	  _proto.dispose = function dispose() {
	    this.labelEl_ = null;
	
	    _MenuButton.prototype.dispose.call(this);
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  ;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-playback-rate " + _MenuButton.prototype.buildCSSClass.call(this);
	  };
	
	  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
	    return "vjs-playback-rate " + _MenuButton.prototype.buildWrapperCSSClass.call(this);
	  }
	  /**
	   * Create the list of menu items. Specific to each subclass.
	   *
	   */
	  ;
	
	  _proto.createItems = function createItems() {
	    var rates = this.playbackRates();
	    var items = [];
	
	    for (var i = rates.length - 1; i >= 0; i--) {
	      items.push(new PlaybackRateMenuItem(this.player(), {
	        rate: rates[i] + 'x'
	      }));
	    }
	
	    return items;
	  }
	  /**
	   * Updates ARIA accessibility attributes
	   */
	  ;
	
	  _proto.updateARIAAttributes = function updateARIAAttributes() {
	    // Current playback rate
	    this.el().setAttribute('aria-valuenow', this.player().playbackRate());
	  }
	  /**
	   * This gets called when an `PlaybackRateMenuButton` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	  ;
	
	  _proto.handleClick = function handleClick(event) {
	    // select next rate option
	    var currentRate = this.player().playbackRate();
	    var rates = this.playbackRates();
	    var currentIndex = rates.indexOf(currentRate); // this get the next rate and it will select first one if the last one currently selected
	
	    var newIndex = (currentIndex + 1) % rates.length;
	    this.player().playbackRate(rates[newIndex]);
	  }
	  /**
	   * On playbackrateschange, update the menu to account for the new items.
	   *
	   * @listens Player#playbackrateschange
	   */
	  ;
	
	  _proto.handlePlaybackRateschange = function handlePlaybackRateschange(event) {
	    this.update();
	  }
	  /**
	   * Get possible playback rates
	   *
	   * @return {Array}
	   *         All possible playback rates
	   */
	  ;
	
	  _proto.playbackRates = function playbackRates() {
	    var player = this.player();
	    return player.playbackRates && player.playbackRates() || [];
	  }
	  /**
	   * Get whether playback rates is supported by the tech
	   * and an array of playback rates exists
	   *
	   * @return {boolean}
	   *         Whether changing playback rate is supported
	   */
	  ;
	
	  _proto.playbackRateSupported = function playbackRateSupported() {
	    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
	  }
	  /**
	   * Hide playback rate controls when they're no playback rate options to select
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#loadstart
	   */
	  ;
	
	  _proto.updateVisibility = function updateVisibility(event) {
	    if (this.playbackRateSupported()) {
	      this.removeClass('vjs-hidden');
	    } else {
	      this.addClass('vjs-hidden');
	    }
	  }
	  /**
	   * Update button label when rate changed
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	  ;
	
	  _proto.updateLabel = function updateLabel(event) {
	    if (this.playbackRateSupported()) {
	      this.labelEl_.textContent = this.player().playbackRate() + 'x';
	    }
	  };
	
	  return PlaybackRateMenuButton;
	}(MenuButton);
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuButton.prototype.controlText_ = 'Playback Rate';
	Component$1.registerComponent('PlaybackRateMenuButton', PlaybackRateMenuButton);
	
	/**
	 * Just an empty spacer element that can be used as an append point for plugins, etc.
	 * Also can be used to create space between elements when necessary.
	 *
	 * @extends Component
	 */
	
	var Spacer = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Spacer, _Component);
	
	  function Spacer() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Spacer.prototype;
	
	  /**
	  * Builds the default DOM `className`.
	  *
	  * @return {string}
	  *         The DOM `className` for this object.
	  */
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-spacer " + _Component.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl(tag, props, attributes) {
	    if (tag === void 0) {
	      tag = 'div';
	    }
	
	    if (props === void 0) {
	      props = {};
	    }
	
	    if (attributes === void 0) {
	      attributes = {};
	    }
	
	    if (!props.className) {
	      props.className = this.buildCSSClass();
	    }
	
	    return _Component.prototype.createEl.call(this, tag, props, attributes);
	  };
	
	  return Spacer;
	}(Component$1);
	
	Component$1.registerComponent('Spacer', Spacer);
	
	/**
	 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
	 *
	 * @extends Spacer
	 */
	
	var CustomControlSpacer = /*#__PURE__*/function (_Spacer) {
	  _inheritsLoose__default['default'](CustomControlSpacer, _Spacer);
	
	  function CustomControlSpacer() {
	    return _Spacer.apply(this, arguments) || this;
	  }
	
	  var _proto = CustomControlSpacer.prototype;
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-custom-control-spacer " + _Spacer.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    return _Spacer.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass(),
	      // No-flex/table-cell mode requires there be some content
	      // in the cell to fill the remaining space of the table.
	      textContent: "\xA0"
	    });
	  };
	
	  return CustomControlSpacer;
	}(Spacer);
	
	Component$1.registerComponent('CustomControlSpacer', CustomControlSpacer);
	
	/**
	 * Container of main controls.
	 *
	 * @extends Component
	 */
	
	var ControlBar = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ControlBar, _Component);
	
	  function ControlBar() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ControlBar.prototype;
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-control-bar',
	      dir: 'ltr'
	    });
	  };
	
	  return ControlBar;
	}(Component$1);
	/**
	 * Default options for `ControlBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ControlBar.prototype.options_ = {
	  children: ['playToggle', 'volumePanel', 'currentTimeDisplay', 'timeDivider', 'durationDisplay', 'progressControl', 'liveDisplay', 'seekToLive', 'remainingTimeDisplay', 'customControlSpacer', 'playbackRateMenuButton', 'chaptersButton', 'descriptionsButton', 'subsCapsButton', 'audioTrackButton', 'fullscreenToggle']
	};
	
	if ('exitPictureInPicture' in document__default['default']) {
	  ControlBar.prototype.options_.children.splice(ControlBar.prototype.options_.children.length - 1, 0, 'pictureInPictureToggle');
	}
	
	Component$1.registerComponent('ControlBar', ControlBar);
	
	/**
	 * A display that indicates an error has occurred. This means that the video
	 * is unplayable.
	 *
	 * @extends ModalDialog
	 */
	
	var ErrorDisplay = /*#__PURE__*/function (_ModalDialog) {
	  _inheritsLoose__default['default'](ErrorDisplay, _ModalDialog);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of player options.
	   */
	  function ErrorDisplay(player, options) {
	    var _this;
	
	    _this = _ModalDialog.call(this, player, options) || this;
	
	    _this.on(player, 'error', function (e) {
	      return _this.open(e);
	    });
	
	    return _this;
	  }
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   *
	   * @deprecated Since version 5.
	   */
	
	
	  var _proto = ErrorDisplay.prototype;
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return "vjs-error-display " + _ModalDialog.prototype.buildCSSClass.call(this);
	  }
	  /**
	   * Gets the localized error message based on the `Player`s error.
	   *
	   * @return {string}
	   *         The `Player`s error message localized or an empty string.
	   */
	  ;
	
	  _proto.content = function content() {
	    var error = this.player().error();
	    return error ? this.localize(error.message) : '';
	  };
	
	  return ErrorDisplay;
	}(ModalDialog);
	/**
	 * The default options for an `ErrorDisplay`.
	 *
	 * @private
	 */
	
	
	ErrorDisplay.prototype.options_ = _extends__default['default']({}, ModalDialog.prototype.options_, {
	  pauseOnOpen: false,
	  fillAlways: true,
	  temporary: false,
	  uncloseable: true
	});
	Component$1.registerComponent('ErrorDisplay', ErrorDisplay);
	
	var LOCAL_STORAGE_KEY$1 = 'vjs-text-track-settings';
	var COLOR_BLACK = ['#000', 'Black'];
	var COLOR_BLUE = ['#00F', 'Blue'];
	var COLOR_CYAN = ['#0FF', 'Cyan'];
	var COLOR_GREEN = ['#0F0', 'Green'];
	var COLOR_MAGENTA = ['#F0F', 'Magenta'];
	var COLOR_RED = ['#F00', 'Red'];
	var COLOR_WHITE = ['#FFF', 'White'];
	var COLOR_YELLOW = ['#FF0', 'Yellow'];
	var OPACITY_OPAQUE = ['1', 'Opaque'];
	var OPACITY_SEMI = ['0.5', 'Semi-Transparent'];
	var OPACITY_TRANS = ['0', 'Transparent']; // Configuration for the various <select> elements in the DOM of this component.
	//
	// Possible keys include:
	//
	// `default`:
	//   The default option index. Only needs to be provided if not zero.
	// `parser`:
	//   A function which is used to parse the value from the selected option in
	//   a customized way.
	// `selector`:
	//   The selector used to find the associated <select> element.
	
	var selectConfigs = {
	  backgroundColor: {
	    selector: '.vjs-bg-color > select',
	    id: 'captions-background-color-%s',
	    label: 'Color',
	    options: [COLOR_BLACK, COLOR_WHITE, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	  backgroundOpacity: {
	    selector: '.vjs-bg-opacity > select',
	    id: 'captions-background-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI, OPACITY_TRANS]
	  },
	  color: {
	    selector: '.vjs-fg-color > select',
	    id: 'captions-foreground-color-%s',
	    label: 'Color',
	    options: [COLOR_WHITE, COLOR_BLACK, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	  edgeStyle: {
	    selector: '.vjs-edge-style > select',
	    id: '%s',
	    label: 'Text Edge Style',
	    options: [['none', 'None'], ['raised', 'Raised'], ['depressed', 'Depressed'], ['uniform', 'Uniform'], ['dropshadow', 'Dropshadow']]
	  },
	  fontFamily: {
	    selector: '.vjs-font-family > select',
	    id: 'captions-font-family-%s',
	    label: 'Font Family',
	    options: [['proportionalSansSerif', 'Proportional Sans-Serif'], ['monospaceSansSerif', 'Monospace Sans-Serif'], ['proportionalSerif', 'Proportional Serif'], ['monospaceSerif', 'Monospace Serif'], ['casual', 'Casual'], ['script', 'Script'], ['small-caps', 'Small Caps']]
	  },
	  fontPercent: {
	    selector: '.vjs-font-percent > select',
	    id: 'captions-font-size-%s',
	    label: 'Font Size',
	    options: [['0.50', '50%'], ['0.75', '75%'], ['1.00', '100%'], ['1.25', '125%'], ['1.50', '150%'], ['1.75', '175%'], ['2.00', '200%'], ['3.00', '300%'], ['4.00', '400%']],
	    "default": 2,
	    parser: function parser(v) {
	      return v === '1.00' ? null : Number(v);
	    }
	  },
	  textOpacity: {
	    selector: '.vjs-text-opacity > select',
	    id: 'captions-foreground-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI]
	  },
	  // Options for this object are defined below.
	  windowColor: {
	    selector: '.vjs-window-color > select',
	    id: 'captions-window-color-%s',
	    label: 'Color'
	  },
	  // Options for this object are defined below.
	  windowOpacity: {
	    selector: '.vjs-window-opacity > select',
	    id: 'captions-window-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_TRANS, OPACITY_SEMI, OPACITY_OPAQUE]
	  }
	};
	selectConfigs.windowColor.options = selectConfigs.backgroundColor.options;
	/**
	 * Get the actual value of an option.
	 *
	 * @param  {string} value
	 *         The value to get
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	
	function parseOptionValue(value, parser) {
	  if (parser) {
	    value = parser(value);
	  }
	
	  if (value && value !== 'none') {
	    return value;
	  }
	}
	/**
	 * Gets the value of the selected <option> element within a <select> element.
	 *
	 * @param  {Element} el
	 *         the element to look in
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	
	
	function getSelectedOptionValue(el, parser) {
	  var value = el.options[el.options.selectedIndex].value;
	  return parseOptionValue(value, parser);
	}
	/**
	 * Sets the selected <option> element within a <select> element based on a
	 * given value.
	 *
	 * @param {Element} el
	 *        The element to look in.
	 *
	 * @param {string} value
	 *        the property to look on.
	 *
	 * @param {Function} [parser]
	 *        Optional function to adjust the value before comparing.
	 *
	 * @private
	 */
	
	
	function setSelectedOption(el, value, parser) {
	  if (!value) {
	    return;
	  }
	
	  for (var i = 0; i < el.options.length; i++) {
	    if (parseOptionValue(el.options[i].value, parser) === value) {
	      el.selectedIndex = i;
	      break;
	    }
	  }
	}
	/**
	 * Manipulate Text Tracks settings.
	 *
	 * @extends ModalDialog
	 */
	
	
	var TextTrackSettings = /*#__PURE__*/function (_ModalDialog) {
	  _inheritsLoose__default['default'](TextTrackSettings, _ModalDialog);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *         The key/value store of player options.
	   */
	  function TextTrackSettings(player, options) {
	    var _this;
	
	    options.temporary = false;
	    _this = _ModalDialog.call(this, player, options) || this;
	    _this.updateDisplay = _this.updateDisplay.bind(_assertThisInitialized__default['default'](_this)); // fill the modal and pretend we have opened it
	
	    _this.fill();
	
	    _this.hasBeenOpened_ = _this.hasBeenFilled_ = true;
	    _this.endDialog = createEl('p', {
	      className: 'vjs-control-text',
	      textContent: _this.localize('End of dialog window.')
	    });
	
	    _this.el().appendChild(_this.endDialog);
	
	    _this.setDefaults(); // Grab `persistTextTrackSettings` from the player options if not passed in child options
	
	
	    if (options.persistTextTrackSettings === undefined) {
	      _this.options_.persistTextTrackSettings = _this.options_.playerOptions.persistTextTrackSettings;
	    }
	
	    _this.on(_this.$('.vjs-done-button'), 'click', function () {
	      _this.saveSettings();
	
	      _this.close();
	    });
	
	    _this.on(_this.$('.vjs-default-button'), 'click', function () {
	      _this.setDefaults();
	
	      _this.updateDisplay();
	    });
	
	    each(selectConfigs, function (config) {
	      _this.on(_this.$(config.selector), 'change', _this.updateDisplay);
	    });
	
	    if (_this.options_.persistTextTrackSettings) {
	      _this.restoreSettings();
	    }
	
	    return _this;
	  }
	
	  var _proto = TextTrackSettings.prototype;
	
	  _proto.dispose = function dispose() {
	    this.endDialog = null;
	
	    _ModalDialog.prototype.dispose.call(this);
	  }
	  /**
	   * Create a <select> element with configured options.
	   *
	   * @param {string} key
	   *        Configuration key to use during creation.
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElSelect_ = function createElSelect_(key, legendId, type) {
	    var _this2 = this;
	
	    if (legendId === void 0) {
	      legendId = '';
	    }
	
	    if (type === void 0) {
	      type = 'label';
	    }
	
	    var config = selectConfigs[key];
	    var id = config.id.replace('%s', this.id_);
	    var selectLabelledbyIds = [legendId, id].join(' ').trim();
	    return ["<" + type + " id=\"" + id + "\" class=\"" + (type === 'label' ? 'vjs-label' : '') + "\">", this.localize(config.label), "</" + type + ">", "<select aria-labelledby=\"" + selectLabelledbyIds + "\">"].concat(config.options.map(function (o) {
	      var optionId = id + '-' + o[1].replace(/\W+/g, '');
	      return ["<option id=\"" + optionId + "\" value=\"" + o[0] + "\" ", "aria-labelledby=\"" + selectLabelledbyIds + " " + optionId + "\">", _this2.localize(o[1]), '</option>'].join('');
	    })).concat('</select>').join('');
	  }
	  /**
	   * Create foreground color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElFgColor_ = function createElFgColor_() {
	    var legendId = "captions-text-legend-" + this.id_;
	    return ['<fieldset class="vjs-fg-color vjs-track-setting">', "<legend id=\"" + legendId + "\">", this.localize('Text'), '</legend>', this.createElSelect_('color', legendId), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_('textOpacity', legendId), '</span>', '</fieldset>'].join('');
	  }
	  /**
	   * Create background color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElBgColor_ = function createElBgColor_() {
	    var legendId = "captions-background-" + this.id_;
	    return ['<fieldset class="vjs-bg-color vjs-track-setting">', "<legend id=\"" + legendId + "\">", this.localize('Background'), '</legend>', this.createElSelect_('backgroundColor', legendId), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_('backgroundOpacity', legendId), '</span>', '</fieldset>'].join('');
	  }
	  /**
	   * Create window color element for the component
	   *
	   * @return {string}
	   *         An HTML string.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElWinColor_ = function createElWinColor_() {
	    var legendId = "captions-window-" + this.id_;
	    return ['<fieldset class="vjs-window-color vjs-track-setting">', "<legend id=\"" + legendId + "\">", this.localize('Window'), '</legend>', this.createElSelect_('windowColor', legendId), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_('windowOpacity', legendId), '</span>', '</fieldset>'].join('');
	  }
	  /**
	   * Create color elements for the component
	   *
	   * @return {Element}
	   *         The element that was created
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElColors_ = function createElColors_() {
	    return createEl('div', {
	      className: 'vjs-track-settings-colors',
	      innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join('')
	    });
	  }
	  /**
	   * Create font elements for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElFont_ = function createElFont_() {
	    return createEl('div', {
	      className: 'vjs-track-settings-font',
	      innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_('fontPercent', '', 'legend'), '</fieldset>', '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_('edgeStyle', '', 'legend'), '</fieldset>', '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_('fontFamily', '', 'legend'), '</fieldset>'].join('')
	    });
	  }
	  /**
	   * Create controls for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	  ;
	
	  _proto.createElControls_ = function createElControls_() {
	    var defaultsDescription = this.localize('restore all settings to the default values');
	    return createEl('div', {
	      className: 'vjs-track-settings-controls',
	      innerHTML: ["<button type=\"button\" class=\"vjs-default-button\" title=\"" + defaultsDescription + "\">", this.localize('Reset'), "<span class=\"vjs-control-text\"> " + defaultsDescription + "</span>", '</button>', "<button type=\"button\" class=\"vjs-done-button\">" + this.localize('Done') + "</button>"].join('')
	    });
	  };
	
	  _proto.content = function content() {
	    return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
	  };
	
	  _proto.label = function label() {
	    return this.localize('Caption Settings Dialog');
	  };
	
	  _proto.description = function description() {
	    return this.localize('Beginning of dialog window. Escape will cancel and close the window.');
	  };
	
	  _proto.buildCSSClass = function buildCSSClass() {
	    return _ModalDialog.prototype.buildCSSClass.call(this) + ' vjs-text-track-settings';
	  }
	  /**
	   * Gets an object of text track settings (or null).
	   *
	   * @return {Object}
	   *         An object with config values parsed from the DOM or localStorage.
	   */
	  ;
	
	  _proto.getValues = function getValues() {
	    var _this3 = this;
	
	    return reduce(selectConfigs, function (accum, config, key) {
	      var value = getSelectedOptionValue(_this3.$(config.selector), config.parser);
	
	      if (value !== undefined) {
	        accum[key] = value;
	      }
	
	      return accum;
	    }, {});
	  }
	  /**
	   * Sets text track settings from an object of values.
	   *
	   * @param {Object} values
	   *        An object with config values parsed from the DOM or localStorage.
	   */
	  ;
	
	  _proto.setValues = function setValues(values) {
	    var _this4 = this;
	
	    each(selectConfigs, function (config, key) {
	      setSelectedOption(_this4.$(config.selector), values[key], config.parser);
	    });
	  }
	  /**
	   * Sets all `<select>` elements to their default values.
	   */
	  ;
	
	  _proto.setDefaults = function setDefaults() {
	    var _this5 = this;
	
	    each(selectConfigs, function (config) {
	      var index = config.hasOwnProperty('default') ? config["default"] : 0;
	      _this5.$(config.selector).selectedIndex = index;
	    });
	  }
	  /**
	   * Restore texttrack settings from localStorage
	   */
	  ;
	
	  _proto.restoreSettings = function restoreSettings() {
	    var values;
	
	    try {
	      values = JSON.parse(window__default['default'].localStorage.getItem(LOCAL_STORAGE_KEY$1));
	    } catch (err) {
	      log$1.warn(err);
	    }
	
	    if (values) {
	      this.setValues(values);
	    }
	  }
	  /**
	   * Save text track settings to localStorage
	   */
	  ;
	
	  _proto.saveSettings = function saveSettings() {
	    if (!this.options_.persistTextTrackSettings) {
	      return;
	    }
	
	    var values = this.getValues();
	
	    try {
	      if (Object.keys(values).length) {
	        window__default['default'].localStorage.setItem(LOCAL_STORAGE_KEY$1, JSON.stringify(values));
	      } else {
	        window__default['default'].localStorage.removeItem(LOCAL_STORAGE_KEY$1);
	      }
	    } catch (err) {
	      log$1.warn(err);
	    }
	  }
	  /**
	   * Update display of text track settings
	   */
	  ;
	
	  _proto.updateDisplay = function updateDisplay() {
	    var ttDisplay = this.player_.getChild('textTrackDisplay');
	
	    if (ttDisplay) {
	      ttDisplay.updateDisplay();
	    }
	  }
	  /**
	   * conditionally blur the element and refocus the captions button
	   *
	   * @private
	   */
	  ;
	
	  _proto.conditionalBlur_ = function conditionalBlur_() {
	    this.previouslyActiveEl_ = null;
	    var cb = this.player_.controlBar;
	    var subsCapsBtn = cb && cb.subsCapsButton;
	    var ccBtn = cb && cb.captionsButton;
	
	    if (subsCapsBtn) {
	      subsCapsBtn.focus();
	    } else if (ccBtn) {
	      ccBtn.focus();
	    }
	  };
	
	  return TextTrackSettings;
	}(ModalDialog);
	
	Component$1.registerComponent('TextTrackSettings', TextTrackSettings);
	
	/**
	 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
	 *
	 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
	 *
	 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
	 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
	 * @example <caption>How to disable the resize manager</caption>
	 * const player = videojs('#vid', {
	 *   resizeManager: false
	 * });
	 *
	 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
	 *
	 * @extends Component
	 */
	
	var ResizeManager = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](ResizeManager, _Component);
	
	  /**
	   * Create the ResizeManager.
	   *
	   * @param {Object} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of ResizeManager options.
	   *
	   * @param {Object} [options.ResizeObserver]
	   *        A polyfill for ResizeObserver can be passed in here.
	   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
	   */
	  function ResizeManager(player, options) {
	    var _this;
	
	    var RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || window__default['default'].ResizeObserver; // if `null` was passed, we want to disable the ResizeObserver
	
	    if (options.ResizeObserver === null) {
	      RESIZE_OBSERVER_AVAILABLE = false;
	    } // Only create an element when ResizeObserver isn't available
	
	
	    var options_ = mergeOptions$3({
	      createEl: !RESIZE_OBSERVER_AVAILABLE,
	      reportTouchActivity: false
	    }, options);
	    _this = _Component.call(this, player, options_) || this;
	    _this.ResizeObserver = options.ResizeObserver || window__default['default'].ResizeObserver;
	    _this.loadListener_ = null;
	    _this.resizeObserver_ = null;
	    _this.debouncedHandler_ = debounce(function () {
	      _this.resizeHandler();
	    }, 100, false, _assertThisInitialized__default['default'](_this));
	
	    if (RESIZE_OBSERVER_AVAILABLE) {
	      _this.resizeObserver_ = new _this.ResizeObserver(_this.debouncedHandler_);
	
	      _this.resizeObserver_.observe(player.el());
	    } else {
	      _this.loadListener_ = function () {
	        if (!_this.el_ || !_this.el_.contentWindow) {
	          return;
	        }
	
	        var debouncedHandler_ = _this.debouncedHandler_;
	
	        var unloadListener_ = _this.unloadListener_ = function () {
	          off(this, 'resize', debouncedHandler_);
	          off(this, 'unload', unloadListener_);
	          unloadListener_ = null;
	        }; // safari and edge can unload the iframe before resizemanager dispose
	        // we have to dispose of event handlers correctly before that happens
	
	
	        on(_this.el_.contentWindow, 'unload', unloadListener_);
	        on(_this.el_.contentWindow, 'resize', debouncedHandler_);
	      };
	
	      _this.one('load', _this.loadListener_);
	    }
	
	    return _this;
	  }
	
	  var _proto = ResizeManager.prototype;
	
	  _proto.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'iframe', {
	      className: 'vjs-resize-manager',
	      tabIndex: -1,
	      title: this.localize('No content')
	    }, {
	      'aria-hidden': 'true'
	    });
	  }
	  /**
	   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
	   *
	   * @fires Player#playerresize
	   */
	  ;
	
	  _proto.resizeHandler = function resizeHandler() {
	    /**
	     * Called when the player size has changed
	     *
	     * @event Player#playerresize
	     * @type {EventTarget~Event}
	     */
	    // make sure player is still around to trigger
	    // prevents this from causing an error after dispose
	    if (!this.player_ || !this.player_.trigger) {
	      return;
	    }
	
	    this.player_.trigger('playerresize');
	  };
	
	  _proto.dispose = function dispose() {
	    if (this.debouncedHandler_) {
	      this.debouncedHandler_.cancel();
	    }
	
	    if (this.resizeObserver_) {
	      if (this.player_.el()) {
	        this.resizeObserver_.unobserve(this.player_.el());
	      }
	
	      this.resizeObserver_.disconnect();
	    }
	
	    if (this.loadListener_) {
	      this.off('load', this.loadListener_);
	    }
	
	    if (this.el_ && this.el_.contentWindow && this.unloadListener_) {
	      this.unloadListener_.call(this.el_.contentWindow);
	    }
	
	    this.ResizeObserver = null;
	    this.resizeObserver = null;
	    this.debouncedHandler_ = null;
	    this.loadListener_ = null;
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  return ResizeManager;
	}(Component$1);
	
	Component$1.registerComponent('ResizeManager', ResizeManager);
	
	var defaults = {
	  trackingThreshold: 20,
	  liveTolerance: 15
	};
	/*
	  track when we are at the live edge, and other helpers for live playback */
	
	/**
	 * A class for checking live current time and determining when the player
	 * is at or behind the live edge.
	 */
	
	var LiveTracker = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](LiveTracker, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {number} [options.trackingThreshold=20]
	   *        Number of seconds of live window (seekableEnd - seekableStart) that
	   *        media needs to have before the liveui will be shown.
	   *
	   * @param {number} [options.liveTolerance=15]
	   *        Number of seconds behind live that we have to be
	   *        before we will be considered non-live. Note that this will only
	   *        be used when playing at the live edge. This allows large seekable end
	   *        changes to not effect wether we are live or not.
	   */
	  function LiveTracker(player, options) {
	    var _this;
	
	    // LiveTracker does not need an element
	    var options_ = mergeOptions$3(defaults, options, {
	      createEl: false
	    });
	    _this = _Component.call(this, player, options_) || this;
	
	    _this.handleVisibilityChange_ = function (e) {
	      return _this.handleVisibilityChange(e);
	    };
	
	    _this.trackLiveHandler_ = function () {
	      return _this.trackLive_();
	    };
	
	    _this.handlePlay_ = function (e) {
	      return _this.handlePlay(e);
	    };
	
	    _this.handleFirstTimeupdate_ = function (e) {
	      return _this.handleFirstTimeupdate(e);
	    };
	
	    _this.handleSeeked_ = function (e) {
	      return _this.handleSeeked(e);
	    };
	
	    _this.seekToLiveEdge_ = function (e) {
	      return _this.seekToLiveEdge(e);
	    };
	
	    _this.reset_();
	
	    _this.on(_this.player_, 'durationchange', function (e) {
	      return _this.handleDurationchange(e);
	    }); // we should try to toggle tracking on canplay as native playback engines, like Safari
	    // may not have the proper values for things like seekableEnd until then
	
	
	    _this.on(_this.player_, 'canplay', function () {
	      return _this.toggleTracking();
	    }); // we don't need to track live playback if the document is hidden,
	    // also, tracking when the document is hidden can
	    // cause the CPU to spike and eventually crash the page on IE11.
	
	
	    if (IE_VERSION && 'hidden' in document__default['default'] && 'visibilityState' in document__default['default']) {
	      _this.on(document__default['default'], 'visibilitychange', _this.handleVisibilityChange_);
	    }
	
	    return _this;
	  }
	  /**
	   * toggle tracking based on document visiblility
	   */
	
	
	  var _proto = LiveTracker.prototype;
	
	  _proto.handleVisibilityChange = function handleVisibilityChange() {
	    if (this.player_.duration() !== Infinity) {
	      return;
	    }
	
	    if (document__default['default'].hidden) {
	      this.stopTracking();
	    } else {
	      this.startTracking();
	    }
	  }
	  /**
	   * all the functionality for tracking when seek end changes
	   * and for tracking how far past seek end we should be
	   */
	  ;
	
	  _proto.trackLive_ = function trackLive_() {
	    var seekable = this.player_.seekable(); // skip undefined seekable
	
	    if (!seekable || !seekable.length) {
	      return;
	    }
	
	    var newTime = Number(window__default['default'].performance.now().toFixed(4));
	    var deltaTime = this.lastTime_ === -1 ? 0 : (newTime - this.lastTime_) / 1000;
	    this.lastTime_ = newTime;
	    this.pastSeekEnd_ = this.pastSeekEnd() + deltaTime;
	    var liveCurrentTime = this.liveCurrentTime();
	    var currentTime = this.player_.currentTime(); // we are behind live if any are true
	    // 1. the player is paused
	    // 2. the user seeked to a location 2 seconds away from live
	    // 3. the difference between live and current time is greater
	    //    liveTolerance which defaults to 15s
	
	    var isBehind = this.player_.paused() || this.seekedBehindLive_ || Math.abs(liveCurrentTime - currentTime) > this.options_.liveTolerance; // we cannot be behind if
	    // 1. until we have not seen a timeupdate yet
	    // 2. liveCurrentTime is Infinity, which happens on Android and Native Safari
	
	    if (!this.timeupdateSeen_ || liveCurrentTime === Infinity) {
	      isBehind = false;
	    }
	
	    if (isBehind !== this.behindLiveEdge_) {
	      this.behindLiveEdge_ = isBehind;
	      this.trigger('liveedgechange');
	    }
	  }
	  /**
	   * handle a durationchange event on the player
	   * and start/stop tracking accordingly.
	   */
	  ;
	
	  _proto.handleDurationchange = function handleDurationchange() {
	    this.toggleTracking();
	  }
	  /**
	   * start/stop tracking
	   */
	  ;
	
	  _proto.toggleTracking = function toggleTracking() {
	    if (this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold) {
	      if (this.player_.options_.liveui) {
	        this.player_.addClass('vjs-liveui');
	      }
	
	      this.startTracking();
	    } else {
	      this.player_.removeClass('vjs-liveui');
	      this.stopTracking();
	    }
	  }
	  /**
	   * start tracking live playback
	   */
	  ;
	
	  _proto.startTracking = function startTracking() {
	    if (this.isTracking()) {
	      return;
	    } // If we haven't seen a timeupdate, we need to check whether playback
	    // began before this component started tracking. This can happen commonly
	    // when using autoplay.
	
	
	    if (!this.timeupdateSeen_) {
	      this.timeupdateSeen_ = this.player_.hasStarted();
	    }
	
	    this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, UPDATE_REFRESH_INTERVAL);
	    this.trackLive_();
	    this.on(this.player_, ['play', 'pause'], this.trackLiveHandler_);
	
	    if (!this.timeupdateSeen_) {
	      this.one(this.player_, 'play', this.handlePlay_);
	      this.one(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
	    } else {
	      this.on(this.player_, 'seeked', this.handleSeeked_);
	    }
	  }
	  /**
	   * handle the first timeupdate on the player if it wasn't already playing
	   * when live tracker started tracking.
	   */
	  ;
	
	  _proto.handleFirstTimeupdate = function handleFirstTimeupdate() {
	    this.timeupdateSeen_ = true;
	    this.on(this.player_, 'seeked', this.handleSeeked_);
	  }
	  /**
	   * Keep track of what time a seek starts, and listen for seeked
	   * to find where a seek ends.
	   */
	  ;
	
	  _proto.handleSeeked = function handleSeeked() {
	    var timeDiff = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
	    this.seekedBehindLive_ = this.nextSeekedFromUser_ && timeDiff > 2;
	    this.nextSeekedFromUser_ = false;
	    this.trackLive_();
	  }
	  /**
	   * handle the first play on the player, and make sure that we seek
	   * right to the live edge.
	   */
	  ;
	
	  _proto.handlePlay = function handlePlay() {
	    this.one(this.player_, 'timeupdate', this.seekToLiveEdge_);
	  }
	  /**
	   * Stop tracking, and set all internal variables to
	   * their initial value.
	   */
	  ;
	
	  _proto.reset_ = function reset_() {
	    this.lastTime_ = -1;
	    this.pastSeekEnd_ = 0;
	    this.lastSeekEnd_ = -1;
	    this.behindLiveEdge_ = true;
	    this.timeupdateSeen_ = false;
	    this.seekedBehindLive_ = false;
	    this.nextSeekedFromUser_ = false;
	    this.clearInterval(this.trackingInterval_);
	    this.trackingInterval_ = null;
	    this.off(this.player_, ['play', 'pause'], this.trackLiveHandler_);
	    this.off(this.player_, 'seeked', this.handleSeeked_);
	    this.off(this.player_, 'play', this.handlePlay_);
	    this.off(this.player_, 'timeupdate', this.handleFirstTimeupdate_);
	    this.off(this.player_, 'timeupdate', this.seekToLiveEdge_);
	  }
	  /**
	   * The next seeked event is from the user. Meaning that any seek
	   * > 2s behind live will be considered behind live for real and
	   * liveTolerance will be ignored.
	   */
	  ;
	
	  _proto.nextSeekedFromUser = function nextSeekedFromUser() {
	    this.nextSeekedFromUser_ = true;
	  }
	  /**
	   * stop tracking live playback
	   */
	  ;
	
	  _proto.stopTracking = function stopTracking() {
	    if (!this.isTracking()) {
	      return;
	    }
	
	    this.reset_();
	    this.trigger('liveedgechange');
	  }
	  /**
	   * A helper to get the player seekable end
	   * so that we don't have to null check everywhere
	   *
	   * @return {number}
	   *         The furthest seekable end or Infinity.
	   */
	  ;
	
	  _proto.seekableEnd = function seekableEnd() {
	    var seekable = this.player_.seekable();
	    var seekableEnds = [];
	    var i = seekable ? seekable.length : 0;
	
	    while (i--) {
	      seekableEnds.push(seekable.end(i));
	    } // grab the furthest seekable end after sorting, or if there are none
	    // default to Infinity
	
	
	    return seekableEnds.length ? seekableEnds.sort()[seekableEnds.length - 1] : Infinity;
	  }
	  /**
	   * A helper to get the player seekable start
	   * so that we don't have to null check everywhere
	   *
	   * @return {number}
	   *         The earliest seekable start or 0.
	   */
	  ;
	
	  _proto.seekableStart = function seekableStart() {
	    var seekable = this.player_.seekable();
	    var seekableStarts = [];
	    var i = seekable ? seekable.length : 0;
	
	    while (i--) {
	      seekableStarts.push(seekable.start(i));
	    } // grab the first seekable start after sorting, or if there are none
	    // default to 0
	
	
	    return seekableStarts.length ? seekableStarts.sort()[0] : 0;
	  }
	  /**
	   * Get the live time window aka
	   * the amount of time between seekable start and
	   * live current time.
	   *
	   * @return {number}
	   *         The amount of seconds that are seekable in
	   *         the live video.
	   */
	  ;
	
	  _proto.liveWindow = function liveWindow() {
	    var liveCurrentTime = this.liveCurrentTime(); // if liveCurrenTime is Infinity then we don't have a liveWindow at all
	
	    if (liveCurrentTime === Infinity) {
	      return 0;
	    }
	
	    return liveCurrentTime - this.seekableStart();
	  }
	  /**
	   * Determines if the player is live, only checks if this component
	   * is tracking live playback or not
	   *
	   * @return {boolean}
	   *         Wether liveTracker is tracking
	   */
	  ;
	
	  _proto.isLive = function isLive() {
	    return this.isTracking();
	  }
	  /**
	   * Determines if currentTime is at the live edge and won't fall behind
	   * on each seekableendchange
	   *
	   * @return {boolean}
	   *         Wether playback is at the live edge
	   */
	  ;
	
	  _proto.atLiveEdge = function atLiveEdge() {
	    return !this.behindLiveEdge();
	  }
	  /**
	   * get what we expect the live current time to be
	   *
	   * @return {number}
	   *         The expected live current time
	   */
	  ;
	
	  _proto.liveCurrentTime = function liveCurrentTime() {
	    return this.pastSeekEnd() + this.seekableEnd();
	  }
	  /**
	   * The number of seconds that have occured after seekable end
	   * changed. This will be reset to 0 once seekable end changes.
	   *
	   * @return {number}
	   *         Seconds past the current seekable end
	   */
	  ;
	
	  _proto.pastSeekEnd = function pastSeekEnd() {
	    var seekableEnd = this.seekableEnd();
	
	    if (this.lastSeekEnd_ !== -1 && seekableEnd !== this.lastSeekEnd_) {
	      this.pastSeekEnd_ = 0;
	    }
	
	    this.lastSeekEnd_ = seekableEnd;
	    return this.pastSeekEnd_;
	  }
	  /**
	   * If we are currently behind the live edge, aka currentTime will be
	   * behind on a seekableendchange
	   *
	   * @return {boolean}
	   *         If we are behind the live edge
	   */
	  ;
	
	  _proto.behindLiveEdge = function behindLiveEdge() {
	    return this.behindLiveEdge_;
	  }
	  /**
	   * Wether live tracker is currently tracking or not.
	   */
	  ;
	
	  _proto.isTracking = function isTracking() {
	    return typeof this.trackingInterval_ === 'number';
	  }
	  /**
	   * Seek to the live edge if we are behind the live edge
	   */
	  ;
	
	  _proto.seekToLiveEdge = function seekToLiveEdge() {
	    this.seekedBehindLive_ = false;
	
	    if (this.atLiveEdge()) {
	      return;
	    }
	
	    this.nextSeekedFromUser_ = false;
	    this.player_.currentTime(this.liveCurrentTime());
	  }
	  /**
	   * Dispose of liveTracker
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.off(document__default['default'], 'visibilitychange', this.handleVisibilityChange_);
	    this.stopTracking();
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  return LiveTracker;
	}(Component$1);
	
	Component$1.registerComponent('LiveTracker', LiveTracker);
	
	/**
	 * This function is used to fire a sourceset when there is something
	 * similar to `mediaEl.load()` being called. It will try to find the source via
	 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
	 * with the source that was found or empty string if we cannot know. If it cannot
	 * find a source then `sourceset` will not be fired.
	 *
	 * @param {Html5} tech
	 *        The tech object that sourceset was setup on
	 *
	 * @return {boolean}
	 *         returns false if the sourceset was not fired and true otherwise.
	 */
	
	var sourcesetLoad = function sourcesetLoad(tech) {
	  var el = tech.el(); // if `el.src` is set, that source will be loaded.
	
	  if (el.hasAttribute('src')) {
	    tech.triggerSourceset(el.src);
	    return true;
	  }
	  /**
	   * Since there isn't a src property on the media element, source elements will be used for
	   * implementing the source selection algorithm. This happens asynchronously and
	   * for most cases were there is more than one source we cannot tell what source will
	   * be loaded, without re-implementing the source selection algorithm. At this time we are not
	   * going to do that. There are three special cases that we do handle here though:
	   *
	   * 1. If there are no sources, do not fire `sourceset`.
	   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
	   * 3. If there is more than one `<source>` but all of them have the same `src` url.
	   *    That will be our src.
	   */
	
	
	  var sources = tech.$$('source');
	  var srcUrls = [];
	  var src = ''; // if there are no sources, do not fire sourceset
	
	  if (!sources.length) {
	    return false;
	  } // only count valid/non-duplicate source elements
	
	
	  for (var i = 0; i < sources.length; i++) {
	    var url = sources[i].src;
	
	    if (url && srcUrls.indexOf(url) === -1) {
	      srcUrls.push(url);
	    }
	  } // there were no valid sources
	
	
	  if (!srcUrls.length) {
	    return false;
	  } // there is only one valid source element url
	  // use that
	
	
	  if (srcUrls.length === 1) {
	    src = srcUrls[0];
	  }
	
	  tech.triggerSourceset(src);
	  return true;
	};
	/**
	 * our implementation of an `innerHTML` descriptor for browsers
	 * that do not have one.
	 */
	
	
	var innerHTMLDescriptorPolyfill = Object.defineProperty({}, 'innerHTML', {
	  get: function get() {
	    return this.cloneNode(true).innerHTML;
	  },
	  set: function set(v) {
	    // make a dummy node to use innerHTML on
	    var dummy = document__default['default'].createElement(this.nodeName.toLowerCase()); // set innerHTML to the value provided
	
	    dummy.innerHTML = v; // make a document fragment to hold the nodes from dummy
	
	    var docFrag = document__default['default'].createDocumentFragment(); // copy all of the nodes created by the innerHTML on dummy
	    // to the document fragment
	
	    while (dummy.childNodes.length) {
	      docFrag.appendChild(dummy.childNodes[0]);
	    } // remove content
	
	
	    this.innerText = ''; // now we add all of that html in one by appending the
	    // document fragment. This is how innerHTML does it.
	
	    window__default['default'].Element.prototype.appendChild.call(this, docFrag); // then return the result that innerHTML's setter would
	
	    return this.innerHTML;
	  }
	});
	/**
	 * Get a property descriptor given a list of priorities and the
	 * property to get.
	 */
	
	var getDescriptor = function getDescriptor(priority, prop) {
	  var descriptor = {};
	
	  for (var i = 0; i < priority.length; i++) {
	    descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);
	
	    if (descriptor && descriptor.set && descriptor.get) {
	      break;
	    }
	  }
	
	  descriptor.enumerable = true;
	  descriptor.configurable = true;
	  return descriptor;
	};
	
	var getInnerHTMLDescriptor = function getInnerHTMLDescriptor(tech) {
	  return getDescriptor([tech.el(), window__default['default'].HTMLMediaElement.prototype, window__default['default'].Element.prototype, innerHTMLDescriptorPolyfill], 'innerHTML');
	};
	/**
	 * Patches browser internal functions so that we can tell synchronously
	 * if a `<source>` was appended to the media element. For some reason this
	 * causes a `sourceset` if the the media element is ready and has no source.
	 * This happens when:
	 * - The page has just loaded and the media element does not have a source.
	 * - The media element was emptied of all sources, then `load()` was called.
	 *
	 * It does this by patching the following functions/properties when they are supported:
	 *
	 * - `append()` - can be used to add a `<source>` element to the media element
	 * - `appendChild()` - can be used to add a `<source>` element to the media element
	 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
	 * - `innerHTML` -  can be used to add a `<source>` element to the media element
	 *
	 * @param {Html5} tech
	 *        The tech object that sourceset is being setup on.
	 */
	
	
	var firstSourceWatch = function firstSourceWatch(tech) {
	  var el = tech.el(); // make sure firstSourceWatch isn't setup twice.
	
	  if (el.resetSourceWatch_) {
	    return;
	  }
	
	  var old = {};
	  var innerDescriptor = getInnerHTMLDescriptor(tech);
	
	  var appendWrapper = function appendWrapper(appendFn) {
	    return function () {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var retval = appendFn.apply(el, args);
	      sourcesetLoad(tech);
	      return retval;
	    };
	  };
	
	  ['append', 'appendChild', 'insertAdjacentHTML'].forEach(function (k) {
	    if (!el[k]) {
	      return;
	    } // store the old function
	
	
	    old[k] = el[k]; // call the old function with a sourceset if a source
	    // was loaded
	
	    el[k] = appendWrapper(old[k]);
	  });
	  Object.defineProperty(el, 'innerHTML', mergeOptions$3(innerDescriptor, {
	    set: appendWrapper(innerDescriptor.set)
	  }));
	
	  el.resetSourceWatch_ = function () {
	    el.resetSourceWatch_ = null;
	    Object.keys(old).forEach(function (k) {
	      el[k] = old[k];
	    });
	    Object.defineProperty(el, 'innerHTML', innerDescriptor);
	  }; // on the first sourceset, we need to revert our changes
	
	
	  tech.one('sourceset', el.resetSourceWatch_);
	};
	/**
	 * our implementation of a `src` descriptor for browsers
	 * that do not have one.
	 */
	
	
	var srcDescriptorPolyfill = Object.defineProperty({}, 'src', {
	  get: function get() {
	    if (this.hasAttribute('src')) {
	      return getAbsoluteURL(window__default['default'].Element.prototype.getAttribute.call(this, 'src'));
	    }
	
	    return '';
	  },
	  set: function set(v) {
	    window__default['default'].Element.prototype.setAttribute.call(this, 'src', v);
	    return v;
	  }
	});
	
	var getSrcDescriptor = function getSrcDescriptor(tech) {
	  return getDescriptor([tech.el(), window__default['default'].HTMLMediaElement.prototype, srcDescriptorPolyfill], 'src');
	};
	/**
	 * setup `sourceset` handling on the `Html5` tech. This function
	 * patches the following element properties/functions:
	 *
	 * - `src` - to determine when `src` is set
	 * - `setAttribute()` - to determine when `src` is set
	 * - `load()` - this re-triggers the source selection algorithm, and can
	 *              cause a sourceset.
	 *
	 * If there is no source when we are adding `sourceset` support or during a `load()`
	 * we also patch the functions listed in `firstSourceWatch`.
	 *
	 * @param {Html5} tech
	 *        The tech to patch
	 */
	
	
	var setupSourceset = function setupSourceset(tech) {
	  if (!tech.featuresSourceset) {
	    return;
	  }
	
	  var el = tech.el(); // make sure sourceset isn't setup twice.
	
	  if (el.resetSourceset_) {
	    return;
	  }
	
	  var srcDescriptor = getSrcDescriptor(tech);
	  var oldSetAttribute = el.setAttribute;
	  var oldLoad = el.load;
	  Object.defineProperty(el, 'src', mergeOptions$3(srcDescriptor, {
	    set: function set(v) {
	      var retval = srcDescriptor.set.call(el, v); // we use the getter here to get the actual value set on src
	
	      tech.triggerSourceset(el.src);
	      return retval;
	    }
	  }));
	
	  el.setAttribute = function (n, v) {
	    var retval = oldSetAttribute.call(el, n, v);
	
	    if (/src/i.test(n)) {
	      tech.triggerSourceset(el.src);
	    }
	
	    return retval;
	  };
	
	  el.load = function () {
	    var retval = oldLoad.call(el); // if load was called, but there was no source to fire
	    // sourceset on. We have to watch for a source append
	    // as that can trigger a `sourceset` when the media element
	    // has no source
	
	    if (!sourcesetLoad(tech)) {
	      tech.triggerSourceset('');
	      firstSourceWatch(tech);
	    }
	
	    return retval;
	  };
	
	  if (el.currentSrc) {
	    tech.triggerSourceset(el.currentSrc);
	  } else if (!sourcesetLoad(tech)) {
	    firstSourceWatch(tech);
	  }
	
	  el.resetSourceset_ = function () {
	    el.resetSourceset_ = null;
	    el.load = oldLoad;
	    el.setAttribute = oldSetAttribute;
	    Object.defineProperty(el, 'src', srcDescriptor);
	
	    if (el.resetSourceWatch_) {
	      el.resetSourceWatch_();
	    }
	  };
	};
	
	/**
	 * Object.defineProperty but "lazy", which means that the value is only set after
	 * it retrieved the first time, rather than being set right away.
	 *
	 * @param {Object} obj the object to set the property on
	 * @param {string} key the key for the property to set
	 * @param {Function} getValue the function used to get the value when it is needed.
	 * @param {boolean} setter wether a setter shoould be allowed or not
	 */
	var defineLazyProperty = function defineLazyProperty(obj, key, getValue, setter) {
	  if (setter === void 0) {
	    setter = true;
	  }
	
	  var set = function set(value) {
	    return Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      writable: true
	    });
	  };
	
	  var options = {
	    configurable: true,
	    enumerable: true,
	    get: function get() {
	      var value = getValue();
	      set(value);
	      return value;
	    }
	  };
	
	  if (setter) {
	    options.set = set;
	  }
	
	  return Object.defineProperty(obj, key, options);
	};
	
	/**
	 * HTML5 Media Controller - Wrapper for HTML5 Media API
	 *
	 * @mixes Tech~SourceHandlerAdditions
	 * @extends Tech
	 */
	
	var Html5 = /*#__PURE__*/function (_Tech) {
	  _inheritsLoose__default['default'](Html5, _Tech);
	
	  /**
	  * Create an instance of this Tech.
	  *
	  * @param {Object} [options]
	  *        The key/value store of player options.
	  *
	  * @param {Component~ReadyCallback} ready
	  *        Callback function to call when the `HTML5` Tech is ready.
	  */
	  function Html5(options, ready) {
	    var _this;
	
	    _this = _Tech.call(this, options, ready) || this;
	    var source = options.source;
	    var crossoriginTracks = false;
	    _this.featuresVideoFrameCallback = _this.featuresVideoFrameCallback && _this.el_.tagName === 'VIDEO'; // Set the source if one is provided
	    // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
	    // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
	    // anyway so the error gets fired.
	
	    if (source && (_this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) {
	      _this.setSource(source);
	    } else {
	      _this.handleLateInit_(_this.el_);
	    } // setup sourceset after late sourceset/init
	
	
	    if (options.enableSourceset) {
	      _this.setupSourcesetHandling_();
	    }
	
	    _this.isScrubbing_ = false;
	
	    if (_this.el_.hasChildNodes()) {
	      var nodes = _this.el_.childNodes;
	      var nodesLength = nodes.length;
	      var removeNodes = [];
	
	      while (nodesLength--) {
	        var node = nodes[nodesLength];
	        var nodeName = node.nodeName.toLowerCase();
	
	        if (nodeName === 'track') {
	          if (!_this.featuresNativeTextTracks) {
	            // Empty video tag tracks so the built-in player doesn't use them also.
	            // This may not be fast enough to stop HTML5 browsers from reading the tags
	            // so we'll need to turn off any default tracks if we're manually doing
	            // captions and subtitles. videoElement.textTracks
	            removeNodes.push(node);
	          } else {
	            // store HTMLTrackElement and TextTrack to remote list
	            _this.remoteTextTrackEls().addTrackElement_(node);
	
	            _this.remoteTextTracks().addTrack(node.track);
	
	            _this.textTracks().addTrack(node.track);
	
	            if (!crossoriginTracks && !_this.el_.hasAttribute('crossorigin') && isCrossOrigin(node.src)) {
	              crossoriginTracks = true;
	            }
	          }
	        }
	      }
	
	      for (var i = 0; i < removeNodes.length; i++) {
	        _this.el_.removeChild(removeNodes[i]);
	      }
	    }
	
	    _this.proxyNativeTracks_();
	
	    if (_this.featuresNativeTextTracks && crossoriginTracks) {
	      log$1.warn('Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n' + 'This may prevent text tracks from loading.');
	    } // prevent iOS Safari from disabling metadata text tracks during native playback
	
	
	    _this.restoreMetadataTracksInIOSNativePlayer_(); // Determine if native controls should be used
	    // Our goal should be to get the custom controls on mobile solid everywhere
	    // so we can remove this all together. Right now this will block custom
	    // controls on touch enabled laptops like the Chrome Pixel
	
	
	    if ((TOUCH_ENABLED || IS_IPHONE || IS_NATIVE_ANDROID) && options.nativeControlsForTouch === true) {
	      _this.setControls(true);
	    } // on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
	    // into a `fullscreenchange` event
	
	
	    _this.proxyWebkitFullscreen_();
	
	    _this.triggerReady();
	
	    return _this;
	  }
	  /**
	   * Dispose of `HTML5` media element and remove all tracks.
	   */
	
	
	  var _proto = Html5.prototype;
	
	  _proto.dispose = function dispose() {
	    if (this.el_ && this.el_.resetSourceset_) {
	      this.el_.resetSourceset_();
	    }
	
	    Html5.disposeMediaElement(this.el_);
	    this.options_ = null; // tech will handle clearing of the emulated track list
	
	    _Tech.prototype.dispose.call(this);
	  }
	  /**
	   * Modify the media element so that we can detect when
	   * the source is changed. Fires `sourceset` just after the source has changed
	   */
	  ;
	
	  _proto.setupSourcesetHandling_ = function setupSourcesetHandling_() {
	    setupSourceset(this);
	  }
	  /**
	   * When a captions track is enabled in the iOS Safari native player, all other
	   * tracks are disabled (including metadata tracks), which nulls all of their
	   * associated cue points. This will restore metadata tracks to their pre-fullscreen
	   * state in those cases so that cue points are not needlessly lost.
	   *
	   * @private
	   */
	  ;
	
	  _proto.restoreMetadataTracksInIOSNativePlayer_ = function restoreMetadataTracksInIOSNativePlayer_() {
	    var textTracks = this.textTracks();
	    var metadataTracksPreFullscreenState; // captures a snapshot of every metadata track's current state
	
	    var takeMetadataTrackSnapshot = function takeMetadataTrackSnapshot() {
	      metadataTracksPreFullscreenState = [];
	
	      for (var i = 0; i < textTracks.length; i++) {
	        var track = textTracks[i];
	
	        if (track.kind === 'metadata') {
	          metadataTracksPreFullscreenState.push({
	            track: track,
	            storedMode: track.mode
	          });
	        }
	      }
	    }; // snapshot each metadata track's initial state, and update the snapshot
	    // each time there is a track 'change' event
	
	
	    takeMetadataTrackSnapshot();
	    textTracks.addEventListener('change', takeMetadataTrackSnapshot);
	    this.on('dispose', function () {
	      return textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	    });
	
	    var restoreTrackMode = function restoreTrackMode() {
	      for (var i = 0; i < metadataTracksPreFullscreenState.length; i++) {
	        var storedTrack = metadataTracksPreFullscreenState[i];
	
	        if (storedTrack.track.mode === 'disabled' && storedTrack.track.mode !== storedTrack.storedMode) {
	          storedTrack.track.mode = storedTrack.storedMode;
	        }
	      } // we only want this handler to be executed on the first 'change' event
	
	
	      textTracks.removeEventListener('change', restoreTrackMode);
	    }; // when we enter fullscreen playback, stop updating the snapshot and
	    // restore all track modes to their pre-fullscreen state
	
	
	    this.on('webkitbeginfullscreen', function () {
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot); // remove the listener before adding it just in case it wasn't previously removed
	
	      textTracks.removeEventListener('change', restoreTrackMode);
	      textTracks.addEventListener('change', restoreTrackMode);
	    }); // start updating the snapshot again after leaving fullscreen
	
	    this.on('webkitendfullscreen', function () {
	      // remove the listener before adding it just in case it wasn't previously removed
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	      textTracks.addEventListener('change', takeMetadataTrackSnapshot); // remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
	
	      textTracks.removeEventListener('change', restoreTrackMode);
	    });
	  }
	  /**
	   * Attempt to force override of tracks for the given type
	   *
	   * @param {string} type - Track type to override, possible values include 'Audio',
	   * 'Video', and 'Text'.
	   * @param {boolean} override - If set to true native audio/video will be overridden,
	   * otherwise native audio/video will potentially be used.
	   * @private
	   */
	  ;
	
	  _proto.overrideNative_ = function overrideNative_(type, override) {
	    var _this2 = this;
	
	    // If there is no behavioral change don't add/remove listeners
	    if (override !== this["featuresNative" + type + "Tracks"]) {
	      return;
	    }
	
	    var lowerCaseType = type.toLowerCase();
	
	    if (this[lowerCaseType + "TracksListeners_"]) {
	      Object.keys(this[lowerCaseType + "TracksListeners_"]).forEach(function (eventName) {
	        var elTracks = _this2.el()[lowerCaseType + "Tracks"];
	
	        elTracks.removeEventListener(eventName, _this2[lowerCaseType + "TracksListeners_"][eventName]);
	      });
	    }
	
	    this["featuresNative" + type + "Tracks"] = !override;
	    this[lowerCaseType + "TracksListeners_"] = null;
	    this.proxyNativeTracksForType_(lowerCaseType);
	  }
	  /**
	   * Attempt to force override of native audio tracks.
	   *
	   * @param {boolean} override - If set to true native audio will be overridden,
	   * otherwise native audio will potentially be used.
	   */
	  ;
	
	  _proto.overrideNativeAudioTracks = function overrideNativeAudioTracks(override) {
	    this.overrideNative_('Audio', override);
	  }
	  /**
	   * Attempt to force override of native video tracks.
	   *
	   * @param {boolean} override - If set to true native video will be overridden,
	   * otherwise native video will potentially be used.
	   */
	  ;
	
	  _proto.overrideNativeVideoTracks = function overrideNativeVideoTracks(override) {
	    this.overrideNative_('Video', override);
	  }
	  /**
	   * Proxy native track list events for the given type to our track
	   * lists if the browser we are playing in supports that type of track list.
	   *
	   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
	   * @private
	   */
	  ;
	
	  _proto.proxyNativeTracksForType_ = function proxyNativeTracksForType_(name) {
	    var _this3 = this;
	
	    var props = NORMAL[name];
	    var elTracks = this.el()[props.getterName];
	    var techTracks = this[props.getterName]();
	
	    if (!this["featuresNative" + props.capitalName + "Tracks"] || !elTracks || !elTracks.addEventListener) {
	      return;
	    }
	
	    var listeners = {
	      change: function change(e) {
	        var event = {
	          type: 'change',
	          target: techTracks,
	          currentTarget: techTracks,
	          srcElement: techTracks
	        };
	        techTracks.trigger(event); // if we are a text track change event, we should also notify the
	        // remote text track list. This can potentially cause a false positive
	        // if we were to get a change event on a non-remote track and
	        // we triggered the event on the remote text track list which doesn't
	        // contain that track. However, best practices mean looping through the
	        // list of tracks and searching for the appropriate mode value, so,
	        // this shouldn't pose an issue
	
	        if (name === 'text') {
	          _this3[REMOTE.remoteText.getterName]().trigger(event);
	        }
	      },
	      addtrack: function addtrack(e) {
	        techTracks.addTrack(e.track);
	      },
	      removetrack: function removetrack(e) {
	        techTracks.removeTrack(e.track);
	      }
	    };
	
	    var removeOldTracks = function removeOldTracks() {
	      var removeTracks = [];
	
	      for (var i = 0; i < techTracks.length; i++) {
	        var found = false;
	
	        for (var j = 0; j < elTracks.length; j++) {
	          if (elTracks[j] === techTracks[i]) {
	            found = true;
	            break;
	          }
	        }
	
	        if (!found) {
	          removeTracks.push(techTracks[i]);
	        }
	      }
	
	      while (removeTracks.length) {
	        techTracks.removeTrack(removeTracks.shift());
	      }
	    };
	
	    this[props.getterName + 'Listeners_'] = listeners;
	    Object.keys(listeners).forEach(function (eventName) {
	      var listener = listeners[eventName];
	      elTracks.addEventListener(eventName, listener);
	
	      _this3.on('dispose', function (e) {
	        return elTracks.removeEventListener(eventName, listener);
	      });
	    }); // Remove (native) tracks that are not used anymore
	
	    this.on('loadstart', removeOldTracks);
	    this.on('dispose', function (e) {
	      return _this3.off('loadstart', removeOldTracks);
	    });
	  }
	  /**
	   * Proxy all native track list events to our track lists if the browser we are playing
	   * in supports that type of track list.
	   *
	   * @private
	   */
	  ;
	
	  _proto.proxyNativeTracks_ = function proxyNativeTracks_() {
	    var _this4 = this;
	
	    NORMAL.names.forEach(function (name) {
	      _this4.proxyNativeTracksForType_(name);
	    });
	  }
	  /**
	   * Create the `Html5` Tech's DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    var el = this.options_.tag; // Check if this browser supports moving the element into the box.
	    // On the iPhone video will break if you move the element,
	    // So we have to create a brand new element.
	    // If we ingested the player div, we do not need to move the media element.
	
	    if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
	      // If the original tag is still there, clone and remove it.
	      if (el) {
	        var clone = el.cloneNode(true);
	
	        if (el.parentNode) {
	          el.parentNode.insertBefore(clone, el);
	        }
	
	        Html5.disposeMediaElement(el);
	        el = clone;
	      } else {
	        el = document__default['default'].createElement('video'); // determine if native controls should be used
	
	        var tagAttributes = this.options_.tag && getAttributes(this.options_.tag);
	        var attributes = mergeOptions$3({}, tagAttributes);
	
	        if (!TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) {
	          delete attributes.controls;
	        }
	
	        setAttributes(el, assign(attributes, {
	          id: this.options_.techId,
	          "class": 'vjs-tech'
	        }));
	      }
	
	      el.playerId = this.options_.playerId;
	    }
	
	    if (typeof this.options_.preload !== 'undefined') {
	      setAttribute(el, 'preload', this.options_.preload);
	    }
	
	    if (this.options_.disablePictureInPicture !== undefined) {
	      el.disablePictureInPicture = this.options_.disablePictureInPicture;
	    } // Update specific tag settings, in case they were overridden
	    // `autoplay` has to be *last* so that `muted` and `playsinline` are present
	    // when iOS/Safari or other browsers attempt to autoplay.
	
	
	    var settingsAttrs = ['loop', 'muted', 'playsinline', 'autoplay'];
	
	    for (var i = 0; i < settingsAttrs.length; i++) {
	      var attr = settingsAttrs[i];
	      var value = this.options_[attr];
	
	      if (typeof value !== 'undefined') {
	        if (value) {
	          setAttribute(el, attr, attr);
	        } else {
	          removeAttribute(el, attr);
	        }
	
	        el[attr] = value;
	      }
	    }
	
	    return el;
	  }
	  /**
	   * This will be triggered if the loadstart event has already fired, before videojs was
	   * ready. Two known examples of when this can happen are:
	   * 1. If we're loading the playback object after it has started loading
	   * 2. The media is already playing the (often with autoplay on) then
	   *
	   * This function will fire another loadstart so that videojs can catchup.
	   *
	   * @fires Tech#loadstart
	   *
	   * @return {undefined}
	   *         returns nothing.
	   */
	  ;
	
	  _proto.handleLateInit_ = function handleLateInit_(el) {
	    if (el.networkState === 0 || el.networkState === 3) {
	      // The video element hasn't started loading the source yet
	      // or didn't find a source
	      return;
	    }
	
	    if (el.readyState === 0) {
	      // NetworkState is set synchronously BUT loadstart is fired at the
	      // end of the current stack, usually before setInterval(fn, 0).
	      // So at this point we know loadstart may have already fired or is
	      // about to fire, and either way the player hasn't seen it yet.
	      // We don't want to fire loadstart prematurely here and cause a
	      // double loadstart so we'll wait and see if it happens between now
	      // and the next loop, and fire it if not.
	      // HOWEVER, we also want to make sure it fires before loadedmetadata
	      // which could also happen between now and the next loop, so we'll
	      // watch for that also.
	      var loadstartFired = false;
	
	      var setLoadstartFired = function setLoadstartFired() {
	        loadstartFired = true;
	      };
	
	      this.on('loadstart', setLoadstartFired);
	
	      var triggerLoadstart = function triggerLoadstart() {
	        // We did miss the original loadstart. Make sure the player
	        // sees loadstart before loadedmetadata
	        if (!loadstartFired) {
	          this.trigger('loadstart');
	        }
	      };
	
	      this.on('loadedmetadata', triggerLoadstart);
	      this.ready(function () {
	        this.off('loadstart', setLoadstartFired);
	        this.off('loadedmetadata', triggerLoadstart);
	
	        if (!loadstartFired) {
	          // We did miss the original native loadstart. Fire it now.
	          this.trigger('loadstart');
	        }
	      });
	      return;
	    } // From here on we know that loadstart already fired and we missed it.
	    // The other readyState events aren't as much of a problem if we double
	    // them, so not going to go to as much trouble as loadstart to prevent
	    // that unless we find reason to.
	
	
	    var eventsToTrigger = ['loadstart']; // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
	
	    eventsToTrigger.push('loadedmetadata'); // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
	
	    if (el.readyState >= 2) {
	      eventsToTrigger.push('loadeddata');
	    } // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
	
	
	    if (el.readyState >= 3) {
	      eventsToTrigger.push('canplay');
	    } // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
	
	
	    if (el.readyState >= 4) {
	      eventsToTrigger.push('canplaythrough');
	    } // We still need to give the player time to add event listeners
	
	
	    this.ready(function () {
	      eventsToTrigger.forEach(function (type) {
	        this.trigger(type);
	      }, this);
	    });
	  }
	  /**
	   * Set whether we are scrubbing or not.
	   * This is used to decide whether we should use `fastSeek` or not.
	   * `fastSeek` is used to provide trick play on Safari browsers.
	   *
	   * @param {boolean} isScrubbing
	   *                  - true for we are currently scrubbing
	   *                  - false for we are no longer scrubbing
	   */
	  ;
	
	  _proto.setScrubbing = function setScrubbing(isScrubbing) {
	    this.isScrubbing_ = isScrubbing;
	  }
	  /**
	   * Get whether we are scrubbing or not.
	   *
	   * @return {boolean} isScrubbing
	   *                  - true for we are currently scrubbing
	   *                  - false for we are no longer scrubbing
	   */
	  ;
	
	  _proto.scrubbing = function scrubbing() {
	    return this.isScrubbing_;
	  }
	  /**
	   * Set current time for the `HTML5` tech.
	   *
	   * @param {number} seconds
	   *        Set the current time of the media to this.
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime(seconds) {
	    try {
	      if (this.isScrubbing_ && this.el_.fastSeek && IS_ANY_SAFARI) {
	        this.el_.fastSeek(seconds);
	      } else {
	        this.el_.currentTime = seconds;
	      }
	    } catch (e) {
	      log$1(e, 'Video is not ready. (Video.js)'); // this.warning(VideoJS.warnings.videoNotReady);
	    }
	  }
	  /**
	   * Get the current duration of the HTML5 media element.
	   *
	   * @return {number}
	   *         The duration of the media or 0 if there is no duration.
	   */
	  ;
	
	  _proto.duration = function duration() {
	    var _this5 = this;
	
	    // Android Chrome will report duration as Infinity for VOD HLS until after
	    // playback has started, which triggers the live display erroneously.
	    // Return NaN if playback has not started and trigger a durationupdate once
	    // the duration can be reliably known.
	    if (this.el_.duration === Infinity && IS_ANDROID && IS_CHROME && this.el_.currentTime === 0) {
	      // Wait for the first `timeupdate` with currentTime > 0 - there may be
	      // several with 0
	      var checkProgress = function checkProgress() {
	        if (_this5.el_.currentTime > 0) {
	          // Trigger durationchange for genuinely live video
	          if (_this5.el_.duration === Infinity) {
	            _this5.trigger('durationchange');
	          }
	
	          _this5.off('timeupdate', checkProgress);
	        }
	      };
	
	      this.on('timeupdate', checkProgress);
	      return NaN;
	    }
	
	    return this.el_.duration || NaN;
	  }
	  /**
	   * Get the current width of the HTML5 media element.
	   *
	   * @return {number}
	   *         The width of the HTML5 media element.
	   */
	  ;
	
	  _proto.width = function width() {
	    return this.el_.offsetWidth;
	  }
	  /**
	   * Get the current height of the HTML5 media element.
	   *
	   * @return {number}
	   *         The height of the HTML5 media element.
	   */
	  ;
	
	  _proto.height = function height() {
	    return this.el_.offsetHeight;
	  }
	  /**
	   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
	   * `fullscreenchange` event.
	   *
	   * @private
	   * @fires fullscreenchange
	   * @listens webkitendfullscreen
	   * @listens webkitbeginfullscreen
	   * @listens webkitbeginfullscreen
	   */
	  ;
	
	  _proto.proxyWebkitFullscreen_ = function proxyWebkitFullscreen_() {
	    var _this6 = this;
	
	    if (!('webkitDisplayingFullscreen' in this.el_)) {
	      return;
	    }
	
	    var endFn = function endFn() {
	      this.trigger('fullscreenchange', {
	        isFullscreen: false
	      }); // Safari will sometimes set contols on the videoelement when existing fullscreen.
	
	      if (this.el_.controls && !this.options_.nativeControlsForTouch && this.controls()) {
	        this.el_.controls = false;
	      }
	    };
	
	    var beginFn = function beginFn() {
	      if ('webkitPresentationMode' in this.el_ && this.el_.webkitPresentationMode !== 'picture-in-picture') {
	        this.one('webkitendfullscreen', endFn);
	        this.trigger('fullscreenchange', {
	          isFullscreen: true,
	          // set a flag in case another tech triggers fullscreenchange
	          nativeIOSFullscreen: true
	        });
	      }
	    };
	
	    this.on('webkitbeginfullscreen', beginFn);
	    this.on('dispose', function () {
	      _this6.off('webkitbeginfullscreen', beginFn);
	
	      _this6.off('webkitendfullscreen', endFn);
	    });
	  }
	  /**
	   * Check if fullscreen is supported on the current playback device.
	   *
	   * @return {boolean}
	   *         - True if fullscreen is supported.
	   *         - False if fullscreen is not supported.
	   */
	  ;
	
	  _proto.supportsFullScreen = function supportsFullScreen() {
	    if (typeof this.el_.webkitEnterFullScreen === 'function') {
	      var userAgent = window__default['default'].navigator && window__default['default'].navigator.userAgent || ''; // Seems to be broken in Chromium/Chrome && Safari in Leopard
	
	      if (/Android/.test(userAgent) || !/Chrome|Mac OS X 10.5/.test(userAgent)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	  /**
	   * Request that the `HTML5` Tech enter fullscreen.
	   */
	  ;
	
	  _proto.enterFullScreen = function enterFullScreen() {
	    var video = this.el_;
	
	    if (video.paused && video.networkState <= video.HAVE_METADATA) {
	      // attempt to prime the video element for programmatic access
	      // this isn't necessary on the desktop but shouldn't hurt
	      silencePromise(this.el_.play()); // playing and pausing synchronously during the transition to fullscreen
	      // can get iOS ~6.1 devices into a play/pause loop
	
	      this.setTimeout(function () {
	        video.pause();
	
	        try {
	          video.webkitEnterFullScreen();
	        } catch (e) {
	          this.trigger('fullscreenerror', e);
	        }
	      }, 0);
	    } else {
	      try {
	        video.webkitEnterFullScreen();
	      } catch (e) {
	        this.trigger('fullscreenerror', e);
	      }
	    }
	  }
	  /**
	   * Request that the `HTML5` Tech exit fullscreen.
	   */
	  ;
	
	  _proto.exitFullScreen = function exitFullScreen() {
	    if (!this.el_.webkitDisplayingFullscreen) {
	      this.trigger('fullscreenerror', new Error('The video is not fullscreen'));
	      return;
	    }
	
	    this.el_.webkitExitFullScreen();
	  }
	  /**
	   * Create a floating video window always on top of other windows so that users may
	   * continue consuming media while they interact with other content sites, or
	   * applications on their device.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @return {Promise}
	   *         A promise with a Picture-in-Picture window.
	   */
	  ;
	
	  _proto.requestPictureInPicture = function requestPictureInPicture() {
	    return this.el_.requestPictureInPicture();
	  }
	  /**
	   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
	   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
	   * Needs to be checked later than the constructor
	   * This will be a false positive for clear sources loaded after a Fairplay source
	   *
	   * @param {function} cb function to call
	   * @return {number} id of request
	   */
	  ;
	
	  _proto.requestVideoFrameCallback = function requestVideoFrameCallback(cb) {
	    if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) {
	      return this.el_.requestVideoFrameCallback(cb);
	    }
	
	    return _Tech.prototype.requestVideoFrameCallback.call(this, cb);
	  }
	  /**
	   * Native or fallback requestVideoFrameCallback
	   *
	   * @param {number} id request id to cancel
	   */
	  ;
	
	  _proto.cancelVideoFrameCallback = function cancelVideoFrameCallback(id) {
	    if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) {
	      this.el_.cancelVideoFrameCallback(id);
	    } else {
	      _Tech.prototype.cancelVideoFrameCallback.call(this, id);
	    }
	  }
	  /**
	   * A getter/setter for the `Html5` Tech's source object.
	   * > Note: Please use {@link Html5#setSource}
	   *
	   * @param {Tech~SourceObject} [src]
	   *        The source object you want to set on the `HTML5` techs element.
	   *
	   * @return {Tech~SourceObject|undefined}
	   *         - The current source object when a source is not passed in.
	   *         - undefined when setting
	   *
	   * @deprecated Since version 5.
	   */
	  ;
	
	  _proto.src = function src(_src) {
	    if (_src === undefined) {
	      return this.el_.src;
	    } // Setting src through `src` instead of `setSrc` will be deprecated
	
	
	    this.setSrc(_src);
	  }
	  /**
	   * Reset the tech by removing all sources and then calling
	   * {@link Html5.resetMediaElement}.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    Html5.resetMediaElement(this.el_);
	  }
	  /**
	   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
	   * the HTML5 media element.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object from the HTML5 tech. With a fallback to the
	   *         elements source.
	   */
	  ;
	
	  _proto.currentSrc = function currentSrc() {
	    if (this.currentSource_) {
	      return this.currentSource_.src;
	    }
	
	    return this.el_.currentSrc;
	  }
	  /**
	   * Set controls attribute for the HTML5 media Element.
	   *
	   * @param {string} val
	   *        Value to set the controls attribute to
	   */
	  ;
	
	  _proto.setControls = function setControls(val) {
	    this.el_.controls = !!val;
	  }
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	  ;
	
	  _proto.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.addTextTrack.call(this, kind, label, language);
	    }
	
	    return this.el_.addTextTrack(kind, label, language);
	  }
	  /**
	   * Creates either native TextTrack or an emulated TextTrack depending
	   * on the value of `featuresNativeTextTracks`
	   *
	   * @param {Object} options
	   *        The object should contain the options to initialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label]
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @param {boolean} [options.default]
	   *        Default this track to on.
	   *
	   * @param {string} [options.id]
	   *        The internal id to assign this track.
	   *
	   * @param {string} [options.src]
	   *        A source url for the track.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	  ;
	
	  _proto.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.createRemoteTextTrack.call(this, options);
	    }
	
	    var htmlTrackElement = document__default['default'].createElement('track');
	
	    if (options.kind) {
	      htmlTrackElement.kind = options.kind;
	    }
	
	    if (options.label) {
	      htmlTrackElement.label = options.label;
	    }
	
	    if (options.language || options.srclang) {
	      htmlTrackElement.srclang = options.language || options.srclang;
	    }
	
	    if (options["default"]) {
	      htmlTrackElement["default"] = options["default"];
	    }
	
	    if (options.id) {
	      htmlTrackElement.id = options.id;
	    }
	
	    if (options.src) {
	      htmlTrackElement.src = options.src;
	    }
	
	    return htmlTrackElement;
	  }
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * @param {Object} options The object should contain values for
	   * kind, language, label, and src (location of the WebVTT file)
	   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   * automatically removed from the video element whenever the source changes
	   * @return {HTMLTrackElement} An Html Track Element.
	   * This can be an emulated {@link HTMLTrackElement} or a native one.
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   * to "false" in upcoming versions of Video.js
	   */
	  ;
	
	  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    var htmlTrackElement = _Tech.prototype.addRemoteTextTrack.call(this, options, manualCleanup);
	
	    if (this.featuresNativeTextTracks) {
	      this.el().appendChild(htmlTrackElement);
	    }
	
	    return htmlTrackElement;
	  }
	  /**
	   * Remove remote `TextTrack` from `TextTrackList` object
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` object to remove
	   */
	  ;
	
	  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    _Tech.prototype.removeRemoteTextTrack.call(this, track);
	
	    if (this.featuresNativeTextTracks) {
	      var tracks = this.$$('track');
	      var i = tracks.length;
	
	      while (i--) {
	        if (track === tracks[i] || track === tracks[i].track) {
	          this.el().removeChild(tracks[i]);
	        }
	      }
	    }
	  }
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   */
	  ;
	
	  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    if (typeof this.el().getVideoPlaybackQuality === 'function') {
	      return this.el().getVideoPlaybackQuality();
	    }
	
	    var videoPlaybackQuality = {};
	
	    if (typeof this.el().webkitDroppedFrameCount !== 'undefined' && typeof this.el().webkitDecodedFrameCount !== 'undefined') {
	      videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
	      videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
	    }
	
	    if (window__default['default'].performance && typeof window__default['default'].performance.now === 'function') {
	      videoPlaybackQuality.creationTime = window__default['default'].performance.now();
	    } else if (window__default['default'].performance && window__default['default'].performance.timing && typeof window__default['default'].performance.timing.navigationStart === 'number') {
	      videoPlaybackQuality.creationTime = window__default['default'].Date.now() - window__default['default'].performance.timing.navigationStart;
	    }
	
	    return videoPlaybackQuality;
	  };
	
	  return Html5;
	}(Tech);
	/* HTML5 Support Testing ---------------------------------------------------- */
	
	/**
	 * Element for testing browser HTML5 media capabilities
	 *
	 * @type {Element}
	 * @constant
	 * @private
	 */
	
	
	defineLazyProperty(Html5, 'TEST_VID', function () {
	  if (!isReal()) {
	    return;
	  }
	
	  var video = document__default['default'].createElement('video');
	  var track = document__default['default'].createElement('track');
	  track.kind = 'captions';
	  track.srclang = 'en';
	  track.label = 'English';
	  video.appendChild(track);
	  return video;
	});
	/**
	 * Check if HTML5 media is supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if HTML5 media is supported.
	 *         - False if HTML5 media is not supported.
	 */
	
	Html5.isSupported = function () {
	  // IE with no Media Player is a LIAR! (#984)
	  try {
	    Html5.TEST_VID.volume = 0.5;
	  } catch (e) {
	    return false;
	  }
	
	  return !!(Html5.TEST_VID && Html5.TEST_VID.canPlayType);
	};
	/**
	 * Check if the tech can support the given type
	 *
	 * @param {string} type
	 *        The mimetype to check
	 * @return {string} 'probably', 'maybe', or '' (empty string)
	 */
	
	
	Html5.canPlayType = function (type) {
	  return Html5.TEST_VID.canPlayType(type);
	};
	/**
	 * Check if the tech can support the given source
	 *
	 * @param {Object} srcObj
	 *        The source object
	 * @param {Object} options
	 *        The options passed to the tech
	 * @return {string} 'probably', 'maybe', or '' (empty string)
	 */
	
	
	Html5.canPlaySource = function (srcObj, options) {
	  return Html5.canPlayType(srcObj.type);
	};
	/**
	 * Check if the volume can be changed in this browser/device.
	 * Volume cannot be changed in a lot of mobile devices.
	 * Specifically, it can't be changed from 1 on iOS.
	 *
	 * @return {boolean}
	 *         - True if volume can be controlled
	 *         - False otherwise
	 */
	
	
	Html5.canControlVolume = function () {
	  // IE will error if Windows Media Player not installed #3315
	  try {
	    var volume = Html5.TEST_VID.volume;
	    Html5.TEST_VID.volume = volume / 2 + 0.1;
	    var canControl = volume !== Html5.TEST_VID.volume; // With the introduction of iOS 15, there are cases where the volume is read as
	    // changed but reverts back to its original state at the start of the next tick.
	    // To determine whether volume can be controlled on iOS,
	    // a timeout is set and the volume is checked asynchronously.
	    // Since `features` doesn't currently work asynchronously, the value is manually set.
	
	    if (canControl && IS_IOS) {
	      window__default['default'].setTimeout(function () {
	        if (Html5 && Html5.prototype) {
	          Html5.prototype.featuresVolumeControl = volume !== Html5.TEST_VID.volume;
	        }
	      }); // default iOS to false, which will be updated in the timeout above.
	
	      return false;
	    }
	
	    return canControl;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Check if the volume can be muted in this browser/device.
	 * Some devices, e.g. iOS, don't allow changing volume
	 * but permits muting/unmuting.
	 *
	 * @return {bolean}
	 *      - True if volume can be muted
	 *      - False otherwise
	 */
	
	
	Html5.canMuteVolume = function () {
	  try {
	    var muted = Html5.TEST_VID.muted; // in some versions of iOS muted property doesn't always
	    // work, so we want to set both property and attribute
	
	    Html5.TEST_VID.muted = !muted;
	
	    if (Html5.TEST_VID.muted) {
	      setAttribute(Html5.TEST_VID, 'muted', 'muted');
	    } else {
	      removeAttribute(Html5.TEST_VID, 'muted', 'muted');
	    }
	
	    return muted !== Html5.TEST_VID.muted;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Check if the playback rate can be changed in this browser/device.
	 *
	 * @return {boolean}
	 *         - True if playback rate can be controlled
	 *         - False otherwise
	 */
	
	
	Html5.canControlPlaybackRate = function () {
	  // Playback rate API is implemented in Android Chrome, but doesn't do anything
	  // https://github.com/videojs/video.js/issues/3180
	  if (IS_ANDROID && IS_CHROME && CHROME_VERSION < 58) {
	    return false;
	  } // IE will error if Windows Media Player not installed #3315
	
	
	  try {
	    var playbackRate = Html5.TEST_VID.playbackRate;
	    Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
	    return playbackRate !== Html5.TEST_VID.playbackRate;
	  } catch (e) {
	    return false;
	  }
	};
	/**
	 * Check if we can override a video/audio elements attributes, with
	 * Object.defineProperty.
	 *
	 * @return {boolean}
	 *         - True if builtin attributes can be overridden
	 *         - False otherwise
	 */
	
	
	Html5.canOverrideAttributes = function () {
	  // if we cannot overwrite the src/innerHTML property, there is no support
	  // iOS 7 safari for instance cannot do this.
	  try {
	    var noop = function noop() {};
	
	    Object.defineProperty(document__default['default'].createElement('video'), 'src', {
	      get: noop,
	      set: noop
	    });
	    Object.defineProperty(document__default['default'].createElement('audio'), 'src', {
	      get: noop,
	      set: noop
	    });
	    Object.defineProperty(document__default['default'].createElement('video'), 'innerHTML', {
	      get: noop,
	      set: noop
	    });
	    Object.defineProperty(document__default['default'].createElement('audio'), 'innerHTML', {
	      get: noop,
	      set: noop
	    });
	  } catch (e) {
	    return false;
	  }
	
	  return true;
	};
	/**
	 * Check to see if native `TextTrack`s are supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if native `TextTrack`s are supported.
	 *         - False otherwise
	 */
	
	
	Html5.supportsNativeTextTracks = function () {
	  return IS_ANY_SAFARI || IS_IOS && IS_CHROME;
	};
	/**
	 * Check to see if native `VideoTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `VideoTrack`s are supported.
	 *        - False otherwise
	 */
	
	
	Html5.supportsNativeVideoTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.videoTracks);
	};
	/**
	 * Check to see if native `AudioTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `AudioTrack`s are supported.
	 *        - False otherwise
	 */
	
	
	Html5.supportsNativeAudioTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.audioTracks);
	};
	/**
	 * An array of events available on the Html5 tech.
	 *
	 * @private
	 * @type {Array}
	 */
	
	
	Html5.Events = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'resize', 'volumechange'];
	/**
	 * Boolean indicating whether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlVolume}
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports muting volume.
	 *
	 * @type {bolean}
	 * @default {@link Html5.canMuteVolume}
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports changing the speed at which the media
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlPlaybackRate}
	 */
	
	/**
	 * Boolean indicating whether the `Tech` supports the `sourceset` event.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeTextTracks}
	 */
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeVideoTracks}
	 */
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeAudioTracks}
	 */
	
	[['featuresMuteControl', 'canMuteVolume'], ['featuresPlaybackRate', 'canControlPlaybackRate'], ['featuresSourceset', 'canOverrideAttributes'], ['featuresNativeTextTracks', 'supportsNativeTextTracks'], ['featuresNativeVideoTracks', 'supportsNativeVideoTracks'], ['featuresNativeAudioTracks', 'supportsNativeAudioTracks']].forEach(function (_ref) {
	  var key = _ref[0],
	      fn = _ref[1];
	  defineLazyProperty(Html5.prototype, key, function () {
	    return Html5[fn]();
	  }, true);
	});
	Html5.prototype.featuresVolumeControl = Html5.canControlVolume();
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the media element
	 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
	 * false there. Everywhere else this should be true.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Html5.prototype.movingMediaElementInDOM = !IS_IOS; // TODO: Previous comment: No longer appears to be used. Can probably be removed.
	//       Is this true?
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
	 * when going into fullscreen.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Html5.prototype.featuresFullscreenResize = true;
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
	 * If this is false, manual `progress` events will be triggered instead.
	 *
	 * @type {boolean}
	 * @default
	 */
	
	Html5.prototype.featuresProgressEvents = true;
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
	 * If this is false, manual `timeupdate` events will be triggered instead.
	 *
	 * @default
	 */
	
	Html5.prototype.featuresTimeupdateEvents = true;
	/**
	 * Whether the HTML5 el supports `requestVideoFrameCallback`
	 *
	 * @type {boolean}
	 */
	
	Html5.prototype.featuresVideoFrameCallback = !!(Html5.TEST_VID && Html5.TEST_VID.requestVideoFrameCallback); // HTML5 Feature detection and Device Fixes --------------------------------- //
	
	var canPlayType;
	
	Html5.patchCanPlayType = function () {
	  // Android 4.0 and above can play HLS to some extent but it reports being unable to do so
	  // Firefox and Chrome report correctly
	  if (ANDROID_VERSION >= 4.0 && !IS_FIREFOX && !IS_CHROME) {
	    canPlayType = Html5.TEST_VID && Html5.TEST_VID.constructor.prototype.canPlayType;
	
	    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
	      var mpegurlRE = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
	
	      if (type && mpegurlRE.test(type)) {
	        return 'maybe';
	      }
	
	      return canPlayType.call(this, type);
	    };
	  }
	};
	
	Html5.unpatchCanPlayType = function () {
	  var r = Html5.TEST_VID.constructor.prototype.canPlayType;
	
	  if (canPlayType) {
	    Html5.TEST_VID.constructor.prototype.canPlayType = canPlayType;
	  }
	
	  return r;
	}; // by default, patch the media element
	
	
	Html5.patchCanPlayType();
	
	Html5.disposeMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  if (el.parentNode) {
	    el.parentNode.removeChild(el);
	  } // remove any child track or source nodes to prevent their loading
	
	
	  while (el.hasChildNodes()) {
	    el.removeChild(el.firstChild);
	  } // remove any src reference. not setting `src=''` because that causes a warning
	  // in firefox
	
	
	  el.removeAttribute('src'); // force the media element to update its loading state by calling load()
	  // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
	
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {// not supported
	      }
	    })();
	  }
	};
	
	Html5.resetMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  var sources = el.querySelectorAll('source');
	  var i = sources.length;
	
	  while (i--) {
	    el.removeChild(sources[i]);
	  } // remove any src reference.
	  // not setting `src=''` because that throws an error
	
	
	  el.removeAttribute('src');
	
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {// satisfy linter
	      }
	    })();
	  }
	};
	/* Native HTML5 element property wrapping ----------------------------------- */
	// Wrap native boolean attributes with getters that check both property and attribute
	// The list is as followed:
	// muted, defaultMuted, autoplay, controls, loop, playsinline
	
	
	[
	/**
	 * Get the value of `muted` from the media element. `muted` indicates
	 * that the volume for the media should be set to silent. This does not actually change
	 * the `volume` attribute.
	 *
	 * @method Html5#muted
	 * @return {boolean}
	 *         - True if the value of `volume` should be ignored and the audio set to silent.
	 *         - False if the value of `volume` should be used.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	/**
	 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
	 * whether the media should start muted or not. Only changes the default state of the
	 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
	 * current state.
	 *
	 * @method Html5#defaultMuted
	 * @return {boolean}
	 *         - The value of `defaultMuted` from the media element.
	 *         - True indicates that the media should start muted.
	 *         - False indicates that the media should not start muted
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	/**
	 * Get the value of `autoplay` from the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#autoplay
	 * @return {boolean}
	 *         - The value of `autoplay` from the media element.
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	/**
	 * Get the value of `controls` from the media element. `controls` indicates
	 * whether the native media controls should be shown or hidden.
	 *
	 * @method Html5#controls
	 * @return {boolean}
	 *         - The value of `controls` from the media element.
	 *         - True indicates that native controls should be showing.
	 *         - False indicates that native controls should be hidden.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
	 */
	'controls',
	/**
	 * Get the value of `loop` from the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#loop
	 * @return {boolean}
	 *         - The value of `loop` from the media element.
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	/**
	 * Get the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#playsinline
	 * @return {boolean}
	 *         - The value of `playsinline` from the media element.
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop] || this.el_.hasAttribute(prop);
	  };
	}); // Wrap native boolean attributes with setters that set both property and attribute
	// The list is as followed:
	// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
	// setControls is special-cased above
	
	[
	/**
	 * Set the value of `muted` on the media element. `muted` indicates that the current
	 * audio level should be silent.
	 *
	 * @method Html5#setMuted
	 * @param {boolean} muted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	/**
	 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
	 * audio level should be silent, but will only effect the muted level on initial playback..
	 *
	 * @method Html5.prototype.setDefaultMuted
	 * @param {boolean} defaultMuted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	/**
	 * Set the value of `autoplay` on the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#setAutoplay
	 * @param {boolean} autoplay
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	/**
	 * Set the value of `loop` on the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#setLoop
	 * @param {boolean} loop
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	/**
	 * Set the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#setPlaysinline
	 * @param {boolean} playsinline
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype['set' + toTitleCase$1(prop)] = function (v) {
	    this.el_[prop] = v;
	
	    if (v) {
	      this.el_.setAttribute(prop, prop);
	    } else {
	      this.el_.removeAttribute(prop);
	    }
	  };
	}); // Wrap native properties with a getter
	// The list is as followed
	// paused, currentTime, buffered, volume, poster, preload, error, seeking
	// seekable, ended, playbackRate, defaultPlaybackRate, disablePictureInPicture
	// played, networkState, readyState, videoWidth, videoHeight, crossOrigin
	
	[
	/**
	 * Get the value of `paused` from the media element. `paused` indicates whether the media element
	 * is currently paused or not.
	 *
	 * @method Html5#paused
	 * @return {boolean}
	 *         The value of `paused` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
	 */
	'paused',
	/**
	 * Get the value of `currentTime` from the media element. `currentTime` indicates
	 * the current second that the media is at in playback.
	 *
	 * @method Html5#currentTime
	 * @return {number}
	 *         The value of `currentTime` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
	 */
	'currentTime',
	/**
	 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
	 * object that represents the parts of the media that are already downloaded and
	 * available for playback.
	 *
	 * @method Html5#buffered
	 * @return {TimeRange}
	 *         The value of `buffered` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
	 */
	'buffered',
	/**
	 * Get the value of `volume` from the media element. `volume` indicates
	 * the current playback volume of audio for a media. `volume` will be a value from 0
	 * (silent) to 1 (loudest and default).
	 *
	 * @method Html5#volume
	 * @return {number}
	 *         The value of `volume` from the media element. Value will be between 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	/**
	 * Get the value of `poster` from the media element. `poster` indicates
	 * that the url of an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#poster
	 * @return {string}
	 *         The value of `poster` from the media element. Value will be a url to an
	 *         image.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
	 */
	'poster',
	/**
	 * Get the value of `preload` from the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#preload
	 * @return {string}
	 *         The value of `preload` from the media element. Will be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	/**
	 * Get the value of the `error` from the media element. `error` indicates any
	 * MediaError that may have occurred during playback. If error returns null there is no
	 * current error.
	 *
	 * @method Html5#error
	 * @return {MediaError|null}
	 *         The value of `error` from the media element. Will be `MediaError` if there
	 *         is a current error and null otherwise.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
	 */
	'error',
	/**
	 * Get the value of `seeking` from the media element. `seeking` indicates whether the
	 * media is currently seeking to a new position or not.
	 *
	 * @method Html5#seeking
	 * @return {boolean}
	 *         - The value of `seeking` from the media element.
	 *         - True indicates that the media is currently seeking to a new position.
	 *         - False indicates that the media is not seeking to a new position at this time.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
	 */
	'seeking',
	/**
	 * Get the value of `seekable` from the media element. `seekable` returns a
	 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
	 *
	 * @method Html5#seekable
	 * @return {TimeRange}
	 *         The value of `seekable` from the media element. A `TimeRange` object
	 *         indicating the current ranges of time that can be seeked to.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
	 */
	'seekable',
	/**
	 * Get the value of `ended` from the media element. `ended` indicates whether
	 * the media has reached the end or not.
	 *
	 * @method Html5#ended
	 * @return {boolean}
	 *         - The value of `ended` from the media element.
	 *         - True indicates that the media has ended.
	 *         - False indicates that the media has not ended.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
	 */
	'ended',
	/**
	 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
	 * the rate at which the media is currently playing back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#playbackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate',
	/**
	 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
	 * the rate at which the media is currently playing back. This value will not indicate the current
	 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
	 *
	 * Examples:
	 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
	 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5.prototype.defaultPlaybackRate
	 * @return {number}
	 *         The value of `defaultPlaybackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'defaultPlaybackRate',
	/**
	 * Get the value of 'disablePictureInPicture' from the video element.
	 *
	 * @method Html5#disablePictureInPicture
	 * @return {boolean} value
	 *         - The value of `disablePictureInPicture` from the video element.
	 *         - True indicates that the video can't be played in Picture-In-Picture mode
	 *         - False indicates that the video can be played in Picture-In-Picture mode
	 *
	 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
	 */
	'disablePictureInPicture',
	/**
	 * Get the value of `played` from the media element. `played` returns a `TimeRange`
	 * object representing points in the media timeline that have been played.
	 *
	 * @method Html5#played
	 * @return {TimeRange}
	 *         The value of `played` from the media element. A `TimeRange` object indicating
	 *         the ranges of time that have been played.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
	 */
	'played',
	/**
	 * Get the value of `networkState` from the media element. `networkState` indicates
	 * the current network state. It returns an enumeration from the following list:
	 * - 0: NETWORK_EMPTY
	 * - 1: NETWORK_IDLE
	 * - 2: NETWORK_LOADING
	 * - 3: NETWORK_NO_SOURCE
	 *
	 * @method Html5#networkState
	 * @return {number}
	 *         The value of `networkState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
	 */
	'networkState',
	/**
	 * Get the value of `readyState` from the media element. `readyState` indicates
	 * the current state of the media element. It returns an enumeration from the
	 * following list:
	 * - 0: HAVE_NOTHING
	 * - 1: HAVE_METADATA
	 * - 2: HAVE_CURRENT_DATA
	 * - 3: HAVE_FUTURE_DATA
	 * - 4: HAVE_ENOUGH_DATA
	 *
	 * @method Html5#readyState
	 * @return {number}
	 *         The value of `readyState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
	 */
	'readyState',
	/**
	 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
	 * the current width of the video in css pixels.
	 *
	 * @method Html5#videoWidth
	 * @return {number}
	 *         The value of `videoWidth` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoWidth',
	/**
	 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
	 * the current height of the video in css pixels.
	 *
	 * @method Html5#videoHeight
	 * @return {number}
	 *         The value of `videoHeight` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoHeight',
	/**
	 * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
	 * to the browser that should sent the cookies along with the requests for the
	 * different assets/playlists
	 *
	 * @method Html5#crossOrigin
	 * @return {string}
	 *         - anonymous indicates that the media should not sent cookies.
	 *         - use-credentials indicates that the media should sent cookies along the requests.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
	 */
	'crossOrigin'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop];
	  };
	}); // Wrap native properties with a setter in this format:
	// set + toTitleCase(name)
	// The list is as follows:
	// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate,
	// setDisablePictureInPicture, setCrossOrigin
	
	[
	/**
	 * Set the value of `volume` on the media element. `volume` indicates the current
	 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
	 * so on.
	 *
	 * @method Html5#setVolume
	 * @param {number} percentAsDecimal
	 *        The volume percent as a decimal. Valid range is from 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	/**
	 * Set the value of `src` on the media element. `src` indicates the current
	 * {@link Tech~SourceObject} for the media.
	 *
	 * @method Html5#setSrc
	 * @param {Tech~SourceObject} src
	 *        The source object to set as the current source.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
	 */
	'src',
	/**
	 * Set the value of `poster` on the media element. `poster` is the url to
	 * an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#setPoster
	 * @param {string} poster
	 *        The url to an image that should be used as the `poster` for the media
	 *        element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
	 */
	'poster',
	/**
	 * Set the value of `preload` on the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#setPreload
	 * @param {string} preload
	 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	/**
	 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
	 * the rate at which the media should play back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#setPlaybackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate',
	/**
	 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
	 * the rate at which the media should play back upon initial startup. Changing this value
	 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
	 *
	 * Example Values:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5.prototype.setDefaultPlaybackRate
	 * @return {number}
	 *         The value of `defaultPlaybackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
	 */
	'defaultPlaybackRate',
	/**
	 * Prevents the browser from suggesting a Picture-in-Picture context menu
	 * or to request Picture-in-Picture automatically in some cases.
	 *
	 * @method Html5#setDisablePictureInPicture
	 * @param {boolean} value
	 *         The true value will disable Picture-in-Picture mode.
	 *
	 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
	 */
	'disablePictureInPicture',
	/**
	 * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
	 * to the browser that should sent the cookies along with the requests for the
	 * different assets/playlists
	 *
	 * @method Html5#setCrossOrigin
	 * @param {string} crossOrigin
	 *         - anonymous indicates that the media should not sent cookies.
	 *         - use-credentials indicates that the media should sent cookies along the requests.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
	 */
	'crossOrigin'].forEach(function (prop) {
	  Html5.prototype['set' + toTitleCase$1(prop)] = function (v) {
	    this.el_[prop] = v;
	  };
	}); // wrap native functions with a function
	// The list is as follows:
	// pause, load, play
	
	[
	/**
	 * A wrapper around the media elements `pause` function. This will call the `HTML5`
	 * media elements `pause` function.
	 *
	 * @method Html5#pause
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
	 */
	'pause',
	/**
	 * A wrapper around the media elements `load` function. This will call the `HTML5`s
	 * media element `load` function.
	 *
	 * @method Html5#load
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
	 */
	'load',
	/**
	 * A wrapper around the media elements `play` function. This will call the `HTML5`s
	 * media element `play` function.
	 *
	 * @method Html5#play
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
	 */
	'play'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop]();
	  };
	});
	Tech.withSourceHandlers(Html5);
	/**
	 * Native source handler for Html5, simply passes the source to the media element.
	 *
	 * @property {Tech~SourceObject} source
	 *        The source object
	 *
	 * @property {Html5} tech
	 *        The instance of the HTML5 tech.
	 */
	
	Html5.nativeSourceHandler = {};
	/**
	 * Check if the media element can play the given mime type.
	 *
	 * @param {string} type
	 *        The mimetype to check
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string)
	 */
	
	Html5.nativeSourceHandler.canPlayType = function (type) {
	  // IE without MediaPlayer throws an error (#519)
	  try {
	    return Html5.TEST_VID.canPlayType(type);
	  } catch (e) {
	    return '';
	  }
	};
	/**
	 * Check if the media element can handle a source natively.
	 *
	 * @param {Tech~SourceObject} source
	 *         The source object
	 *
	 * @param {Object} [options]
	 *         Options to be passed to the tech.
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string).
	 */
	
	
	Html5.nativeSourceHandler.canHandleSource = function (source, options) {
	  // If a type was provided we should rely on that
	  if (source.type) {
	    return Html5.nativeSourceHandler.canPlayType(source.type); // If no type, fall back to checking 'video/[EXTENSION]'
	  } else if (source.src) {
	    var ext = getFileExtension(source.src);
	    return Html5.nativeSourceHandler.canPlayType("video/" + ext);
	  }
	
	  return '';
	};
	/**
	 * Pass the source to the native media element.
	 *
	 * @param {Tech~SourceObject} source
	 *        The source object
	 *
	 * @param {Html5} tech
	 *        The instance of the Html5 tech
	 *
	 * @param {Object} [options]
	 *        The options to pass to the source
	 */
	
	
	Html5.nativeSourceHandler.handleSource = function (source, tech, options) {
	  tech.setSrc(source.src);
	};
	/**
	 * A noop for the native dispose function, as cleanup is not needed.
	 */
	
	
	Html5.nativeSourceHandler.dispose = function () {}; // Register the native source handler
	
	
	Html5.registerSourceHandler(Html5.nativeSourceHandler);
	Tech.registerTech('Html5', Html5);
	
	// on the player when they happen
	
	var TECH_EVENTS_RETRIGGER = [
	/**
	 * Fired while the user agent is downloading media data.
	 *
	 * @event Player#progress
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `progress` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechProgress_
	 * @fires Player#progress
	 * @listens Tech#progress
	 */
	'progress',
	/**
	 * Fires when the loading of an audio/video is aborted.
	 *
	 * @event Player#abort
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `abort` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechAbort_
	 * @fires Player#abort
	 * @listens Tech#abort
	 */
	'abort',
	/**
	 * Fires when the browser is intentionally not getting media data.
	 *
	 * @event Player#suspend
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechSuspend_
	 * @fires Player#suspend
	 * @listens Tech#suspend
	 */
	'suspend',
	/**
	 * Fires when the current playlist is empty.
	 *
	 * @event Player#emptied
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechEmptied_
	 * @fires Player#emptied
	 * @listens Tech#emptied
	 */
	'emptied',
	/**
	 * Fires when the browser is trying to get media data, but data is not available.
	 *
	 * @event Player#stalled
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechStalled_
	 * @fires Player#stalled
	 * @listens Tech#stalled
	 */
	'stalled',
	/**
	 * Fires when the browser has loaded meta data for the audio/video.
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoadedmetadata_
	 * @fires Player#loadedmetadata
	 * @listens Tech#loadedmetadata
	 */
	'loadedmetadata',
	/**
	 * Fires when the browser has loaded the current frame of the audio/video.
	 *
	 * @event Player#loadeddata
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoaddeddata_
	 * @fires Player#loadeddata
	 * @listens Tech#loadeddata
	 */
	'loadeddata',
	/**
	 * Fires when the current playback position has changed.
	 *
	 * @event Player#timeupdate
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTimeUpdate_
	 * @fires Player#timeupdate
	 * @listens Tech#timeupdate
	 */
	'timeupdate',
	/**
	 * Fires when the video's intrinsic dimensions change
	 *
	 * @event Player#resize
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `resize` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechResize_
	 * @fires Player#resize
	 * @listens Tech#resize
	 */
	'resize',
	/**
	 * Fires when the volume has been changed
	 *
	 * @event Player#volumechange
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechVolumechange_
	 * @fires Player#volumechange
	 * @listens Tech#volumechange
	 */
	'volumechange',
	/**
	 * Fires when the text track has been changed
	 *
	 * @event Player#texttrackchange
	 * @type {event}
	 */
	
	/**
	 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTexttrackchange_
	 * @fires Player#texttrackchange
	 * @listens Tech#texttrackchange
	 */
	'texttrackchange']; // events to queue when playback rate is zero
	// this is a hash for the sole purpose of mapping non-camel-cased event names
	// to camel-cased function names
	
	var TECH_EVENTS_QUEUE = {
	  canplay: 'CanPlay',
	  canplaythrough: 'CanPlayThrough',
	  playing: 'Playing',
	  seeked: 'Seeked'
	};
	var BREAKPOINT_ORDER = ['tiny', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'huge'];
	var BREAKPOINT_CLASSES = {}; // grep: vjs-layout-tiny
	// grep: vjs-layout-x-small
	// grep: vjs-layout-small
	// grep: vjs-layout-medium
	// grep: vjs-layout-large
	// grep: vjs-layout-x-large
	// grep: vjs-layout-huge
	
	BREAKPOINT_ORDER.forEach(function (k) {
	  var v = k.charAt(0) === 'x' ? "x-" + k.substring(1) : k;
	  BREAKPOINT_CLASSES[k] = "vjs-layout-" + v;
	});
	var DEFAULT_BREAKPOINTS = {
	  tiny: 210,
	  xsmall: 320,
	  small: 425,
	  medium: 768,
	  large: 1440,
	  xlarge: 2560,
	  huge: Infinity
	};
	/**
	 * An instance of the `Player` class is created when any of the Video.js setup methods
	 * are used to initialize a video.
	 *
	 * After an instance has been created it can be accessed globally in two ways:
	 * 1. By calling `videojs('example_video_1');`
	 * 2. By using it directly via  `videojs.players.example_video_1;`
	 *
	 * @extends Component
	 */
	
	var Player = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](Player, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Element} tag
	   *        The original video DOM element used for configuring options.
	   *
	   * @param {Object} [options]
	   *        Object of option names and values.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Ready callback function.
	   */
	  function Player(tag, options, ready) {
	    var _this;
	
	    // Make sure tag ID exists
	    tag.id = tag.id || options.id || "vjs_video_" + newGUID(); // Set Options
	    // The options argument overrides options set in the video tag
	    // which overrides globally set options.
	    // This latter part coincides with the load order
	    // (tag must exist before Player)
	
	    options = assign(Player.getTagSettings(tag), options); // Delay the initialization of children because we need to set up
	    // player properties first, and can't use `this` before `super()`
	
	    options.initChildren = false; // Same with creating the element
	
	    options.createEl = false; // don't auto mixin the evented mixin
	
	    options.evented = false; // we don't want the player to report touch activity on itself
	    // see enableTouchActivity in Component
	
	    options.reportTouchActivity = false; // If language is not set, get the closest lang attribute
	
	    if (!options.language) {
	      if (typeof tag.closest === 'function') {
	        var closest = tag.closest('[lang]');
	
	        if (closest && closest.getAttribute) {
	          options.language = closest.getAttribute('lang');
	        }
	      } else {
	        var element = tag;
	
	        while (element && element.nodeType === 1) {
	          if (getAttributes(element).hasOwnProperty('lang')) {
	            options.language = element.getAttribute('lang');
	            break;
	          }
	
	          element = element.parentNode;
	        }
	      }
	    } // Run base component initializing with new options
	
	
	    _this = _Component.call(this, null, options, ready) || this; // Create bound methods for document listeners.
	
	    _this.boundDocumentFullscreenChange_ = function (e) {
	      return _this.documentFullscreenChange_(e);
	    };
	
	    _this.boundFullWindowOnEscKey_ = function (e) {
	      return _this.fullWindowOnEscKey(e);
	    };
	
	    _this.boundUpdateStyleEl_ = function (e) {
	      return _this.updateStyleEl_(e);
	    };
	
	    _this.boundApplyInitTime_ = function (e) {
	      return _this.applyInitTime_(e);
	    };
	
	    _this.boundUpdateCurrentBreakpoint_ = function (e) {
	      return _this.updateCurrentBreakpoint_(e);
	    };
	
	    _this.boundHandleTechClick_ = function (e) {
	      return _this.handleTechClick_(e);
	    };
	
	    _this.boundHandleTechDoubleClick_ = function (e) {
	      return _this.handleTechDoubleClick_(e);
	    };
	
	    _this.boundHandleTechTouchStart_ = function (e) {
	      return _this.handleTechTouchStart_(e);
	    };
	
	    _this.boundHandleTechTouchMove_ = function (e) {
	      return _this.handleTechTouchMove_(e);
	    };
	
	    _this.boundHandleTechTouchEnd_ = function (e) {
	      return _this.handleTechTouchEnd_(e);
	    };
	
	    _this.boundHandleTechTap_ = function (e) {
	      return _this.handleTechTap_(e);
	    }; // default isFullscreen_ to false
	
	
	    _this.isFullscreen_ = false; // create logger
	
	    _this.log = createLogger(_this.id_); // Hold our own reference to fullscreen api so it can be mocked in tests
	
	    _this.fsApi_ = FullscreenApi; // Tracks when a tech changes the poster
	
	    _this.isPosterFromTech_ = false; // Holds callback info that gets queued when playback rate is zero
	    // and a seek is happening
	
	    _this.queuedCallbacks_ = []; // Turn off API access because we're loading a new tech that might load asynchronously
	
	    _this.isReady_ = false; // Init state hasStarted_
	
	    _this.hasStarted_ = false; // Init state userActive_
	
	    _this.userActive_ = false; // Init debugEnabled_
	
	    _this.debugEnabled_ = false; // Init state audioOnlyMode_
	
	    _this.audioOnlyMode_ = false; // Init state audioPosterMode_
	
	    _this.audioPosterMode_ = false; // Init state audioOnlyCache_
	
	    _this.audioOnlyCache_ = {
	      playerHeight: null,
	      hiddenChildren: []
	    }; // if the global option object was accidentally blown away by
	    // someone, bail early with an informative error
	
	    if (!_this.options_ || !_this.options_.techOrder || !_this.options_.techOrder.length) {
	      throw new Error('No techOrder specified. Did you overwrite ' + 'videojs.options instead of just changing the ' + 'properties you want to override?');
	    } // Store the original tag used to set options
	
	
	    _this.tag = tag; // Store the tag attributes used to restore html5 element
	
	    _this.tagAttributes = tag && getAttributes(tag); // Update current language
	
	    _this.language(_this.options_.language); // Update Supported Languages
	
	
	    if (options.languages) {
	      // Normalise player option languages to lowercase
	      var languagesToLower = {};
	      Object.getOwnPropertyNames(options.languages).forEach(function (name) {
	        languagesToLower[name.toLowerCase()] = options.languages[name];
	      });
	      _this.languages_ = languagesToLower;
	    } else {
	      _this.languages_ = Player.prototype.options_.languages;
	    }
	
	    _this.resetCache_(); // Set poster
	
	
	    _this.poster_ = options.poster || ''; // Set controls
	
	    _this.controls_ = !!options.controls; // Original tag settings stored in options
	    // now remove immediately so native controls don't flash.
	    // May be turned back on by HTML5 tech if nativeControlsForTouch is true
	
	    tag.controls = false;
	    tag.removeAttribute('controls');
	    _this.changingSrc_ = false;
	    _this.playCallbacks_ = [];
	    _this.playTerminatedQueue_ = []; // the attribute overrides the option
	
	    if (tag.hasAttribute('autoplay')) {
	      _this.autoplay(true);
	    } else {
	      // otherwise use the setter to validate and
	      // set the correct value.
	      _this.autoplay(_this.options_.autoplay);
	    } // check plugins
	
	
	    if (options.plugins) {
	      Object.keys(options.plugins).forEach(function (name) {
	        if (typeof _this[name] !== 'function') {
	          throw new Error("plugin \"" + name + "\" does not exist");
	        }
	      });
	    }
	    /*
	     * Store the internal state of scrubbing
	     *
	     * @private
	     * @return {Boolean} True if the user is scrubbing
	     */
	
	
	    _this.scrubbing_ = false;
	    _this.el_ = _this.createEl(); // Make this an evented object and use `el_` as its event bus.
	
	    evented(_assertThisInitialized__default['default'](_this), {
	      eventBusKey: 'el_'
	    }); // listen to document and player fullscreenchange handlers so we receive those events
	    // before a user can receive them so we can update isFullscreen appropriately.
	    // make sure that we listen to fullscreenchange events before everything else to make sure that
	    // our isFullscreen method is updated properly for internal components as well as external.
	
	    if (_this.fsApi_.requestFullscreen) {
	      on(document__default['default'], _this.fsApi_.fullscreenchange, _this.boundDocumentFullscreenChange_);
	
	      _this.on(_this.fsApi_.fullscreenchange, _this.boundDocumentFullscreenChange_);
	    }
	
	    if (_this.fluid_) {
	      _this.on(['playerreset', 'resize'], _this.boundUpdateStyleEl_);
	    } // We also want to pass the original player options to each component and plugin
	    // as well so they don't need to reach back into the player for options later.
	    // We also need to do another copy of this.options_ so we don't end up with
	    // an infinite loop.
	
	
	    var playerOptionsCopy = mergeOptions$3(_this.options_); // Load plugins
	
	    if (options.plugins) {
	      Object.keys(options.plugins).forEach(function (name) {
	        _this[name](options.plugins[name]);
	      });
	    } // Enable debug mode to fire debugon event for all plugins.
	
	
	    if (options.debug) {
	      _this.debug(true);
	    }
	
	    _this.options_.playerOptions = playerOptionsCopy;
	    _this.middleware_ = [];
	
	    _this.playbackRates(options.playbackRates);
	
	    _this.initChildren(); // Set isAudio based on whether or not an audio tag was used
	
	
	    _this.isAudio(tag.nodeName.toLowerCase() === 'audio'); // Update controls className. Can't do this when the controls are initially
	    // set because the element doesn't exist yet.
	
	
	    if (_this.controls()) {
	      _this.addClass('vjs-controls-enabled');
	    } else {
	      _this.addClass('vjs-controls-disabled');
	    } // Set ARIA label and region role depending on player type
	
	
	    _this.el_.setAttribute('role', 'region');
	
	    if (_this.isAudio()) {
	      _this.el_.setAttribute('aria-label', _this.localize('Audio Player'));
	    } else {
	      _this.el_.setAttribute('aria-label', _this.localize('Video Player'));
	    }
	
	    if (_this.isAudio()) {
	      _this.addClass('vjs-audio');
	    }
	
	    if (_this.flexNotSupported_()) {
	      _this.addClass('vjs-no-flex');
	    } // TODO: Make this smarter. Toggle user state between touching/mousing
	    // using events, since devices can have both touch and mouse events.
	    // TODO: Make this check be performed again when the window switches between monitors
	    // (See https://github.com/videojs/video.js/issues/5683)
	
	
	    if (TOUCH_ENABLED) {
	      _this.addClass('vjs-touch-enabled');
	    } // iOS Safari has broken hover handling
	
	
	    if (!IS_IOS) {
	      _this.addClass('vjs-workinghover');
	    } // Make player easily findable by ID
	
	
	    Player.players[_this.id_] = _assertThisInitialized__default['default'](_this); // Add a major version class to aid css in plugins
	
	    var majorVersion = version$5.split('.')[0];
	
	    _this.addClass("vjs-v" + majorVersion); // When the player is first initialized, trigger activity so components
	    // like the control bar show themselves if needed
	
	
	    _this.userActive(true);
	
	    _this.reportUserActivity();
	
	    _this.one('play', function (e) {
	      return _this.listenForUserActivity_(e);
	    });
	
	    _this.on('stageclick', function (e) {
	      return _this.handleStageClick_(e);
	    });
	
	    _this.on('keydown', function (e) {
	      return _this.handleKeyDown(e);
	    });
	
	    _this.on('languagechange', function (e) {
	      return _this.handleLanguagechange(e);
	    });
	
	    _this.breakpoints(_this.options_.breakpoints);
	
	    _this.responsive(_this.options_.responsive); // Calling both the audio mode methods after the player is fully
	    // setup to be able to listen to the events triggered by them
	
	
	    _this.on('ready', function () {
	      // Calling the audioPosterMode method first so that
	      // the audioOnlyMode can take precedence when both options are set to true
	      _this.audioPosterMode(_this.options_.audioPosterMode);
	
	      _this.audioOnlyMode(_this.options_.audioOnlyMode);
	    });
	
	    return _this;
	  }
	  /**
	   * Destroys the video player and does any necessary cleanup.
	   *
	   * This is especially helpful if you are dynamically adding and removing videos
	   * to/from the DOM.
	   *
	   * @fires Player#dispose
	   */
	
	
	  var _proto = Player.prototype;
	
	  _proto.dispose = function dispose() {
	    var _this2 = this;
	
	    /**
	     * Called when the player is being disposed of.
	     *
	     * @event Player#dispose
	     * @type {EventTarget~Event}
	     */
	    this.trigger('dispose'); // prevent dispose from being called twice
	
	    this.off('dispose'); // Make sure all player-specific document listeners are unbound. This is
	
	    off(document__default['default'], this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
	    off(document__default['default'], 'keydown', this.boundFullWindowOnEscKey_);
	
	    if (this.styleEl_ && this.styleEl_.parentNode) {
	      this.styleEl_.parentNode.removeChild(this.styleEl_);
	      this.styleEl_ = null;
	    } // Kill reference to this player
	
	
	    Player.players[this.id_] = null;
	
	    if (this.tag && this.tag.player) {
	      this.tag.player = null;
	    }
	
	    if (this.el_ && this.el_.player) {
	      this.el_.player = null;
	    }
	
	    if (this.tech_) {
	      this.tech_.dispose();
	      this.isPosterFromTech_ = false;
	      this.poster_ = '';
	    }
	
	    if (this.playerElIngest_) {
	      this.playerElIngest_ = null;
	    }
	
	    if (this.tag) {
	      this.tag = null;
	    }
	
	    clearCacheForPlayer(this); // remove all event handlers for track lists
	    // all tracks and track listeners are removed on
	    // tech dispose
	
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	
	      var list = _this2[props.getterName](); // if it is not a native list
	      // we have to manually remove event listeners
	
	
	      if (list && list.off) {
	        list.off();
	      }
	    }); // the actual .el_ is removed here, or replaced if
	
	    _Component.prototype.dispose.call(this, {
	      restoreEl: this.options_.restoreEl
	    });
	  }
	  /**
	   * Create the `Player`'s DOM element.
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	  ;
	
	  _proto.createEl = function createEl() {
	    var tag = this.tag;
	    var el;
	    var playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute('data-vjs-player');
	    var divEmbed = this.tag.tagName.toLowerCase() === 'video-js';
	
	    if (playerElIngest) {
	      el = this.el_ = tag.parentNode;
	    } else if (!divEmbed) {
	      el = this.el_ = _Component.prototype.createEl.call(this, 'div');
	    } // Copy over all the attributes from the tag, including ID and class
	    // ID will now reference player box, not the video tag
	
	
	    var attrs = getAttributes(tag);
	
	    if (divEmbed) {
	      el = this.el_ = tag;
	      tag = this.tag = document__default['default'].createElement('video');
	
	      while (el.children.length) {
	        tag.appendChild(el.firstChild);
	      }
	
	      if (!hasClass(el, 'video-js')) {
	        addClass(el, 'video-js');
	      }
	
	      el.appendChild(tag);
	      playerElIngest = this.playerElIngest_ = el; // move properties over from our custom `video-js` element
	      // to our new `video` element. This will move things like
	      // `src` or `controls` that were set via js before the player
	      // was initialized.
	
	      Object.keys(el).forEach(function (k) {
	        try {
	          tag[k] = el[k];
	        } catch (e) {// we got a a property like outerHTML which we can't actually copy, ignore it
	        }
	      });
	    } // set tabindex to -1 to remove the video element from the focus order
	
	
	    tag.setAttribute('tabindex', '-1');
	    attrs.tabindex = '-1'; // Workaround for #4583 (JAWS+IE doesn't announce BPB or play button), and
	    // for the same issue with Chrome (on Windows) with JAWS.
	    // See https://github.com/FreedomScientific/VFO-standards-support/issues/78
	    // Note that we can't detect if JAWS is being used, but this ARIA attribute
	    //  doesn't change behavior of IE11 or Chrome if JAWS is not being used
	
	    if (IE_VERSION || IS_CHROME && IS_WINDOWS) {
	      tag.setAttribute('role', 'application');
	      attrs.role = 'application';
	    } // Remove width/height attrs from tag so CSS can make it 100% width/height
	
	
	    tag.removeAttribute('width');
	    tag.removeAttribute('height');
	
	    if ('width' in attrs) {
	      delete attrs.width;
	    }
	
	    if ('height' in attrs) {
	      delete attrs.height;
	    }
	
	    Object.getOwnPropertyNames(attrs).forEach(function (attr) {
	      // don't copy over the class attribute to the player element when we're in a div embed
	      // the class is already set up properly in the divEmbed case
	      // and we want to make sure that the `video-js` class doesn't get lost
	      if (!(divEmbed && attr === 'class')) {
	        el.setAttribute(attr, attrs[attr]);
	      }
	
	      if (divEmbed) {
	        tag.setAttribute(attr, attrs[attr]);
	      }
	    }); // Update tag id/class for use as HTML5 playback tech
	    // Might think we should do this after embedding in container so .vjs-tech class
	    // doesn't flash 100% width/height, but class only applies with .video-js parent
	
	    tag.playerId = tag.id;
	    tag.id += '_html5_api';
	    tag.className = 'vjs-tech'; // Make player findable on elements
	
	    tag.player = el.player = this; // Default state of video is paused
	
	    this.addClass('vjs-paused'); // Add a style element in the player that we'll use to set the width/height
	    // of the player in a way that's still overrideable by CSS, just like the
	    // video element
	
	    if (window__default['default'].VIDEOJS_NO_DYNAMIC_STYLE !== true) {
	      this.styleEl_ = createStyleElement('vjs-styles-dimensions');
	      var defaultsStyleEl = $('.vjs-styles-defaults');
	      var head = $('head');
	      head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
	    }
	
	    this.fill_ = false;
	    this.fluid_ = false; // Pass in the width/height/aspectRatio options which will update the style el
	
	    this.width(this.options_.width);
	    this.height(this.options_.height);
	    this.fill(this.options_.fill);
	    this.fluid(this.options_.fluid);
	    this.aspectRatio(this.options_.aspectRatio); // support both crossOrigin and crossorigin to reduce confusion and issues around the name
	
	    this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin); // Hide any links within the video/audio tag,
	    // because IE doesn't hide them completely from screen readers.
	
	    var links = tag.getElementsByTagName('a');
	
	    for (var i = 0; i < links.length; i++) {
	      var linkEl = links.item(i);
	      addClass(linkEl, 'vjs-hidden');
	      linkEl.setAttribute('hidden', 'hidden');
	    } // insertElFirst seems to cause the networkState to flicker from 3 to 2, so
	    // keep track of the original for later so we can know if the source originally failed
	
	
	    tag.initNetworkState_ = tag.networkState; // Wrap video tag in div (el/box) container
	
	    if (tag.parentNode && !playerElIngest) {
	      tag.parentNode.insertBefore(el, tag);
	    } // insert the tag as the first child of the player element
	    // then manually add it to the children array so that this.addChild
	    // will work properly for other components
	    //
	    // Breaks iPhone, fixed in HTML5 setup.
	
	
	    prependTo(tag, el);
	    this.children_.unshift(tag); // Set lang attr on player to ensure CSS :lang() in consistent with player
	    // if it's been set to something different to the doc
	
	    this.el_.setAttribute('lang', this.language_);
	    this.el_.setAttribute('translate', 'no');
	    this.el_ = el;
	    return el;
	  }
	  /**
	   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
	   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
	   * behavior.
	   *
	   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
	   *
	   * @param {string} [value]
	   *        The value to set the `Player`'s crossOrigin to. If an argument is
	   *        given, must be one of `anonymous` or `use-credentials`.
	   *
	   * @return {string|undefined}
	   *         - The current crossOrigin value of the `Player` when getting.
	   *         - undefined when setting
	   */
	  ;
	
	  _proto.crossOrigin = function crossOrigin(value) {
	    if (!value) {
	      return this.techGet_('crossOrigin');
	    }
	
	    if (value !== 'anonymous' && value !== 'use-credentials') {
	      log$1.warn("crossOrigin must be \"anonymous\" or \"use-credentials\", given \"" + value + "\"");
	      return;
	    }
	
	    this.techCall_('setCrossOrigin', value);
	    return;
	  }
	  /**
	   * A getter/setter for the `Player`'s width. Returns the player's configured value.
	   * To get the current width use `currentWidth()`.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player`'s width to.
	   *
	   * @return {number}
	   *         The current width of the `Player` when getting.
	   */
	  ;
	
	  _proto.width = function width(value) {
	    return this.dimension('width', value);
	  }
	  /**
	   * A getter/setter for the `Player`'s height. Returns the player's configured value.
	   * To get the current height use `currentheight()`.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player`'s heigth to.
	   *
	   * @return {number}
	   *         The current height of the `Player` when getting.
	   */
	  ;
	
	  _proto.height = function height(value) {
	    return this.dimension('height', value);
	  }
	  /**
	   * A getter/setter for the `Player`'s width & height.
	   *
	   * @param {string} dimension
	   *        This string can be:
	   *        - 'width'
	   *        - 'height'
	   *
	   * @param {number} [value]
	   *        Value for dimension specified in the first argument.
	   *
	   * @return {number}
	   *         The dimension arguments value when getting (width/height).
	   */
	  ;
	
	  _proto.dimension = function dimension(_dimension, value) {
	    var privDimension = _dimension + '_';
	
	    if (value === undefined) {
	      return this[privDimension] || 0;
	    }
	
	    if (value === '' || value === 'auto') {
	      // If an empty string is given, reset the dimension to be automatic
	      this[privDimension] = undefined;
	      this.updateStyleEl_();
	      return;
	    }
	
	    var parsedVal = parseFloat(value);
	
	    if (isNaN(parsedVal)) {
	      log$1.error("Improper value \"" + value + "\" supplied for for " + _dimension);
	      return;
	    }
	
	    this[privDimension] = parsedVal;
	    this.updateStyleEl_();
	  }
	  /**
	   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
	   *
	   * Turning this on will turn off fill mode.
	   *
	   * @param {boolean} [bool]
	   *        - A value of true adds the class.
	   *        - A value of false removes the class.
	   *        - No value will be a getter.
	   *
	   * @return {boolean|undefined}
	   *         - The value of fluid when getting.
	   *         - `undefined` when setting.
	   */
	  ;
	
	  _proto.fluid = function fluid(bool) {
	    var _this3 = this;
	
	    if (bool === undefined) {
	      return !!this.fluid_;
	    }
	
	    this.fluid_ = !!bool;
	
	    if (isEvented(this)) {
	      this.off(['playerreset', 'resize'], this.boundUpdateStyleEl_);
	    }
	
	    if (bool) {
	      this.addClass('vjs-fluid');
	      this.fill(false);
	      addEventedCallback(this, function () {
	        _this3.on(['playerreset', 'resize'], _this3.boundUpdateStyleEl_);
	      });
	    } else {
	      this.removeClass('vjs-fluid');
	    }
	
	    this.updateStyleEl_();
	  }
	  /**
	   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
	   *
	   * Turning this on will turn off fluid mode.
	   *
	   * @param {boolean} [bool]
	   *        - A value of true adds the class.
	   *        - A value of false removes the class.
	   *        - No value will be a getter.
	   *
	   * @return {boolean|undefined}
	   *         - The value of fluid when getting.
	   *         - `undefined` when setting.
	   */
	  ;
	
	  _proto.fill = function fill(bool) {
	    if (bool === undefined) {
	      return !!this.fill_;
	    }
	
	    this.fill_ = !!bool;
	
	    if (bool) {
	      this.addClass('vjs-fill');
	      this.fluid(false);
	    } else {
	      this.removeClass('vjs-fill');
	    }
	  }
	  /**
	   * Get/Set the aspect ratio
	   *
	   * @param {string} [ratio]
	   *        Aspect ratio for player
	   *
	   * @return {string|undefined}
	   *         returns the current aspect ratio when getting
	   */
	
	  /**
	   * A getter/setter for the `Player`'s aspect ratio.
	   *
	   * @param {string} [ratio]
	   *        The value to set the `Player`'s aspect ratio to.
	   *
	   * @return {string|undefined}
	   *         - The current aspect ratio of the `Player` when getting.
	   *         - undefined when setting
	   */
	  ;
	
	  _proto.aspectRatio = function aspectRatio(ratio) {
	    if (ratio === undefined) {
	      return this.aspectRatio_;
	    } // Check for width:height format
	
	
	    if (!/^\d+\:\d+$/.test(ratio)) {
	      throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');
	    }
	
	    this.aspectRatio_ = ratio; // We're assuming if you set an aspect ratio you want fluid mode,
	    // because in fixed mode you could calculate width and height yourself.
	
	    this.fluid(true);
	    this.updateStyleEl_();
	  }
	  /**
	   * Update styles of the `Player` element (height, width and aspect ratio).
	   *
	   * @private
	   * @listens Tech#loadedmetadata
	   */
	  ;
	
	  _proto.updateStyleEl_ = function updateStyleEl_() {
	    if (window__default['default'].VIDEOJS_NO_DYNAMIC_STYLE === true) {
	      var _width = typeof this.width_ === 'number' ? this.width_ : this.options_.width;
	
	      var _height = typeof this.height_ === 'number' ? this.height_ : this.options_.height;
	
	      var techEl = this.tech_ && this.tech_.el();
	
	      if (techEl) {
	        if (_width >= 0) {
	          techEl.width = _width;
	        }
	
	        if (_height >= 0) {
	          techEl.height = _height;
	        }
	      }
	
	      return;
	    }
	
	    var width;
	    var height;
	    var aspectRatio;
	    var idClass; // The aspect ratio is either used directly or to calculate width and height.
	
	    if (this.aspectRatio_ !== undefined && this.aspectRatio_ !== 'auto') {
	      // Use any aspectRatio that's been specifically set
	      aspectRatio = this.aspectRatio_;
	    } else if (this.videoWidth() > 0) {
	      // Otherwise try to get the aspect ratio from the video metadata
	      aspectRatio = this.videoWidth() + ':' + this.videoHeight();
	    } else {
	      // Or use a default. The video element's is 2:1, but 16:9 is more common.
	      aspectRatio = '16:9';
	    } // Get the ratio as a decimal we can use to calculate dimensions
	
	
	    var ratioParts = aspectRatio.split(':');
	    var ratioMultiplier = ratioParts[1] / ratioParts[0];
	
	    if (this.width_ !== undefined) {
	      // Use any width that's been specifically set
	      width = this.width_;
	    } else if (this.height_ !== undefined) {
	      // Or calulate the width from the aspect ratio if a height has been set
	      width = this.height_ / ratioMultiplier;
	    } else {
	      // Or use the video's metadata, or use the video el's default of 300
	      width = this.videoWidth() || 300;
	    }
	
	    if (this.height_ !== undefined) {
	      // Use any height that's been specifically set
	      height = this.height_;
	    } else {
	      // Otherwise calculate the height from the ratio and the width
	      height = width * ratioMultiplier;
	    } // Ensure the CSS class is valid by starting with an alpha character
	
	
	    if (/^[^a-zA-Z]/.test(this.id())) {
	      idClass = 'dimensions-' + this.id();
	    } else {
	      idClass = this.id() + '-dimensions';
	    } // Ensure the right class is still on the player for the style element
	
	
	    this.addClass(idClass);
	    setTextContent(this.styleEl_, "\n      ." + idClass + " {\n        width: " + width + "px;\n        height: " + height + "px;\n      }\n\n      ." + idClass + ".vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: " + ratioMultiplier * 100 + "%;\n      }\n    ");
	  }
	  /**
	   * Load/Create an instance of playback {@link Tech} including element
	   * and API methods. Then append the `Tech` element in `Player` as a child.
	   *
	   * @param {string} techName
	   *        name of the playback technology
	   *
	   * @param {string} source
	   *        video source
	   *
	   * @private
	   */
	  ;
	
	  _proto.loadTech_ = function loadTech_(techName, source) {
	    var _this4 = this;
	
	    // Pause and remove current playback technology
	    if (this.tech_) {
	      this.unloadTech_();
	    }
	
	    var titleTechName = toTitleCase$1(techName);
	    var camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1); // get rid of the HTML5 video tag as soon as we are using another tech
	
	    if (titleTechName !== 'Html5' && this.tag) {
	      Tech.getTech('Html5').disposeMediaElement(this.tag);
	      this.tag.player = null;
	      this.tag = null;
	    }
	
	    this.techName_ = titleTechName; // Turn off API access because we're loading a new tech that might load asynchronously
	
	    this.isReady_ = false;
	    var autoplay = this.autoplay(); // if autoplay is a string (or `true` with normalizeAutoplay: true) we pass false to the tech
	    // because the player is going to handle autoplay on `loadstart`
	
	    if (typeof this.autoplay() === 'string' || this.autoplay() === true && this.options_.normalizeAutoplay) {
	      autoplay = false;
	    } // Grab tech-specific options from player options and add source and parent element to use.
	
	
	    var techOptions = {
	      source: source,
	      autoplay: autoplay,
	      'nativeControlsForTouch': this.options_.nativeControlsForTouch,
	      'playerId': this.id(),
	      'techId': this.id() + "_" + camelTechName + "_api",
	      'playsinline': this.options_.playsinline,
	      'preload': this.options_.preload,
	      'loop': this.options_.loop,
	      'disablePictureInPicture': this.options_.disablePictureInPicture,
	      'muted': this.options_.muted,
	      'poster': this.poster(),
	      'language': this.language(),
	      'playerElIngest': this.playerElIngest_ || false,
	      'vtt.js': this.options_['vtt.js'],
	      'canOverridePoster': !!this.options_.techCanOverridePoster,
	      'enableSourceset': this.options_.enableSourceset,
	      'Promise': this.options_.Promise
	    };
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	      techOptions[props.getterName] = _this4[props.privateName];
	    });
	    assign(techOptions, this.options_[titleTechName]);
	    assign(techOptions, this.options_[camelTechName]);
	    assign(techOptions, this.options_[techName.toLowerCase()]);
	
	    if (this.tag) {
	      techOptions.tag = this.tag;
	    }
	
	    if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) {
	      techOptions.startTime = this.cache_.currentTime;
	    } // Initialize tech instance
	
	
	    var TechClass = Tech.getTech(techName);
	
	    if (!TechClass) {
	      throw new Error("No Tech named '" + titleTechName + "' exists! '" + titleTechName + "' should be registered using videojs.registerTech()'");
	    }
	
	    this.tech_ = new TechClass(techOptions); // player.triggerReady is always async, so don't need this to be async
	
	    this.tech_.ready(bind(this, this.handleTechReady_), true);
	    textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_); // Listen to all HTML5-defined events and trigger them on the player
	
	    TECH_EVENTS_RETRIGGER.forEach(function (event) {
	      _this4.on(_this4.tech_, event, function (e) {
	        return _this4["handleTech" + toTitleCase$1(event) + "_"](e);
	      });
	    });
	    Object.keys(TECH_EVENTS_QUEUE).forEach(function (event) {
	      _this4.on(_this4.tech_, event, function (eventObj) {
	        if (_this4.tech_.playbackRate() === 0 && _this4.tech_.seeking()) {
	          _this4.queuedCallbacks_.push({
	            callback: _this4["handleTech" + TECH_EVENTS_QUEUE[event] + "_"].bind(_this4),
	            event: eventObj
	          });
	
	          return;
	        }
	
	        _this4["handleTech" + TECH_EVENTS_QUEUE[event] + "_"](eventObj);
	      });
	    });
	    this.on(this.tech_, 'loadstart', function (e) {
	      return _this4.handleTechLoadStart_(e);
	    });
	    this.on(this.tech_, 'sourceset', function (e) {
	      return _this4.handleTechSourceset_(e);
	    });
	    this.on(this.tech_, 'waiting', function (e) {
	      return _this4.handleTechWaiting_(e);
	    });
	    this.on(this.tech_, 'ended', function (e) {
	      return _this4.handleTechEnded_(e);
	    });
	    this.on(this.tech_, 'seeking', function (e) {
	      return _this4.handleTechSeeking_(e);
	    });
	    this.on(this.tech_, 'play', function (e) {
	      return _this4.handleTechPlay_(e);
	    });
	    this.on(this.tech_, 'firstplay', function (e) {
	      return _this4.handleTechFirstPlay_(e);
	    });
	    this.on(this.tech_, 'pause', function (e) {
	      return _this4.handleTechPause_(e);
	    });
	    this.on(this.tech_, 'durationchange', function (e) {
	      return _this4.handleTechDurationChange_(e);
	    });
	    this.on(this.tech_, 'fullscreenchange', function (e, data) {
	      return _this4.handleTechFullscreenChange_(e, data);
	    });
	    this.on(this.tech_, 'fullscreenerror', function (e, err) {
	      return _this4.handleTechFullscreenError_(e, err);
	    });
	    this.on(this.tech_, 'enterpictureinpicture', function (e) {
	      return _this4.handleTechEnterPictureInPicture_(e);
	    });
	    this.on(this.tech_, 'leavepictureinpicture', function (e) {
	      return _this4.handleTechLeavePictureInPicture_(e);
	    });
	    this.on(this.tech_, 'error', function (e) {
	      return _this4.handleTechError_(e);
	    });
	    this.on(this.tech_, 'posterchange', function (e) {
	      return _this4.handleTechPosterChange_(e);
	    });
	    this.on(this.tech_, 'textdata', function (e) {
	      return _this4.handleTechTextData_(e);
	    });
	    this.on(this.tech_, 'ratechange', function (e) {
	      return _this4.handleTechRateChange_(e);
	    });
	    this.on(this.tech_, 'loadedmetadata', this.boundUpdateStyleEl_);
	    this.usingNativeControls(this.techGet_('controls'));
	
	    if (this.controls() && !this.usingNativeControls()) {
	      this.addTechControlsListeners_();
	    } // Add the tech element in the DOM if it was not already there
	    // Make sure to not insert the original video element if using Html5
	
	
	    if (this.tech_.el().parentNode !== this.el() && (titleTechName !== 'Html5' || !this.tag)) {
	      prependTo(this.tech_.el(), this.el());
	    } // Get rid of the original video tag reference after the first tech is loaded
	
	
	    if (this.tag) {
	      this.tag.player = null;
	      this.tag = null;
	    }
	  }
	  /**
	   * Unload and dispose of the current playback {@link Tech}.
	   *
	   * @private
	   */
	  ;
	
	  _proto.unloadTech_ = function unloadTech_() {
	    var _this5 = this;
	
	    // Save the current text tracks so that we can reuse the same text tracks with the next tech
	    ALL.names.forEach(function (name) {
	      var props = ALL[name];
	      _this5[props.privateName] = _this5[props.getterName]();
	    });
	    this.textTracksJson_ = textTrackConverter.textTracksToJson(this.tech_);
	    this.isReady_ = false;
	    this.tech_.dispose();
	    this.tech_ = false;
	
	    if (this.isPosterFromTech_) {
	      this.poster_ = '';
	      this.trigger('posterchange');
	    }
	
	    this.isPosterFromTech_ = false;
	  }
	  /**
	   * Return a reference to the current {@link Tech}.
	   * It will print a warning by default about the danger of using the tech directly
	   * but any argument that is passed in will silence the warning.
	   *
	   * @param {*} [safety]
	   *        Anything passed in to silence the warning
	   *
	   * @return {Tech}
	   *         The Tech
	   */
	  ;
	
	  _proto.tech = function tech(safety) {
	    if (safety === undefined) {
	      log$1.warn('Using the tech directly can be dangerous. I hope you know what you\'re doing.\n' + 'See https://github.com/videojs/video.js/issues/2617 for more info.\n');
	    }
	
	    return this.tech_;
	  }
	  /**
	   * Set up click and touch listeners for the playback element
	   *
	   * - On desktops: a click on the video itself will toggle playback
	   * - On mobile devices: a click on the video toggles controls
	   *   which is done by toggling the user state between active and
	   *   inactive
	   * - A tap can signal that a user has become active or has become inactive
	   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
	   *   quick tap should hide them again (signaling the user is in an inactive
	   *   viewing state)
	   * - In addition to this, we still want the user to be considered inactive after
	   *   a few seconds of inactivity.
	   *
	   * > Note: the only part of iOS interaction we can't mimic with this setup
	   * is a touch and hold on the video element counting as activity in order to
	   * keep the controls showing, but that shouldn't be an issue. A touch and hold
	   * on any controls will still keep the user active
	   *
	   * @private
	   */
	  ;
	
	  _proto.addTechControlsListeners_ = function addTechControlsListeners_() {
	    // Make sure to remove all the previous listeners in case we are called multiple times.
	    this.removeTechControlsListeners_();
	    this.on(this.tech_, 'click', this.boundHandleTechClick_);
	    this.on(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_); // If the controls were hidden we don't want that to change without a tap event
	    // so we'll check if the controls were already showing before reporting user
	    // activity
	
	    this.on(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
	    this.on(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
	    this.on(this.tech_, 'touchend', this.boundHandleTechTouchEnd_); // The tap listener needs to come after the touchend listener because the tap
	    // listener cancels out any reportedUserActivity when setting userActive(false)
	
	    this.on(this.tech_, 'tap', this.boundHandleTechTap_);
	  }
	  /**
	   * Remove the listeners used for click and tap controls. This is needed for
	   * toggling to controls disabled, where a tap/touch should do nothing.
	   *
	   * @private
	   */
	  ;
	
	  _proto.removeTechControlsListeners_ = function removeTechControlsListeners_() {
	    // We don't want to just use `this.off()` because there might be other needed
	    // listeners added by techs that extend this.
	    this.off(this.tech_, 'tap', this.boundHandleTechTap_);
	    this.off(this.tech_, 'touchstart', this.boundHandleTechTouchStart_);
	    this.off(this.tech_, 'touchmove', this.boundHandleTechTouchMove_);
	    this.off(this.tech_, 'touchend', this.boundHandleTechTouchEnd_);
	    this.off(this.tech_, 'click', this.boundHandleTechClick_);
	    this.off(this.tech_, 'dblclick', this.boundHandleTechDoubleClick_);
	  }
	  /**
	   * Player waits for the tech to be ready
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleTechReady_ = function handleTechReady_() {
	    this.triggerReady(); // Keep the same volume as before
	
	    if (this.cache_.volume) {
	      this.techCall_('setVolume', this.cache_.volume);
	    } // Look if the tech found a higher resolution poster while loading
	
	
	    this.handleTechPosterChange_(); // Update the duration if available
	
	    this.handleTechDurationChange_();
	  }
	  /**
	   * Retrigger the `loadstart` event that was triggered by the {@link Tech}. This
	   * function will also trigger {@link Player#firstplay} if it is the first loadstart
	   * for a video.
	   *
	   * @fires Player#loadstart
	   * @fires Player#firstplay
	   * @listens Tech#loadstart
	   * @private
	   */
	  ;
	
	  _proto.handleTechLoadStart_ = function handleTechLoadStart_() {
	    // TODO: Update to use `emptied` event instead. See #1277.
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-seeking'); // reset the error state
	
	    this.error(null); // Update the duration
	
	    this.handleTechDurationChange_(); // If it's already playing we want to trigger a firstplay event now.
	    // The firstplay event relies on both the play and loadstart events
	    // which can happen in any order for a new source
	
	    if (!this.paused()) {
	      /**
	       * Fired when the user agent begins looking for media data
	       *
	       * @event Player#loadstart
	       * @type {EventTarget~Event}
	       */
	      this.trigger('loadstart');
	      this.trigger('firstplay');
	    } else {
	      // reset the hasStarted state
	      this.hasStarted(false);
	      this.trigger('loadstart');
	    } // autoplay happens after loadstart for the browser,
	    // so we mimic that behavior
	
	
	    this.manualAutoplay_(this.autoplay() === true && this.options_.normalizeAutoplay ? 'play' : this.autoplay());
	  }
	  /**
	   * Handle autoplay string values, rather than the typical boolean
	   * values that should be handled by the tech. Note that this is not
	   * part of any specification. Valid values and what they do can be
	   * found on the autoplay getter at Player#autoplay()
	   */
	  ;
	
	  _proto.manualAutoplay_ = function manualAutoplay_(type) {
	    var _this6 = this;
	
	    if (!this.tech_ || typeof type !== 'string') {
	      return;
	    } // Save original muted() value, set muted to true, and attempt to play().
	    // On promise rejection, restore muted from saved value
	
	
	    var resolveMuted = function resolveMuted() {
	      var previouslyMuted = _this6.muted();
	
	      _this6.muted(true);
	
	      var restoreMuted = function restoreMuted() {
	        _this6.muted(previouslyMuted);
	      }; // restore muted on play terminatation
	
	
	      _this6.playTerminatedQueue_.push(restoreMuted);
	
	      var mutedPromise = _this6.play();
	
	      if (!isPromise(mutedPromise)) {
	        return;
	      }
	
	      return mutedPromise["catch"](function (err) {
	        restoreMuted();
	        throw new Error("Rejection at manualAutoplay. Restoring muted value. " + (err ? err : ''));
	      });
	    };
	
	    var promise; // if muted defaults to true
	    // the only thing we can do is call play
	
	    if (type === 'any' && !this.muted()) {
	      promise = this.play();
	
	      if (isPromise(promise)) {
	        promise = promise["catch"](resolveMuted);
	      }
	    } else if (type === 'muted' && !this.muted()) {
	      promise = resolveMuted();
	    } else {
	      promise = this.play();
	    }
	
	    if (!isPromise(promise)) {
	      return;
	    }
	
	    return promise.then(function () {
	      _this6.trigger({
	        type: 'autoplay-success',
	        autoplay: type
	      });
	    })["catch"](function () {
	      _this6.trigger({
	        type: 'autoplay-failure',
	        autoplay: type
	      });
	    });
	  }
	  /**
	   * Update the internal source caches so that we return the correct source from
	   * `src()`, `currentSource()`, and `currentSources()`.
	   *
	   * > Note: `currentSources` will not be updated if the source that is passed in exists
	   *         in the current `currentSources` cache.
	   *
	   *
	   * @param {Tech~SourceObject} srcObj
	   *        A string or object source to update our caches to.
	   */
	  ;
	
	  _proto.updateSourceCaches_ = function updateSourceCaches_(srcObj) {
	    if (srcObj === void 0) {
	      srcObj = '';
	    }
	
	    var src = srcObj;
	    var type = '';
	
	    if (typeof src !== 'string') {
	      src = srcObj.src;
	      type = srcObj.type;
	    } // make sure all the caches are set to default values
	    // to prevent null checking
	
	
	    this.cache_.source = this.cache_.source || {};
	    this.cache_.sources = this.cache_.sources || []; // try to get the type of the src that was passed in
	
	    if (src && !type) {
	      type = findMimetype(this, src);
	    } // update `currentSource` cache always
	
	
	    this.cache_.source = mergeOptions$3({}, srcObj, {
	      src: src,
	      type: type
	    });
	    var matchingSources = this.cache_.sources.filter(function (s) {
	      return s.src && s.src === src;
	    });
	    var sourceElSources = [];
	    var sourceEls = this.$$('source');
	    var matchingSourceEls = [];
	
	    for (var i = 0; i < sourceEls.length; i++) {
	      var sourceObj = getAttributes(sourceEls[i]);
	      sourceElSources.push(sourceObj);
	
	      if (sourceObj.src && sourceObj.src === src) {
	        matchingSourceEls.push(sourceObj.src);
	      }
	    } // if we have matching source els but not matching sources
	    // the current source cache is not up to date
	
	
	    if (matchingSourceEls.length && !matchingSources.length) {
	      this.cache_.sources = sourceElSources; // if we don't have matching source or source els set the
	      // sources cache to the `currentSource` cache
	    } else if (!matchingSources.length) {
	      this.cache_.sources = [this.cache_.source];
	    } // update the tech `src` cache
	
	
	    this.cache_.src = src;
	  }
	  /**
	   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
	   * causing the media element to reload.
	   *
	   * It will fire for the initial source and each subsequent source.
	   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
	   *
	   * The event object for this event contains a `src` property that will contain the source
	   * that was available when the event was triggered. This is generally only necessary if Video.js
	   * is switching techs while the source was being changed.
	   *
	   * It is also fired when `load` is called on the player (or media element)
	   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
	   * says that the resource selection algorithm needs to be aborted and restarted.
	   * In this case, it is very likely that the `src` property will be set to the
	   * empty string `""` to indicate we do not know what the source will be but
	   * that it is changing.
	   *
	   * *This event is currently still experimental and may change in minor releases.*
	   * __To use this, pass `enableSourceset` option to the player.__
	   *
	   * @event Player#sourceset
	   * @type {EventTarget~Event}
	   * @prop {string} src
	   *                The source url available when the `sourceset` was triggered.
	   *                It will be an empty string if we cannot know what the source is
	   *                but know that the source will change.
	   */
	
	  /**
	   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#sourceset
	   * @listens Tech#sourceset
	   * @private
	   */
	  ;
	
	  _proto.handleTechSourceset_ = function handleTechSourceset_(event) {
	    var _this7 = this;
	
	    // only update the source cache when the source
	    // was not updated using the player api
	    if (!this.changingSrc_) {
	      var updateSourceCaches = function updateSourceCaches(src) {
	        return _this7.updateSourceCaches_(src);
	      };
	
	      var playerSrc = this.currentSource().src;
	      var eventSrc = event.src; // if we have a playerSrc that is not a blob, and a tech src that is a blob
	
	      if (playerSrc && !/^blob:/.test(playerSrc) && /^blob:/.test(eventSrc)) {
	        // if both the tech source and the player source were updated we assume
	        // something like @videojs/http-streaming did the sourceset and skip updating the source cache.
	        if (!this.lastSource_ || this.lastSource_.tech !== eventSrc && this.lastSource_.player !== playerSrc) {
	          updateSourceCaches = function updateSourceCaches() {};
	        }
	      } // update the source to the initial source right away
	      // in some cases this will be empty string
	
	
	      updateSourceCaches(eventSrc); // if the `sourceset` `src` was an empty string
	      // wait for a `loadstart` to update the cache to `currentSrc`.
	      // If a sourceset happens before a `loadstart`, we reset the state
	
	      if (!event.src) {
	        this.tech_.any(['sourceset', 'loadstart'], function (e) {
	          // if a sourceset happens before a `loadstart` there
	          // is nothing to do as this `handleTechSourceset_`
	          // will be called again and this will be handled there.
	          if (e.type === 'sourceset') {
	            return;
	          }
	
	          var techSrc = _this7.techGet('currentSrc');
	
	          _this7.lastSource_.tech = techSrc;
	
	          _this7.updateSourceCaches_(techSrc);
	        });
	      }
	    }
	
	    this.lastSource_ = {
	      player: this.currentSource().src,
	      tech: event.src
	    };
	    this.trigger({
	      src: event.src,
	      type: 'sourceset'
	    });
	  }
	  /**
	   * Add/remove the vjs-has-started class
	   *
	   * @fires Player#firstplay
	   *
	   * @param {boolean} request
	   *        - true: adds the class
	   *        - false: remove the class
	   *
	   * @return {boolean}
	   *         the boolean value of hasStarted_
	   */
	  ;
	
	  _proto.hasStarted = function hasStarted(request) {
	    if (request === undefined) {
	      // act as getter, if we have no request to change
	      return this.hasStarted_;
	    }
	
	    if (request === this.hasStarted_) {
	      return;
	    }
	
	    this.hasStarted_ = request;
	
	    if (this.hasStarted_) {
	      this.addClass('vjs-has-started');
	      this.trigger('firstplay');
	    } else {
	      this.removeClass('vjs-has-started');
	    }
	  }
	  /**
	   * Fired whenever the media begins or resumes playback
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
	   * @fires Player#play
	   * @listens Tech#play
	   * @private
	   */
	  ;
	
	  _proto.handleTechPlay_ = function handleTechPlay_() {
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing'); // hide the poster when the user hits play
	
	    this.hasStarted(true);
	    /**
	     * Triggered whenever an {@link Tech#play} event happens. Indicates that
	     * playback has started or resumed.
	     *
	     * @event Player#play
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('play');
	  }
	  /**
	   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
	   *
	   * If there were any events queued while the playback rate was zero, fire
	   * those events now.
	   *
	   * @private
	   * @method Player#handleTechRateChange_
	   * @fires Player#ratechange
	   * @listens Tech#ratechange
	   */
	  ;
	
	  _proto.handleTechRateChange_ = function handleTechRateChange_() {
	    if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
	      this.queuedCallbacks_.forEach(function (queued) {
	        return queued.callback(queued.event);
	      });
	      this.queuedCallbacks_ = [];
	    }
	
	    this.cache_.lastPlaybackRate = this.tech_.playbackRate();
	    /**
	     * Fires when the playing speed of the audio/video is changed
	     *
	     * @event Player#ratechange
	     * @type {event}
	     */
	
	    this.trigger('ratechange');
	  }
	  /**
	   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#waiting
	   * @listens Tech#waiting
	   * @private
	   */
	  ;
	
	  _proto.handleTechWaiting_ = function handleTechWaiting_() {
	    var _this8 = this;
	
	    this.addClass('vjs-waiting');
	    /**
	     * A readyState change on the DOM element has caused playback to stop.
	     *
	     * @event Player#waiting
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('waiting'); // Browsers may emit a timeupdate event after a waiting event. In order to prevent
	    // premature removal of the waiting class, wait for the time to change.
	
	    var timeWhenWaiting = this.currentTime();
	
	    var timeUpdateListener = function timeUpdateListener() {
	      if (timeWhenWaiting !== _this8.currentTime()) {
	        _this8.removeClass('vjs-waiting');
	
	        _this8.off('timeupdate', timeUpdateListener);
	      }
	    };
	
	    this.on('timeupdate', timeUpdateListener);
	  }
	  /**
	   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
	   * > Note: This is not consistent between browsers. See #1351
	   *
	   * @fires Player#canplay
	   * @listens Tech#canplay
	   * @private
	   */
	  ;
	
	  _proto.handleTechCanPlay_ = function handleTechCanPlay_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_FUTURE_DATA or greater.
	     *
	     * @event Player#canplay
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('canplay');
	  }
	  /**
	   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#canplaythrough
	   * @listens Tech#canplaythrough
	   * @private
	   */
	  ;
	
	  _proto.handleTechCanPlayThrough_ = function handleTechCanPlayThrough_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
	     * entire media file can be played without buffering.
	     *
	     * @event Player#canplaythrough
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('canplaythrough');
	  }
	  /**
	   * Retrigger the `playing` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#playing
	   * @listens Tech#playing
	   * @private
	   */
	  ;
	
	  _proto.handleTechPlaying_ = function handleTechPlaying_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media is no longer blocked from playback, and has started playing.
	     *
	     * @event Player#playing
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('playing');
	  }
	  /**
	   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeking
	   * @listens Tech#seeking
	   * @private
	   */
	  ;
	
	  _proto.handleTechSeeking_ = function handleTechSeeking_() {
	    this.addClass('vjs-seeking');
	    /**
	     * Fired whenever the player is jumping to a new time
	     *
	     * @event Player#seeking
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('seeking');
	  }
	  /**
	   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeked
	   * @listens Tech#seeked
	   * @private
	   */
	  ;
	
	  _proto.handleTechSeeked_ = function handleTechSeeked_() {
	    this.removeClass('vjs-seeking');
	    this.removeClass('vjs-ended');
	    /**
	     * Fired when the player has finished jumping to a new time
	     *
	     * @event Player#seeked
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('seeked');
	  }
	  /**
	   * Retrigger the `firstplay` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#firstplay
	   * @listens Tech#firstplay
	   * @deprecated As of 6.0 firstplay event is deprecated.
	   *             As of 6.0 passing the `starttime` option to the player and the firstplay event are deprecated.
	   * @private
	   */
	  ;
	
	  _proto.handleTechFirstPlay_ = function handleTechFirstPlay_() {
	    // If the first starttime attribute is specified
	    // then we will start at the given offset in seconds
	    if (this.options_.starttime) {
	      log$1.warn('Passing the `starttime` option to the player will be deprecated in 6.0');
	      this.currentTime(this.options_.starttime);
	    }
	
	    this.addClass('vjs-has-started');
	    /**
	     * Fired the first time a video is played. Not part of the HLS spec, and this is
	     * probably not the best implementation yet, so use sparingly. If you don't have a
	     * reason to prevent playback, use `myPlayer.one('play');` instead.
	     *
	     * @event Player#firstplay
	     * @deprecated As of 6.0 firstplay event is deprecated.
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('firstplay');
	  }
	  /**
	   * Retrigger the `pause` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#pause
	   * @listens Tech#pause
	   * @private
	   */
	  ;
	
	  _proto.handleTechPause_ = function handleTechPause_() {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused');
	    /**
	     * Fired whenever the media has been paused
	     *
	     * @event Player#pause
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('pause');
	  }
	  /**
	   * Retrigger the `ended` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#ended
	   * @listens Tech#ended
	   * @private
	   */
	  ;
	
	  _proto.handleTechEnded_ = function handleTechEnded_() {
	    this.addClass('vjs-ended');
	    this.removeClass('vjs-waiting');
	
	    if (this.options_.loop) {
	      this.currentTime(0);
	      this.play();
	    } else if (!this.paused()) {
	      this.pause();
	    }
	    /**
	     * Fired when the end of the media resource is reached (currentTime == duration)
	     *
	     * @event Player#ended
	     * @type {EventTarget~Event}
	     */
	
	
	    this.trigger('ended');
	  }
	  /**
	   * Fired when the duration of the media resource is first known or changed
	   *
	   * @listens Tech#durationchange
	   * @private
	   */
	  ;
	
	  _proto.handleTechDurationChange_ = function handleTechDurationChange_() {
	    this.duration(this.techGet_('duration'));
	  }
	  /**
	   * Handle a click on the media element to play/pause
	   *
	   * @param {EventTarget~Event} event
	   *        the event that caused this function to trigger
	   *
	   * @listens Tech#click
	   * @private
	   */
	  ;
	
	  _proto.handleTechClick_ = function handleTechClick_(event) {
	    // When controls are disabled a click should not toggle playback because
	    // the click is considered a control
	    if (!this.controls_) {
	      return;
	    }
	
	    if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.click === undefined || this.options_.userActions.click !== false) {
	      if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.click === 'function') {
	        this.options_.userActions.click.call(this, event);
	      } else if (this.paused()) {
	        silencePromise(this.play());
	      } else {
	        this.pause();
	      }
	    }
	  }
	  /**
	   * Handle a double-click on the media element to enter/exit fullscreen
	   *
	   * @param {EventTarget~Event} event
	   *        the event that caused this function to trigger
	   *
	   * @listens Tech#dblclick
	   * @private
	   */
	  ;
	
	  _proto.handleTechDoubleClick_ = function handleTechDoubleClick_(event) {
	    if (!this.controls_) {
	      return;
	    } // we do not want to toggle fullscreen state
	    // when double-clicking inside a control bar or a modal
	
	
	    var inAllowedEls = Array.prototype.some.call(this.$$('.vjs-control-bar, .vjs-modal-dialog'), function (el) {
	      return el.contains(event.target);
	    });
	
	    if (!inAllowedEls) {
	      /*
	       * options.userActions.doubleClick
	       *
	       * If `undefined` or `true`, double-click toggles fullscreen if controls are present
	       * Set to `false` to disable double-click handling
	       * Set to a function to substitute an external double-click handler
	       */
	      if (this.options_ === undefined || this.options_.userActions === undefined || this.options_.userActions.doubleClick === undefined || this.options_.userActions.doubleClick !== false) {
	        if (this.options_ !== undefined && this.options_.userActions !== undefined && typeof this.options_.userActions.doubleClick === 'function') {
	          this.options_.userActions.doubleClick.call(this, event);
	        } else if (this.isFullscreen()) {
	          this.exitFullscreen();
	        } else {
	          this.requestFullscreen();
	        }
	      }
	    }
	  }
	  /**
	   * Handle a tap on the media element. It will toggle the user
	   * activity state, which hides and shows the controls.
	   *
	   * @listens Tech#tap
	   * @private
	   */
	  ;
	
	  _proto.handleTechTap_ = function handleTechTap_() {
	    this.userActive(!this.userActive());
	  }
	  /**
	   * Handle touch to start
	   *
	   * @listens Tech#touchstart
	   * @private
	   */
	  ;
	
	  _proto.handleTechTouchStart_ = function handleTechTouchStart_() {
	    this.userWasActive = this.userActive();
	  }
	  /**
	   * Handle touch to move
	   *
	   * @listens Tech#touchmove
	   * @private
	   */
	  ;
	
	  _proto.handleTechTouchMove_ = function handleTechTouchMove_() {
	    if (this.userWasActive) {
	      this.reportUserActivity();
	    }
	  }
	  /**
	   * Handle touch to end
	   *
	   * @param {EventTarget~Event} event
	   *        the touchend event that triggered
	   *        this function
	   *
	   * @listens Tech#touchend
	   * @private
	   */
	  ;
	
	  _proto.handleTechTouchEnd_ = function handleTechTouchEnd_(event) {
	    // Stop the mouse events from also happening
	    if (event.cancelable) {
	      event.preventDefault();
	    }
	  }
	  /**
	   * native click events on the SWF aren't triggered on IE11, Win8.1RT
	   * use stageclick events triggered from inside the SWF instead
	   *
	   * @private
	   * @listens stageclick
	   */
	  ;
	
	  _proto.handleStageClick_ = function handleStageClick_() {
	    this.reportUserActivity();
	  }
	  /**
	   * @private
	   */
	  ;
	
	  _proto.toggleFullscreenClass_ = function toggleFullscreenClass_() {
	    if (this.isFullscreen()) {
	      this.addClass('vjs-fullscreen');
	    } else {
	      this.removeClass('vjs-fullscreen');
	    }
	  }
	  /**
	   * when the document fschange event triggers it calls this
	   */
	  ;
	
	  _proto.documentFullscreenChange_ = function documentFullscreenChange_(e) {
	    var targetPlayer = e.target.player; // if another player was fullscreen
	    // do a null check for targetPlayer because older firefox's would put document as e.target
	
	    if (targetPlayer && targetPlayer !== this) {
	      return;
	    }
	
	    var el = this.el();
	    var isFs = document__default['default'][this.fsApi_.fullscreenElement] === el;
	
	    if (!isFs && el.matches) {
	      isFs = el.matches(':' + this.fsApi_.fullscreen);
	    } else if (!isFs && el.msMatchesSelector) {
	      isFs = el.msMatchesSelector(':' + this.fsApi_.fullscreen);
	    }
	
	    this.isFullscreen(isFs);
	  }
	  /**
	   * Handle Tech Fullscreen Change
	   *
	   * @param {EventTarget~Event} event
	   *        the fullscreenchange event that triggered this function
	   *
	   * @param {Object} data
	   *        the data that was sent with the event
	   *
	   * @private
	   * @listens Tech#fullscreenchange
	   * @fires Player#fullscreenchange
	   */
	  ;
	
	  _proto.handleTechFullscreenChange_ = function handleTechFullscreenChange_(event, data) {
	    var _this9 = this;
	
	    if (data) {
	      if (data.nativeIOSFullscreen) {
	        this.addClass('vjs-ios-native-fs');
	        this.tech_.one('webkitendfullscreen', function () {
	          _this9.removeClass('vjs-ios-native-fs');
	        });
	      }
	
	      this.isFullscreen(data.isFullscreen);
	    }
	  };
	
	  _proto.handleTechFullscreenError_ = function handleTechFullscreenError_(event, err) {
	    this.trigger('fullscreenerror', err);
	  }
	  /**
	   * @private
	   */
	  ;
	
	  _proto.togglePictureInPictureClass_ = function togglePictureInPictureClass_() {
	    if (this.isInPictureInPicture()) {
	      this.addClass('vjs-picture-in-picture');
	    } else {
	      this.removeClass('vjs-picture-in-picture');
	    }
	  }
	  /**
	   * Handle Tech Enter Picture-in-Picture.
	   *
	   * @param {EventTarget~Event} event
	   *        the enterpictureinpicture event that triggered this function
	   *
	   * @private
	   * @listens Tech#enterpictureinpicture
	   */
	  ;
	
	  _proto.handleTechEnterPictureInPicture_ = function handleTechEnterPictureInPicture_(event) {
	    this.isInPictureInPicture(true);
	  }
	  /**
	   * Handle Tech Leave Picture-in-Picture.
	   *
	   * @param {EventTarget~Event} event
	   *        the leavepictureinpicture event that triggered this function
	   *
	   * @private
	   * @listens Tech#leavepictureinpicture
	   */
	  ;
	
	  _proto.handleTechLeavePictureInPicture_ = function handleTechLeavePictureInPicture_(event) {
	    this.isInPictureInPicture(false);
	  }
	  /**
	   * Fires when an error occurred during the loading of an audio/video.
	   *
	   * @private
	   * @listens Tech#error
	   */
	  ;
	
	  _proto.handleTechError_ = function handleTechError_() {
	    var error = this.tech_.error();
	    this.error(error);
	  }
	  /**
	   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#textdata
	   * @listens Tech#textdata
	   * @private
	   */
	  ;
	
	  _proto.handleTechTextData_ = function handleTechTextData_() {
	    var data = null;
	
	    if (arguments.length > 1) {
	      data = arguments[1];
	    }
	    /**
	     * Fires when we get a textdata event from tech
	     *
	     * @event Player#textdata
	     * @type {EventTarget~Event}
	     */
	
	
	    this.trigger('textdata', data);
	  }
	  /**
	   * Get object for cached values.
	   *
	   * @return {Object}
	   *         get the current object cache
	   */
	  ;
	
	  _proto.getCache = function getCache() {
	    return this.cache_;
	  }
	  /**
	   * Resets the internal cache object.
	   *
	   * Using this function outside the player constructor or reset method may
	   * have unintended side-effects.
	   *
	   * @private
	   */
	  ;
	
	  _proto.resetCache_ = function resetCache_() {
	    this.cache_ = {
	      // Right now, the currentTime is not _really_ cached because it is always
	      // retrieved from the tech (see: currentTime). However, for completeness,
	      // we set it to zero here to ensure that if we do start actually caching
	      // it, we reset it along with everything else.
	      currentTime: 0,
	      initTime: 0,
	      inactivityTimeout: this.options_.inactivityTimeout,
	      duration: NaN,
	      lastVolume: 1,
	      lastPlaybackRate: this.defaultPlaybackRate(),
	      media: null,
	      src: '',
	      source: {},
	      sources: [],
	      playbackRates: [],
	      volume: 1
	    };
	  }
	  /**
	   * Pass values to the playback tech
	   *
	   * @param {string} [method]
	   *        the method to call
	   *
	   * @param {Object} arg
	   *        the argument to pass
	   *
	   * @private
	   */
	  ;
	
	  _proto.techCall_ = function techCall_(method, arg) {
	    // If it's not ready yet, call method when it is
	    this.ready(function () {
	      if (method in allowedSetters) {
	        return set(this.middleware_, this.tech_, method, arg);
	      } else if (method in allowedMediators) {
	        return mediate(this.middleware_, this.tech_, method, arg);
	      }
	
	      try {
	        if (this.tech_) {
	          this.tech_[method](arg);
	        }
	      } catch (e) {
	        log$1(e);
	        throw e;
	      }
	    }, true);
	  }
	  /**
	   * Get calls can't wait for the tech, and sometimes don't need to.
	   *
	   * @param {string} method
	   *        Tech method
	   *
	   * @return {Function|undefined}
	   *         the method or undefined
	   *
	   * @private
	   */
	  ;
	
	  _proto.techGet_ = function techGet_(method) {
	    if (!this.tech_ || !this.tech_.isReady_) {
	      return;
	    }
	
	    if (method in allowedGetters) {
	      return get(this.middleware_, this.tech_, method);
	    } else if (method in allowedMediators) {
	      return mediate(this.middleware_, this.tech_, method);
	    } // Flash likes to die and reload when you hide or reposition it.
	    // In these cases the object methods go away and we get errors.
	    // TODO: Is this needed for techs other than Flash?
	    // When that happens we'll catch the errors and inform tech that it's not ready any more.
	
	
	    try {
	      return this.tech_[method]();
	    } catch (e) {
	      // When building additional tech libs, an expected method may not be defined yet
	      if (this.tech_[method] === undefined) {
	        log$1("Video.js: " + method + " method not defined for " + this.techName_ + " playback technology.", e);
	        throw e;
	      } // When a method isn't available on the object it throws a TypeError
	
	
	      if (e.name === 'TypeError') {
	        log$1("Video.js: " + method + " unavailable on " + this.techName_ + " playback technology element.", e);
	        this.tech_.isReady_ = false;
	        throw e;
	      } // If error unknown, just log and throw
	
	
	      log$1(e);
	      throw e;
	    }
	  }
	  /**
	   * Attempt to begin playback at the first opportunity.
	   *
	   * @return {Promise|undefined}
	   *         Returns a promise if the browser supports Promises (or one
	   *         was passed in as an option). This promise will be resolved on
	   *         the return value of play. If this is undefined it will fulfill the
	   *         promise chain otherwise the promise chain will be fulfilled when
	   *         the promise from play is fulfilled.
	   */
	  ;
	
	  _proto.play = function play() {
	    var _this10 = this;
	
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      return new PromiseClass(function (resolve) {
	        _this10.play_(resolve);
	      });
	    }
	
	    return this.play_();
	  }
	  /**
	   * The actual logic for play, takes a callback that will be resolved on the
	   * return value of play. This allows us to resolve to the play promise if there
	   * is one on modern browsers.
	   *
	   * @private
	   * @param {Function} [callback]
	   *        The callback that should be called when the techs play is actually called
	   */
	  ;
	
	  _proto.play_ = function play_(callback) {
	    var _this11 = this;
	
	    if (callback === void 0) {
	      callback = silencePromise;
	    }
	
	    this.playCallbacks_.push(callback);
	    var isSrcReady = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
	    var isSafariOrIOS = Boolean(IS_ANY_SAFARI || IS_IOS); // treat calls to play_ somewhat like the `one` event function
	
	    if (this.waitToPlay_) {
	      this.off(['ready', 'loadstart'], this.waitToPlay_);
	      this.waitToPlay_ = null;
	    } // if the player/tech is not ready or the src itself is not ready
	    // queue up a call to play on `ready` or `loadstart`
	
	
	    if (!this.isReady_ || !isSrcReady) {
	      this.waitToPlay_ = function (e) {
	        _this11.play_();
	      };
	
	      this.one(['ready', 'loadstart'], this.waitToPlay_); // if we are in Safari, there is a high chance that loadstart will trigger after the gesture timeperiod
	      // in that case, we need to prime the video element by calling load so it'll be ready in time
	
	      if (!isSrcReady && isSafariOrIOS) {
	        this.load();
	      }
	
	      return;
	    } // If the player/tech is ready and we have a source, we can attempt playback.
	
	
	    var val = this.techGet_('play'); // For native playback, reset the progress bar if we get a play call from a replay.
	
	    var isNativeReplay = isSafariOrIOS && this.hasClass('vjs-ended');
	
	    if (isNativeReplay) {
	      this.resetProgressBar_();
	    } // play was terminated if the returned value is null
	
	
	    if (val === null) {
	      this.runPlayTerminatedQueue_();
	    } else {
	      this.runPlayCallbacks_(val);
	    }
	  }
	  /**
	   * These functions will be run when if play is terminated. If play
	   * runPlayCallbacks_ is run these function will not be run. This allows us
	   * to differenciate between a terminated play and an actual call to play.
	   */
	  ;
	
	  _proto.runPlayTerminatedQueue_ = function runPlayTerminatedQueue_() {
	    var queue = this.playTerminatedQueue_.slice(0);
	    this.playTerminatedQueue_ = [];
	    queue.forEach(function (q) {
	      q();
	    });
	  }
	  /**
	   * When a callback to play is delayed we have to run these
	   * callbacks when play is actually called on the tech. This function
	   * runs the callbacks that were delayed and accepts the return value
	   * from the tech.
	   *
	   * @param {undefined|Promise} val
	   *        The return value from the tech.
	   */
	  ;
	
	  _proto.runPlayCallbacks_ = function runPlayCallbacks_(val) {
	    var callbacks = this.playCallbacks_.slice(0);
	    this.playCallbacks_ = []; // clear play terminatedQueue since we finished a real play
	
	    this.playTerminatedQueue_ = [];
	    callbacks.forEach(function (cb) {
	      cb(val);
	    });
	  }
	  /**
	   * Pause the video playback
	   *
	   * @return {Player}
	   *         A reference to the player object this function was called on
	   */
	  ;
	
	  _proto.pause = function pause() {
	    this.techCall_('pause');
	  }
	  /**
	   * Check if the player is paused or has yet to play
	   *
	   * @return {boolean}
	   *         - false: if the media is currently playing
	   *         - true: if media is not currently playing
	   */
	  ;
	
	  _proto.paused = function paused() {
	    // The initial state of paused should be true (in Safari it's actually false)
	    return this.techGet_('paused') === false ? false : true;
	  }
	  /**
	   * Get a TimeRange object representing the current ranges of time that the user
	   * has played.
	   *
	   * @return {TimeRange}
	   *         A time range object that represents all the increments of time that have
	   *         been played.
	   */
	  ;
	
	  _proto.played = function played() {
	    return this.techGet_('played') || createTimeRanges(0, 0);
	  }
	  /**
	   * Returns whether or not the user is "scrubbing". Scrubbing is
	   * when the user has clicked the progress bar handle and is
	   * dragging it along the progress bar.
	   *
	   * @param {boolean} [isScrubbing]
	   *        whether the user is or is not scrubbing
	   *
	   * @return {boolean}
	   *         The value of scrubbing when getting
	   */
	  ;
	
	  _proto.scrubbing = function scrubbing(isScrubbing) {
	    if (typeof isScrubbing === 'undefined') {
	      return this.scrubbing_;
	    }
	
	    this.scrubbing_ = !!isScrubbing;
	    this.techCall_('setScrubbing', this.scrubbing_);
	
	    if (isScrubbing) {
	      this.addClass('vjs-scrubbing');
	    } else {
	      this.removeClass('vjs-scrubbing');
	    }
	  }
	  /**
	   * Get or set the current time (in seconds)
	   *
	   * @param {number|string} [seconds]
	   *        The time to seek to in seconds
	   *
	   * @return {number}
	   *         - the current time in seconds when getting
	   */
	  ;
	
	  _proto.currentTime = function currentTime(seconds) {
	    if (typeof seconds !== 'undefined') {
	      if (seconds < 0) {
	        seconds = 0;
	      }
	
	      if (!this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
	        this.cache_.initTime = seconds;
	        this.off('canplay', this.boundApplyInitTime_);
	        this.one('canplay', this.boundApplyInitTime_);
	        return;
	      }
	
	      this.techCall_('setCurrentTime', seconds);
	      this.cache_.initTime = 0;
	      return;
	    } // cache last currentTime and return. default to 0 seconds
	    //
	    // Caching the currentTime is meant to prevent a massive amount of reads on the tech's
	    // currentTime when scrubbing, but may not provide much performance benefit afterall.
	    // Should be tested. Also something has to read the actual current time or the cache will
	    // never get updated.
	
	
	    this.cache_.currentTime = this.techGet_('currentTime') || 0;
	    return this.cache_.currentTime;
	  }
	  /**
	   * Apply the value of initTime stored in cache as currentTime.
	   *
	   * @private
	   */
	  ;
	
	  _proto.applyInitTime_ = function applyInitTime_() {
	    this.currentTime(this.cache_.initTime);
	  }
	  /**
	   * Normally gets the length in time of the video in seconds;
	   * in all but the rarest use cases an argument will NOT be passed to the method
	   *
	   * > **NOTE**: The video must have started loading before the duration can be
	   * known, and depending on preload behaviour may not be known until the video starts
	   * playing.
	   *
	   * @fires Player#durationchange
	   *
	   * @param {number} [seconds]
	   *        The duration of the video to set in seconds
	   *
	   * @return {number}
	   *         - The duration of the video in seconds when getting
	   */
	  ;
	
	  _proto.duration = function duration(seconds) {
	    if (seconds === undefined) {
	      // return NaN if the duration is not known
	      return this.cache_.duration !== undefined ? this.cache_.duration : NaN;
	    }
	
	    seconds = parseFloat(seconds); // Standardize on Infinity for signaling video is live
	
	    if (seconds < 0) {
	      seconds = Infinity;
	    }
	
	    if (seconds !== this.cache_.duration) {
	      // Cache the last set value for optimized scrubbing (esp. Flash)
	      // TODO: Required for techs other than Flash?
	      this.cache_.duration = seconds;
	
	      if (seconds === Infinity) {
	        this.addClass('vjs-live');
	      } else {
	        this.removeClass('vjs-live');
	      }
	
	      if (!isNaN(seconds)) {
	        // Do not fire durationchange unless the duration value is known.
	        // @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
	
	        /**
	         * @event Player#durationchange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('durationchange');
	      }
	    }
	  }
	  /**
	   * Calculates how much time is left in the video. Not part
	   * of the native video API.
	   *
	   * @return {number}
	   *         The time remaining in seconds
	   */
	  ;
	
	  _proto.remainingTime = function remainingTime() {
	    return this.duration() - this.currentTime();
	  }
	  /**
	   * A remaining time function that is intented to be used when
	   * the time is to be displayed directly to the user.
	   *
	   * @return {number}
	   *         The rounded time remaining in seconds
	   */
	  ;
	
	  _proto.remainingTimeDisplay = function remainingTimeDisplay() {
	    return Math.floor(this.duration()) - Math.floor(this.currentTime());
	  } //
	  // Kind of like an array of portions of the video that have been downloaded.
	
	  /**
	   * Get a TimeRange object with an array of the times of the video
	   * that have been downloaded. If you just want the percent of the
	   * video that's been downloaded, use bufferedPercent.
	   *
	   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
	   *
	   * @return {TimeRange}
	   *         A mock TimeRange object (following HTML spec)
	   */
	  ;
	
	  _proto.buffered = function buffered() {
	    var buffered = this.techGet_('buffered');
	
	    if (!buffered || !buffered.length) {
	      buffered = createTimeRanges(0, 0);
	    }
	
	    return buffered;
	  }
	  /**
	   * Get the percent (as a decimal) of the video that's been downloaded.
	   * This method is not a part of the native HTML video API.
	   *
	   * @return {number}
	   *         A decimal between 0 and 1 representing the percent
	   *         that is buffered 0 being 0% and 1 being 100%
	   */
	  ;
	
	  _proto.bufferedPercent = function bufferedPercent$1() {
	    return bufferedPercent(this.buffered(), this.duration());
	  }
	  /**
	   * Get the ending time of the last buffered time range
	   * This is used in the progress bar to encapsulate all time ranges.
	   *
	   * @return {number}
	   *         The end of the last buffered time range
	   */
	  ;
	
	  _proto.bufferedEnd = function bufferedEnd() {
	    var buffered = this.buffered();
	    var duration = this.duration();
	    var end = buffered.end(buffered.length - 1);
	
	    if (end > duration) {
	      end = duration;
	    }
	
	    return end;
	  }
	  /**
	   * Get or set the current volume of the media
	   *
	   * @param  {number} [percentAsDecimal]
	   *         The new volume as a decimal percent:
	   *         - 0 is muted/0%/off
	   *         - 1.0 is 100%/full
	   *         - 0.5 is half volume or 50%
	   *
	   * @return {number}
	   *         The current volume as a percent when getting
	   */
	  ;
	
	  _proto.volume = function volume(percentAsDecimal) {
	    var vol;
	
	    if (percentAsDecimal !== undefined) {
	      // Force value to between 0 and 1
	      vol = Math.max(0, Math.min(1, parseFloat(percentAsDecimal)));
	      this.cache_.volume = vol;
	      this.techCall_('setVolume', vol);
	
	      if (vol > 0) {
	        this.lastVolume_(vol);
	      }
	
	      return;
	    } // Default to 1 when returning current volume.
	
	
	    vol = parseFloat(this.techGet_('volume'));
	    return isNaN(vol) ? 1 : vol;
	  }
	  /**
	   * Get the current muted state, or turn mute on or off
	   *
	   * @param {boolean} [muted]
	   *        - true to mute
	   *        - false to unmute
	   *
	   * @return {boolean}
	   *         - true if mute is on and getting
	   *         - false if mute is off and getting
	   */
	  ;
	
	  _proto.muted = function muted(_muted) {
	    if (_muted !== undefined) {
	      this.techCall_('setMuted', _muted);
	      return;
	    }
	
	    return this.techGet_('muted') || false;
	  }
	  /**
	   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
	   * indicates the state of muted on initial playback.
	   *
	   * ```js
	   *   var myPlayer = videojs('some-player-id');
	   *
	   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
	   *
	   *   // get, should be false
	   *   console.log(myPlayer.defaultMuted());
	   *   // set to true
	   *   myPlayer.defaultMuted(true);
	   *   // get should be true
	   *   console.log(myPlayer.defaultMuted());
	   * ```
	   *
	   * @param {boolean} [defaultMuted]
	   *        - true to mute
	   *        - false to unmute
	   *
	   * @return {boolean|Player}
	   *         - true if defaultMuted is on and getting
	   *         - false if defaultMuted is off and getting
	   *         - A reference to the current player when setting
	   */
	  ;
	
	  _proto.defaultMuted = function defaultMuted(_defaultMuted) {
	    if (_defaultMuted !== undefined) {
	      return this.techCall_('setDefaultMuted', _defaultMuted);
	    }
	
	    return this.techGet_('defaultMuted') || false;
	  }
	  /**
	   * Get the last volume, or set it
	   *
	   * @param  {number} [percentAsDecimal]
	   *         The new last volume as a decimal percent:
	   *         - 0 is muted/0%/off
	   *         - 1.0 is 100%/full
	   *         - 0.5 is half volume or 50%
	   *
	   * @return {number}
	   *         the current value of lastVolume as a percent when getting
	   *
	   * @private
	   */
	  ;
	
	  _proto.lastVolume_ = function lastVolume_(percentAsDecimal) {
	    if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
	      this.cache_.lastVolume = percentAsDecimal;
	      return;
	    }
	
	    return this.cache_.lastVolume;
	  }
	  /**
	   * Check if current tech can support native fullscreen
	   * (e.g. with built in controls like iOS)
	   *
	   * @return {boolean}
	   *         if native fullscreen is supported
	   */
	  ;
	
	  _proto.supportsFullScreen = function supportsFullScreen() {
	    return this.techGet_('supportsFullScreen') || false;
	  }
	  /**
	   * Check if the player is in fullscreen mode or tell the player that it
	   * is or is not in fullscreen mode.
	   *
	   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
	   * property and instead document.fullscreenElement is used. But isFullscreen is
	   * still a valuable property for internal player workings.
	   *
	   * @param  {boolean} [isFS]
	   *         Set the players current fullscreen state
	   *
	   * @return {boolean}
	   *         - true if fullscreen is on and getting
	   *         - false if fullscreen is off and getting
	   */
	  ;
	
	  _proto.isFullscreen = function isFullscreen(isFS) {
	    if (isFS !== undefined) {
	      var oldValue = this.isFullscreen_;
	      this.isFullscreen_ = Boolean(isFS); // if we changed fullscreen state and we're in prefixed mode, trigger fullscreenchange
	      // this is the only place where we trigger fullscreenchange events for older browsers
	      // fullWindow mode is treated as a prefixed event and will get a fullscreenchange event as well
	
	      if (this.isFullscreen_ !== oldValue && this.fsApi_.prefixed) {
	        /**
	           * @event Player#fullscreenchange
	           * @type {EventTarget~Event}
	           */
	        this.trigger('fullscreenchange');
	      }
	
	      this.toggleFullscreenClass_();
	      return;
	    }
	
	    return this.isFullscreen_;
	  }
	  /**
	   * Increase the size of the video to full screen
	   * In some browsers, full screen is not supported natively, so it enters
	   * "full window mode", where the video fills the browser window.
	   * In browsers and devices that support native full screen, sometimes the
	   * browser's default controls will be shown, and not the Video.js custom skin.
	   * This includes most mobile devices (iOS, Android) and older versions of
	   * Safari.
	   *
	   * @param  {Object} [fullscreenOptions]
	   *         Override the player fullscreen options
	   *
	   * @fires Player#fullscreenchange
	   */
	  ;
	
	  _proto.requestFullscreen = function requestFullscreen(fullscreenOptions) {
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      var self = this;
	      return new PromiseClass(function (resolve, reject) {
	        function offHandler() {
	          self.off('fullscreenerror', errorHandler);
	          self.off('fullscreenchange', changeHandler);
	        }
	
	        function changeHandler() {
	          offHandler();
	          resolve();
	        }
	
	        function errorHandler(e, err) {
	          offHandler();
	          reject(err);
	        }
	
	        self.one('fullscreenchange', changeHandler);
	        self.one('fullscreenerror', errorHandler);
	        var promise = self.requestFullscreenHelper_(fullscreenOptions);
	
	        if (promise) {
	          promise.then(offHandler, offHandler);
	          promise.then(resolve, reject);
	        }
	      });
	    }
	
	    return this.requestFullscreenHelper_();
	  };
	
	  _proto.requestFullscreenHelper_ = function requestFullscreenHelper_(fullscreenOptions) {
	    var _this12 = this;
	
	    var fsOptions; // Only pass fullscreen options to requestFullscreen in spec-compliant browsers.
	    // Use defaults or player configured option unless passed directly to this method.
	
	    if (!this.fsApi_.prefixed) {
	      fsOptions = this.options_.fullscreen && this.options_.fullscreen.options || {};
	
	      if (fullscreenOptions !== undefined) {
	        fsOptions = fullscreenOptions;
	      }
	    } // This method works as follows:
	    // 1. if a fullscreen api is available, use it
	    //   1. call requestFullscreen with potential options
	    //   2. if we got a promise from above, use it to update isFullscreen()
	    // 2. otherwise, if the tech supports fullscreen, call `enterFullScreen` on it.
	    //   This is particularly used for iPhone, older iPads, and non-safari browser on iOS.
	    // 3. otherwise, use "fullWindow" mode
	
	
	    if (this.fsApi_.requestFullscreen) {
	      var promise = this.el_[this.fsApi_.requestFullscreen](fsOptions);
	
	      if (promise) {
	        promise.then(function () {
	          return _this12.isFullscreen(true);
	        }, function () {
	          return _this12.isFullscreen(false);
	        });
	      }
	
	      return promise;
	    } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) {
	      // we can't take the video.js controls fullscreen but we can go fullscreen
	      // with native controls
	      this.techCall_('enterFullScreen');
	    } else {
	      // fullscreen isn't supported so we'll just stretch the video element to
	      // fill the viewport
	      this.enterFullWindow();
	    }
	  }
	  /**
	   * Return the video to its normal size after having been in full screen mode
	   *
	   * @fires Player#fullscreenchange
	   */
	  ;
	
	  _proto.exitFullscreen = function exitFullscreen() {
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      var self = this;
	      return new PromiseClass(function (resolve, reject) {
	        function offHandler() {
	          self.off('fullscreenerror', errorHandler);
	          self.off('fullscreenchange', changeHandler);
	        }
	
	        function changeHandler() {
	          offHandler();
	          resolve();
	        }
	
	        function errorHandler(e, err) {
	          offHandler();
	          reject(err);
	        }
	
	        self.one('fullscreenchange', changeHandler);
	        self.one('fullscreenerror', errorHandler);
	        var promise = self.exitFullscreenHelper_();
	
	        if (promise) {
	          promise.then(offHandler, offHandler); // map the promise to our resolve/reject methods
	
	          promise.then(resolve, reject);
	        }
	      });
	    }
	
	    return this.exitFullscreenHelper_();
	  };
	
	  _proto.exitFullscreenHelper_ = function exitFullscreenHelper_() {
	    var _this13 = this;
	
	    if (this.fsApi_.requestFullscreen) {
	      var promise = document__default['default'][this.fsApi_.exitFullscreen]();
	
	      if (promise) {
	        // we're splitting the promise here, so, we want to catch the
	        // potential error so that this chain doesn't have unhandled errors
	        silencePromise(promise.then(function () {
	          return _this13.isFullscreen(false);
	        }));
	      }
	
	      return promise;
	    } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) {
	      this.techCall_('exitFullScreen');
	    } else {
	      this.exitFullWindow();
	    }
	  }
	  /**
	   * When fullscreen isn't supported we can stretch the
	   * video container to as wide as the browser will let us.
	   *
	   * @fires Player#enterFullWindow
	   */
	  ;
	
	  _proto.enterFullWindow = function enterFullWindow() {
	    this.isFullscreen(true);
	    this.isFullWindow = true; // Storing original doc overflow value to return to when fullscreen is off
	
	    this.docOrigOverflow = document__default['default'].documentElement.style.overflow; // Add listener for esc key to exit fullscreen
	
	    on(document__default['default'], 'keydown', this.boundFullWindowOnEscKey_); // Hide any scroll bars
	
	    document__default['default'].documentElement.style.overflow = 'hidden'; // Apply fullscreen styles
	
	    addClass(document__default['default'].body, 'vjs-full-window');
	    /**
	     * @event Player#enterFullWindow
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('enterFullWindow');
	  }
	  /**
	   * Check for call to either exit full window or
	   * full screen on ESC key
	   *
	   * @param {string} event
	   *        Event to check for key press
	   */
	  ;
	
	  _proto.fullWindowOnEscKey = function fullWindowOnEscKey(event) {
	    if (keycode__default['default'].isEventKey(event, 'Esc')) {
	      if (this.isFullscreen() === true) {
	        if (!this.isFullWindow) {
	          this.exitFullscreen();
	        } else {
	          this.exitFullWindow();
	        }
	      }
	    }
	  }
	  /**
	   * Exit full window
	   *
	   * @fires Player#exitFullWindow
	   */
	  ;
	
	  _proto.exitFullWindow = function exitFullWindow() {
	    this.isFullscreen(false);
	    this.isFullWindow = false;
	    off(document__default['default'], 'keydown', this.boundFullWindowOnEscKey_); // Unhide scroll bars.
	
	    document__default['default'].documentElement.style.overflow = this.docOrigOverflow; // Remove fullscreen styles
	
	    removeClass(document__default['default'].body, 'vjs-full-window'); // Resize the box, controller, and poster to original sizes
	    // this.positionAll();
	
	    /**
	     * @event Player#exitFullWindow
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('exitFullWindow');
	  }
	  /**
	   * Disable Picture-in-Picture mode.
	   *
	   * @param {boolean} value
	   *                  - true will disable Picture-in-Picture mode
	   *                  - false will enable Picture-in-Picture mode
	   */
	  ;
	
	  _proto.disablePictureInPicture = function disablePictureInPicture(value) {
	    if (value === undefined) {
	      return this.techGet_('disablePictureInPicture');
	    }
	
	    this.techCall_('setDisablePictureInPicture', value);
	    this.options_.disablePictureInPicture = value;
	    this.trigger('disablepictureinpicturechanged');
	  }
	  /**
	   * Check if the player is in Picture-in-Picture mode or tell the player that it
	   * is or is not in Picture-in-Picture mode.
	   *
	   * @param  {boolean} [isPiP]
	   *         Set the players current Picture-in-Picture state
	   *
	   * @return {boolean}
	   *         - true if Picture-in-Picture is on and getting
	   *         - false if Picture-in-Picture is off and getting
	   */
	  ;
	
	  _proto.isInPictureInPicture = function isInPictureInPicture(isPiP) {
	    if (isPiP !== undefined) {
	      this.isInPictureInPicture_ = !!isPiP;
	      this.togglePictureInPictureClass_();
	      return;
	    }
	
	    return !!this.isInPictureInPicture_;
	  }
	  /**
	   * Create a floating video window always on top of other windows so that users may
	   * continue consuming media while they interact with other content sites, or
	   * applications on their device.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @fires Player#enterpictureinpicture
	   *
	   * @return {Promise}
	   *         A promise with a Picture-in-Picture window.
	   */
	  ;
	
	  _proto.requestPictureInPicture = function requestPictureInPicture() {
	    if ('pictureInPictureEnabled' in document__default['default'] && this.disablePictureInPicture() === false) {
	      /**
	       * This event fires when the player enters picture in picture mode
	       *
	       * @event Player#enterpictureinpicture
	       * @type {EventTarget~Event}
	       */
	      return this.techGet_('requestPictureInPicture');
	    }
	  }
	  /**
	   * Exit Picture-in-Picture mode.
	   *
	   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
	   *
	   * @fires Player#leavepictureinpicture
	   *
	   * @return {Promise}
	   *         A promise.
	   */
	  ;
	
	  _proto.exitPictureInPicture = function exitPictureInPicture() {
	    if ('pictureInPictureEnabled' in document__default['default']) {
	      /**
	       * This event fires when the player leaves picture in picture mode
	       *
	       * @event Player#leavepictureinpicture
	       * @type {EventTarget~Event}
	       */
	      return document__default['default'].exitPictureInPicture();
	    }
	  }
	  /**
	   * Called when this Player has focus and a key gets pressed down, or when
	   * any Component of this player receives a key press that it doesn't handle.
	   * This allows player-wide hotkeys (either as defined below, or optionally
	   * by an external function).
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	  ;
	
	  _proto.handleKeyDown = function handleKeyDown(event) {
	    var userActions = this.options_.userActions; // Bail out if hotkeys are not configured.
	
	    if (!userActions || !userActions.hotkeys) {
	      return;
	    } // Function that determines whether or not to exclude an element from
	    // hotkeys handling.
	
	
	    var excludeElement = function excludeElement(el) {
	      var tagName = el.tagName.toLowerCase(); // The first and easiest test is for `contenteditable` elements.
	
	      if (el.isContentEditable) {
	        return true;
	      } // Inputs matching these types will still trigger hotkey handling as
	      // they are not text inputs.
	
	
	      var allowedInputTypes = ['button', 'checkbox', 'hidden', 'radio', 'reset', 'submit'];
	
	      if (tagName === 'input') {
	        return allowedInputTypes.indexOf(el.type) === -1;
	      } // The final test is by tag name. These tags will be excluded entirely.
	
	
	      var excludedTags = ['textarea'];
	      return excludedTags.indexOf(tagName) !== -1;
	    }; // Bail out if the user is focused on an interactive form element.
	
	
	    if (excludeElement(this.el_.ownerDocument.activeElement)) {
	      return;
	    }
	
	    if (typeof userActions.hotkeys === 'function') {
	      userActions.hotkeys.call(this, event);
	    } else {
	      this.handleHotkeys(event);
	    }
	  }
	  /**
	   * Called when this Player receives a hotkey keydown event.
	   * Supported player-wide hotkeys are:
	   *
	   *   f          - toggle fullscreen
	   *   m          - toggle mute
	   *   k or Space - toggle play/pause
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   */
	  ;
	
	  _proto.handleHotkeys = function handleHotkeys(event) {
	    var hotkeys = this.options_.userActions ? this.options_.userActions.hotkeys : {}; // set fullscreenKey, muteKey, playPauseKey from `hotkeys`, use defaults if not set
	
	    var _hotkeys$fullscreenKe = hotkeys.fullscreenKey,
	        fullscreenKey = _hotkeys$fullscreenKe === void 0 ? function (keydownEvent) {
	      return keycode__default['default'].isEventKey(keydownEvent, 'f');
	    } : _hotkeys$fullscreenKe,
	        _hotkeys$muteKey = hotkeys.muteKey,
	        muteKey = _hotkeys$muteKey === void 0 ? function (keydownEvent) {
	      return keycode__default['default'].isEventKey(keydownEvent, 'm');
	    } : _hotkeys$muteKey,
	        _hotkeys$playPauseKey = hotkeys.playPauseKey,
	        playPauseKey = _hotkeys$playPauseKey === void 0 ? function (keydownEvent) {
	      return keycode__default['default'].isEventKey(keydownEvent, 'k') || keycode__default['default'].isEventKey(keydownEvent, 'Space');
	    } : _hotkeys$playPauseKey;
	
	    if (fullscreenKey.call(this, event)) {
	      event.preventDefault();
	      event.stopPropagation();
	      var FSToggle = Component$1.getComponent('FullscreenToggle');
	
	      if (document__default['default'][this.fsApi_.fullscreenEnabled] !== false) {
	        FSToggle.prototype.handleClick.call(this, event);
	      }
	    } else if (muteKey.call(this, event)) {
	      event.preventDefault();
	      event.stopPropagation();
	      var MuteToggle = Component$1.getComponent('MuteToggle');
	      MuteToggle.prototype.handleClick.call(this, event);
	    } else if (playPauseKey.call(this, event)) {
	      event.preventDefault();
	      event.stopPropagation();
	      var PlayToggle = Component$1.getComponent('PlayToggle');
	      PlayToggle.prototype.handleClick.call(this, event);
	    }
	  }
	  /**
	   * Check whether the player can play a given mimetype
	   *
	   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
	   *
	   * @param {string} type
	   *        The mimetype to check
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	  ;
	
	  _proto.canPlayType = function canPlayType(type) {
	    var can; // Loop through each playback technology in the options order
	
	    for (var i = 0, j = this.options_.techOrder; i < j.length; i++) {
	      var techName = j[i];
	      var tech = Tech.getTech(techName); // Support old behavior of techs being registered as components.
	      // Remove once that deprecated behavior is removed.
	
	      if (!tech) {
	        tech = Component$1.getComponent(techName);
	      } // Check if the current tech is defined before continuing
	
	
	      if (!tech) {
	        log$1.error("The \"" + techName + "\" tech is undefined. Skipped browser support check for that tech.");
	        continue;
	      } // Check if the browser supports this technology
	
	
	      if (tech.isSupported()) {
	        can = tech.canPlayType(type);
	
	        if (can) {
	          return can;
	        }
	      }
	    }
	
	    return '';
	  }
	  /**
	   * Select source based on tech-order or source-order
	   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
	   * defaults to tech-order selection
	   *
	   * @param {Array} sources
	   *        The sources for a media asset
	   *
	   * @return {Object|boolean}
	   *         Object of source and tech order or false
	   */
	  ;
	
	  _proto.selectSource = function selectSource(sources) {
	    var _this14 = this;
	
	    // Get only the techs specified in `techOrder` that exist and are supported by the
	    // current platform
	    var techs = this.options_.techOrder.map(function (techName) {
	      return [techName, Tech.getTech(techName)];
	    }).filter(function (_ref) {
	      var techName = _ref[0],
	          tech = _ref[1];
	
	      // Check if the current tech is defined before continuing
	      if (tech) {
	        // Check if the browser supports this technology
	        return tech.isSupported();
	      }
	
	      log$1.error("The \"" + techName + "\" tech is undefined. Skipped browser support check for that tech.");
	      return false;
	    }); // Iterate over each `innerArray` element once per `outerArray` element and execute
	    // `tester` with both. If `tester` returns a non-falsy value, exit early and return
	    // that value.
	
	    var findFirstPassingTechSourcePair = function findFirstPassingTechSourcePair(outerArray, innerArray, tester) {
	      var found;
	      outerArray.some(function (outerChoice) {
	        return innerArray.some(function (innerChoice) {
	          found = tester(outerChoice, innerChoice);
	
	          if (found) {
	            return true;
	          }
	        });
	      });
	      return found;
	    };
	
	    var foundSourceAndTech;
	
	    var flip = function flip(fn) {
	      return function (a, b) {
	        return fn(b, a);
	      };
	    };
	
	    var finder = function finder(_ref2, source) {
	      var techName = _ref2[0],
	          tech = _ref2[1];
	
	      if (tech.canPlaySource(source, _this14.options_[techName.toLowerCase()])) {
	        return {
	          source: source,
	          tech: techName
	        };
	      }
	    }; // Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
	    // to select from them based on their priority.
	
	
	    if (this.options_.sourceOrder) {
	      // Source-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
	    } else {
	      // Tech-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
	    }
	
	    return foundSourceAndTech || false;
	  }
	  /**
	   * Executes source setting and getting logic
	   *
	   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
	   *        A SourceObject, an array of SourceObjects, or a string referencing
	   *        a URL to a media source. It is _highly recommended_ that an object
	   *        or array of objects is used here, so that source selection
	   *        algorithms can take the `type` into account.
	   *
	   *        If not provided, this method acts as a getter.
	   * @param {boolean} isRetry
	   *        Indicates whether this is being called internally as a result of a retry
	   *
	   * @return {string|undefined}
	   *         If the `source` argument is missing, returns the current source
	   *         URL. Otherwise, returns nothing/undefined.
	   */
	  ;
	
	  _proto.handleSrc_ = function handleSrc_(source, isRetry) {
	    var _this15 = this;
	
	    // getter usage
	    if (typeof source === 'undefined') {
	      return this.cache_.src || '';
	    } // Reset retry behavior for new source
	
	
	    if (this.resetRetryOnError_) {
	      this.resetRetryOnError_();
	    } // filter out invalid sources and turn our source into
	    // an array of source objects
	
	
	    var sources = filterSource(source); // if a source was passed in then it is invalid because
	    // it was filtered to a zero length Array. So we have to
	    // show an error
	
	    if (!sources.length) {
	      this.setTimeout(function () {
	        this.error({
	          code: 4,
	          message: this.options_.notSupportedMessage
	        });
	      }, 0);
	      return;
	    } // initial sources
	
	
	    this.changingSrc_ = true; // Only update the cached source list if we are not retrying a new source after error,
	    // since in that case we want to include the failed source(s) in the cache
	
	    if (!isRetry) {
	      this.cache_.sources = sources;
	    }
	
	    this.updateSourceCaches_(sources[0]); // middlewareSource is the source after it has been changed by middleware
	
	    setSource(this, sources[0], function (middlewareSource, mws) {
	      _this15.middleware_ = mws; // since sourceSet is async we have to update the cache again after we select a source since
	      // the source that is selected could be out of order from the cache update above this callback.
	
	      if (!isRetry) {
	        _this15.cache_.sources = sources;
	      }
	
	      _this15.updateSourceCaches_(middlewareSource);
	
	      var err = _this15.src_(middlewareSource);
	
	      if (err) {
	        if (sources.length > 1) {
	          return _this15.handleSrc_(sources.slice(1));
	        }
	
	        _this15.changingSrc_ = false; // We need to wrap this in a timeout to give folks a chance to add error event handlers
	
	        _this15.setTimeout(function () {
	          this.error({
	            code: 4,
	            message: this.options_.notSupportedMessage
	          });
	        }, 0); // we could not find an appropriate tech, but let's still notify the delegate that this is it
	        // this needs a better comment about why this is needed
	
	
	        _this15.triggerReady();
	
	        return;
	      }
	
	      setTech(mws, _this15.tech_);
	    }); // Try another available source if this one fails before playback.
	
	    if (this.options_.retryOnError && sources.length > 1) {
	      var retry = function retry() {
	        // Remove the error modal
	        _this15.error(null);
	
	        _this15.handleSrc_(sources.slice(1), true);
	      };
	
	      var stopListeningForErrors = function stopListeningForErrors() {
	        _this15.off('error', retry);
	      };
	
	      this.one('error', retry);
	      this.one('playing', stopListeningForErrors);
	
	      this.resetRetryOnError_ = function () {
	        _this15.off('error', retry);
	
	        _this15.off('playing', stopListeningForErrors);
	      };
	    }
	  }
	  /**
	   * Get or set the video source.
	   *
	   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
	   *        A SourceObject, an array of SourceObjects, or a string referencing
	   *        a URL to a media source. It is _highly recommended_ that an object
	   *        or array of objects is used here, so that source selection
	   *        algorithms can take the `type` into account.
	   *
	   *        If not provided, this method acts as a getter.
	   *
	   * @return {string|undefined}
	   *         If the `source` argument is missing, returns the current source
	   *         URL. Otherwise, returns nothing/undefined.
	   */
	  ;
	
	  _proto.src = function src(source) {
	    return this.handleSrc_(source, false);
	  }
	  /**
	   * Set the source object on the tech, returns a boolean that indicates whether
	   * there is a tech that can play the source or not
	   *
	   * @param {Tech~SourceObject} source
	   *        The source object to set on the Tech
	   *
	   * @return {boolean}
	   *         - True if there is no Tech to playback this source
	   *         - False otherwise
	   *
	   * @private
	   */
	  ;
	
	  _proto.src_ = function src_(source) {
	    var _this16 = this;
	
	    var sourceTech = this.selectSource([source]);
	
	    if (!sourceTech) {
	      return true;
	    }
	
	    if (!titleCaseEquals(sourceTech.tech, this.techName_)) {
	      this.changingSrc_ = true; // load this technology with the chosen source
	
	      this.loadTech_(sourceTech.tech, sourceTech.source);
	      this.tech_.ready(function () {
	        _this16.changingSrc_ = false;
	      });
	      return false;
	    } // wait until the tech is ready to set the source
	    // and set it synchronously if possible (#2326)
	
	
	    this.ready(function () {
	      // The setSource tech method was added with source handlers
	      // so older techs won't support it
	      // We need to check the direct prototype for the case where subclasses
	      // of the tech do not support source handlers
	      if (this.tech_.constructor.prototype.hasOwnProperty('setSource')) {
	        this.techCall_('setSource', source);
	      } else {
	        this.techCall_('src', source.src);
	      }
	
	      this.changingSrc_ = false;
	    }, true);
	    return false;
	  }
	  /**
	   * Begin loading the src data.
	   */
	  ;
	
	  _proto.load = function load() {
	    this.techCall_('load');
	  }
	  /**
	   * Reset the player. Loads the first tech in the techOrder,
	   * removes all the text tracks in the existing `tech`,
	   * and calls `reset` on the `tech`.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    var _this17 = this;
	
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (this.paused() || !PromiseClass) {
	      this.doReset_();
	    } else {
	      var playPromise = this.play();
	      silencePromise(playPromise.then(function () {
	        return _this17.doReset_();
	      }));
	    }
	  };
	
	  _proto.doReset_ = function doReset_() {
	    if (this.tech_) {
	      this.tech_.clearTracks('text');
	    }
	
	    this.resetCache_();
	    this.poster('');
	    this.loadTech_(this.options_.techOrder[0], null);
	    this.techCall_('reset');
	    this.resetControlBarUI_();
	
	    if (isEvented(this)) {
	      this.trigger('playerreset');
	    }
	  }
	  /**
	   * Reset Control Bar's UI by calling sub-methods that reset
	   * all of Control Bar's components
	   */
	  ;
	
	  _proto.resetControlBarUI_ = function resetControlBarUI_() {
	    this.resetProgressBar_();
	    this.resetPlaybackRate_();
	    this.resetVolumeBar_();
	  }
	  /**
	   * Reset tech's progress so progress bar is reset in the UI
	   */
	  ;
	
	  _proto.resetProgressBar_ = function resetProgressBar_() {
	    this.currentTime(0);
	
	    var _ref3 = this.controlBar || {},
	        durationDisplay = _ref3.durationDisplay,
	        remainingTimeDisplay = _ref3.remainingTimeDisplay;
	
	    if (durationDisplay) {
	      durationDisplay.updateContent();
	    }
	
	    if (remainingTimeDisplay) {
	      remainingTimeDisplay.updateContent();
	    }
	  }
	  /**
	   * Reset Playback ratio
	   */
	  ;
	
	  _proto.resetPlaybackRate_ = function resetPlaybackRate_() {
	    this.playbackRate(this.defaultPlaybackRate());
	    this.handleTechRateChange_();
	  }
	  /**
	   * Reset Volume bar
	   */
	  ;
	
	  _proto.resetVolumeBar_ = function resetVolumeBar_() {
	    this.volume(1.0);
	    this.trigger('volumechange');
	  }
	  /**
	   * Returns all of the current source objects.
	   *
	   * @return {Tech~SourceObject[]}
	   *         The current source objects
	   */
	  ;
	
	  _proto.currentSources = function currentSources() {
	    var source = this.currentSource();
	    var sources = []; // assume `{}` or `{ src }`
	
	    if (Object.keys(source).length !== 0) {
	      sources.push(source);
	    }
	
	    return this.cache_.sources || sources;
	  }
	  /**
	   * Returns the current source object.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object
	   */
	  ;
	
	  _proto.currentSource = function currentSource() {
	    return this.cache_.source || {};
	  }
	  /**
	   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
	   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
	   *
	   * @return {string}
	   *         The current source
	   */
	  ;
	
	  _proto.currentSrc = function currentSrc() {
	    return this.currentSource() && this.currentSource().src || '';
	  }
	  /**
	   * Get the current source type e.g. video/mp4
	   * This can allow you rebuild the current source object so that you could load the same
	   * source and tech later
	   *
	   * @return {string}
	   *         The source MIME type
	   */
	  ;
	
	  _proto.currentType = function currentType() {
	    return this.currentSource() && this.currentSource().type || '';
	  }
	  /**
	   * Get or set the preload attribute
	   *
	   * @param {boolean} [value]
	   *        - true means that we should preload
	   *        - false means that we should not preload
	   *
	   * @return {string}
	   *         The preload attribute value when getting
	   */
	  ;
	
	  _proto.preload = function preload(value) {
	    if (value !== undefined) {
	      this.techCall_('setPreload', value);
	      this.options_.preload = value;
	      return;
	    }
	
	    return this.techGet_('preload');
	  }
	  /**
	   * Get or set the autoplay option. When this is a boolean it will
	   * modify the attribute on the tech. When this is a string the attribute on
	   * the tech will be removed and `Player` will handle autoplay on loadstarts.
	   *
	   * @param {boolean|string} [value]
	   *        - true: autoplay using the browser behavior
	   *        - false: do not autoplay
	   *        - 'play': call play() on every loadstart
	   *        - 'muted': call muted() then play() on every loadstart
	   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
	   *        - *: values other than those listed here will be set `autoplay` to true
	   *
	   * @return {boolean|string}
	   *         The current value of autoplay when getting
	   */
	  ;
	
	  _proto.autoplay = function autoplay(value) {
	    // getter usage
	    if (value === undefined) {
	      return this.options_.autoplay || false;
	    }
	
	    var techAutoplay; // if the value is a valid string set it to that, or normalize `true` to 'play', if need be
	
	    if (typeof value === 'string' && /(any|play|muted)/.test(value) || value === true && this.options_.normalizeAutoplay) {
	      this.options_.autoplay = value;
	      this.manualAutoplay_(typeof value === 'string' ? value : 'play');
	      techAutoplay = false; // any falsy value sets autoplay to false in the browser,
	      // lets do the same
	    } else if (!value) {
	      this.options_.autoplay = false; // any other value (ie truthy) sets autoplay to true
	    } else {
	      this.options_.autoplay = true;
	    }
	
	    techAutoplay = typeof techAutoplay === 'undefined' ? this.options_.autoplay : techAutoplay; // if we don't have a tech then we do not queue up
	    // a setAutoplay call on tech ready. We do this because the
	    // autoplay option will be passed in the constructor and we
	    // do not need to set it twice
	
	    if (this.tech_) {
	      this.techCall_('setAutoplay', techAutoplay);
	    }
	  }
	  /**
	   * Set or unset the playsinline attribute.
	   * Playsinline tells the browser that non-fullscreen playback is preferred.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should try to play inline by default
	   *        - false means that we should use the browser's default playback mode,
	   *          which in most cases is inline. iOS Safari is a notable exception
	   *          and plays fullscreen by default.
	   *
	   * @return {string|Player}
	   *         - the current value of playsinline
	   *         - the player when setting
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	   */
	  ;
	
	  _proto.playsinline = function playsinline(value) {
	    if (value !== undefined) {
	      this.techCall_('setPlaysinline', value);
	      this.options_.playsinline = value;
	      return this;
	    }
	
	    return this.techGet_('playsinline');
	  }
	  /**
	   * Get or set the loop attribute on the video element.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should loop the video
	   *        - false means that we should not loop the video
	   *
	   * @return {boolean}
	   *         The current value of loop when getting
	   */
	  ;
	
	  _proto.loop = function loop(value) {
	    if (value !== undefined) {
	      this.techCall_('setLoop', value);
	      this.options_.loop = value;
	      return;
	    }
	
	    return this.techGet_('loop');
	  }
	  /**
	   * Get or set the poster image source url
	   *
	   * @fires Player#posterchange
	   *
	   * @param {string} [src]
	   *        Poster image source URL
	   *
	   * @return {string}
	   *         The current value of poster when getting
	   */
	  ;
	
	  _proto.poster = function poster(src) {
	    if (src === undefined) {
	      return this.poster_;
	    } // The correct way to remove a poster is to set as an empty string
	    // other falsey values will throw errors
	
	
	    if (!src) {
	      src = '';
	    }
	
	    if (src === this.poster_) {
	      return;
	    } // update the internal poster variable
	
	
	    this.poster_ = src; // update the tech's poster
	
	    this.techCall_('setPoster', src);
	    this.isPosterFromTech_ = false; // alert components that the poster has been set
	
	    /**
	     * This event fires when the poster image is changed on the player.
	     *
	     * @event Player#posterchange
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('posterchange');
	  }
	  /**
	   * Some techs (e.g. YouTube) can provide a poster source in an
	   * asynchronous way. We want the poster component to use this
	   * poster source so that it covers up the tech's controls.
	   * (YouTube's play button). However we only want to use this
	   * source if the player user hasn't set a poster through
	   * the normal APIs.
	   *
	   * @fires Player#posterchange
	   * @listens Tech#posterchange
	   * @private
	   */
	  ;
	
	  _proto.handleTechPosterChange_ = function handleTechPosterChange_() {
	    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
	      var newPoster = this.tech_.poster() || '';
	
	      if (newPoster !== this.poster_) {
	        this.poster_ = newPoster;
	        this.isPosterFromTech_ = true; // Let components know the poster has changed
	
	        this.trigger('posterchange');
	      }
	    }
	  }
	  /**
	   * Get or set whether or not the controls are showing.
	   *
	   * @fires Player#controlsenabled
	   *
	   * @param {boolean} [bool]
	   *        - true to turn controls on
	   *        - false to turn controls off
	   *
	   * @return {boolean}
	   *         The current value of controls when getting
	   */
	  ;
	
	  _proto.controls = function controls(bool) {
	    if (bool === undefined) {
	      return !!this.controls_;
	    }
	
	    bool = !!bool; // Don't trigger a change event unless it actually changed
	
	    if (this.controls_ === bool) {
	      return;
	    }
	
	    this.controls_ = bool;
	
	    if (this.usingNativeControls()) {
	      this.techCall_('setControls', bool);
	    }
	
	    if (this.controls_) {
	      this.removeClass('vjs-controls-disabled');
	      this.addClass('vjs-controls-enabled');
	      /**
	       * @event Player#controlsenabled
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('controlsenabled');
	
	      if (!this.usingNativeControls()) {
	        this.addTechControlsListeners_();
	      }
	    } else {
	      this.removeClass('vjs-controls-enabled');
	      this.addClass('vjs-controls-disabled');
	      /**
	       * @event Player#controlsdisabled
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('controlsdisabled');
	
	      if (!this.usingNativeControls()) {
	        this.removeTechControlsListeners_();
	      }
	    }
	  }
	  /**
	   * Toggle native controls on/off. Native controls are the controls built into
	   * devices (e.g. default iPhone controls) or other techs
	   * (e.g. Vimeo Controls)
	   * **This should only be set by the current tech, because only the tech knows
	   * if it can support native controls**
	   *
	   * @fires Player#usingnativecontrols
	   * @fires Player#usingcustomcontrols
	   *
	   * @param {boolean} [bool]
	   *        - true to turn native controls on
	   *        - false to turn native controls off
	   *
	   * @return {boolean}
	   *         The current value of native controls when getting
	   */
	  ;
	
	  _proto.usingNativeControls = function usingNativeControls(bool) {
	    if (bool === undefined) {
	      return !!this.usingNativeControls_;
	    }
	
	    bool = !!bool; // Don't trigger a change event unless it actually changed
	
	    if (this.usingNativeControls_ === bool) {
	      return;
	    }
	
	    this.usingNativeControls_ = bool;
	
	    if (this.usingNativeControls_) {
	      this.addClass('vjs-using-native-controls');
	      /**
	       * player is using the native device controls
	       *
	       * @event Player#usingnativecontrols
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('usingnativecontrols');
	    } else {
	      this.removeClass('vjs-using-native-controls');
	      /**
	       * player is using the custom HTML controls
	       *
	       * @event Player#usingcustomcontrols
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('usingcustomcontrols');
	    }
	  }
	  /**
	   * Set or get the current MediaError
	   *
	   * @fires Player#error
	   *
	   * @param  {MediaError|string|number} [err]
	   *         A MediaError or a string/number to be turned
	   *         into a MediaError
	   *
	   * @return {MediaError|null}
	   *         The current MediaError when getting (or null)
	   */
	  ;
	
	  _proto.error = function error(err) {
	    var _this18 = this;
	
	    if (err === undefined) {
	      return this.error_ || null;
	    } // allow hooks to modify error object
	
	
	    hooks('beforeerror').forEach(function (hookFunction) {
	      var newErr = hookFunction(_this18, err);
	
	      if (!(isObject(newErr) && !Array.isArray(newErr) || typeof newErr === 'string' || typeof newErr === 'number' || newErr === null)) {
	        _this18.log.error('please return a value that MediaError expects in beforeerror hooks');
	
	        return;
	      }
	
	      err = newErr;
	    }); // Suppress the first error message for no compatible source until
	    // user interaction
	
	    if (this.options_.suppressNotSupportedError && err && err.code === 4) {
	      var triggerSuppressedError = function triggerSuppressedError() {
	        this.error(err);
	      };
	
	      this.options_.suppressNotSupportedError = false;
	      this.any(['click', 'touchstart'], triggerSuppressedError);
	      this.one('loadstart', function () {
	        this.off(['click', 'touchstart'], triggerSuppressedError);
	      });
	      return;
	    } // restoring to default
	
	
	    if (err === null) {
	      this.error_ = err;
	      this.removeClass('vjs-error');
	
	      if (this.errorDisplay) {
	        this.errorDisplay.close();
	      }
	
	      return;
	    }
	
	    this.error_ = new MediaError(err); // add the vjs-error classname to the player
	
	    this.addClass('vjs-error'); // log the name of the error type and any message
	    // IE11 logs "[object object]" and required you to expand message to see error object
	
	    log$1.error("(CODE:" + this.error_.code + " " + MediaError.errorTypes[this.error_.code] + ")", this.error_.message, this.error_);
	    /**
	     * @event Player#error
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('error'); // notify hooks of the per player error
	
	    hooks('error').forEach(function (hookFunction) {
	      return hookFunction(_this18, _this18.error_);
	    });
	    return;
	  }
	  /**
	   * Report user activity
	   *
	   * @param {Object} event
	   *        Event object
	   */
	  ;
	
	  _proto.reportUserActivity = function reportUserActivity(event) {
	    this.userActivity_ = true;
	  }
	  /**
	   * Get/set if user is active
	   *
	   * @fires Player#useractive
	   * @fires Player#userinactive
	   *
	   * @param {boolean} [bool]
	   *        - true if the user is active
	   *        - false if the user is inactive
	   *
	   * @return {boolean}
	   *         The current value of userActive when getting
	   */
	  ;
	
	  _proto.userActive = function userActive(bool) {
	    if (bool === undefined) {
	      return this.userActive_;
	    }
	
	    bool = !!bool;
	
	    if (bool === this.userActive_) {
	      return;
	    }
	
	    this.userActive_ = bool;
	
	    if (this.userActive_) {
	      this.userActivity_ = true;
	      this.removeClass('vjs-user-inactive');
	      this.addClass('vjs-user-active');
	      /**
	       * @event Player#useractive
	       * @type {EventTarget~Event}
	       */
	
	      this.trigger('useractive');
	      return;
	    } // Chrome/Safari/IE have bugs where when you change the cursor it can
	    // trigger a mousemove event. This causes an issue when you're hiding
	    // the cursor when the user is inactive, and a mousemove signals user
	    // activity. Making it impossible to go into inactive mode. Specifically
	    // this happens in fullscreen when we really need to hide the cursor.
	    //
	    // When this gets resolved in ALL browsers it can be removed
	    // https://code.google.com/p/chromium/issues/detail?id=103041
	
	
	    if (this.tech_) {
	      this.tech_.one('mousemove', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	      });
	    }
	
	    this.userActivity_ = false;
	    this.removeClass('vjs-user-active');
	    this.addClass('vjs-user-inactive');
	    /**
	     * @event Player#userinactive
	     * @type {EventTarget~Event}
	     */
	
	    this.trigger('userinactive');
	  }
	  /**
	   * Listen for user activity based on timeout value
	   *
	   * @private
	   */
	  ;
	
	  _proto.listenForUserActivity_ = function listenForUserActivity_() {
	    var mouseInProgress;
	    var lastMoveX;
	    var lastMoveY;
	    var handleActivity = bind(this, this.reportUserActivity);
	
	    var handleMouseMove = function handleMouseMove(e) {
	      // #1068 - Prevent mousemove spamming
	      // Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
	      if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
	        lastMoveX = e.screenX;
	        lastMoveY = e.screenY;
	        handleActivity();
	      }
	    };
	
	    var handleMouseDown = function handleMouseDown() {
	      handleActivity(); // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	
	      this.clearInterval(mouseInProgress); // Setting userActivity=true now and setting the interval to the same time
	      // as the activityCheck interval (250) should ensure we never miss the
	      // next activityCheck
	
	      mouseInProgress = this.setInterval(handleActivity, 250);
	    };
	
	    var handleMouseUpAndMouseLeave = function handleMouseUpAndMouseLeave(event) {
	      handleActivity(); // Stop the interval that maintains activity if the mouse/touch is down
	
	      this.clearInterval(mouseInProgress);
	    }; // Any mouse movement will be considered user activity
	
	
	    this.on('mousedown', handleMouseDown);
	    this.on('mousemove', handleMouseMove);
	    this.on('mouseup', handleMouseUpAndMouseLeave);
	    this.on('mouseleave', handleMouseUpAndMouseLeave);
	    var controlBar = this.getChild('controlBar'); // Fixes bug on Android & iOS where when tapping progressBar (when control bar is displayed)
	    // controlBar would no longer be hidden by default timeout.
	
	    if (controlBar && !IS_IOS && !IS_ANDROID) {
	      controlBar.on('mouseenter', function (event) {
	        if (this.player().options_.inactivityTimeout !== 0) {
	          this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout;
	        }
	
	        this.player().options_.inactivityTimeout = 0;
	      });
	      controlBar.on('mouseleave', function (event) {
	        this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
	      });
	    } // Listen for keyboard navigation
	    // Shouldn't need to use inProgress interval because of key repeat
	
	
	    this.on('keydown', handleActivity);
	    this.on('keyup', handleActivity); // Run an interval every 250 milliseconds instead of stuffing everything into
	    // the mousemove/touchmove function itself, to prevent performance degradation.
	    // `this.reportUserActivity` simply sets this.userActivity_ to true, which
	    // then gets picked up by this loop
	    // http://ejohn.org/blog/learning-from-twitter/
	
	    var inactivityTimeout;
	    this.setInterval(function () {
	      // Check to see if mouse/touch activity has happened
	      if (!this.userActivity_) {
	        return;
	      } // Reset the activity tracker
	
	
	      this.userActivity_ = false; // If the user state was inactive, set the state to active
	
	      this.userActive(true); // Clear any existing inactivity timeout to start the timer over
	
	      this.clearTimeout(inactivityTimeout);
	      var timeout = this.options_.inactivityTimeout;
	
	      if (timeout <= 0) {
	        return;
	      } // In <timeout> milliseconds, if no more activity has occurred the
	      // user will be considered inactive
	
	
	      inactivityTimeout = this.setTimeout(function () {
	        // Protect against the case where the inactivityTimeout can trigger just
	        // before the next user activity is picked up by the activity check loop
	        // causing a flicker
	        if (!this.userActivity_) {
	          this.userActive(false);
	        }
	      }, timeout);
	    }, 250);
	  }
	  /**
	   * Gets or sets the current playback rate. A playback rate of
	   * 1.0 represents normal speed and 0.5 would indicate half-speed
	   * playback, for instance.
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
	   *
	   * @param {number} [rate]
	   *       New playback rate to set.
	   *
	   * @return {number}
	   *         The current playback rate when getting or 1.0
	   */
	  ;
	
	  _proto.playbackRate = function playbackRate(rate) {
	    if (rate !== undefined) {
	      // NOTE: this.cache_.lastPlaybackRate is set from the tech handler
	      // that is registered above
	      this.techCall_('setPlaybackRate', rate);
	      return;
	    }
	
	    if (this.tech_ && this.tech_.featuresPlaybackRate) {
	      return this.cache_.lastPlaybackRate || this.techGet_('playbackRate');
	    }
	
	    return 1.0;
	  }
	  /**
	   * Gets or sets the current default playback rate. A default playback rate of
	   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
	   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
	   * not the current playbackRate.
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
	   *
	   * @param {number} [rate]
	   *       New default playback rate to set.
	   *
	   * @return {number|Player}
	   *         - The default playback rate when getting or 1.0
	   *         - the player when setting
	   */
	  ;
	
	  _proto.defaultPlaybackRate = function defaultPlaybackRate(rate) {
	    if (rate !== undefined) {
	      return this.techCall_('setDefaultPlaybackRate', rate);
	    }
	
	    if (this.tech_ && this.tech_.featuresPlaybackRate) {
	      return this.techGet_('defaultPlaybackRate');
	    }
	
	    return 1.0;
	  }
	  /**
	   * Gets or sets the audio flag
	   *
	   * @param {boolean} bool
	   *        - true signals that this is an audio player
	   *        - false signals that this is not an audio player
	   *
	   * @return {boolean}
	   *         The current value of isAudio when getting
	   */
	  ;
	
	  _proto.isAudio = function isAudio(bool) {
	    if (bool !== undefined) {
	      this.isAudio_ = !!bool;
	      return;
	    }
	
	    return !!this.isAudio_;
	  };
	
	  _proto.enableAudioOnlyUI_ = function enableAudioOnlyUI_() {
	    var _this19 = this;
	
	    // Update styling immediately to show the control bar so we can get its height
	    this.addClass('vjs-audio-only-mode');
	    var playerChildren = this.children();
	    var controlBar = this.getChild('ControlBar');
	    var controlBarHeight = controlBar && controlBar.currentHeight(); // Hide all player components except the control bar. Control bar components
	    // needed only for video are hidden with CSS
	
	    playerChildren.forEach(function (child) {
	      if (child === controlBar) {
	        return;
	      }
	
	      if (child.el_ && !child.hasClass('vjs-hidden')) {
	        child.hide();
	
	        _this19.audioOnlyCache_.hiddenChildren.push(child);
	      }
	    });
	    this.audioOnlyCache_.playerHeight = this.currentHeight(); // Set the player height the same as the control bar
	
	    this.height(controlBarHeight);
	    this.trigger('audioonlymodechange');
	  };
	
	  _proto.disableAudioOnlyUI_ = function disableAudioOnlyUI_() {
	    this.removeClass('vjs-audio-only-mode'); // Show player components that were previously hidden
	
	    this.audioOnlyCache_.hiddenChildren.forEach(function (child) {
	      return child.show();
	    }); // Reset player height
	
	    this.height(this.audioOnlyCache_.playerHeight);
	    this.trigger('audioonlymodechange');
	  }
	  /**
	   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
	   *
	   * Setting this to `true` will hide all player components except the control bar,
	   * as well as control bar components needed only for video.
	   *
	   * @param {boolean} [value]
	   *         The value to set audioOnlyMode to.
	   *
	   * @return {Promise|boolean}
	   *        A Promise is returned when setting the state, and a boolean when getting
	   *        the present state
	   */
	  ;
	
	  _proto.audioOnlyMode = function audioOnlyMode(value) {
	    var _this20 = this;
	
	    if (typeof value !== 'boolean' || value === this.audioOnlyMode_) {
	      return this.audioOnlyMode_;
	    }
	
	    this.audioOnlyMode_ = value;
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      // Enable Audio Only Mode
	      if (value) {
	        var exitPromises = []; // Fullscreen and PiP are not supported in audioOnlyMode, so exit if we need to.
	
	        if (this.isInPictureInPicture()) {
	          exitPromises.push(this.exitPictureInPicture());
	        }
	
	        if (this.isFullscreen()) {
	          exitPromises.push(this.exitFullscreen());
	        }
	
	        if (this.audioPosterMode()) {
	          exitPromises.push(this.audioPosterMode(false));
	        }
	
	        return PromiseClass.all(exitPromises).then(function () {
	          return _this20.enableAudioOnlyUI_();
	        });
	      } // Disable Audio Only Mode
	
	
	      return PromiseClass.resolve().then(function () {
	        return _this20.disableAudioOnlyUI_();
	      });
	    }
	
	    if (value) {
	      if (this.isInPictureInPicture()) {
	        this.exitPictureInPicture();
	      }
	
	      if (this.isFullscreen()) {
	        this.exitFullscreen();
	      }
	
	      this.enableAudioOnlyUI_();
	    } else {
	      this.disableAudioOnlyUI_();
	    }
	  };
	
	  _proto.enablePosterModeUI_ = function enablePosterModeUI_() {
	    // Hide the video element and show the poster image to enable posterModeUI
	    var tech = this.tech_ && this.tech_;
	    tech.hide();
	    this.addClass('vjs-audio-poster-mode');
	    this.trigger('audiopostermodechange');
	  };
	
	  _proto.disablePosterModeUI_ = function disablePosterModeUI_() {
	    // Show the video element and hide the poster image to disable posterModeUI
	    var tech = this.tech_ && this.tech_;
	    tech.show();
	    this.removeClass('vjs-audio-poster-mode');
	    this.trigger('audiopostermodechange');
	  }
	  /**
	   * Get the current audioPosterMode state or set audioPosterMode to true or false
	   *
	   * @param {boolean} [value]
	   *         The value to set audioPosterMode to.
	   *
	   * @return {Promise|boolean}
	   *         A Promise is returned when setting the state, and a boolean when getting
	   *        the present state
	   */
	  ;
	
	  _proto.audioPosterMode = function audioPosterMode(value) {
	    var _this21 = this;
	
	    if (typeof value !== 'boolean' || value === this.audioPosterMode_) {
	      return this.audioPosterMode_;
	    }
	
	    this.audioPosterMode_ = value;
	    var PromiseClass = this.options_.Promise || window__default['default'].Promise;
	
	    if (PromiseClass) {
	      if (value) {
	        if (this.audioOnlyMode()) {
	          var audioOnlyModePromise = this.audioOnlyMode(false);
	          return audioOnlyModePromise.then(function () {
	            // enable audio poster mode after audio only mode is disabled
	            _this21.enablePosterModeUI_();
	          });
	        }
	
	        return PromiseClass.resolve().then(function () {
	          // enable audio poster mode
	          _this21.enablePosterModeUI_();
	        });
	      }
	
	      return PromiseClass.resolve().then(function () {
	        // disable audio poster mode
	        _this21.disablePosterModeUI_();
	      });
	    }
	
	    if (value) {
	      if (this.audioOnlyMode()) {
	        this.audioOnlyMode(false);
	      }
	
	      this.enablePosterModeUI_();
	      return;
	    }
	
	    this.disablePosterModeUI_();
	  }
	  /**
	   * A helper method for adding a {@link TextTrack} to our
	   * {@link TextTrackList}.
	   *
	   * In addition to the W3C settings we allow adding additional info through options.
	   *
	   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
	   *
	   * @param {string} [kind]
	   *        the kind of TextTrack you are adding
	   *
	   * @param {string} [label]
	   *        the label to give the TextTrack label
	   *
	   * @param {string} [language]
	   *        the language to set on the TextTrack
	   *
	   * @return {TextTrack|undefined}
	   *         the TextTrack that was added or undefined
	   *         if there is no tech
	   */
	  ;
	
	  _proto.addTextTrack = function addTextTrack(kind, label, language) {
	    if (this.tech_) {
	      return this.tech_.addTextTrack(kind, label, language);
	    }
	  }
	  /**
	   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
	   * When manualCleanup is set to false, the track will be automatically removed
	   * on source changes.
	   *
	   * @param {Object} options
	   *        Options to pass to {@link HTMLTrackElement} during creation. See
	   *        {@link HTMLTrackElement} for object properties that you should use.
	   *
	   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   *                                       removed on a source change
	   *
	   * @return {HtmlTrackElement}
	   *         the HTMLTrackElement that was created and added
	   *         to the HtmlTrackElementList and the remote
	   *         TextTrackList
	   *
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   *             to "false" in upcoming versions of Video.js
	   */
	  ;
	
	  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    if (this.tech_) {
	      return this.tech_.addRemoteTextTrack(options, manualCleanup);
	    }
	  }
	  /**
	   * Remove a remote {@link TextTrack} from the respective
	   * {@link TextTrackList} and {@link HtmlTrackElementList}.
	   *
	   * @param {Object} track
	   *        Remote {@link TextTrack} to remove
	   *
	   * @return {undefined}
	   *         does not return anything
	   */
	  ;
	
	  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(obj) {
	    if (obj === void 0) {
	      obj = {};
	    }
	
	    var _obj = obj,
	        track = _obj.track;
	
	    if (!track) {
	      track = obj;
	    } // destructure the input into an object with a track argument, defaulting to arguments[0]
	    // default the whole argument to an empty object if nothing was passed in
	
	
	    if (this.tech_) {
	      return this.tech_.removeRemoteTextTrack(track);
	    }
	  }
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object|undefined}
	   *         An object with supported media playback quality metrics or undefined if there
	   *         is no tech or the tech does not support it.
	   */
	  ;
	
	  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return this.techGet_('getVideoPlaybackQuality');
	  }
	  /**
	   * Get video width
	   *
	   * @return {number}
	   *         current video width
	   */
	  ;
	
	  _proto.videoWidth = function videoWidth() {
	    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
	  }
	  /**
	   * Get video height
	   *
	   * @return {number}
	   *         current video height
	   */
	  ;
	
	  _proto.videoHeight = function videoHeight() {
	    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
	  }
	  /**
	   * The player's language code.
	   *
	   * Changing the language will trigger
	   * [languagechange]{@link Player#event:languagechange}
	   * which Components can use to update control text.
	   * ClickableComponent will update its control text by default on
	   * [languagechange]{@link Player#event:languagechange}.
	   *
	   * @fires Player#languagechange
	   *
	   * @param {string} [code]
	   *        the language code to set the player to
	   *
	   * @return {string}
	   *         The current language code when getting
	   */
	  ;
	
	  _proto.language = function language(code) {
	    if (code === undefined) {
	      return this.language_;
	    }
	
	    if (this.language_ !== String(code).toLowerCase()) {
	      this.language_ = String(code).toLowerCase(); // during first init, it's possible some things won't be evented
	
	      if (isEvented(this)) {
	        /**
	        * fires when the player language change
	        *
	        * @event Player#languagechange
	        * @type {EventTarget~Event}
	        */
	        this.trigger('languagechange');
	      }
	    }
	  }
	  /**
	   * Get the player's language dictionary
	   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
	   * Languages specified directly in the player options have precedence
	   *
	   * @return {Array}
	   *         An array of of supported languages
	   */
	  ;
	
	  _proto.languages = function languages() {
	    return mergeOptions$3(Player.prototype.options_.languages, this.languages_);
	  }
	  /**
	   * returns a JavaScript object reperesenting the current track
	   * information. **DOES not return it as JSON**
	   *
	   * @return {Object}
	   *         Object representing the current of track info
	   */
	  ;
	
	  _proto.toJSON = function toJSON() {
	    var options = mergeOptions$3(this.options_);
	    var tracks = options.tracks;
	    options.tracks = [];
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i]; // deep merge tracks and null out player so no circular references
	
	      track = mergeOptions$3(track);
	      track.player = undefined;
	      options.tracks[i] = track;
	    }
	
	    return options;
	  }
	  /**
	   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
	   * component) that immediately overlays the player with arbitrary
	   * content and removes itself when closed.
	   *
	   * @param {string|Function|Element|Array|null} content
	   *        Same as {@link ModalDialog#content}'s param of the same name.
	   *        The most straight-forward usage is to provide a string or DOM
	   *        element.
	   *
	   * @param {Object} [options]
	   *        Extra options which will be passed on to the {@link ModalDialog}.
	   *
	   * @return {ModalDialog}
	   *         the {@link ModalDialog} that was created
	   */
	  ;
	
	  _proto.createModal = function createModal(content, options) {
	    var _this22 = this;
	
	    options = options || {};
	    options.content = content || '';
	    var modal = new ModalDialog(this, options);
	    this.addChild(modal);
	    modal.on('dispose', function () {
	      _this22.removeChild(modal);
	    });
	    modal.open();
	    return modal;
	  }
	  /**
	   * Change breakpoint classes when the player resizes.
	   *
	   * @private
	   */
	  ;
	
	  _proto.updateCurrentBreakpoint_ = function updateCurrentBreakpoint_() {
	    if (!this.responsive()) {
	      return;
	    }
	
	    var currentBreakpoint = this.currentBreakpoint();
	    var currentWidth = this.currentWidth();
	
	    for (var i = 0; i < BREAKPOINT_ORDER.length; i++) {
	      var candidateBreakpoint = BREAKPOINT_ORDER[i];
	      var maxWidth = this.breakpoints_[candidateBreakpoint];
	
	      if (currentWidth <= maxWidth) {
	        // The current breakpoint did not change, nothing to do.
	        if (currentBreakpoint === candidateBreakpoint) {
	          return;
	        } // Only remove a class if there is a current breakpoint.
	
	
	        if (currentBreakpoint) {
	          this.removeClass(BREAKPOINT_CLASSES[currentBreakpoint]);
	        }
	
	        this.addClass(BREAKPOINT_CLASSES[candidateBreakpoint]);
	        this.breakpoint_ = candidateBreakpoint;
	        break;
	      }
	    }
	  }
	  /**
	   * Removes the current breakpoint.
	   *
	   * @private
	   */
	  ;
	
	  _proto.removeCurrentBreakpoint_ = function removeCurrentBreakpoint_() {
	    var className = this.currentBreakpointClass();
	    this.breakpoint_ = '';
	
	    if (className) {
	      this.removeClass(className);
	    }
	  }
	  /**
	   * Get or set breakpoints on the player.
	   *
	   * Calling this method with an object or `true` will remove any previous
	   * custom breakpoints and start from the defaults again.
	   *
	   * @param  {Object|boolean} [breakpoints]
	   *         If an object is given, it can be used to provide custom
	   *         breakpoints. If `true` is given, will set default breakpoints.
	   *         If this argument is not given, will simply return the current
	   *         breakpoints.
	   *
	   * @param  {number} [breakpoints.tiny]
	   *         The maximum width for the "vjs-layout-tiny" class.
	   *
	   * @param  {number} [breakpoints.xsmall]
	   *         The maximum width for the "vjs-layout-x-small" class.
	   *
	   * @param  {number} [breakpoints.small]
	   *         The maximum width for the "vjs-layout-small" class.
	   *
	   * @param  {number} [breakpoints.medium]
	   *         The maximum width for the "vjs-layout-medium" class.
	   *
	   * @param  {number} [breakpoints.large]
	   *         The maximum width for the "vjs-layout-large" class.
	   *
	   * @param  {number} [breakpoints.xlarge]
	   *         The maximum width for the "vjs-layout-x-large" class.
	   *
	   * @param  {number} [breakpoints.huge]
	   *         The maximum width for the "vjs-layout-huge" class.
	   *
	   * @return {Object}
	   *         An object mapping breakpoint names to maximum width values.
	   */
	  ;
	
	  _proto.breakpoints = function breakpoints(_breakpoints) {
	    // Used as a getter.
	    if (_breakpoints === undefined) {
	      return assign(this.breakpoints_);
	    }
	
	    this.breakpoint_ = '';
	    this.breakpoints_ = assign({}, DEFAULT_BREAKPOINTS, _breakpoints); // When breakpoint definitions change, we need to update the currently
	    // selected breakpoint.
	
	    this.updateCurrentBreakpoint_(); // Clone the breakpoints before returning.
	
	    return assign(this.breakpoints_);
	  }
	  /**
	   * Get or set a flag indicating whether or not this player should adjust
	   * its UI based on its dimensions.
	   *
	   * @param  {boolean} value
	   *         Should be `true` if the player should adjust its UI based on its
	   *         dimensions; otherwise, should be `false`.
	   *
	   * @return {boolean}
	   *         Will be `true` if this player should adjust its UI based on its
	   *         dimensions; otherwise, will be `false`.
	   */
	  ;
	
	  _proto.responsive = function responsive(value) {
	    // Used as a getter.
	    if (value === undefined) {
	      return this.responsive_;
	    }
	
	    value = Boolean(value);
	    var current = this.responsive_; // Nothing changed.
	
	    if (value === current) {
	      return;
	    } // The value actually changed, set it.
	
	
	    this.responsive_ = value; // Start listening for breakpoints and set the initial breakpoint if the
	    // player is now responsive.
	
	    if (value) {
	      this.on('playerresize', this.boundUpdateCurrentBreakpoint_);
	      this.updateCurrentBreakpoint_(); // Stop listening for breakpoints if the player is no longer responsive.
	    } else {
	      this.off('playerresize', this.boundUpdateCurrentBreakpoint_);
	      this.removeCurrentBreakpoint_();
	    }
	
	    return value;
	  }
	  /**
	   * Get current breakpoint name, if any.
	   *
	   * @return {string}
	   *         If there is currently a breakpoint set, returns a the key from the
	   *         breakpoints object matching it. Otherwise, returns an empty string.
	   */
	  ;
	
	  _proto.currentBreakpoint = function currentBreakpoint() {
	    return this.breakpoint_;
	  }
	  /**
	   * Get the current breakpoint class name.
	   *
	   * @return {string}
	   *         The matching class name (e.g. `"vjs-layout-tiny"` or
	   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
	   *         there is no current breakpoint.
	   */
	  ;
	
	  _proto.currentBreakpointClass = function currentBreakpointClass() {
	    return BREAKPOINT_CLASSES[this.breakpoint_] || '';
	  }
	  /**
	   * An object that describes a single piece of media.
	   *
	   * Properties that are not part of this type description will be retained; so,
	   * this can be viewed as a generic metadata storage mechanism as well.
	   *
	   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
	   * @typedef  {Object} Player~MediaObject
	   *
	   * @property {string} [album]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API.
	   *
	   * @property {string} [artist]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API.
	   *
	   * @property {Object[]} [artwork]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API. If not specified, will be populated via the `poster`, if
	   *           available.
	   *
	   * @property {string} [poster]
	   *           URL to an image that will display before playback.
	   *
	   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
	   *           A single source object, an array of source objects, or a string
	   *           referencing a URL to a media source. It is _highly recommended_
	   *           that an object or array of objects is used here, so that source
	   *           selection algorithms can take the `type` into account.
	   *
	   * @property {string} [title]
	   *           Unused, except if this object is passed to the `MediaSession`
	   *           API.
	   *
	   * @property {Object[]} [textTracks]
	   *           An array of objects to be used to create text tracks, following
	   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
	   *           For ease of removal, these will be created as "remote" text
	   *           tracks and set to automatically clean up on source changes.
	   *
	   *           These objects may have properties like `src`, `kind`, `label`,
	   *           and `language`, see {@link Tech#createRemoteTextTrack}.
	   */
	
	  /**
	   * Populate the player using a {@link Player~MediaObject|MediaObject}.
	   *
	   * @param  {Player~MediaObject} media
	   *         A media object.
	   *
	   * @param  {Function} ready
	   *         A callback to be called when the player is ready.
	   */
	  ;
	
	  _proto.loadMedia = function loadMedia(media, ready) {
	    var _this23 = this;
	
	    if (!media || typeof media !== 'object') {
	      return;
	    }
	
	    this.reset(); // Clone the media object so it cannot be mutated from outside.
	
	    this.cache_.media = mergeOptions$3(media);
	    var _this$cache_$media = this.cache_.media,
	        artwork = _this$cache_$media.artwork,
	        poster = _this$cache_$media.poster,
	        src = _this$cache_$media.src,
	        textTracks = _this$cache_$media.textTracks; // If `artwork` is not given, create it using `poster`.
	
	    if (!artwork && poster) {
	      this.cache_.media.artwork = [{
	        src: poster,
	        type: getMimetype(poster)
	      }];
	    }
	
	    if (src) {
	      this.src(src);
	    }
	
	    if (poster) {
	      this.poster(poster);
	    }
	
	    if (Array.isArray(textTracks)) {
	      textTracks.forEach(function (tt) {
	        return _this23.addRemoteTextTrack(tt, false);
	      });
	    }
	
	    this.ready(ready);
	  }
	  /**
	   * Get a clone of the current {@link Player~MediaObject} for this player.
	   *
	   * If the `loadMedia` method has not been used, will attempt to return a
	   * {@link Player~MediaObject} based on the current state of the player.
	   *
	   * @return {Player~MediaObject}
	   */
	  ;
	
	  _proto.getMedia = function getMedia() {
	    if (!this.cache_.media) {
	      var poster = this.poster();
	      var src = this.currentSources();
	      var textTracks = Array.prototype.map.call(this.remoteTextTracks(), function (tt) {
	        return {
	          kind: tt.kind,
	          label: tt.label,
	          language: tt.language,
	          src: tt.src
	        };
	      });
	      var media = {
	        src: src,
	        textTracks: textTracks
	      };
	
	      if (poster) {
	        media.poster = poster;
	        media.artwork = [{
	          src: media.poster,
	          type: getMimetype(media.poster)
	        }];
	      }
	
	      return media;
	    }
	
	    return mergeOptions$3(this.cache_.media);
	  }
	  /**
	   * Gets tag settings
	   *
	   * @param {Element} tag
	   *        The player tag
	   *
	   * @return {Object}
	   *         An object containing all of the settings
	   *         for a player tag
	   */
	  ;
	
	  Player.getTagSettings = function getTagSettings(tag) {
	    var baseOptions = {
	      sources: [],
	      tracks: []
	    };
	    var tagOptions = getAttributes(tag);
	    var dataSetup = tagOptions['data-setup'];
	
	    if (hasClass(tag, 'vjs-fill')) {
	      tagOptions.fill = true;
	    }
	
	    if (hasClass(tag, 'vjs-fluid')) {
	      tagOptions.fluid = true;
	    } // Check if data-setup attr exists.
	
	
	    if (dataSetup !== null) {
	      // Parse options JSON
	      // If empty string, make it a parsable json object.
	      var _safeParseTuple = safeParseTuple__default['default'](dataSetup || '{}'),
	          err = _safeParseTuple[0],
	          data = _safeParseTuple[1];
	
	      if (err) {
	        log$1.error(err);
	      }
	
	      assign(tagOptions, data);
	    }
	
	    assign(baseOptions, tagOptions); // Get tag children settings
	
	    if (tag.hasChildNodes()) {
	      var children = tag.childNodes;
	
	      for (var i = 0, j = children.length; i < j; i++) {
	        var child = children[i]; // Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
	
	        var childName = child.nodeName.toLowerCase();
	
	        if (childName === 'source') {
	          baseOptions.sources.push(getAttributes(child));
	        } else if (childName === 'track') {
	          baseOptions.tracks.push(getAttributes(child));
	        }
	      }
	    }
	
	    return baseOptions;
	  }
	  /**
	   * Determine whether or not flexbox is supported
	   *
	   * @return {boolean}
	   *         - true if flexbox is supported
	   *         - false if flexbox is not supported
	   */
	  ;
	
	  _proto.flexNotSupported_ = function flexNotSupported_() {
	    var elem = document__default['default'].createElement('i'); // Note: We don't actually use flexBasis (or flexOrder), but it's one of the more
	    // common flex features that we can rely on when checking for flex support.
	
	    return !('flexBasis' in elem.style || 'webkitFlexBasis' in elem.style || 'mozFlexBasis' in elem.style || 'msFlexBasis' in elem.style || // IE10-specific (2012 flex spec), available for completeness
	    'msFlexOrder' in elem.style);
	  }
	  /**
	   * Set debug mode to enable/disable logs at info level.
	   *
	   * @param {boolean} enabled
	   * @fires Player#debugon
	   * @fires Player#debugoff
	   */
	  ;
	
	  _proto.debug = function debug(enabled) {
	    if (enabled === undefined) {
	      return this.debugEnabled_;
	    }
	
	    if (enabled) {
	      this.trigger('debugon');
	      this.previousLogLevel_ = this.log.level;
	      this.log.level('debug');
	      this.debugEnabled_ = true;
	    } else {
	      this.trigger('debugoff');
	      this.log.level(this.previousLogLevel_);
	      this.previousLogLevel_ = undefined;
	      this.debugEnabled_ = false;
	    }
	  }
	  /**
	   * Set or get current playback rates.
	   * Takes an array and updates the playback rates menu with the new items.
	   * Pass in an empty array to hide the menu.
	   * Values other than arrays are ignored.
	   *
	   * @fires Player#playbackrateschange
	   * @param {number[]} newRates
	   *                   The new rates that the playback rates menu should update to.
	   *                   An empty array will hide the menu
	   * @return {number[]} When used as a getter will return the current playback rates
	   */
	  ;
	
	  _proto.playbackRates = function playbackRates(newRates) {
	    if (newRates === undefined) {
	      return this.cache_.playbackRates;
	    } // ignore any value that isn't an array
	
	
	    if (!Array.isArray(newRates)) {
	      return;
	    } // ignore any arrays that don't only contain numbers
	
	
	    if (!newRates.every(function (rate) {
	      return typeof rate === 'number';
	    })) {
	      return;
	    }
	
	    this.cache_.playbackRates = newRates;
	    /**
	    * fires when the playback rates in a player are changed
	    *
	    * @event Player#playbackrateschange
	    * @type {EventTarget~Event}
	    */
	
	    this.trigger('playbackrateschange');
	  };
	
	  return Player;
	}(Component$1);
	/**
	 * Get the {@link VideoTrackList}
	 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
	 *
	 * @return {VideoTrackList}
	 *         the current video track list
	 *
	 * @method Player.prototype.videoTracks
	 */
	
	/**
	 * Get the {@link AudioTrackList}
	 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
	 *
	 * @return {AudioTrackList}
	 *         the current audio track list
	 *
	 * @method Player.prototype.audioTracks
	 */
	
	/**
	 * Get the {@link TextTrackList}
	 *
	 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
	 *
	 * @return {TextTrackList}
	 *         the current text track list
	 *
	 * @method Player.prototype.textTracks
	 */
	
	/**
	 * Get the remote {@link TextTrackList}
	 *
	 * @return {TextTrackList}
	 *         The current remote text track list
	 *
	 * @method Player.prototype.remoteTextTracks
	 */
	
	/**
	 * Get the remote {@link HtmlTrackElementList} tracks.
	 *
	 * @return {HtmlTrackElementList}
	 *         The current remote text track element list
	 *
	 * @method Player.prototype.remoteTextTrackEls
	 */
	
	
	ALL.names.forEach(function (name) {
	  var props = ALL[name];
	
	  Player.prototype[props.getterName] = function () {
	    if (this.tech_) {
	      return this.tech_[props.getterName]();
	    } // if we have not yet loadTech_, we create {video,audio,text}Tracks_
	    // these will be passed to the tech during loading
	
	
	    this[props.privateName] = this[props.privateName] || new props.ListClass();
	    return this[props.privateName];
	  };
	});
	/**
	 * Get or set the `Player`'s crossorigin option. For the HTML5 player, this
	 * sets the `crossOrigin` property on the `<video>` tag to control the CORS
	 * behavior.
	 *
	 * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
	 *
	 * @param {string} [value]
	 *        The value to set the `Player`'s crossorigin to. If an argument is
	 *        given, must be one of `anonymous` or `use-credentials`.
	 *
	 * @return {string|undefined}
	 *         - The current crossorigin value of the `Player` when getting.
	 *         - undefined when setting
	 */
	
	Player.prototype.crossorigin = Player.prototype.crossOrigin;
	/**
	 * Global enumeration of players.
	 *
	 * The keys are the player IDs and the values are either the {@link Player}
	 * instance or `null` for disposed players.
	 *
	 * @type {Object}
	 */
	
	Player.players = {};
	var navigator = window__default['default'].navigator;
	/*
	 * Player instance options, surfaced using options
	 * options = Player.prototype.options_
	 * Make changes in options, not here.
	 *
	 * @type {Object}
	 * @private
	 */
	
	Player.prototype.options_ = {
	  // Default order of fallback technology
	  techOrder: Tech.defaultTechOrder_,
	  html5: {},
	  // default inactivity timeout
	  inactivityTimeout: 2000,
	  // default playback rates
	  playbackRates: [],
	  // Add playback rate selection by adding rates
	  // 'playbackRates': [0.5, 1, 1.5, 2],
	  liveui: false,
	  // Included control sets
	  children: ['mediaLoader', 'posterImage', 'textTrackDisplay', 'loadingSpinner', 'bigPlayButton', 'liveTracker', 'controlBar', 'errorDisplay', 'textTrackSettings', 'resizeManager'],
	  language: navigator && (navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language) || 'en',
	  // locales and their language translations
	  languages: {},
	  // Default message to show when a video cannot be played.
	  notSupportedMessage: 'No compatible source was found for this media.',
	  normalizeAutoplay: false,
	  fullscreen: {
	    options: {
	      navigationUI: 'hide'
	    }
	  },
	  breakpoints: {},
	  responsive: false,
	  audioOnlyMode: false,
	  audioPosterMode: false
	};
	[
	/**
	 * Returns whether or not the player is in the "ended" state.
	 *
	 * @return {Boolean} True if the player is in the ended state, false if not.
	 * @method Player#ended
	 */
	'ended',
	/**
	 * Returns whether or not the player is in the "seeking" state.
	 *
	 * @return {Boolean} True if the player is in the seeking state, false if not.
	 * @method Player#seeking
	 */
	'seeking',
	/**
	 * Returns the TimeRanges of the media that are currently available
	 * for seeking to.
	 *
	 * @return {TimeRanges} the seekable intervals of the media timeline
	 * @method Player#seekable
	 */
	'seekable',
	/**
	 * Returns the current state of network activity for the element, from
	 * the codes in the list below.
	 * - NETWORK_EMPTY (numeric value 0)
	 *   The element has not yet been initialised. All attributes are in
	 *   their initial states.
	 * - NETWORK_IDLE (numeric value 1)
	 *   The element's resource selection algorithm is active and has
	 *   selected a resource, but it is not actually using the network at
	 *   this time.
	 * - NETWORK_LOADING (numeric value 2)
	 *   The user agent is actively trying to download data.
	 * - NETWORK_NO_SOURCE (numeric value 3)
	 *   The element's resource selection algorithm is active, but it has
	 *   not yet found a resource to use.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
	 * @return {number} the current network activity state
	 * @method Player#networkState
	 */
	'networkState',
	/**
	 * Returns a value that expresses the current state of the element
	 * with respect to rendering the current playback position, from the
	 * codes in the list below.
	 * - HAVE_NOTHING (numeric value 0)
	 *   No information regarding the media resource is available.
	 * - HAVE_METADATA (numeric value 1)
	 *   Enough of the resource has been obtained that the duration of the
	 *   resource is available.
	 * - HAVE_CURRENT_DATA (numeric value 2)
	 *   Data for the immediate current playback position is available.
	 * - HAVE_FUTURE_DATA (numeric value 3)
	 *   Data for the immediate current playback position is available, as
	 *   well as enough data for the user agent to advance the current
	 *   playback position in the direction of playback.
	 * - HAVE_ENOUGH_DATA (numeric value 4)
	 *   The user agent estimates that enough data is available for
	 *   playback to proceed uninterrupted.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
	 * @return {number} the current playback rendering state
	 * @method Player#readyState
	 */
	'readyState'].forEach(function (fn) {
	  Player.prototype[fn] = function () {
	    return this.techGet_(fn);
	  };
	});
	TECH_EVENTS_RETRIGGER.forEach(function (event) {
	  Player.prototype["handleTech" + toTitleCase$1(event) + "_"] = function () {
	    return this.trigger(event);
	  };
	});
	/**
	 * Fired when the player has initial duration and dimension information
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the player has downloaded data at the current playback position
	 *
	 * @event Player#loadeddata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the current playback position has changed *
	 * During playback this is fired every 15-250 milliseconds, depending on the
	 * playback technology in use.
	 *
	 * @event Player#timeupdate
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the volume changes
	 *
	 * @event Player#volumechange
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Reports whether or not a player has a plugin available.
	 *
	 * This does not report whether or not the plugin has ever been initialized
	 * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
	 *
	 * @method Player#hasPlugin
	 * @param  {string}  name
	 *         The name of a plugin.
	 *
	 * @return {boolean}
	 *         Whether or not this player has the requested plugin available.
	 */
	
	/**
	 * Reports whether or not a player is using a plugin by name.
	 *
	 * For basic plugins, this only reports whether the plugin has _ever_ been
	 * initialized on this player.
	 *
	 * @method Player#usingPlugin
	 * @param  {string} name
	 *         The name of a plugin.
	 *
	 * @return {boolean}
	 *         Whether or not this player is using the requested plugin.
	 */
	
	Component$1.registerComponent('Player', Player);
	
	/**
	 * The base plugin name.
	 *
	 * @private
	 * @constant
	 * @type {string}
	 */
	
	var BASE_PLUGIN_NAME = 'plugin';
	/**
	 * The key on which a player's active plugins cache is stored.
	 *
	 * @private
	 * @constant
	 * @type     {string}
	 */
	
	var PLUGIN_CACHE_KEY = 'activePlugins_';
	/**
	 * Stores registered plugins in a private space.
	 *
	 * @private
	 * @type    {Object}
	 */
	
	var pluginStorage = {};
	/**
	 * Reports whether or not a plugin has been registered.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of a plugin.
	 *
	 * @return {boolean}
	 *          Whether or not the plugin has been registered.
	 */
	
	var pluginExists = function pluginExists(name) {
	  return pluginStorage.hasOwnProperty(name);
	};
	/**
	 * Get a single registered plugin by name.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of a plugin.
	 *
	 * @return {Function|undefined}
	 *          The plugin (or undefined).
	 */
	
	
	var getPlugin = function getPlugin(name) {
	  return pluginExists(name) ? pluginStorage[name] : undefined;
	};
	/**
	 * Marks a plugin as "active" on a player.
	 *
	 * Also, ensures that the player has an object for tracking active plugins.
	 *
	 * @private
	 * @param   {Player} player
	 *          A Video.js player instance.
	 *
	 * @param   {string} name
	 *          The name of a plugin.
	 */
	
	
	var markPluginAsActive = function markPluginAsActive(player, name) {
	  player[PLUGIN_CACHE_KEY] = player[PLUGIN_CACHE_KEY] || {};
	  player[PLUGIN_CACHE_KEY][name] = true;
	};
	/**
	 * Triggers a pair of plugin setup events.
	 *
	 * @private
	 * @param  {Player} player
	 *         A Video.js player instance.
	 *
	 * @param  {Plugin~PluginEventHash} hash
	 *         A plugin event hash.
	 *
	 * @param  {boolean} [before]
	 *         If true, prefixes the event name with "before". In other words,
	 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
	 */
	
	
	var triggerSetupEvent = function triggerSetupEvent(player, hash, before) {
	  var eventName = (before ? 'before' : '') + 'pluginsetup';
	  player.trigger(eventName, hash);
	  player.trigger(eventName + ':' + hash.name, hash);
	};
	/**
	 * Takes a basic plugin function and returns a wrapper function which marks
	 * on the player that the plugin has been activated.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of the plugin.
	 *
	 * @param   {Function} plugin
	 *          The basic plugin.
	 *
	 * @return {Function}
	 *          A wrapper function for the given plugin.
	 */
	
	
	var createBasicPlugin = function createBasicPlugin(name, plugin) {
	  var basicPluginWrapper = function basicPluginWrapper() {
	    // We trigger the "beforepluginsetup" and "pluginsetup" events on the player
	    // regardless, but we want the hash to be consistent with the hash provided
	    // for advanced plugins.
	    //
	    // The only potentially counter-intuitive thing here is the `instance` in
	    // the "pluginsetup" event is the value returned by the `plugin` function.
	    triggerSetupEvent(this, {
	      name: name,
	      plugin: plugin,
	      instance: null
	    }, true);
	    var instance = plugin.apply(this, arguments);
	    markPluginAsActive(this, name);
	    triggerSetupEvent(this, {
	      name: name,
	      plugin: plugin,
	      instance: instance
	    });
	    return instance;
	  };
	
	  Object.keys(plugin).forEach(function (prop) {
	    basicPluginWrapper[prop] = plugin[prop];
	  });
	  return basicPluginWrapper;
	};
	/**
	 * Takes a plugin sub-class and returns a factory function for generating
	 * instances of it.
	 *
	 * This factory function will replace itself with an instance of the requested
	 * sub-class of Plugin.
	 *
	 * @private
	 * @param   {string} name
	 *          The name of the plugin.
	 *
	 * @param   {Plugin} PluginSubClass
	 *          The advanced plugin.
	 *
	 * @return {Function}
	 */
	
	
	var createPluginFactory = function createPluginFactory(name, PluginSubClass) {
	  // Add a `name` property to the plugin prototype so that each plugin can
	  // refer to itself by name.
	  PluginSubClass.prototype.name = name;
	  return function () {
	    triggerSetupEvent(this, {
	      name: name,
	      plugin: PluginSubClass,
	      instance: null
	    }, true);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var instance = _construct__default['default'](PluginSubClass, [this].concat(args)); // The plugin is replaced by a function that returns the current instance.
	
	
	    this[name] = function () {
	      return instance;
	    };
	
	    triggerSetupEvent(this, instance.getEventHash());
	    return instance;
	  };
	};
	/**
	 * Parent class for all advanced plugins.
	 *
	 * @mixes   module:evented~EventedMixin
	 * @mixes   module:stateful~StatefulMixin
	 * @fires   Player#beforepluginsetup
	 * @fires   Player#beforepluginsetup:$name
	 * @fires   Player#pluginsetup
	 * @fires   Player#pluginsetup:$name
	 * @listens Player#dispose
	 * @throws  {Error}
	 *          If attempting to instantiate the base {@link Plugin} class
	 *          directly instead of via a sub-class.
	 */
	
	
	var Plugin = /*#__PURE__*/function () {
	  /**
	   * Creates an instance of this class.
	   *
	   * Sub-classes should call `super` to ensure plugins are properly initialized.
	   *
	   * @param {Player} player
	   *        A Video.js player instance.
	   */
	  function Plugin(player) {
	    if (this.constructor === Plugin) {
	      throw new Error('Plugin must be sub-classed; not directly instantiated.');
	    }
	
	    this.player = player;
	
	    if (!this.log) {
	      this.log = this.player.log.createLogger(this.name);
	    } // Make this object evented, but remove the added `trigger` method so we
	    // use the prototype version instead.
	
	
	    evented(this);
	    delete this.trigger;
	    stateful(this, this.constructor.defaultState);
	    markPluginAsActive(player, this.name); // Auto-bind the dispose method so we can use it as a listener and unbind
	    // it later easily.
	
	    this.dispose = this.dispose.bind(this); // If the player is disposed, dispose the plugin.
	
	    player.on('dispose', this.dispose);
	  }
	  /**
	   * Get the version of the plugin that was set on <pluginName>.VERSION
	   */
	
	
	  var _proto = Plugin.prototype;
	
	  _proto.version = function version() {
	    return this.constructor.VERSION;
	  }
	  /**
	   * Each event triggered by plugins includes a hash of additional data with
	   * conventional properties.
	   *
	   * This returns that object or mutates an existing hash.
	   *
	   * @param   {Object} [hash={}]
	   *          An object to be used as event an event hash.
	   *
	   * @return {Plugin~PluginEventHash}
	   *          An event hash object with provided properties mixed-in.
	   */
	  ;
	
	  _proto.getEventHash = function getEventHash(hash) {
	    if (hash === void 0) {
	      hash = {};
	    }
	
	    hash.name = this.name;
	    hash.plugin = this.constructor;
	    hash.instance = this;
	    return hash;
	  }
	  /**
	   * Triggers an event on the plugin object and overrides
	   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
	   *
	   * @param   {string|Object} event
	   *          An event type or an object with a type property.
	   *
	   * @param   {Object} [hash={}]
	   *          Additional data hash to merge with a
	   *          {@link Plugin~PluginEventHash|PluginEventHash}.
	   *
	   * @return {boolean}
	   *          Whether or not default was prevented.
	   */
	  ;
	
	  _proto.trigger = function trigger$1(event, hash) {
	    if (hash === void 0) {
	      hash = {};
	    }
	
	    return trigger(this.eventBusEl_, event, this.getEventHash(hash));
	  }
	  /**
	   * Handles "statechanged" events on the plugin. No-op by default, override by
	   * subclassing.
	   *
	   * @abstract
	   * @param    {Event} e
	   *           An event object provided by a "statechanged" event.
	   *
	   * @param    {Object} e.changes
	   *           An object describing changes that occurred with the "statechanged"
	   *           event.
	   */
	  ;
	
	  _proto.handleStateChanged = function handleStateChanged(e) {}
	  /**
	   * Disposes a plugin.
	   *
	   * Subclasses can override this if they want, but for the sake of safety,
	   * it's probably best to subscribe the "dispose" event.
	   *
	   * @fires Plugin#dispose
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    var name = this.name,
	        player = this.player;
	    /**
	     * Signals that a advanced plugin is about to be disposed.
	     *
	     * @event Plugin#dispose
	     * @type  {EventTarget~Event}
	     */
	
	    this.trigger('dispose');
	    this.off();
	    player.off('dispose', this.dispose); // Eliminate any possible sources of leaking memory by clearing up
	    // references between the player and the plugin instance and nulling out
	    // the plugin's state and replacing methods with a function that throws.
	
	    player[PLUGIN_CACHE_KEY][name] = false;
	    this.player = this.state = null; // Finally, replace the plugin name on the player with a new factory
	    // function, so that the plugin is ready to be set up again.
	
	    player[name] = createPluginFactory(name, pluginStorage[name]);
	  }
	  /**
	   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
	   *
	   * @param   {string|Function} plugin
	   *          If a string, matches the name of a plugin. If a function, will be
	   *          tested directly.
	   *
	   * @return {boolean}
	   *          Whether or not a plugin is a basic plugin.
	   */
	  ;
	
	  Plugin.isBasic = function isBasic(plugin) {
	    var p = typeof plugin === 'string' ? getPlugin(plugin) : plugin;
	    return typeof p === 'function' && !Plugin.prototype.isPrototypeOf(p.prototype);
	  }
	  /**
	   * Register a Video.js plugin.
	   *
	   * @param   {string} name
	   *          The name of the plugin to be registered. Must be a string and
	   *          must not match an existing plugin or a method on the `Player`
	   *          prototype.
	   *
	   * @param   {Function} plugin
	   *          A sub-class of `Plugin` or a function for basic plugins.
	   *
	   * @return {Function}
	   *          For advanced plugins, a factory function for that plugin. For
	   *          basic plugins, a wrapper function that initializes the plugin.
	   */
	  ;
	
	  Plugin.registerPlugin = function registerPlugin(name, plugin) {
	    if (typeof name !== 'string') {
	      throw new Error("Illegal plugin name, \"" + name + "\", must be a string, was " + typeof name + ".");
	    }
	
	    if (pluginExists(name)) {
	      log$1.warn("A plugin named \"" + name + "\" already exists. You may want to avoid re-registering plugins!");
	    } else if (Player.prototype.hasOwnProperty(name)) {
	      throw new Error("Illegal plugin name, \"" + name + "\", cannot share a name with an existing player method!");
	    }
	
	    if (typeof plugin !== 'function') {
	      throw new Error("Illegal plugin for \"" + name + "\", must be a function, was " + typeof plugin + ".");
	    }
	
	    pluginStorage[name] = plugin; // Add a player prototype method for all sub-classed plugins (but not for
	    // the base Plugin class).
	
	    if (name !== BASE_PLUGIN_NAME) {
	      if (Plugin.isBasic(plugin)) {
	        Player.prototype[name] = createBasicPlugin(name, plugin);
	      } else {
	        Player.prototype[name] = createPluginFactory(name, plugin);
	      }
	    }
	
	    return plugin;
	  }
	  /**
	   * De-register a Video.js plugin.
	   *
	   * @param  {string} name
	   *         The name of the plugin to be de-registered. Must be a string that
	   *         matches an existing plugin.
	   *
	   * @throws {Error}
	   *         If an attempt is made to de-register the base plugin.
	   */
	  ;
	
	  Plugin.deregisterPlugin = function deregisterPlugin(name) {
	    if (name === BASE_PLUGIN_NAME) {
	      throw new Error('Cannot de-register base plugin.');
	    }
	
	    if (pluginExists(name)) {
	      delete pluginStorage[name];
	      delete Player.prototype[name];
	    }
	  }
	  /**
	   * Gets an object containing multiple Video.js plugins.
	   *
	   * @param   {Array} [names]
	   *          If provided, should be an array of plugin names. Defaults to _all_
	   *          plugin names.
	   *
	   * @return {Object|undefined}
	   *          An object containing plugin(s) associated with their name(s) or
	   *          `undefined` if no matching plugins exist).
	   */
	  ;
	
	  Plugin.getPlugins = function getPlugins(names) {
	    if (names === void 0) {
	      names = Object.keys(pluginStorage);
	    }
	
	    var result;
	    names.forEach(function (name) {
	      var plugin = getPlugin(name);
	
	      if (plugin) {
	        result = result || {};
	        result[name] = plugin;
	      }
	    });
	    return result;
	  }
	  /**
	   * Gets a plugin's version, if available
	   *
	   * @param   {string} name
	   *          The name of a plugin.
	   *
	   * @return {string}
	   *          The plugin's version or an empty string.
	   */
	  ;
	
	  Plugin.getPluginVersion = function getPluginVersion(name) {
	    var plugin = getPlugin(name);
	    return plugin && plugin.VERSION || '';
	  };
	
	  return Plugin;
	}();
	/**
	 * Gets a plugin by name if it exists.
	 *
	 * @static
	 * @method   getPlugin
	 * @memberOf Plugin
	 * @param    {string} name
	 *           The name of a plugin.
	 *
	 * @returns  {Function|undefined}
	 *           The plugin (or `undefined`).
	 */
	
	
	Plugin.getPlugin = getPlugin;
	/**
	 * The name of the base plugin class as it is registered.
	 *
	 * @type {string}
	 */
	
	Plugin.BASE_PLUGIN_NAME = BASE_PLUGIN_NAME;
	Plugin.registerPlugin(BASE_PLUGIN_NAME, Plugin);
	/**
	 * Documented in player.js
	 *
	 * @ignore
	 */
	
	Player.prototype.usingPlugin = function (name) {
	  return !!this[PLUGIN_CACHE_KEY] && this[PLUGIN_CACHE_KEY][name] === true;
	};
	/**
	 * Documented in player.js
	 *
	 * @ignore
	 */
	
	
	Player.prototype.hasPlugin = function (name) {
	  return !!pluginExists(name);
	};
	/**
	 * Signals that a plugin is about to be set up on a player.
	 *
	 * @event    Player#beforepluginsetup
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * Signals that a plugin is about to be set up on a player - by name. The name
	 * is the name of the plugin.
	 *
	 * @event    Player#beforepluginsetup:$name
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * Signals that a plugin has just been set up on a player.
	 *
	 * @event    Player#pluginsetup
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * Signals that a plugin has just been set up on a player - by name. The name
	 * is the name of the plugin.
	 *
	 * @event    Player#pluginsetup:$name
	 * @type     {Plugin~PluginEventHash}
	 */
	
	/**
	 * @typedef  {Object} Plugin~PluginEventHash
	 *
	 * @property {string} instance
	 *           For basic plugins, the return value of the plugin function. For
	 *           advanced plugins, the plugin instance on which the event is fired.
	 *
	 * @property {string} name
	 *           The name of the plugin.
	 *
	 * @property {string} plugin
	 *           For basic plugins, the plugin function. For advanced plugins, the
	 *           plugin class/constructor.
	 */
	
	/**
	 * @file extend.js
	 * @module extend
	 */
	var hasLogged = false;
	/**
	 * Used to subclass an existing class by emulating ES subclassing using the
	 * `extends` keyword.
	 *
	 * @function
	 * @deprecated
	 * @example
	 * var MyComponent = videojs.extend(videojs.getComponent('Component'), {
	 *   myCustomMethod: function() {
	 *     // Do things in my method.
	 *   }
	 * });
	 *
	 * @param    {Function} superClass
	 *           The class to inherit from
	 *
	 * @param    {Object}   [subClassMethods={}]
	 *           Methods of the new class
	 *
	 * @return   {Function}
	 *           The new class with subClassMethods that inherited superClass.
	 */
	
	var extend = function extend(superClass, subClassMethods) {
	  if (subClassMethods === void 0) {
	    subClassMethods = {};
	  }
	
	  // Log a warning the first time extend is called to note that it is deprecated
	  // It was previously deprecated in our documentation (guides, specifically),
	  // but was never formally deprecated in code.
	  if (!hasLogged) {
	    log$1.warn('videojs.extend is deprecated as of Video.js 7.22.0 and will be removed in Video.js 8.0.0');
	    hasLogged = true;
	  }
	
	  var subClass = function subClass() {
	    superClass.apply(this, arguments);
	  };
	
	  var methods = {};
	
	  if (typeof subClassMethods === 'object') {
	    if (subClassMethods.constructor !== Object.prototype.constructor) {
	      subClass = subClassMethods.constructor;
	    }
	
	    methods = subClassMethods;
	  } else if (typeof subClassMethods === 'function') {
	    subClass = subClassMethods;
	  }
	
	  _inherits__default['default'](subClass, superClass); // this is needed for backward-compatibility and node compatibility.
	
	
	  if (superClass) {
	    subClass.super_ = superClass;
	  } // Extend subObj's prototype with functions and other properties from props
	
	
	  for (var name in methods) {
	    if (methods.hasOwnProperty(name)) {
	      subClass.prototype[name] = methods[name];
	    }
	  }
	
	  return subClass;
	};
	
	/**
	 * @file video.js
	 * @module videojs
	 */
	/**
	 * Normalize an `id` value by trimming off a leading `#`
	 *
	 * @private
	 * @param   {string} id
	 *          A string, maybe with a leading `#`.
	 *
	 * @return {string}
	 *          The string, without any leading `#`.
	 */
	
	var normalizeId = function normalizeId(id) {
	  return id.indexOf('#') === 0 ? id.slice(1) : id;
	};
	/**
	 * The `videojs()` function doubles as the main function for users to create a
	 * {@link Player} instance as well as the main library namespace.
	 *
	 * It can also be used as a getter for a pre-existing {@link Player} instance.
	 * However, we _strongly_ recommend using `videojs.getPlayer()` for this
	 * purpose because it avoids any potential for unintended initialization.
	 *
	 * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
	 * of our JSDoc template, we cannot properly document this as both a function
	 * and a namespace, so its function signature is documented here.
	 *
	 * #### Arguments
	 * ##### id
	 * string|Element, **required**
	 *
	 * Video element or video element ID.
	 *
	 * ##### options
	 * Object, optional
	 *
	 * Options object for providing settings.
	 * See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
	 *
	 * ##### ready
	 * {@link Component~ReadyCallback}, optional
	 *
	 * A function to be called when the {@link Player} and {@link Tech} are ready.
	 *
	 * #### Return Value
	 *
	 * The `videojs()` function returns a {@link Player} instance.
	 *
	 * @namespace
	 *
	 * @borrows AudioTrack as AudioTrack
	 * @borrows Component.getComponent as getComponent
	 * @borrows module:computed-style~computedStyle as computedStyle
	 * @borrows module:events.on as on
	 * @borrows module:events.one as one
	 * @borrows module:events.off as off
	 * @borrows module:events.trigger as trigger
	 * @borrows EventTarget as EventTarget
	 * @borrows module:extend~extend as extend
	 * @borrows module:fn.bind as bind
	 * @borrows module:format-time.formatTime as formatTime
	 * @borrows module:format-time.resetFormatTime as resetFormatTime
	 * @borrows module:format-time.setFormatTime as setFormatTime
	 * @borrows module:merge-options.mergeOptions as mergeOptions
	 * @borrows module:middleware.use as use
	 * @borrows Player.players as players
	 * @borrows Plugin.registerPlugin as registerPlugin
	 * @borrows Plugin.deregisterPlugin as deregisterPlugin
	 * @borrows Plugin.getPlugins as getPlugins
	 * @borrows Plugin.getPlugin as getPlugin
	 * @borrows Plugin.getPluginVersion as getPluginVersion
	 * @borrows Tech.getTech as getTech
	 * @borrows Tech.registerTech as registerTech
	 * @borrows TextTrack as TextTrack
	 * @borrows module:time-ranges.createTimeRanges as createTimeRange
	 * @borrows module:time-ranges.createTimeRanges as createTimeRanges
	 * @borrows module:url.isCrossOrigin as isCrossOrigin
	 * @borrows module:url.parseUrl as parseUrl
	 * @borrows VideoTrack as VideoTrack
	 *
	 * @param  {string|Element} id
	 *         Video element or video element ID.
	 *
	 * @param  {Object} [options]
	 *         Options object for providing settings.
	 *         See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
	 *
	 * @param  {Component~ReadyCallback} [ready]
	 *         A function to be called when the {@link Player} and {@link Tech} are
	 *         ready.
	 *
	 * @return {Player}
	 *         The `videojs()` function returns a {@link Player|Player} instance.
	 */
	
	
	function videojs(id, options, ready) {
	  var player = videojs.getPlayer(id);
	
	  if (player) {
	    if (options) {
	      log$1.warn("Player \"" + id + "\" is already initialised. Options will not be applied.");
	    }
	
	    if (ready) {
	      player.ready(ready);
	    }
	
	    return player;
	  }
	
	  var el = typeof id === 'string' ? $('#' + normalizeId(id)) : id;
	
	  if (!isEl(el)) {
	    throw new TypeError('The element or ID supplied is not valid. (videojs)');
	  } // document.body.contains(el) will only check if el is contained within that one document.
	  // This causes problems for elements in iframes.
	  // Instead, use the element's ownerDocument instead of the global document.
	  // This will make sure that the element is indeed in the dom of that document.
	  // Additionally, check that the document in question has a default view.
	  // If the document is no longer attached to the dom, the defaultView of the document will be null.
	
	
	  if (!el.ownerDocument.defaultView || !el.ownerDocument.body.contains(el)) {
	    log$1.warn('The element supplied is not included in the DOM');
	  }
	
	  options = options || {}; // Store a copy of the el before modification, if it is to be restored in destroy()
	  // If div ingest, store the parent div
	
	  if (options.restoreEl === true) {
	    options.restoreEl = (el.parentNode && el.parentNode.hasAttribute('data-vjs-player') ? el.parentNode : el).cloneNode(true);
	  }
	
	  hooks('beforesetup').forEach(function (hookFunction) {
	    var opts = hookFunction(el, mergeOptions$3(options));
	
	    if (!isObject(opts) || Array.isArray(opts)) {
	      log$1.error('please return an object in beforesetup hooks');
	      return;
	    }
	
	    options = mergeOptions$3(options, opts);
	  }); // We get the current "Player" component here in case an integration has
	  // replaced it with a custom player.
	
	  var PlayerComponent = Component$1.getComponent('Player');
	  player = new PlayerComponent(el, options, ready);
	  hooks('setup').forEach(function (hookFunction) {
	    return hookFunction(player);
	  });
	  return player;
	}
	
	videojs.hooks_ = hooks_;
	videojs.hooks = hooks;
	videojs.hook = hook;
	videojs.hookOnce = hookOnce;
	videojs.removeHook = removeHook; // Add default styles
	
	if (window__default['default'].VIDEOJS_NO_DYNAMIC_STYLE !== true && isReal()) {
	  var style = $('.vjs-styles-defaults');
	
	  if (!style) {
	    style = createStyleElement('vjs-styles-defaults');
	    var head = $('head');
	
	    if (head) {
	      head.insertBefore(style, head.firstChild);
	    }
	
	    setTextContent(style, "\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: 56.25%\n      }\n    ");
	  }
	} // Run Auto-load players
	// You have to wait at least once in case this script is loaded after your
	// video in the DOM (weird behavior only with minified version)
	
	
	autoSetupTimeout(1, videojs);
	/**
	 * Current Video.js version. Follows [semantic versioning](https://semver.org/).
	 *
	 * @type {string}
	 */
	
	videojs.VERSION = version$5;
	/**
	 * The global options object. These are the settings that take effect
	 * if no overrides are specified when the player is created.
	 *
	 * @type {Object}
	 */
	
	videojs.options = Player.prototype.options_;
	/**
	 * Get an object with the currently created players, keyed by player ID
	 *
	 * @return {Object}
	 *         The created players
	 */
	
	videojs.getPlayers = function () {
	  return Player.players;
	};
	/**
	 * Get a single player based on an ID or DOM element.
	 *
	 * This is useful if you want to check if an element or ID has an associated
	 * Video.js player, but not create one if it doesn't.
	 *
	 * @param   {string|Element} id
	 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
	 *          or a string matching the `id` of such an element.
	 *
	 * @return {Player|undefined}
	 *          A player instance or `undefined` if there is no player instance
	 *          matching the argument.
	 */
	
	
	videojs.getPlayer = function (id) {
	  var players = Player.players;
	  var tag;
	
	  if (typeof id === 'string') {
	    var nId = normalizeId(id);
	    var player = players[nId];
	
	    if (player) {
	      return player;
	    }
	
	    tag = $('#' + nId);
	  } else {
	    tag = id;
	  }
	
	  if (isEl(tag)) {
	    var _tag = tag,
	        _player = _tag.player,
	        playerId = _tag.playerId; // Element may have a `player` property referring to an already created
	    // player instance. If so, return that.
	
	    if (_player || players[playerId]) {
	      return _player || players[playerId];
	    }
	  }
	};
	/**
	 * Returns an array of all current players.
	 *
	 * @return {Array}
	 *         An array of all players. The array will be in the order that
	 *         `Object.keys` provides, which could potentially vary between
	 *         JavaScript engines.
	 *
	 */
	
	
	videojs.getAllPlayers = function () {
	  return (// Disposed players leave a key with a `null` value, so we need to make sure
	    // we filter those out.
	    Object.keys(Player.players).map(function (k) {
	      return Player.players[k];
	    }).filter(Boolean)
	  );
	};
	
	videojs.players = Player.players;
	videojs.getComponent = Component$1.getComponent;
	/**
	 * Register a component so it can referred to by name. Used when adding to other
	 * components, either through addChild `component.addChild('myComponent')` or through
	 * default children options  `{ children: ['myComponent'] }`.
	 *
	 * > NOTE: You could also just initialize the component before adding.
	 * `component.addChild(new MyComponent());`
	 *
	 * @param {string} name
	 *        The class name of the component
	 *
	 * @param {Component} comp
	 *        The component class
	 *
	 * @return {Component}
	 *         The newly registered component
	 */
	
	videojs.registerComponent = function (name, comp) {
	  if (Tech.isTech(comp)) {
	    log$1.warn("The " + name + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)");
	  }
	
	  Component$1.registerComponent.call(Component$1, name, comp);
	};
	
	videojs.getTech = Tech.getTech;
	videojs.registerTech = Tech.registerTech;
	videojs.use = use;
	/**
	 * An object that can be returned by a middleware to signify
	 * that the middleware is being terminated.
	 *
	 * @type {object}
	 * @property {object} middleware.TERMINATOR
	 */
	
	Object.defineProperty(videojs, 'middleware', {
	  value: {},
	  writeable: false,
	  enumerable: true
	});
	Object.defineProperty(videojs.middleware, 'TERMINATOR', {
	  value: TERMINATOR,
	  writeable: false,
	  enumerable: true
	});
	/**
	 * A reference to the {@link module:browser|browser utility module} as an object.
	 *
	 * @type {Object}
	 * @see  {@link module:browser|browser}
	 */
	
	videojs.browser = browser;
	/**
	 * Use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED} instead; only
	 * included for backward-compatibility with 4.x.
	 *
	 * @deprecated Since version 5.0, use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED instead.
	 * @type {boolean}
	 */
	
	videojs.TOUCH_ENABLED = TOUCH_ENABLED;
	videojs.extend = extend;
	videojs.mergeOptions = mergeOptions$3;
	videojs.bind = bind;
	videojs.registerPlugin = Plugin.registerPlugin;
	videojs.deregisterPlugin = Plugin.deregisterPlugin;
	/**
	 * Deprecated method to register a plugin with Video.js
	 *
	 * @deprecated videojs.plugin() is deprecated; use videojs.registerPlugin() instead
	 *
	 * @param {string} name
	 *        The plugin name
	 *
	 * @param {Plugin|Function} plugin
	 *         The plugin sub-class or function
	 */
	
	videojs.plugin = function (name, plugin) {
	  log$1.warn('videojs.plugin() is deprecated; use videojs.registerPlugin() instead');
	  return Plugin.registerPlugin(name, plugin);
	};
	
	videojs.getPlugins = Plugin.getPlugins;
	videojs.getPlugin = Plugin.getPlugin;
	videojs.getPluginVersion = Plugin.getPluginVersion;
	/**
	 * Adding languages so that they're available to all players.
	 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
	 *
	 * @param {string} code
	 *        The language code or dictionary property
	 *
	 * @param {Object} data
	 *        The data values to be translated
	 *
	 * @return {Object}
	 *         The resulting language dictionary object
	 */
	
	videojs.addLanguage = function (code, data) {
	  var _mergeOptions;
	
	  code = ('' + code).toLowerCase();
	  videojs.options.languages = mergeOptions$3(videojs.options.languages, (_mergeOptions = {}, _mergeOptions[code] = data, _mergeOptions));
	  return videojs.options.languages[code];
	};
	/**
	 * A reference to the {@link module:log|log utility module} as an object.
	 *
	 * @type {Function}
	 * @see  {@link module:log|log}
	 */
	
	
	videojs.log = log$1;
	videojs.createLogger = createLogger;
	videojs.createTimeRange = videojs.createTimeRanges = createTimeRanges;
	videojs.formatTime = formatTime;
	videojs.setFormatTime = setFormatTime;
	videojs.resetFormatTime = resetFormatTime;
	videojs.parseUrl = parseUrl;
	videojs.isCrossOrigin = isCrossOrigin;
	videojs.EventTarget = EventTarget$2;
	videojs.on = on;
	videojs.one = one;
	videojs.off = off;
	videojs.trigger = trigger;
	/**
	 * A cross-browser XMLHttpRequest wrapper.
	 *
	 * @function
	 * @param    {Object} options
	 *           Settings for the request.
	 *
	 * @return   {XMLHttpRequest|XDomainRequest}
	 *           The request object.
	 *
	 * @see      https://github.com/Raynos/xhr
	 */
	
	videojs.xhr = XHR__default['default'];
	videojs.TextTrack = TextTrack;
	videojs.AudioTrack = AudioTrack;
	videojs.VideoTrack = VideoTrack;
	['isEl', 'isTextNode', 'createEl', 'hasClass', 'addClass', 'removeClass', 'toggleClass', 'setAttributes', 'getAttributes', 'emptyEl', 'appendContent', 'insertContent'].forEach(function (k) {
	  videojs[k] = function () {
	    log$1.warn("videojs." + k + "() is deprecated; use videojs.dom." + k + "() instead");
	    return Dom[k].apply(null, arguments);
	  };
	});
	videojs.computedStyle = computedStyle;
	/**
	 * A reference to the {@link module:dom|DOM utility module} as an object.
	 *
	 * @type {Object}
	 * @see  {@link module:dom|dom}
	 */
	
	videojs.dom = Dom;
	/**
	 * A reference to the {@link module:url|URL utility module} as an object.
	 *
	 * @type {Object}
	 * @see  {@link module:url|url}
	 */
	
	videojs.url = Url;
	videojs.defineLazyProperty = defineLazyProperty; // Adding less ambiguous text for fullscreen button.
	// In a major update this could become the default text and key.
	
	videojs.addLanguage('en', {
	  'Non-Fullscreen': 'Exit Fullscreen'
	});
	
	/*! @name @videojs/http-streaming @version 2.16.2 @license Apache-2.0 */
	/**
	 * @file resolve-url.js - Handling how URLs are resolved and manipulated
	 */
	
	var resolveUrl = _resolveUrl__default['default'];
	/**
	 * Checks whether xhr request was redirected and returns correct url depending
	 * on `handleManifestRedirects` option
	 *
	 * @api private
	 *
	 * @param  {string} url - an url being requested
	 * @param  {XMLHttpRequest} req - xhr request result
	 *
	 * @return {string}
	 */
	
	var resolveManifestRedirect = function resolveManifestRedirect(handleManifestRedirect, url, req) {
	  // To understand how the responseURL below is set and generated:
	  // - https://fetch.spec.whatwg.org/#concept-response-url
	  // - https://fetch.spec.whatwg.org/#atomic-http-redirect-handling
	  if (handleManifestRedirect && req && req.responseURL && url !== req.responseURL) {
	    return req.responseURL;
	  }
	
	  return url;
	};
	
	var logger = function logger(source) {
	  if (videojs.log.debug) {
	    return videojs.log.debug.bind(videojs, 'VHS:', source + " >");
	  }
	
	  return function () {};
	};
	/**
	 * ranges
	 *
	 * Utilities for working with TimeRanges.
	 *
	 */
	
	
	var TIME_FUDGE_FACTOR = 1 / 30; // Comparisons between time values such as current time and the end of the buffered range
	// can be misleading because of precision differences or when the current media has poorly
	// aligned audio and video, which can cause values to be slightly off from what you would
	// expect. This value is what we consider to be safe to use in such comparisons to account
	// for these scenarios.
	
	var SAFE_TIME_DELTA = TIME_FUDGE_FACTOR * 3;
	
	var filterRanges = function filterRanges(timeRanges, predicate) {
	  var results = [];
	  var i;
	
	  if (timeRanges && timeRanges.length) {
	    // Search for ranges that match the predicate
	    for (i = 0; i < timeRanges.length; i++) {
	      if (predicate(timeRanges.start(i), timeRanges.end(i))) {
	        results.push([timeRanges.start(i), timeRanges.end(i)]);
	      }
	    }
	  }
	
	  return videojs.createTimeRanges(results);
	};
	/**
	 * Attempts to find the buffered TimeRange that contains the specified
	 * time.
	 *
	 * @param {TimeRanges} buffered - the TimeRanges object to query
	 * @param {number} time  - the time to filter on.
	 * @return {TimeRanges} a new TimeRanges object
	 */
	
	
	var findRange = function findRange(buffered, time) {
	  return filterRanges(buffered, function (start, end) {
	    return start - SAFE_TIME_DELTA <= time && end + SAFE_TIME_DELTA >= time;
	  });
	};
	/**
	 * Returns the TimeRanges that begin later than the specified time.
	 *
	 * @param {TimeRanges} timeRanges - the TimeRanges object to query
	 * @param {number} time - the time to filter on.
	 * @return {TimeRanges} a new TimeRanges object.
	 */
	
	
	var findNextRange = function findNextRange(timeRanges, time) {
	  return filterRanges(timeRanges, function (start) {
	    return start - TIME_FUDGE_FACTOR >= time;
	  });
	};
	/**
	 * Returns gaps within a list of TimeRanges
	 *
	 * @param {TimeRanges} buffered - the TimeRanges object
	 * @return {TimeRanges} a TimeRanges object of gaps
	 */
	
	
	var findGaps = function findGaps(buffered) {
	  if (buffered.length < 2) {
	    return videojs.createTimeRanges();
	  }
	
	  var ranges = [];
	
	  for (var i = 1; i < buffered.length; i++) {
	    var start = buffered.end(i - 1);
	    var end = buffered.start(i);
	    ranges.push([start, end]);
	  }
	
	  return videojs.createTimeRanges(ranges);
	};
	/**
	 * Calculate the intersection of two TimeRanges
	 *
	 * @param {TimeRanges} bufferA
	 * @param {TimeRanges} bufferB
	 * @return {TimeRanges} The interesection of `bufferA` with `bufferB`
	 */
	
	
	var bufferIntersection = function bufferIntersection(bufferA, bufferB) {
	  var start = null;
	  var end = null;
	  var arity = 0;
	  var extents = [];
	  var ranges = [];
	
	  if (!bufferA || !bufferA.length || !bufferB || !bufferB.length) {
	    return videojs.createTimeRange();
	  } // Handle the case where we have both buffers and create an
	  // intersection of the two
	
	
	  var count = bufferA.length; // A) Gather up all start and end times
	
	  while (count--) {
	    extents.push({
	      time: bufferA.start(count),
	      type: 'start'
	    });
	    extents.push({
	      time: bufferA.end(count),
	      type: 'end'
	    });
	  }
	
	  count = bufferB.length;
	
	  while (count--) {
	    extents.push({
	      time: bufferB.start(count),
	      type: 'start'
	    });
	    extents.push({
	      time: bufferB.end(count),
	      type: 'end'
	    });
	  } // B) Sort them by time
	
	
	  extents.sort(function (a, b) {
	    return a.time - b.time;
	  }); // C) Go along one by one incrementing arity for start and decrementing
	  //    arity for ends
	
	  for (count = 0; count < extents.length; count++) {
	    if (extents[count].type === 'start') {
	      arity++; // D) If arity is ever incremented to 2 we are entering an
	      //    overlapping range
	
	      if (arity === 2) {
	        start = extents[count].time;
	      }
	    } else if (extents[count].type === 'end') {
	      arity--; // E) If arity is ever decremented to 1 we leaving an
	      //    overlapping range
	
	      if (arity === 1) {
	        end = extents[count].time;
	      }
	    } // F) Record overlapping ranges
	
	
	    if (start !== null && end !== null) {
	      ranges.push([start, end]);
	      start = null;
	      end = null;
	    }
	  }
	
	  return videojs.createTimeRanges(ranges);
	};
	/**
	 * Gets a human readable string for a TimeRange
	 *
	 * @param {TimeRange} range
	 * @return {string} a human readable string
	 */
	
	
	var printableRange = function printableRange(range) {
	  var strArr = [];
	
	  if (!range || !range.length) {
	    return '';
	  }
	
	  for (var i = 0; i < range.length; i++) {
	    strArr.push(range.start(i) + ' => ' + range.end(i));
	  }
	
	  return strArr.join(', ');
	};
	/**
	 * Calculates the amount of time left in seconds until the player hits the end of the
	 * buffer and causes a rebuffer
	 *
	 * @param {TimeRange} buffered
	 *        The state of the buffer
	 * @param {Numnber} currentTime
	 *        The current time of the player
	 * @param {number} playbackRate
	 *        The current playback rate of the player. Defaults to 1.
	 * @return {number}
	 *         Time until the player has to start rebuffering in seconds.
	 * @function timeUntilRebuffer
	 */
	
	
	var timeUntilRebuffer = function timeUntilRebuffer(buffered, currentTime, playbackRate) {
	  if (playbackRate === void 0) {
	    playbackRate = 1;
	  }
	
	  var bufferedEnd = buffered.length ? buffered.end(buffered.length - 1) : 0;
	  return (bufferedEnd - currentTime) / playbackRate;
	};
	/**
	 * Converts a TimeRanges object into an array representation
	 *
	 * @param {TimeRanges} timeRanges
	 * @return {Array}
	 */
	
	
	var timeRangesToArray = function timeRangesToArray(timeRanges) {
	  var timeRangesList = [];
	
	  for (var i = 0; i < timeRanges.length; i++) {
	    timeRangesList.push({
	      start: timeRanges.start(i),
	      end: timeRanges.end(i)
	    });
	  }
	
	  return timeRangesList;
	};
	/**
	 * Determines if two time range objects are different.
	 *
	 * @param {TimeRange} a
	 *        the first time range object to check
	 *
	 * @param {TimeRange} b
	 *        the second time range object to check
	 *
	 * @return {Boolean}
	 *         Whether the time range objects differ
	 */
	
	
	var isRangeDifferent = function isRangeDifferent(a, b) {
	  // same object
	  if (a === b) {
	    return false;
	  } // one or the other is undefined
	
	
	  if (!a && b || !b && a) {
	    return true;
	  } // length is different
	
	
	  if (a.length !== b.length) {
	    return true;
	  } // see if any start/end pair is different
	
	
	  for (var i = 0; i < a.length; i++) {
	    if (a.start(i) !== b.start(i) || a.end(i) !== b.end(i)) {
	      return true;
	    }
	  } // if the length and every pair is the same
	  // this is the same time range
	
	
	  return false;
	};
	
	var lastBufferedEnd = function lastBufferedEnd(a) {
	  if (!a || !a.length || !a.end) {
	    return;
	  }
	
	  return a.end(a.length - 1);
	};
	/**
	 * A utility function to add up the amount of time in a timeRange
	 * after a specified startTime.
	 * ie:[[0, 10], [20, 40], [50, 60]] with a startTime 0
	 *     would return 40 as there are 40s seconds after 0 in the timeRange
	 *
	 * @param {TimeRange} range
	 *        The range to check against
	 * @param {number} startTime
	 *        The time in the time range that you should start counting from
	 *
	 * @return {number}
	 *          The number of seconds in the buffer passed the specified time.
	 */
	
	
	var timeAheadOf = function timeAheadOf(range, startTime) {
	  var time = 0;
	
	  if (!range || !range.length) {
	    return time;
	  }
	
	  for (var i = 0; i < range.length; i++) {
	    var start = range.start(i);
	    var end = range.end(i); // startTime is after this range entirely
	
	    if (startTime > end) {
	      continue;
	    } // startTime is within this range
	
	
	    if (startTime > start && startTime <= end) {
	      time += end - startTime;
	      continue;
	    } // startTime is before this range.
	
	
	    time += end - start;
	  }
	
	  return time;
	};
	/**
	 * @file playlist.js
	 *
	 * Playlist related utilities.
	 */
	
	
	var createTimeRange = videojs.createTimeRange;
	/**
	 * Get the duration of a segment, with special cases for
	 * llhls segments that do not have a duration yet.
	 *
	 * @param {Object} playlist
	 *        the playlist that the segment belongs to.
	 * @param {Object} segment
	 *        the segment to get a duration for.
	 *
	 * @return {number}
	 *          the segment duration
	 */
	
	var segmentDurationWithParts = function segmentDurationWithParts(playlist, segment) {
	  // if this isn't a preload segment
	  // then we will have a segment duration that is accurate.
	  if (!segment.preload) {
	    return segment.duration;
	  } // otherwise we have to add up parts and preload hints
	  // to get an up to date duration.
	
	
	  var result = 0;
	  (segment.parts || []).forEach(function (p) {
	    result += p.duration;
	  }); // for preload hints we have to use partTargetDuration
	  // as they won't even have a duration yet.
	
	  (segment.preloadHints || []).forEach(function (p) {
	    if (p.type === 'PART') {
	      result += playlist.partTargetDuration;
	    }
	  });
	  return result;
	};
	/**
	 * A function to get a combined list of parts and segments with durations
	 * and indexes.
	 *
	 * @param {Playlist} playlist the playlist to get the list for.
	 *
	 * @return {Array} The part/segment list.
	 */
	
	
	var getPartsAndSegments = function getPartsAndSegments(playlist) {
	  return (playlist.segments || []).reduce(function (acc, segment, si) {
	    if (segment.parts) {
	      segment.parts.forEach(function (part, pi) {
	        acc.push({
	          duration: part.duration,
	          segmentIndex: si,
	          partIndex: pi,
	          part: part,
	          segment: segment
	        });
	      });
	    } else {
	      acc.push({
	        duration: segment.duration,
	        segmentIndex: si,
	        partIndex: null,
	        segment: segment,
	        part: null
	      });
	    }
	
	    return acc;
	  }, []);
	};
	
	var getLastParts = function getLastParts(media) {
	  var lastSegment = media.segments && media.segments.length && media.segments[media.segments.length - 1];
	  return lastSegment && lastSegment.parts || [];
	};
	
	var getKnownPartCount = function getKnownPartCount(_ref) {
	  var preloadSegment = _ref.preloadSegment;
	
	  if (!preloadSegment) {
	    return;
	  }
	
	  var parts = preloadSegment.parts,
	      preloadHints = preloadSegment.preloadHints;
	  var partCount = (preloadHints || []).reduce(function (count, hint) {
	    return count + (hint.type === 'PART' ? 1 : 0);
	  }, 0);
	  partCount += parts && parts.length ? parts.length : 0;
	  return partCount;
	};
	/**
	 * Get the number of seconds to delay from the end of a
	 * live playlist.
	 *
	 * @param {Playlist} master the master playlist
	 * @param {Playlist} media the media playlist
	 * @return {number} the hold back in seconds.
	 */
	
	
	var liveEdgeDelay = function liveEdgeDelay(master, media) {
	  if (media.endList) {
	    return 0;
	  } // dash suggestedPresentationDelay trumps everything
	
	
	  if (master && master.suggestedPresentationDelay) {
	    return master.suggestedPresentationDelay;
	  }
	
	  var hasParts = getLastParts(media).length > 0; // look for "part" delays from ll-hls first
	
	  if (hasParts && media.serverControl && media.serverControl.partHoldBack) {
	    return media.serverControl.partHoldBack;
	  } else if (hasParts && media.partTargetDuration) {
	    return media.partTargetDuration * 3; // finally look for full segment delays
	  } else if (media.serverControl && media.serverControl.holdBack) {
	    return media.serverControl.holdBack;
	  } else if (media.targetDuration) {
	    return media.targetDuration * 3;
	  }
	
	  return 0;
	};
	/**
	 * walk backward until we find a duration we can use
	 * or return a failure
	 *
	 * @param {Playlist} playlist the playlist to walk through
	 * @param {Number} endSequence the mediaSequence to stop walking on
	 */
	
	
	var backwardDuration = function backwardDuration(playlist, endSequence) {
	  var result = 0;
	  var i = endSequence - playlist.mediaSequence; // if a start time is available for segment immediately following
	  // the interval, use it
	
	  var segment = playlist.segments[i]; // Walk backward until we find the latest segment with timeline
	  // information that is earlier than endSequence
	
	  if (segment) {
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: segment.start,
	        precise: true
	      };
	    }
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: segment.end - segment.duration,
	        precise: true
	      };
	    }
	  }
	
	  while (i--) {
	    segment = playlist.segments[i];
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: result + segment.end,
	        precise: true
	      };
	    }
	
	    result += segmentDurationWithParts(playlist, segment);
	
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: result + segment.start,
	        precise: true
	      };
	    }
	  }
	
	  return {
	    result: result,
	    precise: false
	  };
	};
	/**
	 * walk forward until we find a duration we can use
	 * or return a failure
	 *
	 * @param {Playlist} playlist the playlist to walk through
	 * @param {number} endSequence the mediaSequence to stop walking on
	 */
	
	
	var forwardDuration = function forwardDuration(playlist, endSequence) {
	  var result = 0;
	  var segment;
	  var i = endSequence - playlist.mediaSequence; // Walk forward until we find the earliest segment with timeline
	  // information
	
	  for (; i < playlist.segments.length; i++) {
	    segment = playlist.segments[i];
	
	    if (typeof segment.start !== 'undefined') {
	      return {
	        result: segment.start - result,
	        precise: true
	      };
	    }
	
	    result += segmentDurationWithParts(playlist, segment);
	
	    if (typeof segment.end !== 'undefined') {
	      return {
	        result: segment.end - result,
	        precise: true
	      };
	    }
	  } // indicate we didn't find a useful duration estimate
	
	
	  return {
	    result: -1,
	    precise: false
	  };
	};
	/**
	  * Calculate the media duration from the segments associated with a
	  * playlist. The duration of a subinterval of the available segments
	  * may be calculated by specifying an end index.
	  *
	  * @param {Object} playlist a media playlist object
	  * @param {number=} endSequence an exclusive upper boundary
	  * for the playlist.  Defaults to playlist length.
	  * @param {number} expired the amount of time that has dropped
	  * off the front of the playlist in a live scenario
	  * @return {number} the duration between the first available segment
	  * and end index.
	  */
	
	
	var intervalDuration = function intervalDuration(playlist, endSequence, expired) {
	  if (typeof endSequence === 'undefined') {
	    endSequence = playlist.mediaSequence + playlist.segments.length;
	  }
	
	  if (endSequence < playlist.mediaSequence) {
	    return 0;
	  } // do a backward walk to estimate the duration
	
	
	  var backward = backwardDuration(playlist, endSequence);
	
	  if (backward.precise) {
	    // if we were able to base our duration estimate on timing
	    // information provided directly from the Media Source, return
	    // it
	    return backward.result;
	  } // walk forward to see if a precise duration estimate can be made
	  // that way
	
	
	  var forward = forwardDuration(playlist, endSequence);
	
	  if (forward.precise) {
	    // we found a segment that has been buffered and so it's
	    // position is known precisely
	    return forward.result;
	  } // return the less-precise, playlist-based duration estimate
	
	
	  return backward.result + expired;
	};
	/**
	  * Calculates the duration of a playlist. If a start and end index
	  * are specified, the duration will be for the subset of the media
	  * timeline between those two indices. The total duration for live
	  * playlists is always Infinity.
	  *
	  * @param {Object} playlist a media playlist object
	  * @param {number=} endSequence an exclusive upper
	  * boundary for the playlist. Defaults to the playlist media
	  * sequence number plus its length.
	  * @param {number=} expired the amount of time that has
	  * dropped off the front of the playlist in a live scenario
	  * @return {number} the duration between the start index and end
	  * index.
	  */
	
	
	var duration = function duration(playlist, endSequence, expired) {
	  if (!playlist) {
	    return 0;
	  }
	
	  if (typeof expired !== 'number') {
	    expired = 0;
	  } // if a slice of the total duration is not requested, use
	  // playlist-level duration indicators when they're present
	
	
	  if (typeof endSequence === 'undefined') {
	    // if present, use the duration specified in the playlist
	    if (playlist.totalDuration) {
	      return playlist.totalDuration;
	    } // duration should be Infinity for live playlists
	
	
	    if (!playlist.endList) {
	      return window__default['default'].Infinity;
	    }
	  } // calculate the total duration based on the segment durations
	
	
	  return intervalDuration(playlist, endSequence, expired);
	};
	/**
	  * Calculate the time between two indexes in the current playlist
	  * neight the start- nor the end-index need to be within the current
	  * playlist in which case, the targetDuration of the playlist is used
	  * to approximate the durations of the segments
	  *
	  * @param {Array} options.durationList list to iterate over for durations.
	  * @param {number} options.defaultDuration duration to use for elements before or after the durationList
	  * @param {number} options.startIndex partsAndSegments index to start
	  * @param {number} options.endIndex partsAndSegments index to end.
	  * @return {number} the number of seconds between startIndex and endIndex
	  */
	
	
	var sumDurations = function sumDurations(_ref2) {
	  var defaultDuration = _ref2.defaultDuration,
	      durationList = _ref2.durationList,
	      startIndex = _ref2.startIndex,
	      endIndex = _ref2.endIndex;
	  var durations = 0;
	
	  if (startIndex > endIndex) {
	    var _ref3 = [endIndex, startIndex];
	    startIndex = _ref3[0];
	    endIndex = _ref3[1];
	  }
	
	  if (startIndex < 0) {
	    for (var i = startIndex; i < Math.min(0, endIndex); i++) {
	      durations += defaultDuration;
	    }
	
	    startIndex = 0;
	  }
	
	  for (var _i = startIndex; _i < endIndex; _i++) {
	    durations += durationList[_i].duration;
	  }
	
	  return durations;
	};
	/**
	 * Calculates the playlist end time
	 *
	 * @param {Object} playlist a media playlist object
	 * @param {number=} expired the amount of time that has
	 *                  dropped off the front of the playlist in a live scenario
	 * @param {boolean|false} useSafeLiveEnd a boolean value indicating whether or not the
	 *                        playlist end calculation should consider the safe live end
	 *                        (truncate the playlist end by three segments). This is normally
	 *                        used for calculating the end of the playlist's seekable range.
	 *                        This takes into account the value of liveEdgePadding.
	 *                        Setting liveEdgePadding to 0 is equivalent to setting this to false.
	 * @param {number} liveEdgePadding a number indicating how far from the end of the playlist we should be in seconds.
	 *                 If this is provided, it is used in the safe live end calculation.
	 *                 Setting useSafeLiveEnd=false or liveEdgePadding=0 are equivalent.
	 *                 Corresponds to suggestedPresentationDelay in DASH manifests.
	 * @return {number} the end time of playlist
	 * @function playlistEnd
	 */
	
	
	var playlistEnd = function playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding) {
	  if (!playlist || !playlist.segments) {
	    return null;
	  }
	
	  if (playlist.endList) {
	    return duration(playlist);
	  }
	
	  if (expired === null) {
	    return null;
	  }
	
	  expired = expired || 0;
	  var lastSegmentEndTime = intervalDuration(playlist, playlist.mediaSequence + playlist.segments.length, expired);
	
	  if (useSafeLiveEnd) {
	    liveEdgePadding = typeof liveEdgePadding === 'number' ? liveEdgePadding : liveEdgeDelay(null, playlist);
	    lastSegmentEndTime -= liveEdgePadding;
	  } // don't return a time less than zero
	
	
	  return Math.max(0, lastSegmentEndTime);
	};
	/**
	  * Calculates the interval of time that is currently seekable in a
	  * playlist. The returned time ranges are relative to the earliest
	  * moment in the specified playlist that is still available. A full
	  * seekable implementation for live streams would need to offset
	  * these values by the duration of content that has expired from the
	  * stream.
	  *
	  * @param {Object} playlist a media playlist object
	  * dropped off the front of the playlist in a live scenario
	  * @param {number=} expired the amount of time that has
	  * dropped off the front of the playlist in a live scenario
	  * @param {number} liveEdgePadding how far from the end of the playlist we should be in seconds.
	  *        Corresponds to suggestedPresentationDelay in DASH manifests.
	  * @return {TimeRanges} the periods of time that are valid targets
	  * for seeking
	  */
	
	
	var seekable = function seekable(playlist, expired, liveEdgePadding) {
	  var useSafeLiveEnd = true;
	  var seekableStart = expired || 0;
	  var seekableEnd = playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding);
	
	  if (seekableEnd === null) {
	    return createTimeRange();
	  }
	
	  return createTimeRange(seekableStart, seekableEnd);
	};
	/**
	 * Determine the index and estimated starting time of the segment that
	 * contains a specified playback position in a media playlist.
	 *
	 * @param {Object} options.playlist the media playlist to query
	 * @param {number} options.currentTime The number of seconds since the earliest
	 * possible position to determine the containing segment for
	 * @param {number} options.startTime the time when the segment/part starts
	 * @param {number} options.startingSegmentIndex the segment index to start looking at.
	 * @param {number?} [options.startingPartIndex] the part index to look at within the segment.
	 *
	 * @return {Object} an object with partIndex, segmentIndex, and startTime.
	 */
	
	
	var getMediaInfoForTime = function getMediaInfoForTime(_ref4) {
	  var playlist = _ref4.playlist,
	      currentTime = _ref4.currentTime,
	      startingSegmentIndex = _ref4.startingSegmentIndex,
	      startingPartIndex = _ref4.startingPartIndex,
	      startTime = _ref4.startTime,
	      experimentalExactManifestTimings = _ref4.experimentalExactManifestTimings;
	  var time = currentTime - startTime;
	  var partsAndSegments = getPartsAndSegments(playlist);
	  var startIndex = 0;
	
	  for (var i = 0; i < partsAndSegments.length; i++) {
	    var partAndSegment = partsAndSegments[i];
	
	    if (startingSegmentIndex !== partAndSegment.segmentIndex) {
	      continue;
	    } // skip this if part index does not match.
	
	
	    if (typeof startingPartIndex === 'number' && typeof partAndSegment.partIndex === 'number' && startingPartIndex !== partAndSegment.partIndex) {
	      continue;
	    }
	
	    startIndex = i;
	    break;
	  }
	
	  if (time < 0) {
	    // Walk backward from startIndex in the playlist, adding durations
	    // until we find a segment that contains `time` and return it
	    if (startIndex > 0) {
	      for (var _i2 = startIndex - 1; _i2 >= 0; _i2--) {
	        var _partAndSegment = partsAndSegments[_i2];
	        time += _partAndSegment.duration;
	
	        if (experimentalExactManifestTimings) {
	          if (time < 0) {
	            continue;
	          }
	        } else if (time + TIME_FUDGE_FACTOR <= 0) {
	          continue;
	        }
	
	        return {
	          partIndex: _partAndSegment.partIndex,
	          segmentIndex: _partAndSegment.segmentIndex,
	          startTime: startTime - sumDurations({
	            defaultDuration: playlist.targetDuration,
	            durationList: partsAndSegments,
	            startIndex: startIndex,
	            endIndex: _i2
	          })
	        };
	      }
	    } // We were unable to find a good segment within the playlist
	    // so select the first segment
	
	
	    return {
	      partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
	      segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
	      startTime: currentTime
	    };
	  } // When startIndex is negative, we first walk forward to first segment
	  // adding target durations. If we "run out of time" before getting to
	  // the first segment, return the first segment
	
	
	  if (startIndex < 0) {
	    for (var _i3 = startIndex; _i3 < 0; _i3++) {
	      time -= playlist.targetDuration;
	
	      if (time < 0) {
	        return {
	          partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
	          segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
	          startTime: currentTime
	        };
	      }
	    }
	
	    startIndex = 0;
	  } // Walk forward from startIndex in the playlist, subtracting durations
	  // until we find a segment that contains `time` and return it
	
	
	  for (var _i4 = startIndex; _i4 < partsAndSegments.length; _i4++) {
	    var _partAndSegment2 = partsAndSegments[_i4];
	    time -= _partAndSegment2.duration;
	
	    if (experimentalExactManifestTimings) {
	      if (time > 0) {
	        continue;
	      }
	    } else if (time - TIME_FUDGE_FACTOR >= 0) {
	      continue;
	    }
	
	    return {
	      partIndex: _partAndSegment2.partIndex,
	      segmentIndex: _partAndSegment2.segmentIndex,
	      startTime: startTime + sumDurations({
	        defaultDuration: playlist.targetDuration,
	        durationList: partsAndSegments,
	        startIndex: startIndex,
	        endIndex: _i4
	      })
	    };
	  } // We are out of possible candidates so load the last one...
	
	
	  return {
	    segmentIndex: partsAndSegments[partsAndSegments.length - 1].segmentIndex,
	    partIndex: partsAndSegments[partsAndSegments.length - 1].partIndex,
	    startTime: currentTime
	  };
	};
	/**
	 * Check whether the playlist is blacklisted or not.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is blacklisted or not
	 * @function isBlacklisted
	 */
	
	
	var isBlacklisted = function isBlacklisted(playlist) {
	  return playlist.excludeUntil && playlist.excludeUntil > Date.now();
	};
	/**
	 * Check whether the playlist is compatible with current playback configuration or has
	 * been blacklisted permanently for being incompatible.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is incompatible or not
	 * @function isIncompatible
	 */
	
	
	var isIncompatible = function isIncompatible(playlist) {
	  return playlist.excludeUntil && playlist.excludeUntil === Infinity;
	};
	/**
	 * Check whether the playlist is enabled or not.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is enabled or not
	 * @function isEnabled
	 */
	
	
	var isEnabled = function isEnabled(playlist) {
	  var blacklisted = isBlacklisted(playlist);
	  return !playlist.disabled && !blacklisted;
	};
	/**
	 * Check whether the playlist has been manually disabled through the representations api.
	 *
	 * @param {Object} playlist the media playlist object
	 * @return {boolean} whether the playlist is disabled manually or not
	 * @function isDisabled
	 */
	
	
	var isDisabled = function isDisabled(playlist) {
	  return playlist.disabled;
	};
	/**
	 * Returns whether the current playlist is an AES encrypted HLS stream
	 *
	 * @return {boolean} true if it's an AES encrypted HLS stream
	 */
	
	
	var isAes = function isAes(media) {
	  for (var i = 0; i < media.segments.length; i++) {
	    if (media.segments[i].key) {
	      return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * Checks if the playlist has a value for the specified attribute
	 *
	 * @param {string} attr
	 *        Attribute to check for
	 * @param {Object} playlist
	 *        The media playlist object
	 * @return {boolean}
	 *         Whether the playlist contains a value for the attribute or not
	 * @function hasAttribute
	 */
	
	
	var hasAttribute = function hasAttribute(attr, playlist) {
	  return playlist.attributes && playlist.attributes[attr];
	};
	/**
	 * Estimates the time required to complete a segment download from the specified playlist
	 *
	 * @param {number} segmentDuration
	 *        Duration of requested segment
	 * @param {number} bandwidth
	 *        Current measured bandwidth of the player
	 * @param {Object} playlist
	 *        The media playlist object
	 * @param {number=} bytesReceived
	 *        Number of bytes already received for the request. Defaults to 0
	 * @return {number|NaN}
	 *         The estimated time to request the segment. NaN if bandwidth information for
	 *         the given playlist is unavailable
	 * @function estimateSegmentRequestTime
	 */
	
	
	var estimateSegmentRequestTime = function estimateSegmentRequestTime(segmentDuration, bandwidth, playlist, bytesReceived) {
	  if (bytesReceived === void 0) {
	    bytesReceived = 0;
	  }
	
	  if (!hasAttribute('BANDWIDTH', playlist)) {
	    return NaN;
	  }
	
	  var size = segmentDuration * playlist.attributes.BANDWIDTH;
	  return (size - bytesReceived * 8) / bandwidth;
	};
	/*
	 * Returns whether the current playlist is the lowest rendition
	 *
	 * @return {Boolean} true if on lowest rendition
	 */
	
	
	var isLowestEnabledRendition = function isLowestEnabledRendition(master, media) {
	  if (master.playlists.length === 1) {
	    return true;
	  }
	
	  var currentBandwidth = media.attributes.BANDWIDTH || Number.MAX_VALUE;
	  return master.playlists.filter(function (playlist) {
	    if (!isEnabled(playlist)) {
	      return false;
	    }
	
	    return (playlist.attributes.BANDWIDTH || 0) < currentBandwidth;
	  }).length === 0;
	};
	
	var playlistMatch = function playlistMatch(a, b) {
	  // both playlits are null
	  // or only one playlist is non-null
	  // no match
	  if (!a && !b || !a && b || a && !b) {
	    return false;
	  } // playlist objects are the same, match
	
	
	  if (a === b) {
	    return true;
	  } // first try to use id as it should be the most
	  // accurate
	
	
	  if (a.id && b.id && a.id === b.id) {
	    return true;
	  } // next try to use reslovedUri as it should be the
	  // second most accurate.
	
	
	  if (a.resolvedUri && b.resolvedUri && a.resolvedUri === b.resolvedUri) {
	    return true;
	  } // finally try to use uri as it should be accurate
	  // but might miss a few cases for relative uris
	
	
	  if (a.uri && b.uri && a.uri === b.uri) {
	    return true;
	  }
	
	  return false;
	};
	
	var someAudioVariant = function someAudioVariant(master, callback) {
	  var AUDIO = master && master.mediaGroups && master.mediaGroups.AUDIO || {};
	  var found = false;
	
	  for (var groupName in AUDIO) {
	    for (var label in AUDIO[groupName]) {
	      found = callback(AUDIO[groupName][label]);
	
	      if (found) {
	        break;
	      }
	    }
	
	    if (found) {
	      break;
	    }
	  }
	
	  return !!found;
	};
	
	var isAudioOnly = function isAudioOnly(master) {
	  // we are audio only if we have no main playlists but do
	  // have media group playlists.
	  if (!master || !master.playlists || !master.playlists.length) {
	    // without audio variants or playlists this
	    // is not an audio only master.
	    var found = someAudioVariant(master, function (variant) {
	      return variant.playlists && variant.playlists.length || variant.uri;
	    });
	    return found;
	  } // if every playlist has only an audio codec it is audio only
	
	
	  var _loop = function _loop(i) {
	    var playlist = master.playlists[i];
	    var CODECS = playlist.attributes && playlist.attributes.CODECS; // all codecs are audio, this is an audio playlist.
	
	    if (CODECS && CODECS.split(',').every(function (c) {
	      return codecs_js.isAudioCodec(c);
	    })) {
	      return "continue";
	    } // playlist is in an audio group it is audio only
	
	
	    var found = someAudioVariant(master, function (variant) {
	      return playlistMatch(playlist, variant);
	    });
	
	    if (found) {
	      return "continue";
	    } // if we make it here this playlist isn't audio and we
	    // are not audio only
	
	
	    return {
	      v: false
	    };
	  };
	
	  for (var i = 0; i < master.playlists.length; i++) {
	    var _ret = _loop(i);
	
	    if (_ret === "continue") continue;
	    if (typeof _ret === "object") return _ret.v;
	  } // if we make it past every playlist without returning, then
	  // this is an audio only playlist.
	
	
	  return true;
	}; // exports
	
	
	var Playlist = {
	  liveEdgeDelay: liveEdgeDelay,
	  duration: duration,
	  seekable: seekable,
	  getMediaInfoForTime: getMediaInfoForTime,
	  isEnabled: isEnabled,
	  isDisabled: isDisabled,
	  isBlacklisted: isBlacklisted,
	  isIncompatible: isIncompatible,
	  playlistEnd: playlistEnd,
	  isAes: isAes,
	  hasAttribute: hasAttribute,
	  estimateSegmentRequestTime: estimateSegmentRequestTime,
	  isLowestEnabledRendition: isLowestEnabledRendition,
	  isAudioOnly: isAudioOnly,
	  playlistMatch: playlistMatch,
	  segmentDurationWithParts: segmentDurationWithParts
	};
	var log = videojs.log;
	
	var createPlaylistID = function createPlaylistID(index, uri) {
	  return index + "-" + uri;
	}; // default function for creating a group id
	
	
	var groupID = function groupID(type, group, label) {
	  return "placeholder-uri-" + type + "-" + group + "-" + label;
	};
	/**
	 * Parses a given m3u8 playlist
	 *
	 * @param {Function} [onwarn]
	 *        a function to call when the parser triggers a warning event.
	 * @param {Function} [oninfo]
	 *        a function to call when the parser triggers an info event.
	 * @param {string} manifestString
	 *        The downloaded manifest string
	 * @param {Object[]} [customTagParsers]
	 *        An array of custom tag parsers for the m3u8-parser instance
	 * @param {Object[]} [customTagMappers]
	 *        An array of custom tag mappers for the m3u8-parser instance
	 * @param {boolean} [experimentalLLHLS=false]
	 *        Whether to keep ll-hls features in the manifest after parsing.
	 * @return {Object}
	 *         The manifest object
	 */
	
	
	var parseManifest = function parseManifest(_ref) {
	  var onwarn = _ref.onwarn,
	      oninfo = _ref.oninfo,
	      manifestString = _ref.manifestString,
	      _ref$customTagParsers = _ref.customTagParsers,
	      customTagParsers = _ref$customTagParsers === void 0 ? [] : _ref$customTagParsers,
	      _ref$customTagMappers = _ref.customTagMappers,
	      customTagMappers = _ref$customTagMappers === void 0 ? [] : _ref$customTagMappers,
	      experimentalLLHLS = _ref.experimentalLLHLS;
	  var parser = new m3u8Parser.Parser();
	
	  if (onwarn) {
	    parser.on('warn', onwarn);
	  }
	
	  if (oninfo) {
	    parser.on('info', oninfo);
	  }
	
	  customTagParsers.forEach(function (customParser) {
	    return parser.addParser(customParser);
	  });
	  customTagMappers.forEach(function (mapper) {
	    return parser.addTagMapper(mapper);
	  });
	  parser.push(manifestString);
	  parser.end();
	  var manifest = parser.manifest; // remove llhls features from the parsed manifest
	  // if we don't want llhls support.
	
	  if (!experimentalLLHLS) {
	    ['preloadSegment', 'skip', 'serverControl', 'renditionReports', 'partInf', 'partTargetDuration'].forEach(function (k) {
	      if (manifest.hasOwnProperty(k)) {
	        delete manifest[k];
	      }
	    });
	
	    if (manifest.segments) {
	      manifest.segments.forEach(function (segment) {
	        ['parts', 'preloadHints'].forEach(function (k) {
	          if (segment.hasOwnProperty(k)) {
	            delete segment[k];
	          }
	        });
	      });
	    }
	  }
	
	  if (!manifest.targetDuration) {
	    var targetDuration = 10;
	
	    if (manifest.segments && manifest.segments.length) {
	      targetDuration = manifest.segments.reduce(function (acc, s) {
	        return Math.max(acc, s.duration);
	      }, 0);
	    }
	
	    if (onwarn) {
	      onwarn("manifest has no targetDuration defaulting to " + targetDuration);
	    }
	
	    manifest.targetDuration = targetDuration;
	  }
	
	  var parts = getLastParts(manifest);
	
	  if (parts.length && !manifest.partTargetDuration) {
	    var partTargetDuration = parts.reduce(function (acc, p) {
	      return Math.max(acc, p.duration);
	    }, 0);
	
	    if (onwarn) {
	      onwarn("manifest has no partTargetDuration defaulting to " + partTargetDuration);
	      log.error('LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.');
	    }
	
	    manifest.partTargetDuration = partTargetDuration;
	  }
	
	  return manifest;
	};
	/**
	 * Loops through all supported media groups in master and calls the provided
	 * callback for each group
	 *
	 * @param {Object} master
	 *        The parsed master manifest object
	 * @param {Function} callback
	 *        Callback to call for each media group
	 */
	
	
	var forEachMediaGroup = function forEachMediaGroup(master, callback) {
	  if (!master.mediaGroups) {
	    return;
	  }
	
	  ['AUDIO', 'SUBTITLES'].forEach(function (mediaType) {
	    if (!master.mediaGroups[mediaType]) {
	      return;
	    }
	
	    for (var groupKey in master.mediaGroups[mediaType]) {
	      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
	        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
	        callback(mediaProperties, mediaType, groupKey, labelKey);
	      }
	    }
	  });
	};
	/**
	 * Adds properties and attributes to the playlist to keep consistent functionality for
	 * playlists throughout VHS.
	 *
	 * @param {Object} config
	 *        Arguments object
	 * @param {Object} config.playlist
	 *        The media playlist
	 * @param {string} [config.uri]
	 *        The uri to the media playlist (if media playlist is not from within a master
	 *        playlist)
	 * @param {string} id
	 *        ID to use for the playlist
	 */
	
	
	var setupMediaPlaylist = function setupMediaPlaylist(_ref2) {
	  var playlist = _ref2.playlist,
	      uri = _ref2.uri,
	      id = _ref2.id;
	  playlist.id = id;
	  playlist.playlistErrors_ = 0;
	
	  if (uri) {
	    // For media playlists, m3u8-parser does not have access to a URI, as HLS media
	    // playlists do not contain their own source URI, but one is needed for consistency in
	    // VHS.
	    playlist.uri = uri;
	  } // For HLS master playlists, even though certain attributes MUST be defined, the
	  // stream may still be played without them.
	  // For HLS media playlists, m3u8-parser does not attach an attributes object to the
	  // manifest.
	  //
	  // To avoid undefined reference errors through the project, and make the code easier
	  // to write/read, add an empty attributes object for these cases.
	
	
	  playlist.attributes = playlist.attributes || {};
	};
	/**
	 * Adds ID, resolvedUri, and attributes properties to each playlist of the master, where
	 * necessary. In addition, creates playlist IDs for each playlist and adds playlist ID to
	 * playlist references to the playlists array.
	 *
	 * @param {Object} master
	 *        The master playlist
	 */
	
	
	var setupMediaPlaylists = function setupMediaPlaylists(master) {
	  var i = master.playlists.length;
	
	  while (i--) {
	    var playlist = master.playlists[i];
	    setupMediaPlaylist({
	      playlist: playlist,
	      id: createPlaylistID(i, playlist.uri)
	    });
	    playlist.resolvedUri = resolveUrl(master.uri, playlist.uri);
	    master.playlists[playlist.id] = playlist; // URI reference added for backwards compatibility
	
	    master.playlists[playlist.uri] = playlist; // Although the spec states an #EXT-X-STREAM-INF tag MUST have a BANDWIDTH attribute,
	    // the stream can be played without it. Although an attributes property may have been
	    // added to the playlist to prevent undefined references, issue a warning to fix the
	    // manifest.
	
	    if (!playlist.attributes.BANDWIDTH) {
	      log.warn('Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.');
	    }
	  }
	};
	/**
	 * Adds resolvedUri properties to each media group.
	 *
	 * @param {Object} master
	 *        The master playlist
	 */
	
	
	var resolveMediaGroupUris = function resolveMediaGroupUris(master) {
	  forEachMediaGroup(master, function (properties) {
	    if (properties.uri) {
	      properties.resolvedUri = resolveUrl(master.uri, properties.uri);
	    }
	  });
	};
	/**
	 * Creates a master playlist wrapper to insert a sole media playlist into.
	 *
	 * @param {Object} media
	 *        Media playlist
	 * @param {string} uri
	 *        The media URI
	 *
	 * @return {Object}
	 *         Master playlist
	 */
	
	
	var masterForMedia = function masterForMedia(media, uri) {
	  var id = createPlaylistID(0, uri);
	  var master = {
	    mediaGroups: {
	      'AUDIO': {},
	      'VIDEO': {},
	      'CLOSED-CAPTIONS': {},
	      'SUBTITLES': {}
	    },
	    uri: window__default['default'].location.href,
	    resolvedUri: window__default['default'].location.href,
	    playlists: [{
	      uri: uri,
	      id: id,
	      resolvedUri: uri,
	      // m3u8-parser does not attach an attributes property to media playlists so make
	      // sure that the property is attached to avoid undefined reference errors
	      attributes: {}
	    }]
	  }; // set up ID reference
	
	  master.playlists[id] = master.playlists[0]; // URI reference added for backwards compatibility
	
	  master.playlists[uri] = master.playlists[0];
	  return master;
	};
	/**
	 * Does an in-place update of the master manifest to add updated playlist URI references
	 * as well as other properties needed by VHS that aren't included by the parser.
	 *
	 * @param {Object} master
	 *        Master manifest object
	 * @param {string} uri
	 *        The source URI
	 * @param {function} createGroupID
	 *        A function to determine how to create the groupID for mediaGroups
	 */
	
	
	var addPropertiesToMaster = function addPropertiesToMaster(master, uri, createGroupID) {
	  if (createGroupID === void 0) {
	    createGroupID = groupID;
	  }
	
	  master.uri = uri;
	
	  for (var i = 0; i < master.playlists.length; i++) {
	    if (!master.playlists[i].uri) {
	      // Set up phony URIs for the playlists since playlists are referenced by their URIs
	      // throughout VHS, but some formats (e.g., DASH) don't have external URIs
	      // TODO: consider adding dummy URIs in mpd-parser
	      var phonyUri = "placeholder-uri-" + i;
	      master.playlists[i].uri = phonyUri;
	    }
	  }
	
	  var audioOnlyMaster = isAudioOnly(master);
	  forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	    // add a playlist array under properties
	    if (!properties.playlists || !properties.playlists.length) {
	      // If the manifest is audio only and this media group does not have a uri, check
	      // if the media group is located in the main list of playlists. If it is, don't add
	      // placeholder properties as it shouldn't be considered an alternate audio track.
	      if (audioOnlyMaster && mediaType === 'AUDIO' && !properties.uri) {
	        for (var _i = 0; _i < master.playlists.length; _i++) {
	          var p = master.playlists[_i];
	
	          if (p.attributes && p.attributes.AUDIO && p.attributes.AUDIO === groupKey) {
	            return;
	          }
	        }
	      }
	
	      properties.playlists = [_extends__default['default']({}, properties)];
	    }
	
	    properties.playlists.forEach(function (p, i) {
	      var groupId = createGroupID(mediaType, groupKey, labelKey, p);
	      var id = createPlaylistID(i, groupId);
	
	      if (p.uri) {
	        p.resolvedUri = p.resolvedUri || resolveUrl(master.uri, p.uri);
	      } else {
	        // DEPRECATED, this has been added to prevent a breaking change.
	        // previously we only ever had a single media group playlist, so
	        // we mark the first playlist uri without prepending the index as we used to
	        // ideally we would do all of the playlists the same way.
	        p.uri = i === 0 ? groupId : id; // don't resolve a placeholder uri to an absolute url, just use
	        // the placeholder again
	
	        p.resolvedUri = p.uri;
	      }
	
	      p.id = p.id || id; // add an empty attributes object, all playlists are
	      // expected to have this.
	
	      p.attributes = p.attributes || {}; // setup ID and URI references (URI for backwards compatibility)
	
	      master.playlists[p.id] = p;
	      master.playlists[p.uri] = p;
	    });
	  });
	  setupMediaPlaylists(master);
	  resolveMediaGroupUris(master);
	};
	
	var mergeOptions$2 = videojs.mergeOptions,
	    EventTarget$1 = videojs.EventTarget;
	
	var addLLHLSQueryDirectives = function addLLHLSQueryDirectives(uri, media) {
	  if (media.endList || !media.serverControl) {
	    return uri;
	  }
	
	  var parameters = {};
	
	  if (media.serverControl.canBlockReload) {
	    var preloadSegment = media.preloadSegment; // next msn is a zero based value, length is not.
	
	    var nextMSN = media.mediaSequence + media.segments.length; // If preload segment has parts then it is likely
	    // that we are going to request a part of that preload segment.
	    // the logic below is used to determine that.
	
	    if (preloadSegment) {
	      var parts = preloadSegment.parts || []; // _HLS_part is a zero based index
	
	      var nextPart = getKnownPartCount(media) - 1; // if nextPart is > -1 and not equal to just the
	      // length of parts, then we know we had part preload hints
	      // and we need to add the _HLS_part= query
	
	      if (nextPart > -1 && nextPart !== parts.length - 1) {
	        // add existing parts to our preload hints
	        // eslint-disable-next-line
	        parameters._HLS_part = nextPart;
	      } // this if statement makes sure that we request the msn
	      // of the preload segment if:
	      // 1. the preload segment had parts (and was not yet a full segment)
	      //    but was added to our segments array
	      // 2. the preload segment had preload hints for parts that are not in
	      //    the manifest yet.
	      // in all other cases we want the segment after the preload segment
	      // which will be given by using media.segments.length because it is 1 based
	      // rather than 0 based.
	
	
	      if (nextPart > -1 || parts.length) {
	        nextMSN--;
	      }
	    } // add _HLS_msn= in front of any _HLS_part query
	    // eslint-disable-next-line
	
	
	    parameters._HLS_msn = nextMSN;
	  }
	
	  if (media.serverControl && media.serverControl.canSkipUntil) {
	    // add _HLS_skip= infront of all other queries.
	    // eslint-disable-next-line
	    parameters._HLS_skip = media.serverControl.canSkipDateranges ? 'v2' : 'YES';
	  }
	
	  if (Object.keys(parameters).length) {
	    var parsedUri = new window__default['default'].URL(uri);
	    ['_HLS_skip', '_HLS_msn', '_HLS_part'].forEach(function (name) {
	      if (!parameters.hasOwnProperty(name)) {
	        return;
	      }
	
	      parsedUri.searchParams.set(name, parameters[name]);
	    });
	    uri = parsedUri.toString();
	  }
	
	  return uri;
	};
	/**
	 * Returns a new segment object with properties and
	 * the parts array merged.
	 *
	 * @param {Object} a the old segment
	 * @param {Object} b the new segment
	 *
	 * @return {Object} the merged segment
	 */
	
	
	var updateSegment = function updateSegment(a, b) {
	  if (!a) {
	    return b;
	  }
	
	  var result = mergeOptions$2(a, b); // if only the old segment has preload hints
	  // and the new one does not, remove preload hints.
	
	  if (a.preloadHints && !b.preloadHints) {
	    delete result.preloadHints;
	  } // if only the old segment has parts
	  // then the parts are no longer valid
	
	
	  if (a.parts && !b.parts) {
	    delete result.parts; // if both segments have parts
	    // copy part propeties from the old segment
	    // to the new one.
	  } else if (a.parts && b.parts) {
	    for (var i = 0; i < b.parts.length; i++) {
	      if (a.parts && a.parts[i]) {
	        result.parts[i] = mergeOptions$2(a.parts[i], b.parts[i]);
	      }
	    }
	  } // set skipped to false for segments that have
	  // have had information merged from the old segment.
	
	
	  if (!a.skipped && b.skipped) {
	    result.skipped = false;
	  } // set preload to false for segments that have
	  // had information added in the new segment.
	
	
	  if (a.preload && !b.preload) {
	    result.preload = false;
	  }
	
	  return result;
	};
	/**
	 * Returns a new array of segments that is the result of merging
	 * properties from an older list of segments onto an updated
	 * list. No properties on the updated playlist will be ovewritten.
	 *
	 * @param {Array} original the outdated list of segments
	 * @param {Array} update the updated list of segments
	 * @param {number=} offset the index of the first update
	 * segment in the original segment list. For non-live playlists,
	 * this should always be zero and does not need to be
	 * specified. For live playlists, it should be the difference
	 * between the media sequence numbers in the original and updated
	 * playlists.
	 * @return {Array} a list of merged segment objects
	 */
	
	
	var updateSegments = function updateSegments(original, update, offset) {
	  var oldSegments = original.slice();
	  var newSegments = update.slice();
	  offset = offset || 0;
	  var result = [];
	  var currentMap;
	
	  for (var newIndex = 0; newIndex < newSegments.length; newIndex++) {
	    var oldSegment = oldSegments[newIndex + offset];
	    var newSegment = newSegments[newIndex];
	
	    if (oldSegment) {
	      currentMap = oldSegment.map || currentMap;
	      result.push(updateSegment(oldSegment, newSegment));
	    } else {
	      // carry over map to new segment if it is missing
	      if (currentMap && !newSegment.map) {
	        newSegment.map = currentMap;
	      }
	
	      result.push(newSegment);
	    }
	  }
	
	  return result;
	};
	
	var resolveSegmentUris = function resolveSegmentUris(segment, baseUri) {
	  // preloadSegment will not have a uri at all
	  // as the segment isn't actually in the manifest yet, only parts
	  if (!segment.resolvedUri && segment.uri) {
	    segment.resolvedUri = resolveUrl(baseUri, segment.uri);
	  }
	
	  if (segment.key && !segment.key.resolvedUri) {
	    segment.key.resolvedUri = resolveUrl(baseUri, segment.key.uri);
	  }
	
	  if (segment.map && !segment.map.resolvedUri) {
	    segment.map.resolvedUri = resolveUrl(baseUri, segment.map.uri);
	  }
	
	  if (segment.map && segment.map.key && !segment.map.key.resolvedUri) {
	    segment.map.key.resolvedUri = resolveUrl(baseUri, segment.map.key.uri);
	  }
	
	  if (segment.parts && segment.parts.length) {
	    segment.parts.forEach(function (p) {
	      if (p.resolvedUri) {
	        return;
	      }
	
	      p.resolvedUri = resolveUrl(baseUri, p.uri);
	    });
	  }
	
	  if (segment.preloadHints && segment.preloadHints.length) {
	    segment.preloadHints.forEach(function (p) {
	      if (p.resolvedUri) {
	        return;
	      }
	
	      p.resolvedUri = resolveUrl(baseUri, p.uri);
	    });
	  }
	};
	
	var getAllSegments = function getAllSegments(media) {
	  var segments = media.segments || [];
	  var preloadSegment = media.preloadSegment; // a preloadSegment with only preloadHints is not currently
	  // a usable segment, only include a preloadSegment that has
	  // parts.
	
	  if (preloadSegment && preloadSegment.parts && preloadSegment.parts.length) {
	    // if preloadHints has a MAP that means that the
	    // init segment is going to change. We cannot use any of the parts
	    // from this preload segment.
	    if (preloadSegment.preloadHints) {
	      for (var i = 0; i < preloadSegment.preloadHints.length; i++) {
	        if (preloadSegment.preloadHints[i].type === 'MAP') {
	          return segments;
	        }
	      }
	    } // set the duration for our preload segment to target duration.
	
	
	    preloadSegment.duration = media.targetDuration;
	    preloadSegment.preload = true;
	    segments.push(preloadSegment);
	  }
	
	  return segments;
	}; // consider the playlist unchanged if the playlist object is the same or
	// the number of segments is equal, the media sequence number is unchanged,
	// and this playlist hasn't become the end of the playlist
	
	
	var isPlaylistUnchanged = function isPlaylistUnchanged(a, b) {
	  return a === b || a.segments && b.segments && a.segments.length === b.segments.length && a.endList === b.endList && a.mediaSequence === b.mediaSequence && a.preloadSegment === b.preloadSegment;
	};
	/**
	  * Returns a new master playlist that is the result of merging an
	  * updated media playlist into the original version. If the
	  * updated media playlist does not match any of the playlist
	  * entries in the original master playlist, null is returned.
	  *
	  * @param {Object} master a parsed master M3U8 object
	  * @param {Object} media a parsed media M3U8 object
	  * @return {Object} a new object that represents the original
	  * master playlist with the updated media playlist merged in, or
	  * null if the merge produced no change.
	  */
	
	
	var updateMaster$1 = function updateMaster(master, newMedia, unchangedCheck) {
	  if (unchangedCheck === void 0) {
	    unchangedCheck = isPlaylistUnchanged;
	  }
	
	  var result = mergeOptions$2(master, {});
	  var oldMedia = result.playlists[newMedia.id];
	
	  if (!oldMedia) {
	    return null;
	  }
	
	  if (unchangedCheck(oldMedia, newMedia)) {
	    return null;
	  }
	
	  newMedia.segments = getAllSegments(newMedia);
	  var mergedPlaylist = mergeOptions$2(oldMedia, newMedia); // always use the new media's preload segment
	
	  if (mergedPlaylist.preloadSegment && !newMedia.preloadSegment) {
	    delete mergedPlaylist.preloadSegment;
	  } // if the update could overlap existing segment information, merge the two segment lists
	
	
	  if (oldMedia.segments) {
	    if (newMedia.skip) {
	      newMedia.segments = newMedia.segments || []; // add back in objects for skipped segments, so that we merge
	      // old properties into the new segments
	
	      for (var i = 0; i < newMedia.skip.skippedSegments; i++) {
	        newMedia.segments.unshift({
	          skipped: true
	        });
	      }
	    }
	
	    mergedPlaylist.segments = updateSegments(oldMedia.segments, newMedia.segments, newMedia.mediaSequence - oldMedia.mediaSequence);
	  } // resolve any segment URIs to prevent us from having to do it later
	
	
	  mergedPlaylist.segments.forEach(function (segment) {
	    resolveSegmentUris(segment, mergedPlaylist.resolvedUri);
	  }); // TODO Right now in the playlists array there are two references to each playlist, one
	  // that is referenced by index, and one by URI. The index reference may no longer be
	  // necessary.
	
	  for (var _i = 0; _i < result.playlists.length; _i++) {
	    if (result.playlists[_i].id === newMedia.id) {
	      result.playlists[_i] = mergedPlaylist;
	    }
	  }
	
	  result.playlists[newMedia.id] = mergedPlaylist; // URI reference added for backwards compatibility
	
	  result.playlists[newMedia.uri] = mergedPlaylist; // update media group playlist references.
	
	  forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	    if (!properties.playlists) {
	      return;
	    }
	
	    for (var _i2 = 0; _i2 < properties.playlists.length; _i2++) {
	      if (newMedia.id === properties.playlists[_i2].id) {
	        properties.playlists[_i2] = mergedPlaylist;
	      }
	    }
	  });
	  return result;
	};
	/**
	 * Calculates the time to wait before refreshing a live playlist
	 *
	 * @param {Object} media
	 *        The current media
	 * @param {boolean} update
	 *        True if there were any updates from the last refresh, false otherwise
	 * @return {number}
	 *         The time in ms to wait before refreshing the live playlist
	 */
	
	
	var refreshDelay = function refreshDelay(media, update) {
	  var segments = media.segments || [];
	  var lastSegment = segments[segments.length - 1];
	  var lastPart = lastSegment && lastSegment.parts && lastSegment.parts[lastSegment.parts.length - 1];
	  var lastDuration = lastPart && lastPart.duration || lastSegment && lastSegment.duration;
	
	  if (update && lastDuration) {
	    return lastDuration * 1000;
	  } // if the playlist is unchanged since the last reload or last segment duration
	  // cannot be determined, try again after half the target duration
	
	
	  return (media.partTargetDuration || media.targetDuration || 10) * 500;
	};
	/**
	 * Load a playlist from a remote location
	 *
	 * @class PlaylistLoader
	 * @extends Stream
	 * @param {string|Object} src url or object of manifest
	 * @param {boolean} withCredentials the withCredentials xhr option
	 * @class
	 */
	
	
	var PlaylistLoader = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](PlaylistLoader, _EventTarget);
	
	  function PlaylistLoader(src, vhs, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	
	    if (!src) {
	      throw new Error('A non-empty playlist URL or object is required');
	    }
	
	    _this.logger_ = logger('PlaylistLoader');
	    var _options = options,
	        _options$withCredenti = _options.withCredentials,
	        withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti,
	        _options$handleManife = _options.handleManifestRedirects,
	        handleManifestRedirects = _options$handleManife === void 0 ? false : _options$handleManife;
	    _this.src = src;
	    _this.vhs_ = vhs;
	    _this.withCredentials = withCredentials;
	    _this.handleManifestRedirects = handleManifestRedirects;
	    var vhsOptions = vhs.options_;
	    _this.customTagParsers = vhsOptions && vhsOptions.customTagParsers || [];
	    _this.customTagMappers = vhsOptions && vhsOptions.customTagMappers || [];
	    _this.experimentalLLHLS = vhsOptions && vhsOptions.experimentalLLHLS || false; // force experimentalLLHLS for IE 11
	
	    if (videojs.browser.IE_VERSION) {
	      _this.experimentalLLHLS = false;
	    } // initialize the loader state
	
	
	    _this.state = 'HAVE_NOTHING'; // live playlist staleness timeout
	
	    _this.handleMediaupdatetimeout_ = _this.handleMediaupdatetimeout_.bind(_assertThisInitialized__default['default'](_this));
	
	    _this.on('mediaupdatetimeout', _this.handleMediaupdatetimeout_);
	
	    return _this;
	  }
	
	  var _proto = PlaylistLoader.prototype;
	
	  _proto.handleMediaupdatetimeout_ = function handleMediaupdatetimeout_() {
	    var _this2 = this;
	
	    if (this.state !== 'HAVE_METADATA') {
	      // only refresh the media playlist if no other activity is going on
	      return;
	    }
	
	    var media = this.media();
	    var uri = resolveUrl(this.master.uri, media.uri);
	
	    if (this.experimentalLLHLS) {
	      uri = addLLHLSQueryDirectives(uri, media);
	    }
	
	    this.state = 'HAVE_CURRENT_METADATA';
	    this.request = this.vhs_.xhr({
	      uri: uri,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this2.request) {
	        return;
	      }
	
	      if (error) {
	        return _this2.playlistRequestError(_this2.request, _this2.media(), 'HAVE_METADATA');
	      }
	
	      _this2.haveMetadata({
	        playlistString: _this2.request.responseText,
	        url: _this2.media().uri,
	        id: _this2.media().id
	      });
	    });
	  };
	
	  _proto.playlistRequestError = function playlistRequestError(xhr, playlist, startingState) {
	    var uri = playlist.uri,
	        id = playlist.id; // any in-flight request is now finished
	
	    this.request = null;
	
	    if (startingState) {
	      this.state = startingState;
	    }
	
	    this.error = {
	      playlist: this.master.playlists[id],
	      status: xhr.status,
	      message: "HLS playlist request error at URL: " + uri + ".",
	      responseText: xhr.responseText,
	      code: xhr.status >= 500 ? 4 : 2
	    };
	    this.trigger('error');
	  };
	
	  _proto.parseManifest_ = function parseManifest_(_ref) {
	    var _this3 = this;
	
	    var url = _ref.url,
	        manifestString = _ref.manifestString;
	    return parseManifest({
	      onwarn: function onwarn(_ref2) {
	        var message = _ref2.message;
	        return _this3.logger_("m3u8-parser warn for " + url + ": " + message);
	      },
	      oninfo: function oninfo(_ref3) {
	        var message = _ref3.message;
	        return _this3.logger_("m3u8-parser info for " + url + ": " + message);
	      },
	      manifestString: manifestString,
	      customTagParsers: this.customTagParsers,
	      customTagMappers: this.customTagMappers,
	      experimentalLLHLS: this.experimentalLLHLS
	    });
	  }
	  /**
	   * Update the playlist loader's state in response to a new or updated playlist.
	   *
	   * @param {string} [playlistString]
	   *        Playlist string (if playlistObject is not provided)
	   * @param {Object} [playlistObject]
	   *        Playlist object (if playlistString is not provided)
	   * @param {string} url
	   *        URL of playlist
	   * @param {string} id
	   *        ID to use for playlist
	   */
	  ;
	
	  _proto.haveMetadata = function haveMetadata(_ref4) {
	    var playlistString = _ref4.playlistString,
	        playlistObject = _ref4.playlistObject,
	        url = _ref4.url,
	        id = _ref4.id; // any in-flight request is now finished
	
	    this.request = null;
	    this.state = 'HAVE_METADATA';
	    var playlist = playlistObject || this.parseManifest_({
	      url: url,
	      manifestString: playlistString
	    });
	    playlist.lastRequest = Date.now();
	    setupMediaPlaylist({
	      playlist: playlist,
	      uri: url,
	      id: id
	    }); // merge this playlist into the master
	
	    var update = updateMaster$1(this.master, playlist);
	    this.targetDuration = playlist.partTargetDuration || playlist.targetDuration;
	    this.pendingMedia_ = null;
	
	    if (update) {
	      this.master = update;
	      this.media_ = this.master.playlists[id];
	    } else {
	      this.trigger('playlistunchanged');
	    }
	
	    this.updateMediaUpdateTimeout_(refreshDelay(this.media(), !!update));
	    this.trigger('loadedplaylist');
	  }
	  /**
	    * Abort any outstanding work and clean up.
	    */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.stopRequest();
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    window__default['default'].clearTimeout(this.finalRenditionTimeout);
	    this.off();
	  };
	
	  _proto.stopRequest = function stopRequest() {
	    if (this.request) {
	      var oldRequest = this.request;
	      this.request = null;
	      oldRequest.onreadystatechange = null;
	      oldRequest.abort();
	    }
	  }
	  /**
	    * When called without any arguments, returns the currently
	    * active media playlist. When called with a single argument,
	    * triggers the playlist loader to asynchronously switch to the
	    * specified media playlist. Calling this method while the
	    * loader is in the HAVE_NOTHING causes an error to be emitted
	    * but otherwise has no effect.
	    *
	    * @param {Object=} playlist the parsed media playlist
	    * object to switch to
	    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
	    *
	    * @return {Playlist} the current loaded media
	    */
	  ;
	
	  _proto.media = function media(playlist, shouldDelay) {
	    var _this4 = this; // getter
	
	
	    if (!playlist) {
	      return this.media_;
	    } // setter
	
	
	    if (this.state === 'HAVE_NOTHING') {
	      throw new Error('Cannot switch media playlist from ' + this.state);
	    } // find the playlist object if the target playlist has been
	    // specified by URI
	
	
	    if (typeof playlist === 'string') {
	      if (!this.master.playlists[playlist]) {
	        throw new Error('Unknown playlist URI: ' + playlist);
	      }
	
	      playlist = this.master.playlists[playlist];
	    }
	
	    window__default['default'].clearTimeout(this.finalRenditionTimeout);
	
	    if (shouldDelay) {
	      var delay = (playlist.partTargetDuration || playlist.targetDuration) / 2 * 1000 || 5 * 1000;
	      this.finalRenditionTimeout = window__default['default'].setTimeout(this.media.bind(this, playlist, false), delay);
	      return;
	    }
	
	    var startingState = this.state;
	    var mediaChange = !this.media_ || playlist.id !== this.media_.id;
	    var masterPlaylistRef = this.master.playlists[playlist.id]; // switch to fully loaded playlists immediately
	
	    if (masterPlaylistRef && masterPlaylistRef.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
	    // media playlist or, for the case of demuxed audio, a resolved audio media group)
	    playlist.endList && playlist.segments.length) {
	      // abort outstanding playlist requests
	      if (this.request) {
	        this.request.onreadystatechange = null;
	        this.request.abort();
	        this.request = null;
	      }
	
	      this.state = 'HAVE_METADATA';
	      this.media_ = playlist; // trigger media change if the active media has been updated
	
	      if (mediaChange) {
	        this.trigger('mediachanging');
	
	        if (startingState === 'HAVE_MASTER') {
	          // The initial playlist was a master manifest, and the first media selected was
	          // also provided (in the form of a resolved playlist object) as part of the
	          // source object (rather than just a URL). Therefore, since the media playlist
	          // doesn't need to be requested, loadedmetadata won't trigger as part of the
	          // normal flow, and needs an explicit trigger here.
	          this.trigger('loadedmetadata');
	        } else {
	          this.trigger('mediachange');
	        }
	      }
	
	      return;
	    } // We update/set the timeout here so that live playlists
	    // that are not a media change will "start" the loader as expected.
	    // We expect that this function will start the media update timeout
	    // cycle again. This also prevents a playlist switch failure from
	    // causing us to stall during live.
	
	
	    this.updateMediaUpdateTimeout_(refreshDelay(playlist, true)); // switching to the active playlist is a no-op
	
	    if (!mediaChange) {
	      return;
	    }
	
	    this.state = 'SWITCHING_MEDIA'; // there is already an outstanding playlist request
	
	    if (this.request) {
	      if (playlist.resolvedUri === this.request.url) {
	        // requesting to switch to the same playlist multiple times
	        // has no effect after the first
	        return;
	      }
	
	      this.request.onreadystatechange = null;
	      this.request.abort();
	      this.request = null;
	    } // request the new playlist
	
	
	    if (this.media_) {
	      this.trigger('mediachanging');
	    }
	
	    this.pendingMedia_ = playlist;
	    this.request = this.vhs_.xhr({
	      uri: playlist.resolvedUri,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this4.request) {
	        return;
	      }
	
	      playlist.lastRequest = Date.now();
	      playlist.resolvedUri = resolveManifestRedirect(_this4.handleManifestRedirects, playlist.resolvedUri, req);
	
	      if (error) {
	        return _this4.playlistRequestError(_this4.request, playlist, startingState);
	      }
	
	      _this4.haveMetadata({
	        playlistString: req.responseText,
	        url: playlist.uri,
	        id: playlist.id
	      }); // fire loadedmetadata the first time a media playlist is loaded
	
	
	      if (startingState === 'HAVE_MASTER') {
	        _this4.trigger('loadedmetadata');
	      } else {
	        _this4.trigger('mediachange');
	      }
	    });
	  }
	  /**
	   * pause loading of the playlist
	   */
	  ;
	
	  _proto.pause = function pause() {
	    if (this.mediaUpdateTimeout) {
	      window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	      this.mediaUpdateTimeout = null;
	    }
	
	    this.stopRequest();
	
	    if (this.state === 'HAVE_NOTHING') {
	      // If we pause the loader before any data has been retrieved, its as if we never
	      // started, so reset to an unstarted state.
	      this.started = false;
	    } // Need to restore state now that no activity is happening
	
	
	    if (this.state === 'SWITCHING_MEDIA') {
	      // if the loader was in the process of switching media, it should either return to
	      // HAVE_MASTER or HAVE_METADATA depending on if the loader has loaded a media
	      // playlist yet. This is determined by the existence of loader.media_
	      if (this.media_) {
	        this.state = 'HAVE_METADATA';
	      } else {
	        this.state = 'HAVE_MASTER';
	      }
	    } else if (this.state === 'HAVE_CURRENT_METADATA') {
	      this.state = 'HAVE_METADATA';
	    }
	  }
	  /**
	   * start loading of the playlist
	   */
	  ;
	
	  _proto.load = function load(shouldDelay) {
	    var _this5 = this;
	
	    if (this.mediaUpdateTimeout) {
	      window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	      this.mediaUpdateTimeout = null;
	    }
	
	    var media = this.media();
	
	    if (shouldDelay) {
	      var delay = media ? (media.partTargetDuration || media.targetDuration) / 2 * 1000 : 5 * 1000;
	      this.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	        _this5.mediaUpdateTimeout = null;
	
	        _this5.load();
	      }, delay);
	      return;
	    }
	
	    if (!this.started) {
	      this.start();
	      return;
	    }
	
	    if (media && !media.endList) {
	      this.trigger('mediaupdatetimeout');
	    } else {
	      this.trigger('loadedplaylist');
	    }
	  };
	
	  _proto.updateMediaUpdateTimeout_ = function updateMediaUpdateTimeout_(delay) {
	    var _this6 = this;
	
	    if (this.mediaUpdateTimeout) {
	      window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	      this.mediaUpdateTimeout = null;
	    } // we only have use mediaupdatetimeout for live playlists.
	
	
	    if (!this.media() || this.media().endList) {
	      return;
	    }
	
	    this.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	      _this6.mediaUpdateTimeout = null;
	
	      _this6.trigger('mediaupdatetimeout');
	
	      _this6.updateMediaUpdateTimeout_(delay);
	    }, delay);
	  }
	  /**
	   * start loading of the playlist
	   */
	  ;
	
	  _proto.start = function start() {
	    var _this7 = this;
	
	    this.started = true;
	
	    if (typeof this.src === 'object') {
	      // in the case of an entirely constructed manifest object (meaning there's no actual
	      // manifest on a server), default the uri to the page's href
	      if (!this.src.uri) {
	        this.src.uri = window__default['default'].location.href;
	      } // resolvedUri is added on internally after the initial request. Since there's no
	      // request for pre-resolved manifests, add on resolvedUri here.
	
	
	      this.src.resolvedUri = this.src.uri; // Since a manifest object was passed in as the source (instead of a URL), the first
	      // request can be skipped (since the top level of the manifest, at a minimum, is
	      // already available as a parsed manifest object). However, if the manifest object
	      // represents a master playlist, some media playlists may need to be resolved before
	      // the starting segment list is available. Therefore, go directly to setup of the
	      // initial playlist, and let the normal flow continue from there.
	      //
	      // Note that the call to setup is asynchronous, as other sections of VHS may assume
	      // that the first request is asynchronous.
	
	      setTimeout(function () {
	        _this7.setupInitialPlaylist(_this7.src);
	      }, 0);
	      return;
	    } // request the specified URL
	
	
	    this.request = this.vhs_.xhr({
	      uri: this.src,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this7.request) {
	        return;
	      } // clear the loader's request reference
	
	
	      _this7.request = null;
	
	      if (error) {
	        _this7.error = {
	          status: req.status,
	          message: "HLS playlist request error at URL: " + _this7.src + ".",
	          responseText: req.responseText,
	          // MEDIA_ERR_NETWORK
	          code: 2
	        };
	
	        if (_this7.state === 'HAVE_NOTHING') {
	          _this7.started = false;
	        }
	
	        return _this7.trigger('error');
	      }
	
	      _this7.src = resolveManifestRedirect(_this7.handleManifestRedirects, _this7.src, req);
	
	      var manifest = _this7.parseManifest_({
	        manifestString: req.responseText,
	        url: _this7.src
	      });
	
	      _this7.setupInitialPlaylist(manifest);
	    });
	  };
	
	  _proto.srcUri = function srcUri() {
	    return typeof this.src === 'string' ? this.src : this.src.uri;
	  }
	  /**
	   * Given a manifest object that's either a master or media playlist, trigger the proper
	   * events and set the state of the playlist loader.
	   *
	   * If the manifest object represents a master playlist, `loadedplaylist` will be
	   * triggered to allow listeners to select a playlist. If none is selected, the loader
	   * will default to the first one in the playlists array.
	   *
	   * If the manifest object represents a media playlist, `loadedplaylist` will be
	   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
	   *
	   * In the case of a media playlist, a master playlist object wrapper with one playlist
	   * will be created so that all logic can handle playlists in the same fashion (as an
	   * assumed manifest object schema).
	   *
	   * @param {Object} manifest
	   *        The parsed manifest object
	   */
	  ;
	
	  _proto.setupInitialPlaylist = function setupInitialPlaylist(manifest) {
	    this.state = 'HAVE_MASTER';
	
	    if (manifest.playlists) {
	      this.master = manifest;
	      addPropertiesToMaster(this.master, this.srcUri()); // If the initial master playlist has playlists wtih segments already resolved,
	      // then resolve URIs in advance, as they are usually done after a playlist request,
	      // which may not happen if the playlist is resolved.
	
	      manifest.playlists.forEach(function (playlist) {
	        playlist.segments = getAllSegments(playlist);
	        playlist.segments.forEach(function (segment) {
	          resolveSegmentUris(segment, playlist.resolvedUri);
	        });
	      });
	      this.trigger('loadedplaylist');
	
	      if (!this.request) {
	        // no media playlist was specifically selected so start
	        // from the first listed one
	        this.media(this.master.playlists[0]);
	      }
	
	      return;
	    } // In order to support media playlists passed in as vhs-json, the case where the uri
	    // is not provided as part of the manifest should be considered, and an appropriate
	    // default used.
	
	
	    var uri = this.srcUri() || window__default['default'].location.href;
	    this.master = masterForMedia(manifest, uri);
	    this.haveMetadata({
	      playlistObject: manifest,
	      url: uri,
	      id: this.master.playlists[0].id
	    });
	    this.trigger('loadedmetadata');
	  };
	
	  return PlaylistLoader;
	}(EventTarget$1);
	/**
	 * @file xhr.js
	 */
	
	
	var videojsXHR = videojs.xhr,
	    mergeOptions$1 = videojs.mergeOptions;
	
	var callbackWrapper = function callbackWrapper(request, error, response, callback) {
	  var reqResponse = request.responseType === 'arraybuffer' ? request.response : request.responseText;
	
	  if (!error && reqResponse) {
	    request.responseTime = Date.now();
	    request.roundTripTime = request.responseTime - request.requestTime;
	    request.bytesReceived = reqResponse.byteLength || reqResponse.length;
	
	    if (!request.bandwidth) {
	      request.bandwidth = Math.floor(request.bytesReceived / request.roundTripTime * 8 * 1000);
	    }
	  }
	
	  if (response.headers) {
	    request.responseHeaders = response.headers;
	  } // videojs.xhr now uses a specific code on the error
	  // object to signal that a request has timed out instead
	  // of setting a boolean on the request object
	
	
	  if (error && error.code === 'ETIMEDOUT') {
	    request.timedout = true;
	  } // videojs.xhr no longer considers status codes outside of 200 and 0
	  // (for file uris) to be errors, but the old XHR did, so emulate that
	  // behavior. Status 206 may be used in response to byterange requests.
	
	
	  if (!error && !request.aborted && response.statusCode !== 200 && response.statusCode !== 206 && response.statusCode !== 0) {
	    error = new Error('XHR Failed with a response of: ' + (request && (reqResponse || request.responseText)));
	  }
	
	  callback(error, request);
	};
	
	var xhrFactory = function xhrFactory() {
	  var xhr = function XhrFunction(options, callback) {
	    // Add a default timeout
	    options = mergeOptions$1({
	      timeout: 45e3
	    }, options); // Allow an optional user-specified function to modify the option
	    // object before we construct the xhr request
	
	    var beforeRequest = XhrFunction.beforeRequest || videojs.Vhs.xhr.beforeRequest;
	
	    if (beforeRequest && typeof beforeRequest === 'function') {
	      var newOptions = beforeRequest(options);
	
	      if (newOptions) {
	        options = newOptions;
	      }
	    } // Use the standard videojs.xhr() method unless `videojs.Vhs.xhr` has been overriden
	    // TODO: switch back to videojs.Vhs.xhr.name === 'XhrFunction' when we drop IE11
	
	
	    var xhrMethod = videojs.Vhs.xhr.original === true ? videojsXHR : videojs.Vhs.xhr;
	    var request = xhrMethod(options, function (error, response) {
	      return callbackWrapper(request, error, response, callback);
	    });
	    var originalAbort = request.abort;
	
	    request.abort = function () {
	      request.aborted = true;
	      return originalAbort.apply(request, arguments);
	    };
	
	    request.uri = options.uri;
	    request.requestTime = Date.now();
	    return request;
	  };
	
	  xhr.original = true;
	  return xhr;
	};
	/**
	 * Turns segment byterange into a string suitable for use in
	 * HTTP Range requests
	 *
	 * @param {Object} byterange - an object with two values defining the start and end
	 *                             of a byte-range
	 */
	
	
	var byterangeStr = function byterangeStr(byterange) {
	  // `byterangeEnd` is one less than `offset + length` because the HTTP range
	  // header uses inclusive ranges
	  var byterangeEnd;
	  var byterangeStart = byterange.offset;
	
	  if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') {
	    byterangeEnd = window__default['default'].BigInt(byterange.offset) + window__default['default'].BigInt(byterange.length) - window__default['default'].BigInt(1);
	  } else {
	    byterangeEnd = byterange.offset + byterange.length - 1;
	  }
	
	  return 'bytes=' + byterangeStart + '-' + byterangeEnd;
	};
	/**
	 * Defines headers for use in the xhr request for a particular segment.
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 */
	
	
	var segmentXhrHeaders = function segmentXhrHeaders(segment) {
	  var headers = {};
	
	  if (segment.byterange) {
	    headers.Range = byterangeStr(segment.byterange);
	  }
	
	  return headers;
	};
	/**
	 * @file bin-utils.js
	 */
	
	/**
	 * convert a TimeRange to text
	 *
	 * @param {TimeRange} range the timerange to use for conversion
	 * @param {number} i the iterator on the range to convert
	 * @return {string} the range in string format
	 */
	
	
	var textRange = function textRange(range, i) {
	  return range.start(i) + '-' + range.end(i);
	};
	/**
	 * format a number as hex string
	 *
	 * @param {number} e The number
	 * @param {number} i the iterator
	 * @return {string} the hex formatted number as a string
	 */
	
	
	var formatHexString = function formatHexString(e, i) {
	  var value = e.toString(16);
	  return '00'.substring(0, 2 - value.length) + value + (i % 2 ? ' ' : '');
	};
	
	var formatAsciiString = function formatAsciiString(e) {
	  if (e >= 0x20 && e < 0x7e) {
	    return String.fromCharCode(e);
	  }
	
	  return '.';
	};
	/**
	 * Creates an object for sending to a web worker modifying properties that are TypedArrays
	 * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
	 *
	 * @param {Object} message
	 *        Object of properties and values to send to the web worker
	 * @return {Object}
	 *         Modified message with TypedArray values expanded
	 * @function createTransferableMessage
	 */
	
	
	var createTransferableMessage = function createTransferableMessage(message) {
	  var transferable = {};
	  Object.keys(message).forEach(function (key) {
	    var value = message[key];
	
	    if (byteHelpers.isArrayBufferView(value)) {
	      transferable[key] = {
	        bytes: value.buffer,
	        byteOffset: value.byteOffset,
	        byteLength: value.byteLength
	      };
	    } else {
	      transferable[key] = value;
	    }
	  });
	  return transferable;
	};
	/**
	 * Returns a unique string identifier for a media initialization
	 * segment.
	 *
	 * @param {Object} initSegment
	 *        the init segment object.
	 *
	 * @return {string} the generated init segment id
	 */
	
	
	var initSegmentId = function initSegmentId(initSegment) {
	  var byterange = initSegment.byterange || {
	    length: Infinity,
	    offset: 0
	  };
	  return [byterange.length, byterange.offset, initSegment.resolvedUri].join(',');
	};
	/**
	 * Returns a unique string identifier for a media segment key.
	 *
	 * @param {Object} key the encryption key
	 * @return {string} the unique id for the media segment key.
	 */
	
	
	var segmentKeyId = function segmentKeyId(key) {
	  return key.resolvedUri;
	};
	/**
	 * utils to help dump binary data to the console
	 *
	 * @param {Array|TypedArray} data
	 *        data to dump to a string
	 *
	 * @return {string} the data as a hex string.
	 */
	
	
	var hexDump = function hexDump(data) {
	  var bytes = Array.prototype.slice.call(data);
	  var step = 16;
	  var result = '';
	  var hex;
	  var ascii;
	
	  for (var j = 0; j < bytes.length / step; j++) {
	    hex = bytes.slice(j * step, j * step + step).map(formatHexString).join('');
	    ascii = bytes.slice(j * step, j * step + step).map(formatAsciiString).join('');
	    result += hex + ' ' + ascii + '\n';
	  }
	
	  return result;
	};
	
	var tagDump = function tagDump(_ref) {
	  var bytes = _ref.bytes;
	  return hexDump(bytes);
	};
	
	var textRanges = function textRanges(ranges) {
	  var result = '';
	  var i;
	
	  for (i = 0; i < ranges.length; i++) {
	    result += textRange(ranges, i) + ' ';
	  }
	
	  return result;
	};
	
	var utils = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  createTransferableMessage: createTransferableMessage,
	  initSegmentId: initSegmentId,
	  segmentKeyId: segmentKeyId,
	  hexDump: hexDump,
	  tagDump: tagDump,
	  textRanges: textRanges
	}); // TODO handle fmp4 case where the timing info is accurate and doesn't involve transmux
	// 25% was arbitrarily chosen, and may need to be refined over time.
	
	var SEGMENT_END_FUDGE_PERCENT = 0.25;
	/**
	 * Converts a player time (any time that can be gotten/set from player.currentTime(),
	 * e.g., any time within player.seekable().start(0) to player.seekable().end(0)) to a
	 * program time (any time referencing the real world (e.g., EXT-X-PROGRAM-DATE-TIME)).
	 *
	 * The containing segment is required as the EXT-X-PROGRAM-DATE-TIME serves as an "anchor
	 * point" (a point where we have a mapping from program time to player time, with player
	 * time being the post transmux start of the segment).
	 *
	 * For more details, see [this doc](../../docs/program-time-from-player-time.md).
	 *
	 * @param {number} playerTime the player time
	 * @param {Object} segment the segment which contains the player time
	 * @return {Date} program time
	 */
	
	var playerTimeToProgramTime = function playerTimeToProgramTime(playerTime, segment) {
	  if (!segment.dateTimeObject) {
	    // Can't convert without an "anchor point" for the program time (i.e., a time that can
	    // be used to map the start of a segment with a real world time).
	    return null;
	  }
	
	  var transmuxerPrependedSeconds = segment.videoTimingInfo.transmuxerPrependedSeconds;
	  var transmuxedStart = segment.videoTimingInfo.transmuxedPresentationStart; // get the start of the content from before old content is prepended
	
	  var startOfSegment = transmuxedStart + transmuxerPrependedSeconds;
	  var offsetFromSegmentStart = playerTime - startOfSegment;
	  return new Date(segment.dateTimeObject.getTime() + offsetFromSegmentStart * 1000);
	};
	
	var originalSegmentVideoDuration = function originalSegmentVideoDuration(videoTimingInfo) {
	  return videoTimingInfo.transmuxedPresentationEnd - videoTimingInfo.transmuxedPresentationStart - videoTimingInfo.transmuxerPrependedSeconds;
	};
	/**
	 * Finds a segment that contains the time requested given as an ISO-8601 string. The
	 * returned segment might be an estimate or an accurate match.
	 *
	 * @param {string} programTime The ISO-8601 programTime to find a match for
	 * @param {Object} playlist A playlist object to search within
	 */
	
	
	var findSegmentForProgramTime = function findSegmentForProgramTime(programTime, playlist) {
	  // Assumptions:
	  //  - verifyProgramDateTimeTags has already been run
	  //  - live streams have been started
	  var dateTimeObject;
	
	  try {
	    dateTimeObject = new Date(programTime);
	  } catch (e) {
	    return null;
	  }
	
	  if (!playlist || !playlist.segments || playlist.segments.length === 0) {
	    return null;
	  }
	
	  var segment = playlist.segments[0];
	
	  if (dateTimeObject < segment.dateTimeObject) {
	    // Requested time is before stream start.
	    return null;
	  }
	
	  for (var i = 0; i < playlist.segments.length - 1; i++) {
	    segment = playlist.segments[i];
	    var nextSegmentStart = playlist.segments[i + 1].dateTimeObject;
	
	    if (dateTimeObject < nextSegmentStart) {
	      break;
	    }
	  }
	
	  var lastSegment = playlist.segments[playlist.segments.length - 1];
	  var lastSegmentStart = lastSegment.dateTimeObject;
	  var lastSegmentDuration = lastSegment.videoTimingInfo ? originalSegmentVideoDuration(lastSegment.videoTimingInfo) : lastSegment.duration + lastSegment.duration * SEGMENT_END_FUDGE_PERCENT;
	  var lastSegmentEnd = new Date(lastSegmentStart.getTime() + lastSegmentDuration * 1000);
	
	  if (dateTimeObject > lastSegmentEnd) {
	    // Beyond the end of the stream, or our best guess of the end of the stream.
	    return null;
	  }
	
	  if (dateTimeObject > lastSegmentStart) {
	    segment = lastSegment;
	  }
	
	  return {
	    segment: segment,
	    estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : Playlist.duration(playlist, playlist.mediaSequence + playlist.segments.indexOf(segment)),
	    // Although, given that all segments have accurate date time objects, the segment
	    // selected should be accurate, unless the video has been transmuxed at some point
	    // (determined by the presence of the videoTimingInfo object), the segment's "player
	    // time" (the start time in the player) can't be considered accurate.
	    type: segment.videoTimingInfo ? 'accurate' : 'estimate'
	  };
	};
	/**
	 * Finds a segment that contains the given player time(in seconds).
	 *
	 * @param {number} time The player time to find a match for
	 * @param {Object} playlist A playlist object to search within
	 */
	
	
	var findSegmentForPlayerTime = function findSegmentForPlayerTime(time, playlist) {
	  // Assumptions:
	  // - there will always be a segment.duration
	  // - we can start from zero
	  // - segments are in time order
	  if (!playlist || !playlist.segments || playlist.segments.length === 0) {
	    return null;
	  }
	
	  var segmentEnd = 0;
	  var segment;
	
	  for (var i = 0; i < playlist.segments.length; i++) {
	    segment = playlist.segments[i]; // videoTimingInfo is set after the segment is downloaded and transmuxed, and
	    // should contain the most accurate values we have for the segment's player times.
	    //
	    // Use the accurate transmuxedPresentationEnd value if it is available, otherwise fall
	    // back to an estimate based on the manifest derived (inaccurate) segment.duration, to
	    // calculate an end value.
	
	    segmentEnd = segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationEnd : segmentEnd + segment.duration;
	
	    if (time <= segmentEnd) {
	      break;
	    }
	  }
	
	  var lastSegment = playlist.segments[playlist.segments.length - 1];
	
	  if (lastSegment.videoTimingInfo && lastSegment.videoTimingInfo.transmuxedPresentationEnd < time) {
	    // The time requested is beyond the stream end.
	    return null;
	  }
	
	  if (time > segmentEnd) {
	    // The time is within or beyond the last segment.
	    //
	    // Check to see if the time is beyond a reasonable guess of the end of the stream.
	    if (time > segmentEnd + lastSegment.duration * SEGMENT_END_FUDGE_PERCENT) {
	      // Technically, because the duration value is only an estimate, the time may still
	      // exist in the last segment, however, there isn't enough information to make even
	      // a reasonable estimate.
	      return null;
	    }
	
	    segment = lastSegment;
	  }
	
	  return {
	    segment: segment,
	    estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : segmentEnd - segment.duration,
	    // Because videoTimingInfo is only set after transmux, it is the only way to get
	    // accurate timing values.
	    type: segment.videoTimingInfo ? 'accurate' : 'estimate'
	  };
	};
	/**
	 * Gives the offset of the comparisonTimestamp from the programTime timestamp in seconds.
	 * If the offset returned is positive, the programTime occurs after the
	 * comparisonTimestamp.
	 * If the offset is negative, the programTime occurs before the comparisonTimestamp.
	 *
	 * @param {string} comparisonTimeStamp An ISO-8601 timestamp to compare against
	 * @param {string} programTime The programTime as an ISO-8601 string
	 * @return {number} offset
	 */
	
	
	var getOffsetFromTimestamp = function getOffsetFromTimestamp(comparisonTimeStamp, programTime) {
	  var segmentDateTime;
	  var programDateTime;
	
	  try {
	    segmentDateTime = new Date(comparisonTimeStamp);
	    programDateTime = new Date(programTime);
	  } catch (e) {// TODO handle error
	  }
	
	  var segmentTimeEpoch = segmentDateTime.getTime();
	  var programTimeEpoch = programDateTime.getTime();
	  return (programTimeEpoch - segmentTimeEpoch) / 1000;
	};
	/**
	 * Checks that all segments in this playlist have programDateTime tags.
	 *
	 * @param {Object} playlist A playlist object
	 */
	
	
	var verifyProgramDateTimeTags = function verifyProgramDateTimeTags(playlist) {
	  if (!playlist.segments || playlist.segments.length === 0) {
	    return false;
	  }
	
	  for (var i = 0; i < playlist.segments.length; i++) {
	    var segment = playlist.segments[i];
	
	    if (!segment.dateTimeObject) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Returns the programTime of the media given a playlist and a playerTime.
	 * The playlist must have programDateTime tags for a programDateTime tag to be returned.
	 * If the segments containing the time requested have not been buffered yet, an estimate
	 * may be returned to the callback.
	 *
	 * @param {Object} args
	 * @param {Object} args.playlist A playlist object to search within
	 * @param {number} time A playerTime in seconds
	 * @param {Function} callback(err, programTime)
	 * @return {string} err.message A detailed error message
	 * @return {Object} programTime
	 * @return {number} programTime.mediaSeconds The streamTime in seconds
	 * @return {string} programTime.programDateTime The programTime as an ISO-8601 String
	 */
	
	
	var getProgramTime = function getProgramTime(_ref) {
	  var playlist = _ref.playlist,
	      _ref$time = _ref.time,
	      time = _ref$time === void 0 ? undefined : _ref$time,
	      callback = _ref.callback;
	
	  if (!callback) {
	    throw new Error('getProgramTime: callback must be provided');
	  }
	
	  if (!playlist || time === undefined) {
	    return callback({
	      message: 'getProgramTime: playlist and time must be provided'
	    });
	  }
	
	  var matchedSegment = findSegmentForPlayerTime(time, playlist);
	
	  if (!matchedSegment) {
	    return callback({
	      message: 'valid programTime was not found'
	    });
	  }
	
	  if (matchedSegment.type === 'estimate') {
	    return callback({
	      message: 'Accurate programTime could not be determined.' + ' Please seek to e.seekTime and try again',
	      seekTime: matchedSegment.estimatedStart
	    });
	  }
	
	  var programTimeObject = {
	    mediaSeconds: time
	  };
	  var programTime = playerTimeToProgramTime(time, matchedSegment.segment);
	
	  if (programTime) {
	    programTimeObject.programDateTime = programTime.toISOString();
	  }
	
	  return callback(null, programTimeObject);
	};
	/**
	 * Seeks in the player to a time that matches the given programTime ISO-8601 string.
	 *
	 * @param {Object} args
	 * @param {string} args.programTime A programTime to seek to as an ISO-8601 String
	 * @param {Object} args.playlist A playlist to look within
	 * @param {number} args.retryCount The number of times to try for an accurate seek. Default is 2.
	 * @param {Function} args.seekTo A method to perform a seek
	 * @param {boolean} args.pauseAfterSeek Whether to end in a paused state after seeking. Default is true.
	 * @param {Object} args.tech The tech to seek on
	 * @param {Function} args.callback(err, newTime) A callback to return the new time to
	 * @return {string} err.message A detailed error message
	 * @return {number} newTime The exact time that was seeked to in seconds
	 */
	
	
	var seekToProgramTime = function seekToProgramTime(_ref2) {
	  var programTime = _ref2.programTime,
	      playlist = _ref2.playlist,
	      _ref2$retryCount = _ref2.retryCount,
	      retryCount = _ref2$retryCount === void 0 ? 2 : _ref2$retryCount,
	      seekTo = _ref2.seekTo,
	      _ref2$pauseAfterSeek = _ref2.pauseAfterSeek,
	      pauseAfterSeek = _ref2$pauseAfterSeek === void 0 ? true : _ref2$pauseAfterSeek,
	      tech = _ref2.tech,
	      callback = _ref2.callback;
	
	  if (!callback) {
	    throw new Error('seekToProgramTime: callback must be provided');
	  }
	
	  if (typeof programTime === 'undefined' || !playlist || !seekTo) {
	    return callback({
	      message: 'seekToProgramTime: programTime, seekTo and playlist must be provided'
	    });
	  }
	
	  if (!playlist.endList && !tech.hasStarted_) {
	    return callback({
	      message: 'player must be playing a live stream to start buffering'
	    });
	  }
	
	  if (!verifyProgramDateTimeTags(playlist)) {
	    return callback({
	      message: 'programDateTime tags must be provided in the manifest ' + playlist.resolvedUri
	    });
	  }
	
	  var matchedSegment = findSegmentForProgramTime(programTime, playlist); // no match
	
	  if (!matchedSegment) {
	    return callback({
	      message: programTime + " was not found in the stream"
	    });
	  }
	
	  var segment = matchedSegment.segment;
	  var mediaOffset = getOffsetFromTimestamp(segment.dateTimeObject, programTime);
	
	  if (matchedSegment.type === 'estimate') {
	    // we've run out of retries
	    if (retryCount === 0) {
	      return callback({
	        message: programTime + " is not buffered yet. Try again"
	      });
	    }
	
	    seekTo(matchedSegment.estimatedStart + mediaOffset);
	    tech.one('seeked', function () {
	      seekToProgramTime({
	        programTime: programTime,
	        playlist: playlist,
	        retryCount: retryCount - 1,
	        seekTo: seekTo,
	        pauseAfterSeek: pauseAfterSeek,
	        tech: tech,
	        callback: callback
	      });
	    });
	    return;
	  } // Since the segment.start value is determined from the buffered end or ending time
	  // of the prior segment, the seekToTime doesn't need to account for any transmuxer
	  // modifications.
	
	
	  var seekToTime = segment.start + mediaOffset;
	
	  var seekedCallback = function seekedCallback() {
	    return callback(null, tech.currentTime());
	  }; // listen for seeked event
	
	
	  tech.one('seeked', seekedCallback); // pause before seeking as video.js will restore this state
	
	  if (pauseAfterSeek) {
	    tech.pause();
	  }
	
	  seekTo(seekToTime);
	}; // which will only happen if the request is complete.
	
	
	var callbackOnCompleted = function callbackOnCompleted(request, cb) {
	  if (request.readyState === 4) {
	    return cb();
	  }
	
	  return;
	};
	
	var containerRequest = function containerRequest(uri, xhr, cb) {
	  var bytes = [];
	  var id3Offset;
	  var finished = false;
	
	  var endRequestAndCallback = function endRequestAndCallback(err, req, type, _bytes) {
	    req.abort();
	    finished = true;
	    return cb(err, req, type, _bytes);
	  };
	
	  var progressListener = function progressListener(error, request) {
	    if (finished) {
	      return;
	    }
	
	    if (error) {
	      return endRequestAndCallback(error, request, '', bytes);
	    } // grap the new part of content that was just downloaded
	
	
	    var newPart = request.responseText.substring(bytes && bytes.byteLength || 0, request.responseText.length); // add that onto bytes
	
	    bytes = byteHelpers.concatTypedArrays(bytes, byteHelpers.stringToBytes(newPart, true));
	    id3Offset = id3Offset || id3Helpers.getId3Offset(bytes); // we need at least 10 bytes to determine a type
	    // or we need at least two bytes after an id3Offset
	
	    if (bytes.length < 10 || id3Offset && bytes.length < id3Offset + 2) {
	      return callbackOnCompleted(request, function () {
	        return endRequestAndCallback(error, request, '', bytes);
	      });
	    }
	
	    var type = containers.detectContainerForBytes(bytes); // if this looks like a ts segment but we don't have enough data
	    // to see the second sync byte, wait until we have enough data
	    // before declaring it ts
	
	    if (type === 'ts' && bytes.length < 188) {
	      return callbackOnCompleted(request, function () {
	        return endRequestAndCallback(error, request, '', bytes);
	      });
	    } // this may be an unsynced ts segment
	    // wait for 376 bytes before detecting no container
	
	
	    if (!type && bytes.length < 376) {
	      return callbackOnCompleted(request, function () {
	        return endRequestAndCallback(error, request, '', bytes);
	      });
	    }
	
	    return endRequestAndCallback(null, request, type, bytes);
	  };
	
	  var options = {
	    uri: uri,
	    beforeSend: function beforeSend(request) {
	      // this forces the browser to pass the bytes to us unprocessed
	      request.overrideMimeType('text/plain; charset=x-user-defined');
	      request.addEventListener('progress', function (_ref) {
	        _ref.total;
	        _ref.loaded;
	        return callbackWrapper(request, null, {
	          statusCode: request.status
	        }, progressListener);
	      });
	    }
	  };
	  var request = xhr(options, function (error, response) {
	    return callbackWrapper(request, error, response, progressListener);
	  });
	  return request;
	};
	
	var EventTarget = videojs.EventTarget,
	    mergeOptions = videojs.mergeOptions;
	
	var dashPlaylistUnchanged = function dashPlaylistUnchanged(a, b) {
	  if (!isPlaylistUnchanged(a, b)) {
	    return false;
	  } // for dash the above check will often return true in scenarios where
	  // the playlist actually has changed because mediaSequence isn't a
	  // dash thing, and we often set it to 1. So if the playlists have the same amount
	  // of segments we return true.
	  // So for dash we need to make sure that the underlying segments are different.
	  // if sidx changed then the playlists are different.
	
	
	  if (a.sidx && b.sidx && (a.sidx.offset !== b.sidx.offset || a.sidx.length !== b.sidx.length)) {
	    return false;
	  } else if (!a.sidx && b.sidx || a.sidx && !b.sidx) {
	    return false;
	  } // one or the other does not have segments
	  // there was a change.
	
	
	  if (a.segments && !b.segments || !a.segments && b.segments) {
	    return false;
	  } // neither has segments nothing changed
	
	
	  if (!a.segments && !b.segments) {
	    return true;
	  } // check segments themselves
	
	
	  for (var i = 0; i < a.segments.length; i++) {
	    var aSegment = a.segments[i];
	    var bSegment = b.segments[i]; // if uris are different between segments there was a change
	
	    if (aSegment.uri !== bSegment.uri) {
	      return false;
	    } // neither segment has a byterange, there will be no byterange change.
	
	
	    if (!aSegment.byterange && !bSegment.byterange) {
	      continue;
	    }
	
	    var aByterange = aSegment.byterange;
	    var bByterange = bSegment.byterange; // if byterange only exists on one of the segments, there was a change.
	
	    if (aByterange && !bByterange || !aByterange && bByterange) {
	      return false;
	    } // if both segments have byterange with different offsets, there was a change.
	
	
	    if (aByterange.offset !== bByterange.offset || aByterange.length !== bByterange.length) {
	      return false;
	    }
	  } // if everything was the same with segments, this is the same playlist.
	
	
	  return true;
	};
	/**
	 * Use the representation IDs from the mpd object to create groupIDs, the NAME is set to mandatory representation
	 * ID in the parser. This allows for continuous playout across periods with the same representation IDs
	 * (continuous periods as defined in DASH-IF 3.2.12). This is assumed in the mpd-parser as well. If we want to support
	 * periods without continuous playback this function may need modification as well as the parser.
	 */
	
	
	var dashGroupId = function dashGroupId(type, group, label, playlist) {
	  // If the manifest somehow does not have an ID (non-dash compliant), use the label.
	  var playlistId = playlist.attributes.NAME || label;
	  return "placeholder-uri-" + type + "-" + group + "-" + playlistId;
	};
	/**
	 * Parses the master XML string and updates playlist URI references.
	 *
	 * @param {Object} config
	 *        Object of arguments
	 * @param {string} config.masterXml
	 *        The mpd XML
	 * @param {string} config.srcUrl
	 *        The mpd URL
	 * @param {Date} config.clientOffset
	 *         A time difference between server and client
	 * @param {Object} config.sidxMapping
	 *        SIDX mappings for moof/mdat URIs and byte ranges
	 * @return {Object}
	 *         The parsed mpd manifest object
	 */
	
	
	var parseMasterXml = function parseMasterXml(_ref) {
	  var masterXml = _ref.masterXml,
	      srcUrl = _ref.srcUrl,
	      clientOffset = _ref.clientOffset,
	      sidxMapping = _ref.sidxMapping,
	      previousManifest = _ref.previousManifest;
	  var manifest = mpdParser.parse(masterXml, {
	    manifestUri: srcUrl,
	    clientOffset: clientOffset,
	    sidxMapping: sidxMapping,
	    previousManifest: previousManifest
	  });
	  addPropertiesToMaster(manifest, srcUrl, dashGroupId);
	  return manifest;
	};
	/**
	 * Removes any mediaGroup labels that no longer exist in the newMaster
	 *
	 * @param {Object} update
	 *         The previous mpd object being updated
	 * @param {Object} newMaster
	 *         The new mpd object
	 */
	
	
	var removeOldMediaGroupLabels = function removeOldMediaGroupLabels(update, newMaster) {
	  forEachMediaGroup(update, function (properties, type, group, label) {
	    if (!(label in newMaster.mediaGroups[type][group])) {
	      delete update.mediaGroups[type][group][label];
	    }
	  });
	};
	/**
	 * Returns a new master manifest that is the result of merging an updated master manifest
	 * into the original version.
	 *
	 * @param {Object} oldMaster
	 *        The old parsed mpd object
	 * @param {Object} newMaster
	 *        The updated parsed mpd object
	 * @return {Object}
	 *         A new object representing the original master manifest with the updated media
	 *         playlists merged in
	 */
	
	
	var updateMaster = function updateMaster(oldMaster, newMaster, sidxMapping) {
	  var noChanges = true;
	  var update = mergeOptions(oldMaster, {
	    // These are top level properties that can be updated
	    duration: newMaster.duration,
	    minimumUpdatePeriod: newMaster.minimumUpdatePeriod,
	    timelineStarts: newMaster.timelineStarts
	  }); // First update the playlists in playlist list
	
	  for (var i = 0; i < newMaster.playlists.length; i++) {
	    var playlist = newMaster.playlists[i];
	
	    if (playlist.sidx) {
	      var sidxKey = mpdParser.generateSidxKey(playlist.sidx); // add sidx segments to the playlist if we have all the sidx info already
	
	      if (sidxMapping && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx) {
	        mpdParser.addSidxSegmentsToPlaylist(playlist, sidxMapping[sidxKey].sidx, playlist.sidx.resolvedUri);
	      }
	    }
	
	    var playlistUpdate = updateMaster$1(update, playlist, dashPlaylistUnchanged);
	
	    if (playlistUpdate) {
	      update = playlistUpdate;
	      noChanges = false;
	    }
	  } // Then update media group playlists
	
	
	  forEachMediaGroup(newMaster, function (properties, type, group, label) {
	    if (properties.playlists && properties.playlists.length) {
	      var id = properties.playlists[0].id;
	
	      var _playlistUpdate = updateMaster$1(update, properties.playlists[0], dashPlaylistUnchanged);
	
	      if (_playlistUpdate) {
	        update = _playlistUpdate; // add new mediaGroup label if it doesn't exist and assign the new mediaGroup.
	
	        if (!(label in update.mediaGroups[type][group])) {
	          update.mediaGroups[type][group][label] = properties;
	        } // update the playlist reference within media groups
	
	
	        update.mediaGroups[type][group][label].playlists[0] = update.playlists[id];
	        noChanges = false;
	      }
	    }
	  }); // remove mediaGroup labels and references that no longer exist in the newMaster
	
	  removeOldMediaGroupLabels(update, newMaster);
	
	  if (newMaster.minimumUpdatePeriod !== oldMaster.minimumUpdatePeriod) {
	    noChanges = false;
	  }
	
	  if (noChanges) {
	    return null;
	  }
	
	  return update;
	}; // SIDX should be equivalent if the URI and byteranges of the SIDX match.
	// If the SIDXs have maps, the two maps should match,
	// both `a` and `b` missing SIDXs is considered matching.
	// If `a` or `b` but not both have a map, they aren't matching.
	
	
	var equivalentSidx = function equivalentSidx(a, b) {
	  var neitherMap = Boolean(!a.map && !b.map);
	  var equivalentMap = neitherMap || Boolean(a.map && b.map && a.map.byterange.offset === b.map.byterange.offset && a.map.byterange.length === b.map.byterange.length);
	  return equivalentMap && a.uri === b.uri && a.byterange.offset === b.byterange.offset && a.byterange.length === b.byterange.length;
	}; // exported for testing
	
	
	var compareSidxEntry = function compareSidxEntry(playlists, oldSidxMapping) {
	  var newSidxMapping = {};
	
	  for (var id in playlists) {
	    var playlist = playlists[id];
	    var currentSidxInfo = playlist.sidx;
	
	    if (currentSidxInfo) {
	      var key = mpdParser.generateSidxKey(currentSidxInfo);
	
	      if (!oldSidxMapping[key]) {
	        break;
	      }
	
	      var savedSidxInfo = oldSidxMapping[key].sidxInfo;
	
	      if (equivalentSidx(savedSidxInfo, currentSidxInfo)) {
	        newSidxMapping[key] = oldSidxMapping[key];
	      }
	    }
	  }
	
	  return newSidxMapping;
	};
	/**
	 *  A function that filters out changed items as they need to be requested separately.
	 *
	 *  The method is exported for testing
	 *
	 *  @param {Object} master the parsed mpd XML returned via mpd-parser
	 *  @param {Object} oldSidxMapping the SIDX to compare against
	 */
	
	
	var filterChangedSidxMappings = function filterChangedSidxMappings(master, oldSidxMapping) {
	  var videoSidx = compareSidxEntry(master.playlists, oldSidxMapping);
	  var mediaGroupSidx = videoSidx;
	  forEachMediaGroup(master, function (properties, mediaType, groupKey, labelKey) {
	    if (properties.playlists && properties.playlists.length) {
	      var playlists = properties.playlists;
	      mediaGroupSidx = mergeOptions(mediaGroupSidx, compareSidxEntry(playlists, oldSidxMapping));
	    }
	  });
	  return mediaGroupSidx;
	};
	
	var DashPlaylistLoader = /*#__PURE__*/function (_EventTarget) {
	  _inheritsLoose__default['default'](DashPlaylistLoader, _EventTarget); // DashPlaylistLoader must accept either a src url or a playlist because subsequent
	  // playlist loader setups from media groups will expect to be able to pass a playlist
	  // (since there aren't external URLs to media playlists with DASH)
	
	
	  function DashPlaylistLoader(srcUrlOrPlaylist, vhs, options, masterPlaylistLoader) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _EventTarget.call(this) || this;
	    _this.masterPlaylistLoader_ = masterPlaylistLoader || _assertThisInitialized__default['default'](_this);
	
	    if (!masterPlaylistLoader) {
	      _this.isMaster_ = true;
	    }
	
	    var _options = options,
	        _options$withCredenti = _options.withCredentials,
	        withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti,
	        _options$handleManife = _options.handleManifestRedirects,
	        handleManifestRedirects = _options$handleManife === void 0 ? false : _options$handleManife;
	    _this.vhs_ = vhs;
	    _this.withCredentials = withCredentials;
	    _this.handleManifestRedirects = handleManifestRedirects;
	
	    if (!srcUrlOrPlaylist) {
	      throw new Error('A non-empty playlist URL or object is required');
	    } // event naming?
	
	
	    _this.on('minimumUpdatePeriod', function () {
	      _this.refreshXml_();
	    }); // live playlist staleness timeout
	
	
	    _this.on('mediaupdatetimeout', function () {
	      _this.refreshMedia_(_this.media().id);
	    });
	
	    _this.state = 'HAVE_NOTHING';
	    _this.loadedPlaylists_ = {};
	    _this.logger_ = logger('DashPlaylistLoader'); // initialize the loader state
	    // The masterPlaylistLoader will be created with a string
	
	    if (_this.isMaster_) {
	      _this.masterPlaylistLoader_.srcUrl = srcUrlOrPlaylist; // TODO: reset sidxMapping between period changes
	      // once multi-period is refactored
	
	      _this.masterPlaylistLoader_.sidxMapping_ = {};
	    } else {
	      _this.childPlaylist_ = srcUrlOrPlaylist;
	    }
	
	    return _this;
	  }
	
	  var _proto = DashPlaylistLoader.prototype;
	
	  _proto.requestErrored_ = function requestErrored_(err, request, startingState) {
	    // disposed
	    if (!this.request) {
	      return true;
	    } // pending request is cleared
	
	
	    this.request = null;
	
	    if (err) {
	      // use the provided error object or create one
	      // based on the request/response
	      this.error = typeof err === 'object' && !(err instanceof Error) ? err : {
	        status: request.status,
	        message: 'DASH request error at URL: ' + request.uri,
	        response: request.response,
	        // MEDIA_ERR_NETWORK
	        code: 2
	      };
	
	      if (startingState) {
	        this.state = startingState;
	      }
	
	      this.trigger('error');
	      return true;
	    }
	  }
	  /**
	   * Verify that the container of the sidx segment can be parsed
	   * and if it can, get and parse that segment.
	   */
	  ;
	
	  _proto.addSidxSegments_ = function addSidxSegments_(playlist, startingState, cb) {
	    var _this2 = this;
	
	    var sidxKey = playlist.sidx && mpdParser.generateSidxKey(playlist.sidx); // playlist lacks sidx or sidx segments were added to this playlist already.
	
	    if (!playlist.sidx || !sidxKey || this.masterPlaylistLoader_.sidxMapping_[sidxKey]) {
	      // keep this function async
	      this.mediaRequest_ = window__default['default'].setTimeout(function () {
	        return cb(false);
	      }, 0);
	      return;
	    } // resolve the segment URL relative to the playlist
	
	
	    var uri = resolveManifestRedirect(this.handleManifestRedirects, playlist.sidx.resolvedUri);
	
	    var fin = function fin(err, request) {
	      if (_this2.requestErrored_(err, request, startingState)) {
	        return;
	      }
	
	      var sidxMapping = _this2.masterPlaylistLoader_.sidxMapping_;
	      var sidx;
	
	      try {
	        sidx = parseSidx__default['default'](byteHelpers.toUint8(request.response).subarray(8));
	      } catch (e) {
	        // sidx parsing failed.
	        _this2.requestErrored_(e, request, startingState);
	
	        return;
	      }
	
	      sidxMapping[sidxKey] = {
	        sidxInfo: playlist.sidx,
	        sidx: sidx
	      };
	      mpdParser.addSidxSegmentsToPlaylist(playlist, sidx, playlist.sidx.resolvedUri);
	      return cb(true);
	    };
	
	    this.request = containerRequest(uri, this.vhs_.xhr, function (err, request, container, bytes) {
	      if (err) {
	        return fin(err, request);
	      }
	
	      if (!container || container !== 'mp4') {
	        return fin({
	          status: request.status,
	          message: "Unsupported " + (container || 'unknown') + " container type for sidx segment at URL: " + uri,
	          // response is just bytes in this case
	          // but we really don't want to return that.
	          response: '',
	          playlist: playlist,
	          internal: true,
	          blacklistDuration: Infinity,
	          // MEDIA_ERR_NETWORK
	          code: 2
	        }, request);
	      } // if we already downloaded the sidx bytes in the container request, use them
	
	
	      var _playlist$sidx$bytera = playlist.sidx.byterange,
	          offset = _playlist$sidx$bytera.offset,
	          length = _playlist$sidx$bytera.length;
	
	      if (bytes.length >= length + offset) {
	        return fin(err, {
	          response: bytes.subarray(offset, offset + length),
	          status: request.status,
	          uri: request.uri
	        });
	      } // otherwise request sidx bytes
	
	
	      _this2.request = _this2.vhs_.xhr({
	        uri: uri,
	        responseType: 'arraybuffer',
	        headers: segmentXhrHeaders({
	          byterange: playlist.sidx.byterange
	        })
	      }, fin);
	    });
	  };
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.stopRequest();
	    this.loadedPlaylists_ = {};
	    window__default['default'].clearTimeout(this.minimumUpdatePeriodTimeout_);
	    window__default['default'].clearTimeout(this.mediaRequest_);
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    this.mediaUpdateTimeout = null;
	    this.mediaRequest_ = null;
	    this.minimumUpdatePeriodTimeout_ = null;
	
	    if (this.masterPlaylistLoader_.createMupOnMedia_) {
	      this.off('loadedmetadata', this.masterPlaylistLoader_.createMupOnMedia_);
	      this.masterPlaylistLoader_.createMupOnMedia_ = null;
	    }
	
	    this.off();
	  };
	
	  _proto.hasPendingRequest = function hasPendingRequest() {
	    return this.request || this.mediaRequest_;
	  };
	
	  _proto.stopRequest = function stopRequest() {
	    if (this.request) {
	      var oldRequest = this.request;
	      this.request = null;
	      oldRequest.onreadystatechange = null;
	      oldRequest.abort();
	    }
	  };
	
	  _proto.media = function media(playlist) {
	    var _this3 = this; // getter
	
	
	    if (!playlist) {
	      return this.media_;
	    } // setter
	
	
	    if (this.state === 'HAVE_NOTHING') {
	      throw new Error('Cannot switch media playlist from ' + this.state);
	    }
	
	    var startingState = this.state; // find the playlist object if the target playlist has been specified by URI
	
	    if (typeof playlist === 'string') {
	      if (!this.masterPlaylistLoader_.master.playlists[playlist]) {
	        throw new Error('Unknown playlist URI: ' + playlist);
	      }
	
	      playlist = this.masterPlaylistLoader_.master.playlists[playlist];
	    }
	
	    var mediaChange = !this.media_ || playlist.id !== this.media_.id; // switch to previously loaded playlists immediately
	
	    if (mediaChange && this.loadedPlaylists_[playlist.id] && this.loadedPlaylists_[playlist.id].endList) {
	      this.state = 'HAVE_METADATA';
	      this.media_ = playlist; // trigger media change if the active media has been updated
	
	      if (mediaChange) {
	        this.trigger('mediachanging');
	        this.trigger('mediachange');
	      }
	
	      return;
	    } // switching to the active playlist is a no-op
	
	
	    if (!mediaChange) {
	      return;
	    } // switching from an already loaded playlist
	
	
	    if (this.media_) {
	      this.trigger('mediachanging');
	    }
	
	    this.addSidxSegments_(playlist, startingState, function (sidxChanged) {
	      // everything is ready just continue to haveMetadata
	      _this3.haveMetadata({
	        startingState: startingState,
	        playlist: playlist
	      });
	    });
	  };
	
	  _proto.haveMetadata = function haveMetadata(_ref2) {
	    var startingState = _ref2.startingState,
	        playlist = _ref2.playlist;
	    this.state = 'HAVE_METADATA';
	    this.loadedPlaylists_[playlist.id] = playlist;
	    this.mediaRequest_ = null; // This will trigger loadedplaylist
	
	    this.refreshMedia_(playlist.id); // fire loadedmetadata the first time a media playlist is loaded
	    // to resolve setup of media groups
	
	    if (startingState === 'HAVE_MASTER') {
	      this.trigger('loadedmetadata');
	    } else {
	      // trigger media change if the active media has been updated
	      this.trigger('mediachange');
	    }
	  };
	
	  _proto.pause = function pause() {
	    if (this.masterPlaylistLoader_.createMupOnMedia_) {
	      this.off('loadedmetadata', this.masterPlaylistLoader_.createMupOnMedia_);
	      this.masterPlaylistLoader_.createMupOnMedia_ = null;
	    }
	
	    this.stopRequest();
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    this.mediaUpdateTimeout = null;
	
	    if (this.isMaster_) {
	      window__default['default'].clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_);
	      this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_ = null;
	    }
	
	    if (this.state === 'HAVE_NOTHING') {
	      // If we pause the loader before any data has been retrieved, its as if we never
	      // started, so reset to an unstarted state.
	      this.started = false;
	    }
	  };
	
	  _proto.load = function load(isFinalRendition) {
	    var _this4 = this;
	
	    window__default['default'].clearTimeout(this.mediaUpdateTimeout);
	    this.mediaUpdateTimeout = null;
	    var media = this.media();
	
	    if (isFinalRendition) {
	      var delay = media ? media.targetDuration / 2 * 1000 : 5 * 1000;
	      this.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	        return _this4.load();
	      }, delay);
	      return;
	    } // because the playlists are internal to the manifest, load should either load the
	    // main manifest, or do nothing but trigger an event
	
	
	    if (!this.started) {
	      this.start();
	      return;
	    }
	
	    if (media && !media.endList) {
	      // Check to see if this is the master loader and the MUP was cleared (this happens
	      // when the loader was paused). `media` should be set at this point since one is always
	      // set during `start()`.
	      if (this.isMaster_ && !this.minimumUpdatePeriodTimeout_) {
	        // Trigger minimumUpdatePeriod to refresh the master manifest
	        this.trigger('minimumUpdatePeriod'); // Since there was no prior minimumUpdatePeriodTimeout it should be recreated
	
	        this.updateMinimumUpdatePeriodTimeout_();
	      }
	
	      this.trigger('mediaupdatetimeout');
	    } else {
	      this.trigger('loadedplaylist');
	    }
	  };
	
	  _proto.start = function start() {
	    var _this5 = this;
	
	    this.started = true; // We don't need to request the master manifest again
	    // Call this asynchronously to match the xhr request behavior below
	
	    if (!this.isMaster_) {
	      this.mediaRequest_ = window__default['default'].setTimeout(function () {
	        return _this5.haveMaster_();
	      }, 0);
	      return;
	    }
	
	    this.requestMaster_(function (req, masterChanged) {
	      _this5.haveMaster_();
	
	      if (!_this5.hasPendingRequest() && !_this5.media_) {
	        _this5.media(_this5.masterPlaylistLoader_.master.playlists[0]);
	      }
	    });
	  };
	
	  _proto.requestMaster_ = function requestMaster_(cb) {
	    var _this6 = this;
	
	    this.request = this.vhs_.xhr({
	      uri: this.masterPlaylistLoader_.srcUrl,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      if (_this6.requestErrored_(error, req)) {
	        if (_this6.state === 'HAVE_NOTHING') {
	          _this6.started = false;
	        }
	
	        return;
	      }
	
	      var masterChanged = req.responseText !== _this6.masterPlaylistLoader_.masterXml_;
	      _this6.masterPlaylistLoader_.masterXml_ = req.responseText;
	
	      if (req.responseHeaders && req.responseHeaders.date) {
	        _this6.masterLoaded_ = Date.parse(req.responseHeaders.date);
	      } else {
	        _this6.masterLoaded_ = Date.now();
	      }
	
	      _this6.masterPlaylistLoader_.srcUrl = resolveManifestRedirect(_this6.handleManifestRedirects, _this6.masterPlaylistLoader_.srcUrl, req);
	
	      if (masterChanged) {
	        _this6.handleMaster_();
	
	        _this6.syncClientServerClock_(function () {
	          return cb(req, masterChanged);
	        });
	
	        return;
	      }
	
	      return cb(req, masterChanged);
	    });
	  }
	  /**
	   * Parses the master xml for UTCTiming node to sync the client clock to the server
	   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
	   *
	   * @param {Function} done
	   *        Function to call when clock sync has completed
	   */
	  ;
	
	  _proto.syncClientServerClock_ = function syncClientServerClock_(done) {
	    var _this7 = this;
	
	    var utcTiming = mpdParser.parseUTCTiming(this.masterPlaylistLoader_.masterXml_); // No UTCTiming element found in the mpd. Use Date header from mpd request as the
	    // server clock
	
	    if (utcTiming === null) {
	      this.masterPlaylistLoader_.clientOffset_ = this.masterLoaded_ - Date.now();
	      return done();
	    }
	
	    if (utcTiming.method === 'DIRECT') {
	      this.masterPlaylistLoader_.clientOffset_ = utcTiming.value - Date.now();
	      return done();
	    }
	
	    this.request = this.vhs_.xhr({
	      uri: resolveUrl(this.masterPlaylistLoader_.srcUrl, utcTiming.value),
	      method: utcTiming.method,
	      withCredentials: this.withCredentials
	    }, function (error, req) {
	      // disposed
	      if (!_this7.request) {
	        return;
	      }
	
	      if (error) {
	        // sync request failed, fall back to using date header from mpd
	        // TODO: log warning
	        _this7.masterPlaylistLoader_.clientOffset_ = _this7.masterLoaded_ - Date.now();
	        return done();
	      }
	
	      var serverTime;
	
	      if (utcTiming.method === 'HEAD') {
	        if (!req.responseHeaders || !req.responseHeaders.date) {
	          // expected date header not preset, fall back to using date header from mpd
	          // TODO: log warning
	          serverTime = _this7.masterLoaded_;
	        } else {
	          serverTime = Date.parse(req.responseHeaders.date);
	        }
	      } else {
	        serverTime = Date.parse(req.responseText);
	      }
	
	      _this7.masterPlaylistLoader_.clientOffset_ = serverTime - Date.now();
	      done();
	    });
	  };
	
	  _proto.haveMaster_ = function haveMaster_() {
	    this.state = 'HAVE_MASTER';
	
	    if (this.isMaster_) {
	      // We have the master playlist at this point, so
	      // trigger this to allow MasterPlaylistController
	      // to make an initial playlist selection
	      this.trigger('loadedplaylist');
	    } else if (!this.media_) {
	      // no media playlist was specifically selected so select
	      // the one the child playlist loader was created with
	      this.media(this.childPlaylist_);
	    }
	  };
	
	  _proto.handleMaster_ = function handleMaster_() {
	    // clear media request
	    this.mediaRequest_ = null;
	    var oldMaster = this.masterPlaylistLoader_.master;
	    var newMaster = parseMasterXml({
	      masterXml: this.masterPlaylistLoader_.masterXml_,
	      srcUrl: this.masterPlaylistLoader_.srcUrl,
	      clientOffset: this.masterPlaylistLoader_.clientOffset_,
	      sidxMapping: this.masterPlaylistLoader_.sidxMapping_,
	      previousManifest: oldMaster
	    }); // if we have an old master to compare the new master against
	
	    if (oldMaster) {
	      newMaster = updateMaster(oldMaster, newMaster, this.masterPlaylistLoader_.sidxMapping_);
	    } // only update master if we have a new master
	
	
	    this.masterPlaylistLoader_.master = newMaster ? newMaster : oldMaster;
	    var location = this.masterPlaylistLoader_.master.locations && this.masterPlaylistLoader_.master.locations[0];
	
	    if (location && location !== this.masterPlaylistLoader_.srcUrl) {
	      this.masterPlaylistLoader_.srcUrl = location;
	    }
	
	    if (!oldMaster || newMaster && newMaster.minimumUpdatePeriod !== oldMaster.minimumUpdatePeriod) {
	      this.updateMinimumUpdatePeriodTimeout_();
	    }
	
	    return Boolean(newMaster);
	  };
	
	  _proto.updateMinimumUpdatePeriodTimeout_ = function updateMinimumUpdatePeriodTimeout_() {
	    var mpl = this.masterPlaylistLoader_; // cancel any pending creation of mup on media
	    // a new one will be added if needed.
	
	    if (mpl.createMupOnMedia_) {
	      mpl.off('loadedmetadata', mpl.createMupOnMedia_);
	      mpl.createMupOnMedia_ = null;
	    } // clear any pending timeouts
	
	
	    if (mpl.minimumUpdatePeriodTimeout_) {
	      window__default['default'].clearTimeout(mpl.minimumUpdatePeriodTimeout_);
	      mpl.minimumUpdatePeriodTimeout_ = null;
	    }
	
	    var mup = mpl.master && mpl.master.minimumUpdatePeriod; // If the minimumUpdatePeriod has a value of 0, that indicates that the current
	    // MPD has no future validity, so a new one will need to be acquired when new
	    // media segments are to be made available. Thus, we use the target duration
	    // in this case
	
	    if (mup === 0) {
	      if (mpl.media()) {
	        mup = mpl.media().targetDuration * 1000;
	      } else {
	        mpl.createMupOnMedia_ = mpl.updateMinimumUpdatePeriodTimeout_;
	        mpl.one('loadedmetadata', mpl.createMupOnMedia_);
	      }
	    } // if minimumUpdatePeriod is invalid or <= zero, which
	    // can happen when a live video becomes VOD. skip timeout
	    // creation.
	
	
	    if (typeof mup !== 'number' || mup <= 0) {
	      if (mup < 0) {
	        this.logger_("found invalid minimumUpdatePeriod of " + mup + ", not setting a timeout");
	      }
	
	      return;
	    }
	
	    this.createMUPTimeout_(mup);
	  };
	
	  _proto.createMUPTimeout_ = function createMUPTimeout_(mup) {
	    var mpl = this.masterPlaylistLoader_;
	    mpl.minimumUpdatePeriodTimeout_ = window__default['default'].setTimeout(function () {
	      mpl.minimumUpdatePeriodTimeout_ = null;
	      mpl.trigger('minimumUpdatePeriod');
	      mpl.createMUPTimeout_(mup);
	    }, mup);
	  }
	  /**
	   * Sends request to refresh the master xml and updates the parsed master manifest
	   */
	  ;
	
	  _proto.refreshXml_ = function refreshXml_() {
	    var _this8 = this;
	
	    this.requestMaster_(function (req, masterChanged) {
	      if (!masterChanged) {
	        return;
	      }
	
	      if (_this8.media_) {
	        _this8.media_ = _this8.masterPlaylistLoader_.master.playlists[_this8.media_.id];
	      } // This will filter out updated sidx info from the mapping
	
	
	      _this8.masterPlaylistLoader_.sidxMapping_ = filterChangedSidxMappings(_this8.masterPlaylistLoader_.master, _this8.masterPlaylistLoader_.sidxMapping_);
	
	      _this8.addSidxSegments_(_this8.media(), _this8.state, function (sidxChanged) {
	        // TODO: do we need to reload the current playlist?
	        _this8.refreshMedia_(_this8.media().id);
	      });
	    });
	  }
	  /**
	   * Refreshes the media playlist by re-parsing the master xml and updating playlist
	   * references. If this is an alternate loader, the updated parsed manifest is retrieved
	   * from the master loader.
	   */
	  ;
	
	  _proto.refreshMedia_ = function refreshMedia_(mediaID) {
	    var _this9 = this;
	
	    if (!mediaID) {
	      throw new Error('refreshMedia_ must take a media id');
	    } // for master we have to reparse the master xml
	    // to re-create segments based on current timing values
	    // which may change media. We only skip updating master
	    // if this is the first time this.media_ is being set.
	    // as master was just parsed in that case.
	
	
	    if (this.media_ && this.isMaster_) {
	      this.handleMaster_();
	    }
	
	    var playlists = this.masterPlaylistLoader_.master.playlists;
	    var mediaChanged = !this.media_ || this.media_ !== playlists[mediaID];
	
	    if (mediaChanged) {
	      this.media_ = playlists[mediaID];
	    } else {
	      this.trigger('playlistunchanged');
	    }
	
	    if (!this.mediaUpdateTimeout) {
	      var createMediaUpdateTimeout = function createMediaUpdateTimeout() {
	        if (_this9.media().endList) {
	          return;
	        }
	
	        _this9.mediaUpdateTimeout = window__default['default'].setTimeout(function () {
	          _this9.trigger('mediaupdatetimeout');
	
	          createMediaUpdateTimeout();
	        }, refreshDelay(_this9.media(), Boolean(mediaChanged)));
	      };
	
	      createMediaUpdateTimeout();
	    }
	
	    this.trigger('loadedplaylist');
	  };
	
	  return DashPlaylistLoader;
	}(EventTarget);
	
	var Config = {
	  GOAL_BUFFER_LENGTH: 30,
	  MAX_GOAL_BUFFER_LENGTH: 60,
	  BACK_BUFFER_LENGTH: 30,
	  GOAL_BUFFER_LENGTH_RATE: 1,
	  // 0.5 MB/s
	  INITIAL_BANDWIDTH: 4194304,
	  // A fudge factor to apply to advertised playlist bitrates to account for
	  // temporary flucations in client bandwidth
	  BANDWIDTH_VARIANCE: 1.2,
	  // How much of the buffer must be filled before we consider upswitching
	  BUFFER_LOW_WATER_LINE: 0,
	  MAX_BUFFER_LOW_WATER_LINE: 30,
	  // TODO: Remove this when experimentalBufferBasedABR is removed
	  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
	  BUFFER_LOW_WATER_LINE_RATE: 1,
	  // If the buffer is greater than the high water line, we won't switch down
	  BUFFER_HIGH_WATER_LINE: 30
	};
	
	var stringToArrayBuffer = function stringToArrayBuffer(string) {
	  var view = new Uint8Array(new ArrayBuffer(string.length));
	
	  for (var i = 0; i < string.length; i++) {
	    view[i] = string.charCodeAt(i);
	  }
	
	  return view.buffer;
	};
	/* global Blob, BlobBuilder, Worker */
	// unify worker interface
	
	
	var browserWorkerPolyFill = function browserWorkerPolyFill(workerObj) {
	  // node only supports on/off
	  workerObj.on = workerObj.addEventListener;
	  workerObj.off = workerObj.removeEventListener;
	  return workerObj;
	};
	
	var createObjectURL = function createObjectURL(str) {
	  try {
	    return URL.createObjectURL(new Blob([str], {
	      type: 'application/javascript'
	    }));
	  } catch (e) {
	    var blob = new BlobBuilder();
	    blob.append(str);
	    return URL.createObjectURL(blob.getBlob());
	  }
	};
	
	var factory = function factory(code) {
	  return function () {
	    var objectUrl = createObjectURL(code);
	    var worker = browserWorkerPolyFill(new Worker(objectUrl));
	    worker.objURL = objectUrl;
	    var terminate = worker.terminate;
	    worker.on = worker.addEventListener;
	    worker.off = worker.removeEventListener;
	
	    worker.terminate = function () {
	      URL.revokeObjectURL(objectUrl);
	      return terminate.call(this);
	    };
	
	    return worker;
	  };
	};
	
	var transform = function transform(code) {
	  return "var browserWorkerPolyFill = " + browserWorkerPolyFill.toString() + ";\n" + 'browserWorkerPolyFill(self);\n' + code;
	};
	
	var getWorkerString = function getWorkerString(fn) {
	  return fn.toString().replace(/^function.+?{/, '').slice(0, -1);
	};
	/* rollup-plugin-worker-factory start for worker!/Users/ddashkevich/projects/http-streaming/src/transmuxer-worker.js */
	
	
	var workerCode$1 = transform(getWorkerString(function () {
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   *
	   * A lightweight readable stream implemention that handles event dispatching.
	   * Objects that inherit from streams should call init in their constructors.
	   */
	  var Stream = function Stream() {
	    this.init = function () {
	      var listeners = {};
	      /**
	       * Add a listener for a specified event type.
	       * @param type {string} the event name
	       * @param listener {function} the callback to be invoked when an event of
	       * the specified type occurs
	       */
	
	      this.on = function (type, listener) {
	        if (!listeners[type]) {
	          listeners[type] = [];
	        }
	
	        listeners[type] = listeners[type].concat(listener);
	      };
	      /**
	       * Remove a listener for a specified event type.
	       * @param type {string} the event name
	       * @param listener {function} a function previously registered for this
	       * type of event through `on`
	       */
	
	
	      this.off = function (type, listener) {
	        var index;
	
	        if (!listeners[type]) {
	          return false;
	        }
	
	        index = listeners[type].indexOf(listener);
	        listeners[type] = listeners[type].slice();
	        listeners[type].splice(index, 1);
	        return index > -1;
	      };
	      /**
	       * Trigger an event of the specified type on this stream. Any additional
	       * arguments to this function are passed as parameters to event listeners.
	       * @param type {string} the event name
	       */
	
	
	      this.trigger = function (type) {
	        var callbacks, i, length, args;
	        callbacks = listeners[type];
	
	        if (!callbacks) {
	          return;
	        } // Slicing the arguments on every invocation of this method
	        // can add a significant amount of overhead. Avoid the
	        // intermediate object creation for the common case of a
	        // single callback argument
	
	
	        if (arguments.length === 2) {
	          length = callbacks.length;
	
	          for (i = 0; i < length; ++i) {
	            callbacks[i].call(this, arguments[1]);
	          }
	        } else {
	          args = [];
	          i = arguments.length;
	
	          for (i = 1; i < arguments.length; ++i) {
	            args.push(arguments[i]);
	          }
	
	          length = callbacks.length;
	
	          for (i = 0; i < length; ++i) {
	            callbacks[i].apply(this, args);
	          }
	        }
	      };
	      /**
	       * Destroys the stream and cleans up.
	       */
	
	
	      this.dispose = function () {
	        listeners = {};
	      };
	    };
	  };
	  /**
	   * Forwards all `data` events on this stream to the destination stream. The
	   * destination stream should provide a method `push` to receive the data
	   * events as they arrive.
	   * @param destination {stream} the stream that will receive all `data` events
	   * @param autoFlush {boolean} if false, we will not call `flush` on the destination
	   *                            when the current stream emits a 'done' event
	   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	   */
	
	
	  Stream.prototype.pipe = function (destination) {
	    this.on('data', function (data) {
	      destination.push(data);
	    });
	    this.on('done', function (flushSource) {
	      destination.flush(flushSource);
	    });
	    this.on('partialdone', function (flushSource) {
	      destination.partialFlush(flushSource);
	    });
	    this.on('endedtimeline', function (flushSource) {
	      destination.endTimeline(flushSource);
	    });
	    this.on('reset', function (flushSource) {
	      destination.reset(flushSource);
	    });
	    return destination;
	  }; // Default stream functions that are expected to be overridden to perform
	  // actual work. These are provided by the prototype as a sort of no-op
	  // implementation so that we don't have to check for their existence in the
	  // `pipe` function above.
	
	
	  Stream.prototype.push = function (data) {
	    this.trigger('data', data);
	  };
	
	  Stream.prototype.flush = function (flushSource) {
	    this.trigger('done', flushSource);
	  };
	
	  Stream.prototype.partialFlush = function (flushSource) {
	    this.trigger('partialdone', flushSource);
	  };
	
	  Stream.prototype.endTimeline = function (flushSource) {
	    this.trigger('endedtimeline', flushSource);
	  };
	
	  Stream.prototype.reset = function (flushSource) {
	    this.trigger('reset', flushSource);
	  };
	
	  var stream = Stream;
	  var MAX_UINT32$1 = Math.pow(2, 32);
	
	  var getUint64$2 = function getUint64(uint8) {
	    var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
	    var value;
	
	    if (dv.getBigUint64) {
	      value = dv.getBigUint64(0);
	
	      if (value < Number.MAX_SAFE_INTEGER) {
	        return Number(value);
	      }
	
	      return value;
	    }
	
	    return dv.getUint32(0) * MAX_UINT32$1 + dv.getUint32(4);
	  };
	
	  var numbers = {
	    getUint64: getUint64$2,
	    MAX_UINT32: MAX_UINT32$1
	  };
	  var MAX_UINT32 = numbers.MAX_UINT32;
	  var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd, trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex, trun$1, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR, AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS; // pre-calculate constants
	
	  (function () {
	    var i;
	    types = {
	      avc1: [],
	      // codingname
	      avcC: [],
	      btrt: [],
	      dinf: [],
	      dref: [],
	      esds: [],
	      ftyp: [],
	      hdlr: [],
	      mdat: [],
	      mdhd: [],
	      mdia: [],
	      mfhd: [],
	      minf: [],
	      moof: [],
	      moov: [],
	      mp4a: [],
	      // codingname
	      mvex: [],
	      mvhd: [],
	      pasp: [],
	      sdtp: [],
	      smhd: [],
	      stbl: [],
	      stco: [],
	      stsc: [],
	      stsd: [],
	      stsz: [],
	      stts: [],
	      styp: [],
	      tfdt: [],
	      tfhd: [],
	      traf: [],
	      trak: [],
	      trun: [],
	      trex: [],
	      tkhd: [],
	      vmhd: []
	    }; // In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
	    // don't throw an error
	
	    if (typeof Uint8Array === 'undefined') {
	      return;
	    }
	
	    for (i in types) {
	      if (types.hasOwnProperty(i)) {
	        types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
	      }
	    }
	
	    MAJOR_BRAND = new Uint8Array(['i'.charCodeAt(0), 's'.charCodeAt(0), 'o'.charCodeAt(0), 'm'.charCodeAt(0)]);
	    AVC1_BRAND = new Uint8Array(['a'.charCodeAt(0), 'v'.charCodeAt(0), 'c'.charCodeAt(0), '1'.charCodeAt(0)]);
	    MINOR_VERSION = new Uint8Array([0, 0, 0, 1]);
	    VIDEO_HDLR = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
	    ]);
	    AUDIO_HDLR = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // pre_defined
	    0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
	    ]);
	    HDLR_TYPES = {
	      video: VIDEO_HDLR,
	      audio: AUDIO_HDLR
	    };
	    DREF = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01, // entry_count
	    0x00, 0x00, 0x00, 0x0c, // entry_size
	    0x75, 0x72, 0x6c, 0x20, // 'url' type
	    0x00, // version 0
	    0x00, 0x00, 0x01 // entry_flags
	    ]);
	    SMHD = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, // balance, 0 means centered
	    0x00, 0x00 // reserved
	    ]);
	    STCO = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00 // entry_count
	    ]);
	    STSC = STCO;
	    STSZ = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x00, // sample_size
	    0x00, 0x00, 0x00, 0x00 // sample_count
	    ]);
	    STTS = STCO;
	    VMHD = new Uint8Array([0x00, // version
	    0x00, 0x00, 0x01, // flags
	    0x00, 0x00, // graphicsmode
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
	    ]);
	  })();
	
	  box = function box(type) {
	    var payload = [],
	        size = 0,
	        i,
	        result,
	        view;
	
	    for (i = 1; i < arguments.length; i++) {
	      payload.push(arguments[i]);
	    }
	
	    i = payload.length; // calculate the total size we need to allocate
	
	    while (i--) {
	      size += payload[i].byteLength;
	    }
	
	    result = new Uint8Array(size + 8);
	    view = new DataView(result.buffer, result.byteOffset, result.byteLength);
	    view.setUint32(0, result.byteLength);
	    result.set(type, 4); // copy the payload into the result
	
	    for (i = 0, size = 8; i < payload.length; i++) {
	      result.set(payload[i], size);
	      size += payload[i].byteLength;
	    }
	
	    return result;
	  };
	
	  dinf = function dinf() {
	    return box(types.dinf, box(types.dref, DREF));
	  };
	
	  esds = function esds(track) {
	    return box(types.esds, new Uint8Array([0x00, // version
	    0x00, 0x00, 0x00, // flags
	    // ES_Descriptor
	    0x03, // tag, ES_DescrTag
	    0x19, // length
	    0x00, 0x00, // ES_ID
	    0x00, // streamDependenceFlag, URL_flag, reserved, streamPriority
	    // DecoderConfigDescriptor
	    0x04, // tag, DecoderConfigDescrTag
	    0x11, // length
	    0x40, // object type
	    0x15, // streamType
	    0x00, 0x06, 0x00, // bufferSizeDB
	    0x00, 0x00, 0xda, 0xc0, // maxBitrate
	    0x00, 0x00, 0xda, 0xc0, // avgBitrate
	    // DecoderSpecificInfo
	    0x05, // tag, DecoderSpecificInfoTag
	    0x02, // length
	    // ISO/IEC 14496-3, AudioSpecificConfig
	    // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
	    track.audioobjecttype << 3 | track.samplingfrequencyindex >>> 1, track.samplingfrequencyindex << 7 | track.channelcount << 3, 0x06, 0x01, 0x02 // GASpecificConfig
	    ]));
	  };
	
	  ftyp = function ftyp() {
	    return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
	  };
	
	  hdlr = function hdlr(type) {
	    return box(types.hdlr, HDLR_TYPES[type]);
	  };
	
	  mdat = function mdat(data) {
	    return box(types.mdat, data);
	  };
	
	  mdhd = function mdhd(track) {
	    var result = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x02, // creation_time
	    0x00, 0x00, 0x00, 0x03, // modification_time
	    0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	    track.duration >>> 24 & 0xFF, track.duration >>> 16 & 0xFF, track.duration >>> 8 & 0xFF, track.duration & 0xFF, // duration
	    0x55, 0xc4, // 'und' language (undetermined)
	    0x00, 0x00]); // Use the sample rate from the track metadata, when it is
	    // defined. The sample rate can be parsed out of an ADTS header, for
	    // instance.
	
	    if (track.samplerate) {
	      result[12] = track.samplerate >>> 24 & 0xFF;
	      result[13] = track.samplerate >>> 16 & 0xFF;
	      result[14] = track.samplerate >>> 8 & 0xFF;
	      result[15] = track.samplerate & 0xFF;
	    }
	
	    return box(types.mdhd, result);
	  };
	
	  mdia = function mdia(track) {
	    return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
	  };
	
	  mfhd = function mfhd(sequenceNumber) {
	    return box(types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // flags
	    (sequenceNumber & 0xFF000000) >> 24, (sequenceNumber & 0xFF0000) >> 16, (sequenceNumber & 0xFF00) >> 8, sequenceNumber & 0xFF // sequence_number
	    ]));
	  };
	
	  minf = function minf(track) {
	    return box(types.minf, track.type === 'video' ? box(types.vmhd, VMHD) : box(types.smhd, SMHD), dinf(), stbl(track));
	  };
	
	  moof = function moof(sequenceNumber, tracks) {
	    var trackFragments = [],
	        i = tracks.length; // build traf boxes for each track fragment
	
	    while (i--) {
	      trackFragments[i] = traf(tracks[i]);
	    }
	
	    return box.apply(null, [types.moof, mfhd(sequenceNumber)].concat(trackFragments));
	  };
	  /**
	   * Returns a movie box.
	   * @param tracks {array} the tracks associated with this movie
	   * @see ISO/IEC 14496-12:2012(E), section 8.2.1
	   */
	
	
	  moov = function moov(tracks) {
	    var i = tracks.length,
	        boxes = [];
	
	    while (i--) {
	      boxes[i] = trak(tracks[i]);
	    }
	
	    return box.apply(null, [types.moov, mvhd(0xffffffff)].concat(boxes).concat(mvex(tracks)));
	  };
	
	  mvex = function mvex(tracks) {
	    var i = tracks.length,
	        boxes = [];
	
	    while (i--) {
	      boxes[i] = trex(tracks[i]);
	    }
	
	    return box.apply(null, [types.mvex].concat(boxes));
	  };
	
	  mvhd = function mvhd(duration) {
	    var bytes = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01, // creation_time
	    0x00, 0x00, 0x00, 0x02, // modification_time
	    0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	    (duration & 0xFF000000) >> 24, (duration & 0xFF0000) >> 16, (duration & 0xFF00) >> 8, duration & 0xFF, // duration
	    0x00, 0x01, 0x00, 0x00, // 1.0 rate
	    0x01, 0x00, // 1.0 volume
	    0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	    0xff, 0xff, 0xff, 0xff // next_track_ID
	    ]);
	    return box(types.mvhd, bytes);
	  };
	
	  sdtp = function sdtp(track) {
	    var samples = track.samples || [],
	        bytes = new Uint8Array(4 + samples.length),
	        flags,
	        i; // leave the full box header (4 bytes) all zero
	    // write the sample table
	
	    for (i = 0; i < samples.length; i++) {
	      flags = samples[i].flags;
	      bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
	    }
	
	    return box(types.sdtp, bytes);
	  };
	
	  stbl = function stbl(track) {
	    return box(types.stbl, stsd(track), box(types.stts, STTS), box(types.stsc, STSC), box(types.stsz, STSZ), box(types.stco, STCO));
	  };
	
	  (function () {
	    var videoSample, audioSample;
	
	    stsd = function stsd(track) {
	      return box(types.stsd, new Uint8Array([0x00, // version 0
	      0x00, 0x00, 0x00, // flags
	      0x00, 0x00, 0x00, 0x01]), track.type === 'video' ? videoSample(track) : audioSample(track));
	    };
	
	    videoSample = function videoSample(track) {
	      var sps = track.sps || [],
	          pps = track.pps || [],
	          sequenceParameterSets = [],
	          pictureParameterSets = [],
	          i,
	          avc1Box; // assemble the SPSs
	
	      for (i = 0; i < sps.length; i++) {
	        sequenceParameterSets.push((sps[i].byteLength & 0xFF00) >>> 8);
	        sequenceParameterSets.push(sps[i].byteLength & 0xFF); // sequenceParameterSetLength
	
	        sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i])); // SPS
	      } // assemble the PPSs
	
	
	      for (i = 0; i < pps.length; i++) {
	        pictureParameterSets.push((pps[i].byteLength & 0xFF00) >>> 8);
	        pictureParameterSets.push(pps[i].byteLength & 0xFF);
	        pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
	      }
	
	      avc1Box = [types.avc1, new Uint8Array([0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // data_reference_index
	      0x00, 0x00, // pre_defined
	      0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	      (track.width & 0xff00) >> 8, track.width & 0xff, // width
	      (track.height & 0xff00) >> 8, track.height & 0xff, // height
	      0x00, 0x48, 0x00, 0x00, // horizresolution
	      0x00, 0x48, 0x00, 0x00, // vertresolution
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // frame_count
	      0x13, 0x76, 0x69, 0x64, 0x65, 0x6f, 0x6a, 0x73, 0x2d, 0x63, 0x6f, 0x6e, 0x74, 0x72, 0x69, 0x62, 0x2d, 0x68, 0x6c, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // compressorname
	      0x00, 0x18, // depth = 24
	      0x11, 0x11 // pre_defined = -1
	      ]), box(types.avcC, new Uint8Array([0x01, // configurationVersion
	      track.profileIdc, // AVCProfileIndication
	      track.profileCompatibility, // profile_compatibility
	      track.levelIdc, // AVCLevelIndication
	      0xff // lengthSizeMinusOne, hard-coded to 4 bytes
	      ].concat([sps.length], // numOfSequenceParameterSets
	      sequenceParameterSets, // "SPS"
	      [pps.length], // numOfPictureParameterSets
	      pictureParameterSets // "PPS"
	      ))), box(types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
	      0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
	      0x00, 0x2d, 0xc6, 0xc0 // avgBitrate
	      ]))];
	
	      if (track.sarRatio) {
	        var hSpacing = track.sarRatio[0],
	            vSpacing = track.sarRatio[1];
	        avc1Box.push(box(types.pasp, new Uint8Array([(hSpacing & 0xFF000000) >> 24, (hSpacing & 0xFF0000) >> 16, (hSpacing & 0xFF00) >> 8, hSpacing & 0xFF, (vSpacing & 0xFF000000) >> 24, (vSpacing & 0xFF0000) >> 16, (vSpacing & 0xFF00) >> 8, vSpacing & 0xFF])));
	      }
	
	      return box.apply(null, avc1Box);
	    };
	
	    audioSample = function audioSample(track) {
	      return box(types.mp4a, new Uint8Array([// SampleEntry, ISO/IEC 14496-12
	      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x01, // data_reference_index
	      // AudioSampleEntry, ISO/IEC 14496-12
	      0x00, 0x00, 0x00, 0x00, // reserved
	      0x00, 0x00, 0x00, 0x00, // reserved
	      (track.channelcount & 0xff00) >> 8, track.channelcount & 0xff, // channelcount
	      (track.samplesize & 0xff00) >> 8, track.samplesize & 0xff, // samplesize
	      0x00, 0x00, // pre_defined
	      0x00, 0x00, // reserved
	      (track.samplerate & 0xff00) >> 8, track.samplerate & 0xff, 0x00, 0x00 // samplerate, 16.16
	      // MP4AudioSampleEntry, ISO/IEC 14496-14
	      ]), esds(track));
	    };
	  })();
	
	  tkhd = function tkhd(track) {
	    var result = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x07, // flags
	    0x00, 0x00, 0x00, 0x00, // creation_time
	    0x00, 0x00, 0x00, 0x00, // modification_time
	    (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x00, // reserved
	    (track.duration & 0xFF000000) >> 24, (track.duration & 0xFF0000) >> 16, (track.duration & 0xFF00) >> 8, track.duration & 0xFF, // duration
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, // layer
	    0x00, 0x00, // alternate_group
	    0x01, 0x00, // non-audio track volume
	    0x00, 0x00, // reserved
	    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	    (track.width & 0xFF00) >> 8, track.width & 0xFF, 0x00, 0x00, // width
	    (track.height & 0xFF00) >> 8, track.height & 0xFF, 0x00, 0x00 // height
	    ]);
	    return box(types.tkhd, result);
	  };
	  /**
	   * Generate a track fragment (traf) box. A traf box collects metadata
	   * about tracks in a movie fragment (moof) box.
	   */
	
	
	  traf = function traf(track) {
	    var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable, dataOffset, upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
	    trackFragmentHeader = box(types.tfhd, new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x3a, // flags
	    (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x01, // sample_description_index
	    0x00, 0x00, 0x00, 0x00, // default_sample_duration
	    0x00, 0x00, 0x00, 0x00, // default_sample_size
	    0x00, 0x00, 0x00, 0x00 // default_sample_flags
	    ]));
	    upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / MAX_UINT32);
	    lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % MAX_UINT32);
	    trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([0x01, // version 1
	    0x00, 0x00, 0x00, // flags
	    // baseMediaDecodeTime
	    upperWordBaseMediaDecodeTime >>> 24 & 0xFF, upperWordBaseMediaDecodeTime >>> 16 & 0xFF, upperWordBaseMediaDecodeTime >>> 8 & 0xFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >>> 24 & 0xFF, lowerWordBaseMediaDecodeTime >>> 16 & 0xFF, lowerWordBaseMediaDecodeTime >>> 8 & 0xFF, lowerWordBaseMediaDecodeTime & 0xFF])); // the data offset specifies the number of bytes from the start of
	    // the containing moof to the first payload byte of the associated
	    // mdat
	
	    dataOffset = 32 + // tfhd
	    20 + // tfdt
	    8 + // traf header
	    16 + // mfhd
	    8 + // moof header
	    8; // mdat header
	    // audio tracks require less metadata
	
	    if (track.type === 'audio') {
	      trackFragmentRun = trun$1(track, dataOffset);
	      return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun);
	    } // video tracks should contain an independent and disposable samples
	    // box (sdtp)
	    // generate one and adjust offsets to match
	
	
	    sampleDependencyTable = sdtp(track);
	    trackFragmentRun = trun$1(track, sampleDependencyTable.length + dataOffset);
	    return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable);
	  };
	  /**
	   * Generate a track box.
	   * @param track {object} a track definition
	   * @return {Uint8Array} the track box
	   */
	
	
	  trak = function trak(track) {
	    track.duration = track.duration || 0xffffffff;
	    return box(types.trak, tkhd(track), mdia(track));
	  };
	
	  trex = function trex(track) {
	    var result = new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	    0x00, 0x00, 0x00, 0x01, // default_sample_description_index
	    0x00, 0x00, 0x00, 0x00, // default_sample_duration
	    0x00, 0x00, 0x00, 0x00, // default_sample_size
	    0x00, 0x01, 0x00, 0x01 // default_sample_flags
	    ]); // the last two bytes of default_sample_flags is the sample
	    // degradation priority, a hint about the importance of this sample
	    // relative to others. Lower the degradation priority for all sample
	    // types other than video.
	
	    if (track.type !== 'video') {
	      result[result.length - 1] = 0x00;
	    }
	
	    return box(types.trex, result);
	  };
	
	  (function () {
	    var audioTrun, videoTrun, trunHeader; // This method assumes all samples are uniform. That is, if a
	    // duration is present for the first sample, it will be present for
	    // all subsequent samples.
	    // see ISO/IEC 14496-12:2012, Section 8.8.8.1
	
	    trunHeader = function trunHeader(samples, offset) {
	      var durationPresent = 0,
	          sizePresent = 0,
	          flagsPresent = 0,
	          compositionTimeOffset = 0; // trun flag constants
	
	      if (samples.length) {
	        if (samples[0].duration !== undefined) {
	          durationPresent = 0x1;
	        }
	
	        if (samples[0].size !== undefined) {
	          sizePresent = 0x2;
	        }
	
	        if (samples[0].flags !== undefined) {
	          flagsPresent = 0x4;
	        }
	
	        if (samples[0].compositionTimeOffset !== undefined) {
	          compositionTimeOffset = 0x8;
	        }
	      }
	
	      return [0x00, // version 0
	      0x00, durationPresent | sizePresent | flagsPresent | compositionTimeOffset, 0x01, // flags
	      (samples.length & 0xFF000000) >>> 24, (samples.length & 0xFF0000) >>> 16, (samples.length & 0xFF00) >>> 8, samples.length & 0xFF, // sample_count
	      (offset & 0xFF000000) >>> 24, (offset & 0xFF0000) >>> 16, (offset & 0xFF00) >>> 8, offset & 0xFF // data_offset
	      ];
	    };
	
	    videoTrun = function videoTrun(track, offset) {
	      var bytesOffest, bytes, header, samples, sample, i;
	      samples = track.samples || [];
	      offset += 8 + 12 + 16 * samples.length;
	      header = trunHeader(samples, offset);
	      bytes = new Uint8Array(header.length + samples.length * 16);
	      bytes.set(header);
	      bytesOffest = header.length;
	
	      for (i = 0; i < samples.length; i++) {
	        sample = samples[i];
	        bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
	
	        bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
	
	        bytes[bytesOffest++] = sample.flags.isLeading << 2 | sample.flags.dependsOn;
	        bytes[bytesOffest++] = sample.flags.isDependedOn << 6 | sample.flags.hasRedundancy << 4 | sample.flags.paddingValue << 1 | sample.flags.isNonSyncSample;
	        bytes[bytesOffest++] = sample.flags.degradationPriority & 0xF0 << 8;
	        bytes[bytesOffest++] = sample.flags.degradationPriority & 0x0F; // sample_flags
	
	        bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.compositionTimeOffset & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.compositionTimeOffset & 0xFF; // sample_composition_time_offset
	      }
	
	      return box(types.trun, bytes);
	    };
	
	    audioTrun = function audioTrun(track, offset) {
	      var bytes, bytesOffest, header, samples, sample, i;
	      samples = track.samples || [];
	      offset += 8 + 12 + 8 * samples.length;
	      header = trunHeader(samples, offset);
	      bytes = new Uint8Array(header.length + samples.length * 8);
	      bytes.set(header);
	      bytesOffest = header.length;
	
	      for (i = 0; i < samples.length; i++) {
	        sample = samples[i];
	        bytes[bytesOffest++] = (sample.duration & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.duration & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.duration & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.duration & 0xFF; // sample_duration
	
	        bytes[bytesOffest++] = (sample.size & 0xFF000000) >>> 24;
	        bytes[bytesOffest++] = (sample.size & 0xFF0000) >>> 16;
	        bytes[bytesOffest++] = (sample.size & 0xFF00) >>> 8;
	        bytes[bytesOffest++] = sample.size & 0xFF; // sample_size
	      }
	
	      return box(types.trun, bytes);
	    };
	
	    trun$1 = function trun(track, offset) {
	      if (track.type === 'audio') {
	        return audioTrun(track, offset);
	      }
	
	      return videoTrun(track, offset);
	    };
	  })();
	
	  var mp4Generator = {
	    ftyp: ftyp,
	    mdat: mdat,
	    moof: moof,
	    moov: moov,
	    initSegment: function initSegment(tracks) {
	      var fileType = ftyp(),
	          movie = moov(tracks),
	          result;
	      result = new Uint8Array(fileType.byteLength + movie.byteLength);
	      result.set(fileType);
	      result.set(movie, fileType.byteLength);
	      return result;
	    }
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	  // Convert an array of nal units into an array of frames with each frame being
	  // composed of the nal units that make up that frame
	  // Also keep track of cummulative data about the frame from the nal units such
	  // as the frame duration, starting pts, etc.
	
	  var groupNalsIntoFrames = function groupNalsIntoFrames(nalUnits) {
	    var i,
	        currentNal,
	        currentFrame = [],
	        frames = []; // TODO added for LHLS, make sure this is OK
	
	    frames.byteLength = 0;
	    frames.nalCount = 0;
	    frames.duration = 0;
	    currentFrame.byteLength = 0;
	
	    for (i = 0; i < nalUnits.length; i++) {
	      currentNal = nalUnits[i]; // Split on 'aud'-type nal units
	
	      if (currentNal.nalUnitType === 'access_unit_delimiter_rbsp') {
	        // Since the very first nal unit is expected to be an AUD
	        // only push to the frames array when currentFrame is not empty
	        if (currentFrame.length) {
	          currentFrame.duration = currentNal.dts - currentFrame.dts; // TODO added for LHLS, make sure this is OK
	
	          frames.byteLength += currentFrame.byteLength;
	          frames.nalCount += currentFrame.length;
	          frames.duration += currentFrame.duration;
	          frames.push(currentFrame);
	        }
	
	        currentFrame = [currentNal];
	        currentFrame.byteLength = currentNal.data.byteLength;
	        currentFrame.pts = currentNal.pts;
	        currentFrame.dts = currentNal.dts;
	      } else {
	        // Specifically flag key frames for ease of use later
	        if (currentNal.nalUnitType === 'slice_layer_without_partitioning_rbsp_idr') {
	          currentFrame.keyFrame = true;
	        }
	
	        currentFrame.duration = currentNal.dts - currentFrame.dts;
	        currentFrame.byteLength += currentNal.data.byteLength;
	        currentFrame.push(currentNal);
	      }
	    } // For the last frame, use the duration of the previous frame if we
	    // have nothing better to go on
	
	
	    if (frames.length && (!currentFrame.duration || currentFrame.duration <= 0)) {
	      currentFrame.duration = frames[frames.length - 1].duration;
	    } // Push the final frame
	    // TODO added for LHLS, make sure this is OK
	
	
	    frames.byteLength += currentFrame.byteLength;
	    frames.nalCount += currentFrame.length;
	    frames.duration += currentFrame.duration;
	    frames.push(currentFrame);
	    return frames;
	  }; // Convert an array of frames into an array of Gop with each Gop being composed
	  // of the frames that make up that Gop
	  // Also keep track of cummulative data about the Gop from the frames such as the
	  // Gop duration, starting pts, etc.
	
	
	  var groupFramesIntoGops = function groupFramesIntoGops(frames) {
	    var i,
	        currentFrame,
	        currentGop = [],
	        gops = []; // We must pre-set some of the values on the Gop since we
	    // keep running totals of these values
	
	    currentGop.byteLength = 0;
	    currentGop.nalCount = 0;
	    currentGop.duration = 0;
	    currentGop.pts = frames[0].pts;
	    currentGop.dts = frames[0].dts; // store some metadata about all the Gops
	
	    gops.byteLength = 0;
	    gops.nalCount = 0;
	    gops.duration = 0;
	    gops.pts = frames[0].pts;
	    gops.dts = frames[0].dts;
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	
	      if (currentFrame.keyFrame) {
	        // Since the very first frame is expected to be an keyframe
	        // only push to the gops array when currentGop is not empty
	        if (currentGop.length) {
	          gops.push(currentGop);
	          gops.byteLength += currentGop.byteLength;
	          gops.nalCount += currentGop.nalCount;
	          gops.duration += currentGop.duration;
	        }
	
	        currentGop = [currentFrame];
	        currentGop.nalCount = currentFrame.length;
	        currentGop.byteLength = currentFrame.byteLength;
	        currentGop.pts = currentFrame.pts;
	        currentGop.dts = currentFrame.dts;
	        currentGop.duration = currentFrame.duration;
	      } else {
	        currentGop.duration += currentFrame.duration;
	        currentGop.nalCount += currentFrame.length;
	        currentGop.byteLength += currentFrame.byteLength;
	        currentGop.push(currentFrame);
	      }
	    }
	
	    if (gops.length && currentGop.duration <= 0) {
	      currentGop.duration = gops[gops.length - 1].duration;
	    }
	
	    gops.byteLength += currentGop.byteLength;
	    gops.nalCount += currentGop.nalCount;
	    gops.duration += currentGop.duration; // push the final Gop
	
	    gops.push(currentGop);
	    return gops;
	  };
	  /*
	   * Search for the first keyframe in the GOPs and throw away all frames
	   * until that keyframe. Then extend the duration of the pulled keyframe
	   * and pull the PTS and DTS of the keyframe so that it covers the time
	   * range of the frames that were disposed.
	   *
	   * @param {Array} gops video GOPs
	   * @returns {Array} modified video GOPs
	   */
	
	
	  var extendFirstKeyFrame = function extendFirstKeyFrame(gops) {
	    var currentGop;
	
	    if (!gops[0][0].keyFrame && gops.length > 1) {
	      // Remove the first GOP
	      currentGop = gops.shift();
	      gops.byteLength -= currentGop.byteLength;
	      gops.nalCount -= currentGop.nalCount; // Extend the first frame of what is now the
	      // first gop to cover the time period of the
	      // frames we just removed
	
	      gops[0][0].dts = currentGop.dts;
	      gops[0][0].pts = currentGop.pts;
	      gops[0][0].duration += currentGop.duration;
	    }
	
	    return gops;
	  };
	  /**
	   * Default sample object
	   * see ISO/IEC 14496-12:2012, section 8.6.4.3
	   */
	
	
	  var createDefaultSample = function createDefaultSample() {
	    return {
	      size: 0,
	      flags: {
	        isLeading: 0,
	        dependsOn: 1,
	        isDependedOn: 0,
	        hasRedundancy: 0,
	        degradationPriority: 0,
	        isNonSyncSample: 1
	      }
	    };
	  };
	  /*
	   * Collates information from a video frame into an object for eventual
	   * entry into an MP4 sample table.
	   *
	   * @param {Object} frame the video frame
	   * @param {Number} dataOffset the byte offset to position the sample
	   * @return {Object} object containing sample table info for a frame
	   */
	
	
	  var sampleForFrame = function sampleForFrame(frame, dataOffset) {
	    var sample = createDefaultSample();
	    sample.dataOffset = dataOffset;
	    sample.compositionTimeOffset = frame.pts - frame.dts;
	    sample.duration = frame.duration;
	    sample.size = 4 * frame.length; // Space for nal unit size
	
	    sample.size += frame.byteLength;
	
	    if (frame.keyFrame) {
	      sample.flags.dependsOn = 2;
	      sample.flags.isNonSyncSample = 0;
	    }
	
	    return sample;
	  }; // generate the track's sample table from an array of gops
	
	
	  var generateSampleTable$1 = function generateSampleTable(gops, baseDataOffset) {
	    var h,
	        i,
	        sample,
	        currentGop,
	        currentFrame,
	        dataOffset = baseDataOffset || 0,
	        samples = [];
	
	    for (h = 0; h < gops.length; h++) {
	      currentGop = gops[h];
	
	      for (i = 0; i < currentGop.length; i++) {
	        currentFrame = currentGop[i];
	        sample = sampleForFrame(currentFrame, dataOffset);
	        dataOffset += sample.size;
	        samples.push(sample);
	      }
	    }
	
	    return samples;
	  }; // generate the track's raw mdat data from an array of gops
	
	
	  var concatenateNalData = function concatenateNalData(gops) {
	    var h,
	        i,
	        j,
	        currentGop,
	        currentFrame,
	        currentNal,
	        dataOffset = 0,
	        nalsByteLength = gops.byteLength,
	        numberOfNals = gops.nalCount,
	        totalByteLength = nalsByteLength + 4 * numberOfNals,
	        data = new Uint8Array(totalByteLength),
	        view = new DataView(data.buffer); // For each Gop..
	
	    for (h = 0; h < gops.length; h++) {
	      currentGop = gops[h]; // For each Frame..
	
	      for (i = 0; i < currentGop.length; i++) {
	        currentFrame = currentGop[i]; // For each NAL..
	
	        for (j = 0; j < currentFrame.length; j++) {
	          currentNal = currentFrame[j];
	          view.setUint32(dataOffset, currentNal.data.byteLength);
	          dataOffset += 4;
	          data.set(currentNal.data, dataOffset);
	          dataOffset += currentNal.data.byteLength;
	        }
	      }
	    }
	
	    return data;
	  }; // generate the track's sample table from a frame
	
	
	  var generateSampleTableForFrame = function generateSampleTableForFrame(frame, baseDataOffset) {
	    var sample,
	        dataOffset = baseDataOffset || 0,
	        samples = [];
	    sample = sampleForFrame(frame, dataOffset);
	    samples.push(sample);
	    return samples;
	  }; // generate the track's raw mdat data from a frame
	
	
	  var concatenateNalDataForFrame = function concatenateNalDataForFrame(frame) {
	    var i,
	        currentNal,
	        dataOffset = 0,
	        nalsByteLength = frame.byteLength,
	        numberOfNals = frame.length,
	        totalByteLength = nalsByteLength + 4 * numberOfNals,
	        data = new Uint8Array(totalByteLength),
	        view = new DataView(data.buffer); // For each NAL..
	
	    for (i = 0; i < frame.length; i++) {
	      currentNal = frame[i];
	      view.setUint32(dataOffset, currentNal.data.byteLength);
	      dataOffset += 4;
	      data.set(currentNal.data, dataOffset);
	      dataOffset += currentNal.data.byteLength;
	    }
	
	    return data;
	  };
	
	  var frameUtils = {
	    groupNalsIntoFrames: groupNalsIntoFrames,
	    groupFramesIntoGops: groupFramesIntoGops,
	    extendFirstKeyFrame: extendFirstKeyFrame,
	    generateSampleTable: generateSampleTable$1,
	    concatenateNalData: concatenateNalData,
	    generateSampleTableForFrame: generateSampleTableForFrame,
	    concatenateNalDataForFrame: concatenateNalDataForFrame
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var highPrefix = [33, 16, 5, 32, 164, 27];
	  var lowPrefix = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252];
	
	  var zeroFill = function zeroFill(count) {
	    var a = [];
	
	    while (count--) {
	      a.push(0);
	    }
	
	    return a;
	  };
	
	  var makeTable = function makeTable(metaTable) {
	    return Object.keys(metaTable).reduce(function (obj, key) {
	      obj[key] = new Uint8Array(metaTable[key].reduce(function (arr, part) {
	        return arr.concat(part);
	      }, []));
	      return obj;
	    }, {});
	  };
	
	  var silence;
	
	  var silence_1 = function silence_1() {
	    if (!silence) {
	      // Frames-of-silence to use for filling in missing AAC frames
	      var coneOfSilence = {
	        96000: [highPrefix, [227, 64], zeroFill(154), [56]],
	        88200: [highPrefix, [231], zeroFill(170), [56]],
	        64000: [highPrefix, [248, 192], zeroFill(240), [56]],
	        48000: [highPrefix, [255, 192], zeroFill(268), [55, 148, 128], zeroFill(54), [112]],
	        44100: [highPrefix, [255, 192], zeroFill(268), [55, 163, 128], zeroFill(84), [112]],
	        32000: [highPrefix, [255, 192], zeroFill(268), [55, 234], zeroFill(226), [112]],
	        24000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 112], zeroFill(126), [224]],
	        16000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 255], zeroFill(269), [223, 108], zeroFill(195), [1, 192]],
	        12000: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 253, 128], zeroFill(259), [56]],
	        11025: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 255, 192], zeroFill(268), [55, 175, 128], zeroFill(108), [112]],
	        8000: [lowPrefix, zeroFill(268), [3, 121, 16], zeroFill(47), [7]]
	      };
	      silence = makeTable(coneOfSilence);
	    }
	
	    return silence;
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	
	  var ONE_SECOND_IN_TS$4 = 90000,
	      // 90kHz clock
	  secondsToVideoTs,
	      secondsToAudioTs,
	      videoTsToSeconds,
	      audioTsToSeconds,
	      audioTsToVideoTs,
	      videoTsToAudioTs,
	      metadataTsToSeconds;
	
	  secondsToVideoTs = function secondsToVideoTs(seconds) {
	    return seconds * ONE_SECOND_IN_TS$4;
	  };
	
	  secondsToAudioTs = function secondsToAudioTs(seconds, sampleRate) {
	    return seconds * sampleRate;
	  };
	
	  videoTsToSeconds = function videoTsToSeconds(timestamp) {
	    return timestamp / ONE_SECOND_IN_TS$4;
	  };
	
	  audioTsToSeconds = function audioTsToSeconds(timestamp, sampleRate) {
	    return timestamp / sampleRate;
	  };
	
	  audioTsToVideoTs = function audioTsToVideoTs(timestamp, sampleRate) {
	    return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
	  };
	
	  videoTsToAudioTs = function videoTsToAudioTs(timestamp, sampleRate) {
	    return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
	  };
	  /**
	   * Adjust ID3 tag or caption timing information by the timeline pts values
	   * (if keepOriginalTimestamps is false) and convert to seconds
	   */
	
	
	  metadataTsToSeconds = function metadataTsToSeconds(timestamp, timelineStartPts, keepOriginalTimestamps) {
	    return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
	  };
	
	  var clock = {
	    ONE_SECOND_IN_TS: ONE_SECOND_IN_TS$4,
	    secondsToVideoTs: secondsToVideoTs,
	    secondsToAudioTs: secondsToAudioTs,
	    videoTsToSeconds: videoTsToSeconds,
	    audioTsToSeconds: audioTsToSeconds,
	    audioTsToVideoTs: audioTsToVideoTs,
	    videoTsToAudioTs: videoTsToAudioTs,
	    metadataTsToSeconds: metadataTsToSeconds
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  /**
	   * Sum the `byteLength` properties of the data in each AAC frame
	   */
	
	  var sumFrameByteLengths = function sumFrameByteLengths(array) {
	    var i,
	        currentObj,
	        sum = 0; // sum the byteLength's all each nal unit in the frame
	
	    for (i = 0; i < array.length; i++) {
	      currentObj = array[i];
	      sum += currentObj.data.byteLength;
	    }
	
	    return sum;
	  }; // Possibly pad (prefix) the audio track with silence if appending this track
	  // would lead to the introduction of a gap in the audio buffer
	
	
	  var prefixWithSilence = function prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime) {
	    var baseMediaDecodeTimeTs,
	        frameDuration = 0,
	        audioGapDuration = 0,
	        audioFillFrameCount = 0,
	        audioFillDuration = 0,
	        silentFrame,
	        i,
	        firstFrame;
	
	    if (!frames.length) {
	      return;
	    }
	
	    baseMediaDecodeTimeTs = clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate); // determine frame clock duration based on sample rate, round up to avoid overfills
	
	    frameDuration = Math.ceil(clock.ONE_SECOND_IN_TS / (track.samplerate / 1024));
	
	    if (audioAppendStartTs && videoBaseMediaDecodeTime) {
	      // insert the shortest possible amount (audio gap or audio to video gap)
	      audioGapDuration = baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime); // number of full frames in the audio gap
	
	      audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
	      audioFillDuration = audioFillFrameCount * frameDuration;
	    } // don't attempt to fill gaps smaller than a single frame or larger
	    // than a half second
	
	
	    if (audioFillFrameCount < 1 || audioFillDuration > clock.ONE_SECOND_IN_TS / 2) {
	      return;
	    }
	
	    silentFrame = silence_1()[track.samplerate];
	
	    if (!silentFrame) {
	      // we don't have a silent frame pregenerated for the sample rate, so use a frame
	      // from the content instead
	      silentFrame = frames[0].data;
	    }
	
	    for (i = 0; i < audioFillFrameCount; i++) {
	      firstFrame = frames[0];
	      frames.splice(0, 0, {
	        data: silentFrame,
	        dts: firstFrame.dts - frameDuration,
	        pts: firstFrame.pts - frameDuration
	      });
	    }
	
	    track.baseMediaDecodeTime -= Math.floor(clock.videoTsToAudioTs(audioFillDuration, track.samplerate));
	    return audioFillDuration;
	  }; // If the audio segment extends before the earliest allowed dts
	  // value, remove AAC frames until starts at or after the earliest
	  // allowed DTS so that we don't end up with a negative baseMedia-
	  // DecodeTime for the audio track
	
	
	  var trimAdtsFramesByEarliestDts = function trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts) {
	    if (track.minSegmentDts >= earliestAllowedDts) {
	      return adtsFrames;
	    } // We will need to recalculate the earliest segment Dts
	
	
	    track.minSegmentDts = Infinity;
	    return adtsFrames.filter(function (currentFrame) {
	      // If this is an allowed frame, keep it and record it's Dts
	      if (currentFrame.dts >= earliestAllowedDts) {
	        track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
	        track.minSegmentPts = track.minSegmentDts;
	        return true;
	      } // Otherwise, discard it
	
	
	      return false;
	    });
	  }; // generate the track's raw mdat data from an array of frames
	
	
	  var generateSampleTable = function generateSampleTable(frames) {
	    var i,
	        currentFrame,
	        samples = [];
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	      samples.push({
	        size: currentFrame.data.byteLength,
	        duration: 1024 // For AAC audio, all samples contain 1024 samples
	
	      });
	    }
	
	    return samples;
	  }; // generate the track's sample table from an array of frames
	
	
	  var concatenateFrameData = function concatenateFrameData(frames) {
	    var i,
	        currentFrame,
	        dataOffset = 0,
	        data = new Uint8Array(sumFrameByteLengths(frames));
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	      data.set(currentFrame.data, dataOffset);
	      dataOffset += currentFrame.data.byteLength;
	    }
	
	    return data;
	  };
	
	  var audioFrameUtils = {
	    prefixWithSilence: prefixWithSilence,
	    trimAdtsFramesByEarliestDts: trimAdtsFramesByEarliestDts,
	    generateSampleTable: generateSampleTable,
	    concatenateFrameData: concatenateFrameData
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var ONE_SECOND_IN_TS$3 = clock.ONE_SECOND_IN_TS;
	  /**
	   * Store information about the start and end of the track and the
	   * duration for each frame/sample we process in order to calculate
	   * the baseMediaDecodeTime
	   */
	
	  var collectDtsInfo = function collectDtsInfo(track, data) {
	    if (typeof data.pts === 'number') {
	      if (track.timelineStartInfo.pts === undefined) {
	        track.timelineStartInfo.pts = data.pts;
	      }
	
	      if (track.minSegmentPts === undefined) {
	        track.minSegmentPts = data.pts;
	      } else {
	        track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
	      }
	
	      if (track.maxSegmentPts === undefined) {
	        track.maxSegmentPts = data.pts;
	      } else {
	        track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
	      }
	    }
	
	    if (typeof data.dts === 'number') {
	      if (track.timelineStartInfo.dts === undefined) {
	        track.timelineStartInfo.dts = data.dts;
	      }
	
	      if (track.minSegmentDts === undefined) {
	        track.minSegmentDts = data.dts;
	      } else {
	        track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
	      }
	
	      if (track.maxSegmentDts === undefined) {
	        track.maxSegmentDts = data.dts;
	      } else {
	        track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
	      }
	    }
	  };
	  /**
	   * Clear values used to calculate the baseMediaDecodeTime between
	   * tracks
	   */
	
	
	  var clearDtsInfo = function clearDtsInfo(track) {
	    delete track.minSegmentDts;
	    delete track.maxSegmentDts;
	    delete track.minSegmentPts;
	    delete track.maxSegmentPts;
	  };
	  /**
	   * Calculate the track's baseMediaDecodeTime based on the earliest
	   * DTS the transmuxer has ever seen and the minimum DTS for the
	   * current track
	   * @param track {object} track metadata configuration
	   * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at 0.
	   */
	
	
	  var calculateTrackBaseMediaDecodeTime = function calculateTrackBaseMediaDecodeTime(track, keepOriginalTimestamps) {
	    var baseMediaDecodeTime,
	        scale,
	        minSegmentDts = track.minSegmentDts; // Optionally adjust the time so the first segment starts at zero.
	
	    if (!keepOriginalTimestamps) {
	      minSegmentDts -= track.timelineStartInfo.dts;
	    } // track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
	    // we want the start of the first segment to be placed
	
	
	    baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime; // Add to that the distance this segment is from the very first
	
	    baseMediaDecodeTime += minSegmentDts; // baseMediaDecodeTime must not become negative
	
	    baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
	
	    if (track.type === 'audio') {
	      // Audio has a different clock equal to the sampling_rate so we need to
	      // scale the PTS values into the clock rate of the track
	      scale = track.samplerate / ONE_SECOND_IN_TS$3;
	      baseMediaDecodeTime *= scale;
	      baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
	    }
	
	    return baseMediaDecodeTime;
	  };
	
	  var trackDecodeInfo = {
	    clearDtsInfo: clearDtsInfo,
	    calculateTrackBaseMediaDecodeTime: calculateTrackBaseMediaDecodeTime,
	    collectDtsInfo: collectDtsInfo
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   *
	   * Reads in-band caption information from a video elementary
	   * stream. Captions must follow the CEA-708 standard for injection
	   * into an MPEG-2 transport streams.
	   * @see https://en.wikipedia.org/wiki/CEA-708
	   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
	   */
	  // payload type field to indicate how they are to be
	  // interpreted. CEAS-708 caption content is always transmitted with
	  // payload type 0x04.
	
	  var USER_DATA_REGISTERED_ITU_T_T35 = 4,
	      RBSP_TRAILING_BITS = 128;
	  /**
	    * Parse a supplemental enhancement information (SEI) NAL unit.
	    * Stops parsing once a message of type ITU T T35 has been found.
	    *
	    * @param bytes {Uint8Array} the bytes of a SEI NAL unit
	    * @return {object} the parsed SEI payload
	    * @see Rec. ITU-T H.264, 7.3.2.3.1
	    */
	
	  var parseSei = function parseSei(bytes) {
	    var i = 0,
	        result = {
	      payloadType: -1,
	      payloadSize: 0
	    },
	        payloadType = 0,
	        payloadSize = 0; // go through the sei_rbsp parsing each each individual sei_message
	
	    while (i < bytes.byteLength) {
	      // stop once we have hit the end of the sei_rbsp
	      if (bytes[i] === RBSP_TRAILING_BITS) {
	        break;
	      } // Parse payload type
	
	
	      while (bytes[i] === 0xFF) {
	        payloadType += 255;
	        i++;
	      }
	
	      payloadType += bytes[i++]; // Parse payload size
	
	      while (bytes[i] === 0xFF) {
	        payloadSize += 255;
	        i++;
	      }
	
	      payloadSize += bytes[i++]; // this sei_message is a 608/708 caption so save it and break
	      // there can only ever be one caption message in a frame's sei
	
	      if (!result.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
	        var userIdentifier = String.fromCharCode(bytes[i + 3], bytes[i + 4], bytes[i + 5], bytes[i + 6]);
	
	        if (userIdentifier === 'GA94') {
	          result.payloadType = payloadType;
	          result.payloadSize = payloadSize;
	          result.payload = bytes.subarray(i, i + payloadSize);
	          break;
	        } else {
	          result.payload = void 0;
	        }
	      } // skip the payload and parse the next message
	
	
	      i += payloadSize;
	      payloadType = 0;
	      payloadSize = 0;
	    }
	
	    return result;
	  }; // see ANSI/SCTE 128-1 (2013), section 8.1
	
	
	  var parseUserData = function parseUserData(sei) {
	    // itu_t_t35_contry_code must be 181 (United States) for
	    // captions
	    if (sei.payload[0] !== 181) {
	      return null;
	    } // itu_t_t35_provider_code should be 49 (ATSC) for captions
	
	
	    if ((sei.payload[1] << 8 | sei.payload[2]) !== 49) {
	      return null;
	    } // the user_identifier should be "GA94" to indicate ATSC1 data
	
	
	    if (String.fromCharCode(sei.payload[3], sei.payload[4], sei.payload[5], sei.payload[6]) !== 'GA94') {
	      return null;
	    } // finally, user_data_type_code should be 0x03 for caption data
	
	
	    if (sei.payload[7] !== 0x03) {
	      return null;
	    } // return the user_data_type_structure and strip the trailing
	    // marker bits
	
	
	    return sei.payload.subarray(8, sei.payload.length - 1);
	  }; // see CEA-708-D, section 4.4
	
	
	  var parseCaptionPackets = function parseCaptionPackets(pts, userData) {
	    var results = [],
	        i,
	        count,
	        offset,
	        data; // if this is just filler, return immediately
	
	    if (!(userData[0] & 0x40)) {
	      return results;
	    } // parse out the cc_data_1 and cc_data_2 fields
	
	
	    count = userData[0] & 0x1f;
	
	    for (i = 0; i < count; i++) {
	      offset = i * 3;
	      data = {
	        type: userData[offset + 2] & 0x03,
	        pts: pts
	      }; // capture cc data when cc_valid is 1
	
	      if (userData[offset + 2] & 0x04) {
	        data.ccData = userData[offset + 3] << 8 | userData[offset + 4];
	        results.push(data);
	      }
	    }
	
	    return results;
	  };
	
	  var discardEmulationPreventionBytes$1 = function discardEmulationPreventionBytes(data) {
	    var length = data.byteLength,
	        emulationPreventionBytesPositions = [],
	        i = 1,
	        newLength,
	        newData; // Find all `Emulation Prevention Bytes`
	
	    while (i < length - 2) {
	      if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	        emulationPreventionBytesPositions.push(i + 2);
	        i += 2;
	      } else {
	        i++;
	      }
	    } // If no Emulation Prevention Bytes were found just return the original
	    // array
	
	
	    if (emulationPreventionBytesPositions.length === 0) {
	      return data;
	    } // Create a new array to hold the NAL unit data
	
	
	    newLength = length - emulationPreventionBytesPositions.length;
	    newData = new Uint8Array(newLength);
	    var sourceIndex = 0;
	
	    for (i = 0; i < newLength; sourceIndex++, i++) {
	      if (sourceIndex === emulationPreventionBytesPositions[0]) {
	        // Skip this byte
	        sourceIndex++; // Remove this position index
	
	        emulationPreventionBytesPositions.shift();
	      }
	
	      newData[i] = data[sourceIndex];
	    }
	
	    return newData;
	  }; // exports
	
	
	  var captionPacketParser = {
	    parseSei: parseSei,
	    parseUserData: parseUserData,
	    parseCaptionPackets: parseCaptionPackets,
	    discardEmulationPreventionBytes: discardEmulationPreventionBytes$1,
	    USER_DATA_REGISTERED_ITU_T_T35: USER_DATA_REGISTERED_ITU_T_T35
	  }; // Link To Transport
	  // -----------------
	
	  var CaptionStream$1 = function CaptionStream(options) {
	    options = options || {};
	    CaptionStream.prototype.init.call(this); // parse708captions flag, default to true
	
	    this.parse708captions_ = typeof options.parse708captions === 'boolean' ? options.parse708captions : true;
	    this.captionPackets_ = [];
	    this.ccStreams_ = [new Cea608Stream(0, 0), // eslint-disable-line no-use-before-define
	    new Cea608Stream(0, 1), // eslint-disable-line no-use-before-define
	    new Cea608Stream(1, 0), // eslint-disable-line no-use-before-define
	    new Cea608Stream(1, 1) // eslint-disable-line no-use-before-define
	    ];
	
	    if (this.parse708captions_) {
	      this.cc708Stream_ = new Cea708Stream({
	        captionServices: options.captionServices
	      }); // eslint-disable-line no-use-before-define
	    }
	
	    this.reset(); // forward data and done events from CCs to this CaptionStream
	
	    this.ccStreams_.forEach(function (cc) {
	      cc.on('data', this.trigger.bind(this, 'data'));
	      cc.on('partialdone', this.trigger.bind(this, 'partialdone'));
	      cc.on('done', this.trigger.bind(this, 'done'));
	    }, this);
	
	    if (this.parse708captions_) {
	      this.cc708Stream_.on('data', this.trigger.bind(this, 'data'));
	      this.cc708Stream_.on('partialdone', this.trigger.bind(this, 'partialdone'));
	      this.cc708Stream_.on('done', this.trigger.bind(this, 'done'));
	    }
	  };
	
	  CaptionStream$1.prototype = new stream();
	
	  CaptionStream$1.prototype.push = function (event) {
	    var sei, userData, newCaptionPackets; // only examine SEI NALs
	
	    if (event.nalUnitType !== 'sei_rbsp') {
	      return;
	    } // parse the sei
	
	
	    sei = captionPacketParser.parseSei(event.escapedRBSP); // no payload data, skip
	
	    if (!sei.payload) {
	      return;
	    } // ignore everything but user_data_registered_itu_t_t35
	
	
	    if (sei.payloadType !== captionPacketParser.USER_DATA_REGISTERED_ITU_T_T35) {
	      return;
	    } // parse out the user data payload
	
	
	    userData = captionPacketParser.parseUserData(sei); // ignore unrecognized userData
	
	    if (!userData) {
	      return;
	    } // Sometimes, the same segment # will be downloaded twice. To stop the
	    // caption data from being processed twice, we track the latest dts we've
	    // received and ignore everything with a dts before that. However, since
	    // data for a specific dts can be split across packets on either side of
	    // a segment boundary, we need to make sure we *don't* ignore the packets
	    // from the *next* segment that have dts === this.latestDts_. By constantly
	    // tracking the number of packets received with dts === this.latestDts_, we
	    // know how many should be ignored once we start receiving duplicates.
	
	
	    if (event.dts < this.latestDts_) {
	      // We've started getting older data, so set the flag.
	      this.ignoreNextEqualDts_ = true;
	      return;
	    } else if (event.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
	      this.numSameDts_--;
	
	      if (!this.numSameDts_) {
	        // We've received the last duplicate packet, time to start processing again
	        this.ignoreNextEqualDts_ = false;
	      }
	
	      return;
	    } // parse out CC data packets and save them for later
	
	
	    newCaptionPackets = captionPacketParser.parseCaptionPackets(event.pts, userData);
	    this.captionPackets_ = this.captionPackets_.concat(newCaptionPackets);
	
	    if (this.latestDts_ !== event.dts) {
	      this.numSameDts_ = 0;
	    }
	
	    this.numSameDts_++;
	    this.latestDts_ = event.dts;
	  };
	
	  CaptionStream$1.prototype.flushCCStreams = function (flushType) {
	    this.ccStreams_.forEach(function (cc) {
	      return flushType === 'flush' ? cc.flush() : cc.partialFlush();
	    }, this);
	  };
	
	  CaptionStream$1.prototype.flushStream = function (flushType) {
	    // make sure we actually parsed captions before proceeding
	    if (!this.captionPackets_.length) {
	      this.flushCCStreams(flushType);
	      return;
	    } // In Chrome, the Array#sort function is not stable so add a
	    // presortIndex that we can use to ensure we get a stable-sort
	
	
	    this.captionPackets_.forEach(function (elem, idx) {
	      elem.presortIndex = idx;
	    }); // sort caption byte-pairs based on their PTS values
	
	    this.captionPackets_.sort(function (a, b) {
	      if (a.pts === b.pts) {
	        return a.presortIndex - b.presortIndex;
	      }
	
	      return a.pts - b.pts;
	    });
	    this.captionPackets_.forEach(function (packet) {
	      if (packet.type < 2) {
	        // Dispatch packet to the right Cea608Stream
	        this.dispatchCea608Packet(packet);
	      } else {
	        // Dispatch packet to the Cea708Stream
	        this.dispatchCea708Packet(packet);
	      }
	    }, this);
	    this.captionPackets_.length = 0;
	    this.flushCCStreams(flushType);
	  };
	
	  CaptionStream$1.prototype.flush = function () {
	    return this.flushStream('flush');
	  }; // Only called if handling partial data
	
	
	  CaptionStream$1.prototype.partialFlush = function () {
	    return this.flushStream('partialFlush');
	  };
	
	  CaptionStream$1.prototype.reset = function () {
	    this.latestDts_ = null;
	    this.ignoreNextEqualDts_ = false;
	    this.numSameDts_ = 0;
	    this.activeCea608Channel_ = [null, null];
	    this.ccStreams_.forEach(function (ccStream) {
	      ccStream.reset();
	    });
	  }; // From the CEA-608 spec:
	
	  /*
	   * When XDS sub-packets are interleaved with other services, the end of each sub-packet shall be followed
	   * by a control pair to change to a different service. When any of the control codes from 0x10 to 0x1F is
	   * used to begin a control code pair, it indicates the return to captioning or Text data. The control code pair
	   * and subsequent data should then be processed according to the FCC rules. It may be necessary for the
	   * line 21 data encoder to automatically insert a control code pair (i.e. RCL, RU2, RU3, RU4, RDC, or RTD)
	   * to switch to captioning or Text.
	  */
	  // With that in mind, we ignore any data between an XDS control code and a
	  // subsequent closed-captioning control code.
	
	
	  CaptionStream$1.prototype.dispatchCea608Packet = function (packet) {
	    // NOTE: packet.type is the CEA608 field
	    if (this.setsTextOrXDSActive(packet)) {
	      this.activeCea608Channel_[packet.type] = null;
	    } else if (this.setsChannel1Active(packet)) {
	      this.activeCea608Channel_[packet.type] = 0;
	    } else if (this.setsChannel2Active(packet)) {
	      this.activeCea608Channel_[packet.type] = 1;
	    }
	
	    if (this.activeCea608Channel_[packet.type] === null) {
	      // If we haven't received anything to set the active channel, or the
	      // packets are Text/XDS data, discard the data; we don't want jumbled
	      // captions
	      return;
	    }
	
	    this.ccStreams_[(packet.type << 1) + this.activeCea608Channel_[packet.type]].push(packet);
	  };
	
	  CaptionStream$1.prototype.setsChannel1Active = function (packet) {
	    return (packet.ccData & 0x7800) === 0x1000;
	  };
	
	  CaptionStream$1.prototype.setsChannel2Active = function (packet) {
	    return (packet.ccData & 0x7800) === 0x1800;
	  };
	
	  CaptionStream$1.prototype.setsTextOrXDSActive = function (packet) {
	    return (packet.ccData & 0x7100) === 0x0100 || (packet.ccData & 0x78fe) === 0x102a || (packet.ccData & 0x78fe) === 0x182a;
	  };
	
	  CaptionStream$1.prototype.dispatchCea708Packet = function (packet) {
	    if (this.parse708captions_) {
	      this.cc708Stream_.push(packet);
	    }
	  }; // ----------------------
	  // Session to Application
	  // ----------------------
	  // This hash maps special and extended character codes to their
	  // proper Unicode equivalent. The first one-byte key is just a
	  // non-standard character code. The two-byte keys that follow are
	  // the extended CEA708 character codes, along with the preceding
	  // 0x10 extended character byte to distinguish these codes from
	  // non-extended character codes. Every CEA708 character code that
	  // is not in this object maps directly to a standard unicode
	  // character code.
	  // The transparent space and non-breaking transparent space are
	  // technically not fully supported since there is no code to
	  // make them transparent, so they have normal non-transparent
	  // stand-ins.
	  // The special closed caption (CC) character isn't a standard
	  // unicode character, so a fairly similar unicode character was
	  // chosen in it's place.
	
	
	  var CHARACTER_TRANSLATION_708 = {
	    0x7f: 0x266a,
	    // ♪
	    0x1020: 0x20,
	    // Transparent Space
	    0x1021: 0xa0,
	    // Nob-breaking Transparent Space
	    0x1025: 0x2026,
	    // …
	    0x102a: 0x0160,
	    // Š
	    0x102c: 0x0152,
	    // Œ
	    0x1030: 0x2588,
	    // █
	    0x1031: 0x2018,
	    // ‘
	    0x1032: 0x2019,
	    // ’
	    0x1033: 0x201c,
	    // “
	    0x1034: 0x201d,
	    // ”
	    0x1035: 0x2022,
	    // •
	    0x1039: 0x2122,
	    // ™
	    0x103a: 0x0161,
	    // š
	    0x103c: 0x0153,
	    // œ
	    0x103d: 0x2120,
	    // ℠
	    0x103f: 0x0178,
	    // Ÿ
	    0x1076: 0x215b,
	    // ⅛
	    0x1077: 0x215c,
	    // ⅜
	    0x1078: 0x215d,
	    // ⅝
	    0x1079: 0x215e,
	    // ⅞
	    0x107a: 0x23d0,
	    // ⏐
	    0x107b: 0x23a4,
	    // ⎤
	    0x107c: 0x23a3,
	    // ⎣
	    0x107d: 0x23af,
	    // ⎯
	    0x107e: 0x23a6,
	    // ⎦
	    0x107f: 0x23a1,
	    // ⎡
	    0x10a0: 0x3138 // ㄸ (CC char)
	
	  };
	
	  var get708CharFromCode = function get708CharFromCode(code) {
	    var newCode = CHARACTER_TRANSLATION_708[code] || code;
	
	    if (code & 0x1000 && code === newCode) {
	      // Invalid extended code
	      return '';
	    }
	
	    return String.fromCharCode(newCode);
	  };
	
	  var within708TextBlock = function within708TextBlock(b) {
	    return 0x20 <= b && b <= 0x7f || 0xa0 <= b && b <= 0xff;
	  };
	
	  var Cea708Window = function Cea708Window(windowNum) {
	    this.windowNum = windowNum;
	    this.reset();
	  };
	
	  Cea708Window.prototype.reset = function () {
	    this.clearText();
	    this.pendingNewLine = false;
	    this.winAttr = {};
	    this.penAttr = {};
	    this.penLoc = {};
	    this.penColor = {}; // These default values are arbitrary,
	    // defineWindow will usually override them
	
	    this.visible = 0;
	    this.rowLock = 0;
	    this.columnLock = 0;
	    this.priority = 0;
	    this.relativePositioning = 0;
	    this.anchorVertical = 0;
	    this.anchorHorizontal = 0;
	    this.anchorPoint = 0;
	    this.rowCount = 1;
	    this.virtualRowCount = this.rowCount + 1;
	    this.columnCount = 41;
	    this.windowStyle = 0;
	    this.penStyle = 0;
	  };
	
	  Cea708Window.prototype.getText = function () {
	    return this.rows.join('\n');
	  };
	
	  Cea708Window.prototype.clearText = function () {
	    this.rows = [''];
	    this.rowIdx = 0;
	  };
	
	  Cea708Window.prototype.newLine = function (pts) {
	    if (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow === 'function') {
	      this.beforeRowOverflow(pts);
	    }
	
	    if (this.rows.length > 0) {
	      this.rows.push('');
	      this.rowIdx++;
	    } // Show all virtual rows since there's no visible scrolling
	
	
	    while (this.rows.length > this.virtualRowCount) {
	      this.rows.shift();
	      this.rowIdx--;
	    }
	  };
	
	  Cea708Window.prototype.isEmpty = function () {
	    if (this.rows.length === 0) {
	      return true;
	    } else if (this.rows.length === 1) {
	      return this.rows[0] === '';
	    }
	
	    return false;
	  };
	
	  Cea708Window.prototype.addText = function (text) {
	    this.rows[this.rowIdx] += text;
	  };
	
	  Cea708Window.prototype.backspace = function () {
	    if (!this.isEmpty()) {
	      var row = this.rows[this.rowIdx];
	      this.rows[this.rowIdx] = row.substr(0, row.length - 1);
	    }
	  };
	
	  var Cea708Service = function Cea708Service(serviceNum, encoding, stream) {
	    this.serviceNum = serviceNum;
	    this.text = '';
	    this.currentWindow = new Cea708Window(-1);
	    this.windows = [];
	    this.stream = stream; // Try to setup a TextDecoder if an `encoding` value was provided
	
	    if (typeof encoding === 'string') {
	      this.createTextDecoder(encoding);
	    }
	  };
	  /**
	   * Initialize service windows
	   * Must be run before service use
	   *
	   * @param  {Integer}  pts               PTS value
	   * @param  {Function} beforeRowOverflow Function to execute before row overflow of a window
	   */
	
	
	  Cea708Service.prototype.init = function (pts, beforeRowOverflow) {
	    this.startPts = pts;
	
	    for (var win = 0; win < 8; win++) {
	      this.windows[win] = new Cea708Window(win);
	
	      if (typeof beforeRowOverflow === 'function') {
	        this.windows[win].beforeRowOverflow = beforeRowOverflow;
	      }
	    }
	  };
	  /**
	   * Set current window of service to be affected by commands
	   *
	   * @param  {Integer} windowNum Window number
	   */
	
	
	  Cea708Service.prototype.setCurrentWindow = function (windowNum) {
	    this.currentWindow = this.windows[windowNum];
	  };
	  /**
	   * Try to create a TextDecoder if it is natively supported
	   */
	
	
	  Cea708Service.prototype.createTextDecoder = function (encoding) {
	    if (typeof TextDecoder === 'undefined') {
	      this.stream.trigger('log', {
	        level: 'warn',
	        message: 'The `encoding` option is unsupported without TextDecoder support'
	      });
	    } else {
	      try {
	        this.textDecoder_ = new TextDecoder(encoding);
	      } catch (error) {
	        this.stream.trigger('log', {
	          level: 'warn',
	          message: 'TextDecoder could not be created with ' + encoding + ' encoding. ' + error
	        });
	      }
	    }
	  };
	
	  var Cea708Stream = function Cea708Stream(options) {
	    options = options || {};
	    Cea708Stream.prototype.init.call(this);
	    var self = this;
	    var captionServices = options.captionServices || {};
	    var captionServiceEncodings = {};
	    var serviceProps; // Get service encodings from captionServices option block
	
	    Object.keys(captionServices).forEach(function (serviceName) {
	      serviceProps = captionServices[serviceName];
	
	      if (/^SERVICE/.test(serviceName)) {
	        captionServiceEncodings[serviceName] = serviceProps.encoding;
	      }
	    });
	    this.serviceEncodings = captionServiceEncodings;
	    this.current708Packet = null;
	    this.services = {};
	
	    this.push = function (packet) {
	      if (packet.type === 3) {
	        // 708 packet start
	        self.new708Packet();
	        self.add708Bytes(packet);
	      } else {
	        if (self.current708Packet === null) {
	          // This should only happen at the start of a file if there's no packet start.
	          self.new708Packet();
	        }
	
	        self.add708Bytes(packet);
	      }
	    };
	  };
	
	  Cea708Stream.prototype = new stream();
	  /**
	   * Push current 708 packet, create new 708 packet.
	   */
	
	  Cea708Stream.prototype.new708Packet = function () {
	    if (this.current708Packet !== null) {
	      this.push708Packet();
	    }
	
	    this.current708Packet = {
	      data: [],
	      ptsVals: []
	    };
	  };
	  /**
	   * Add pts and both bytes from packet into current 708 packet.
	   */
	
	
	  Cea708Stream.prototype.add708Bytes = function (packet) {
	    var data = packet.ccData;
	    var byte0 = data >>> 8;
	    var byte1 = data & 0xff; // I would just keep a list of packets instead of bytes, but it isn't clear in the spec
	    // that service blocks will always line up with byte pairs.
	
	    this.current708Packet.ptsVals.push(packet.pts);
	    this.current708Packet.data.push(byte0);
	    this.current708Packet.data.push(byte1);
	  };
	  /**
	   * Parse completed 708 packet into service blocks and push each service block.
	   */
	
	
	  Cea708Stream.prototype.push708Packet = function () {
	    var packet708 = this.current708Packet;
	    var packetData = packet708.data;
	    var serviceNum = null;
	    var blockSize = null;
	    var i = 0;
	    var b = packetData[i++];
	    packet708.seq = b >> 6;
	    packet708.sizeCode = b & 0x3f; // 0b00111111;
	
	    for (; i < packetData.length; i++) {
	      b = packetData[i++];
	      serviceNum = b >> 5;
	      blockSize = b & 0x1f; // 0b00011111
	
	      if (serviceNum === 7 && blockSize > 0) {
	        // Extended service num
	        b = packetData[i++];
	        serviceNum = b;
	      }
	
	      this.pushServiceBlock(serviceNum, i, blockSize);
	
	      if (blockSize > 0) {
	        i += blockSize - 1;
	      }
	    }
	  };
	  /**
	   * Parse service block, execute commands, read text.
	   *
	   * Note: While many of these commands serve important purposes,
	   * many others just parse out the parameters or attributes, but
	   * nothing is done with them because this is not a full and complete
	   * implementation of the entire 708 spec.
	   *
	   * @param  {Integer} serviceNum Service number
	   * @param  {Integer} start      Start index of the 708 packet data
	   * @param  {Integer} size       Block size
	   */
	
	
	  Cea708Stream.prototype.pushServiceBlock = function (serviceNum, start, size) {
	    var b;
	    var i = start;
	    var packetData = this.current708Packet.data;
	    var service = this.services[serviceNum];
	
	    if (!service) {
	      service = this.initService(serviceNum, i);
	    }
	
	    for (; i < start + size && i < packetData.length; i++) {
	      b = packetData[i];
	
	      if (within708TextBlock(b)) {
	        i = this.handleText(i, service);
	      } else if (b === 0x18) {
	        i = this.multiByteCharacter(i, service);
	      } else if (b === 0x10) {
	        i = this.extendedCommands(i, service);
	      } else if (0x80 <= b && b <= 0x87) {
	        i = this.setCurrentWindow(i, service);
	      } else if (0x98 <= b && b <= 0x9f) {
	        i = this.defineWindow(i, service);
	      } else if (b === 0x88) {
	        i = this.clearWindows(i, service);
	      } else if (b === 0x8c) {
	        i = this.deleteWindows(i, service);
	      } else if (b === 0x89) {
	        i = this.displayWindows(i, service);
	      } else if (b === 0x8a) {
	        i = this.hideWindows(i, service);
	      } else if (b === 0x8b) {
	        i = this.toggleWindows(i, service);
	      } else if (b === 0x97) {
	        i = this.setWindowAttributes(i, service);
	      } else if (b === 0x90) {
	        i = this.setPenAttributes(i, service);
	      } else if (b === 0x91) {
	        i = this.setPenColor(i, service);
	      } else if (b === 0x92) {
	        i = this.setPenLocation(i, service);
	      } else if (b === 0x8f) {
	        service = this.reset(i, service);
	      } else if (b === 0x08) {
	        // BS: Backspace
	        service.currentWindow.backspace();
	      } else if (b === 0x0c) {
	        // FF: Form feed
	        service.currentWindow.clearText();
	      } else if (b === 0x0d) {
	        // CR: Carriage return
	        service.currentWindow.pendingNewLine = true;
	      } else if (b === 0x0e) {
	        // HCR: Horizontal carriage return
	        service.currentWindow.clearText();
	      } else if (b === 0x8d) {
	        // DLY: Delay, nothing to do
	        i++;
	      } else ;
	    }
	  };
	  /**
	   * Execute an extended command
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.extendedCommands = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	
	    if (within708TextBlock(b)) {
	      i = this.handleText(i, service, {
	        isExtended: true
	      });
	    }
	
	    return i;
	  };
	  /**
	   * Get PTS value of a given byte index
	   *
	   * @param  {Integer} byteIndex  Index of the byte
	   * @return {Integer}            PTS
	   */
	
	
	  Cea708Stream.prototype.getPts = function (byteIndex) {
	    // There's 1 pts value per 2 bytes
	    return this.current708Packet.ptsVals[Math.floor(byteIndex / 2)];
	  };
	  /**
	   * Initializes a service
	   *
	   * @param  {Integer} serviceNum Service number
	   * @return {Service}            Initialized service object
	   */
	
	
	  Cea708Stream.prototype.initService = function (serviceNum, i) {
	    var serviceName = 'SERVICE' + serviceNum;
	    var self = this;
	    var serviceName;
	    var encoding;
	
	    if (serviceName in this.serviceEncodings) {
	      encoding = this.serviceEncodings[serviceName];
	    }
	
	    this.services[serviceNum] = new Cea708Service(serviceNum, encoding, self);
	    this.services[serviceNum].init(this.getPts(i), function (pts) {
	      self.flushDisplayed(pts, self.services[serviceNum]);
	    });
	    return this.services[serviceNum];
	  };
	  /**
	   * Execute text writing to current window
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.handleText = function (i, service, options) {
	    var isExtended = options && options.isExtended;
	    var isMultiByte = options && options.isMultiByte;
	    var packetData = this.current708Packet.data;
	    var extended = isExtended ? 0x1000 : 0x0000;
	    var currentByte = packetData[i];
	    var nextByte = packetData[i + 1];
	    var win = service.currentWindow;
	
	    var _char;
	
	    var charCodeArray; // Use the TextDecoder if one was created for this service
	
	    if (service.textDecoder_ && !isExtended) {
	      if (isMultiByte) {
	        charCodeArray = [currentByte, nextByte];
	        i++;
	      } else {
	        charCodeArray = [currentByte];
	      }
	
	      _char = service.textDecoder_.decode(new Uint8Array(charCodeArray));
	    } else {
	      _char = get708CharFromCode(extended | currentByte);
	    }
	
	    if (win.pendingNewLine && !win.isEmpty()) {
	      win.newLine(this.getPts(i));
	    }
	
	    win.pendingNewLine = false;
	    win.addText(_char);
	    return i;
	  };
	  /**
	   * Handle decoding of multibyte character
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.multiByteCharacter = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var firstByte = packetData[i + 1];
	    var secondByte = packetData[i + 2];
	
	    if (within708TextBlock(firstByte) && within708TextBlock(secondByte)) {
	      i = this.handleText(++i, service, {
	        isMultiByte: true
	      });
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the CW# command.
	   *
	   * Set the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setCurrentWindow = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var windowNum = b & 0x07;
	    service.setCurrentWindow(windowNum);
	    return i;
	  };
	  /**
	   * Parse and execute the DF# command.
	   *
	   * Define a window and set it as the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.defineWindow = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var windowNum = b & 0x07;
	    service.setCurrentWindow(windowNum);
	    var win = service.currentWindow;
	    b = packetData[++i];
	    win.visible = (b & 0x20) >> 5; // v
	
	    win.rowLock = (b & 0x10) >> 4; // rl
	
	    win.columnLock = (b & 0x08) >> 3; // cl
	
	    win.priority = b & 0x07; // p
	
	    b = packetData[++i];
	    win.relativePositioning = (b & 0x80) >> 7; // rp
	
	    win.anchorVertical = b & 0x7f; // av
	
	    b = packetData[++i];
	    win.anchorHorizontal = b; // ah
	
	    b = packetData[++i];
	    win.anchorPoint = (b & 0xf0) >> 4; // ap
	
	    win.rowCount = b & 0x0f; // rc
	
	    b = packetData[++i];
	    win.columnCount = b & 0x3f; // cc
	
	    b = packetData[++i];
	    win.windowStyle = (b & 0x38) >> 3; // ws
	
	    win.penStyle = b & 0x07; // ps
	    // The spec says there are (rowCount+1) "virtual rows"
	
	    win.virtualRowCount = win.rowCount + 1;
	    return i;
	  };
	  /**
	   * Parse and execute the SWA command.
	   *
	   * Set attributes of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setWindowAttributes = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var winAttr = service.currentWindow.winAttr;
	    b = packetData[++i];
	    winAttr.fillOpacity = (b & 0xc0) >> 6; // fo
	
	    winAttr.fillRed = (b & 0x30) >> 4; // fr
	
	    winAttr.fillGreen = (b & 0x0c) >> 2; // fg
	
	    winAttr.fillBlue = b & 0x03; // fb
	
	    b = packetData[++i];
	    winAttr.borderType = (b & 0xc0) >> 6; // bt
	
	    winAttr.borderRed = (b & 0x30) >> 4; // br
	
	    winAttr.borderGreen = (b & 0x0c) >> 2; // bg
	
	    winAttr.borderBlue = b & 0x03; // bb
	
	    b = packetData[++i];
	    winAttr.borderType += (b & 0x80) >> 5; // bt
	
	    winAttr.wordWrap = (b & 0x40) >> 6; // ww
	
	    winAttr.printDirection = (b & 0x30) >> 4; // pd
	
	    winAttr.scrollDirection = (b & 0x0c) >> 2; // sd
	
	    winAttr.justify = b & 0x03; // j
	
	    b = packetData[++i];
	    winAttr.effectSpeed = (b & 0xf0) >> 4; // es
	
	    winAttr.effectDirection = (b & 0x0c) >> 2; // ed
	
	    winAttr.displayEffect = b & 0x03; // de
	
	    return i;
	  };
	  /**
	   * Gather text from all displayed windows and push a caption to output.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   */
	
	
	  Cea708Stream.prototype.flushDisplayed = function (pts, service) {
	    var displayedText = []; // TODO: Positioning not supported, displaying multiple windows will not necessarily
	    // display text in the correct order, but sample files so far have not shown any issue.
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (service.windows[winId].visible && !service.windows[winId].isEmpty()) {
	        displayedText.push(service.windows[winId].getText());
	      }
	    }
	
	    service.endPts = pts;
	    service.text = displayedText.join('\n\n');
	    this.pushCaption(service);
	    service.startPts = pts;
	  };
	  /**
	   * Push a caption to output if the caption contains text.
	   *
	   * @param  {Service} service  The service object to be affected
	   */
	
	
	  Cea708Stream.prototype.pushCaption = function (service) {
	    if (service.text !== '') {
	      this.trigger('data', {
	        startPts: service.startPts,
	        endPts: service.endPts,
	        text: service.text,
	        stream: 'cc708_' + service.serviceNum
	      });
	      service.text = '';
	      service.startPts = service.endPts;
	    }
	  };
	  /**
	   * Parse and execute the DSW command.
	   *
	   * Set visible property of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.displayWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].visible = 1;
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the HDW command.
	   *
	   * Set visible property of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.hideWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].visible = 0;
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the TGW command.
	   *
	   * Set visible property of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.toggleWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].visible ^= 1;
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the CLW command.
	   *
	   * Clear text of windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.clearWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].clearText();
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the DLW command.
	   *
	   * Re-initialize windows based on the parsed bitmask.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.deleteWindows = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[++i];
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	
	    for (var winId = 0; winId < 8; winId++) {
	      if (b & 0x01 << winId) {
	        service.windows[winId].reset();
	      }
	    }
	
	    return i;
	  };
	  /**
	   * Parse and execute the SPA command.
	   *
	   * Set pen attributes of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setPenAttributes = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var penAttr = service.currentWindow.penAttr;
	    b = packetData[++i];
	    penAttr.textTag = (b & 0xf0) >> 4; // tt
	
	    penAttr.offset = (b & 0x0c) >> 2; // o
	
	    penAttr.penSize = b & 0x03; // s
	
	    b = packetData[++i];
	    penAttr.italics = (b & 0x80) >> 7; // i
	
	    penAttr.underline = (b & 0x40) >> 6; // u
	
	    penAttr.edgeType = (b & 0x38) >> 3; // et
	
	    penAttr.fontStyle = b & 0x07; // fs
	
	    return i;
	  };
	  /**
	   * Parse and execute the SPC command.
	   *
	   * Set pen color of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setPenColor = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var penColor = service.currentWindow.penColor;
	    b = packetData[++i];
	    penColor.fgOpacity = (b & 0xc0) >> 6; // fo
	
	    penColor.fgRed = (b & 0x30) >> 4; // fr
	
	    penColor.fgGreen = (b & 0x0c) >> 2; // fg
	
	    penColor.fgBlue = b & 0x03; // fb
	
	    b = packetData[++i];
	    penColor.bgOpacity = (b & 0xc0) >> 6; // bo
	
	    penColor.bgRed = (b & 0x30) >> 4; // br
	
	    penColor.bgGreen = (b & 0x0c) >> 2; // bg
	
	    penColor.bgBlue = b & 0x03; // bb
	
	    b = packetData[++i];
	    penColor.edgeRed = (b & 0x30) >> 4; // er
	
	    penColor.edgeGreen = (b & 0x0c) >> 2; // eg
	
	    penColor.edgeBlue = b & 0x03; // eb
	
	    return i;
	  };
	  /**
	   * Parse and execute the SPL command.
	   *
	   * Set pen location of the current window.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Integer}          New index after parsing
	   */
	
	
	  Cea708Stream.prototype.setPenLocation = function (i, service) {
	    var packetData = this.current708Packet.data;
	    var b = packetData[i];
	    var penLoc = service.currentWindow.penLoc; // Positioning isn't really supported at the moment, so this essentially just inserts a linebreak
	
	    service.currentWindow.pendingNewLine = true;
	    b = packetData[++i];
	    penLoc.row = b & 0x0f; // r
	
	    b = packetData[++i];
	    penLoc.column = b & 0x3f; // c
	
	    return i;
	  };
	  /**
	   * Execute the RST command.
	   *
	   * Reset service to a clean slate. Re-initialize.
	   *
	   * @param  {Integer} i        Current index in the 708 packet
	   * @param  {Service} service  The service object to be affected
	   * @return {Service}          Re-initialized service
	   */
	
	
	  Cea708Stream.prototype.reset = function (i, service) {
	    var pts = this.getPts(i);
	    this.flushDisplayed(pts, service);
	    return this.initService(service.serviceNum, i);
	  }; // This hash maps non-ASCII, special, and extended character codes to their
	  // proper Unicode equivalent. The first keys that are only a single byte
	  // are the non-standard ASCII characters, which simply map the CEA608 byte
	  // to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
	  // character codes, but have their MSB bitmasked with 0x03 so that a lookup
	  // can be performed regardless of the field and data channel on which the
	  // character code was received.
	
	
	  var CHARACTER_TRANSLATION = {
	    0x2a: 0xe1,
	    // á
	    0x5c: 0xe9,
	    // é
	    0x5e: 0xed,
	    // í
	    0x5f: 0xf3,
	    // ó
	    0x60: 0xfa,
	    // ú
	    0x7b: 0xe7,
	    // ç
	    0x7c: 0xf7,
	    // ÷
	    0x7d: 0xd1,
	    // Ñ
	    0x7e: 0xf1,
	    // ñ
	    0x7f: 0x2588,
	    // █
	    0x0130: 0xae,
	    // ®
	    0x0131: 0xb0,
	    // °
	    0x0132: 0xbd,
	    // ½
	    0x0133: 0xbf,
	    // ¿
	    0x0134: 0x2122,
	    // ™
	    0x0135: 0xa2,
	    // ¢
	    0x0136: 0xa3,
	    // £
	    0x0137: 0x266a,
	    // ♪
	    0x0138: 0xe0,
	    // à
	    0x0139: 0xa0,
	    //
	    0x013a: 0xe8,
	    // è
	    0x013b: 0xe2,
	    // â
	    0x013c: 0xea,
	    // ê
	    0x013d: 0xee,
	    // î
	    0x013e: 0xf4,
	    // ô
	    0x013f: 0xfb,
	    // û
	    0x0220: 0xc1,
	    // Á
	    0x0221: 0xc9,
	    // É
	    0x0222: 0xd3,
	    // Ó
	    0x0223: 0xda,
	    // Ú
	    0x0224: 0xdc,
	    // Ü
	    0x0225: 0xfc,
	    // ü
	    0x0226: 0x2018,
	    // ‘
	    0x0227: 0xa1,
	    // ¡
	    0x0228: 0x2a,
	    // *
	    0x0229: 0x27,
	    // '
	    0x022a: 0x2014,
	    // —
	    0x022b: 0xa9,
	    // ©
	    0x022c: 0x2120,
	    // ℠
	    0x022d: 0x2022,
	    // •
	    0x022e: 0x201c,
	    // “
	    0x022f: 0x201d,
	    // ”
	    0x0230: 0xc0,
	    // À
	    0x0231: 0xc2,
	    // Â
	    0x0232: 0xc7,
	    // Ç
	    0x0233: 0xc8,
	    // È
	    0x0234: 0xca,
	    // Ê
	    0x0235: 0xcb,
	    // Ë
	    0x0236: 0xeb,
	    // ë
	    0x0237: 0xce,
	    // Î
	    0x0238: 0xcf,
	    // Ï
	    0x0239: 0xef,
	    // ï
	    0x023a: 0xd4,
	    // Ô
	    0x023b: 0xd9,
	    // Ù
	    0x023c: 0xf9,
	    // ù
	    0x023d: 0xdb,
	    // Û
	    0x023e: 0xab,
	    // «
	    0x023f: 0xbb,
	    // »
	    0x0320: 0xc3,
	    // Ã
	    0x0321: 0xe3,
	    // ã
	    0x0322: 0xcd,
	    // Í
	    0x0323: 0xcc,
	    // Ì
	    0x0324: 0xec,
	    // ì
	    0x0325: 0xd2,
	    // Ò
	    0x0326: 0xf2,
	    // ò
	    0x0327: 0xd5,
	    // Õ
	    0x0328: 0xf5,
	    // õ
	    0x0329: 0x7b,
	    // {
	    0x032a: 0x7d,
	    // }
	    0x032b: 0x5c,
	    // \
	    0x032c: 0x5e,
	    // ^
	    0x032d: 0x5f,
	    // _
	    0x032e: 0x7c,
	    // |
	    0x032f: 0x7e,
	    // ~
	    0x0330: 0xc4,
	    // Ä
	    0x0331: 0xe4,
	    // ä
	    0x0332: 0xd6,
	    // Ö
	    0x0333: 0xf6,
	    // ö
	    0x0334: 0xdf,
	    // ß
	    0x0335: 0xa5,
	    // ¥
	    0x0336: 0xa4,
	    // ¤
	    0x0337: 0x2502,
	    // │
	    0x0338: 0xc5,
	    // Å
	    0x0339: 0xe5,
	    // å
	    0x033a: 0xd8,
	    // Ø
	    0x033b: 0xf8,
	    // ø
	    0x033c: 0x250c,
	    // ┌
	    0x033d: 0x2510,
	    // ┐
	    0x033e: 0x2514,
	    // └
	    0x033f: 0x2518 // ┘
	
	  };
	
	  var getCharFromCode = function getCharFromCode(code) {
	    if (code === null) {
	      return '';
	    }
	
	    code = CHARACTER_TRANSLATION[code] || code;
	    return String.fromCharCode(code);
	  }; // the index of the last row in a CEA-608 display buffer
	
	
	  var BOTTOM_ROW = 14; // This array is used for mapping PACs -> row #, since there's no way of
	  // getting it through bit logic.
	
	  var ROWS = [0x1100, 0x1120, 0x1200, 0x1220, 0x1500, 0x1520, 0x1600, 0x1620, 0x1700, 0x1720, 0x1000, 0x1300, 0x1320, 0x1400, 0x1420]; // CEA-608 captions are rendered onto a 34x15 matrix of character
	  // cells. The "bottom" row is the last element in the outer array.
	
	  var createDisplayBuffer = function createDisplayBuffer() {
	    var result = [],
	        i = BOTTOM_ROW + 1;
	
	    while (i--) {
	      result.push('');
	    }
	
	    return result;
	  };
	
	  var Cea608Stream = function Cea608Stream(field, dataChannel) {
	    Cea608Stream.prototype.init.call(this);
	    this.field_ = field || 0;
	    this.dataChannel_ = dataChannel || 0;
	    this.name_ = 'CC' + ((this.field_ << 1 | this.dataChannel_) + 1);
	    this.setConstants();
	    this.reset();
	
	    this.push = function (packet) {
	      var data, swap, char0, char1, text; // remove the parity bits
	
	      data = packet.ccData & 0x7f7f; // ignore duplicate control codes; the spec demands they're sent twice
	
	      if (data === this.lastControlCode_) {
	        this.lastControlCode_ = null;
	        return;
	      } // Store control codes
	
	
	      if ((data & 0xf000) === 0x1000) {
	        this.lastControlCode_ = data;
	      } else if (data !== this.PADDING_) {
	        this.lastControlCode_ = null;
	      }
	
	      char0 = data >>> 8;
	      char1 = data & 0xff;
	
	      if (data === this.PADDING_) {
	        return;
	      } else if (data === this.RESUME_CAPTION_LOADING_) {
	        this.mode_ = 'popOn';
	      } else if (data === this.END_OF_CAPTION_) {
	        // If an EOC is received while in paint-on mode, the displayed caption
	        // text should be swapped to non-displayed memory as if it was a pop-on
	        // caption. Because of that, we should explicitly switch back to pop-on
	        // mode
	        this.mode_ = 'popOn';
	        this.clearFormatting(packet.pts); // if a caption was being displayed, it's gone now
	
	        this.flushDisplayed(packet.pts); // flip memory
	
	        swap = this.displayed_;
	        this.displayed_ = this.nonDisplayed_;
	        this.nonDisplayed_ = swap; // start measuring the time to display the caption
	
	        this.startPts_ = packet.pts;
	      } else if (data === this.ROLL_UP_2_ROWS_) {
	        this.rollUpRows_ = 2;
	        this.setRollUp(packet.pts);
	      } else if (data === this.ROLL_UP_3_ROWS_) {
	        this.rollUpRows_ = 3;
	        this.setRollUp(packet.pts);
	      } else if (data === this.ROLL_UP_4_ROWS_) {
	        this.rollUpRows_ = 4;
	        this.setRollUp(packet.pts);
	      } else if (data === this.CARRIAGE_RETURN_) {
	        this.clearFormatting(packet.pts);
	        this.flushDisplayed(packet.pts);
	        this.shiftRowsUp_();
	        this.startPts_ = packet.pts;
	      } else if (data === this.BACKSPACE_) {
	        if (this.mode_ === 'popOn') {
	          this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	        } else {
	          this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	        }
	      } else if (data === this.ERASE_DISPLAYED_MEMORY_) {
	        this.flushDisplayed(packet.pts);
	        this.displayed_ = createDisplayBuffer();
	      } else if (data === this.ERASE_NON_DISPLAYED_MEMORY_) {
	        this.nonDisplayed_ = createDisplayBuffer();
	      } else if (data === this.RESUME_DIRECT_CAPTIONING_) {
	        if (this.mode_ !== 'paintOn') {
	          // NOTE: This should be removed when proper caption positioning is
	          // implemented
	          this.flushDisplayed(packet.pts);
	          this.displayed_ = createDisplayBuffer();
	        }
	
	        this.mode_ = 'paintOn';
	        this.startPts_ = packet.pts; // Append special characters to caption text
	      } else if (this.isSpecialCharacter(char0, char1)) {
	        // Bitmask char0 so that we can apply character transformations
	        // regardless of field and data channel.
	        // Then byte-shift to the left and OR with char1 so we can pass the
	        // entire character code to `getCharFromCode`.
	        char0 = (char0 & 0x03) << 8;
	        text = getCharFromCode(char0 | char1);
	        this[this.mode_](packet.pts, text);
	        this.column_++; // Append extended characters to caption text
	      } else if (this.isExtCharacter(char0, char1)) {
	        // Extended characters always follow their "non-extended" equivalents.
	        // IE if a "è" is desired, you'll always receive "eè"; non-compliant
	        // decoders are supposed to drop the "è", while compliant decoders
	        // backspace the "e" and insert "è".
	        // Delete the previous character
	        if (this.mode_ === 'popOn') {
	          this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
	        } else {
	          this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
	        } // Bitmask char0 so that we can apply character transformations
	        // regardless of field and data channel.
	        // Then byte-shift to the left and OR with char1 so we can pass the
	        // entire character code to `getCharFromCode`.
	
	
	        char0 = (char0 & 0x03) << 8;
	        text = getCharFromCode(char0 | char1);
	        this[this.mode_](packet.pts, text);
	        this.column_++; // Process mid-row codes
	      } else if (this.isMidRowCode(char0, char1)) {
	        // Attributes are not additive, so clear all formatting
	        this.clearFormatting(packet.pts); // According to the standard, mid-row codes
	        // should be replaced with spaces, so add one now
	
	        this[this.mode_](packet.pts, ' ');
	        this.column_++;
	
	        if ((char1 & 0xe) === 0xe) {
	          this.addFormatting(packet.pts, ['i']);
	        }
	
	        if ((char1 & 0x1) === 0x1) {
	          this.addFormatting(packet.pts, ['u']);
	        } // Detect offset control codes and adjust cursor
	
	      } else if (this.isOffsetControlCode(char0, char1)) {
	        // Cursor position is set by indent PAC (see below) in 4-column
	        // increments, with an additional offset code of 1-3 to reach any
	        // of the 32 columns specified by CEA-608. So all we need to do
	        // here is increment the column cursor by the given offset.
	        this.column_ += char1 & 0x03; // Detect PACs (Preamble Address Codes)
	      } else if (this.isPAC(char0, char1)) {
	        // There's no logic for PAC -> row mapping, so we have to just
	        // find the row code in an array and use its index :(
	        var row = ROWS.indexOf(data & 0x1f20); // Configure the caption window if we're in roll-up mode
	
	        if (this.mode_ === 'rollUp') {
	          // This implies that the base row is incorrectly set.
	          // As per the recommendation in CEA-608(Base Row Implementation), defer to the number
	          // of roll-up rows set.
	          if (row - this.rollUpRows_ + 1 < 0) {
	            row = this.rollUpRows_ - 1;
	          }
	
	          this.setRollUp(packet.pts, row);
	        }
	
	        if (row !== this.row_) {
	          // formatting is only persistent for current row
	          this.clearFormatting(packet.pts);
	          this.row_ = row;
	        } // All PACs can apply underline, so detect and apply
	        // (All odd-numbered second bytes set underline)
	
	
	        if (char1 & 0x1 && this.formatting_.indexOf('u') === -1) {
	          this.addFormatting(packet.pts, ['u']);
	        }
	
	        if ((data & 0x10) === 0x10) {
	          // We've got an indent level code. Each successive even number
	          // increments the column cursor by 4, so we can get the desired
	          // column position by bit-shifting to the right (to get n/2)
	          // and multiplying by 4.
	          this.column_ = ((data & 0xe) >> 1) * 4;
	        }
	
	        if (this.isColorPAC(char1)) {
	          // it's a color code, though we only support white, which
	          // can be either normal or italicized. white italics can be
	          // either 0x4e or 0x6e depending on the row, so we just
	          // bitwise-and with 0xe to see if italics should be turned on
	          if ((char1 & 0xe) === 0xe) {
	            this.addFormatting(packet.pts, ['i']);
	          }
	        } // We have a normal character in char0, and possibly one in char1
	
	      } else if (this.isNormalChar(char0)) {
	        if (char1 === 0x00) {
	          char1 = null;
	        }
	
	        text = getCharFromCode(char0);
	        text += getCharFromCode(char1);
	        this[this.mode_](packet.pts, text);
	        this.column_ += text.length;
	      } // finish data processing
	
	    };
	  };
	
	  Cea608Stream.prototype = new stream(); // Trigger a cue point that captures the current state of the
	  // display buffer
	
	  Cea608Stream.prototype.flushDisplayed = function (pts) {
	    var content = this.displayed_ // remove spaces from the start and end of the string
	    .map(function (row, index) {
	      try {
	        return row.trim();
	      } catch (e) {
	        // Ordinarily, this shouldn't happen. However, caption
	        // parsing errors should not throw exceptions and
	        // break playback.
	        this.trigger('log', {
	          level: 'warn',
	          message: 'Skipping a malformed 608 caption at index ' + index + '.'
	        });
	        return '';
	      }
	    }, this) // combine all text rows to display in one cue
	    .join('\n') // and remove blank rows from the start and end, but not the middle
	    .replace(/^\n+|\n+$/g, '');
	
	    if (content.length) {
	      this.trigger('data', {
	        startPts: this.startPts_,
	        endPts: pts,
	        text: content,
	        stream: this.name_
	      });
	    }
	  };
	  /**
	   * Zero out the data, used for startup and on seek
	   */
	
	
	  Cea608Stream.prototype.reset = function () {
	    this.mode_ = 'popOn'; // When in roll-up mode, the index of the last row that will
	    // actually display captions. If a caption is shifted to a row
	    // with a lower index than this, it is cleared from the display
	    // buffer
	
	    this.topRow_ = 0;
	    this.startPts_ = 0;
	    this.displayed_ = createDisplayBuffer();
	    this.nonDisplayed_ = createDisplayBuffer();
	    this.lastControlCode_ = null; // Track row and column for proper line-breaking and spacing
	
	    this.column_ = 0;
	    this.row_ = BOTTOM_ROW;
	    this.rollUpRows_ = 2; // This variable holds currently-applied formatting
	
	    this.formatting_ = [];
	  };
	  /**
	   * Sets up control code and related constants for this instance
	   */
	
	
	  Cea608Stream.prototype.setConstants = function () {
	    // The following attributes have these uses:
	    // ext_ :    char0 for mid-row codes, and the base for extended
	    //           chars (ext_+0, ext_+1, and ext_+2 are char0s for
	    //           extended codes)
	    // control_: char0 for control codes, except byte-shifted to the
	    //           left so that we can do this.control_ | CONTROL_CODE
	    // offset_:  char0 for tab offset codes
	    //
	    // It's also worth noting that control codes, and _only_ control codes,
	    // differ between field 1 and field2. Field 2 control codes are always
	    // their field 1 value plus 1. That's why there's the "| field" on the
	    // control value.
	    if (this.dataChannel_ === 0) {
	      this.BASE_ = 0x10;
	      this.EXT_ = 0x11;
	      this.CONTROL_ = (0x14 | this.field_) << 8;
	      this.OFFSET_ = 0x17;
	    } else if (this.dataChannel_ === 1) {
	      this.BASE_ = 0x18;
	      this.EXT_ = 0x19;
	      this.CONTROL_ = (0x1c | this.field_) << 8;
	      this.OFFSET_ = 0x1f;
	    } // Constants for the LSByte command codes recognized by Cea608Stream. This
	    // list is not exhaustive. For a more comprehensive listing and semantics see
	    // http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
	    // Padding
	
	
	    this.PADDING_ = 0x0000; // Pop-on Mode
	
	    this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 0x20;
	    this.END_OF_CAPTION_ = this.CONTROL_ | 0x2f; // Roll-up Mode
	
	    this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 0x25;
	    this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 0x26;
	    this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 0x27;
	    this.CARRIAGE_RETURN_ = this.CONTROL_ | 0x2d; // paint-on mode
	
	    this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 0x29; // Erasure
	
	    this.BACKSPACE_ = this.CONTROL_ | 0x21;
	    this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2c;
	    this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 0x2e;
	  };
	  /**
	   * Detects if the 2-byte packet data is a special character
	   *
	   * Special characters have a second byte in the range 0x30 to 0x3f,
	   * with the first byte being 0x11 (for data channel 1) or 0x19 (for
	   * data channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are an special character
	   */
	
	
	  Cea608Stream.prototype.isSpecialCharacter = function (char0, char1) {
	    return char0 === this.EXT_ && char1 >= 0x30 && char1 <= 0x3f;
	  };
	  /**
	   * Detects if the 2-byte packet data is an extended character
	   *
	   * Extended characters have a second byte in the range 0x20 to 0x3f,
	   * with the first byte being 0x12 or 0x13 (for data channel 1) or
	   * 0x1a or 0x1b (for data channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are an extended character
	   */
	
	
	  Cea608Stream.prototype.isExtCharacter = function (char0, char1) {
	    return (char0 === this.EXT_ + 1 || char0 === this.EXT_ + 2) && char1 >= 0x20 && char1 <= 0x3f;
	  };
	  /**
	   * Detects if the 2-byte packet is a mid-row code
	   *
	   * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
	   * the first byte being 0x11 (for data channel 1) or 0x19 (for data
	   * channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are a mid-row code
	   */
	
	
	  Cea608Stream.prototype.isMidRowCode = function (char0, char1) {
	    return char0 === this.EXT_ && char1 >= 0x20 && char1 <= 0x2f;
	  };
	  /**
	   * Detects if the 2-byte packet is an offset control code
	   *
	   * Offset control codes have a second byte in the range 0x21 to 0x23,
	   * with the first byte being 0x17 (for data channel 1) or 0x1f (for
	   * data channel 2).
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are an offset control code
	   */
	
	
	  Cea608Stream.prototype.isOffsetControlCode = function (char0, char1) {
	    return char0 === this.OFFSET_ && char1 >= 0x21 && char1 <= 0x23;
	  };
	  /**
	   * Detects if the 2-byte packet is a Preamble Address Code
	   *
	   * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
	   * or 0x18 to 0x1f (for data channel 2), with the second byte in the
	   * range 0x40 to 0x7f.
	   *
	   * @param  {Integer} char0 The first byte
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the 2 bytes are a PAC
	   */
	
	
	  Cea608Stream.prototype.isPAC = function (char0, char1) {
	    return char0 >= this.BASE_ && char0 < this.BASE_ + 8 && char1 >= 0x40 && char1 <= 0x7f;
	  };
	  /**
	   * Detects if a packet's second byte is in the range of a PAC color code
	   *
	   * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
	   * 0x60 to 0x6f.
	   *
	   * @param  {Integer} char1 The second byte
	   * @return {Boolean}       Whether the byte is a color PAC
	   */
	
	
	  Cea608Stream.prototype.isColorPAC = function (char1) {
	    return char1 >= 0x40 && char1 <= 0x4f || char1 >= 0x60 && char1 <= 0x7f;
	  };
	  /**
	   * Detects if a single byte is in the range of a normal character
	   *
	   * Normal text bytes are in the range 0x20 to 0x7f.
	   *
	   * @param  {Integer} char  The byte
	   * @return {Boolean}       Whether the byte is a normal character
	   */
	
	
	  Cea608Stream.prototype.isNormalChar = function (_char2) {
	    return _char2 >= 0x20 && _char2 <= 0x7f;
	  };
	  /**
	   * Configures roll-up
	   *
	   * @param  {Integer} pts         Current PTS
	   * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
	   *                               a new position
	   */
	
	
	  Cea608Stream.prototype.setRollUp = function (pts, newBaseRow) {
	    // Reset the base row to the bottom row when switching modes
	    if (this.mode_ !== 'rollUp') {
	      this.row_ = BOTTOM_ROW;
	      this.mode_ = 'rollUp'; // Spec says to wipe memories when switching to roll-up
	
	      this.flushDisplayed(pts);
	      this.nonDisplayed_ = createDisplayBuffer();
	      this.displayed_ = createDisplayBuffer();
	    }
	
	    if (newBaseRow !== undefined && newBaseRow !== this.row_) {
	      // move currently displayed captions (up or down) to the new base row
	      for (var i = 0; i < this.rollUpRows_; i++) {
	        this.displayed_[newBaseRow - i] = this.displayed_[this.row_ - i];
	        this.displayed_[this.row_ - i] = '';
	      }
	    }
	
	    if (newBaseRow === undefined) {
	      newBaseRow = this.row_;
	    }
	
	    this.topRow_ = newBaseRow - this.rollUpRows_ + 1;
	  }; // Adds the opening HTML tag for the passed character to the caption text,
	  // and keeps track of it for later closing
	
	
	  Cea608Stream.prototype.addFormatting = function (pts, format) {
	    this.formatting_ = this.formatting_.concat(format);
	    var text = format.reduce(function (text, format) {
	      return text + '<' + format + '>';
	    }, '');
	    this[this.mode_](pts, text);
	  }; // Adds HTML closing tags for current formatting to caption text and
	  // clears remembered formatting
	
	
	  Cea608Stream.prototype.clearFormatting = function (pts) {
	    if (!this.formatting_.length) {
	      return;
	    }
	
	    var text = this.formatting_.reverse().reduce(function (text, format) {
	      return text + '</' + format + '>';
	    }, '');
	    this.formatting_ = [];
	    this[this.mode_](pts, text);
	  }; // Mode Implementations
	
	
	  Cea608Stream.prototype.popOn = function (pts, text) {
	    var baseRow = this.nonDisplayed_[this.row_]; // buffer characters
	
	    baseRow += text;
	    this.nonDisplayed_[this.row_] = baseRow;
	  };
	
	  Cea608Stream.prototype.rollUp = function (pts, text) {
	    var baseRow = this.displayed_[this.row_];
	    baseRow += text;
	    this.displayed_[this.row_] = baseRow;
	  };
	
	  Cea608Stream.prototype.shiftRowsUp_ = function () {
	    var i; // clear out inactive rows
	
	    for (i = 0; i < this.topRow_; i++) {
	      this.displayed_[i] = '';
	    }
	
	    for (i = this.row_ + 1; i < BOTTOM_ROW + 1; i++) {
	      this.displayed_[i] = '';
	    } // shift displayed rows up
	
	
	    for (i = this.topRow_; i < this.row_; i++) {
	      this.displayed_[i] = this.displayed_[i + 1];
	    } // clear out the bottom row
	
	
	    this.displayed_[this.row_] = '';
	  };
	
	  Cea608Stream.prototype.paintOn = function (pts, text) {
	    var baseRow = this.displayed_[this.row_];
	    baseRow += text;
	    this.displayed_[this.row_] = baseRow;
	  }; // exports
	
	
	  var captionStream = {
	    CaptionStream: CaptionStream$1,
	    Cea608Stream: Cea608Stream,
	    Cea708Stream: Cea708Stream
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var streamTypes = {
	    H264_STREAM_TYPE: 0x1B,
	    ADTS_STREAM_TYPE: 0x0F,
	    METADATA_STREAM_TYPE: 0x15
	  };
	  var MAX_TS = 8589934592;
	  var RO_THRESH = 4294967296;
	  var TYPE_SHARED = 'shared';
	
	  var handleRollover$1 = function handleRollover(value, reference) {
	    var direction = 1;
	
	    if (value > reference) {
	      // If the current timestamp value is greater than our reference timestamp and we detect a
	      // timestamp rollover, this means the roll over is happening in the opposite direction.
	      // Example scenario: Enter a long stream/video just after a rollover occurred. The reference
	      // point will be set to a small number, e.g. 1. The user then seeks backwards over the
	      // rollover point. In loading this segment, the timestamp values will be very large,
	      // e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
	      // the time stamp to be `value - 2^33`.
	      direction = -1;
	    } // Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
	    // cause an incorrect adjustment.
	
	
	    while (Math.abs(reference - value) > RO_THRESH) {
	      value += direction * MAX_TS;
	    }
	
	    return value;
	  };
	
	  var TimestampRolloverStream$1 = function TimestampRolloverStream(type) {
	    var lastDTS, referenceDTS;
	    TimestampRolloverStream.prototype.init.call(this); // The "shared" type is used in cases where a stream will contain muxed
	    // video and audio. We could use `undefined` here, but having a string
	    // makes debugging a little clearer.
	
	    this.type_ = type || TYPE_SHARED;
	
	    this.push = function (data) {
	      // Any "shared" rollover streams will accept _all_ data. Otherwise,
	      // streams will only accept data that matches their type.
	      if (this.type_ !== TYPE_SHARED && data.type !== this.type_) {
	        return;
	      }
	
	      if (referenceDTS === undefined) {
	        referenceDTS = data.dts;
	      }
	
	      data.dts = handleRollover$1(data.dts, referenceDTS);
	      data.pts = handleRollover$1(data.pts, referenceDTS);
	      lastDTS = data.dts;
	      this.trigger('data', data);
	    };
	
	    this.flush = function () {
	      referenceDTS = lastDTS;
	      this.trigger('done');
	    };
	
	    this.endTimeline = function () {
	      this.flush();
	      this.trigger('endedtimeline');
	    };
	
	    this.discontinuity = function () {
	      referenceDTS = void 0;
	      lastDTS = void 0;
	    };
	
	    this.reset = function () {
	      this.discontinuity();
	      this.trigger('reset');
	    };
	  };
	
	  TimestampRolloverStream$1.prototype = new stream();
	  var timestampRolloverStream = {
	    TimestampRolloverStream: TimestampRolloverStream$1,
	    handleRollover: handleRollover$1
	  };
	
	  var percentEncode$1 = function percentEncode(bytes, start, end) {
	    var i,
	        result = '';
	
	    for (i = start; i < end; i++) {
	      result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	    }
	
	    return result;
	  },
	      // return the string representation of the specified byte range,
	  // interpreted as UTf-8.
	  parseUtf8 = function parseUtf8(bytes, start, end) {
	    return decodeURIComponent(percentEncode$1(bytes, start, end));
	  },
	      // return the string representation of the specified byte range,
	  // interpreted as ISO-8859-1.
	  parseIso88591$1 = function parseIso88591(bytes, start, end) {
	    return unescape(percentEncode$1(bytes, start, end)); // jshint ignore:line
	  },
	      parseSyncSafeInteger$1 = function parseSyncSafeInteger(data) {
	    return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
	  },
	      tagParsers = {
	    TXXX: function TXXX(tag) {
	      var i;
	
	      if (tag.data[0] !== 3) {
	        // ignore frames with unrecognized character encodings
	        return;
	      }
	
	      for (i = 1; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the text fields
	          tag.description = parseUtf8(tag.data, 1, i); // do not include the null terminator in the tag value
	
	          tag.value = parseUtf8(tag.data, i + 1, tag.data.length).replace(/\0*$/, '');
	          break;
	        }
	      }
	
	      tag.data = tag.value;
	    },
	    WXXX: function WXXX(tag) {
	      var i;
	
	      if (tag.data[0] !== 3) {
	        // ignore frames with unrecognized character encodings
	        return;
	      }
	
	      for (i = 1; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the description and URL fields
	          tag.description = parseUtf8(tag.data, 1, i);
	          tag.url = parseUtf8(tag.data, i + 1, tag.data.length);
	          break;
	        }
	      }
	    },
	    PRIV: function PRIV(tag) {
	      var i;
	
	      for (i = 0; i < tag.data.length; i++) {
	        if (tag.data[i] === 0) {
	          // parse the description and URL fields
	          tag.owner = parseIso88591$1(tag.data, 0, i);
	          break;
	        }
	      }
	
	      tag.privateData = tag.data.subarray(i + 1);
	      tag.data = tag.privateData;
	    }
	  },
	      _MetadataStream;
	
	  _MetadataStream = function MetadataStream(options) {
	    var settings = {
	      // the bytes of the program-level descriptor field in MP2T
	      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
	      // program element descriptors"
	      descriptor: options && options.descriptor
	    },
	        // the total size in bytes of the ID3 tag being parsed
	    tagSize = 0,
	        // tag data that is not complete enough to be parsed
	    buffer = [],
	        // the total number of bytes currently in the buffer
	    bufferSize = 0,
	        i;
	
	    _MetadataStream.prototype.init.call(this); // calculate the text track in-band metadata track dispatch type
	    // https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
	
	
	    this.dispatchType = streamTypes.METADATA_STREAM_TYPE.toString(16);
	
	    if (settings.descriptor) {
	      for (i = 0; i < settings.descriptor.length; i++) {
	        this.dispatchType += ('00' + settings.descriptor[i].toString(16)).slice(-2);
	      }
	    }
	
	    this.push = function (chunk) {
	      var tag, frameStart, frameSize, frame, i, frameHeader;
	
	      if (chunk.type !== 'timed-metadata') {
	        return;
	      } // if data_alignment_indicator is set in the PES header,
	      // we must have the start of a new ID3 tag. Assume anything
	      // remaining in the buffer was malformed and throw it out
	
	
	      if (chunk.dataAlignmentIndicator) {
	        bufferSize = 0;
	        buffer.length = 0;
	      } // ignore events that don't look like ID3 data
	
	
	      if (buffer.length === 0 && (chunk.data.length < 10 || chunk.data[0] !== 'I'.charCodeAt(0) || chunk.data[1] !== 'D'.charCodeAt(0) || chunk.data[2] !== '3'.charCodeAt(0))) {
	        this.trigger('log', {
	          level: 'warn',
	          message: 'Skipping unrecognized metadata packet'
	        });
	        return;
	      } // add this chunk to the data we've collected so far
	
	
	      buffer.push(chunk);
	      bufferSize += chunk.data.byteLength; // grab the size of the entire frame from the ID3 header
	
	      if (buffer.length === 1) {
	        // the frame size is transmitted as a 28-bit integer in the
	        // last four bytes of the ID3 header.
	        // The most significant bit of each byte is dropped and the
	        // results concatenated to recover the actual value.
	        tagSize = parseSyncSafeInteger$1(chunk.data.subarray(6, 10)); // ID3 reports the tag size excluding the header but it's more
	        // convenient for our comparisons to include it
	
	        tagSize += 10;
	      } // if the entire frame has not arrived, wait for more data
	
	
	      if (bufferSize < tagSize) {
	        return;
	      } // collect the entire frame so it can be parsed
	
	
	      tag = {
	        data: new Uint8Array(tagSize),
	        frames: [],
	        pts: buffer[0].pts,
	        dts: buffer[0].dts
	      };
	
	      for (i = 0; i < tagSize;) {
	        tag.data.set(buffer[0].data.subarray(0, tagSize - i), i);
	        i += buffer[0].data.byteLength;
	        bufferSize -= buffer[0].data.byteLength;
	        buffer.shift();
	      } // find the start of the first frame and the end of the tag
	
	
	      frameStart = 10;
	
	      if (tag.data[5] & 0x40) {
	        // advance the frame start past the extended header
	        frameStart += 4; // header size field
	
	        frameStart += parseSyncSafeInteger$1(tag.data.subarray(10, 14)); // clip any padding off the end
	
	        tagSize -= parseSyncSafeInteger$1(tag.data.subarray(16, 20));
	      } // parse one or more ID3 frames
	      // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	
	
	      do {
	        // determine the number of bytes in this frame
	        frameSize = parseSyncSafeInteger$1(tag.data.subarray(frameStart + 4, frameStart + 8));
	
	        if (frameSize < 1) {
	          this.trigger('log', {
	            level: 'warn',
	            message: 'Malformed ID3 frame encountered. Skipping metadata parsing.'
	          });
	          return;
	        }
	
	        frameHeader = String.fromCharCode(tag.data[frameStart], tag.data[frameStart + 1], tag.data[frameStart + 2], tag.data[frameStart + 3]);
	        frame = {
	          id: frameHeader,
	          data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
	        };
	        frame.key = frame.id;
	
	        if (tagParsers[frame.id]) {
	          tagParsers[frame.id](frame); // handle the special PRIV frame used to indicate the start
	          // time for raw AAC data
	
	          if (frame.owner === 'com.apple.streaming.transportStreamTimestamp') {
	            var d = frame.data,
	                size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
	            size *= 4;
	            size += d[7] & 0x03;
	            frame.timeStamp = size; // in raw AAC, all subsequent data will be timestamped based
	            // on the value of this frame
	            // we couldn't have known the appropriate pts and dts before
	            // parsing this ID3 tag so set those values now
	
	            if (tag.pts === undefined && tag.dts === undefined) {
	              tag.pts = frame.timeStamp;
	              tag.dts = frame.timeStamp;
	            }
	
	            this.trigger('timestamp', frame);
	          }
	        }
	
	        tag.frames.push(frame);
	        frameStart += 10; // advance past the frame header
	
	        frameStart += frameSize; // advance past the frame body
	      } while (frameStart < tagSize);
	
	      this.trigger('data', tag);
	    };
	  };
	
	  _MetadataStream.prototype = new stream();
	  var metadataStream = _MetadataStream;
	  var TimestampRolloverStream = timestampRolloverStream.TimestampRolloverStream; // object types
	
	  var _TransportPacketStream, _TransportParseStream, _ElementaryStream; // constants
	
	
	  var MP2T_PACKET_LENGTH$1 = 188,
	      // bytes
	  SYNC_BYTE$1 = 0x47;
	  /**
	   * Splits an incoming stream of binary data into MPEG-2 Transport
	   * Stream packets.
	   */
	
	  _TransportPacketStream = function TransportPacketStream() {
	    var buffer = new Uint8Array(MP2T_PACKET_LENGTH$1),
	        bytesInBuffer = 0;
	
	    _TransportPacketStream.prototype.init.call(this); // Deliver new bytes to the stream.
	
	    /**
	     * Split a stream of data into M2TS packets
	    **/
	
	
	    this.push = function (bytes) {
	      var startIndex = 0,
	          endIndex = MP2T_PACKET_LENGTH$1,
	          everything; // If there are bytes remaining from the last segment, prepend them to the
	      // bytes that were pushed in
	
	      if (bytesInBuffer) {
	        everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
	        everything.set(buffer.subarray(0, bytesInBuffer));
	        everything.set(bytes, bytesInBuffer);
	        bytesInBuffer = 0;
	      } else {
	        everything = bytes;
	      } // While we have enough data for a packet
	
	
	      while (endIndex < everything.byteLength) {
	        // Look for a pair of start and end sync bytes in the data..
	        if (everything[startIndex] === SYNC_BYTE$1 && everything[endIndex] === SYNC_BYTE$1) {
	          // We found a packet so emit it and jump one whole packet forward in
	          // the stream
	          this.trigger('data', everything.subarray(startIndex, endIndex));
	          startIndex += MP2T_PACKET_LENGTH$1;
	          endIndex += MP2T_PACKET_LENGTH$1;
	          continue;
	        } // If we get here, we have somehow become de-synchronized and we need to step
	        // forward one byte at a time until we find a pair of sync bytes that denote
	        // a packet
	
	
	        startIndex++;
	        endIndex++;
	      } // If there was some data left over at the end of the segment that couldn't
	      // possibly be a whole packet, keep it because it might be the start of a packet
	      // that continues in the next segment
	
	
	      if (startIndex < everything.byteLength) {
	        buffer.set(everything.subarray(startIndex), 0);
	        bytesInBuffer = everything.byteLength - startIndex;
	      }
	    };
	    /**
	     * Passes identified M2TS packets to the TransportParseStream to be parsed
	    **/
	
	
	    this.flush = function () {
	      // If the buffer contains a whole packet when we are being flushed, emit it
	      // and empty the buffer. Otherwise hold onto the data because it may be
	      // important for decoding the next segment
	      if (bytesInBuffer === MP2T_PACKET_LENGTH$1 && buffer[0] === SYNC_BYTE$1) {
	        this.trigger('data', buffer);
	        bytesInBuffer = 0;
	      }
	
	      this.trigger('done');
	    };
	
	    this.endTimeline = function () {
	      this.flush();
	      this.trigger('endedtimeline');
	    };
	
	    this.reset = function () {
	      bytesInBuffer = 0;
	      this.trigger('reset');
	    };
	  };
	
	  _TransportPacketStream.prototype = new stream();
	  /**
	   * Accepts an MP2T TransportPacketStream and emits data events with parsed
	   * forms of the individual transport stream packets.
	   */
	
	  _TransportParseStream = function TransportParseStream() {
	    var parsePsi, parsePat, parsePmt, self;
	
	    _TransportParseStream.prototype.init.call(this);
	
	    self = this;
	    this.packetsWaitingForPmt = [];
	    this.programMapTable = undefined;
	
	    parsePsi = function parsePsi(payload, psi) {
	      var offset = 0; // PSI packets may be split into multiple sections and those
	      // sections may be split into multiple packets. If a PSI
	      // section starts in this packet, the payload_unit_start_indicator
	      // will be true and the first byte of the payload will indicate
	      // the offset from the current position to the start of the
	      // section.
	
	      if (psi.payloadUnitStartIndicator) {
	        offset += payload[offset] + 1;
	      }
	
	      if (psi.type === 'pat') {
	        parsePat(payload.subarray(offset), psi);
	      } else {
	        parsePmt(payload.subarray(offset), psi);
	      }
	    };
	
	    parsePat = function parsePat(payload, pat) {
	      pat.section_number = payload[7]; // eslint-disable-line camelcase
	
	      pat.last_section_number = payload[8]; // eslint-disable-line camelcase
	      // skip the PSI header and parse the first PMT entry
	
	      self.pmtPid = (payload[10] & 0x1F) << 8 | payload[11];
	      pat.pmtPid = self.pmtPid;
	    };
	    /**
	     * Parse out the relevant fields of a Program Map Table (PMT).
	     * @param payload {Uint8Array} the PMT-specific portion of an MP2T
	     * packet. The first byte in this array should be the table_id
	     * field.
	     * @param pmt {object} the object that should be decorated with
	     * fields parsed from the PMT.
	     */
	
	
	    parsePmt = function parsePmt(payload, pmt) {
	      var sectionLength, tableEnd, programInfoLength, offset; // PMTs can be sent ahead of the time when they should actually
	      // take effect. We don't believe this should ever be the case
	      // for HLS but we'll ignore "forward" PMT declarations if we see
	      // them. Future PMT declarations have the current_next_indicator
	      // set to zero.
	
	      if (!(payload[5] & 0x01)) {
	        return;
	      } // overwrite any existing program map table
	
	
	      self.programMapTable = {
	        video: null,
	        audio: null,
	        'timed-metadata': {}
	      }; // the mapping table ends at the end of the current section
	
	      sectionLength = (payload[1] & 0x0f) << 8 | payload[2];
	      tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
	      // long the program info descriptors are
	
	      programInfoLength = (payload[10] & 0x0f) << 8 | payload[11]; // advance the offset to the first entry in the mapping table
	
	      offset = 12 + programInfoLength;
	
	      while (offset < tableEnd) {
	        var streamType = payload[offset];
	        var pid = (payload[offset + 1] & 0x1F) << 8 | payload[offset + 2]; // only map a single elementary_pid for audio and video stream types
	        // TODO: should this be done for metadata too? for now maintain behavior of
	        //       multiple metadata streams
	
	        if (streamType === streamTypes.H264_STREAM_TYPE && self.programMapTable.video === null) {
	          self.programMapTable.video = pid;
	        } else if (streamType === streamTypes.ADTS_STREAM_TYPE && self.programMapTable.audio === null) {
	          self.programMapTable.audio = pid;
	        } else if (streamType === streamTypes.METADATA_STREAM_TYPE) {
	          // map pid to stream type for metadata streams
	          self.programMapTable['timed-metadata'][pid] = streamType;
	        } // move to the next table entry
	        // skip past the elementary stream descriptors, if present
	
	
	        offset += ((payload[offset + 3] & 0x0F) << 8 | payload[offset + 4]) + 5;
	      } // record the map on the packet as well
	
	
	      pmt.programMapTable = self.programMapTable;
	    };
	    /**
	     * Deliver a new MP2T packet to the next stream in the pipeline.
	     */
	
	
	    this.push = function (packet) {
	      var result = {},
	          offset = 4;
	      result.payloadUnitStartIndicator = !!(packet[1] & 0x40); // pid is a 13-bit field starting at the last bit of packet[1]
	
	      result.pid = packet[1] & 0x1f;
	      result.pid <<= 8;
	      result.pid |= packet[2]; // if an adaption field is present, its length is specified by the
	      // fifth byte of the TS packet header. The adaptation field is
	      // used to add stuffing to PES packets that don't fill a complete
	      // TS packet, and to specify some forms of timing and control data
	      // that we do not currently use.
	
	      if ((packet[3] & 0x30) >>> 4 > 0x01) {
	        offset += packet[offset] + 1;
	      } // parse the rest of the packet based on the type
	
	
	      if (result.pid === 0) {
	        result.type = 'pat';
	        parsePsi(packet.subarray(offset), result);
	        this.trigger('data', result);
	      } else if (result.pid === this.pmtPid) {
	        result.type = 'pmt';
	        parsePsi(packet.subarray(offset), result);
	        this.trigger('data', result); // if there are any packets waiting for a PMT to be found, process them now
	
	        while (this.packetsWaitingForPmt.length) {
	          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
	        }
	      } else if (this.programMapTable === undefined) {
	        // When we have not seen a PMT yet, defer further processing of
	        // PES packets until one has been parsed
	        this.packetsWaitingForPmt.push([packet, offset, result]);
	      } else {
	        this.processPes_(packet, offset, result);
	      }
	    };
	
	    this.processPes_ = function (packet, offset, result) {
	      // set the appropriate stream type
	      if (result.pid === this.programMapTable.video) {
	        result.streamType = streamTypes.H264_STREAM_TYPE;
	      } else if (result.pid === this.programMapTable.audio) {
	        result.streamType = streamTypes.ADTS_STREAM_TYPE;
	      } else {
	        // if not video or audio, it is timed-metadata or unknown
	        // if unknown, streamType will be undefined
	        result.streamType = this.programMapTable['timed-metadata'][result.pid];
	      }
	
	      result.type = 'pes';
	      result.data = packet.subarray(offset);
	      this.trigger('data', result);
	    };
	  };
	
	  _TransportParseStream.prototype = new stream();
	  _TransportParseStream.STREAM_TYPES = {
	    h264: 0x1b,
	    adts: 0x0f
	  };
	  /**
	   * Reconsistutes program elementary stream (PES) packets from parsed
	   * transport stream packets. That is, if you pipe an
	   * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
	   * events will be events which capture the bytes for individual PES
	   * packets plus relevant metadata that has been extracted from the
	   * container.
	   */
	
	  _ElementaryStream = function ElementaryStream() {
	    var self = this,
	        segmentHadPmt = false,
	        // PES packet fragments
	    video = {
	      data: [],
	      size: 0
	    },
	        audio = {
	      data: [],
	      size: 0
	    },
	        timedMetadata = {
	      data: [],
	      size: 0
	    },
	        programMapTable,
	        parsePes = function parsePes(payload, pes) {
	      var ptsDtsFlags;
	      var startPrefix = payload[0] << 16 | payload[1] << 8 | payload[2]; // default to an empty array
	
	      pes.data = new Uint8Array(); // In certain live streams, the start of a TS fragment has ts packets
	      // that are frame data that is continuing from the previous fragment. This
	      // is to check that the pes data is the start of a new pes payload
	
	      if (startPrefix !== 1) {
	        return;
	      } // get the packet length, this will be 0 for video
	
	
	      pes.packetLength = 6 + (payload[4] << 8 | payload[5]); // find out if this packets starts a new keyframe
	
	      pes.dataAlignmentIndicator = (payload[6] & 0x04) !== 0; // PES packets may be annotated with a PTS value, or a PTS value
	      // and a DTS value. Determine what combination of values is
	      // available to work with.
	
	      ptsDtsFlags = payload[7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
	      // performs all bitwise operations on 32-bit integers but javascript
	      // supports a much greater range (52-bits) of integer using standard
	      // mathematical operations.
	      // We construct a 31-bit value using bitwise operators over the 31
	      // most significant bits and then multiply by 4 (equal to a left-shift
	      // of 2) before we add the final 2 least significant bits of the
	      // timestamp (equal to an OR.)
	
	      if (ptsDtsFlags & 0xC0) {
	        // the PTS and DTS are not written out directly. For information
	        // on how they are encoded, see
	        // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	        pes.pts = (payload[9] & 0x0E) << 27 | (payload[10] & 0xFF) << 20 | (payload[11] & 0xFE) << 12 | (payload[12] & 0xFF) << 5 | (payload[13] & 0xFE) >>> 3;
	        pes.pts *= 4; // Left shift by 2
	
	        pes.pts += (payload[13] & 0x06) >>> 1; // OR by the two LSBs
	
	        pes.dts = pes.pts;
	
	        if (ptsDtsFlags & 0x40) {
	          pes.dts = (payload[14] & 0x0E) << 27 | (payload[15] & 0xFF) << 20 | (payload[16] & 0xFE) << 12 | (payload[17] & 0xFF) << 5 | (payload[18] & 0xFE) >>> 3;
	          pes.dts *= 4; // Left shift by 2
	
	          pes.dts += (payload[18] & 0x06) >>> 1; // OR by the two LSBs
	        }
	      } // the data section starts immediately after the PES header.
	      // pes_header_data_length specifies the number of header bytes
	      // that follow the last byte of the field.
	
	
	      pes.data = payload.subarray(9 + payload[8]);
	    },
	
	    /**
	      * Pass completely parsed PES packets to the next stream in the pipeline
	     **/
	    flushStream = function flushStream(stream, type, forceFlush) {
	      var packetData = new Uint8Array(stream.size),
	          event = {
	        type: type
	      },
	          i = 0,
	          offset = 0,
	          packetFlushable = false,
	          fragment; // do nothing if there is not enough buffered data for a complete
	      // PES header
	
	      if (!stream.data.length || stream.size < 9) {
	        return;
	      }
	
	      event.trackId = stream.data[0].pid; // reassemble the packet
	
	      for (i = 0; i < stream.data.length; i++) {
	        fragment = stream.data[i];
	        packetData.set(fragment.data, offset);
	        offset += fragment.data.byteLength;
	      } // parse assembled packet's PES header
	
	
	      parsePes(packetData, event); // non-video PES packets MUST have a non-zero PES_packet_length
	      // check that there is enough stream data to fill the packet
	
	      packetFlushable = type === 'video' || event.packetLength <= stream.size; // flush pending packets if the conditions are right
	
	      if (forceFlush || packetFlushable) {
	        stream.size = 0;
	        stream.data.length = 0;
	      } // only emit packets that are complete. this is to avoid assembling
	      // incomplete PES packets due to poor segmentation
	
	
	      if (packetFlushable) {
	        self.trigger('data', event);
	      }
	    };
	
	    _ElementaryStream.prototype.init.call(this);
	    /**
	     * Identifies M2TS packet types and parses PES packets using metadata
	     * parsed from the PMT
	     **/
	
	
	    this.push = function (data) {
	      ({
	        pat: function pat() {// we have to wait for the PMT to arrive as well before we
	          // have any meaningful metadata
	        },
	        pes: function pes() {
	          var stream, streamType;
	
	          switch (data.streamType) {
	            case streamTypes.H264_STREAM_TYPE:
	              stream = video;
	              streamType = 'video';
	              break;
	
	            case streamTypes.ADTS_STREAM_TYPE:
	              stream = audio;
	              streamType = 'audio';
	              break;
	
	            case streamTypes.METADATA_STREAM_TYPE:
	              stream = timedMetadata;
	              streamType = 'timed-metadata';
	              break;
	
	            default:
	              // ignore unknown stream types
	              return;
	          } // if a new packet is starting, we can flush the completed
	          // packet
	
	
	          if (data.payloadUnitStartIndicator) {
	            flushStream(stream, streamType, true);
	          } // buffer this fragment until we are sure we've received the
	          // complete payload
	
	
	          stream.data.push(data);
	          stream.size += data.data.byteLength;
	        },
	        pmt: function pmt() {
	          var event = {
	            type: 'metadata',
	            tracks: []
	          };
	          programMapTable = data.programMapTable; // translate audio and video streams to tracks
	
	          if (programMapTable.video !== null) {
	            event.tracks.push({
	              timelineStartInfo: {
	                baseMediaDecodeTime: 0
	              },
	              id: +programMapTable.video,
	              codec: 'avc',
	              type: 'video'
	            });
	          }
	
	          if (programMapTable.audio !== null) {
	            event.tracks.push({
	              timelineStartInfo: {
	                baseMediaDecodeTime: 0
	              },
	              id: +programMapTable.audio,
	              codec: 'adts',
	              type: 'audio'
	            });
	          }
	
	          segmentHadPmt = true;
	          self.trigger('data', event);
	        }
	      })[data.type]();
	    };
	
	    this.reset = function () {
	      video.size = 0;
	      video.data.length = 0;
	      audio.size = 0;
	      audio.data.length = 0;
	      this.trigger('reset');
	    };
	    /**
	     * Flush any remaining input. Video PES packets may be of variable
	     * length. Normally, the start of a new video packet can trigger the
	     * finalization of the previous packet. That is not possible if no
	     * more video is forthcoming, however. In that case, some other
	     * mechanism (like the end of the file) has to be employed. When it is
	     * clear that no additional data is forthcoming, calling this method
	     * will flush the buffered packets.
	     */
	
	
	    this.flushStreams_ = function () {
	      // !!THIS ORDER IS IMPORTANT!!
	      // video first then audio
	      flushStream(video, 'video');
	      flushStream(audio, 'audio');
	      flushStream(timedMetadata, 'timed-metadata');
	    };
	
	    this.flush = function () {
	      // if on flush we haven't had a pmt emitted
	      // and we have a pmt to emit. emit the pmt
	      // so that we trigger a trackinfo downstream.
	      if (!segmentHadPmt && programMapTable) {
	        var pmt = {
	          type: 'metadata',
	          tracks: []
	        }; // translate audio and video streams to tracks
	
	        if (programMapTable.video !== null) {
	          pmt.tracks.push({
	            timelineStartInfo: {
	              baseMediaDecodeTime: 0
	            },
	            id: +programMapTable.video,
	            codec: 'avc',
	            type: 'video'
	          });
	        }
	
	        if (programMapTable.audio !== null) {
	          pmt.tracks.push({
	            timelineStartInfo: {
	              baseMediaDecodeTime: 0
	            },
	            id: +programMapTable.audio,
	            codec: 'adts',
	            type: 'audio'
	          });
	        }
	
	        self.trigger('data', pmt);
	      }
	
	      segmentHadPmt = false;
	      this.flushStreams_();
	      this.trigger('done');
	    };
	  };
	
	  _ElementaryStream.prototype = new stream();
	  var m2ts = {
	    PAT_PID: 0x0000,
	    MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH$1,
	    TransportPacketStream: _TransportPacketStream,
	    TransportParseStream: _TransportParseStream,
	    ElementaryStream: _ElementaryStream,
	    TimestampRolloverStream: TimestampRolloverStream,
	    CaptionStream: captionStream.CaptionStream,
	    Cea608Stream: captionStream.Cea608Stream,
	    Cea708Stream: captionStream.Cea708Stream,
	    MetadataStream: metadataStream
	  };
	
	  for (var type in streamTypes) {
	    if (streamTypes.hasOwnProperty(type)) {
	      m2ts[type] = streamTypes[type];
	    }
	  }
	
	  var m2ts_1 = m2ts;
	  var ONE_SECOND_IN_TS$2 = clock.ONE_SECOND_IN_TS;
	
	  var _AdtsStream;
	
	  var ADTS_SAMPLING_FREQUENCIES$1 = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	  /*
	   * Accepts a ElementaryStream and emits data events with parsed
	   * AAC Audio Frames of the individual packets. Input audio in ADTS
	   * format is unpacked and re-emitted as AAC frames.
	   *
	   * @see http://wiki.multimedia.cx/index.php?title=ADTS
	   * @see http://wiki.multimedia.cx/?title=Understanding_AAC
	   */
	
	  _AdtsStream = function AdtsStream(handlePartialSegments) {
	    var buffer,
	        frameNum = 0;
	
	    _AdtsStream.prototype.init.call(this);
	
	    this.skipWarn_ = function (start, end) {
	      this.trigger('log', {
	        level: 'warn',
	        message: "adts skiping bytes " + start + " to " + end + " in frame " + frameNum + " outside syncword"
	      });
	    };
	
	    this.push = function (packet) {
	      var i = 0,
	          frameLength,
	          protectionSkipBytes,
	          oldBuffer,
	          sampleCount,
	          adtsFrameDuration;
	
	      if (!handlePartialSegments) {
	        frameNum = 0;
	      }
	
	      if (packet.type !== 'audio') {
	        // ignore non-audio data
	        return;
	      } // Prepend any data in the buffer to the input data so that we can parse
	      // aac frames the cross a PES packet boundary
	
	
	      if (buffer && buffer.length) {
	        oldBuffer = buffer;
	        buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
	        buffer.set(oldBuffer);
	        buffer.set(packet.data, oldBuffer.byteLength);
	      } else {
	        buffer = packet.data;
	      } // unpack any ADTS frames which have been fully received
	      // for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
	
	
	      var skip; // We use i + 7 here because we want to be able to parse the entire header.
	      // If we don't have enough bytes to do that, then we definitely won't have a full frame.
	
	      while (i + 7 < buffer.length) {
	        // Look for the start of an ADTS header..
	        if (buffer[i] !== 0xFF || (buffer[i + 1] & 0xF6) !== 0xF0) {
	          if (typeof skip !== 'number') {
	            skip = i;
	          } // If a valid header was not found,  jump one forward and attempt to
	          // find a valid ADTS header starting at the next byte
	
	
	          i++;
	          continue;
	        }
	
	        if (typeof skip === 'number') {
	          this.skipWarn_(skip, i);
	          skip = null;
	        } // The protection skip bit tells us if we have 2 bytes of CRC data at the
	        // end of the ADTS header
	
	
	        protectionSkipBytes = (~buffer[i + 1] & 0x01) * 2; // Frame length is a 13 bit integer starting 16 bits from the
	        // end of the sync sequence
	        // NOTE: frame length includes the size of the header
	
	        frameLength = (buffer[i + 3] & 0x03) << 11 | buffer[i + 4] << 3 | (buffer[i + 5] & 0xe0) >> 5;
	        sampleCount = ((buffer[i + 6] & 0x03) + 1) * 1024;
	        adtsFrameDuration = sampleCount * ONE_SECOND_IN_TS$2 / ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2]; // If we don't have enough data to actually finish this ADTS frame,
	        // then we have to wait for more data
	
	        if (buffer.byteLength - i < frameLength) {
	          break;
	        } // Otherwise, deliver the complete AAC frame
	
	
	        this.trigger('data', {
	          pts: packet.pts + frameNum * adtsFrameDuration,
	          dts: packet.dts + frameNum * adtsFrameDuration,
	          sampleCount: sampleCount,
	          audioobjecttype: (buffer[i + 2] >>> 6 & 0x03) + 1,
	          channelcount: (buffer[i + 2] & 1) << 2 | (buffer[i + 3] & 0xc0) >>> 6,
	          samplerate: ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 0x3c) >>> 2],
	          samplingfrequencyindex: (buffer[i + 2] & 0x3c) >>> 2,
	          // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
	          samplesize: 16,
	          // data is the frame without it's header
	          data: buffer.subarray(i + 7 + protectionSkipBytes, i + frameLength)
	        });
	        frameNum++;
	        i += frameLength;
	      }
	
	      if (typeof skip === 'number') {
	        this.skipWarn_(skip, i);
	        skip = null;
	      } // remove processed bytes from the buffer.
	
	
	      buffer = buffer.subarray(i);
	    };
	
	    this.flush = function () {
	      frameNum = 0;
	      this.trigger('done');
	    };
	
	    this.reset = function () {
	      buffer = void 0;
	      this.trigger('reset');
	    };
	
	    this.endTimeline = function () {
	      buffer = void 0;
	      this.trigger('endedtimeline');
	    };
	  };
	
	  _AdtsStream.prototype = new stream();
	  var adts = _AdtsStream;
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var ExpGolomb;
	  /**
	   * Parser for exponential Golomb codes, a variable-bitwidth number encoding
	   * scheme used by h264.
	   */
	
	  ExpGolomb = function ExpGolomb(workingData) {
	    var // the number of bytes left to examine in workingData
	    workingBytesAvailable = workingData.byteLength,
	        // the current word being examined
	    workingWord = 0,
	        // :uint
	    // the number of bits left to examine in the current word
	    workingBitsAvailable = 0; // :uint;
	    // ():uint
	
	    this.length = function () {
	      return 8 * workingBytesAvailable;
	    }; // ():uint
	
	
	    this.bitsAvailable = function () {
	      return 8 * workingBytesAvailable + workingBitsAvailable;
	    }; // ():void
	
	
	    this.loadWord = function () {
	      var position = workingData.byteLength - workingBytesAvailable,
	          workingBytes = new Uint8Array(4),
	          availableBytes = Math.min(4, workingBytesAvailable);
	
	      if (availableBytes === 0) {
	        throw new Error('no bytes available');
	      }
	
	      workingBytes.set(workingData.subarray(position, position + availableBytes));
	      workingWord = new DataView(workingBytes.buffer).getUint32(0); // track the amount of workingData that has been processed
	
	      workingBitsAvailable = availableBytes * 8;
	      workingBytesAvailable -= availableBytes;
	    }; // (count:int):void
	
	
	    this.skipBits = function (count) {
	      var skipBytes; // :int
	
	      if (workingBitsAvailable > count) {
	        workingWord <<= count;
	        workingBitsAvailable -= count;
	      } else {
	        count -= workingBitsAvailable;
	        skipBytes = Math.floor(count / 8);
	        count -= skipBytes * 8;
	        workingBytesAvailable -= skipBytes;
	        this.loadWord();
	        workingWord <<= count;
	        workingBitsAvailable -= count;
	      }
	    }; // (size:int):uint
	
	
	    this.readBits = function (size) {
	      var bits = Math.min(workingBitsAvailable, size),
	          // :uint
	      valu = workingWord >>> 32 - bits; // :uint
	      // if size > 31, handle error
	
	      workingBitsAvailable -= bits;
	
	      if (workingBitsAvailable > 0) {
	        workingWord <<= bits;
	      } else if (workingBytesAvailable > 0) {
	        this.loadWord();
	      }
	
	      bits = size - bits;
	
	      if (bits > 0) {
	        return valu << bits | this.readBits(bits);
	      }
	
	      return valu;
	    }; // ():uint
	
	
	    this.skipLeadingZeros = function () {
	      var leadingZeroCount; // :uint
	
	      for (leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount) {
	        if ((workingWord & 0x80000000 >>> leadingZeroCount) !== 0) {
	          // the first bit of working word is 1
	          workingWord <<= leadingZeroCount;
	          workingBitsAvailable -= leadingZeroCount;
	          return leadingZeroCount;
	        }
	      } // we exhausted workingWord and still have not found a 1
	
	
	      this.loadWord();
	      return leadingZeroCount + this.skipLeadingZeros();
	    }; // ():void
	
	
	    this.skipUnsignedExpGolomb = function () {
	      this.skipBits(1 + this.skipLeadingZeros());
	    }; // ():void
	
	
	    this.skipExpGolomb = function () {
	      this.skipBits(1 + this.skipLeadingZeros());
	    }; // ():uint
	
	
	    this.readUnsignedExpGolomb = function () {
	      var clz = this.skipLeadingZeros(); // :uint
	
	      return this.readBits(clz + 1) - 1;
	    }; // ():int
	
	
	    this.readExpGolomb = function () {
	      var valu = this.readUnsignedExpGolomb(); // :int
	
	      if (0x01 & valu) {
	        // the number is odd if the low order bit is set
	        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
	      }
	
	      return -1 * (valu >>> 1); // divide by two then make it negative
	    }; // Some convenience functions
	    // :Boolean
	
	
	    this.readBoolean = function () {
	      return this.readBits(1) === 1;
	    }; // ():int
	
	
	    this.readUnsignedByte = function () {
	      return this.readBits(8);
	    };
	
	    this.loadWord();
	  };
	
	  var expGolomb = ExpGolomb;
	
	  var _H264Stream, _NalByteStream;
	
	  var PROFILES_WITH_OPTIONAL_SPS_DATA;
	  /**
	   * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
	   */
	
	  _NalByteStream = function NalByteStream() {
	    var syncPoint = 0,
	        i,
	        buffer;
	
	    _NalByteStream.prototype.init.call(this);
	    /*
	     * Scans a byte stream and triggers a data event with the NAL units found.
	     * @param {Object} data Event received from H264Stream
	     * @param {Uint8Array} data.data The h264 byte stream to be scanned
	     *
	     * @see H264Stream.push
	     */
	
	
	    this.push = function (data) {
	      var swapBuffer;
	
	      if (!buffer) {
	        buffer = data.data;
	      } else {
	        swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
	        swapBuffer.set(buffer);
	        swapBuffer.set(data.data, buffer.byteLength);
	        buffer = swapBuffer;
	      }
	
	      var len = buffer.byteLength; // Rec. ITU-T H.264, Annex B
	      // scan for NAL unit boundaries
	      // a match looks like this:
	      // 0 0 1 .. NAL .. 0 0 1
	      // ^ sync point        ^ i
	      // or this:
	      // 0 0 1 .. NAL .. 0 0 0
	      // ^ sync point        ^ i
	      // advance the sync point to a NAL start, if necessary
	
	      for (; syncPoint < len - 3; syncPoint++) {
	        if (buffer[syncPoint + 2] === 1) {
	          // the sync point is properly aligned
	          i = syncPoint + 5;
	          break;
	        }
	      }
	
	      while (i < len) {
	        // look at the current byte to determine if we've hit the end of
	        // a NAL unit boundary
	        switch (buffer[i]) {
	          case 0:
	            // skip past non-sync sequences
	            if (buffer[i - 1] !== 0) {
	              i += 2;
	              break;
	            } else if (buffer[i - 2] !== 0) {
	              i++;
	              break;
	            } // deliver the NAL unit if it isn't empty
	
	
	            if (syncPoint + 3 !== i - 2) {
	              this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	            } // drop trailing zeroes
	
	
	            do {
	              i++;
	            } while (buffer[i] !== 1 && i < len);
	
	            syncPoint = i - 2;
	            i += 3;
	            break;
	
	          case 1:
	            // skip past non-sync sequences
	            if (buffer[i - 1] !== 0 || buffer[i - 2] !== 0) {
	              i += 3;
	              break;
	            } // deliver the NAL unit
	
	
	            this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	            syncPoint = i - 2;
	            i += 3;
	            break;
	
	          default:
	            // the current byte isn't a one or zero, so it cannot be part
	            // of a sync sequence
	            i += 3;
	            break;
	        }
	      } // filter out the NAL units that were delivered
	
	
	      buffer = buffer.subarray(syncPoint);
	      i -= syncPoint;
	      syncPoint = 0;
	    };
	
	    this.reset = function () {
	      buffer = null;
	      syncPoint = 0;
	      this.trigger('reset');
	    };
	
	    this.flush = function () {
	      // deliver the last buffered NAL unit
	      if (buffer && buffer.byteLength > 3) {
	        this.trigger('data', buffer.subarray(syncPoint + 3));
	      } // reset the stream state
	
	
	      buffer = null;
	      syncPoint = 0;
	      this.trigger('done');
	    };
	
	    this.endTimeline = function () {
	      this.flush();
	      this.trigger('endedtimeline');
	    };
	  };
	
	  _NalByteStream.prototype = new stream(); // values of profile_idc that indicate additional fields are included in the SPS
	  // see Recommendation ITU-T H.264 (4/2013),
	  // 7.3.2.1.1 Sequence parameter set data syntax
	
	  PROFILES_WITH_OPTIONAL_SPS_DATA = {
	    100: true,
	    110: true,
	    122: true,
	    244: true,
	    44: true,
	    83: true,
	    86: true,
	    118: true,
	    128: true,
	    // TODO: the three profiles below don't
	    // appear to have sps data in the specificiation anymore?
	    138: true,
	    139: true,
	    134: true
	  };
	  /**
	   * Accepts input from a ElementaryStream and produces H.264 NAL unit data
	   * events.
	   */
	
	  _H264Stream = function H264Stream() {
	    var nalByteStream = new _NalByteStream(),
	        self,
	        trackId,
	        currentPts,
	        currentDts,
	        discardEmulationPreventionBytes,
	        readSequenceParameterSet,
	        skipScalingList;
	
	    _H264Stream.prototype.init.call(this);
	
	    self = this;
	    /*
	     * Pushes a packet from a stream onto the NalByteStream
	     *
	     * @param {Object} packet - A packet received from a stream
	     * @param {Uint8Array} packet.data - The raw bytes of the packet
	     * @param {Number} packet.dts - Decode timestamp of the packet
	     * @param {Number} packet.pts - Presentation timestamp of the packet
	     * @param {Number} packet.trackId - The id of the h264 track this packet came from
	     * @param {('video'|'audio')} packet.type - The type of packet
	     *
	     */
	
	    this.push = function (packet) {
	      if (packet.type !== 'video') {
	        return;
	      }
	
	      trackId = packet.trackId;
	      currentPts = packet.pts;
	      currentDts = packet.dts;
	      nalByteStream.push(packet);
	    };
	    /*
	     * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
	     * for the NALUs to the next stream component.
	     * Also, preprocess caption and sequence parameter NALUs.
	     *
	     * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
	     * @see NalByteStream.push
	     */
	
	
	    nalByteStream.on('data', function (data) {
	      var event = {
	        trackId: trackId,
	        pts: currentPts,
	        dts: currentDts,
	        data: data,
	        nalUnitTypeCode: data[0] & 0x1f
	      };
	
	      switch (event.nalUnitTypeCode) {
	        case 0x05:
	          event.nalUnitType = 'slice_layer_without_partitioning_rbsp_idr';
	          break;
	
	        case 0x06:
	          event.nalUnitType = 'sei_rbsp';
	          event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	          break;
	
	        case 0x07:
	          event.nalUnitType = 'seq_parameter_set_rbsp';
	          event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	          event.config = readSequenceParameterSet(event.escapedRBSP);
	          break;
	
	        case 0x08:
	          event.nalUnitType = 'pic_parameter_set_rbsp';
	          break;
	
	        case 0x09:
	          event.nalUnitType = 'access_unit_delimiter_rbsp';
	          break;
	      } // This triggers data on the H264Stream
	
	
	      self.trigger('data', event);
	    });
	    nalByteStream.on('done', function () {
	      self.trigger('done');
	    });
	    nalByteStream.on('partialdone', function () {
	      self.trigger('partialdone');
	    });
	    nalByteStream.on('reset', function () {
	      self.trigger('reset');
	    });
	    nalByteStream.on('endedtimeline', function () {
	      self.trigger('endedtimeline');
	    });
	
	    this.flush = function () {
	      nalByteStream.flush();
	    };
	
	    this.partialFlush = function () {
	      nalByteStream.partialFlush();
	    };
	
	    this.reset = function () {
	      nalByteStream.reset();
	    };
	
	    this.endTimeline = function () {
	      nalByteStream.endTimeline();
	    };
	    /**
	     * Advance the ExpGolomb decoder past a scaling list. The scaling
	     * list is optionally transmitted as part of a sequence parameter
	     * set and is not relevant to transmuxing.
	     * @param count {number} the number of entries in this scaling list
	     * @param expGolombDecoder {object} an ExpGolomb pointed to the
	     * start of a scaling list
	     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
	     */
	
	
	    skipScalingList = function skipScalingList(count, expGolombDecoder) {
	      var lastScale = 8,
	          nextScale = 8,
	          j,
	          deltaScale;
	
	      for (j = 0; j < count; j++) {
	        if (nextScale !== 0) {
	          deltaScale = expGolombDecoder.readExpGolomb();
	          nextScale = (lastScale + deltaScale + 256) % 256;
	        }
	
	        lastScale = nextScale === 0 ? lastScale : nextScale;
	      }
	    };
	    /**
	     * Expunge any "Emulation Prevention" bytes from a "Raw Byte
	     * Sequence Payload"
	     * @param data {Uint8Array} the bytes of a RBSP from a NAL
	     * unit
	     * @return {Uint8Array} the RBSP without any Emulation
	     * Prevention Bytes
	     */
	
	
	    discardEmulationPreventionBytes = function discardEmulationPreventionBytes(data) {
	      var length = data.byteLength,
	          emulationPreventionBytesPositions = [],
	          i = 1,
	          newLength,
	          newData; // Find all `Emulation Prevention Bytes`
	
	      while (i < length - 2) {
	        if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	          emulationPreventionBytesPositions.push(i + 2);
	          i += 2;
	        } else {
	          i++;
	        }
	      } // If no Emulation Prevention Bytes were found just return the original
	      // array
	
	
	      if (emulationPreventionBytesPositions.length === 0) {
	        return data;
	      } // Create a new array to hold the NAL unit data
	
	
	      newLength = length - emulationPreventionBytesPositions.length;
	      newData = new Uint8Array(newLength);
	      var sourceIndex = 0;
	
	      for (i = 0; i < newLength; sourceIndex++, i++) {
	        if (sourceIndex === emulationPreventionBytesPositions[0]) {
	          // Skip this byte
	          sourceIndex++; // Remove this position index
	
	          emulationPreventionBytesPositions.shift();
	        }
	
	        newData[i] = data[sourceIndex];
	      }
	
	      return newData;
	    };
	    /**
	     * Read a sequence parameter set and return some interesting video
	     * properties. A sequence parameter set is the H264 metadata that
	     * describes the properties of upcoming video frames.
	     * @param data {Uint8Array} the bytes of a sequence parameter set
	     * @return {object} an object with configuration parsed from the
	     * sequence parameter set, including the dimensions of the
	     * associated video frames.
	     */
	
	
	    readSequenceParameterSet = function readSequenceParameterSet(data) {
	      var frameCropLeftOffset = 0,
	          frameCropRightOffset = 0,
	          frameCropTopOffset = 0,
	          frameCropBottomOffset = 0,
	          expGolombDecoder,
	          profileIdc,
	          levelIdc,
	          profileCompatibility,
	          chromaFormatIdc,
	          picOrderCntType,
	          numRefFramesInPicOrderCntCycle,
	          picWidthInMbsMinus1,
	          picHeightInMapUnitsMinus1,
	          frameMbsOnlyFlag,
	          scalingListCount,
	          sarRatio = [1, 1],
	          aspectRatioIdc,
	          i;
	      expGolombDecoder = new expGolomb(data);
	      profileIdc = expGolombDecoder.readUnsignedByte(); // profile_idc
	
	      profileCompatibility = expGolombDecoder.readUnsignedByte(); // constraint_set[0-5]_flag
	
	      levelIdc = expGolombDecoder.readUnsignedByte(); // level_idc u(8)
	
	      expGolombDecoder.skipUnsignedExpGolomb(); // seq_parameter_set_id
	      // some profiles have more optional data we don't need
	
	      if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
	        chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
	
	        if (chromaFormatIdc === 3) {
	          expGolombDecoder.skipBits(1); // separate_colour_plane_flag
	        }
	
	        expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_luma_minus8
	
	        expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_chroma_minus8
	
	        expGolombDecoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag
	
	        if (expGolombDecoder.readBoolean()) {
	          // seq_scaling_matrix_present_flag
	          scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
	
	          for (i = 0; i < scalingListCount; i++) {
	            if (expGolombDecoder.readBoolean()) {
	              // seq_scaling_list_present_flag[ i ]
	              if (i < 6) {
	                skipScalingList(16, expGolombDecoder);
	              } else {
	                skipScalingList(64, expGolombDecoder);
	              }
	            }
	          }
	        }
	      }
	
	      expGolombDecoder.skipUnsignedExpGolomb(); // log2_max_frame_num_minus4
	
	      picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
	
	      if (picOrderCntType === 0) {
	        expGolombDecoder.readUnsignedExpGolomb(); // log2_max_pic_order_cnt_lsb_minus4
	      } else if (picOrderCntType === 1) {
	        expGolombDecoder.skipBits(1); // delta_pic_order_always_zero_flag
	
	        expGolombDecoder.skipExpGolomb(); // offset_for_non_ref_pic
	
	        expGolombDecoder.skipExpGolomb(); // offset_for_top_to_bottom_field
	
	        numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
	
	        for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
	          expGolombDecoder.skipExpGolomb(); // offset_for_ref_frame[ i ]
	        }
	      }
	
	      expGolombDecoder.skipUnsignedExpGolomb(); // max_num_ref_frames
	
	      expGolombDecoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag
	
	      picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	      picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	      frameMbsOnlyFlag = expGolombDecoder.readBits(1);
	
	      if (frameMbsOnlyFlag === 0) {
	        expGolombDecoder.skipBits(1); // mb_adaptive_frame_field_flag
	      }
	
	      expGolombDecoder.skipBits(1); // direct_8x8_inference_flag
	
	      if (expGolombDecoder.readBoolean()) {
	        // frame_cropping_flag
	        frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
	        frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
	        frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
	        frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
	      }
	
	      if (expGolombDecoder.readBoolean()) {
	        // vui_parameters_present_flag
	        if (expGolombDecoder.readBoolean()) {
	          // aspect_ratio_info_present_flag
	          aspectRatioIdc = expGolombDecoder.readUnsignedByte();
	
	          switch (aspectRatioIdc) {
	            case 1:
	              sarRatio = [1, 1];
	              break;
	
	            case 2:
	              sarRatio = [12, 11];
	              break;
	
	            case 3:
	              sarRatio = [10, 11];
	              break;
	
	            case 4:
	              sarRatio = [16, 11];
	              break;
	
	            case 5:
	              sarRatio = [40, 33];
	              break;
	
	            case 6:
	              sarRatio = [24, 11];
	              break;
	
	            case 7:
	              sarRatio = [20, 11];
	              break;
	
	            case 8:
	              sarRatio = [32, 11];
	              break;
	
	            case 9:
	              sarRatio = [80, 33];
	              break;
	
	            case 10:
	              sarRatio = [18, 11];
	              break;
	
	            case 11:
	              sarRatio = [15, 11];
	              break;
	
	            case 12:
	              sarRatio = [64, 33];
	              break;
	
	            case 13:
	              sarRatio = [160, 99];
	              break;
	
	            case 14:
	              sarRatio = [4, 3];
	              break;
	
	            case 15:
	              sarRatio = [3, 2];
	              break;
	
	            case 16:
	              sarRatio = [2, 1];
	              break;
	
	            case 255:
	              {
	                sarRatio = [expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte(), expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte()];
	                break;
	              }
	          }
	
	          if (sarRatio) {
	            sarRatio[0] / sarRatio[1];
	          }
	        }
	      }
	
	      return {
	        profileIdc: profileIdc,
	        levelIdc: levelIdc,
	        profileCompatibility: profileCompatibility,
	        width: (picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2,
	        height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - frameCropTopOffset * 2 - frameCropBottomOffset * 2,
	        // sar is sample aspect ratio
	        sarRatio: sarRatio
	      };
	    };
	  };
	
	  _H264Stream.prototype = new stream();
	  var h264 = {
	    H264Stream: _H264Stream,
	    NalByteStream: _NalByteStream
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   *
	   * Utilities to detect basic properties and metadata about Aac data.
	   */
	
	  var ADTS_SAMPLING_FREQUENCIES = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	
	  var parseId3TagSize = function parseId3TagSize(header, byteIndex) {
	    var returnSize = header[byteIndex + 6] << 21 | header[byteIndex + 7] << 14 | header[byteIndex + 8] << 7 | header[byteIndex + 9],
	        flags = header[byteIndex + 5],
	        footerPresent = (flags & 16) >> 4; // if we get a negative returnSize clamp it to 0
	
	    returnSize = returnSize >= 0 ? returnSize : 0;
	
	    if (footerPresent) {
	      return returnSize + 20;
	    }
	
	    return returnSize + 10;
	  };
	
	  var getId3Offset = function getId3Offset(data, offset) {
	    if (data.length - offset < 10 || data[offset] !== 'I'.charCodeAt(0) || data[offset + 1] !== 'D'.charCodeAt(0) || data[offset + 2] !== '3'.charCodeAt(0)) {
	      return offset;
	    }
	
	    offset += parseId3TagSize(data, offset);
	    return getId3Offset(data, offset);
	  }; // TODO: use vhs-utils
	
	
	  var isLikelyAacData$1 = function isLikelyAacData(data) {
	    var offset = getId3Offset(data, 0);
	    return data.length >= offset + 2 && (data[offset] & 0xFF) === 0xFF && (data[offset + 1] & 0xF0) === 0xF0 && // verify that the 2 layer bits are 0, aka this
	    // is not mp3 data but aac data.
	    (data[offset + 1] & 0x16) === 0x10;
	  };
	
	  var parseSyncSafeInteger = function parseSyncSafeInteger(data) {
	    return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
	  }; // return a percent-encoded representation of the specified byte range
	  // @see http://en.wikipedia.org/wiki/Percent-encoding
	
	
	  var percentEncode = function percentEncode(bytes, start, end) {
	    var i,
	        result = '';
	
	    for (i = start; i < end; i++) {
	      result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	    }
	
	    return result;
	  }; // return the string representation of the specified byte range,
	  // interpreted as ISO-8859-1.
	
	
	  var parseIso88591 = function parseIso88591(bytes, start, end) {
	    return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
	  };
	
	  var parseAdtsSize = function parseAdtsSize(header, byteIndex) {
	    var lowThree = (header[byteIndex + 5] & 0xE0) >> 5,
	        middle = header[byteIndex + 4] << 3,
	        highTwo = header[byteIndex + 3] & 0x3 << 11;
	    return highTwo | middle | lowThree;
	  };
	
	  var parseType$2 = function parseType(header, byteIndex) {
	    if (header[byteIndex] === 'I'.charCodeAt(0) && header[byteIndex + 1] === 'D'.charCodeAt(0) && header[byteIndex + 2] === '3'.charCodeAt(0)) {
	      return 'timed-metadata';
	    } else if (header[byteIndex] & 0xff === 0xff && (header[byteIndex + 1] & 0xf0) === 0xf0) {
	      return 'audio';
	    }
	
	    return null;
	  };
	
	  var parseSampleRate = function parseSampleRate(packet) {
	    var i = 0;
	
	    while (i + 5 < packet.length) {
	      if (packet[i] !== 0xFF || (packet[i + 1] & 0xF6) !== 0xF0) {
	        // If a valid header was not found,  jump one forward and attempt to
	        // find a valid ADTS header starting at the next byte
	        i++;
	        continue;
	      }
	
	      return ADTS_SAMPLING_FREQUENCIES[(packet[i + 2] & 0x3c) >>> 2];
	    }
	
	    return null;
	  };
	
	  var parseAacTimestamp = function parseAacTimestamp(packet) {
	    var frameStart, frameSize, frame, frameHeader; // find the start of the first frame and the end of the tag
	
	    frameStart = 10;
	
	    if (packet[5] & 0x40) {
	      // advance the frame start past the extended header
	      frameStart += 4; // header size field
	
	      frameStart += parseSyncSafeInteger(packet.subarray(10, 14));
	    } // parse one or more ID3 frames
	    // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	
	
	    do {
	      // determine the number of bytes in this frame
	      frameSize = parseSyncSafeInteger(packet.subarray(frameStart + 4, frameStart + 8));
	
	      if (frameSize < 1) {
	        return null;
	      }
	
	      frameHeader = String.fromCharCode(packet[frameStart], packet[frameStart + 1], packet[frameStart + 2], packet[frameStart + 3]);
	
	      if (frameHeader === 'PRIV') {
	        frame = packet.subarray(frameStart + 10, frameStart + frameSize + 10);
	
	        for (var i = 0; i < frame.byteLength; i++) {
	          if (frame[i] === 0) {
	            var owner = parseIso88591(frame, 0, i);
	
	            if (owner === 'com.apple.streaming.transportStreamTimestamp') {
	              var d = frame.subarray(i + 1);
	              var size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
	              size *= 4;
	              size += d[7] & 0x03;
	              return size;
	            }
	
	            break;
	          }
	        }
	      }
	
	      frameStart += 10; // advance past the frame header
	
	      frameStart += frameSize; // advance past the frame body
	    } while (frameStart < packet.byteLength);
	
	    return null;
	  };
	
	  var utils = {
	    isLikelyAacData: isLikelyAacData$1,
	    parseId3TagSize: parseId3TagSize,
	    parseAdtsSize: parseAdtsSize,
	    parseType: parseType$2,
	    parseSampleRate: parseSampleRate,
	    parseAacTimestamp: parseAacTimestamp
	  };
	
	  var _AacStream;
	  /**
	   * Splits an incoming stream of binary data into ADTS and ID3 Frames.
	   */
	
	
	  _AacStream = function AacStream() {
	    var everything = new Uint8Array(),
	        timeStamp = 0;
	
	    _AacStream.prototype.init.call(this);
	
	    this.setTimestamp = function (timestamp) {
	      timeStamp = timestamp;
	    };
	
	    this.push = function (bytes) {
	      var frameSize = 0,
	          byteIndex = 0,
	          bytesLeft,
	          chunk,
	          packet,
	          tempLength; // If there are bytes remaining from the last segment, prepend them to the
	      // bytes that were pushed in
	
	      if (everything.length) {
	        tempLength = everything.length;
	        everything = new Uint8Array(bytes.byteLength + tempLength);
	        everything.set(everything.subarray(0, tempLength));
	        everything.set(bytes, tempLength);
	      } else {
	        everything = bytes;
	      }
	
	      while (everything.length - byteIndex >= 3) {
	        if (everything[byteIndex] === 'I'.charCodeAt(0) && everything[byteIndex + 1] === 'D'.charCodeAt(0) && everything[byteIndex + 2] === '3'.charCodeAt(0)) {
	          // Exit early because we don't have enough to parse
	          // the ID3 tag header
	          if (everything.length - byteIndex < 10) {
	            break;
	          } // check framesize
	
	
	          frameSize = utils.parseId3TagSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	          // Add to byteIndex to support multiple ID3 tags in sequence
	
	          if (byteIndex + frameSize > everything.length) {
	            break;
	          }
	
	          chunk = {
	            type: 'timed-metadata',
	            data: everything.subarray(byteIndex, byteIndex + frameSize)
	          };
	          this.trigger('data', chunk);
	          byteIndex += frameSize;
	          continue;
	        } else if ((everything[byteIndex] & 0xff) === 0xff && (everything[byteIndex + 1] & 0xf0) === 0xf0) {
	          // Exit early because we don't have enough to parse
	          // the ADTS frame header
	          if (everything.length - byteIndex < 7) {
	            break;
	          }
	
	          frameSize = utils.parseAdtsSize(everything, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	
	          if (byteIndex + frameSize > everything.length) {
	            break;
	          }
	
	          packet = {
	            type: 'audio',
	            data: everything.subarray(byteIndex, byteIndex + frameSize),
	            pts: timeStamp,
	            dts: timeStamp
	          };
	          this.trigger('data', packet);
	          byteIndex += frameSize;
	          continue;
	        }
	
	        byteIndex++;
	      }
	
	      bytesLeft = everything.length - byteIndex;
	
	      if (bytesLeft > 0) {
	        everything = everything.subarray(byteIndex);
	      } else {
	        everything = new Uint8Array();
	      }
	    };
	
	    this.reset = function () {
	      everything = new Uint8Array();
	      this.trigger('reset');
	    };
	
	    this.endTimeline = function () {
	      everything = new Uint8Array();
	      this.trigger('endedtimeline');
	    };
	  };
	
	  _AacStream.prototype = new stream();
	  var aac = _AacStream; // constants
	
	  var AUDIO_PROPERTIES = ['audioobjecttype', 'channelcount', 'samplerate', 'samplingfrequencyindex', 'samplesize'];
	  var audioProperties = AUDIO_PROPERTIES;
	  var VIDEO_PROPERTIES = ['width', 'height', 'profileIdc', 'levelIdc', 'profileCompatibility', 'sarRatio'];
	  var videoProperties = VIDEO_PROPERTIES;
	  var H264Stream = h264.H264Stream;
	  var isLikelyAacData = utils.isLikelyAacData;
	  var ONE_SECOND_IN_TS$1 = clock.ONE_SECOND_IN_TS; // object types
	
	  var _VideoSegmentStream, _AudioSegmentStream, _Transmuxer, _CoalesceStream;
	
	  var retriggerForStream = function retriggerForStream(key, event) {
	    event.stream = key;
	    this.trigger('log', event);
	  };
	
	  var addPipelineLogRetriggers = function addPipelineLogRetriggers(transmuxer, pipeline) {
	    var keys = Object.keys(pipeline);
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i]; // skip non-stream keys and headOfPipeline
	      // which is just a duplicate
	
	      if (key === 'headOfPipeline' || !pipeline[key].on) {
	        continue;
	      }
	
	      pipeline[key].on('log', retriggerForStream.bind(transmuxer, key));
	    }
	  };
	  /**
	   * Compare two arrays (even typed) for same-ness
	   */
	
	
	  var arrayEquals = function arrayEquals(a, b) {
	    var i;
	
	    if (a.length !== b.length) {
	      return false;
	    } // compare the value of each element in the array
	
	
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  var generateSegmentTimingInfo = function generateSegmentTimingInfo(baseMediaDecodeTime, startDts, startPts, endDts, endPts, prependedContentDuration) {
	    var ptsOffsetFromDts = startPts - startDts,
	        decodeDuration = endDts - startDts,
	        presentationDuration = endPts - startPts; // The PTS and DTS values are based on the actual stream times from the segment,
	    // however, the player time values will reflect a start from the baseMediaDecodeTime.
	    // In order to provide relevant values for the player times, base timing info on the
	    // baseMediaDecodeTime and the DTS and PTS durations of the segment.
	
	    return {
	      start: {
	        dts: baseMediaDecodeTime,
	        pts: baseMediaDecodeTime + ptsOffsetFromDts
	      },
	      end: {
	        dts: baseMediaDecodeTime + decodeDuration,
	        pts: baseMediaDecodeTime + presentationDuration
	      },
	      prependedContentDuration: prependedContentDuration,
	      baseMediaDecodeTime: baseMediaDecodeTime
	    };
	  };
	  /**
	   * Constructs a single-track, ISO BMFF media segment from AAC data
	   * events. The output of this stream can be fed to a SourceBuffer
	   * configured with a suitable initialization segment.
	   * @param track {object} track metadata configuration
	   * @param options {object} transmuxer options object
	   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at 0.
	   */
	
	
	  _AudioSegmentStream = function AudioSegmentStream(track, options) {
	    var adtsFrames = [],
	        sequenceNumber,
	        earliestAllowedDts = 0,
	        audioAppendStartTs = 0,
	        videoBaseMediaDecodeTime = Infinity;
	    options = options || {};
	    sequenceNumber = options.firstSequenceNumber || 0;
	
	    _AudioSegmentStream.prototype.init.call(this);
	
	    this.push = function (data) {
	      trackDecodeInfo.collectDtsInfo(track, data);
	
	      if (track) {
	        audioProperties.forEach(function (prop) {
	          track[prop] = data[prop];
	        });
	      } // buffer audio data until end() is called
	
	
	      adtsFrames.push(data);
	    };
	
	    this.setEarliestDts = function (earliestDts) {
	      earliestAllowedDts = earliestDts;
	    };
	
	    this.setVideoBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	      videoBaseMediaDecodeTime = baseMediaDecodeTime;
	    };
	
	    this.setAudioAppendStart = function (timestamp) {
	      audioAppendStartTs = timestamp;
	    };
	
	    this.flush = function () {
	      var frames, moof, mdat, boxes, frameDuration, segmentDuration, videoClockCyclesOfSilencePrefixed; // return early if no audio data has been observed
	
	      if (adtsFrames.length === 0) {
	        this.trigger('done', 'AudioSegmentStream');
	        return;
	      }
	
	      frames = audioFrameUtils.trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts);
	      track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps); // amount of audio filled but the value is in video clock rather than audio clock
	
	      videoClockCyclesOfSilencePrefixed = audioFrameUtils.prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime); // we have to build the index from byte locations to
	      // samples (that is, adts frames) in the audio data
	
	      track.samples = audioFrameUtils.generateSampleTable(frames); // concatenate the audio data to constuct the mdat
	
	      mdat = mp4Generator.mdat(audioFrameUtils.concatenateFrameData(frames));
	      adtsFrames = [];
	      moof = mp4Generator.moof(sequenceNumber, [track]);
	      boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // bump the sequence number for next time
	
	      sequenceNumber++;
	      boxes.set(moof);
	      boxes.set(mdat, moof.byteLength);
	      trackDecodeInfo.clearDtsInfo(track);
	      frameDuration = Math.ceil(ONE_SECOND_IN_TS$1 * 1024 / track.samplerate); // TODO this check was added to maintain backwards compatibility (particularly with
	      // tests) on adding the timingInfo event. However, it seems unlikely that there's a
	      // valid use-case where an init segment/data should be triggered without associated
	      // frames. Leaving for now, but should be looked into.
	
	      if (frames.length) {
	        segmentDuration = frames.length * frameDuration;
	        this.trigger('segmentTimingInfo', generateSegmentTimingInfo( // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
	        // frame info is in video clock cycles. Convert to match expectation of
	        // listeners (that all timestamps will be based on video clock cycles).
	        clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate), // frame times are already in video clock, as is segment duration
	        frames[0].dts, frames[0].pts, frames[0].dts + segmentDuration, frames[0].pts + segmentDuration, videoClockCyclesOfSilencePrefixed || 0));
	        this.trigger('timingInfo', {
	          start: frames[0].pts,
	          end: frames[0].pts + segmentDuration
	        });
	      }
	
	      this.trigger('data', {
	        track: track,
	        boxes: boxes
	      });
	      this.trigger('done', 'AudioSegmentStream');
	    };
	
	    this.reset = function () {
	      trackDecodeInfo.clearDtsInfo(track);
	      adtsFrames = [];
	      this.trigger('reset');
	    };
	  };
	
	  _AudioSegmentStream.prototype = new stream();
	  /**
	   * Constructs a single-track, ISO BMFF media segment from H264 data
	   * events. The output of this stream can be fed to a SourceBuffer
	   * configured with a suitable initialization segment.
	   * @param track {object} track metadata configuration
	   * @param options {object} transmuxer options object
	   * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
	   *        gopsToAlignWith list when attempting to align gop pts
	   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at 0.
	   */
	
	  _VideoSegmentStream = function VideoSegmentStream(track, options) {
	    var sequenceNumber,
	        nalUnits = [],
	        gopsToAlignWith = [],
	        config,
	        pps;
	    options = options || {};
	    sequenceNumber = options.firstSequenceNumber || 0;
	
	    _VideoSegmentStream.prototype.init.call(this);
	
	    delete track.minPTS;
	    this.gopCache_ = [];
	    /**
	      * Constructs a ISO BMFF segment given H264 nalUnits
	      * @param {Object} nalUnit A data event representing a nalUnit
	      * @param {String} nalUnit.nalUnitType
	      * @param {Object} nalUnit.config Properties for a mp4 track
	      * @param {Uint8Array} nalUnit.data The nalUnit bytes
	      * @see lib/codecs/h264.js
	     **/
	
	    this.push = function (nalUnit) {
	      trackDecodeInfo.collectDtsInfo(track, nalUnit); // record the track config
	
	      if (nalUnit.nalUnitType === 'seq_parameter_set_rbsp' && !config) {
	        config = nalUnit.config;
	        track.sps = [nalUnit.data];
	        videoProperties.forEach(function (prop) {
	          track[prop] = config[prop];
	        }, this);
	      }
	
	      if (nalUnit.nalUnitType === 'pic_parameter_set_rbsp' && !pps) {
	        pps = nalUnit.data;
	        track.pps = [nalUnit.data];
	      } // buffer video until flush() is called
	
	
	      nalUnits.push(nalUnit);
	    };
	    /**
	      * Pass constructed ISO BMFF track and boxes on to the
	      * next stream in the pipeline
	     **/
	
	
	    this.flush = function () {
	      var frames,
	          gopForFusion,
	          gops,
	          moof,
	          mdat,
	          boxes,
	          prependedContentDuration = 0,
	          firstGop,
	          lastGop; // Throw away nalUnits at the start of the byte stream until
	      // we find the first AUD
	
	      while (nalUnits.length) {
	        if (nalUnits[0].nalUnitType === 'access_unit_delimiter_rbsp') {
	          break;
	        }
	
	        nalUnits.shift();
	      } // Return early if no video data has been observed
	
	
	      if (nalUnits.length === 0) {
	        this.resetStream_();
	        this.trigger('done', 'VideoSegmentStream');
	        return;
	      } // Organize the raw nal-units into arrays that represent
	      // higher-level constructs such as frames and gops
	      // (group-of-pictures)
	
	
	      frames = frameUtils.groupNalsIntoFrames(nalUnits);
	      gops = frameUtils.groupFramesIntoGops(frames); // If the first frame of this fragment is not a keyframe we have
	      // a problem since MSE (on Chrome) requires a leading keyframe.
	      //
	      // We have two approaches to repairing this situation:
	      // 1) GOP-FUSION:
	      //    This is where we keep track of the GOPS (group-of-pictures)
	      //    from previous fragments and attempt to find one that we can
	      //    prepend to the current fragment in order to create a valid
	      //    fragment.
	      // 2) KEYFRAME-PULLING:
	      //    Here we search for the first keyframe in the fragment and
	      //    throw away all the frames between the start of the fragment
	      //    and that keyframe. We then extend the duration and pull the
	      //    PTS of the keyframe forward so that it covers the time range
	      //    of the frames that were disposed of.
	      //
	      // #1 is far prefereable over #2 which can cause "stuttering" but
	      // requires more things to be just right.
	
	      if (!gops[0][0].keyFrame) {
	        // Search for a gop for fusion from our gopCache
	        gopForFusion = this.getGopForFusion_(nalUnits[0], track);
	
	        if (gopForFusion) {
	          // in order to provide more accurate timing information about the segment, save
	          // the number of seconds prepended to the original segment due to GOP fusion
	          prependedContentDuration = gopForFusion.duration;
	          gops.unshift(gopForFusion); // Adjust Gops' metadata to account for the inclusion of the
	          // new gop at the beginning
	
	          gops.byteLength += gopForFusion.byteLength;
	          gops.nalCount += gopForFusion.nalCount;
	          gops.pts = gopForFusion.pts;
	          gops.dts = gopForFusion.dts;
	          gops.duration += gopForFusion.duration;
	        } else {
	          // If we didn't find a candidate gop fall back to keyframe-pulling
	          gops = frameUtils.extendFirstKeyFrame(gops);
	        }
	      } // Trim gops to align with gopsToAlignWith
	
	
	      if (gopsToAlignWith.length) {
	        var alignedGops;
	
	        if (options.alignGopsAtEnd) {
	          alignedGops = this.alignGopsAtEnd_(gops);
	        } else {
	          alignedGops = this.alignGopsAtStart_(gops);
	        }
	
	        if (!alignedGops) {
	          // save all the nals in the last GOP into the gop cache
	          this.gopCache_.unshift({
	            gop: gops.pop(),
	            pps: track.pps,
	            sps: track.sps
	          }); // Keep a maximum of 6 GOPs in the cache
	
	          this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
	
	          nalUnits = []; // return early no gops can be aligned with desired gopsToAlignWith
	
	          this.resetStream_();
	          this.trigger('done', 'VideoSegmentStream');
	          return;
	        } // Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
	        // when recalculated before sending off to CoalesceStream
	
	
	        trackDecodeInfo.clearDtsInfo(track);
	        gops = alignedGops;
	      }
	
	      trackDecodeInfo.collectDtsInfo(track, gops); // First, we have to build the index from byte locations to
	      // samples (that is, frames) in the video data
	
	      track.samples = frameUtils.generateSampleTable(gops); // Concatenate the video data and construct the mdat
	
	      mdat = mp4Generator.mdat(frameUtils.concatenateNalData(gops));
	      track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
	      this.trigger('processedGopsInfo', gops.map(function (gop) {
	        return {
	          pts: gop.pts,
	          dts: gop.dts,
	          byteLength: gop.byteLength
	        };
	      }));
	      firstGop = gops[0];
	      lastGop = gops[gops.length - 1];
	      this.trigger('segmentTimingInfo', generateSegmentTimingInfo(track.baseMediaDecodeTime, firstGop.dts, firstGop.pts, lastGop.dts + lastGop.duration, lastGop.pts + lastGop.duration, prependedContentDuration));
	      this.trigger('timingInfo', {
	        start: gops[0].pts,
	        end: gops[gops.length - 1].pts + gops[gops.length - 1].duration
	      }); // save all the nals in the last GOP into the gop cache
	
	      this.gopCache_.unshift({
	        gop: gops.pop(),
	        pps: track.pps,
	        sps: track.sps
	      }); // Keep a maximum of 6 GOPs in the cache
	
	      this.gopCache_.length = Math.min(6, this.gopCache_.length); // Clear nalUnits
	
	      nalUnits = [];
	      this.trigger('baseMediaDecodeTime', track.baseMediaDecodeTime);
	      this.trigger('timelineStartInfo', track.timelineStartInfo);
	      moof = mp4Generator.moof(sequenceNumber, [track]); // it would be great to allocate this array up front instead of
	      // throwing away hundreds of media segment fragments
	
	      boxes = new Uint8Array(moof.byteLength + mdat.byteLength); // Bump the sequence number for next time
	
	      sequenceNumber++;
	      boxes.set(moof);
	      boxes.set(mdat, moof.byteLength);
	      this.trigger('data', {
	        track: track,
	        boxes: boxes
	      });
	      this.resetStream_(); // Continue with the flush process now
	
	      this.trigger('done', 'VideoSegmentStream');
	    };
	
	    this.reset = function () {
	      this.resetStream_();
	      nalUnits = [];
	      this.gopCache_.length = 0;
	      gopsToAlignWith.length = 0;
	      this.trigger('reset');
	    };
	
	    this.resetStream_ = function () {
	      trackDecodeInfo.clearDtsInfo(track); // reset config and pps because they may differ across segments
	      // for instance, when we are rendition switching
	
	      config = undefined;
	      pps = undefined;
	    }; // Search for a candidate Gop for gop-fusion from the gop cache and
	    // return it or return null if no good candidate was found
	
	
	    this.getGopForFusion_ = function (nalUnit) {
	      var halfSecond = 45000,
	          // Half-a-second in a 90khz clock
	      allowableOverlap = 10000,
	          // About 3 frames @ 30fps
	      nearestDistance = Infinity,
	          dtsDistance,
	          nearestGopObj,
	          currentGop,
	          currentGopObj,
	          i; // Search for the GOP nearest to the beginning of this nal unit
	
	      for (i = 0; i < this.gopCache_.length; i++) {
	        currentGopObj = this.gopCache_[i];
	        currentGop = currentGopObj.gop; // Reject Gops with different SPS or PPS
	
	        if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) || !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) {
	          continue;
	        } // Reject Gops that would require a negative baseMediaDecodeTime
	
	
	        if (currentGop.dts < track.timelineStartInfo.dts) {
	          continue;
	        } // The distance between the end of the gop and the start of the nalUnit
	
	
	        dtsDistance = nalUnit.dts - currentGop.dts - currentGop.duration; // Only consider GOPS that start before the nal unit and end within
	        // a half-second of the nal unit
	
	        if (dtsDistance >= -allowableOverlap && dtsDistance <= halfSecond) {
	          // Always use the closest GOP we found if there is more than
	          // one candidate
	          if (!nearestGopObj || nearestDistance > dtsDistance) {
	            nearestGopObj = currentGopObj;
	            nearestDistance = dtsDistance;
	          }
	        }
	      }
	
	      if (nearestGopObj) {
	        return nearestGopObj.gop;
	      }
	
	      return null;
	    }; // trim gop list to the first gop found that has a matching pts with a gop in the list
	    // of gopsToAlignWith starting from the START of the list
	
	
	    this.alignGopsAtStart_ = function (gops) {
	      var alignIndex, gopIndex, align, gop, byteLength, nalCount, duration, alignedGops;
	      byteLength = gops.byteLength;
	      nalCount = gops.nalCount;
	      duration = gops.duration;
	      alignIndex = gopIndex = 0;
	
	      while (alignIndex < gopsToAlignWith.length && gopIndex < gops.length) {
	        align = gopsToAlignWith[alignIndex];
	        gop = gops[gopIndex];
	
	        if (align.pts === gop.pts) {
	          break;
	        }
	
	        if (gop.pts > align.pts) {
	          // this current gop starts after the current gop we want to align on, so increment
	          // align index
	          alignIndex++;
	          continue;
	        } // current gop starts before the current gop we want to align on. so increment gop
	        // index
	
	
	        gopIndex++;
	        byteLength -= gop.byteLength;
	        nalCount -= gop.nalCount;
	        duration -= gop.duration;
	      }
	
	      if (gopIndex === 0) {
	        // no gops to trim
	        return gops;
	      }
	
	      if (gopIndex === gops.length) {
	        // all gops trimmed, skip appending all gops
	        return null;
	      }
	
	      alignedGops = gops.slice(gopIndex);
	      alignedGops.byteLength = byteLength;
	      alignedGops.duration = duration;
	      alignedGops.nalCount = nalCount;
	      alignedGops.pts = alignedGops[0].pts;
	      alignedGops.dts = alignedGops[0].dts;
	      return alignedGops;
	    }; // trim gop list to the first gop found that has a matching pts with a gop in the list
	    // of gopsToAlignWith starting from the END of the list
	
	
	    this.alignGopsAtEnd_ = function (gops) {
	      var alignIndex, gopIndex, align, gop, alignEndIndex, matchFound;
	      alignIndex = gopsToAlignWith.length - 1;
	      gopIndex = gops.length - 1;
	      alignEndIndex = null;
	      matchFound = false;
	
	      while (alignIndex >= 0 && gopIndex >= 0) {
	        align = gopsToAlignWith[alignIndex];
	        gop = gops[gopIndex];
	
	        if (align.pts === gop.pts) {
	          matchFound = true;
	          break;
	        }
	
	        if (align.pts > gop.pts) {
	          alignIndex--;
	          continue;
	        }
	
	        if (alignIndex === gopsToAlignWith.length - 1) {
	          // gop.pts is greater than the last alignment candidate. If no match is found
	          // by the end of this loop, we still want to append gops that come after this
	          // point
	          alignEndIndex = gopIndex;
	        }
	
	        gopIndex--;
	      }
	
	      if (!matchFound && alignEndIndex === null) {
	        return null;
	      }
	
	      var trimIndex;
	
	      if (matchFound) {
	        trimIndex = gopIndex;
	      } else {
	        trimIndex = alignEndIndex;
	      }
	
	      if (trimIndex === 0) {
	        return gops;
	      }
	
	      var alignedGops = gops.slice(trimIndex);
	      var metadata = alignedGops.reduce(function (total, gop) {
	        total.byteLength += gop.byteLength;
	        total.duration += gop.duration;
	        total.nalCount += gop.nalCount;
	        return total;
	      }, {
	        byteLength: 0,
	        duration: 0,
	        nalCount: 0
	      });
	      alignedGops.byteLength = metadata.byteLength;
	      alignedGops.duration = metadata.duration;
	      alignedGops.nalCount = metadata.nalCount;
	      alignedGops.pts = alignedGops[0].pts;
	      alignedGops.dts = alignedGops[0].dts;
	      return alignedGops;
	    };
	
	    this.alignGopsWith = function (newGopsToAlignWith) {
	      gopsToAlignWith = newGopsToAlignWith;
	    };
	  };
	
	  _VideoSegmentStream.prototype = new stream();
	  /**
	   * A Stream that can combine multiple streams (ie. audio & video)
	   * into a single output segment for MSE. Also supports audio-only
	   * and video-only streams.
	   * @param options {object} transmuxer options object
	   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
	   *        in the source; false to adjust the first segment to start at media timeline start.
	   */
	
	  _CoalesceStream = function CoalesceStream(options, metadataStream) {
	    // Number of Tracks per output segment
	    // If greater than 1, we combine multiple
	    // tracks into a single segment
	    this.numberOfTracks = 0;
	    this.metadataStream = metadataStream;
	    options = options || {};
	
	    if (typeof options.remux !== 'undefined') {
	      this.remuxTracks = !!options.remux;
	    } else {
	      this.remuxTracks = true;
	    }
	
	    if (typeof options.keepOriginalTimestamps === 'boolean') {
	      this.keepOriginalTimestamps = options.keepOriginalTimestamps;
	    } else {
	      this.keepOriginalTimestamps = false;
	    }
	
	    this.pendingTracks = [];
	    this.videoTrack = null;
	    this.pendingBoxes = [];
	    this.pendingCaptions = [];
	    this.pendingMetadata = [];
	    this.pendingBytes = 0;
	    this.emittedTracks = 0;
	
	    _CoalesceStream.prototype.init.call(this); // Take output from multiple
	
	
	    this.push = function (output) {
	      // buffer incoming captions until the associated video segment
	      // finishes
	      if (output.text) {
	        return this.pendingCaptions.push(output);
	      } // buffer incoming id3 tags until the final flush
	
	
	      if (output.frames) {
	        return this.pendingMetadata.push(output);
	      } // Add this track to the list of pending tracks and store
	      // important information required for the construction of
	      // the final segment
	
	
	      this.pendingTracks.push(output.track);
	      this.pendingBytes += output.boxes.byteLength; // TODO: is there an issue for this against chrome?
	      // We unshift audio and push video because
	      // as of Chrome 75 when switching from
	      // one init segment to another if the video
	      // mdat does not appear after the audio mdat
	      // only audio will play for the duration of our transmux.
	
	      if (output.track.type === 'video') {
	        this.videoTrack = output.track;
	        this.pendingBoxes.push(output.boxes);
	      }
	
	      if (output.track.type === 'audio') {
	        this.audioTrack = output.track;
	        this.pendingBoxes.unshift(output.boxes);
	      }
	    };
	  };
	
	  _CoalesceStream.prototype = new stream();
	
	  _CoalesceStream.prototype.flush = function (flushSource) {
	    var offset = 0,
	        event = {
	      captions: [],
	      captionStreams: {},
	      metadata: [],
	      info: {}
	    },
	        caption,
	        id3,
	        initSegment,
	        timelineStartPts = 0,
	        i;
	
	    if (this.pendingTracks.length < this.numberOfTracks) {
	      if (flushSource !== 'VideoSegmentStream' && flushSource !== 'AudioSegmentStream') {
	        // Return because we haven't received a flush from a data-generating
	        // portion of the segment (meaning that we have only recieved meta-data
	        // or captions.)
	        return;
	      } else if (this.remuxTracks) {
	        // Return until we have enough tracks from the pipeline to remux (if we
	        // are remuxing audio and video into a single MP4)
	        return;
	      } else if (this.pendingTracks.length === 0) {
	        // In the case where we receive a flush without any data having been
	        // received we consider it an emitted track for the purposes of coalescing
	        // `done` events.
	        // We do this for the case where there is an audio and video track in the
	        // segment but no audio data. (seen in several playlists with alternate
	        // audio tracks and no audio present in the main TS segments.)
	        this.emittedTracks++;
	
	        if (this.emittedTracks >= this.numberOfTracks) {
	          this.trigger('done');
	          this.emittedTracks = 0;
	        }
	
	        return;
	      }
	    }
	
	    if (this.videoTrack) {
	      timelineStartPts = this.videoTrack.timelineStartInfo.pts;
	      videoProperties.forEach(function (prop) {
	        event.info[prop] = this.videoTrack[prop];
	      }, this);
	    } else if (this.audioTrack) {
	      timelineStartPts = this.audioTrack.timelineStartInfo.pts;
	      audioProperties.forEach(function (prop) {
	        event.info[prop] = this.audioTrack[prop];
	      }, this);
	    }
	
	    if (this.videoTrack || this.audioTrack) {
	      if (this.pendingTracks.length === 1) {
	        event.type = this.pendingTracks[0].type;
	      } else {
	        event.type = 'combined';
	      }
	
	      this.emittedTracks += this.pendingTracks.length;
	      initSegment = mp4Generator.initSegment(this.pendingTracks); // Create a new typed array to hold the init segment
	
	      event.initSegment = new Uint8Array(initSegment.byteLength); // Create an init segment containing a moov
	      // and track definitions
	
	      event.initSegment.set(initSegment); // Create a new typed array to hold the moof+mdats
	
	      event.data = new Uint8Array(this.pendingBytes); // Append each moof+mdat (one per track) together
	
	      for (i = 0; i < this.pendingBoxes.length; i++) {
	        event.data.set(this.pendingBoxes[i], offset);
	        offset += this.pendingBoxes[i].byteLength;
	      } // Translate caption PTS times into second offsets to match the
	      // video timeline for the segment, and add track info
	
	
	      for (i = 0; i < this.pendingCaptions.length; i++) {
	        caption = this.pendingCaptions[i];
	        caption.startTime = clock.metadataTsToSeconds(caption.startPts, timelineStartPts, this.keepOriginalTimestamps);
	        caption.endTime = clock.metadataTsToSeconds(caption.endPts, timelineStartPts, this.keepOriginalTimestamps);
	        event.captionStreams[caption.stream] = true;
	        event.captions.push(caption);
	      } // Translate ID3 frame PTS times into second offsets to match the
	      // video timeline for the segment
	
	
	      for (i = 0; i < this.pendingMetadata.length; i++) {
	        id3 = this.pendingMetadata[i];
	        id3.cueTime = clock.metadataTsToSeconds(id3.pts, timelineStartPts, this.keepOriginalTimestamps);
	        event.metadata.push(id3);
	      } // We add this to every single emitted segment even though we only need
	      // it for the first
	
	
	      event.metadata.dispatchType = this.metadataStream.dispatchType; // Reset stream state
	
	      this.pendingTracks.length = 0;
	      this.videoTrack = null;
	      this.pendingBoxes.length = 0;
	      this.pendingCaptions.length = 0;
	      this.pendingBytes = 0;
	      this.pendingMetadata.length = 0; // Emit the built segment
	      // We include captions and ID3 tags for backwards compatibility,
	      // ideally we should send only video and audio in the data event
	
	      this.trigger('data', event); // Emit each caption to the outside world
	      // Ideally, this would happen immediately on parsing captions,
	      // but we need to ensure that video data is sent back first
	      // so that caption timing can be adjusted to match video timing
	
	      for (i = 0; i < event.captions.length; i++) {
	        caption = event.captions[i];
	        this.trigger('caption', caption);
	      } // Emit each id3 tag to the outside world
	      // Ideally, this would happen immediately on parsing the tag,
	      // but we need to ensure that video data is sent back first
	      // so that ID3 frame timing can be adjusted to match video timing
	
	
	      for (i = 0; i < event.metadata.length; i++) {
	        id3 = event.metadata[i];
	        this.trigger('id3Frame', id3);
	      }
	    } // Only emit `done` if all tracks have been flushed and emitted
	
	
	    if (this.emittedTracks >= this.numberOfTracks) {
	      this.trigger('done');
	      this.emittedTracks = 0;
	    }
	  };
	
	  _CoalesceStream.prototype.setRemux = function (val) {
	    this.remuxTracks = val;
	  };
	  /**
	   * A Stream that expects MP2T binary data as input and produces
	   * corresponding media segments, suitable for use with Media Source
	   * Extension (MSE) implementations that support the ISO BMFF byte
	   * stream format, like Chrome.
	   */
	
	
	  _Transmuxer = function Transmuxer(options) {
	    var self = this,
	        hasFlushed = true,
	        videoTrack,
	        audioTrack;
	
	    _Transmuxer.prototype.init.call(this);
	
	    options = options || {};
	    this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
	    this.transmuxPipeline_ = {};
	
	    this.setupAacPipeline = function () {
	      var pipeline = {};
	      this.transmuxPipeline_ = pipeline;
	      pipeline.type = 'aac';
	      pipeline.metadataStream = new m2ts_1.MetadataStream(); // set up the parsing pipeline
	
	      pipeline.aacStream = new aac();
	      pipeline.audioTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('audio');
	      pipeline.timedMetadataTimestampRolloverStream = new m2ts_1.TimestampRolloverStream('timed-metadata');
	      pipeline.adtsStream = new adts();
	      pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	      pipeline.headOfPipeline = pipeline.aacStream;
	      pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
	      pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
	      pipeline.metadataStream.on('timestamp', function (frame) {
	        pipeline.aacStream.setTimestamp(frame.timeStamp);
	      });
	      pipeline.aacStream.on('data', function (data) {
	        if (data.type !== 'timed-metadata' && data.type !== 'audio' || pipeline.audioSegmentStream) {
	          return;
	        }
	
	        audioTrack = audioTrack || {
	          timelineStartInfo: {
	            baseMediaDecodeTime: self.baseMediaDecodeTime
	          },
	          codec: 'adts',
	          type: 'audio'
	        }; // hook up the audio segment stream to the first track with aac data
	
	        pipeline.coalesceStream.numberOfTracks++;
	        pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
	        pipeline.audioSegmentStream.on('log', self.getLogTrigger_('audioSegmentStream'));
	        pipeline.audioSegmentStream.on('timingInfo', self.trigger.bind(self, 'audioTimingInfo')); // Set up the final part of the audio pipeline
	
	        pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream); // emit pmt info
	
	        self.trigger('trackinfo', {
	          hasAudio: !!audioTrack,
	          hasVideo: !!videoTrack
	        });
	      }); // Re-emit any data coming from the coalesce stream to the outside world
	
	      pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data')); // Let the consumer know we have finished flushing the entire pipeline
	
	      pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	      addPipelineLogRetriggers(this, pipeline);
	    };
	
	    this.setupTsPipeline = function () {
	      var pipeline = {};
	      this.transmuxPipeline_ = pipeline;
	      pipeline.type = 'ts';
	      pipeline.metadataStream = new m2ts_1.MetadataStream(); // set up the parsing pipeline
	
	      pipeline.packetStream = new m2ts_1.TransportPacketStream();
	      pipeline.parseStream = new m2ts_1.TransportParseStream();
	      pipeline.elementaryStream = new m2ts_1.ElementaryStream();
	      pipeline.timestampRolloverStream = new m2ts_1.TimestampRolloverStream();
	      pipeline.adtsStream = new adts();
	      pipeline.h264Stream = new H264Stream();
	      pipeline.captionStream = new m2ts_1.CaptionStream(options);
	      pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	      pipeline.headOfPipeline = pipeline.packetStream; // disassemble MPEG2-TS packets into elementary streams
	
	      pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream).pipe(pipeline.timestampRolloverStream); // !!THIS ORDER IS IMPORTANT!!
	      // demux the streams
	
	      pipeline.timestampRolloverStream.pipe(pipeline.h264Stream);
	      pipeline.timestampRolloverStream.pipe(pipeline.adtsStream);
	      pipeline.timestampRolloverStream.pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream); // Hook up CEA-608/708 caption stream
	
	      pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);
	      pipeline.elementaryStream.on('data', function (data) {
	        var i;
	
	        if (data.type === 'metadata') {
	          i = data.tracks.length; // scan the tracks listed in the metadata
	
	          while (i--) {
	            if (!videoTrack && data.tracks[i].type === 'video') {
	              videoTrack = data.tracks[i];
	              videoTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	            } else if (!audioTrack && data.tracks[i].type === 'audio') {
	              audioTrack = data.tracks[i];
	              audioTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	            }
	          } // hook up the video segment stream to the first track with h264 data
	
	
	          if (videoTrack && !pipeline.videoSegmentStream) {
	            pipeline.coalesceStream.numberOfTracks++;
	            pipeline.videoSegmentStream = new _VideoSegmentStream(videoTrack, options);
	            pipeline.videoSegmentStream.on('log', self.getLogTrigger_('videoSegmentStream'));
	            pipeline.videoSegmentStream.on('timelineStartInfo', function (timelineStartInfo) {
	              // When video emits timelineStartInfo data after a flush, we forward that
	              // info to the AudioSegmentStream, if it exists, because video timeline
	              // data takes precedence.  Do not do this if keepOriginalTimestamps is set,
	              // because this is a particularly subtle form of timestamp alteration.
	              if (audioTrack && !options.keepOriginalTimestamps) {
	                audioTrack.timelineStartInfo = timelineStartInfo; // On the first segment we trim AAC frames that exist before the
	                // very earliest DTS we have seen in video because Chrome will
	                // interpret any video track with a baseMediaDecodeTime that is
	                // non-zero as a gap.
	
	                pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts - self.baseMediaDecodeTime);
	              }
	            });
	            pipeline.videoSegmentStream.on('processedGopsInfo', self.trigger.bind(self, 'gopInfo'));
	            pipeline.videoSegmentStream.on('segmentTimingInfo', self.trigger.bind(self, 'videoSegmentTimingInfo'));
	            pipeline.videoSegmentStream.on('baseMediaDecodeTime', function (baseMediaDecodeTime) {
	              if (audioTrack) {
	                pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
	              }
	            });
	            pipeline.videoSegmentStream.on('timingInfo', self.trigger.bind(self, 'videoTimingInfo')); // Set up the final part of the video pipeline
	
	            pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);
	          }
	
	          if (audioTrack && !pipeline.audioSegmentStream) {
	            // hook up the audio segment stream to the first track with aac data
	            pipeline.coalesceStream.numberOfTracks++;
	            pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
	            pipeline.audioSegmentStream.on('log', self.getLogTrigger_('audioSegmentStream'));
	            pipeline.audioSegmentStream.on('timingInfo', self.trigger.bind(self, 'audioTimingInfo'));
	            pipeline.audioSegmentStream.on('segmentTimingInfo', self.trigger.bind(self, 'audioSegmentTimingInfo')); // Set up the final part of the audio pipeline
	
	            pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
	          } // emit pmt info
	
	
	          self.trigger('trackinfo', {
	            hasAudio: !!audioTrack,
	            hasVideo: !!videoTrack
	          });
	        }
	      }); // Re-emit any data coming from the coalesce stream to the outside world
	
	      pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
	      pipeline.coalesceStream.on('id3Frame', function (id3Frame) {
	        id3Frame.dispatchType = pipeline.metadataStream.dispatchType;
	        self.trigger('id3Frame', id3Frame);
	      });
	      pipeline.coalesceStream.on('caption', this.trigger.bind(this, 'caption')); // Let the consumer know we have finished flushing the entire pipeline
	
	      pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	      addPipelineLogRetriggers(this, pipeline);
	    }; // hook up the segment streams once track metadata is delivered
	
	
	    this.setBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	      var pipeline = this.transmuxPipeline_;
	
	      if (!options.keepOriginalTimestamps) {
	        this.baseMediaDecodeTime = baseMediaDecodeTime;
	      }
	
	      if (audioTrack) {
	        audioTrack.timelineStartInfo.dts = undefined;
	        audioTrack.timelineStartInfo.pts = undefined;
	        trackDecodeInfo.clearDtsInfo(audioTrack);
	
	        if (pipeline.audioTimestampRolloverStream) {
	          pipeline.audioTimestampRolloverStream.discontinuity();
	        }
	      }
	
	      if (videoTrack) {
	        if (pipeline.videoSegmentStream) {
	          pipeline.videoSegmentStream.gopCache_ = [];
	        }
	
	        videoTrack.timelineStartInfo.dts = undefined;
	        videoTrack.timelineStartInfo.pts = undefined;
	        trackDecodeInfo.clearDtsInfo(videoTrack);
	        pipeline.captionStream.reset();
	      }
	
	      if (pipeline.timestampRolloverStream) {
	        pipeline.timestampRolloverStream.discontinuity();
	      }
	    };
	
	    this.setAudioAppendStart = function (timestamp) {
	      if (audioTrack) {
	        this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
	      }
	    };
	
	    this.setRemux = function (val) {
	      var pipeline = this.transmuxPipeline_;
	      options.remux = val;
	
	      if (pipeline && pipeline.coalesceStream) {
	        pipeline.coalesceStream.setRemux(val);
	      }
	    };
	
	    this.alignGopsWith = function (gopsToAlignWith) {
	      if (videoTrack && this.transmuxPipeline_.videoSegmentStream) {
	        this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);
	      }
	    };
	
	    this.getLogTrigger_ = function (key) {
	      var self = this;
	      return function (event) {
	        event.stream = key;
	        self.trigger('log', event);
	      };
	    }; // feed incoming data to the front of the parsing pipeline
	
	
	    this.push = function (data) {
	      if (hasFlushed) {
	        var isAac = isLikelyAacData(data);
	
	        if (isAac && this.transmuxPipeline_.type !== 'aac') {
	          this.setupAacPipeline();
	        } else if (!isAac && this.transmuxPipeline_.type !== 'ts') {
	          this.setupTsPipeline();
	        }
	
	        hasFlushed = false;
	      }
	
	      this.transmuxPipeline_.headOfPipeline.push(data);
	    }; // flush any buffered data
	
	
	    this.flush = function () {
	      hasFlushed = true; // Start at the top of the pipeline and flush all pending work
	
	      this.transmuxPipeline_.headOfPipeline.flush();
	    };
	
	    this.endTimeline = function () {
	      this.transmuxPipeline_.headOfPipeline.endTimeline();
	    };
	
	    this.reset = function () {
	      if (this.transmuxPipeline_.headOfPipeline) {
	        this.transmuxPipeline_.headOfPipeline.reset();
	      }
	    }; // Caption data has to be reset when seeking outside buffered range
	
	
	    this.resetCaptions = function () {
	      if (this.transmuxPipeline_.captionStream) {
	        this.transmuxPipeline_.captionStream.reset();
	      }
	    };
	  };
	
	  _Transmuxer.prototype = new stream();
	  var transmuxer = {
	    Transmuxer: _Transmuxer,
	    VideoSegmentStream: _VideoSegmentStream,
	    AudioSegmentStream: _AudioSegmentStream,
	    AUDIO_PROPERTIES: audioProperties,
	    VIDEO_PROPERTIES: videoProperties,
	    // exported for testing
	    generateSegmentTimingInfo: generateSegmentTimingInfo
	  };
	  /**
	   * mux.js
	   *
	   * Copyright (c) Brightcove
	   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	   */
	
	  var toUnsigned$3 = function toUnsigned(value) {
	    return value >>> 0;
	  };
	
	  var toHexString$1 = function toHexString(value) {
	    return ('00' + value.toString(16)).slice(-2);
	  };
	
	  var bin = {
	    toUnsigned: toUnsigned$3,
	    toHexString: toHexString$1
	  };
	
	  var parseType$1 = function parseType(buffer) {
	    var result = '';
	    result += String.fromCharCode(buffer[0]);
	    result += String.fromCharCode(buffer[1]);
	    result += String.fromCharCode(buffer[2]);
	    result += String.fromCharCode(buffer[3]);
	    return result;
	  };
	
	  var parseType_1 = parseType$1;
	  var toUnsigned$2 = bin.toUnsigned;
	
	  var findBox = function findBox(data, path) {
	    var results = [],
	        i,
	        size,
	        type,
	        end,
	        subresults;
	
	    if (!path.length) {
	      // short-circuit the search for empty paths
	      return null;
	    }
	
	    for (i = 0; i < data.byteLength;) {
	      size = toUnsigned$2(data[i] << 24 | data[i + 1] << 16 | data[i + 2] << 8 | data[i + 3]);
	      type = parseType_1(data.subarray(i + 4, i + 8));
	      end = size > 1 ? i + size : data.byteLength;
	
	      if (type === path[0]) {
	        if (path.length === 1) {
	          // this is the end of the path and we've found the box we were
	          // looking for
	          results.push(data.subarray(i + 8, end));
	        } else {
	          // recursively search for the next box along the path
	          subresults = findBox(data.subarray(i + 8, end), path.slice(1));
	
	          if (subresults.length) {
	            results = results.concat(subresults);
	          }
	        }
	      }
	
	      i = end;
	    } // we've finished searching all of data
	
	
	    return results;
	  };
	
	  var findBox_1 = findBox;
	  var toUnsigned$1 = bin.toUnsigned;
	  var getUint64$1 = numbers.getUint64;
	
	  var tfdt = function tfdt(data) {
	    var result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4))
	    };
	
	    if (result.version === 1) {
	      result.baseMediaDecodeTime = getUint64$1(data.subarray(4));
	    } else {
	      result.baseMediaDecodeTime = toUnsigned$1(data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]);
	    }
	
	    return result;
	  };
	
	  var parseTfdt = tfdt;
	
	  var parseSampleFlags = function parseSampleFlags(flags) {
	    return {
	      isLeading: (flags[0] & 0x0c) >>> 2,
	      dependsOn: flags[0] & 0x03,
	      isDependedOn: (flags[1] & 0xc0) >>> 6,
	      hasRedundancy: (flags[1] & 0x30) >>> 4,
	      paddingValue: (flags[1] & 0x0e) >>> 1,
	      isNonSyncSample: flags[1] & 0x01,
	      degradationPriority: flags[2] << 8 | flags[3]
	    };
	  };
	
	  var parseSampleFlags_1 = parseSampleFlags;
	
	  var trun = function trun(data) {
	    var result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      samples: []
	    },
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        // Flag interpretation
	    dataOffsetPresent = result.flags[2] & 0x01,
	        // compare with 2nd byte of 0x1
	    firstSampleFlagsPresent = result.flags[2] & 0x04,
	        // compare with 2nd byte of 0x4
	    sampleDurationPresent = result.flags[1] & 0x01,
	        // compare with 2nd byte of 0x100
	    sampleSizePresent = result.flags[1] & 0x02,
	        // compare with 2nd byte of 0x200
	    sampleFlagsPresent = result.flags[1] & 0x04,
	        // compare with 2nd byte of 0x400
	    sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08,
	        // compare with 2nd byte of 0x800
	    sampleCount = view.getUint32(4),
	        offset = 8,
	        sample;
	
	    if (dataOffsetPresent) {
	      // 32 bit signed integer
	      result.dataOffset = view.getInt32(offset);
	      offset += 4;
	    } // Overrides the flags for the first sample only. The order of
	    // optional values will be: duration, size, compositionTimeOffset
	
	
	    if (firstSampleFlagsPresent && sampleCount) {
	      sample = {
	        flags: parseSampleFlags_1(data.subarray(offset, offset + 4))
	      };
	      offset += 4;
	
	      if (sampleDurationPresent) {
	        sample.duration = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleSizePresent) {
	        sample.size = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleCompositionTimeOffsetPresent) {
	        if (result.version === 1) {
	          sample.compositionTimeOffset = view.getInt32(offset);
	        } else {
	          sample.compositionTimeOffset = view.getUint32(offset);
	        }
	
	        offset += 4;
	      }
	
	      result.samples.push(sample);
	      sampleCount--;
	    }
	
	    while (sampleCount--) {
	      sample = {};
	
	      if (sampleDurationPresent) {
	        sample.duration = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleSizePresent) {
	        sample.size = view.getUint32(offset);
	        offset += 4;
	      }
	
	      if (sampleFlagsPresent) {
	        sample.flags = parseSampleFlags_1(data.subarray(offset, offset + 4));
	        offset += 4;
	      }
	
	      if (sampleCompositionTimeOffsetPresent) {
	        if (result.version === 1) {
	          sample.compositionTimeOffset = view.getInt32(offset);
	        } else {
	          sample.compositionTimeOffset = view.getUint32(offset);
	        }
	
	        offset += 4;
	      }
	
	      result.samples.push(sample);
	    }
	
	    return result;
	  };
	
	  var parseTrun = trun;
	
	  var tfhd = function tfhd(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      trackId: view.getUint32(4)
	    },
	        baseDataOffsetPresent = result.flags[2] & 0x01,
	        sampleDescriptionIndexPresent = result.flags[2] & 0x02,
	        defaultSampleDurationPresent = result.flags[2] & 0x08,
	        defaultSampleSizePresent = result.flags[2] & 0x10,
	        defaultSampleFlagsPresent = result.flags[2] & 0x20,
	        durationIsEmpty = result.flags[0] & 0x010000,
	        defaultBaseIsMoof = result.flags[0] & 0x020000,
	        i;
	    i = 8;
	
	    if (baseDataOffsetPresent) {
	      i += 4; // truncate top 4 bytes
	      // FIXME: should we read the full 64 bits?
	
	      result.baseDataOffset = view.getUint32(12);
	      i += 4;
	    }
	
	    if (sampleDescriptionIndexPresent) {
	      result.sampleDescriptionIndex = view.getUint32(i);
	      i += 4;
	    }
	
	    if (defaultSampleDurationPresent) {
	      result.defaultSampleDuration = view.getUint32(i);
	      i += 4;
	    }
	
	    if (defaultSampleSizePresent) {
	      result.defaultSampleSize = view.getUint32(i);
	      i += 4;
	    }
	
	    if (defaultSampleFlagsPresent) {
	      result.defaultSampleFlags = view.getUint32(i);
	    }
	
	    if (durationIsEmpty) {
	      result.durationIsEmpty = true;
	    }
	
	    if (!baseDataOffsetPresent && defaultBaseIsMoof) {
	      result.baseDataOffsetIsMoof = true;
	    }
	
	    return result;
	  };
	
	  var parseTfhd = tfhd;
	  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	  var win;
	
	  if (typeof window !== "undefined") {
	    win = window;
	  } else if (typeof commonjsGlobal !== "undefined") {
	    win = commonjsGlobal;
	  } else if (typeof self !== "undefined") {
	    win = self;
	  } else {
	    win = {};
	  }
	
	  var window_1 = win;
	  var discardEmulationPreventionBytes = captionPacketParser.discardEmulationPreventionBytes;
	  var CaptionStream = captionStream.CaptionStream;
	  /**
	    * Maps an offset in the mdat to a sample based on the the size of the samples.
	    * Assumes that `parseSamples` has been called first.
	    *
	    * @param {Number} offset - The offset into the mdat
	    * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
	    * @return {?Object} The matching sample, or null if no match was found.
	    *
	    * @see ISO-BMFF-12/2015, Section 8.8.8
	   **/
	
	  var mapToSample = function mapToSample(offset, samples) {
	    var approximateOffset = offset;
	
	    for (var i = 0; i < samples.length; i++) {
	      var sample = samples[i];
	
	      if (approximateOffset < sample.size) {
	        return sample;
	      }
	
	      approximateOffset -= sample.size;
	    }
	
	    return null;
	  };
	  /**
	    * Finds SEI nal units contained in a Media Data Box.
	    * Assumes that `parseSamples` has been called first.
	    *
	    * @param {Uint8Array} avcStream - The bytes of the mdat
	    * @param {Object[]} samples - The samples parsed out by `parseSamples`
	    * @param {Number} trackId - The trackId of this video track
	    * @return {Object[]} seiNals - the parsed SEI NALUs found.
	    *   The contents of the seiNal should match what is expected by
	    *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
	    *
	    * @see ISO-BMFF-12/2015, Section 8.1.1
	    * @see Rec. ITU-T H.264, 7.3.2.3.1
	   **/
	
	
	  var findSeiNals = function findSeiNals(avcStream, samples, trackId) {
	    var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength),
	        result = {
	      logs: [],
	      seiNals: []
	    },
	        seiNal,
	        i,
	        length,
	        lastMatchedSample;
	
	    for (i = 0; i + 4 < avcStream.length; i += length) {
	      length = avcView.getUint32(i);
	      i += 4; // Bail if this doesn't appear to be an H264 stream
	
	      if (length <= 0) {
	        continue;
	      }
	
	      switch (avcStream[i] & 0x1F) {
	        case 0x06:
	          var data = avcStream.subarray(i + 1, i + 1 + length);
	          var matchingSample = mapToSample(i, samples);
	          seiNal = {
	            nalUnitType: 'sei_rbsp',
	            size: length,
	            data: data,
	            escapedRBSP: discardEmulationPreventionBytes(data),
	            trackId: trackId
	          };
	
	          if (matchingSample) {
	            seiNal.pts = matchingSample.pts;
	            seiNal.dts = matchingSample.dts;
	            lastMatchedSample = matchingSample;
	          } else if (lastMatchedSample) {
	            // If a matching sample cannot be found, use the last
	            // sample's values as they should be as close as possible
	            seiNal.pts = lastMatchedSample.pts;
	            seiNal.dts = lastMatchedSample.dts;
	          } else {
	            result.logs.push({
	              level: 'warn',
	              message: 'We\'ve encountered a nal unit without data at ' + i + ' for trackId ' + trackId + '. See mux.js#223.'
	            });
	            break;
	          }
	
	          result.seiNals.push(seiNal);
	          break;
	      }
	    }
	
	    return result;
	  };
	  /**
	    * Parses sample information out of Track Run Boxes and calculates
	    * the absolute presentation and decode timestamps of each sample.
	    *
	    * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
	    * @param {Number|BigInt} baseMediaDecodeTime - base media decode time from tfdt
	        @see ISO-BMFF-12/2015, Section 8.8.12
	    * @param {Object} tfhd - The parsed Track Fragment Header
	    *   @see inspect.parseTfhd
	    * @return {Object[]} the parsed samples
	    *
	    * @see ISO-BMFF-12/2015, Section 8.8.8
	   **/
	
	
	  var parseSamples = function parseSamples(truns, baseMediaDecodeTime, tfhd) {
	    var currentDts = baseMediaDecodeTime;
	    var defaultSampleDuration = tfhd.defaultSampleDuration || 0;
	    var defaultSampleSize = tfhd.defaultSampleSize || 0;
	    var trackId = tfhd.trackId;
	    var allSamples = [];
	    truns.forEach(function (trun) {
	      // Note: We currently do not parse the sample table as well
	      // as the trun. It's possible some sources will require this.
	      // moov > trak > mdia > minf > stbl
	      var trackRun = parseTrun(trun);
	      var samples = trackRun.samples;
	      samples.forEach(function (sample) {
	        if (sample.duration === undefined) {
	          sample.duration = defaultSampleDuration;
	        }
	
	        if (sample.size === undefined) {
	          sample.size = defaultSampleSize;
	        }
	
	        sample.trackId = trackId;
	        sample.dts = currentDts;
	
	        if (sample.compositionTimeOffset === undefined) {
	          sample.compositionTimeOffset = 0;
	        }
	
	        if (typeof currentDts === 'bigint') {
	          sample.pts = currentDts + window_1.BigInt(sample.compositionTimeOffset);
	          currentDts += window_1.BigInt(sample.duration);
	        } else {
	          sample.pts = currentDts + sample.compositionTimeOffset;
	          currentDts += sample.duration;
	        }
	      });
	      allSamples = allSamples.concat(samples);
	    });
	    return allSamples;
	  };
	  /**
	    * Parses out caption nals from an FMP4 segment's video tracks.
	    *
	    * @param {Uint8Array} segment - The bytes of a single segment
	    * @param {Number} videoTrackId - The trackId of a video track in the segment
	    * @return {Object.<Number, Object[]>} A mapping of video trackId to
	    *   a list of seiNals found in that track
	   **/
	
	
	  var parseCaptionNals = function parseCaptionNals(segment, videoTrackId) {
	    // To get the samples
	    var trafs = findBox_1(segment, ['moof', 'traf']); // To get SEI NAL units
	
	    var mdats = findBox_1(segment, ['mdat']);
	    var captionNals = {};
	    var mdatTrafPairs = []; // Pair up each traf with a mdat as moofs and mdats are in pairs
	
	    mdats.forEach(function (mdat, index) {
	      var matchingTraf = trafs[index];
	      mdatTrafPairs.push({
	        mdat: mdat,
	        traf: matchingTraf
	      });
	    });
	    mdatTrafPairs.forEach(function (pair) {
	      var mdat = pair.mdat;
	      var traf = pair.traf;
	      var tfhd = findBox_1(traf, ['tfhd']); // Exactly 1 tfhd per traf
	
	      var headerInfo = parseTfhd(tfhd[0]);
	      var trackId = headerInfo.trackId;
	      var tfdt = findBox_1(traf, ['tfdt']); // Either 0 or 1 tfdt per traf
	
	      var baseMediaDecodeTime = tfdt.length > 0 ? parseTfdt(tfdt[0]).baseMediaDecodeTime : 0;
	      var truns = findBox_1(traf, ['trun']);
	      var samples;
	      var result; // Only parse video data for the chosen video track
	
	      if (videoTrackId === trackId && truns.length > 0) {
	        samples = parseSamples(truns, baseMediaDecodeTime, headerInfo);
	        result = findSeiNals(mdat, samples, trackId);
	
	        if (!captionNals[trackId]) {
	          captionNals[trackId] = {
	            seiNals: [],
	            logs: []
	          };
	        }
	
	        captionNals[trackId].seiNals = captionNals[trackId].seiNals.concat(result.seiNals);
	        captionNals[trackId].logs = captionNals[trackId].logs.concat(result.logs);
	      }
	    });
	    return captionNals;
	  };
	  /**
	    * Parses out inband captions from an MP4 container and returns
	    * caption objects that can be used by WebVTT and the TextTrack API.
	    * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
	    * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
	    * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
	    *
	    * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	    * @param {Number} trackId - The id of the video track to parse
	    * @param {Number} timescale - The timescale for the video track from the init segment
	    *
	    * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
	    * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
	    * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
	    * @return {String} parsedCaptions[].text - The visible content of the caption
	   **/
	
	
	  var parseEmbeddedCaptions = function parseEmbeddedCaptions(segment, trackId, timescale) {
	    var captionNals; // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
	
	    if (trackId === null) {
	      return null;
	    }
	
	    captionNals = parseCaptionNals(segment, trackId);
	    var trackNals = captionNals[trackId] || {};
	    return {
	      seiNals: trackNals.seiNals,
	      logs: trackNals.logs,
	      timescale: timescale
	    };
	  };
	  /**
	    * Converts SEI NALUs into captions that can be used by video.js
	   **/
	
	
	  var CaptionParser = function CaptionParser() {
	    var isInitialized = false;
	    var captionStream; // Stores segments seen before trackId and timescale are set
	
	    var segmentCache; // Stores video track ID of the track being parsed
	
	    var trackId; // Stores the timescale of the track being parsed
	
	    var timescale; // Stores captions parsed so far
	
	    var parsedCaptions; // Stores whether we are receiving partial data or not
	
	    var parsingPartial;
	    /**
	      * A method to indicate whether a CaptionParser has been initalized
	      * @returns {Boolean}
	     **/
	
	    this.isInitialized = function () {
	      return isInitialized;
	    };
	    /**
	      * Initializes the underlying CaptionStream, SEI NAL parsing
	      * and management, and caption collection
	     **/
	
	
	    this.init = function (options) {
	      captionStream = new CaptionStream();
	      isInitialized = true;
	      parsingPartial = options ? options.isPartial : false; // Collect dispatched captions
	
	      captionStream.on('data', function (event) {
	        // Convert to seconds in the source's timescale
	        event.startTime = event.startPts / timescale;
	        event.endTime = event.endPts / timescale;
	        parsedCaptions.captions.push(event);
	        parsedCaptions.captionStreams[event.stream] = true;
	      });
	      captionStream.on('log', function (log) {
	        parsedCaptions.logs.push(log);
	      });
	    };
	    /**
	      * Determines if a new video track will be selected
	      * or if the timescale changed
	      * @return {Boolean}
	     **/
	
	
	    this.isNewInit = function (videoTrackIds, timescales) {
	      if (videoTrackIds && videoTrackIds.length === 0 || timescales && typeof timescales === 'object' && Object.keys(timescales).length === 0) {
	        return false;
	      }
	
	      return trackId !== videoTrackIds[0] || timescale !== timescales[trackId];
	    };
	    /**
	      * Parses out SEI captions and interacts with underlying
	      * CaptionStream to return dispatched captions
	      *
	      * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
	      * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
	      * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
	      * @see parseEmbeddedCaptions
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.parse = function (segment, videoTrackIds, timescales) {
	      var parsedData;
	
	      if (!this.isInitialized()) {
	        return null; // This is not likely to be a video segment
	      } else if (!videoTrackIds || !timescales) {
	        return null;
	      } else if (this.isNewInit(videoTrackIds, timescales)) {
	        // Use the first video track only as there is no
	        // mechanism to switch to other video tracks
	        trackId = videoTrackIds[0];
	        timescale = timescales[trackId]; // If an init segment has not been seen yet, hold onto segment
	        // data until we have one.
	        // the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
	      } else if (trackId === null || !timescale) {
	        segmentCache.push(segment);
	        return null;
	      } // Now that a timescale and trackId is set, parse cached segments
	
	
	      while (segmentCache.length > 0) {
	        var cachedSegment = segmentCache.shift();
	        this.parse(cachedSegment, videoTrackIds, timescales);
	      }
	
	      parsedData = parseEmbeddedCaptions(segment, trackId, timescale);
	
	      if (parsedData && parsedData.logs) {
	        parsedCaptions.logs = parsedCaptions.logs.concat(parsedData.logs);
	      }
	
	      if (parsedData === null || !parsedData.seiNals) {
	        if (parsedCaptions.logs.length) {
	          return {
	            logs: parsedCaptions.logs,
	            captions: [],
	            captionStreams: []
	          };
	        }
	
	        return null;
	      }
	
	      this.pushNals(parsedData.seiNals); // Force the parsed captions to be dispatched
	
	      this.flushStream();
	      return parsedCaptions;
	    };
	    /**
	      * Pushes SEI NALUs onto CaptionStream
	      * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
	      * Assumes that `parseCaptionNals` has been called first
	      * @see m2ts/caption-stream.js
	      **/
	
	
	    this.pushNals = function (nals) {
	      if (!this.isInitialized() || !nals || nals.length === 0) {
	        return null;
	      }
	
	      nals.forEach(function (nal) {
	        captionStream.push(nal);
	      });
	    };
	    /**
	      * Flushes underlying CaptionStream to dispatch processed, displayable captions
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.flushStream = function () {
	      if (!this.isInitialized()) {
	        return null;
	      }
	
	      if (!parsingPartial) {
	        captionStream.flush();
	      } else {
	        captionStream.partialFlush();
	      }
	    };
	    /**
	      * Reset caption buckets for new data
	     **/
	
	
	    this.clearParsedCaptions = function () {
	      parsedCaptions.captions = [];
	      parsedCaptions.captionStreams = {};
	      parsedCaptions.logs = [];
	    };
	    /**
	      * Resets underlying CaptionStream
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.resetCaptionStream = function () {
	      if (!this.isInitialized()) {
	        return null;
	      }
	
	      captionStream.reset();
	    };
	    /**
	      * Convenience method to clear all captions flushed from the
	      * CaptionStream and still being parsed
	      * @see m2ts/caption-stream.js
	     **/
	
	
	    this.clearAllCaptions = function () {
	      this.clearParsedCaptions();
	      this.resetCaptionStream();
	    };
	    /**
	      * Reset caption parser
	     **/
	
	
	    this.reset = function () {
	      segmentCache = [];
	      trackId = null;
	      timescale = null;
	
	      if (!parsedCaptions) {
	        parsedCaptions = {
	          captions: [],
	          // CC1, CC2, CC3, CC4
	          captionStreams: {},
	          logs: []
	        };
	      } else {
	        this.clearParsedCaptions();
	      }
	
	      this.resetCaptionStream();
	    };
	
	    this.reset();
	  };
	
	  var captionParser = CaptionParser;
	  var toUnsigned = bin.toUnsigned;
	  var toHexString = bin.toHexString;
	  var getUint64 = numbers.getUint64;
	  var timescale, startTime, compositionStartTime, getVideoTrackIds, getTracks, getTimescaleFromMediaHeader;
	  /**
	   * Parses an MP4 initialization segment and extracts the timescale
	   * values for any declared tracks. Timescale values indicate the
	   * number of clock ticks per second to assume for time-based values
	   * elsewhere in the MP4.
	   *
	   * To determine the start time of an MP4, you need two pieces of
	   * information: the timescale unit and the earliest base media decode
	   * time. Multiple timescales can be specified within an MP4 but the
	   * base media decode time is always expressed in the timescale from
	   * the media header box for the track:
	   * ```
	   * moov > trak > mdia > mdhd.timescale
	   * ```
	   * @param init {Uint8Array} the bytes of the init segment
	   * @return {object} a hash of track ids to timescale values or null if
	   * the init segment is malformed.
	   */
	
	  timescale = function timescale(init) {
	    var result = {},
	        traks = findBox_1(init, ['moov', 'trak']); // mdhd timescale
	
	    return traks.reduce(function (result, trak) {
	      var tkhd, version, index, id, mdhd;
	      tkhd = findBox_1(trak, ['tkhd'])[0];
	
	      if (!tkhd) {
	        return null;
	      }
	
	      version = tkhd[0];
	      index = version === 0 ? 12 : 20;
	      id = toUnsigned(tkhd[index] << 24 | tkhd[index + 1] << 16 | tkhd[index + 2] << 8 | tkhd[index + 3]);
	      mdhd = findBox_1(trak, ['mdia', 'mdhd'])[0];
	
	      if (!mdhd) {
	        return null;
	      }
	
	      version = mdhd[0];
	      index = version === 0 ? 12 : 20;
	      result[id] = toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
	      return result;
	    }, result);
	  };
	  /**
	   * Determine the base media decode start time, in seconds, for an MP4
	   * fragment. If multiple fragments are specified, the earliest time is
	   * returned.
	   *
	   * The base media decode time can be parsed from track fragment
	   * metadata:
	   * ```
	   * moof > traf > tfdt.baseMediaDecodeTime
	   * ```
	   * It requires the timescale value from the mdhd to interpret.
	   *
	   * @param timescale {object} a hash of track ids to timescale values.
	   * @return {number} the earliest base media decode start time for the
	   * fragment, in seconds
	   */
	
	
	  startTime = function startTime(timescale, fragment) {
	    var trafs; // we need info from two childrend of each track fragment box
	
	    trafs = findBox_1(fragment, ['moof', 'traf']); // determine the start times for each track
	
	    var lowestTime = trafs.reduce(function (acc, traf) {
	      var tfhd = findBox_1(traf, ['tfhd'])[0]; // get the track id from the tfhd
	
	      var id = toUnsigned(tfhd[4] << 24 | tfhd[5] << 16 | tfhd[6] << 8 | tfhd[7]); // assume a 90kHz clock if no timescale was specified
	
	      var scale = timescale[id] || 90e3; // get the base media decode time from the tfdt
	
	      var tfdt = findBox_1(traf, ['tfdt'])[0];
	      var dv = new DataView(tfdt.buffer, tfdt.byteOffset, tfdt.byteLength);
	      var baseTime; // version 1 is 64 bit
	
	      if (tfdt[0] === 1) {
	        baseTime = getUint64(tfdt.subarray(4, 12));
	      } else {
	        baseTime = dv.getUint32(4);
	      } // convert base time to seconds if it is a valid number.
	
	
	      var seconds;
	
	      if (typeof baseTime === 'bigint') {
	        seconds = baseTime / window_1.BigInt(scale);
	      } else if (typeof baseTime === 'number' && !isNaN(baseTime)) {
	        seconds = baseTime / scale;
	      }
	
	      if (seconds < Number.MAX_SAFE_INTEGER) {
	        seconds = Number(seconds);
	      }
	
	      if (seconds < acc) {
	        acc = seconds;
	      }
	
	      return acc;
	    }, Infinity);
	    return typeof lowestTime === 'bigint' || isFinite(lowestTime) ? lowestTime : 0;
	  };
	  /**
	   * Determine the composition start, in seconds, for an MP4
	   * fragment.
	   *
	   * The composition start time of a fragment can be calculated using the base
	   * media decode time, composition time offset, and timescale, as follows:
	   *
	   * compositionStartTime = (baseMediaDecodeTime + compositionTimeOffset) / timescale
	   *
	   * All of the aforementioned information is contained within a media fragment's
	   * `traf` box, except for timescale info, which comes from the initialization
	   * segment, so a track id (also contained within a `traf`) is also necessary to
	   * associate it with a timescale
	   *
	   *
	   * @param timescales {object} - a hash of track ids to timescale values.
	   * @param fragment {Unit8Array} - the bytes of a media segment
	   * @return {number} the composition start time for the fragment, in seconds
	   **/
	
	
	  compositionStartTime = function compositionStartTime(timescales, fragment) {
	    var trafBoxes = findBox_1(fragment, ['moof', 'traf']);
	    var baseMediaDecodeTime = 0;
	    var compositionTimeOffset = 0;
	    var trackId;
	
	    if (trafBoxes && trafBoxes.length) {
	      // The spec states that track run samples contained within a `traf` box are contiguous, but
	      // it does not explicitly state whether the `traf` boxes themselves are contiguous.
	      // We will assume that they are, so we only need the first to calculate start time.
	      var tfhd = findBox_1(trafBoxes[0], ['tfhd'])[0];
	      var trun = findBox_1(trafBoxes[0], ['trun'])[0];
	      var tfdt = findBox_1(trafBoxes[0], ['tfdt'])[0];
	
	      if (tfhd) {
	        var parsedTfhd = parseTfhd(tfhd);
	        trackId = parsedTfhd.trackId;
	      }
	
	      if (tfdt) {
	        var parsedTfdt = parseTfdt(tfdt);
	        baseMediaDecodeTime = parsedTfdt.baseMediaDecodeTime;
	      }
	
	      if (trun) {
	        var parsedTrun = parseTrun(trun);
	
	        if (parsedTrun.samples && parsedTrun.samples.length) {
	          compositionTimeOffset = parsedTrun.samples[0].compositionTimeOffset || 0;
	        }
	      }
	    } // Get timescale for this specific track. Assume a 90kHz clock if no timescale was
	    // specified.
	
	
	    var timescale = timescales[trackId] || 90e3; // return the composition start time, in seconds
	
	    if (typeof baseMediaDecodeTime === 'bigint') {
	      compositionTimeOffset = window_1.BigInt(compositionTimeOffset);
	      timescale = window_1.BigInt(timescale);
	    }
	
	    var result = (baseMediaDecodeTime + compositionTimeOffset) / timescale;
	
	    if (typeof result === 'bigint' && result < Number.MAX_SAFE_INTEGER) {
	      result = Number(result);
	    }
	
	    return result;
	  };
	  /**
	    * Find the trackIds of the video tracks in this source.
	    * Found by parsing the Handler Reference and Track Header Boxes:
	    *   moov > trak > mdia > hdlr
	    *   moov > trak > tkhd
	    *
	    * @param {Uint8Array} init - The bytes of the init segment for this source
	    * @return {Number[]} A list of trackIds
	    *
	    * @see ISO-BMFF-12/2015, Section 8.4.3
	   **/
	
	
	  getVideoTrackIds = function getVideoTrackIds(init) {
	    var traks = findBox_1(init, ['moov', 'trak']);
	    var videoTrackIds = [];
	    traks.forEach(function (trak) {
	      var hdlrs = findBox_1(trak, ['mdia', 'hdlr']);
	      var tkhds = findBox_1(trak, ['tkhd']);
	      hdlrs.forEach(function (hdlr, index) {
	        var handlerType = parseType_1(hdlr.subarray(8, 12));
	        var tkhd = tkhds[index];
	        var view;
	        var version;
	        var trackId;
	
	        if (handlerType === 'vide') {
	          view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	          version = view.getUint8(0);
	          trackId = version === 0 ? view.getUint32(12) : view.getUint32(20);
	          videoTrackIds.push(trackId);
	        }
	      });
	    });
	    return videoTrackIds;
	  };
	
	  getTimescaleFromMediaHeader = function getTimescaleFromMediaHeader(mdhd) {
	    // mdhd is a FullBox, meaning it will have its own version as the first byte
	    var version = mdhd[0];
	    var index = version === 0 ? 12 : 20;
	    return toUnsigned(mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]);
	  };
	  /**
	   * Get all the video, audio, and hint tracks from a non fragmented
	   * mp4 segment
	   */
	
	
	  getTracks = function getTracks(init) {
	    var traks = findBox_1(init, ['moov', 'trak']);
	    var tracks = [];
	    traks.forEach(function (trak) {
	      var track = {};
	      var tkhd = findBox_1(trak, ['tkhd'])[0];
	      var view, tkhdVersion; // id
	
	      if (tkhd) {
	        view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	        tkhdVersion = view.getUint8(0);
	        track.id = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
	      }
	
	      var hdlr = findBox_1(trak, ['mdia', 'hdlr'])[0]; // type
	
	      if (hdlr) {
	        var type = parseType_1(hdlr.subarray(8, 12));
	
	        if (type === 'vide') {
	          track.type = 'video';
	        } else if (type === 'soun') {
	          track.type = 'audio';
	        } else {
	          track.type = type;
	        }
	      } // codec
	
	
	      var stsd = findBox_1(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];
	
	      if (stsd) {
	        var sampleDescriptions = stsd.subarray(8); // gives the codec type string
	
	        track.codec = parseType_1(sampleDescriptions.subarray(4, 8));
	        var codecBox = findBox_1(sampleDescriptions, [track.codec])[0];
	        var codecConfig, codecConfigType;
	
	        if (codecBox) {
	          // https://tools.ietf.org/html/rfc6381#section-3.3
	          if (/^[asm]vc[1-9]$/i.test(track.codec)) {
	            // we don't need anything but the "config" parameter of the
	            // avc1 codecBox
	            codecConfig = codecBox.subarray(78);
	            codecConfigType = parseType_1(codecConfig.subarray(4, 8));
	
	            if (codecConfigType === 'avcC' && codecConfig.length > 11) {
	              track.codec += '.'; // left padded with zeroes for single digit hex
	              // profile idc
	
	              track.codec += toHexString(codecConfig[9]); // the byte containing the constraint_set flags
	
	              track.codec += toHexString(codecConfig[10]); // level idc
	
	              track.codec += toHexString(codecConfig[11]);
	            } else {
	              // TODO: show a warning that we couldn't parse the codec
	              // and are using the default
	              track.codec = 'avc1.4d400d';
	            }
	          } else if (/^mp4[a,v]$/i.test(track.codec)) {
	            // we do not need anything but the streamDescriptor of the mp4a codecBox
	            codecConfig = codecBox.subarray(28);
	            codecConfigType = parseType_1(codecConfig.subarray(4, 8));
	
	            if (codecConfigType === 'esds' && codecConfig.length > 20 && codecConfig[19] !== 0) {
	              track.codec += '.' + toHexString(codecConfig[19]); // this value is only a single digit
	
	              track.codec += '.' + toHexString(codecConfig[20] >>> 2 & 0x3f).replace(/^0/, '');
	            } else {
	              // TODO: show a warning that we couldn't parse the codec
	              // and are using the default
	              track.codec = 'mp4a.40.2';
	            }
	          } else {
	            // flac, opus, etc
	            track.codec = track.codec.toLowerCase();
	          }
	        }
	      }
	
	      var mdhd = findBox_1(trak, ['mdia', 'mdhd'])[0];
	
	      if (mdhd) {
	        track.timescale = getTimescaleFromMediaHeader(mdhd);
	      }
	
	      tracks.push(track);
	    });
	    return tracks;
	  };
	
	  var probe$2 = {
	    // export mp4 inspector's findBox and parseType for backwards compatibility
	    findBox: findBox_1,
	    parseType: parseType_1,
	    timescale: timescale,
	    startTime: startTime,
	    compositionStartTime: compositionStartTime,
	    videoTrackIds: getVideoTrackIds,
	    tracks: getTracks,
	    getTimescaleFromMediaHeader: getTimescaleFromMediaHeader
	  };
	
	  var parsePid = function parsePid(packet) {
	    var pid = packet[1] & 0x1f;
	    pid <<= 8;
	    pid |= packet[2];
	    return pid;
	  };
	
	  var parsePayloadUnitStartIndicator = function parsePayloadUnitStartIndicator(packet) {
	    return !!(packet[1] & 0x40);
	  };
	
	  var parseAdaptionField = function parseAdaptionField(packet) {
	    var offset = 0; // if an adaption field is present, its length is specified by the
	    // fifth byte of the TS packet header. The adaptation field is
	    // used to add stuffing to PES packets that don't fill a complete
	    // TS packet, and to specify some forms of timing and control data
	    // that we do not currently use.
	
	    if ((packet[3] & 0x30) >>> 4 > 0x01) {
	      offset += packet[4] + 1;
	    }
	
	    return offset;
	  };
	
	  var parseType = function parseType(packet, pmtPid) {
	    var pid = parsePid(packet);
	
	    if (pid === 0) {
	      return 'pat';
	    } else if (pid === pmtPid) {
	      return 'pmt';
	    } else if (pmtPid) {
	      return 'pes';
	    }
	
	    return null;
	  };
	
	  var parsePat = function parsePat(packet) {
	    var pusi = parsePayloadUnitStartIndicator(packet);
	    var offset = 4 + parseAdaptionField(packet);
	
	    if (pusi) {
	      offset += packet[offset] + 1;
	    }
	
	    return (packet[offset + 10] & 0x1f) << 8 | packet[offset + 11];
	  };
	
	  var parsePmt = function parsePmt(packet) {
	    var programMapTable = {};
	    var pusi = parsePayloadUnitStartIndicator(packet);
	    var payloadOffset = 4 + parseAdaptionField(packet);
	
	    if (pusi) {
	      payloadOffset += packet[payloadOffset] + 1;
	    } // PMTs can be sent ahead of the time when they should actually
	    // take effect. We don't believe this should ever be the case
	    // for HLS but we'll ignore "forward" PMT declarations if we see
	    // them. Future PMT declarations have the current_next_indicator
	    // set to zero.
	
	
	    if (!(packet[payloadOffset + 5] & 0x01)) {
	      return;
	    }
	
	    var sectionLength, tableEnd, programInfoLength; // the mapping table ends at the end of the current section
	
	    sectionLength = (packet[payloadOffset + 1] & 0x0f) << 8 | packet[payloadOffset + 2];
	    tableEnd = 3 + sectionLength - 4; // to determine where the table is, we have to figure out how
	    // long the program info descriptors are
	
	    programInfoLength = (packet[payloadOffset + 10] & 0x0f) << 8 | packet[payloadOffset + 11]; // advance the offset to the first entry in the mapping table
	
	    var offset = 12 + programInfoLength;
	
	    while (offset < tableEnd) {
	      var i = payloadOffset + offset; // add an entry that maps the elementary_pid to the stream_type
	
	      programMapTable[(packet[i + 1] & 0x1F) << 8 | packet[i + 2]] = packet[i]; // move to the next table entry
	      // skip past the elementary stream descriptors, if present
	
	      offset += ((packet[i + 3] & 0x0F) << 8 | packet[i + 4]) + 5;
	    }
	
	    return programMapTable;
	  };
	
	  var parsePesType = function parsePesType(packet, programMapTable) {
	    var pid = parsePid(packet);
	    var type = programMapTable[pid];
	
	    switch (type) {
	      case streamTypes.H264_STREAM_TYPE:
	        return 'video';
	
	      case streamTypes.ADTS_STREAM_TYPE:
	        return 'audio';
	
	      case streamTypes.METADATA_STREAM_TYPE:
	        return 'timed-metadata';
	
	      default:
	        return null;
	    }
	  };
	
	  var parsePesTime = function parsePesTime(packet) {
	    var pusi = parsePayloadUnitStartIndicator(packet);
	
	    if (!pusi) {
	      return null;
	    }
	
	    var offset = 4 + parseAdaptionField(packet);
	
	    if (offset >= packet.byteLength) {
	      // From the H 222.0 MPEG-TS spec
	      // "For transport stream packets carrying PES packets, stuffing is needed when there
	      //  is insufficient PES packet data to completely fill the transport stream packet
	      //  payload bytes. Stuffing is accomplished by defining an adaptation field longer than
	      //  the sum of the lengths of the data elements in it, so that the payload bytes
	      //  remaining after the adaptation field exactly accommodates the available PES packet
	      //  data."
	      //
	      // If the offset is >= the length of the packet, then the packet contains no data
	      // and instead is just adaption field stuffing bytes
	      return null;
	    }
	
	    var pes = null;
	    var ptsDtsFlags; // PES packets may be annotated with a PTS value, or a PTS value
	    // and a DTS value. Determine what combination of values is
	    // available to work with.
	
	    ptsDtsFlags = packet[offset + 7]; // PTS and DTS are normally stored as a 33-bit number.  Javascript
	    // performs all bitwise operations on 32-bit integers but javascript
	    // supports a much greater range (52-bits) of integer using standard
	    // mathematical operations.
	    // We construct a 31-bit value using bitwise operators over the 31
	    // most significant bits and then multiply by 4 (equal to a left-shift
	    // of 2) before we add the final 2 least significant bits of the
	    // timestamp (equal to an OR.)
	
	    if (ptsDtsFlags & 0xC0) {
	      pes = {}; // the PTS and DTS are not written out directly. For information
	      // on how they are encoded, see
	      // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	
	      pes.pts = (packet[offset + 9] & 0x0E) << 27 | (packet[offset + 10] & 0xFF) << 20 | (packet[offset + 11] & 0xFE) << 12 | (packet[offset + 12] & 0xFF) << 5 | (packet[offset + 13] & 0xFE) >>> 3;
	      pes.pts *= 4; // Left shift by 2
	
	      pes.pts += (packet[offset + 13] & 0x06) >>> 1; // OR by the two LSBs
	
	      pes.dts = pes.pts;
	
	      if (ptsDtsFlags & 0x40) {
	        pes.dts = (packet[offset + 14] & 0x0E) << 27 | (packet[offset + 15] & 0xFF) << 20 | (packet[offset + 16] & 0xFE) << 12 | (packet[offset + 17] & 0xFF) << 5 | (packet[offset + 18] & 0xFE) >>> 3;
	        pes.dts *= 4; // Left shift by 2
	
	        pes.dts += (packet[offset + 18] & 0x06) >>> 1; // OR by the two LSBs
	      }
	    }
	
	    return pes;
	  };
	
	  var parseNalUnitType = function parseNalUnitType(type) {
	    switch (type) {
	      case 0x05:
	        return 'slice_layer_without_partitioning_rbsp_idr';
	
	      case 0x06:
	        return 'sei_rbsp';
	
	      case 0x07:
	        return 'seq_parameter_set_rbsp';
	
	      case 0x08:
	        return 'pic_parameter_set_rbsp';
	
	      case 0x09:
	        return 'access_unit_delimiter_rbsp';
	
	      default:
	        return null;
	    }
	  };
	
	  var videoPacketContainsKeyFrame = function videoPacketContainsKeyFrame(packet) {
	    var offset = 4 + parseAdaptionField(packet);
	    var frameBuffer = packet.subarray(offset);
	    var frameI = 0;
	    var frameSyncPoint = 0;
	    var foundKeyFrame = false;
	    var nalType; // advance the sync point to a NAL start, if necessary
	
	    for (; frameSyncPoint < frameBuffer.byteLength - 3; frameSyncPoint++) {
	      if (frameBuffer[frameSyncPoint + 2] === 1) {
	        // the sync point is properly aligned
	        frameI = frameSyncPoint + 5;
	        break;
	      }
	    }
	
	    while (frameI < frameBuffer.byteLength) {
	      // look at the current byte to determine if we've hit the end of
	      // a NAL unit boundary
	      switch (frameBuffer[frameI]) {
	        case 0:
	          // skip past non-sync sequences
	          if (frameBuffer[frameI - 1] !== 0) {
	            frameI += 2;
	            break;
	          } else if (frameBuffer[frameI - 2] !== 0) {
	            frameI++;
	            break;
	          }
	
	          if (frameSyncPoint + 3 !== frameI - 2) {
	            nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	
	            if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	              foundKeyFrame = true;
	            }
	          } // drop trailing zeroes
	
	
	          do {
	            frameI++;
	          } while (frameBuffer[frameI] !== 1 && frameI < frameBuffer.length);
	
	          frameSyncPoint = frameI - 2;
	          frameI += 3;
	          break;
	
	        case 1:
	          // skip past non-sync sequences
	          if (frameBuffer[frameI - 1] !== 0 || frameBuffer[frameI - 2] !== 0) {
	            frameI += 3;
	            break;
	          }
	
	          nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	
	          if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	            foundKeyFrame = true;
	          }
	
	          frameSyncPoint = frameI - 2;
	          frameI += 3;
	          break;
	
	        default:
	          // the current byte isn't a one or zero, so it cannot be part
	          // of a sync sequence
	          frameI += 3;
	          break;
	      }
	    }
	
	    frameBuffer = frameBuffer.subarray(frameSyncPoint);
	    frameI -= frameSyncPoint;
	    frameSyncPoint = 0; // parse the final nal
	
	    if (frameBuffer && frameBuffer.byteLength > 3) {
	      nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	
	      if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	        foundKeyFrame = true;
	      }
	    }
	
	    return foundKeyFrame;
	  };
	
	  var probe$1 = {
	    parseType: parseType,
	    parsePat: parsePat,
	    parsePmt: parsePmt,
	    parsePayloadUnitStartIndicator: parsePayloadUnitStartIndicator,
	    parsePesType: parsePesType,
	    parsePesTime: parsePesTime,
	    videoPacketContainsKeyFrame: videoPacketContainsKeyFrame
	  };
	  var handleRollover = timestampRolloverStream.handleRollover;
	  var probe = {};
	  probe.ts = probe$1;
	  probe.aac = utils;
	  var ONE_SECOND_IN_TS = clock.ONE_SECOND_IN_TS;
	  var MP2T_PACKET_LENGTH = 188,
	      // bytes
	  SYNC_BYTE = 0x47;
	  /**
	   * walks through segment data looking for pat and pmt packets to parse out
	   * program map table information
	   */
	
	  var parsePsi_ = function parsePsi_(bytes, pmt) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	        packet,
	        type;
	
	    while (endIndex < bytes.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pat':
	            pmt.pid = probe.ts.parsePat(packet);
	            break;
	
	          case 'pmt':
	            var table = probe.ts.parsePmt(packet);
	            pmt.table = pmt.table || {};
	            Object.keys(table).forEach(function (key) {
	              pmt.table[key] = table[key];
	            });
	            break;
	        }
	
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex++;
	      endIndex++;
	    }
	  };
	  /**
	   * walks through the segment data from the start and end to get timing information
	   * for the first and last audio pes packets
	   */
	
	
	  var parseAudioPes_ = function parseAudioPes_(bytes, pmt, result) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	        packet,
	        type,
	        pesType,
	        pusi,
	        parsed;
	    var endLoop = false; // Start walking from start of segment to get first audio packet
	
	    while (endIndex <= bytes.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'audio' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	
	              if (parsed) {
	                parsed.type = 'audio';
	                result.audio.push(parsed);
	                endLoop = true;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop) {
	          break;
	        }
	
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex++;
	      endIndex++;
	    } // Start walking from end of segment to get last audio packet
	
	
	    endIndex = bytes.byteLength;
	    startIndex = endIndex - MP2T_PACKET_LENGTH;
	    endLoop = false;
	
	    while (startIndex >= 0) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'audio' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	
	              if (parsed) {
	                parsed.type = 'audio';
	                result.audio.push(parsed);
	                endLoop = true;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop) {
	          break;
	        }
	
	        startIndex -= MP2T_PACKET_LENGTH;
	        endIndex -= MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex--;
	      endIndex--;
	    }
	  };
	  /**
	   * walks through the segment data from the start and end to get timing information
	   * for the first and last video pes packets as well as timing information for the first
	   * key frame.
	   */
	
	
	  var parseVideoPes_ = function parseVideoPes_(bytes, pmt, result) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	        packet,
	        type,
	        pesType,
	        pusi,
	        parsed,
	        frame,
	        i,
	        pes;
	    var endLoop = false;
	    var currentFrame = {
	      data: [],
	      size: 0
	    }; // Start walking from start of segment to get first video packet
	
	    while (endIndex < bytes.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'video') {
	              if (pusi && !endLoop) {
	                parsed = probe.ts.parsePesTime(packet);
	
	                if (parsed) {
	                  parsed.type = 'video';
	                  result.video.push(parsed);
	                  endLoop = true;
	                }
	              }
	
	              if (!result.firstKeyFrame) {
	                if (pusi) {
	                  if (currentFrame.size !== 0) {
	                    frame = new Uint8Array(currentFrame.size);
	                    i = 0;
	
	                    while (currentFrame.data.length) {
	                      pes = currentFrame.data.shift();
	                      frame.set(pes, i);
	                      i += pes.byteLength;
	                    }
	
	                    if (probe.ts.videoPacketContainsKeyFrame(frame)) {
	                      var firstKeyFrame = probe.ts.parsePesTime(frame); // PTS/DTS may not be available. Simply *not* setting
	                      // the keyframe seems to work fine with HLS playback
	                      // and definitely preferable to a crash with TypeError...
	
	                      if (firstKeyFrame) {
	                        result.firstKeyFrame = firstKeyFrame;
	                        result.firstKeyFrame.type = 'video';
	                      } else {
	                        // eslint-disable-next-line
	                        console.warn('Failed to extract PTS/DTS from PES at first keyframe. ' + 'This could be an unusual TS segment, or else mux.js did not ' + 'parse your TS segment correctly. If you know your TS ' + 'segments do contain PTS/DTS on keyframes please file a bug ' + 'report! You can try ffprobe to double check for yourself.');
	                      }
	                    }
	
	                    currentFrame.size = 0;
	                  }
	                }
	
	                currentFrame.data.push(packet);
	                currentFrame.size += packet.byteLength;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop && result.firstKeyFrame) {
	          break;
	        }
	
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex++;
	      endIndex++;
	    } // Start walking from end of segment to get last video packet
	
	
	    endIndex = bytes.byteLength;
	    startIndex = endIndex - MP2T_PACKET_LENGTH;
	    endLoop = false;
	
	    while (startIndex >= 0) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	        // We found a packet
	        packet = bytes.subarray(startIndex, endIndex);
	        type = probe.ts.parseType(packet, pmt.pid);
	
	        switch (type) {
	          case 'pes':
	            pesType = probe.ts.parsePesType(packet, pmt.table);
	            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	
	            if (pesType === 'video' && pusi) {
	              parsed = probe.ts.parsePesTime(packet);
	
	              if (parsed) {
	                parsed.type = 'video';
	                result.video.push(parsed);
	                endLoop = true;
	              }
	            }
	
	            break;
	        }
	
	        if (endLoop) {
	          break;
	        }
	
	        startIndex -= MP2T_PACKET_LENGTH;
	        endIndex -= MP2T_PACKET_LENGTH;
	        continue;
	      } // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	
	
	      startIndex--;
	      endIndex--;
	    }
	  };
	  /**
	   * Adjusts the timestamp information for the segment to account for
	   * rollover and convert to seconds based on pes packet timescale (90khz clock)
	   */
	
	
	  var adjustTimestamp_ = function adjustTimestamp_(segmentInfo, baseTimestamp) {
	    if (segmentInfo.audio && segmentInfo.audio.length) {
	      var audioBaseTimestamp = baseTimestamp;
	
	      if (typeof audioBaseTimestamp === 'undefined' || isNaN(audioBaseTimestamp)) {
	        audioBaseTimestamp = segmentInfo.audio[0].dts;
	      }
	
	      segmentInfo.audio.forEach(function (info) {
	        info.dts = handleRollover(info.dts, audioBaseTimestamp);
	        info.pts = handleRollover(info.pts, audioBaseTimestamp); // time in seconds
	
	        info.dtsTime = info.dts / ONE_SECOND_IN_TS;
	        info.ptsTime = info.pts / ONE_SECOND_IN_TS;
	      });
	    }
	
	    if (segmentInfo.video && segmentInfo.video.length) {
	      var videoBaseTimestamp = baseTimestamp;
	
	      if (typeof videoBaseTimestamp === 'undefined' || isNaN(videoBaseTimestamp)) {
	        videoBaseTimestamp = segmentInfo.video[0].dts;
	      }
	
	      segmentInfo.video.forEach(function (info) {
	        info.dts = handleRollover(info.dts, videoBaseTimestamp);
	        info.pts = handleRollover(info.pts, videoBaseTimestamp); // time in seconds
	
	        info.dtsTime = info.dts / ONE_SECOND_IN_TS;
	        info.ptsTime = info.pts / ONE_SECOND_IN_TS;
	      });
	
	      if (segmentInfo.firstKeyFrame) {
	        var frame = segmentInfo.firstKeyFrame;
	        frame.dts = handleRollover(frame.dts, videoBaseTimestamp);
	        frame.pts = handleRollover(frame.pts, videoBaseTimestamp); // time in seconds
	
	        frame.dtsTime = frame.dts / ONE_SECOND_IN_TS;
	        frame.ptsTime = frame.pts / ONE_SECOND_IN_TS;
	      }
	    }
	  };
	  /**
	   * inspects the aac data stream for start and end time information
	   */
	
	
	  var inspectAac_ = function inspectAac_(bytes) {
	    var endLoop = false,
	        audioCount = 0,
	        sampleRate = null,
	        timestamp = null,
	        frameSize = 0,
	        byteIndex = 0,
	        packet;
	
	    while (bytes.length - byteIndex >= 3) {
	      var type = probe.aac.parseType(bytes, byteIndex);
	
	      switch (type) {
	        case 'timed-metadata':
	          // Exit early because we don't have enough to parse
	          // the ID3 tag header
	          if (bytes.length - byteIndex < 10) {
	            endLoop = true;
	            break;
	          }
	
	          frameSize = probe.aac.parseId3TagSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	
	          if (frameSize > bytes.length) {
	            endLoop = true;
	            break;
	          }
	
	          if (timestamp === null) {
	            packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	            timestamp = probe.aac.parseAacTimestamp(packet);
	          }
	
	          byteIndex += frameSize;
	          break;
	
	        case 'audio':
	          // Exit early because we don't have enough to parse
	          // the ADTS frame header
	          if (bytes.length - byteIndex < 7) {
	            endLoop = true;
	            break;
	          }
	
	          frameSize = probe.aac.parseAdtsSize(bytes, byteIndex); // Exit early if we don't have enough in the buffer
	          // to emit a full packet
	
	          if (frameSize > bytes.length) {
	            endLoop = true;
	            break;
	          }
	
	          if (sampleRate === null) {
	            packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	            sampleRate = probe.aac.parseSampleRate(packet);
	          }
	
	          audioCount++;
	          byteIndex += frameSize;
	          break;
	
	        default:
	          byteIndex++;
	          break;
	      }
	
	      if (endLoop) {
	        return null;
	      }
	    }
	
	    if (sampleRate === null || timestamp === null) {
	      return null;
	    }
	
	    var audioTimescale = ONE_SECOND_IN_TS / sampleRate;
	    var result = {
	      audio: [{
	        type: 'audio',
	        dts: timestamp,
	        pts: timestamp
	      }, {
	        type: 'audio',
	        dts: timestamp + audioCount * 1024 * audioTimescale,
	        pts: timestamp + audioCount * 1024 * audioTimescale
	      }]
	    };
	    return result;
	  };
	  /**
	   * inspects the transport stream segment data for start and end time information
	   * of the audio and video tracks (when present) as well as the first key frame's
	   * start time.
	   */
	
	
	  var inspectTs_ = function inspectTs_(bytes) {
	    var pmt = {
	      pid: null,
	      table: null
	    };
	    var result = {};
	    parsePsi_(bytes, pmt);
	
	    for (var pid in pmt.table) {
	      if (pmt.table.hasOwnProperty(pid)) {
	        var type = pmt.table[pid];
	
	        switch (type) {
	          case streamTypes.H264_STREAM_TYPE:
	            result.video = [];
	            parseVideoPes_(bytes, pmt, result);
	
	            if (result.video.length === 0) {
	              delete result.video;
	            }
	
	            break;
	
	          case streamTypes.ADTS_STREAM_TYPE:
	            result.audio = [];
	            parseAudioPes_(bytes, pmt, result);
	
	            if (result.audio.length === 0) {
	              delete result.audio;
	            }
	
	            break;
	        }
	      }
	    }
	
	    return result;
	  };
	  /**
	   * Inspects segment byte data and returns an object with start and end timing information
	   *
	   * @param {Uint8Array} bytes The segment byte data
	   * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
	   *  timestamps for rollover. This value must be in 90khz clock.
	   * @return {Object} Object containing start and end frame timing info of segment.
	   */
	
	
	  var inspect = function inspect(bytes, baseTimestamp) {
	    var isAacData = probe.aac.isLikelyAacData(bytes);
	    var result;
	
	    if (isAacData) {
	      result = inspectAac_(bytes);
	    } else {
	      result = inspectTs_(bytes);
	    }
	
	    if (!result || !result.audio && !result.video) {
	      return null;
	    }
	
	    adjustTimestamp_(result, baseTimestamp);
	    return result;
	  };
	
	  var tsInspector = {
	    inspect: inspect,
	    parseAudioPes_: parseAudioPes_
	  };
	  /* global self */
	
	  /**
	   * Re-emits transmuxer events by converting them into messages to the
	   * world outside the worker.
	   *
	   * @param {Object} transmuxer the transmuxer to wire events on
	   * @private
	   */
	
	  var wireTransmuxerEvents = function wireTransmuxerEvents(self, transmuxer) {
	    transmuxer.on('data', function (segment) {
	      // transfer ownership of the underlying ArrayBuffer
	      // instead of doing a copy to save memory
	      // ArrayBuffers are transferable but generic TypedArrays are not
	      // @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Passing_data_by_transferring_ownership_(transferable_objects)
	      var initArray = segment.initSegment;
	      segment.initSegment = {
	        data: initArray.buffer,
	        byteOffset: initArray.byteOffset,
	        byteLength: initArray.byteLength
	      };
	      var typedArray = segment.data;
	      segment.data = typedArray.buffer;
	      self.postMessage({
	        action: 'data',
	        segment: segment,
	        byteOffset: typedArray.byteOffset,
	        byteLength: typedArray.byteLength
	      }, [segment.data]);
	    });
	    transmuxer.on('done', function (data) {
	      self.postMessage({
	        action: 'done'
	      });
	    });
	    transmuxer.on('gopInfo', function (gopInfo) {
	      self.postMessage({
	        action: 'gopInfo',
	        gopInfo: gopInfo
	      });
	    });
	    transmuxer.on('videoSegmentTimingInfo', function (timingInfo) {
	      var videoSegmentTimingInfo = {
	        start: {
	          decode: clock.videoTsToSeconds(timingInfo.start.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.start.pts)
	        },
	        end: {
	          decode: clock.videoTsToSeconds(timingInfo.end.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.end.pts)
	        },
	        baseMediaDecodeTime: clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
	      };
	
	      if (timingInfo.prependedContentDuration) {
	        videoSegmentTimingInfo.prependedContentDuration = clock.videoTsToSeconds(timingInfo.prependedContentDuration);
	      }
	
	      self.postMessage({
	        action: 'videoSegmentTimingInfo',
	        videoSegmentTimingInfo: videoSegmentTimingInfo
	      });
	    });
	    transmuxer.on('audioSegmentTimingInfo', function (timingInfo) {
	      // Note that all times for [audio/video]SegmentTimingInfo events are in video clock
	      var audioSegmentTimingInfo = {
	        start: {
	          decode: clock.videoTsToSeconds(timingInfo.start.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.start.pts)
	        },
	        end: {
	          decode: clock.videoTsToSeconds(timingInfo.end.dts),
	          presentation: clock.videoTsToSeconds(timingInfo.end.pts)
	        },
	        baseMediaDecodeTime: clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
	      };
	
	      if (timingInfo.prependedContentDuration) {
	        audioSegmentTimingInfo.prependedContentDuration = clock.videoTsToSeconds(timingInfo.prependedContentDuration);
	      }
	
	      self.postMessage({
	        action: 'audioSegmentTimingInfo',
	        audioSegmentTimingInfo: audioSegmentTimingInfo
	      });
	    });
	    transmuxer.on('id3Frame', function (id3Frame) {
	      self.postMessage({
	        action: 'id3Frame',
	        id3Frame: id3Frame
	      });
	    });
	    transmuxer.on('caption', function (caption) {
	      self.postMessage({
	        action: 'caption',
	        caption: caption
	      });
	    });
	    transmuxer.on('trackinfo', function (trackInfo) {
	      self.postMessage({
	        action: 'trackinfo',
	        trackInfo: trackInfo
	      });
	    });
	    transmuxer.on('audioTimingInfo', function (audioTimingInfo) {
	      // convert to video TS since we prioritize video time over audio
	      self.postMessage({
	        action: 'audioTimingInfo',
	        audioTimingInfo: {
	          start: clock.videoTsToSeconds(audioTimingInfo.start),
	          end: clock.videoTsToSeconds(audioTimingInfo.end)
	        }
	      });
	    });
	    transmuxer.on('videoTimingInfo', function (videoTimingInfo) {
	      self.postMessage({
	        action: 'videoTimingInfo',
	        videoTimingInfo: {
	          start: clock.videoTsToSeconds(videoTimingInfo.start),
	          end: clock.videoTsToSeconds(videoTimingInfo.end)
	        }
	      });
	    });
	    transmuxer.on('log', function (log) {
	      self.postMessage({
	        action: 'log',
	        log: log
	      });
	    });
	  };
	  /**
	   * All incoming messages route through this hash. If no function exists
	   * to handle an incoming message, then we ignore the message.
	   *
	   * @class MessageHandlers
	   * @param {Object} options the options to initialize with
	   */
	
	
	  var MessageHandlers = /*#__PURE__*/function () {
	    function MessageHandlers(self, options) {
	      this.options = options || {};
	      this.self = self;
	      this.init();
	    }
	    /**
	     * initialize our web worker and wire all the events.
	     */
	
	
	    var _proto = MessageHandlers.prototype;
	
	    _proto.init = function init() {
	      if (this.transmuxer) {
	        this.transmuxer.dispose();
	      }
	
	      this.transmuxer = new transmuxer.Transmuxer(this.options);
	      wireTransmuxerEvents(this.self, this.transmuxer);
	    };
	
	    _proto.pushMp4Captions = function pushMp4Captions(data) {
	      if (!this.captionParser) {
	        this.captionParser = new captionParser();
	        this.captionParser.init();
	      }
	
	      var segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
	      var parsed = this.captionParser.parse(segment, data.trackIds, data.timescales);
	      this.self.postMessage({
	        action: 'mp4Captions',
	        captions: parsed && parsed.captions || [],
	        logs: parsed && parsed.logs || [],
	        data: segment.buffer
	      }, [segment.buffer]);
	    };
	
	    _proto.probeMp4StartTime = function probeMp4StartTime(_ref) {
	      var timescales = _ref.timescales,
	          data = _ref.data;
	      var startTime = probe$2.startTime(timescales, data);
	      this.self.postMessage({
	        action: 'probeMp4StartTime',
	        startTime: startTime,
	        data: data
	      }, [data.buffer]);
	    };
	
	    _proto.probeMp4Tracks = function probeMp4Tracks(_ref2) {
	      var data = _ref2.data;
	      var tracks = probe$2.tracks(data);
	      this.self.postMessage({
	        action: 'probeMp4Tracks',
	        tracks: tracks,
	        data: data
	      }, [data.buffer]);
	    }
	    /**
	     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
	     * internal "media time," as well as whether it contains video and/or audio.
	     *
	     * @private
	     * @param {Uint8Array} bytes - segment bytes
	     * @param {number} baseStartTime
	     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
	     *        This value should be in seconds, as it's converted to a 90khz clock within the
	     *        function body.
	     * @return {Object} The start time of the current segment in "media time" as well as
	     *                  whether it contains video and/or audio
	     */
	    ;
	
	    _proto.probeTs = function probeTs(_ref3) {
	      var data = _ref3.data,
	          baseStartTime = _ref3.baseStartTime;
	      var tsStartTime = typeof baseStartTime === 'number' && !isNaN(baseStartTime) ? baseStartTime * clock.ONE_SECOND_IN_TS : void 0;
	      var timeInfo = tsInspector.inspect(data, tsStartTime);
	      var result = null;
	
	      if (timeInfo) {
	        result = {
	          // each type's time info comes back as an array of 2 times, start and end
	          hasVideo: timeInfo.video && timeInfo.video.length === 2 || false,
	          hasAudio: timeInfo.audio && timeInfo.audio.length === 2 || false
	        };
	
	        if (result.hasVideo) {
	          result.videoStart = timeInfo.video[0].ptsTime;
	        }
	
	        if (result.hasAudio) {
	          result.audioStart = timeInfo.audio[0].ptsTime;
	        }
	      }
	
	      this.self.postMessage({
	        action: 'probeTs',
	        result: result,
	        data: data
	      }, [data.buffer]);
	    };
	
	    _proto.clearAllMp4Captions = function clearAllMp4Captions() {
	      if (this.captionParser) {
	        this.captionParser.clearAllCaptions();
	      }
	    };
	
	    _proto.clearParsedMp4Captions = function clearParsedMp4Captions() {
	      if (this.captionParser) {
	        this.captionParser.clearParsedCaptions();
	      }
	    }
	    /**
	     * Adds data (a ts segment) to the start of the transmuxer pipeline for
	     * processing.
	     *
	     * @param {ArrayBuffer} data data to push into the muxer
	     */
	    ;
	
	    _proto.push = function push(data) {
	      // Cast array buffer to correct type for transmuxer
	      var segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
	      this.transmuxer.push(segment);
	    }
	    /**
	     * Recreate the transmuxer so that the next segment added via `push`
	     * start with a fresh transmuxer.
	     */
	    ;
	
	    _proto.reset = function reset() {
	      this.transmuxer.reset();
	    }
	    /**
	     * Set the value that will be used as the `baseMediaDecodeTime` time for the
	     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
	     * set relative to the first based on the PTS values.
	     *
	     * @param {Object} data used to set the timestamp offset in the muxer
	     */
	    ;
	
	    _proto.setTimestampOffset = function setTimestampOffset(data) {
	      var timestampOffset = data.timestampOffset || 0;
	      this.transmuxer.setBaseMediaDecodeTime(Math.round(clock.secondsToVideoTs(timestampOffset)));
	    };
	
	    _proto.setAudioAppendStart = function setAudioAppendStart(data) {
	      this.transmuxer.setAudioAppendStart(Math.ceil(clock.secondsToVideoTs(data.appendStart)));
	    };
	
	    _proto.setRemux = function setRemux(data) {
	      this.transmuxer.setRemux(data.remux);
	    }
	    /**
	     * Forces the pipeline to finish processing the last segment and emit it's
	     * results.
	     *
	     * @param {Object} data event data, not really used
	     */
	    ;
	
	    _proto.flush = function flush(data) {
	      this.transmuxer.flush(); // transmuxed done action is fired after both audio/video pipelines are flushed
	
	      self.postMessage({
	        action: 'done',
	        type: 'transmuxed'
	      });
	    };
	
	    _proto.endTimeline = function endTimeline() {
	      this.transmuxer.endTimeline(); // transmuxed endedtimeline action is fired after both audio/video pipelines end their
	      // timelines
	
	      self.postMessage({
	        action: 'endedtimeline',
	        type: 'transmuxed'
	      });
	    };
	
	    _proto.alignGopsWith = function alignGopsWith(data) {
	      this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());
	    };
	
	    return MessageHandlers;
	  }();
	  /**
	   * Our web worker interface so that things can talk to mux.js
	   * that will be running in a web worker. the scope is passed to this by
	   * webworkify.
	   *
	   * @param {Object} self the scope for the web worker
	   */
	
	
	  self.onmessage = function (event) {
	    if (event.data.action === 'init' && event.data.options) {
	      this.messageHandlers = new MessageHandlers(self, event.data.options);
	      return;
	    }
	
	    if (!this.messageHandlers) {
	      this.messageHandlers = new MessageHandlers(self);
	    }
	
	    if (event.data && event.data.action && event.data.action !== 'init') {
	      if (this.messageHandlers[event.data.action]) {
	        this.messageHandlers[event.data.action](event.data);
	      }
	    }
	  };
	}));
	var TransmuxWorker = factory(workerCode$1);
	/* rollup-plugin-worker-factory end for worker!/Users/ddashkevich/projects/http-streaming/src/transmuxer-worker.js */
	
	var handleData_ = function handleData_(event, transmuxedData, callback) {
	  var _event$data$segment = event.data.segment,
	      type = _event$data$segment.type,
	      initSegment = _event$data$segment.initSegment,
	      captions = _event$data$segment.captions,
	      captionStreams = _event$data$segment.captionStreams,
	      metadata = _event$data$segment.metadata,
	      videoFrameDtsTime = _event$data$segment.videoFrameDtsTime,
	      videoFramePtsTime = _event$data$segment.videoFramePtsTime;
	  transmuxedData.buffer.push({
	    captions: captions,
	    captionStreams: captionStreams,
	    metadata: metadata
	  });
	  var boxes = event.data.segment.boxes || {
	    data: event.data.segment.data
	  };
	  var result = {
	    type: type,
	    // cast ArrayBuffer to TypedArray
	    data: new Uint8Array(boxes.data, boxes.data.byteOffset, boxes.data.byteLength),
	    initSegment: new Uint8Array(initSegment.data, initSegment.byteOffset, initSegment.byteLength)
	  };
	
	  if (typeof videoFrameDtsTime !== 'undefined') {
	    result.videoFrameDtsTime = videoFrameDtsTime;
	  }
	
	  if (typeof videoFramePtsTime !== 'undefined') {
	    result.videoFramePtsTime = videoFramePtsTime;
	  }
	
	  callback(result);
	};
	
	var handleDone_ = function handleDone_(_ref) {
	  var transmuxedData = _ref.transmuxedData,
	      callback = _ref.callback; // Previously we only returned data on data events,
	  // not on done events. Clear out the buffer to keep that consistent.
	
	  transmuxedData.buffer = []; // all buffers should have been flushed from the muxer, so start processing anything we
	  // have received
	
	  callback(transmuxedData);
	};
	
	var handleGopInfo_ = function handleGopInfo_(event, transmuxedData) {
	  transmuxedData.gopInfo = event.data.gopInfo;
	};
	
	var processTransmux = function processTransmux(options) {
	  var transmuxer = options.transmuxer,
	      bytes = options.bytes,
	      audioAppendStart = options.audioAppendStart,
	      gopsToAlignWith = options.gopsToAlignWith,
	      remux = options.remux,
	      onData = options.onData,
	      onTrackInfo = options.onTrackInfo,
	      onAudioTimingInfo = options.onAudioTimingInfo,
	      onVideoTimingInfo = options.onVideoTimingInfo,
	      onVideoSegmentTimingInfo = options.onVideoSegmentTimingInfo,
	      onAudioSegmentTimingInfo = options.onAudioSegmentTimingInfo,
	      onId3 = options.onId3,
	      onCaptions = options.onCaptions,
	      onDone = options.onDone,
	      onEndedTimeline = options.onEndedTimeline,
	      onTransmuxerLog = options.onTransmuxerLog,
	      isEndOfTimeline = options.isEndOfTimeline;
	  var transmuxedData = {
	    buffer: []
	  };
	  var waitForEndedTimelineEvent = isEndOfTimeline;
	
	  var handleMessage = function handleMessage(event) {
	    if (transmuxer.currentTransmux !== options) {
	      // disposed
	      return;
	    }
	
	    if (event.data.action === 'data') {
	      handleData_(event, transmuxedData, onData);
	    }
	
	    if (event.data.action === 'trackinfo') {
	      onTrackInfo(event.data.trackInfo);
	    }
	
	    if (event.data.action === 'gopInfo') {
	      handleGopInfo_(event, transmuxedData);
	    }
	
	    if (event.data.action === 'audioTimingInfo') {
	      onAudioTimingInfo(event.data.audioTimingInfo);
	    }
	
	    if (event.data.action === 'videoTimingInfo') {
	      onVideoTimingInfo(event.data.videoTimingInfo);
	    }
	
	    if (event.data.action === 'videoSegmentTimingInfo') {
	      onVideoSegmentTimingInfo(event.data.videoSegmentTimingInfo);
	    }
	
	    if (event.data.action === 'audioSegmentTimingInfo') {
	      onAudioSegmentTimingInfo(event.data.audioSegmentTimingInfo);
	    }
	
	    if (event.data.action === 'id3Frame') {
	      onId3([event.data.id3Frame], event.data.id3Frame.dispatchType);
	    }
	
	    if (event.data.action === 'caption') {
	      onCaptions(event.data.caption);
	    }
	
	    if (event.data.action === 'endedtimeline') {
	      waitForEndedTimelineEvent = false;
	      onEndedTimeline();
	    }
	
	    if (event.data.action === 'log') {
	      onTransmuxerLog(event.data.log);
	    } // wait for the transmuxed event since we may have audio and video
	
	
	    if (event.data.type !== 'transmuxed') {
	      return;
	    } // If the "endedtimeline" event has not yet fired, and this segment represents the end
	    // of a timeline, that means there may still be data events before the segment
	    // processing can be considerred complete. In that case, the final event should be
	    // an "endedtimeline" event with the type "transmuxed."
	
	
	    if (waitForEndedTimelineEvent) {
	      return;
	    }
	
	    transmuxer.onmessage = null;
	    handleDone_({
	      transmuxedData: transmuxedData,
	      callback: onDone
	    });
	    /* eslint-disable no-use-before-define */
	
	    dequeue(transmuxer);
	    /* eslint-enable */
	  };
	
	  transmuxer.onmessage = handleMessage;
	
	  if (audioAppendStart) {
	    transmuxer.postMessage({
	      action: 'setAudioAppendStart',
	      appendStart: audioAppendStart
	    });
	  } // allow empty arrays to be passed to clear out GOPs
	
	
	  if (Array.isArray(gopsToAlignWith)) {
	    transmuxer.postMessage({
	      action: 'alignGopsWith',
	      gopsToAlignWith: gopsToAlignWith
	    });
	  }
	
	  if (typeof remux !== 'undefined') {
	    transmuxer.postMessage({
	      action: 'setRemux',
	      remux: remux
	    });
	  }
	
	  if (bytes.byteLength) {
	    var buffer = bytes instanceof ArrayBuffer ? bytes : bytes.buffer;
	    var byteOffset = bytes instanceof ArrayBuffer ? 0 : bytes.byteOffset;
	    transmuxer.postMessage({
	      action: 'push',
	      // Send the typed-array of data as an ArrayBuffer so that
	      // it can be sent as a "Transferable" and avoid the costly
	      // memory copy
	      data: buffer,
	      // To recreate the original typed-array, we need information
	      // about what portion of the ArrayBuffer it was a view into
	      byteOffset: byteOffset,
	      byteLength: bytes.byteLength
	    }, [buffer]);
	  }
	
	  if (isEndOfTimeline) {
	    transmuxer.postMessage({
	      action: 'endTimeline'
	    });
	  } // even if we didn't push any bytes, we have to make sure we flush in case we reached
	  // the end of the segment
	
	
	  transmuxer.postMessage({
	    action: 'flush'
	  });
	};
	
	var dequeue = function dequeue(transmuxer) {
	  transmuxer.currentTransmux = null;
	
	  if (transmuxer.transmuxQueue.length) {
	    transmuxer.currentTransmux = transmuxer.transmuxQueue.shift();
	
	    if (typeof transmuxer.currentTransmux === 'function') {
	      transmuxer.currentTransmux();
	    } else {
	      processTransmux(transmuxer.currentTransmux);
	    }
	  }
	};
	
	var processAction = function processAction(transmuxer, action) {
	  transmuxer.postMessage({
	    action: action
	  });
	  dequeue(transmuxer);
	};
	
	var enqueueAction = function enqueueAction(action, transmuxer) {
	  if (!transmuxer.currentTransmux) {
	    transmuxer.currentTransmux = action;
	    processAction(transmuxer, action);
	    return;
	  }
	
	  transmuxer.transmuxQueue.push(processAction.bind(null, transmuxer, action));
	};
	
	var reset = function reset(transmuxer) {
	  enqueueAction('reset', transmuxer);
	};
	
	var endTimeline = function endTimeline(transmuxer) {
	  enqueueAction('endTimeline', transmuxer);
	};
	
	var transmux = function transmux(options) {
	  if (!options.transmuxer.currentTransmux) {
	    options.transmuxer.currentTransmux = options;
	    processTransmux(options);
	    return;
	  }
	
	  options.transmuxer.transmuxQueue.push(options);
	};
	
	var createTransmuxer = function createTransmuxer(options) {
	  var transmuxer = new TransmuxWorker();
	  transmuxer.currentTransmux = null;
	  transmuxer.transmuxQueue = [];
	  var term = transmuxer.terminate;
	
	  transmuxer.terminate = function () {
	    transmuxer.currentTransmux = null;
	    transmuxer.transmuxQueue.length = 0;
	    return term.call(transmuxer);
	  };
	
	  transmuxer.postMessage({
	    action: 'init',
	    options: options
	  });
	  return transmuxer;
	};
	
	var segmentTransmuxer = {
	  reset: reset,
	  endTimeline: endTimeline,
	  transmux: transmux,
	  createTransmuxer: createTransmuxer
	};
	
	var workerCallback = function workerCallback(options) {
	  var transmuxer = options.transmuxer;
	  var endAction = options.endAction || options.action;
	  var callback = options.callback;
	
	  var message = _extends__default['default']({}, options, {
	    endAction: null,
	    transmuxer: null,
	    callback: null
	  });
	
	  var listenForEndEvent = function listenForEndEvent(event) {
	    if (event.data.action !== endAction) {
	      return;
	    }
	
	    transmuxer.removeEventListener('message', listenForEndEvent); // transfer ownership of bytes back to us.
	
	    if (event.data.data) {
	      event.data.data = new Uint8Array(event.data.data, options.byteOffset || 0, options.byteLength || event.data.data.byteLength);
	
	      if (options.data) {
	        options.data = event.data.data;
	      }
	    }
	
	    callback(event.data);
	  };
	
	  transmuxer.addEventListener('message', listenForEndEvent);
	
	  if (options.data) {
	    var isArrayBuffer = options.data instanceof ArrayBuffer;
	    message.byteOffset = isArrayBuffer ? 0 : options.data.byteOffset;
	    message.byteLength = options.data.byteLength;
	    var transfers = [isArrayBuffer ? options.data : options.data.buffer];
	    transmuxer.postMessage(message, transfers);
	  } else {
	    transmuxer.postMessage(message);
	  }
	};
	
	var REQUEST_ERRORS = {
	  FAILURE: 2,
	  TIMEOUT: -101,
	  ABORTED: -102
	};
	/**
	 * Abort all requests
	 *
	 * @param {Object} activeXhrs - an object that tracks all XHR requests
	 */
	
	var abortAll = function abortAll(activeXhrs) {
	  activeXhrs.forEach(function (xhr) {
	    xhr.abort();
	  });
	};
	/**
	 * Gather important bandwidth stats once a request has completed
	 *
	 * @param {Object} request - the XHR request from which to gather stats
	 */
	
	
	var getRequestStats = function getRequestStats(request) {
	  return {
	    bandwidth: request.bandwidth,
	    bytesReceived: request.bytesReceived || 0,
	    roundTripTime: request.roundTripTime || 0
	  };
	};
	/**
	 * If possible gather bandwidth stats as a request is in
	 * progress
	 *
	 * @param {Event} progressEvent - an event object from an XHR's progress event
	 */
	
	
	var getProgressStats = function getProgressStats(progressEvent) {
	  var request = progressEvent.target;
	  var roundTripTime = Date.now() - request.requestTime;
	  var stats = {
	    bandwidth: Infinity,
	    bytesReceived: 0,
	    roundTripTime: roundTripTime || 0
	  };
	  stats.bytesReceived = progressEvent.loaded; // This can result in Infinity if stats.roundTripTime is 0 but that is ok
	  // because we should only use bandwidth stats on progress to determine when
	  // abort a request early due to insufficient bandwidth
	
	  stats.bandwidth = Math.floor(stats.bytesReceived / stats.roundTripTime * 8 * 1000);
	  return stats;
	};
	/**
	 * Handle all error conditions in one place and return an object
	 * with all the information
	 *
	 * @param {Error|null} error - if non-null signals an error occured with the XHR
	 * @param {Object} request -  the XHR request that possibly generated the error
	 */
	
	
	var handleErrors = function handleErrors(error, request) {
	  if (request.timedout) {
	    return {
	      status: request.status,
	      message: 'HLS request timed-out at URL: ' + request.uri,
	      code: REQUEST_ERRORS.TIMEOUT,
	      xhr: request
	    };
	  }
	
	  if (request.aborted) {
	    return {
	      status: request.status,
	      message: 'HLS request aborted at URL: ' + request.uri,
	      code: REQUEST_ERRORS.ABORTED,
	      xhr: request
	    };
	  }
	
	  if (error) {
	    return {
	      status: request.status,
	      message: 'HLS request errored at URL: ' + request.uri,
	      code: REQUEST_ERRORS.FAILURE,
	      xhr: request
	    };
	  }
	
	  if (request.responseType === 'arraybuffer' && request.response.byteLength === 0) {
	    return {
	      status: request.status,
	      message: 'Empty HLS response at URL: ' + request.uri,
	      code: REQUEST_ERRORS.FAILURE,
	      xhr: request
	    };
	  }
	
	  return null;
	};
	/**
	 * Handle responses for key data and convert the key data to the correct format
	 * for the decryption step later
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Array} objects - objects to add the key bytes to.
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	
	
	var handleKeyResponse = function handleKeyResponse(segment, objects, finishProcessingFn) {
	  return function (error, request) {
	    var response = request.response;
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    if (response.byteLength !== 16) {
	      return finishProcessingFn({
	        status: request.status,
	        message: 'Invalid HLS key at URL: ' + request.uri,
	        code: REQUEST_ERRORS.FAILURE,
	        xhr: request
	      }, segment);
	    }
	
	    var view = new DataView(response);
	    var bytes = new Uint32Array([view.getUint32(0), view.getUint32(4), view.getUint32(8), view.getUint32(12)]);
	
	    for (var i = 0; i < objects.length; i++) {
	      objects[i].bytes = bytes;
	    }
	
	    return finishProcessingFn(null, segment);
	  };
	};
	
	var parseInitSegment = function parseInitSegment(segment, _callback) {
	  var type = containers.detectContainerForBytes(segment.map.bytes); // TODO: We should also handle ts init segments here, but we
	  // only know how to parse mp4 init segments at the moment
	
	  if (type !== 'mp4') {
	    var uri = segment.map.resolvedUri || segment.map.uri;
	    return _callback({
	      internal: true,
	      message: "Found unsupported " + (type || 'unknown') + " container for initialization segment at URL: " + uri,
	      code: REQUEST_ERRORS.FAILURE
	    });
	  }
	
	  workerCallback({
	    action: 'probeMp4Tracks',
	    data: segment.map.bytes,
	    transmuxer: segment.transmuxer,
	    callback: function callback(_ref) {
	      var tracks = _ref.tracks,
	          data = _ref.data; // transfer bytes back to us
	
	      segment.map.bytes = data;
	      tracks.forEach(function (track) {
	        segment.map.tracks = segment.map.tracks || {}; // only support one track of each type for now
	
	        if (segment.map.tracks[track.type]) {
	          return;
	        }
	
	        segment.map.tracks[track.type] = track;
	
	        if (typeof track.id === 'number' && track.timescale) {
	          segment.map.timescales = segment.map.timescales || {};
	          segment.map.timescales[track.id] = track.timescale;
	        }
	      });
	      return _callback(null);
	    }
	  });
	};
	/**
	 * Handle init-segment responses
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	
	
	var handleInitSegmentResponse = function handleInitSegmentResponse(_ref2) {
	  var segment = _ref2.segment,
	      finishProcessingFn = _ref2.finishProcessingFn;
	  return function (error, request) {
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    var bytes = new Uint8Array(request.response); // init segment is encypted, we will have to wait
	    // until the key request is done to decrypt.
	
	    if (segment.map.key) {
	      segment.map.encryptedBytes = bytes;
	      return finishProcessingFn(null, segment);
	    }
	
	    segment.map.bytes = bytes;
	    parseInitSegment(segment, function (parseError) {
	      if (parseError) {
	        parseError.xhr = request;
	        parseError.status = request.status;
	        return finishProcessingFn(parseError, segment);
	      }
	
	      finishProcessingFn(null, segment);
	    });
	  };
	};
	/**
	 * Response handler for segment-requests being sure to set the correct
	 * property depending on whether the segment is encryped or not
	 * Also records and keeps track of stats that are used for ABR purposes
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} finishProcessingFn - a callback to execute to continue processing
	 *                                        this request
	 */
	
	
	var handleSegmentResponse = function handleSegmentResponse(_ref3) {
	  var segment = _ref3.segment,
	      finishProcessingFn = _ref3.finishProcessingFn,
	      responseType = _ref3.responseType;
	  return function (error, request) {
	    var errorObj = handleErrors(error, request);
	
	    if (errorObj) {
	      return finishProcessingFn(errorObj, segment);
	    }
	
	    var newBytes = // although responseText "should" exist, this guard serves to prevent an error being
	    // thrown for two primary cases:
	    // 1. the mime type override stops working, or is not implemented for a specific
	    //    browser
	    // 2. when using mock XHR libraries like sinon that do not allow the override behavior
	    responseType === 'arraybuffer' || !request.responseText ? request.response : stringToArrayBuffer(request.responseText.substring(segment.lastReachedChar || 0));
	    segment.stats = getRequestStats(request);
	
	    if (segment.key) {
	      segment.encryptedBytes = new Uint8Array(newBytes);
	    } else {
	      segment.bytes = new Uint8Array(newBytes);
	    }
	
	    return finishProcessingFn(null, segment);
	  };
	};
	
	var transmuxAndNotify = function transmuxAndNotify(_ref4) {
	  var segment = _ref4.segment,
	      bytes = _ref4.bytes,
	      trackInfoFn = _ref4.trackInfoFn,
	      timingInfoFn = _ref4.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref4.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref4.audioSegmentTimingInfoFn,
	      id3Fn = _ref4.id3Fn,
	      captionsFn = _ref4.captionsFn,
	      isEndOfTimeline = _ref4.isEndOfTimeline,
	      endedTimelineFn = _ref4.endedTimelineFn,
	      dataFn = _ref4.dataFn,
	      doneFn = _ref4.doneFn,
	      onTransmuxerLog = _ref4.onTransmuxerLog;
	  var fmp4Tracks = segment.map && segment.map.tracks || {};
	  var isMuxed = Boolean(fmp4Tracks.audio && fmp4Tracks.video); // Keep references to each function so we can null them out after we're done with them.
	  // One reason for this is that in the case of full segments, we want to trust start
	  // times from the probe, rather than the transmuxer.
	
	  var audioStartFn = timingInfoFn.bind(null, segment, 'audio', 'start');
	  var audioEndFn = timingInfoFn.bind(null, segment, 'audio', 'end');
	  var videoStartFn = timingInfoFn.bind(null, segment, 'video', 'start');
	  var videoEndFn = timingInfoFn.bind(null, segment, 'video', 'end');
	
	  var finish = function finish() {
	    return transmux({
	      bytes: bytes,
	      transmuxer: segment.transmuxer,
	      audioAppendStart: segment.audioAppendStart,
	      gopsToAlignWith: segment.gopsToAlignWith,
	      remux: isMuxed,
	      onData: function onData(result) {
	        result.type = result.type === 'combined' ? 'video' : result.type;
	        dataFn(segment, result);
	      },
	      onTrackInfo: function onTrackInfo(trackInfo) {
	        if (trackInfoFn) {
	          if (isMuxed) {
	            trackInfo.isMuxed = true;
	          }
	
	          trackInfoFn(segment, trackInfo);
	        }
	      },
	      onAudioTimingInfo: function onAudioTimingInfo(audioTimingInfo) {
	        // we only want the first start value we encounter
	        if (audioStartFn && typeof audioTimingInfo.start !== 'undefined') {
	          audioStartFn(audioTimingInfo.start);
	          audioStartFn = null;
	        } // we want to continually update the end time
	
	
	        if (audioEndFn && typeof audioTimingInfo.end !== 'undefined') {
	          audioEndFn(audioTimingInfo.end);
	        }
	      },
	      onVideoTimingInfo: function onVideoTimingInfo(videoTimingInfo) {
	        // we only want the first start value we encounter
	        if (videoStartFn && typeof videoTimingInfo.start !== 'undefined') {
	          videoStartFn(videoTimingInfo.start);
	          videoStartFn = null;
	        } // we want to continually update the end time
	
	
	        if (videoEndFn && typeof videoTimingInfo.end !== 'undefined') {
	          videoEndFn(videoTimingInfo.end);
	        }
	      },
	      onVideoSegmentTimingInfo: function onVideoSegmentTimingInfo(videoSegmentTimingInfo) {
	        videoSegmentTimingInfoFn(videoSegmentTimingInfo);
	      },
	      onAudioSegmentTimingInfo: function onAudioSegmentTimingInfo(audioSegmentTimingInfo) {
	        audioSegmentTimingInfoFn(audioSegmentTimingInfo);
	      },
	      onId3: function onId3(id3Frames, dispatchType) {
	        id3Fn(segment, id3Frames, dispatchType);
	      },
	      onCaptions: function onCaptions(captions) {
	        captionsFn(segment, [captions]);
	      },
	      isEndOfTimeline: isEndOfTimeline,
	      onEndedTimeline: function onEndedTimeline() {
	        endedTimelineFn();
	      },
	      onTransmuxerLog: onTransmuxerLog,
	      onDone: function onDone(result) {
	        if (!doneFn) {
	          return;
	        }
	
	        result.type = result.type === 'combined' ? 'video' : result.type;
	        doneFn(null, segment, result);
	      }
	    });
	  }; // In the transmuxer, we don't yet have the ability to extract a "proper" start time.
	  // Meaning cached frame data may corrupt our notion of where this segment
	  // really starts. To get around this, probe for the info needed.
	
	
	  workerCallback({
	    action: 'probeTs',
	    transmuxer: segment.transmuxer,
	    data: bytes,
	    baseStartTime: segment.baseStartTime,
	    callback: function callback(data) {
	      segment.bytes = bytes = data.data;
	      var probeResult = data.result;
	
	      if (probeResult) {
	        trackInfoFn(segment, {
	          hasAudio: probeResult.hasAudio,
	          hasVideo: probeResult.hasVideo,
	          isMuxed: isMuxed
	        });
	        trackInfoFn = null;
	
	        if (probeResult.hasAudio && !isMuxed) {
	          audioStartFn(probeResult.audioStart);
	        }
	
	        if (probeResult.hasVideo) {
	          videoStartFn(probeResult.videoStart);
	        }
	
	        audioStartFn = null;
	        videoStartFn = null;
	      }
	
	      finish();
	    }
	  });
	};
	
	var handleSegmentBytes = function handleSegmentBytes(_ref5) {
	  var segment = _ref5.segment,
	      bytes = _ref5.bytes,
	      trackInfoFn = _ref5.trackInfoFn,
	      timingInfoFn = _ref5.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref5.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref5.audioSegmentTimingInfoFn,
	      id3Fn = _ref5.id3Fn,
	      captionsFn = _ref5.captionsFn,
	      isEndOfTimeline = _ref5.isEndOfTimeline,
	      endedTimelineFn = _ref5.endedTimelineFn,
	      dataFn = _ref5.dataFn,
	      doneFn = _ref5.doneFn,
	      onTransmuxerLog = _ref5.onTransmuxerLog;
	  var bytesAsUint8Array = new Uint8Array(bytes); // TODO:
	  // We should have a handler that fetches the number of bytes required
	  // to check if something is fmp4. This will allow us to save bandwidth
	  // because we can only blacklist a playlist and abort requests
	  // by codec after trackinfo triggers.
	
	  if (containers.isLikelyFmp4MediaSegment(bytesAsUint8Array)) {
	    segment.isFmp4 = true;
	    var tracks = segment.map.tracks;
	    var trackInfo = {
	      isFmp4: true,
	      hasVideo: !!tracks.video,
	      hasAudio: !!tracks.audio
	    }; // if we have a audio track, with a codec that is not set to
	    // encrypted audio
	
	    if (tracks.audio && tracks.audio.codec && tracks.audio.codec !== 'enca') {
	      trackInfo.audioCodec = tracks.audio.codec;
	    } // if we have a video track, with a codec that is not set to
	    // encrypted video
	
	
	    if (tracks.video && tracks.video.codec && tracks.video.codec !== 'encv') {
	      trackInfo.videoCodec = tracks.video.codec;
	    }
	
	    if (tracks.video && tracks.audio) {
	      trackInfo.isMuxed = true;
	    } // since we don't support appending fmp4 data on progress, we know we have the full
	    // segment here
	
	
	    trackInfoFn(segment, trackInfo); // The probe doesn't provide the segment end time, so only callback with the start
	    // time. The end time can be roughly calculated by the receiver using the duration.
	    //
	    // Note that the start time returned by the probe reflects the baseMediaDecodeTime, as
	    // that is the true start of the segment (where the playback engine should begin
	    // decoding).
	
	    var finishLoading = function finishLoading(captions) {
	      // if the track still has audio at this point it is only possible
	      // for it to be audio only. See `tracks.video && tracks.audio` if statement
	      // above.
	      // we make sure to use segment.bytes here as that
	      dataFn(segment, {
	        data: bytesAsUint8Array,
	        type: trackInfo.hasAudio && !trackInfo.isMuxed ? 'audio' : 'video'
	      });
	
	      if (captions && captions.length) {
	        captionsFn(segment, captions);
	      }
	
	      doneFn(null, segment, {});
	    };
	
	    workerCallback({
	      action: 'probeMp4StartTime',
	      timescales: segment.map.timescales,
	      data: bytesAsUint8Array,
	      transmuxer: segment.transmuxer,
	      callback: function callback(_ref6) {
	        var data = _ref6.data,
	            startTime = _ref6.startTime; // transfer bytes back to us
	
	        bytes = data.buffer;
	        segment.bytes = bytesAsUint8Array = data;
	
	        if (trackInfo.hasAudio && !trackInfo.isMuxed) {
	          timingInfoFn(segment, 'audio', 'start', startTime);
	        }
	
	        if (trackInfo.hasVideo) {
	          timingInfoFn(segment, 'video', 'start', startTime);
	        } // Run through the CaptionParser in case there are captions.
	        // Initialize CaptionParser if it hasn't been yet
	
	
	        if (!tracks.video || !data.byteLength || !segment.transmuxer) {
	          finishLoading();
	          return;
	        }
	
	        workerCallback({
	          action: 'pushMp4Captions',
	          endAction: 'mp4Captions',
	          transmuxer: segment.transmuxer,
	          data: bytesAsUint8Array,
	          timescales: segment.map.timescales,
	          trackIds: [tracks.video.id],
	          callback: function callback(message) {
	            // transfer bytes back to us
	            bytes = message.data.buffer;
	            segment.bytes = bytesAsUint8Array = message.data;
	            message.logs.forEach(function (log) {
	              onTransmuxerLog(videojs.mergeOptions(log, {
	                stream: 'mp4CaptionParser'
	              }));
	            });
	            finishLoading(message.captions);
	          }
	        });
	      }
	    });
	    return;
	  } // VTT or other segments that don't need processing
	
	
	  if (!segment.transmuxer) {
	    doneFn(null, segment, {});
	    return;
	  }
	
	  if (typeof segment.container === 'undefined') {
	    segment.container = containers.detectContainerForBytes(bytesAsUint8Array);
	  }
	
	  if (segment.container !== 'ts' && segment.container !== 'aac') {
	    trackInfoFn(segment, {
	      hasAudio: false,
	      hasVideo: false
	    });
	    doneFn(null, segment, {});
	    return;
	  } // ts or aac
	
	
	  transmuxAndNotify({
	    segment: segment,
	    bytes: bytes,
	    trackInfoFn: trackInfoFn,
	    timingInfoFn: timingInfoFn,
	    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	    id3Fn: id3Fn,
	    captionsFn: captionsFn,
	    isEndOfTimeline: isEndOfTimeline,
	    endedTimelineFn: endedTimelineFn,
	    dataFn: dataFn,
	    doneFn: doneFn,
	    onTransmuxerLog: onTransmuxerLog
	  });
	};
	
	var decrypt = function decrypt(_ref7, callback) {
	  var id = _ref7.id,
	      key = _ref7.key,
	      encryptedBytes = _ref7.encryptedBytes,
	      decryptionWorker = _ref7.decryptionWorker;
	
	  var decryptionHandler = function decryptionHandler(event) {
	    if (event.data.source === id) {
	      decryptionWorker.removeEventListener('message', decryptionHandler);
	      var decrypted = event.data.decrypted;
	      callback(new Uint8Array(decrypted.bytes, decrypted.byteOffset, decrypted.byteLength));
	    }
	  };
	
	  decryptionWorker.addEventListener('message', decryptionHandler);
	  var keyBytes;
	
	  if (key.bytes.slice) {
	    keyBytes = key.bytes.slice();
	  } else {
	    keyBytes = new Uint32Array(Array.prototype.slice.call(key.bytes));
	  } // incrementally decrypt the bytes
	
	
	  decryptionWorker.postMessage(createTransferableMessage({
	    source: id,
	    encrypted: encryptedBytes,
	    key: keyBytes,
	    iv: key.iv
	  }), [encryptedBytes.buffer, keyBytes.buffer]);
	};
	/**
	 * Decrypt the segment via the decryption web worker
	 *
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
	 *                                       routines
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that is executed when segment bytes are available
	 *                            and ready to use
	 * @param {Function} doneFn - a callback that is executed after decryption has completed
	 */
	
	
	var decryptSegment = function decryptSegment(_ref8) {
	  var decryptionWorker = _ref8.decryptionWorker,
	      segment = _ref8.segment,
	      trackInfoFn = _ref8.trackInfoFn,
	      timingInfoFn = _ref8.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref8.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref8.audioSegmentTimingInfoFn,
	      id3Fn = _ref8.id3Fn,
	      captionsFn = _ref8.captionsFn,
	      isEndOfTimeline = _ref8.isEndOfTimeline,
	      endedTimelineFn = _ref8.endedTimelineFn,
	      dataFn = _ref8.dataFn,
	      doneFn = _ref8.doneFn,
	      onTransmuxerLog = _ref8.onTransmuxerLog;
	  decrypt({
	    id: segment.requestId,
	    key: segment.key,
	    encryptedBytes: segment.encryptedBytes,
	    decryptionWorker: decryptionWorker
	  }, function (decryptedBytes) {
	    segment.bytes = decryptedBytes;
	    handleSegmentBytes({
	      segment: segment,
	      bytes: segment.bytes,
	      trackInfoFn: trackInfoFn,
	      timingInfoFn: timingInfoFn,
	      videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	      id3Fn: id3Fn,
	      captionsFn: captionsFn,
	      isEndOfTimeline: isEndOfTimeline,
	      endedTimelineFn: endedTimelineFn,
	      dataFn: dataFn,
	      doneFn: doneFn,
	      onTransmuxerLog: onTransmuxerLog
	    });
	  });
	};
	/**
	 * This function waits for all XHRs to finish (with either success or failure)
	 * before continueing processing via it's callback. The function gathers errors
	 * from each request into a single errors array so that the error status for
	 * each request can be examined later.
	 *
	 * @param {Object} activeXhrs - an object that tracks all XHR requests
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
	 *                                       routines
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} id3Fn - a callback that receives ID3 metadata
	 * @param {Function} captionsFn - a callback that receives captions
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that is executed when segment bytes are available
	 *                            and ready to use
	 * @param {Function} doneFn - a callback that is executed after all resources have been
	 *                            downloaded and any decryption completed
	 */
	
	
	var waitForCompletion = function waitForCompletion(_ref9) {
	  var activeXhrs = _ref9.activeXhrs,
	      decryptionWorker = _ref9.decryptionWorker,
	      trackInfoFn = _ref9.trackInfoFn,
	      timingInfoFn = _ref9.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref9.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref9.audioSegmentTimingInfoFn,
	      id3Fn = _ref9.id3Fn,
	      captionsFn = _ref9.captionsFn,
	      isEndOfTimeline = _ref9.isEndOfTimeline,
	      endedTimelineFn = _ref9.endedTimelineFn,
	      dataFn = _ref9.dataFn,
	      doneFn = _ref9.doneFn,
	      onTransmuxerLog = _ref9.onTransmuxerLog;
	  var count = 0;
	  var didError = false;
	  return function (error, segment) {
	    if (didError) {
	      return;
	    }
	
	    if (error) {
	      didError = true; // If there are errors, we have to abort any outstanding requests
	
	      abortAll(activeXhrs); // Even though the requests above are aborted, and in theory we could wait until we
	      // handle the aborted events from those requests, there are some cases where we may
	      // never get an aborted event. For instance, if the network connection is lost and
	      // there were two requests, the first may have triggered an error immediately, while
	      // the second request remains unsent. In that case, the aborted algorithm will not
	      // trigger an abort: see https://xhr.spec.whatwg.org/#the-abort()-method
	      //
	      // We also can't rely on the ready state of the XHR, since the request that
	      // triggered the connection error may also show as a ready state of 0 (unsent).
	      // Therefore, we have to finish this group of requests immediately after the first
	      // seen error.
	
	      return doneFn(error, segment);
	    }
	
	    count += 1;
	
	    if (count === activeXhrs.length) {
	      var segmentFinish = function segmentFinish() {
	        if (segment.encryptedBytes) {
	          return decryptSegment({
	            decryptionWorker: decryptionWorker,
	            segment: segment,
	            trackInfoFn: trackInfoFn,
	            timingInfoFn: timingInfoFn,
	            videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	            audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	            id3Fn: id3Fn,
	            captionsFn: captionsFn,
	            isEndOfTimeline: isEndOfTimeline,
	            endedTimelineFn: endedTimelineFn,
	            dataFn: dataFn,
	            doneFn: doneFn,
	            onTransmuxerLog: onTransmuxerLog
	          });
	        } // Otherwise, everything is ready just continue
	
	
	        handleSegmentBytes({
	          segment: segment,
	          bytes: segment.bytes,
	          trackInfoFn: trackInfoFn,
	          timingInfoFn: timingInfoFn,
	          videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	          audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	          id3Fn: id3Fn,
	          captionsFn: captionsFn,
	          isEndOfTimeline: isEndOfTimeline,
	          endedTimelineFn: endedTimelineFn,
	          dataFn: dataFn,
	          doneFn: doneFn,
	          onTransmuxerLog: onTransmuxerLog
	        });
	      }; // Keep track of when *all* of the requests have completed
	
	
	      segment.endOfAllRequests = Date.now();
	
	      if (segment.map && segment.map.encryptedBytes && !segment.map.bytes) {
	        return decrypt({
	          decryptionWorker: decryptionWorker,
	          // add -init to the "id" to differentiate between segment
	          // and init segment decryption, just in case they happen
	          // at the same time at some point in the future.
	          id: segment.requestId + '-init',
	          encryptedBytes: segment.map.encryptedBytes,
	          key: segment.map.key
	        }, function (decryptedBytes) {
	          segment.map.bytes = decryptedBytes;
	          parseInitSegment(segment, function (parseError) {
	            if (parseError) {
	              abortAll(activeXhrs);
	              return doneFn(parseError, segment);
	            }
	
	            segmentFinish();
	          });
	        });
	      }
	
	      segmentFinish();
	    }
	  };
	};
	/**
	 * Calls the abort callback if any request within the batch was aborted. Will only call
	 * the callback once per batch of requests, even if multiple were aborted.
	 *
	 * @param {Object} loadendState - state to check to see if the abort function was called
	 * @param {Function} abortFn - callback to call for abort
	 */
	
	
	var handleLoadEnd = function handleLoadEnd(_ref10) {
	  var loadendState = _ref10.loadendState,
	      abortFn = _ref10.abortFn;
	  return function (event) {
	    var request = event.target;
	
	    if (request.aborted && abortFn && !loadendState.calledAbortFn) {
	      abortFn();
	      loadendState.calledAbortFn = true;
	    }
	  };
	};
	/**
	 * Simple progress event callback handler that gathers some stats before
	 * executing a provided callback with the `segment` object
	 *
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} progressFn - a callback that is executed each time a progress event
	 *                                is received
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that is executed when segment bytes are available
	 *                            and ready to use
	 * @param {Event} event - the progress event object from XMLHttpRequest
	 */
	
	
	var handleProgress = function handleProgress(_ref11) {
	  var segment = _ref11.segment,
	      progressFn = _ref11.progressFn;
	  _ref11.trackInfoFn;
	  _ref11.timingInfoFn;
	  _ref11.videoSegmentTimingInfoFn;
	  _ref11.audioSegmentTimingInfoFn;
	  _ref11.id3Fn;
	  _ref11.captionsFn;
	  _ref11.isEndOfTimeline;
	  _ref11.endedTimelineFn;
	  _ref11.dataFn;
	  return function (event) {
	    var request = event.target;
	
	    if (request.aborted) {
	      return;
	    }
	
	    segment.stats = videojs.mergeOptions(segment.stats, getProgressStats(event)); // record the time that we receive the first byte of data
	
	    if (!segment.stats.firstBytesReceivedAt && segment.stats.bytesReceived) {
	      segment.stats.firstBytesReceivedAt = Date.now();
	    }
	
	    return progressFn(event, segment);
	  };
	};
	/**
	 * Load all resources and does any processing necessary for a media-segment
	 *
	 * Features:
	 *   decrypts the media-segment if it has a key uri and an iv
	 *   aborts *all* requests if *any* one request fails
	 *
	 * The segment object, at minimum, has the following format:
	 * {
	 *   resolvedUri: String,
	 *   [transmuxer]: Object,
	 *   [byterange]: {
	 *     offset: Number,
	 *     length: Number
	 *   },
	 *   [key]: {
	 *     resolvedUri: String
	 *     [byterange]: {
	 *       offset: Number,
	 *       length: Number
	 *     },
	 *     iv: {
	 *       bytes: Uint32Array
	 *     }
	 *   },
	 *   [map]: {
	 *     resolvedUri: String,
	 *     [byterange]: {
	 *       offset: Number,
	 *       length: Number
	 *     },
	 *     [bytes]: Uint8Array
	 *   }
	 * }
	 * ...where [name] denotes optional properties
	 *
	 * @param {Function} xhr - an instance of the xhr wrapper in xhr.js
	 * @param {Object} xhrOptions - the base options to provide to all xhr requests
	 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128
	 *                                       decryption routines
	 * @param {Object} segment - a simplified copy of the segmentInfo object
	 *                           from SegmentLoader
	 * @param {Function} abortFn - a callback called (only once) if any piece of a request was
	 *                             aborted
	 * @param {Function} progressFn - a callback that receives progress events from the main
	 *                                segment's xhr request
	 * @param {Function} trackInfoFn - a callback that receives track info
	 * @param {Function} timingInfoFn - a callback that receives timing info
	 * @param {Function} videoSegmentTimingInfoFn
	 *                   a callback that receives video timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} audioSegmentTimingInfoFn
	 *                   a callback that receives audio timing info based on media times and
	 *                   any adjustments made by the transmuxer
	 * @param {Function} id3Fn - a callback that receives ID3 metadata
	 * @param {Function} captionsFn - a callback that receives captions
	 * @param {boolean}  isEndOfTimeline
	 *                   true if this segment represents the last segment in a timeline
	 * @param {Function} endedTimelineFn
	 *                   a callback made when a timeline is ended, will only be called if
	 *                   isEndOfTimeline is true
	 * @param {Function} dataFn - a callback that receives data from the main segment's xhr
	 *                            request, transmuxed if needed
	 * @param {Function} doneFn - a callback that is executed only once all requests have
	 *                            succeeded or failed
	 * @return {Function} a function that, when invoked, immediately aborts all
	 *                     outstanding requests
	 */
	
	
	var mediaSegmentRequest = function mediaSegmentRequest(_ref12) {
	  var xhr = _ref12.xhr,
	      xhrOptions = _ref12.xhrOptions,
	      decryptionWorker = _ref12.decryptionWorker,
	      segment = _ref12.segment,
	      abortFn = _ref12.abortFn,
	      progressFn = _ref12.progressFn,
	      trackInfoFn = _ref12.trackInfoFn,
	      timingInfoFn = _ref12.timingInfoFn,
	      videoSegmentTimingInfoFn = _ref12.videoSegmentTimingInfoFn,
	      audioSegmentTimingInfoFn = _ref12.audioSegmentTimingInfoFn,
	      id3Fn = _ref12.id3Fn,
	      captionsFn = _ref12.captionsFn,
	      isEndOfTimeline = _ref12.isEndOfTimeline,
	      endedTimelineFn = _ref12.endedTimelineFn,
	      dataFn = _ref12.dataFn,
	      doneFn = _ref12.doneFn,
	      onTransmuxerLog = _ref12.onTransmuxerLog;
	  var activeXhrs = [];
	  var finishProcessingFn = waitForCompletion({
	    activeXhrs: activeXhrs,
	    decryptionWorker: decryptionWorker,
	    trackInfoFn: trackInfoFn,
	    timingInfoFn: timingInfoFn,
	    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	    id3Fn: id3Fn,
	    captionsFn: captionsFn,
	    isEndOfTimeline: isEndOfTimeline,
	    endedTimelineFn: endedTimelineFn,
	    dataFn: dataFn,
	    doneFn: doneFn,
	    onTransmuxerLog: onTransmuxerLog
	  }); // optionally, request the decryption key
	
	  if (segment.key && !segment.key.bytes) {
	    var objects = [segment.key];
	
	    if (segment.map && !segment.map.bytes && segment.map.key && segment.map.key.resolvedUri === segment.key.resolvedUri) {
	      objects.push(segment.map.key);
	    }
	
	    var keyRequestOptions = videojs.mergeOptions(xhrOptions, {
	      uri: segment.key.resolvedUri,
	      responseType: 'arraybuffer'
	    });
	    var keyRequestCallback = handleKeyResponse(segment, objects, finishProcessingFn);
	    var keyXhr = xhr(keyRequestOptions, keyRequestCallback);
	    activeXhrs.push(keyXhr);
	  } // optionally, request the associated media init segment
	
	
	  if (segment.map && !segment.map.bytes) {
	    var differentMapKey = segment.map.key && (!segment.key || segment.key.resolvedUri !== segment.map.key.resolvedUri);
	
	    if (differentMapKey) {
	      var mapKeyRequestOptions = videojs.mergeOptions(xhrOptions, {
	        uri: segment.map.key.resolvedUri,
	        responseType: 'arraybuffer'
	      });
	      var mapKeyRequestCallback = handleKeyResponse(segment, [segment.map.key], finishProcessingFn);
	      var mapKeyXhr = xhr(mapKeyRequestOptions, mapKeyRequestCallback);
	      activeXhrs.push(mapKeyXhr);
	    }
	
	    var initSegmentOptions = videojs.mergeOptions(xhrOptions, {
	      uri: segment.map.resolvedUri,
	      responseType: 'arraybuffer',
	      headers: segmentXhrHeaders(segment.map)
	    });
	    var initSegmentRequestCallback = handleInitSegmentResponse({
	      segment: segment,
	      finishProcessingFn: finishProcessingFn
	    });
	    var initSegmentXhr = xhr(initSegmentOptions, initSegmentRequestCallback);
	    activeXhrs.push(initSegmentXhr);
	  }
	
	  var segmentRequestOptions = videojs.mergeOptions(xhrOptions, {
	    uri: segment.part && segment.part.resolvedUri || segment.resolvedUri,
	    responseType: 'arraybuffer',
	    headers: segmentXhrHeaders(segment)
	  });
	  var segmentRequestCallback = handleSegmentResponse({
	    segment: segment,
	    finishProcessingFn: finishProcessingFn,
	    responseType: segmentRequestOptions.responseType
	  });
	  var segmentXhr = xhr(segmentRequestOptions, segmentRequestCallback);
	  segmentXhr.addEventListener('progress', handleProgress({
	    segment: segment,
	    progressFn: progressFn,
	    trackInfoFn: trackInfoFn,
	    timingInfoFn: timingInfoFn,
	    videoSegmentTimingInfoFn: videoSegmentTimingInfoFn,
	    audioSegmentTimingInfoFn: audioSegmentTimingInfoFn,
	    id3Fn: id3Fn,
	    captionsFn: captionsFn,
	    isEndOfTimeline: isEndOfTimeline,
	    endedTimelineFn: endedTimelineFn,
	    dataFn: dataFn
	  }));
	  activeXhrs.push(segmentXhr); // since all parts of the request must be considered, but should not make callbacks
	  // multiple times, provide a shared state object
	
	  var loadendState = {};
	  activeXhrs.forEach(function (activeXhr) {
	    activeXhr.addEventListener('loadend', handleLoadEnd({
	      loadendState: loadendState,
	      abortFn: abortFn
	    }));
	  });
	  return function () {
	    return abortAll(activeXhrs);
	  };
	};
	/**
	 * @file - codecs.js - Handles tasks regarding codec strings such as translating them to
	 * codec strings, or translating codec strings into objects that can be examined.
	 */
	
	
	var logFn$1 = logger('CodecUtils');
	/**
	 * Returns a set of codec strings parsed from the playlist or the default
	 * codec strings if no codecs were specified in the playlist
	 *
	 * @param {Playlist} media the current media playlist
	 * @return {Object} an object with the video and audio codecs
	 */
	
	var getCodecs = function getCodecs(media) {
	  // if the codecs were explicitly specified, use them instead of the
	  // defaults
	  var mediaAttributes = media.attributes || {};
	
	  if (mediaAttributes.CODECS) {
	    return codecs_js.parseCodecs(mediaAttributes.CODECS);
	  }
	};
	
	var isMaat = function isMaat(master, media) {
	  var mediaAttributes = media.attributes || {};
	  return master && master.mediaGroups && master.mediaGroups.AUDIO && mediaAttributes.AUDIO && master.mediaGroups.AUDIO[mediaAttributes.AUDIO];
	};
	
	var isMuxed = function isMuxed(master, media) {
	  if (!isMaat(master, media)) {
	    return true;
	  }
	
	  var mediaAttributes = media.attributes || {};
	  var audioGroup = master.mediaGroups.AUDIO[mediaAttributes.AUDIO];
	
	  for (var groupId in audioGroup) {
	    // If an audio group has a URI (the case for HLS, as HLS will use external playlists),
	    // or there are listed playlists (the case for DASH, as the manifest will have already
	    // provided all of the details necessary to generate the audio playlist, as opposed to
	    // HLS' externally requested playlists), then the content is demuxed.
	    if (!audioGroup[groupId].uri && !audioGroup[groupId].playlists) {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	var unwrapCodecList = function unwrapCodecList(codecList) {
	  var codecs = {};
	  codecList.forEach(function (_ref) {
	    var mediaType = _ref.mediaType,
	        type = _ref.type,
	        details = _ref.details;
	    codecs[mediaType] = codecs[mediaType] || [];
	    codecs[mediaType].push(codecs_js.translateLegacyCodec("" + type + details));
	  });
	  Object.keys(codecs).forEach(function (mediaType) {
	    if (codecs[mediaType].length > 1) {
	      logFn$1("multiple " + mediaType + " codecs found as attributes: " + codecs[mediaType].join(', ') + ". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.");
	      codecs[mediaType] = null;
	      return;
	    }
	
	    codecs[mediaType] = codecs[mediaType][0];
	  });
	  return codecs;
	};
	
	var codecCount = function codecCount(codecObj) {
	  var count = 0;
	
	  if (codecObj.audio) {
	    count++;
	  }
	
	  if (codecObj.video) {
	    count++;
	  }
	
	  return count;
	};
	/**
	 * Calculates the codec strings for a working configuration of
	 * SourceBuffers to play variant streams in a master playlist. If
	 * there is no possible working configuration, an empty object will be
	 * returned.
	 *
	 * @param master {Object} the m3u8 object for the master playlist
	 * @param media {Object} the m3u8 object for the variant playlist
	 * @return {Object} the codec strings.
	 *
	 * @private
	 */
	
	
	var codecsForPlaylist = function codecsForPlaylist(master, media) {
	  var mediaAttributes = media.attributes || {};
	  var codecInfo = unwrapCodecList(getCodecs(media) || []); // HLS with multiple-audio tracks must always get an audio codec.
	  // Put another way, there is no way to have a video-only multiple-audio HLS!
	
	  if (isMaat(master, media) && !codecInfo.audio) {
	    if (!isMuxed(master, media)) {
	      // It is possible for codecs to be specified on the audio media group playlist but
	      // not on the rendition playlist. This is mostly the case for DASH, where audio and
	      // video are always separate (and separately specified).
	      var defaultCodecs = unwrapCodecList(codecs_js.codecsFromDefault(master, mediaAttributes.AUDIO) || []);
	
	      if (defaultCodecs.audio) {
	        codecInfo.audio = defaultCodecs.audio;
	      }
	    }
	  }
	
	  return codecInfo;
	};
	
	var logFn = logger('PlaylistSelector');
	
	var representationToString = function representationToString(representation) {
	  if (!representation || !representation.playlist) {
	    return;
	  }
	
	  var playlist = representation.playlist;
	  return JSON.stringify({
	    id: playlist.id,
	    bandwidth: representation.bandwidth,
	    width: representation.width,
	    height: representation.height,
	    codecs: playlist.attributes && playlist.attributes.CODECS || ''
	  });
	}; // Utilities
	
	/**
	 * Returns the CSS value for the specified property on an element
	 * using `getComputedStyle`. Firefox has a long-standing issue where
	 * getComputedStyle() may return null when running in an iframe with
	 * `display: none`.
	 *
	 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 * @param {HTMLElement} el the htmlelement to work on
	 * @param {string} the proprety to get the style for
	 */
	
	
	var safeGetComputedStyle = function safeGetComputedStyle(el, property) {
	  if (!el) {
	    return '';
	  }
	
	  var result = window__default['default'].getComputedStyle(el);
	
	  if (!result) {
	    return '';
	  }
	
	  return result[property];
	};
	/**
	 * Resuable stable sort function
	 *
	 * @param {Playlists} array
	 * @param {Function} sortFn Different comparators
	 * @function stableSort
	 */
	
	
	var stableSort = function stableSort(array, sortFn) {
	  var newArray = array.slice();
	  array.sort(function (left, right) {
	    var cmp = sortFn(left, right);
	
	    if (cmp === 0) {
	      return newArray.indexOf(left) - newArray.indexOf(right);
	    }
	
	    return cmp;
	  });
	};
	/**
	 * A comparator function to sort two playlist object by bandwidth.
	 *
	 * @param {Object} left a media playlist object
	 * @param {Object} right a media playlist object
	 * @return {number} Greater than zero if the bandwidth attribute of
	 * left is greater than the corresponding attribute of right. Less
	 * than zero if the bandwidth of right is greater than left and
	 * exactly zero if the two are equal.
	 */
	
	
	var comparePlaylistBandwidth = function comparePlaylistBandwidth(left, right) {
	  var leftBandwidth;
	  var rightBandwidth;
	
	  if (left.attributes.BANDWIDTH) {
	    leftBandwidth = left.attributes.BANDWIDTH;
	  }
	
	  leftBandwidth = leftBandwidth || window__default['default'].Number.MAX_VALUE;
	
	  if (right.attributes.BANDWIDTH) {
	    rightBandwidth = right.attributes.BANDWIDTH;
	  }
	
	  rightBandwidth = rightBandwidth || window__default['default'].Number.MAX_VALUE;
	  return leftBandwidth - rightBandwidth;
	};
	/**
	 * A comparator function to sort two playlist object by resolution (width).
	 *
	 * @param {Object} left a media playlist object
	 * @param {Object} right a media playlist object
	 * @return {number} Greater than zero if the resolution.width attribute of
	 * left is greater than the corresponding attribute of right. Less
	 * than zero if the resolution.width of right is greater than left and
	 * exactly zero if the two are equal.
	 */
	
	
	var comparePlaylistResolution = function comparePlaylistResolution(left, right) {
	  var leftWidth;
	  var rightWidth;
	
	  if (left.attributes.RESOLUTION && left.attributes.RESOLUTION.width) {
	    leftWidth = left.attributes.RESOLUTION.width;
	  }
	
	  leftWidth = leftWidth || window__default['default'].Number.MAX_VALUE;
	
	  if (right.attributes.RESOLUTION && right.attributes.RESOLUTION.width) {
	    rightWidth = right.attributes.RESOLUTION.width;
	  }
	
	  rightWidth = rightWidth || window__default['default'].Number.MAX_VALUE; // NOTE - Fallback to bandwidth sort as appropriate in cases where multiple renditions
	  // have the same media dimensions/ resolution
	
	  if (leftWidth === rightWidth && left.attributes.BANDWIDTH && right.attributes.BANDWIDTH) {
	    return left.attributes.BANDWIDTH - right.attributes.BANDWIDTH;
	  }
	
	  return leftWidth - rightWidth;
	};
	/**
	 * Chooses the appropriate media playlist based on bandwidth and player size
	 *
	 * @param {Object} master
	 *        Object representation of the master manifest
	 * @param {number} playerBandwidth
	 *        Current calculated bandwidth of the player
	 * @param {number} playerWidth
	 *        Current width of the player element (should account for the device pixel ratio)
	 * @param {number} playerHeight
	 *        Current height of the player element (should account for the device pixel ratio)
	 * @param {boolean} limitRenditionByPlayerDimensions
	 *        True if the player width and height should be used during the selection, false otherwise
	 * @param {Object} masterPlaylistController
	 *        the current masterPlaylistController object
	 * @return {Playlist} the highest bitrate playlist less than the
	 * currently detected bandwidth, accounting for some amount of
	 * bandwidth variance
	 */
	
	
	var simpleSelector = function simpleSelector(master, playerBandwidth, playerWidth, playerHeight, limitRenditionByPlayerDimensions, masterPlaylistController) {
	  // If we end up getting called before `master` is available, exit early
	  if (!master) {
	    return;
	  }
	
	  var options = {
	    bandwidth: playerBandwidth,
	    width: playerWidth,
	    height: playerHeight,
	    limitRenditionByPlayerDimensions: limitRenditionByPlayerDimensions
	  };
	  var playlists = master.playlists; // if playlist is audio only, select between currently active audio group playlists.
	
	  if (Playlist.isAudioOnly(master)) {
	    playlists = masterPlaylistController.getAudioTrackPlaylists_(); // add audioOnly to options so that we log audioOnly: true
	    // at the buttom of this function for debugging.
	
	    options.audioOnly = true;
	  } // convert the playlists to an intermediary representation to make comparisons easier
	
	
	  var sortedPlaylistReps = playlists.map(function (playlist) {
	    var bandwidth;
	    var width = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.width;
	    var height = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height;
	    bandwidth = playlist.attributes && playlist.attributes.BANDWIDTH;
	    bandwidth = bandwidth || window__default['default'].Number.MAX_VALUE;
	    return {
	      bandwidth: bandwidth,
	      width: width,
	      height: height,
	      playlist: playlist
	    };
	  });
	  stableSort(sortedPlaylistReps, function (left, right) {
	    return left.bandwidth - right.bandwidth;
	  }); // filter out any playlists that have been excluded due to
	  // incompatible configurations
	
	  sortedPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	    return !Playlist.isIncompatible(rep.playlist);
	  }); // filter out any playlists that have been disabled manually through the representations
	  // api or blacklisted temporarily due to playback errors.
	
	  var enabledPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	    return Playlist.isEnabled(rep.playlist);
	  });
	
	  if (!enabledPlaylistReps.length) {
	    // if there are no enabled playlists, then they have all been blacklisted or disabled
	    // by the user through the representations api. In this case, ignore blacklisting and
	    // fallback to what the user wants by using playlists the user has not disabled.
	    enabledPlaylistReps = sortedPlaylistReps.filter(function (rep) {
	      return !Playlist.isDisabled(rep.playlist);
	    });
	  } // filter out any variant that has greater effective bitrate
	  // than the current estimated bandwidth
	
	
	  var bandwidthPlaylistReps = enabledPlaylistReps.filter(function (rep) {
	    return rep.bandwidth * Config.BANDWIDTH_VARIANCE < playerBandwidth;
	  });
	  var highestRemainingBandwidthRep = bandwidthPlaylistReps[bandwidthPlaylistReps.length - 1]; // get all of the renditions with the same (highest) bandwidth
	  // and then taking the very first element
	
	  var bandwidthBestRep = bandwidthPlaylistReps.filter(function (rep) {
	    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	  })[0]; // if we're not going to limit renditions by player size, make an early decision.
	
	  if (limitRenditionByPlayerDimensions === false) {
	    var _chosenRep = bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
	
	    if (_chosenRep && _chosenRep.playlist) {
	      var type = 'sortedPlaylistReps';
	
	      if (bandwidthBestRep) {
	        type = 'bandwidthBestRep';
	      }
	
	      if (enabledPlaylistReps[0]) {
	        type = 'enabledPlaylistReps';
	      }
	
	      logFn("choosing " + representationToString(_chosenRep) + " using " + type + " with options", options);
	      return _chosenRep.playlist;
	    }
	
	    logFn('could not choose a playlist with options', options);
	    return null;
	  } // filter out playlists without resolution information
	
	
	  var haveResolution = bandwidthPlaylistReps.filter(function (rep) {
	    return rep.width && rep.height;
	  }); // sort variants by resolution
	
	  stableSort(haveResolution, function (left, right) {
	    return left.width - right.width;
	  }); // if we have the exact resolution as the player use it
	
	  var resolutionBestRepList = haveResolution.filter(function (rep) {
	    return rep.width === playerWidth && rep.height === playerHeight;
	  });
	  highestRemainingBandwidthRep = resolutionBestRepList[resolutionBestRepList.length - 1]; // ensure that we pick the highest bandwidth variant that have exact resolution
	
	  var resolutionBestRep = resolutionBestRepList.filter(function (rep) {
	    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	  })[0];
	  var resolutionPlusOneList;
	  var resolutionPlusOneSmallest;
	  var resolutionPlusOneRep; // find the smallest variant that is larger than the player
	  // if there is no match of exact resolution
	
	  if (!resolutionBestRep) {
	    resolutionPlusOneList = haveResolution.filter(function (rep) {
	      return rep.width > playerWidth || rep.height > playerHeight;
	    }); // find all the variants have the same smallest resolution
	
	    resolutionPlusOneSmallest = resolutionPlusOneList.filter(function (rep) {
	      return rep.width === resolutionPlusOneList[0].width && rep.height === resolutionPlusOneList[0].height;
	    }); // ensure that we also pick the highest bandwidth variant that
	    // is just-larger-than the video player
	
	    highestRemainingBandwidthRep = resolutionPlusOneSmallest[resolutionPlusOneSmallest.length - 1];
	    resolutionPlusOneRep = resolutionPlusOneSmallest.filter(function (rep) {
	      return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
	    })[0];
	  }
	
	  var leastPixelDiffRep; // If this selector proves to be better than others,
	  // resolutionPlusOneRep and resolutionBestRep and all
	  // the code involving them should be removed.
	
	  if (masterPlaylistController.experimentalLeastPixelDiffSelector) {
	    // find the variant that is closest to the player's pixel size
	    var leastPixelDiffList = haveResolution.map(function (rep) {
	      rep.pixelDiff = Math.abs(rep.width - playerWidth) + Math.abs(rep.height - playerHeight);
	      return rep;
	    }); // get the highest bandwidth, closest resolution playlist
	
	    stableSort(leastPixelDiffList, function (left, right) {
	      // sort by highest bandwidth if pixelDiff is the same
	      if (left.pixelDiff === right.pixelDiff) {
	        return right.bandwidth - left.bandwidth;
	      }
	
	      return left.pixelDiff - right.pixelDiff;
	    });
	    leastPixelDiffRep = leastPixelDiffList[0];
	  } // fallback chain of variants
	
	
	  var chosenRep = leastPixelDiffRep || resolutionPlusOneRep || resolutionBestRep || bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
	
	  if (chosenRep && chosenRep.playlist) {
	    var _type = 'sortedPlaylistReps';
	
	    if (leastPixelDiffRep) {
	      _type = 'leastPixelDiffRep';
	    } else if (resolutionPlusOneRep) {
	      _type = 'resolutionPlusOneRep';
	    } else if (resolutionBestRep) {
	      _type = 'resolutionBestRep';
	    } else if (bandwidthBestRep) {
	      _type = 'bandwidthBestRep';
	    } else if (enabledPlaylistReps[0]) {
	      _type = 'enabledPlaylistReps';
	    }
	
	    logFn("choosing " + representationToString(chosenRep) + " using " + _type + " with options", options);
	    return chosenRep.playlist;
	  }
	
	  logFn('could not choose a playlist with options', options);
	  return null;
	};
	/**
	 * Chooses the appropriate media playlist based on the most recent
	 * bandwidth estimate and the player size.
	 *
	 * Expects to be called within the context of an instance of VhsHandler
	 *
	 * @return {Playlist} the highest bitrate playlist less than the
	 * currently detected bandwidth, accounting for some amount of
	 * bandwidth variance
	 */
	
	
	var lastBandwidthSelector = function lastBandwidthSelector() {
	  var pixelRatio = this.useDevicePixelRatio ? window__default['default'].devicePixelRatio || 1 : 1;
	  return simpleSelector(this.playlists.master, this.systemBandwidth, parseInt(safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio, parseInt(safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
	};
	/**
	 * Chooses the appropriate media playlist based on an
	 * exponential-weighted moving average of the bandwidth after
	 * filtering for player size.
	 *
	 * Expects to be called within the context of an instance of VhsHandler
	 *
	 * @param {number} decay - a number between 0 and 1. Higher values of
	 * this parameter will cause previous bandwidth estimates to lose
	 * significance more quickly.
	 * @return {Function} a function which can be invoked to create a new
	 * playlist selector function.
	 * @see https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
	 */
	
	
	var movingAverageBandwidthSelector = function movingAverageBandwidthSelector(decay) {
	  var average = -1;
	  var lastSystemBandwidth = -1;
	
	  if (decay < 0 || decay > 1) {
	    throw new Error('Moving average bandwidth decay must be between 0 and 1.');
	  }
	
	  return function () {
	    var pixelRatio = this.useDevicePixelRatio ? window__default['default'].devicePixelRatio || 1 : 1;
	
	    if (average < 0) {
	      average = this.systemBandwidth;
	      lastSystemBandwidth = this.systemBandwidth;
	    } // stop the average value from decaying for every 250ms
	    // when the systemBandwidth is constant
	    // and
	    // stop average from setting to a very low value when the
	    // systemBandwidth becomes 0 in case of chunk cancellation
	
	
	    if (this.systemBandwidth > 0 && this.systemBandwidth !== lastSystemBandwidth) {
	      average = decay * this.systemBandwidth + (1 - decay) * average;
	      lastSystemBandwidth = this.systemBandwidth;
	    }
	
	    return simpleSelector(this.playlists.master, average, parseInt(safeGetComputedStyle(this.tech_.el(), 'width'), 10) * pixelRatio, parseInt(safeGetComputedStyle(this.tech_.el(), 'height'), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
	  };
	};
	/**
	 * Chooses the appropriate media playlist based on the potential to rebuffer
	 *
	 * @param {Object} settings
	 *        Object of information required to use this selector
	 * @param {Object} settings.master
	 *        Object representation of the master manifest
	 * @param {number} settings.currentTime
	 *        The current time of the player
	 * @param {number} settings.bandwidth
	 *        Current measured bandwidth
	 * @param {number} settings.duration
	 *        Duration of the media
	 * @param {number} settings.segmentDuration
	 *        Segment duration to be used in round trip time calculations
	 * @param {number} settings.timeUntilRebuffer
	 *        Time left in seconds until the player has to rebuffer
	 * @param {number} settings.currentTimeline
	 *        The current timeline segments are being loaded from
	 * @param {SyncController} settings.syncController
	 *        SyncController for determining if we have a sync point for a given playlist
	 * @return {Object|null}
	 *         {Object} return.playlist
	 *         The highest bandwidth playlist with the least amount of rebuffering
	 *         {Number} return.rebufferingImpact
	 *         The amount of time in seconds switching to this playlist will rebuffer. A
	 *         negative value means that switching will cause zero rebuffering.
	 */
	
	
	var minRebufferMaxBandwidthSelector = function minRebufferMaxBandwidthSelector(settings) {
	  var master = settings.master,
	      currentTime = settings.currentTime,
	      bandwidth = settings.bandwidth,
	      duration = settings.duration,
	      segmentDuration = settings.segmentDuration,
	      timeUntilRebuffer = settings.timeUntilRebuffer,
	      currentTimeline = settings.currentTimeline,
	      syncController = settings.syncController; // filter out any playlists that have been excluded due to
	  // incompatible configurations
	
	  var compatiblePlaylists = master.playlists.filter(function (playlist) {
	    return !Playlist.isIncompatible(playlist);
	  }); // filter out any playlists that have been disabled manually through the representations
	  // api or blacklisted temporarily due to playback errors.
	
	  var enabledPlaylists = compatiblePlaylists.filter(Playlist.isEnabled);
	
	  if (!enabledPlaylists.length) {
	    // if there are no enabled playlists, then they have all been blacklisted or disabled
	    // by the user through the representations api. In this case, ignore blacklisting and
	    // fallback to what the user wants by using playlists the user has not disabled.
	    enabledPlaylists = compatiblePlaylists.filter(function (playlist) {
	      return !Playlist.isDisabled(playlist);
	    });
	  }
	
	  var bandwidthPlaylists = enabledPlaylists.filter(Playlist.hasAttribute.bind(null, 'BANDWIDTH'));
	  var rebufferingEstimates = bandwidthPlaylists.map(function (playlist) {
	    var syncPoint = syncController.getSyncPoint(playlist, duration, currentTimeline, currentTime); // If there is no sync point for this playlist, switching to it will require a
	    // sync request first. This will double the request time
	
	    var numRequests = syncPoint ? 1 : 2;
	    var requestTimeEstimate = Playlist.estimateSegmentRequestTime(segmentDuration, bandwidth, playlist);
	    var rebufferingImpact = requestTimeEstimate * numRequests - timeUntilRebuffer;
	    return {
	      playlist: playlist,
	      rebufferingImpact: rebufferingImpact
	    };
	  });
	  var noRebufferingPlaylists = rebufferingEstimates.filter(function (estimate) {
	    return estimate.rebufferingImpact <= 0;
	  }); // Sort by bandwidth DESC
	
	  stableSort(noRebufferingPlaylists, function (a, b) {
	    return comparePlaylistBandwidth(b.playlist, a.playlist);
	  });
	
	  if (noRebufferingPlaylists.length) {
	    return noRebufferingPlaylists[0];
	  }
	
	  stableSort(rebufferingEstimates, function (a, b) {
	    return a.rebufferingImpact - b.rebufferingImpact;
	  });
	  return rebufferingEstimates[0] || null;
	};
	/**
	 * Chooses the appropriate media playlist, which in this case is the lowest bitrate
	 * one with video.  If no renditions with video exist, return the lowest audio rendition.
	 *
	 * Expects to be called within the context of an instance of VhsHandler
	 *
	 * @return {Object|null}
	 *         {Object} return.playlist
	 *         The lowest bitrate playlist that contains a video codec.  If no such rendition
	 *         exists pick the lowest audio rendition.
	 */
	
	
	var lowestBitrateCompatibleVariantSelector = function lowestBitrateCompatibleVariantSelector() {
	  var _this = this; // filter out any playlists that have been excluded due to
	  // incompatible configurations or playback errors
	
	
	  var playlists = this.playlists.master.playlists.filter(Playlist.isEnabled); // Sort ascending by bitrate
	
	  stableSort(playlists, function (a, b) {
	    return comparePlaylistBandwidth(a, b);
	  }); // Parse and assume that playlists with no video codec have no video
	  // (this is not necessarily true, although it is generally true).
	  //
	  // If an entire manifest has no valid videos everything will get filtered
	  // out.
	
	  var playlistsWithVideo = playlists.filter(function (playlist) {
	    return !!codecsForPlaylist(_this.playlists.master, playlist).video;
	  });
	  return playlistsWithVideo[0] || null;
	};
	/**
	 * Combine all segments into a single Uint8Array
	 *
	 * @param {Object} segmentObj
	 * @return {Uint8Array} concatenated bytes
	 * @private
	 */
	
	
	var concatSegments = function concatSegments(segmentObj) {
	  var offset = 0;
	  var tempBuffer;
	
	  if (segmentObj.bytes) {
	    tempBuffer = new Uint8Array(segmentObj.bytes); // combine the individual segments into one large typed-array
	
	    segmentObj.segments.forEach(function (segment) {
	      tempBuffer.set(segment, offset);
	      offset += segment.byteLength;
	    });
	  }
	
	  return tempBuffer;
	};
	/**
	 * @file text-tracks.js
	 */
	
	/**
	 * Create captions text tracks on video.js if they do not exist
	 *
	 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
	 * @param {Object} tech the video.js tech
	 * @param {Object} captionStream the caption stream to create
	 * @private
	 */
	
	
	var createCaptionsTrackIfNotExists = function createCaptionsTrackIfNotExists(inbandTextTracks, tech, captionStream) {
	  if (!inbandTextTracks[captionStream]) {
	    tech.trigger({
	      type: 'usage',
	      name: 'vhs-608'
	    });
	    tech.trigger({
	      type: 'usage',
	      name: 'hls-608'
	    });
	    var instreamId = captionStream; // we need to translate SERVICEn for 708 to how mux.js currently labels them
	
	    if (/^cc708_/.test(captionStream)) {
	      instreamId = 'SERVICE' + captionStream.split('_')[1];
	    }
	
	    var track = tech.textTracks().getTrackById(instreamId);
	
	    if (track) {
	      // Resuse an existing track with a CC# id because this was
	      // very likely created by videojs-contrib-hls from information
	      // in the m3u8 for us to use
	      inbandTextTracks[captionStream] = track;
	    } else {
	      // This section gets called when we have caption services that aren't specified in the manifest.
	      // Manifest level caption services are handled in media-groups.js under CLOSED-CAPTIONS.
	      var captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
	      var label = captionStream;
	      var language = captionStream;
	      var def = false;
	      var captionService = captionServices[instreamId];
	
	      if (captionService) {
	        label = captionService.label;
	        language = captionService.language;
	        def = captionService["default"];
	      } // Otherwise, create a track with the default `CC#` label and
	      // without a language
	
	
	      inbandTextTracks[captionStream] = tech.addRemoteTextTrack({
	        kind: 'captions',
	        id: instreamId,
	        // TODO: investigate why this doesn't seem to turn the caption on by default
	        "default": def,
	        label: label,
	        language: language
	      }, false).track;
	    }
	  }
	};
	/**
	 * Add caption text track data to a source handler given an array of captions
	 *
	 * @param {Object}
	 *   @param {Object} inbandTextTracks the inband text tracks
	 *   @param {number} timestampOffset the timestamp offset of the source buffer
	 *   @param {Array} captionArray an array of caption data
	 * @private
	 */
	
	
	var addCaptionData = function addCaptionData(_ref) {
	  var inbandTextTracks = _ref.inbandTextTracks,
	      captionArray = _ref.captionArray,
	      timestampOffset = _ref.timestampOffset;
	
	  if (!captionArray) {
	    return;
	  }
	
	  var Cue = window__default['default'].WebKitDataCue || window__default['default'].VTTCue;
	  captionArray.forEach(function (caption) {
	    var track = caption.stream;
	    inbandTextTracks[track].addCue(new Cue(caption.startTime + timestampOffset, caption.endTime + timestampOffset, caption.text));
	  });
	};
	/**
	 * Define properties on a cue for backwards compatability,
	 * but warn the user that the way that they are using it
	 * is depricated and will be removed at a later date.
	 *
	 * @param {Cue} cue the cue to add the properties on
	 * @private
	 */
	
	
	var deprecateOldCue = function deprecateOldCue(cue) {
	  Object.defineProperties(cue.frame, {
	    id: {
	      get: function get() {
	        videojs.log.warn('cue.frame.id is deprecated. Use cue.value.key instead.');
	        return cue.value.key;
	      }
	    },
	    value: {
	      get: function get() {
	        videojs.log.warn('cue.frame.value is deprecated. Use cue.value.data instead.');
	        return cue.value.data;
	      }
	    },
	    privateData: {
	      get: function get() {
	        videojs.log.warn('cue.frame.privateData is deprecated. Use cue.value.data instead.');
	        return cue.value.data;
	      }
	    }
	  });
	};
	/**
	 * Add metadata text track data to a source handler given an array of metadata
	 *
	 * @param {Object}
	 *   @param {Object} inbandTextTracks the inband text tracks
	 *   @param {Array} metadataArray an array of meta data
	 *   @param {number} timestampOffset the timestamp offset of the source buffer
	 *   @param {number} videoDuration the duration of the video
	 * @private
	 */
	
	
	var addMetadata = function addMetadata(_ref2) {
	  var inbandTextTracks = _ref2.inbandTextTracks,
	      metadataArray = _ref2.metadataArray,
	      timestampOffset = _ref2.timestampOffset,
	      videoDuration = _ref2.videoDuration;
	
	  if (!metadataArray) {
	    return;
	  }
	
	  var Cue = window__default['default'].WebKitDataCue || window__default['default'].VTTCue;
	  var metadataTrack = inbandTextTracks.metadataTrack_;
	
	  if (!metadataTrack) {
	    return;
	  }
	
	  metadataArray.forEach(function (metadata) {
	    var time = metadata.cueTime + timestampOffset; // if time isn't a finite number between 0 and Infinity, like NaN,
	    // ignore this bit of metadata.
	    // This likely occurs when you have an non-timed ID3 tag like TIT2,
	    // which is the "Title/Songname/Content description" frame
	
	    if (typeof time !== 'number' || window__default['default'].isNaN(time) || time < 0 || !(time < Infinity)) {
	      return;
	    }
	
	    metadata.frames.forEach(function (frame) {
	      var cue = new Cue(time, time, frame.value || frame.url || frame.data || '');
	      cue.frame = frame;
	      cue.value = frame;
	      deprecateOldCue(cue);
	      metadataTrack.addCue(cue);
	    });
	  });
	
	  if (!metadataTrack.cues || !metadataTrack.cues.length) {
	    return;
	  } // Updating the metadeta cues so that
	  // the endTime of each cue is the startTime of the next cue
	  // the endTime of last cue is the duration of the video
	
	
	  var cues = metadataTrack.cues;
	  var cuesArray = []; // Create a copy of the TextTrackCueList...
	  // ...disregarding cues with a falsey value
	
	  for (var i = 0; i < cues.length; i++) {
	    if (cues[i]) {
	      cuesArray.push(cues[i]);
	    }
	  } // Group cues by their startTime value
	
	
	  var cuesGroupedByStartTime = cuesArray.reduce(function (obj, cue) {
	    var timeSlot = obj[cue.startTime] || [];
	    timeSlot.push(cue);
	    obj[cue.startTime] = timeSlot;
	    return obj;
	  }, {}); // Sort startTimes by ascending order
	
	  var sortedStartTimes = Object.keys(cuesGroupedByStartTime).sort(function (a, b) {
	    return Number(a) - Number(b);
	  }); // Map each cue group's endTime to the next group's startTime
	
	  sortedStartTimes.forEach(function (startTime, idx) {
	    var cueGroup = cuesGroupedByStartTime[startTime];
	    var nextTime = Number(sortedStartTimes[idx + 1]) || videoDuration; // Map each cue's endTime the next group's startTime
	
	    cueGroup.forEach(function (cue) {
	      cue.endTime = nextTime;
	    });
	  });
	};
	/**
	 * Create metadata text track on video.js if it does not exist
	 *
	 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
	 * @param {string} dispatchType the inband metadata track dispatch type
	 * @param {Object} tech the video.js tech
	 * @private
	 */
	
	
	var createMetadataTrackIfNotExists = function createMetadataTrackIfNotExists(inbandTextTracks, dispatchType, tech) {
	  if (inbandTextTracks.metadataTrack_) {
	    return;
	  }
	
	  inbandTextTracks.metadataTrack_ = tech.addRemoteTextTrack({
	    kind: 'metadata',
	    label: 'Timed Metadata'
	  }, false).track;
	  inbandTextTracks.metadataTrack_.inBandMetadataTrackDispatchType = dispatchType;
	};
	/**
	 * Remove cues from a track on video.js.
	 *
	 * @param {Double} start start of where we should remove the cue
	 * @param {Double} end end of where the we should remove the cue
	 * @param {Object} track the text track to remove the cues from
	 * @private
	 */
	
	
	var removeCuesFromTrack = function removeCuesFromTrack(start, end, track) {
	  var i;
	  var cue;
	
	  if (!track) {
	    return;
	  }
	
	  if (!track.cues) {
	    return;
	  }
	
	  i = track.cues.length;
	
	  while (i--) {
	    cue = track.cues[i]; // Remove any cue within the provided start and end time
	
	    if (cue.startTime >= start && cue.endTime <= end) {
	      track.removeCue(cue);
	    }
	  }
	};
	/**
	 * Remove duplicate cues from a track on video.js (a cue is considered a
	 * duplicate if it has the same time interval and text as another)
	 *
	 * @param {Object} track the text track to remove the duplicate cues from
	 * @private
	 */
	
	
	var removeDuplicateCuesFromTrack = function removeDuplicateCuesFromTrack(track) {
	  var cues = track.cues;
	
	  if (!cues) {
	    return;
	  }
	
	  for (var i = 0; i < cues.length; i++) {
	    var duplicates = [];
	    var occurrences = 0;
	
	    for (var j = 0; j < cues.length; j++) {
	      if (cues[i].startTime === cues[j].startTime && cues[i].endTime === cues[j].endTime && cues[i].text === cues[j].text) {
	        occurrences++;
	
	        if (occurrences > 1) {
	          duplicates.push(cues[j]);
	        }
	      }
	    }
	
	    if (duplicates.length) {
	      duplicates.forEach(function (dupe) {
	        return track.removeCue(dupe);
	      });
	    }
	  }
	};
	/**
	 * Returns a list of gops in the buffer that have a pts value of 3 seconds or more in
	 * front of current time.
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {number} currentTime
	 *        The current time
	 * @param {Double} mapping
	 *        Offset to map display time to stream presentation time
	 * @return {Array}
	 *         List of gops considered safe to append over
	 */
	
	
	var gopsSafeToAlignWith = function gopsSafeToAlignWith(buffer, currentTime, mapping) {
	  if (typeof currentTime === 'undefined' || currentTime === null || !buffer.length) {
	    return [];
	  } // pts value for current time + 3 seconds to give a bit more wiggle room
	
	
	  var currentTimePts = Math.ceil((currentTime - mapping + 3) * clock.ONE_SECOND_IN_TS);
	  var i;
	
	  for (i = 0; i < buffer.length; i++) {
	    if (buffer[i].pts > currentTimePts) {
	      break;
	    }
	  }
	
	  return buffer.slice(i);
	};
	/**
	 * Appends gop information (timing and byteLength) received by the transmuxer for the
	 * gops appended in the last call to appendBuffer
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {Array} gops
	 *        List of new gop information
	 * @param {boolean} replace
	 *        If true, replace the buffer with the new gop information. If false, append the
	 *        new gop information to the buffer in the right location of time.
	 * @return {Array}
	 *         Updated list of gop information
	 */
	
	
	var updateGopBuffer = function updateGopBuffer(buffer, gops, replace) {
	  if (!gops.length) {
	    return buffer;
	  }
	
	  if (replace) {
	    // If we are in safe append mode, then completely overwrite the gop buffer
	    // with the most recent appeneded data. This will make sure that when appending
	    // future segments, we only try to align with gops that are both ahead of current
	    // time and in the last segment appended.
	    return gops.slice();
	  }
	
	  var start = gops[0].pts;
	  var i = 0;
	
	  for (i; i < buffer.length; i++) {
	    if (buffer[i].pts >= start) {
	      break;
	    }
	  }
	
	  return buffer.slice(0, i).concat(gops);
	};
	/**
	 * Removes gop information in buffer that overlaps with provided start and end
	 *
	 * @param {Array} buffer
	 *        The current buffer of gop information
	 * @param {Double} start
	 *        position to start the remove at
	 * @param {Double} end
	 *        position to end the remove at
	 * @param {Double} mapping
	 *        Offset to map display time to stream presentation time
	 */
	
	
	var removeGopBuffer = function removeGopBuffer(buffer, start, end, mapping) {
	  var startPts = Math.ceil((start - mapping) * clock.ONE_SECOND_IN_TS);
	  var endPts = Math.ceil((end - mapping) * clock.ONE_SECOND_IN_TS);
	  var updatedBuffer = buffer.slice();
	  var i = buffer.length;
	
	  while (i--) {
	    if (buffer[i].pts <= endPts) {
	      break;
	    }
	  }
	
	  if (i === -1) {
	    // no removal because end of remove range is before start of buffer
	    return updatedBuffer;
	  }
	
	  var j = i + 1;
	
	  while (j--) {
	    if (buffer[j].pts <= startPts) {
	      break;
	    }
	  } // clamp remove range start to 0 index
	
	
	  j = Math.max(j, 0);
	  updatedBuffer.splice(j, i - j + 1);
	  return updatedBuffer;
	};
	
	var shallowEqual = function shallowEqual(a, b) {
	  // if both are undefined
	  // or one or the other is undefined
	  // they are not equal
	  if (!a && !b || !a && b || a && !b) {
	    return false;
	  } // they are the same object and thus, equal
	
	
	  if (a === b) {
	    return true;
	  } // sort keys so we can make sure they have
	  // all the same keys later.
	
	
	  var akeys = Object.keys(a).sort();
	  var bkeys = Object.keys(b).sort(); // different number of keys, not equal
	
	  if (akeys.length !== bkeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < akeys.length; i++) {
	    var key = akeys[i]; // different sorted keys, not equal
	
	    if (key !== bkeys[i]) {
	      return false;
	    } // different values, not equal
	
	
	    if (a[key] !== b[key]) {
	      return false;
	    }
	  }
	
	  return true;
	}; // https://www.w3.org/TR/WebIDL-1/#quotaexceedederror
	
	
	var QUOTA_EXCEEDED_ERR = 22;
	/**
	 * The segment loader has no recourse except to fetch a segment in the
	 * current playlist and use the internal timestamps in that segment to
	 * generate a syncPoint. This function returns a good candidate index
	 * for that process.
	 *
	 * @param {Array} segments - the segments array from a playlist.
	 * @return {number} An index of a segment from the playlist to load
	 */
	
	var getSyncSegmentCandidate = function getSyncSegmentCandidate(currentTimeline, segments, targetTime) {
	  segments = segments || [];
	  var timelineSegments = [];
	  var time = 0;
	
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	
	    if (currentTimeline === segment.timeline) {
	      timelineSegments.push(i);
	      time += segment.duration;
	
	      if (time > targetTime) {
	        return i;
	      }
	    }
	  }
	
	  if (timelineSegments.length === 0) {
	    return 0;
	  } // default to the last timeline segment
	
	
	  return timelineSegments[timelineSegments.length - 1];
	}; // In the event of a quota exceeded error, keep at least one second of back buffer. This
	// number was arbitrarily chosen and may be updated in the future, but seemed reasonable
	// as a start to prevent any potential issues with removing content too close to the
	// playhead.
	
	
	var MIN_BACK_BUFFER = 1; // in ms
	
	var CHECK_BUFFER_DELAY = 500;
	
	var finite = function finite(num) {
	  return typeof num === 'number' && isFinite(num);
	}; // With most content hovering around 30fps, if a segment has a duration less than a half
	// frame at 30fps or one frame at 60fps, the bandwidth and throughput calculations will
	// not accurately reflect the rest of the content.
	
	
	var MIN_SEGMENT_DURATION_TO_SAVE_STATS = 1 / 60;
	
	var illegalMediaSwitch = function illegalMediaSwitch(loaderType, startingMedia, trackInfo) {
	  // Although these checks should most likely cover non 'main' types, for now it narrows
	  // the scope of our checks.
	  if (loaderType !== 'main' || !startingMedia || !trackInfo) {
	    return null;
	  }
	
	  if (!trackInfo.hasAudio && !trackInfo.hasVideo) {
	    return 'Neither audio nor video found in segment.';
	  }
	
	  if (startingMedia.hasVideo && !trackInfo.hasVideo) {
	    return 'Only audio found in segment when we expected video.' + ' We can\'t switch to audio only from a stream that had video.' + ' To get rid of this message, please add codec information to the manifest.';
	  }
	
	  if (!startingMedia.hasVideo && trackInfo.hasVideo) {
	    return 'Video found in segment when we expected only audio.' + ' We can\'t switch to a stream with video from an audio only stream.' + ' To get rid of this message, please add codec information to the manifest.';
	  }
	
	  return null;
	};
	/**
	 * Calculates a time value that is safe to remove from the back buffer without interrupting
	 * playback.
	 *
	 * @param {TimeRange} seekable
	 *        The current seekable range
	 * @param {number} currentTime
	 *        The current time of the player
	 * @param {number} targetDuration
	 *        The target duration of the current playlist
	 * @return {number}
	 *         Time that is safe to remove from the back buffer without interrupting playback
	 */
	
	
	var safeBackBufferTrimTime = function safeBackBufferTrimTime(seekable, currentTime, targetDuration) {
	  // 30 seconds before the playhead provides a safe default for trimming.
	  //
	  // Choosing a reasonable default is particularly important for high bitrate content and
	  // VOD videos/live streams with large windows, as the buffer may end up overfilled and
	  // throw an APPEND_BUFFER_ERR.
	  var trimTime = currentTime - Config.BACK_BUFFER_LENGTH;
	
	  if (seekable.length) {
	    // Some live playlists may have a shorter window of content than the full allowed back
	    // buffer. For these playlists, don't save content that's no longer within the window.
	    trimTime = Math.max(trimTime, seekable.start(0));
	  } // Don't remove within target duration of the current time to avoid the possibility of
	  // removing the GOP currently being played, as removing it can cause playback stalls.
	
	
	  var maxTrimTime = currentTime - targetDuration;
	  return Math.min(maxTrimTime, trimTime);
	};
	
	var segmentInfoString = function segmentInfoString(segmentInfo) {
	  var startOfSegment = segmentInfo.startOfSegment,
	      duration = segmentInfo.duration,
	      segment = segmentInfo.segment,
	      part = segmentInfo.part,
	      _segmentInfo$playlist = segmentInfo.playlist,
	      seq = _segmentInfo$playlist.mediaSequence,
	      id = _segmentInfo$playlist.id,
	      _segmentInfo$playlist2 = _segmentInfo$playlist.segments,
	      segments = _segmentInfo$playlist2 === void 0 ? [] : _segmentInfo$playlist2,
	      index = segmentInfo.mediaIndex,
	      partIndex = segmentInfo.partIndex,
	      timeline = segmentInfo.timeline;
	  var segmentLen = segments.length - 1;
	  var selection = 'mediaIndex/partIndex increment';
	
	  if (segmentInfo.getMediaInfoForTime) {
	    selection = "getMediaInfoForTime (" + segmentInfo.getMediaInfoForTime + ")";
	  } else if (segmentInfo.isSyncRequest) {
	    selection = 'getSyncSegmentCandidate (isSyncRequest)';
	  }
	
	  if (segmentInfo.independent) {
	    selection += " with independent " + segmentInfo.independent;
	  }
	
	  var hasPartIndex = typeof partIndex === 'number';
	  var name = segmentInfo.segment.uri ? 'segment' : 'pre-segment';
	  var zeroBasedPartCount = hasPartIndex ? getKnownPartCount({
	    preloadSegment: segment
	  }) - 1 : 0;
	  return name + " [" + (seq + index) + "/" + (seq + segmentLen) + "]" + (hasPartIndex ? " part [" + partIndex + "/" + zeroBasedPartCount + "]" : '') + (" segment start/end [" + segment.start + " => " + segment.end + "]") + (hasPartIndex ? " part start/end [" + part.start + " => " + part.end + "]" : '') + (" startOfSegment [" + startOfSegment + "]") + (" duration [" + duration + "]") + (" timeline [" + timeline + "]") + (" selected by [" + selection + "]") + (" playlist [" + id + "]");
	};
	
	var timingInfoPropertyForMedia = function timingInfoPropertyForMedia(mediaType) {
	  return mediaType + "TimingInfo";
	};
	/**
	 * Returns the timestamp offset to use for the segment.
	 *
	 * @param {number} segmentTimeline
	 *        The timeline of the segment
	 * @param {number} currentTimeline
	 *        The timeline currently being followed by the loader
	 * @param {number} startOfSegment
	 *        The estimated segment start
	 * @param {TimeRange[]} buffered
	 *        The loader's buffer
	 * @param {boolean} overrideCheck
	 *        If true, no checks are made to see if the timestamp offset value should be set,
	 *        but sets it directly to a value.
	 *
	 * @return {number|null}
	 *         Either a number representing a new timestamp offset, or null if the segment is
	 *         part of the same timeline
	 */
	
	
	var timestampOffsetForSegment = function timestampOffsetForSegment(_ref) {
	  var segmentTimeline = _ref.segmentTimeline,
	      currentTimeline = _ref.currentTimeline,
	      startOfSegment = _ref.startOfSegment,
	      buffered = _ref.buffered,
	      overrideCheck = _ref.overrideCheck; // Check to see if we are crossing a discontinuity to see if we need to set the
	  // timestamp offset on the transmuxer and source buffer.
	  //
	  // Previously, we changed the timestampOffset if the start of this segment was less than
	  // the currently set timestampOffset, but this isn't desirable as it can produce bad
	  // behavior, especially around long running live streams.
	
	  if (!overrideCheck && segmentTimeline === currentTimeline) {
	    return null;
	  } // When changing renditions, it's possible to request a segment on an older timeline. For
	  // instance, given two renditions with the following:
	  //
	  // #EXTINF:10
	  // segment1
	  // #EXT-X-DISCONTINUITY
	  // #EXTINF:10
	  // segment2
	  // #EXTINF:10
	  // segment3
	  //
	  // And the current player state:
	  //
	  // current time: 8
	  // buffer: 0 => 20
	  //
	  // The next segment on the current rendition would be segment3, filling the buffer from
	  // 20s onwards. However, if a rendition switch happens after segment2 was requested,
	  // then the next segment to be requested will be segment1 from the new rendition in
	  // order to fill time 8 and onwards. Using the buffered end would result in repeated
	  // content (since it would position segment1 of the new rendition starting at 20s). This
	  // case can be identified when the new segment's timeline is a prior value. Instead of
	  // using the buffered end, the startOfSegment can be used, which, hopefully, will be
	  // more accurate to the actual start time of the segment.
	
	
	  if (segmentTimeline < currentTimeline) {
	    return startOfSegment;
	  } // segmentInfo.startOfSegment used to be used as the timestamp offset, however, that
	  // value uses the end of the last segment if it is available. While this value
	  // should often be correct, it's better to rely on the buffered end, as the new
	  // content post discontinuity should line up with the buffered end as if it were
	  // time 0 for the new content.
	
	
	  return buffered.length ? buffered.end(buffered.length - 1) : startOfSegment;
	};
	/**
	 * Returns whether or not the loader should wait for a timeline change from the timeline
	 * change controller before processing the segment.
	 *
	 * Primary timing in VHS goes by video. This is different from most media players, as
	 * audio is more often used as the primary timing source. For the foreseeable future, VHS
	 * will continue to use video as the primary timing source, due to the current logic and
	 * expectations built around it.
	
	 * Since the timing follows video, in order to maintain sync, the video loader is
	 * responsible for setting both audio and video source buffer timestamp offsets.
	 *
	 * Setting different values for audio and video source buffers could lead to
	 * desyncing. The following examples demonstrate some of the situations where this
	 * distinction is important. Note that all of these cases involve demuxed content. When
	 * content is muxed, the audio and video are packaged together, therefore syncing
	 * separate media playlists is not an issue.
	 *
	 * CASE 1: Audio prepares to load a new timeline before video:
	 *
	 * Timeline:       0                 1
	 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Audio Loader:                     ^
	 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Video Loader              ^
	 *
	 * In the above example, the audio loader is preparing to load the 6th segment, the first
	 * after a discontinuity, while the video loader is still loading the 5th segment, before
	 * the discontinuity.
	 *
	 * If the audio loader goes ahead and loads and appends the 6th segment before the video
	 * loader crosses the discontinuity, then when appended, the 6th audio segment will use
	 * the timestamp offset from timeline 0. This will likely lead to desyncing. In addition,
	 * the audio loader must provide the audioAppendStart value to trim the content in the
	 * transmuxer, and that value relies on the audio timestamp offset. Since the audio
	 * timestamp offset is set by the video (main) loader, the audio loader shouldn't load the
	 * segment until that value is provided.
	 *
	 * CASE 2: Video prepares to load a new timeline before audio:
	 *
	 * Timeline:       0                 1
	 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Audio Loader:             ^
	 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Video Loader                      ^
	 *
	 * In the above example, the video loader is preparing to load the 6th segment, the first
	 * after a discontinuity, while the audio loader is still loading the 5th segment, before
	 * the discontinuity.
	 *
	 * If the video loader goes ahead and loads and appends the 6th segment, then once the
	 * segment is loaded and processed, both the video and audio timestamp offsets will be
	 * set, since video is used as the primary timing source. This is to ensure content lines
	 * up appropriately, as any modifications to the video timing are reflected by audio when
	 * the video loader sets the audio and video timestamp offsets to the same value. However,
	 * setting the timestamp offset for audio before audio has had a chance to change
	 * timelines will likely lead to desyncing, as the audio loader will append segment 5 with
	 * a timestamp intended to apply to segments from timeline 1 rather than timeline 0.
	 *
	 * CASE 3: When seeking, audio prepares to load a new timeline before video
	 *
	 * Timeline:       0                 1
	 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Audio Loader:           ^
	 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
	 * Video Loader            ^
	 *
	 * In the above example, both audio and video loaders are loading segments from timeline
	 * 0, but imagine that the seek originated from timeline 1.
	 *
	 * When seeking to a new timeline, the timestamp offset will be set based on the expected
	 * segment start of the loaded video segment. In order to maintain sync, the audio loader
	 * must wait for the video loader to load its segment and update both the audio and video
	 * timestamp offsets before it may load and append its own segment. This is the case
	 * whether the seek results in a mismatched segment request (e.g., the audio loader
	 * chooses to load segment 3 and the video loader chooses to load segment 4) or the
	 * loaders choose to load the same segment index from each playlist, as the segments may
	 * not be aligned perfectly, even for matching segment indexes.
	 *
	 * @param {Object} timelinechangeController
	 * @param {number} currentTimeline
	 *        The timeline currently being followed by the loader
	 * @param {number} segmentTimeline
	 *        The timeline of the segment being loaded
	 * @param {('main'|'audio')} loaderType
	 *        The loader type
	 * @param {boolean} audioDisabled
	 *        Whether the audio is disabled for the loader. This should only be true when the
	 *        loader may have muxed audio in its segment, but should not append it, e.g., for
	 *        the main loader when an alternate audio playlist is active.
	 *
	 * @return {boolean}
	 *         Whether the loader should wait for a timeline change from the timeline change
	 *         controller before processing the segment
	 */
	
	
	var shouldWaitForTimelineChange = function shouldWaitForTimelineChange(_ref2) {
	  var timelineChangeController = _ref2.timelineChangeController,
	      currentTimeline = _ref2.currentTimeline,
	      segmentTimeline = _ref2.segmentTimeline,
	      loaderType = _ref2.loaderType,
	      audioDisabled = _ref2.audioDisabled;
	
	  if (currentTimeline === segmentTimeline) {
	    return false;
	  }
	
	  if (loaderType === 'audio') {
	    var lastMainTimelineChange = timelineChangeController.lastTimelineChange({
	      type: 'main'
	    }); // Audio loader should wait if:
	    //
	    // * main hasn't had a timeline change yet (thus has not loaded its first segment)
	    // * main hasn't yet changed to the timeline audio is looking to load
	
	    return !lastMainTimelineChange || lastMainTimelineChange.to !== segmentTimeline;
	  } // The main loader only needs to wait for timeline changes if there's demuxed audio.
	  // Otherwise, there's nothing to wait for, since audio would be muxed into the main
	  // loader's segments (or the content is audio/video only and handled by the main
	  // loader).
	
	
	  if (loaderType === 'main' && audioDisabled) {
	    var pendingAudioTimelineChange = timelineChangeController.pendingTimelineChange({
	      type: 'audio'
	    }); // Main loader should wait for the audio loader if audio is not pending a timeline
	    // change to the current timeline.
	    //
	    // Since the main loader is responsible for setting the timestamp offset for both
	    // audio and video, the main loader must wait for audio to be about to change to its
	    // timeline before setting the offset, otherwise, if audio is behind in loading,
	    // segments from the previous timeline would be adjusted by the new timestamp offset.
	    //
	    // This requirement means that video will not cross a timeline until the audio is
	    // about to cross to it, so that way audio and video will always cross the timeline
	    // together.
	    //
	    // In addition to normal timeline changes, these rules also apply to the start of a
	    // stream (going from a non-existent timeline, -1, to timeline 0). It's important
	    // that these rules apply to the first timeline change because if they did not, it's
	    // possible that the main loader will cross two timelines before the audio loader has
	    // crossed one. Logic may be implemented to handle the startup as a special case, but
	    // it's easier to simply treat all timeline changes the same.
	
	    if (pendingAudioTimelineChange && pendingAudioTimelineChange.to === segmentTimeline) {
	      return false;
	    }
	
	    return true;
	  }
	
	  return false;
	};
	
	var mediaDuration = function mediaDuration(timingInfos) {
	  var maxDuration = 0;
	  ['video', 'audio'].forEach(function (type) {
	    var typeTimingInfo = timingInfos[type + "TimingInfo"];
	
	    if (!typeTimingInfo) {
	      return;
	    }
	
	    var start = typeTimingInfo.start,
	        end = typeTimingInfo.end;
	    var duration;
	
	    if (typeof start === 'bigint' || typeof end === 'bigint') {
	      duration = window__default['default'].BigInt(end) - window__default['default'].BigInt(start);
	    } else if (typeof start === 'number' && typeof end === 'number') {
	      duration = end - start;
	    }
	
	    if (typeof duration !== 'undefined' && duration > maxDuration) {
	      maxDuration = duration;
	    }
	  }); // convert back to a number if it is lower than MAX_SAFE_INTEGER
	  // as we only need BigInt when we are above that.
	
	  if (typeof maxDuration === 'bigint' && maxDuration < Number.MAX_SAFE_INTEGER) {
	    maxDuration = Number(maxDuration);
	  }
	
	  return maxDuration;
	};
	
	var segmentTooLong = function segmentTooLong(_ref3) {
	  var segmentDuration = _ref3.segmentDuration,
	      maxDuration = _ref3.maxDuration; // 0 duration segments are most likely due to metadata only segments or a lack of
	  // information.
	
	  if (!segmentDuration) {
	    return false;
	  } // For HLS:
	  //
	  // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1
	  // The EXTINF duration of each Media Segment in the Playlist
	  // file, when rounded to the nearest integer, MUST be less than or equal
	  // to the target duration; longer segments can trigger playback stalls
	  // or other errors.
	  //
	  // For DASH, the mpd-parser uses the largest reported segment duration as the target
	  // duration. Although that reported duration is occasionally approximate (i.e., not
	  // exact), a strict check may report that a segment is too long more often in DASH.
	
	
	  return Math.round(segmentDuration) > maxDuration + TIME_FUDGE_FACTOR;
	};
	
	var getTroublesomeSegmentDurationMessage = function getTroublesomeSegmentDurationMessage(segmentInfo, sourceType) {
	  // Right now we aren't following DASH's timing model exactly, so only perform
	  // this check for HLS content.
	  if (sourceType !== 'hls') {
	    return null;
	  }
	
	  var segmentDuration = mediaDuration({
	    audioTimingInfo: segmentInfo.audioTimingInfo,
	    videoTimingInfo: segmentInfo.videoTimingInfo
	  }); // Don't report if we lack information.
	  //
	  // If the segment has a duration of 0 it is either a lack of information or a
	  // metadata only segment and shouldn't be reported here.
	
	  if (!segmentDuration) {
	    return null;
	  }
	
	  var targetDuration = segmentInfo.playlist.targetDuration;
	  var isSegmentWayTooLong = segmentTooLong({
	    segmentDuration: segmentDuration,
	    maxDuration: targetDuration * 2
	  });
	  var isSegmentSlightlyTooLong = segmentTooLong({
	    segmentDuration: segmentDuration,
	    maxDuration: targetDuration
	  });
	  var segmentTooLongMessage = "Segment with index " + segmentInfo.mediaIndex + " " + ("from playlist " + segmentInfo.playlist.id + " ") + ("has a duration of " + segmentDuration + " ") + ("when the reported duration is " + segmentInfo.duration + " ") + ("and the target duration is " + targetDuration + ". ") + 'For HLS content, a duration in excess of the target duration may result in ' + 'playback issues. See the HLS specification section on EXT-X-TARGETDURATION for ' + 'more details: ' + 'https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1';
	
	  if (isSegmentWayTooLong || isSegmentSlightlyTooLong) {
	    return {
	      severity: isSegmentWayTooLong ? 'warn' : 'info',
	      message: segmentTooLongMessage
	    };
	  }
	
	  return null;
	};
	/**
	 * An object that manages segment loading and appending.
	 *
	 * @class SegmentLoader
	 * @param {Object} options required and optional options
	 * @extends videojs.EventTarget
	 */
	
	
	var SegmentLoader = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](SegmentLoader, _videojs$EventTarget);
	
	  function SegmentLoader(settings, options) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this; // check pre-conditions
	
	    if (!settings) {
	      throw new TypeError('Initialization settings are required');
	    }
	
	    if (typeof settings.currentTime !== 'function') {
	      throw new TypeError('No currentTime getter specified');
	    }
	
	    if (!settings.mediaSource) {
	      throw new TypeError('No MediaSource specified');
	    } // public properties
	
	
	    _this.bandwidth = settings.bandwidth;
	    _this.throughput = {
	      rate: 0,
	      count: 0
	    };
	    _this.roundTrip = NaN;
	
	    _this.resetStats_();
	
	    _this.mediaIndex = null;
	    _this.partIndex = null; // private settings
	
	    _this.hasPlayed_ = settings.hasPlayed;
	    _this.currentTime_ = settings.currentTime;
	    _this.seekable_ = settings.seekable;
	    _this.seeking_ = settings.seeking;
	    _this.duration_ = settings.duration;
	    _this.mediaSource_ = settings.mediaSource;
	    _this.vhs_ = settings.vhs;
	    _this.loaderType_ = settings.loaderType;
	    _this.currentMediaInfo_ = void 0;
	    _this.startingMediaInfo_ = void 0;
	    _this.segmentMetadataTrack_ = settings.segmentMetadataTrack;
	    _this.goalBufferLength_ = settings.goalBufferLength;
	    _this.sourceType_ = settings.sourceType;
	    _this.sourceUpdater_ = settings.sourceUpdater;
	    _this.inbandTextTracks_ = settings.inbandTextTracks;
	    _this.state_ = 'INIT';
	    _this.timelineChangeController_ = settings.timelineChangeController;
	    _this.shouldSaveSegmentTimingInfo_ = true;
	    _this.parse708captions_ = settings.parse708captions;
	    _this.useDtsForTimestampOffset_ = settings.useDtsForTimestampOffset;
	    _this.captionServices_ = settings.captionServices;
	    _this.experimentalExactManifestTimings = settings.experimentalExactManifestTimings; // private instance variables
	
	    _this.checkBufferTimeout_ = null;
	    _this.error_ = void 0;
	    _this.currentTimeline_ = -1;
	    _this.pendingSegment_ = null;
	    _this.xhrOptions_ = null;
	    _this.pendingSegments_ = [];
	    _this.audioDisabled_ = false;
	    _this.isPendingTimestampOffset_ = false; // TODO possibly move gopBuffer and timeMapping info to a separate controller
	
	    _this.gopBuffer_ = [];
	    _this.timeMapping_ = 0;
	    _this.safeAppend_ = videojs.browser.IE_VERSION >= 11;
	    _this.appendInitSegment_ = {
	      audio: true,
	      video: true
	    };
	    _this.playlistOfLastInitSegment_ = {
	      audio: null,
	      video: null
	    };
	    _this.callQueue_ = []; // If the segment loader prepares to load a segment, but does not have enough
	    // information yet to start the loading process (e.g., if the audio loader wants to
	    // load a segment from the next timeline but the main loader hasn't yet crossed that
	    // timeline), then the load call will be added to the queue until it is ready to be
	    // processed.
	
	    _this.loadQueue_ = [];
	    _this.metadataQueue_ = {
	      id3: [],
	      caption: []
	    };
	    _this.waitingOnRemove_ = false;
	    _this.quotaExceededErrorRetryTimeout_ = null; // Fragmented mp4 playback
	
	    _this.activeInitSegmentId_ = null;
	    _this.initSegments_ = {}; // HLSe playback
	
	    _this.cacheEncryptionKeys_ = settings.cacheEncryptionKeys;
	    _this.keyCache_ = {};
	    _this.decrypter_ = settings.decrypter; // Manages the tracking and generation of sync-points, mappings
	    // between a time in the display time and a segment index within
	    // a playlist
	
	    _this.syncController_ = settings.syncController;
	    _this.syncPoint_ = {
	      segmentIndex: 0,
	      time: 0
	    };
	    _this.transmuxer_ = _this.createTransmuxer_();
	
	    _this.triggerSyncInfoUpdate_ = function () {
	      return _this.trigger('syncinfoupdate');
	    };
	
	    _this.syncController_.on('syncinfoupdate', _this.triggerSyncInfoUpdate_);
	
	    _this.mediaSource_.addEventListener('sourceopen', function () {
	      if (!_this.isEndOfStream_()) {
	        _this.ended_ = false;
	      }
	    }); // ...for determining the fetch location
	
	
	    _this.fetchAtBuffer_ = false;
	    _this.logger_ = logger("SegmentLoader[" + _this.loaderType_ + "]");
	    Object.defineProperty(_assertThisInitialized__default['default'](_this), 'state', {
	      get: function get() {
	        return this.state_;
	      },
	      set: function set(newState) {
	        if (newState !== this.state_) {
	          this.logger_(this.state_ + " -> " + newState);
	          this.state_ = newState;
	          this.trigger('statechange');
	        }
	      }
	    });
	
	    _this.sourceUpdater_.on('ready', function () {
	      if (_this.hasEnoughInfoToAppend_()) {
	        _this.processCallQueue_();
	      }
	    }); // Only the main loader needs to listen for pending timeline changes, as the main
	    // loader should wait for audio to be ready to change its timeline so that both main
	    // and audio timelines change together. For more details, see the
	    // shouldWaitForTimelineChange function.
	
	
	    if (_this.loaderType_ === 'main') {
	      _this.timelineChangeController_.on('pendingtimelinechange', function () {
	        if (_this.hasEnoughInfoToAppend_()) {
	          _this.processCallQueue_();
	        }
	      });
	    } // The main loader only listens on pending timeline changes, but the audio loader,
	    // since its loads follow main, needs to listen on timeline changes. For more details,
	    // see the shouldWaitForTimelineChange function.
	
	
	    if (_this.loaderType_ === 'audio') {
	      _this.timelineChangeController_.on('timelinechange', function () {
	        if (_this.hasEnoughInfoToLoad_()) {
	          _this.processLoadQueue_();
	        }
	
	        if (_this.hasEnoughInfoToAppend_()) {
	          _this.processCallQueue_();
	        }
	      });
	    }
	
	    return _this;
	  }
	
	  var _proto = SegmentLoader.prototype;
	
	  _proto.createTransmuxer_ = function createTransmuxer_() {
	    return segmentTransmuxer.createTransmuxer({
	      remux: false,
	      alignGopsAtEnd: this.safeAppend_,
	      keepOriginalTimestamps: true,
	      parse708captions: this.parse708captions_,
	      captionServices: this.captionServices_
	    });
	  }
	  /**
	   * reset all of our media stats
	   *
	   * @private
	   */
	  ;
	
	  _proto.resetStats_ = function resetStats_() {
	    this.mediaBytesTransferred = 0;
	    this.mediaRequests = 0;
	    this.mediaRequestsAborted = 0;
	    this.mediaRequestsTimedout = 0;
	    this.mediaRequestsErrored = 0;
	    this.mediaTransferDuration = 0;
	    this.mediaSecondsLoaded = 0;
	    this.mediaAppends = 0;
	  }
	  /**
	   * dispose of the SegmentLoader and reset to the default state
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.state = 'DISPOSED';
	    this.pause();
	    this.abort_();
	
	    if (this.transmuxer_) {
	      this.transmuxer_.terminate();
	    }
	
	    this.resetStats_();
	
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	    }
	
	    if (this.syncController_ && this.triggerSyncInfoUpdate_) {
	      this.syncController_.off('syncinfoupdate', this.triggerSyncInfoUpdate_);
	    }
	
	    this.off();
	  };
	
	  _proto.setAudio = function setAudio(enable) {
	    this.audioDisabled_ = !enable;
	
	    if (enable) {
	      this.appendInitSegment_.audio = true;
	    } else {
	      // remove current track audio if it gets disabled
	      this.sourceUpdater_.removeAudio(0, this.duration_());
	    }
	  }
	  /**
	   * abort anything that is currently doing on with the SegmentLoader
	   * and reset to a default state
	   */
	  ;
	
	  _proto.abort = function abort() {
	    if (this.state !== 'WAITING') {
	      if (this.pendingSegment_) {
	        this.pendingSegment_ = null;
	      }
	
	      return;
	    }
	
	    this.abort_(); // We aborted the requests we were waiting on, so reset the loader's state to READY
	    // since we are no longer "waiting" on any requests. XHR callback is not always run
	    // when the request is aborted. This will prevent the loader from being stuck in the
	    // WAITING state indefinitely.
	
	    this.state = 'READY'; // don't wait for buffer check timeouts to begin fetching the
	    // next segment
	
	    if (!this.paused()) {
	      this.monitorBuffer_();
	    }
	  }
	  /**
	   * abort all pending xhr requests and null any pending segements
	   *
	   * @private
	   */
	  ;
	
	  _proto.abort_ = function abort_() {
	    if (this.pendingSegment_ && this.pendingSegment_.abortRequests) {
	      this.pendingSegment_.abortRequests();
	    } // clear out the segment being processed
	
	
	    this.pendingSegment_ = null;
	    this.callQueue_ = [];
	    this.loadQueue_ = [];
	    this.metadataQueue_.id3 = [];
	    this.metadataQueue_.caption = [];
	    this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
	    this.waitingOnRemove_ = false;
	    window__default['default'].clearTimeout(this.quotaExceededErrorRetryTimeout_);
	    this.quotaExceededErrorRetryTimeout_ = null;
	  };
	
	  _proto.checkForAbort_ = function checkForAbort_(requestId) {
	    // If the state is APPENDING, then aborts will not modify the state, meaning the first
	    // callback that happens should reset the state to READY so that loading can continue.
	    if (this.state === 'APPENDING' && !this.pendingSegment_) {
	      this.state = 'READY';
	      return true;
	    }
	
	    if (!this.pendingSegment_ || this.pendingSegment_.requestId !== requestId) {
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * set an error on the segment loader and null out any pending segements
	   *
	   * @param {Error} error the error to set on the SegmentLoader
	   * @return {Error} the error that was set or that is currently set
	   */
	  ;
	
	  _proto.error = function error(_error) {
	    if (typeof _error !== 'undefined') {
	      this.logger_('error occurred:', _error);
	      this.error_ = _error;
	    }
	
	    this.pendingSegment_ = null;
	    return this.error_;
	  };
	
	  _proto.endOfStream = function endOfStream() {
	    this.ended_ = true;
	
	    if (this.transmuxer_) {
	      // need to clear out any cached data to prepare for the new segment
	      segmentTransmuxer.reset(this.transmuxer_);
	    }
	
	    this.gopBuffer_.length = 0;
	    this.pause();
	    this.trigger('ended');
	  }
	  /**
	   * Indicates which time ranges are buffered
	   *
	   * @return {TimeRange}
	   *         TimeRange object representing the current buffered ranges
	   */
	  ;
	
	  _proto.buffered_ = function buffered_() {
	    var trackInfo = this.getMediaInfo_();
	
	    if (!this.sourceUpdater_ || !trackInfo) {
	      return videojs.createTimeRanges();
	    }
	
	    if (this.loaderType_ === 'main') {
	      var hasAudio = trackInfo.hasAudio,
	          hasVideo = trackInfo.hasVideo,
	          isMuxed = trackInfo.isMuxed;
	
	      if (hasVideo && hasAudio && !this.audioDisabled_ && !isMuxed) {
	        return this.sourceUpdater_.buffered();
	      }
	
	      if (hasVideo) {
	        return this.sourceUpdater_.videoBuffered();
	      }
	    } // One case that can be ignored for now is audio only with alt audio,
	    // as we don't yet have proper support for that.
	
	
	    return this.sourceUpdater_.audioBuffered();
	  }
	  /**
	   * Gets and sets init segment for the provided map
	   *
	   * @param {Object} map
	   *        The map object representing the init segment to get or set
	   * @param {boolean=} set
	   *        If true, the init segment for the provided map should be saved
	   * @return {Object}
	   *         map object for desired init segment
	   */
	  ;
	
	  _proto.initSegmentForMap = function initSegmentForMap(map, set) {
	    if (set === void 0) {
	      set = false;
	    }
	
	    if (!map) {
	      return null;
	    }
	
	    var id = initSegmentId(map);
	    var storedMap = this.initSegments_[id];
	
	    if (set && !storedMap && map.bytes) {
	      this.initSegments_[id] = storedMap = {
	        resolvedUri: map.resolvedUri,
	        byterange: map.byterange,
	        bytes: map.bytes,
	        tracks: map.tracks,
	        timescales: map.timescales
	      };
	    }
	
	    return storedMap || map;
	  }
	  /**
	   * Gets and sets key for the provided key
	   *
	   * @param {Object} key
	   *        The key object representing the key to get or set
	   * @param {boolean=} set
	   *        If true, the key for the provided key should be saved
	   * @return {Object}
	   *         Key object for desired key
	   */
	  ;
	
	  _proto.segmentKey = function segmentKey(key, set) {
	    if (set === void 0) {
	      set = false;
	    }
	
	    if (!key) {
	      return null;
	    }
	
	    var id = segmentKeyId(key);
	    var storedKey = this.keyCache_[id]; // TODO: We should use the HTTP Expires header to invalidate our cache per
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-6.2.3
	
	    if (this.cacheEncryptionKeys_ && set && !storedKey && key.bytes) {
	      this.keyCache_[id] = storedKey = {
	        resolvedUri: key.resolvedUri,
	        bytes: key.bytes
	      };
	    }
	
	    var result = {
	      resolvedUri: (storedKey || key).resolvedUri
	    };
	
	    if (storedKey) {
	      result.bytes = storedKey.bytes;
	    }
	
	    return result;
	  }
	  /**
	   * Returns true if all configuration required for loading is present, otherwise false.
	   *
	   * @return {boolean} True if the all configuration is ready for loading
	   * @private
	   */
	  ;
	
	  _proto.couldBeginLoading_ = function couldBeginLoading_() {
	    return this.playlist_ && !this.paused();
	  }
	  /**
	   * load a playlist and start to fill the buffer
	   */
	  ;
	
	  _proto.load = function load() {
	    // un-pause
	    this.monitorBuffer_(); // if we don't have a playlist yet, keep waiting for one to be
	    // specified
	
	    if (!this.playlist_) {
	      return;
	    } // if all the configuration is ready, initialize and begin loading
	
	
	    if (this.state === 'INIT' && this.couldBeginLoading_()) {
	      return this.init_();
	    } // if we're in the middle of processing a segment already, don't
	    // kick off an additional segment request
	
	
	    if (!this.couldBeginLoading_() || this.state !== 'READY' && this.state !== 'INIT') {
	      return;
	    }
	
	    this.state = 'READY';
	  }
	  /**
	   * Once all the starting parameters have been specified, begin
	   * operation. This method should only be invoked from the INIT
	   * state.
	   *
	   * @private
	   */
	  ;
	
	  _proto.init_ = function init_() {
	    this.state = 'READY'; // if this is the audio segment loader, and it hasn't been inited before, then any old
	    // audio data from the muxed content should be removed
	
	    this.resetEverything();
	    return this.monitorBuffer_();
	  }
	  /**
	   * set a playlist on the segment loader
	   *
	   * @param {PlaylistLoader} media the playlist to set on the segment loader
	   */
	  ;
	
	  _proto.playlist = function playlist(newPlaylist, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!newPlaylist) {
	      return;
	    }
	
	    var oldPlaylist = this.playlist_;
	    var segmentInfo = this.pendingSegment_;
	    this.playlist_ = newPlaylist;
	    this.xhrOptions_ = options; // when we haven't started playing yet, the start of a live playlist
	    // is always our zero-time so force a sync update each time the playlist
	    // is refreshed from the server
	    //
	    // Use the INIT state to determine if playback has started, as the playlist sync info
	    // should be fixed once requests begin (as sync points are generated based on sync
	    // info), but not before then.
	
	    if (this.state === 'INIT') {
	      newPlaylist.syncInfo = {
	        mediaSequence: newPlaylist.mediaSequence,
	        time: 0
	      }; // Setting the date time mapping means mapping the program date time (if available)
	      // to time 0 on the player's timeline. The playlist's syncInfo serves a similar
	      // purpose, mapping the initial mediaSequence to time zero. Since the syncInfo can
	      // be updated as the playlist is refreshed before the loader starts loading, the
	      // program date time mapping needs to be updated as well.
	      //
	      // This mapping is only done for the main loader because a program date time should
	      // map equivalently between playlists.
	
	      if (this.loaderType_ === 'main') {
	        this.syncController_.setDateTimeMappingForStart(newPlaylist);
	      }
	    }
	
	    var oldId = null;
	
	    if (oldPlaylist) {
	      if (oldPlaylist.id) {
	        oldId = oldPlaylist.id;
	      } else if (oldPlaylist.uri) {
	        oldId = oldPlaylist.uri;
	      }
	    }
	
	    this.logger_("playlist update [" + oldId + " => " + (newPlaylist.id || newPlaylist.uri) + "]"); // in VOD, this is always a rendition switch (or we updated our syncInfo above)
	    // in LIVE, we always want to update with new playlists (including refreshes)
	
	    this.trigger('syncinfoupdate'); // if we were unpaused but waiting for a playlist, start
	    // buffering now
	
	    if (this.state === 'INIT' && this.couldBeginLoading_()) {
	      return this.init_();
	    }
	
	    if (!oldPlaylist || oldPlaylist.uri !== newPlaylist.uri) {
	      if (this.mediaIndex !== null) {
	        // we must reset/resync the segment loader when we switch renditions and
	        // the segment loader is already synced to the previous rendition
	        // on playlist changes we want it to be possible to fetch
	        // at the buffer for vod but not for live. So we use resetLoader
	        // for live and resyncLoader for vod. We want this because
	        // if a playlist uses independent and non-independent segments/parts the
	        // buffer may not accurately reflect the next segment that we should try
	        // downloading.
	        if (!newPlaylist.endList) {
	          this.resetLoader();
	        } else {
	          this.resyncLoader();
	        }
	      }
	
	      this.currentMediaInfo_ = void 0;
	      this.trigger('playlistupdate'); // the rest of this function depends on `oldPlaylist` being defined
	
	      return;
	    } // we reloaded the same playlist so we are in a live scenario
	    // and we will likely need to adjust the mediaIndex
	
	
	    var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
	    this.logger_("live window shift [" + mediaSequenceDiff + "]"); // update the mediaIndex on the SegmentLoader
	    // this is important because we can abort a request and this value must be
	    // equal to the last appended mediaIndex
	
	    if (this.mediaIndex !== null) {
	      this.mediaIndex -= mediaSequenceDiff; // this can happen if we are going to load the first segment, but get a playlist
	      // update during that. mediaIndex would go from 0 to -1 if mediaSequence in the
	      // new playlist was incremented by 1.
	
	      if (this.mediaIndex < 0) {
	        this.mediaIndex = null;
	        this.partIndex = null;
	      } else {
	        var segment = this.playlist_.segments[this.mediaIndex]; // partIndex should remain the same for the same segment
	        // unless parts fell off of the playlist for this segment.
	        // In that case we need to reset partIndex and resync
	
	        if (this.partIndex && (!segment.parts || !segment.parts.length || !segment.parts[this.partIndex])) {
	          var mediaIndex = this.mediaIndex;
	          this.logger_("currently processing part (index " + this.partIndex + ") no longer exists.");
	          this.resetLoader(); // We want to throw away the partIndex and the data associated with it,
	          // as the part was dropped from our current playlists segment.
	          // The mediaIndex will still be valid so keep that around.
	
	          this.mediaIndex = mediaIndex;
	        }
	      }
	    } // update the mediaIndex on the SegmentInfo object
	    // this is important because we will update this.mediaIndex with this value
	    // in `handleAppendsDone_` after the segment has been successfully appended
	
	
	    if (segmentInfo) {
	      segmentInfo.mediaIndex -= mediaSequenceDiff;
	
	      if (segmentInfo.mediaIndex < 0) {
	        segmentInfo.mediaIndex = null;
	        segmentInfo.partIndex = null;
	      } else {
	        // we need to update the referenced segment so that timing information is
	        // saved for the new playlist's segment, however, if the segment fell off the
	        // playlist, we can leave the old reference and just lose the timing info
	        if (segmentInfo.mediaIndex >= 0) {
	          segmentInfo.segment = newPlaylist.segments[segmentInfo.mediaIndex];
	        }
	
	        if (segmentInfo.partIndex >= 0 && segmentInfo.segment.parts) {
	          segmentInfo.part = segmentInfo.segment.parts[segmentInfo.partIndex];
	        }
	      }
	    }
	
	    this.syncController_.saveExpiredSegmentInfo(oldPlaylist, newPlaylist);
	  }
	  /**
	   * Prevent the loader from fetching additional segments. If there
	   * is a segment request outstanding, it will finish processing
	   * before the loader halts. A segment loader can be unpaused by
	   * calling load().
	   */
	  ;
	
	  _proto.pause = function pause() {
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	      this.checkBufferTimeout_ = null;
	    }
	  }
	  /**
	   * Returns whether the segment loader is fetching additional
	   * segments when given the opportunity. This property can be
	   * modified through calls to pause() and load().
	   */
	  ;
	
	  _proto.paused = function paused() {
	    return this.checkBufferTimeout_ === null;
	  }
	  /**
	   * Delete all the buffered data and reset the SegmentLoader
	   *
	   * @param {Function} [done] an optional callback to be executed when the remove
	   * operation is complete
	   */
	  ;
	
	  _proto.resetEverything = function resetEverything(done) {
	    this.ended_ = false;
	    this.activeInitSegmentId_ = null;
	    this.appendInitSegment_ = {
	      audio: true,
	      video: true
	    };
	    this.resetLoader(); // remove from 0, the earliest point, to Infinity, to signify removal of everything.
	    // VTT Segment Loader doesn't need to do anything but in the regular SegmentLoader,
	    // we then clamp the value to duration if necessary.
	
	    this.remove(0, Infinity, done); // clears fmp4 captions
	
	    if (this.transmuxer_) {
	      this.transmuxer_.postMessage({
	        action: 'clearAllMp4Captions'
	      }); // reset the cache in the transmuxer
	
	      this.transmuxer_.postMessage({
	        action: 'reset'
	      });
	    }
	  }
	  /**
	   * Force the SegmentLoader to resync and start loading around the currentTime instead
	   * of starting at the end of the buffer
	   *
	   * Useful for fast quality changes
	   */
	  ;
	
	  _proto.resetLoader = function resetLoader() {
	    this.fetchAtBuffer_ = false;
	    this.resyncLoader();
	  }
	  /**
	   * Force the SegmentLoader to restart synchronization and make a conservative guess
	   * before returning to the simple walk-forward method
	   */
	  ;
	
	  _proto.resyncLoader = function resyncLoader() {
	    if (this.transmuxer_) {
	      // need to clear out any cached data to prepare for the new segment
	      segmentTransmuxer.reset(this.transmuxer_);
	    }
	
	    this.mediaIndex = null;
	    this.partIndex = null;
	    this.syncPoint_ = null;
	    this.isPendingTimestampOffset_ = false;
	    this.callQueue_ = [];
	    this.loadQueue_ = [];
	    this.metadataQueue_.id3 = [];
	    this.metadataQueue_.caption = [];
	    this.abort();
	
	    if (this.transmuxer_) {
	      this.transmuxer_.postMessage({
	        action: 'clearParsedMp4Captions'
	      });
	    }
	  }
	  /**
	   * Remove any data in the source buffer between start and end times
	   *
	   * @param {number} start - the start time of the region to remove from the buffer
	   * @param {number} end - the end time of the region to remove from the buffer
	   * @param {Function} [done] - an optional callback to be executed when the remove
	   * @param {boolean} force - force all remove operations to happen
	   * operation is complete
	   */
	  ;
	
	  _proto.remove = function remove(start, end, done, force) {
	    if (done === void 0) {
	      done = function done() {};
	    }
	
	    if (force === void 0) {
	      force = false;
	    } // clamp end to duration if we need to remove everything.
	    // This is due to a browser bug that causes issues if we remove to Infinity.
	    // videojs/videojs-contrib-hls#1225
	
	
	    if (end === Infinity) {
	      end = this.duration_();
	    } // skip removes that would throw an error
	    // commonly happens during a rendition switch at the start of a video
	    // from start 0 to end 0
	
	
	    if (end <= start) {
	      this.logger_('skipping remove because end ${end} is <= start ${start}');
	      return;
	    }
	
	    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
	      this.logger_('skipping remove because no source updater or starting media info'); // nothing to remove if we haven't processed any media
	
	      return;
	    } // set it to one to complete this function's removes
	
	
	    var removesRemaining = 1;
	
	    var removeFinished = function removeFinished() {
	      removesRemaining--;
	
	      if (removesRemaining === 0) {
	        done();
	      }
	    };
	
	    if (force || !this.audioDisabled_) {
	      removesRemaining++;
	      this.sourceUpdater_.removeAudio(start, end, removeFinished);
	    } // While it would be better to only remove video if the main loader has video, this
	    // should be safe with audio only as removeVideo will call back even if there's no
	    // video buffer.
	    //
	    // In theory we can check to see if there's video before calling the remove, but in
	    // the event that we're switching between renditions and from video to audio only
	    // (when we add support for that), we may need to clear the video contents despite
	    // what the new media will contain.
	
	
	    if (force || this.loaderType_ === 'main') {
	      this.gopBuffer_ = removeGopBuffer(this.gopBuffer_, start, end, this.timeMapping_);
	      removesRemaining++;
	      this.sourceUpdater_.removeVideo(start, end, removeFinished);
	    } // remove any captions and ID3 tags
	
	
	    for (var track in this.inbandTextTracks_) {
	      removeCuesFromTrack(start, end, this.inbandTextTracks_[track]);
	    }
	
	    removeCuesFromTrack(start, end, this.segmentMetadataTrack_); // finished this function's removes
	
	    removeFinished();
	  }
	  /**
	   * (re-)schedule monitorBufferTick_ to run as soon as possible
	   *
	   * @private
	   */
	  ;
	
	  _proto.monitorBuffer_ = function monitorBuffer_() {
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	    }
	
	    this.checkBufferTimeout_ = window__default['default'].setTimeout(this.monitorBufferTick_.bind(this), 1);
	  }
	  /**
	   * As long as the SegmentLoader is in the READY state, periodically
	   * invoke fillBuffer_().
	   *
	   * @private
	   */
	  ;
	
	  _proto.monitorBufferTick_ = function monitorBufferTick_() {
	    if (this.state === 'READY') {
	      this.fillBuffer_();
	    }
	
	    if (this.checkBufferTimeout_) {
	      window__default['default'].clearTimeout(this.checkBufferTimeout_);
	    }
	
	    this.checkBufferTimeout_ = window__default['default'].setTimeout(this.monitorBufferTick_.bind(this), CHECK_BUFFER_DELAY);
	  }
	  /**
	   * fill the buffer with segements unless the sourceBuffers are
	   * currently updating
	   *
	   * Note: this function should only ever be called by monitorBuffer_
	   * and never directly
	   *
	   * @private
	   */
	  ;
	
	  _proto.fillBuffer_ = function fillBuffer_() {
	    // TODO since the source buffer maintains a queue, and we shouldn't call this function
	    // except when we're ready for the next segment, this check can most likely be removed
	    if (this.sourceUpdater_.updating()) {
	      return;
	    } // see if we need to begin loading immediately
	
	
	    var segmentInfo = this.chooseNextRequest_();
	
	    if (!segmentInfo) {
	      return;
	    }
	
	    if (typeof segmentInfo.timestampOffset === 'number') {
	      this.isPendingTimestampOffset_ = false;
	      this.timelineChangeController_.pendingTimelineChange({
	        type: this.loaderType_,
	        from: this.currentTimeline_,
	        to: segmentInfo.timeline
	      });
	    }
	
	    this.loadSegment_(segmentInfo);
	  }
	  /**
	   * Determines if we should call endOfStream on the media source based
	   * on the state of the buffer or if appened segment was the final
	   * segment in the playlist.
	   *
	   * @param {number} [mediaIndex] the media index of segment we last appended
	   * @param {Object} [playlist] a media playlist object
	   * @return {boolean} do we need to call endOfStream on the MediaSource
	   */
	  ;
	
	  _proto.isEndOfStream_ = function isEndOfStream_(mediaIndex, playlist, partIndex) {
	    if (mediaIndex === void 0) {
	      mediaIndex = this.mediaIndex;
	    }
	
	    if (playlist === void 0) {
	      playlist = this.playlist_;
	    }
	
	    if (partIndex === void 0) {
	      partIndex = this.partIndex;
	    }
	
	    if (!playlist || !this.mediaSource_) {
	      return false;
	    }
	
	    var segment = typeof mediaIndex === 'number' && playlist.segments[mediaIndex]; // mediaIndex is zero based but length is 1 based
	
	    var appendedLastSegment = mediaIndex + 1 === playlist.segments.length; // true if there are no parts, or this is the last part.
	
	    var appendedLastPart = !segment || !segment.parts || partIndex + 1 === segment.parts.length; // if we've buffered to the end of the video, we need to call endOfStream
	    // so that MediaSources can trigger the `ended` event when it runs out of
	    // buffered data instead of waiting for me
	
	    return playlist.endList && this.mediaSource_.readyState === 'open' && appendedLastSegment && appendedLastPart;
	  }
	  /**
	   * Determines what request should be made given current segment loader state.
	   *
	   * @return {Object} a request object that describes the segment/part to load
	   */
	  ;
	
	  _proto.chooseNextRequest_ = function chooseNextRequest_() {
	    var buffered = this.buffered_();
	    var bufferedEnd = lastBufferedEnd(buffered) || 0;
	    var bufferedTime = timeAheadOf(buffered, this.currentTime_());
	    var preloaded = !this.hasPlayed_() && bufferedTime >= 1;
	    var haveEnoughBuffer = bufferedTime >= this.goalBufferLength_();
	    var segments = this.playlist_.segments; // return no segment if:
	    // 1. we don't have segments
	    // 2. The video has not yet played and we already downloaded a segment
	    // 3. we already have enough buffered time
	
	    if (!segments.length || preloaded || haveEnoughBuffer) {
	      return null;
	    }
	
	    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
	    var next = {
	      partIndex: null,
	      mediaIndex: null,
	      startOfSegment: null,
	      playlist: this.playlist_,
	      isSyncRequest: Boolean(!this.syncPoint_)
	    };
	
	    if (next.isSyncRequest) {
	      next.mediaIndex = getSyncSegmentCandidate(this.currentTimeline_, segments, bufferedEnd);
	    } else if (this.mediaIndex !== null) {
	      var segment = segments[this.mediaIndex];
	      var partIndex = typeof this.partIndex === 'number' ? this.partIndex : -1;
	      next.startOfSegment = segment.end ? segment.end : bufferedEnd;
	
	      if (segment.parts && segment.parts[partIndex + 1]) {
	        next.mediaIndex = this.mediaIndex;
	        next.partIndex = partIndex + 1;
	      } else {
	        next.mediaIndex = this.mediaIndex + 1;
	      }
	    } else {
	      // Find the segment containing the end of the buffer or current time.
	      var _Playlist$getMediaInf = Playlist.getMediaInfoForTime({
	        experimentalExactManifestTimings: this.experimentalExactManifestTimings,
	        playlist: this.playlist_,
	        currentTime: this.fetchAtBuffer_ ? bufferedEnd : this.currentTime_(),
	        startingPartIndex: this.syncPoint_.partIndex,
	        startingSegmentIndex: this.syncPoint_.segmentIndex,
	        startTime: this.syncPoint_.time
	      }),
	          segmentIndex = _Playlist$getMediaInf.segmentIndex,
	          startTime = _Playlist$getMediaInf.startTime,
	          _partIndex = _Playlist$getMediaInf.partIndex;
	
	      next.getMediaInfoForTime = this.fetchAtBuffer_ ? "bufferedEnd " + bufferedEnd : "currentTime " + this.currentTime_();
	      next.mediaIndex = segmentIndex;
	      next.startOfSegment = startTime;
	      next.partIndex = _partIndex;
	    }
	
	    var nextSegment = segments[next.mediaIndex];
	    var nextPart = nextSegment && typeof next.partIndex === 'number' && nextSegment.parts && nextSegment.parts[next.partIndex]; // if the next segment index is invalid or
	    // the next partIndex is invalid do not choose a next segment.
	
	    if (!nextSegment || typeof next.partIndex === 'number' && !nextPart) {
	      return null;
	    } // if the next segment has parts, and we don't have a partIndex.
	    // Set partIndex to 0
	
	
	    if (typeof next.partIndex !== 'number' && nextSegment.parts) {
	      next.partIndex = 0;
	      nextPart = nextSegment.parts[0];
	    } // if we have no buffered data then we need to make sure
	    // that the next part we append is "independent" if possible.
	    // So we check if the previous part is independent, and request
	    // it if it is.
	
	
	    if (!bufferedTime && nextPart && !nextPart.independent) {
	      if (next.partIndex === 0) {
	        var lastSegment = segments[next.mediaIndex - 1];
	        var lastSegmentLastPart = lastSegment.parts && lastSegment.parts.length && lastSegment.parts[lastSegment.parts.length - 1];
	
	        if (lastSegmentLastPart && lastSegmentLastPart.independent) {
	          next.mediaIndex -= 1;
	          next.partIndex = lastSegment.parts.length - 1;
	          next.independent = 'previous segment';
	        }
	      } else if (nextSegment.parts[next.partIndex - 1].independent) {
	        next.partIndex -= 1;
	        next.independent = 'previous part';
	      }
	    }
	
	    var ended = this.mediaSource_ && this.mediaSource_.readyState === 'ended'; // do not choose a next segment if all of the following:
	    // 1. this is the last segment in the playlist
	    // 2. end of stream has been called on the media source already
	    // 3. the player is not seeking
	
	    if (next.mediaIndex >= segments.length - 1 && ended && !this.seeking_()) {
	      return null;
	    }
	
	    return this.generateSegmentInfo_(next);
	  };
	
	  _proto.generateSegmentInfo_ = function generateSegmentInfo_(options) {
	    var independent = options.independent,
	        playlist = options.playlist,
	        mediaIndex = options.mediaIndex,
	        startOfSegment = options.startOfSegment,
	        isSyncRequest = options.isSyncRequest,
	        partIndex = options.partIndex,
	        forceTimestampOffset = options.forceTimestampOffset,
	        getMediaInfoForTime = options.getMediaInfoForTime;
	    var segment = playlist.segments[mediaIndex];
	    var part = typeof partIndex === 'number' && segment.parts[partIndex];
	    var segmentInfo = {
	      requestId: 'segment-loader-' + Math.random(),
	      // resolve the segment URL relative to the playlist
	      uri: part && part.resolvedUri || segment.resolvedUri,
	      // the segment's mediaIndex at the time it was requested
	      mediaIndex: mediaIndex,
	      partIndex: part ? partIndex : null,
	      // whether or not to update the SegmentLoader's state with this
	      // segment's mediaIndex
	      isSyncRequest: isSyncRequest,
	      startOfSegment: startOfSegment,
	      // the segment's playlist
	      playlist: playlist,
	      // unencrypted bytes of the segment
	      bytes: null,
	      // when a key is defined for this segment, the encrypted bytes
	      encryptedBytes: null,
	      // The target timestampOffset for this segment when we append it
	      // to the source buffer
	      timestampOffset: null,
	      // The timeline that the segment is in
	      timeline: segment.timeline,
	      // The expected duration of the segment in seconds
	      duration: part && part.duration || segment.duration,
	      // retain the segment in case the playlist updates while doing an async process
	      segment: segment,
	      part: part,
	      byteLength: 0,
	      transmuxer: this.transmuxer_,
	      // type of getMediaInfoForTime that was used to get this segment
	      getMediaInfoForTime: getMediaInfoForTime,
	      independent: independent
	    };
	    var overrideCheck = typeof forceTimestampOffset !== 'undefined' ? forceTimestampOffset : this.isPendingTimestampOffset_;
	    segmentInfo.timestampOffset = this.timestampOffsetForSegment_({
	      segmentTimeline: segment.timeline,
	      currentTimeline: this.currentTimeline_,
	      startOfSegment: startOfSegment,
	      buffered: this.buffered_(),
	      overrideCheck: overrideCheck
	    });
	    var audioBufferedEnd = lastBufferedEnd(this.sourceUpdater_.audioBuffered());
	
	    if (typeof audioBufferedEnd === 'number') {
	      // since the transmuxer is using the actual timing values, but the buffer is
	      // adjusted by the timestamp offset, we must adjust the value here
	      segmentInfo.audioAppendStart = audioBufferedEnd - this.sourceUpdater_.audioTimestampOffset();
	    }
	
	    if (this.sourceUpdater_.videoBuffered().length) {
	      segmentInfo.gopsToAlignWith = gopsSafeToAlignWith(this.gopBuffer_, // since the transmuxer is using the actual timing values, but the time is
	      // adjusted by the timestmap offset, we must adjust the value here
	      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_);
	    }
	
	    return segmentInfo;
	  } // get the timestampoffset for a segment,
	  // added so that vtt segment loader can override and prevent
	  // adding timestamp offsets.
	  ;
	
	  _proto.timestampOffsetForSegment_ = function timestampOffsetForSegment_(options) {
	    return timestampOffsetForSegment(options);
	  }
	  /**
	   * Determines if the network has enough bandwidth to complete the current segment
	   * request in a timely manner. If not, the request will be aborted early and bandwidth
	   * updated to trigger a playlist switch.
	   *
	   * @param {Object} stats
	   *        Object containing stats about the request timing and size
	   * @private
	   */
	  ;
	
	  _proto.earlyAbortWhenNeeded_ = function earlyAbortWhenNeeded_(stats) {
	    if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
	    // TODO: Replace using timeout with a boolean indicating whether this playlist is
	    //       the lowestEnabledRendition.
	    !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
	    !this.playlist_.attributes.BANDWIDTH) {
	      return;
	    } // Wait at least 1 second since the first byte of data has been received before
	    // using the calculated bandwidth from the progress event to allow the bitrate
	    // to stabilize
	
	
	    if (Date.now() - (stats.firstBytesReceivedAt || Date.now()) < 1000) {
	      return;
	    }
	
	    var currentTime = this.currentTime_();
	    var measuredBandwidth = stats.bandwidth;
	    var segmentDuration = this.pendingSegment_.duration;
	    var requestTimeRemaining = Playlist.estimateSegmentRequestTime(segmentDuration, measuredBandwidth, this.playlist_, stats.bytesReceived); // Subtract 1 from the timeUntilRebuffer so we still consider an early abort
	    // if we are only left with less than 1 second when the request completes.
	    // A negative timeUntilRebuffering indicates we are already rebuffering
	
	    var timeUntilRebuffer$1 = timeUntilRebuffer(this.buffered_(), currentTime, this.vhs_.tech_.playbackRate()) - 1; // Only consider aborting early if the estimated time to finish the download
	    // is larger than the estimated time until the player runs out of forward buffer
	
	    if (requestTimeRemaining <= timeUntilRebuffer$1) {
	      return;
	    }
	
	    var switchCandidate = minRebufferMaxBandwidthSelector({
	      master: this.vhs_.playlists.master,
	      currentTime: currentTime,
	      bandwidth: measuredBandwidth,
	      duration: this.duration_(),
	      segmentDuration: segmentDuration,
	      timeUntilRebuffer: timeUntilRebuffer$1,
	      currentTimeline: this.currentTimeline_,
	      syncController: this.syncController_
	    });
	
	    if (!switchCandidate) {
	      return;
	    }
	
	    var rebufferingImpact = requestTimeRemaining - timeUntilRebuffer$1;
	    var timeSavedBySwitching = rebufferingImpact - switchCandidate.rebufferingImpact;
	    var minimumTimeSaving = 0.5; // If we are already rebuffering, increase the amount of variance we add to the
	    // potential round trip time of the new request so that we are not too aggressive
	    // with switching to a playlist that might save us a fraction of a second.
	
	    if (timeUntilRebuffer$1 <= TIME_FUDGE_FACTOR) {
	      minimumTimeSaving = 1;
	    }
	
	    if (!switchCandidate.playlist || switchCandidate.playlist.uri === this.playlist_.uri || timeSavedBySwitching < minimumTimeSaving) {
	      return;
	    } // set the bandwidth to that of the desired playlist being sure to scale by
	    // BANDWIDTH_VARIANCE and add one so the playlist selector does not exclude it
	    // don't trigger a bandwidthupdate as the bandwidth is artifial
	
	
	    this.bandwidth = switchCandidate.playlist.attributes.BANDWIDTH * Config.BANDWIDTH_VARIANCE + 1;
	    this.trigger('earlyabort');
	  };
	
	  _proto.handleAbort_ = function handleAbort_(segmentInfo) {
	    this.logger_("Aborting " + segmentInfoString(segmentInfo));
	    this.mediaRequestsAborted += 1;
	  }
	  /**
	   * XHR `progress` event handler
	   *
	   * @param {Event}
	   *        The XHR `progress` event
	   * @param {Object} simpleSegment
	   *        A simplified segment object copy
	   * @private
	   */
	  ;
	
	  _proto.handleProgress_ = function handleProgress_(event, simpleSegment) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    this.trigger('progress');
	  };
	
	  _proto.handleTrackInfo_ = function handleTrackInfo_(simpleSegment, trackInfo) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    if (this.checkForIllegalMediaSwitch(trackInfo)) {
	      return;
	    }
	
	    trackInfo = trackInfo || {}; // When we have track info, determine what media types this loader is dealing with.
	    // Guard against cases where we're not getting track info at all until we are
	    // certain that all streams will provide it.
	
	    if (!shallowEqual(this.currentMediaInfo_, trackInfo)) {
	      this.appendInitSegment_ = {
	        audio: true,
	        video: true
	      };
	      this.startingMediaInfo_ = trackInfo;
	      this.currentMediaInfo_ = trackInfo;
	      this.logger_('trackinfo update', trackInfo);
	      this.trigger('trackinfo');
	    } // trackinfo may cause an abort if the trackinfo
	    // causes a codec change to an unsupported codec.
	
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    } // set trackinfo on the pending segment so that
	    // it can append.
	
	
	    this.pendingSegment_.trackInfo = trackInfo; // check if any calls were waiting on the track info
	
	    if (this.hasEnoughInfoToAppend_()) {
	      this.processCallQueue_();
	    }
	  };
	
	  _proto.handleTimingInfo_ = function handleTimingInfo_(simpleSegment, mediaType, timeType, time) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_;
	    var timingInfoProperty = timingInfoPropertyForMedia(mediaType);
	    segmentInfo[timingInfoProperty] = segmentInfo[timingInfoProperty] || {};
	    segmentInfo[timingInfoProperty][timeType] = time;
	    this.logger_("timinginfo: " + mediaType + " - " + timeType + " - " + time); // check if any calls were waiting on the timing info
	
	    if (this.hasEnoughInfoToAppend_()) {
	      this.processCallQueue_();
	    }
	  };
	
	  _proto.handleCaptions_ = function handleCaptions_(simpleSegment, captionData) {
	    var _this2 = this;
	
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    } // This could only happen with fmp4 segments, but
	    // should still not happen in general
	
	
	    if (captionData.length === 0) {
	      this.logger_('SegmentLoader received no captions from a caption event');
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // Wait until we have some video data so that caption timing
	    // can be adjusted by the timestamp offset
	
	    if (!segmentInfo.hasAppendedData_) {
	      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, simpleSegment, captionData));
	      return;
	    }
	
	    var timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
	    var captionTracks = {}; // get total start/end and captions for each track/stream
	
	    captionData.forEach(function (caption) {
	      // caption.stream is actually a track name...
	      // set to the existing values in tracks or default values
	      captionTracks[caption.stream] = captionTracks[caption.stream] || {
	        // Infinity, as any other value will be less than this
	        startTime: Infinity,
	        captions: [],
	        // 0 as an other value will be more than this
	        endTime: 0
	      };
	      var captionTrack = captionTracks[caption.stream];
	      captionTrack.startTime = Math.min(captionTrack.startTime, caption.startTime + timestampOffset);
	      captionTrack.endTime = Math.max(captionTrack.endTime, caption.endTime + timestampOffset);
	      captionTrack.captions.push(caption);
	    });
	    Object.keys(captionTracks).forEach(function (trackName) {
	      var _captionTracks$trackN = captionTracks[trackName],
	          startTime = _captionTracks$trackN.startTime,
	          endTime = _captionTracks$trackN.endTime,
	          captions = _captionTracks$trackN.captions;
	      var inbandTextTracks = _this2.inbandTextTracks_;
	
	      _this2.logger_("adding cues from " + startTime + " -> " + endTime + " for " + trackName);
	
	      createCaptionsTrackIfNotExists(inbandTextTracks, _this2.vhs_.tech_, trackName); // clear out any cues that start and end at the same time period for the same track.
	      // We do this because a rendition change that also changes the timescale for captions
	      // will result in captions being re-parsed for certain segments. If we add them again
	      // without clearing we will have two of the same captions visible.
	
	      removeCuesFromTrack(startTime, endTime, inbandTextTracks[trackName]);
	      addCaptionData({
	        captionArray: captions,
	        inbandTextTracks: inbandTextTracks,
	        timestampOffset: timestampOffset
	      });
	    }); // Reset stored captions since we added parsed
	    // captions to a text track at this point
	
	    if (this.transmuxer_) {
	      this.transmuxer_.postMessage({
	        action: 'clearParsedMp4Captions'
	      });
	    }
	  };
	
	  _proto.handleId3_ = function handleId3_(simpleSegment, id3Frames, dispatchType) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // we need to have appended data in order for the timestamp offset to be set
	
	    if (!segmentInfo.hasAppendedData_) {
	      this.metadataQueue_.id3.push(this.handleId3_.bind(this, simpleSegment, id3Frames, dispatchType));
	      return;
	    }
	
	    var timestampOffset = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(); // There's potentially an issue where we could double add metadata if there's a muxed
	    // audio/video source with a metadata track, and an alt audio with a metadata track.
	    // However, this probably won't happen, and if it does it can be handled then.
	
	    createMetadataTrackIfNotExists(this.inbandTextTracks_, dispatchType, this.vhs_.tech_);
	    addMetadata({
	      inbandTextTracks: this.inbandTextTracks_,
	      metadataArray: id3Frames,
	      timestampOffset: timestampOffset,
	      videoDuration: this.duration_()
	    });
	  };
	
	  _proto.processMetadataQueue_ = function processMetadataQueue_() {
	    this.metadataQueue_.id3.forEach(function (fn) {
	      return fn();
	    });
	    this.metadataQueue_.caption.forEach(function (fn) {
	      return fn();
	    });
	    this.metadataQueue_.id3 = [];
	    this.metadataQueue_.caption = [];
	  };
	
	  _proto.processCallQueue_ = function processCallQueue_() {
	    var callQueue = this.callQueue_; // Clear out the queue before the queued functions are run, since some of the
	    // functions may check the length of the load queue and default to pushing themselves
	    // back onto the queue.
	
	    this.callQueue_ = [];
	    callQueue.forEach(function (fun) {
	      return fun();
	    });
	  };
	
	  _proto.processLoadQueue_ = function processLoadQueue_() {
	    var loadQueue = this.loadQueue_; // Clear out the queue before the queued functions are run, since some of the
	    // functions may check the length of the load queue and default to pushing themselves
	    // back onto the queue.
	
	    this.loadQueue_ = [];
	    loadQueue.forEach(function (fun) {
	      return fun();
	    });
	  }
	  /**
	   * Determines whether the loader has enough info to load the next segment.
	   *
	   * @return {boolean}
	   *         Whether or not the loader has enough info to load the next segment
	   */
	  ;
	
	  _proto.hasEnoughInfoToLoad_ = function hasEnoughInfoToLoad_() {
	    // Since primary timing goes by video, only the audio loader potentially needs to wait
	    // to load.
	    if (this.loaderType_ !== 'audio') {
	      return true;
	    }
	
	    var segmentInfo = this.pendingSegment_; // A fill buffer must have already run to establish a pending segment before there's
	    // enough info to load.
	
	    if (!segmentInfo) {
	      return false;
	    } // The first segment can and should be loaded immediately so that source buffers are
	    // created together (before appending). Source buffer creation uses the presence of
	    // audio and video data to determine whether to create audio/video source buffers, and
	    // uses processed (transmuxed or parsed) media to determine the types required.
	
	
	    if (!this.getCurrentMediaInfo_()) {
	      return true;
	    }
	
	    if ( // Technically, instead of waiting to load a segment on timeline changes, a segment
	    // can be requested and downloaded and only wait before it is transmuxed or parsed.
	    // But in practice, there are a few reasons why it is better to wait until a loader
	    // is ready to append that segment before requesting and downloading:
	    //
	    // 1. Because audio and main loaders cross discontinuities together, if this loader
	    //    is waiting for the other to catch up, then instead of requesting another
	    //    segment and using up more bandwidth, by not yet loading, more bandwidth is
	    //    allotted to the loader currently behind.
	    // 2. media-segment-request doesn't have to have logic to consider whether a segment
	    // is ready to be processed or not, isolating the queueing behavior to the loader.
	    // 3. The audio loader bases some of its segment properties on timing information
	    //    provided by the main loader, meaning that, if the logic for waiting on
	    //    processing was in media-segment-request, then it would also need to know how
	    //    to re-generate the segment information after the main loader caught up.
	    shouldWaitForTimelineChange({
	      timelineChangeController: this.timelineChangeController_,
	      currentTimeline: this.currentTimeline_,
	      segmentTimeline: segmentInfo.timeline,
	      loaderType: this.loaderType_,
	      audioDisabled: this.audioDisabled_
	    })) {
	      return false;
	    }
	
	    return true;
	  };
	
	  _proto.getCurrentMediaInfo_ = function getCurrentMediaInfo_(segmentInfo) {
	    if (segmentInfo === void 0) {
	      segmentInfo = this.pendingSegment_;
	    }
	
	    return segmentInfo && segmentInfo.trackInfo || this.currentMediaInfo_;
	  };
	
	  _proto.getMediaInfo_ = function getMediaInfo_(segmentInfo) {
	    if (segmentInfo === void 0) {
	      segmentInfo = this.pendingSegment_;
	    }
	
	    return this.getCurrentMediaInfo_(segmentInfo) || this.startingMediaInfo_;
	  };
	
	  _proto.getPendingSegmentPlaylist = function getPendingSegmentPlaylist() {
	    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
	  };
	
	  _proto.hasEnoughInfoToAppend_ = function hasEnoughInfoToAppend_() {
	    if (!this.sourceUpdater_.ready()) {
	      return false;
	    } // If content needs to be removed or the loader is waiting on an append reattempt,
	    // then no additional content should be appended until the prior append is resolved.
	
	
	    if (this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) {
	      return false;
	    }
	
	    var segmentInfo = this.pendingSegment_;
	    var trackInfo = this.getCurrentMediaInfo_(); // no segment to append any data for or
	    // we do not have information on this specific
	    // segment yet
	
	    if (!segmentInfo || !trackInfo) {
	      return false;
	    }
	
	    var hasAudio = trackInfo.hasAudio,
	        hasVideo = trackInfo.hasVideo,
	        isMuxed = trackInfo.isMuxed;
	
	    if (hasVideo && !segmentInfo.videoTimingInfo) {
	      return false;
	    } // muxed content only relies on video timing information for now.
	
	
	    if (hasAudio && !this.audioDisabled_ && !isMuxed && !segmentInfo.audioTimingInfo) {
	      return false;
	    }
	
	    if (shouldWaitForTimelineChange({
	      timelineChangeController: this.timelineChangeController_,
	      currentTimeline: this.currentTimeline_,
	      segmentTimeline: segmentInfo.timeline,
	      loaderType: this.loaderType_,
	      audioDisabled: this.audioDisabled_
	    })) {
	      return false;
	    }
	
	    return true;
	  };
	
	  _proto.handleData_ = function handleData_(simpleSegment, result) {
	    this.earlyAbortWhenNeeded_(simpleSegment.stats);
	
	    if (this.checkForAbort_(simpleSegment.requestId)) {
	      return;
	    } // If there's anything in the call queue, then this data came later and should be
	    // executed after the calls currently queued.
	
	
	    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
	      this.callQueue_.push(this.handleData_.bind(this, simpleSegment, result));
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // update the time mapping so we can translate from display time to media time
	
	    this.setTimeMapping_(segmentInfo.timeline); // for tracking overall stats
	
	    this.updateMediaSecondsLoaded_(segmentInfo.part || segmentInfo.segment); // Note that the state isn't changed from loading to appending. This is because abort
	    // logic may change behavior depending on the state, and changing state too early may
	    // inflate our estimates of bandwidth. In the future this should be re-examined to
	    // note more granular states.
	    // don't process and append data if the mediaSource is closed
	
	    if (this.mediaSource_.readyState === 'closed') {
	      return;
	    } // if this request included an initialization segment, save that data
	    // to the initSegment cache
	
	
	    if (simpleSegment.map) {
	      simpleSegment.map = this.initSegmentForMap(simpleSegment.map, true); // move over init segment properties to media request
	
	      segmentInfo.segment.map = simpleSegment.map;
	    } // if this request included a segment key, save that data in the cache
	
	
	    if (simpleSegment.key) {
	      this.segmentKey(simpleSegment.key, true);
	    }
	
	    segmentInfo.isFmp4 = simpleSegment.isFmp4;
	    segmentInfo.timingInfo = segmentInfo.timingInfo || {};
	
	    if (segmentInfo.isFmp4) {
	      this.trigger('fmp4');
	      segmentInfo.timingInfo.start = segmentInfo[timingInfoPropertyForMedia(result.type)].start;
	    } else {
	      var trackInfo = this.getCurrentMediaInfo_();
	      var useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
	      var firstVideoFrameTimeForData;
	
	      if (useVideoTimingInfo) {
	        firstVideoFrameTimeForData = segmentInfo.videoTimingInfo.start;
	      } // Segment loader knows more about segment timing than the transmuxer (in certain
	      // aspects), so make any changes required for a more accurate start time.
	      // Don't set the end time yet, as the segment may not be finished processing.
	
	
	      segmentInfo.timingInfo.start = this.trueSegmentStart_({
	        currentStart: segmentInfo.timingInfo.start,
	        playlist: segmentInfo.playlist,
	        mediaIndex: segmentInfo.mediaIndex,
	        currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
	        useVideoTimingInfo: useVideoTimingInfo,
	        firstVideoFrameTimeForData: firstVideoFrameTimeForData,
	        videoTimingInfo: segmentInfo.videoTimingInfo,
	        audioTimingInfo: segmentInfo.audioTimingInfo
	      });
	    } // Init segments for audio and video only need to be appended in certain cases. Now
	    // that data is about to be appended, we can check the final cases to determine
	    // whether we should append an init segment.
	
	
	    this.updateAppendInitSegmentStatus(segmentInfo, result.type); // Timestamp offset should be updated once we get new data and have its timing info,
	    // as we use the start of the segment to offset the best guess (playlist provided)
	    // timestamp offset.
	
	    this.updateSourceBufferTimestampOffset_(segmentInfo); // if this is a sync request we need to determine whether it should
	    // be appended or not.
	
	    if (segmentInfo.isSyncRequest) {
	      // first save/update our timing info for this segment.
	      // this is what allows us to choose an accurate segment
	      // and the main reason we make a sync request.
	      this.updateTimingInfoEnd_(segmentInfo);
	      this.syncController_.saveSegmentTimingInfo({
	        segmentInfo: segmentInfo,
	        shouldSaveTimelineMapping: this.loaderType_ === 'main'
	      });
	      var next = this.chooseNextRequest_(); // If the sync request isn't the segment that would be requested next
	      // after taking into account its timing info, do not append it.
	
	      if (next.mediaIndex !== segmentInfo.mediaIndex || next.partIndex !== segmentInfo.partIndex) {
	        this.logger_('sync segment was incorrect, not appending');
	        return;
	      } // otherwise append it like any other segment as our guess was correct.
	
	
	      this.logger_('sync segment was correct, appending');
	    } // Save some state so that in the future anything waiting on first append (and/or
	    // timestamp offset(s)) can process immediately. While the extra state isn't optimal,
	    // we need some notion of whether the timestamp offset or other relevant information
	    // has had a chance to be set.
	
	
	    segmentInfo.hasAppendedData_ = true; // Now that the timestamp offset should be set, we can append any waiting ID3 tags.
	
	    this.processMetadataQueue_();
	    this.appendData_(segmentInfo, result);
	  };
	
	  _proto.updateAppendInitSegmentStatus = function updateAppendInitSegmentStatus(segmentInfo, type) {
	    // alt audio doesn't manage timestamp offset
	    if (this.loaderType_ === 'main' && typeof segmentInfo.timestampOffset === 'number' && // in the case that we're handling partial data, we don't want to append an init
	    // segment for each chunk
	    !segmentInfo.changedTimestampOffset) {
	      // if the timestamp offset changed, the timeline may have changed, so we have to re-
	      // append init segments
	      this.appendInitSegment_ = {
	        audio: true,
	        video: true
	      };
	    }
	
	    if (this.playlistOfLastInitSegment_[type] !== segmentInfo.playlist) {
	      // make sure we append init segment on playlist changes, in case the media config
	      // changed
	      this.appendInitSegment_[type] = true;
	    }
	  };
	
	  _proto.getInitSegmentAndUpdateState_ = function getInitSegmentAndUpdateState_(_ref4) {
	    var type = _ref4.type,
	        initSegment = _ref4.initSegment,
	        map = _ref4.map,
	        playlist = _ref4.playlist; // "The EXT-X-MAP tag specifies how to obtain the Media Initialization Section
	    // (Section 3) required to parse the applicable Media Segments.  It applies to every
	    // Media Segment that appears after it in the Playlist until the next EXT-X-MAP tag
	    // or until the end of the playlist."
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.5
	
	    if (map) {
	      var id = initSegmentId(map);
	
	      if (this.activeInitSegmentId_ === id) {
	        // don't need to re-append the init segment if the ID matches
	        return null;
	      } // a map-specified init segment takes priority over any transmuxed (or otherwise
	      // obtained) init segment
	      //
	      // this also caches the init segment for later use
	
	
	      initSegment = this.initSegmentForMap(map, true).bytes;
	      this.activeInitSegmentId_ = id;
	    } // We used to always prepend init segments for video, however, that shouldn't be
	    // necessary. Instead, we should only append on changes, similar to what we've always
	    // done for audio. This is more important (though may not be that important) for
	    // frame-by-frame appending for LHLS, simply because of the increased quantity of
	    // appends.
	
	
	    if (initSegment && this.appendInitSegment_[type]) {
	      // Make sure we track the playlist that we last used for the init segment, so that
	      // we can re-append the init segment in the event that we get data from a new
	      // playlist. Discontinuities and track changes are handled in other sections.
	      this.playlistOfLastInitSegment_[type] = playlist; // Disable future init segment appends for this type. Until a change is necessary.
	
	      this.appendInitSegment_[type] = false; // we need to clear out the fmp4 active init segment id, since
	      // we are appending the muxer init segment
	
	      this.activeInitSegmentId_ = null;
	      return initSegment;
	    }
	
	    return null;
	  };
	
	  _proto.handleQuotaExceededError_ = function handleQuotaExceededError_(_ref5, error) {
	    var _this3 = this;
	
	    var segmentInfo = _ref5.segmentInfo,
	        type = _ref5.type,
	        bytes = _ref5.bytes;
	    var audioBuffered = this.sourceUpdater_.audioBuffered();
	    var videoBuffered = this.sourceUpdater_.videoBuffered(); // For now we're ignoring any notion of gaps in the buffer, but they, in theory,
	    // should be cleared out during the buffer removals. However, log in case it helps
	    // debug.
	
	    if (audioBuffered.length > 1) {
	      this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: ' + timeRangesToArray(audioBuffered).join(', '));
	    }
	
	    if (videoBuffered.length > 1) {
	      this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: ' + timeRangesToArray(videoBuffered).join(', '));
	    }
	
	    var audioBufferStart = audioBuffered.length ? audioBuffered.start(0) : 0;
	    var audioBufferEnd = audioBuffered.length ? audioBuffered.end(audioBuffered.length - 1) : 0;
	    var videoBufferStart = videoBuffered.length ? videoBuffered.start(0) : 0;
	    var videoBufferEnd = videoBuffered.length ? videoBuffered.end(videoBuffered.length - 1) : 0;
	
	    if (audioBufferEnd - audioBufferStart <= MIN_BACK_BUFFER && videoBufferEnd - videoBufferStart <= MIN_BACK_BUFFER) {
	      // Can't remove enough buffer to make room for new segment (or the browser doesn't
	      // allow for appends of segments this size). In the future, it may be possible to
	      // split up the segment and append in pieces, but for now, error out this playlist
	      // in an attempt to switch to a more manageable rendition.
	      this.logger_('On QUOTA_EXCEEDED_ERR, single segment too large to append to ' + 'buffer, triggering an error. ' + ("Appended byte length: " + bytes.byteLength + ", ") + ("audio buffer: " + timeRangesToArray(audioBuffered).join(', ') + ", ") + ("video buffer: " + timeRangesToArray(videoBuffered).join(', ') + ", "));
	      this.error({
	        message: 'Quota exceeded error with append of a single segment of content',
	        excludeUntil: Infinity
	      });
	      this.trigger('error');
	      return;
	    } // To try to resolve the quota exceeded error, clear back buffer and retry. This means
	    // that the segment-loader should block on future events until this one is handled, so
	    // that it doesn't keep moving onto further segments. Adding the call to the call
	    // queue will prevent further appends until waitingOnRemove_ and
	    // quotaExceededErrorRetryTimeout_ are cleared.
	    //
	    // Note that this will only block the current loader. In the case of demuxed content,
	    // the other load may keep filling as fast as possible. In practice, this should be
	    // OK, as it is a rare case when either audio has a high enough bitrate to fill up a
	    // source buffer, or video fills without enough room for audio to append (and without
	    // the availability of clearing out seconds of back buffer to make room for audio).
	    // But it might still be good to handle this case in the future as a TODO.
	
	
	    this.waitingOnRemove_ = true;
	    this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
	      segmentInfo: segmentInfo,
	      type: type,
	      bytes: bytes
	    }));
	    var currentTime = this.currentTime_(); // Try to remove as much audio and video as possible to make room for new content
	    // before retrying.
	
	    var timeToRemoveUntil = currentTime - MIN_BACK_BUFFER;
	    this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to " + timeToRemoveUntil);
	    this.remove(0, timeToRemoveUntil, function () {
	      _this3.logger_("On QUOTA_EXCEEDED_ERR, retrying append in " + MIN_BACK_BUFFER + "s");
	
	      _this3.waitingOnRemove_ = false; // wait the length of time alotted in the back buffer to prevent wasted
	      // attempts (since we can't clear less than the minimum)
	
	      _this3.quotaExceededErrorRetryTimeout_ = window__default['default'].setTimeout(function () {
	        _this3.logger_('On QUOTA_EXCEEDED_ERR, re-processing call queue');
	
	        _this3.quotaExceededErrorRetryTimeout_ = null;
	
	        _this3.processCallQueue_();
	      }, MIN_BACK_BUFFER * 1000);
	    }, true);
	  };
	
	  _proto.handleAppendError_ = function handleAppendError_(_ref6, error) {
	    var segmentInfo = _ref6.segmentInfo,
	        type = _ref6.type,
	        bytes = _ref6.bytes; // if there's no error, nothing to do
	
	    if (!error) {
	      return;
	    }
	
	    if (error.code === QUOTA_EXCEEDED_ERR) {
	      this.handleQuotaExceededError_({
	        segmentInfo: segmentInfo,
	        type: type,
	        bytes: bytes
	      }); // A quota exceeded error should be recoverable with a future re-append, so no need
	      // to trigger an append error.
	
	      return;
	    }
	
	    this.logger_('Received non QUOTA_EXCEEDED_ERR on append', error);
	    this.error(type + " append of " + bytes.length + "b failed for segment " + ("#" + segmentInfo.mediaIndex + " in playlist " + segmentInfo.playlist.id)); // If an append errors, we often can't recover.
	    // (see https://w3c.github.io/media-source/#sourcebuffer-append-error).
	    //
	    // Trigger a special error so that it can be handled separately from normal,
	    // recoverable errors.
	
	    this.trigger('appenderror');
	  };
	
	  _proto.appendToSourceBuffer_ = function appendToSourceBuffer_(_ref7) {
	    var segmentInfo = _ref7.segmentInfo,
	        type = _ref7.type,
	        initSegment = _ref7.initSegment,
	        data = _ref7.data,
	        bytes = _ref7.bytes; // If this is a re-append, bytes were already created and don't need to be recreated
	
	    if (!bytes) {
	      var segments = [data];
	      var byteLength = data.byteLength;
	
	      if (initSegment) {
	        // if the media initialization segment is changing, append it before the content
	        // segment
	        segments.unshift(initSegment);
	        byteLength += initSegment.byteLength;
	      } // Technically we should be OK appending the init segment separately, however, we
	      // haven't yet tested that, and prepending is how we have always done things.
	
	
	      bytes = concatSegments({
	        bytes: byteLength,
	        segments: segments
	      });
	    }
	
	    this.sourceUpdater_.appendBuffer({
	      segmentInfo: segmentInfo,
	      type: type,
	      bytes: bytes
	    }, this.handleAppendError_.bind(this, {
	      segmentInfo: segmentInfo,
	      type: type,
	      bytes: bytes
	    }));
	  };
	
	  _proto.handleSegmentTimingInfo_ = function handleSegmentTimingInfo_(type, requestId, segmentTimingInfo) {
	    if (!this.pendingSegment_ || requestId !== this.pendingSegment_.requestId) {
	      return;
	    }
	
	    var segment = this.pendingSegment_.segment;
	    var timingInfoProperty = type + "TimingInfo";
	
	    if (!segment[timingInfoProperty]) {
	      segment[timingInfoProperty] = {};
	    }
	
	    segment[timingInfoProperty].transmuxerPrependedSeconds = segmentTimingInfo.prependedContentDuration || 0;
	    segment[timingInfoProperty].transmuxedPresentationStart = segmentTimingInfo.start.presentation;
	    segment[timingInfoProperty].transmuxedDecodeStart = segmentTimingInfo.start.decode;
	    segment[timingInfoProperty].transmuxedPresentationEnd = segmentTimingInfo.end.presentation;
	    segment[timingInfoProperty].transmuxedDecodeEnd = segmentTimingInfo.end.decode; // mainly used as a reference for debugging
	
	    segment[timingInfoProperty].baseMediaDecodeTime = segmentTimingInfo.baseMediaDecodeTime;
	  };
	
	  _proto.appendData_ = function appendData_(segmentInfo, result) {
	    var type = result.type,
	        data = result.data;
	
	    if (!data || !data.byteLength) {
	      return;
	    }
	
	    if (type === 'audio' && this.audioDisabled_) {
	      return;
	    }
	
	    var initSegment = this.getInitSegmentAndUpdateState_({
	      type: type,
	      initSegment: result.initSegment,
	      playlist: segmentInfo.playlist,
	      map: segmentInfo.isFmp4 ? segmentInfo.segment.map : null
	    });
	    this.appendToSourceBuffer_({
	      segmentInfo: segmentInfo,
	      type: type,
	      initSegment: initSegment,
	      data: data
	    });
	  }
	  /**
	   * load a specific segment from a request into the buffer
	   *
	   * @private
	   */
	  ;
	
	  _proto.loadSegment_ = function loadSegment_(segmentInfo) {
	    var _this4 = this;
	
	    this.state = 'WAITING';
	    this.pendingSegment_ = segmentInfo;
	    this.trimBackBuffer_(segmentInfo);
	
	    if (typeof segmentInfo.timestampOffset === 'number') {
	      if (this.transmuxer_) {
	        this.transmuxer_.postMessage({
	          action: 'clearAllMp4Captions'
	        });
	      }
	    }
	
	    if (!this.hasEnoughInfoToLoad_()) {
	      this.loadQueue_.push(function () {
	        // regenerate the audioAppendStart, timestampOffset, etc as they
	        // may have changed since this function was added to the queue.
	        var options = _extends__default['default']({}, segmentInfo, {
	          forceTimestampOffset: true
	        });
	
	        _extends__default['default'](segmentInfo, _this4.generateSegmentInfo_(options));
	
	        _this4.isPendingTimestampOffset_ = false;
	
	        _this4.updateTransmuxerAndRequestSegment_(segmentInfo);
	      });
	      return;
	    }
	
	    this.updateTransmuxerAndRequestSegment_(segmentInfo);
	  };
	
	  _proto.updateTransmuxerAndRequestSegment_ = function updateTransmuxerAndRequestSegment_(segmentInfo) {
	    var _this5 = this; // We'll update the source buffer's timestamp offset once we have transmuxed data, but
	    // the transmuxer still needs to be updated before then.
	    //
	    // Even though keepOriginalTimestamps is set to true for the transmuxer, timestamp
	    // offset must be passed to the transmuxer for stream correcting adjustments.
	
	
	    if (this.shouldUpdateTransmuxerTimestampOffset_(segmentInfo.timestampOffset)) {
	      this.gopBuffer_.length = 0; // gopsToAlignWith was set before the GOP buffer was cleared
	
	      segmentInfo.gopsToAlignWith = [];
	      this.timeMapping_ = 0; // reset values in the transmuxer since a discontinuity should start fresh
	
	      this.transmuxer_.postMessage({
	        action: 'reset'
	      });
	      this.transmuxer_.postMessage({
	        action: 'setTimestampOffset',
	        timestampOffset: segmentInfo.timestampOffset
	      });
	    }
	
	    var simpleSegment = this.createSimplifiedSegmentObj_(segmentInfo);
	    var isEndOfStream = this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex);
	    var isWalkingForward = this.mediaIndex !== null;
	    var isDiscontinuity = segmentInfo.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
	    // the first timeline
	    segmentInfo.timeline > 0;
	    var isEndOfTimeline = isEndOfStream || isWalkingForward && isDiscontinuity;
	    this.logger_("Requesting " + segmentInfoString(segmentInfo)); // If there's an init segment associated with this segment, but it is not cached (identified by a lack of bytes),
	    // then this init segment has never been seen before and should be appended.
	    //
	    // At this point the content type (audio/video or both) is not yet known, but it should be safe to set
	    // both to true and leave the decision of whether to append the init segment to append time.
	
	    if (simpleSegment.map && !simpleSegment.map.bytes) {
	      this.logger_('going to request init segment.');
	      this.appendInitSegment_ = {
	        video: true,
	        audio: true
	      };
	    }
	
	    segmentInfo.abortRequests = mediaSegmentRequest({
	      xhr: this.vhs_.xhr,
	      xhrOptions: this.xhrOptions_,
	      decryptionWorker: this.decrypter_,
	      segment: simpleSegment,
	      abortFn: this.handleAbort_.bind(this, segmentInfo),
	      progressFn: this.handleProgress_.bind(this),
	      trackInfoFn: this.handleTrackInfo_.bind(this),
	      timingInfoFn: this.handleTimingInfo_.bind(this),
	      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'video', segmentInfo.requestId),
	      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, 'audio', segmentInfo.requestId),
	      captionsFn: this.handleCaptions_.bind(this),
	      isEndOfTimeline: isEndOfTimeline,
	      endedTimelineFn: function endedTimelineFn() {
	        _this5.logger_('received endedtimeline callback');
	      },
	      id3Fn: this.handleId3_.bind(this),
	      dataFn: this.handleData_.bind(this),
	      doneFn: this.segmentRequestFinished_.bind(this),
	      onTransmuxerLog: function onTransmuxerLog(_ref8) {
	        var message = _ref8.message,
	            level = _ref8.level,
	            stream = _ref8.stream;
	
	        _this5.logger_(segmentInfoString(segmentInfo) + " logged from transmuxer stream " + stream + " as a " + level + ": " + message);
	      }
	    });
	  }
	  /**
	   * trim the back buffer so that we don't have too much data
	   * in the source buffer
	   *
	   * @private
	   *
	   * @param {Object} segmentInfo - the current segment
	   */
	  ;
	
	  _proto.trimBackBuffer_ = function trimBackBuffer_(segmentInfo) {
	    var removeToTime = safeBackBufferTrimTime(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10); // Chrome has a hard limit of 150MB of
	    // buffer and a very conservative "garbage collector"
	    // We manually clear out the old buffer to ensure
	    // we don't trigger the QuotaExceeded error
	    // on the source buffer during subsequent appends
	
	    if (removeToTime > 0) {
	      this.remove(0, removeToTime);
	    }
	  }
	  /**
	   * created a simplified copy of the segment object with just the
	   * information necessary to perform the XHR and decryption
	   *
	   * @private
	   *
	   * @param {Object} segmentInfo - the current segment
	   * @return {Object} a simplified segment object copy
	   */
	  ;
	
	  _proto.createSimplifiedSegmentObj_ = function createSimplifiedSegmentObj_(segmentInfo) {
	    var segment = segmentInfo.segment;
	    var part = segmentInfo.part;
	    var simpleSegment = {
	      resolvedUri: part ? part.resolvedUri : segment.resolvedUri,
	      byterange: part ? part.byterange : segment.byterange,
	      requestId: segmentInfo.requestId,
	      transmuxer: segmentInfo.transmuxer,
	      audioAppendStart: segmentInfo.audioAppendStart,
	      gopsToAlignWith: segmentInfo.gopsToAlignWith,
	      part: segmentInfo.part
	    };
	    var previousSegment = segmentInfo.playlist.segments[segmentInfo.mediaIndex - 1];
	
	    if (previousSegment && previousSegment.timeline === segment.timeline) {
	      // The baseStartTime of a segment is used to handle rollover when probing the TS
	      // segment to retrieve timing information. Since the probe only looks at the media's
	      // times (e.g., PTS and DTS values of the segment), and doesn't consider the
	      // player's time (e.g., player.currentTime()), baseStartTime should reflect the
	      // media time as well. transmuxedDecodeEnd represents the end time of a segment, in
	      // seconds of media time, so should be used here. The previous segment is used since
	      // the end of the previous segment should represent the beginning of the current
	      // segment, so long as they are on the same timeline.
	      if (previousSegment.videoTimingInfo) {
	        simpleSegment.baseStartTime = previousSegment.videoTimingInfo.transmuxedDecodeEnd;
	      } else if (previousSegment.audioTimingInfo) {
	        simpleSegment.baseStartTime = previousSegment.audioTimingInfo.transmuxedDecodeEnd;
	      }
	    }
	
	    if (segment.key) {
	      // if the media sequence is greater than 2^32, the IV will be incorrect
	      // assuming 10s segments, that would be about 1300 years
	      var iv = segment.key.iv || new Uint32Array([0, 0, 0, segmentInfo.mediaIndex + segmentInfo.playlist.mediaSequence]);
	      simpleSegment.key = this.segmentKey(segment.key);
	      simpleSegment.key.iv = iv;
	    }
	
	    if (segment.map) {
	      simpleSegment.map = this.initSegmentForMap(segment.map);
	    }
	
	    return simpleSegment;
	  };
	
	  _proto.saveTransferStats_ = function saveTransferStats_(stats) {
	    // every request counts as a media request even if it has been aborted
	    // or canceled due to a timeout
	    this.mediaRequests += 1;
	
	    if (stats) {
	      this.mediaBytesTransferred += stats.bytesReceived;
	      this.mediaTransferDuration += stats.roundTripTime;
	    }
	  };
	
	  _proto.saveBandwidthRelatedStats_ = function saveBandwidthRelatedStats_(duration, stats) {
	    // byteLength will be used for throughput, and should be based on bytes receieved,
	    // which we only know at the end of the request and should reflect total bytes
	    // downloaded rather than just bytes processed from components of the segment
	    this.pendingSegment_.byteLength = stats.bytesReceived;
	
	    if (duration < MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
	      this.logger_("Ignoring segment's bandwidth because its duration of " + duration + (" is less than the min to record " + MIN_SEGMENT_DURATION_TO_SAVE_STATS));
	      return;
	    }
	
	    this.bandwidth = stats.bandwidth;
	    this.roundTrip = stats.roundTripTime;
	  };
	
	  _proto.handleTimeout_ = function handleTimeout_() {
	    // although the VTT segment loader bandwidth isn't really used, it's good to
	    // maintain functinality between segment loaders
	    this.mediaRequestsTimedout += 1;
	    this.bandwidth = 1;
	    this.roundTrip = NaN;
	    this.trigger('bandwidthupdate');
	    this.trigger('timeout');
	  }
	  /**
	   * Handle the callback from the segmentRequest function and set the
	   * associated SegmentLoader state and errors if necessary
	   *
	   * @private
	   */
	  ;
	
	  _proto.segmentRequestFinished_ = function segmentRequestFinished_(error, simpleSegment, result) {
	    // TODO handle special cases, e.g., muxed audio/video but only audio in the segment
	    // check the call queue directly since this function doesn't need to deal with any
	    // data, and can continue even if the source buffers are not set up and we didn't get
	    // any data from the segment
	    if (this.callQueue_.length) {
	      this.callQueue_.push(this.segmentRequestFinished_.bind(this, error, simpleSegment, result));
	      return;
	    }
	
	    this.saveTransferStats_(simpleSegment.stats); // The request was aborted and the SegmentLoader has already been reset
	
	    if (!this.pendingSegment_) {
	      return;
	    } // the request was aborted and the SegmentLoader has already started
	    // another request. this can happen when the timeout for an aborted
	    // request triggers due to a limitation in the XHR library
	    // do not count this as any sort of request or we risk double-counting
	
	
	    if (simpleSegment.requestId !== this.pendingSegment_.requestId) {
	      return;
	    } // an error occurred from the active pendingSegment_ so reset everything
	
	
	    if (error) {
	      this.pendingSegment_ = null;
	      this.state = 'READY'; // aborts are not a true error condition and nothing corrective needs to be done
	
	      if (error.code === REQUEST_ERRORS.ABORTED) {
	        return;
	      }
	
	      this.pause(); // the error is really just that at least one of the requests timed-out
	      // set the bandwidth to a very low value and trigger an ABR switch to
	      // take emergency action
	
	      if (error.code === REQUEST_ERRORS.TIMEOUT) {
	        this.handleTimeout_();
	        return;
	      } // if control-flow has arrived here, then the error is real
	      // emit an error event to blacklist the current playlist
	
	
	      this.mediaRequestsErrored += 1;
	      this.error(error);
	      this.trigger('error');
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // the response was a success so set any bandwidth stats the request
	    // generated for ABR purposes
	
	    this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats);
	    segmentInfo.endOfAllRequests = simpleSegment.endOfAllRequests;
	
	    if (result.gopInfo) {
	      this.gopBuffer_ = updateGopBuffer(this.gopBuffer_, result.gopInfo, this.safeAppend_);
	    } // Although we may have already started appending on progress, we shouldn't switch the
	    // state away from loading until we are officially done loading the segment data.
	
	
	    this.state = 'APPENDING'; // used for testing
	
	    this.trigger('appending');
	    this.waitForAppendsToComplete_(segmentInfo);
	  };
	
	  _proto.setTimeMapping_ = function setTimeMapping_(timeline) {
	    var timelineMapping = this.syncController_.mappingForTimeline(timeline);
	
	    if (timelineMapping !== null) {
	      this.timeMapping_ = timelineMapping;
	    }
	  };
	
	  _proto.updateMediaSecondsLoaded_ = function updateMediaSecondsLoaded_(segment) {
	    if (typeof segment.start === 'number' && typeof segment.end === 'number') {
	      this.mediaSecondsLoaded += segment.end - segment.start;
	    } else {
	      this.mediaSecondsLoaded += segment.duration;
	    }
	  };
	
	  _proto.shouldUpdateTransmuxerTimestampOffset_ = function shouldUpdateTransmuxerTimestampOffset_(timestampOffset) {
	    if (timestampOffset === null) {
	      return false;
	    } // note that we're potentially using the same timestamp offset for both video and
	    // audio
	
	
	    if (this.loaderType_ === 'main' && timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
	      return true;
	    }
	
	    if (!this.audioDisabled_ && timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.trueSegmentStart_ = function trueSegmentStart_(_ref9) {
	    var currentStart = _ref9.currentStart,
	        playlist = _ref9.playlist,
	        mediaIndex = _ref9.mediaIndex,
	        firstVideoFrameTimeForData = _ref9.firstVideoFrameTimeForData,
	        currentVideoTimestampOffset = _ref9.currentVideoTimestampOffset,
	        useVideoTimingInfo = _ref9.useVideoTimingInfo,
	        videoTimingInfo = _ref9.videoTimingInfo,
	        audioTimingInfo = _ref9.audioTimingInfo;
	
	    if (typeof currentStart !== 'undefined') {
	      // if start was set once, keep using it
	      return currentStart;
	    }
	
	    if (!useVideoTimingInfo) {
	      return audioTimingInfo.start;
	    }
	
	    var previousSegment = playlist.segments[mediaIndex - 1]; // The start of a segment should be the start of the first full frame contained
	    // within that segment. Since the transmuxer maintains a cache of incomplete data
	    // from and/or the last frame seen, the start time may reflect a frame that starts
	    // in the previous segment. Check for that case and ensure the start time is
	    // accurate for the segment.
	
	    if (mediaIndex === 0 || !previousSegment || typeof previousSegment.start === 'undefined' || previousSegment.end !== firstVideoFrameTimeForData + currentVideoTimestampOffset) {
	      return firstVideoFrameTimeForData;
	    }
	
	    return videoTimingInfo.start;
	  };
	
	  _proto.waitForAppendsToComplete_ = function waitForAppendsToComplete_(segmentInfo) {
	    var trackInfo = this.getCurrentMediaInfo_(segmentInfo);
	
	    if (!trackInfo) {
	      this.error({
	        message: 'No starting media returned, likely due to an unsupported media format.',
	        blacklistDuration: Infinity
	      });
	      this.trigger('error');
	      return;
	    } // Although transmuxing is done, appends may not yet be finished. Throw a marker
	    // on each queue this loader is responsible for to ensure that the appends are
	    // complete.
	
	
	    var hasAudio = trackInfo.hasAudio,
	        hasVideo = trackInfo.hasVideo,
	        isMuxed = trackInfo.isMuxed;
	    var waitForVideo = this.loaderType_ === 'main' && hasVideo;
	    var waitForAudio = !this.audioDisabled_ && hasAudio && !isMuxed;
	    segmentInfo.waitingOnAppends = 0; // segments with no data
	
	    if (!segmentInfo.hasAppendedData_) {
	      if (!segmentInfo.timingInfo && typeof segmentInfo.timestampOffset === 'number') {
	        // When there's no audio or video data in the segment, there's no audio or video
	        // timing information.
	        //
	        // If there's no audio or video timing information, then the timestamp offset
	        // can't be adjusted to the appropriate value for the transmuxer and source
	        // buffers.
	        //
	        // Therefore, the next segment should be used to set the timestamp offset.
	        this.isPendingTimestampOffset_ = true;
	      } // override settings for metadata only segments
	
	
	      segmentInfo.timingInfo = {
	        start: 0
	      };
	      segmentInfo.waitingOnAppends++;
	
	      if (!this.isPendingTimestampOffset_) {
	        // update the timestampoffset
	        this.updateSourceBufferTimestampOffset_(segmentInfo); // make sure the metadata queue is processed even though we have
	        // no video/audio data.
	
	        this.processMetadataQueue_();
	      } // append is "done" instantly with no data.
	
	
	      this.checkAppendsDone_(segmentInfo);
	      return;
	    } // Since source updater could call back synchronously, do the increments first.
	
	
	    if (waitForVideo) {
	      segmentInfo.waitingOnAppends++;
	    }
	
	    if (waitForAudio) {
	      segmentInfo.waitingOnAppends++;
	    }
	
	    if (waitForVideo) {
	      this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
	    }
	
	    if (waitForAudio) {
	      this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
	    }
	  };
	
	  _proto.checkAppendsDone_ = function checkAppendsDone_(segmentInfo) {
	    if (this.checkForAbort_(segmentInfo.requestId)) {
	      return;
	    }
	
	    segmentInfo.waitingOnAppends--;
	
	    if (segmentInfo.waitingOnAppends === 0) {
	      this.handleAppendsDone_();
	    }
	  };
	
	  _proto.checkForIllegalMediaSwitch = function checkForIllegalMediaSwitch(trackInfo) {
	    var illegalMediaSwitchError = illegalMediaSwitch(this.loaderType_, this.getCurrentMediaInfo_(), trackInfo);
	
	    if (illegalMediaSwitchError) {
	      this.error({
	        message: illegalMediaSwitchError,
	        blacklistDuration: Infinity
	      });
	      this.trigger('error');
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.updateSourceBufferTimestampOffset_ = function updateSourceBufferTimestampOffset_(segmentInfo) {
	    if (segmentInfo.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
	    // priority, timing-wise, so we must wait
	    typeof segmentInfo.timingInfo.start !== 'number' || // already updated the timestamp offset for this segment
	    segmentInfo.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
	    this.loaderType_ !== 'main') {
	      return;
	    }
	
	    var didChange = false; // Primary timing goes by video, and audio is trimmed in the transmuxer, meaning that
	    // the timing info here comes from video. In the event that the audio is longer than
	    // the video, this will trim the start of the audio.
	    // This also trims any offset from 0 at the beginning of the media
	
	    segmentInfo.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
	      videoTimingInfo: segmentInfo.segment.videoTimingInfo,
	      audioTimingInfo: segmentInfo.segment.audioTimingInfo,
	      timingInfo: segmentInfo.timingInfo
	    }); // In the event that there are part segment downloads, each will try to update the
	    // timestamp offset. Retaining this bit of state prevents us from updating in the
	    // future (within the same segment), however, there may be a better way to handle it.
	
	    segmentInfo.changedTimestampOffset = true;
	
	    if (segmentInfo.timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
	      this.sourceUpdater_.videoTimestampOffset(segmentInfo.timestampOffset);
	      didChange = true;
	    }
	
	    if (segmentInfo.timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
	      this.sourceUpdater_.audioTimestampOffset(segmentInfo.timestampOffset);
	      didChange = true;
	    }
	
	    if (didChange) {
	      this.trigger('timestampoffset');
	    }
	  };
	
	  _proto.getSegmentStartTimeForTimestampOffsetCalculation_ = function getSegmentStartTimeForTimestampOffsetCalculation_(_ref10) {
	    var videoTimingInfo = _ref10.videoTimingInfo,
	        audioTimingInfo = _ref10.audioTimingInfo,
	        timingInfo = _ref10.timingInfo;
	
	    if (!this.useDtsForTimestampOffset_) {
	      return timingInfo.start;
	    }
	
	    if (videoTimingInfo && typeof videoTimingInfo.transmuxedDecodeStart === 'number') {
	      return videoTimingInfo.transmuxedDecodeStart;
	    } // handle audio only
	
	
	    if (audioTimingInfo && typeof audioTimingInfo.transmuxedDecodeStart === 'number') {
	      return audioTimingInfo.transmuxedDecodeStart;
	    } // handle content not transmuxed (e.g., MP4)
	
	
	    return timingInfo.start;
	  };
	
	  _proto.updateTimingInfoEnd_ = function updateTimingInfoEnd_(segmentInfo) {
	    segmentInfo.timingInfo = segmentInfo.timingInfo || {};
	    var trackInfo = this.getMediaInfo_();
	    var useVideoTimingInfo = this.loaderType_ === 'main' && trackInfo && trackInfo.hasVideo;
	    var prioritizedTimingInfo = useVideoTimingInfo && segmentInfo.videoTimingInfo ? segmentInfo.videoTimingInfo : segmentInfo.audioTimingInfo;
	
	    if (!prioritizedTimingInfo) {
	      return;
	    }
	
	    segmentInfo.timingInfo.end = typeof prioritizedTimingInfo.end === 'number' ? // End time may not exist in a case where we aren't parsing the full segment (one
	    // current example is the case of fmp4), so use the rough duration to calculate an
	    // end time.
	    prioritizedTimingInfo.end : prioritizedTimingInfo.start + segmentInfo.duration;
	  }
	  /**
	   * callback to run when appendBuffer is finished. detects if we are
	   * in a good state to do things with the data we got, or if we need
	   * to wait for more
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleAppendsDone_ = function handleAppendsDone_() {
	    // appendsdone can cause an abort
	    if (this.pendingSegment_) {
	      this.trigger('appendsdone');
	    }
	
	    if (!this.pendingSegment_) {
	      this.state = 'READY'; // TODO should this move into this.checkForAbort to speed up requests post abort in
	      // all appending cases?
	
	      if (!this.paused()) {
	        this.monitorBuffer_();
	      }
	
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // Now that the end of the segment has been reached, we can set the end time. It's
	    // best to wait until all appends are done so we're sure that the primary media is
	    // finished (and we have its end time).
	
	    this.updateTimingInfoEnd_(segmentInfo);
	
	    if (this.shouldSaveSegmentTimingInfo_) {
	      // Timeline mappings should only be saved for the main loader. This is for multiple
	      // reasons:
	      //
	      // 1) Only one mapping is saved per timeline, meaning that if both the audio loader
	      //    and the main loader try to save the timeline mapping, whichever comes later
	      //    will overwrite the first. In theory this is OK, as the mappings should be the
	      //    same, however, it breaks for (2)
	      // 2) In the event of a live stream, the initial live point will make for a somewhat
	      //    arbitrary mapping. If audio and video streams are not perfectly in-sync, then
	      //    the mapping will be off for one of the streams, dependent on which one was
	      //    first saved (see (1)).
	      // 3) Primary timing goes by video in VHS, so the mapping should be video.
	      //
	      // Since the audio loader will wait for the main loader to load the first segment,
	      // the main loader will save the first timeline mapping, and ensure that there won't
	      // be a case where audio loads two segments without saving a mapping (thus leading
	      // to missing segment timing info).
	      this.syncController_.saveSegmentTimingInfo({
	        segmentInfo: segmentInfo,
	        shouldSaveTimelineMapping: this.loaderType_ === 'main'
	      });
	    }
	
	    var segmentDurationMessage = getTroublesomeSegmentDurationMessage(segmentInfo, this.sourceType_);
	
	    if (segmentDurationMessage) {
	      if (segmentDurationMessage.severity === 'warn') {
	        videojs.log.warn(segmentDurationMessage.message);
	      } else {
	        this.logger_(segmentDurationMessage.message);
	      }
	    }
	
	    this.recordThroughput_(segmentInfo);
	    this.pendingSegment_ = null;
	    this.state = 'READY';
	
	    if (segmentInfo.isSyncRequest) {
	      this.trigger('syncinfoupdate'); // if the sync request was not appended
	      // then it was not the correct segment.
	      // throw it away and use the data it gave us
	      // to get the correct one.
	
	      if (!segmentInfo.hasAppendedData_) {
	        this.logger_("Throwing away un-appended sync request " + segmentInfoString(segmentInfo));
	        return;
	      }
	    }
	
	    this.logger_("Appended " + segmentInfoString(segmentInfo));
	    this.addSegmentMetadataCue_(segmentInfo);
	    this.fetchAtBuffer_ = true;
	
	    if (this.currentTimeline_ !== segmentInfo.timeline) {
	      this.timelineChangeController_.lastTimelineChange({
	        type: this.loaderType_,
	        from: this.currentTimeline_,
	        to: segmentInfo.timeline
	      }); // If audio is not disabled, the main segment loader is responsible for updating
	      // the audio timeline as well. If the content is video only, this won't have any
	      // impact.
	
	      if (this.loaderType_ === 'main' && !this.audioDisabled_) {
	        this.timelineChangeController_.lastTimelineChange({
	          type: 'audio',
	          from: this.currentTimeline_,
	          to: segmentInfo.timeline
	        });
	      }
	    }
	
	    this.currentTimeline_ = segmentInfo.timeline; // We must update the syncinfo to recalculate the seekable range before
	    // the following conditional otherwise it may consider this a bad "guess"
	    // and attempt to resync when the post-update seekable window and live
	    // point would mean that this was the perfect segment to fetch
	
	    this.trigger('syncinfoupdate');
	    var segment = segmentInfo.segment;
	    var part = segmentInfo.part;
	    var badSegmentGuess = segment.end && this.currentTime_() - segment.end > segmentInfo.playlist.targetDuration * 3;
	    var badPartGuess = part && part.end && this.currentTime_() - part.end > segmentInfo.playlist.partTargetDuration * 3; // If we previously appended a segment/part that ends more than 3 part/targetDurations before
	    // the currentTime_ that means that our conservative guess was too conservative.
	    // In that case, reset the loader state so that we try to use any information gained
	    // from the previous request to create a new, more accurate, sync-point.
	
	    if (badSegmentGuess || badPartGuess) {
	      this.logger_("bad " + (badSegmentGuess ? 'segment' : 'part') + " " + segmentInfoString(segmentInfo));
	      this.resetEverything();
	      return;
	    }
	
	    var isWalkingForward = this.mediaIndex !== null; // Don't do a rendition switch unless we have enough time to get a sync segment
	    // and conservatively guess
	
	    if (isWalkingForward) {
	      this.trigger('bandwidthupdate');
	    }
	
	    this.trigger('progress');
	    this.mediaIndex = segmentInfo.mediaIndex;
	    this.partIndex = segmentInfo.partIndex; // any time an update finishes and the last segment is in the
	    // buffer, end the stream. this ensures the "ended" event will
	    // fire if playback reaches that point.
	
	    if (this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex)) {
	      this.endOfStream();
	    } // used for testing
	
	
	    this.trigger('appended');
	
	    if (segmentInfo.hasAppendedData_) {
	      this.mediaAppends++;
	    }
	
	    if (!this.paused()) {
	      this.monitorBuffer_();
	    }
	  }
	  /**
	   * Records the current throughput of the decrypt, transmux, and append
	   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
	   * moving average of the throughput. `throughput.count` is the number of
	   * data points in the average.
	   *
	   * @private
	   * @param {Object} segmentInfo the object returned by loadSegment
	   */
	  ;
	
	  _proto.recordThroughput_ = function recordThroughput_(segmentInfo) {
	    if (segmentInfo.duration < MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
	      this.logger_("Ignoring segment's throughput because its duration of " + segmentInfo.duration + (" is less than the min to record " + MIN_SEGMENT_DURATION_TO_SAVE_STATS));
	      return;
	    }
	
	    var rate = this.throughput.rate; // Add one to the time to ensure that we don't accidentally attempt to divide
	    // by zero in the case where the throughput is ridiculously high
	
	    var segmentProcessingTime = Date.now() - segmentInfo.endOfAllRequests + 1; // Multiply by 8000 to convert from bytes/millisecond to bits/second
	
	    var segmentProcessingThroughput = Math.floor(segmentInfo.byteLength / segmentProcessingTime * 8 * 1000); // This is just a cumulative moving average calculation:
	    //   newAvg = oldAvg + (sample - oldAvg) / (sampleCount + 1)
	
	    this.throughput.rate += (segmentProcessingThroughput - rate) / ++this.throughput.count;
	  }
	  /**
	   * Adds a cue to the segment-metadata track with some metadata information about the
	   * segment
	   *
	   * @private
	   * @param {Object} segmentInfo
	   *        the object returned by loadSegment
	   * @method addSegmentMetadataCue_
	   */
	  ;
	
	  _proto.addSegmentMetadataCue_ = function addSegmentMetadataCue_(segmentInfo) {
	    if (!this.segmentMetadataTrack_) {
	      return;
	    }
	
	    var segment = segmentInfo.segment;
	    var start = segment.start;
	    var end = segment.end; // Do not try adding the cue if the start and end times are invalid.
	
	    if (!finite(start) || !finite(end)) {
	      return;
	    }
	
	    removeCuesFromTrack(start, end, this.segmentMetadataTrack_);
	    var Cue = window__default['default'].WebKitDataCue || window__default['default'].VTTCue;
	    var value = {
	      custom: segment.custom,
	      dateTimeObject: segment.dateTimeObject,
	      dateTimeString: segment.dateTimeString,
	      bandwidth: segmentInfo.playlist.attributes.BANDWIDTH,
	      resolution: segmentInfo.playlist.attributes.RESOLUTION,
	      codecs: segmentInfo.playlist.attributes.CODECS,
	      byteLength: segmentInfo.byteLength,
	      uri: segmentInfo.uri,
	      timeline: segmentInfo.timeline,
	      playlist: segmentInfo.playlist.id,
	      start: start,
	      end: end
	    };
	    var data = JSON.stringify(value);
	    var cue = new Cue(start, end, data); // Attach the metadata to the value property of the cue to keep consistency between
	    // the differences of WebKitDataCue in safari and VTTCue in other browsers
	
	    cue.value = value;
	    this.segmentMetadataTrack_.addCue(cue);
	  };
	
	  return SegmentLoader;
	}(videojs.EventTarget);
	
	function noop() {}
	
	var toTitleCase = function toTitleCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.replace(/./, function (w) {
	    return w.toUpperCase();
	  });
	};
	
	var bufferTypes = ['video', 'audio'];
	
	var _updating = function updating(type, sourceUpdater) {
	  var sourceBuffer = sourceUpdater[type + "Buffer"];
	  return sourceBuffer && sourceBuffer.updating || sourceUpdater.queuePending[type];
	};
	
	var nextQueueIndexOfType = function nextQueueIndexOfType(type, queue) {
	  for (var i = 0; i < queue.length; i++) {
	    var queueEntry = queue[i];
	
	    if (queueEntry.type === 'mediaSource') {
	      // If the next entry is a media source entry (uses multiple source buffers), block
	      // processing to allow it to go through first.
	      return null;
	    }
	
	    if (queueEntry.type === type) {
	      return i;
	    }
	  }
	
	  return null;
	};
	
	var shiftQueue = function shiftQueue(type, sourceUpdater) {
	  if (sourceUpdater.queue.length === 0) {
	    return;
	  }
	
	  var queueIndex = 0;
	  var queueEntry = sourceUpdater.queue[queueIndex];
	
	  if (queueEntry.type === 'mediaSource') {
	    if (!sourceUpdater.updating() && sourceUpdater.mediaSource.readyState !== 'closed') {
	      sourceUpdater.queue.shift();
	      queueEntry.action(sourceUpdater);
	
	      if (queueEntry.doneFn) {
	        queueEntry.doneFn();
	      } // Only specific source buffer actions must wait for async updateend events. Media
	      // Source actions process synchronously. Therefore, both audio and video source
	      // buffers are now clear to process the next queue entries.
	
	
	      shiftQueue('audio', sourceUpdater);
	      shiftQueue('video', sourceUpdater);
	    } // Media Source actions require both source buffers, so if the media source action
	    // couldn't process yet (because one or both source buffers are busy), block other
	    // queue actions until both are available and the media source action can process.
	
	
	    return;
	  }
	
	  if (type === 'mediaSource') {
	    // If the queue was shifted by a media source action (this happens when pushing a
	    // media source action onto the queue), then it wasn't from an updateend event from an
	    // audio or video source buffer, so there's no change from previous state, and no
	    // processing should be done.
	    return;
	  } // Media source queue entries don't need to consider whether the source updater is
	  // started (i.e., source buffers are created) as they don't need the source buffers, but
	  // source buffer queue entries do.
	
	
	  if (!sourceUpdater.ready() || sourceUpdater.mediaSource.readyState === 'closed' || _updating(type, sourceUpdater)) {
	    return;
	  }
	
	  if (queueEntry.type !== type) {
	    queueIndex = nextQueueIndexOfType(type, sourceUpdater.queue);
	
	    if (queueIndex === null) {
	      // Either there's no queue entry that uses this source buffer type in the queue, or
	      // there's a media source queue entry before the next entry of this type, in which
	      // case wait for that action to process first.
	      return;
	    }
	
	    queueEntry = sourceUpdater.queue[queueIndex];
	  }
	
	  sourceUpdater.queue.splice(queueIndex, 1); // Keep a record that this source buffer type is in use.
	  //
	  // The queue pending operation must be set before the action is performed in the event
	  // that the action results in a synchronous event that is acted upon. For instance, if
	  // an exception is thrown that can be handled, it's possible that new actions will be
	  // appended to an empty queue and immediately executed, but would not have the correct
	  // pending information if this property was set after the action was performed.
	
	  sourceUpdater.queuePending[type] = queueEntry;
	  queueEntry.action(type, sourceUpdater);
	
	  if (!queueEntry.doneFn) {
	    // synchronous operation, process next entry
	    sourceUpdater.queuePending[type] = null;
	    shiftQueue(type, sourceUpdater);
	    return;
	  }
	};
	
	var cleanupBuffer = function cleanupBuffer(type, sourceUpdater) {
	  var buffer = sourceUpdater[type + "Buffer"];
	  var titleType = toTitleCase(type);
	
	  if (!buffer) {
	    return;
	  }
	
	  buffer.removeEventListener('updateend', sourceUpdater["on" + titleType + "UpdateEnd_"]);
	  buffer.removeEventListener('error', sourceUpdater["on" + titleType + "Error_"]);
	  sourceUpdater.codecs[type] = null;
	  sourceUpdater[type + "Buffer"] = null;
	};
	
	var inSourceBuffers = function inSourceBuffers(mediaSource, sourceBuffer) {
	  return mediaSource && sourceBuffer && Array.prototype.indexOf.call(mediaSource.sourceBuffers, sourceBuffer) !== -1;
	};
	
	var actions = {
	  appendBuffer: function appendBuffer(bytes, segmentInfo, onError) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Appending segment " + segmentInfo.mediaIndex + "'s " + bytes.length + " bytes to " + type + "Buffer");
	
	      try {
	        sourceBuffer.appendBuffer(bytes);
	      } catch (e) {
	        sourceUpdater.logger_("Error with code " + e.code + " " + (e.code === QUOTA_EXCEEDED_ERR ? '(QUOTA_EXCEEDED_ERR) ' : '') + ("when appending segment " + segmentInfo.mediaIndex + " to " + type + "Buffer"));
	        sourceUpdater.queuePending[type] = null;
	        onError(e);
	      }
	    };
	  },
	  remove: function remove(start, end) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Removing " + start + " to " + end + " from " + type + "Buffer");
	
	      try {
	        sourceBuffer.remove(start, end);
	      } catch (e) {
	        sourceUpdater.logger_("Remove " + start + " to " + end + " from " + type + "Buffer failed");
	      }
	    };
	  },
	  timestampOffset: function timestampOffset(offset) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Setting " + type + "timestampOffset to " + offset);
	      sourceBuffer.timestampOffset = offset;
	    };
	  },
	  callback: function callback(_callback) {
	    return function (type, sourceUpdater) {
	      _callback();
	    };
	  },
	  endOfStream: function endOfStream(error) {
	    return function (sourceUpdater) {
	      if (sourceUpdater.mediaSource.readyState !== 'open') {
	        return;
	      }
	
	      sourceUpdater.logger_("Calling mediaSource endOfStream(" + (error || '') + ")");
	
	      try {
	        sourceUpdater.mediaSource.endOfStream(error);
	      } catch (e) {
	        videojs.log.warn('Failed to call media source endOfStream', e);
	      }
	    };
	  },
	  duration: function duration(_duration) {
	    return function (sourceUpdater) {
	      sourceUpdater.logger_("Setting mediaSource duration to " + _duration);
	
	      try {
	        sourceUpdater.mediaSource.duration = _duration;
	      } catch (e) {
	        videojs.log.warn('Failed to set media source duration', e);
	      }
	    };
	  },
	  abort: function abort() {
	    return function (type, sourceUpdater) {
	      if (sourceUpdater.mediaSource.readyState !== 'open') {
	        return;
	      }
	
	      var sourceBuffer = sourceUpdater[type + "Buffer"]; // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("calling abort on " + type + "Buffer");
	
	      try {
	        sourceBuffer.abort();
	      } catch (e) {
	        videojs.log.warn("Failed to abort on " + type + "Buffer", e);
	      }
	    };
	  },
	  addSourceBuffer: function addSourceBuffer(type, codec) {
	    return function (sourceUpdater) {
	      var titleType = toTitleCase(type);
	      var mime = codecs_js.getMimeForCodec(codec);
	      sourceUpdater.logger_("Adding " + type + "Buffer with codec " + codec + " to mediaSource");
	      var sourceBuffer = sourceUpdater.mediaSource.addSourceBuffer(mime);
	      sourceBuffer.addEventListener('updateend', sourceUpdater["on" + titleType + "UpdateEnd_"]);
	      sourceBuffer.addEventListener('error', sourceUpdater["on" + titleType + "Error_"]);
	      sourceUpdater.codecs[type] = codec;
	      sourceUpdater[type + "Buffer"] = sourceBuffer;
	    };
	  },
	  removeSourceBuffer: function removeSourceBuffer(type) {
	    return function (sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"];
	      cleanupBuffer(type, sourceUpdater); // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      }
	
	      sourceUpdater.logger_("Removing " + type + "Buffer with codec " + sourceUpdater.codecs[type] + " from mediaSource");
	
	      try {
	        sourceUpdater.mediaSource.removeSourceBuffer(sourceBuffer);
	      } catch (e) {
	        videojs.log.warn("Failed to removeSourceBuffer " + type + "Buffer", e);
	      }
	    };
	  },
	  changeType: function changeType(codec) {
	    return function (type, sourceUpdater) {
	      var sourceBuffer = sourceUpdater[type + "Buffer"];
	      var mime = codecs_js.getMimeForCodec(codec); // can't do anything if the media source / source buffer is null
	      // or the media source does not contain this source buffer.
	
	      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
	        return;
	      } // do not update codec if we don't need to.
	
	
	      if (sourceUpdater.codecs[type] === codec) {
	        return;
	      }
	
	      sourceUpdater.logger_("changing " + type + "Buffer codec from " + sourceUpdater.codecs[type] + " to " + codec);
	      sourceBuffer.changeType(mime);
	      sourceUpdater.codecs[type] = codec;
	    };
	  }
	};
	
	var pushQueue = function pushQueue(_ref) {
	  var type = _ref.type,
	      sourceUpdater = _ref.sourceUpdater,
	      action = _ref.action,
	      doneFn = _ref.doneFn,
	      name = _ref.name;
	  sourceUpdater.queue.push({
	    type: type,
	    action: action,
	    doneFn: doneFn,
	    name: name
	  });
	  shiftQueue(type, sourceUpdater);
	};
	
	var onUpdateend = function onUpdateend(type, sourceUpdater) {
	  return function (e) {
	    // Although there should, in theory, be a pending action for any updateend receieved,
	    // there are some actions that may trigger updateend events without set definitions in
	    // the w3c spec. For instance, setting the duration on the media source may trigger
	    // updateend events on source buffers. This does not appear to be in the spec. As such,
	    // if we encounter an updateend without a corresponding pending action from our queue
	    // for that source buffer type, process the next action.
	    if (sourceUpdater.queuePending[type]) {
	      var doneFn = sourceUpdater.queuePending[type].doneFn;
	      sourceUpdater.queuePending[type] = null;
	
	      if (doneFn) {
	        // if there's an error, report it
	        doneFn(sourceUpdater[type + "Error_"]);
	      }
	    }
	
	    shiftQueue(type, sourceUpdater);
	  };
	};
	/**
	 * A queue of callbacks to be serialized and applied when a
	 * MediaSource and its associated SourceBuffers are not in the
	 * updating state. It is used by the segment loader to update the
	 * underlying SourceBuffers when new data is loaded, for instance.
	 *
	 * @class SourceUpdater
	 * @param {MediaSource} mediaSource the MediaSource to create the SourceBuffer from
	 * @param {string} mimeType the desired MIME type of the underlying SourceBuffer
	 */
	
	
	var SourceUpdater = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](SourceUpdater, _videojs$EventTarget);
	
	  function SourceUpdater(mediaSource) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this;
	    _this.mediaSource = mediaSource;
	
	    _this.sourceopenListener_ = function () {
	      return shiftQueue('mediaSource', _assertThisInitialized__default['default'](_this));
	    };
	
	    _this.mediaSource.addEventListener('sourceopen', _this.sourceopenListener_);
	
	    _this.logger_ = logger('SourceUpdater'); // initial timestamp offset is 0
	
	    _this.audioTimestampOffset_ = 0;
	    _this.videoTimestampOffset_ = 0;
	    _this.queue = [];
	    _this.queuePending = {
	      audio: null,
	      video: null
	    };
	    _this.delayedAudioAppendQueue_ = [];
	    _this.videoAppendQueued_ = false;
	    _this.codecs = {};
	    _this.onVideoUpdateEnd_ = onUpdateend('video', _assertThisInitialized__default['default'](_this));
	    _this.onAudioUpdateEnd_ = onUpdateend('audio', _assertThisInitialized__default['default'](_this));
	
	    _this.onVideoError_ = function (e) {
	      // used for debugging
	      _this.videoError_ = e;
	    };
	
	    _this.onAudioError_ = function (e) {
	      // used for debugging
	      _this.audioError_ = e;
	    };
	
	    _this.createdSourceBuffers_ = false;
	    _this.initializedEme_ = false;
	    _this.triggeredReady_ = false;
	    return _this;
	  }
	
	  var _proto = SourceUpdater.prototype;
	
	  _proto.initializedEme = function initializedEme() {
	    this.initializedEme_ = true;
	    this.triggerReady();
	  };
	
	  _proto.hasCreatedSourceBuffers = function hasCreatedSourceBuffers() {
	    // if false, likely waiting on one of the segment loaders to get enough data to create
	    // source buffers
	    return this.createdSourceBuffers_;
	  };
	
	  _proto.hasInitializedAnyEme = function hasInitializedAnyEme() {
	    return this.initializedEme_;
	  };
	
	  _proto.ready = function ready() {
	    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
	  };
	
	  _proto.createSourceBuffers = function createSourceBuffers(codecs) {
	    if (this.hasCreatedSourceBuffers()) {
	      // already created them before
	      return;
	    } // the intial addOrChangeSourceBuffers will always be
	    // two add buffers.
	
	
	    this.addOrChangeSourceBuffers(codecs);
	    this.createdSourceBuffers_ = true;
	    this.trigger('createdsourcebuffers');
	    this.triggerReady();
	  };
	
	  _proto.triggerReady = function triggerReady() {
	    // only allow ready to be triggered once, this prevents the case
	    // where:
	    // 1. we trigger createdsourcebuffers
	    // 2. ie 11 synchronously initializates eme
	    // 3. the synchronous initialization causes us to trigger ready
	    // 4. We go back to the ready check in createSourceBuffers and ready is triggered again.
	    if (this.ready() && !this.triggeredReady_) {
	      this.triggeredReady_ = true;
	      this.trigger('ready');
	    }
	  }
	  /**
	   * Add a type of source buffer to the media source.
	   *
	   * @param {string} type
	   *        The type of source buffer to add.
	   *
	   * @param {string} codec
	   *        The codec to add the source buffer with.
	   */
	  ;
	
	  _proto.addSourceBuffer = function addSourceBuffer(type, codec) {
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.addSourceBuffer(type, codec),
	      name: 'addSourceBuffer'
	    });
	  }
	  /**
	   * call abort on a source buffer.
	   *
	   * @param {string} type
	   *        The type of source buffer to call abort on.
	   */
	  ;
	
	  _proto.abort = function abort(type) {
	    pushQueue({
	      type: type,
	      sourceUpdater: this,
	      action: actions.abort(type),
	      name: 'abort'
	    });
	  }
	  /**
	   * Call removeSourceBuffer and remove a specific type
	   * of source buffer on the mediaSource.
	   *
	   * @param {string} type
	   *        The type of source buffer to remove.
	   */
	  ;
	
	  _proto.removeSourceBuffer = function removeSourceBuffer(type) {
	    if (!this.canRemoveSourceBuffer()) {
	      videojs.log.error('removeSourceBuffer is not supported!');
	      return;
	    }
	
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.removeSourceBuffer(type),
	      name: 'removeSourceBuffer'
	    });
	  }
	  /**
	   * Whether or not the removeSourceBuffer function is supported
	   * on the mediaSource.
	   *
	   * @return {boolean}
	   *          if removeSourceBuffer can be called.
	   */
	  ;
	
	  _proto.canRemoveSourceBuffer = function canRemoveSourceBuffer() {
	    // IE reports that it supports removeSourceBuffer, but often throws
	    // errors when attempting to use the function. So we report that it
	    // does not support removeSourceBuffer. As of Firefox 83 removeSourceBuffer
	    // throws errors, so we report that it does not support this as well.
	    return !videojs.browser.IE_VERSION && !videojs.browser.IS_FIREFOX && window__default['default'].MediaSource && window__default['default'].MediaSource.prototype && typeof window__default['default'].MediaSource.prototype.removeSourceBuffer === 'function';
	  }
	  /**
	   * Whether or not the changeType function is supported
	   * on our SourceBuffers.
	   *
	   * @return {boolean}
	   *         if changeType can be called.
	   */
	  ;
	
	  SourceUpdater.canChangeType = function canChangeType() {
	    return window__default['default'].SourceBuffer && window__default['default'].SourceBuffer.prototype && typeof window__default['default'].SourceBuffer.prototype.changeType === 'function';
	  }
	  /**
	   * Whether or not the changeType function is supported
	   * on our SourceBuffers.
	   *
	   * @return {boolean}
	   *         if changeType can be called.
	   */
	  ;
	
	  _proto.canChangeType = function canChangeType() {
	    return this.constructor.canChangeType();
	  }
	  /**
	   * Call the changeType function on a source buffer, given the code and type.
	   *
	   * @param {string} type
	   *        The type of source buffer to call changeType on.
	   *
	   * @param {string} codec
	   *        The codec string to change type with on the source buffer.
	   */
	  ;
	
	  _proto.changeType = function changeType(type, codec) {
	    if (!this.canChangeType()) {
	      videojs.log.error('changeType is not supported!');
	      return;
	    }
	
	    pushQueue({
	      type: type,
	      sourceUpdater: this,
	      action: actions.changeType(codec),
	      name: 'changeType'
	    });
	  }
	  /**
	   * Add source buffers with a codec or, if they are already created,
	   * call changeType on source buffers using changeType.
	   *
	   * @param {Object} codecs
	   *        Codecs to switch to
	   */
	  ;
	
	  _proto.addOrChangeSourceBuffers = function addOrChangeSourceBuffers(codecs) {
	    var _this2 = this;
	
	    if (!codecs || typeof codecs !== 'object' || Object.keys(codecs).length === 0) {
	      throw new Error('Cannot addOrChangeSourceBuffers to undefined codecs');
	    }
	
	    Object.keys(codecs).forEach(function (type) {
	      var codec = codecs[type];
	
	      if (!_this2.hasCreatedSourceBuffers()) {
	        return _this2.addSourceBuffer(type, codec);
	      }
	
	      if (_this2.canChangeType()) {
	        _this2.changeType(type, codec);
	      }
	    });
	  }
	  /**
	   * Queue an update to append an ArrayBuffer.
	   *
	   * @param {MediaObject} object containing audioBytes and/or videoBytes
	   * @param {Function} done the function to call when done
	   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
	   */
	  ;
	
	  _proto.appendBuffer = function appendBuffer(options, doneFn) {
	    var _this3 = this;
	
	    var segmentInfo = options.segmentInfo,
	        type = options.type,
	        bytes = options.bytes;
	    this.processedAppend_ = true;
	
	    if (type === 'audio' && this.videoBuffer && !this.videoAppendQueued_) {
	      this.delayedAudioAppendQueue_.push([options, doneFn]);
	      this.logger_("delayed audio append of " + bytes.length + " until video append");
	      return;
	    } // In the case of certain errors, for instance, QUOTA_EXCEEDED_ERR, updateend will
	    // not be fired. This means that the queue will be blocked until the next action
	    // taken by the segment-loader. Provide a mechanism for segment-loader to handle
	    // these errors by calling the doneFn with the specific error.
	
	
	    var onError = doneFn;
	    pushQueue({
	      type: type,
	      sourceUpdater: this,
	      action: actions.appendBuffer(bytes, segmentInfo || {
	        mediaIndex: -1
	      }, onError),
	      doneFn: doneFn,
	      name: 'appendBuffer'
	    });
	
	    if (type === 'video') {
	      this.videoAppendQueued_ = true;
	
	      if (!this.delayedAudioAppendQueue_.length) {
	        return;
	      }
	
	      var queue = this.delayedAudioAppendQueue_.slice();
	      this.logger_("queuing delayed audio " + queue.length + " appendBuffers");
	      this.delayedAudioAppendQueue_.length = 0;
	      queue.forEach(function (que) {
	        _this3.appendBuffer.apply(_this3, que);
	      });
	    }
	  }
	  /**
	   * Get the audio buffer's buffered timerange.
	   *
	   * @return {TimeRange}
	   *         The audio buffer's buffered time range
	   */
	  ;
	
	  _proto.audioBuffered = function audioBuffered() {
	    // no media source/source buffer or it isn't in the media sources
	    // source buffer list
	    if (!inSourceBuffers(this.mediaSource, this.audioBuffer)) {
	      return videojs.createTimeRange();
	    }
	
	    return this.audioBuffer.buffered ? this.audioBuffer.buffered : videojs.createTimeRange();
	  }
	  /**
	   * Get the video buffer's buffered timerange.
	   *
	   * @return {TimeRange}
	   *         The video buffer's buffered time range
	   */
	  ;
	
	  _proto.videoBuffered = function videoBuffered() {
	    // no media source/source buffer or it isn't in the media sources
	    // source buffer list
	    if (!inSourceBuffers(this.mediaSource, this.videoBuffer)) {
	      return videojs.createTimeRange();
	    }
	
	    return this.videoBuffer.buffered ? this.videoBuffer.buffered : videojs.createTimeRange();
	  }
	  /**
	   * Get a combined video/audio buffer's buffered timerange.
	   *
	   * @return {TimeRange}
	   *         the combined time range
	   */
	  ;
	
	  _proto.buffered = function buffered() {
	    var video = inSourceBuffers(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null;
	    var audio = inSourceBuffers(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
	
	    if (audio && !video) {
	      return this.audioBuffered();
	    }
	
	    if (video && !audio) {
	      return this.videoBuffered();
	    }
	
	    return bufferIntersection(this.audioBuffered(), this.videoBuffered());
	  }
	  /**
	   * Add a callback to the queue that will set duration on the mediaSource.
	   *
	   * @param {number} duration
	   *        The duration to set
	   *
	   * @param {Function} [doneFn]
	   *        function to run after duration has been set.
	   */
	  ;
	
	  _proto.setDuration = function setDuration(duration, doneFn) {
	    if (doneFn === void 0) {
	      doneFn = noop;
	    } // In order to set the duration on the media source, it's necessary to wait for all
	    // source buffers to no longer be updating. "If the updating attribute equals true on
	    // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
	    // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
	
	
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.duration(duration),
	      name: 'duration',
	      doneFn: doneFn
	    });
	  }
	  /**
	   * Add a mediaSource endOfStream call to the queue
	   *
	   * @param {Error} [error]
	   *        Call endOfStream with an error
	   *
	   * @param {Function} [doneFn]
	   *        A function that should be called when the
	   *        endOfStream call has finished.
	   */
	  ;
	
	  _proto.endOfStream = function endOfStream(error, doneFn) {
	    if (error === void 0) {
	      error = null;
	    }
	
	    if (doneFn === void 0) {
	      doneFn = noop;
	    }
	
	    if (typeof error !== 'string') {
	      error = undefined;
	    } // In order to set the duration on the media source, it's necessary to wait for all
	    // source buffers to no longer be updating. "If the updating attribute equals true on
	    // any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
	    // abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
	
	
	    pushQueue({
	      type: 'mediaSource',
	      sourceUpdater: this,
	      action: actions.endOfStream(error),
	      name: 'endOfStream',
	      doneFn: doneFn
	    });
	  }
	  /**
	   * Queue an update to remove a time range from the buffer.
	   *
	   * @param {number} start where to start the removal
	   * @param {number} end where to end the removal
	   * @param {Function} [done=noop] optional callback to be executed when the remove
	   * operation is complete
	   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
	   */
	  ;
	
	  _proto.removeAudio = function removeAudio(start, end, done) {
	    if (done === void 0) {
	      done = noop;
	    }
	
	    if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
	      done();
	      return;
	    }
	
	    pushQueue({
	      type: 'audio',
	      sourceUpdater: this,
	      action: actions.remove(start, end),
	      doneFn: done,
	      name: 'remove'
	    });
	  }
	  /**
	   * Queue an update to remove a time range from the buffer.
	   *
	   * @param {number} start where to start the removal
	   * @param {number} end where to end the removal
	   * @param {Function} [done=noop] optional callback to be executed when the remove
	   * operation is complete
	   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
	   */
	  ;
	
	  _proto.removeVideo = function removeVideo(start, end, done) {
	    if (done === void 0) {
	      done = noop;
	    }
	
	    if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
	      done();
	      return;
	    }
	
	    pushQueue({
	      type: 'video',
	      sourceUpdater: this,
	      action: actions.remove(start, end),
	      doneFn: done,
	      name: 'remove'
	    });
	  }
	  /**
	   * Whether the underlying sourceBuffer is updating or not
	   *
	   * @return {boolean} the updating status of the SourceBuffer
	   */
	  ;
	
	  _proto.updating = function updating() {
	    // the audio/video source buffer is updating
	    if (_updating('audio', this) || _updating('video', this)) {
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * Set/get the timestampoffset on the audio SourceBuffer
	   *
	   * @return {number} the timestamp offset
	   */
	  ;
	
	  _proto.audioTimestampOffset = function audioTimestampOffset(offset) {
	    if (typeof offset !== 'undefined' && this.audioBuffer && // no point in updating if it's the same
	    this.audioTimestampOffset_ !== offset) {
	      pushQueue({
	        type: 'audio',
	        sourceUpdater: this,
	        action: actions.timestampOffset(offset),
	        name: 'timestampOffset'
	      });
	      this.audioTimestampOffset_ = offset;
	    }
	
	    return this.audioTimestampOffset_;
	  }
	  /**
	   * Set/get the timestampoffset on the video SourceBuffer
	   *
	   * @return {number} the timestamp offset
	   */
	  ;
	
	  _proto.videoTimestampOffset = function videoTimestampOffset(offset) {
	    if (typeof offset !== 'undefined' && this.videoBuffer && // no point in updating if it's the same
	    this.videoTimestampOffset !== offset) {
	      pushQueue({
	        type: 'video',
	        sourceUpdater: this,
	        action: actions.timestampOffset(offset),
	        name: 'timestampOffset'
	      });
	      this.videoTimestampOffset_ = offset;
	    }
	
	    return this.videoTimestampOffset_;
	  }
	  /**
	   * Add a function to the queue that will be called
	   * when it is its turn to run in the audio queue.
	   *
	   * @param {Function} callback
	   *        The callback to queue.
	   */
	  ;
	
	  _proto.audioQueueCallback = function audioQueueCallback(callback) {
	    if (!this.audioBuffer) {
	      return;
	    }
	
	    pushQueue({
	      type: 'audio',
	      sourceUpdater: this,
	      action: actions.callback(callback),
	      name: 'callback'
	    });
	  }
	  /**
	   * Add a function to the queue that will be called
	   * when it is its turn to run in the video queue.
	   *
	   * @param {Function} callback
	   *        The callback to queue.
	   */
	  ;
	
	  _proto.videoQueueCallback = function videoQueueCallback(callback) {
	    if (!this.videoBuffer) {
	      return;
	    }
	
	    pushQueue({
	      type: 'video',
	      sourceUpdater: this,
	      action: actions.callback(callback),
	      name: 'callback'
	    });
	  }
	  /**
	   * dispose of the source updater and the underlying sourceBuffer
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    var _this4 = this;
	
	    this.trigger('dispose');
	    bufferTypes.forEach(function (type) {
	      _this4.abort(type);
	
	      if (_this4.canRemoveSourceBuffer()) {
	        _this4.removeSourceBuffer(type);
	      } else {
	        _this4[type + "QueueCallback"](function () {
	          return cleanupBuffer(type, _this4);
	        });
	      }
	    });
	    this.videoAppendQueued_ = false;
	    this.delayedAudioAppendQueue_.length = 0;
	
	    if (this.sourceopenListener_) {
	      this.mediaSource.removeEventListener('sourceopen', this.sourceopenListener_);
	    }
	
	    this.off();
	  };
	
	  return SourceUpdater;
	}(videojs.EventTarget);
	
	var uint8ToUtf8 = function uint8ToUtf8(uintArray) {
	  return decodeURIComponent(escape(String.fromCharCode.apply(null, uintArray)));
	};
	
	var VTT_LINE_TERMINATORS = new Uint8Array('\n\n'.split('').map(function (_char3) {
	  return _char3.charCodeAt(0);
	}));
	
	var NoVttJsError = /*#__PURE__*/function (_Error) {
	  _inheritsLoose__default['default'](NoVttJsError, _Error);
	
	  function NoVttJsError() {
	    return _Error.call(this, 'Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.') || this;
	  }
	
	  return NoVttJsError;
	}( /*#__PURE__*/_wrapNativeSuper__default['default'](Error));
	/**
	 * An object that manages segment loading and appending.
	 *
	 * @class VTTSegmentLoader
	 * @param {Object} options required and optional options
	 * @extends videojs.EventTarget
	 */
	
	
	var VTTSegmentLoader = /*#__PURE__*/function (_SegmentLoader) {
	  _inheritsLoose__default['default'](VTTSegmentLoader, _SegmentLoader);
	
	  function VTTSegmentLoader(settings, options) {
	    var _this;
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    _this = _SegmentLoader.call(this, settings, options) || this; // SegmentLoader requires a MediaSource be specified or it will throw an error;
	    // however, VTTSegmentLoader has no need of a media source, so delete the reference
	
	    _this.mediaSource_ = null;
	    _this.subtitlesTrack_ = null;
	    _this.loaderType_ = 'subtitle';
	    _this.featuresNativeTextTracks_ = settings.featuresNativeTextTracks;
	    _this.loadVttJs = settings.loadVttJs; // The VTT segment will have its own time mappings. Saving VTT segment timing info in
	    // the sync controller leads to improper behavior.
	
	    _this.shouldSaveSegmentTimingInfo_ = false;
	    return _this;
	  }
	
	  var _proto = VTTSegmentLoader.prototype;
	
	  _proto.createTransmuxer_ = function createTransmuxer_() {
	    // don't need to transmux any subtitles
	    return null;
	  }
	  /**
	   * Indicates which time ranges are buffered
	   *
	   * @return {TimeRange}
	   *         TimeRange object representing the current buffered ranges
	   */
	  ;
	
	  _proto.buffered_ = function buffered_() {
	    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) {
	      return videojs.createTimeRanges();
	    }
	
	    var cues = this.subtitlesTrack_.cues;
	    var start = cues[0].startTime;
	    var end = cues[cues.length - 1].startTime;
	    return videojs.createTimeRanges([[start, end]]);
	  }
	  /**
	   * Gets and sets init segment for the provided map
	   *
	   * @param {Object} map
	   *        The map object representing the init segment to get or set
	   * @param {boolean=} set
	   *        If true, the init segment for the provided map should be saved
	   * @return {Object}
	   *         map object for desired init segment
	   */
	  ;
	
	  _proto.initSegmentForMap = function initSegmentForMap(map, set) {
	    if (set === void 0) {
	      set = false;
	    }
	
	    if (!map) {
	      return null;
	    }
	
	    var id = initSegmentId(map);
	    var storedMap = this.initSegments_[id];
	
	    if (set && !storedMap && map.bytes) {
	      // append WebVTT line terminators to the media initialization segment if it exists
	      // to follow the WebVTT spec (https://w3c.github.io/webvtt/#file-structure) that
	      // requires two or more WebVTT line terminators between the WebVTT header and the
	      // rest of the file
	      var combinedByteLength = VTT_LINE_TERMINATORS.byteLength + map.bytes.byteLength;
	      var combinedSegment = new Uint8Array(combinedByteLength);
	      combinedSegment.set(map.bytes);
	      combinedSegment.set(VTT_LINE_TERMINATORS, map.bytes.byteLength);
	      this.initSegments_[id] = storedMap = {
	        resolvedUri: map.resolvedUri,
	        byterange: map.byterange,
	        bytes: combinedSegment
	      };
	    }
	
	    return storedMap || map;
	  }
	  /**
	   * Returns true if all configuration required for loading is present, otherwise false.
	   *
	   * @return {boolean} True if the all configuration is ready for loading
	   * @private
	   */
	  ;
	
	  _proto.couldBeginLoading_ = function couldBeginLoading_() {
	    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
	  }
	  /**
	   * Once all the starting parameters have been specified, begin
	   * operation. This method should only be invoked from the INIT
	   * state.
	   *
	   * @private
	   */
	  ;
	
	  _proto.init_ = function init_() {
	    this.state = 'READY';
	    this.resetEverything();
	    return this.monitorBuffer_();
	  }
	  /**
	   * Set a subtitle track on the segment loader to add subtitles to
	   *
	   * @param {TextTrack=} track
	   *        The text track to add loaded subtitles to
	   * @return {TextTrack}
	   *        Returns the subtitles track
	   */
	  ;
	
	  _proto.track = function track(_track) {
	    if (typeof _track === 'undefined') {
	      return this.subtitlesTrack_;
	    }
	
	    this.subtitlesTrack_ = _track; // if we were unpaused but waiting for a sourceUpdater, start
	    // buffering now
	
	    if (this.state === 'INIT' && this.couldBeginLoading_()) {
	      this.init_();
	    }
	
	    return this.subtitlesTrack_;
	  }
	  /**
	   * Remove any data in the source buffer between start and end times
	   *
	   * @param {number} start - the start time of the region to remove from the buffer
	   * @param {number} end - the end time of the region to remove from the buffer
	   */
	  ;
	
	  _proto.remove = function remove(start, end) {
	    removeCuesFromTrack(start, end, this.subtitlesTrack_);
	  }
	  /**
	   * fill the buffer with segements unless the sourceBuffers are
	   * currently updating
	   *
	   * Note: this function should only ever be called by monitorBuffer_
	   * and never directly
	   *
	   * @private
	   */
	  ;
	
	  _proto.fillBuffer_ = function fillBuffer_() {
	    var _this2 = this; // see if we need to begin loading immediately
	
	
	    var segmentInfo = this.chooseNextRequest_();
	
	    if (!segmentInfo) {
	      return;
	    }
	
	    if (this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline) === null) {
	      // We don't have the timestamp offset that we need to sync subtitles.
	      // Rerun on a timestamp offset or user interaction.
	      var checkTimestampOffset = function checkTimestampOffset() {
	        _this2.state = 'READY';
	
	        if (!_this2.paused()) {
	          // if not paused, queue a buffer check as soon as possible
	          _this2.monitorBuffer_();
	        }
	      };
	
	      this.syncController_.one('timestampoffset', checkTimestampOffset);
	      this.state = 'WAITING_ON_TIMELINE';
	      return;
	    }
	
	    this.loadSegment_(segmentInfo);
	  } // never set a timestamp offset for vtt segments.
	  ;
	
	  _proto.timestampOffsetForSegment_ = function timestampOffsetForSegment_() {
	    return null;
	  };
	
	  _proto.chooseNextRequest_ = function chooseNextRequest_() {
	    return this.skipEmptySegments_(_SegmentLoader.prototype.chooseNextRequest_.call(this));
	  }
	  /**
	   * Prevents the segment loader from requesting segments we know contain no subtitles
	   * by walking forward until we find the next segment that we don't know whether it is
	   * empty or not.
	   *
	   * @param {Object} segmentInfo
	   *        a segment info object that describes the current segment
	   * @return {Object}
	   *         a segment info object that describes the current segment
	   */
	  ;
	
	  _proto.skipEmptySegments_ = function skipEmptySegments_(segmentInfo) {
	    while (segmentInfo && segmentInfo.segment.empty) {
	      // stop at the last possible segmentInfo
	      if (segmentInfo.mediaIndex + 1 >= segmentInfo.playlist.segments.length) {
	        segmentInfo = null;
	        break;
	      }
	
	      segmentInfo = this.generateSegmentInfo_({
	        playlist: segmentInfo.playlist,
	        mediaIndex: segmentInfo.mediaIndex + 1,
	        startOfSegment: segmentInfo.startOfSegment + segmentInfo.duration,
	        isSyncRequest: segmentInfo.isSyncRequest
	      });
	    }
	
	    return segmentInfo;
	  };
	
	  _proto.stopForError = function stopForError(error) {
	    this.error(error);
	    this.state = 'READY';
	    this.pause();
	    this.trigger('error');
	  }
	  /**
	   * append a decrypted segement to the SourceBuffer through a SourceUpdater
	   *
	   * @private
	   */
	  ;
	
	  _proto.segmentRequestFinished_ = function segmentRequestFinished_(error, simpleSegment, result) {
	    var _this3 = this;
	
	    if (!this.subtitlesTrack_) {
	      this.state = 'READY';
	      return;
	    }
	
	    this.saveTransferStats_(simpleSegment.stats); // the request was aborted
	
	    if (!this.pendingSegment_) {
	      this.state = 'READY';
	      this.mediaRequestsAborted += 1;
	      return;
	    }
	
	    if (error) {
	      if (error.code === REQUEST_ERRORS.TIMEOUT) {
	        this.handleTimeout_();
	      }
	
	      if (error.code === REQUEST_ERRORS.ABORTED) {
	        this.mediaRequestsAborted += 1;
	      } else {
	        this.mediaRequestsErrored += 1;
	      }
	
	      this.stopForError(error);
	      return;
	    }
	
	    var segmentInfo = this.pendingSegment_; // although the VTT segment loader bandwidth isn't really used, it's good to
	    // maintain functionality between segment loaders
	
	    this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats); // if this request included a segment key, save that data in the cache
	
	    if (simpleSegment.key) {
	      this.segmentKey(simpleSegment.key, true);
	    }
	
	    this.state = 'APPENDING'; // used for tests
	
	    this.trigger('appending');
	    var segment = segmentInfo.segment;
	
	    if (segment.map) {
	      segment.map.bytes = simpleSegment.map.bytes;
	    }
	
	    segmentInfo.bytes = simpleSegment.bytes; // Make sure that vttjs has loaded, otherwise, load it and wait till it finished loading
	
	    if (typeof window__default['default'].WebVTT !== 'function' && typeof this.loadVttJs === 'function') {
	      this.state = 'WAITING_ON_VTTJS'; // should be fine to call multiple times
	      // script will be loaded once but multiple listeners will be added to the queue, which is expected.
	
	      this.loadVttJs().then(function () {
	        return _this3.segmentRequestFinished_(error, simpleSegment, result);
	      }, function () {
	        return _this3.stopForError({
	          message: 'Error loading vtt.js'
	        });
	      });
	      return;
	    }
	
	    segment.requested = true;
	
	    try {
	      this.parseVTTCues_(segmentInfo);
	    } catch (e) {
	      this.stopForError({
	        message: e.message
	      });
	      return;
	    }
	
	    this.updateTimeMapping_(segmentInfo, this.syncController_.timelines[segmentInfo.timeline], this.playlist_);
	
	    if (segmentInfo.cues.length) {
	      segmentInfo.timingInfo = {
	        start: segmentInfo.cues[0].startTime,
	        end: segmentInfo.cues[segmentInfo.cues.length - 1].endTime
	      };
	    } else {
	      segmentInfo.timingInfo = {
	        start: segmentInfo.startOfSegment,
	        end: segmentInfo.startOfSegment + segmentInfo.duration
	      };
	    }
	
	    if (segmentInfo.isSyncRequest) {
	      this.trigger('syncinfoupdate');
	      this.pendingSegment_ = null;
	      this.state = 'READY';
	      return;
	    }
	
	    segmentInfo.byteLength = segmentInfo.bytes.byteLength;
	    this.mediaSecondsLoaded += segment.duration; // Create VTTCue instances for each cue in the new segment and add them to
	    // the subtitle track
	
	    segmentInfo.cues.forEach(function (cue) {
	      _this3.subtitlesTrack_.addCue(_this3.featuresNativeTextTracks_ ? new window__default['default'].VTTCue(cue.startTime, cue.endTime, cue.text) : cue);
	    }); // Remove any duplicate cues from the subtitle track. The WebVTT spec allows
	    // cues to have identical time-intervals, but if the text is also identical
	    // we can safely assume it is a duplicate that can be removed (ex. when a cue
	    // "overlaps" VTT segments)
	
	    removeDuplicateCuesFromTrack(this.subtitlesTrack_);
	    this.handleAppendsDone_();
	  };
	
	  _proto.handleData_ = function handleData_() {// noop as we shouldn't be getting video/audio data captions
	    // that we do not support here.
	  };
	
	  _proto.updateTimingInfoEnd_ = function updateTimingInfoEnd_() {// noop
	  }
	  /**
	   * Uses the WebVTT parser to parse the segment response
	   *
	   * @throws NoVttJsError
	   *
	   * @param {Object} segmentInfo
	   *        a segment info object that describes the current segment
	   * @private
	   */
	  ;
	
	  _proto.parseVTTCues_ = function parseVTTCues_(segmentInfo) {
	    var decoder;
	    var decodeBytesToString = false;
	
	    if (typeof window__default['default'].WebVTT !== 'function') {
	      // caller is responsible for exception handling.
	      throw new NoVttJsError();
	    }
	
	    if (typeof window__default['default'].TextDecoder === 'function') {
	      decoder = new window__default['default'].TextDecoder('utf8');
	    } else {
	      decoder = window__default['default'].WebVTT.StringDecoder();
	      decodeBytesToString = true;
	    }
	
	    var parser = new window__default['default'].WebVTT.Parser(window__default['default'], window__default['default'].vttjs, decoder);
	    segmentInfo.cues = [];
	    segmentInfo.timestampmap = {
	      MPEGTS: 0,
	      LOCAL: 0
	    };
	    parser.oncue = segmentInfo.cues.push.bind(segmentInfo.cues);
	
	    parser.ontimestampmap = function (map) {
	      segmentInfo.timestampmap = map;
	    };
	
	    parser.onparsingerror = function (error) {
	      videojs.log.warn('Error encountered when parsing cues: ' + error.message);
	    };
	
	    if (segmentInfo.segment.map) {
	      var mapData = segmentInfo.segment.map.bytes;
	
	      if (decodeBytesToString) {
	        mapData = uint8ToUtf8(mapData);
	      }
	
	      parser.parse(mapData);
	    }
	
	    var segmentData = segmentInfo.bytes;
	
	    if (decodeBytesToString) {
	      segmentData = uint8ToUtf8(segmentData);
	    }
	
	    parser.parse(segmentData);
	    parser.flush();
	  }
	  /**
	   * Updates the start and end times of any cues parsed by the WebVTT parser using
	   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
	   * from the SyncController
	   *
	   * @param {Object} segmentInfo
	   *        a segment info object that describes the current segment
	   * @param {Object} mappingObj
	   *        object containing a mapping from TS to media time
	   * @param {Object} playlist
	   *        the playlist object containing the segment
	   * @private
	   */
	  ;
	
	  _proto.updateTimeMapping_ = function updateTimeMapping_(segmentInfo, mappingObj, playlist) {
	    var segment = segmentInfo.segment;
	
	    if (!mappingObj) {
	      // If the sync controller does not have a mapping of TS to Media Time for the
	      // timeline, then we don't have enough information to update the cue
	      // start/end times
	      return;
	    }
	
	    if (!segmentInfo.cues.length) {
	      // If there are no cues, we also do not have enough information to figure out
	      // segment timing. Mark that the segment contains no cues so we don't re-request
	      // an empty segment.
	      segment.empty = true;
	      return;
	    }
	
	    var timestampmap = segmentInfo.timestampmap;
	    var diff = timestampmap.MPEGTS / clock.ONE_SECOND_IN_TS - timestampmap.LOCAL + mappingObj.mapping;
	    segmentInfo.cues.forEach(function (cue) {
	      // First convert cue time to TS time using the timestamp-map provided within the vtt
	      cue.startTime += diff;
	      cue.endTime += diff;
	    });
	
	    if (!playlist.syncInfo) {
	      var firstStart = segmentInfo.cues[0].startTime;
	      var lastStart = segmentInfo.cues[segmentInfo.cues.length - 1].startTime;
	      playlist.syncInfo = {
	        mediaSequence: playlist.mediaSequence + segmentInfo.mediaIndex,
	        time: Math.min(firstStart, lastStart - segment.duration)
	      };
	    }
	  };
	
	  return VTTSegmentLoader;
	}(SegmentLoader);
	/**
	 * @file ad-cue-tags.js
	 */
	
	/**
	 * Searches for an ad cue that overlaps with the given mediaTime
	 *
	 * @param {Object} track
	 *        the track to find the cue for
	 *
	 * @param {number} mediaTime
	 *        the time to find the cue at
	 *
	 * @return {Object|null}
	 *         the found cue or null
	 */
	
	
	var findAdCue = function findAdCue(track, mediaTime) {
	  var cues = track.cues;
	
	  for (var i = 0; i < cues.length; i++) {
	    var cue = cues[i];
	
	    if (mediaTime >= cue.adStartTime && mediaTime <= cue.adEndTime) {
	      return cue;
	    }
	  }
	
	  return null;
	};
	
	var updateAdCues = function updateAdCues(media, track, offset) {
	  if (offset === void 0) {
	    offset = 0;
	  }
	
	  if (!media.segments) {
	    return;
	  }
	
	  var mediaTime = offset;
	  var cue;
	
	  for (var i = 0; i < media.segments.length; i++) {
	    var segment = media.segments[i];
	
	    if (!cue) {
	      // Since the cues will span for at least the segment duration, adding a fudge
	      // factor of half segment duration will prevent duplicate cues from being
	      // created when timing info is not exact (e.g. cue start time initialized
	      // at 10.006677, but next call mediaTime is 10.003332 )
	      cue = findAdCue(track, mediaTime + segment.duration / 2);
	    }
	
	    if (cue) {
	      if ('cueIn' in segment) {
	        // Found a CUE-IN so end the cue
	        cue.endTime = mediaTime;
	        cue.adEndTime = mediaTime;
	        mediaTime += segment.duration;
	        cue = null;
	        continue;
	      }
	
	      if (mediaTime < cue.endTime) {
	        // Already processed this mediaTime for this cue
	        mediaTime += segment.duration;
	        continue;
	      } // otherwise extend cue until a CUE-IN is found
	
	
	      cue.endTime += segment.duration;
	    } else {
	      if ('cueOut' in segment) {
	        cue = new window__default['default'].VTTCue(mediaTime, mediaTime + segment.duration, segment.cueOut);
	        cue.adStartTime = mediaTime; // Assumes tag format to be
	        // #EXT-X-CUE-OUT:30
	
	        cue.adEndTime = mediaTime + parseFloat(segment.cueOut);
	        track.addCue(cue);
	      }
	
	      if ('cueOutCont' in segment) {
	        // Entered into the middle of an ad cue
	        // Assumes tag formate to be
	        // #EXT-X-CUE-OUT-CONT:10/30
	        var _segment$cueOutCont$s = segment.cueOutCont.split('/').map(parseFloat),
	            adOffset = _segment$cueOutCont$s[0],
	            adTotal = _segment$cueOutCont$s[1];
	
	        cue = new window__default['default'].VTTCue(mediaTime, mediaTime + segment.duration, '');
	        cue.adStartTime = mediaTime - adOffset;
	        cue.adEndTime = cue.adStartTime + adTotal;
	        track.addCue(cue);
	      }
	    }
	
	    mediaTime += segment.duration;
	  }
	}; // synchronize expired playlist segments.
	// the max media sequence diff is 48 hours of live stream
	// content with two second segments. Anything larger than that
	// will likely be invalid.
	
	
	var MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC = 86400;
	var syncPointStrategies = [// Stategy "VOD": Handle the VOD-case where the sync-point is *always*
	//                the equivalence display-time 0 === segment-index 0
	{
	  name: 'VOD',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    if (duration !== Infinity) {
	      var syncPoint = {
	        time: 0,
	        segmentIndex: 0,
	        partIndex: null
	      };
	      return syncPoint;
	    }
	
	    return null;
	  }
	}, // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
	{
	  name: 'ProgramDateTime',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    if (!Object.keys(syncController.timelineToDatetimeMappings).length) {
	      return null;
	    }
	
	    var syncPoint = null;
	    var lastDistance = null;
	    var partsAndSegments = getPartsAndSegments(playlist);
	    currentTime = currentTime || 0;
	
	    for (var i = 0; i < partsAndSegments.length; i++) {
	      // start from the end and loop backwards for live
	      // or start from the front and loop forwards for non-live
	      var index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
	      var partAndSegment = partsAndSegments[index];
	      var segment = partAndSegment.segment;
	      var datetimeMapping = syncController.timelineToDatetimeMappings[segment.timeline];
	
	      if (!datetimeMapping || !segment.dateTimeObject) {
	        continue;
	      }
	
	      var segmentTime = segment.dateTimeObject.getTime() / 1000;
	      var start = segmentTime + datetimeMapping; // take part duration into account.
	
	      if (segment.parts && typeof partAndSegment.partIndex === 'number') {
	        for (var z = 0; z < partAndSegment.partIndex; z++) {
	          start += segment.parts[z].duration;
	        }
	      }
	
	      var distance = Math.abs(currentTime - start); // Once the distance begins to increase, or if distance is 0, we have passed
	      // currentTime and can stop looking for better candidates
	
	      if (lastDistance !== null && (distance === 0 || lastDistance < distance)) {
	        break;
	      }
	
	      lastDistance = distance;
	      syncPoint = {
	        time: start,
	        segmentIndex: partAndSegment.segmentIndex,
	        partIndex: partAndSegment.partIndex
	      };
	    }
	
	    return syncPoint;
	  }
	}, // Stategy "Segment": We have a known time mapping for a timeline and a
	//                    segment in the current timeline with timing data
	{
	  name: 'Segment',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    var syncPoint = null;
	    var lastDistance = null;
	    currentTime = currentTime || 0;
	    var partsAndSegments = getPartsAndSegments(playlist);
	
	    for (var i = 0; i < partsAndSegments.length; i++) {
	      // start from the end and loop backwards for live
	      // or start from the front and loop forwards for non-live
	      var index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
	      var partAndSegment = partsAndSegments[index];
	      var segment = partAndSegment.segment;
	      var start = partAndSegment.part && partAndSegment.part.start || segment && segment.start;
	
	      if (segment.timeline === currentTimeline && typeof start !== 'undefined') {
	        var distance = Math.abs(currentTime - start); // Once the distance begins to increase, we have passed
	        // currentTime and can stop looking for better candidates
	
	        if (lastDistance !== null && lastDistance < distance) {
	          break;
	        }
	
	        if (!syncPoint || lastDistance === null || lastDistance >= distance) {
	          lastDistance = distance;
	          syncPoint = {
	            time: start,
	            segmentIndex: partAndSegment.segmentIndex,
	            partIndex: partAndSegment.partIndex
	          };
	        }
	      }
	    }
	
	    return syncPoint;
	  }
	}, // Stategy "Discontinuity": We have a discontinuity with a known
	//                          display-time
	{
	  name: 'Discontinuity',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    var syncPoint = null;
	    currentTime = currentTime || 0;
	
	    if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
	      var lastDistance = null;
	
	      for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
	        var segmentIndex = playlist.discontinuityStarts[i];
	        var discontinuity = playlist.discontinuitySequence + i + 1;
	        var discontinuitySync = syncController.discontinuities[discontinuity];
	
	        if (discontinuitySync) {
	          var distance = Math.abs(currentTime - discontinuitySync.time); // Once the distance begins to increase, we have passed
	          // currentTime and can stop looking for better candidates
	
	          if (lastDistance !== null && lastDistance < distance) {
	            break;
	          }
	
	          if (!syncPoint || lastDistance === null || lastDistance >= distance) {
	            lastDistance = distance;
	            syncPoint = {
	              time: discontinuitySync.time,
	              segmentIndex: segmentIndex,
	              partIndex: null
	            };
	          }
	        }
	      }
	    }
	
	    return syncPoint;
	  }
	}, // Stategy "Playlist": We have a playlist with a known mapping of
	//                     segment index to display time
	{
	  name: 'Playlist',
	  run: function run(syncController, playlist, duration, currentTimeline, currentTime) {
	    if (playlist.syncInfo) {
	      var syncPoint = {
	        time: playlist.syncInfo.time,
	        segmentIndex: playlist.syncInfo.mediaSequence - playlist.mediaSequence,
	        partIndex: null
	      };
	      return syncPoint;
	    }
	
	    return null;
	  }
	}];
	
	var SyncController = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](SyncController, _videojs$EventTarget);
	
	  function SyncController(options) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this; // ...for synching across variants
	
	    _this.timelines = [];
	    _this.discontinuities = [];
	    _this.timelineToDatetimeMappings = {};
	    _this.logger_ = logger('SyncController');
	    return _this;
	  }
	  /**
	   * Find a sync-point for the playlist specified
	   *
	   * A sync-point is defined as a known mapping from display-time to
	   * a segment-index in the current playlist.
	   *
	   * @param {Playlist} playlist
	   *        The playlist that needs a sync-point
	   * @param {number} duration
	   *        Duration of the MediaSource (Infinite if playing a live source)
	   * @param {number} currentTimeline
	   *        The last timeline from which a segment was loaded
	   * @return {Object}
	   *          A sync-point object
	   */
	
	
	  var _proto = SyncController.prototype;
	
	  _proto.getSyncPoint = function getSyncPoint(playlist, duration, currentTimeline, currentTime) {
	    var syncPoints = this.runStrategies_(playlist, duration, currentTimeline, currentTime);
	
	    if (!syncPoints.length) {
	      // Signal that we need to attempt to get a sync-point manually
	      // by fetching a segment in the playlist and constructing
	      // a sync-point from that information
	      return null;
	    } // Now find the sync-point that is closest to the currentTime because
	    // that should result in the most accurate guess about which segment
	    // to fetch
	
	
	    return this.selectSyncPoint_(syncPoints, {
	      key: 'time',
	      value: currentTime
	    });
	  }
	  /**
	   * Calculate the amount of time that has expired off the playlist during playback
	   *
	   * @param {Playlist} playlist
	   *        Playlist object to calculate expired from
	   * @param {number} duration
	   *        Duration of the MediaSource (Infinity if playling a live source)
	   * @return {number|null}
	   *          The amount of time that has expired off the playlist during playback. Null
	   *          if no sync-points for the playlist can be found.
	   */
	  ;
	
	  _proto.getExpiredTime = function getExpiredTime(playlist, duration) {
	    if (!playlist || !playlist.segments) {
	      return null;
	    }
	
	    var syncPoints = this.runStrategies_(playlist, duration, playlist.discontinuitySequence, 0); // Without sync-points, there is not enough information to determine the expired time
	
	    if (!syncPoints.length) {
	      return null;
	    }
	
	    var syncPoint = this.selectSyncPoint_(syncPoints, {
	      key: 'segmentIndex',
	      value: 0
	    }); // If the sync-point is beyond the start of the playlist, we want to subtract the
	    // duration from index 0 to syncPoint.segmentIndex instead of adding.
	
	    if (syncPoint.segmentIndex > 0) {
	      syncPoint.time *= -1;
	    }
	
	    return Math.abs(syncPoint.time + sumDurations({
	      defaultDuration: playlist.targetDuration,
	      durationList: playlist.segments,
	      startIndex: syncPoint.segmentIndex,
	      endIndex: 0
	    }));
	  }
	  /**
	   * Runs each sync-point strategy and returns a list of sync-points returned by the
	   * strategies
	   *
	   * @private
	   * @param {Playlist} playlist
	   *        The playlist that needs a sync-point
	   * @param {number} duration
	   *        Duration of the MediaSource (Infinity if playing a live source)
	   * @param {number} currentTimeline
	   *        The last timeline from which a segment was loaded
	   * @return {Array}
	   *          A list of sync-point objects
	   */
	  ;
	
	  _proto.runStrategies_ = function runStrategies_(playlist, duration, currentTimeline, currentTime) {
	    var syncPoints = []; // Try to find a sync-point in by utilizing various strategies...
	
	    for (var i = 0; i < syncPointStrategies.length; i++) {
	      var strategy = syncPointStrategies[i];
	      var syncPoint = strategy.run(this, playlist, duration, currentTimeline, currentTime);
	
	      if (syncPoint) {
	        syncPoint.strategy = strategy.name;
	        syncPoints.push({
	          strategy: strategy.name,
	          syncPoint: syncPoint
	        });
	      }
	    }
	
	    return syncPoints;
	  }
	  /**
	   * Selects the sync-point nearest the specified target
	   *
	   * @private
	   * @param {Array} syncPoints
	   *        List of sync-points to select from
	   * @param {Object} target
	   *        Object specifying the property and value we are targeting
	   * @param {string} target.key
	   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
	   * @param {number} target.value
	   *        The value to target for the specified key.
	   * @return {Object}
	   *          The sync-point nearest the target
	   */
	  ;
	
	  _proto.selectSyncPoint_ = function selectSyncPoint_(syncPoints, target) {
	    var bestSyncPoint = syncPoints[0].syncPoint;
	    var bestDistance = Math.abs(syncPoints[0].syncPoint[target.key] - target.value);
	    var bestStrategy = syncPoints[0].strategy;
	
	    for (var i = 1; i < syncPoints.length; i++) {
	      var newDistance = Math.abs(syncPoints[i].syncPoint[target.key] - target.value);
	
	      if (newDistance < bestDistance) {
	        bestDistance = newDistance;
	        bestSyncPoint = syncPoints[i].syncPoint;
	        bestStrategy = syncPoints[i].strategy;
	      }
	    }
	
	    this.logger_("syncPoint for [" + target.key + ": " + target.value + "] chosen with strategy" + (" [" + bestStrategy + "]: [time:" + bestSyncPoint.time + ",") + (" segmentIndex:" + bestSyncPoint.segmentIndex) + (typeof bestSyncPoint.partIndex === 'number' ? ",partIndex:" + bestSyncPoint.partIndex : '') + ']');
	    return bestSyncPoint;
	  }
	  /**
	   * Save any meta-data present on the segments when segments leave
	   * the live window to the playlist to allow for synchronization at the
	   * playlist level later.
	   *
	   * @param {Playlist} oldPlaylist - The previous active playlist
	   * @param {Playlist} newPlaylist - The updated and most current playlist
	   */
	  ;
	
	  _proto.saveExpiredSegmentInfo = function saveExpiredSegmentInfo(oldPlaylist, newPlaylist) {
	    var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence; // Ignore large media sequence gaps
	
	    if (mediaSequenceDiff > MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC) {
	      videojs.log.warn("Not saving expired segment info. Media sequence gap " + mediaSequenceDiff + " is too large.");
	      return;
	    } // When a segment expires from the playlist and it has a start time
	    // save that information as a possible sync-point reference in future
	
	
	    for (var i = mediaSequenceDiff - 1; i >= 0; i--) {
	      var lastRemovedSegment = oldPlaylist.segments[i];
	
	      if (lastRemovedSegment && typeof lastRemovedSegment.start !== 'undefined') {
	        newPlaylist.syncInfo = {
	          mediaSequence: oldPlaylist.mediaSequence + i,
	          time: lastRemovedSegment.start
	        };
	        this.logger_("playlist refresh sync: [time:" + newPlaylist.syncInfo.time + "," + (" mediaSequence: " + newPlaylist.syncInfo.mediaSequence + "]"));
	        this.trigger('syncinfoupdate');
	        break;
	      }
	    }
	  }
	  /**
	   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
	   * before segments start to load.
	   *
	   * @param {Playlist} playlist - The currently active playlist
	   */
	  ;
	
	  _proto.setDateTimeMappingForStart = function setDateTimeMappingForStart(playlist) {
	    // It's possible for the playlist to be updated before playback starts, meaning time
	    // zero is not yet set. If, during these playlist refreshes, a discontinuity is
	    // crossed, then the old time zero mapping (for the prior timeline) would be retained
	    // unless the mappings are cleared.
	    this.timelineToDatetimeMappings = {};
	
	    if (playlist.segments && playlist.segments.length && playlist.segments[0].dateTimeObject) {
	      var firstSegment = playlist.segments[0];
	      var playlistTimestamp = firstSegment.dateTimeObject.getTime() / 1000;
	      this.timelineToDatetimeMappings[firstSegment.timeline] = -playlistTimestamp;
	    }
	  }
	  /**
	   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
	   * based on the latest timing information.
	   *
	   * @param {Object} options
	   *        Options object
	   * @param {SegmentInfo} options.segmentInfo
	   *        The current active request information
	   * @param {boolean} options.shouldSaveTimelineMapping
	   *        If there's a timeline change, determines if the timeline mapping should be
	   *        saved for timeline mapping and program date time mappings.
	   */
	  ;
	
	  _proto.saveSegmentTimingInfo = function saveSegmentTimingInfo(_ref) {
	    var segmentInfo = _ref.segmentInfo,
	        shouldSaveTimelineMapping = _ref.shouldSaveTimelineMapping;
	    var didCalculateSegmentTimeMapping = this.calculateSegmentTimeMapping_(segmentInfo, segmentInfo.timingInfo, shouldSaveTimelineMapping);
	    var segment = segmentInfo.segment;
	
	    if (didCalculateSegmentTimeMapping) {
	      this.saveDiscontinuitySyncInfo_(segmentInfo); // If the playlist does not have sync information yet, record that information
	      // now with segment timing information
	
	      if (!segmentInfo.playlist.syncInfo) {
	        segmentInfo.playlist.syncInfo = {
	          mediaSequence: segmentInfo.playlist.mediaSequence + segmentInfo.mediaIndex,
	          time: segment.start
	        };
	      }
	    }
	
	    var dateTime = segment.dateTimeObject;
	
	    if (segment.discontinuity && shouldSaveTimelineMapping && dateTime) {
	      this.timelineToDatetimeMappings[segment.timeline] = -(dateTime.getTime() / 1000);
	    }
	  };
	
	  _proto.timestampOffsetForTimeline = function timestampOffsetForTimeline(timeline) {
	    if (typeof this.timelines[timeline] === 'undefined') {
	      return null;
	    }
	
	    return this.timelines[timeline].time;
	  };
	
	  _proto.mappingForTimeline = function mappingForTimeline(timeline) {
	    if (typeof this.timelines[timeline] === 'undefined') {
	      return null;
	    }
	
	    return this.timelines[timeline].mapping;
	  }
	  /**
	   * Use the "media time" for a segment to generate a mapping to "display time" and
	   * save that display time to the segment.
	   *
	   * @private
	   * @param {SegmentInfo} segmentInfo
	   *        The current active request information
	   * @param {Object} timingInfo
	   *        The start and end time of the current segment in "media time"
	   * @param {boolean} shouldSaveTimelineMapping
	   *        If there's a timeline change, determines if the timeline mapping should be
	   *        saved in timelines.
	   * @return {boolean}
	   *          Returns false if segment time mapping could not be calculated
	   */
	  ;
	
	  _proto.calculateSegmentTimeMapping_ = function calculateSegmentTimeMapping_(segmentInfo, timingInfo, shouldSaveTimelineMapping) {
	    // TODO: remove side effects
	    var segment = segmentInfo.segment;
	    var part = segmentInfo.part;
	    var mappingObj = this.timelines[segmentInfo.timeline];
	    var start;
	    var end;
	
	    if (typeof segmentInfo.timestampOffset === 'number') {
	      mappingObj = {
	        time: segmentInfo.startOfSegment,
	        mapping: segmentInfo.startOfSegment - timingInfo.start
	      };
	
	      if (shouldSaveTimelineMapping) {
	        this.timelines[segmentInfo.timeline] = mappingObj;
	        this.trigger('timestampoffset');
	        this.logger_("time mapping for timeline " + segmentInfo.timeline + ": " + ("[time: " + mappingObj.time + "] [mapping: " + mappingObj.mapping + "]"));
	      }
	
	      start = segmentInfo.startOfSegment;
	      end = timingInfo.end + mappingObj.mapping;
	    } else if (mappingObj) {
	      start = timingInfo.start + mappingObj.mapping;
	      end = timingInfo.end + mappingObj.mapping;
	    } else {
	      return false;
	    }
	
	    if (part) {
	      part.start = start;
	      part.end = end;
	    } // If we don't have a segment start yet or the start value we got
	    // is less than our current segment.start value, save a new start value.
	    // We have to do this because parts will have segment timing info saved
	    // multiple times and we want segment start to be the earliest part start
	    // value for that segment.
	
	
	    if (!segment.start || start < segment.start) {
	      segment.start = start;
	    }
	
	    segment.end = end;
	    return true;
	  }
	  /**
	   * Each time we have discontinuity in the playlist, attempt to calculate the location
	   * in display of the start of the discontinuity and save that. We also save an accuracy
	   * value so that we save values with the most accuracy (closest to 0.)
	   *
	   * @private
	   * @param {SegmentInfo} segmentInfo - The current active request information
	   */
	  ;
	
	  _proto.saveDiscontinuitySyncInfo_ = function saveDiscontinuitySyncInfo_(segmentInfo) {
	    var playlist = segmentInfo.playlist;
	    var segment = segmentInfo.segment; // If the current segment is a discontinuity then we know exactly where
	    // the start of the range and it's accuracy is 0 (greater accuracy values
	    // mean more approximation)
	
	    if (segment.discontinuity) {
	      this.discontinuities[segment.timeline] = {
	        time: segment.start,
	        accuracy: 0
	      };
	    } else if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
	      // Search for future discontinuities that we can provide better timing
	      // information for and save that information for sync purposes
	      for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
	        var segmentIndex = playlist.discontinuityStarts[i];
	        var discontinuity = playlist.discontinuitySequence + i + 1;
	        var mediaIndexDiff = segmentIndex - segmentInfo.mediaIndex;
	        var accuracy = Math.abs(mediaIndexDiff);
	
	        if (!this.discontinuities[discontinuity] || this.discontinuities[discontinuity].accuracy > accuracy) {
	          var time = void 0;
	
	          if (mediaIndexDiff < 0) {
	            time = segment.start - sumDurations({
	              defaultDuration: playlist.targetDuration,
	              durationList: playlist.segments,
	              startIndex: segmentInfo.mediaIndex,
	              endIndex: segmentIndex
	            });
	          } else {
	            time = segment.end + sumDurations({
	              defaultDuration: playlist.targetDuration,
	              durationList: playlist.segments,
	              startIndex: segmentInfo.mediaIndex + 1,
	              endIndex: segmentIndex
	            });
	          }
	
	          this.discontinuities[discontinuity] = {
	            time: time,
	            accuracy: accuracy
	          };
	        }
	      }
	    }
	  };
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.off();
	  };
	
	  return SyncController;
	}(videojs.EventTarget);
	/**
	 * The TimelineChangeController acts as a source for segment loaders to listen for and
	 * keep track of latest and pending timeline changes. This is useful to ensure proper
	 * sync, as each loader may need to make a consideration for what timeline the other
	 * loader is on before making changes which could impact the other loader's media.
	 *
	 * @class TimelineChangeController
	 * @extends videojs.EventTarget
	 */
	
	
	var TimelineChangeController = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](TimelineChangeController, _videojs$EventTarget);
	
	  function TimelineChangeController() {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this;
	    _this.pendingTimelineChanges_ = {};
	    _this.lastTimelineChanges_ = {};
	    return _this;
	  }
	
	  var _proto = TimelineChangeController.prototype;
	
	  _proto.clearPendingTimelineChange = function clearPendingTimelineChange(type) {
	    this.pendingTimelineChanges_[type] = null;
	    this.trigger('pendingtimelinechange');
	  };
	
	  _proto.pendingTimelineChange = function pendingTimelineChange(_ref) {
	    var type = _ref.type,
	        from = _ref.from,
	        to = _ref.to;
	
	    if (typeof from === 'number' && typeof to === 'number') {
	      this.pendingTimelineChanges_[type] = {
	        type: type,
	        from: from,
	        to: to
	      };
	      this.trigger('pendingtimelinechange');
	    }
	
	    return this.pendingTimelineChanges_[type];
	  };
	
	  _proto.lastTimelineChange = function lastTimelineChange(_ref2) {
	    var type = _ref2.type,
	        from = _ref2.from,
	        to = _ref2.to;
	
	    if (typeof from === 'number' && typeof to === 'number') {
	      this.lastTimelineChanges_[type] = {
	        type: type,
	        from: from,
	        to: to
	      };
	      delete this.pendingTimelineChanges_[type];
	      this.trigger('timelinechange');
	    }
	
	    return this.lastTimelineChanges_[type];
	  };
	
	  _proto.dispose = function dispose() {
	    this.trigger('dispose');
	    this.pendingTimelineChanges_ = {};
	    this.lastTimelineChanges_ = {};
	    this.off();
	  };
	
	  return TimelineChangeController;
	}(videojs.EventTarget);
	/* rollup-plugin-worker-factory start for worker!/Users/ddashkevich/projects/http-streaming/src/decrypter-worker.js */
	
	
	var workerCode = transform(getWorkerString(function () {
	  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	  function createCommonjsModule(fn, basedir, module) {
	    return module = {
	      path: basedir,
	      exports: {},
	      require: function require(path, base) {
	        return commonjsRequire(path, base === undefined || base === null ? module.path : base);
	      }
	    }, fn(module, module.exports), module.exports;
	  }
	
	  function commonjsRequire() {
	    throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	  }
	
	  var createClass = createCommonjsModule(function (module) {
	    function _defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    function _createClass(Constructor, protoProps, staticProps) {
	      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) _defineProperties(Constructor, staticProps);
	      return Constructor;
	    }
	
	    module.exports = _createClass;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  });
	  var setPrototypeOf = createCommonjsModule(function (module) {
	    function _setPrototypeOf(o, p) {
	      module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	        o.__proto__ = p;
	        return o;
	      };
	
	      module.exports["default"] = module.exports, module.exports.__esModule = true;
	      return _setPrototypeOf(o, p);
	    }
	
	    module.exports = _setPrototypeOf;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  });
	  var inheritsLoose = createCommonjsModule(function (module) {
	    function _inheritsLoose(subClass, superClass) {
	      subClass.prototype = Object.create(superClass.prototype);
	      subClass.prototype.constructor = subClass;
	      setPrototypeOf(subClass, superClass);
	    }
	
	    module.exports = _inheritsLoose;
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  });
	  /**
	   * @file stream.js
	   */
	
	  /**
	   * A lightweight readable stream implemention that handles event dispatching.
	   *
	   * @class Stream
	   */
	
	  var Stream = /*#__PURE__*/function () {
	    function Stream() {
	      this.listeners = {};
	    }
	    /**
	     * Add a listener for a specified event type.
	     *
	     * @param {string} type the event name
	     * @param {Function} listener the callback to be invoked when an event of
	     * the specified type occurs
	     */
	
	
	    var _proto = Stream.prototype;
	
	    _proto.on = function on(type, listener) {
	      if (!this.listeners[type]) {
	        this.listeners[type] = [];
	      }
	
	      this.listeners[type].push(listener);
	    }
	    /**
	     * Remove a listener for a specified event type.
	     *
	     * @param {string} type the event name
	     * @param {Function} listener  a function previously registered for this
	     * type of event through `on`
	     * @return {boolean} if we could turn it off or not
	     */
	    ;
	
	    _proto.off = function off(type, listener) {
	      if (!this.listeners[type]) {
	        return false;
	      }
	
	      var index = this.listeners[type].indexOf(listener); // TODO: which is better?
	      // In Video.js we slice listener functions
	      // on trigger so that it does not mess up the order
	      // while we loop through.
	      //
	      // Here we slice on off so that the loop in trigger
	      // can continue using it's old reference to loop without
	      // messing up the order.
	
	      this.listeners[type] = this.listeners[type].slice(0);
	      this.listeners[type].splice(index, 1);
	      return index > -1;
	    }
	    /**
	     * Trigger an event of the specified type on this stream. Any additional
	     * arguments to this function are passed as parameters to event listeners.
	     *
	     * @param {string} type the event name
	     */
	    ;
	
	    _proto.trigger = function trigger(type) {
	      var callbacks = this.listeners[type];
	
	      if (!callbacks) {
	        return;
	      } // Slicing the arguments on every invocation of this method
	      // can add a significant amount of overhead. Avoid the
	      // intermediate object creation for the common case of a
	      // single callback argument
	
	
	      if (arguments.length === 2) {
	        var length = callbacks.length;
	
	        for (var i = 0; i < length; ++i) {
	          callbacks[i].call(this, arguments[1]);
	        }
	      } else {
	        var args = Array.prototype.slice.call(arguments, 1);
	        var _length = callbacks.length;
	
	        for (var _i = 0; _i < _length; ++_i) {
	          callbacks[_i].apply(this, args);
	        }
	      }
	    }
	    /**
	     * Destroys the stream and cleans up.
	     */
	    ;
	
	    _proto.dispose = function dispose() {
	      this.listeners = {};
	    }
	    /**
	     * Forwards all `data` events on this stream to the destination stream. The
	     * destination stream should provide a method `push` to receive the data
	     * events as they arrive.
	     *
	     * @param {Stream} destination the stream that will receive all `data` events
	     * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	     */
	    ;
	
	    _proto.pipe = function pipe(destination) {
	      this.on('data', function (data) {
	        destination.push(data);
	      });
	    };
	
	    return Stream;
	  }();
	  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
	
	  /**
	   * Returns the subarray of a Uint8Array without PKCS#7 padding.
	   *
	   * @param padded {Uint8Array} unencrypted bytes that have been padded
	   * @return {Uint8Array} the unpadded bytes
	   * @see http://tools.ietf.org/html/rfc5652
	   */
	
	
	  function unpad(padded) {
	    return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
	  }
	  /*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */
	
	  /**
	   * @file aes.js
	   *
	   * This file contains an adaptation of the AES decryption algorithm
	   * from the Standford Javascript Cryptography Library. That work is
	   * covered by the following copyright and permissions notice:
	   *
	   * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
	   * All rights reserved.
	   *
	   * Redistribution and use in source and binary forms, with or without
	   * modification, are permitted provided that the following conditions are
	   * met:
	   *
	   * 1. Redistributions of source code must retain the above copyright
	   *    notice, this list of conditions and the following disclaimer.
	   *
	   * 2. Redistributions in binary form must reproduce the above
	   *    copyright notice, this list of conditions and the following
	   *    disclaimer in the documentation and/or other materials provided
	   *    with the distribution.
	   *
	   * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
	   * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	   * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	   * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
	   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
	   * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	   * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
	   * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
	   * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	   *
	   * The views and conclusions contained in the software and documentation
	   * are those of the authors and should not be interpreted as representing
	   * official policies, either expressed or implied, of the authors.
	   */
	
	  /**
	   * Expand the S-box tables.
	   *
	   * @private
	   */
	
	
	  var precompute = function precompute() {
	    var tables = [[[], [], [], [], []], [[], [], [], [], []]];
	    var encTable = tables[0];
	    var decTable = tables[1];
	    var sbox = encTable[4];
	    var sboxInv = decTable[4];
	    var i;
	    var x;
	    var xInv;
	    var d = [];
	    var th = [];
	    var x2;
	    var x4;
	    var x8;
	    var s;
	    var tEnc;
	    var tDec; // Compute double and third tables
	
	    for (i = 0; i < 256; i++) {
	      th[(d[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
	    }
	
	    for (x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th[xInv] || 1) {
	      // Compute sbox
	      s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
	      s = s >> 8 ^ s & 255 ^ 99;
	      sbox[x] = s;
	      sboxInv[s] = x; // Compute MixColumns
	
	      x8 = d[x4 = d[x2 = d[x]]];
	      tDec = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	      tEnc = d[s] * 0x101 ^ s * 0x1010100;
	
	      for (i = 0; i < 4; i++) {
	        encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
	        decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
	      }
	    } // Compactify. Considerable speedup on Firefox.
	
	
	    for (i = 0; i < 5; i++) {
	      encTable[i] = encTable[i].slice(0);
	      decTable[i] = decTable[i].slice(0);
	    }
	
	    return tables;
	  };
	
	  var aesTables = null;
	  /**
	   * Schedule out an AES key for both encryption and decryption. This
	   * is a low-level class. Use a cipher mode to do bulk encryption.
	   *
	   * @class AES
	   * @param key {Array} The key as an array of 4, 6 or 8 words.
	   */
	
	  var AES = /*#__PURE__*/function () {
	    function AES(key) {
	      /**
	      * The expanded S-box and inverse S-box tables. These will be computed
	      * on the client so that we don't have to send them down the wire.
	      *
	      * There are two tables, _tables[0] is for encryption and
	      * _tables[1] is for decryption.
	      *
	      * The first 4 sub-tables are the expanded S-box with MixColumns. The
	      * last (_tables[01][4]) is the S-box itself.
	      *
	      * @private
	      */
	      // if we have yet to precompute the S-box tables
	      // do so now
	      if (!aesTables) {
	        aesTables = precompute();
	      } // then make a copy of that object for use
	
	
	      this._tables = [[aesTables[0][0].slice(), aesTables[0][1].slice(), aesTables[0][2].slice(), aesTables[0][3].slice(), aesTables[0][4].slice()], [aesTables[1][0].slice(), aesTables[1][1].slice(), aesTables[1][2].slice(), aesTables[1][3].slice(), aesTables[1][4].slice()]];
	      var i;
	      var j;
	      var tmp;
	      var sbox = this._tables[0][4];
	      var decTable = this._tables[1];
	      var keyLen = key.length;
	      var rcon = 1;
	
	      if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) {
	        throw new Error('Invalid aes key size');
	      }
	
	      var encKey = key.slice(0);
	      var decKey = [];
	      this._key = [encKey, decKey]; // schedule encryption keys
	
	      for (i = keyLen; i < 4 * keyLen + 28; i++) {
	        tmp = encKey[i - 1]; // apply sbox
	
	        if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
	          tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255]; // shift rows and add rcon
	
	          if (i % keyLen === 0) {
	            tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
	            rcon = rcon << 1 ^ (rcon >> 7) * 283;
	          }
	        }
	
	        encKey[i] = encKey[i - keyLen] ^ tmp;
	      } // schedule decryption keys
	
	
	      for (j = 0; i; j++, i--) {
	        tmp = encKey[j & 3 ? i : i - 4];
	
	        if (i <= 4 || j < 4) {
	          decKey[j] = tmp;
	        } else {
	          decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
	        }
	      }
	    }
	    /**
	     * Decrypt 16 bytes, specified as four 32-bit words.
	     *
	     * @param {number} encrypted0 the first word to decrypt
	     * @param {number} encrypted1 the second word to decrypt
	     * @param {number} encrypted2 the third word to decrypt
	     * @param {number} encrypted3 the fourth word to decrypt
	     * @param {Int32Array} out the array to write the decrypted words
	     * into
	     * @param {number} offset the offset into the output array to start
	     * writing results
	     * @return {Array} The plaintext.
	     */
	
	
	    var _proto = AES.prototype;
	
	    _proto.decrypt = function decrypt(encrypted0, encrypted1, encrypted2, encrypted3, out, offset) {
	      var key = this._key[1]; // state variables a,b,c,d are loaded with pre-whitened data
	
	      var a = encrypted0 ^ key[0];
	      var b = encrypted3 ^ key[1];
	      var c = encrypted2 ^ key[2];
	      var d = encrypted1 ^ key[3];
	      var a2;
	      var b2;
	      var c2; // key.length === 2 ?
	
	      var nInnerRounds = key.length / 4 - 2;
	      var i;
	      var kIndex = 4;
	      var table = this._tables[1]; // load up the tables
	
	      var table0 = table[0];
	      var table1 = table[1];
	      var table2 = table[2];
	      var table3 = table[3];
	      var sbox = table[4]; // Inner rounds. Cribbed from OpenSSL.
	
	      for (i = 0; i < nInnerRounds; i++) {
	        a2 = table0[a >>> 24] ^ table1[b >> 16 & 255] ^ table2[c >> 8 & 255] ^ table3[d & 255] ^ key[kIndex];
	        b2 = table0[b >>> 24] ^ table1[c >> 16 & 255] ^ table2[d >> 8 & 255] ^ table3[a & 255] ^ key[kIndex + 1];
	        c2 = table0[c >>> 24] ^ table1[d >> 16 & 255] ^ table2[a >> 8 & 255] ^ table3[b & 255] ^ key[kIndex + 2];
	        d = table0[d >>> 24] ^ table1[a >> 16 & 255] ^ table2[b >> 8 & 255] ^ table3[c & 255] ^ key[kIndex + 3];
	        kIndex += 4;
	        a = a2;
	        b = b2;
	        c = c2;
	      } // Last round.
	
	
	      for (i = 0; i < 4; i++) {
	        out[(3 & -i) + offset] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d & 255] ^ key[kIndex++];
	        a2 = a;
	        a = b;
	        b = c;
	        c = d;
	        d = a2;
	      }
	    };
	
	    return AES;
	  }();
	  /**
	   * A wrapper around the Stream class to use setTimeout
	   * and run stream "jobs" Asynchronously
	   *
	   * @class AsyncStream
	   * @extends Stream
	   */
	
	
	  var AsyncStream = /*#__PURE__*/function (_Stream) {
	    inheritsLoose(AsyncStream, _Stream);
	
	    function AsyncStream() {
	      var _this;
	
	      _this = _Stream.call(this, Stream) || this;
	      _this.jobs = [];
	      _this.delay = 1;
	      _this.timeout_ = null;
	      return _this;
	    }
	    /**
	     * process an async job
	     *
	     * @private
	     */
	
	
	    var _proto = AsyncStream.prototype;
	
	    _proto.processJob_ = function processJob_() {
	      this.jobs.shift()();
	
	      if (this.jobs.length) {
	        this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	      } else {
	        this.timeout_ = null;
	      }
	    }
	    /**
	     * push a job into the stream
	     *
	     * @param {Function} job the job to push into the stream
	     */
	    ;
	
	    _proto.push = function push(job) {
	      this.jobs.push(job);
	
	      if (!this.timeout_) {
	        this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
	      }
	    };
	
	    return AsyncStream;
	  }(Stream);
	  /**
	   * Convert network-order (big-endian) bytes into their little-endian
	   * representation.
	   */
	
	
	  var ntoh = function ntoh(word) {
	    return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
	  };
	  /**
	   * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
	   *
	   * @param {Uint8Array} encrypted the encrypted bytes
	   * @param {Uint32Array} key the bytes of the decryption key
	   * @param {Uint32Array} initVector the initialization vector (IV) to
	   * use for the first round of CBC.
	   * @return {Uint8Array} the decrypted bytes
	   *
	   * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
	   * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
	   * @see https://tools.ietf.org/html/rfc2315
	   */
	
	
	  var decrypt = function decrypt(encrypted, key, initVector) {
	    // word-level access to the encrypted bytes
	    var encrypted32 = new Int32Array(encrypted.buffer, encrypted.byteOffset, encrypted.byteLength >> 2);
	    var decipher = new AES(Array.prototype.slice.call(key)); // byte and word-level access for the decrypted output
	
	    var decrypted = new Uint8Array(encrypted.byteLength);
	    var decrypted32 = new Int32Array(decrypted.buffer); // temporary variables for working with the IV, encrypted, and
	    // decrypted data
	
	    var init0;
	    var init1;
	    var init2;
	    var init3;
	    var encrypted0;
	    var encrypted1;
	    var encrypted2;
	    var encrypted3; // iteration variable
	
	    var wordIx; // pull out the words of the IV to ensure we don't modify the
	    // passed-in reference and easier access
	
	    init0 = initVector[0];
	    init1 = initVector[1];
	    init2 = initVector[2];
	    init3 = initVector[3]; // decrypt four word sequences, applying cipher-block chaining (CBC)
	    // to each decrypted block
	
	    for (wordIx = 0; wordIx < encrypted32.length; wordIx += 4) {
	      // convert big-endian (network order) words into little-endian
	      // (javascript order)
	      encrypted0 = ntoh(encrypted32[wordIx]);
	      encrypted1 = ntoh(encrypted32[wordIx + 1]);
	      encrypted2 = ntoh(encrypted32[wordIx + 2]);
	      encrypted3 = ntoh(encrypted32[wordIx + 3]); // decrypt the block
	
	      decipher.decrypt(encrypted0, encrypted1, encrypted2, encrypted3, decrypted32, wordIx); // XOR with the IV, and restore network byte-order to obtain the
	      // plaintext
	
	      decrypted32[wordIx] = ntoh(decrypted32[wordIx] ^ init0);
	      decrypted32[wordIx + 1] = ntoh(decrypted32[wordIx + 1] ^ init1);
	      decrypted32[wordIx + 2] = ntoh(decrypted32[wordIx + 2] ^ init2);
	      decrypted32[wordIx + 3] = ntoh(decrypted32[wordIx + 3] ^ init3); // setup the IV for the next round
	
	      init0 = encrypted0;
	      init1 = encrypted1;
	      init2 = encrypted2;
	      init3 = encrypted3;
	    }
	
	    return decrypted;
	  };
	  /**
	   * The `Decrypter` class that manages decryption of AES
	   * data through `AsyncStream` objects and the `decrypt`
	   * function
	   *
	   * @param {Uint8Array} encrypted the encrypted bytes
	   * @param {Uint32Array} key the bytes of the decryption key
	   * @param {Uint32Array} initVector the initialization vector (IV) to
	   * @param {Function} done the function to run when done
	   * @class Decrypter
	   */
	
	
	  var Decrypter = /*#__PURE__*/function () {
	    function Decrypter(encrypted, key, initVector, done) {
	      var step = Decrypter.STEP;
	      var encrypted32 = new Int32Array(encrypted.buffer);
	      var decrypted = new Uint8Array(encrypted.byteLength);
	      var i = 0;
	      this.asyncStream_ = new AsyncStream(); // split up the encryption job and do the individual chunks asynchronously
	
	      this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	
	      for (i = step; i < encrypted32.length; i += step) {
	        initVector = new Uint32Array([ntoh(encrypted32[i - 4]), ntoh(encrypted32[i - 3]), ntoh(encrypted32[i - 2]), ntoh(encrypted32[i - 1])]);
	        this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
	      } // invoke the done() callback when everything is finished
	
	
	      this.asyncStream_.push(function () {
	        // remove pkcs#7 padding from the decrypted bytes
	        done(null, unpad(decrypted));
	      });
	    }
	    /**
	     * a getter for step the maximum number of bytes to process at one time
	     *
	     * @return {number} the value of step 32000
	     */
	
	
	    var _proto = Decrypter.prototype;
	    /**
	     * @private
	     */
	
	    _proto.decryptChunk_ = function decryptChunk_(encrypted, key, initVector, decrypted) {
	      return function () {
	        var bytes = decrypt(encrypted, key, initVector);
	        decrypted.set(bytes, encrypted.byteOffset);
	      };
	    };
	
	    createClass(Decrypter, null, [{
	      key: "STEP",
	      get: function get() {
	        // 4 * 8000;
	        return 32000;
	      }
	    }]);
	    return Decrypter;
	  }();
	
	  var win;
	
	  if (typeof window !== "undefined") {
	    win = window;
	  } else if (typeof commonjsGlobal !== "undefined") {
	    win = commonjsGlobal;
	  } else if (typeof self !== "undefined") {
	    win = self;
	  } else {
	    win = {};
	  }
	
	  var window_1 = win;
	
	  var isArrayBufferView = function isArrayBufferView(obj) {
	    if (ArrayBuffer.isView === 'function') {
	      return ArrayBuffer.isView(obj);
	    }
	
	    return obj && obj.buffer instanceof ArrayBuffer;
	  };
	
	  var BigInt = window_1.BigInt || Number;
	  [BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000')];
	  /**
	   * Creates an object for sending to a web worker modifying properties that are TypedArrays
	   * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
	   *
	   * @param {Object} message
	   *        Object of properties and values to send to the web worker
	   * @return {Object}
	   *         Modified message with TypedArray values expanded
	   * @function createTransferableMessage
	   */
	
	
	  var createTransferableMessage = function createTransferableMessage(message) {
	    var transferable = {};
	    Object.keys(message).forEach(function (key) {
	      var value = message[key];
	
	      if (isArrayBufferView(value)) {
	        transferable[key] = {
	          bytes: value.buffer,
	          byteOffset: value.byteOffset,
	          byteLength: value.byteLength
	        };
	      } else {
	        transferable[key] = value;
	      }
	    });
	    return transferable;
	  };
	  /* global self */
	
	  /**
	   * Our web worker interface so that things can talk to aes-decrypter
	   * that will be running in a web worker. the scope is passed to this by
	   * webworkify.
	   */
	
	
	  self.onmessage = function (event) {
	    var data = event.data;
	    var encrypted = new Uint8Array(data.encrypted.bytes, data.encrypted.byteOffset, data.encrypted.byteLength);
	    var key = new Uint32Array(data.key.bytes, data.key.byteOffset, data.key.byteLength / 4);
	    var iv = new Uint32Array(data.iv.bytes, data.iv.byteOffset, data.iv.byteLength / 4);
	    /* eslint-disable no-new, handle-callback-err */
	
	    new Decrypter(encrypted, key, iv, function (err, bytes) {
	      self.postMessage(createTransferableMessage({
	        source: data.source,
	        decrypted: bytes
	      }), [bytes.buffer]);
	    });
	    /* eslint-enable */
	  };
	}));
	var Decrypter = factory(workerCode);
	/* rollup-plugin-worker-factory end for worker!/Users/ddashkevich/projects/http-streaming/src/decrypter-worker.js */
	
	/**
	 * Convert the properties of an HLS track into an audioTrackKind.
	 *
	 * @private
	 */
	
	var audioTrackKind_ = function audioTrackKind_(properties) {
	  var kind = properties["default"] ? 'main' : 'alternative';
	
	  if (properties.characteristics && properties.characteristics.indexOf('public.accessibility.describes-video') >= 0) {
	    kind = 'main-desc';
	  }
	
	  return kind;
	};
	/**
	 * Pause provided segment loader and playlist loader if active
	 *
	 * @param {SegmentLoader} segmentLoader
	 *        SegmentLoader to pause
	 * @param {Object} mediaType
	 *        Active media type
	 * @function stopLoaders
	 */
	
	
	var stopLoaders = function stopLoaders(segmentLoader, mediaType) {
	  segmentLoader.abort();
	  segmentLoader.pause();
	
	  if (mediaType && mediaType.activePlaylistLoader) {
	    mediaType.activePlaylistLoader.pause();
	    mediaType.activePlaylistLoader = null;
	  }
	};
	/**
	 * Start loading provided segment loader and playlist loader
	 *
	 * @param {PlaylistLoader} playlistLoader
	 *        PlaylistLoader to start loading
	 * @param {Object} mediaType
	 *        Active media type
	 * @function startLoaders
	 */
	
	
	var startLoaders = function startLoaders(playlistLoader, mediaType) {
	  // Segment loader will be started after `loadedmetadata` or `loadedplaylist` from the
	  // playlist loader
	  mediaType.activePlaylistLoader = playlistLoader;
	  playlistLoader.load();
	};
	/**
	 * Returns a function to be called when the media group changes. It performs a
	 * non-destructive (preserve the buffer) resync of the SegmentLoader. This is because a
	 * change of group is merely a rendition switch of the same content at another encoding,
	 * rather than a change of content, such as switching audio from English to Spanish.
	 *
	 * @param {string} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Handler for a non-destructive resync of SegmentLoader when the active media
	 *         group changes.
	 * @function onGroupChanged
	 */
	
	
	var onGroupChanged = function onGroupChanged(type, settings) {
	  return function () {
	    var _settings$segmentLoad = settings.segmentLoaders,
	        segmentLoader = _settings$segmentLoad[type],
	        mainSegmentLoader = _settings$segmentLoad.main,
	        mediaType = settings.mediaTypes[type];
	    var activeTrack = mediaType.activeTrack();
	    var activeGroup = mediaType.getActiveGroup();
	    var previousActiveLoader = mediaType.activePlaylistLoader;
	    var lastGroup = mediaType.lastGroup_; // the group did not change do nothing
	
	    if (activeGroup && lastGroup && activeGroup.id === lastGroup.id) {
	      return;
	    }
	
	    mediaType.lastGroup_ = activeGroup;
	    mediaType.lastTrack_ = activeTrack;
	    stopLoaders(segmentLoader, mediaType);
	
	    if (!activeGroup || activeGroup.isMasterPlaylist) {
	      // there is no group active or active group is a main playlist and won't change
	      return;
	    }
	
	    if (!activeGroup.playlistLoader) {
	      if (previousActiveLoader) {
	        // The previous group had a playlist loader but the new active group does not
	        // this means we are switching from demuxed to muxed audio. In this case we want to
	        // do a destructive reset of the main segment loader and not restart the audio
	        // loaders.
	        mainSegmentLoader.resetEverything();
	      }
	
	      return;
	    } // Non-destructive resync
	
	
	    segmentLoader.resyncLoader();
	    startLoaders(activeGroup.playlistLoader, mediaType);
	  };
	};
	
	var onGroupChanging = function onGroupChanging(type, settings) {
	  return function () {
	    var segmentLoader = settings.segmentLoaders[type],
	        mediaType = settings.mediaTypes[type];
	    mediaType.lastGroup_ = null;
	    segmentLoader.abort();
	    segmentLoader.pause();
	  };
	};
	/**
	 * Returns a function to be called when the media track changes. It performs a
	 * destructive reset of the SegmentLoader to ensure we start loading as close to
	 * currentTime as possible.
	 *
	 * @param {string} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Handler for a destructive reset of SegmentLoader when the active media
	 *         track changes.
	 * @function onTrackChanged
	 */
	
	
	var onTrackChanged = function onTrackChanged(type, settings) {
	  return function () {
	    var masterPlaylistLoader = settings.masterPlaylistLoader,
	        _settings$segmentLoad2 = settings.segmentLoaders,
	        segmentLoader = _settings$segmentLoad2[type],
	        mainSegmentLoader = _settings$segmentLoad2.main,
	        mediaType = settings.mediaTypes[type];
	    var activeTrack = mediaType.activeTrack();
	    var activeGroup = mediaType.getActiveGroup();
	    var previousActiveLoader = mediaType.activePlaylistLoader;
	    var lastTrack = mediaType.lastTrack_; // track did not change, do nothing
	
	    if (lastTrack && activeTrack && lastTrack.id === activeTrack.id) {
	      return;
	    }
	
	    mediaType.lastGroup_ = activeGroup;
	    mediaType.lastTrack_ = activeTrack;
	    stopLoaders(segmentLoader, mediaType);
	
	    if (!activeGroup) {
	      // there is no group active so we do not want to restart loaders
	      return;
	    }
	
	    if (activeGroup.isMasterPlaylist) {
	      // track did not change, do nothing
	      if (!activeTrack || !lastTrack || activeTrack.id === lastTrack.id) {
	        return;
	      }
	
	      var mpc = settings.vhs.masterPlaylistController_;
	      var newPlaylist = mpc.selectPlaylist(); // media will not change do nothing
	
	      if (mpc.media() === newPlaylist) {
	        return;
	      }
	
	      mediaType.logger_("track change. Switching master audio from " + lastTrack.id + " to " + activeTrack.id);
	      masterPlaylistLoader.pause();
	      mainSegmentLoader.resetEverything();
	      mpc.fastQualityChange_(newPlaylist);
	      return;
	    }
	
	    if (type === 'AUDIO') {
	      if (!activeGroup.playlistLoader) {
	        // when switching from demuxed audio/video to muxed audio/video (noted by no
	        // playlist loader for the audio group), we want to do a destructive reset of the
	        // main segment loader and not restart the audio loaders
	        mainSegmentLoader.setAudio(true); // don't have to worry about disabling the audio of the audio segment loader since
	        // it should be stopped
	
	        mainSegmentLoader.resetEverything();
	        return;
	      } // although the segment loader is an audio segment loader, call the setAudio
	      // function to ensure it is prepared to re-append the init segment (or handle other
	      // config changes)
	
	
	      segmentLoader.setAudio(true);
	      mainSegmentLoader.setAudio(false);
	    }
	
	    if (previousActiveLoader === activeGroup.playlistLoader) {
	      // Nothing has actually changed. This can happen because track change events can fire
	      // multiple times for a "single" change. One for enabling the new active track, and
	      // one for disabling the track that was active
	      startLoaders(activeGroup.playlistLoader, mediaType);
	      return;
	    }
	
	    if (segmentLoader.track) {
	      // For WebVTT, set the new text track in the segmentloader
	      segmentLoader.track(activeTrack);
	    } // destructive reset
	
	
	    segmentLoader.resetEverything();
	    startLoaders(activeGroup.playlistLoader, mediaType);
	  };
	};
	
	var onError = {
	  /**
	   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
	   * an error.
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Error handler. Logs warning (or error if the playlist is blacklisted) to
	   *         console and switches back to default audio track.
	   * @function onError.AUDIO
	   */
	  AUDIO: function AUDIO(type, settings) {
	    return function () {
	      var segmentLoader = settings.segmentLoaders[type],
	          mediaType = settings.mediaTypes[type],
	          blacklistCurrentPlaylist = settings.blacklistCurrentPlaylist;
	      stopLoaders(segmentLoader, mediaType); // switch back to default audio track
	
	      var activeTrack = mediaType.activeTrack();
	      var activeGroup = mediaType.activeGroup();
	      var id = (activeGroup.filter(function (group) {
	        return group["default"];
	      })[0] || activeGroup[0]).id;
	      var defaultTrack = mediaType.tracks[id];
	
	      if (activeTrack === defaultTrack) {
	        // Default track encountered an error. All we can do now is blacklist the current
	        // rendition and hope another will switch audio groups
	        blacklistCurrentPlaylist({
	          message: 'Problem encountered loading the default audio track.'
	        });
	        return;
	      }
	
	      videojs.log.warn('Problem encountered loading the alternate audio track.' + 'Switching back to default.');
	
	      for (var trackId in mediaType.tracks) {
	        mediaType.tracks[trackId].enabled = mediaType.tracks[trackId] === defaultTrack;
	      }
	
	      mediaType.onTrackChanged();
	    };
	  },
	
	  /**
	   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
	   * an error.
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Error handler. Logs warning to console and disables the active subtitle track
	   * @function onError.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, settings) {
	    return function () {
	      var segmentLoader = settings.segmentLoaders[type],
	          mediaType = settings.mediaTypes[type];
	      videojs.log.warn('Problem encountered loading the subtitle track.' + 'Disabling subtitle track.');
	      stopLoaders(segmentLoader, mediaType);
	      var track = mediaType.activeTrack();
	
	      if (track) {
	        track.mode = 'disabled';
	      }
	
	      mediaType.onTrackChanged();
	    };
	  }
	};
	var setupListeners = {
	  /**
	   * Setup event listeners for audio playlist loader
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {PlaylistLoader|null} playlistLoader
	   *        PlaylistLoader to register listeners on
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function setupListeners.AUDIO
	   */
	  AUDIO: function AUDIO(type, playlistLoader, settings) {
	    if (!playlistLoader) {
	      // no playlist loader means audio will be muxed with the video
	      return;
	    }
	
	    var tech = settings.tech,
	        requestOptions = settings.requestOptions,
	        segmentLoader = settings.segmentLoaders[type];
	    playlistLoader.on('loadedmetadata', function () {
	      var media = playlistLoader.media();
	      segmentLoader.playlist(media, requestOptions); // if the video is already playing, or if this isn't a live video and preload
	      // permits, start downloading segments
	
	      if (!tech.paused() || media.endList && tech.preload() !== 'none') {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('loadedplaylist', function () {
	      segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
	
	      if (!tech.paused()) {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('error', onError[type](type, settings));
	  },
	
	  /**
	   * Setup event listeners for subtitle playlist loader
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {PlaylistLoader|null} playlistLoader
	   *        PlaylistLoader to register listeners on
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function setupListeners.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, playlistLoader, settings) {
	    var tech = settings.tech,
	        requestOptions = settings.requestOptions,
	        segmentLoader = settings.segmentLoaders[type],
	        mediaType = settings.mediaTypes[type];
	    playlistLoader.on('loadedmetadata', function () {
	      var media = playlistLoader.media();
	      segmentLoader.playlist(media, requestOptions);
	      segmentLoader.track(mediaType.activeTrack()); // if the video is already playing, or if this isn't a live video and preload
	      // permits, start downloading segments
	
	      if (!tech.paused() || media.endList && tech.preload() !== 'none') {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('loadedplaylist', function () {
	      segmentLoader.playlist(playlistLoader.media(), requestOptions); // If the player isn't paused, ensure that the segment loader is running
	
	      if (!tech.paused()) {
	        segmentLoader.load();
	      }
	    });
	    playlistLoader.on('error', onError[type](type, settings));
	  }
	};
	var initialize = {
	  /**
	   * Setup PlaylistLoaders and AudioTracks for the audio groups
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize.AUDIO
	   */
	  'AUDIO': function AUDIO(type, settings) {
	    var vhs = settings.vhs,
	        sourceType = settings.sourceType,
	        segmentLoader = settings.segmentLoaders[type],
	        requestOptions = settings.requestOptions,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$ = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$.groups,
	        tracks = _settings$mediaTypes$.tracks,
	        logger_ = _settings$mediaTypes$.logger_,
	        masterPlaylistLoader = settings.masterPlaylistLoader;
	    var audioOnlyMaster = isAudioOnly(masterPlaylistLoader.master); // force a default if we have none
	
	    if (!mediaGroups[type] || Object.keys(mediaGroups[type]).length === 0) {
	      mediaGroups[type] = {
	        main: {
	          "default": {
	            "default": true
	          }
	        }
	      };
	
	      if (audioOnlyMaster) {
	        mediaGroups[type].main["default"].playlists = masterPlaylistLoader.master.playlists;
	      }
	    }
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        var properties = mediaGroups[type][groupId][variantLabel];
	        var playlistLoader = void 0;
	
	        if (audioOnlyMaster) {
	          logger_("AUDIO group '" + groupId + "' label '" + variantLabel + "' is a master playlist");
	          properties.isMasterPlaylist = true;
	          playlistLoader = null; // if vhs-json was provided as the source, and the media playlist was resolved,
	          // use the resolved media playlist object
	        } else if (sourceType === 'vhs-json' && properties.playlists) {
	          playlistLoader = new PlaylistLoader(properties.playlists[0], vhs, requestOptions);
	        } else if (properties.resolvedUri) {
	          playlistLoader = new PlaylistLoader(properties.resolvedUri, vhs, requestOptions); // TODO: dash isn't the only type with properties.playlists
	          // should we even have properties.playlists in this check.
	        } else if (properties.playlists && sourceType === 'dash') {
	          playlistLoader = new DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, masterPlaylistLoader);
	        } else {
	          // no resolvedUri means the audio is muxed with the video when using this
	          // audio track
	          playlistLoader = null;
	        }
	
	        properties = videojs.mergeOptions({
	          id: variantLabel,
	          playlistLoader: playlistLoader
	        }, properties);
	        setupListeners[type](type, properties.playlistLoader, settings);
	        groups[groupId].push(properties);
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = new videojs.AudioTrack({
	            id: variantLabel,
	            kind: audioTrackKind_(properties),
	            enabled: false,
	            language: properties.language,
	            "default": properties["default"],
	            label: variantLabel
	          });
	          tracks[variantLabel] = track;
	        }
	      }
	    } // setup single error event handler for the segment loader
	
	
	    segmentLoader.on('error', onError[type](type, settings));
	  },
	
	  /**
	   * Setup PlaylistLoaders and TextTracks for the subtitle groups
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize.SUBTITLES
	   */
	  'SUBTITLES': function SUBTITLES(type, settings) {
	    var tech = settings.tech,
	        vhs = settings.vhs,
	        sourceType = settings.sourceType,
	        segmentLoader = settings.segmentLoaders[type],
	        requestOptions = settings.requestOptions,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$2 = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$2.groups,
	        tracks = _settings$mediaTypes$2.tracks,
	        masterPlaylistLoader = settings.masterPlaylistLoader;
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        if (mediaGroups[type][groupId][variantLabel].forced) {
	          // Subtitle playlists with the forced attribute are not selectable in Safari.
	          // According to Apple's HLS Authoring Specification:
	          //   If content has forced subtitles and regular subtitles in a given language,
	          //   the regular subtitles track in that language MUST contain both the forced
	          //   subtitles and the regular subtitles for that language.
	          // Because of this requirement and that Safari does not add forced subtitles,
	          // forced subtitles are skipped here to maintain consistent experience across
	          // all platforms
	          continue;
	        }
	
	        var properties = mediaGroups[type][groupId][variantLabel];
	        var playlistLoader = void 0;
	
	        if (sourceType === 'hls') {
	          playlistLoader = new PlaylistLoader(properties.resolvedUri, vhs, requestOptions);
	        } else if (sourceType === 'dash') {
	          var playlists = properties.playlists.filter(function (p) {
	            return p.excludeUntil !== Infinity;
	          });
	
	          if (!playlists.length) {
	            return;
	          }
	
	          playlistLoader = new DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, masterPlaylistLoader);
	        } else if (sourceType === 'vhs-json') {
	          playlistLoader = new PlaylistLoader( // if the vhs-json object included the media playlist, use the media playlist
	          // as provided, otherwise use the resolved URI to load the playlist
	          properties.playlists ? properties.playlists[0] : properties.resolvedUri, vhs, requestOptions);
	        }
	
	        properties = videojs.mergeOptions({
	          id: variantLabel,
	          playlistLoader: playlistLoader
	        }, properties);
	        setupListeners[type](type, properties.playlistLoader, settings);
	        groups[groupId].push(properties);
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = tech.addRemoteTextTrack({
	            id: variantLabel,
	            kind: 'subtitles',
	            "default": properties["default"] && properties.autoselect,
	            language: properties.language,
	            label: variantLabel
	          }, false).track;
	          tracks[variantLabel] = track;
	        }
	      }
	    } // setup single error event handler for the segment loader
	
	
	    segmentLoader.on('error', onError[type](type, settings));
	  },
	
	  /**
	   * Setup TextTracks for the closed-caption groups
	   *
	   * @param {String} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @function initialize['CLOSED-CAPTIONS']
	   */
	  'CLOSED-CAPTIONS': function CLOSEDCAPTIONS(type, settings) {
	    var tech = settings.tech,
	        mediaGroups = settings.master.mediaGroups,
	        _settings$mediaTypes$3 = settings.mediaTypes[type],
	        groups = _settings$mediaTypes$3.groups,
	        tracks = _settings$mediaTypes$3.tracks;
	
	    for (var groupId in mediaGroups[type]) {
	      if (!groups[groupId]) {
	        groups[groupId] = [];
	      }
	
	      for (var variantLabel in mediaGroups[type][groupId]) {
	        var properties = mediaGroups[type][groupId][variantLabel]; // Look for either 608 (CCn) or 708 (SERVICEn) caption services
	
	        if (!/^(?:CC|SERVICE)/.test(properties.instreamId)) {
	          continue;
	        }
	
	        var captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
	        var newProps = {
	          label: variantLabel,
	          language: properties.language,
	          instreamId: properties.instreamId,
	          "default": properties["default"] && properties.autoselect
	        };
	
	        if (captionServices[newProps.instreamId]) {
	          newProps = videojs.mergeOptions(newProps, captionServices[newProps.instreamId]);
	        }
	
	        if (newProps["default"] === undefined) {
	          delete newProps["default"];
	        } // No PlaylistLoader is required for Closed-Captions because the captions are
	        // embedded within the video stream
	
	
	        groups[groupId].push(videojs.mergeOptions({
	          id: variantLabel
	        }, properties));
	
	        if (typeof tracks[variantLabel] === 'undefined') {
	          var track = tech.addRemoteTextTrack({
	            id: newProps.instreamId,
	            kind: 'captions',
	            "default": newProps["default"],
	            language: newProps.language,
	            label: newProps.label
	          }, false).track;
	          tracks[variantLabel] = track;
	        }
	      }
	    }
	  }
	};
	
	var groupMatch = function groupMatch(list, media) {
	  for (var i = 0; i < list.length; i++) {
	    if (playlistMatch(media, list[i])) {
	      return true;
	    }
	
	    if (list[i].playlists && groupMatch(list[i].playlists, media)) {
	      return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * Returns a function used to get the active group of the provided type
	 *
	 * @param {string} type
	 *        MediaGroup type
	 * @param {Object} settings
	 *        Object containing required information for media groups
	 * @return {Function}
	 *         Function that returns the active media group for the provided type. Takes an
	 *         optional parameter {TextTrack} track. If no track is provided, a list of all
	 *         variants in the group, otherwise the variant corresponding to the provided
	 *         track is returned.
	 * @function activeGroup
	 */
	
	
	var activeGroup = function activeGroup(type, settings) {
	  return function (track) {
	    var masterPlaylistLoader = settings.masterPlaylistLoader,
	        groups = settings.mediaTypes[type].groups;
	    var media = masterPlaylistLoader.media();
	
	    if (!media) {
	      return null;
	    }
	
	    var variants = null; // set to variants to main media active group
	
	    if (media.attributes[type]) {
	      variants = groups[media.attributes[type]];
	    }
	
	    var groupKeys = Object.keys(groups);
	
	    if (!variants) {
	      // find the masterPlaylistLoader media
	      // that is in a media group if we are dealing
	      // with audio only
	      if (type === 'AUDIO' && groupKeys.length > 1 && isAudioOnly(settings.master)) {
	        for (var i = 0; i < groupKeys.length; i++) {
	          var groupPropertyList = groups[groupKeys[i]];
	
	          if (groupMatch(groupPropertyList, media)) {
	            variants = groupPropertyList;
	            break;
	          }
	        } // use the main group if it exists
	
	      } else if (groups.main) {
	        variants = groups.main; // only one group, use that one
	      } else if (groupKeys.length === 1) {
	        variants = groups[groupKeys[0]];
	      }
	    }
	
	    if (typeof track === 'undefined') {
	      return variants;
	    }
	
	    if (track === null || !variants) {
	      // An active track was specified so a corresponding group is expected. track === null
	      // means no track is currently active so there is no corresponding group
	      return null;
	    }
	
	    return variants.filter(function (props) {
	      return props.id === track.id;
	    })[0] || null;
	  };
	};
	
	var activeTrack = {
	  /**
	   * Returns a function used to get the active track of type provided
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Function that returns the active media track for the provided type. Returns
	   *         null if no track is active
	   * @function activeTrack.AUDIO
	   */
	  AUDIO: function AUDIO(type, settings) {
	    return function () {
	      var tracks = settings.mediaTypes[type].tracks;
	
	      for (var id in tracks) {
	        if (tracks[id].enabled) {
	          return tracks[id];
	        }
	      }
	
	      return null;
	    };
	  },
	
	  /**
	   * Returns a function used to get the active track of type provided
	   *
	   * @param {string} type
	   *        MediaGroup type
	   * @param {Object} settings
	   *        Object containing required information for media groups
	   * @return {Function}
	   *         Function that returns the active media track for the provided type. Returns
	   *         null if no track is active
	   * @function activeTrack.SUBTITLES
	   */
	  SUBTITLES: function SUBTITLES(type, settings) {
	    return function () {
	      var tracks = settings.mediaTypes[type].tracks;
	
	      for (var id in tracks) {
	        if (tracks[id].mode === 'showing' || tracks[id].mode === 'hidden') {
	          return tracks[id];
	        }
	      }
	
	      return null;
	    };
	  }
	};
	
	var getActiveGroup = function getActiveGroup(type, _ref) {
	  var mediaTypes = _ref.mediaTypes;
	  return function () {
	    var activeTrack_ = mediaTypes[type].activeTrack();
	
	    if (!activeTrack_) {
	      return null;
	    }
	
	    return mediaTypes[type].activeGroup(activeTrack_);
	  };
	};
	/**
	 * Setup PlaylistLoaders and Tracks for media groups (Audio, Subtitles,
	 * Closed-Captions) specified in the master manifest.
	 *
	 * @param {Object} settings
	 *        Object containing required information for setting up the media groups
	 * @param {Tech} settings.tech
	 *        The tech of the player
	 * @param {Object} settings.requestOptions
	 *        XHR request options used by the segment loaders
	 * @param {PlaylistLoader} settings.masterPlaylistLoader
	 *        PlaylistLoader for the master source
	 * @param {VhsHandler} settings.vhs
	 *        VHS SourceHandler
	 * @param {Object} settings.master
	 *        The parsed master manifest
	 * @param {Object} settings.mediaTypes
	 *        Object to store the loaders, tracks, and utility methods for each media type
	 * @param {Function} settings.blacklistCurrentPlaylist
	 *        Blacklists the current rendition and forces a rendition switch.
	 * @function setupMediaGroups
	 */
	
	
	var setupMediaGroups = function setupMediaGroups(settings) {
	  ['AUDIO', 'SUBTITLES', 'CLOSED-CAPTIONS'].forEach(function (type) {
	    initialize[type](type, settings);
	  });
	  var mediaTypes = settings.mediaTypes,
	      masterPlaylistLoader = settings.masterPlaylistLoader,
	      tech = settings.tech,
	      vhs = settings.vhs,
	      _settings$segmentLoad3 = settings.segmentLoaders,
	      audioSegmentLoader = _settings$segmentLoad3['AUDIO'],
	      mainSegmentLoader = _settings$segmentLoad3.main; // setup active group and track getters and change event handlers
	
	  ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	    mediaTypes[type].activeGroup = activeGroup(type, settings);
	    mediaTypes[type].activeTrack = activeTrack[type](type, settings);
	    mediaTypes[type].onGroupChanged = onGroupChanged(type, settings);
	    mediaTypes[type].onGroupChanging = onGroupChanging(type, settings);
	    mediaTypes[type].onTrackChanged = onTrackChanged(type, settings);
	    mediaTypes[type].getActiveGroup = getActiveGroup(type, settings);
	  }); // DO NOT enable the default subtitle or caption track.
	  // DO enable the default audio track
	
	  var audioGroup = mediaTypes.AUDIO.activeGroup();
	
	  if (audioGroup) {
	    var groupId = (audioGroup.filter(function (group) {
	      return group["default"];
	    })[0] || audioGroup[0]).id;
	    mediaTypes.AUDIO.tracks[groupId].enabled = true;
	    mediaTypes.AUDIO.onGroupChanged();
	    mediaTypes.AUDIO.onTrackChanged();
	    var activeAudioGroup = mediaTypes.AUDIO.getActiveGroup(); // a similar check for handling setAudio on each loader is run again each time the
	    // track is changed, but needs to be handled here since the track may not be considered
	    // changed on the first call to onTrackChanged
	
	    if (!activeAudioGroup.playlistLoader) {
	      // either audio is muxed with video or the stream is audio only
	      mainSegmentLoader.setAudio(true);
	    } else {
	      // audio is demuxed
	      mainSegmentLoader.setAudio(false);
	      audioSegmentLoader.setAudio(true);
	    }
	  }
	
	  masterPlaylistLoader.on('mediachange', function () {
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      return mediaTypes[type].onGroupChanged();
	    });
	  });
	  masterPlaylistLoader.on('mediachanging', function () {
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      return mediaTypes[type].onGroupChanging();
	    });
	  }); // custom audio track change event handler for usage event
	
	  var onAudioTrackChanged = function onAudioTrackChanged() {
	    mediaTypes.AUDIO.onTrackChanged();
	    tech.trigger({
	      type: 'usage',
	      name: 'vhs-audio-change'
	    });
	    tech.trigger({
	      type: 'usage',
	      name: 'hls-audio-change'
	    });
	  };
	
	  tech.audioTracks().addEventListener('change', onAudioTrackChanged);
	  tech.remoteTextTracks().addEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
	  vhs.on('dispose', function () {
	    tech.audioTracks().removeEventListener('change', onAudioTrackChanged);
	    tech.remoteTextTracks().removeEventListener('change', mediaTypes.SUBTITLES.onTrackChanged);
	  }); // clear existing audio tracks and add the ones we just created
	
	  tech.clearTracks('audio');
	
	  for (var id in mediaTypes.AUDIO.tracks) {
	    tech.audioTracks().addTrack(mediaTypes.AUDIO.tracks[id]);
	  }
	};
	/**
	 * Creates skeleton object used to store the loaders, tracks, and utility methods for each
	 * media type
	 *
	 * @return {Object}
	 *         Object to store the loaders, tracks, and utility methods for each media type
	 * @function createMediaTypes
	 */
	
	
	var createMediaTypes = function createMediaTypes() {
	  var mediaTypes = {};
	  ['AUDIO', 'SUBTITLES', 'CLOSED-CAPTIONS'].forEach(function (type) {
	    mediaTypes[type] = {
	      groups: {},
	      tracks: {},
	      activePlaylistLoader: null,
	      activeGroup: noop,
	      activeTrack: noop,
	      getActiveGroup: noop,
	      onGroupChanged: noop,
	      onTrackChanged: noop,
	      lastTrack_: null,
	      logger_: logger("MediaGroups[" + type + "]")
	    };
	  });
	  return mediaTypes;
	};
	
	var ABORT_EARLY_BLACKLIST_SECONDS = 60 * 2;
	var Vhs$1; // SegmentLoader stats that need to have each loader's
	// values summed to calculate the final value
	
	var loaderStats = ['mediaRequests', 'mediaRequestsAborted', 'mediaRequestsTimedout', 'mediaRequestsErrored', 'mediaTransferDuration', 'mediaBytesTransferred', 'mediaAppends'];
	
	var sumLoaderStat = function sumLoaderStat(stat) {
	  return this.audioSegmentLoader_[stat] + this.mainSegmentLoader_[stat];
	};
	
	var shouldSwitchToMedia = function shouldSwitchToMedia(_ref) {
	  var currentPlaylist = _ref.currentPlaylist,
	      buffered = _ref.buffered,
	      currentTime = _ref.currentTime,
	      nextPlaylist = _ref.nextPlaylist,
	      bufferLowWaterLine = _ref.bufferLowWaterLine,
	      bufferHighWaterLine = _ref.bufferHighWaterLine,
	      duration = _ref.duration,
	      experimentalBufferBasedABR = _ref.experimentalBufferBasedABR,
	      log = _ref.log; // we have no other playlist to switch to
	
	  if (!nextPlaylist) {
	    videojs.log.warn('We received no playlist to switch to. Please check your stream.');
	    return false;
	  }
	
	  var sharedLogLine = "allowing switch " + (currentPlaylist && currentPlaylist.id || 'null') + " -> " + nextPlaylist.id;
	
	  if (!currentPlaylist) {
	    log(sharedLogLine + " as current playlist is not set");
	    return true;
	  } // no need to switch if playlist is the same
	
	
	  if (nextPlaylist.id === currentPlaylist.id) {
	    return false;
	  } // determine if current time is in a buffered range.
	
	
	  var isBuffered = Boolean(findRange(buffered, currentTime).length); // If the playlist is live, then we want to not take low water line into account.
	  // This is because in LIVE, the player plays 3 segments from the end of the
	  // playlist, and if `BUFFER_LOW_WATER_LINE` is greater than the duration availble
	  // in those segments, a viewer will never experience a rendition upswitch.
	
	  if (!currentPlaylist.endList) {
	    // For LLHLS live streams, don't switch renditions before playback has started, as it almost
	    // doubles the time to first playback.
	    if (!isBuffered && typeof currentPlaylist.partTargetDuration === 'number') {
	      log("not " + sharedLogLine + " as current playlist is live llhls, but currentTime isn't in buffered.");
	      return false;
	    }
	
	    log(sharedLogLine + " as current playlist is live");
	    return true;
	  }
	
	  var forwardBuffer = timeAheadOf(buffered, currentTime);
	  var maxBufferLowWaterLine = experimentalBufferBasedABR ? Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Config.MAX_BUFFER_LOW_WATER_LINE; // For the same reason as LIVE, we ignore the low water line when the VOD
	  // duration is below the max potential low water line
	
	  if (duration < maxBufferLowWaterLine) {
	    log(sharedLogLine + " as duration < max low water line (" + duration + " < " + maxBufferLowWaterLine + ")");
	    return true;
	  }
	
	  var nextBandwidth = nextPlaylist.attributes.BANDWIDTH;
	  var currBandwidth = currentPlaylist.attributes.BANDWIDTH; // when switching down, if our buffer is lower than the high water line,
	  // we can switch down
	
	  if (nextBandwidth < currBandwidth && (!experimentalBufferBasedABR || forwardBuffer < bufferHighWaterLine)) {
	    var logLine = sharedLogLine + " as next bandwidth < current bandwidth (" + nextBandwidth + " < " + currBandwidth + ")";
	
	    if (experimentalBufferBasedABR) {
	      logLine += " and forwardBuffer < bufferHighWaterLine (" + forwardBuffer + " < " + bufferHighWaterLine + ")";
	    }
	
	    log(logLine);
	    return true;
	  } // and if our buffer is higher than the low water line,
	  // we can switch up
	
	
	  if ((!experimentalBufferBasedABR || nextBandwidth > currBandwidth) && forwardBuffer >= bufferLowWaterLine) {
	    var _logLine = sharedLogLine + " as forwardBuffer >= bufferLowWaterLine (" + forwardBuffer + " >= " + bufferLowWaterLine + ")";
	
	    if (experimentalBufferBasedABR) {
	      _logLine += " and next bandwidth > current bandwidth (" + nextBandwidth + " > " + currBandwidth + ")";
	    }
	
	    log(_logLine);
	    return true;
	  }
	
	  log("not " + sharedLogLine + " as no switching criteria met");
	  return false;
	};
	/**
	 * the master playlist controller controller all interactons
	 * between playlists and segmentloaders. At this time this mainly
	 * involves a master playlist and a series of audio playlists
	 * if they are available
	 *
	 * @class MasterPlaylistController
	 * @extends videojs.EventTarget
	 */
	
	
	var MasterPlaylistController = /*#__PURE__*/function (_videojs$EventTarget) {
	  _inheritsLoose__default['default'](MasterPlaylistController, _videojs$EventTarget);
	
	  function MasterPlaylistController(options) {
	    var _this;
	
	    _this = _videojs$EventTarget.call(this) || this;
	    var src = options.src,
	        handleManifestRedirects = options.handleManifestRedirects,
	        withCredentials = options.withCredentials,
	        tech = options.tech,
	        bandwidth = options.bandwidth,
	        externVhs = options.externVhs,
	        useCueTags = options.useCueTags,
	        blacklistDuration = options.blacklistDuration,
	        enableLowInitialPlaylist = options.enableLowInitialPlaylist,
	        sourceType = options.sourceType,
	        cacheEncryptionKeys = options.cacheEncryptionKeys,
	        experimentalBufferBasedABR = options.experimentalBufferBasedABR,
	        experimentalLeastPixelDiffSelector = options.experimentalLeastPixelDiffSelector,
	        captionServices = options.captionServices;
	
	    if (!src) {
	      throw new Error('A non-empty playlist URL or JSON manifest string is required');
	    }
	
	    var maxPlaylistRetries = options.maxPlaylistRetries;
	
	    if (maxPlaylistRetries === null || typeof maxPlaylistRetries === 'undefined') {
	      maxPlaylistRetries = Infinity;
	    }
	
	    Vhs$1 = externVhs;
	    _this.experimentalBufferBasedABR = Boolean(experimentalBufferBasedABR);
	    _this.experimentalLeastPixelDiffSelector = Boolean(experimentalLeastPixelDiffSelector);
	    _this.withCredentials = withCredentials;
	    _this.tech_ = tech;
	    _this.vhs_ = tech.vhs;
	    _this.sourceType_ = sourceType;
	    _this.useCueTags_ = useCueTags;
	    _this.blacklistDuration = blacklistDuration;
	    _this.maxPlaylistRetries = maxPlaylistRetries;
	    _this.enableLowInitialPlaylist = enableLowInitialPlaylist;
	
	    if (_this.useCueTags_) {
	      _this.cueTagsTrack_ = _this.tech_.addTextTrack('metadata', 'ad-cues');
	      _this.cueTagsTrack_.inBandMetadataTrackDispatchType = '';
	    }
	
	    _this.requestOptions_ = {
	      withCredentials: withCredentials,
	      handleManifestRedirects: handleManifestRedirects,
	      maxPlaylistRetries: maxPlaylistRetries,
	      timeout: null
	    };
	
	    _this.on('error', _this.pauseLoading);
	
	    _this.mediaTypes_ = createMediaTypes();
	    _this.mediaSource = new window__default['default'].MediaSource();
	    _this.handleDurationChange_ = _this.handleDurationChange_.bind(_assertThisInitialized__default['default'](_this));
	    _this.handleSourceOpen_ = _this.handleSourceOpen_.bind(_assertThisInitialized__default['default'](_this));
	    _this.handleSourceEnded_ = _this.handleSourceEnded_.bind(_assertThisInitialized__default['default'](_this));
	
	    _this.mediaSource.addEventListener('durationchange', _this.handleDurationChange_); // load the media source into the player
	
	
	    _this.mediaSource.addEventListener('sourceopen', _this.handleSourceOpen_);
	
	    _this.mediaSource.addEventListener('sourceended', _this.handleSourceEnded_); // we don't have to handle sourceclose since dispose will handle termination of
	    // everything, and the MediaSource should not be detached without a proper disposal
	
	
	    _this.seekable_ = videojs.createTimeRanges();
	    _this.hasPlayed_ = false;
	    _this.syncController_ = new SyncController(options);
	    _this.segmentMetadataTrack_ = tech.addRemoteTextTrack({
	      kind: 'metadata',
	      label: 'segment-metadata'
	    }, false).track;
	    _this.decrypter_ = new Decrypter();
	    _this.sourceUpdater_ = new SourceUpdater(_this.mediaSource);
	    _this.inbandTextTracks_ = {};
	    _this.timelineChangeController_ = new TimelineChangeController();
	    var segmentLoaderSettings = {
	      vhs: _this.vhs_,
	      parse708captions: options.parse708captions,
	      useDtsForTimestampOffset: options.useDtsForTimestampOffset,
	      captionServices: captionServices,
	      mediaSource: _this.mediaSource,
	      currentTime: _this.tech_.currentTime.bind(_this.tech_),
	      seekable: function seekable() {
	        return _this.seekable();
	      },
	      seeking: function seeking() {
	        return _this.tech_.seeking();
	      },
	      duration: function duration() {
	        return _this.duration();
	      },
	      hasPlayed: function hasPlayed() {
	        return _this.hasPlayed_;
	      },
	      goalBufferLength: function goalBufferLength() {
	        return _this.goalBufferLength();
	      },
	      bandwidth: bandwidth,
	      syncController: _this.syncController_,
	      decrypter: _this.decrypter_,
	      sourceType: _this.sourceType_,
	      inbandTextTracks: _this.inbandTextTracks_,
	      cacheEncryptionKeys: cacheEncryptionKeys,
	      sourceUpdater: _this.sourceUpdater_,
	      timelineChangeController: _this.timelineChangeController_,
	      experimentalExactManifestTimings: options.experimentalExactManifestTimings
	    }; // The source type check not only determines whether a special DASH playlist loader
	    // should be used, but also covers the case where the provided src is a vhs-json
	    // manifest object (instead of a URL). In the case of vhs-json, the default
	    // PlaylistLoader should be used.
	
	    _this.masterPlaylistLoader_ = _this.sourceType_ === 'dash' ? new DashPlaylistLoader(src, _this.vhs_, _this.requestOptions_) : new PlaylistLoader(src, _this.vhs_, _this.requestOptions_);
	
	    _this.setupMasterPlaylistLoaderListeners_(); // setup segment loaders
	    // combined audio/video or just video when alternate audio track is selected
	
	
	    _this.mainSegmentLoader_ = new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
	      segmentMetadataTrack: _this.segmentMetadataTrack_,
	      loaderType: 'main'
	    }), options); // alternate audio track
	
	    _this.audioSegmentLoader_ = new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
	      loaderType: 'audio'
	    }), options);
	    _this.subtitleSegmentLoader_ = new VTTSegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
	      loaderType: 'vtt',
	      featuresNativeTextTracks: _this.tech_.featuresNativeTextTracks,
	      loadVttJs: function loadVttJs() {
	        return new Promise(function (resolve, reject) {
	          function onLoad() {
	            tech.off('vttjserror', onError);
	            resolve();
	          }
	
	          function onError() {
	            tech.off('vttjsloaded', onLoad);
	            reject();
	          }
	
	          tech.one('vttjsloaded', onLoad);
	          tech.one('vttjserror', onError); // safe to call multiple times, script will be loaded only once:
	
	          tech.addWebVttScript_();
	        });
	      }
	    }), options);
	
	    _this.setupSegmentLoaderListeners_();
	
	    if (_this.experimentalBufferBasedABR) {
	      _this.masterPlaylistLoader_.one('loadedplaylist', function () {
	        return _this.startABRTimer_();
	      });
	
	      _this.tech_.on('pause', function () {
	        return _this.stopABRTimer_();
	      });
	
	      _this.tech_.on('play', function () {
	        return _this.startABRTimer_();
	      });
	    } // Create SegmentLoader stat-getters
	    // mediaRequests_
	    // mediaRequestsAborted_
	    // mediaRequestsTimedout_
	    // mediaRequestsErrored_
	    // mediaTransferDuration_
	    // mediaBytesTransferred_
	    // mediaAppends_
	
	
	    loaderStats.forEach(function (stat) {
	      _this[stat + '_'] = sumLoaderStat.bind(_assertThisInitialized__default['default'](_this), stat);
	    });
	    _this.logger_ = logger('MPC');
	    _this.triggeredFmp4Usage = false;
	
	    if (_this.tech_.preload() === 'none') {
	      _this.loadOnPlay_ = function () {
	        _this.loadOnPlay_ = null;
	
	        _this.masterPlaylistLoader_.load();
	      };
	
	      _this.tech_.one('play', _this.loadOnPlay_);
	    } else {
	      _this.masterPlaylistLoader_.load();
	    }
	
	    _this.timeToLoadedData__ = -1;
	    _this.mainAppendsToLoadedData__ = -1;
	    _this.audioAppendsToLoadedData__ = -1;
	    var event = _this.tech_.preload() === 'none' ? 'play' : 'loadstart'; // start the first frame timer on loadstart or play (for preload none)
	
	    _this.tech_.one(event, function () {
	      var timeToLoadedDataStart = Date.now();
	
	      _this.tech_.one('loadeddata', function () {
	        _this.timeToLoadedData__ = Date.now() - timeToLoadedDataStart;
	        _this.mainAppendsToLoadedData__ = _this.mainSegmentLoader_.mediaAppends;
	        _this.audioAppendsToLoadedData__ = _this.audioSegmentLoader_.mediaAppends;
	      });
	    });
	
	    return _this;
	  }
	
	  var _proto = MasterPlaylistController.prototype;
	
	  _proto.mainAppendsToLoadedData_ = function mainAppendsToLoadedData_() {
	    return this.mainAppendsToLoadedData__;
	  };
	
	  _proto.audioAppendsToLoadedData_ = function audioAppendsToLoadedData_() {
	    return this.audioAppendsToLoadedData__;
	  };
	
	  _proto.appendsToLoadedData_ = function appendsToLoadedData_() {
	    var main = this.mainAppendsToLoadedData_();
	    var audio = this.audioAppendsToLoadedData_();
	
	    if (main === -1 || audio === -1) {
	      return -1;
	    }
	
	    return main + audio;
	  };
	
	  _proto.timeToLoadedData_ = function timeToLoadedData_() {
	    return this.timeToLoadedData__;
	  }
	  /**
	   * Run selectPlaylist and switch to the new playlist if we should
	   *
	   * @param {string} [reason=abr] a reason for why the ABR check is made
	   * @private
	   */
	  ;
	
	  _proto.checkABR_ = function checkABR_(reason) {
	    if (reason === void 0) {
	      reason = 'abr';
	    }
	
	    var nextPlaylist = this.selectPlaylist();
	
	    if (nextPlaylist && this.shouldSwitchToMedia_(nextPlaylist)) {
	      this.switchMedia_(nextPlaylist, reason);
	    }
	  };
	
	  _proto.switchMedia_ = function switchMedia_(playlist, cause, delay) {
	    var oldMedia = this.media();
	    var oldId = oldMedia && (oldMedia.id || oldMedia.uri);
	    var newId = playlist.id || playlist.uri;
	
	    if (oldId && oldId !== newId) {
	      this.logger_("switch media " + oldId + " -> " + newId + " from " + cause);
	      this.tech_.trigger({
	        type: 'usage',
	        name: "vhs-rendition-change-" + cause
	      });
	    }
	
	    this.masterPlaylistLoader_.media(playlist, delay);
	  }
	  /**
	   * Start a timer that periodically calls checkABR_
	   *
	   * @private
	   */
	  ;
	
	  _proto.startABRTimer_ = function startABRTimer_() {
	    var _this2 = this;
	
	    this.stopABRTimer_();
	    this.abrTimer_ = window__default['default'].setInterval(function () {
	      return _this2.checkABR_();
	    }, 250);
	  }
	  /**
	   * Stop the timer that periodically calls checkABR_
	   *
	   * @private
	   */
	  ;
	
	  _proto.stopABRTimer_ = function stopABRTimer_() {
	    // if we're scrubbing, we don't need to pause.
	    // This getter will be added to Video.js in version 7.11.
	    if (this.tech_.scrubbing && this.tech_.scrubbing()) {
	      return;
	    }
	
	    window__default['default'].clearInterval(this.abrTimer_);
	    this.abrTimer_ = null;
	  }
	  /**
	   * Get a list of playlists for the currently selected audio playlist
	   *
	   * @return {Array} the array of audio playlists
	   */
	  ;
	
	  _proto.getAudioTrackPlaylists_ = function getAudioTrackPlaylists_() {
	    var master = this.master();
	    var defaultPlaylists = master && master.playlists || []; // if we don't have any audio groups then we can only
	    // assume that the audio tracks are contained in masters
	    // playlist array, use that or an empty array.
	
	    if (!master || !master.mediaGroups || !master.mediaGroups.AUDIO) {
	      return defaultPlaylists;
	    }
	
	    var AUDIO = master.mediaGroups.AUDIO;
	    var groupKeys = Object.keys(AUDIO);
	    var track; // get the current active track
	
	    if (Object.keys(this.mediaTypes_.AUDIO.groups).length) {
	      track = this.mediaTypes_.AUDIO.activeTrack(); // or get the default track from master if mediaTypes_ isn't setup yet
	    } else {
	      // default group is `main` or just the first group.
	      var defaultGroup = AUDIO.main || groupKeys.length && AUDIO[groupKeys[0]];
	
	      for (var label in defaultGroup) {
	        if (defaultGroup[label]["default"]) {
	          track = {
	            label: label
	          };
	          break;
	        }
	      }
	    } // no active track no playlists.
	
	
	    if (!track) {
	      return defaultPlaylists;
	    }
	
	    var playlists = []; // get all of the playlists that are possible for the
	    // active track.
	
	    for (var group in AUDIO) {
	      if (AUDIO[group][track.label]) {
	        var properties = AUDIO[group][track.label];
	
	        if (properties.playlists && properties.playlists.length) {
	          playlists.push.apply(playlists, properties.playlists);
	        } else if (properties.uri) {
	          playlists.push(properties);
	        } else if (master.playlists.length) {
	          // if an audio group does not have a uri
	          // see if we have main playlists that use it as a group.
	          // if we do then add those to the playlists list.
	          for (var i = 0; i < master.playlists.length; i++) {
	            var playlist = master.playlists[i];
	
	            if (playlist.attributes && playlist.attributes.AUDIO && playlist.attributes.AUDIO === group) {
	              playlists.push(playlist);
	            }
	          }
	        }
	      }
	    }
	
	    if (!playlists.length) {
	      return defaultPlaylists;
	    }
	
	    return playlists;
	  }
	  /**
	   * Register event handlers on the master playlist loader. A helper
	   * function for construction time.
	   *
	   * @private
	   */
	  ;
	
	  _proto.setupMasterPlaylistLoaderListeners_ = function setupMasterPlaylistLoaderListeners_() {
	    var _this3 = this;
	
	    this.masterPlaylistLoader_.on('loadedmetadata', function () {
	      var media = _this3.masterPlaylistLoader_.media();
	
	      var requestTimeout = media.targetDuration * 1.5 * 1000; // If we don't have any more available playlists, we don't want to
	      // timeout the request.
	
	      if (isLowestEnabledRendition(_this3.masterPlaylistLoader_.master, _this3.masterPlaylistLoader_.media())) {
	        _this3.requestOptions_.timeout = 0;
	      } else {
	        _this3.requestOptions_.timeout = requestTimeout;
	      } // if this isn't a live video and preload permits, start
	      // downloading segments
	
	
	      if (media.endList && _this3.tech_.preload() !== 'none') {
	        _this3.mainSegmentLoader_.playlist(media, _this3.requestOptions_);
	
	        _this3.mainSegmentLoader_.load();
	      }
	
	      setupMediaGroups({
	        sourceType: _this3.sourceType_,
	        segmentLoaders: {
	          AUDIO: _this3.audioSegmentLoader_,
	          SUBTITLES: _this3.subtitleSegmentLoader_,
	          main: _this3.mainSegmentLoader_
	        },
	        tech: _this3.tech_,
	        requestOptions: _this3.requestOptions_,
	        masterPlaylistLoader: _this3.masterPlaylistLoader_,
	        vhs: _this3.vhs_,
	        master: _this3.master(),
	        mediaTypes: _this3.mediaTypes_,
	        blacklistCurrentPlaylist: _this3.blacklistCurrentPlaylist.bind(_this3)
	      });
	
	      _this3.triggerPresenceUsage_(_this3.master(), media);
	
	      _this3.setupFirstPlay();
	
	      if (!_this3.mediaTypes_.AUDIO.activePlaylistLoader || _this3.mediaTypes_.AUDIO.activePlaylistLoader.media()) {
	        _this3.trigger('selectedinitialmedia');
	      } else {
	        // We must wait for the active audio playlist loader to
	        // finish setting up before triggering this event so the
	        // representations API and EME setup is correct
	        _this3.mediaTypes_.AUDIO.activePlaylistLoader.one('loadedmetadata', function () {
	          _this3.trigger('selectedinitialmedia');
	        });
	      }
	    });
	    this.masterPlaylistLoader_.on('loadedplaylist', function () {
	      if (_this3.loadOnPlay_) {
	        _this3.tech_.off('play', _this3.loadOnPlay_);
	      }
	
	      var updatedPlaylist = _this3.masterPlaylistLoader_.media();
	
	      if (!updatedPlaylist) {
	        // exclude any variants that are not supported by the browser before selecting
	        // an initial media as the playlist selectors do not consider browser support
	        _this3.excludeUnsupportedVariants_();
	
	        var selectedMedia;
	
	        if (_this3.enableLowInitialPlaylist) {
	          selectedMedia = _this3.selectInitialPlaylist();
	        }
	
	        if (!selectedMedia) {
	          selectedMedia = _this3.selectPlaylist();
	        }
	
	        if (!selectedMedia || !_this3.shouldSwitchToMedia_(selectedMedia)) {
	          return;
	        }
	
	        _this3.initialMedia_ = selectedMedia;
	
	        _this3.switchMedia_(_this3.initialMedia_, 'initial'); // Under the standard case where a source URL is provided, loadedplaylist will
	        // fire again since the playlist will be requested. In the case of vhs-json
	        // (where the manifest object is provided as the source), when the media
	        // playlist's `segments` list is already available, a media playlist won't be
	        // requested, and loadedplaylist won't fire again, so the playlist handler must be
	        // called on its own here.
	
	
	        var haveJsonSource = _this3.sourceType_ === 'vhs-json' && _this3.initialMedia_.segments;
	
	        if (!haveJsonSource) {
	          return;
	        }
	
	        updatedPlaylist = _this3.initialMedia_;
	      }
	
	      _this3.handleUpdatedMediaPlaylist(updatedPlaylist);
	    });
	    this.masterPlaylistLoader_.on('error', function () {
	      _this3.blacklistCurrentPlaylist(_this3.masterPlaylistLoader_.error);
	    });
	    this.masterPlaylistLoader_.on('mediachanging', function () {
	      _this3.mainSegmentLoader_.abort();
	
	      _this3.mainSegmentLoader_.pause();
	    });
	    this.masterPlaylistLoader_.on('mediachange', function () {
	      var media = _this3.masterPlaylistLoader_.media();
	
	      var requestTimeout = media.targetDuration * 1.5 * 1000; // If we don't have any more available playlists, we don't want to
	      // timeout the request.
	
	      if (isLowestEnabledRendition(_this3.masterPlaylistLoader_.master, _this3.masterPlaylistLoader_.media())) {
	        _this3.requestOptions_.timeout = 0;
	      } else {
	        _this3.requestOptions_.timeout = requestTimeout;
	      }
	
	      _this3.masterPlaylistLoader_.load(); // TODO: Create a new event on the PlaylistLoader that signals
	      // that the segments have changed in some way and use that to
	      // update the SegmentLoader instead of doing it twice here and
	      // on `loadedplaylist`
	
	
	      _this3.mainSegmentLoader_.playlist(media, _this3.requestOptions_);
	
	      _this3.mainSegmentLoader_.load();
	
	      _this3.tech_.trigger({
	        type: 'mediachange',
	        bubbles: true
	      });
	    });
	    this.masterPlaylistLoader_.on('playlistunchanged', function () {
	      var updatedPlaylist = _this3.masterPlaylistLoader_.media(); // ignore unchanged playlists that have already been
	      // excluded for not-changing. We likely just have a really slowly updating
	      // playlist.
	
	
	      if (updatedPlaylist.lastExcludeReason_ === 'playlist-unchanged') {
	        return;
	      }
	
	      var playlistOutdated = _this3.stuckAtPlaylistEnd_(updatedPlaylist);
	
	      if (playlistOutdated) {
	        // Playlist has stopped updating and we're stuck at its end. Try to
	        // blacklist it and switch to another playlist in the hope that that
	        // one is updating (and give the player a chance to re-adjust to the
	        // safe live point).
	        _this3.blacklistCurrentPlaylist({
	          message: 'Playlist no longer updating.',
	          reason: 'playlist-unchanged'
	        }); // useful for monitoring QoS
	
	
	        _this3.tech_.trigger('playliststuck');
	      }
	    });
	    this.masterPlaylistLoader_.on('renditiondisabled', function () {
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-rendition-disabled'
	      });
	
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'hls-rendition-disabled'
	      });
	    });
	    this.masterPlaylistLoader_.on('renditionenabled', function () {
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-rendition-enabled'
	      });
	
	      _this3.tech_.trigger({
	        type: 'usage',
	        name: 'hls-rendition-enabled'
	      });
	    });
	  }
	  /**
	   * Given an updated media playlist (whether it was loaded for the first time, or
	   * refreshed for live playlists), update any relevant properties and state to reflect
	   * changes in the media that should be accounted for (e.g., cues and duration).
	   *
	   * @param {Object} updatedPlaylist the updated media playlist object
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleUpdatedMediaPlaylist = function handleUpdatedMediaPlaylist(updatedPlaylist) {
	    if (this.useCueTags_) {
	      this.updateAdCues_(updatedPlaylist);
	    } // TODO: Create a new event on the PlaylistLoader that signals
	    // that the segments have changed in some way and use that to
	    // update the SegmentLoader instead of doing it twice here and
	    // on `mediachange`
	
	
	    this.mainSegmentLoader_.playlist(updatedPlaylist, this.requestOptions_);
	    this.updateDuration(!updatedPlaylist.endList); // If the player isn't paused, ensure that the segment loader is running,
	    // as it is possible that it was temporarily stopped while waiting for
	    // a playlist (e.g., in case the playlist errored and we re-requested it).
	
	    if (!this.tech_.paused()) {
	      this.mainSegmentLoader_.load();
	
	      if (this.audioSegmentLoader_) {
	        this.audioSegmentLoader_.load();
	      }
	    }
	  }
	  /**
	   * A helper function for triggerring presence usage events once per source
	   *
	   * @private
	   */
	  ;
	
	  _proto.triggerPresenceUsage_ = function triggerPresenceUsage_(master, media) {
	    var mediaGroups = master.mediaGroups || {};
	    var defaultDemuxed = true;
	    var audioGroupKeys = Object.keys(mediaGroups.AUDIO);
	
	    for (var mediaGroup in mediaGroups.AUDIO) {
	      for (var label in mediaGroups.AUDIO[mediaGroup]) {
	        var properties = mediaGroups.AUDIO[mediaGroup][label];
	
	        if (!properties.uri) {
	          defaultDemuxed = false;
	        }
	      }
	    }
	
	    if (defaultDemuxed) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-demuxed'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-demuxed'
	      });
	    }
	
	    if (Object.keys(mediaGroups.SUBTITLES).length) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-webvtt'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-webvtt'
	      });
	    }
	
	    if (Vhs$1.Playlist.isAes(media)) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-aes'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-aes'
	      });
	    }
	
	    if (audioGroupKeys.length && Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length > 1) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-alternate-audio'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-alternate-audio'
	      });
	    }
	
	    if (this.useCueTags_) {
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-playlist-cue-tags'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-playlist-cue-tags'
	      });
	    }
	  };
	
	  _proto.shouldSwitchToMedia_ = function shouldSwitchToMedia_(nextPlaylist) {
	    var currentPlaylist = this.masterPlaylistLoader_.media() || this.masterPlaylistLoader_.pendingMedia_;
	    var currentTime = this.tech_.currentTime();
	    var bufferLowWaterLine = this.bufferLowWaterLine();
	    var bufferHighWaterLine = this.bufferHighWaterLine();
	    var buffered = this.tech_.buffered();
	    return shouldSwitchToMedia({
	      buffered: buffered,
	      currentTime: currentTime,
	      currentPlaylist: currentPlaylist,
	      nextPlaylist: nextPlaylist,
	      bufferLowWaterLine: bufferLowWaterLine,
	      bufferHighWaterLine: bufferHighWaterLine,
	      duration: this.duration(),
	      experimentalBufferBasedABR: this.experimentalBufferBasedABR,
	      log: this.logger_
	    });
	  }
	  /**
	   * Register event handlers on the segment loaders. A helper function
	   * for construction time.
	   *
	   * @private
	   */
	  ;
	
	  _proto.setupSegmentLoaderListeners_ = function setupSegmentLoaderListeners_() {
	    var _this4 = this;
	
	    this.mainSegmentLoader_.on('bandwidthupdate', function () {
	      // Whether or not buffer based ABR or another ABR is used, on a bandwidth change it's
	      // useful to check to see if a rendition switch should be made.
	      _this4.checkABR_('bandwidthupdate');
	
	      _this4.tech_.trigger('bandwidthupdate');
	    });
	    this.mainSegmentLoader_.on('timeout', function () {
	      if (_this4.experimentalBufferBasedABR) {
	        // If a rendition change is needed, then it would've be done on `bandwidthupdate`.
	        // Here the only consideration is that for buffer based ABR there's no guarantee
	        // of an immediate switch (since the bandwidth is averaged with a timeout
	        // bandwidth value of 1), so force a load on the segment loader to keep it going.
	        _this4.mainSegmentLoader_.load();
	      }
	    }); // `progress` events are not reliable enough of a bandwidth measure to trigger buffer
	    // based ABR.
	
	    if (!this.experimentalBufferBasedABR) {
	      this.mainSegmentLoader_.on('progress', function () {
	        _this4.trigger('progress');
	      });
	    }
	
	    this.mainSegmentLoader_.on('error', function () {
	      _this4.blacklistCurrentPlaylist(_this4.mainSegmentLoader_.error());
	    });
	    this.mainSegmentLoader_.on('appenderror', function () {
	      _this4.error = _this4.mainSegmentLoader_.error_;
	
	      _this4.trigger('error');
	    });
	    this.mainSegmentLoader_.on('syncinfoupdate', function () {
	      _this4.onSyncInfoUpdate_();
	    });
	    this.mainSegmentLoader_.on('timestampoffset', function () {
	      _this4.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-timestamp-offset'
	      });
	
	      _this4.tech_.trigger({
	        type: 'usage',
	        name: 'hls-timestamp-offset'
	      });
	    });
	    this.audioSegmentLoader_.on('syncinfoupdate', function () {
	      _this4.onSyncInfoUpdate_();
	    });
	    this.audioSegmentLoader_.on('appenderror', function () {
	      _this4.error = _this4.audioSegmentLoader_.error_;
	
	      _this4.trigger('error');
	    });
	    this.mainSegmentLoader_.on('ended', function () {
	      _this4.logger_('main segment loader ended');
	
	      _this4.onEndOfStream();
	    });
	    this.mainSegmentLoader_.on('earlyabort', function (event) {
	      // never try to early abort with the new ABR algorithm
	      if (_this4.experimentalBufferBasedABR) {
	        return;
	      }
	
	      _this4.delegateLoaders_('all', ['abort']);
	
	      _this4.blacklistCurrentPlaylist({
	        message: 'Aborted early because there isn\'t enough bandwidth to complete the ' + 'request without rebuffering.'
	      }, ABORT_EARLY_BLACKLIST_SECONDS);
	    });
	
	    var updateCodecs = function updateCodecs() {
	      if (!_this4.sourceUpdater_.hasCreatedSourceBuffers()) {
	        return _this4.tryToCreateSourceBuffers_();
	      }
	
	      var codecs = _this4.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
	
	
	      if (!codecs) {
	        return;
	      }
	
	      _this4.sourceUpdater_.addOrChangeSourceBuffers(codecs);
	    };
	
	    this.mainSegmentLoader_.on('trackinfo', updateCodecs);
	    this.audioSegmentLoader_.on('trackinfo', updateCodecs);
	    this.mainSegmentLoader_.on('fmp4', function () {
	      if (!_this4.triggeredFmp4Usage) {
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'vhs-fmp4'
	        });
	
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'hls-fmp4'
	        });
	
	        _this4.triggeredFmp4Usage = true;
	      }
	    });
	    this.audioSegmentLoader_.on('fmp4', function () {
	      if (!_this4.triggeredFmp4Usage) {
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'vhs-fmp4'
	        });
	
	        _this4.tech_.trigger({
	          type: 'usage',
	          name: 'hls-fmp4'
	        });
	
	        _this4.triggeredFmp4Usage = true;
	      }
	    });
	    this.audioSegmentLoader_.on('ended', function () {
	      _this4.logger_('audioSegmentLoader ended');
	
	      _this4.onEndOfStream();
	    });
	  };
	
	  _proto.mediaSecondsLoaded_ = function mediaSecondsLoaded_() {
	    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
	  }
	  /**
	   * Call load on our SegmentLoaders
	   */
	  ;
	
	  _proto.load = function load() {
	    this.mainSegmentLoader_.load();
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      this.audioSegmentLoader_.load();
	    }
	
	    if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
	      this.subtitleSegmentLoader_.load();
	    }
	  }
	  /**
	   * Re-tune playback quality level for the current player
	   * conditions without performing destructive actions, like
	   * removing already buffered content
	   *
	   * @private
	   * @deprecated
	   */
	  ;
	
	  _proto.smoothQualityChange_ = function smoothQualityChange_(media) {
	    if (media === void 0) {
	      media = this.selectPlaylist();
	    }
	
	    this.fastQualityChange_(media);
	  }
	  /**
	   * Re-tune playback quality level for the current player
	   * conditions. This method will perform destructive actions like removing
	   * already buffered content in order to readjust the currently active
	   * playlist quickly. This is good for manual quality changes
	   *
	   * @private
	   */
	  ;
	
	  _proto.fastQualityChange_ = function fastQualityChange_(media) {
	    var _this5 = this;
	
	    if (media === void 0) {
	      media = this.selectPlaylist();
	    }
	
	    if (media === this.masterPlaylistLoader_.media()) {
	      this.logger_('skipping fastQualityChange because new media is same as old');
	      return;
	    }
	
	    this.switchMedia_(media, 'fast-quality'); // Delete all buffered data to allow an immediate quality switch, then seek to give
	    // the browser a kick to remove any cached frames from the previous rendtion (.04 seconds
	    // ahead is roughly the minimum that will accomplish this across a variety of content
	    // in IE and Edge, but seeking in place is sufficient on all other browsers)
	    // Edge/IE bug: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/14600375/
	    // Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=651904
	
	    this.mainSegmentLoader_.resetEverything(function () {
	      // Since this is not a typical seek, we avoid the seekTo method which can cause segments
	      // from the previously enabled rendition to load before the new playlist has finished loading
	      if (videojs.browser.IE_VERSION || videojs.browser.IS_EDGE) {
	        _this5.tech_.setCurrentTime(_this5.tech_.currentTime() + 0.04);
	      } else {
	        _this5.tech_.setCurrentTime(_this5.tech_.currentTime());
	      }
	    }); // don't need to reset audio as it is reset when media changes
	  }
	  /**
	   * Begin playback.
	   */
	  ;
	
	  _proto.play = function play() {
	    if (this.setupFirstPlay()) {
	      return;
	    }
	
	    if (this.tech_.ended()) {
	      this.tech_.setCurrentTime(0);
	    }
	
	    if (this.hasPlayed_) {
	      this.load();
	    }
	
	    var seekable = this.tech_.seekable(); // if the viewer has paused and we fell out of the live window,
	    // seek forward to the live point
	
	    if (this.tech_.duration() === Infinity) {
	      if (this.tech_.currentTime() < seekable.start(0)) {
	        return this.tech_.setCurrentTime(seekable.end(seekable.length - 1));
	      }
	    }
	  }
	  /**
	   * Seek to the latest media position if this is a live video and the
	   * player and video are loaded and initialized.
	   */
	  ;
	
	  _proto.setupFirstPlay = function setupFirstPlay() {
	    var _this6 = this;
	
	    var media = this.masterPlaylistLoader_.media(); // Check that everything is ready to begin buffering for the first call to play
	    //  If 1) there is no active media
	    //     2) the player is paused
	    //     3) the first play has already been setup
	    // then exit early
	
	    if (!media || this.tech_.paused() || this.hasPlayed_) {
	      return false;
	    } // when the video is a live stream
	
	
	    if (!media.endList) {
	      var seekable = this.seekable();
	
	      if (!seekable.length) {
	        // without a seekable range, the player cannot seek to begin buffering at the live
	        // point
	        return false;
	      }
	
	      if (videojs.browser.IE_VERSION && this.tech_.readyState() === 0) {
	        // IE11 throws an InvalidStateError if you try to set currentTime while the
	        // readyState is 0, so it must be delayed until the tech fires loadedmetadata.
	        this.tech_.one('loadedmetadata', function () {
	          _this6.trigger('firstplay');
	
	          _this6.tech_.setCurrentTime(seekable.end(0));
	
	          _this6.hasPlayed_ = true;
	        });
	        return false;
	      } // trigger firstplay to inform the source handler to ignore the next seek event
	
	
	      this.trigger('firstplay'); // seek to the live point
	
	      this.tech_.setCurrentTime(seekable.end(0));
	    }
	
	    this.hasPlayed_ = true; // we can begin loading now that everything is ready
	
	    this.load();
	    return true;
	  }
	  /**
	   * handle the sourceopen event on the MediaSource
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleSourceOpen_ = function handleSourceOpen_() {
	    // Only attempt to create the source buffer if none already exist.
	    // handleSourceOpen is also called when we are "re-opening" a source buffer
	    // after `endOfStream` has been called (in response to a seek for instance)
	    this.tryToCreateSourceBuffers_(); // if autoplay is enabled, begin playback. This is duplicative of
	    // code in video.js but is required because play() must be invoked
	    // *after* the media source has opened.
	
	    if (this.tech_.autoplay()) {
	      var playPromise = this.tech_.play(); // Catch/silence error when a pause interrupts a play request
	      // on browsers which return a promise
	
	      if (typeof playPromise !== 'undefined' && typeof playPromise.then === 'function') {
	        playPromise.then(null, function (e) {});
	      }
	    }
	
	    this.trigger('sourceopen');
	  }
	  /**
	   * handle the sourceended event on the MediaSource
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleSourceEnded_ = function handleSourceEnded_() {
	    if (!this.inbandTextTracks_.metadataTrack_) {
	      return;
	    }
	
	    var cues = this.inbandTextTracks_.metadataTrack_.cues;
	
	    if (!cues || !cues.length) {
	      return;
	    }
	
	    var duration = this.duration();
	    cues[cues.length - 1].endTime = isNaN(duration) || Math.abs(duration) === Infinity ? Number.MAX_VALUE : duration;
	  }
	  /**
	   * handle the durationchange event on the MediaSource
	   *
	   * @private
	   */
	  ;
	
	  _proto.handleDurationChange_ = function handleDurationChange_() {
	    this.tech_.trigger('durationchange');
	  }
	  /**
	   * Calls endOfStream on the media source when all active stream types have called
	   * endOfStream
	   *
	   * @param {string} streamType
	   *        Stream type of the segment loader that called endOfStream
	   * @private
	   */
	  ;
	
	  _proto.onEndOfStream = function onEndOfStream() {
	    var isEndOfStream = this.mainSegmentLoader_.ended_;
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      var mainMediaInfo = this.mainSegmentLoader_.getCurrentMediaInfo_(); // if the audio playlist loader exists, then alternate audio is active
	
	      if (!mainMediaInfo || mainMediaInfo.hasVideo) {
	        // if we do not know if the main segment loader contains video yet or if we
	        // definitively know the main segment loader contains video, then we need to wait
	        // for both main and audio segment loaders to call endOfStream
	        isEndOfStream = isEndOfStream && this.audioSegmentLoader_.ended_;
	      } else {
	        // otherwise just rely on the audio loader
	        isEndOfStream = this.audioSegmentLoader_.ended_;
	      }
	    }
	
	    if (!isEndOfStream) {
	      return;
	    }
	
	    this.stopABRTimer_();
	    this.sourceUpdater_.endOfStream();
	  }
	  /**
	   * Check if a playlist has stopped being updated
	   *
	   * @param {Object} playlist the media playlist object
	   * @return {boolean} whether the playlist has stopped being updated or not
	   */
	  ;
	
	  _proto.stuckAtPlaylistEnd_ = function stuckAtPlaylistEnd_(playlist) {
	    var seekable = this.seekable();
	
	    if (!seekable.length) {
	      // playlist doesn't have enough information to determine whether we are stuck
	      return false;
	    }
	
	    var expired = this.syncController_.getExpiredTime(playlist, this.duration());
	
	    if (expired === null) {
	      return false;
	    } // does not use the safe live end to calculate playlist end, since we
	    // don't want to say we are stuck while there is still content
	
	
	    var absolutePlaylistEnd = Vhs$1.Playlist.playlistEnd(playlist, expired);
	    var currentTime = this.tech_.currentTime();
	    var buffered = this.tech_.buffered();
	
	    if (!buffered.length) {
	      // return true if the playhead reached the absolute end of the playlist
	      return absolutePlaylistEnd - currentTime <= SAFE_TIME_DELTA;
	    }
	
	    var bufferedEnd = buffered.end(buffered.length - 1); // return true if there is too little buffer left and buffer has reached absolute
	    // end of playlist
	
	    return bufferedEnd - currentTime <= SAFE_TIME_DELTA && absolutePlaylistEnd - bufferedEnd <= SAFE_TIME_DELTA;
	  }
	  /**
	   * Blacklists a playlist when an error occurs for a set amount of time
	   * making it unavailable for selection by the rendition selection algorithm
	   * and then forces a new playlist (rendition) selection.
	   *
	   * @param {Object=} error an optional error that may include the playlist
	   * to blacklist
	   * @param {number=} blacklistDuration an optional number of seconds to blacklist the
	   * playlist
	   */
	  ;
	
	  _proto.blacklistCurrentPlaylist = function blacklistCurrentPlaylist(error, blacklistDuration) {
	    if (error === void 0) {
	      error = {};
	    } // If the `error` was generated by the playlist loader, it will contain
	    // the playlist we were trying to load (but failed) and that should be
	    // blacklisted instead of the currently selected playlist which is likely
	    // out-of-date in this scenario
	
	
	    var currentPlaylist = error.playlist || this.masterPlaylistLoader_.media();
	    blacklistDuration = blacklistDuration || error.blacklistDuration || this.blacklistDuration; // If there is no current playlist, then an error occurred while we were
	    // trying to load the master OR while we were disposing of the tech
	
	    if (!currentPlaylist) {
	      this.error = error;
	
	      if (this.mediaSource.readyState !== 'open') {
	        this.trigger('error');
	      } else {
	        this.sourceUpdater_.endOfStream('network');
	      }
	
	      return;
	    }
	
	    currentPlaylist.playlistErrors_++;
	    var playlists = this.masterPlaylistLoader_.master.playlists;
	    var enabledPlaylists = playlists.filter(isEnabled);
	    var isFinalRendition = enabledPlaylists.length === 1 && enabledPlaylists[0] === currentPlaylist; // Don't blacklist the only playlist unless it was blacklisted
	    // forever
	
	    if (playlists.length === 1 && blacklistDuration !== Infinity) {
	      videojs.log.warn("Problem encountered with playlist " + currentPlaylist.id + ". " + 'Trying again since it is the only playlist.');
	      this.tech_.trigger('retryplaylist'); // if this is a final rendition, we should delay
	
	      return this.masterPlaylistLoader_.load(isFinalRendition);
	    }
	
	    if (isFinalRendition) {
	      // Since we're on the final non-blacklisted playlist, and we're about to blacklist
	      // it, instead of erring the player or retrying this playlist, clear out the current
	      // blacklist. This allows other playlists to be attempted in case any have been
	      // fixed.
	      var reincluded = false;
	      playlists.forEach(function (playlist) {
	        // skip current playlist which is about to be blacklisted
	        if (playlist === currentPlaylist) {
	          return;
	        }
	
	        var excludeUntil = playlist.excludeUntil; // a playlist cannot be reincluded if it wasn't excluded to begin with.
	
	        if (typeof excludeUntil !== 'undefined' && excludeUntil !== Infinity) {
	          reincluded = true;
	          delete playlist.excludeUntil;
	        }
	      });
	
	      if (reincluded) {
	        videojs.log.warn('Removing other playlists from the exclusion list because the last ' + 'rendition is about to be excluded.'); // Technically we are retrying a playlist, in that we are simply retrying a previous
	        // playlist. This is needed for users relying on the retryplaylist event to catch a
	        // case where the player might be stuck and looping through "dead" playlists.
	
	        this.tech_.trigger('retryplaylist');
	      }
	    } // Blacklist this playlist
	
	
	    var excludeUntil;
	
	    if (currentPlaylist.playlistErrors_ > this.maxPlaylistRetries) {
	      excludeUntil = Infinity;
	    } else {
	      excludeUntil = Date.now() + blacklistDuration * 1000;
	    }
	
	    currentPlaylist.excludeUntil = excludeUntil;
	
	    if (error.reason) {
	      currentPlaylist.lastExcludeReason_ = error.reason;
	    }
	
	    this.tech_.trigger('blacklistplaylist');
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'vhs-rendition-blacklisted'
	    });
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'hls-rendition-blacklisted'
	    }); // TODO: should we select a new playlist if this blacklist wasn't for the currentPlaylist?
	    // Would be something like media().id !=== currentPlaylist.id and we  would need something
	    // like `pendingMedia` in playlist loaders to check against that too. This will prevent us
	    // from loading a new playlist on any blacklist.
	    // Select a new playlist
	
	    var nextPlaylist = this.selectPlaylist();
	
	    if (!nextPlaylist) {
	      this.error = 'Playback cannot continue. No available working or supported playlists.';
	      this.trigger('error');
	      return;
	    }
	
	    var logFn = error.internal ? this.logger_ : videojs.log.warn;
	    var errorMessage = error.message ? ' ' + error.message : '';
	    logFn((error.internal ? 'Internal problem' : 'Problem') + " encountered with playlist " + currentPlaylist.id + "." + (errorMessage + " Switching to playlist " + nextPlaylist.id + ".")); // if audio group changed reset audio loaders
	
	    if (nextPlaylist.attributes.AUDIO !== currentPlaylist.attributes.AUDIO) {
	      this.delegateLoaders_('audio', ['abort', 'pause']);
	    } // if subtitle group changed reset subtitle loaders
	
	
	    if (nextPlaylist.attributes.SUBTITLES !== currentPlaylist.attributes.SUBTITLES) {
	      this.delegateLoaders_('subtitle', ['abort', 'pause']);
	    }
	
	    this.delegateLoaders_('main', ['abort', 'pause']);
	    var delayDuration = nextPlaylist.targetDuration / 2 * 1000 || 5 * 1000;
	    var shouldDelay = typeof nextPlaylist.lastRequest === 'number' && Date.now() - nextPlaylist.lastRequest <= delayDuration; // delay if it's a final rendition or if the last refresh is sooner than half targetDuration
	
	    return this.switchMedia_(nextPlaylist, 'exclude', isFinalRendition || shouldDelay);
	  }
	  /**
	   * Pause all segment/playlist loaders
	   */
	  ;
	
	  _proto.pauseLoading = function pauseLoading() {
	    this.delegateLoaders_('all', ['abort', 'pause']);
	    this.stopABRTimer_();
	  }
	  /**
	   * Call a set of functions in order on playlist loaders, segment loaders,
	   * or both types of loaders.
	   *
	   * @param {string} filter
	   *        Filter loaders that should call fnNames using a string. Can be:
	   *        * all - run on all loaders
	   *        * audio - run on all audio loaders
	   *        * subtitle - run on all subtitle loaders
	   *        * main - run on the main/master loaders
	   *
	   * @param {Array|string} fnNames
	   *        A string or array of function names to call.
	   */
	  ;
	
	  _proto.delegateLoaders_ = function delegateLoaders_(filter, fnNames) {
	    var _this7 = this;
	
	    var loaders = [];
	    var dontFilterPlaylist = filter === 'all';
	
	    if (dontFilterPlaylist || filter === 'main') {
	      loaders.push(this.masterPlaylistLoader_);
	    }
	
	    var mediaTypes = [];
	
	    if (dontFilterPlaylist || filter === 'audio') {
	      mediaTypes.push('AUDIO');
	    }
	
	    if (dontFilterPlaylist || filter === 'subtitle') {
	      mediaTypes.push('CLOSED-CAPTIONS');
	      mediaTypes.push('SUBTITLES');
	    }
	
	    mediaTypes.forEach(function (mediaType) {
	      var loader = _this7.mediaTypes_[mediaType] && _this7.mediaTypes_[mediaType].activePlaylistLoader;
	
	      if (loader) {
	        loaders.push(loader);
	      }
	    });
	    ['main', 'audio', 'subtitle'].forEach(function (name) {
	      var loader = _this7[name + "SegmentLoader_"];
	
	      if (loader && (filter === name || filter === 'all')) {
	        loaders.push(loader);
	      }
	    });
	    loaders.forEach(function (loader) {
	      return fnNames.forEach(function (fnName) {
	        if (typeof loader[fnName] === 'function') {
	          loader[fnName]();
	        }
	      });
	    });
	  }
	  /**
	   * set the current time on all segment loaders
	   *
	   * @param {TimeRange} currentTime the current time to set
	   * @return {TimeRange} the current time
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime(currentTime) {
	    var buffered = findRange(this.tech_.buffered(), currentTime);
	
	    if (!(this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media())) {
	      // return immediately if the metadata is not ready yet
	      return 0;
	    } // it's clearly an edge-case but don't thrown an error if asked to
	    // seek within an empty playlist
	
	
	    if (!this.masterPlaylistLoader_.media().segments) {
	      return 0;
	    } // if the seek location is already buffered, continue buffering as usual
	
	
	    if (buffered && buffered.length) {
	      return currentTime;
	    } // cancel outstanding requests so we begin buffering at the new
	    // location
	
	
	    this.mainSegmentLoader_.resetEverything();
	    this.mainSegmentLoader_.abort();
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      this.audioSegmentLoader_.resetEverything();
	      this.audioSegmentLoader_.abort();
	    }
	
	    if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
	      this.subtitleSegmentLoader_.resetEverything();
	      this.subtitleSegmentLoader_.abort();
	    } // start segment loader loading in case they are paused
	
	
	    this.load();
	  }
	  /**
	   * get the current duration
	   *
	   * @return {TimeRange} the duration
	   */
	  ;
	
	  _proto.duration = function duration() {
	    if (!this.masterPlaylistLoader_) {
	      return 0;
	    }
	
	    var media = this.masterPlaylistLoader_.media();
	
	    if (!media) {
	      // no playlists loaded yet, so can't determine a duration
	      return 0;
	    } // Don't rely on the media source for duration in the case of a live playlist since
	    // setting the native MediaSource's duration to infinity ends up with consequences to
	    // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
	    //
	    // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
	    // however, few browsers have support for setLiveSeekableRange()
	    // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
	    //
	    // Until a time when the duration of the media source can be set to infinity, and a
	    // seekable range specified across browsers, just return Infinity.
	
	
	    if (!media.endList) {
	      return Infinity;
	    } // Since this is a VOD video, it is safe to rely on the media source's duration (if
	    // available). If it's not available, fall back to a playlist-calculated estimate.
	
	
	    if (this.mediaSource) {
	      return this.mediaSource.duration;
	    }
	
	    return Vhs$1.Playlist.duration(media);
	  }
	  /**
	   * check the seekable range
	   *
	   * @return {TimeRange} the seekable range
	   */
	  ;
	
	  _proto.seekable = function seekable() {
	    return this.seekable_;
	  };
	
	  _proto.onSyncInfoUpdate_ = function onSyncInfoUpdate_() {
	    var audioSeekable; // TODO check for creation of both source buffers before updating seekable
	    //
	    // A fix was made to this function where a check for
	    // this.sourceUpdater_.hasCreatedSourceBuffers
	    // was added to ensure that both source buffers were created before seekable was
	    // updated. However, it originally had a bug where it was checking for a true and
	    // returning early instead of checking for false. Setting it to check for false to
	    // return early though created other issues. A call to play() would check for seekable
	    // end without verifying that a seekable range was present. In addition, even checking
	    // for that didn't solve some issues, as handleFirstPlay is sometimes worked around
	    // due to a media update calling load on the segment loaders, skipping a seek to live,
	    // thereby starting live streams at the beginning of the stream rather than at the end.
	    //
	    // This conditional should be fixed to wait for the creation of two source buffers at
	    // the same time as the other sections of code are fixed to properly seek to live and
	    // not throw an error due to checking for a seekable end when no seekable range exists.
	    //
	    // For now, fall back to the older behavior, with the understanding that the seekable
	    // range may not be completely correct, leading to a suboptimal initial live point.
	
	    if (!this.masterPlaylistLoader_) {
	      return;
	    }
	
	    var media = this.masterPlaylistLoader_.media();
	
	    if (!media) {
	      return;
	    }
	
	    var expired = this.syncController_.getExpiredTime(media, this.duration());
	
	    if (expired === null) {
	      // not enough information to update seekable
	      return;
	    }
	
	    var master = this.masterPlaylistLoader_.master;
	    var mainSeekable = Vhs$1.Playlist.seekable(media, expired, Vhs$1.Playlist.liveEdgeDelay(master, media));
	
	    if (mainSeekable.length === 0) {
	      return;
	    }
	
	    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
	      media = this.mediaTypes_.AUDIO.activePlaylistLoader.media();
	      expired = this.syncController_.getExpiredTime(media, this.duration());
	
	      if (expired === null) {
	        return;
	      }
	
	      audioSeekable = Vhs$1.Playlist.seekable(media, expired, Vhs$1.Playlist.liveEdgeDelay(master, media));
	
	      if (audioSeekable.length === 0) {
	        return;
	      }
	    }
	
	    var oldEnd;
	    var oldStart;
	
	    if (this.seekable_ && this.seekable_.length) {
	      oldEnd = this.seekable_.end(0);
	      oldStart = this.seekable_.start(0);
	    }
	
	    if (!audioSeekable) {
	      // seekable has been calculated based on buffering video data so it
	      // can be returned directly
	      this.seekable_ = mainSeekable;
	    } else if (audioSeekable.start(0) > mainSeekable.end(0) || mainSeekable.start(0) > audioSeekable.end(0)) {
	      // seekables are pretty far off, rely on main
	      this.seekable_ = mainSeekable;
	    } else {
	      this.seekable_ = videojs.createTimeRanges([[audioSeekable.start(0) > mainSeekable.start(0) ? audioSeekable.start(0) : mainSeekable.start(0), audioSeekable.end(0) < mainSeekable.end(0) ? audioSeekable.end(0) : mainSeekable.end(0)]]);
	    } // seekable is the same as last time
	
	
	    if (this.seekable_ && this.seekable_.length) {
	      if (this.seekable_.end(0) === oldEnd && this.seekable_.start(0) === oldStart) {
	        return;
	      }
	    }
	
	    this.logger_("seekable updated [" + printableRange(this.seekable_) + "]");
	    this.tech_.trigger('seekablechanged');
	  }
	  /**
	   * Update the player duration
	   */
	  ;
	
	  _proto.updateDuration = function updateDuration(isLive) {
	    if (this.updateDuration_) {
	      this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
	      this.updateDuration_ = null;
	    }
	
	    if (this.mediaSource.readyState !== 'open') {
	      this.updateDuration_ = this.updateDuration.bind(this, isLive);
	      this.mediaSource.addEventListener('sourceopen', this.updateDuration_);
	      return;
	    }
	
	    if (isLive) {
	      var seekable = this.seekable();
	
	      if (!seekable.length) {
	        return;
	      } // Even in the case of a live playlist, the native MediaSource's duration should not
	      // be set to Infinity (even though this would be expected for a live playlist), since
	      // setting the native MediaSource's duration to infinity ends up with consequences to
	      // seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
	      //
	      // This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
	      // however, few browsers have support for setLiveSeekableRange()
	      // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
	      //
	      // Until a time when the duration of the media source can be set to infinity, and a
	      // seekable range specified across browsers, the duration should be greater than or
	      // equal to the last possible seekable value.
	      // MediaSource duration starts as NaN
	      // It is possible (and probable) that this case will never be reached for many
	      // sources, since the MediaSource reports duration as the highest value without
	      // accounting for timestamp offset. For example, if the timestamp offset is -100 and
	      // we buffered times 0 to 100 with real times of 100 to 200, even though current
	      // time will be between 0 and 100, the native media source may report the duration
	      // as 200. However, since we report duration separate from the media source (as
	      // Infinity), and as long as the native media source duration value is greater than
	      // our reported seekable range, seeks will work as expected. The large number as
	      // duration for live is actually a strategy used by some players to work around the
	      // issue of live seekable ranges cited above.
	
	
	      if (isNaN(this.mediaSource.duration) || this.mediaSource.duration < seekable.end(seekable.length - 1)) {
	        this.sourceUpdater_.setDuration(seekable.end(seekable.length - 1));
	      }
	
	      return;
	    }
	
	    var buffered = this.tech_.buffered();
	    var duration = Vhs$1.Playlist.duration(this.masterPlaylistLoader_.media());
	
	    if (buffered.length > 0) {
	      duration = Math.max(duration, buffered.end(buffered.length - 1));
	    }
	
	    if (this.mediaSource.duration !== duration) {
	      this.sourceUpdater_.setDuration(duration);
	    }
	  }
	  /**
	   * dispose of the MasterPlaylistController and everything
	   * that it controls
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    var _this8 = this;
	
	    this.trigger('dispose');
	    this.decrypter_.terminate();
	    this.masterPlaylistLoader_.dispose();
	    this.mainSegmentLoader_.dispose();
	
	    if (this.loadOnPlay_) {
	      this.tech_.off('play', this.loadOnPlay_);
	    }
	
	    ['AUDIO', 'SUBTITLES'].forEach(function (type) {
	      var groups = _this8.mediaTypes_[type].groups;
	
	      for (var id in groups) {
	        groups[id].forEach(function (group) {
	          if (group.playlistLoader) {
	            group.playlistLoader.dispose();
	          }
	        });
	      }
	    });
	    this.audioSegmentLoader_.dispose();
	    this.subtitleSegmentLoader_.dispose();
	    this.sourceUpdater_.dispose();
	    this.timelineChangeController_.dispose();
	    this.stopABRTimer_();
	
	    if (this.updateDuration_) {
	      this.mediaSource.removeEventListener('sourceopen', this.updateDuration_);
	    }
	
	    this.mediaSource.removeEventListener('durationchange', this.handleDurationChange_); // load the media source into the player
	
	    this.mediaSource.removeEventListener('sourceopen', this.handleSourceOpen_);
	    this.mediaSource.removeEventListener('sourceended', this.handleSourceEnded_);
	    this.off();
	  }
	  /**
	   * return the master playlist object if we have one
	   *
	   * @return {Object} the master playlist object that we parsed
	   */
	  ;
	
	  _proto.master = function master() {
	    return this.masterPlaylistLoader_.master;
	  }
	  /**
	   * return the currently selected playlist
	   *
	   * @return {Object} the currently selected playlist object that we parsed
	   */
	  ;
	
	  _proto.media = function media() {
	    // playlist loader will not return media if it has not been fully loaded
	    return this.masterPlaylistLoader_.media() || this.initialMedia_;
	  };
	
	  _proto.areMediaTypesKnown_ = function areMediaTypesKnown_() {
	    var usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
	    var hasMainMediaInfo = !!this.mainSegmentLoader_.getCurrentMediaInfo_(); // if we are not using an audio loader, then we have audio media info
	    // otherwise check on the segment loader.
	
	    var hasAudioMediaInfo = !usingAudioLoader ? true : !!this.audioSegmentLoader_.getCurrentMediaInfo_(); // one or both loaders has not loaded sufficently to get codecs
	
	    if (!hasMainMediaInfo || !hasAudioMediaInfo) {
	      return false;
	    }
	
	    return true;
	  };
	
	  _proto.getCodecsOrExclude_ = function getCodecsOrExclude_() {
	    var _this9 = this;
	
	    var media = {
	      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
	      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
	    };
	    var playlist = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media(); // set "main" media equal to video
	
	    media.video = media.main;
	    var playlistCodecs = codecsForPlaylist(this.master(), playlist);
	    var codecs = {};
	    var usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
	
	    if (media.main.hasVideo) {
	      codecs.video = playlistCodecs.video || media.main.videoCodec || codecs_js.DEFAULT_VIDEO_CODEC;
	    }
	
	    if (media.main.isMuxed) {
	      codecs.video += "," + (playlistCodecs.audio || media.main.audioCodec || codecs_js.DEFAULT_AUDIO_CODEC);
	    }
	
	    if (media.main.hasAudio && !media.main.isMuxed || media.audio.hasAudio || usingAudioLoader) {
	      codecs.audio = playlistCodecs.audio || media.main.audioCodec || media.audio.audioCodec || codecs_js.DEFAULT_AUDIO_CODEC; // set audio isFmp4 so we use the correct "supports" function below
	
	      media.audio.isFmp4 = media.main.hasAudio && !media.main.isMuxed ? media.main.isFmp4 : media.audio.isFmp4;
	    } // no codecs, no playback.
	
	
	    if (!codecs.audio && !codecs.video) {
	      this.blacklistCurrentPlaylist({
	        playlist: playlist,
	        message: 'Could not determine codecs for playlist.',
	        blacklistDuration: Infinity
	      });
	      return;
	    } // fmp4 relies on browser support, while ts relies on muxer support
	
	
	    var supportFunction = function supportFunction(isFmp4, codec) {
	      return isFmp4 ? codecs_js.browserSupportsCodec(codec) : codecs_js.muxerSupportsCodec(codec);
	    };
	
	    var unsupportedCodecs = {};
	    var unsupportedAudio;
	    ['video', 'audio'].forEach(function (type) {
	      if (codecs.hasOwnProperty(type) && !supportFunction(media[type].isFmp4, codecs[type])) {
	        var supporter = media[type].isFmp4 ? 'browser' : 'muxer';
	        unsupportedCodecs[supporter] = unsupportedCodecs[supporter] || [];
	        unsupportedCodecs[supporter].push(codecs[type]);
	
	        if (type === 'audio') {
	          unsupportedAudio = supporter;
	        }
	      }
	    });
	
	    if (usingAudioLoader && unsupportedAudio && playlist.attributes.AUDIO) {
	      var audioGroup = playlist.attributes.AUDIO;
	      this.master().playlists.forEach(function (variant) {
	        var variantAudioGroup = variant.attributes && variant.attributes.AUDIO;
	
	        if (variantAudioGroup === audioGroup && variant !== playlist) {
	          variant.excludeUntil = Infinity;
	        }
	      });
	      this.logger_("excluding audio group " + audioGroup + " as " + unsupportedAudio + " does not support codec(s): \"" + codecs.audio + "\"");
	    } // if we have any unsupported codecs blacklist this playlist.
	
	
	    if (Object.keys(unsupportedCodecs).length) {
	      var message = Object.keys(unsupportedCodecs).reduce(function (acc, supporter) {
	        if (acc) {
	          acc += ', ';
	        }
	
	        acc += supporter + " does not support codec(s): \"" + unsupportedCodecs[supporter].join(',') + "\"";
	        return acc;
	      }, '') + '.';
	      this.blacklistCurrentPlaylist({
	        playlist: playlist,
	        internal: true,
	        message: message,
	        blacklistDuration: Infinity
	      });
	      return;
	    } // check if codec switching is happening
	
	
	    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
	      var switchMessages = [];
	      ['video', 'audio'].forEach(function (type) {
	        var newCodec = (codecs_js.parseCodecs(_this9.sourceUpdater_.codecs[type] || '')[0] || {}).type;
	        var oldCodec = (codecs_js.parseCodecs(codecs[type] || '')[0] || {}).type;
	
	        if (newCodec && oldCodec && newCodec.toLowerCase() !== oldCodec.toLowerCase()) {
	          switchMessages.push("\"" + _this9.sourceUpdater_.codecs[type] + "\" -> \"" + codecs[type] + "\"");
	        }
	      });
	
	      if (switchMessages.length) {
	        this.blacklistCurrentPlaylist({
	          playlist: playlist,
	          message: "Codec switching not supported: " + switchMessages.join(', ') + ".",
	          blacklistDuration: Infinity,
	          internal: true
	        });
	        return;
	      }
	    } // TODO: when using the muxer shouldn't we just return
	    // the codecs that the muxer outputs?
	
	
	    return codecs;
	  }
	  /**
	   * Create source buffers and exlude any incompatible renditions.
	   *
	   * @private
	   */
	  ;
	
	  _proto.tryToCreateSourceBuffers_ = function tryToCreateSourceBuffers_() {
	    // media source is not ready yet or sourceBuffers are already
	    // created.
	    if (this.mediaSource.readyState !== 'open' || this.sourceUpdater_.hasCreatedSourceBuffers()) {
	      return;
	    }
	
	    if (!this.areMediaTypesKnown_()) {
	      return;
	    }
	
	    var codecs = this.getCodecsOrExclude_(); // no codecs means that the playlist was excluded
	
	    if (!codecs) {
	      return;
	    }
	
	    this.sourceUpdater_.createSourceBuffers(codecs);
	    var codecString = [codecs.video, codecs.audio].filter(Boolean).join(',');
	    this.excludeIncompatibleVariants_(codecString);
	  }
	  /**
	   * Excludes playlists with codecs that are unsupported by the muxer and browser.
	   */
	  ;
	
	  _proto.excludeUnsupportedVariants_ = function excludeUnsupportedVariants_() {
	    var _this10 = this;
	
	    var playlists = this.master().playlists;
	    var ids = []; // TODO: why don't we have a property to loop through all
	    // playlist? Why did we ever mix indexes and keys?
	
	    Object.keys(playlists).forEach(function (key) {
	      var variant = playlists[key]; // check if we already processed this playlist.
	
	      if (ids.indexOf(variant.id) !== -1) {
	        return;
	      }
	
	      ids.push(variant.id);
	      var codecs = codecsForPlaylist(_this10.master, variant);
	      var unsupported = [];
	
	      if (codecs.audio && !codecs_js.muxerSupportsCodec(codecs.audio) && !codecs_js.browserSupportsCodec(codecs.audio)) {
	        unsupported.push("audio codec " + codecs.audio);
	      }
	
	      if (codecs.video && !codecs_js.muxerSupportsCodec(codecs.video) && !codecs_js.browserSupportsCodec(codecs.video)) {
	        unsupported.push("video codec " + codecs.video);
	      }
	
	      if (codecs.text && codecs.text === 'stpp.ttml.im1t') {
	        unsupported.push("text codec " + codecs.text);
	      }
	
	      if (unsupported.length) {
	        variant.excludeUntil = Infinity;
	
	        _this10.logger_("excluding " + variant.id + " for unsupported: " + unsupported.join(', '));
	      }
	    });
	  }
	  /**
	   * Blacklist playlists that are known to be codec or
	   * stream-incompatible with the SourceBuffer configuration. For
	   * instance, Media Source Extensions would cause the video element to
	   * stall waiting for video data if you switched from a variant with
	   * video and audio to an audio-only one.
	   *
	   * @param {Object} media a media playlist compatible with the current
	   * set of SourceBuffers. Variants in the current master playlist that
	   * do not appear to have compatible codec or stream configurations
	   * will be excluded from the default playlist selection algorithm
	   * indefinitely.
	   * @private
	   */
	  ;
	
	  _proto.excludeIncompatibleVariants_ = function excludeIncompatibleVariants_(codecString) {
	    var _this11 = this;
	
	    var ids = [];
	    var playlists = this.master().playlists;
	    var codecs = unwrapCodecList(codecs_js.parseCodecs(codecString));
	    var codecCount_ = codecCount(codecs);
	    var videoDetails = codecs.video && codecs_js.parseCodecs(codecs.video)[0] || null;
	    var audioDetails = codecs.audio && codecs_js.parseCodecs(codecs.audio)[0] || null;
	    Object.keys(playlists).forEach(function (key) {
	      var variant = playlists[key]; // check if we already processed this playlist.
	      // or it if it is already excluded forever.
	
	      if (ids.indexOf(variant.id) !== -1 || variant.excludeUntil === Infinity) {
	        return;
	      }
	
	      ids.push(variant.id);
	      var blacklistReasons = []; // get codecs from the playlist for this variant
	
	      var variantCodecs = codecsForPlaylist(_this11.masterPlaylistLoader_.master, variant);
	      var variantCodecCount = codecCount(variantCodecs); // if no codecs are listed, we cannot determine that this
	      // variant is incompatible. Wait for mux.js to probe
	
	      if (!variantCodecs.audio && !variantCodecs.video) {
	        return;
	      } // TODO: we can support this by removing the
	      // old media source and creating a new one, but it will take some work.
	      // The number of streams cannot change
	
	
	      if (variantCodecCount !== codecCount_) {
	        blacklistReasons.push("codec count \"" + variantCodecCount + "\" !== \"" + codecCount_ + "\"");
	      } // only exclude playlists by codec change, if codecs cannot switch
	      // during playback.
	
	
	      if (!_this11.sourceUpdater_.canChangeType()) {
	        var variantVideoDetails = variantCodecs.video && codecs_js.parseCodecs(variantCodecs.video)[0] || null;
	        var variantAudioDetails = variantCodecs.audio && codecs_js.parseCodecs(variantCodecs.audio)[0] || null; // the video codec cannot change
	
	        if (variantVideoDetails && videoDetails && variantVideoDetails.type.toLowerCase() !== videoDetails.type.toLowerCase()) {
	          blacklistReasons.push("video codec \"" + variantVideoDetails.type + "\" !== \"" + videoDetails.type + "\"");
	        } // the audio codec cannot change
	
	
	        if (variantAudioDetails && audioDetails && variantAudioDetails.type.toLowerCase() !== audioDetails.type.toLowerCase()) {
	          blacklistReasons.push("audio codec \"" + variantAudioDetails.type + "\" !== \"" + audioDetails.type + "\"");
	        }
	      }
	
	      if (blacklistReasons.length) {
	        variant.excludeUntil = Infinity;
	
	        _this11.logger_("blacklisting " + variant.id + ": " + blacklistReasons.join(' && '));
	      }
	    });
	  };
	
	  _proto.updateAdCues_ = function updateAdCues_(media) {
	    var offset = 0;
	    var seekable = this.seekable();
	
	    if (seekable.length) {
	      offset = seekable.start(0);
	    }
	
	    updateAdCues(media, this.cueTagsTrack_, offset);
	  }
	  /**
	   * Calculates the desired forward buffer length based on current time
	   *
	   * @return {number} Desired forward buffer length in seconds
	   */
	  ;
	
	  _proto.goalBufferLength = function goalBufferLength() {
	    var currentTime = this.tech_.currentTime();
	    var initial = Config.GOAL_BUFFER_LENGTH;
	    var rate = Config.GOAL_BUFFER_LENGTH_RATE;
	    var max = Math.max(initial, Config.MAX_GOAL_BUFFER_LENGTH);
	    return Math.min(initial + currentTime * rate, max);
	  }
	  /**
	   * Calculates the desired buffer low water line based on current time
	   *
	   * @return {number} Desired buffer low water line in seconds
	   */
	  ;
	
	  _proto.bufferLowWaterLine = function bufferLowWaterLine() {
	    var currentTime = this.tech_.currentTime();
	    var initial = Config.BUFFER_LOW_WATER_LINE;
	    var rate = Config.BUFFER_LOW_WATER_LINE_RATE;
	    var max = Math.max(initial, Config.MAX_BUFFER_LOW_WATER_LINE);
	    var newMax = Math.max(initial, Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
	    return Math.min(initial + currentTime * rate, this.experimentalBufferBasedABR ? newMax : max);
	  };
	
	  _proto.bufferHighWaterLine = function bufferHighWaterLine() {
	    return Config.BUFFER_HIGH_WATER_LINE;
	  };
	
	  return MasterPlaylistController;
	}(videojs.EventTarget);
	/**
	 * Returns a function that acts as the Enable/disable playlist function.
	 *
	 * @param {PlaylistLoader} loader - The master playlist loader
	 * @param {string} playlistID - id of the playlist
	 * @param {Function} changePlaylistFn - A function to be called after a
	 * playlist's enabled-state has been changed. Will NOT be called if a
	 * playlist's enabled-state is unchanged
	 * @param {boolean=} enable - Value to set the playlist enabled-state to
	 * or if undefined returns the current enabled-state for the playlist
	 * @return {Function} Function for setting/getting enabled
	 */
	
	
	var enableFunction = function enableFunction(loader, playlistID, changePlaylistFn) {
	  return function (enable) {
	    var playlist = loader.master.playlists[playlistID];
	    var incompatible = isIncompatible(playlist);
	    var currentlyEnabled = isEnabled(playlist);
	
	    if (typeof enable === 'undefined') {
	      return currentlyEnabled;
	    }
	
	    if (enable) {
	      delete playlist.disabled;
	    } else {
	      playlist.disabled = true;
	    }
	
	    if (enable !== currentlyEnabled && !incompatible) {
	      // Ensure the outside world knows about our changes
	      changePlaylistFn();
	
	      if (enable) {
	        loader.trigger('renditionenabled');
	      } else {
	        loader.trigger('renditiondisabled');
	      }
	    }
	
	    return enable;
	  };
	};
	/**
	 * The representation object encapsulates the publicly visible information
	 * in a media playlist along with a setter/getter-type function (enabled)
	 * for changing the enabled-state of a particular playlist entry
	 *
	 * @class Representation
	 */
	
	
	var Representation = function Representation(vhsHandler, playlist, id) {
	  var mpc = vhsHandler.masterPlaylistController_,
	      smoothQualityChange = vhsHandler.options_.smoothQualityChange; // Get a reference to a bound version of the quality change function
	
	  var changeType = smoothQualityChange ? 'smooth' : 'fast';
	  var qualityChangeFunction = mpc[changeType + "QualityChange_"].bind(mpc); // some playlist attributes are optional
	
	  if (playlist.attributes) {
	    var resolution = playlist.attributes.RESOLUTION;
	    this.width = resolution && resolution.width;
	    this.height = resolution && resolution.height;
	    this.bandwidth = playlist.attributes.BANDWIDTH;
	    this.frameRate = playlist.attributes['FRAME-RATE'];
	  }
	
	  this.codecs = codecsForPlaylist(mpc.master(), playlist);
	  this.playlist = playlist; // The id is simply the ordinality of the media playlist
	  // within the master playlist
	
	  this.id = id; // Partially-apply the enableFunction to create a playlist-
	  // specific variant
	
	  this.enabled = enableFunction(vhsHandler.playlists, playlist.id, qualityChangeFunction);
	};
	/**
	 * A mixin function that adds the `representations` api to an instance
	 * of the VhsHandler class
	 *
	 * @param {VhsHandler} vhsHandler - An instance of VhsHandler to add the
	 * representation API into
	 */
	
	
	var renditionSelectionMixin = function renditionSelectionMixin(vhsHandler) {
	  // Add a single API-specific function to the VhsHandler instance
	  vhsHandler.representations = function () {
	    var master = vhsHandler.masterPlaylistController_.master();
	    var playlists = isAudioOnly(master) ? vhsHandler.masterPlaylistController_.getAudioTrackPlaylists_() : master.playlists;
	
	    if (!playlists) {
	      return [];
	    }
	
	    return playlists.filter(function (media) {
	      return !isIncompatible(media);
	    }).map(function (e, i) {
	      return new Representation(vhsHandler, e, e.id);
	    });
	  };
	};
	/**
	 * @file playback-watcher.js
	 *
	 * Playback starts, and now my watch begins. It shall not end until my death. I shall
	 * take no wait, hold no uncleared timeouts, father no bad seeks. I shall wear no crowns
	 * and win no glory. I shall live and die at my post. I am the corrector of the underflow.
	 * I am the watcher of gaps. I am the shield that guards the realms of seekable. I pledge
	 * my life and honor to the Playback Watch, for this Player and all the Players to come.
	 */
	
	
	var timerCancelEvents = ['seeking', 'seeked', 'pause', 'playing', 'error'];
	/**
	 * @class PlaybackWatcher
	 */
	
	var PlaybackWatcher = /*#__PURE__*/function () {
	  /**
	   * Represents an PlaybackWatcher object.
	   *
	   * @class
	   * @param {Object} options an object that includes the tech and settings
	   */
	  function PlaybackWatcher(options) {
	    var _this = this;
	
	    this.masterPlaylistController_ = options.masterPlaylistController;
	    this.tech_ = options.tech;
	    this.seekable = options.seekable;
	    this.allowSeeksWithinUnsafeLiveWindow = options.allowSeeksWithinUnsafeLiveWindow;
	    this.liveRangeSafeTimeDelta = options.liveRangeSafeTimeDelta;
	    this.media = options.media;
	    this.consecutiveUpdates = 0;
	    this.lastRecordedTime = null;
	    this.timer_ = null;
	    this.checkCurrentTimeTimeout_ = null;
	    this.logger_ = logger('PlaybackWatcher');
	    this.logger_('initialize');
	
	    var playHandler = function playHandler() {
	      return _this.monitorCurrentTime_();
	    };
	
	    var canPlayHandler = function canPlayHandler() {
	      return _this.monitorCurrentTime_();
	    };
	
	    var waitingHandler = function waitingHandler() {
	      return _this.techWaiting_();
	    };
	
	    var cancelTimerHandler = function cancelTimerHandler() {
	      return _this.cancelTimer_();
	    };
	
	    var mpc = this.masterPlaylistController_;
	    var loaderTypes = ['main', 'subtitle', 'audio'];
	    var loaderChecks = {};
	    loaderTypes.forEach(function (type) {
	      loaderChecks[type] = {
	        reset: function reset() {
	          return _this.resetSegmentDownloads_(type);
	        },
	        updateend: function updateend() {
	          return _this.checkSegmentDownloads_(type);
	        }
	      };
	      mpc[type + "SegmentLoader_"].on('appendsdone', loaderChecks[type].updateend); // If a rendition switch happens during a playback stall where the buffer
	      // isn't changing we want to reset. We cannot assume that the new rendition
	      // will also be stalled, until after new appends.
	
	      mpc[type + "SegmentLoader_"].on('playlistupdate', loaderChecks[type].reset); // Playback stalls should not be detected right after seeking.
	      // This prevents one segment playlists (single vtt or single segment content)
	      // from being detected as stalling. As the buffer will not change in those cases, since
	      // the buffer is the entire video duration.
	
	      _this.tech_.on(['seeked', 'seeking'], loaderChecks[type].reset);
	    });
	    /**
	     * We check if a seek was into a gap through the following steps:
	     * 1. We get a seeking event and we do not get a seeked event. This means that
	     *    a seek was attempted but not completed.
	     * 2. We run `fixesBadSeeks_` on segment loader appends. This means that we already
	     *    removed everything from our buffer and appended a segment, and should be ready
	     *    to check for gaps.
	     */
	
	    var setSeekingHandlers = function setSeekingHandlers(fn) {
	      ['main', 'audio'].forEach(function (type) {
	        mpc[type + "SegmentLoader_"][fn]('appended', _this.seekingAppendCheck_);
	      });
	    };
	
	    this.seekingAppendCheck_ = function () {
	      if (_this.fixesBadSeeks_()) {
	        _this.consecutiveUpdates = 0;
	        _this.lastRecordedTime = _this.tech_.currentTime();
	        setSeekingHandlers('off');
	      }
	    };
	
	    this.clearSeekingAppendCheck_ = function () {
	      return setSeekingHandlers('off');
	    };
	
	    this.watchForBadSeeking_ = function () {
	      _this.clearSeekingAppendCheck_();
	
	      setSeekingHandlers('on');
	    };
	
	    this.tech_.on('seeked', this.clearSeekingAppendCheck_);
	    this.tech_.on('seeking', this.watchForBadSeeking_);
	    this.tech_.on('waiting', waitingHandler);
	    this.tech_.on(timerCancelEvents, cancelTimerHandler);
	    this.tech_.on('canplay', canPlayHandler);
	    /*
	      An edge case exists that results in gaps not being skipped when they exist at the beginning of a stream. This case
	      is surfaced in one of two ways:
	       1)  The `waiting` event is fired before the player has buffered content, making it impossible
	          to find or skip the gap. The `waiting` event is followed by a `play` event. On first play
	          we can check if playback is stalled due to a gap, and skip the gap if necessary.
	      2)  A source with a gap at the beginning of the stream is loaded programatically while the player
	          is in a playing state. To catch this case, it's important that our one-time play listener is setup
	          even if the player is in a playing state
	    */
	
	    this.tech_.one('play', playHandler); // Define the dispose function to clean up our events
	
	    this.dispose = function () {
	      _this.clearSeekingAppendCheck_();
	
	      _this.logger_('dispose');
	
	      _this.tech_.off('waiting', waitingHandler);
	
	      _this.tech_.off(timerCancelEvents, cancelTimerHandler);
	
	      _this.tech_.off('canplay', canPlayHandler);
	
	      _this.tech_.off('play', playHandler);
	
	      _this.tech_.off('seeking', _this.watchForBadSeeking_);
	
	      _this.tech_.off('seeked', _this.clearSeekingAppendCheck_);
	
	      loaderTypes.forEach(function (type) {
	        mpc[type + "SegmentLoader_"].off('appendsdone', loaderChecks[type].updateend);
	        mpc[type + "SegmentLoader_"].off('playlistupdate', loaderChecks[type].reset);
	
	        _this.tech_.off(['seeked', 'seeking'], loaderChecks[type].reset);
	      });
	
	      if (_this.checkCurrentTimeTimeout_) {
	        window__default['default'].clearTimeout(_this.checkCurrentTimeTimeout_);
	      }
	
	      _this.cancelTimer_();
	    };
	  }
	  /**
	   * Periodically check current time to see if playback stopped
	   *
	   * @private
	   */
	
	
	  var _proto = PlaybackWatcher.prototype;
	
	  _proto.monitorCurrentTime_ = function monitorCurrentTime_() {
	    this.checkCurrentTime_();
	
	    if (this.checkCurrentTimeTimeout_) {
	      window__default['default'].clearTimeout(this.checkCurrentTimeTimeout_);
	    } // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
	
	
	    this.checkCurrentTimeTimeout_ = window__default['default'].setTimeout(this.monitorCurrentTime_.bind(this), 250);
	  }
	  /**
	   * Reset stalled download stats for a specific type of loader
	   *
	   * @param {string} type
	   *        The segment loader type to check.
	   *
	   * @listens SegmentLoader#playlistupdate
	   * @listens Tech#seeking
	   * @listens Tech#seeked
	   */
	  ;
	
	  _proto.resetSegmentDownloads_ = function resetSegmentDownloads_(type) {
	    var loader = this.masterPlaylistController_[type + "SegmentLoader_"];
	
	    if (this[type + "StalledDownloads_"] > 0) {
	      this.logger_("resetting possible stalled download count for " + type + " loader");
	    }
	
	    this[type + "StalledDownloads_"] = 0;
	    this[type + "Buffered_"] = loader.buffered_();
	  }
	  /**
	   * Checks on every segment `appendsdone` to see
	   * if segment appends are making progress. If they are not
	   * and we are still downloading bytes. We blacklist the playlist.
	   *
	   * @param {string} type
	   *        The segment loader type to check.
	   *
	   * @listens SegmentLoader#appendsdone
	   */
	  ;
	
	  _proto.checkSegmentDownloads_ = function checkSegmentDownloads_(type) {
	    var mpc = this.masterPlaylistController_;
	    var loader = mpc[type + "SegmentLoader_"];
	    var buffered = loader.buffered_();
	    var isBufferedDifferent = isRangeDifferent(this[type + "Buffered_"], buffered);
	    this[type + "Buffered_"] = buffered; // if another watcher is going to fix the issue or
	    // the buffered value for this loader changed
	    // appends are working
	
	    if (isBufferedDifferent) {
	      this.resetSegmentDownloads_(type);
	      return;
	    }
	
	    this[type + "StalledDownloads_"]++;
	    this.logger_("found #" + this[type + "StalledDownloads_"] + " " + type + " appends that did not increase buffer (possible stalled download)", {
	      playlistId: loader.playlist_ && loader.playlist_.id,
	      buffered: timeRangesToArray(buffered)
	    }); // after 10 possibly stalled appends with no reset, exclude
	
	    if (this[type + "StalledDownloads_"] < 10) {
	      return;
	    }
	
	    this.logger_(type + " loader stalled download exclusion");
	    this.resetSegmentDownloads_(type);
	    this.tech_.trigger({
	      type: 'usage',
	      name: "vhs-" + type + "-download-exclusion"
	    });
	
	    if (type === 'subtitle') {
	      return;
	    } // TODO: should we exclude audio tracks rather than main tracks
	    // when type is audio?
	
	
	    mpc.blacklistCurrentPlaylist({
	      message: "Excessive " + type + " segment downloading detected."
	    }, Infinity);
	  }
	  /**
	   * The purpose of this function is to emulate the "waiting" event on
	   * browsers that do not emit it when they are waiting for more
	   * data to continue playback
	   *
	   * @private
	   */
	  ;
	
	  _proto.checkCurrentTime_ = function checkCurrentTime_() {
	    if (this.tech_.paused() || this.tech_.seeking()) {
	      return;
	    }
	
	    var currentTime = this.tech_.currentTime();
	    var buffered = this.tech_.buffered();
	
	    if (this.lastRecordedTime === currentTime && (!buffered.length || currentTime + SAFE_TIME_DELTA >= buffered.end(buffered.length - 1))) {
	      // If current time is at the end of the final buffered region, then any playback
	      // stall is most likely caused by buffering in a low bandwidth environment. The tech
	      // should fire a `waiting` event in this scenario, but due to browser and tech
	      // inconsistencies. Calling `techWaiting_` here allows us to simulate
	      // responding to a native `waiting` event when the tech fails to emit one.
	      return this.techWaiting_();
	    }
	
	    if (this.consecutiveUpdates >= 5 && currentTime === this.lastRecordedTime) {
	      this.consecutiveUpdates++;
	      this.waiting_();
	    } else if (currentTime === this.lastRecordedTime) {
	      this.consecutiveUpdates++;
	    } else {
	      this.consecutiveUpdates = 0;
	      this.lastRecordedTime = currentTime;
	    }
	  }
	  /**
	   * Cancels any pending timers and resets the 'timeupdate' mechanism
	   * designed to detect that we are stalled
	   *
	   * @private
	   */
	  ;
	
	  _proto.cancelTimer_ = function cancelTimer_() {
	    this.consecutiveUpdates = 0;
	
	    if (this.timer_) {
	      this.logger_('cancelTimer_');
	      clearTimeout(this.timer_);
	    }
	
	    this.timer_ = null;
	  }
	  /**
	   * Fixes situations where there's a bad seek
	   *
	   * @return {boolean} whether an action was taken to fix the seek
	   * @private
	   */
	  ;
	
	  _proto.fixesBadSeeks_ = function fixesBadSeeks_() {
	    var seeking = this.tech_.seeking();
	
	    if (!seeking) {
	      return false;
	    } // TODO: It's possible that these seekable checks should be moved out of this function
	    // and into a function that runs on seekablechange. It's also possible that we only need
	    // afterSeekableWindow as the buffered check at the bottom is good enough to handle before
	    // seekable range.
	
	
	    var seekable = this.seekable();
	    var currentTime = this.tech_.currentTime();
	    var isAfterSeekableRange = this.afterSeekableWindow_(seekable, currentTime, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
	    var seekTo;
	
	    if (isAfterSeekableRange) {
	      var seekableEnd = seekable.end(seekable.length - 1); // sync to live point (if VOD, our seekable was updated and we're simply adjusting)
	
	      seekTo = seekableEnd;
	    }
	
	    if (this.beforeSeekableWindow_(seekable, currentTime)) {
	      var seekableStart = seekable.start(0); // sync to the beginning of the live window
	      // provide a buffer of .1 seconds to handle rounding/imprecise numbers
	
	      seekTo = seekableStart + ( // if the playlist is too short and the seekable range is an exact time (can
	      // happen in live with a 3 segment playlist), then don't use a time delta
	      seekableStart === seekable.end(0) ? 0 : SAFE_TIME_DELTA);
	    }
	
	    if (typeof seekTo !== 'undefined') {
	      this.logger_("Trying to seek outside of seekable at time " + currentTime + " with " + ("seekable range " + printableRange(seekable) + ". Seeking to ") + (seekTo + "."));
	      this.tech_.setCurrentTime(seekTo);
	      return true;
	    }
	
	    var sourceUpdater = this.masterPlaylistController_.sourceUpdater_;
	    var buffered = this.tech_.buffered();
	    var audioBuffered = sourceUpdater.audioBuffer ? sourceUpdater.audioBuffered() : null;
	    var videoBuffered = sourceUpdater.videoBuffer ? sourceUpdater.videoBuffered() : null;
	    var media = this.media(); // verify that at least two segment durations or one part duration have been
	    // appended before checking for a gap.
	
	    var minAppendedDuration = media.partTargetDuration ? media.partTargetDuration : (media.targetDuration - TIME_FUDGE_FACTOR) * 2; // verify that at least two segment durations have been
	    // appended before checking for a gap.
	
	    var bufferedToCheck = [audioBuffered, videoBuffered];
	
	    for (var i = 0; i < bufferedToCheck.length; i++) {
	      // skip null buffered
	      if (!bufferedToCheck[i]) {
	        continue;
	      }
	
	      var timeAhead = timeAheadOf(bufferedToCheck[i], currentTime); // if we are less than two video/audio segment durations or one part
	      // duration behind we haven't appended enough to call this a bad seek.
	
	      if (timeAhead < minAppendedDuration) {
	        return false;
	      }
	    }
	
	    var nextRange = findNextRange(buffered, currentTime); // we have appended enough content, but we don't have anything buffered
	    // to seek over the gap
	
	    if (nextRange.length === 0) {
	      return false;
	    }
	
	    seekTo = nextRange.start(0) + SAFE_TIME_DELTA;
	    this.logger_("Buffered region starts (" + nextRange.start(0) + ") " + (" just beyond seek point (" + currentTime + "). Seeking to " + seekTo + "."));
	    this.tech_.setCurrentTime(seekTo);
	    return true;
	  }
	  /**
	   * Handler for situations when we determine the player is waiting.
	   *
	   * @private
	   */
	  ;
	
	  _proto.waiting_ = function waiting_() {
	    if (this.techWaiting_()) {
	      return;
	    } // All tech waiting checks failed. Use last resort correction
	
	
	    var currentTime = this.tech_.currentTime();
	    var buffered = this.tech_.buffered();
	    var currentRange = findRange(buffered, currentTime); // Sometimes the player can stall for unknown reasons within a contiguous buffered
	    // region with no indication that anything is amiss (seen in Firefox). Seeking to
	    // currentTime is usually enough to kickstart the player. This checks that the player
	    // is currently within a buffered region before attempting a corrective seek.
	    // Chrome does not appear to continue `timeupdate` events after a `waiting` event
	    // until there is ~ 3 seconds of forward buffer available. PlaybackWatcher should also
	    // make sure there is ~3 seconds of forward buffer before taking any corrective action
	    // to avoid triggering an `unknownwaiting` event when the network is slow.
	
	    if (currentRange.length && currentTime + 3 <= currentRange.end(0)) {
	      this.cancelTimer_();
	      this.tech_.setCurrentTime(currentTime);
	      this.logger_("Stopped at " + currentTime + " while inside a buffered region " + ("[" + currentRange.start(0) + " -> " + currentRange.end(0) + "]. Attempting to resume ") + 'playback by seeking to the current time.'); // unknown waiting corrections may be useful for monitoring QoS
	
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-unknown-waiting'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-unknown-waiting'
	      });
	      return;
	    }
	  }
	  /**
	   * Handler for situations when the tech fires a `waiting` event
	   *
	   * @return {boolean}
	   *         True if an action (or none) was needed to correct the waiting. False if no
	   *         checks passed
	   * @private
	   */
	  ;
	
	  _proto.techWaiting_ = function techWaiting_() {
	    var seekable = this.seekable();
	    var currentTime = this.tech_.currentTime();
	
	    if (this.tech_.seeking() || this.timer_ !== null) {
	      // Tech is seeking or already waiting on another action, no action needed
	      return true;
	    }
	
	    if (this.beforeSeekableWindow_(seekable, currentTime)) {
	      var livePoint = seekable.end(seekable.length - 1);
	      this.logger_("Fell out of live window at time " + currentTime + ". Seeking to " + ("live point (seekable end) " + livePoint));
	      this.cancelTimer_();
	      this.tech_.setCurrentTime(livePoint); // live window resyncs may be useful for monitoring QoS
	
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-live-resync'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-live-resync'
	      });
	      return true;
	    }
	
	    var sourceUpdater = this.tech_.vhs.masterPlaylistController_.sourceUpdater_;
	    var buffered = this.tech_.buffered();
	    var videoUnderflow = this.videoUnderflow_({
	      audioBuffered: sourceUpdater.audioBuffered(),
	      videoBuffered: sourceUpdater.videoBuffered(),
	      currentTime: currentTime
	    });
	
	    if (videoUnderflow) {
	      // Even though the video underflowed and was stuck in a gap, the audio overplayed
	      // the gap, leading currentTime into a buffered range. Seeking to currentTime
	      // allows the video to catch up to the audio position without losing any audio
	      // (only suffering ~3 seconds of frozen video and a pause in audio playback).
	      this.cancelTimer_();
	      this.tech_.setCurrentTime(currentTime); // video underflow may be useful for monitoring QoS
	
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'vhs-video-underflow'
	      });
	      this.tech_.trigger({
	        type: 'usage',
	        name: 'hls-video-underflow'
	      });
	      return true;
	    }
	
	    var nextRange = findNextRange(buffered, currentTime); // check for gap
	
	    if (nextRange.length > 0) {
	      var difference = nextRange.start(0) - currentTime;
	      this.logger_("Stopped at " + currentTime + ", setting timer for " + difference + ", seeking " + ("to " + nextRange.start(0)));
	      this.cancelTimer_();
	      this.timer_ = setTimeout(this.skipTheGap_.bind(this), difference * 1000, currentTime);
	      return true;
	    } // All checks failed. Returning false to indicate failure to correct waiting
	
	
	    return false;
	  };
	
	  _proto.afterSeekableWindow_ = function afterSeekableWindow_(seekable, currentTime, playlist, allowSeeksWithinUnsafeLiveWindow) {
	    if (allowSeeksWithinUnsafeLiveWindow === void 0) {
	      allowSeeksWithinUnsafeLiveWindow = false;
	    }
	
	    if (!seekable.length) {
	      // we can't make a solid case if there's no seekable, default to false
	      return false;
	    }
	
	    var allowedEnd = seekable.end(seekable.length - 1) + SAFE_TIME_DELTA;
	    var isLive = !playlist.endList;
	
	    if (isLive && allowSeeksWithinUnsafeLiveWindow) {
	      allowedEnd = seekable.end(seekable.length - 1) + playlist.targetDuration * 3;
	    }
	
	    if (currentTime > allowedEnd) {
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.beforeSeekableWindow_ = function beforeSeekableWindow_(seekable, currentTime) {
	    if (seekable.length && // can't fall before 0 and 0 seekable start identifies VOD stream
	    seekable.start(0) > 0 && currentTime < seekable.start(0) - this.liveRangeSafeTimeDelta) {
	      return true;
	    }
	
	    return false;
	  };
	
	  _proto.videoUnderflow_ = function videoUnderflow_(_ref) {
	    var videoBuffered = _ref.videoBuffered,
	        audioBuffered = _ref.audioBuffered,
	        currentTime = _ref.currentTime; // audio only content will not have video underflow :)
	
	    if (!videoBuffered) {
	      return;
	    }
	
	    var gap; // find a gap in demuxed content.
	
	    if (videoBuffered.length && audioBuffered.length) {
	      // in Chrome audio will continue to play for ~3s when we run out of video
	      // so we have to check that the video buffer did have some buffer in the
	      // past.
	      var lastVideoRange = findRange(videoBuffered, currentTime - 3);
	      var videoRange = findRange(videoBuffered, currentTime);
	      var audioRange = findRange(audioBuffered, currentTime);
	
	      if (audioRange.length && !videoRange.length && lastVideoRange.length) {
	        gap = {
	          start: lastVideoRange.end(0),
	          end: audioRange.end(0)
	        };
	      } // find a gap in muxed content.
	
	    } else {
	      var nextRange = findNextRange(videoBuffered, currentTime); // Even if there is no available next range, there is still a possibility we are
	      // stuck in a gap due to video underflow.
	
	      if (!nextRange.length) {
	        gap = this.gapFromVideoUnderflow_(videoBuffered, currentTime);
	      }
	    }
	
	    if (gap) {
	      this.logger_("Encountered a gap in video from " + gap.start + " to " + gap.end + ". " + ("Seeking to current time " + currentTime));
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * Timer callback. If playback still has not proceeded, then we seek
	   * to the start of the next buffered region.
	   *
	   * @private
	   */
	  ;
	
	  _proto.skipTheGap_ = function skipTheGap_(scheduledCurrentTime) {
	    var buffered = this.tech_.buffered();
	    var currentTime = this.tech_.currentTime();
	    var nextRange = findNextRange(buffered, currentTime);
	    this.cancelTimer_();
	
	    if (nextRange.length === 0 || currentTime !== scheduledCurrentTime) {
	      return;
	    }
	
	    this.logger_('skipTheGap_:', 'currentTime:', currentTime, 'scheduled currentTime:', scheduledCurrentTime, 'nextRange start:', nextRange.start(0)); // only seek if we still have not played
	
	    this.tech_.setCurrentTime(nextRange.start(0) + TIME_FUDGE_FACTOR);
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'vhs-gap-skip'
	    });
	    this.tech_.trigger({
	      type: 'usage',
	      name: 'hls-gap-skip'
	    });
	  };
	
	  _proto.gapFromVideoUnderflow_ = function gapFromVideoUnderflow_(buffered, currentTime) {
	    // At least in Chrome, if there is a gap in the video buffer, the audio will continue
	    // playing for ~3 seconds after the video gap starts. This is done to account for
	    // video buffer underflow/underrun (note that this is not done when there is audio
	    // buffer underflow/underrun -- in that case the video will stop as soon as it
	    // encounters the gap, as audio stalls are more noticeable/jarring to a user than
	    // video stalls). The player's time will reflect the playthrough of audio, so the
	    // time will appear as if we are in a buffered region, even if we are stuck in a
	    // "gap."
	    //
	    // Example:
	    // video buffer:   0 => 10.1, 10.2 => 20
	    // audio buffer:   0 => 20
	    // overall buffer: 0 => 10.1, 10.2 => 20
	    // current time: 13
	    //
	    // Chrome's video froze at 10 seconds, where the video buffer encountered the gap,
	    // however, the audio continued playing until it reached ~3 seconds past the gap
	    // (13 seconds), at which point it stops as well. Since current time is past the
	    // gap, findNextRange will return no ranges.
	    //
	    // To check for this issue, we see if there is a gap that starts somewhere within
	    // a 3 second range (3 seconds +/- 1 second) back from our current time.
	    var gaps = findGaps(buffered);
	
	    for (var i = 0; i < gaps.length; i++) {
	      var start = gaps.start(i);
	      var end = gaps.end(i); // gap is starts no more than 4 seconds back
	
	      if (currentTime - start < 4 && currentTime - start > 2) {
	        return {
	          start: start,
	          end: end
	        };
	      }
	    }
	
	    return null;
	  };
	
	  return PlaybackWatcher;
	}();
	
	var defaultOptions = {
	  errorInterval: 30,
	  getSource: function getSource(next) {
	    var tech = this.tech({
	      IWillNotUseThisInPlugins: true
	    });
	    var sourceObj = tech.currentSource_ || this.currentSource();
	    return next(sourceObj);
	  }
	};
	/**
	 * Main entry point for the plugin
	 *
	 * @param {Player} player a reference to a videojs Player instance
	 * @param {Object} [options] an object with plugin options
	 * @private
	 */
	
	var initPlugin = function initPlugin(player, options) {
	  var lastCalled = 0;
	  var seekTo = 0;
	  var localOptions = videojs.mergeOptions(defaultOptions, options);
	  player.ready(function () {
	    player.trigger({
	      type: 'usage',
	      name: 'vhs-error-reload-initialized'
	    });
	    player.trigger({
	      type: 'usage',
	      name: 'hls-error-reload-initialized'
	    });
	  });
	  /**
	   * Player modifications to perform that must wait until `loadedmetadata`
	   * has been triggered
	   *
	   * @private
	   */
	
	  var loadedMetadataHandler = function loadedMetadataHandler() {
	    if (seekTo) {
	      player.currentTime(seekTo);
	    }
	  };
	  /**
	   * Set the source on the player element, play, and seek if necessary
	   *
	   * @param {Object} sourceObj An object specifying the source url and mime-type to play
	   * @private
	   */
	
	
	  var setSource = function setSource(sourceObj) {
	    if (sourceObj === null || sourceObj === undefined) {
	      return;
	    }
	
	    seekTo = player.duration() !== Infinity && player.currentTime() || 0;
	    player.one('loadedmetadata', loadedMetadataHandler);
	    player.src(sourceObj);
	    player.trigger({
	      type: 'usage',
	      name: 'vhs-error-reload'
	    });
	    player.trigger({
	      type: 'usage',
	      name: 'hls-error-reload'
	    });
	    player.play();
	  };
	  /**
	   * Attempt to get a source from either the built-in getSource function
	   * or a custom function provided via the options
	   *
	   * @private
	   */
	
	
	  var errorHandler = function errorHandler() {
	    // Do not attempt to reload the source if a source-reload occurred before
	    // 'errorInterval' time has elapsed since the last source-reload
	    if (Date.now() - lastCalled < localOptions.errorInterval * 1000) {
	      player.trigger({
	        type: 'usage',
	        name: 'vhs-error-reload-canceled'
	      });
	      player.trigger({
	        type: 'usage',
	        name: 'hls-error-reload-canceled'
	      });
	      return;
	    }
	
	    if (!localOptions.getSource || typeof localOptions.getSource !== 'function') {
	      videojs.log.error('ERROR: reloadSourceOnError - The option getSource must be a function!');
	      return;
	    }
	
	    lastCalled = Date.now();
	    return localOptions.getSource.call(player, setSource);
	  };
	  /**
	   * Unbind any event handlers that were bound by the plugin
	   *
	   * @private
	   */
	
	
	  var cleanupEvents = function cleanupEvents() {
	    player.off('loadedmetadata', loadedMetadataHandler);
	    player.off('error', errorHandler);
	    player.off('dispose', cleanupEvents);
	  };
	  /**
	   * Cleanup before re-initializing the plugin
	   *
	   * @param {Object} [newOptions] an object with plugin options
	   * @private
	   */
	
	
	  var reinitPlugin = function reinitPlugin(newOptions) {
	    cleanupEvents();
	    initPlugin(player, newOptions);
	  };
	
	  player.on('error', errorHandler);
	  player.on('dispose', cleanupEvents); // Overwrite the plugin function so that we can correctly cleanup before
	  // initializing the plugin
	
	  player.reloadSourceOnError = reinitPlugin;
	};
	/**
	 * Reload the source when an error is detected as long as there
	 * wasn't an error previously within the last 30 seconds
	 *
	 * @param {Object} [options] an object with plugin options
	 */
	
	
	var reloadSourceOnError = function reloadSourceOnError(options) {
	  initPlugin(this, options);
	};
	
	var version$4 = "2.16.2";
	var version$3 = "6.0.1";
	var version$2 = "0.22.1";
	var version$1 = "4.8.0";
	var version = "3.1.3";
	var Vhs = {
	  PlaylistLoader: PlaylistLoader,
	  Playlist: Playlist,
	  utils: utils,
	  STANDARD_PLAYLIST_SELECTOR: lastBandwidthSelector,
	  INITIAL_PLAYLIST_SELECTOR: lowestBitrateCompatibleVariantSelector,
	  lastBandwidthSelector: lastBandwidthSelector,
	  movingAverageBandwidthSelector: movingAverageBandwidthSelector,
	  comparePlaylistBandwidth: comparePlaylistBandwidth,
	  comparePlaylistResolution: comparePlaylistResolution,
	  xhr: xhrFactory()
	}; // Define getter/setters for config properties
	
	Object.keys(Config).forEach(function (prop) {
	  Object.defineProperty(Vhs, prop, {
	    get: function get() {
	      videojs.log.warn("using Vhs." + prop + " is UNSAFE be sure you know what you are doing");
	      return Config[prop];
	    },
	    set: function set(value) {
	      videojs.log.warn("using Vhs." + prop + " is UNSAFE be sure you know what you are doing");
	
	      if (typeof value !== 'number' || value < 0) {
	        videojs.log.warn("value of Vhs." + prop + " must be greater than or equal to 0");
	        return;
	      }
	
	      Config[prop] = value;
	    }
	  });
	});
	var LOCAL_STORAGE_KEY = 'videojs-vhs';
	/**
	 * Updates the selectedIndex of the QualityLevelList when a mediachange happens in vhs.
	 *
	 * @param {QualityLevelList} qualityLevels The QualityLevelList to update.
	 * @param {PlaylistLoader} playlistLoader PlaylistLoader containing the new media info.
	 * @function handleVhsMediaChange
	 */
	
	var handleVhsMediaChange = function handleVhsMediaChange(qualityLevels, playlistLoader) {
	  var newPlaylist = playlistLoader.media();
	  var selectedIndex = -1;
	
	  for (var i = 0; i < qualityLevels.length; i++) {
	    if (qualityLevels[i].id === newPlaylist.id) {
	      selectedIndex = i;
	      break;
	    }
	  }
	
	  qualityLevels.selectedIndex_ = selectedIndex;
	  qualityLevels.trigger({
	    selectedIndex: selectedIndex,
	    type: 'change'
	  });
	};
	/**
	 * Adds quality levels to list once playlist metadata is available
	 *
	 * @param {QualityLevelList} qualityLevels The QualityLevelList to attach events to.
	 * @param {Object} vhs Vhs object to listen to for media events.
	 * @function handleVhsLoadedMetadata
	 */
	
	
	var handleVhsLoadedMetadata = function handleVhsLoadedMetadata(qualityLevels, vhs) {
	  vhs.representations().forEach(function (rep) {
	    qualityLevels.addQualityLevel(rep);
	  });
	  handleVhsMediaChange(qualityLevels, vhs.playlists);
	}; // HLS is a source handler, not a tech. Make sure attempts to use it
	// as one do not cause exceptions.
	
	
	Vhs.canPlaySource = function () {
	  return videojs.log.warn('HLS is no longer a tech. Please remove it from ' + 'your player\'s techOrder.');
	};
	
	var emeKeySystems = function emeKeySystems(keySystemOptions, mainPlaylist, audioPlaylist) {
	  if (!keySystemOptions) {
	    return keySystemOptions;
	  }
	
	  var codecs = {};
	
	  if (mainPlaylist && mainPlaylist.attributes && mainPlaylist.attributes.CODECS) {
	    codecs = unwrapCodecList(codecs_js.parseCodecs(mainPlaylist.attributes.CODECS));
	  }
	
	  if (audioPlaylist && audioPlaylist.attributes && audioPlaylist.attributes.CODECS) {
	    codecs.audio = audioPlaylist.attributes.CODECS;
	  }
	
	  var videoContentType = codecs_js.getMimeForCodec(codecs.video);
	  var audioContentType = codecs_js.getMimeForCodec(codecs.audio); // upsert the content types based on the selected playlist
	
	  var keySystemContentTypes = {};
	
	  for (var keySystem in keySystemOptions) {
	    keySystemContentTypes[keySystem] = {};
	
	    if (audioContentType) {
	      keySystemContentTypes[keySystem].audioContentType = audioContentType;
	    }
	
	    if (videoContentType) {
	      keySystemContentTypes[keySystem].videoContentType = videoContentType;
	    } // Default to using the video playlist's PSSH even though they may be different, as
	    // videojs-contrib-eme will only accept one in the options.
	    //
	    // This shouldn't be an issue for most cases as early intialization will handle all
	    // unique PSSH values, and if they aren't, then encrypted events should have the
	    // specific information needed for the unique license.
	
	
	    if (mainPlaylist.contentProtection && mainPlaylist.contentProtection[keySystem] && mainPlaylist.contentProtection[keySystem].pssh) {
	      keySystemContentTypes[keySystem].pssh = mainPlaylist.contentProtection[keySystem].pssh;
	    } // videojs-contrib-eme accepts the option of specifying: 'com.some.cdm': 'url'
	    // so we need to prevent overwriting the URL entirely
	
	
	    if (typeof keySystemOptions[keySystem] === 'string') {
	      keySystemContentTypes[keySystem].url = keySystemOptions[keySystem];
	    }
	  }
	
	  return videojs.mergeOptions(keySystemOptions, keySystemContentTypes);
	};
	/**
	 * @typedef {Object} KeySystems
	 *
	 * keySystems configuration for https://github.com/videojs/videojs-contrib-eme
	 * Note: not all options are listed here.
	 *
	 * @property {Uint8Array} [pssh]
	 *           Protection System Specific Header
	 */
	
	/**
	 * Goes through all the playlists and collects an array of KeySystems options objects
	 * containing each playlist's keySystems and their pssh values, if available.
	 *
	 * @param {Object[]} playlists
	 *        The playlists to look through
	 * @param {string[]} keySystems
	 *        The keySystems to collect pssh values for
	 *
	 * @return {KeySystems[]}
	 *         An array of KeySystems objects containing available key systems and their
	 *         pssh values
	 */
	
	
	var getAllPsshKeySystemsOptions = function getAllPsshKeySystemsOptions(playlists, keySystems) {
	  return playlists.reduce(function (keySystemsArr, playlist) {
	    if (!playlist.contentProtection) {
	      return keySystemsArr;
	    }
	
	    var keySystemsOptions = keySystems.reduce(function (keySystemsObj, keySystem) {
	      var keySystemOptions = playlist.contentProtection[keySystem];
	
	      if (keySystemOptions && keySystemOptions.pssh) {
	        keySystemsObj[keySystem] = {
	          pssh: keySystemOptions.pssh
	        };
	      }
	
	      return keySystemsObj;
	    }, {});
	
	    if (Object.keys(keySystemsOptions).length) {
	      keySystemsArr.push(keySystemsOptions);
	    }
	
	    return keySystemsArr;
	  }, []);
	};
	/**
	 * Returns a promise that waits for the
	 * [eme plugin](https://github.com/videojs/videojs-contrib-eme) to create a key session.
	 *
	 * Works around https://bugs.chromium.org/p/chromium/issues/detail?id=895449 in non-IE11
	 * browsers.
	 *
	 * As per the above ticket, this is particularly important for Chrome, where, if
	 * unencrypted content is appended before encrypted content and the key session has not
	 * been created, a MEDIA_ERR_DECODE will be thrown once the encrypted content is reached
	 * during playback.
	 *
	 * @param {Object} player
	 *        The player instance
	 * @param {Object[]} sourceKeySystems
	 *        The key systems options from the player source
	 * @param {Object} [audioMedia]
	 *        The active audio media playlist (optional)
	 * @param {Object[]} mainPlaylists
	 *        The playlists found on the master playlist object
	 *
	 * @return {Object}
	 *         Promise that resolves when the key session has been created
	 */
	
	
	var waitForKeySessionCreation = function waitForKeySessionCreation(_ref) {
	  var player = _ref.player,
	      sourceKeySystems = _ref.sourceKeySystems,
	      audioMedia = _ref.audioMedia,
	      mainPlaylists = _ref.mainPlaylists;
	
	  if (!player.eme.initializeMediaKeys) {
	    return Promise.resolve();
	  } // TODO should all audio PSSH values be initialized for DRM?
	  //
	  // All unique video rendition pssh values are initialized for DRM, but here only
	  // the initial audio playlist license is initialized. In theory, an encrypted
	  // event should be fired if the user switches to an alternative audio playlist
	  // where a license is required, but this case hasn't yet been tested. In addition, there
	  // may be many alternate audio playlists unlikely to be used (e.g., multiple different
	  // languages).
	
	
	  var playlists = audioMedia ? mainPlaylists.concat([audioMedia]) : mainPlaylists;
	  var keySystemsOptionsArr = getAllPsshKeySystemsOptions(playlists, Object.keys(sourceKeySystems));
	  var initializationFinishedPromises = [];
	  var keySessionCreatedPromises = []; // Since PSSH values are interpreted as initData, EME will dedupe any duplicates. The
	  // only place where it should not be deduped is for ms-prefixed APIs, but the early
	  // return for IE11 above, and the existence of modern EME APIs in addition to
	  // ms-prefixed APIs on Edge should prevent this from being a concern.
	  // initializeMediaKeys also won't use the webkit-prefixed APIs.
	
	  keySystemsOptionsArr.forEach(function (keySystemsOptions) {
	    keySessionCreatedPromises.push(new Promise(function (resolve, reject) {
	      player.tech_.one('keysessioncreated', resolve);
	    }));
	    initializationFinishedPromises.push(new Promise(function (resolve, reject) {
	      player.eme.initializeMediaKeys({
	        keySystems: keySystemsOptions
	      }, function (err) {
	        if (err) {
	          reject(err);
	          return;
	        }
	
	        resolve();
	      });
	    }));
	  }); // The reasons Promise.race is chosen over Promise.any:
	  //
	  // * Promise.any is only available in Safari 14+.
	  // * None of these promises are expected to reject. If they do reject, it might be
	  //   better here for the race to surface the rejection, rather than mask it by using
	  //   Promise.any.
	
	  return Promise.race([// If a session was previously created, these will all finish resolving without
	  // creating a new session, otherwise it will take until the end of all license
	  // requests, which is why the key session check is used (to make setup much faster).
	  Promise.all(initializationFinishedPromises), // Once a single session is created, the browser knows DRM will be used.
	  Promise.race(keySessionCreatedPromises)]);
	};
	/**
	 * If the [eme](https://github.com/videojs/videojs-contrib-eme) plugin is available, and
	 * there are keySystems on the source, sets up source options to prepare the source for
	 * eme.
	 *
	 * @param {Object} player
	 *        The player instance
	 * @param {Object[]} sourceKeySystems
	 *        The key systems options from the player source
	 * @param {Object} media
	 *        The active media playlist
	 * @param {Object} [audioMedia]
	 *        The active audio media playlist (optional)
	 *
	 * @return {boolean}
	 *         Whether or not options were configured and EME is available
	 */
	
	
	var setupEmeOptions = function setupEmeOptions(_ref2) {
	  var player = _ref2.player,
	      sourceKeySystems = _ref2.sourceKeySystems,
	      media = _ref2.media,
	      audioMedia = _ref2.audioMedia;
	  var sourceOptions = emeKeySystems(sourceKeySystems, media, audioMedia);
	
	  if (!sourceOptions) {
	    return false;
	  }
	
	  player.currentSource().keySystems = sourceOptions; // eme handles the rest of the setup, so if it is missing
	  // do nothing.
	
	  if (sourceOptions && !player.eme) {
	    videojs.log.warn('DRM encrypted source cannot be decrypted without a DRM plugin');
	    return false;
	  }
	
	  return true;
	};
	
	var getVhsLocalStorage = function getVhsLocalStorage() {
	  if (!window__default['default'].localStorage) {
	    return null;
	  }
	
	  var storedObject = window__default['default'].localStorage.getItem(LOCAL_STORAGE_KEY);
	
	  if (!storedObject) {
	    return null;
	  }
	
	  try {
	    return JSON.parse(storedObject);
	  } catch (e) {
	    // someone may have tampered with the value
	    return null;
	  }
	};
	
	var updateVhsLocalStorage = function updateVhsLocalStorage(options) {
	  if (!window__default['default'].localStorage) {
	    return false;
	  }
	
	  var objectToStore = getVhsLocalStorage();
	  objectToStore = objectToStore ? videojs.mergeOptions(objectToStore, options) : options;
	
	  try {
	    window__default['default'].localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(objectToStore));
	  } catch (e) {
	    // Throws if storage is full (e.g., always on iOS 5+ Safari private mode, where
	    // storage is set to 0).
	    // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem#Exceptions
	    // No need to perform any operation.
	    return false;
	  }
	
	  return objectToStore;
	};
	/**
	 * Parses VHS-supported media types from data URIs. See
	 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
	 * for information on data URIs.
	 *
	 * @param {string} dataUri
	 *        The data URI
	 *
	 * @return {string|Object}
	 *         The parsed object/string, or the original string if no supported media type
	 *         was found
	 */
	
	
	var expandDataUri = function expandDataUri(dataUri) {
	  if (dataUri.toLowerCase().indexOf('data:application/vnd.videojs.vhs+json,') === 0) {
	    return JSON.parse(dataUri.substring(dataUri.indexOf(',') + 1));
	  } // no known case for this data URI, return the string as-is
	
	
	  return dataUri;
	};
	/**
	 * Whether the browser has built-in HLS support.
	 */
	
	
	Vhs.supportsNativeHls = function () {
	  if (!document__default['default'] || !document__default['default'].createElement) {
	    return false;
	  }
	
	  var video = document__default['default'].createElement('video'); // native HLS is definitely not supported if HTML5 video isn't
	
	  if (!videojs.getTech('Html5').isSupported()) {
	    return false;
	  } // HLS manifests can go by many mime-types
	
	
	  var canPlay = [// Apple santioned
	  'application/vnd.apple.mpegurl', // Apple sanctioned for backwards compatibility
	  'audio/mpegurl', // Very common
	  'audio/x-mpegurl', // Very common
	  'application/x-mpegurl', // Included for completeness
	  'video/x-mpegurl', 'video/mpegurl', 'application/mpegurl'];
	  return canPlay.some(function (canItPlay) {
	    return /maybe|probably/i.test(video.canPlayType(canItPlay));
	  });
	}();
	
	Vhs.supportsNativeDash = function () {
	  if (!document__default['default'] || !document__default['default'].createElement || !videojs.getTech('Html5').isSupported()) {
	    return false;
	  }
	
	  return /maybe|probably/i.test(document__default['default'].createElement('video').canPlayType('application/dash+xml'));
	}();
	
	Vhs.supportsTypeNatively = function (type) {
	  if (type === 'hls') {
	    return Vhs.supportsNativeHls;
	  }
	
	  if (type === 'dash') {
	    return Vhs.supportsNativeDash;
	  }
	
	  return false;
	};
	/**
	 * HLS is a source handler, not a tech. Make sure attempts to use it
	 * as one do not cause exceptions.
	 */
	
	
	Vhs.isSupported = function () {
	  return videojs.log.warn('HLS is no longer a tech. Please remove it from ' + 'your player\'s techOrder.');
	};
	
	var Component = videojs.getComponent('Component');
	/**
	 * The Vhs Handler object, where we orchestrate all of the parts
	 * of HLS to interact with video.js
	 *
	 * @class VhsHandler
	 * @extends videojs.Component
	 * @param {Object} source the soruce object
	 * @param {Tech} tech the parent tech object
	 * @param {Object} options optional and required options
	 */
	
	var VhsHandler = /*#__PURE__*/function (_Component) {
	  _inheritsLoose__default['default'](VhsHandler, _Component);
	
	  function VhsHandler(source, tech, options) {
	    var _this;
	
	    _this = _Component.call(this, tech, videojs.mergeOptions(options.hls, options.vhs)) || this;
	
	    if (options.hls && Object.keys(options.hls).length) {
	      videojs.log.warn('Using hls options is deprecated. Please rename `hls` to `vhs` in your options object.');
	    } // if a tech level `initialBandwidth` option was passed
	    // use that over the VHS level `bandwidth` option
	
	
	    if (typeof options.initialBandwidth === 'number') {
	      _this.options_.bandwidth = options.initialBandwidth;
	    }
	
	    _this.logger_ = logger('VhsHandler'); // tech.player() is deprecated but setup a reference to HLS for
	    // backwards-compatibility
	
	    if (tech.options_ && tech.options_.playerId) {
	      var _player = videojs(tech.options_.playerId);
	
	      if (!_player.hasOwnProperty('hls')) {
	        Object.defineProperty(_player, 'hls', {
	          get: function get() {
	            videojs.log.warn('player.hls is deprecated. Use player.tech().vhs instead.');
	            tech.trigger({
	              type: 'usage',
	              name: 'hls-player-access'
	            });
	            return _assertThisInitialized__default['default'](_this);
	          },
	          configurable: true
	        });
	      }
	
	      if (!_player.hasOwnProperty('vhs')) {
	        Object.defineProperty(_player, 'vhs', {
	          get: function get() {
	            videojs.log.warn('player.vhs is deprecated. Use player.tech().vhs instead.');
	            tech.trigger({
	              type: 'usage',
	              name: 'vhs-player-access'
	            });
	            return _assertThisInitialized__default['default'](_this);
	          },
	          configurable: true
	        });
	      }
	
	      if (!_player.hasOwnProperty('dash')) {
	        Object.defineProperty(_player, 'dash', {
	          get: function get() {
	            videojs.log.warn('player.dash is deprecated. Use player.tech().vhs instead.');
	            return _assertThisInitialized__default['default'](_this);
	          },
	          configurable: true
	        });
	      }
	
	      _this.player_ = _player;
	    }
	
	    _this.tech_ = tech;
	    _this.source_ = source;
	    _this.stats = {};
	    _this.ignoreNextSeekingEvent_ = false;
	
	    _this.setOptions_();
	
	    if (_this.options_.overrideNative && tech.overrideNativeAudioTracks && tech.overrideNativeVideoTracks) {
	      tech.overrideNativeAudioTracks(true);
	      tech.overrideNativeVideoTracks(true);
	    } else if (_this.options_.overrideNative && (tech.featuresNativeVideoTracks || tech.featuresNativeAudioTracks)) {
	      // overriding native HLS only works if audio tracks have been emulated
	      // error early if we're misconfigured
	      throw new Error('Overriding native HLS requires emulated tracks. ' + 'See https://git.io/vMpjB');
	    } // listen for fullscreenchange events for this player so that we
	    // can adjust our quality selection quickly
	
	
	    _this.on(document__default['default'], ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'], function (event) {
	      var fullscreenElement = document__default['default'].fullscreenElement || document__default['default'].webkitFullscreenElement || document__default['default'].mozFullScreenElement || document__default['default'].msFullscreenElement;
	
	      if (fullscreenElement && fullscreenElement.contains(_this.tech_.el())) {
	        _this.masterPlaylistController_.fastQualityChange_();
	      } else {
	        // When leaving fullscreen, since the in page pixel dimensions should be smaller
	        // than full screen, see if there should be a rendition switch down to preserve
	        // bandwidth.
	        _this.masterPlaylistController_.checkABR_();
	      }
	    });
	
	    _this.on(_this.tech_, 'seeking', function () {
	      if (this.ignoreNextSeekingEvent_) {
	        this.ignoreNextSeekingEvent_ = false;
	        return;
	      }
	
	      this.setCurrentTime(this.tech_.currentTime());
	    });
	
	    _this.on(_this.tech_, 'error', function () {
	      // verify that the error was real and we are loaded
	      // enough to have mpc loaded.
	      if (this.tech_.error() && this.masterPlaylistController_) {
	        this.masterPlaylistController_.pauseLoading();
	      }
	    });
	
	    _this.on(_this.tech_, 'play', _this.play);
	
	    return _this;
	  }
	
	  var _proto = VhsHandler.prototype;
	
	  _proto.setOptions_ = function setOptions_() {
	    var _this2 = this; // defaults
	
	
	    this.options_.withCredentials = this.options_.withCredentials || false;
	    this.options_.handleManifestRedirects = this.options_.handleManifestRedirects === false ? false : true;
	    this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions === false ? false : true;
	    this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || false;
	    this.options_.smoothQualityChange = this.options_.smoothQualityChange || false;
	    this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage !== 'undefined' ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || false;
	    this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || false;
	    this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || false;
	    this.options_.customTagParsers = this.options_.customTagParsers || [];
	    this.options_.customTagMappers = this.options_.customTagMappers || [];
	    this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || false;
	
	    if (typeof this.options_.blacklistDuration !== 'number') {
	      this.options_.blacklistDuration = 5 * 60;
	    }
	
	    if (typeof this.options_.bandwidth !== 'number') {
	      if (this.options_.useBandwidthFromLocalStorage) {
	        var storedObject = getVhsLocalStorage();
	
	        if (storedObject && storedObject.bandwidth) {
	          this.options_.bandwidth = storedObject.bandwidth;
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'vhs-bandwidth-from-local-storage'
	          });
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'hls-bandwidth-from-local-storage'
	          });
	        }
	
	        if (storedObject && storedObject.throughput) {
	          this.options_.throughput = storedObject.throughput;
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'vhs-throughput-from-local-storage'
	          });
	          this.tech_.trigger({
	            type: 'usage',
	            name: 'hls-throughput-from-local-storage'
	          });
	        }
	      }
	    } // if bandwidth was not set by options or pulled from local storage, start playlist
	    // selection at a reasonable bandwidth
	
	
	    if (typeof this.options_.bandwidth !== 'number') {
	      this.options_.bandwidth = Config.INITIAL_BANDWIDTH;
	    } // If the bandwidth number is unchanged from the initial setting
	    // then this takes precedence over the enableLowInitialPlaylist option
	
	
	    this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Config.INITIAL_BANDWIDTH; // grab options passed to player.src
	
	    ['withCredentials', 'useDevicePixelRatio', 'limitRenditionByPlayerDimensions', 'bandwidth', 'smoothQualityChange', 'customTagParsers', 'customTagMappers', 'handleManifestRedirects', 'cacheEncryptionKeys', 'playlistSelector', 'initialPlaylistSelector', 'experimentalBufferBasedABR', 'liveRangeSafeTimeDelta', 'experimentalLLHLS', 'useNetworkInformationApi', 'useDtsForTimestampOffset', 'experimentalExactManifestTimings', 'experimentalLeastPixelDiffSelector'].forEach(function (option) {
	      if (typeof _this2.source_[option] !== 'undefined') {
	        _this2.options_[option] = _this2.source_[option];
	      }
	    });
	    this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions;
	    this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
	  }
	  /**
	   * called when player.src gets called, handle a new source
	   *
	   * @param {Object} src the source object to handle
	   */
	  ;
	
	  _proto.src = function src(_src, type) {
	    var _this3 = this; // do nothing if the src is falsey
	
	
	    if (!_src) {
	      return;
	    }
	
	    this.setOptions_(); // add master playlist controller options
	
	    this.options_.src = expandDataUri(this.source_.src);
	    this.options_.tech = this.tech_;
	    this.options_.externVhs = Vhs;
	    this.options_.sourceType = mediaTypes_js.simpleTypeFromSourceType(type); // Whenever we seek internally, we should update the tech
	
	    this.options_.seekTo = function (time) {
	      _this3.tech_.setCurrentTime(time);
	    };
	
	    if (this.options_.smoothQualityChange) {
	      videojs.log.warn('smoothQualityChange is deprecated and will be removed in the next major version');
	    }
	
	    this.masterPlaylistController_ = new MasterPlaylistController(this.options_);
	    var playbackWatcherOptions = videojs.mergeOptions({
	      liveRangeSafeTimeDelta: SAFE_TIME_DELTA
	    }, this.options_, {
	      seekable: function seekable() {
	        return _this3.seekable();
	      },
	      media: function media() {
	        return _this3.masterPlaylistController_.media();
	      },
	      masterPlaylistController: this.masterPlaylistController_
	    });
	    this.playbackWatcher_ = new PlaybackWatcher(playbackWatcherOptions);
	    this.masterPlaylistController_.on('error', function () {
	      var player = videojs.players[_this3.tech_.options_.playerId];
	      var error = _this3.masterPlaylistController_.error;
	
	      if (typeof error === 'object' && !error.code) {
	        error.code = 3;
	      } else if (typeof error === 'string') {
	        error = {
	          message: error,
	          code: 3
	        };
	      }
	
	      player.error(error);
	    });
	    var defaultSelector = this.options_.experimentalBufferBasedABR ? Vhs.movingAverageBandwidthSelector(0.55) : Vhs.STANDARD_PLAYLIST_SELECTOR; // `this` in selectPlaylist should be the VhsHandler for backwards
	    // compatibility with < v2
	
	    this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : defaultSelector.bind(this);
	    this.masterPlaylistController_.selectInitialPlaylist = Vhs.INITIAL_PLAYLIST_SELECTOR.bind(this); // re-expose some internal objects for backwards compatibility with < v2
	
	    this.playlists = this.masterPlaylistController_.masterPlaylistLoader_;
	    this.mediaSource = this.masterPlaylistController_.mediaSource; // Proxy assignment of some properties to the master playlist
	    // controller. Using a custom property for backwards compatibility
	    // with < v2
	
	    Object.defineProperties(this, {
	      selectPlaylist: {
	        get: function get() {
	          return this.masterPlaylistController_.selectPlaylist;
	        },
	        set: function set(selectPlaylist) {
	          this.masterPlaylistController_.selectPlaylist = selectPlaylist.bind(this);
	        }
	      },
	      throughput: {
	        get: function get() {
	          return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;
	        },
	        set: function set(throughput) {
	          this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = throughput; // By setting `count` to 1 the throughput value becomes the starting value
	          // for the cumulative average
	
	          this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1;
	        }
	      },
	      bandwidth: {
	        get: function get() {
	          var playerBandwidthEst = this.masterPlaylistController_.mainSegmentLoader_.bandwidth;
	          var networkInformation = window__default['default'].navigator.connection || window__default['default'].navigator.mozConnection || window__default['default'].navigator.webkitConnection;
	          var tenMbpsAsBitsPerSecond = 10e6;
	
	          if (this.options_.useNetworkInformationApi && networkInformation) {
	            // downlink returns Mbps
	            // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/downlink
	            var networkInfoBandwidthEstBitsPerSec = networkInformation.downlink * 1000 * 1000; // downlink maxes out at 10 Mbps. In the event that both networkInformationApi and the player
	            // estimate a bandwidth greater than 10 Mbps, use the larger of the two estimates to ensure that
	            // high quality streams are not filtered out.
	
	            if (networkInfoBandwidthEstBitsPerSec >= tenMbpsAsBitsPerSecond && playerBandwidthEst >= tenMbpsAsBitsPerSecond) {
	              playerBandwidthEst = Math.max(playerBandwidthEst, networkInfoBandwidthEstBitsPerSec);
	            } else {
	              playerBandwidthEst = networkInfoBandwidthEstBitsPerSec;
	            }
	          }
	
	          return playerBandwidthEst;
	        },
	        set: function set(bandwidth) {
	          this.masterPlaylistController_.mainSegmentLoader_.bandwidth = bandwidth; // setting the bandwidth manually resets the throughput counter
	          // `count` is set to zero that current value of `rate` isn't included
	          // in the cumulative average
	
	          this.masterPlaylistController_.mainSegmentLoader_.throughput = {
	            rate: 0,
	            count: 0
	          };
	        }
	      },
	
	      /**
	       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
	       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
	       * the entire process after that - decryption, transmuxing, and appending - provided
	       * by `throughput`.
	       *
	       * Since the two process are serial, the overall system bandwidth is given by:
	       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
	       */
	      systemBandwidth: {
	        get: function get() {
	          var invBandwidth = 1 / (this.bandwidth || 1);
	          var invThroughput;
	
	          if (this.throughput > 0) {
	            invThroughput = 1 / this.throughput;
	          } else {
	            invThroughput = 0;
	          }
	
	          var systemBitrate = Math.floor(1 / (invBandwidth + invThroughput));
	          return systemBitrate;
	        },
	        set: function set() {
	          videojs.log.error('The "systemBandwidth" property is read-only');
	        }
	      }
	    });
	
	    if (this.options_.bandwidth) {
	      this.bandwidth = this.options_.bandwidth;
	    }
	
	    if (this.options_.throughput) {
	      this.throughput = this.options_.throughput;
	    }
	
	    Object.defineProperties(this.stats, {
	      bandwidth: {
	        get: function get() {
	          return _this3.bandwidth || 0;
	        },
	        enumerable: true
	      },
	      mediaRequests: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequests_() || 0;
	        },
	        enumerable: true
	      },
	      mediaRequestsAborted: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequestsAborted_() || 0;
	        },
	        enumerable: true
	      },
	      mediaRequestsTimedout: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequestsTimedout_() || 0;
	        },
	        enumerable: true
	      },
	      mediaRequestsErrored: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaRequestsErrored_() || 0;
	        },
	        enumerable: true
	      },
	      mediaTransferDuration: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaTransferDuration_() || 0;
	        },
	        enumerable: true
	      },
	      mediaBytesTransferred: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaBytesTransferred_() || 0;
	        },
	        enumerable: true
	      },
	      mediaSecondsLoaded: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaSecondsLoaded_() || 0;
	        },
	        enumerable: true
	      },
	      mediaAppends: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mediaAppends_() || 0;
	        },
	        enumerable: true
	      },
	      mainAppendsToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.mainAppendsToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      audioAppendsToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.audioAppendsToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      appendsToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.appendsToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      timeToLoadedData: {
	        get: function get() {
	          return _this3.masterPlaylistController_.timeToLoadedData_() || 0;
	        },
	        enumerable: true
	      },
	      buffered: {
	        get: function get() {
	          return timeRangesToArray(_this3.tech_.buffered());
	        },
	        enumerable: true
	      },
	      currentTime: {
	        get: function get() {
	          return _this3.tech_.currentTime();
	        },
	        enumerable: true
	      },
	      currentSource: {
	        get: function get() {
	          return _this3.tech_.currentSource_;
	        },
	        enumerable: true
	      },
	      currentTech: {
	        get: function get() {
	          return _this3.tech_.name_;
	        },
	        enumerable: true
	      },
	      duration: {
	        get: function get() {
	          return _this3.tech_.duration();
	        },
	        enumerable: true
	      },
	      master: {
	        get: function get() {
	          return _this3.playlists.master;
	        },
	        enumerable: true
	      },
	      playerDimensions: {
	        get: function get() {
	          return _this3.tech_.currentDimensions();
	        },
	        enumerable: true
	      },
	      seekable: {
	        get: function get() {
	          return timeRangesToArray(_this3.tech_.seekable());
	        },
	        enumerable: true
	      },
	      timestamp: {
	        get: function get() {
	          return Date.now();
	        },
	        enumerable: true
	      },
	      videoPlaybackQuality: {
	        get: function get() {
	          return _this3.tech_.getVideoPlaybackQuality();
	        },
	        enumerable: true
	      }
	    });
	    this.tech_.one('canplay', this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_));
	    this.tech_.on('bandwidthupdate', function () {
	      if (_this3.options_.useBandwidthFromLocalStorage) {
	        updateVhsLocalStorage({
	          bandwidth: _this3.bandwidth,
	          throughput: Math.round(_this3.throughput)
	        });
	      }
	    });
	    this.masterPlaylistController_.on('selectedinitialmedia', function () {
	      // Add the manual rendition mix-in to VhsHandler
	      renditionSelectionMixin(_this3);
	    });
	    this.masterPlaylistController_.sourceUpdater_.on('createdsourcebuffers', function () {
	      _this3.setupEme_();
	    }); // the bandwidth of the primary segment loader is our best
	    // estimate of overall bandwidth
	
	    this.on(this.masterPlaylistController_, 'progress', function () {
	      this.tech_.trigger('progress');
	    }); // In the live case, we need to ignore the very first `seeking` event since
	    // that will be the result of the seek-to-live behavior
	
	    this.on(this.masterPlaylistController_, 'firstplay', function () {
	      this.ignoreNextSeekingEvent_ = true;
	    });
	    this.setupQualityLevels_(); // do nothing if the tech has been disposed already
	    // this can occur if someone sets the src in player.ready(), for instance
	
	    if (!this.tech_.el()) {
	      return;
	    }
	
	    this.mediaSourceUrl_ = window__default['default'].URL.createObjectURL(this.masterPlaylistController_.mediaSource);
	    this.tech_.src(this.mediaSourceUrl_);
	  };
	
	  _proto.createKeySessions_ = function createKeySessions_() {
	    var _this4 = this;
	
	    var audioPlaylistLoader = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
	    this.logger_('waiting for EME key session creation');
	    waitForKeySessionCreation({
	      player: this.player_,
	      sourceKeySystems: this.source_.keySystems,
	      audioMedia: audioPlaylistLoader && audioPlaylistLoader.media(),
	      mainPlaylists: this.playlists.master.playlists
	    }).then(function () {
	      _this4.logger_('created EME key session');
	
	      _this4.masterPlaylistController_.sourceUpdater_.initializedEme();
	    })["catch"](function (err) {
	      _this4.logger_('error while creating EME key session', err);
	
	      _this4.player_.error({
	        message: 'Failed to initialize media keys for EME',
	        code: 3
	      });
	    });
	  };
	
	  _proto.handleWaitingForKey_ = function handleWaitingForKey_() {
	    // If waitingforkey is fired, it's possible that the data that's necessary to retrieve
	    // the key is in the manifest. While this should've happened on initial source load, it
	    // may happen again in live streams where the keys change, and the manifest info
	    // reflects the update.
	    //
	    // Because videojs-contrib-eme compares the PSSH data we send to that of PSSH data it's
	    // already requested keys for, we don't have to worry about this generating extraneous
	    // requests.
	    this.logger_('waitingforkey fired, attempting to create any new key sessions');
	    this.createKeySessions_();
	  }
	  /**
	   * If necessary and EME is available, sets up EME options and waits for key session
	   * creation.
	   *
	   * This function also updates the source updater so taht it can be used, as for some
	   * browsers, EME must be configured before content is appended (if appending unencrypted
	   * content before encrypted content).
	   */
	  ;
	
	  _proto.setupEme_ = function setupEme_() {
	    var _this5 = this;
	
	    var audioPlaylistLoader = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
	    var didSetupEmeOptions = setupEmeOptions({
	      player: this.player_,
	      sourceKeySystems: this.source_.keySystems,
	      media: this.playlists.media(),
	      audioMedia: audioPlaylistLoader && audioPlaylistLoader.media()
	    });
	    this.player_.tech_.on('keystatuschange', function (e) {
	      if (e.status !== 'output-restricted') {
	        return;
	      }
	
	      var masterPlaylist = _this5.masterPlaylistController_.master();
	
	      if (!masterPlaylist || !masterPlaylist.playlists) {
	        return;
	      }
	
	      var excludedHDPlaylists = []; // Assume all HD streams are unplayable and exclude them from ABR selection
	
	      masterPlaylist.playlists.forEach(function (playlist) {
	        if (playlist && playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height >= 720) {
	          if (!playlist.excludeUntil || playlist.excludeUntil < Infinity) {
	            playlist.excludeUntil = Infinity;
	            excludedHDPlaylists.push(playlist);
	          }
	        }
	      });
	
	      if (excludedHDPlaylists.length) {
	        var _videojs$log;
	
	        (_videojs$log = videojs.log).warn.apply(_videojs$log, ['DRM keystatus changed to "output-restricted." Removing the following HD playlists ' + 'that will most likely fail to play and clearing the buffer. ' + 'This may be due to HDCP restrictions on the stream and the capabilities of the current device.'].concat(excludedHDPlaylists)); // Clear the buffer before switching playlists, since it may already contain unplayable segments
	
	
	        _this5.masterPlaylistController_.fastQualityChange_();
	      }
	    });
	    this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this);
	    this.player_.tech_.on('waitingforkey', this.handleWaitingForKey_); // In IE11 this is too early to initialize media keys, and IE11 does not support
	    // promises.
	
	    if (videojs.browser.IE_VERSION === 11 || !didSetupEmeOptions) {
	      // If EME options were not set up, we've done all we could to initialize EME.
	      this.masterPlaylistController_.sourceUpdater_.initializedEme();
	      return;
	    }
	
	    this.createKeySessions_();
	  }
	  /**
	   * Initializes the quality levels and sets listeners to update them.
	   *
	   * @method setupQualityLevels_
	   * @private
	   */
	  ;
	
	  _proto.setupQualityLevels_ = function setupQualityLevels_() {
	    var _this6 = this;
	
	    var player = videojs.players[this.tech_.options_.playerId]; // if there isn't a player or there isn't a qualityLevels plugin
	    // or qualityLevels_ listeners have already been setup, do nothing.
	
	    if (!player || !player.qualityLevels || this.qualityLevels_) {
	      return;
	    }
	
	    this.qualityLevels_ = player.qualityLevels();
	    this.masterPlaylistController_.on('selectedinitialmedia', function () {
	      handleVhsLoadedMetadata(_this6.qualityLevels_, _this6);
	    });
	    this.playlists.on('mediachange', function () {
	      handleVhsMediaChange(_this6.qualityLevels_, _this6.playlists);
	    });
	  }
	  /**
	   * return the version
	   */
	  ;
	
	  VhsHandler.version = function version$5() {
	    return {
	      '@videojs/http-streaming': version$4,
	      'mux.js': version$3,
	      'mpd-parser': version$2,
	      'm3u8-parser': version$1,
	      'aes-decrypter': version
	    };
	  }
	  /**
	   * return the version
	   */
	  ;
	
	  _proto.version = function version() {
	    return this.constructor.version();
	  };
	
	  _proto.canChangeType = function canChangeType() {
	    return SourceUpdater.canChangeType();
	  }
	  /**
	   * Begin playing the video.
	   */
	  ;
	
	  _proto.play = function play() {
	    this.masterPlaylistController_.play();
	  }
	  /**
	   * a wrapper around the function in MasterPlaylistController
	   */
	  ;
	
	  _proto.setCurrentTime = function setCurrentTime(currentTime) {
	    this.masterPlaylistController_.setCurrentTime(currentTime);
	  }
	  /**
	   * a wrapper around the function in MasterPlaylistController
	   */
	  ;
	
	  _proto.duration = function duration() {
	    return this.masterPlaylistController_.duration();
	  }
	  /**
	   * a wrapper around the function in MasterPlaylistController
	   */
	  ;
	
	  _proto.seekable = function seekable() {
	    return this.masterPlaylistController_.seekable();
	  }
	  /**
	   * Abort all outstanding work and cleanup.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    if (this.playbackWatcher_) {
	      this.playbackWatcher_.dispose();
	    }
	
	    if (this.masterPlaylistController_) {
	      this.masterPlaylistController_.dispose();
	    }
	
	    if (this.qualityLevels_) {
	      this.qualityLevels_.dispose();
	    }
	
	    if (this.player_) {
	      delete this.player_.vhs;
	      delete this.player_.dash;
	      delete this.player_.hls;
	    }
	
	    if (this.tech_ && this.tech_.vhs) {
	      delete this.tech_.vhs;
	    } // don't check this.tech_.hls as it will log a deprecated warning
	
	
	    if (this.tech_) {
	      delete this.tech_.hls;
	    }
	
	    if (this.mediaSourceUrl_ && window__default['default'].URL.revokeObjectURL) {
	      window__default['default'].URL.revokeObjectURL(this.mediaSourceUrl_);
	      this.mediaSourceUrl_ = null;
	    }
	
	    if (this.tech_) {
	      this.tech_.off('waitingforkey', this.handleWaitingForKey_);
	    }
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  _proto.convertToProgramTime = function convertToProgramTime(time, callback) {
	    return getProgramTime({
	      playlist: this.masterPlaylistController_.media(),
	      time: time,
	      callback: callback
	    });
	  } // the player must be playing before calling this
	  ;
	
	  _proto.seekToProgramTime = function seekToProgramTime$1(programTime, callback, pauseAfterSeek, retryCount) {
	    if (pauseAfterSeek === void 0) {
	      pauseAfterSeek = true;
	    }
	
	    if (retryCount === void 0) {
	      retryCount = 2;
	    }
	
	    return seekToProgramTime({
	      programTime: programTime,
	      playlist: this.masterPlaylistController_.media(),
	      retryCount: retryCount,
	      pauseAfterSeek: pauseAfterSeek,
	      seekTo: this.options_.seekTo,
	      tech: this.options_.tech,
	      callback: callback
	    });
	  };
	
	  return VhsHandler;
	}(Component);
	/**
	 * The Source Handler object, which informs video.js what additional
	 * MIME types are supported and sets up playback. It is registered
	 * automatically to the appropriate tech based on the capabilities of
	 * the browser it is running in. It is not necessary to use or modify
	 * this object in normal usage.
	 */
	
	
	var VhsSourceHandler = {
	  name: 'videojs-http-streaming',
	  VERSION: version$4,
	  canHandleSource: function canHandleSource(srcObj, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var localOptions = videojs.mergeOptions(videojs.options, options);
	    return VhsSourceHandler.canPlayType(srcObj.type, localOptions);
	  },
	  handleSource: function handleSource(source, tech, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var localOptions = videojs.mergeOptions(videojs.options, options);
	    tech.vhs = new VhsHandler(source, tech, localOptions);
	
	    if (!videojs.hasOwnProperty('hls')) {
	      Object.defineProperty(tech, 'hls', {
	        get: function get() {
	          videojs.log.warn('player.tech().hls is deprecated. Use player.tech().vhs instead.');
	          return tech.vhs;
	        },
	        configurable: true
	      });
	    }
	
	    tech.vhs.xhr = xhrFactory();
	    tech.vhs.src(source.src, source.type);
	    return tech.vhs;
	  },
	  canPlayType: function canPlayType(type, options) {
	    var simpleType = mediaTypes_js.simpleTypeFromSourceType(type);
	
	    if (!simpleType) {
	      return '';
	    }
	
	    var overrideNative = VhsSourceHandler.getOverrideNative(options);
	    var supportsTypeNatively = Vhs.supportsTypeNatively(simpleType);
	    var canUseMsePlayback = !supportsTypeNatively || overrideNative;
	    return canUseMsePlayback ? 'maybe' : '';
	  },
	  getOverrideNative: function getOverrideNative(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        _options$vhs = _options.vhs,
	        vhs = _options$vhs === void 0 ? {} : _options$vhs,
	        _options$hls = _options.hls,
	        hls = _options$hls === void 0 ? {} : _options$hls;
	    var defaultOverrideNative = !(videojs.browser.IS_ANY_SAFARI || videojs.browser.IS_IOS);
	    var _vhs$overrideNative = vhs.overrideNative,
	        overrideNative = _vhs$overrideNative === void 0 ? defaultOverrideNative : _vhs$overrideNative;
	    var _hls$overrideNative = hls.overrideNative,
	        legacyOverrideNative = _hls$overrideNative === void 0 ? false : _hls$overrideNative;
	    return legacyOverrideNative || overrideNative;
	  }
	};
	/**
	 * Check to see if the native MediaSource object exists and supports
	 * an MP4 container with both H.264 video and AAC-LC audio.
	 *
	 * @return {boolean} if  native media sources are supported
	 */
	
	var supportsNativeMediaSources = function supportsNativeMediaSources() {
	  return codecs_js.browserSupportsCodec('avc1.4d400d,mp4a.40.2');
	}; // register source handlers with the appropriate techs
	
	
	if (supportsNativeMediaSources()) {
	  videojs.getTech('Html5').registerSourceHandler(VhsSourceHandler, 0);
	}
	
	videojs.VhsHandler = VhsHandler;
	Object.defineProperty(videojs, 'HlsHandler', {
	  get: function get() {
	    videojs.log.warn('videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead.');
	    return VhsHandler;
	  },
	  configurable: true
	});
	videojs.VhsSourceHandler = VhsSourceHandler;
	Object.defineProperty(videojs, 'HlsSourceHandler', {
	  get: function get() {
	    videojs.log.warn('videojs.HlsSourceHandler is deprecated. ' + 'Use videojs.VhsSourceHandler instead.');
	    return VhsSourceHandler;
	  },
	  configurable: true
	});
	videojs.Vhs = Vhs;
	Object.defineProperty(videojs, 'Hls', {
	  get: function get() {
	    videojs.log.warn('videojs.Hls is deprecated. Use videojs.Vhs instead.');
	    return Vhs;
	  },
	  configurable: true
	});
	
	if (!videojs.use) {
	  videojs.registerComponent('Hls', Vhs);
	  videojs.registerComponent('Vhs', Vhs);
	}
	
	videojs.options.vhs = videojs.options.vhs || {};
	videojs.options.hls = videojs.options.hls || {};
	
	if (!videojs.getPlugin || !videojs.getPlugin('reloadSourceOnError')) {
	  var registerPlugin = videojs.registerPlugin || videojs.plugin;
	  registerPlugin('reloadSourceOnError', reloadSourceOnError);
	}
	
	module.exports = videojs;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(185);
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return arrayLikeToArray(arr);
	}
	module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 304 */
/***/ function(module, exports) {

	function _isNativeFunction(fn) {
	  try {
	    return Function.toString.call(fn).indexOf("[native code]") !== -1;
	  } catch (e) {
	    return typeof fn === "function";
	  }
	}
	module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 305 */
/***/ function(module, exports) {

	function _isNativeReflectConstruct() {
	  try {
	    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	  } catch (t) {}
	  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
	    return !!t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
	}
	module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 306 */
/***/ function(module, exports) {

	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	}
	module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 307 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(99);
	function ownKeys(e, r) {
	  var t = Object.keys(e);
	  if (Object.getOwnPropertySymbols) {
	    var o = Object.getOwnPropertySymbols(e);
	    r && (o = o.filter(function (r) {
	      return Object.getOwnPropertyDescriptor(e, r).enumerable;
	    })), t.push.apply(t, o);
	  }
	  return t;
	}
	function _objectSpread2(e) {
	  for (var r = 1; r < arguments.length; r++) {
	    var t = null != arguments[r] ? arguments[r] : {};
	    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
	      defineProperty(e, r, t[r]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
	      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
	    });
	  }
	  return e;
	}
	module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 309 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(101)["default"];
	function toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r || "default");
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(185);
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(18);
	var setPrototypeOf = __webpack_require__(100);
	var isNativeFunction = __webpack_require__(304);
	var construct = __webpack_require__(186);
	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;
	  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !isNativeFunction(Class)) return Class;
	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);
	      _cache.set(Class, Wrapper);
	    }
	    function Wrapper() {
	      return construct(Class, arguments, getPrototypeOf(this).constructor);
	    }
	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return setPrototypeOf(Wrapper, Class);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _wrapNativeSuper(Class);
	}
	module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_VIDEO_CODEC = exports.DEFAULT_AUDIO_CODEC = exports.muxerSupportsCodec = exports.browserSupportsCodec = exports.getMimeForCodec = exports.isTextCodec = exports.isAudioCodec = exports.isVideoCodec = exports.codecsFromDefault = exports.parseCodecs = exports.mapLegacyAvcCodecs = exports.translateLegacyCodecs = exports.translateLegacyCodec = void 0;
	
	var _window = _interopRequireDefault(__webpack_require__(54));
	
	var regexs = {
	  // to determine mime types
	  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
	  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
	  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
	  // to determine if a codec is audio or video
	  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
	  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
	  text: /^(stpp.ttml.im1t)/,
	  // mux.js support regex
	  muxerVideo: /^(avc0?1)/,
	  muxerAudio: /^(mp4a)/,
	  // match nothing as muxer does not support text right now.
	  // there cannot never be a character before the start of a string
	  // so this matches nothing.
	  muxerText: /a^/
	};
	var mediaTypes = ['video', 'audio', 'text'];
	var upperMediaTypes = ['Video', 'Audio', 'Text'];
	/**
	 * Replace the old apple-style `avc1.<dd>.<dd>` codec string with the standard
	 * `avc1.<hhhhhh>`
	 *
	 * @param {string} codec
	 *        Codec string to translate
	 * @return {string}
	 *         The translated codec string
	 */
	
	var translateLegacyCodec = function translateLegacyCodec(codec) {
	  if (!codec) {
	    return codec;
	  }
	
	  return codec.replace(/avc1\.(\d+)\.(\d+)/i, function (orig, profile, avcLevel) {
	    var profileHex = ('00' + Number(profile).toString(16)).slice(-2);
	    var avcLevelHex = ('00' + Number(avcLevel).toString(16)).slice(-2);
	    return 'avc1.' + profileHex + '00' + avcLevelHex;
	  });
	};
	/**
	 * Replace the old apple-style `avc1.<dd>.<dd>` codec strings with the standard
	 * `avc1.<hhhhhh>`
	 *
	 * @param {string[]} codecs
	 *        An array of codec strings to translate
	 * @return {string[]}
	 *         The translated array of codec strings
	 */
	
	
	exports.translateLegacyCodec = translateLegacyCodec;
	
	var translateLegacyCodecs = function translateLegacyCodecs(codecs) {
	  return codecs.map(translateLegacyCodec);
	};
	/**
	 * Replace codecs in the codec string with the old apple-style `avc1.<dd>.<dd>` to the
	 * standard `avc1.<hhhhhh>`.
	 *
	 * @param {string} codecString
	 *        The codec string
	 * @return {string}
	 *         The codec string with old apple-style codecs replaced
	 *
	 * @private
	 */
	
	
	exports.translateLegacyCodecs = translateLegacyCodecs;
	
	var mapLegacyAvcCodecs = function mapLegacyAvcCodecs(codecString) {
	  return codecString.replace(/avc1\.(\d+)\.(\d+)/i, function (match) {
	    return translateLegacyCodecs([match])[0];
	  });
	};
	/**
	 * @typedef {Object} ParsedCodecInfo
	 * @property {number} codecCount
	 *           Number of codecs parsed
	 * @property {string} [videoCodec]
	 *           Parsed video codec (if found)
	 * @property {string} [videoObjectTypeIndicator]
	 *           Video object type indicator (if found)
	 * @property {string|null} audioProfile
	 *           Audio profile
	 */
	
	/**
	 * Parses a codec string to retrieve the number of codecs specified, the video codec and
	 * object type indicator, and the audio profile.
	 *
	 * @param {string} [codecString]
	 *        The codec string to parse
	 * @return {ParsedCodecInfo}
	 *         Parsed codec info
	 */
	
	
	exports.mapLegacyAvcCodecs = mapLegacyAvcCodecs;
	
	var parseCodecs = function parseCodecs(codecString) {
	  if (codecString === void 0) {
	    codecString = '';
	  }
	
	  var codecs = codecString.split(',');
	  var result = [];
	  codecs.forEach(function (codec) {
	    codec = codec.trim();
	    var codecType;
	    mediaTypes.forEach(function (name) {
	      var match = regexs[name].exec(codec.toLowerCase());
	
	      if (!match || match.length <= 1) {
	        return;
	      }
	
	      codecType = name; // maintain codec case
	
	      var type = codec.substring(0, match[1].length);
	      var details = codec.replace(type, '');
	      result.push({
	        type: type,
	        details: details,
	        mediaType: name
	      });
	    });
	
	    if (!codecType) {
	      result.push({
	        type: codec,
	        details: '',
	        mediaType: 'unknown'
	      });
	    }
	  });
	  return result;
	};
	/**
	 * Returns a ParsedCodecInfo object for the default alternate audio playlist if there is
	 * a default alternate audio playlist for the provided audio group.
	 *
	 * @param {Object} master
	 *        The master playlist
	 * @param {string} audioGroupId
	 *        ID of the audio group for which to find the default codec info
	 * @return {ParsedCodecInfo}
	 *         Parsed codec info
	 */
	
	
	exports.parseCodecs = parseCodecs;
	
	var codecsFromDefault = function codecsFromDefault(master, audioGroupId) {
	  if (!master.mediaGroups.AUDIO || !audioGroupId) {
	    return null;
	  }
	
	  var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
	
	  if (!audioGroup) {
	    return null;
	  }
	
	  for (var name in audioGroup) {
	    var audioType = audioGroup[name];
	
	    if (audioType.default && audioType.playlists) {
	      // codec should be the same for all playlists within the audio type
	      return parseCodecs(audioType.playlists[0].attributes.CODECS);
	    }
	  }
	
	  return null;
	};
	
	exports.codecsFromDefault = codecsFromDefault;
	
	var isVideoCodec = function isVideoCodec(codec) {
	  if (codec === void 0) {
	    codec = '';
	  }
	
	  return regexs.video.test(codec.trim().toLowerCase());
	};
	
	exports.isVideoCodec = isVideoCodec;
	
	var isAudioCodec = function isAudioCodec(codec) {
	  if (codec === void 0) {
	    codec = '';
	  }
	
	  return regexs.audio.test(codec.trim().toLowerCase());
	};
	
	exports.isAudioCodec = isAudioCodec;
	
	var isTextCodec = function isTextCodec(codec) {
	  if (codec === void 0) {
	    codec = '';
	  }
	
	  return regexs.text.test(codec.trim().toLowerCase());
	};
	
	exports.isTextCodec = isTextCodec;
	
	var getMimeForCodec = function getMimeForCodec(codecString) {
	  if (!codecString || typeof codecString !== 'string') {
	    return;
	  }
	
	  var codecs = codecString.toLowerCase().split(',').map(function (c) {
	    return translateLegacyCodec(c.trim());
	  }); // default to video type
	
	  var type = 'video'; // only change to audio type if the only codec we have is
	  // audio
	
	  if (codecs.length === 1 && isAudioCodec(codecs[0])) {
	    type = 'audio';
	  } else if (codecs.length === 1 && isTextCodec(codecs[0])) {
	    // text uses application/<container> for now
	    type = 'application';
	  } // default the container to mp4
	
	
	  var container = 'mp4'; // every codec must be able to go into the container
	  // for that container to be the correct one
	
	  if (codecs.every(function (c) {
	    return regexs.mp4.test(c);
	  })) {
	    container = 'mp4';
	  } else if (codecs.every(function (c) {
	    return regexs.webm.test(c);
	  })) {
	    container = 'webm';
	  } else if (codecs.every(function (c) {
	    return regexs.ogg.test(c);
	  })) {
	    container = 'ogg';
	  }
	
	  return type + "/" + container + ";codecs=\"" + codecString + "\"";
	};
	
	exports.getMimeForCodec = getMimeForCodec;
	
	var browserSupportsCodec = function browserSupportsCodec(codecString) {
	  if (codecString === void 0) {
	    codecString = '';
	  }
	
	  return _window.default.MediaSource && _window.default.MediaSource.isTypeSupported && _window.default.MediaSource.isTypeSupported(getMimeForCodec(codecString)) || false;
	};
	
	exports.browserSupportsCodec = browserSupportsCodec;
	
	var muxerSupportsCodec = function muxerSupportsCodec(codecString) {
	  if (codecString === void 0) {
	    codecString = '';
	  }
	
	  return codecString.toLowerCase().split(',').every(function (codec) {
	    codec = codec.trim(); // any match is supported.
	
	    for (var i = 0; i < upperMediaTypes.length; i++) {
	      var type = upperMediaTypes[i];
	
	      if (regexs["muxer" + type].test(codec)) {
	        return true;
	      }
	    }
	
	    return false;
	  });
	};
	
	exports.muxerSupportsCodec = muxerSupportsCodec;
	var DEFAULT_AUDIO_CODEC = 'mp4a.40.2';
	exports.DEFAULT_AUDIO_CODEC = DEFAULT_AUDIO_CODEC;
	var DEFAULT_VIDEO_CODEC = 'avc1.4d400d';
	exports.DEFAULT_VIDEO_CODEC = DEFAULT_VIDEO_CODEC;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isLikelyFmp4MediaSegment = exports.detectContainerForBytes = exports.isLikely = void 0;
	
	var _byteHelpers = __webpack_require__(63);
	
	var _mp4Helpers = __webpack_require__(318);
	
	var _ebmlHelpers = __webpack_require__(315);
	
	var _id3Helpers = __webpack_require__(192);
	
	var _nalHelpers = __webpack_require__(319);
	
	var CONSTANTS = {
	  // "webm" string literal in hex
	  'webm': (0, _byteHelpers.toUint8)([0x77, 0x65, 0x62, 0x6d]),
	  // "matroska" string literal in hex
	  'matroska': (0, _byteHelpers.toUint8)([0x6d, 0x61, 0x74, 0x72, 0x6f, 0x73, 0x6b, 0x61]),
	  // "fLaC" string literal in hex
	  'flac': (0, _byteHelpers.toUint8)([0x66, 0x4c, 0x61, 0x43]),
	  // "OggS" string literal in hex
	  'ogg': (0, _byteHelpers.toUint8)([0x4f, 0x67, 0x67, 0x53]),
	  // ac-3 sync byte, also works for ec-3 as that is simply a codec
	  // of ac-3
	  'ac3': (0, _byteHelpers.toUint8)([0x0b, 0x77]),
	  // "RIFF" string literal in hex used for wav and avi
	  'riff': (0, _byteHelpers.toUint8)([0x52, 0x49, 0x46, 0x46]),
	  // "AVI" string literal in hex
	  'avi': (0, _byteHelpers.toUint8)([0x41, 0x56, 0x49]),
	  // "WAVE" string literal in hex
	  'wav': (0, _byteHelpers.toUint8)([0x57, 0x41, 0x56, 0x45]),
	  // "ftyp3g" string literal in hex
	  '3gp': (0, _byteHelpers.toUint8)([0x66, 0x74, 0x79, 0x70, 0x33, 0x67]),
	  // "ftyp" string literal in hex
	  'mp4': (0, _byteHelpers.toUint8)([0x66, 0x74, 0x79, 0x70]),
	  // "styp" string literal in hex
	  'fmp4': (0, _byteHelpers.toUint8)([0x73, 0x74, 0x79, 0x70]),
	  // "ftypqt" string literal in hex
	  'mov': (0, _byteHelpers.toUint8)([0x66, 0x74, 0x79, 0x70, 0x71, 0x74]),
	  // moov string literal in hex
	  'moov': (0, _byteHelpers.toUint8)([0x6D, 0x6F, 0x6F, 0x76]),
	  // moof string literal in hex
	  'moof': (0, _byteHelpers.toUint8)([0x6D, 0x6F, 0x6F, 0x66])
	};
	var _isLikely = {
	  aac: function aac(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, [0xFF, 0x10], {
	      offset: offset,
	      mask: [0xFF, 0x16]
	    });
	  },
	  mp3: function mp3(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, [0xFF, 0x02], {
	      offset: offset,
	      mask: [0xFF, 0x06]
	    });
	  },
	  webm: function webm(bytes) {
	    var docType = (0, _ebmlHelpers.findEbml)(bytes, [_ebmlHelpers.EBML_TAGS.EBML, _ebmlHelpers.EBML_TAGS.DocType])[0]; // check if DocType EBML tag is webm
	
	    return (0, _byteHelpers.bytesMatch)(docType, CONSTANTS.webm);
	  },
	  mkv: function mkv(bytes) {
	    var docType = (0, _ebmlHelpers.findEbml)(bytes, [_ebmlHelpers.EBML_TAGS.EBML, _ebmlHelpers.EBML_TAGS.DocType])[0]; // check if DocType EBML tag is matroska
	
	    return (0, _byteHelpers.bytesMatch)(docType, CONSTANTS.matroska);
	  },
	  mp4: function mp4(bytes) {
	    // if this file is another base media file format, it is not mp4
	    if (_isLikely['3gp'](bytes) || _isLikely.mov(bytes)) {
	      return false;
	    } // if this file starts with a ftyp or styp box its mp4
	
	
	    if ((0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.mp4, {
	      offset: 4
	    }) || (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.fmp4, {
	      offset: 4
	    })) {
	      return true;
	    } // if this file starts with a moof/moov box its mp4
	
	
	    if ((0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.moof, {
	      offset: 4
	    }) || (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.moov, {
	      offset: 4
	    })) {
	      return true;
	    }
	  },
	  mov: function mov(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.mov, {
	      offset: 4
	    });
	  },
	  '3gp': function gp(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS['3gp'], {
	      offset: 4
	    });
	  },
	  ac3: function ac3(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.ac3, {
	      offset: offset
	    });
	  },
	  ts: function ts(bytes) {
	    if (bytes.length < 189 && bytes.length >= 1) {
	      return bytes[0] === 0x47;
	    }
	
	    var i = 0; // check the first 376 bytes for two matching sync bytes
	
	    while (i + 188 < bytes.length && i < 188) {
	      if (bytes[i] === 0x47 && bytes[i + 188] === 0x47) {
	        return true;
	      }
	
	      i += 1;
	    }
	
	    return false;
	  },
	  flac: function flac(bytes) {
	    var offset = (0, _id3Helpers.getId3Offset)(bytes);
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.flac, {
	      offset: offset
	    });
	  },
	  ogg: function ogg(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.ogg);
	  },
	  avi: function avi(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.riff) && (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.avi, {
	      offset: 8
	    });
	  },
	  wav: function wav(bytes) {
	    return (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.riff) && (0, _byteHelpers.bytesMatch)(bytes, CONSTANTS.wav, {
	      offset: 8
	    });
	  },
	  'h264': function h264(bytes) {
	    // find seq_parameter_set_rbsp
	    return (0, _nalHelpers.findH264Nal)(bytes, 7, 3).length;
	  },
	  'h265': function h265(bytes) {
	    // find video_parameter_set_rbsp or seq_parameter_set_rbsp
	    return (0, _nalHelpers.findH265Nal)(bytes, [32, 33], 3).length;
	  }
	}; // get all the isLikely functions
	// but make sure 'ts' is above h264 and h265
	// but below everything else as it is the least specific
	
	var isLikelyTypes = Object.keys(_isLikely) // remove ts, h264, h265
	.filter(function (t) {
	  return t !== 'ts' && t !== 'h264' && t !== 'h265';
	}) // add it back to the bottom
	.concat(['ts', 'h264', 'h265']); // make sure we are dealing with uint8 data.
	
	isLikelyTypes.forEach(function (type) {
	  var isLikelyFn = _isLikely[type];
	
	  _isLikely[type] = function (bytes) {
	    return isLikelyFn((0, _byteHelpers.toUint8)(bytes));
	  };
	}); // export after wrapping
	
	var isLikely = _isLikely; // A useful list of file signatures can be found here
	// https://en.wikipedia.org/wiki/List_of_file_signatures
	
	exports.isLikely = isLikely;
	
	var detectContainerForBytes = function detectContainerForBytes(bytes) {
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	
	  for (var i = 0; i < isLikelyTypes.length; i++) {
	    var type = isLikelyTypes[i];
	
	    if (isLikely[type](bytes)) {
	      return type;
	    }
	  }
	
	  return '';
	}; // fmp4 is not a container
	
	
	exports.detectContainerForBytes = detectContainerForBytes;
	
	var isLikelyFmp4MediaSegment = function isLikelyFmp4MediaSegment(bytes) {
	  return (0, _mp4Helpers.findBox)(bytes, ['moof']).length > 0;
	};
	
	exports.isLikelyFmp4MediaSegment = isLikelyFmp4MediaSegment;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseData = exports.parseTracks = exports.decodeBlock = exports.findEbml = exports.EBML_TAGS = void 0;
	
	var _byteHelpers = __webpack_require__(63);
	
	var _codecHelpers = __webpack_require__(190);
	
	// relevant specs for this parser:
	// https://matroska-org.github.io/libebml/specs.html
	// https://www.matroska.org/technical/elements.html
	// https://www.webmproject.org/docs/container/
	var EBML_TAGS = {
	  EBML: (0, _byteHelpers.toUint8)([0x1A, 0x45, 0xDF, 0xA3]),
	  DocType: (0, _byteHelpers.toUint8)([0x42, 0x82]),
	  Segment: (0, _byteHelpers.toUint8)([0x18, 0x53, 0x80, 0x67]),
	  SegmentInfo: (0, _byteHelpers.toUint8)([0x15, 0x49, 0xA9, 0x66]),
	  Tracks: (0, _byteHelpers.toUint8)([0x16, 0x54, 0xAE, 0x6B]),
	  Track: (0, _byteHelpers.toUint8)([0xAE]),
	  TrackNumber: (0, _byteHelpers.toUint8)([0xd7]),
	  DefaultDuration: (0, _byteHelpers.toUint8)([0x23, 0xe3, 0x83]),
	  TrackEntry: (0, _byteHelpers.toUint8)([0xAE]),
	  TrackType: (0, _byteHelpers.toUint8)([0x83]),
	  FlagDefault: (0, _byteHelpers.toUint8)([0x88]),
	  CodecID: (0, _byteHelpers.toUint8)([0x86]),
	  CodecPrivate: (0, _byteHelpers.toUint8)([0x63, 0xA2]),
	  VideoTrack: (0, _byteHelpers.toUint8)([0xe0]),
	  AudioTrack: (0, _byteHelpers.toUint8)([0xe1]),
	  // Not used yet, but will be used for live webm/mkv
	  // see https://www.matroska.org/technical/basics.html#block-structure
	  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
	  Cluster: (0, _byteHelpers.toUint8)([0x1F, 0x43, 0xB6, 0x75]),
	  Timestamp: (0, _byteHelpers.toUint8)([0xE7]),
	  TimestampScale: (0, _byteHelpers.toUint8)([0x2A, 0xD7, 0xB1]),
	  BlockGroup: (0, _byteHelpers.toUint8)([0xA0]),
	  BlockDuration: (0, _byteHelpers.toUint8)([0x9B]),
	  Block: (0, _byteHelpers.toUint8)([0xA1]),
	  SimpleBlock: (0, _byteHelpers.toUint8)([0xA3])
	};
	/**
	 * This is a simple table to determine the length
	 * of things in ebml. The length is one based (starts at 1,
	 * rather than zero) and for every zero bit before a one bit
	 * we add one to length. We also need this table because in some
	 * case we have to xor all the length bits from another value.
	 */
	
	exports.EBML_TAGS = EBML_TAGS;
	var LENGTH_TABLE = [128, 64, 32, 16, 8, 4, 2, 1];
	
	var getLength = function getLength(byte) {
	  var len = 1;
	
	  for (var i = 0; i < LENGTH_TABLE.length; i++) {
	    if (byte & LENGTH_TABLE[i]) {
	      break;
	    }
	
	    len++;
	  }
	
	  return len;
	}; // length in ebml is stored in the first 4 to 8 bits
	// of the first byte. 4 for the id length and 8 for the
	// data size length. Length is measured by converting the number to binary
	// then 1 + the number of zeros before a 1 is encountered starting
	// from the left.
	
	
	var getvint = function getvint(bytes, offset, removeLength, signed) {
	  if (removeLength === void 0) {
	    removeLength = true;
	  }
	
	  if (signed === void 0) {
	    signed = false;
	  }
	
	  var length = getLength(bytes[offset]);
	  var valueBytes = bytes.subarray(offset, offset + length); // NOTE that we do **not** subarray here because we need to copy these bytes
	  // as they will be modified below to remove the dataSizeLen bits and we do not
	  // want to modify the original data. normally we could just call slice on
	  // uint8array but ie 11 does not support that...
	
	  if (removeLength) {
	    valueBytes = Array.prototype.slice.call(bytes, offset, offset + length);
	    valueBytes[0] ^= LENGTH_TABLE[length - 1];
	  }
	
	  return {
	    length: length,
	    value: (0, _byteHelpers.bytesToNumber)(valueBytes, {
	      signed: signed
	    }),
	    bytes: valueBytes
	  };
	};
	
	var normalizePath = function normalizePath(path) {
	  if (typeof path === 'string') {
	    return path.match(/.{1,2}/g).map(function (p) {
	      return normalizePath(p);
	    });
	  }
	
	  if (typeof path === 'number') {
	    return (0, _byteHelpers.numberToBytes)(path);
	  }
	
	  return path;
	};
	
	var normalizePaths = function normalizePaths(paths) {
	  if (!Array.isArray(paths)) {
	    return [normalizePath(paths)];
	  }
	
	  return paths.map(function (p) {
	    return normalizePath(p);
	  });
	};
	
	var getInfinityDataSize = function getInfinityDataSize(id, bytes, offset) {
	  if (offset >= bytes.length) {
	    return bytes.length;
	  }
	
	  var innerid = getvint(bytes, offset, false);
	
	  if ((0, _byteHelpers.bytesMatch)(id.bytes, innerid.bytes)) {
	    return offset;
	  }
	
	  var dataHeader = getvint(bytes, offset + innerid.length);
	  return getInfinityDataSize(id, bytes, offset + dataHeader.length + dataHeader.value + innerid.length);
	};
	/**
	 * Notes on the EBLM format.
	 *
	 * EBLM uses "vints" tags. Every vint tag contains
	 * two parts
	 *
	 * 1. The length from the first byte. You get this by
	 *    converting the byte to binary and counting the zeros
	 *    before a 1. Then you add 1 to that. Examples
	 *    00011111 = length 4 because there are 3 zeros before a 1.
	 *    00100000 = length 3 because there are 2 zeros before a 1.
	 *    00000011 = length 7 because there are 6 zeros before a 1.
	 *
	 * 2. The bits used for length are removed from the first byte
	 *    Then all the bytes are merged into a value. NOTE: this
	 *    is not the case for id ebml tags as there id includes
	 *    length bits.
	 *
	 */
	
	
	var findEbml = function findEbml(bytes, paths) {
	  paths = normalizePaths(paths);
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var results = [];
	
	  if (!paths.length) {
	    return results;
	  }
	
	  var i = 0;
	
	  while (i < bytes.length) {
	    var id = getvint(bytes, i, false);
	    var dataHeader = getvint(bytes, i + id.length);
	    var dataStart = i + id.length + dataHeader.length; // dataSize is unknown or this is a live stream
	
	    if (dataHeader.value === 0x7f) {
	      dataHeader.value = getInfinityDataSize(id, bytes, dataStart);
	
	      if (dataHeader.value !== bytes.length) {
	        dataHeader.value -= dataStart;
	      }
	    }
	
	    var dataEnd = dataStart + dataHeader.value > bytes.length ? bytes.length : dataStart + dataHeader.value;
	    var data = bytes.subarray(dataStart, dataEnd);
	
	    if ((0, _byteHelpers.bytesMatch)(paths[0], id.bytes)) {
	      if (paths.length === 1) {
	        // this is the end of the paths and we've found the tag we were
	        // looking for
	        results.push(data);
	      } else {
	        // recursively search for the next tag inside of the data
	        // of this one
	        results = results.concat(findEbml(data, paths.slice(1)));
	      }
	    }
	
	    var totalLength = id.length + dataHeader.length + data.length; // move past this tag entirely, we are not looking for it
	
	    i += totalLength;
	  }
	
	  return results;
	}; // see https://www.matroska.org/technical/basics.html#block-structure
	
	
	exports.findEbml = findEbml;
	
	var decodeBlock = function decodeBlock(block, type, timestampScale, clusterTimestamp) {
	  var duration;
	
	  if (type === 'group') {
	    duration = findEbml(block, [EBML_TAGS.BlockDuration])[0];
	
	    if (duration) {
	      duration = (0, _byteHelpers.bytesToNumber)(duration);
	      duration = 1 / timestampScale * duration * timestampScale / 1000;
	    }
	
	    block = findEbml(block, [EBML_TAGS.Block])[0];
	    type = 'block'; // treat data as a block after this point
	  }
	
	  var dv = new DataView(block.buffer, block.byteOffset, block.byteLength);
	  var trackNumber = getvint(block, 0);
	  var timestamp = dv.getInt16(trackNumber.length, false);
	  var flags = block[trackNumber.length + 2];
	  var data = block.subarray(trackNumber.length + 3); // pts/dts in seconds
	
	  var ptsdts = 1 / timestampScale * (clusterTimestamp + timestamp) * timestampScale / 1000; // return the frame
	
	  var parsed = {
	    duration: duration,
	    trackNumber: trackNumber.value,
	    keyframe: type === 'simple' && flags >> 7 === 1,
	    invisible: (flags & 0x08) >> 3 === 1,
	    lacing: (flags & 0x06) >> 1,
	    discardable: type === 'simple' && (flags & 0x01) === 1,
	    frames: [],
	    pts: ptsdts,
	    dts: ptsdts,
	    timestamp: timestamp
	  };
	
	  if (!parsed.lacing) {
	    parsed.frames.push(data);
	    return parsed;
	  }
	
	  var numberOfFrames = data[0] + 1;
	  var frameSizes = [];
	  var offset = 1; // Fixed
	
	  if (parsed.lacing === 2) {
	    var sizeOfFrame = (data.length - offset) / numberOfFrames;
	
	    for (var i = 0; i < numberOfFrames; i++) {
	      frameSizes.push(sizeOfFrame);
	    }
	  } // xiph
	
	
	  if (parsed.lacing === 1) {
	    for (var _i = 0; _i < numberOfFrames - 1; _i++) {
	      var size = 0;
	
	      do {
	        size += data[offset];
	        offset++;
	      } while (data[offset - 1] === 0xFF);
	
	      frameSizes.push(size);
	    }
	  } // ebml
	
	
	  if (parsed.lacing === 3) {
	    // first vint is unsinged
	    // after that vints are singed and
	    // based on a compounding size
	    var _size = 0;
	
	    for (var _i2 = 0; _i2 < numberOfFrames - 1; _i2++) {
	      var vint = _i2 === 0 ? getvint(data, offset) : getvint(data, offset, true, true);
	      _size += vint.value;
	      frameSizes.push(_size);
	      offset += vint.length;
	    }
	  }
	
	  frameSizes.forEach(function (size) {
	    parsed.frames.push(data.subarray(offset, offset + size));
	    offset += size;
	  });
	  return parsed;
	}; // VP9 Codec Feature Metadata (CodecPrivate)
	// https://www.webmproject.org/docs/container/
	
	
	exports.decodeBlock = decodeBlock;
	
	var parseVp9Private = function parseVp9Private(bytes) {
	  var i = 0;
	  var params = {};
	
	  while (i < bytes.length) {
	    var id = bytes[i] & 0x7f;
	    var len = bytes[i + 1];
	    var val = void 0;
	
	    if (len === 1) {
	      val = bytes[i + 2];
	    } else {
	      val = bytes.subarray(i + 2, i + 2 + len);
	    }
	
	    if (id === 1) {
	      params.profile = val;
	    } else if (id === 2) {
	      params.level = val;
	    } else if (id === 3) {
	      params.bitDepth = val;
	    } else if (id === 4) {
	      params.chromaSubsampling = val;
	    } else {
	      params[id] = val;
	    }
	
	    i += 2 + len;
	  }
	
	  return params;
	};
	
	var parseTracks = function parseTracks(bytes) {
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var decodedTracks = [];
	  var tracks = findEbml(bytes, [EBML_TAGS.Segment, EBML_TAGS.Tracks, EBML_TAGS.Track]);
	
	  if (!tracks.length) {
	    tracks = findEbml(bytes, [EBML_TAGS.Tracks, EBML_TAGS.Track]);
	  }
	
	  if (!tracks.length) {
	    tracks = findEbml(bytes, [EBML_TAGS.Track]);
	  }
	
	  if (!tracks.length) {
	    return decodedTracks;
	  }
	
	  tracks.forEach(function (track) {
	    var trackType = findEbml(track, EBML_TAGS.TrackType)[0];
	
	    if (!trackType || !trackType.length) {
	      return;
	    } // 1 is video, 2 is audio, 17 is subtitle
	    // other values are unimportant in this context
	
	
	    if (trackType[0] === 1) {
	      trackType = 'video';
	    } else if (trackType[0] === 2) {
	      trackType = 'audio';
	    } else if (trackType[0] === 17) {
	      trackType = 'subtitle';
	    } else {
	      return;
	    } // todo parse language
	
	
	    var decodedTrack = {
	      rawCodec: (0, _byteHelpers.bytesToString)(findEbml(track, [EBML_TAGS.CodecID])[0]),
	      type: trackType,
	      codecPrivate: findEbml(track, [EBML_TAGS.CodecPrivate])[0],
	      number: (0, _byteHelpers.bytesToNumber)(findEbml(track, [EBML_TAGS.TrackNumber])[0]),
	      defaultDuration: (0, _byteHelpers.bytesToNumber)(findEbml(track, [EBML_TAGS.DefaultDuration])[0]),
	      default: findEbml(track, [EBML_TAGS.FlagDefault])[0],
	      rawData: track
	    };
	    var codec = '';
	
	    if (/V_MPEG4\/ISO\/AVC/.test(decodedTrack.rawCodec)) {
	      codec = "avc1." + (0, _codecHelpers.getAvcCodec)(decodedTrack.codecPrivate);
	    } else if (/V_MPEGH\/ISO\/HEVC/.test(decodedTrack.rawCodec)) {
	      codec = "hev1." + (0, _codecHelpers.getHvcCodec)(decodedTrack.codecPrivate);
	    } else if (/V_MPEG4\/ISO\/ASP/.test(decodedTrack.rawCodec)) {
	      if (decodedTrack.codecPrivate) {
	        codec = 'mp4v.20.' + decodedTrack.codecPrivate[4].toString();
	      } else {
	        codec = 'mp4v.20.9';
	      }
	    } else if (/^V_THEORA/.test(decodedTrack.rawCodec)) {
	      codec = 'theora';
	    } else if (/^V_VP8/.test(decodedTrack.rawCodec)) {
	      codec = 'vp8';
	    } else if (/^V_VP9/.test(decodedTrack.rawCodec)) {
	      if (decodedTrack.codecPrivate) {
	        var _parseVp9Private = parseVp9Private(decodedTrack.codecPrivate),
	            profile = _parseVp9Private.profile,
	            level = _parseVp9Private.level,
	            bitDepth = _parseVp9Private.bitDepth,
	            chromaSubsampling = _parseVp9Private.chromaSubsampling;
	
	        codec = 'vp09.';
	        codec += (0, _byteHelpers.padStart)(profile, 2, '0') + ".";
	        codec += (0, _byteHelpers.padStart)(level, 2, '0') + ".";
	        codec += (0, _byteHelpers.padStart)(bitDepth, 2, '0') + ".";
	        codec += "" + (0, _byteHelpers.padStart)(chromaSubsampling, 2, '0'); // Video -> Colour -> Ebml name
	
	        var matrixCoefficients = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB1]])[0] || [];
	        var videoFullRangeFlag = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB9]])[0] || [];
	        var transferCharacteristics = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBA]])[0] || [];
	        var colourPrimaries = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBB]])[0] || []; // if we find any optional codec parameter specify them all.
	
	        if (matrixCoefficients.length || videoFullRangeFlag.length || transferCharacteristics.length || colourPrimaries.length) {
	          codec += "." + (0, _byteHelpers.padStart)(colourPrimaries[0], 2, '0');
	          codec += "." + (0, _byteHelpers.padStart)(transferCharacteristics[0], 2, '0');
	          codec += "." + (0, _byteHelpers.padStart)(matrixCoefficients[0], 2, '0');
	          codec += "." + (0, _byteHelpers.padStart)(videoFullRangeFlag[0], 2, '0');
	        }
	      } else {
	        codec = 'vp9';
	      }
	    } else if (/^V_AV1/.test(decodedTrack.rawCodec)) {
	      codec = "av01." + (0, _codecHelpers.getAv1Codec)(decodedTrack.codecPrivate);
	    } else if (/A_ALAC/.test(decodedTrack.rawCodec)) {
	      codec = 'alac';
	    } else if (/A_MPEG\/L2/.test(decodedTrack.rawCodec)) {
	      codec = 'mp2';
	    } else if (/A_MPEG\/L3/.test(decodedTrack.rawCodec)) {
	      codec = 'mp3';
	    } else if (/^A_AAC/.test(decodedTrack.rawCodec)) {
	      if (decodedTrack.codecPrivate) {
	        codec = 'mp4a.40.' + (decodedTrack.codecPrivate[0] >>> 3).toString();
	      } else {
	        codec = 'mp4a.40.2';
	      }
	    } else if (/^A_AC3/.test(decodedTrack.rawCodec)) {
	      codec = 'ac-3';
	    } else if (/^A_PCM/.test(decodedTrack.rawCodec)) {
	      codec = 'pcm';
	    } else if (/^A_MS\/ACM/.test(decodedTrack.rawCodec)) {
	      codec = 'speex';
	    } else if (/^A_EAC3/.test(decodedTrack.rawCodec)) {
	      codec = 'ec-3';
	    } else if (/^A_VORBIS/.test(decodedTrack.rawCodec)) {
	      codec = 'vorbis';
	    } else if (/^A_FLAC/.test(decodedTrack.rawCodec)) {
	      codec = 'flac';
	    } else if (/^A_OPUS/.test(decodedTrack.rawCodec)) {
	      codec = 'opus';
	    }
	
	    decodedTrack.codec = codec;
	    decodedTracks.push(decodedTrack);
	  });
	  return decodedTracks.sort(function (a, b) {
	    return a.number - b.number;
	  });
	};
	
	exports.parseTracks = parseTracks;
	
	var parseData = function parseData(data, tracks) {
	  var allBlocks = [];
	  var segment = findEbml(data, [EBML_TAGS.Segment])[0];
	  var timestampScale = findEbml(segment, [EBML_TAGS.SegmentInfo, EBML_TAGS.TimestampScale])[0]; // in nanoseconds, defaults to 1ms
	
	  if (timestampScale && timestampScale.length) {
	    timestampScale = (0, _byteHelpers.bytesToNumber)(timestampScale);
	  } else {
	    timestampScale = 1000000;
	  }
	
	  var clusters = findEbml(segment, [EBML_TAGS.Cluster]);
	
	  if (!tracks) {
	    tracks = parseTracks(segment);
	  }
	
	  clusters.forEach(function (cluster, ci) {
	    var simpleBlocks = findEbml(cluster, [EBML_TAGS.SimpleBlock]).map(function (b) {
	      return {
	        type: 'simple',
	        data: b
	      };
	    });
	    var blockGroups = findEbml(cluster, [EBML_TAGS.BlockGroup]).map(function (b) {
	      return {
	        type: 'group',
	        data: b
	      };
	    });
	    var timestamp = findEbml(cluster, [EBML_TAGS.Timestamp])[0] || 0;
	
	    if (timestamp && timestamp.length) {
	      timestamp = (0, _byteHelpers.bytesToNumber)(timestamp);
	    } // get all blocks then sort them into the correct order
	
	
	    var blocks = simpleBlocks.concat(blockGroups).sort(function (a, b) {
	      return a.data.byteOffset - b.data.byteOffset;
	    });
	    blocks.forEach(function (block, bi) {
	      var decoded = decodeBlock(block.data, block.type, timestampScale, timestamp);
	      allBlocks.push(decoded);
	    });
	  });
	  return {
	    tracks: tracks,
	    blocks: allBlocks
	  };
	};
	
	exports.parseData = parseData;

/***/ },
/* 316 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forEachMediaGroup = void 0;
	
	/**
	 * Loops through all supported media groups in master and calls the provided
	 * callback for each group
	 *
	 * @param {Object} master
	 *        The parsed master manifest object
	 * @param {string[]} groups
	 *        The media groups to call the callback for
	 * @param {Function} callback
	 *        Callback to call for each media group
	 */
	var forEachMediaGroup = function forEachMediaGroup(master, groups, callback) {
	  groups.forEach(function (mediaType) {
	    for (var groupKey in master.mediaGroups[mediaType]) {
	      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
	        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
	        callback(mediaProperties, mediaType, groupKey, labelKey);
	      }
	    }
	  });
	};
	
	exports.forEachMediaGroup = forEachMediaGroup;

/***/ },
/* 317 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.simpleTypeFromSourceType = void 0;
	var MPEGURL_REGEX = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
	var DASH_REGEX = /^application\/dash\+xml/i;
	/**
	 * Returns a string that describes the type of source based on a video source object's
	 * media type.
	 *
	 * @see {@link https://dev.w3.org/html5/pf-summary/video.html#dom-source-type|Source Type}
	 *
	 * @param {string} type
	 *        Video source object media type
	 * @return {('hls'|'dash'|'vhs-json'|null)}
	 *         VHS source type string
	 */
	
	var simpleTypeFromSourceType = function simpleTypeFromSourceType(type) {
	  if (MPEGURL_REGEX.test(type)) {
	    return 'hls';
	  }
	
	  if (DASH_REGEX.test(type)) {
	    return 'dash';
	  } // Denotes the special case of a manifest object passed to http-streaming instead of a
	  // source URL.
	  //
	  // See https://en.wikipedia.org/wiki/Media_type for details on specifying media types.
	  //
	  // In this case, vnd stands for vendor, video.js for the organization, VHS for this
	  // project, and the +json suffix identifies the structure of the media type.
	
	
	  if (type === 'application/vnd.videojs.vhs+json') {
	    return 'vhs-json';
	  }
	
	  return null;
	};
	
	exports.simpleTypeFromSourceType = simpleTypeFromSourceType;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseMediaInfo = exports.parseTracks = exports.addSampleDescription = exports.buildFrameTable = exports.findNamedBox = exports.findBox = exports.parseDescriptors = void 0;
	
	var _byteHelpers = __webpack_require__(63);
	
	var _codecHelpers = __webpack_require__(190);
	
	var _opusHelpers = __webpack_require__(320);
	
	var normalizePath = function normalizePath(path) {
	  if (typeof path === 'string') {
	    return (0, _byteHelpers.stringToBytes)(path);
	  }
	
	  if (typeof path === 'number') {
	    return path;
	  }
	
	  return path;
	};
	
	var normalizePaths = function normalizePaths(paths) {
	  if (!Array.isArray(paths)) {
	    return [normalizePath(paths)];
	  }
	
	  return paths.map(function (p) {
	    return normalizePath(p);
	  });
	};
	
	var DESCRIPTORS;
	
	var parseDescriptors = function parseDescriptors(bytes) {
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var results = [];
	  var i = 0;
	
	  while (bytes.length > i) {
	    var tag = bytes[i];
	    var size = 0;
	    var headerSize = 0; // tag
	
	    headerSize++;
	    var byte = bytes[headerSize]; // first byte
	
	    headerSize++;
	
	    while (byte & 0x80) {
	      size = (byte & 0x7F) << 7;
	      byte = bytes[headerSize];
	      headerSize++;
	    }
	
	    size += byte & 0x7F;
	
	    for (var z = 0; z < DESCRIPTORS.length; z++) {
	      var _DESCRIPTORS$z = DESCRIPTORS[z],
	          id = _DESCRIPTORS$z.id,
	          parser = _DESCRIPTORS$z.parser;
	
	      if (tag === id) {
	        results.push(parser(bytes.subarray(headerSize, headerSize + size)));
	        break;
	      }
	    }
	
	    i += size + headerSize;
	  }
	
	  return results;
	};
	
	exports.parseDescriptors = parseDescriptors;
	DESCRIPTORS = [{
	  id: 0x03,
	  parser: function parser(bytes) {
	    var desc = {
	      tag: 0x03,
	      id: bytes[0] << 8 | bytes[1],
	      flags: bytes[2],
	      size: 3,
	      dependsOnEsId: 0,
	      ocrEsId: 0,
	      descriptors: [],
	      url: ''
	    }; // depends on es id
	
	    if (desc.flags & 0x80) {
	      desc.dependsOnEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
	      desc.size += 2;
	    } // url
	
	
	    if (desc.flags & 0x40) {
	      var len = bytes[desc.size];
	      desc.url = (0, _byteHelpers.bytesToString)(bytes.subarray(desc.size + 1, desc.size + 1 + len));
	      desc.size += len;
	    } // ocr es id
	
	
	    if (desc.flags & 0x20) {
	      desc.ocrEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
	      desc.size += 2;
	    }
	
	    desc.descriptors = parseDescriptors(bytes.subarray(desc.size)) || [];
	    return desc;
	  }
	}, {
	  id: 0x04,
	  parser: function parser(bytes) {
	    // DecoderConfigDescriptor
	    var desc = {
	      tag: 0x04,
	      oti: bytes[0],
	      streamType: bytes[1],
	      bufferSize: bytes[2] << 16 | bytes[3] << 8 | bytes[4],
	      maxBitrate: bytes[5] << 24 | bytes[6] << 16 | bytes[7] << 8 | bytes[8],
	      avgBitrate: bytes[9] << 24 | bytes[10] << 16 | bytes[11] << 8 | bytes[12],
	      descriptors: parseDescriptors(bytes.subarray(13))
	    };
	    return desc;
	  }
	}, {
	  id: 0x05,
	  parser: function parser(bytes) {
	    // DecoderSpecificInfo
	    return {
	      tag: 0x05,
	      bytes: bytes
	    };
	  }
	}, {
	  id: 0x06,
	  parser: function parser(bytes) {
	    // SLConfigDescriptor
	    return {
	      tag: 0x06,
	      bytes: bytes
	    };
	  }
	}];
	/**
	 * find any number of boxes by name given a path to it in an iso bmff
	 * such as mp4.
	 *
	 * @param {TypedArray} bytes
	 *        bytes for the iso bmff to search for boxes in
	 *
	 * @param {Uint8Array[]|string[]|string|Uint8Array} name
	 *        An array of paths or a single path representing the name
	 *        of boxes to search through in bytes. Paths may be
	 *        uint8 (character codes) or strings.
	 *
	 * @param {boolean} [complete=false]
	 *        Should we search only for complete boxes on the final path.
	 *        This is very useful when you do not want to get back partial boxes
	 *        in the case of streaming files.
	 *
	 * @return {Uint8Array[]}
	 *         An array of the end paths that we found.
	 */
	
	var findBox = function findBox(bytes, paths, complete) {
	  if (complete === void 0) {
	    complete = false;
	  }
	
	  paths = normalizePaths(paths);
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var results = [];
	
	  if (!paths.length) {
	    // short-circuit the search for empty paths
	    return results;
	  }
	
	  var i = 0;
	
	  while (i < bytes.length) {
	    var size = (bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]) >>> 0;
	    var type = bytes.subarray(i + 4, i + 8); // invalid box format.
	
	    if (size === 0) {
	      break;
	    }
	
	    var end = i + size;
	
	    if (end > bytes.length) {
	      // this box is bigger than the number of bytes we have
	      // and complete is set, we cannot find any more boxes.
	      if (complete) {
	        break;
	      }
	
	      end = bytes.length;
	    }
	
	    var data = bytes.subarray(i + 8, end);
	
	    if ((0, _byteHelpers.bytesMatch)(type, paths[0])) {
	      if (paths.length === 1) {
	        // this is the end of the path and we've found the box we were
	        // looking for
	        results.push(data);
	      } else {
	        // recursively search for the next box along the path
	        results.push.apply(results, findBox(data, paths.slice(1), complete));
	      }
	    }
	
	    i = end;
	  } // we've finished searching all of bytes
	
	
	  return results;
	};
	/**
	 * Search for a single matching box by name in an iso bmff format like
	 * mp4. This function is useful for finding codec boxes which
	 * can be placed arbitrarily in sample descriptions depending
	 * on the version of the file or file type.
	 *
	 * @param {TypedArray} bytes
	 *        bytes for the iso bmff to search for boxes in
	 *
	 * @param {string|Uint8Array} name
	 *        The name of the box to find.
	 *
	 * @return {Uint8Array[]}
	 *         a subarray of bytes representing the name boxed we found.
	 */
	
	
	exports.findBox = findBox;
	
	var findNamedBox = function findNamedBox(bytes, name) {
	  name = normalizePath(name);
	
	  if (!name.length) {
	    // short-circuit the search for empty paths
	    return bytes.subarray(bytes.length);
	  }
	
	  var i = 0;
	
	  while (i < bytes.length) {
	    if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i, i + name.length), name)) {
	      var size = (bytes[i - 4] << 24 | bytes[i - 3] << 16 | bytes[i - 2] << 8 | bytes[i - 1]) >>> 0;
	      var end = size > 1 ? i + size : bytes.byteLength;
	      return bytes.subarray(i + 4, end);
	    }
	
	    i++;
	  } // we've finished searching all of bytes
	
	
	  return bytes.subarray(bytes.length);
	};
	
	exports.findNamedBox = findNamedBox;
	
	var parseSamples = function parseSamples(data, entrySize, parseEntry) {
	  if (entrySize === void 0) {
	    entrySize = 4;
	  }
	
	  if (parseEntry === void 0) {
	    parseEntry = function parseEntry(d) {
	      return (0, _byteHelpers.bytesToNumber)(d);
	    };
	  }
	
	  var entries = [];
	
	  if (!data || !data.length) {
	    return entries;
	  }
	
	  var entryCount = (0, _byteHelpers.bytesToNumber)(data.subarray(4, 8));
	
	  for (var i = 8; entryCount; i += entrySize, entryCount--) {
	    entries.push(parseEntry(data.subarray(i, i + entrySize)));
	  }
	
	  return entries;
	};
	
	var buildFrameTable = function buildFrameTable(stbl, timescale) {
	  var keySamples = parseSamples(findBox(stbl, ['stss'])[0]);
	  var chunkOffsets = parseSamples(findBox(stbl, ['stco'])[0]);
	  var timeToSamples = parseSamples(findBox(stbl, ['stts'])[0], 8, function (entry) {
	    return {
	      sampleCount: (0, _byteHelpers.bytesToNumber)(entry.subarray(0, 4)),
	      sampleDelta: (0, _byteHelpers.bytesToNumber)(entry.subarray(4, 8))
	    };
	  });
	  var samplesToChunks = parseSamples(findBox(stbl, ['stsc'])[0], 12, function (entry) {
	    return {
	      firstChunk: (0, _byteHelpers.bytesToNumber)(entry.subarray(0, 4)),
	      samplesPerChunk: (0, _byteHelpers.bytesToNumber)(entry.subarray(4, 8)),
	      sampleDescriptionIndex: (0, _byteHelpers.bytesToNumber)(entry.subarray(8, 12))
	    };
	  });
	  var stsz = findBox(stbl, ['stsz'])[0]; // stsz starts with a 4 byte sampleSize which we don't need
	
	  var sampleSizes = parseSamples(stsz && stsz.length && stsz.subarray(4) || null);
	  var frames = [];
	
	  for (var chunkIndex = 0; chunkIndex < chunkOffsets.length; chunkIndex++) {
	    var samplesInChunk = void 0;
	
	    for (var i = 0; i < samplesToChunks.length; i++) {
	      var sampleToChunk = samplesToChunks[i];
	      var isThisOne = chunkIndex + 1 >= sampleToChunk.firstChunk && (i + 1 >= samplesToChunks.length || chunkIndex + 1 < samplesToChunks[i + 1].firstChunk);
	
	      if (isThisOne) {
	        samplesInChunk = sampleToChunk.samplesPerChunk;
	        break;
	      }
	    }
	
	    var chunkOffset = chunkOffsets[chunkIndex];
	
	    for (var _i = 0; _i < samplesInChunk; _i++) {
	      var frameEnd = sampleSizes[frames.length]; // if we don't have key samples every frame is a keyframe
	
	      var keyframe = !keySamples.length;
	
	      if (keySamples.length && keySamples.indexOf(frames.length + 1) !== -1) {
	        keyframe = true;
	      }
	
	      var frame = {
	        keyframe: keyframe,
	        start: chunkOffset,
	        end: chunkOffset + frameEnd
	      };
	
	      for (var k = 0; k < timeToSamples.length; k++) {
	        var _timeToSamples$k = timeToSamples[k],
	            sampleCount = _timeToSamples$k.sampleCount,
	            sampleDelta = _timeToSamples$k.sampleDelta;
	
	        if (frames.length <= sampleCount) {
	          // ms to ns
	          var lastTimestamp = frames.length ? frames[frames.length - 1].timestamp : 0;
	          frame.timestamp = lastTimestamp + sampleDelta / timescale * 1000;
	          frame.duration = sampleDelta;
	          break;
	        }
	      }
	
	      frames.push(frame);
	      chunkOffset += frameEnd;
	    }
	  }
	
	  return frames;
	};
	
	exports.buildFrameTable = buildFrameTable;
	
	var addSampleDescription = function addSampleDescription(track, bytes) {
	  var codec = (0, _byteHelpers.bytesToString)(bytes.subarray(0, 4));
	
	  if (track.type === 'video') {
	    track.info = track.info || {};
	    track.info.width = bytes[28] << 8 | bytes[29];
	    track.info.height = bytes[30] << 8 | bytes[31];
	  } else if (track.type === 'audio') {
	    track.info = track.info || {};
	    track.info.channels = bytes[20] << 8 | bytes[21];
	    track.info.bitDepth = bytes[22] << 8 | bytes[23];
	    track.info.sampleRate = bytes[28] << 8 | bytes[29];
	  }
	
	  if (codec === 'avc1') {
	    var avcC = findNamedBox(bytes, 'avcC'); // AVCDecoderConfigurationRecord
	
	    codec += "." + (0, _codecHelpers.getAvcCodec)(avcC);
	    track.info.avcC = avcC; // TODO: do we need to parse all this?
	
	    /* {
	      configurationVersion: avcC[0],
	      profile: avcC[1],
	      profileCompatibility: avcC[2],
	      level: avcC[3],
	      lengthSizeMinusOne: avcC[4] & 0x3
	    };
	     let spsNalUnitCount = avcC[5] & 0x1F;
	    const spsNalUnits = track.info.avc.spsNalUnits = [];
	     // past spsNalUnitCount
	    let offset = 6;
	     while (spsNalUnitCount--) {
	      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
	       spsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
	       offset += nalLen + 2;
	    }
	    let ppsNalUnitCount = avcC[offset];
	    const ppsNalUnits = track.info.avc.ppsNalUnits = [];
	     // past ppsNalUnitCount
	    offset += 1;
	     while (ppsNalUnitCount--) {
	      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
	       ppsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
	       offset += nalLen + 2;
	    }*/
	    // HEVCDecoderConfigurationRecord
	  } else if (codec === 'hvc1' || codec === 'hev1') {
	    codec += "." + (0, _codecHelpers.getHvcCodec)(findNamedBox(bytes, 'hvcC'));
	  } else if (codec === 'mp4a' || codec === 'mp4v') {
	    var esds = findNamedBox(bytes, 'esds');
	    var esDescriptor = parseDescriptors(esds.subarray(4))[0];
	    var decoderConfig = esDescriptor && esDescriptor.descriptors.filter(function (_ref) {
	      var tag = _ref.tag;
	      return tag === 0x04;
	    })[0];
	
	    if (decoderConfig) {
	      // most codecs do not have a further '.'
	      // such as 0xa5 for ac-3 and 0xa6 for e-ac-3
	      codec += '.' + (0, _byteHelpers.toHexString)(decoderConfig.oti);
	
	      if (decoderConfig.oti === 0x40) {
	        codec += '.' + (decoderConfig.descriptors[0].bytes[0] >> 3).toString();
	      } else if (decoderConfig.oti === 0x20) {
	        codec += '.' + decoderConfig.descriptors[0].bytes[4].toString();
	      } else if (decoderConfig.oti === 0xdd) {
	        codec = 'vorbis';
	      }
	    } else if (track.type === 'audio') {
	      codec += '.40.2';
	    } else {
	      codec += '.20.9';
	    }
	  } else if (codec === 'av01') {
	    // AV1DecoderConfigurationRecord
	    codec += "." + (0, _codecHelpers.getAv1Codec)(findNamedBox(bytes, 'av1C'));
	  } else if (codec === 'vp09') {
	    // VPCodecConfigurationRecord
	    var vpcC = findNamedBox(bytes, 'vpcC'); // https://www.webmproject.org/vp9/mp4/
	
	    var profile = vpcC[0];
	    var level = vpcC[1];
	    var bitDepth = vpcC[2] >> 4;
	    var chromaSubsampling = (vpcC[2] & 0x0F) >> 1;
	    var videoFullRangeFlag = (vpcC[2] & 0x0F) >> 3;
	    var colourPrimaries = vpcC[3];
	    var transferCharacteristics = vpcC[4];
	    var matrixCoefficients = vpcC[5];
	    codec += "." + (0, _byteHelpers.padStart)(profile, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(level, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(bitDepth, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(chromaSubsampling, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(colourPrimaries, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(transferCharacteristics, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(matrixCoefficients, 2, '0');
	    codec += "." + (0, _byteHelpers.padStart)(videoFullRangeFlag, 2, '0');
	  } else if (codec === 'theo') {
	    codec = 'theora';
	  } else if (codec === 'spex') {
	    codec = 'speex';
	  } else if (codec === '.mp3') {
	    codec = 'mp4a.40.34';
	  } else if (codec === 'msVo') {
	    codec = 'vorbis';
	  } else if (codec === 'Opus') {
	    codec = 'opus';
	    var dOps = findNamedBox(bytes, 'dOps');
	    track.info.opus = (0, _opusHelpers.parseOpusHead)(dOps); // TODO: should this go into the webm code??
	    // Firefox requires a codecDelay for opus playback
	    // see https://bugzilla.mozilla.org/show_bug.cgi?id=1276238
	
	    track.info.codecDelay = 6500000;
	  } else {
	    codec = codec.toLowerCase();
	  }
	  /* eslint-enable */
	  // flac, ac-3, ec-3, opus
	
	
	  track.codec = codec;
	};
	
	exports.addSampleDescription = addSampleDescription;
	
	var parseTracks = function parseTracks(bytes, frameTable) {
	  if (frameTable === void 0) {
	    frameTable = true;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  var traks = findBox(bytes, ['moov', 'trak'], true);
	  var tracks = [];
	  traks.forEach(function (trak) {
	    var track = {
	      bytes: trak
	    };
	    var mdia = findBox(trak, ['mdia'])[0];
	    var hdlr = findBox(mdia, ['hdlr'])[0];
	    var trakType = (0, _byteHelpers.bytesToString)(hdlr.subarray(8, 12));
	
	    if (trakType === 'soun') {
	      track.type = 'audio';
	    } else if (trakType === 'vide') {
	      track.type = 'video';
	    } else {
	      track.type = trakType;
	    }
	
	    var tkhd = findBox(trak, ['tkhd'])[0];
	
	    if (tkhd) {
	      var view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
	      var tkhdVersion = view.getUint8(0);
	      track.number = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
	    }
	
	    var mdhd = findBox(mdia, ['mdhd'])[0];
	
	    if (mdhd) {
	      // mdhd is a FullBox, meaning it will have its own version as the first byte
	      var version = mdhd[0];
	      var index = version === 0 ? 12 : 20;
	      track.timescale = (mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]) >>> 0;
	    }
	
	    var stbl = findBox(mdia, ['minf', 'stbl'])[0];
	    var stsd = findBox(stbl, ['stsd'])[0];
	    var descriptionCount = (0, _byteHelpers.bytesToNumber)(stsd.subarray(4, 8));
	    var offset = 8; // add codec and codec info
	
	    while (descriptionCount--) {
	      var len = (0, _byteHelpers.bytesToNumber)(stsd.subarray(offset, offset + 4));
	      var sampleDescriptor = stsd.subarray(offset + 4, offset + 4 + len);
	      addSampleDescription(track, sampleDescriptor);
	      offset += 4 + len;
	    }
	
	    if (frameTable) {
	      track.frameTable = buildFrameTable(stbl, track.timescale);
	    } // codec has no sub parameters
	
	
	    tracks.push(track);
	  });
	  return tracks;
	};
	
	exports.parseTracks = parseTracks;
	
	var parseMediaInfo = function parseMediaInfo(bytes) {
	  var mvhd = findBox(bytes, ['moov', 'mvhd'], true)[0];
	
	  if (!mvhd || !mvhd.length) {
	    return;
	  }
	
	  var info = {}; // ms to ns
	  // mvhd v1 has 8 byte duration and other fields too
	
	  if (mvhd[0] === 1) {
	    info.timestampScale = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(20, 24));
	    info.duration = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(24, 32));
	  } else {
	    info.timestampScale = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(12, 16));
	    info.duration = (0, _byteHelpers.bytesToNumber)(mvhd.subarray(16, 20));
	  }
	
	  info.bytes = mvhd;
	  return info;
	};
	
	exports.parseMediaInfo = parseMediaInfo;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findH265Nal = exports.findH264Nal = exports.findNal = exports.discardEmulationPreventionBytes = exports.EMULATION_PREVENTION = exports.NAL_TYPE_TWO = exports.NAL_TYPE_ONE = void 0;
	
	var _byteHelpers = __webpack_require__(63);
	
	var NAL_TYPE_ONE = (0, _byteHelpers.toUint8)([0x00, 0x00, 0x00, 0x01]);
	exports.NAL_TYPE_ONE = NAL_TYPE_ONE;
	var NAL_TYPE_TWO = (0, _byteHelpers.toUint8)([0x00, 0x00, 0x01]);
	exports.NAL_TYPE_TWO = NAL_TYPE_TWO;
	var EMULATION_PREVENTION = (0, _byteHelpers.toUint8)([0x00, 0x00, 0x03]);
	/**
	 * Expunge any "Emulation Prevention" bytes from a "Raw Byte
	 * Sequence Payload"
	 *
	 * @param data {Uint8Array} the bytes of a RBSP from a NAL
	 * unit
	 * @return {Uint8Array} the RBSP without any Emulation
	 * Prevention Bytes
	 */
	
	exports.EMULATION_PREVENTION = EMULATION_PREVENTION;
	
	var discardEmulationPreventionBytes = function discardEmulationPreventionBytes(bytes) {
	  var positions = [];
	  var i = 1; // Find all `Emulation Prevention Bytes`
	
	  while (i < bytes.length - 2) {
	    if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i, i + 3), EMULATION_PREVENTION)) {
	      positions.push(i + 2);
	      i++;
	    }
	
	    i++;
	  } // If no Emulation Prevention Bytes were found just return the original
	  // array
	
	
	  if (positions.length === 0) {
	    return bytes;
	  } // Create a new array to hold the NAL unit data
	
	
	  var newLength = bytes.length - positions.length;
	  var newData = new Uint8Array(newLength);
	  var sourceIndex = 0;
	
	  for (i = 0; i < newLength; sourceIndex++, i++) {
	    if (sourceIndex === positions[0]) {
	      // Skip this byte
	      sourceIndex++; // Remove this position index
	
	      positions.shift();
	    }
	
	    newData[i] = bytes[sourceIndex];
	  }
	
	  return newData;
	};
	
	exports.discardEmulationPreventionBytes = discardEmulationPreventionBytes;
	
	var findNal = function findNal(bytes, dataType, types, nalLimit) {
	  if (nalLimit === void 0) {
	    nalLimit = Infinity;
	  }
	
	  bytes = (0, _byteHelpers.toUint8)(bytes);
	  types = [].concat(types);
	  var i = 0;
	  var nalStart;
	  var nalsFound = 0; // keep searching until:
	  // we reach the end of bytes
	  // we reach the maximum number of nals they want to seach
	  // NOTE: that we disregard nalLimit when we have found the start
	  // of the nal we want so that we can find the end of the nal we want.
	
	  while (i < bytes.length && (nalsFound < nalLimit || nalStart)) {
	    var nalOffset = void 0;
	
	    if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i), NAL_TYPE_ONE)) {
	      nalOffset = 4;
	    } else if ((0, _byteHelpers.bytesMatch)(bytes.subarray(i), NAL_TYPE_TWO)) {
	      nalOffset = 3;
	    } // we are unsynced,
	    // find the next nal unit
	
	
	    if (!nalOffset) {
	      i++;
	      continue;
	    }
	
	    nalsFound++;
	
	    if (nalStart) {
	      return discardEmulationPreventionBytes(bytes.subarray(nalStart, i));
	    }
	
	    var nalType = void 0;
	
	    if (dataType === 'h264') {
	      nalType = bytes[i + nalOffset] & 0x1f;
	    } else if (dataType === 'h265') {
	      nalType = bytes[i + nalOffset] >> 1 & 0x3f;
	    }
	
	    if (types.indexOf(nalType) !== -1) {
	      nalStart = i + nalOffset;
	    } // nal header is 1 length for h264, and 2 for h265
	
	
	    i += nalOffset + (dataType === 'h264' ? 1 : 2);
	  }
	
	  return bytes.subarray(0, 0);
	};
	
	exports.findNal = findNal;
	
	var findH264Nal = function findH264Nal(bytes, type, nalLimit) {
	  return findNal(bytes, 'h264', type, nalLimit);
	};
	
	exports.findH264Nal = findH264Nal;
	
	var findH265Nal = function findH265Nal(bytes, type, nalLimit) {
	  return findNal(bytes, 'h265', type, nalLimit);
	};
	
	exports.findH265Nal = findH265Nal;

/***/ },
/* 320 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOpusHead = exports.parseOpusHead = exports.OPUS_HEAD = void 0;
	var OPUS_HEAD = new Uint8Array([// O, p, u, s
	0x4f, 0x70, 0x75, 0x73, // H, e, a, d
	0x48, 0x65, 0x61, 0x64]); // https://wiki.xiph.org/OggOpus
	// https://vfrmaniac.fushizen.eu/contents/opus_in_isobmff.html
	// https://opus-codec.org/docs/opusfile_api-0.7/structOpusHead.html
	
	exports.OPUS_HEAD = OPUS_HEAD;
	
	var parseOpusHead = function parseOpusHead(bytes) {
	  var view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
	  var version = view.getUint8(0); // version 0, from mp4, does not use littleEndian.
	
	  var littleEndian = version !== 0;
	  var config = {
	    version: version,
	    channels: view.getUint8(1),
	    preSkip: view.getUint16(2, littleEndian),
	    sampleRate: view.getUint32(4, littleEndian),
	    outputGain: view.getUint16(8, littleEndian),
	    channelMappingFamily: view.getUint8(10)
	  };
	
	  if (config.channelMappingFamily > 0 && bytes.length > 10) {
	    config.streamCount = view.getUint8(11);
	    config.twoChannelStreamCount = view.getUint8(12);
	    config.channelMapping = [];
	
	    for (var c = 0; c < config.channels; c++) {
	      config.channelMapping.push(view.getUint8(13 + c));
	    }
	  }
	
	  return config;
	};
	
	exports.parseOpusHead = parseOpusHead;
	
	var setOpusHead = function setOpusHead(config) {
	  var size = config.channelMappingFamily <= 0 ? 11 : 12 + config.channels;
	  var view = new DataView(new ArrayBuffer(size));
	  var littleEndian = config.version !== 0;
	  view.setUint8(0, config.version);
	  view.setUint8(1, config.channels);
	  view.setUint16(2, config.preSkip, littleEndian);
	  view.setUint32(4, config.sampleRate, littleEndian);
	  view.setUint16(8, config.outputGain, littleEndian);
	  view.setUint8(10, config.channelMappingFamily);
	
	  if (config.channelMappingFamily > 0) {
	    view.setUint8(11, config.streamCount);
	    config.channelMapping.foreach(function (cm, i) {
	      view.setUint8(12 + i, cm);
	    });
	  }
	
	  return new Uint8Array(view.buffer);
	};
	
	exports.setOpusHead = setOpusHead;

/***/ },
/* 321 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * @file stream.js
	 */
	
	/**
	 * A lightweight readable stream implemention that handles event dispatching.
	 *
	 * @class Stream
	 */
	var Stream = /*#__PURE__*/function () {
	  function Stream() {
	    this.listeners = {};
	  }
	  /**
	   * Add a listener for a specified event type.
	   *
	   * @param {string} type the event name
	   * @param {Function} listener the callback to be invoked when an event of
	   * the specified type occurs
	   */
	
	
	  var _proto = Stream.prototype;
	
	  _proto.on = function on(type, listener) {
	    if (!this.listeners[type]) {
	      this.listeners[type] = [];
	    }
	
	    this.listeners[type].push(listener);
	  }
	  /**
	   * Remove a listener for a specified event type.
	   *
	   * @param {string} type the event name
	   * @param {Function} listener  a function previously registered for this
	   * type of event through `on`
	   * @return {boolean} if we could turn it off or not
	   */
	  ;
	
	  _proto.off = function off(type, listener) {
	    if (!this.listeners[type]) {
	      return false;
	    }
	
	    var index = this.listeners[type].indexOf(listener); // TODO: which is better?
	    // In Video.js we slice listener functions
	    // on trigger so that it does not mess up the order
	    // while we loop through.
	    //
	    // Here we slice on off so that the loop in trigger
	    // can continue using it's old reference to loop without
	    // messing up the order.
	
	    this.listeners[type] = this.listeners[type].slice(0);
	    this.listeners[type].splice(index, 1);
	    return index > -1;
	  }
	  /**
	   * Trigger an event of the specified type on this stream. Any additional
	   * arguments to this function are passed as parameters to event listeners.
	   *
	   * @param {string} type the event name
	   */
	  ;
	
	  _proto.trigger = function trigger(type) {
	    var callbacks = this.listeners[type];
	
	    if (!callbacks) {
	      return;
	    } // Slicing the arguments on every invocation of this method
	    // can add a significant amount of overhead. Avoid the
	    // intermediate object creation for the common case of a
	    // single callback argument
	
	
	    if (arguments.length === 2) {
	      var length = callbacks.length;
	
	      for (var i = 0; i < length; ++i) {
	        callbacks[i].call(this, arguments[1]);
	      }
	    } else {
	      var args = Array.prototype.slice.call(arguments, 1);
	      var _length = callbacks.length;
	
	      for (var _i = 0; _i < _length; ++_i) {
	        callbacks[_i].apply(this, args);
	      }
	    }
	  }
	  /**
	   * Destroys the stream and cleans up.
	   */
	  ;
	
	  _proto.dispose = function dispose() {
	    this.listeners = {};
	  }
	  /**
	   * Forwards all `data` events on this stream to the destination stream. The
	   * destination stream should provide a method `push` to receive the data
	   * events as they arrive.
	   *
	   * @param {Stream} destination the stream that will receive all `data` events
	   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	   */
	  ;
	
	  _proto.pipe = function pipe(destination) {
	    this.on('data', function (data) {
	      destination.push(data);
	    });
	  };
	
	  return Stream;
	}();
	
	exports.default = Stream;
	module.exports = exports.default;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var window = __webpack_require__(54);
	
	var httpResponseHandler = function httpResponseHandler(callback, decodeResponseBody) {
	  if (decodeResponseBody === void 0) {
	    decodeResponseBody = false;
	  }
	
	  return function (err, response, responseBody) {
	    // if the XHR failed, return that error
	    if (err) {
	      callback(err);
	      return;
	    } // if the HTTP status code is 4xx or 5xx, the request also failed
	
	
	    if (response.statusCode >= 400 && response.statusCode <= 599) {
	      var cause = responseBody;
	
	      if (decodeResponseBody) {
	        if (window.TextDecoder) {
	          var charset = getCharset(response.headers && response.headers['content-type']);
	
	          try {
	            cause = new TextDecoder(charset).decode(responseBody);
	          } catch (e) {}
	        } else {
	          cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
	        }
	      }
	
	      callback({
	        cause: cause
	      });
	      return;
	    } // otherwise, request succeeded
	
	
	    callback(null, responseBody);
	  };
	};
	
	function getCharset(contentTypeHeader) {
	  if (contentTypeHeader === void 0) {
	    contentTypeHeader = '';
	  }
	
	  return contentTypeHeader.toLowerCase().split(';').reduce(function (charset, contentType) {
	    var _contentType$split = contentType.split('='),
	        type = _contentType$split[0],
	        value = _contentType$split[1];
	
	    if (type.trim() === 'charset') {
	      return value.trim();
	    }
	
	    return charset;
	  }, 'utf-8');
	}
	
	module.exports = httpResponseHandler;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var window = __webpack_require__(54);
	
	var _extends = __webpack_require__(57);
	
	var isFunction = __webpack_require__(562);
	
	createXHR.httpHandler = __webpack_require__(322);
	/**
	 * @license
	 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
	 * Copyright (c) 2014 David Björklund
	 * Available under the MIT license
	 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
	 */
	
	var parseHeaders = function parseHeaders(headers) {
	  var result = {};
	
	  if (!headers) {
	    return result;
	  }
	
	  headers.trim().split('\n').forEach(function (row) {
	    var index = row.indexOf(':');
	    var key = row.slice(0, index).trim().toLowerCase();
	    var value = row.slice(index + 1).trim();
	
	    if (typeof result[key] === 'undefined') {
	      result[key] = value;
	    } else if (Array.isArray(result[key])) {
	      result[key].push(value);
	    } else {
	      result[key] = [result[key], value];
	    }
	  });
	  return result;
	};
	
	module.exports = createXHR; // Allow use of default import syntax in TypeScript
	
	module.exports.default = createXHR;
	createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
	createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;
	forEachArray(["get", "put", "post", "patch", "head", "delete"], function (method) {
	  createXHR[method === "delete" ? "del" : method] = function (uri, options, callback) {
	    options = initParams(uri, options, callback);
	    options.method = method.toUpperCase();
	    return _createXHR(options);
	  };
	});
	
	function forEachArray(array, iterator) {
	  for (var i = 0; i < array.length; i++) {
	    iterator(array[i]);
	  }
	}
	
	function isEmpty(obj) {
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) return false;
	  }
	
	  return true;
	}
	
	function initParams(uri, options, callback) {
	  var params = uri;
	
	  if (isFunction(options)) {
	    callback = options;
	
	    if (typeof uri === "string") {
	      params = {
	        uri: uri
	      };
	    }
	  } else {
	    params = _extends({}, options, {
	      uri: uri
	    });
	  }
	
	  params.callback = callback;
	  return params;
	}
	
	function createXHR(uri, options, callback) {
	  options = initParams(uri, options, callback);
	  return _createXHR(options);
	}
	
	function _createXHR(options) {
	  if (typeof options.callback === "undefined") {
	    throw new Error("callback argument missing");
	  }
	
	  var called = false;
	
	  var callback = function cbOnce(err, response, body) {
	    if (!called) {
	      called = true;
	      options.callback(err, response, body);
	    }
	  };
	
	  function readystatechange() {
	    if (xhr.readyState === 4) {
	      setTimeout(loadFunc, 0);
	    }
	  }
	
	  function getBody() {
	    // Chrome with requestType=blob throws errors arround when even testing access to responseText
	    var body = undefined;
	
	    if (xhr.response) {
	      body = xhr.response;
	    } else {
	      body = xhr.responseText || getXml(xhr);
	    }
	
	    if (isJson) {
	      try {
	        body = JSON.parse(body);
	      } catch (e) {}
	    }
	
	    return body;
	  }
	
	  function errorFunc(evt) {
	    clearTimeout(timeoutTimer);
	
	    if (!(evt instanceof Error)) {
	      evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
	    }
	
	    evt.statusCode = 0;
	    return callback(evt, failureResponse);
	  } // will load the data & process the response in a special response object
	
	
	  function loadFunc() {
	    if (aborted) return;
	    var status;
	    clearTimeout(timeoutTimer);
	
	    if (options.useXDR && xhr.status === undefined) {
	      //IE8 CORS GET successful response doesn't have a status field, but body is fine
	      status = 200;
	    } else {
	      status = xhr.status === 1223 ? 204 : xhr.status;
	    }
	
	    var response = failureResponse;
	    var err = null;
	
	    if (status !== 0) {
	      response = {
	        body: getBody(),
	        statusCode: status,
	        method: method,
	        headers: {},
	        url: uri,
	        rawRequest: xhr
	      };
	
	      if (xhr.getAllResponseHeaders) {
	        //remember xhr can in fact be XDR for CORS in IE
	        response.headers = parseHeaders(xhr.getAllResponseHeaders());
	      }
	    } else {
	      err = new Error("Internal XMLHttpRequest Error");
	    }
	
	    return callback(err, response, response.body);
	  }
	
	  var xhr = options.xhr || null;
	
	  if (!xhr) {
	    if (options.cors || options.useXDR) {
	      xhr = new createXHR.XDomainRequest();
	    } else {
	      xhr = new createXHR.XMLHttpRequest();
	    }
	  }
	
	  var key;
	  var aborted;
	  var uri = xhr.url = options.uri || options.url;
	  var method = xhr.method = options.method || "GET";
	  var body = options.body || options.data;
	  var headers = xhr.headers = options.headers || {};
	  var sync = !!options.sync;
	  var isJson = false;
	  var timeoutTimer;
	  var failureResponse = {
	    body: undefined,
	    headers: {},
	    statusCode: 0,
	    method: method,
	    url: uri,
	    rawRequest: xhr
	  };
	
	  if ("json" in options && options.json !== false) {
	    isJson = true;
	    headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
	
	    if (method !== "GET" && method !== "HEAD") {
	      headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
	
	      body = JSON.stringify(options.json === true ? body : options.json);
	    }
	  }
	
	  xhr.onreadystatechange = readystatechange;
	  xhr.onload = loadFunc;
	  xhr.onerror = errorFunc; // IE9 must have onprogress be set to a unique function.
	
	  xhr.onprogress = function () {// IE must die
	  };
	
	  xhr.onabort = function () {
	    aborted = true;
	  };
	
	  xhr.ontimeout = errorFunc;
	  xhr.open(method, uri, !sync, options.username, options.password); //has to be after open
	
	  if (!sync) {
	    xhr.withCredentials = !!options.withCredentials;
	  } // Cannot set timeout with sync request
	  // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
	  // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
	
	
	  if (!sync && options.timeout > 0) {
	    timeoutTimer = setTimeout(function () {
	      if (aborted) return;
	      aborted = true; //IE9 may still call readystatechange
	
	      xhr.abort("timeout");
	      var e = new Error("XMLHttpRequest timeout");
	      e.code = "ETIMEDOUT";
	      errorFunc(e);
	    }, options.timeout);
	  }
	
	  if (xhr.setRequestHeader) {
	    for (key in headers) {
	      if (headers.hasOwnProperty(key)) {
	        xhr.setRequestHeader(key, headers[key]);
	      }
	    }
	  } else if (options.headers && !isEmpty(options.headers)) {
	    throw new Error("Headers cannot be set on an XDomainRequest object");
	  }
	
	  if ("responseType" in options) {
	    xhr.responseType = options.responseType;
	  }
	
	  if ("beforeSend" in options && typeof options.beforeSend === "function") {
	    options.beforeSend(xhr);
	  } // Microsoft Edge browser sends "undefined" when send is called with undefined value.
	  // XMLHttpRequest spec says to pass null as body to indicate no body
	  // See https://github.com/naugtur/xhr/issues/100.
	
	
	  xhr.send(body || null);
	  return xhr;
	}
	
	function getXml(xhr) {
	  // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
	  // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
	  try {
	    if (xhr.responseType === "document") {
	      return xhr.responseXML;
	    }
	
	    var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
	
	    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
	      return xhr.responseXML;
	    }
	  } catch (e) {}
	
	  return null;
	}
	
	function noop() {}

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var conventions = __webpack_require__(102);
	var dom = __webpack_require__(194)
	var entities = __webpack_require__(325);
	var sax = __webpack_require__(327);
	
	var DOMImplementation = dom.DOMImplementation;
	
	var NAMESPACE = conventions.NAMESPACE;
	
	var ParseError = sax.ParseError;
	var XMLReader = sax.XMLReader;
	
	/**
	 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
	 *
	 * > XML parsed entities are often stored in computer files which,
	 * > for editing convenience, are organized into lines.
	 * > These lines are typically separated by some combination
	 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
	 * >
	 * > To simplify the tasks of applications, the XML processor must behave
	 * > as if it normalized all line breaks in external parsed entities (including the document entity)
	 * > on input, before parsing, by translating all of the following to a single #xA character:
	 * >
	 * > 1. the two-character sequence #xD #xA
	 * > 2. the two-character sequence #xD #x85
	 * > 3. the single character #x85
	 * > 4. the single character #x2028
	 * > 5. any #xD character that is not immediately followed by #xA or #x85.
	 *
	 * @param {string} input
	 * @returns {string}
	 */
	function normalizeLineEndings(input) {
		return input
			.replace(/\r[\n\u0085]/g, '\n')
			.replace(/[\r\u0085\u2028]/g, '\n')
	}
	
	/**
	 * @typedef Locator
	 * @property {number} [columnNumber]
	 * @property {number} [lineNumber]
	 */
	
	/**
	 * @typedef DOMParserOptions
	 * @property {DOMHandler} [domBuilder]
	 * @property {Function} [errorHandler]
	 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
	 * 						defaults to `normalizeLineEndings`
	 * @property {Locator} [locator]
	 * @property {Record<string, string>} [xmlns]
	 *
	 * @see normalizeLineEndings
	 */
	
	/**
	 * The DOMParser interface provides the ability to parse XML or HTML source code
	 * from a string into a DOM `Document`.
	 *
	 * _xmldom is different from the spec in that it allows an `options` parameter,
	 * to override the default behavior._
	 *
	 * @param {DOMParserOptions} [options]
	 * @constructor
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
	 */
	function DOMParser(options){
		this.options = options ||{locator:{}};
	}
	
	DOMParser.prototype.parseFromString = function(source,mimeType){
		var options = this.options;
		var sax =  new XMLReader();
		var domBuilder = options.domBuilder || new DOMHandler();//contentHandler and LexicalHandler
		var errorHandler = options.errorHandler;
		var locator = options.locator;
		var defaultNSMap = options.xmlns||{};
		var isHTML = /\/x?html?$/.test(mimeType);//mimeType.toLowerCase().indexOf('html') > -1;
	  	var entityMap = isHTML ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
		if(locator){
			domBuilder.setDocumentLocator(locator)
		}
	
		sax.errorHandler = buildErrorHandler(errorHandler,domBuilder,locator);
		sax.domBuilder = options.domBuilder || domBuilder;
		if(isHTML){
			defaultNSMap[''] = NAMESPACE.HTML;
		}
		defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
		var normalize = options.normalizeLineEndings || normalizeLineEndings;
		if (source && typeof source === 'string') {
			sax.parse(
				normalize(source),
				defaultNSMap,
				entityMap
			)
		} else {
			sax.errorHandler.error('invalid doc source')
		}
		return domBuilder.doc;
	}
	function buildErrorHandler(errorImpl,domBuilder,locator){
		if(!errorImpl){
			if(domBuilder instanceof DOMHandler){
				return domBuilder;
			}
			errorImpl = domBuilder ;
		}
		var errorHandler = {}
		var isCallback = errorImpl instanceof Function;
		locator = locator||{}
		function build(key){
			var fn = errorImpl[key];
			if(!fn && isCallback){
				fn = errorImpl.length == 2?function(msg){errorImpl(key,msg)}:errorImpl;
			}
			errorHandler[key] = fn && function(msg){
				fn('[xmldom '+key+']\t'+msg+_locator(locator));
			}||function(){};
		}
		build('warning');
		build('error');
		build('fatalError');
		return errorHandler;
	}
	
	//console.log('#\n\n\n\n\n\n\n####')
	/**
	 * +ContentHandler+ErrorHandler
	 * +LexicalHandler+EntityResolver2
	 * -DeclHandler-DTDHandler
	 *
	 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
	 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
	 */
	function DOMHandler() {
	    this.cdata = false;
	}
	function position(locator,node){
		node.lineNumber = locator.lineNumber;
		node.columnNumber = locator.columnNumber;
	}
	/**
	 * @see org.xml.sax.ContentHandler#startDocument
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
	 */
	DOMHandler.prototype = {
		startDocument : function() {
	    	this.doc = new DOMImplementation().createDocument(null, null, null);
	    	if (this.locator) {
	        	this.doc.documentURI = this.locator.systemId;
	    	}
		},
		startElement:function(namespaceURI, localName, qName, attrs) {
			var doc = this.doc;
		    var el = doc.createElementNS(namespaceURI, qName||localName);
		    var len = attrs.length;
		    appendElement(this, el);
		    this.currentElement = el;
	
			this.locator && position(this.locator,el)
		    for (var i = 0 ; i < len; i++) {
		        var namespaceURI = attrs.getURI(i);
		        var value = attrs.getValue(i);
		        var qName = attrs.getQName(i);
				var attr = doc.createAttributeNS(namespaceURI, qName);
				this.locator &&position(attrs.getLocator(i),attr);
				attr.value = attr.nodeValue = value;
				el.setAttributeNode(attr)
		    }
		},
		endElement:function(namespaceURI, localName, qName) {
			var current = this.currentElement
			var tagName = current.tagName;
			this.currentElement = current.parentNode;
		},
		startPrefixMapping:function(prefix, uri) {
		},
		endPrefixMapping:function(prefix) {
		},
		processingInstruction:function(target, data) {
		    var ins = this.doc.createProcessingInstruction(target, data);
		    this.locator && position(this.locator,ins)
		    appendElement(this, ins);
		},
		ignorableWhitespace:function(ch, start, length) {
		},
		characters:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
			//console.log(chars)
			if(chars){
				if (this.cdata) {
					var charNode = this.doc.createCDATASection(chars);
				} else {
					var charNode = this.doc.createTextNode(chars);
				}
				if(this.currentElement){
					this.currentElement.appendChild(charNode);
				}else if(/^\s*$/.test(chars)){
					this.doc.appendChild(charNode);
					//process xml
				}
				this.locator && position(this.locator,charNode)
			}
		},
		skippedEntity:function(name) {
		},
		endDocument:function() {
			this.doc.normalize();
		},
		setDocumentLocator:function (locator) {
		    if(this.locator = locator){// && !('lineNumber' in locator)){
		    	locator.lineNumber = 0;
		    }
		},
		//LexicalHandler
		comment:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
		    var comm = this.doc.createComment(chars);
		    this.locator && position(this.locator,comm)
		    appendElement(this, comm);
		},
	
		startCDATA:function() {
		    //used in characters() methods
		    this.cdata = true;
		},
		endCDATA:function() {
		    this.cdata = false;
		},
	
		startDTD:function(name, publicId, systemId) {
			var impl = this.doc.implementation;
		    if (impl && impl.createDocumentType) {
		        var dt = impl.createDocumentType(name, publicId, systemId);
		        this.locator && position(this.locator,dt)
		        appendElement(this, dt);
						this.doc.doctype = dt;
		    }
		},
		/**
		 * @see org.xml.sax.ErrorHandler
		 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
		 */
		warning:function(error) {
			console.warn('[xmldom warning]\t'+error,_locator(this.locator));
		},
		error:function(error) {
			console.error('[xmldom error]\t'+error,_locator(this.locator));
		},
		fatalError:function(error) {
			throw new ParseError(error, this.locator);
		}
	}
	function _locator(l){
		if(l){
			return '\n@'+(l.systemId ||'')+'#[line:'+l.lineNumber+',col:'+l.columnNumber+']'
		}
	}
	function _toString(chars,start,length){
		if(typeof chars == 'string'){
			return chars.substr(start,length)
		}else{//java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
			if(chars.length >= start+length || start){
				return new java.lang.String(chars,start,length)+'';
			}
			return chars;
		}
	}
	
	/*
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
	 * used method of org.xml.sax.ext.LexicalHandler:
	 *  #comment(chars, start, length)
	 *  #startCDATA()
	 *  #endCDATA()
	 *  #startDTD(name, publicId, systemId)
	 *
	 *
	 * IGNORED method of org.xml.sax.ext.LexicalHandler:
	 *  #endDTD()
	 *  #startEntity(name)
	 *  #endEntity(name)
	 *
	 *
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
	 * IGNORED method of org.xml.sax.ext.DeclHandler
	 * 	#attributeDecl(eName, aName, type, mode, value)
	 *  #elementDecl(name, model)
	 *  #externalEntityDecl(name, publicId, systemId)
	 *  #internalEntityDecl(name, value)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
	 * IGNORED method of org.xml.sax.EntityResolver2
	 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
	 *  #resolveEntity(publicId, systemId)
	 *  #getExternalSubset(name, baseURI)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
	 * IGNORED method of org.xml.sax.DTDHandler
	 *  #notationDecl(name, publicId, systemId) {};
	 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
	 */
	"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g,function(key){
		DOMHandler.prototype[key] = function(){return null}
	})
	
	/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
	function appendElement (hander,node) {
	    if (!hander.currentElement) {
	        hander.doc.appendChild(node);
	    } else {
	        hander.currentElement.appendChild(node);
	    }
	}//appendChild and setAttributeNS are preformance key
	
	exports.__DOMHandler = DOMHandler;
	exports.normalizeLineEndings = normalizeLineEndings;
	exports.DOMParser = DOMParser;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var freeze = __webpack_require__(102).freeze;
	
	/**
	 * The entities that are predefined in every XML document.
	 *
	 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
	 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
	 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
	 */
	exports.XML_ENTITIES = freeze({
		amp: '&',
		apos: "'",
		gt: '>',
		lt: '<',
		quot: '"',
	});
	
	/**
	 * A map of all entities that are detected in an HTML document.
	 * They contain all entries from `XML_ENTITIES`.
	 *
	 * @see XML_ENTITIES
	 * @see DOMParser.parseFromString
	 * @see DOMImplementation.prototype.createHTMLDocument
	 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
	 * @see https://html.spec.whatwg.org/entities.json JSON
	 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
	 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
	 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
	 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
	 */
	exports.HTML_ENTITIES = freeze({
		Aacute: '\u00C1',
		aacute: '\u00E1',
		Abreve: '\u0102',
		abreve: '\u0103',
		ac: '\u223E',
		acd: '\u223F',
		acE: '\u223E\u0333',
		Acirc: '\u00C2',
		acirc: '\u00E2',
		acute: '\u00B4',
		Acy: '\u0410',
		acy: '\u0430',
		AElig: '\u00C6',
		aelig: '\u00E6',
		af: '\u2061',
		Afr: '\uD835\uDD04',
		afr: '\uD835\uDD1E',
		Agrave: '\u00C0',
		agrave: '\u00E0',
		alefsym: '\u2135',
		aleph: '\u2135',
		Alpha: '\u0391',
		alpha: '\u03B1',
		Amacr: '\u0100',
		amacr: '\u0101',
		amalg: '\u2A3F',
		AMP: '\u0026',
		amp: '\u0026',
		And: '\u2A53',
		and: '\u2227',
		andand: '\u2A55',
		andd: '\u2A5C',
		andslope: '\u2A58',
		andv: '\u2A5A',
		ang: '\u2220',
		ange: '\u29A4',
		angle: '\u2220',
		angmsd: '\u2221',
		angmsdaa: '\u29A8',
		angmsdab: '\u29A9',
		angmsdac: '\u29AA',
		angmsdad: '\u29AB',
		angmsdae: '\u29AC',
		angmsdaf: '\u29AD',
		angmsdag: '\u29AE',
		angmsdah: '\u29AF',
		angrt: '\u221F',
		angrtvb: '\u22BE',
		angrtvbd: '\u299D',
		angsph: '\u2222',
		angst: '\u00C5',
		angzarr: '\u237C',
		Aogon: '\u0104',
		aogon: '\u0105',
		Aopf: '\uD835\uDD38',
		aopf: '\uD835\uDD52',
		ap: '\u2248',
		apacir: '\u2A6F',
		apE: '\u2A70',
		ape: '\u224A',
		apid: '\u224B',
		apos: '\u0027',
		ApplyFunction: '\u2061',
		approx: '\u2248',
		approxeq: '\u224A',
		Aring: '\u00C5',
		aring: '\u00E5',
		Ascr: '\uD835\uDC9C',
		ascr: '\uD835\uDCB6',
		Assign: '\u2254',
		ast: '\u002A',
		asymp: '\u2248',
		asympeq: '\u224D',
		Atilde: '\u00C3',
		atilde: '\u00E3',
		Auml: '\u00C4',
		auml: '\u00E4',
		awconint: '\u2233',
		awint: '\u2A11',
		backcong: '\u224C',
		backepsilon: '\u03F6',
		backprime: '\u2035',
		backsim: '\u223D',
		backsimeq: '\u22CD',
		Backslash: '\u2216',
		Barv: '\u2AE7',
		barvee: '\u22BD',
		Barwed: '\u2306',
		barwed: '\u2305',
		barwedge: '\u2305',
		bbrk: '\u23B5',
		bbrktbrk: '\u23B6',
		bcong: '\u224C',
		Bcy: '\u0411',
		bcy: '\u0431',
		bdquo: '\u201E',
		becaus: '\u2235',
		Because: '\u2235',
		because: '\u2235',
		bemptyv: '\u29B0',
		bepsi: '\u03F6',
		bernou: '\u212C',
		Bernoullis: '\u212C',
		Beta: '\u0392',
		beta: '\u03B2',
		beth: '\u2136',
		between: '\u226C',
		Bfr: '\uD835\uDD05',
		bfr: '\uD835\uDD1F',
		bigcap: '\u22C2',
		bigcirc: '\u25EF',
		bigcup: '\u22C3',
		bigodot: '\u2A00',
		bigoplus: '\u2A01',
		bigotimes: '\u2A02',
		bigsqcup: '\u2A06',
		bigstar: '\u2605',
		bigtriangledown: '\u25BD',
		bigtriangleup: '\u25B3',
		biguplus: '\u2A04',
		bigvee: '\u22C1',
		bigwedge: '\u22C0',
		bkarow: '\u290D',
		blacklozenge: '\u29EB',
		blacksquare: '\u25AA',
		blacktriangle: '\u25B4',
		blacktriangledown: '\u25BE',
		blacktriangleleft: '\u25C2',
		blacktriangleright: '\u25B8',
		blank: '\u2423',
		blk12: '\u2592',
		blk14: '\u2591',
		blk34: '\u2593',
		block: '\u2588',
		bne: '\u003D\u20E5',
		bnequiv: '\u2261\u20E5',
		bNot: '\u2AED',
		bnot: '\u2310',
		Bopf: '\uD835\uDD39',
		bopf: '\uD835\uDD53',
		bot: '\u22A5',
		bottom: '\u22A5',
		bowtie: '\u22C8',
		boxbox: '\u29C9',
		boxDL: '\u2557',
		boxDl: '\u2556',
		boxdL: '\u2555',
		boxdl: '\u2510',
		boxDR: '\u2554',
		boxDr: '\u2553',
		boxdR: '\u2552',
		boxdr: '\u250C',
		boxH: '\u2550',
		boxh: '\u2500',
		boxHD: '\u2566',
		boxHd: '\u2564',
		boxhD: '\u2565',
		boxhd: '\u252C',
		boxHU: '\u2569',
		boxHu: '\u2567',
		boxhU: '\u2568',
		boxhu: '\u2534',
		boxminus: '\u229F',
		boxplus: '\u229E',
		boxtimes: '\u22A0',
		boxUL: '\u255D',
		boxUl: '\u255C',
		boxuL: '\u255B',
		boxul: '\u2518',
		boxUR: '\u255A',
		boxUr: '\u2559',
		boxuR: '\u2558',
		boxur: '\u2514',
		boxV: '\u2551',
		boxv: '\u2502',
		boxVH: '\u256C',
		boxVh: '\u256B',
		boxvH: '\u256A',
		boxvh: '\u253C',
		boxVL: '\u2563',
		boxVl: '\u2562',
		boxvL: '\u2561',
		boxvl: '\u2524',
		boxVR: '\u2560',
		boxVr: '\u255F',
		boxvR: '\u255E',
		boxvr: '\u251C',
		bprime: '\u2035',
		Breve: '\u02D8',
		breve: '\u02D8',
		brvbar: '\u00A6',
		Bscr: '\u212C',
		bscr: '\uD835\uDCB7',
		bsemi: '\u204F',
		bsim: '\u223D',
		bsime: '\u22CD',
		bsol: '\u005C',
		bsolb: '\u29C5',
		bsolhsub: '\u27C8',
		bull: '\u2022',
		bullet: '\u2022',
		bump: '\u224E',
		bumpE: '\u2AAE',
		bumpe: '\u224F',
		Bumpeq: '\u224E',
		bumpeq: '\u224F',
		Cacute: '\u0106',
		cacute: '\u0107',
		Cap: '\u22D2',
		cap: '\u2229',
		capand: '\u2A44',
		capbrcup: '\u2A49',
		capcap: '\u2A4B',
		capcup: '\u2A47',
		capdot: '\u2A40',
		CapitalDifferentialD: '\u2145',
		caps: '\u2229\uFE00',
		caret: '\u2041',
		caron: '\u02C7',
		Cayleys: '\u212D',
		ccaps: '\u2A4D',
		Ccaron: '\u010C',
		ccaron: '\u010D',
		Ccedil: '\u00C7',
		ccedil: '\u00E7',
		Ccirc: '\u0108',
		ccirc: '\u0109',
		Cconint: '\u2230',
		ccups: '\u2A4C',
		ccupssm: '\u2A50',
		Cdot: '\u010A',
		cdot: '\u010B',
		cedil: '\u00B8',
		Cedilla: '\u00B8',
		cemptyv: '\u29B2',
		cent: '\u00A2',
		CenterDot: '\u00B7',
		centerdot: '\u00B7',
		Cfr: '\u212D',
		cfr: '\uD835\uDD20',
		CHcy: '\u0427',
		chcy: '\u0447',
		check: '\u2713',
		checkmark: '\u2713',
		Chi: '\u03A7',
		chi: '\u03C7',
		cir: '\u25CB',
		circ: '\u02C6',
		circeq: '\u2257',
		circlearrowleft: '\u21BA',
		circlearrowright: '\u21BB',
		circledast: '\u229B',
		circledcirc: '\u229A',
		circleddash: '\u229D',
		CircleDot: '\u2299',
		circledR: '\u00AE',
		circledS: '\u24C8',
		CircleMinus: '\u2296',
		CirclePlus: '\u2295',
		CircleTimes: '\u2297',
		cirE: '\u29C3',
		cire: '\u2257',
		cirfnint: '\u2A10',
		cirmid: '\u2AEF',
		cirscir: '\u29C2',
		ClockwiseContourIntegral: '\u2232',
		CloseCurlyDoubleQuote: '\u201D',
		CloseCurlyQuote: '\u2019',
		clubs: '\u2663',
		clubsuit: '\u2663',
		Colon: '\u2237',
		colon: '\u003A',
		Colone: '\u2A74',
		colone: '\u2254',
		coloneq: '\u2254',
		comma: '\u002C',
		commat: '\u0040',
		comp: '\u2201',
		compfn: '\u2218',
		complement: '\u2201',
		complexes: '\u2102',
		cong: '\u2245',
		congdot: '\u2A6D',
		Congruent: '\u2261',
		Conint: '\u222F',
		conint: '\u222E',
		ContourIntegral: '\u222E',
		Copf: '\u2102',
		copf: '\uD835\uDD54',
		coprod: '\u2210',
		Coproduct: '\u2210',
		COPY: '\u00A9',
		copy: '\u00A9',
		copysr: '\u2117',
		CounterClockwiseContourIntegral: '\u2233',
		crarr: '\u21B5',
		Cross: '\u2A2F',
		cross: '\u2717',
		Cscr: '\uD835\uDC9E',
		cscr: '\uD835\uDCB8',
		csub: '\u2ACF',
		csube: '\u2AD1',
		csup: '\u2AD0',
		csupe: '\u2AD2',
		ctdot: '\u22EF',
		cudarrl: '\u2938',
		cudarrr: '\u2935',
		cuepr: '\u22DE',
		cuesc: '\u22DF',
		cularr: '\u21B6',
		cularrp: '\u293D',
		Cup: '\u22D3',
		cup: '\u222A',
		cupbrcap: '\u2A48',
		CupCap: '\u224D',
		cupcap: '\u2A46',
		cupcup: '\u2A4A',
		cupdot: '\u228D',
		cupor: '\u2A45',
		cups: '\u222A\uFE00',
		curarr: '\u21B7',
		curarrm: '\u293C',
		curlyeqprec: '\u22DE',
		curlyeqsucc: '\u22DF',
		curlyvee: '\u22CE',
		curlywedge: '\u22CF',
		curren: '\u00A4',
		curvearrowleft: '\u21B6',
		curvearrowright: '\u21B7',
		cuvee: '\u22CE',
		cuwed: '\u22CF',
		cwconint: '\u2232',
		cwint: '\u2231',
		cylcty: '\u232D',
		Dagger: '\u2021',
		dagger: '\u2020',
		daleth: '\u2138',
		Darr: '\u21A1',
		dArr: '\u21D3',
		darr: '\u2193',
		dash: '\u2010',
		Dashv: '\u2AE4',
		dashv: '\u22A3',
		dbkarow: '\u290F',
		dblac: '\u02DD',
		Dcaron: '\u010E',
		dcaron: '\u010F',
		Dcy: '\u0414',
		dcy: '\u0434',
		DD: '\u2145',
		dd: '\u2146',
		ddagger: '\u2021',
		ddarr: '\u21CA',
		DDotrahd: '\u2911',
		ddotseq: '\u2A77',
		deg: '\u00B0',
		Del: '\u2207',
		Delta: '\u0394',
		delta: '\u03B4',
		demptyv: '\u29B1',
		dfisht: '\u297F',
		Dfr: '\uD835\uDD07',
		dfr: '\uD835\uDD21',
		dHar: '\u2965',
		dharl: '\u21C3',
		dharr: '\u21C2',
		DiacriticalAcute: '\u00B4',
		DiacriticalDot: '\u02D9',
		DiacriticalDoubleAcute: '\u02DD',
		DiacriticalGrave: '\u0060',
		DiacriticalTilde: '\u02DC',
		diam: '\u22C4',
		Diamond: '\u22C4',
		diamond: '\u22C4',
		diamondsuit: '\u2666',
		diams: '\u2666',
		die: '\u00A8',
		DifferentialD: '\u2146',
		digamma: '\u03DD',
		disin: '\u22F2',
		div: '\u00F7',
		divide: '\u00F7',
		divideontimes: '\u22C7',
		divonx: '\u22C7',
		DJcy: '\u0402',
		djcy: '\u0452',
		dlcorn: '\u231E',
		dlcrop: '\u230D',
		dollar: '\u0024',
		Dopf: '\uD835\uDD3B',
		dopf: '\uD835\uDD55',
		Dot: '\u00A8',
		dot: '\u02D9',
		DotDot: '\u20DC',
		doteq: '\u2250',
		doteqdot: '\u2251',
		DotEqual: '\u2250',
		dotminus: '\u2238',
		dotplus: '\u2214',
		dotsquare: '\u22A1',
		doublebarwedge: '\u2306',
		DoubleContourIntegral: '\u222F',
		DoubleDot: '\u00A8',
		DoubleDownArrow: '\u21D3',
		DoubleLeftArrow: '\u21D0',
		DoubleLeftRightArrow: '\u21D4',
		DoubleLeftTee: '\u2AE4',
		DoubleLongLeftArrow: '\u27F8',
		DoubleLongLeftRightArrow: '\u27FA',
		DoubleLongRightArrow: '\u27F9',
		DoubleRightArrow: '\u21D2',
		DoubleRightTee: '\u22A8',
		DoubleUpArrow: '\u21D1',
		DoubleUpDownArrow: '\u21D5',
		DoubleVerticalBar: '\u2225',
		DownArrow: '\u2193',
		Downarrow: '\u21D3',
		downarrow: '\u2193',
		DownArrowBar: '\u2913',
		DownArrowUpArrow: '\u21F5',
		DownBreve: '\u0311',
		downdownarrows: '\u21CA',
		downharpoonleft: '\u21C3',
		downharpoonright: '\u21C2',
		DownLeftRightVector: '\u2950',
		DownLeftTeeVector: '\u295E',
		DownLeftVector: '\u21BD',
		DownLeftVectorBar: '\u2956',
		DownRightTeeVector: '\u295F',
		DownRightVector: '\u21C1',
		DownRightVectorBar: '\u2957',
		DownTee: '\u22A4',
		DownTeeArrow: '\u21A7',
		drbkarow: '\u2910',
		drcorn: '\u231F',
		drcrop: '\u230C',
		Dscr: '\uD835\uDC9F',
		dscr: '\uD835\uDCB9',
		DScy: '\u0405',
		dscy: '\u0455',
		dsol: '\u29F6',
		Dstrok: '\u0110',
		dstrok: '\u0111',
		dtdot: '\u22F1',
		dtri: '\u25BF',
		dtrif: '\u25BE',
		duarr: '\u21F5',
		duhar: '\u296F',
		dwangle: '\u29A6',
		DZcy: '\u040F',
		dzcy: '\u045F',
		dzigrarr: '\u27FF',
		Eacute: '\u00C9',
		eacute: '\u00E9',
		easter: '\u2A6E',
		Ecaron: '\u011A',
		ecaron: '\u011B',
		ecir: '\u2256',
		Ecirc: '\u00CA',
		ecirc: '\u00EA',
		ecolon: '\u2255',
		Ecy: '\u042D',
		ecy: '\u044D',
		eDDot: '\u2A77',
		Edot: '\u0116',
		eDot: '\u2251',
		edot: '\u0117',
		ee: '\u2147',
		efDot: '\u2252',
		Efr: '\uD835\uDD08',
		efr: '\uD835\uDD22',
		eg: '\u2A9A',
		Egrave: '\u00C8',
		egrave: '\u00E8',
		egs: '\u2A96',
		egsdot: '\u2A98',
		el: '\u2A99',
		Element: '\u2208',
		elinters: '\u23E7',
		ell: '\u2113',
		els: '\u2A95',
		elsdot: '\u2A97',
		Emacr: '\u0112',
		emacr: '\u0113',
		empty: '\u2205',
		emptyset: '\u2205',
		EmptySmallSquare: '\u25FB',
		emptyv: '\u2205',
		EmptyVerySmallSquare: '\u25AB',
		emsp: '\u2003',
		emsp13: '\u2004',
		emsp14: '\u2005',
		ENG: '\u014A',
		eng: '\u014B',
		ensp: '\u2002',
		Eogon: '\u0118',
		eogon: '\u0119',
		Eopf: '\uD835\uDD3C',
		eopf: '\uD835\uDD56',
		epar: '\u22D5',
		eparsl: '\u29E3',
		eplus: '\u2A71',
		epsi: '\u03B5',
		Epsilon: '\u0395',
		epsilon: '\u03B5',
		epsiv: '\u03F5',
		eqcirc: '\u2256',
		eqcolon: '\u2255',
		eqsim: '\u2242',
		eqslantgtr: '\u2A96',
		eqslantless: '\u2A95',
		Equal: '\u2A75',
		equals: '\u003D',
		EqualTilde: '\u2242',
		equest: '\u225F',
		Equilibrium: '\u21CC',
		equiv: '\u2261',
		equivDD: '\u2A78',
		eqvparsl: '\u29E5',
		erarr: '\u2971',
		erDot: '\u2253',
		Escr: '\u2130',
		escr: '\u212F',
		esdot: '\u2250',
		Esim: '\u2A73',
		esim: '\u2242',
		Eta: '\u0397',
		eta: '\u03B7',
		ETH: '\u00D0',
		eth: '\u00F0',
		Euml: '\u00CB',
		euml: '\u00EB',
		euro: '\u20AC',
		excl: '\u0021',
		exist: '\u2203',
		Exists: '\u2203',
		expectation: '\u2130',
		ExponentialE: '\u2147',
		exponentiale: '\u2147',
		fallingdotseq: '\u2252',
		Fcy: '\u0424',
		fcy: '\u0444',
		female: '\u2640',
		ffilig: '\uFB03',
		fflig: '\uFB00',
		ffllig: '\uFB04',
		Ffr: '\uD835\uDD09',
		ffr: '\uD835\uDD23',
		filig: '\uFB01',
		FilledSmallSquare: '\u25FC',
		FilledVerySmallSquare: '\u25AA',
		fjlig: '\u0066\u006A',
		flat: '\u266D',
		fllig: '\uFB02',
		fltns: '\u25B1',
		fnof: '\u0192',
		Fopf: '\uD835\uDD3D',
		fopf: '\uD835\uDD57',
		ForAll: '\u2200',
		forall: '\u2200',
		fork: '\u22D4',
		forkv: '\u2AD9',
		Fouriertrf: '\u2131',
		fpartint: '\u2A0D',
		frac12: '\u00BD',
		frac13: '\u2153',
		frac14: '\u00BC',
		frac15: '\u2155',
		frac16: '\u2159',
		frac18: '\u215B',
		frac23: '\u2154',
		frac25: '\u2156',
		frac34: '\u00BE',
		frac35: '\u2157',
		frac38: '\u215C',
		frac45: '\u2158',
		frac56: '\u215A',
		frac58: '\u215D',
		frac78: '\u215E',
		frasl: '\u2044',
		frown: '\u2322',
		Fscr: '\u2131',
		fscr: '\uD835\uDCBB',
		gacute: '\u01F5',
		Gamma: '\u0393',
		gamma: '\u03B3',
		Gammad: '\u03DC',
		gammad: '\u03DD',
		gap: '\u2A86',
		Gbreve: '\u011E',
		gbreve: '\u011F',
		Gcedil: '\u0122',
		Gcirc: '\u011C',
		gcirc: '\u011D',
		Gcy: '\u0413',
		gcy: '\u0433',
		Gdot: '\u0120',
		gdot: '\u0121',
		gE: '\u2267',
		ge: '\u2265',
		gEl: '\u2A8C',
		gel: '\u22DB',
		geq: '\u2265',
		geqq: '\u2267',
		geqslant: '\u2A7E',
		ges: '\u2A7E',
		gescc: '\u2AA9',
		gesdot: '\u2A80',
		gesdoto: '\u2A82',
		gesdotol: '\u2A84',
		gesl: '\u22DB\uFE00',
		gesles: '\u2A94',
		Gfr: '\uD835\uDD0A',
		gfr: '\uD835\uDD24',
		Gg: '\u22D9',
		gg: '\u226B',
		ggg: '\u22D9',
		gimel: '\u2137',
		GJcy: '\u0403',
		gjcy: '\u0453',
		gl: '\u2277',
		gla: '\u2AA5',
		glE: '\u2A92',
		glj: '\u2AA4',
		gnap: '\u2A8A',
		gnapprox: '\u2A8A',
		gnE: '\u2269',
		gne: '\u2A88',
		gneq: '\u2A88',
		gneqq: '\u2269',
		gnsim: '\u22E7',
		Gopf: '\uD835\uDD3E',
		gopf: '\uD835\uDD58',
		grave: '\u0060',
		GreaterEqual: '\u2265',
		GreaterEqualLess: '\u22DB',
		GreaterFullEqual: '\u2267',
		GreaterGreater: '\u2AA2',
		GreaterLess: '\u2277',
		GreaterSlantEqual: '\u2A7E',
		GreaterTilde: '\u2273',
		Gscr: '\uD835\uDCA2',
		gscr: '\u210A',
		gsim: '\u2273',
		gsime: '\u2A8E',
		gsiml: '\u2A90',
		Gt: '\u226B',
		GT: '\u003E',
		gt: '\u003E',
		gtcc: '\u2AA7',
		gtcir: '\u2A7A',
		gtdot: '\u22D7',
		gtlPar: '\u2995',
		gtquest: '\u2A7C',
		gtrapprox: '\u2A86',
		gtrarr: '\u2978',
		gtrdot: '\u22D7',
		gtreqless: '\u22DB',
		gtreqqless: '\u2A8C',
		gtrless: '\u2277',
		gtrsim: '\u2273',
		gvertneqq: '\u2269\uFE00',
		gvnE: '\u2269\uFE00',
		Hacek: '\u02C7',
		hairsp: '\u200A',
		half: '\u00BD',
		hamilt: '\u210B',
		HARDcy: '\u042A',
		hardcy: '\u044A',
		hArr: '\u21D4',
		harr: '\u2194',
		harrcir: '\u2948',
		harrw: '\u21AD',
		Hat: '\u005E',
		hbar: '\u210F',
		Hcirc: '\u0124',
		hcirc: '\u0125',
		hearts: '\u2665',
		heartsuit: '\u2665',
		hellip: '\u2026',
		hercon: '\u22B9',
		Hfr: '\u210C',
		hfr: '\uD835\uDD25',
		HilbertSpace: '\u210B',
		hksearow: '\u2925',
		hkswarow: '\u2926',
		hoarr: '\u21FF',
		homtht: '\u223B',
		hookleftarrow: '\u21A9',
		hookrightarrow: '\u21AA',
		Hopf: '\u210D',
		hopf: '\uD835\uDD59',
		horbar: '\u2015',
		HorizontalLine: '\u2500',
		Hscr: '\u210B',
		hscr: '\uD835\uDCBD',
		hslash: '\u210F',
		Hstrok: '\u0126',
		hstrok: '\u0127',
		HumpDownHump: '\u224E',
		HumpEqual: '\u224F',
		hybull: '\u2043',
		hyphen: '\u2010',
		Iacute: '\u00CD',
		iacute: '\u00ED',
		ic: '\u2063',
		Icirc: '\u00CE',
		icirc: '\u00EE',
		Icy: '\u0418',
		icy: '\u0438',
		Idot: '\u0130',
		IEcy: '\u0415',
		iecy: '\u0435',
		iexcl: '\u00A1',
		iff: '\u21D4',
		Ifr: '\u2111',
		ifr: '\uD835\uDD26',
		Igrave: '\u00CC',
		igrave: '\u00EC',
		ii: '\u2148',
		iiiint: '\u2A0C',
		iiint: '\u222D',
		iinfin: '\u29DC',
		iiota: '\u2129',
		IJlig: '\u0132',
		ijlig: '\u0133',
		Im: '\u2111',
		Imacr: '\u012A',
		imacr: '\u012B',
		image: '\u2111',
		ImaginaryI: '\u2148',
		imagline: '\u2110',
		imagpart: '\u2111',
		imath: '\u0131',
		imof: '\u22B7',
		imped: '\u01B5',
		Implies: '\u21D2',
		in: '\u2208',
		incare: '\u2105',
		infin: '\u221E',
		infintie: '\u29DD',
		inodot: '\u0131',
		Int: '\u222C',
		int: '\u222B',
		intcal: '\u22BA',
		integers: '\u2124',
		Integral: '\u222B',
		intercal: '\u22BA',
		Intersection: '\u22C2',
		intlarhk: '\u2A17',
		intprod: '\u2A3C',
		InvisibleComma: '\u2063',
		InvisibleTimes: '\u2062',
		IOcy: '\u0401',
		iocy: '\u0451',
		Iogon: '\u012E',
		iogon: '\u012F',
		Iopf: '\uD835\uDD40',
		iopf: '\uD835\uDD5A',
		Iota: '\u0399',
		iota: '\u03B9',
		iprod: '\u2A3C',
		iquest: '\u00BF',
		Iscr: '\u2110',
		iscr: '\uD835\uDCBE',
		isin: '\u2208',
		isindot: '\u22F5',
		isinE: '\u22F9',
		isins: '\u22F4',
		isinsv: '\u22F3',
		isinv: '\u2208',
		it: '\u2062',
		Itilde: '\u0128',
		itilde: '\u0129',
		Iukcy: '\u0406',
		iukcy: '\u0456',
		Iuml: '\u00CF',
		iuml: '\u00EF',
		Jcirc: '\u0134',
		jcirc: '\u0135',
		Jcy: '\u0419',
		jcy: '\u0439',
		Jfr: '\uD835\uDD0D',
		jfr: '\uD835\uDD27',
		jmath: '\u0237',
		Jopf: '\uD835\uDD41',
		jopf: '\uD835\uDD5B',
		Jscr: '\uD835\uDCA5',
		jscr: '\uD835\uDCBF',
		Jsercy: '\u0408',
		jsercy: '\u0458',
		Jukcy: '\u0404',
		jukcy: '\u0454',
		Kappa: '\u039A',
		kappa: '\u03BA',
		kappav: '\u03F0',
		Kcedil: '\u0136',
		kcedil: '\u0137',
		Kcy: '\u041A',
		kcy: '\u043A',
		Kfr: '\uD835\uDD0E',
		kfr: '\uD835\uDD28',
		kgreen: '\u0138',
		KHcy: '\u0425',
		khcy: '\u0445',
		KJcy: '\u040C',
		kjcy: '\u045C',
		Kopf: '\uD835\uDD42',
		kopf: '\uD835\uDD5C',
		Kscr: '\uD835\uDCA6',
		kscr: '\uD835\uDCC0',
		lAarr: '\u21DA',
		Lacute: '\u0139',
		lacute: '\u013A',
		laemptyv: '\u29B4',
		lagran: '\u2112',
		Lambda: '\u039B',
		lambda: '\u03BB',
		Lang: '\u27EA',
		lang: '\u27E8',
		langd: '\u2991',
		langle: '\u27E8',
		lap: '\u2A85',
		Laplacetrf: '\u2112',
		laquo: '\u00AB',
		Larr: '\u219E',
		lArr: '\u21D0',
		larr: '\u2190',
		larrb: '\u21E4',
		larrbfs: '\u291F',
		larrfs: '\u291D',
		larrhk: '\u21A9',
		larrlp: '\u21AB',
		larrpl: '\u2939',
		larrsim: '\u2973',
		larrtl: '\u21A2',
		lat: '\u2AAB',
		lAtail: '\u291B',
		latail: '\u2919',
		late: '\u2AAD',
		lates: '\u2AAD\uFE00',
		lBarr: '\u290E',
		lbarr: '\u290C',
		lbbrk: '\u2772',
		lbrace: '\u007B',
		lbrack: '\u005B',
		lbrke: '\u298B',
		lbrksld: '\u298F',
		lbrkslu: '\u298D',
		Lcaron: '\u013D',
		lcaron: '\u013E',
		Lcedil: '\u013B',
		lcedil: '\u013C',
		lceil: '\u2308',
		lcub: '\u007B',
		Lcy: '\u041B',
		lcy: '\u043B',
		ldca: '\u2936',
		ldquo: '\u201C',
		ldquor: '\u201E',
		ldrdhar: '\u2967',
		ldrushar: '\u294B',
		ldsh: '\u21B2',
		lE: '\u2266',
		le: '\u2264',
		LeftAngleBracket: '\u27E8',
		LeftArrow: '\u2190',
		Leftarrow: '\u21D0',
		leftarrow: '\u2190',
		LeftArrowBar: '\u21E4',
		LeftArrowRightArrow: '\u21C6',
		leftarrowtail: '\u21A2',
		LeftCeiling: '\u2308',
		LeftDoubleBracket: '\u27E6',
		LeftDownTeeVector: '\u2961',
		LeftDownVector: '\u21C3',
		LeftDownVectorBar: '\u2959',
		LeftFloor: '\u230A',
		leftharpoondown: '\u21BD',
		leftharpoonup: '\u21BC',
		leftleftarrows: '\u21C7',
		LeftRightArrow: '\u2194',
		Leftrightarrow: '\u21D4',
		leftrightarrow: '\u2194',
		leftrightarrows: '\u21C6',
		leftrightharpoons: '\u21CB',
		leftrightsquigarrow: '\u21AD',
		LeftRightVector: '\u294E',
		LeftTee: '\u22A3',
		LeftTeeArrow: '\u21A4',
		LeftTeeVector: '\u295A',
		leftthreetimes: '\u22CB',
		LeftTriangle: '\u22B2',
		LeftTriangleBar: '\u29CF',
		LeftTriangleEqual: '\u22B4',
		LeftUpDownVector: '\u2951',
		LeftUpTeeVector: '\u2960',
		LeftUpVector: '\u21BF',
		LeftUpVectorBar: '\u2958',
		LeftVector: '\u21BC',
		LeftVectorBar: '\u2952',
		lEg: '\u2A8B',
		leg: '\u22DA',
		leq: '\u2264',
		leqq: '\u2266',
		leqslant: '\u2A7D',
		les: '\u2A7D',
		lescc: '\u2AA8',
		lesdot: '\u2A7F',
		lesdoto: '\u2A81',
		lesdotor: '\u2A83',
		lesg: '\u22DA\uFE00',
		lesges: '\u2A93',
		lessapprox: '\u2A85',
		lessdot: '\u22D6',
		lesseqgtr: '\u22DA',
		lesseqqgtr: '\u2A8B',
		LessEqualGreater: '\u22DA',
		LessFullEqual: '\u2266',
		LessGreater: '\u2276',
		lessgtr: '\u2276',
		LessLess: '\u2AA1',
		lesssim: '\u2272',
		LessSlantEqual: '\u2A7D',
		LessTilde: '\u2272',
		lfisht: '\u297C',
		lfloor: '\u230A',
		Lfr: '\uD835\uDD0F',
		lfr: '\uD835\uDD29',
		lg: '\u2276',
		lgE: '\u2A91',
		lHar: '\u2962',
		lhard: '\u21BD',
		lharu: '\u21BC',
		lharul: '\u296A',
		lhblk: '\u2584',
		LJcy: '\u0409',
		ljcy: '\u0459',
		Ll: '\u22D8',
		ll: '\u226A',
		llarr: '\u21C7',
		llcorner: '\u231E',
		Lleftarrow: '\u21DA',
		llhard: '\u296B',
		lltri: '\u25FA',
		Lmidot: '\u013F',
		lmidot: '\u0140',
		lmoust: '\u23B0',
		lmoustache: '\u23B0',
		lnap: '\u2A89',
		lnapprox: '\u2A89',
		lnE: '\u2268',
		lne: '\u2A87',
		lneq: '\u2A87',
		lneqq: '\u2268',
		lnsim: '\u22E6',
		loang: '\u27EC',
		loarr: '\u21FD',
		lobrk: '\u27E6',
		LongLeftArrow: '\u27F5',
		Longleftarrow: '\u27F8',
		longleftarrow: '\u27F5',
		LongLeftRightArrow: '\u27F7',
		Longleftrightarrow: '\u27FA',
		longleftrightarrow: '\u27F7',
		longmapsto: '\u27FC',
		LongRightArrow: '\u27F6',
		Longrightarrow: '\u27F9',
		longrightarrow: '\u27F6',
		looparrowleft: '\u21AB',
		looparrowright: '\u21AC',
		lopar: '\u2985',
		Lopf: '\uD835\uDD43',
		lopf: '\uD835\uDD5D',
		loplus: '\u2A2D',
		lotimes: '\u2A34',
		lowast: '\u2217',
		lowbar: '\u005F',
		LowerLeftArrow: '\u2199',
		LowerRightArrow: '\u2198',
		loz: '\u25CA',
		lozenge: '\u25CA',
		lozf: '\u29EB',
		lpar: '\u0028',
		lparlt: '\u2993',
		lrarr: '\u21C6',
		lrcorner: '\u231F',
		lrhar: '\u21CB',
		lrhard: '\u296D',
		lrm: '\u200E',
		lrtri: '\u22BF',
		lsaquo: '\u2039',
		Lscr: '\u2112',
		lscr: '\uD835\uDCC1',
		Lsh: '\u21B0',
		lsh: '\u21B0',
		lsim: '\u2272',
		lsime: '\u2A8D',
		lsimg: '\u2A8F',
		lsqb: '\u005B',
		lsquo: '\u2018',
		lsquor: '\u201A',
		Lstrok: '\u0141',
		lstrok: '\u0142',
		Lt: '\u226A',
		LT: '\u003C',
		lt: '\u003C',
		ltcc: '\u2AA6',
		ltcir: '\u2A79',
		ltdot: '\u22D6',
		lthree: '\u22CB',
		ltimes: '\u22C9',
		ltlarr: '\u2976',
		ltquest: '\u2A7B',
		ltri: '\u25C3',
		ltrie: '\u22B4',
		ltrif: '\u25C2',
		ltrPar: '\u2996',
		lurdshar: '\u294A',
		luruhar: '\u2966',
		lvertneqq: '\u2268\uFE00',
		lvnE: '\u2268\uFE00',
		macr: '\u00AF',
		male: '\u2642',
		malt: '\u2720',
		maltese: '\u2720',
		Map: '\u2905',
		map: '\u21A6',
		mapsto: '\u21A6',
		mapstodown: '\u21A7',
		mapstoleft: '\u21A4',
		mapstoup: '\u21A5',
		marker: '\u25AE',
		mcomma: '\u2A29',
		Mcy: '\u041C',
		mcy: '\u043C',
		mdash: '\u2014',
		mDDot: '\u223A',
		measuredangle: '\u2221',
		MediumSpace: '\u205F',
		Mellintrf: '\u2133',
		Mfr: '\uD835\uDD10',
		mfr: '\uD835\uDD2A',
		mho: '\u2127',
		micro: '\u00B5',
		mid: '\u2223',
		midast: '\u002A',
		midcir: '\u2AF0',
		middot: '\u00B7',
		minus: '\u2212',
		minusb: '\u229F',
		minusd: '\u2238',
		minusdu: '\u2A2A',
		MinusPlus: '\u2213',
		mlcp: '\u2ADB',
		mldr: '\u2026',
		mnplus: '\u2213',
		models: '\u22A7',
		Mopf: '\uD835\uDD44',
		mopf: '\uD835\uDD5E',
		mp: '\u2213',
		Mscr: '\u2133',
		mscr: '\uD835\uDCC2',
		mstpos: '\u223E',
		Mu: '\u039C',
		mu: '\u03BC',
		multimap: '\u22B8',
		mumap: '\u22B8',
		nabla: '\u2207',
		Nacute: '\u0143',
		nacute: '\u0144',
		nang: '\u2220\u20D2',
		nap: '\u2249',
		napE: '\u2A70\u0338',
		napid: '\u224B\u0338',
		napos: '\u0149',
		napprox: '\u2249',
		natur: '\u266E',
		natural: '\u266E',
		naturals: '\u2115',
		nbsp: '\u00A0',
		nbump: '\u224E\u0338',
		nbumpe: '\u224F\u0338',
		ncap: '\u2A43',
		Ncaron: '\u0147',
		ncaron: '\u0148',
		Ncedil: '\u0145',
		ncedil: '\u0146',
		ncong: '\u2247',
		ncongdot: '\u2A6D\u0338',
		ncup: '\u2A42',
		Ncy: '\u041D',
		ncy: '\u043D',
		ndash: '\u2013',
		ne: '\u2260',
		nearhk: '\u2924',
		neArr: '\u21D7',
		nearr: '\u2197',
		nearrow: '\u2197',
		nedot: '\u2250\u0338',
		NegativeMediumSpace: '\u200B',
		NegativeThickSpace: '\u200B',
		NegativeThinSpace: '\u200B',
		NegativeVeryThinSpace: '\u200B',
		nequiv: '\u2262',
		nesear: '\u2928',
		nesim: '\u2242\u0338',
		NestedGreaterGreater: '\u226B',
		NestedLessLess: '\u226A',
		NewLine: '\u000A',
		nexist: '\u2204',
		nexists: '\u2204',
		Nfr: '\uD835\uDD11',
		nfr: '\uD835\uDD2B',
		ngE: '\u2267\u0338',
		nge: '\u2271',
		ngeq: '\u2271',
		ngeqq: '\u2267\u0338',
		ngeqslant: '\u2A7E\u0338',
		nges: '\u2A7E\u0338',
		nGg: '\u22D9\u0338',
		ngsim: '\u2275',
		nGt: '\u226B\u20D2',
		ngt: '\u226F',
		ngtr: '\u226F',
		nGtv: '\u226B\u0338',
		nhArr: '\u21CE',
		nharr: '\u21AE',
		nhpar: '\u2AF2',
		ni: '\u220B',
		nis: '\u22FC',
		nisd: '\u22FA',
		niv: '\u220B',
		NJcy: '\u040A',
		njcy: '\u045A',
		nlArr: '\u21CD',
		nlarr: '\u219A',
		nldr: '\u2025',
		nlE: '\u2266\u0338',
		nle: '\u2270',
		nLeftarrow: '\u21CD',
		nleftarrow: '\u219A',
		nLeftrightarrow: '\u21CE',
		nleftrightarrow: '\u21AE',
		nleq: '\u2270',
		nleqq: '\u2266\u0338',
		nleqslant: '\u2A7D\u0338',
		nles: '\u2A7D\u0338',
		nless: '\u226E',
		nLl: '\u22D8\u0338',
		nlsim: '\u2274',
		nLt: '\u226A\u20D2',
		nlt: '\u226E',
		nltri: '\u22EA',
		nltrie: '\u22EC',
		nLtv: '\u226A\u0338',
		nmid: '\u2224',
		NoBreak: '\u2060',
		NonBreakingSpace: '\u00A0',
		Nopf: '\u2115',
		nopf: '\uD835\uDD5F',
		Not: '\u2AEC',
		not: '\u00AC',
		NotCongruent: '\u2262',
		NotCupCap: '\u226D',
		NotDoubleVerticalBar: '\u2226',
		NotElement: '\u2209',
		NotEqual: '\u2260',
		NotEqualTilde: '\u2242\u0338',
		NotExists: '\u2204',
		NotGreater: '\u226F',
		NotGreaterEqual: '\u2271',
		NotGreaterFullEqual: '\u2267\u0338',
		NotGreaterGreater: '\u226B\u0338',
		NotGreaterLess: '\u2279',
		NotGreaterSlantEqual: '\u2A7E\u0338',
		NotGreaterTilde: '\u2275',
		NotHumpDownHump: '\u224E\u0338',
		NotHumpEqual: '\u224F\u0338',
		notin: '\u2209',
		notindot: '\u22F5\u0338',
		notinE: '\u22F9\u0338',
		notinva: '\u2209',
		notinvb: '\u22F7',
		notinvc: '\u22F6',
		NotLeftTriangle: '\u22EA',
		NotLeftTriangleBar: '\u29CF\u0338',
		NotLeftTriangleEqual: '\u22EC',
		NotLess: '\u226E',
		NotLessEqual: '\u2270',
		NotLessGreater: '\u2278',
		NotLessLess: '\u226A\u0338',
		NotLessSlantEqual: '\u2A7D\u0338',
		NotLessTilde: '\u2274',
		NotNestedGreaterGreater: '\u2AA2\u0338',
		NotNestedLessLess: '\u2AA1\u0338',
		notni: '\u220C',
		notniva: '\u220C',
		notnivb: '\u22FE',
		notnivc: '\u22FD',
		NotPrecedes: '\u2280',
		NotPrecedesEqual: '\u2AAF\u0338',
		NotPrecedesSlantEqual: '\u22E0',
		NotReverseElement: '\u220C',
		NotRightTriangle: '\u22EB',
		NotRightTriangleBar: '\u29D0\u0338',
		NotRightTriangleEqual: '\u22ED',
		NotSquareSubset: '\u228F\u0338',
		NotSquareSubsetEqual: '\u22E2',
		NotSquareSuperset: '\u2290\u0338',
		NotSquareSupersetEqual: '\u22E3',
		NotSubset: '\u2282\u20D2',
		NotSubsetEqual: '\u2288',
		NotSucceeds: '\u2281',
		NotSucceedsEqual: '\u2AB0\u0338',
		NotSucceedsSlantEqual: '\u22E1',
		NotSucceedsTilde: '\u227F\u0338',
		NotSuperset: '\u2283\u20D2',
		NotSupersetEqual: '\u2289',
		NotTilde: '\u2241',
		NotTildeEqual: '\u2244',
		NotTildeFullEqual: '\u2247',
		NotTildeTilde: '\u2249',
		NotVerticalBar: '\u2224',
		npar: '\u2226',
		nparallel: '\u2226',
		nparsl: '\u2AFD\u20E5',
		npart: '\u2202\u0338',
		npolint: '\u2A14',
		npr: '\u2280',
		nprcue: '\u22E0',
		npre: '\u2AAF\u0338',
		nprec: '\u2280',
		npreceq: '\u2AAF\u0338',
		nrArr: '\u21CF',
		nrarr: '\u219B',
		nrarrc: '\u2933\u0338',
		nrarrw: '\u219D\u0338',
		nRightarrow: '\u21CF',
		nrightarrow: '\u219B',
		nrtri: '\u22EB',
		nrtrie: '\u22ED',
		nsc: '\u2281',
		nsccue: '\u22E1',
		nsce: '\u2AB0\u0338',
		Nscr: '\uD835\uDCA9',
		nscr: '\uD835\uDCC3',
		nshortmid: '\u2224',
		nshortparallel: '\u2226',
		nsim: '\u2241',
		nsime: '\u2244',
		nsimeq: '\u2244',
		nsmid: '\u2224',
		nspar: '\u2226',
		nsqsube: '\u22E2',
		nsqsupe: '\u22E3',
		nsub: '\u2284',
		nsubE: '\u2AC5\u0338',
		nsube: '\u2288',
		nsubset: '\u2282\u20D2',
		nsubseteq: '\u2288',
		nsubseteqq: '\u2AC5\u0338',
		nsucc: '\u2281',
		nsucceq: '\u2AB0\u0338',
		nsup: '\u2285',
		nsupE: '\u2AC6\u0338',
		nsupe: '\u2289',
		nsupset: '\u2283\u20D2',
		nsupseteq: '\u2289',
		nsupseteqq: '\u2AC6\u0338',
		ntgl: '\u2279',
		Ntilde: '\u00D1',
		ntilde: '\u00F1',
		ntlg: '\u2278',
		ntriangleleft: '\u22EA',
		ntrianglelefteq: '\u22EC',
		ntriangleright: '\u22EB',
		ntrianglerighteq: '\u22ED',
		Nu: '\u039D',
		nu: '\u03BD',
		num: '\u0023',
		numero: '\u2116',
		numsp: '\u2007',
		nvap: '\u224D\u20D2',
		nVDash: '\u22AF',
		nVdash: '\u22AE',
		nvDash: '\u22AD',
		nvdash: '\u22AC',
		nvge: '\u2265\u20D2',
		nvgt: '\u003E\u20D2',
		nvHarr: '\u2904',
		nvinfin: '\u29DE',
		nvlArr: '\u2902',
		nvle: '\u2264\u20D2',
		nvlt: '\u003C\u20D2',
		nvltrie: '\u22B4\u20D2',
		nvrArr: '\u2903',
		nvrtrie: '\u22B5\u20D2',
		nvsim: '\u223C\u20D2',
		nwarhk: '\u2923',
		nwArr: '\u21D6',
		nwarr: '\u2196',
		nwarrow: '\u2196',
		nwnear: '\u2927',
		Oacute: '\u00D3',
		oacute: '\u00F3',
		oast: '\u229B',
		ocir: '\u229A',
		Ocirc: '\u00D4',
		ocirc: '\u00F4',
		Ocy: '\u041E',
		ocy: '\u043E',
		odash: '\u229D',
		Odblac: '\u0150',
		odblac: '\u0151',
		odiv: '\u2A38',
		odot: '\u2299',
		odsold: '\u29BC',
		OElig: '\u0152',
		oelig: '\u0153',
		ofcir: '\u29BF',
		Ofr: '\uD835\uDD12',
		ofr: '\uD835\uDD2C',
		ogon: '\u02DB',
		Ograve: '\u00D2',
		ograve: '\u00F2',
		ogt: '\u29C1',
		ohbar: '\u29B5',
		ohm: '\u03A9',
		oint: '\u222E',
		olarr: '\u21BA',
		olcir: '\u29BE',
		olcross: '\u29BB',
		oline: '\u203E',
		olt: '\u29C0',
		Omacr: '\u014C',
		omacr: '\u014D',
		Omega: '\u03A9',
		omega: '\u03C9',
		Omicron: '\u039F',
		omicron: '\u03BF',
		omid: '\u29B6',
		ominus: '\u2296',
		Oopf: '\uD835\uDD46',
		oopf: '\uD835\uDD60',
		opar: '\u29B7',
		OpenCurlyDoubleQuote: '\u201C',
		OpenCurlyQuote: '\u2018',
		operp: '\u29B9',
		oplus: '\u2295',
		Or: '\u2A54',
		or: '\u2228',
		orarr: '\u21BB',
		ord: '\u2A5D',
		order: '\u2134',
		orderof: '\u2134',
		ordf: '\u00AA',
		ordm: '\u00BA',
		origof: '\u22B6',
		oror: '\u2A56',
		orslope: '\u2A57',
		orv: '\u2A5B',
		oS: '\u24C8',
		Oscr: '\uD835\uDCAA',
		oscr: '\u2134',
		Oslash: '\u00D8',
		oslash: '\u00F8',
		osol: '\u2298',
		Otilde: '\u00D5',
		otilde: '\u00F5',
		Otimes: '\u2A37',
		otimes: '\u2297',
		otimesas: '\u2A36',
		Ouml: '\u00D6',
		ouml: '\u00F6',
		ovbar: '\u233D',
		OverBar: '\u203E',
		OverBrace: '\u23DE',
		OverBracket: '\u23B4',
		OverParenthesis: '\u23DC',
		par: '\u2225',
		para: '\u00B6',
		parallel: '\u2225',
		parsim: '\u2AF3',
		parsl: '\u2AFD',
		part: '\u2202',
		PartialD: '\u2202',
		Pcy: '\u041F',
		pcy: '\u043F',
		percnt: '\u0025',
		period: '\u002E',
		permil: '\u2030',
		perp: '\u22A5',
		pertenk: '\u2031',
		Pfr: '\uD835\uDD13',
		pfr: '\uD835\uDD2D',
		Phi: '\u03A6',
		phi: '\u03C6',
		phiv: '\u03D5',
		phmmat: '\u2133',
		phone: '\u260E',
		Pi: '\u03A0',
		pi: '\u03C0',
		pitchfork: '\u22D4',
		piv: '\u03D6',
		planck: '\u210F',
		planckh: '\u210E',
		plankv: '\u210F',
		plus: '\u002B',
		plusacir: '\u2A23',
		plusb: '\u229E',
		pluscir: '\u2A22',
		plusdo: '\u2214',
		plusdu: '\u2A25',
		pluse: '\u2A72',
		PlusMinus: '\u00B1',
		plusmn: '\u00B1',
		plussim: '\u2A26',
		plustwo: '\u2A27',
		pm: '\u00B1',
		Poincareplane: '\u210C',
		pointint: '\u2A15',
		Popf: '\u2119',
		popf: '\uD835\uDD61',
		pound: '\u00A3',
		Pr: '\u2ABB',
		pr: '\u227A',
		prap: '\u2AB7',
		prcue: '\u227C',
		prE: '\u2AB3',
		pre: '\u2AAF',
		prec: '\u227A',
		precapprox: '\u2AB7',
		preccurlyeq: '\u227C',
		Precedes: '\u227A',
		PrecedesEqual: '\u2AAF',
		PrecedesSlantEqual: '\u227C',
		PrecedesTilde: '\u227E',
		preceq: '\u2AAF',
		precnapprox: '\u2AB9',
		precneqq: '\u2AB5',
		precnsim: '\u22E8',
		precsim: '\u227E',
		Prime: '\u2033',
		prime: '\u2032',
		primes: '\u2119',
		prnap: '\u2AB9',
		prnE: '\u2AB5',
		prnsim: '\u22E8',
		prod: '\u220F',
		Product: '\u220F',
		profalar: '\u232E',
		profline: '\u2312',
		profsurf: '\u2313',
		prop: '\u221D',
		Proportion: '\u2237',
		Proportional: '\u221D',
		propto: '\u221D',
		prsim: '\u227E',
		prurel: '\u22B0',
		Pscr: '\uD835\uDCAB',
		pscr: '\uD835\uDCC5',
		Psi: '\u03A8',
		psi: '\u03C8',
		puncsp: '\u2008',
		Qfr: '\uD835\uDD14',
		qfr: '\uD835\uDD2E',
		qint: '\u2A0C',
		Qopf: '\u211A',
		qopf: '\uD835\uDD62',
		qprime: '\u2057',
		Qscr: '\uD835\uDCAC',
		qscr: '\uD835\uDCC6',
		quaternions: '\u210D',
		quatint: '\u2A16',
		quest: '\u003F',
		questeq: '\u225F',
		QUOT: '\u0022',
		quot: '\u0022',
		rAarr: '\u21DB',
		race: '\u223D\u0331',
		Racute: '\u0154',
		racute: '\u0155',
		radic: '\u221A',
		raemptyv: '\u29B3',
		Rang: '\u27EB',
		rang: '\u27E9',
		rangd: '\u2992',
		range: '\u29A5',
		rangle: '\u27E9',
		raquo: '\u00BB',
		Rarr: '\u21A0',
		rArr: '\u21D2',
		rarr: '\u2192',
		rarrap: '\u2975',
		rarrb: '\u21E5',
		rarrbfs: '\u2920',
		rarrc: '\u2933',
		rarrfs: '\u291E',
		rarrhk: '\u21AA',
		rarrlp: '\u21AC',
		rarrpl: '\u2945',
		rarrsim: '\u2974',
		Rarrtl: '\u2916',
		rarrtl: '\u21A3',
		rarrw: '\u219D',
		rAtail: '\u291C',
		ratail: '\u291A',
		ratio: '\u2236',
		rationals: '\u211A',
		RBarr: '\u2910',
		rBarr: '\u290F',
		rbarr: '\u290D',
		rbbrk: '\u2773',
		rbrace: '\u007D',
		rbrack: '\u005D',
		rbrke: '\u298C',
		rbrksld: '\u298E',
		rbrkslu: '\u2990',
		Rcaron: '\u0158',
		rcaron: '\u0159',
		Rcedil: '\u0156',
		rcedil: '\u0157',
		rceil: '\u2309',
		rcub: '\u007D',
		Rcy: '\u0420',
		rcy: '\u0440',
		rdca: '\u2937',
		rdldhar: '\u2969',
		rdquo: '\u201D',
		rdquor: '\u201D',
		rdsh: '\u21B3',
		Re: '\u211C',
		real: '\u211C',
		realine: '\u211B',
		realpart: '\u211C',
		reals: '\u211D',
		rect: '\u25AD',
		REG: '\u00AE',
		reg: '\u00AE',
		ReverseElement: '\u220B',
		ReverseEquilibrium: '\u21CB',
		ReverseUpEquilibrium: '\u296F',
		rfisht: '\u297D',
		rfloor: '\u230B',
		Rfr: '\u211C',
		rfr: '\uD835\uDD2F',
		rHar: '\u2964',
		rhard: '\u21C1',
		rharu: '\u21C0',
		rharul: '\u296C',
		Rho: '\u03A1',
		rho: '\u03C1',
		rhov: '\u03F1',
		RightAngleBracket: '\u27E9',
		RightArrow: '\u2192',
		Rightarrow: '\u21D2',
		rightarrow: '\u2192',
		RightArrowBar: '\u21E5',
		RightArrowLeftArrow: '\u21C4',
		rightarrowtail: '\u21A3',
		RightCeiling: '\u2309',
		RightDoubleBracket: '\u27E7',
		RightDownTeeVector: '\u295D',
		RightDownVector: '\u21C2',
		RightDownVectorBar: '\u2955',
		RightFloor: '\u230B',
		rightharpoondown: '\u21C1',
		rightharpoonup: '\u21C0',
		rightleftarrows: '\u21C4',
		rightleftharpoons: '\u21CC',
		rightrightarrows: '\u21C9',
		rightsquigarrow: '\u219D',
		RightTee: '\u22A2',
		RightTeeArrow: '\u21A6',
		RightTeeVector: '\u295B',
		rightthreetimes: '\u22CC',
		RightTriangle: '\u22B3',
		RightTriangleBar: '\u29D0',
		RightTriangleEqual: '\u22B5',
		RightUpDownVector: '\u294F',
		RightUpTeeVector: '\u295C',
		RightUpVector: '\u21BE',
		RightUpVectorBar: '\u2954',
		RightVector: '\u21C0',
		RightVectorBar: '\u2953',
		ring: '\u02DA',
		risingdotseq: '\u2253',
		rlarr: '\u21C4',
		rlhar: '\u21CC',
		rlm: '\u200F',
		rmoust: '\u23B1',
		rmoustache: '\u23B1',
		rnmid: '\u2AEE',
		roang: '\u27ED',
		roarr: '\u21FE',
		robrk: '\u27E7',
		ropar: '\u2986',
		Ropf: '\u211D',
		ropf: '\uD835\uDD63',
		roplus: '\u2A2E',
		rotimes: '\u2A35',
		RoundImplies: '\u2970',
		rpar: '\u0029',
		rpargt: '\u2994',
		rppolint: '\u2A12',
		rrarr: '\u21C9',
		Rrightarrow: '\u21DB',
		rsaquo: '\u203A',
		Rscr: '\u211B',
		rscr: '\uD835\uDCC7',
		Rsh: '\u21B1',
		rsh: '\u21B1',
		rsqb: '\u005D',
		rsquo: '\u2019',
		rsquor: '\u2019',
		rthree: '\u22CC',
		rtimes: '\u22CA',
		rtri: '\u25B9',
		rtrie: '\u22B5',
		rtrif: '\u25B8',
		rtriltri: '\u29CE',
		RuleDelayed: '\u29F4',
		ruluhar: '\u2968',
		rx: '\u211E',
		Sacute: '\u015A',
		sacute: '\u015B',
		sbquo: '\u201A',
		Sc: '\u2ABC',
		sc: '\u227B',
		scap: '\u2AB8',
		Scaron: '\u0160',
		scaron: '\u0161',
		sccue: '\u227D',
		scE: '\u2AB4',
		sce: '\u2AB0',
		Scedil: '\u015E',
		scedil: '\u015F',
		Scirc: '\u015C',
		scirc: '\u015D',
		scnap: '\u2ABA',
		scnE: '\u2AB6',
		scnsim: '\u22E9',
		scpolint: '\u2A13',
		scsim: '\u227F',
		Scy: '\u0421',
		scy: '\u0441',
		sdot: '\u22C5',
		sdotb: '\u22A1',
		sdote: '\u2A66',
		searhk: '\u2925',
		seArr: '\u21D8',
		searr: '\u2198',
		searrow: '\u2198',
		sect: '\u00A7',
		semi: '\u003B',
		seswar: '\u2929',
		setminus: '\u2216',
		setmn: '\u2216',
		sext: '\u2736',
		Sfr: '\uD835\uDD16',
		sfr: '\uD835\uDD30',
		sfrown: '\u2322',
		sharp: '\u266F',
		SHCHcy: '\u0429',
		shchcy: '\u0449',
		SHcy: '\u0428',
		shcy: '\u0448',
		ShortDownArrow: '\u2193',
		ShortLeftArrow: '\u2190',
		shortmid: '\u2223',
		shortparallel: '\u2225',
		ShortRightArrow: '\u2192',
		ShortUpArrow: '\u2191',
		shy: '\u00AD',
		Sigma: '\u03A3',
		sigma: '\u03C3',
		sigmaf: '\u03C2',
		sigmav: '\u03C2',
		sim: '\u223C',
		simdot: '\u2A6A',
		sime: '\u2243',
		simeq: '\u2243',
		simg: '\u2A9E',
		simgE: '\u2AA0',
		siml: '\u2A9D',
		simlE: '\u2A9F',
		simne: '\u2246',
		simplus: '\u2A24',
		simrarr: '\u2972',
		slarr: '\u2190',
		SmallCircle: '\u2218',
		smallsetminus: '\u2216',
		smashp: '\u2A33',
		smeparsl: '\u29E4',
		smid: '\u2223',
		smile: '\u2323',
		smt: '\u2AAA',
		smte: '\u2AAC',
		smtes: '\u2AAC\uFE00',
		SOFTcy: '\u042C',
		softcy: '\u044C',
		sol: '\u002F',
		solb: '\u29C4',
		solbar: '\u233F',
		Sopf: '\uD835\uDD4A',
		sopf: '\uD835\uDD64',
		spades: '\u2660',
		spadesuit: '\u2660',
		spar: '\u2225',
		sqcap: '\u2293',
		sqcaps: '\u2293\uFE00',
		sqcup: '\u2294',
		sqcups: '\u2294\uFE00',
		Sqrt: '\u221A',
		sqsub: '\u228F',
		sqsube: '\u2291',
		sqsubset: '\u228F',
		sqsubseteq: '\u2291',
		sqsup: '\u2290',
		sqsupe: '\u2292',
		sqsupset: '\u2290',
		sqsupseteq: '\u2292',
		squ: '\u25A1',
		Square: '\u25A1',
		square: '\u25A1',
		SquareIntersection: '\u2293',
		SquareSubset: '\u228F',
		SquareSubsetEqual: '\u2291',
		SquareSuperset: '\u2290',
		SquareSupersetEqual: '\u2292',
		SquareUnion: '\u2294',
		squarf: '\u25AA',
		squf: '\u25AA',
		srarr: '\u2192',
		Sscr: '\uD835\uDCAE',
		sscr: '\uD835\uDCC8',
		ssetmn: '\u2216',
		ssmile: '\u2323',
		sstarf: '\u22C6',
		Star: '\u22C6',
		star: '\u2606',
		starf: '\u2605',
		straightepsilon: '\u03F5',
		straightphi: '\u03D5',
		strns: '\u00AF',
		Sub: '\u22D0',
		sub: '\u2282',
		subdot: '\u2ABD',
		subE: '\u2AC5',
		sube: '\u2286',
		subedot: '\u2AC3',
		submult: '\u2AC1',
		subnE: '\u2ACB',
		subne: '\u228A',
		subplus: '\u2ABF',
		subrarr: '\u2979',
		Subset: '\u22D0',
		subset: '\u2282',
		subseteq: '\u2286',
		subseteqq: '\u2AC5',
		SubsetEqual: '\u2286',
		subsetneq: '\u228A',
		subsetneqq: '\u2ACB',
		subsim: '\u2AC7',
		subsub: '\u2AD5',
		subsup: '\u2AD3',
		succ: '\u227B',
		succapprox: '\u2AB8',
		succcurlyeq: '\u227D',
		Succeeds: '\u227B',
		SucceedsEqual: '\u2AB0',
		SucceedsSlantEqual: '\u227D',
		SucceedsTilde: '\u227F',
		succeq: '\u2AB0',
		succnapprox: '\u2ABA',
		succneqq: '\u2AB6',
		succnsim: '\u22E9',
		succsim: '\u227F',
		SuchThat: '\u220B',
		Sum: '\u2211',
		sum: '\u2211',
		sung: '\u266A',
		Sup: '\u22D1',
		sup: '\u2283',
		sup1: '\u00B9',
		sup2: '\u00B2',
		sup3: '\u00B3',
		supdot: '\u2ABE',
		supdsub: '\u2AD8',
		supE: '\u2AC6',
		supe: '\u2287',
		supedot: '\u2AC4',
		Superset: '\u2283',
		SupersetEqual: '\u2287',
		suphsol: '\u27C9',
		suphsub: '\u2AD7',
		suplarr: '\u297B',
		supmult: '\u2AC2',
		supnE: '\u2ACC',
		supne: '\u228B',
		supplus: '\u2AC0',
		Supset: '\u22D1',
		supset: '\u2283',
		supseteq: '\u2287',
		supseteqq: '\u2AC6',
		supsetneq: '\u228B',
		supsetneqq: '\u2ACC',
		supsim: '\u2AC8',
		supsub: '\u2AD4',
		supsup: '\u2AD6',
		swarhk: '\u2926',
		swArr: '\u21D9',
		swarr: '\u2199',
		swarrow: '\u2199',
		swnwar: '\u292A',
		szlig: '\u00DF',
		Tab: '\u0009',
		target: '\u2316',
		Tau: '\u03A4',
		tau: '\u03C4',
		tbrk: '\u23B4',
		Tcaron: '\u0164',
		tcaron: '\u0165',
		Tcedil: '\u0162',
		tcedil: '\u0163',
		Tcy: '\u0422',
		tcy: '\u0442',
		tdot: '\u20DB',
		telrec: '\u2315',
		Tfr: '\uD835\uDD17',
		tfr: '\uD835\uDD31',
		there4: '\u2234',
		Therefore: '\u2234',
		therefore: '\u2234',
		Theta: '\u0398',
		theta: '\u03B8',
		thetasym: '\u03D1',
		thetav: '\u03D1',
		thickapprox: '\u2248',
		thicksim: '\u223C',
		ThickSpace: '\u205F\u200A',
		thinsp: '\u2009',
		ThinSpace: '\u2009',
		thkap: '\u2248',
		thksim: '\u223C',
		THORN: '\u00DE',
		thorn: '\u00FE',
		Tilde: '\u223C',
		tilde: '\u02DC',
		TildeEqual: '\u2243',
		TildeFullEqual: '\u2245',
		TildeTilde: '\u2248',
		times: '\u00D7',
		timesb: '\u22A0',
		timesbar: '\u2A31',
		timesd: '\u2A30',
		tint: '\u222D',
		toea: '\u2928',
		top: '\u22A4',
		topbot: '\u2336',
		topcir: '\u2AF1',
		Topf: '\uD835\uDD4B',
		topf: '\uD835\uDD65',
		topfork: '\u2ADA',
		tosa: '\u2929',
		tprime: '\u2034',
		TRADE: '\u2122',
		trade: '\u2122',
		triangle: '\u25B5',
		triangledown: '\u25BF',
		triangleleft: '\u25C3',
		trianglelefteq: '\u22B4',
		triangleq: '\u225C',
		triangleright: '\u25B9',
		trianglerighteq: '\u22B5',
		tridot: '\u25EC',
		trie: '\u225C',
		triminus: '\u2A3A',
		TripleDot: '\u20DB',
		triplus: '\u2A39',
		trisb: '\u29CD',
		tritime: '\u2A3B',
		trpezium: '\u23E2',
		Tscr: '\uD835\uDCAF',
		tscr: '\uD835\uDCC9',
		TScy: '\u0426',
		tscy: '\u0446',
		TSHcy: '\u040B',
		tshcy: '\u045B',
		Tstrok: '\u0166',
		tstrok: '\u0167',
		twixt: '\u226C',
		twoheadleftarrow: '\u219E',
		twoheadrightarrow: '\u21A0',
		Uacute: '\u00DA',
		uacute: '\u00FA',
		Uarr: '\u219F',
		uArr: '\u21D1',
		uarr: '\u2191',
		Uarrocir: '\u2949',
		Ubrcy: '\u040E',
		ubrcy: '\u045E',
		Ubreve: '\u016C',
		ubreve: '\u016D',
		Ucirc: '\u00DB',
		ucirc: '\u00FB',
		Ucy: '\u0423',
		ucy: '\u0443',
		udarr: '\u21C5',
		Udblac: '\u0170',
		udblac: '\u0171',
		udhar: '\u296E',
		ufisht: '\u297E',
		Ufr: '\uD835\uDD18',
		ufr: '\uD835\uDD32',
		Ugrave: '\u00D9',
		ugrave: '\u00F9',
		uHar: '\u2963',
		uharl: '\u21BF',
		uharr: '\u21BE',
		uhblk: '\u2580',
		ulcorn: '\u231C',
		ulcorner: '\u231C',
		ulcrop: '\u230F',
		ultri: '\u25F8',
		Umacr: '\u016A',
		umacr: '\u016B',
		uml: '\u00A8',
		UnderBar: '\u005F',
		UnderBrace: '\u23DF',
		UnderBracket: '\u23B5',
		UnderParenthesis: '\u23DD',
		Union: '\u22C3',
		UnionPlus: '\u228E',
		Uogon: '\u0172',
		uogon: '\u0173',
		Uopf: '\uD835\uDD4C',
		uopf: '\uD835\uDD66',
		UpArrow: '\u2191',
		Uparrow: '\u21D1',
		uparrow: '\u2191',
		UpArrowBar: '\u2912',
		UpArrowDownArrow: '\u21C5',
		UpDownArrow: '\u2195',
		Updownarrow: '\u21D5',
		updownarrow: '\u2195',
		UpEquilibrium: '\u296E',
		upharpoonleft: '\u21BF',
		upharpoonright: '\u21BE',
		uplus: '\u228E',
		UpperLeftArrow: '\u2196',
		UpperRightArrow: '\u2197',
		Upsi: '\u03D2',
		upsi: '\u03C5',
		upsih: '\u03D2',
		Upsilon: '\u03A5',
		upsilon: '\u03C5',
		UpTee: '\u22A5',
		UpTeeArrow: '\u21A5',
		upuparrows: '\u21C8',
		urcorn: '\u231D',
		urcorner: '\u231D',
		urcrop: '\u230E',
		Uring: '\u016E',
		uring: '\u016F',
		urtri: '\u25F9',
		Uscr: '\uD835\uDCB0',
		uscr: '\uD835\uDCCA',
		utdot: '\u22F0',
		Utilde: '\u0168',
		utilde: '\u0169',
		utri: '\u25B5',
		utrif: '\u25B4',
		uuarr: '\u21C8',
		Uuml: '\u00DC',
		uuml: '\u00FC',
		uwangle: '\u29A7',
		vangrt: '\u299C',
		varepsilon: '\u03F5',
		varkappa: '\u03F0',
		varnothing: '\u2205',
		varphi: '\u03D5',
		varpi: '\u03D6',
		varpropto: '\u221D',
		vArr: '\u21D5',
		varr: '\u2195',
		varrho: '\u03F1',
		varsigma: '\u03C2',
		varsubsetneq: '\u228A\uFE00',
		varsubsetneqq: '\u2ACB\uFE00',
		varsupsetneq: '\u228B\uFE00',
		varsupsetneqq: '\u2ACC\uFE00',
		vartheta: '\u03D1',
		vartriangleleft: '\u22B2',
		vartriangleright: '\u22B3',
		Vbar: '\u2AEB',
		vBar: '\u2AE8',
		vBarv: '\u2AE9',
		Vcy: '\u0412',
		vcy: '\u0432',
		VDash: '\u22AB',
		Vdash: '\u22A9',
		vDash: '\u22A8',
		vdash: '\u22A2',
		Vdashl: '\u2AE6',
		Vee: '\u22C1',
		vee: '\u2228',
		veebar: '\u22BB',
		veeeq: '\u225A',
		vellip: '\u22EE',
		Verbar: '\u2016',
		verbar: '\u007C',
		Vert: '\u2016',
		vert: '\u007C',
		VerticalBar: '\u2223',
		VerticalLine: '\u007C',
		VerticalSeparator: '\u2758',
		VerticalTilde: '\u2240',
		VeryThinSpace: '\u200A',
		Vfr: '\uD835\uDD19',
		vfr: '\uD835\uDD33',
		vltri: '\u22B2',
		vnsub: '\u2282\u20D2',
		vnsup: '\u2283\u20D2',
		Vopf: '\uD835\uDD4D',
		vopf: '\uD835\uDD67',
		vprop: '\u221D',
		vrtri: '\u22B3',
		Vscr: '\uD835\uDCB1',
		vscr: '\uD835\uDCCB',
		vsubnE: '\u2ACB\uFE00',
		vsubne: '\u228A\uFE00',
		vsupnE: '\u2ACC\uFE00',
		vsupne: '\u228B\uFE00',
		Vvdash: '\u22AA',
		vzigzag: '\u299A',
		Wcirc: '\u0174',
		wcirc: '\u0175',
		wedbar: '\u2A5F',
		Wedge: '\u22C0',
		wedge: '\u2227',
		wedgeq: '\u2259',
		weierp: '\u2118',
		Wfr: '\uD835\uDD1A',
		wfr: '\uD835\uDD34',
		Wopf: '\uD835\uDD4E',
		wopf: '\uD835\uDD68',
		wp: '\u2118',
		wr: '\u2240',
		wreath: '\u2240',
		Wscr: '\uD835\uDCB2',
		wscr: '\uD835\uDCCC',
		xcap: '\u22C2',
		xcirc: '\u25EF',
		xcup: '\u22C3',
		xdtri: '\u25BD',
		Xfr: '\uD835\uDD1B',
		xfr: '\uD835\uDD35',
		xhArr: '\u27FA',
		xharr: '\u27F7',
		Xi: '\u039E',
		xi: '\u03BE',
		xlArr: '\u27F8',
		xlarr: '\u27F5',
		xmap: '\u27FC',
		xnis: '\u22FB',
		xodot: '\u2A00',
		Xopf: '\uD835\uDD4F',
		xopf: '\uD835\uDD69',
		xoplus: '\u2A01',
		xotime: '\u2A02',
		xrArr: '\u27F9',
		xrarr: '\u27F6',
		Xscr: '\uD835\uDCB3',
		xscr: '\uD835\uDCCD',
		xsqcup: '\u2A06',
		xuplus: '\u2A04',
		xutri: '\u25B3',
		xvee: '\u22C1',
		xwedge: '\u22C0',
		Yacute: '\u00DD',
		yacute: '\u00FD',
		YAcy: '\u042F',
		yacy: '\u044F',
		Ycirc: '\u0176',
		ycirc: '\u0177',
		Ycy: '\u042B',
		ycy: '\u044B',
		yen: '\u00A5',
		Yfr: '\uD835\uDD1C',
		yfr: '\uD835\uDD36',
		YIcy: '\u0407',
		yicy: '\u0457',
		Yopf: '\uD835\uDD50',
		yopf: '\uD835\uDD6A',
		Yscr: '\uD835\uDCB4',
		yscr: '\uD835\uDCCE',
		YUcy: '\u042E',
		yucy: '\u044E',
		Yuml: '\u0178',
		yuml: '\u00FF',
		Zacute: '\u0179',
		zacute: '\u017A',
		Zcaron: '\u017D',
		zcaron: '\u017E',
		Zcy: '\u0417',
		zcy: '\u0437',
		Zdot: '\u017B',
		zdot: '\u017C',
		zeetrf: '\u2128',
		ZeroWidthSpace: '\u200B',
		Zeta: '\u0396',
		zeta: '\u03B6',
		Zfr: '\u2128',
		zfr: '\uD835\uDD37',
		ZHcy: '\u0416',
		zhcy: '\u0436',
		zigrarr: '\u21DD',
		Zopf: '\u2124',
		zopf: '\uD835\uDD6B',
		Zscr: '\uD835\uDCB5',
		zscr: '\uD835\uDCCF',
		zwj: '\u200D',
		zwnj: '\u200C',
	});
	
	/**
	 * @deprecated use `HTML_ENTITIES` instead
	 * @see HTML_ENTITIES
	 */
	exports.entityMap = exports.HTML_ENTITIES;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var dom = __webpack_require__(194)
	exports.DOMImplementation = dom.DOMImplementation
	exports.XMLSerializer = dom.XMLSerializer
	exports.DOMParser = __webpack_require__(324).DOMParser


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var NAMESPACE = __webpack_require__(102).NAMESPACE;
	
	//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
	//[5]   	Name	   ::=   	NameStartChar (NameChar)*
	var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]///\u10000-\uEFFFF
	var nameChar = new RegExp("[\\-\\.0-9"+nameStartChar.source.slice(1,-1)+"\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
	var tagNamePattern = new RegExp('^'+nameStartChar.source+nameChar.source+'*(?:\:'+nameStartChar.source+nameChar.source+'*)?$');
	//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
	//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
	
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
	var S_TAG = 0;//tag name offerring
	var S_ATTR = 1;//attr name offerring
	var S_ATTR_SPACE=2;//attr name end and space offer
	var S_EQ = 3;//=space?
	var S_ATTR_NOQUOT_VALUE = 4;//attr value(no quot value only)
	var S_ATTR_END = 5;//attr value end and no space(quot end)
	var S_TAG_SPACE = 6;//(attr value end || tag end ) && (space offer)
	var S_TAG_CLOSE = 7;//closed el<el />
	
	/**
	 * Creates an error that will not be caught by XMLReader aka the SAX parser.
	 *
	 * @param {string} message
	 * @param {any?} locator Optional, can provide details about the location in the source
	 * @constructor
	 */
	function ParseError(message, locator) {
		this.message = message
		this.locator = locator
		if(Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
	}
	ParseError.prototype = new Error();
	ParseError.prototype.name = ParseError.name
	
	function XMLReader(){
	
	}
	
	XMLReader.prototype = {
		parse:function(source,defaultNSMap,entityMap){
			var domBuilder = this.domBuilder;
			domBuilder.startDocument();
			_copy(defaultNSMap ,defaultNSMap = {})
			parse(source,defaultNSMap,entityMap,
					domBuilder,this.errorHandler);
			domBuilder.endDocument();
		}
	}
	function parse(source,defaultNSMapCopy,entityMap,domBuilder,errorHandler){
		function fixedFromCharCode(code) {
			// String.prototype.fromCharCode does not supports
			// > 2 bytes unicode chars directly
			if (code > 0xffff) {
				code -= 0x10000;
				var surrogate1 = 0xd800 + (code >> 10)
					, surrogate2 = 0xdc00 + (code & 0x3ff);
	
				return String.fromCharCode(surrogate1, surrogate2);
			} else {
				return String.fromCharCode(code);
			}
		}
		function entityReplacer(a){
			var k = a.slice(1,-1);
			if (Object.hasOwnProperty.call(entityMap, k)) {
				return entityMap[k];
			}else if(k.charAt(0) === '#'){
				return fixedFromCharCode(parseInt(k.substr(1).replace('x','0x')))
			}else{
				errorHandler.error('entity not found:'+a);
				return a;
			}
		}
		function appendText(end){//has some bugs
			if(end>start){
				var xt = source.substring(start,end).replace(/&#?\w+;/g,entityReplacer);
				locator&&position(start);
				domBuilder.characters(xt,0,end-start);
				start = end
			}
		}
		function position(p,m){
			while(p>=lineEnd && (m = linePattern.exec(source))){
				lineStart = m.index;
				lineEnd = lineStart + m[0].length;
				locator.lineNumber++;
				//console.log('line++:',locator,startPos,endPos)
			}
			locator.columnNumber = p-lineStart+1;
		}
		var lineStart = 0;
		var lineEnd = 0;
		var linePattern = /.*(?:\r\n?|\n)|.*$/g
		var locator = domBuilder.locator;
	
		var parseStack = [{currentNSMap:defaultNSMapCopy}]
		var closeMap = {};
		var start = 0;
		while(true){
			try{
				var tagStart = source.indexOf('<',start);
				if(tagStart<0){
					if(!source.substr(start).match(/^\s*$/)){
						var doc = domBuilder.doc;
		    			var text = doc.createTextNode(source.substr(start));
		    			doc.appendChild(text);
		    			domBuilder.currentElement = text;
					}
					return;
				}
				if(tagStart>start){
					appendText(tagStart);
				}
				switch(source.charAt(tagStart+1)){
				case '/':
					var end = source.indexOf('>',tagStart+3);
					var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
					var config = parseStack.pop();
					if(end<0){
	
		        		tagName = source.substring(tagStart+2).replace(/[\s<].*/,'');
		        		errorHandler.error("end tag name: "+tagName+' is not complete:'+config.tagName);
		        		end = tagStart+1+tagName.length;
		        	}else if(tagName.match(/\s</)){
		        		tagName = tagName.replace(/[\s<].*/,'');
		        		errorHandler.error("end tag name: "+tagName+' maybe not complete');
		        		end = tagStart+1+tagName.length;
					}
					var localNSMap = config.localNSMap;
					var endMatch = config.tagName == tagName;
					var endIgnoreCaseMach = endMatch || config.tagName&&config.tagName.toLowerCase() == tagName.toLowerCase()
			        if(endIgnoreCaseMach){
			        	domBuilder.endElement(config.uri,config.localName,tagName);
						if(localNSMap){
							for (var prefix in localNSMap) {
								if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
									domBuilder.endPrefixMapping(prefix);
								}
							}
						}
						if(!endMatch){
			            	errorHandler.fatalError("end tag name: "+tagName+' is not match the current start tagName:'+config.tagName ); // No known test case
						}
			        }else{
			        	parseStack.push(config)
			        }
	
					end++;
					break;
					// end elment
				case '?':// <?...?>
					locator&&position(tagStart);
					end = parseInstruction(source,tagStart,domBuilder);
					break;
				case '!':// <!doctype,<![CDATA,<!--
					locator&&position(tagStart);
					end = parseDCC(source,tagStart,domBuilder,errorHandler);
					break;
				default:
					locator&&position(tagStart);
					var el = new ElementAttributes();
					var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
					//elStartEnd
					var end = parseElementStartPart(source,tagStart,el,currentNSMap,entityReplacer,errorHandler);
					var len = el.length;
	
	
					if(!el.closed && fixSelfClosed(source,end,el.tagName,closeMap)){
						el.closed = true;
						if(!entityMap.nbsp){
							errorHandler.warning('unclosed xml attribute');
						}
					}
					if(locator && len){
						var locator2 = copyLocator(locator,{});
						//try{//attribute position fixed
						for(var i = 0;i<len;i++){
							var a = el[i];
							position(a.offset);
							a.locator = copyLocator(locator,{});
						}
						domBuilder.locator = locator2
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
						domBuilder.locator = locator;
					}else{
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
					}
	
					if (NAMESPACE.isHTML(el.uri) && !el.closed) {
						end = parseHtmlSpecialContent(source,end,el.tagName,entityReplacer,domBuilder)
					} else {
						end++;
					}
				}
			}catch(e){
				if (e instanceof ParseError) {
					throw e;
				}
				errorHandler.error('element parse error: '+e)
				end = -1;
			}
			if(end>start){
				start = end;
			}else{
				//TODO: 这里有可能sax回退，有位置错误风险
				appendText(Math.max(tagStart,start)+1);
			}
		}
	}
	function copyLocator(f,t){
		t.lineNumber = f.lineNumber;
		t.columnNumber = f.columnNumber;
		return t;
	}
	
	/**
	 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
	 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
	 */
	function parseElementStartPart(source,start,el,currentNSMap,entityReplacer,errorHandler){
	
		/**
		 * @param {string} qname
		 * @param {string} value
		 * @param {number} startIndex
		 */
		function addAttribute(qname, value, startIndex) {
			if (el.attributeNames.hasOwnProperty(qname)) {
				errorHandler.fatalError('Attribute ' + qname + ' redefined')
			}
			el.addValue(
				qname,
				// @see https://www.w3.org/TR/xml/#AVNormalize
				// since the xmldom sax parser does not "interpret" DTD the following is not implemented:
				// - recursive replacement of (DTD) entity references
				// - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
				value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer),
				startIndex
			)
		}
		var attrName;
		var value;
		var p = ++start;
		var s = S_TAG;//status
		while(true){
			var c = source.charAt(p);
			switch(c){
			case '=':
				if(s === S_ATTR){//attrName
					attrName = source.slice(start,p);
					s = S_EQ;
				}else if(s === S_ATTR_SPACE){
					s = S_EQ;
				}else{
					//fatalError: equal must after attrName or space after attrName
					throw new Error('attribute equal must after attrName'); // No known test case
				}
				break;
			case '\'':
			case '"':
				if(s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
					){//equal
					if(s === S_ATTR){
						errorHandler.warning('attribute value must after "="')
						attrName = source.slice(start,p)
					}
					start = p+1;
					p = source.indexOf(c,start)
					if(p>0){
						value = source.slice(start, p);
						addAttribute(attrName, value, start-1);
						s = S_ATTR_END;
					}else{
						//fatalError: no end quot match
						throw new Error('attribute value no end \''+c+'\' match');
					}
				}else if(s == S_ATTR_NOQUOT_VALUE){
					value = source.slice(start, p);
					addAttribute(attrName, value, start);
					errorHandler.warning('attribute "'+attrName+'" missed start quot('+c+')!!');
					start = p+1;
					s = S_ATTR_END
				}else{
					//fatalError: no equal before
					throw new Error('attribute value must after "="'); // No known test case
				}
				break;
			case '/':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					s =S_TAG_CLOSE;
					el.closed = true;
				case S_ATTR_NOQUOT_VALUE:
				case S_ATTR:
					break;
					case S_ATTR_SPACE:
						el.closed = true;
					break;
				//case S_EQ:
				default:
					throw new Error("attribute invalid close char('/')") // No known test case
				}
				break;
			case ''://end document
				errorHandler.error('unexpected end of input');
				if(s == S_TAG){
					el.setTagName(source.slice(start,p));
				}
				return p;
			case '>':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					break;//normal
				case S_ATTR_NOQUOT_VALUE://Compatible state
				case S_ATTR:
					value = source.slice(start,p);
					if(value.slice(-1) === '/'){
						el.closed  = true;
						value = value.slice(0,-1)
					}
				case S_ATTR_SPACE:
					if(s === S_ATTR_SPACE){
						value = attrName;
					}
					if(s == S_ATTR_NOQUOT_VALUE){
						errorHandler.warning('attribute "'+value+'" missed quot(")!');
						addAttribute(attrName, value, start)
					}else{
						if(!NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)){
							errorHandler.warning('attribute "'+value+'" missed value!! "'+value+'" instead!!')
						}
						addAttribute(value, value, start)
					}
					break;
				case S_EQ:
					throw new Error('attribute value missed!!');
				}
	//			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
				return p;
			/*xml space '\x20' | #x9 | #xD | #xA; */
			case '\u0080':
				c = ' ';
			default:
				if(c<= ' '){//space
					switch(s){
					case S_TAG:
						el.setTagName(source.slice(start,p));//tagName
						s = S_TAG_SPACE;
						break;
					case S_ATTR:
						attrName = source.slice(start,p)
						s = S_ATTR_SPACE;
						break;
					case S_ATTR_NOQUOT_VALUE:
						var value = source.slice(start, p);
						errorHandler.warning('attribute "'+value+'" missed quot(")!!');
						addAttribute(attrName, value, start)
					case S_ATTR_END:
						s = S_TAG_SPACE;
						break;
					//case S_TAG_SPACE:
					//case S_EQ:
					//case S_ATTR_SPACE:
					//	void();break;
					//case S_TAG_CLOSE:
						//ignore warning
					}
				}else{//not space
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
					switch(s){
					//case S_TAG:void();break;
					//case S_ATTR:void();break;
					//case S_ATTR_NOQUOT_VALUE:void();break;
					case S_ATTR_SPACE:
						var tagName =  el.tagName;
						if (!NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
							errorHandler.warning('attribute "'+attrName+'" missed value!! "'+attrName+'" instead2!!')
						}
						addAttribute(attrName, attrName, start);
						start = p;
						s = S_ATTR;
						break;
					case S_ATTR_END:
						errorHandler.warning('attribute space is required"'+attrName+'"!!')
					case S_TAG_SPACE:
						s = S_ATTR;
						start = p;
						break;
					case S_EQ:
						s = S_ATTR_NOQUOT_VALUE;
						start = p;
						break;
					case S_TAG_CLOSE:
						throw new Error("elements closed character '/' and '>' must be connected to");
					}
				}
			}//end outer switch
			//console.log('p++',p)
			p++;
		}
	}
	/**
	 * @return true if has new namespace define
	 */
	function appendElement(el,domBuilder,currentNSMap){
		var tagName = el.tagName;
		var localNSMap = null;
		//var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
		var i = el.length;
		while(i--){
			var a = el[i];
			var qName = a.qName;
			var value = a.value;
			var nsp = qName.indexOf(':');
			if(nsp>0){
				var prefix = a.prefix = qName.slice(0,nsp);
				var localName = qName.slice(nsp+1);
				var nsPrefix = prefix === 'xmlns' && localName
			}else{
				localName = qName;
				prefix = null
				nsPrefix = qName === 'xmlns' && ''
			}
			//can not set prefix,because prefix !== ''
			a.localName = localName ;
			//prefix == null for no ns prefix attribute
			if(nsPrefix !== false){//hack!!
				if(localNSMap == null){
					localNSMap = {}
					//console.log(currentNSMap,0)
					_copy(currentNSMap,currentNSMap={})
					//console.log(currentNSMap,1)
				}
				currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
				a.uri = NAMESPACE.XMLNS
				domBuilder.startPrefixMapping(nsPrefix, value)
			}
		}
		var i = el.length;
		while(i--){
			a = el[i];
			var prefix = a.prefix;
			if(prefix){//no prefix attribute has no namespace
				if(prefix === 'xml'){
					a.uri = NAMESPACE.XML;
				}if(prefix !== 'xmlns'){
					a.uri = currentNSMap[prefix || '']
	
					//{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
				}
			}
		}
		var nsp = tagName.indexOf(':');
		if(nsp>0){
			prefix = el.prefix = tagName.slice(0,nsp);
			localName = el.localName = tagName.slice(nsp+1);
		}else{
			prefix = null;//important!!
			localName = el.localName = tagName;
		}
		//no prefix element has default namespace
		var ns = el.uri = currentNSMap[prefix || ''];
		domBuilder.startElement(ns,localName,tagName,el);
		//endPrefixMapping and startPrefixMapping have not any help for dom builder
		//localNSMap = null
		if(el.closed){
			domBuilder.endElement(ns,localName,tagName);
			if(localNSMap){
				for (prefix in localNSMap) {
					if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
						domBuilder.endPrefixMapping(prefix);
					}
				}
			}
		}else{
			el.currentNSMap = currentNSMap;
			el.localNSMap = localNSMap;
			//parseStack.push(el);
			return true;
		}
	}
	function parseHtmlSpecialContent(source,elStartEnd,tagName,entityReplacer,domBuilder){
		if(/^(?:script|textarea)$/i.test(tagName)){
			var elEndStart =  source.indexOf('</'+tagName+'>',elStartEnd);
			var text = source.substring(elStartEnd+1,elEndStart);
			if(/[&<]/.test(text)){
				if(/^script$/i.test(tagName)){
					//if(!/\]\]>/.test(text)){
						//lexHandler.startCDATA();
						domBuilder.characters(text,0,text.length);
						//lexHandler.endCDATA();
						return elEndStart;
					//}
				}//}else{//text area
					text = text.replace(/&#?\w+;/g,entityReplacer);
					domBuilder.characters(text,0,text.length);
					return elEndStart;
				//}
	
			}
		}
		return elStartEnd+1;
	}
	function fixSelfClosed(source,elStartEnd,tagName,closeMap){
		//if(tagName in closeMap){
		var pos = closeMap[tagName];
		if(pos == null){
			//console.log(tagName)
			pos =  source.lastIndexOf('</'+tagName+'>')
			if(pos<elStartEnd){//忘记闭合
				pos = source.lastIndexOf('</'+tagName)
			}
			closeMap[tagName] =pos
		}
		return pos<elStartEnd;
		//}
	}
	
	function _copy (source, target) {
		for (var n in source) {
			if (Object.prototype.hasOwnProperty.call(source, n)) {
				target[n] = source[n];
			}
		}
	}
	
	function parseDCC(source,start,domBuilder,errorHandler){//sure start with '<!'
		var next= source.charAt(start+2)
		switch(next){
		case '-':
			if(source.charAt(start + 3) === '-'){
				var end = source.indexOf('-->',start+4);
				//append comment source.substring(4,end)//<!--
				if(end>start){
					domBuilder.comment(source,start+4,end-start-4);
					return end+3;
				}else{
					errorHandler.error("Unclosed comment");
					return -1;
				}
			}else{
				//error
				return -1;
			}
		default:
			if(source.substr(start+3,6) == 'CDATA['){
				var end = source.indexOf(']]>',start+9);
				domBuilder.startCDATA();
				domBuilder.characters(source,start+9,end-start-9);
				domBuilder.endCDATA()
				return end+3;
			}
			//<!DOCTYPE
			//startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
			var matchs = split(source,start);
			var len = matchs.length;
			if(len>1 && /!doctype/i.test(matchs[0][0])){
				var name = matchs[1][0];
				var pubid = false;
				var sysid = false;
				if(len>3){
					if(/^public$/i.test(matchs[2][0])){
						pubid = matchs[3][0];
						sysid = len>4 && matchs[4][0];
					}else if(/^system$/i.test(matchs[2][0])){
						sysid = matchs[3][0];
					}
				}
				var lastMatch = matchs[len-1]
				domBuilder.startDTD(name, pubid, sysid);
				domBuilder.endDTD();
	
				return lastMatch.index+lastMatch[0].length
			}
		}
		return -1;
	}
	
	
	
	function parseInstruction(source,start,domBuilder){
		var end = source.indexOf('?>',start);
		if(end){
			var match = source.substring(start,end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
			if(match){
				var len = match[0].length;
				domBuilder.processingInstruction(match[1], match[2]) ;
				return end+2;
			}else{//error
				return -1;
			}
		}
		return -1;
	}
	
	function ElementAttributes(){
		this.attributeNames = {}
	}
	ElementAttributes.prototype = {
		setTagName:function(tagName){
			if(!tagNamePattern.test(tagName)){
				throw new Error('invalid tagName:'+tagName)
			}
			this.tagName = tagName
		},
		addValue:function(qName, value, offset) {
			if(!tagNamePattern.test(qName)){
				throw new Error('invalid attribute:'+qName)
			}
			this.attributeNames[qName] = this.length;
			this[this.length++] = {qName:qName,value:value,offset:offset}
		},
		length:0,
		getLocalName:function(i){return this[i].localName},
		getLocator:function(i){return this[i].locator},
		getQName:function(i){return this[i].qName},
		getURI:function(i){return this[i].uri},
		getValue:function(i){return this[i].value}
	//	,getIndex:function(uri, localName)){
	//		if(localName){
	//
	//		}else{
	//			var qName = uri
	//		}
	//	},
	//	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
	//	getType:function(uri,localName){}
	//	getType:function(i){},
	}
	
	
	
	function split(source,start){
		var match;
		var buf = [];
		var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
		reg.lastIndex = start;
		reg.exec(source);//skip <
		while(match = reg.exec(source)){
			buf.push(match);
			if(match[1])return buf;
		}
	}
	
	exports.XMLReader = XMLReader;
	exports.ParseError = ParseError;


/***/ },
/* 328 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(532);
	
	__webpack_require__(276);
	
	__webpack_require__(333);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(703);


/***/ },
/* 331 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(331)
	var ieee754 = __webpack_require__(561)
	var isArray = __webpack_require__(563)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(340);
	module.exports = __webpack_require__(39).RegExp.escape;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	var isArray = __webpack_require__(107);
	var SPECIES = __webpack_require__(13)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(8);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(5);
	var toPrimitive = __webpack_require__(48);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(68);
	var gOPS = __webpack_require__(111);
	var pIE = __webpack_require__(92);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 338 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 339 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1);
	var $re = __webpack_require__(338)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(196) });
	
	__webpack_require__(59)('copyWithin');


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $every = __webpack_require__(44)(4);
	
	$export($export.P + $export.F * !__webpack_require__(41)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { fill: __webpack_require__(131) });
	
	__webpack_require__(59)('fill');


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $filter = __webpack_require__(44)(2);
	
	$export($export.P + $export.F * !__webpack_require__(41)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(44)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(59)(KEY);


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(44)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(59)(KEY);


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $forEach = __webpack_require__(44)(0);
	var STRICT = __webpack_require__(41)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(40);
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(26);
	var call = __webpack_require__(207);
	var isArrayIter = __webpack_require__(139);
	var toLength = __webpack_require__(24);
	var createProperty = __webpack_require__(133);
	var getIterFn = __webpack_require__(155);
	
	$export($export.S + $export.F * !__webpack_require__(109)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $indexOf = __webpack_require__(103)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(41)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(107) });


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(37);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(91) != Object || !__webpack_require__(41)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(37);
	var toInteger = __webpack_require__(47);
	var toLength = __webpack_require__(24);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(41)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $map = __webpack_require__(44)(1);
	
	$export($export.P + $export.F * !__webpack_require__(41)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var createProperty = __webpack_require__(133);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(8)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(198);
	
	$export($export.P + $export.F * !__webpack_require__(41)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(198);
	
	$export($export.P + $export.F * !__webpack_require__(41)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var html = __webpack_require__(137);
	var cof = __webpack_require__(38);
	var toAbsoluteIndex = __webpack_require__(72);
	var toLength = __webpack_require__(24);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(8)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $some = __webpack_require__(44)(3);
	
	$export($export.P + $export.F * !__webpack_require__(41)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(28);
	var toObject = __webpack_require__(26);
	var fails = __webpack_require__(8);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(41)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(71)('Array');


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1);
	var toISOString = __webpack_require__(335);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(26);
	var toPrimitive = __webpack_require__(48);
	
	$export($export.P + $export.F * __webpack_require__(8)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(13)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(31)(proto, TO_PRIMITIVE, __webpack_require__(336));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(32)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', { bind: __webpack_require__(199) });


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(9);
	var getPrototypeOf = __webpack_require__(36);
	var HAS_INSTANCE = __webpack_require__(13)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(23).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(23).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(22) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1);
	var log1p = __webpack_require__(210);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1);
	var sign = __webpack_require__(143);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1);
	var $expm1 = __webpack_require__(142);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { fround: __webpack_require__(209) });


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(8)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(210) });


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { sign: __webpack_require__(143) });


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(142);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(8)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(142);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(6);
	var has = __webpack_require__(34);
	var cof = __webpack_require__(38);
	var inheritIfRequired = __webpack_require__(138);
	var toPrimitive = __webpack_require__(48);
	var fails = __webpack_require__(8);
	var gOPN = __webpack_require__(67).f;
	var gOPD = __webpack_require__(35).f;
	var dP = __webpack_require__(23).f;
	var $trim = __webpack_require__(79).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(66)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(22) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(32)(global, NUMBER, $Number);
	}


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(1);
	var _isFinite = __webpack_require__(6).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(206) });


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(1);
	var isInteger = __webpack_require__(206);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(218);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(219);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toInteger = __webpack_require__(47);
	var aNumberValue = __webpack_require__(195);
	var repeat = __webpack_require__(150);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(8)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $fails = __webpack_require__(8);
	var aNumberValue = __webpack_require__(195);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(212) });


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(66) });


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(22), 'Object', { defineProperties: __webpack_require__(213) });


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(22), 'Object', { defineProperty: __webpack_require__(23).f });


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(61).onFreeze;
	
	__webpack_require__(46)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(37);
	var $getOwnPropertyDescriptor = __webpack_require__(35).f;
	
	__webpack_require__(46)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(46)('getOwnPropertyNames', function () {
	  return __webpack_require__(214).f;
	});


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(26);
	var $getPrototypeOf = __webpack_require__(36);
	
	__webpack_require__(46)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(9);
	
	__webpack_require__(46)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(9);
	
	__webpack_require__(46)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(9);
	
	__webpack_require__(46)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { is: __webpack_require__(339) });


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(26);
	var $keys = __webpack_require__(68);
	
	__webpack_require__(46)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(61).onFreeze;
	
	__webpack_require__(46)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(61).onFreeze;
	
	__webpack_require__(46)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(146).set });


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(90);
	var test = {};
	test[__webpack_require__(13)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(32)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(218);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(219);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(60);
	var global = __webpack_require__(6);
	var ctx = __webpack_require__(40);
	var classof = __webpack_require__(90);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(9);
	var aFunction = __webpack_require__(28);
	var anInstance = __webpack_require__(64);
	var forOf = __webpack_require__(65);
	var speciesConstructor = __webpack_require__(115);
	var task = __webpack_require__(152).set;
	var microtask = __webpack_require__(144)();
	var newPromiseCapabilityModule = __webpack_require__(145);
	var perform = __webpack_require__(220);
	var userAgent = __webpack_require__(117);
	var promiseResolve = __webpack_require__(221);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(13)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(70)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(78)($Promise, PROMISE);
	__webpack_require__(71)(PROMISE);
	Wrapper = __webpack_require__(39)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(109)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(28);
	var anObject = __webpack_require__(5);
	var rApply = (__webpack_require__(6).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(8)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(1);
	var create = __webpack_require__(66);
	var aFunction = __webpack_require__(28);
	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(9);
	var fails = __webpack_require__(8);
	var bind = __webpack_require__(199);
	var rConstruct = (__webpack_require__(6).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(23);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	var toPrimitive = __webpack_require__(48);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(8)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(1);
	var gOPD = __webpack_require__(35).f;
	var anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(140)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(35);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(1);
	var getProto = __webpack_require__(36);
	var anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(35);
	var getPrototypeOf = __webpack_require__(36);
	var has = __webpack_require__(34);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(9);
	var anObject = __webpack_require__(5);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(217) });


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(1);
	var setProto = __webpack_require__(146);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(23);
	var gOPD = __webpack_require__(35);
	var getPrototypeOf = __webpack_require__(36);
	var has = __webpack_require__(34);
	var $export = __webpack_require__(1);
	var createDesc = __webpack_require__(69);
	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(9);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var inheritIfRequired = __webpack_require__(138);
	var dP = __webpack_require__(23).f;
	var gOPN = __webpack_require__(67).f;
	var isRegExp = __webpack_require__(108);
	var $flags = __webpack_require__(106);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(22) && (!CORRECT_NEW || __webpack_require__(8)(function () {
	  re2[__webpack_require__(13)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(32)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(71)('RegExp');


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(105)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(105)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(105)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(105)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(108);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(226);
	var anObject = __webpack_require__(5);
	var $flags = __webpack_require__(106);
	var DESCRIPTORS = __webpack_require__(22);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(32)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(8)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(33)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(33)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(33)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(33)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(148)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(24);
	var context = __webpack_require__(149);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(33)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(33)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(33)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toAbsoluteIndex = __webpack_require__(72);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(1);
	var context = __webpack_require__(149);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(136)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(33)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(148)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(141)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(33)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(37);
	var toLength = __webpack_require__(24);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(150)
	});


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(33)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(24);
	var context = __webpack_require__(149);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(33)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(33)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(33)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(79)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(6);
	var has = __webpack_require__(34);
	var DESCRIPTORS = __webpack_require__(22);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(32);
	var META = __webpack_require__(61).KEY;
	var $fails = __webpack_require__(8);
	var shared = __webpack_require__(114);
	var setToStringTag = __webpack_require__(78);
	var uid = __webpack_require__(73);
	var wks = __webpack_require__(13);
	var wksExt = __webpack_require__(224);
	var wksDefine = __webpack_require__(154);
	var enumKeys = __webpack_require__(337);
	var isArray = __webpack_require__(107);
	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(9);
	var toIObject = __webpack_require__(37);
	var toPrimitive = __webpack_require__(48);
	var createDesc = __webpack_require__(69);
	var _create = __webpack_require__(66);
	var gOPNExt = __webpack_require__(214);
	var $GOPD = __webpack_require__(35);
	var $DP = __webpack_require__(23);
	var $keys = __webpack_require__(68);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(67).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(92).f = $propertyIsEnumerable;
	  __webpack_require__(111).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(60)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(31)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $typed = __webpack_require__(116);
	var buffer = __webpack_require__(153);
	var anObject = __webpack_require__(5);
	var toAbsoluteIndex = __webpack_require__(72);
	var toLength = __webpack_require__(24);
	var isObject = __webpack_require__(9);
	var ArrayBuffer = __webpack_require__(6).ArrayBuffer;
	var speciesConstructor = __webpack_require__(115);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(8)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(71)(ARRAY_BUFFER);


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(116).ABV, {
	  DataView: __webpack_require__(153).DataView
	});


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(202);
	var validate = __webpack_require__(80);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(104)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(203);
	var toObject = __webpack_require__(26);
	var toLength = __webpack_require__(24);
	var aFunction = __webpack_require__(28);
	var arraySpeciesCreate = __webpack_require__(132);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(59)('flatMap');


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(203);
	var toObject = __webpack_require__(26);
	var toLength = __webpack_require__(24);
	var toInteger = __webpack_require__(47);
	var arraySpeciesCreate = __webpack_require__(132);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(59)('flatten');


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(1);
	var $includes = __webpack_require__(103)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(59)('includes');


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(1);
	var microtask = __webpack_require__(144)();
	var process = __webpack_require__(6).process;
	var isNode = __webpack_require__(38)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1);
	var cof = __webpack_require__(38);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.G, { global: __webpack_require__(6) });


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(112)('Map');


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(113)('Map');


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(201)('Map') });


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var scale = __webpack_require__(211);
	var fround = __webpack_require__(209);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { scale: __webpack_require__(211) });


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(26);
	var aFunction = __webpack_require__(28);
	var $defineProperty = __webpack_require__(23);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(22) && $export($export.P + __webpack_require__(110), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(26);
	var aFunction = __webpack_require__(28);
	var $defineProperty = __webpack_require__(23);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(22) && $export($export.P + __webpack_require__(110), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $entries = __webpack_require__(216)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(1);
	var ownKeys = __webpack_require__(217);
	var toIObject = __webpack_require__(37);
	var gOPD = __webpack_require__(35);
	var createProperty = __webpack_require__(133);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(26);
	var toPrimitive = __webpack_require__(48);
	var getPrototypeOf = __webpack_require__(36);
	var getOwnPropertyDescriptor = __webpack_require__(35).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(22) && $export($export.P + __webpack_require__(110), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(26);
	var toPrimitive = __webpack_require__(48);
	var getPrototypeOf = __webpack_require__(36);
	var getOwnPropertyDescriptor = __webpack_require__(35).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(22) && $export($export.P + __webpack_require__(110), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $values = __webpack_require__(216)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(1);
	var global = __webpack_require__(6);
	var core = __webpack_require__(39);
	var microtask = __webpack_require__(144)();
	var OBSERVABLE = __webpack_require__(13)('observable');
	var aFunction = __webpack_require__(28);
	var anObject = __webpack_require__(5);
	var anInstance = __webpack_require__(64);
	var redefineAll = __webpack_require__(70);
	var hide = __webpack_require__(31);
	var forOf = __webpack_require__(65);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(71)('Observable');


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(1);
	var core = __webpack_require__(39);
	var global = __webpack_require__(6);
	var speciesConstructor = __webpack_require__(115);
	var promiseResolve = __webpack_require__(221);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(1);
	var newPromiseCapability = __webpack_require__(145);
	var perform = __webpack_require__(220);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(5);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(5);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(227);
	var from = __webpack_require__(197);
	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(5);
	var getPrototypeOf = __webpack_require__(36);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(5);
	var getPrototypeOf = __webpack_require__(36);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(5);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(5);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(5);
	var getPrototypeOf = __webpack_require__(36);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(5);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(52);
	var anObject = __webpack_require__(5);
	var aFunction = __webpack_require__(28);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(112)('Set');


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(113)('Set');


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(201)('Set') });


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(148)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(1);
	var defined = __webpack_require__(45);
	var toLength = __webpack_require__(24);
	var isRegExp = __webpack_require__(108);
	var getFlags = __webpack_require__(106);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(140)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(222);
	var userAgent = __webpack_require__(117);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(222);
	var userAgent = __webpack_require__(117);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(79)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(79)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(154)('asyncIterator');


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(154)('observable');


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', { global: __webpack_require__(6) });


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(112)('WeakMap');


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(113)('WeakMap');


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(112)('WeakSet');


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(113)('WeakSet');


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(156);
	var getKeys = __webpack_require__(68);
	var redefine = __webpack_require__(32);
	var global = __webpack_require__(6);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(77);
	var wks = __webpack_require__(13);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $task = __webpack_require__(152);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(6);
	var $export = __webpack_require__(1);
	var userAgent = __webpack_require__(117);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(460);
	__webpack_require__(399);
	__webpack_require__(401);
	__webpack_require__(400);
	__webpack_require__(403);
	__webpack_require__(405);
	__webpack_require__(410);
	__webpack_require__(404);
	__webpack_require__(402);
	__webpack_require__(412);
	__webpack_require__(411);
	__webpack_require__(407);
	__webpack_require__(408);
	__webpack_require__(406);
	__webpack_require__(398);
	__webpack_require__(409);
	__webpack_require__(413);
	__webpack_require__(414);
	__webpack_require__(366);
	__webpack_require__(368);
	__webpack_require__(367);
	__webpack_require__(416);
	__webpack_require__(415);
	__webpack_require__(386);
	__webpack_require__(396);
	__webpack_require__(397);
	__webpack_require__(387);
	__webpack_require__(388);
	__webpack_require__(389);
	__webpack_require__(390);
	__webpack_require__(391);
	__webpack_require__(392);
	__webpack_require__(393);
	__webpack_require__(394);
	__webpack_require__(395);
	__webpack_require__(369);
	__webpack_require__(370);
	__webpack_require__(371);
	__webpack_require__(372);
	__webpack_require__(373);
	__webpack_require__(374);
	__webpack_require__(375);
	__webpack_require__(376);
	__webpack_require__(377);
	__webpack_require__(378);
	__webpack_require__(379);
	__webpack_require__(380);
	__webpack_require__(381);
	__webpack_require__(382);
	__webpack_require__(383);
	__webpack_require__(384);
	__webpack_require__(385);
	__webpack_require__(447);
	__webpack_require__(452);
	__webpack_require__(459);
	__webpack_require__(450);
	__webpack_require__(442);
	__webpack_require__(443);
	__webpack_require__(448);
	__webpack_require__(453);
	__webpack_require__(455);
	__webpack_require__(438);
	__webpack_require__(439);
	__webpack_require__(440);
	__webpack_require__(441);
	__webpack_require__(444);
	__webpack_require__(445);
	__webpack_require__(446);
	__webpack_require__(449);
	__webpack_require__(451);
	__webpack_require__(454);
	__webpack_require__(456);
	__webpack_require__(457);
	__webpack_require__(458);
	__webpack_require__(361);
	__webpack_require__(363);
	__webpack_require__(362);
	__webpack_require__(365);
	__webpack_require__(364);
	__webpack_require__(350);
	__webpack_require__(348);
	__webpack_require__(354);
	__webpack_require__(351);
	__webpack_require__(357);
	__webpack_require__(359);
	__webpack_require__(347);
	__webpack_require__(353);
	__webpack_require__(344);
	__webpack_require__(358);
	__webpack_require__(342);
	__webpack_require__(356);
	__webpack_require__(355);
	__webpack_require__(349);
	__webpack_require__(352);
	__webpack_require__(341);
	__webpack_require__(343);
	__webpack_require__(346);
	__webpack_require__(345);
	__webpack_require__(360);
	__webpack_require__(156);
	__webpack_require__(432);
	__webpack_require__(437);
	__webpack_require__(226);
	__webpack_require__(433);
	__webpack_require__(434);
	__webpack_require__(435);
	__webpack_require__(436);
	__webpack_require__(417);
	__webpack_require__(225);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(472);
	__webpack_require__(461);
	__webpack_require__(462);
	__webpack_require__(467);
	__webpack_require__(470);
	__webpack_require__(471);
	__webpack_require__(465);
	__webpack_require__(468);
	__webpack_require__(466);
	__webpack_require__(469);
	__webpack_require__(463);
	__webpack_require__(464);
	__webpack_require__(418);
	__webpack_require__(419);
	__webpack_require__(420);
	__webpack_require__(421);
	__webpack_require__(422);
	__webpack_require__(425);
	__webpack_require__(423);
	__webpack_require__(424);
	__webpack_require__(426);
	__webpack_require__(427);
	__webpack_require__(428);
	__webpack_require__(429);
	__webpack_require__(431);
	__webpack_require__(430);
	__webpack_require__(475);
	__webpack_require__(473);
	__webpack_require__(474);
	__webpack_require__(516);
	__webpack_require__(519);
	__webpack_require__(518);
	__webpack_require__(520);
	__webpack_require__(521);
	__webpack_require__(517);
	__webpack_require__(522);
	__webpack_require__(523);
	__webpack_require__(497);
	__webpack_require__(500);
	__webpack_require__(496);
	__webpack_require__(494);
	__webpack_require__(495);
	__webpack_require__(498);
	__webpack_require__(499);
	__webpack_require__(481);
	__webpack_require__(515);
	__webpack_require__(480);
	__webpack_require__(514);
	__webpack_require__(526);
	__webpack_require__(528);
	__webpack_require__(479);
	__webpack_require__(513);
	__webpack_require__(525);
	__webpack_require__(527);
	__webpack_require__(478);
	__webpack_require__(524);
	__webpack_require__(477);
	__webpack_require__(482);
	__webpack_require__(483);
	__webpack_require__(484);
	__webpack_require__(485);
	__webpack_require__(486);
	__webpack_require__(488);
	__webpack_require__(487);
	__webpack_require__(489);
	__webpack_require__(490);
	__webpack_require__(491);
	__webpack_require__(493);
	__webpack_require__(492);
	__webpack_require__(502);
	__webpack_require__(503);
	__webpack_require__(504);
	__webpack_require__(505);
	__webpack_require__(507);
	__webpack_require__(506);
	__webpack_require__(509);
	__webpack_require__(508);
	__webpack_require__(510);
	__webpack_require__(511);
	__webpack_require__(512);
	__webpack_require__(476);
	__webpack_require__(501);
	__webpack_require__(531);
	__webpack_require__(530);
	__webpack_require__(529);
	module.exports = __webpack_require__(39);


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var emptyObject = __webpack_require__(118);
	var _invariant = __webpack_require__(4);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 534 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 535 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 537 */
157,
/* 538 */
157,
/* 539 */
157,
/* 540 */
157,
/* 541 */
157,
/* 542 */
157,
/* 543 */
157,
/* 544 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(544);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(554);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createArrayFromMixed = __webpack_require__(547);
	var getMarkupWrap = __webpack_require__(549);
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 550 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 551 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(551);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 553 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(553);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 555 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 556 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(81);
	
	var _PathUtils = __webpack_require__(74);
	
	var _ExecutionEnvironment = __webpack_require__(119);
	
	var _DOMUtils = __webpack_require__(159);
	
	var _DOMStateStorage = __webpack_require__(234);
	
	var _createDOMHistory = __webpack_require__(235);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(81);
	
	var _PathUtils = __webpack_require__(74);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(49);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(74);
	
	var _Actions = __webpack_require__(81);
	
	var _createHistory = __webpack_require__(237);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 560 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 561 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 562 */
/***/ function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  if (!fn) {
	    return false
	  }
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ },
/* 563 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 564 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 565 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.10';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function safeGet(object, key) {
	    return key == '__proto__'
	      ? undefined
	      : object[key];
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(730)(module)))

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	/*! @name m3u8-parser @version 4.8.0 @license Apache-2.0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _inheritsLoose = __webpack_require__(187);
	var Stream = __webpack_require__(321);
	var _extends = __webpack_require__(57);
	var _assertThisInitialized = __webpack_require__(15);
	var decodeB64ToUint8Array = __webpack_require__(191);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var Stream__default = /*#__PURE__*/_interopDefaultLegacy(Stream);
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var decodeB64ToUint8Array__default = /*#__PURE__*/_interopDefaultLegacy(decodeB64ToUint8Array);
	
	/**
	 * A stream that buffers string input and generates a `data` event for each
	 * line.
	 *
	 * @class LineStream
	 * @extends Stream
	 */
	
	var LineStream = /*#__PURE__*/function (_Stream) {
	  _inheritsLoose__default['default'](LineStream, _Stream);
	
	  function LineStream() {
	    var _this;
	
	    _this = _Stream.call(this) || this;
	    _this.buffer = '';
	    return _this;
	  }
	  /**
	   * Add new data to be parsed.
	   *
	   * @param {string} data the text to process
	   */
	
	
	  var _proto = LineStream.prototype;
	
	  _proto.push = function push(data) {
	    var nextNewline;
	    this.buffer += data;
	    nextNewline = this.buffer.indexOf('\n');
	
	    for (; nextNewline > -1; nextNewline = this.buffer.indexOf('\n')) {
	      this.trigger('data', this.buffer.substring(0, nextNewline));
	      this.buffer = this.buffer.substring(nextNewline + 1);
	    }
	  };
	
	  return LineStream;
	}(Stream__default['default']);
	
	var TAB = String.fromCharCode(0x09);
	
	var parseByterange = function parseByterange(byterangeString) {
	  // optionally match and capture 0+ digits before `@`
	  // optionally match and capture 0+ digits after `@`
	  var match = /([0-9.]*)?@?([0-9.]*)?/.exec(byterangeString || '');
	  var result = {};
	
	  if (match[1]) {
	    result.length = parseInt(match[1], 10);
	  }
	
	  if (match[2]) {
	    result.offset = parseInt(match[2], 10);
	  }
	
	  return result;
	};
	/**
	 * "forgiving" attribute list psuedo-grammar:
	 * attributes -> keyvalue (',' keyvalue)*
	 * keyvalue   -> key '=' value
	 * key        -> [^=]*
	 * value      -> '"' [^"]* '"' | [^,]*
	 */
	
	
	var attributeSeparator = function attributeSeparator() {
	  var key = '[^=]*';
	  var value = '"[^"]*"|[^,]*';
	  var keyvalue = '(?:' + key + ')=(?:' + value + ')';
	  return new RegExp('(?:^|,)(' + keyvalue + ')');
	};
	/**
	 * Parse attributes from a line given the separator
	 *
	 * @param {string} attributes the attribute line to parse
	 */
	
	
	var parseAttributes = function parseAttributes(attributes) {
	  // split the string using attributes as the separator
	  var attrs = attributes.split(attributeSeparator());
	  var result = {};
	  var i = attrs.length;
	  var attr;
	
	  while (i--) {
	    // filter out unmatched portions of the string
	    if (attrs[i] === '') {
	      continue;
	    } // split the key and value
	
	
	    attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1); // trim whitespace and remove optional quotes around the value
	
	    attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
	    attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
	    attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
	    result[attr[0]] = attr[1];
	  }
	
	  return result;
	};
	/**
	 * A line-level M3U8 parser event stream. It expects to receive input one
	 * line at a time and performs a context-free parse of its contents. A stream
	 * interpretation of a manifest can be useful if the manifest is expected to
	 * be too large to fit comfortably into memory or the entirety of the input
	 * is not immediately available. Otherwise, it's probably much easier to work
	 * with a regular `Parser` object.
	 *
	 * Produces `data` events with an object that captures the parser's
	 * interpretation of the input. That object has a property `tag` that is one
	 * of `uri`, `comment`, or `tag`. URIs only have a single additional
	 * property, `line`, which captures the entirety of the input without
	 * interpretation. Comments similarly have a single additional property
	 * `text` which is the input without the leading `#`.
	 *
	 * Tags always have a property `tagType` which is the lower-cased version of
	 * the M3U8 directive without the `#EXT` or `#EXT-X-` prefix. For instance,
	 * `#EXT-X-MEDIA-SEQUENCE` becomes `media-sequence` when parsed. Unrecognized
	 * tags are given the tag type `unknown` and a single additional property
	 * `data` with the remainder of the input.
	 *
	 * @class ParseStream
	 * @extends Stream
	 */
	
	
	var ParseStream = /*#__PURE__*/function (_Stream) {
	  _inheritsLoose__default['default'](ParseStream, _Stream);
	
	  function ParseStream() {
	    var _this;
	
	    _this = _Stream.call(this) || this;
	    _this.customParsers = [];
	    _this.tagMappers = [];
	    return _this;
	  }
	  /**
	   * Parses an additional line of input.
	   *
	   * @param {string} line a single line of an M3U8 file to parse
	   */
	
	
	  var _proto = ParseStream.prototype;
	
	  _proto.push = function push(line) {
	    var _this2 = this;
	
	    var match;
	    var event; // strip whitespace
	
	    line = line.trim();
	
	    if (line.length === 0) {
	      // ignore empty lines
	      return;
	    } // URIs
	
	
	    if (line[0] !== '#') {
	      this.trigger('data', {
	        type: 'uri',
	        uri: line
	      });
	      return;
	    } // map tags
	
	
	    var newLines = this.tagMappers.reduce(function (acc, mapper) {
	      var mappedLine = mapper(line); // skip if unchanged
	
	      if (mappedLine === line) {
	        return acc;
	      }
	
	      return acc.concat([mappedLine]);
	    }, [line]);
	    newLines.forEach(function (newLine) {
	      for (var i = 0; i < _this2.customParsers.length; i++) {
	        if (_this2.customParsers[i].call(_this2, newLine)) {
	          return;
	        }
	      } // Comments
	
	
	      if (newLine.indexOf('#EXT') !== 0) {
	        _this2.trigger('data', {
	          type: 'comment',
	          text: newLine.slice(1)
	        });
	
	        return;
	      } // strip off any carriage returns here so the regex matching
	      // doesn't have to account for them.
	
	
	      newLine = newLine.replace('\r', ''); // Tags
	
	      match = /^#EXTM3U/.exec(newLine);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'tag',
	          tagType: 'm3u'
	        });
	
	        return;
	      }
	
	      match = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'inf'
	        };
	
	        if (match[1]) {
	          event.duration = parseFloat(match[1]);
	        }
	
	        if (match[2]) {
	          event.title = match[2];
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'targetduration'
	        };
	
	        if (match[1]) {
	          event.duration = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'version'
	        };
	
	        if (match[1]) {
	          event.version = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'media-sequence'
	        };
	
	        if (match[1]) {
	          event.number = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'discontinuity-sequence'
	        };
	
	        if (match[1]) {
	          event.number = parseInt(match[1], 10);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'playlist-type'
	        };
	
	        if (match[1]) {
	          event.playlistType = match[1];
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = _extends__default['default'](parseByterange(match[1]), {
	          type: 'tag',
	          tagType: 'byterange'
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'allow-cache'
	        };
	
	        if (match[1]) {
	          event.allowed = !/NO/.test(match[1]);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-MAP:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'map'
	        };
	
	        if (match[1]) {
	          var attributes = parseAttributes(match[1]);
	
	          if (attributes.URI) {
	            event.uri = attributes.URI;
	          }
	
	          if (attributes.BYTERANGE) {
	            event.byterange = parseByterange(attributes.BYTERANGE);
	          }
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-STREAM-INF:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'stream-inf'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]);
	
	          if (event.attributes.RESOLUTION) {
	            var split = event.attributes.RESOLUTION.split('x');
	            var resolution = {};
	
	            if (split[0]) {
	              resolution.width = parseInt(split[0], 10);
	            }
	
	            if (split[1]) {
	              resolution.height = parseInt(split[1], 10);
	            }
	
	            event.attributes.RESOLUTION = resolution;
	          }
	
	          if (event.attributes.BANDWIDTH) {
	            event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
	          }
	
	          if (event.attributes['FRAME-RATE']) {
	            event.attributes['FRAME-RATE'] = parseFloat(event.attributes['FRAME-RATE']);
	          }
	
	          if (event.attributes['PROGRAM-ID']) {
	            event.attributes['PROGRAM-ID'] = parseInt(event.attributes['PROGRAM-ID'], 10);
	          }
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-MEDIA:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'media'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-ENDLIST/.exec(newLine);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'tag',
	          tagType: 'endlist'
	        });
	
	        return;
	      }
	
	      match = /^#EXT-X-DISCONTINUITY/.exec(newLine);
	
	      if (match) {
	        _this2.trigger('data', {
	          type: 'tag',
	          tagType: 'discontinuity'
	        });
	
	        return;
	      }
	
	      match = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'program-date-time'
	        };
	
	        if (match[1]) {
	          event.dateTimeString = match[1];
	          event.dateTimeObject = new Date(match[1]);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-KEY:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'key'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]); // parse the IV string into a Uint32Array
	
	          if (event.attributes.IV) {
	            if (event.attributes.IV.substring(0, 2).toLowerCase() === '0x') {
	              event.attributes.IV = event.attributes.IV.substring(2);
	            }
	
	            event.attributes.IV = event.attributes.IV.match(/.{8}/g);
	            event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
	            event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
	            event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
	            event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
	            event.attributes.IV = new Uint32Array(event.attributes.IV);
	          }
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-START:?(.*)$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'start'
	        };
	
	        if (match[1]) {
	          event.attributes = parseAttributes(match[1]);
	          event.attributes['TIME-OFFSET'] = parseFloat(event.attributes['TIME-OFFSET']);
	          event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'cue-out-cont'
	        };
	
	        if (match[1]) {
	          event.data = match[1];
	        } else {
	          event.data = '';
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'cue-out'
	        };
	
	        if (match[1]) {
	          event.data = match[1];
	        } else {
	          event.data = '';
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-CUE-IN:?(.*)?$/.exec(newLine);
	
	      if (match) {
	        event = {
	          type: 'tag',
	          tagType: 'cue-in'
	        };
	
	        if (match[1]) {
	          event.data = match[1];
	        } else {
	          event.data = '';
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-SKIP:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'skip'
	        };
	        event.attributes = parseAttributes(match[1]);
	
	        if (event.attributes.hasOwnProperty('SKIPPED-SEGMENTS')) {
	          event.attributes['SKIPPED-SEGMENTS'] = parseInt(event.attributes['SKIPPED-SEGMENTS'], 10);
	        }
	
	        if (event.attributes.hasOwnProperty('RECENTLY-REMOVED-DATERANGES')) {
	          event.attributes['RECENTLY-REMOVED-DATERANGES'] = event.attributes['RECENTLY-REMOVED-DATERANGES'].split(TAB);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PART:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'part'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['DURATION'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseFloat(event.attributes[key]);
	          }
	        });
	        ['INDEPENDENT', 'GAP'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = /YES/.test(event.attributes[key]);
	          }
	        });
	
	        if (event.attributes.hasOwnProperty('BYTERANGE')) {
	          event.attributes.byterange = parseByterange(event.attributes.BYTERANGE);
	        }
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'server-control'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['CAN-SKIP-UNTIL', 'PART-HOLD-BACK', 'HOLD-BACK'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseFloat(event.attributes[key]);
	          }
	        });
	        ['CAN-SKIP-DATERANGES', 'CAN-BLOCK-RELOAD'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = /YES/.test(event.attributes[key]);
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PART-INF:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'part-inf'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['PART-TARGET'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseFloat(event.attributes[key]);
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'preload-hint'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['BYTERANGE-START', 'BYTERANGE-LENGTH'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseInt(event.attributes[key], 10);
	            var subkey = key === 'BYTERANGE-LENGTH' ? 'length' : 'offset';
	            event.attributes.byterange = event.attributes.byterange || {};
	            event.attributes.byterange[subkey] = event.attributes[key]; // only keep the parsed byterange object.
	
	            delete event.attributes[key];
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      }
	
	      match = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(newLine);
	
	      if (match && match[1]) {
	        event = {
	          type: 'tag',
	          tagType: 'rendition-report'
	        };
	        event.attributes = parseAttributes(match[1]);
	        ['LAST-MSN', 'LAST-PART'].forEach(function (key) {
	          if (event.attributes.hasOwnProperty(key)) {
	            event.attributes[key] = parseInt(event.attributes[key], 10);
	          }
	        });
	
	        _this2.trigger('data', event);
	
	        return;
	      } // unknown tag type
	
	
	      _this2.trigger('data', {
	        type: 'tag',
	        data: newLine.slice(4)
	      });
	    });
	  }
	  /**
	   * Add a parser for custom headers
	   *
	   * @param {Object}   options              a map of options for the added parser
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {string}   options.customType   the custom type to register to the output
	   * @param {Function} [options.dataParser] function to parse the line into an object
	   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
	   */
	  ;
	
	  _proto.addParser = function addParser(_ref) {
	    var _this3 = this;
	
	    var expression = _ref.expression,
	        customType = _ref.customType,
	        dataParser = _ref.dataParser,
	        segment = _ref.segment;
	
	    if (typeof dataParser !== 'function') {
	      dataParser = function dataParser(line) {
	        return line;
	      };
	    }
	
	    this.customParsers.push(function (line) {
	      var match = expression.exec(line);
	
	      if (match) {
	        _this3.trigger('data', {
	          type: 'custom',
	          data: dataParser(line),
	          customType: customType,
	          segment: segment
	        });
	
	        return true;
	      }
	    });
	  }
	  /**
	   * Add a custom header mapper
	   *
	   * @param {Object}   options
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {Function} options.map          function to translate tag into a different tag
	   */
	  ;
	
	  _proto.addTagMapper = function addTagMapper(_ref2) {
	    var expression = _ref2.expression,
	        map = _ref2.map;
	
	    var mapFn = function mapFn(line) {
	      if (expression.test(line)) {
	        return map(line);
	      }
	
	      return line;
	    };
	
	    this.tagMappers.push(mapFn);
	  };
	
	  return ParseStream;
	}(Stream__default['default']);
	
	var camelCase = function camelCase(str) {
	  return str.toLowerCase().replace(/-(\w)/g, function (a) {
	    return a[1].toUpperCase();
	  });
	};
	
	var camelCaseKeys = function camelCaseKeys(attributes) {
	  var result = {};
	  Object.keys(attributes).forEach(function (key) {
	    result[camelCase(key)] = attributes[key];
	  });
	  return result;
	}; // set SERVER-CONTROL hold back based upon targetDuration and partTargetDuration
	// we need this helper because defaults are based upon targetDuration and
	// partTargetDuration being set, but they may not be if SERVER-CONTROL appears before
	// target durations are set.
	
	
	var setHoldBack = function setHoldBack(manifest) {
	  var serverControl = manifest.serverControl,
	      targetDuration = manifest.targetDuration,
	      partTargetDuration = manifest.partTargetDuration;
	
	  if (!serverControl) {
	    return;
	  }
	
	  var tag = '#EXT-X-SERVER-CONTROL';
	  var hb = 'holdBack';
	  var phb = 'partHoldBack';
	  var minTargetDuration = targetDuration && targetDuration * 3;
	  var minPartDuration = partTargetDuration && partTargetDuration * 2;
	
	  if (targetDuration && !serverControl.hasOwnProperty(hb)) {
	    serverControl[hb] = minTargetDuration;
	    this.trigger('info', {
	      message: tag + " defaulting HOLD-BACK to targetDuration * 3 (" + minTargetDuration + ")."
	    });
	  }
	
	  if (minTargetDuration && serverControl[hb] < minTargetDuration) {
	    this.trigger('warn', {
	      message: tag + " clamping HOLD-BACK (" + serverControl[hb] + ") to targetDuration * 3 (" + minTargetDuration + ")"
	    });
	    serverControl[hb] = minTargetDuration;
	  } // default no part hold back to part target duration * 3
	
	
	  if (partTargetDuration && !serverControl.hasOwnProperty(phb)) {
	    serverControl[phb] = partTargetDuration * 3;
	    this.trigger('info', {
	      message: tag + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + serverControl[phb] + ")."
	    });
	  } // if part hold back is too small default it to part target duration * 2
	
	
	  if (partTargetDuration && serverControl[phb] < minPartDuration) {
	    this.trigger('warn', {
	      message: tag + " clamping PART-HOLD-BACK (" + serverControl[phb] + ") to partTargetDuration * 2 (" + minPartDuration + ")."
	    });
	    serverControl[phb] = minPartDuration;
	  }
	};
	/**
	 * A parser for M3U8 files. The current interpretation of the input is
	 * exposed as a property `manifest` on parser objects. It's just two lines to
	 * create and parse a manifest once you have the contents available as a string:
	 *
	 * ```js
	 * var parser = new m3u8.Parser();
	 * parser.push(xhr.responseText);
	 * ```
	 *
	 * New input can later be applied to update the manifest object by calling
	 * `push` again.
	 *
	 * The parser attempts to create a usable manifest object even if the
	 * underlying input is somewhat nonsensical. It emits `info` and `warning`
	 * events during the parse if it encounters input that seems invalid or
	 * requires some property of the manifest object to be defaulted.
	 *
	 * @class Parser
	 * @extends Stream
	 */
	
	
	var Parser = /*#__PURE__*/function (_Stream) {
	  _inheritsLoose__default['default'](Parser, _Stream);
	
	  function Parser() {
	    var _this;
	
	    _this = _Stream.call(this) || this;
	    _this.lineStream = new LineStream();
	    _this.parseStream = new ParseStream();
	
	    _this.lineStream.pipe(_this.parseStream);
	    /* eslint-disable consistent-this */
	
	
	    var self = _assertThisInitialized__default['default'](_this);
	    /* eslint-enable consistent-this */
	
	
	    var uris = [];
	    var currentUri = {}; // if specified, the active EXT-X-MAP definition
	
	    var currentMap; // if specified, the active decryption key
	
	    var _key;
	
	    var hasParts = false;
	
	    var noop = function noop() {};
	
	    var defaultMediaGroups = {
	      'AUDIO': {},
	      'VIDEO': {},
	      'CLOSED-CAPTIONS': {},
	      'SUBTITLES': {}
	    }; // This is the Widevine UUID from DASH IF IOP. The same exact string is
	    // used in MPDs with Widevine encrypted streams.
	
	    var widevineUuid = 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed'; // group segments into numbered timelines delineated by discontinuities
	
	    var currentTimeline = 0; // the manifest is empty until the parse stream begins delivering data
	
	    _this.manifest = {
	      allowCache: true,
	      discontinuityStarts: [],
	      segments: []
	    }; // keep track of the last seen segment's byte range end, as segments are not required
	    // to provide the offset, in which case it defaults to the next byte after the
	    // previous segment
	
	    var lastByterangeEnd = 0; // keep track of the last seen part's byte range end.
	
	    var lastPartByterangeEnd = 0;
	
	    _this.on('end', function () {
	      // only add preloadSegment if we don't yet have a uri for it.
	      // and we actually have parts/preloadHints
	      if (currentUri.uri || !currentUri.parts && !currentUri.preloadHints) {
	        return;
	      }
	
	      if (!currentUri.map && currentMap) {
	        currentUri.map = currentMap;
	      }
	
	      if (!currentUri.key && _key) {
	        currentUri.key = _key;
	      }
	
	      if (!currentUri.timeline && typeof currentTimeline === 'number') {
	        currentUri.timeline = currentTimeline;
	      }
	
	      _this.manifest.preloadSegment = currentUri;
	    }); // update the manifest with the m3u8 entry from the parse stream
	
	
	    _this.parseStream.on('data', function (entry) {
	      var mediaGroup;
	      var rendition;
	      ({
	        tag: function tag() {
	          // switch based on the tag type
	          (({
	            version: function version() {
	              if (entry.version) {
	                this.manifest.version = entry.version;
	              }
	            },
	            'allow-cache': function allowCache() {
	              this.manifest.allowCache = entry.allowed;
	
	              if (!('allowed' in entry)) {
	                this.trigger('info', {
	                  message: 'defaulting allowCache to YES'
	                });
	                this.manifest.allowCache = true;
	              }
	            },
	            byterange: function byterange() {
	              var byterange = {};
	
	              if ('length' in entry) {
	                currentUri.byterange = byterange;
	                byterange.length = entry.length;
	
	                if (!('offset' in entry)) {
	                  /*
	                   * From the latest spec (as of this writing):
	                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.2
	                   *
	                   * Same text since EXT-X-BYTERANGE's introduction in draft 7:
	                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-07#section-3.3.1)
	                   *
	                   * "If o [offset] is not present, the sub-range begins at the next byte
	                   * following the sub-range of the previous media segment."
	                   */
	                  entry.offset = lastByterangeEnd;
	                }
	              }
	
	              if ('offset' in entry) {
	                currentUri.byterange = byterange;
	                byterange.offset = entry.offset;
	              }
	
	              lastByterangeEnd = byterange.offset + byterange.length;
	            },
	            endlist: function endlist() {
	              this.manifest.endList = true;
	            },
	            inf: function inf() {
	              if (!('mediaSequence' in this.manifest)) {
	                this.manifest.mediaSequence = 0;
	                this.trigger('info', {
	                  message: 'defaulting media sequence to zero'
	                });
	              }
	
	              if (!('discontinuitySequence' in this.manifest)) {
	                this.manifest.discontinuitySequence = 0;
	                this.trigger('info', {
	                  message: 'defaulting discontinuity sequence to zero'
	                });
	              }
	
	              if (entry.duration > 0) {
	                currentUri.duration = entry.duration;
	              }
	
	              if (entry.duration === 0) {
	                currentUri.duration = 0.01;
	                this.trigger('info', {
	                  message: 'updating zero segment duration to a small value'
	                });
	              }
	
	              this.manifest.segments = uris;
	            },
	            key: function key() {
	              if (!entry.attributes) {
	                this.trigger('warn', {
	                  message: 'ignoring key declaration without attribute list'
	                });
	                return;
	              } // clear the active encryption key
	
	
	              if (entry.attributes.METHOD === 'NONE') {
	                _key = null;
	                return;
	              }
	
	              if (!entry.attributes.URI) {
	                this.trigger('warn', {
	                  message: 'ignoring key declaration without URI'
	                });
	                return;
	              }
	
	              if (entry.attributes.KEYFORMAT === 'com.apple.streamingkeydelivery') {
	                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
	
	                this.manifest.contentProtection['com.apple.fps.1_0'] = {
	                  attributes: entry.attributes
	                };
	                return;
	              }
	
	              if (entry.attributes.KEYFORMAT === 'com.microsoft.playready') {
	                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.
	
	                this.manifest.contentProtection['com.microsoft.playready'] = {
	                  uri: entry.attributes.URI
	                };
	                return;
	              } // check if the content is encrypted for Widevine
	              // Widevine/HLS spec: https://storage.googleapis.com/wvdocs/Widevine_DRM_HLS.pdf
	
	
	              if (entry.attributes.KEYFORMAT === widevineUuid) {
	                var VALID_METHODS = ['SAMPLE-AES', 'SAMPLE-AES-CTR', 'SAMPLE-AES-CENC'];
	
	                if (VALID_METHODS.indexOf(entry.attributes.METHOD) === -1) {
	                  this.trigger('warn', {
	                    message: 'invalid key method provided for Widevine'
	                  });
	                  return;
	                }
	
	                if (entry.attributes.METHOD === 'SAMPLE-AES-CENC') {
	                  this.trigger('warn', {
	                    message: 'SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead'
	                  });
	                }
	
	                if (entry.attributes.URI.substring(0, 23) !== 'data:text/plain;base64,') {
	                  this.trigger('warn', {
	                    message: 'invalid key URI provided for Widevine'
	                  });
	                  return;
	                }
	
	                if (!(entry.attributes.KEYID && entry.attributes.KEYID.substring(0, 2) === '0x')) {
	                  this.trigger('warn', {
	                    message: 'invalid key ID provided for Widevine'
	                  });
	                  return;
	                } // if Widevine key attributes are valid, store them as `contentProtection`
	                // on the manifest to emulate Widevine tag structure in a DASH mpd
	
	
	                this.manifest.contentProtection = this.manifest.contentProtection || {};
	                this.manifest.contentProtection['com.widevine.alpha'] = {
	                  attributes: {
	                    schemeIdUri: entry.attributes.KEYFORMAT,
	                    // remove '0x' from the key id string
	                    keyId: entry.attributes.KEYID.substring(2)
	                  },
	                  // decode the base64-encoded PSSH box
	                  pssh: decodeB64ToUint8Array__default['default'](entry.attributes.URI.split(',')[1])
	                };
	                return;
	              }
	
	              if (!entry.attributes.METHOD) {
	                this.trigger('warn', {
	                  message: 'defaulting key method to AES-128'
	                });
	              } // setup an encryption key for upcoming segments
	
	
	              _key = {
	                method: entry.attributes.METHOD || 'AES-128',
	                uri: entry.attributes.URI
	              };
	
	              if (typeof entry.attributes.IV !== 'undefined') {
	                _key.iv = entry.attributes.IV;
	              }
	            },
	            'media-sequence': function mediaSequence() {
	              if (!isFinite(entry.number)) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid media sequence: ' + entry.number
	                });
	                return;
	              }
	
	              this.manifest.mediaSequence = entry.number;
	            },
	            'discontinuity-sequence': function discontinuitySequence() {
	              if (!isFinite(entry.number)) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid discontinuity sequence: ' + entry.number
	                });
	                return;
	              }
	
	              this.manifest.discontinuitySequence = entry.number;
	              currentTimeline = entry.number;
	            },
	            'playlist-type': function playlistType() {
	              if (!/VOD|EVENT/.test(entry.playlistType)) {
	                this.trigger('warn', {
	                  message: 'ignoring unknown playlist type: ' + entry.playlist
	                });
	                return;
	              }
	
	              this.manifest.playlistType = entry.playlistType;
	            },
	            map: function map() {
	              currentMap = {};
	
	              if (entry.uri) {
	                currentMap.uri = entry.uri;
	              }
	
	              if (entry.byterange) {
	                currentMap.byterange = entry.byterange;
	              }
	
	              if (_key) {
	                currentMap.key = _key;
	              }
	            },
	            'stream-inf': function streamInf() {
	              this.manifest.playlists = uris;
	              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
	
	              if (!entry.attributes) {
	                this.trigger('warn', {
	                  message: 'ignoring empty stream-inf attributes'
	                });
	                return;
	              }
	
	              if (!currentUri.attributes) {
	                currentUri.attributes = {};
	              }
	
	              _extends__default['default'](currentUri.attributes, entry.attributes);
	            },
	            media: function media() {
	              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
	
	              if (!(entry.attributes && entry.attributes.TYPE && entry.attributes['GROUP-ID'] && entry.attributes.NAME)) {
	                this.trigger('warn', {
	                  message: 'ignoring incomplete or missing media group'
	                });
	                return;
	              } // find the media group, creating defaults as necessary
	
	
	              var mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
	              mediaGroupType[entry.attributes['GROUP-ID']] = mediaGroupType[entry.attributes['GROUP-ID']] || {};
	              mediaGroup = mediaGroupType[entry.attributes['GROUP-ID']]; // collect the rendition metadata
	
	              rendition = {
	                default: /yes/i.test(entry.attributes.DEFAULT)
	              };
	
	              if (rendition.default) {
	                rendition.autoselect = true;
	              } else {
	                rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
	              }
	
	              if (entry.attributes.LANGUAGE) {
	                rendition.language = entry.attributes.LANGUAGE;
	              }
	
	              if (entry.attributes.URI) {
	                rendition.uri = entry.attributes.URI;
	              }
	
	              if (entry.attributes['INSTREAM-ID']) {
	                rendition.instreamId = entry.attributes['INSTREAM-ID'];
	              }
	
	              if (entry.attributes.CHARACTERISTICS) {
	                rendition.characteristics = entry.attributes.CHARACTERISTICS;
	              }
	
	              if (entry.attributes.FORCED) {
	                rendition.forced = /yes/i.test(entry.attributes.FORCED);
	              } // insert the new rendition
	
	
	              mediaGroup[entry.attributes.NAME] = rendition;
	            },
	            discontinuity: function discontinuity() {
	              currentTimeline += 1;
	              currentUri.discontinuity = true;
	              this.manifest.discontinuityStarts.push(uris.length);
	            },
	            'program-date-time': function programDateTime() {
	              if (typeof this.manifest.dateTimeString === 'undefined') {
	                // PROGRAM-DATE-TIME is a media-segment tag, but for backwards
	                // compatibility, we add the first occurence of the PROGRAM-DATE-TIME tag
	                // to the manifest object
	                // TODO: Consider removing this in future major version
	                this.manifest.dateTimeString = entry.dateTimeString;
	                this.manifest.dateTimeObject = entry.dateTimeObject;
	              }
	
	              currentUri.dateTimeString = entry.dateTimeString;
	              currentUri.dateTimeObject = entry.dateTimeObject;
	            },
	            targetduration: function targetduration() {
	              if (!isFinite(entry.duration) || entry.duration < 0) {
	                this.trigger('warn', {
	                  message: 'ignoring invalid target duration: ' + entry.duration
	                });
	                return;
	              }
	
	              this.manifest.targetDuration = entry.duration;
	              setHoldBack.call(this, this.manifest);
	            },
	            start: function start() {
	              if (!entry.attributes || isNaN(entry.attributes['TIME-OFFSET'])) {
	                this.trigger('warn', {
	                  message: 'ignoring start declaration without appropriate attribute list'
	                });
	                return;
	              }
	
	              this.manifest.start = {
	                timeOffset: entry.attributes['TIME-OFFSET'],
	                precise: entry.attributes.PRECISE
	              };
	            },
	            'cue-out': function cueOut() {
	              currentUri.cueOut = entry.data;
	            },
	            'cue-out-cont': function cueOutCont() {
	              currentUri.cueOutCont = entry.data;
	            },
	            'cue-in': function cueIn() {
	              currentUri.cueIn = entry.data;
	            },
	            'skip': function skip() {
	              this.manifest.skip = camelCaseKeys(entry.attributes);
	              this.warnOnMissingAttributes_('#EXT-X-SKIP', entry.attributes, ['SKIPPED-SEGMENTS']);
	            },
	            'part': function part() {
	              var _this2 = this;
	
	              hasParts = true; // parts are always specifed before a segment
	
	              var segmentIndex = this.manifest.segments.length;
	              var part = camelCaseKeys(entry.attributes);
	              currentUri.parts = currentUri.parts || [];
	              currentUri.parts.push(part);
	
	              if (part.byterange) {
	                if (!part.byterange.hasOwnProperty('offset')) {
	                  part.byterange.offset = lastPartByterangeEnd;
	                }
	
	                lastPartByterangeEnd = part.byterange.offset + part.byterange.length;
	              }
	
	              var partIndex = currentUri.parts.length - 1;
	              this.warnOnMissingAttributes_("#EXT-X-PART #" + partIndex + " for segment #" + segmentIndex, entry.attributes, ['URI', 'DURATION']);
	
	              if (this.manifest.renditionReports) {
	                this.manifest.renditionReports.forEach(function (r, i) {
	                  if (!r.hasOwnProperty('lastPart')) {
	                    _this2.trigger('warn', {
	                      message: "#EXT-X-RENDITION-REPORT #" + i + " lacks required attribute(s): LAST-PART"
	                    });
	                  }
	                });
	              }
	            },
	            'server-control': function serverControl() {
	              var attrs = this.manifest.serverControl = camelCaseKeys(entry.attributes);
	
	              if (!attrs.hasOwnProperty('canBlockReload')) {
	                attrs.canBlockReload = false;
	                this.trigger('info', {
	                  message: '#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false'
	                });
	              }
	
	              setHoldBack.call(this, this.manifest);
	
	              if (attrs.canSkipDateranges && !attrs.hasOwnProperty('canSkipUntil')) {
	                this.trigger('warn', {
	                  message: '#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set'
	                });
	              }
	            },
	            'preload-hint': function preloadHint() {
	              // parts are always specifed before a segment
	              var segmentIndex = this.manifest.segments.length;
	              var hint = camelCaseKeys(entry.attributes);
	              var isPart = hint.type && hint.type === 'PART';
	              currentUri.preloadHints = currentUri.preloadHints || [];
	              currentUri.preloadHints.push(hint);
	
	              if (hint.byterange) {
	                if (!hint.byterange.hasOwnProperty('offset')) {
	                  // use last part byterange end or zero if not a part.
	                  hint.byterange.offset = isPart ? lastPartByterangeEnd : 0;
	
	                  if (isPart) {
	                    lastPartByterangeEnd = hint.byterange.offset + hint.byterange.length;
	                  }
	                }
	              }
	
	              var index = currentUri.preloadHints.length - 1;
	              this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex, entry.attributes, ['TYPE', 'URI']);
	
	              if (!hint.type) {
	                return;
	              } // search through all preload hints except for the current one for
	              // a duplicate type.
	
	
	              for (var i = 0; i < currentUri.preloadHints.length - 1; i++) {
	                var otherHint = currentUri.preloadHints[i];
	
	                if (!otherHint.type) {
	                  continue;
	                }
	
	                if (otherHint.type === hint.type) {
	                  this.trigger('warn', {
	                    message: "#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex + " has the same TYPE " + hint.type + " as preload hint #" + i
	                  });
	                }
	              }
	            },
	            'rendition-report': function renditionReport() {
	              var report = camelCaseKeys(entry.attributes);
	              this.manifest.renditionReports = this.manifest.renditionReports || [];
	              this.manifest.renditionReports.push(report);
	              var index = this.manifest.renditionReports.length - 1;
	              var required = ['LAST-MSN', 'URI'];
	
	              if (hasParts) {
	                required.push('LAST-PART');
	              }
	
	              this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + index, entry.attributes, required);
	            },
	            'part-inf': function partInf() {
	              this.manifest.partInf = camelCaseKeys(entry.attributes);
	              this.warnOnMissingAttributes_('#EXT-X-PART-INF', entry.attributes, ['PART-TARGET']);
	
	              if (this.manifest.partInf.partTarget) {
	                this.manifest.partTargetDuration = this.manifest.partInf.partTarget;
	              }
	
	              setHoldBack.call(this, this.manifest);
	            }
	          })[entry.tagType] || noop).call(self);
	        },
	        uri: function uri() {
	          currentUri.uri = entry.uri;
	          uris.push(currentUri); // if no explicit duration was declared, use the target duration
	
	          if (this.manifest.targetDuration && !('duration' in currentUri)) {
	            this.trigger('warn', {
	              message: 'defaulting segment duration to the target duration'
	            });
	            currentUri.duration = this.manifest.targetDuration;
	          } // annotate with encryption information, if necessary
	
	
	          if (_key) {
	            currentUri.key = _key;
	          }
	
	          currentUri.timeline = currentTimeline; // annotate with initialization segment information, if necessary
	
	          if (currentMap) {
	            currentUri.map = currentMap;
	          } // reset the last byterange end as it needs to be 0 between parts
	
	
	          lastPartByterangeEnd = 0; // prepare for the next URI
	
	          currentUri = {};
	        },
	        comment: function comment() {// comments are not important for playback
	        },
	        custom: function custom() {
	          // if this is segment-level data attach the output to the segment
	          if (entry.segment) {
	            currentUri.custom = currentUri.custom || {};
	            currentUri.custom[entry.customType] = entry.data; // if this is manifest-level data attach to the top level manifest object
	          } else {
	            this.manifest.custom = this.manifest.custom || {};
	            this.manifest.custom[entry.customType] = entry.data;
	          }
	        }
	      })[entry.type].call(self);
	    });
	
	    return _this;
	  }
	
	  var _proto = Parser.prototype;
	
	  _proto.warnOnMissingAttributes_ = function warnOnMissingAttributes_(identifier, attributes, required) {
	    var missing = [];
	    required.forEach(function (key) {
	      if (!attributes.hasOwnProperty(key)) {
	        missing.push(key);
	      }
	    });
	
	    if (missing.length) {
	      this.trigger('warn', {
	        message: identifier + " lacks required attribute(s): " + missing.join(', ')
	      });
	    }
	  }
	  /**
	   * Parse the input string and update the manifest object.
	   *
	   * @param {string} chunk a potentially incomplete portion of the manifest
	   */
	  ;
	
	  _proto.push = function push(chunk) {
	    this.lineStream.push(chunk);
	  }
	  /**
	   * Flush any remaining input. This can be handy if the last line of an M3U8
	   * manifest did not contain a trailing newline but the file has been
	   * completely received.
	   */
	  ;
	
	  _proto.end = function end() {
	    // flush any buffered input
	    this.lineStream.push('\n');
	    this.trigger('end');
	  }
	  /**
	   * Add an additional parser for non-standard tags
	   *
	   * @param {Object}   options              a map of options for the added parser
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {string}   options.type         the type to register to the output
	   * @param {Function} [options.dataParser] function to parse the line into an object
	   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
	   */
	  ;
	
	  _proto.addParser = function addParser(options) {
	    this.parseStream.addParser(options);
	  }
	  /**
	   * Add a custom header mapper
	   *
	   * @param {Object}   options
	   * @param {RegExp}   options.expression   a regular expression to match the custom header
	   * @param {Function} options.map          function to translate tag into a different tag
	   */
	  ;
	
	  _proto.addTagMapper = function addTagMapper(options) {
	    this.parseStream.addTagMapper(options);
	  };
	
	  return Parser;
	}(Stream__default['default']);
	
	exports.LineStream = LineStream;
	exports.ParseStream = ParseStream;
	exports.Parser = Parser;


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	/*! @name mpd-parser @version 0.22.1 @license Apache-2.0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var resolveUrl = __webpack_require__(193);
	var window = __webpack_require__(54);
	var mediaGroups = __webpack_require__(316);
	var decodeB64ToUint8Array = __webpack_require__(191);
	var xmldom = __webpack_require__(326);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var resolveUrl__default = /*#__PURE__*/_interopDefaultLegacy(resolveUrl);
	var window__default = /*#__PURE__*/_interopDefaultLegacy(window);
	var decodeB64ToUint8Array__default = /*#__PURE__*/_interopDefaultLegacy(decodeB64ToUint8Array);
	
	var version = "0.22.1";
	
	var isObject = function isObject(obj) {
	  return !!obj && typeof obj === 'object';
	};
	
	var merge = function merge() {
	  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
	    objects[_key] = arguments[_key];
	  }
	
	  return objects.reduce(function (result, source) {
	    if (typeof source !== 'object') {
	      return result;
	    }
	
	    Object.keys(source).forEach(function (key) {
	      if (Array.isArray(result[key]) && Array.isArray(source[key])) {
	        result[key] = result[key].concat(source[key]);
	      } else if (isObject(result[key]) && isObject(source[key])) {
	        result[key] = merge(result[key], source[key]);
	      } else {
	        result[key] = source[key];
	      }
	    });
	    return result;
	  }, {});
	};
	var values = function values(o) {
	  return Object.keys(o).map(function (k) {
	    return o[k];
	  });
	};
	
	var range = function range(start, end) {
	  var result = [];
	
	  for (var i = start; i < end; i++) {
	    result.push(i);
	  }
	
	  return result;
	};
	var flatten = function flatten(lists) {
	  return lists.reduce(function (x, y) {
	    return x.concat(y);
	  }, []);
	};
	var from = function from(list) {
	  if (!list.length) {
	    return [];
	  }
	
	  var result = [];
	
	  for (var i = 0; i < list.length; i++) {
	    result.push(list[i]);
	  }
	
	  return result;
	};
	var findIndexes = function findIndexes(l, key) {
	  return l.reduce(function (a, e, i) {
	    if (e[key]) {
	      a.push(i);
	    }
	
	    return a;
	  }, []);
	};
	/**
	 * Returns the first index that satisfies the matching function, or -1 if not found.
	 *
	 * Only necessary because of IE11 support.
	 *
	 * @param {Array} list - the list to search through
	 * @param {Function} matchingFunction - the matching function
	 *
	 * @return {number} the matching index or -1 if not found
	 */
	
	var findIndex = function findIndex(list, matchingFunction) {
	  for (var i = 0; i < list.length; i++) {
	    if (matchingFunction(list[i])) {
	      return i;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Returns a union of the included lists provided each element can be identified by a key.
	 *
	 * @param {Array} list - list of lists to get the union of
	 * @param {Function} keyFunction - the function to use as a key for each element
	 *
	 * @return {Array} the union of the arrays
	 */
	
	var union = function union(lists, keyFunction) {
	  return values(lists.reduce(function (acc, list) {
	    list.forEach(function (el) {
	      acc[keyFunction(el)] = el;
	    });
	    return acc;
	  }, {}));
	};
	
	var errors = {
	  INVALID_NUMBER_OF_PERIOD: 'INVALID_NUMBER_OF_PERIOD',
	  DASH_EMPTY_MANIFEST: 'DASH_EMPTY_MANIFEST',
	  DASH_INVALID_XML: 'DASH_INVALID_XML',
	  NO_BASE_URL: 'NO_BASE_URL',
	  MISSING_SEGMENT_INFORMATION: 'MISSING_SEGMENT_INFORMATION',
	  SEGMENT_TIME_UNSPECIFIED: 'SEGMENT_TIME_UNSPECIFIED',
	  UNSUPPORTED_UTC_TIMING_SCHEME: 'UNSUPPORTED_UTC_TIMING_SCHEME'
	};
	
	/**
	 * @typedef {Object} SingleUri
	 * @property {string} uri - relative location of segment
	 * @property {string} resolvedUri - resolved location of segment
	 * @property {Object} byterange - Object containing information on how to make byte range
	 *   requests following byte-range-spec per RFC2616.
	 * @property {String} byterange.length - length of range request
	 * @property {String} byterange.offset - byte offset of range request
	 *
	 * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.35.1
	 */
	
	/**
	 * Converts a URLType node (5.3.9.2.3 Table 13) to a segment object
	 * that conforms to how m3u8-parser is structured
	 *
	 * @see https://github.com/videojs/m3u8-parser
	 *
	 * @param {string} baseUrl - baseUrl provided by <BaseUrl> nodes
	 * @param {string} source - source url for segment
	 * @param {string} range - optional range used for range calls,
	 *   follows  RFC 2616, Clause 14.35.1
	 * @return {SingleUri} full segment information transformed into a format similar
	 *   to m3u8-parser
	 */
	
	var urlTypeToSegment = function urlTypeToSegment(_ref) {
	  var _ref$baseUrl = _ref.baseUrl,
	      baseUrl = _ref$baseUrl === void 0 ? '' : _ref$baseUrl,
	      _ref$source = _ref.source,
	      source = _ref$source === void 0 ? '' : _ref$source,
	      _ref$range = _ref.range,
	      range = _ref$range === void 0 ? '' : _ref$range,
	      _ref$indexRange = _ref.indexRange,
	      indexRange = _ref$indexRange === void 0 ? '' : _ref$indexRange;
	  var segment = {
	    uri: source,
	    resolvedUri: resolveUrl__default['default'](baseUrl || '', source)
	  };
	
	  if (range || indexRange) {
	    var rangeStr = range ? range : indexRange;
	    var ranges = rangeStr.split('-'); // default to parsing this as a BigInt if possible
	
	    var startRange = window__default['default'].BigInt ? window__default['default'].BigInt(ranges[0]) : parseInt(ranges[0], 10);
	    var endRange = window__default['default'].BigInt ? window__default['default'].BigInt(ranges[1]) : parseInt(ranges[1], 10); // convert back to a number if less than MAX_SAFE_INTEGER
	
	    if (startRange < Number.MAX_SAFE_INTEGER && typeof startRange === 'bigint') {
	      startRange = Number(startRange);
	    }
	
	    if (endRange < Number.MAX_SAFE_INTEGER && typeof endRange === 'bigint') {
	      endRange = Number(endRange);
	    }
	
	    var length;
	
	    if (typeof endRange === 'bigint' || typeof startRange === 'bigint') {
	      length = window__default['default'].BigInt(endRange) - window__default['default'].BigInt(startRange) + window__default['default'].BigInt(1);
	    } else {
	      length = endRange - startRange + 1;
	    }
	
	    if (typeof length === 'bigint' && length < Number.MAX_SAFE_INTEGER) {
	      length = Number(length);
	    } // byterange should be inclusive according to
	    // RFC 2616, Clause 14.35.1
	
	
	    segment.byterange = {
	      length: length,
	      offset: startRange
	    };
	  }
	
	  return segment;
	};
	var byteRangeToString = function byteRangeToString(byterange) {
	  // `endRange` is one less than `offset + length` because the HTTP range
	  // header uses inclusive ranges
	  var endRange;
	
	  if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') {
	    endRange = window__default['default'].BigInt(byterange.offset) + window__default['default'].BigInt(byterange.length) - window__default['default'].BigInt(1);
	  } else {
	    endRange = byterange.offset + byterange.length - 1;
	  }
	
	  return byterange.offset + "-" + endRange;
	};
	
	/**
	 * parse the end number attribue that can be a string
	 * number, or undefined.
	 *
	 * @param {string|number|undefined} endNumber
	 *        The end number attribute.
	 *
	 * @return {number|null}
	 *          The result of parsing the end number.
	 */
	
	var parseEndNumber = function parseEndNumber(endNumber) {
	  if (endNumber && typeof endNumber !== 'number') {
	    endNumber = parseInt(endNumber, 10);
	  }
	
	  if (isNaN(endNumber)) {
	    return null;
	  }
	
	  return endNumber;
	};
	/**
	 * Functions for calculating the range of available segments in static and dynamic
	 * manifests.
	 */
	
	
	var segmentRange = {
	  /**
	   * Returns the entire range of available segments for a static MPD
	   *
	   * @param {Object} attributes
	   *        Inheritied MPD attributes
	   * @return {{ start: number, end: number }}
	   *         The start and end numbers for available segments
	   */
	  static: function _static(attributes) {
	    var duration = attributes.duration,
	        _attributes$timescale = attributes.timescale,
	        timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
	        sourceDuration = attributes.sourceDuration,
	        periodDuration = attributes.periodDuration;
	    var endNumber = parseEndNumber(attributes.endNumber);
	    var segmentDuration = duration / timescale;
	
	    if (typeof endNumber === 'number') {
	      return {
	        start: 0,
	        end: endNumber
	      };
	    }
	
	    if (typeof periodDuration === 'number') {
	      return {
	        start: 0,
	        end: periodDuration / segmentDuration
	      };
	    }
	
	    return {
	      start: 0,
	      end: sourceDuration / segmentDuration
	    };
	  },
	
	  /**
	   * Returns the current live window range of available segments for a dynamic MPD
	   *
	   * @param {Object} attributes
	   *        Inheritied MPD attributes
	   * @return {{ start: number, end: number }}
	   *         The start and end numbers for available segments
	   */
	  dynamic: function dynamic(attributes) {
	    var NOW = attributes.NOW,
	        clientOffset = attributes.clientOffset,
	        availabilityStartTime = attributes.availabilityStartTime,
	        _attributes$timescale2 = attributes.timescale,
	        timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
	        duration = attributes.duration,
	        _attributes$periodSta = attributes.periodStart,
	        periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
	        _attributes$minimumUp = attributes.minimumUpdatePeriod,
	        minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp,
	        _attributes$timeShift = attributes.timeShiftBufferDepth,
	        timeShiftBufferDepth = _attributes$timeShift === void 0 ? Infinity : _attributes$timeShift;
	    var endNumber = parseEndNumber(attributes.endNumber); // clientOffset is passed in at the top level of mpd-parser and is an offset calculated
	    // after retrieving UTC server time.
	
	    var now = (NOW + clientOffset) / 1000; // WC stands for Wall Clock.
	    // Convert the period start time to EPOCH.
	
	    var periodStartWC = availabilityStartTime + periodStart; // Period end in EPOCH is manifest's retrieval time + time until next update.
	
	    var periodEndWC = now + minimumUpdatePeriod;
	    var periodDuration = periodEndWC - periodStartWC;
	    var segmentCount = Math.ceil(periodDuration * timescale / duration);
	    var availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth) * timescale / duration);
	    var availableEnd = Math.floor((now - periodStartWC) * timescale / duration);
	    return {
	      start: Math.max(0, availableStart),
	      end: typeof endNumber === 'number' ? endNumber : Math.min(segmentCount, availableEnd)
	    };
	  }
	};
	/**
	 * Maps a range of numbers to objects with information needed to build the corresponding
	 * segment list
	 *
	 * @name toSegmentsCallback
	 * @function
	 * @param {number} number
	 *        Number of the segment
	 * @param {number} index
	 *        Index of the number in the range list
	 * @return {{ number: Number, duration: Number, timeline: Number, time: Number }}
	 *         Object with segment timing and duration info
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping a range of numbers to
	 * information needed to build the segment list.
	 *
	 * @param {Object} attributes
	 *        Inherited MPD attributes
	 * @return {toSegmentsCallback}
	 *         Callback map function
	 */
	
	var toSegments = function toSegments(attributes) {
	  return function (number) {
	    var duration = attributes.duration,
	        _attributes$timescale3 = attributes.timescale,
	        timescale = _attributes$timescale3 === void 0 ? 1 : _attributes$timescale3,
	        periodStart = attributes.periodStart,
	        _attributes$startNumb = attributes.startNumber,
	        startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb;
	    return {
	      number: startNumber + number,
	      duration: duration / timescale,
	      timeline: periodStart,
	      time: number * duration
	    };
	  };
	};
	/**
	 * Returns a list of objects containing segment timing and duration info used for
	 * building the list of segments. This uses the @duration attribute specified
	 * in the MPD manifest to derive the range of segments.
	 *
	 * @param {Object} attributes
	 *        Inherited MPD attributes
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	
	var parseByDuration = function parseByDuration(attributes) {
	  var type = attributes.type,
	      duration = attributes.duration,
	      _attributes$timescale4 = attributes.timescale,
	      timescale = _attributes$timescale4 === void 0 ? 1 : _attributes$timescale4,
	      periodDuration = attributes.periodDuration,
	      sourceDuration = attributes.sourceDuration;
	
	  var _segmentRange$type = segmentRange[type](attributes),
	      start = _segmentRange$type.start,
	      end = _segmentRange$type.end;
	
	  var segments = range(start, end).map(toSegments(attributes));
	
	  if (type === 'static') {
	    var index = segments.length - 1; // section is either a period or the full source
	
	    var sectionDuration = typeof periodDuration === 'number' ? periodDuration : sourceDuration; // final segment may be less than full segment duration
	
	    segments[index].duration = sectionDuration - duration / timescale * index;
	  }
	
	  return segments;
	};
	
	/**
	 * Translates SegmentBase into a set of segments.
	 * (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
	 * node should be translated into segment.
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @return {Object.<Array>} list of segments
	 */
	
	var segmentsFromBase = function segmentsFromBase(attributes) {
	  var baseUrl = attributes.baseUrl,
	      _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ,
	      sourceDuration = attributes.sourceDuration,
	      _attributes$indexRang = attributes.indexRange,
	      indexRange = _attributes$indexRang === void 0 ? '' : _attributes$indexRang,
	      periodStart = attributes.periodStart,
	      presentationTime = attributes.presentationTime,
	      _attributes$number = attributes.number,
	      number = _attributes$number === void 0 ? 0 : _attributes$number,
	      duration = attributes.duration; // base url is required for SegmentBase to work, per spec (Section 5.3.9.2.1)
	
	  if (!baseUrl) {
	    throw new Error(errors.NO_BASE_URL);
	  }
	
	  var initSegment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: initialization.sourceURL,
	    range: initialization.range
	  });
	  var segment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: baseUrl,
	    indexRange: indexRange
	  });
	  segment.map = initSegment; // If there is a duration, use it, otherwise use the given duration of the source
	  // (since SegmentBase is only for one total segment)
	
	  if (duration) {
	    var segmentTimeInfo = parseByDuration(attributes);
	
	    if (segmentTimeInfo.length) {
	      segment.duration = segmentTimeInfo[0].duration;
	      segment.timeline = segmentTimeInfo[0].timeline;
	    }
	  } else if (sourceDuration) {
	    segment.duration = sourceDuration;
	    segment.timeline = periodStart;
	  } // If presentation time is provided, these segments are being generated by SIDX
	  // references, and should use the time provided. For the general case of SegmentBase,
	  // there should only be one segment in the period, so its presentation time is the same
	  // as its period start.
	
	
	  segment.presentationTime = presentationTime || periodStart;
	  segment.number = number;
	  return [segment];
	};
	/**
	 * Given a playlist, a sidx box, and a baseUrl, update the segment list of the playlist
	 * according to the sidx information given.
	 *
	 * playlist.sidx has metadadata about the sidx where-as the sidx param
	 * is the parsed sidx box itself.
	 *
	 * @param {Object} playlist the playlist to update the sidx information for
	 * @param {Object} sidx the parsed sidx box
	 * @return {Object} the playlist object with the updated sidx information
	 */
	
	var addSidxSegmentsToPlaylist$1 = function addSidxSegmentsToPlaylist(playlist, sidx, baseUrl) {
	  // Retain init segment information
	  var initSegment = playlist.sidx.map ? playlist.sidx.map : null; // Retain source duration from initial main manifest parsing
	
	  var sourceDuration = playlist.sidx.duration; // Retain source timeline
	
	  var timeline = playlist.timeline || 0;
	  var sidxByteRange = playlist.sidx.byterange;
	  var sidxEnd = sidxByteRange.offset + sidxByteRange.length; // Retain timescale of the parsed sidx
	
	  var timescale = sidx.timescale; // referenceType 1 refers to other sidx boxes
	
	  var mediaReferences = sidx.references.filter(function (r) {
	    return r.referenceType !== 1;
	  });
	  var segments = [];
	  var type = playlist.endList ? 'static' : 'dynamic';
	  var periodStart = playlist.sidx.timeline;
	  var presentationTime = periodStart;
	  var number = playlist.mediaSequence || 0; // firstOffset is the offset from the end of the sidx box
	
	  var startIndex; // eslint-disable-next-line
	
	  if (typeof sidx.firstOffset === 'bigint') {
	    startIndex = window__default['default'].BigInt(sidxEnd) + sidx.firstOffset;
	  } else {
	    startIndex = sidxEnd + sidx.firstOffset;
	  }
	
	  for (var i = 0; i < mediaReferences.length; i++) {
	    var reference = sidx.references[i]; // size of the referenced (sub)segment
	
	    var size = reference.referencedSize; // duration of the referenced (sub)segment, in  the  timescale
	    // this will be converted to seconds when generating segments
	
	    var duration = reference.subsegmentDuration; // should be an inclusive range
	
	    var endIndex = void 0; // eslint-disable-next-line
	
	    if (typeof startIndex === 'bigint') {
	      endIndex = startIndex + window__default['default'].BigInt(size) - window__default['default'].BigInt(1);
	    } else {
	      endIndex = startIndex + size - 1;
	    }
	
	    var indexRange = startIndex + "-" + endIndex;
	    var attributes = {
	      baseUrl: baseUrl,
	      timescale: timescale,
	      timeline: timeline,
	      periodStart: periodStart,
	      presentationTime: presentationTime,
	      number: number,
	      duration: duration,
	      sourceDuration: sourceDuration,
	      indexRange: indexRange,
	      type: type
	    };
	    var segment = segmentsFromBase(attributes)[0];
	
	    if (initSegment) {
	      segment.map = initSegment;
	    }
	
	    segments.push(segment);
	
	    if (typeof startIndex === 'bigint') {
	      startIndex += window__default['default'].BigInt(size);
	    } else {
	      startIndex += size;
	    }
	
	    presentationTime += duration / timescale;
	    number++;
	  }
	
	  playlist.segments = segments;
	  return playlist;
	};
	
	var SUPPORTED_MEDIA_TYPES = ['AUDIO', 'SUBTITLES']; // allow one 60fps frame as leniency (arbitrarily chosen)
	
	var TIME_FUDGE = 1 / 60;
	/**
	 * Given a list of timelineStarts, combines, dedupes, and sorts them.
	 *
	 * @param {TimelineStart[]} timelineStarts - list of timeline starts
	 *
	 * @return {TimelineStart[]} the combined and deduped timeline starts
	 */
	
	var getUniqueTimelineStarts = function getUniqueTimelineStarts(timelineStarts) {
	  return union(timelineStarts, function (_ref) {
	    var timeline = _ref.timeline;
	    return timeline;
	  }).sort(function (a, b) {
	    return a.timeline > b.timeline ? 1 : -1;
	  });
	};
	/**
	 * Finds the playlist with the matching NAME attribute.
	 *
	 * @param {Array} playlists - playlists to search through
	 * @param {string} name - the NAME attribute to search for
	 *
	 * @return {Object|null} the matching playlist object, or null
	 */
	
	var findPlaylistWithName = function findPlaylistWithName(playlists, name) {
	  for (var i = 0; i < playlists.length; i++) {
	    if (playlists[i].attributes.NAME === name) {
	      return playlists[i];
	    }
	  }
	
	  return null;
	};
	/**
	 * Gets a flattened array of media group playlists.
	 *
	 * @param {Object} manifest - the main manifest object
	 *
	 * @return {Array} the media group playlists
	 */
	
	var getMediaGroupPlaylists = function getMediaGroupPlaylists(manifest) {
	  var mediaGroupPlaylists = [];
	  mediaGroups.forEachMediaGroup(manifest, SUPPORTED_MEDIA_TYPES, function (properties, type, group, label) {
	    mediaGroupPlaylists = mediaGroupPlaylists.concat(properties.playlists || []);
	  });
	  return mediaGroupPlaylists;
	};
	/**
	 * Updates the playlist's media sequence numbers.
	 *
	 * @param {Object} config - options object
	 * @param {Object} config.playlist - the playlist to update
	 * @param {number} config.mediaSequence - the mediaSequence number to start with
	 */
	
	var updateMediaSequenceForPlaylist = function updateMediaSequenceForPlaylist(_ref2) {
	  var playlist = _ref2.playlist,
	      mediaSequence = _ref2.mediaSequence;
	  playlist.mediaSequence = mediaSequence;
	  playlist.segments.forEach(function (segment, index) {
	    segment.number = playlist.mediaSequence + index;
	  });
	};
	/**
	 * Updates the media and discontinuity sequence numbers of newPlaylists given oldPlaylists
	 * and a complete list of timeline starts.
	 *
	 * If no matching playlist is found, only the discontinuity sequence number of the playlist
	 * will be updated.
	 *
	 * Since early available timelines are not supported, at least one segment must be present.
	 *
	 * @param {Object} config - options object
	 * @param {Object[]} oldPlaylists - the old playlists to use as a reference
	 * @param {Object[]} newPlaylists - the new playlists to update
	 * @param {Object} timelineStarts - all timelineStarts seen in the stream to this point
	 */
	
	var updateSequenceNumbers = function updateSequenceNumbers(_ref3) {
	  var oldPlaylists = _ref3.oldPlaylists,
	      newPlaylists = _ref3.newPlaylists,
	      timelineStarts = _ref3.timelineStarts;
	  newPlaylists.forEach(function (playlist) {
	    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref4) {
	      var timeline = _ref4.timeline;
	      return timeline === playlist.timeline;
	    }); // Playlists NAMEs come from DASH Representation IDs, which are mandatory
	    // (see ISO_23009-1-2012 5.3.5.2).
	    //
	    // If the same Representation existed in a prior Period, it will retain the same NAME.
	
	    var oldPlaylist = findPlaylistWithName(oldPlaylists, playlist.attributes.NAME);
	
	    if (!oldPlaylist) {
	      // Since this is a new playlist, the media sequence values can start from 0 without
	      // consequence.
	      return;
	    } // TODO better support for live SIDX
	    //
	    // As of this writing, mpd-parser does not support multiperiod SIDX (in live or VOD).
	    // This is evident by a playlist only having a single SIDX reference. In a multiperiod
	    // playlist there would need to be multiple SIDX references. In addition, live SIDX is
	    // not supported when the SIDX properties change on refreshes.
	    //
	    // In the future, if support needs to be added, the merging logic here can be called
	    // after SIDX references are resolved. For now, exit early to prevent exceptions being
	    // thrown due to undefined references.
	
	
	    if (playlist.sidx) {
	      return;
	    } // Since we don't yet support early available timelines, we don't need to support
	    // playlists with no segments.
	
	
	    var firstNewSegment = playlist.segments[0];
	    var oldMatchingSegmentIndex = findIndex(oldPlaylist.segments, function (oldSegment) {
	      return Math.abs(oldSegment.presentationTime - firstNewSegment.presentationTime) < TIME_FUDGE;
	    }); // No matching segment from the old playlist means the entire playlist was refreshed.
	    // In this case the media sequence should account for this update, and the new segments
	    // should be marked as discontinuous from the prior content, since the last prior
	    // timeline was removed.
	
	    if (oldMatchingSegmentIndex === -1) {
	      updateMediaSequenceForPlaylist({
	        playlist: playlist,
	        mediaSequence: oldPlaylist.mediaSequence + oldPlaylist.segments.length
	      });
	      playlist.segments[0].discontinuity = true;
	      playlist.discontinuityStarts.unshift(0); // No matching segment does not necessarily mean there's missing content.
	      //
	      // If the new playlist's timeline is the same as the last seen segment's timeline,
	      // then a discontinuity can be added to identify that there's potentially missing
	      // content. If there's no missing content, the discontinuity should still be rather
	      // harmless. It's possible that if segment durations are accurate enough, that the
	      // existence of a gap can be determined using the presentation times and durations,
	      // but if the segment timing info is off, it may introduce more problems than simply
	      // adding the discontinuity.
	      //
	      // If the new playlist's timeline is different from the last seen segment's timeline,
	      // then a discontinuity can be added to identify that this is the first seen segment
	      // of a new timeline. However, the logic at the start of this function that
	      // determined the disconinuity sequence by timeline index is now off by one (the
	      // discontinuity of the newest timeline hasn't yet fallen off the manifest...since
	      // we added it), so the disconinuity sequence must be decremented.
	      //
	      // A period may also have a duration of zero, so the case of no segments is handled
	      // here even though we don't yet support early available periods.
	
	      if (!oldPlaylist.segments.length && playlist.timeline > oldPlaylist.timeline || oldPlaylist.segments.length && playlist.timeline > oldPlaylist.segments[oldPlaylist.segments.length - 1].timeline) {
	        playlist.discontinuitySequence--;
	      }
	
	      return;
	    } // If the first segment matched with a prior segment on a discontinuity (it's matching
	    // on the first segment of a period), then the discontinuitySequence shouldn't be the
	    // timeline's matching one, but instead should be the one prior, and the first segment
	    // of the new manifest should be marked with a discontinuity.
	    //
	    // The reason for this special case is that discontinuity sequence shows how many
	    // discontinuities have fallen off of the playlist, and discontinuities are marked on
	    // the first segment of a new "timeline." Because of this, while DASH will retain that
	    // Period while the "timeline" exists, HLS keeps track of it via the discontinuity
	    // sequence, and that first segment is an indicator, but can be removed before that
	    // timeline is gone.
	
	
	    var oldMatchingSegment = oldPlaylist.segments[oldMatchingSegmentIndex];
	
	    if (oldMatchingSegment.discontinuity && !firstNewSegment.discontinuity) {
	      firstNewSegment.discontinuity = true;
	      playlist.discontinuityStarts.unshift(0);
	      playlist.discontinuitySequence--;
	    }
	
	    updateMediaSequenceForPlaylist({
	      playlist: playlist,
	      mediaSequence: oldPlaylist.segments[oldMatchingSegmentIndex].number
	    });
	  });
	};
	/**
	 * Given an old parsed manifest object and a new parsed manifest object, updates the
	 * sequence and timing values within the new manifest to ensure that it lines up with the
	 * old.
	 *
	 * @param {Array} oldManifest - the old main manifest object
	 * @param {Array} newManifest - the new main manifest object
	 *
	 * @return {Object} the updated new manifest object
	 */
	
	var positionManifestOnTimeline = function positionManifestOnTimeline(_ref5) {
	  var oldManifest = _ref5.oldManifest,
	      newManifest = _ref5.newManifest;
	  // Starting from v4.1.2 of the IOP, section 4.4.3.3 states:
	  //
	  // "MPD@availabilityStartTime and Period@start shall not be changed over MPD updates."
	  //
	  // This was added from https://github.com/Dash-Industry-Forum/DASH-IF-IOP/issues/160
	  //
	  // Because of this change, and the difficulty of supporting periods with changing start
	  // times, periods with changing start times are not supported. This makes the logic much
	  // simpler, since periods with the same start time can be considerred the same period
	  // across refreshes.
	  //
	  // To give an example as to the difficulty of handling periods where the start time may
	  // change, if a single period manifest is refreshed with another manifest with a single
	  // period, and both the start and end times are increased, then the only way to determine
	  // if it's a new period or an old one that has changed is to look through the segments of
	  // each playlist and determine the presentation time bounds to find a match. In addition,
	  // if the period start changed to exceed the old period end, then there would be no
	  // match, and it would not be possible to determine whether the refreshed period is a new
	  // one or the old one.
	  var oldPlaylists = oldManifest.playlists.concat(getMediaGroupPlaylists(oldManifest));
	  var newPlaylists = newManifest.playlists.concat(getMediaGroupPlaylists(newManifest)); // Save all seen timelineStarts to the new manifest. Although this potentially means that
	  // there's a "memory leak" in that it will never stop growing, in reality, only a couple
	  // of properties are saved for each seen Period. Even long running live streams won't
	  // generate too many Periods, unless the stream is watched for decades. In the future,
	  // this can be optimized by mapping to discontinuity sequence numbers for each timeline,
	  // but it may not become an issue, and the additional info can be useful for debugging.
	
	  newManifest.timelineStarts = getUniqueTimelineStarts([oldManifest.timelineStarts, newManifest.timelineStarts]);
	  updateSequenceNumbers({
	    oldPlaylists: oldPlaylists,
	    newPlaylists: newPlaylists,
	    timelineStarts: newManifest.timelineStarts
	  });
	  return newManifest;
	};
	
	var generateSidxKey = function generateSidxKey(sidx) {
	  return sidx && sidx.uri + '-' + byteRangeToString(sidx.byterange);
	};
	
	var mergeDiscontiguousPlaylists = function mergeDiscontiguousPlaylists(playlists) {
	  var mergedPlaylists = values(playlists.reduce(function (acc, playlist) {
	    // assuming playlist IDs are the same across periods
	    // TODO: handle multiperiod where representation sets are not the same
	    // across periods
	    var name = playlist.attributes.id + (playlist.attributes.lang || '');
	
	    if (!acc[name]) {
	      // First Period
	      acc[name] = playlist;
	      acc[name].attributes.timelineStarts = [];
	    } else {
	      // Subsequent Periods
	      if (playlist.segments) {
	        var _acc$name$segments;
	
	        // first segment of subsequent periods signal a discontinuity
	        if (playlist.segments[0]) {
	          playlist.segments[0].discontinuity = true;
	        }
	
	        (_acc$name$segments = acc[name].segments).push.apply(_acc$name$segments, playlist.segments);
	      } // bubble up contentProtection, this assumes all DRM content
	      // has the same contentProtection
	
	
	      if (playlist.attributes.contentProtection) {
	        acc[name].attributes.contentProtection = playlist.attributes.contentProtection;
	      }
	    }
	
	    acc[name].attributes.timelineStarts.push({
	      // Although they represent the same number, it's important to have both to make it
	      // compatible with HLS potentially having a similar attribute.
	      start: playlist.attributes.periodStart,
	      timeline: playlist.attributes.periodStart
	    });
	    return acc;
	  }, {}));
	  return mergedPlaylists.map(function (playlist) {
	    playlist.discontinuityStarts = findIndexes(playlist.segments || [], 'discontinuity');
	    return playlist;
	  });
	};
	
	var addSidxSegmentsToPlaylist = function addSidxSegmentsToPlaylist(playlist, sidxMapping) {
	  var sidxKey = generateSidxKey(playlist.sidx);
	  var sidxMatch = sidxKey && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx;
	
	  if (sidxMatch) {
	    addSidxSegmentsToPlaylist$1(playlist, sidxMatch, playlist.sidx.resolvedUri);
	  }
	
	  return playlist;
	};
	var addSidxSegmentsToPlaylists = function addSidxSegmentsToPlaylists(playlists, sidxMapping) {
	  if (sidxMapping === void 0) {
	    sidxMapping = {};
	  }
	
	  if (!Object.keys(sidxMapping).length) {
	    return playlists;
	  }
	
	  for (var i in playlists) {
	    playlists[i] = addSidxSegmentsToPlaylist(playlists[i], sidxMapping);
	  }
	
	  return playlists;
	};
	var formatAudioPlaylist = function formatAudioPlaylist(_ref, isAudioOnly) {
	  var _attributes;
	
	  var attributes = _ref.attributes,
	      segments = _ref.segments,
	      sidx = _ref.sidx,
	      mediaSequence = _ref.mediaSequence,
	      discontinuitySequence = _ref.discontinuitySequence,
	      discontinuityStarts = _ref.discontinuityStarts;
	  var playlist = {
	    attributes: (_attributes = {
	      NAME: attributes.id,
	      BANDWIDTH: attributes.bandwidth,
	      CODECS: attributes.codecs
	    }, _attributes['PROGRAM-ID'] = 1, _attributes),
	    uri: '',
	    endList: attributes.type === 'static',
	    timeline: attributes.periodStart,
	    resolvedUri: '',
	    targetDuration: attributes.duration,
	    discontinuitySequence: discontinuitySequence,
	    discontinuityStarts: discontinuityStarts,
	    timelineStarts: attributes.timelineStarts,
	    mediaSequence: mediaSequence,
	    segments: segments
	  };
	
	  if (attributes.contentProtection) {
	    playlist.contentProtection = attributes.contentProtection;
	  }
	
	  if (sidx) {
	    playlist.sidx = sidx;
	  }
	
	  if (isAudioOnly) {
	    playlist.attributes.AUDIO = 'audio';
	    playlist.attributes.SUBTITLES = 'subs';
	  }
	
	  return playlist;
	};
	var formatVttPlaylist = function formatVttPlaylist(_ref2) {
	  var _m3u8Attributes;
	
	  var attributes = _ref2.attributes,
	      segments = _ref2.segments,
	      mediaSequence = _ref2.mediaSequence,
	      discontinuityStarts = _ref2.discontinuityStarts,
	      discontinuitySequence = _ref2.discontinuitySequence;
	
	  if (typeof segments === 'undefined') {
	    // vtt tracks may use single file in BaseURL
	    segments = [{
	      uri: attributes.baseUrl,
	      timeline: attributes.periodStart,
	      resolvedUri: attributes.baseUrl || '',
	      duration: attributes.sourceDuration,
	      number: 0
	    }]; // targetDuration should be the same duration as the only segment
	
	    attributes.duration = attributes.sourceDuration;
	  }
	
	  var m3u8Attributes = (_m3u8Attributes = {
	    NAME: attributes.id,
	    BANDWIDTH: attributes.bandwidth
	  }, _m3u8Attributes['PROGRAM-ID'] = 1, _m3u8Attributes);
	
	  if (attributes.codecs) {
	    m3u8Attributes.CODECS = attributes.codecs;
	  }
	
	  return {
	    attributes: m3u8Attributes,
	    uri: '',
	    endList: attributes.type === 'static',
	    timeline: attributes.periodStart,
	    resolvedUri: attributes.baseUrl || '',
	    targetDuration: attributes.duration,
	    timelineStarts: attributes.timelineStarts,
	    discontinuityStarts: discontinuityStarts,
	    discontinuitySequence: discontinuitySequence,
	    mediaSequence: mediaSequence,
	    segments: segments
	  };
	};
	var organizeAudioPlaylists = function organizeAudioPlaylists(playlists, sidxMapping, isAudioOnly) {
	  if (sidxMapping === void 0) {
	    sidxMapping = {};
	  }
	
	  if (isAudioOnly === void 0) {
	    isAudioOnly = false;
	  }
	
	  var mainPlaylist;
	  var formattedPlaylists = playlists.reduce(function (a, playlist) {
	    var role = playlist.attributes.role && playlist.attributes.role.value || '';
	    var language = playlist.attributes.lang || '';
	    var label = playlist.attributes.label || 'main';
	
	    if (language && !playlist.attributes.label) {
	      var roleLabel = role ? " (" + role + ")" : '';
	      label = "" + playlist.attributes.lang + roleLabel;
	    }
	
	    if (!a[label]) {
	      a[label] = {
	        language: language,
	        autoselect: true,
	        default: role === 'main',
	        playlists: [],
	        uri: ''
	      };
	    }
	
	    var formatted = addSidxSegmentsToPlaylist(formatAudioPlaylist(playlist, isAudioOnly), sidxMapping);
	    a[label].playlists.push(formatted);
	
	    if (typeof mainPlaylist === 'undefined' && role === 'main') {
	      mainPlaylist = playlist;
	      mainPlaylist.default = true;
	    }
	
	    return a;
	  }, {}); // if no playlists have role "main", mark the first as main
	
	  if (!mainPlaylist) {
	    var firstLabel = Object.keys(formattedPlaylists)[0];
	    formattedPlaylists[firstLabel].default = true;
	  }
	
	  return formattedPlaylists;
	};
	var organizeVttPlaylists = function organizeVttPlaylists(playlists, sidxMapping) {
	  if (sidxMapping === void 0) {
	    sidxMapping = {};
	  }
	
	  return playlists.reduce(function (a, playlist) {
	    var label = playlist.attributes.lang || 'text';
	
	    if (!a[label]) {
	      a[label] = {
	        language: label,
	        default: false,
	        autoselect: false,
	        playlists: [],
	        uri: ''
	      };
	    }
	
	    a[label].playlists.push(addSidxSegmentsToPlaylist(formatVttPlaylist(playlist), sidxMapping));
	    return a;
	  }, {});
	};
	
	var organizeCaptionServices = function organizeCaptionServices(captionServices) {
	  return captionServices.reduce(function (svcObj, svc) {
	    if (!svc) {
	      return svcObj;
	    }
	
	    svc.forEach(function (service) {
	      var channel = service.channel,
	          language = service.language;
	      svcObj[language] = {
	        autoselect: false,
	        default: false,
	        instreamId: channel,
	        language: language
	      };
	
	      if (service.hasOwnProperty('aspectRatio')) {
	        svcObj[language].aspectRatio = service.aspectRatio;
	      }
	
	      if (service.hasOwnProperty('easyReader')) {
	        svcObj[language].easyReader = service.easyReader;
	      }
	
	      if (service.hasOwnProperty('3D')) {
	        svcObj[language]['3D'] = service['3D'];
	      }
	    });
	    return svcObj;
	  }, {});
	};
	
	var formatVideoPlaylist = function formatVideoPlaylist(_ref3) {
	  var _attributes2;
	
	  var attributes = _ref3.attributes,
	      segments = _ref3.segments,
	      sidx = _ref3.sidx,
	      discontinuityStarts = _ref3.discontinuityStarts;
	  var playlist = {
	    attributes: (_attributes2 = {
	      NAME: attributes.id,
	      AUDIO: 'audio',
	      SUBTITLES: 'subs',
	      RESOLUTION: {
	        width: attributes.width,
	        height: attributes.height
	      },
	      CODECS: attributes.codecs,
	      BANDWIDTH: attributes.bandwidth
	    }, _attributes2['PROGRAM-ID'] = 1, _attributes2),
	    uri: '',
	    endList: attributes.type === 'static',
	    timeline: attributes.periodStart,
	    resolvedUri: '',
	    targetDuration: attributes.duration,
	    discontinuityStarts: discontinuityStarts,
	    timelineStarts: attributes.timelineStarts,
	    segments: segments
	  };
	
	  if (attributes.frameRate) {
	    playlist.attributes['FRAME-RATE'] = attributes.frameRate;
	  }
	
	  if (attributes.contentProtection) {
	    playlist.contentProtection = attributes.contentProtection;
	  }
	
	  if (sidx) {
	    playlist.sidx = sidx;
	  }
	
	  return playlist;
	};
	
	var videoOnly = function videoOnly(_ref4) {
	  var attributes = _ref4.attributes;
	  return attributes.mimeType === 'video/mp4' || attributes.mimeType === 'video/webm' || attributes.contentType === 'video';
	};
	
	var audioOnly = function audioOnly(_ref5) {
	  var attributes = _ref5.attributes;
	  return attributes.mimeType === 'audio/mp4' || attributes.mimeType === 'audio/webm' || attributes.contentType === 'audio';
	};
	
	var vttOnly = function vttOnly(_ref6) {
	  var attributes = _ref6.attributes;
	  return attributes.mimeType === 'text/vtt' || attributes.contentType === 'text';
	};
	/**
	 * Contains start and timeline properties denoting a timeline start. For DASH, these will
	 * be the same number.
	 *
	 * @typedef {Object} TimelineStart
	 * @property {number} start - the start time of the timeline
	 * @property {number} timeline - the timeline number
	 */
	
	/**
	 * Adds appropriate media and discontinuity sequence values to the segments and playlists.
	 *
	 * Throughout mpd-parser, the `number` attribute is used in relation to `startNumber`, a
	 * DASH specific attribute used in constructing segment URI's from templates. However, from
	 * an HLS perspective, the `number` attribute on a segment would be its `mediaSequence`
	 * value, which should start at the original media sequence value (or 0) and increment by 1
	 * for each segment thereafter. Since DASH's `startNumber` values are independent per
	 * period, it doesn't make sense to use it for `number`. Instead, assume everything starts
	 * from a 0 mediaSequence value and increment from there.
	 *
	 * Note that VHS currently doesn't use the `number` property, but it can be helpful for
	 * debugging and making sense of the manifest.
	 *
	 * For live playlists, to account for values increasing in manifests when periods are
	 * removed on refreshes, merging logic should be used to update the numbers to their
	 * appropriate values (to ensure they're sequential and increasing).
	 *
	 * @param {Object[]} playlists - the playlists to update
	 * @param {TimelineStart[]} timelineStarts - the timeline starts for the manifest
	 */
	
	
	var addMediaSequenceValues = function addMediaSequenceValues(playlists, timelineStarts) {
	  // increment all segments sequentially
	  playlists.forEach(function (playlist) {
	    playlist.mediaSequence = 0;
	    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref7) {
	      var timeline = _ref7.timeline;
	      return timeline === playlist.timeline;
	    });
	
	    if (!playlist.segments) {
	      return;
	    }
	
	    playlist.segments.forEach(function (segment, index) {
	      segment.number = index;
	    });
	  });
	};
	/**
	 * Given a media group object, flattens all playlists within the media group into a single
	 * array.
	 *
	 * @param {Object} mediaGroupObject - the media group object
	 *
	 * @return {Object[]}
	 *         The media group playlists
	 */
	
	var flattenMediaGroupPlaylists = function flattenMediaGroupPlaylists(mediaGroupObject) {
	  if (!mediaGroupObject) {
	    return [];
	  }
	
	  return Object.keys(mediaGroupObject).reduce(function (acc, label) {
	    var labelContents = mediaGroupObject[label];
	    return acc.concat(labelContents.playlists);
	  }, []);
	};
	var toM3u8 = function toM3u8(_ref8) {
	  var _mediaGroups;
	
	  var dashPlaylists = _ref8.dashPlaylists,
	      locations = _ref8.locations,
	      _ref8$sidxMapping = _ref8.sidxMapping,
	      sidxMapping = _ref8$sidxMapping === void 0 ? {} : _ref8$sidxMapping,
	      previousManifest = _ref8.previousManifest;
	
	  if (!dashPlaylists.length) {
	    return {};
	  } // grab all main manifest attributes
	
	
	  var _dashPlaylists$0$attr = dashPlaylists[0].attributes,
	      duration = _dashPlaylists$0$attr.sourceDuration,
	      type = _dashPlaylists$0$attr.type,
	      suggestedPresentationDelay = _dashPlaylists$0$attr.suggestedPresentationDelay,
	      minimumUpdatePeriod = _dashPlaylists$0$attr.minimumUpdatePeriod;
	  var videoPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(videoOnly)).map(formatVideoPlaylist);
	  var audioPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(audioOnly));
	  var vttPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(vttOnly));
	  var captions = dashPlaylists.map(function (playlist) {
	    return playlist.attributes.captionServices;
	  }).filter(Boolean);
	  var manifest = {
	    allowCache: true,
	    discontinuityStarts: [],
	    segments: [],
	    endList: true,
	    mediaGroups: (_mediaGroups = {
	      AUDIO: {},
	      VIDEO: {}
	    }, _mediaGroups['CLOSED-CAPTIONS'] = {}, _mediaGroups.SUBTITLES = {}, _mediaGroups),
	    uri: '',
	    duration: duration,
	    playlists: addSidxSegmentsToPlaylists(videoPlaylists, sidxMapping)
	  };
	
	  if (minimumUpdatePeriod >= 0) {
	    manifest.minimumUpdatePeriod = minimumUpdatePeriod * 1000;
	  }
	
	  if (locations) {
	    manifest.locations = locations;
	  }
	
	  if (type === 'dynamic') {
	    manifest.suggestedPresentationDelay = suggestedPresentationDelay;
	  }
	
	  var isAudioOnly = manifest.playlists.length === 0;
	  var organizedAudioGroup = audioPlaylists.length ? organizeAudioPlaylists(audioPlaylists, sidxMapping, isAudioOnly) : null;
	  var organizedVttGroup = vttPlaylists.length ? organizeVttPlaylists(vttPlaylists, sidxMapping) : null;
	  var formattedPlaylists = videoPlaylists.concat(flattenMediaGroupPlaylists(organizedAudioGroup), flattenMediaGroupPlaylists(organizedVttGroup));
	  var playlistTimelineStarts = formattedPlaylists.map(function (_ref9) {
	    var timelineStarts = _ref9.timelineStarts;
	    return timelineStarts;
	  });
	  manifest.timelineStarts = getUniqueTimelineStarts(playlistTimelineStarts);
	  addMediaSequenceValues(formattedPlaylists, manifest.timelineStarts);
	
	  if (organizedAudioGroup) {
	    manifest.mediaGroups.AUDIO.audio = organizedAudioGroup;
	  }
	
	  if (organizedVttGroup) {
	    manifest.mediaGroups.SUBTITLES.subs = organizedVttGroup;
	  }
	
	  if (captions.length) {
	    manifest.mediaGroups['CLOSED-CAPTIONS'].cc = organizeCaptionServices(captions);
	  }
	
	  if (previousManifest) {
	    return positionManifestOnTimeline({
	      oldManifest: previousManifest,
	      newManifest: manifest
	    });
	  }
	
	  return manifest;
	};
	
	/**
	 * Calculates the R (repetition) value for a live stream (for the final segment
	 * in a manifest where the r value is negative 1)
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {number} time
	 *        current time (typically the total time up until the final segment)
	 * @param {number} duration
	 *        duration property for the given <S />
	 *
	 * @return {number}
	 *        R value to reach the end of the given period
	 */
	var getLiveRValue = function getLiveRValue(attributes, time, duration) {
	  var NOW = attributes.NOW,
	      clientOffset = attributes.clientOffset,
	      availabilityStartTime = attributes.availabilityStartTime,
	      _attributes$timescale = attributes.timescale,
	      timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
	      _attributes$periodSta = attributes.periodStart,
	      periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
	      _attributes$minimumUp = attributes.minimumUpdatePeriod,
	      minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp;
	  var now = (NOW + clientOffset) / 1000;
	  var periodStartWC = availabilityStartTime + periodStart;
	  var periodEndWC = now + minimumUpdatePeriod;
	  var periodDuration = periodEndWC - periodStartWC;
	  return Math.ceil((periodDuration * timescale - time) / duration);
	};
	/**
	 * Uses information provided by SegmentTemplate.SegmentTimeline to determine segment
	 * timing and duration
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	
	
	var parseByTimeline = function parseByTimeline(attributes, segmentTimeline) {
	  var type = attributes.type,
	      _attributes$minimumUp2 = attributes.minimumUpdatePeriod,
	      minimumUpdatePeriod = _attributes$minimumUp2 === void 0 ? 0 : _attributes$minimumUp2,
	      _attributes$media = attributes.media,
	      media = _attributes$media === void 0 ? '' : _attributes$media,
	      sourceDuration = attributes.sourceDuration,
	      _attributes$timescale2 = attributes.timescale,
	      timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
	      _attributes$startNumb = attributes.startNumber,
	      startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb,
	      timeline = attributes.periodStart;
	  var segments = [];
	  var time = -1;
	
	  for (var sIndex = 0; sIndex < segmentTimeline.length; sIndex++) {
	    var S = segmentTimeline[sIndex];
	    var duration = S.d;
	    var repeat = S.r || 0;
	    var segmentTime = S.t || 0;
	
	    if (time < 0) {
	      // first segment
	      time = segmentTime;
	    }
	
	    if (segmentTime && segmentTime > time) {
	      // discontinuity
	      // TODO: How to handle this type of discontinuity
	      // timeline++ here would treat it like HLS discontuity and content would
	      // get appended without gap
	      // E.G.
	      //  <S t="0" d="1" />
	      //  <S d="1" />
	      //  <S d="1" />
	      //  <S t="5" d="1" />
	      // would have $Time$ values of [0, 1, 2, 5]
	      // should this be appened at time positions [0, 1, 2, 3],(#EXT-X-DISCONTINUITY)
	      // or [0, 1, 2, gap, gap, 5]? (#EXT-X-GAP)
	      // does the value of sourceDuration consider this when calculating arbitrary
	      // negative @r repeat value?
	      // E.G. Same elements as above with this added at the end
	      //  <S d="1" r="-1" />
	      //  with a sourceDuration of 10
	      // Would the 2 gaps be included in the time duration calculations resulting in
	      // 8 segments with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9] or 10 segments
	      // with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9, 10, 11] ?
	      time = segmentTime;
	    }
	
	    var count = void 0;
	
	    if (repeat < 0) {
	      var nextS = sIndex + 1;
	
	      if (nextS === segmentTimeline.length) {
	        // last segment
	        if (type === 'dynamic' && minimumUpdatePeriod > 0 && media.indexOf('$Number$') > 0) {
	          count = getLiveRValue(attributes, time, duration);
	        } else {
	          // TODO: This may be incorrect depending on conclusion of TODO above
	          count = (sourceDuration * timescale - time) / duration;
	        }
	      } else {
	        count = (segmentTimeline[nextS].t - time) / duration;
	      }
	    } else {
	      count = repeat + 1;
	    }
	
	    var end = startNumber + segments.length + count;
	    var number = startNumber + segments.length;
	
	    while (number < end) {
	      segments.push({
	        number: number,
	        duration: duration / timescale,
	        time: time,
	        timeline: timeline
	      });
	      time += duration;
	      number++;
	    }
	  }
	
	  return segments;
	};
	
	var identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
	/**
	 * Replaces template identifiers with corresponding values. To be used as the callback
	 * for String.prototype.replace
	 *
	 * @name replaceCallback
	 * @function
	 * @param {string} match
	 *        Entire match of identifier
	 * @param {string} identifier
	 *        Name of matched identifier
	 * @param {string} format
	 *        Format tag string. Its presence indicates that padding is expected
	 * @param {string} width
	 *        Desired length of the replaced value. Values less than this width shall be left
	 *        zero padded
	 * @return {string}
	 *         Replacement for the matched identifier
	 */
	
	/**
	 * Returns a function to be used as a callback for String.prototype.replace to replace
	 * template identifiers
	 *
	 * @param {Obect} values
	 *        Object containing values that shall be used to replace known identifiers
	 * @param {number} values.RepresentationID
	 *        Value of the Representation@id attribute
	 * @param {number} values.Number
	 *        Number of the corresponding segment
	 * @param {number} values.Bandwidth
	 *        Value of the Representation@bandwidth attribute.
	 * @param {number} values.Time
	 *        Timestamp value of the corresponding segment
	 * @return {replaceCallback}
	 *         Callback to be used with String.prototype.replace to replace identifiers
	 */
	
	var identifierReplacement = function identifierReplacement(values) {
	  return function (match, identifier, format, width) {
	    if (match === '$$') {
	      // escape sequence
	      return '$';
	    }
	
	    if (typeof values[identifier] === 'undefined') {
	      return match;
	    }
	
	    var value = '' + values[identifier];
	
	    if (identifier === 'RepresentationID') {
	      // Format tag shall not be present with RepresentationID
	      return value;
	    }
	
	    if (!format) {
	      width = 1;
	    } else {
	      width = parseInt(width, 10);
	    }
	
	    if (value.length >= width) {
	      return value;
	    }
	
	    return "" + new Array(width - value.length + 1).join('0') + value;
	  };
	};
	/**
	 * Constructs a segment url from a template string
	 *
	 * @param {string} url
	 *        Template string to construct url from
	 * @param {Obect} values
	 *        Object containing values that shall be used to replace known identifiers
	 * @param {number} values.RepresentationID
	 *        Value of the Representation@id attribute
	 * @param {number} values.Number
	 *        Number of the corresponding segment
	 * @param {number} values.Bandwidth
	 *        Value of the Representation@bandwidth attribute.
	 * @param {number} values.Time
	 *        Timestamp value of the corresponding segment
	 * @return {string}
	 *         Segment url with identifiers replaced
	 */
	
	var constructTemplateUrl = function constructTemplateUrl(url, values) {
	  return url.replace(identifierPattern, identifierReplacement(values));
	};
	/**
	 * Generates a list of objects containing timing and duration information about each
	 * segment needed to generate segment uris and the complete segment object
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {{number: number, duration: number, time: number, timeline: number}[]}
	 *         List of Objects with segment timing and duration info
	 */
	
	var parseTemplateInfo = function parseTemplateInfo(attributes, segmentTimeline) {
	  if (!attributes.duration && !segmentTimeline) {
	    // if neither @duration or SegmentTimeline are present, then there shall be exactly
	    // one media segment
	    return [{
	      number: attributes.startNumber || 1,
	      duration: attributes.sourceDuration,
	      time: 0,
	      timeline: attributes.periodStart
	    }];
	  }
	
	  if (attributes.duration) {
	    return parseByDuration(attributes);
	  }
	
	  return parseByTimeline(attributes, segmentTimeline);
	};
	/**
	 * Generates a list of segments using information provided by the SegmentTemplate element
	 *
	 * @param {Object} attributes
	 *        Object containing all inherited attributes from parent elements with attribute
	 *        names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {Object[]}
	 *         List of segment objects
	 */
	
	var segmentsFromTemplate = function segmentsFromTemplate(attributes, segmentTimeline) {
	  var templateValues = {
	    RepresentationID: attributes.id,
	    Bandwidth: attributes.bandwidth || 0
	  };
	  var _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === void 0 ? {
	    sourceURL: '',
	    range: ''
	  } : _attributes$initializ;
	  var mapSegment = urlTypeToSegment({
	    baseUrl: attributes.baseUrl,
	    source: constructTemplateUrl(initialization.sourceURL, templateValues),
	    range: initialization.range
	  });
	  var segments = parseTemplateInfo(attributes, segmentTimeline);
	  return segments.map(function (segment) {
	    templateValues.Number = segment.number;
	    templateValues.Time = segment.time;
	    var uri = constructTemplateUrl(attributes.media || '', templateValues); // See DASH spec section 5.3.9.2.2
	    // - if timescale isn't present on any level, default to 1.
	
	    var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
	
	    var presentationTimeOffset = attributes.presentationTimeOffset || 0;
	    var presentationTime = // Even if the @t attribute is not specified for the segment, segment.time is
	    // calculated in mpd-parser prior to this, so it's assumed to be available.
	    attributes.periodStart + (segment.time - presentationTimeOffset) / timescale;
	    var map = {
	      uri: uri,
	      timeline: segment.timeline,
	      duration: segment.duration,
	      resolvedUri: resolveUrl__default['default'](attributes.baseUrl || '', uri),
	      map: mapSegment,
	      number: segment.number,
	      presentationTime: presentationTime
	    };
	    return map;
	  });
	};
	
	/**
	 * Converts a <SegmentUrl> (of type URLType from the DASH spec 5.3.9.2 Table 14)
	 * to an object that matches the output of a segment in videojs/mpd-parser
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @param {Object} segmentUrl
	 *   <SegmentURL> node to translate into a segment object
	 * @return {Object} translated segment object
	 */
	
	var SegmentURLToSegmentObject = function SegmentURLToSegmentObject(attributes, segmentUrl) {
	  var baseUrl = attributes.baseUrl,
	      _attributes$initializ = attributes.initialization,
	      initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ;
	  var initSegment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: initialization.sourceURL,
	    range: initialization.range
	  });
	  var segment = urlTypeToSegment({
	    baseUrl: baseUrl,
	    source: segmentUrl.media,
	    range: segmentUrl.mediaRange
	  });
	  segment.map = initSegment;
	  return segment;
	};
	/**
	 * Generates a list of segments using information provided by the SegmentList element
	 * SegmentList (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
	 * node should be translated into segment.
	 *
	 * @param {Object} attributes
	 *   Object containing all inherited attributes from parent elements with attribute
	 *   names as keys
	 * @param {Object[]|undefined} segmentTimeline
	 *        List of objects representing the attributes of each S element contained within
	 *        the SegmentTimeline element
	 * @return {Object.<Array>} list of segments
	 */
	
	
	var segmentsFromList = function segmentsFromList(attributes, segmentTimeline) {
	  var duration = attributes.duration,
	      _attributes$segmentUr = attributes.segmentUrls,
	      segmentUrls = _attributes$segmentUr === void 0 ? [] : _attributes$segmentUr,
	      periodStart = attributes.periodStart; // Per spec (5.3.9.2.1) no way to determine segment duration OR
	  // if both SegmentTimeline and @duration are defined, it is outside of spec.
	
	  if (!duration && !segmentTimeline || duration && segmentTimeline) {
	    throw new Error(errors.SEGMENT_TIME_UNSPECIFIED);
	  }
	
	  var segmentUrlMap = segmentUrls.map(function (segmentUrlObject) {
	    return SegmentURLToSegmentObject(attributes, segmentUrlObject);
	  });
	  var segmentTimeInfo;
	
	  if (duration) {
	    segmentTimeInfo = parseByDuration(attributes);
	  }
	
	  if (segmentTimeline) {
	    segmentTimeInfo = parseByTimeline(attributes, segmentTimeline);
	  }
	
	  var segments = segmentTimeInfo.map(function (segmentTime, index) {
	    if (segmentUrlMap[index]) {
	      var segment = segmentUrlMap[index]; // See DASH spec section 5.3.9.2.2
	      // - if timescale isn't present on any level, default to 1.
	
	      var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0
	
	      var presentationTimeOffset = attributes.presentationTimeOffset || 0;
	      segment.timeline = segmentTime.timeline;
	      segment.duration = segmentTime.duration;
	      segment.number = segmentTime.number;
	      segment.presentationTime = periodStart + (segmentTime.time - presentationTimeOffset) / timescale;
	      return segment;
	    } // Since we're mapping we should get rid of any blank segments (in case
	    // the given SegmentTimeline is handling for more elements than we have
	    // SegmentURLs for).
	
	  }).filter(function (segment) {
	    return segment;
	  });
	  return segments;
	};
	
	var generateSegments = function generateSegments(_ref) {
	  var attributes = _ref.attributes,
	      segmentInfo = _ref.segmentInfo;
	  var segmentAttributes;
	  var segmentsFn;
	
	  if (segmentInfo.template) {
	    segmentsFn = segmentsFromTemplate;
	    segmentAttributes = merge(attributes, segmentInfo.template);
	  } else if (segmentInfo.base) {
	    segmentsFn = segmentsFromBase;
	    segmentAttributes = merge(attributes, segmentInfo.base);
	  } else if (segmentInfo.list) {
	    segmentsFn = segmentsFromList;
	    segmentAttributes = merge(attributes, segmentInfo.list);
	  }
	
	  var segmentsInfo = {
	    attributes: attributes
	  };
	
	  if (!segmentsFn) {
	    return segmentsInfo;
	  }
	
	  var segments = segmentsFn(segmentAttributes, segmentInfo.segmentTimeline); // The @duration attribute will be used to determin the playlist's targetDuration which
	  // must be in seconds. Since we've generated the segment list, we no longer need
	  // @duration to be in @timescale units, so we can convert it here.
	
	  if (segmentAttributes.duration) {
	    var _segmentAttributes = segmentAttributes,
	        duration = _segmentAttributes.duration,
	        _segmentAttributes$ti = _segmentAttributes.timescale,
	        timescale = _segmentAttributes$ti === void 0 ? 1 : _segmentAttributes$ti;
	    segmentAttributes.duration = duration / timescale;
	  } else if (segments.length) {
	    // if there is no @duration attribute, use the largest segment duration as
	    // as target duration
	    segmentAttributes.duration = segments.reduce(function (max, segment) {
	      return Math.max(max, Math.ceil(segment.duration));
	    }, 0);
	  } else {
	    segmentAttributes.duration = 0;
	  }
	
	  segmentsInfo.attributes = segmentAttributes;
	  segmentsInfo.segments = segments; // This is a sidx box without actual segment information
	
	  if (segmentInfo.base && segmentAttributes.indexRange) {
	    segmentsInfo.sidx = segments[0];
	    segmentsInfo.segments = [];
	  }
	
	  return segmentsInfo;
	};
	var toPlaylists = function toPlaylists(representations) {
	  return representations.map(generateSegments);
	};
	
	var findChildren = function findChildren(element, name) {
	  return from(element.childNodes).filter(function (_ref) {
	    var tagName = _ref.tagName;
	    return tagName === name;
	  });
	};
	var getContent = function getContent(element) {
	  return element.textContent.trim();
	};
	
	/**
	 * Converts the provided string that may contain a division operation to a number.
	 *
	 * @param {string} value - the provided string value
	 *
	 * @return {number} the parsed string value
	 */
	var parseDivisionValue = function parseDivisionValue(value) {
	  return parseFloat(value.split('/').reduce(function (prev, current) {
	    return prev / current;
	  }));
	};
	
	var parseDuration = function parseDuration(str) {
	  var SECONDS_IN_YEAR = 365 * 24 * 60 * 60;
	  var SECONDS_IN_MONTH = 30 * 24 * 60 * 60;
	  var SECONDS_IN_DAY = 24 * 60 * 60;
	  var SECONDS_IN_HOUR = 60 * 60;
	  var SECONDS_IN_MIN = 60; // P10Y10M10DT10H10M10.1S
	
	  var durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
	  var match = durationRegex.exec(str);
	
	  if (!match) {
	    return 0;
	  }
	
	  var _match$slice = match.slice(1),
	      year = _match$slice[0],
	      month = _match$slice[1],
	      day = _match$slice[2],
	      hour = _match$slice[3],
	      minute = _match$slice[4],
	      second = _match$slice[5];
	
	  return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
	};
	var parseDate = function parseDate(str) {
	  // Date format without timezone according to ISO 8601
	  // YYY-MM-DDThh:mm:ss.ssssss
	  var dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/; // If the date string does not specifiy a timezone, we must specifiy UTC. This is
	  // expressed by ending with 'Z'
	
	  if (dateRegex.test(str)) {
	    str += 'Z';
	  }
	
	  return Date.parse(str);
	};
	
	var parsers = {
	  /**
	   * Specifies the duration of the entire Media Presentation. Format is a duration string
	   * as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  mediaPresentationDuration: function mediaPresentationDuration(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the Segment availability start time for all Segments referred to in this
	   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
	   * time. Format is a date string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The date as seconds from unix epoch
	   */
	  availabilityStartTime: function availabilityStartTime(value) {
	    return parseDate(value) / 1000;
	  },
	
	  /**
	   * Specifies the smallest period between potential changes to the MPD. Format is a
	   * duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  minimumUpdatePeriod: function minimumUpdatePeriod(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the suggested presentation delay. Format is a
	   * duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  suggestedPresentationDelay: function suggestedPresentationDelay(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * specifices the type of mpd. Can be either "static" or "dynamic"
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   *
	   * @return {string}
	   *         The type as a string
	   */
	  type: function type(value) {
	    return value;
	  },
	
	  /**
	   * Specifies the duration of the smallest time shifting buffer for any Representation
	   * in the MPD. Format is a duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  timeShiftBufferDepth: function timeShiftBufferDepth(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
	   * Format is a duration string as specified in ISO 8601
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The duration in seconds
	   */
	  start: function start(value) {
	    return parseDuration(value);
	  },
	
	  /**
	   * Specifies the width of the visual presentation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed width
	   */
	  width: function width(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the height of the visual presentation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed height
	   */
	  height: function height(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the bitrate of the representation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed bandwidth
	   */
	  bandwidth: function bandwidth(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the frame rate of the representation
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed frame rate
	   */
	  frameRate: function frameRate(value) {
	    return parseDivisionValue(value);
	  },
	
	  /**
	   * Specifies the number of the first Media Segment in this Representation in the Period
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed number
	   */
	  startNumber: function startNumber(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the timescale in units per seconds
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed timescale
	   */
	  timescale: function timescale(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the presentationTimeOffset.
	   *
	   * @param {string} value
	   *        value of the attribute as a string
	   *
	   * @return {number}
	   *         The parsed presentationTimeOffset
	   */
	  presentationTimeOffset: function presentationTimeOffset(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the constant approximate Segment duration
	   * NOTE: The <Period> element also contains an @duration attribute. This duration
	   *       specifies the duration of the Period. This attribute is currently not
	   *       supported by the rest of the parser, however we still check for it to prevent
	   *       errors.
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed duration
	   */
	  duration: function duration(value) {
	    var parsedValue = parseInt(value, 10);
	
	    if (isNaN(parsedValue)) {
	      return parseDuration(value);
	    }
	
	    return parsedValue;
	  },
	
	  /**
	   * Specifies the Segment duration, in units of the value of the @timescale.
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed duration
	   */
	  d: function d(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the MPD start time, in @timescale units, the first Segment in the series
	   * starts relative to the beginning of the Period
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed time
	   */
	  t: function t(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Specifies the repeat count of the number of following contiguous Segments with the
	   * same duration expressed by the value of @d
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {number}
	   *         The parsed number
	   */
	  r: function r(value) {
	    return parseInt(value, 10);
	  },
	
	  /**
	   * Default parser for all other attributes. Acts as a no-op and just returns the value
	   * as a string
	   *
	   * @param {string} value
	   *        value of attribute as a string
	   * @return {string}
	   *         Unparsed value
	   */
	  DEFAULT: function DEFAULT(value) {
	    return value;
	  }
	};
	/**
	 * Gets all the attributes and values of the provided node, parses attributes with known
	 * types, and returns an object with attribute names mapped to values.
	 *
	 * @param {Node} el
	 *        The node to parse attributes from
	 * @return {Object}
	 *         Object with all attributes of el parsed
	 */
	
	var parseAttributes = function parseAttributes(el) {
	  if (!(el && el.attributes)) {
	    return {};
	  }
	
	  return from(el.attributes).reduce(function (a, e) {
	    var parseFn = parsers[e.name] || parsers.DEFAULT;
	    a[e.name] = parseFn(e.value);
	    return a;
	  }, {});
	};
	
	var keySystemsMap = {
	  'urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b': 'org.w3.clearkey',
	  'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed': 'com.widevine.alpha',
	  'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95': 'com.microsoft.playready',
	  'urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb': 'com.adobe.primetime'
	};
	/**
	 * Builds a list of urls that is the product of the reference urls and BaseURL values
	 *
	 * @param {string[]} referenceUrls
	 *        List of reference urls to resolve to
	 * @param {Node[]} baseUrlElements
	 *        List of BaseURL nodes from the mpd
	 * @return {string[]}
	 *         List of resolved urls
	 */
	
	var buildBaseUrls = function buildBaseUrls(referenceUrls, baseUrlElements) {
	  if (!baseUrlElements.length) {
	    return referenceUrls;
	  }
	
	  return flatten(referenceUrls.map(function (reference) {
	    return baseUrlElements.map(function (baseUrlElement) {
	      return resolveUrl__default['default'](reference, getContent(baseUrlElement));
	    });
	  }));
	};
	/**
	 * Contains all Segment information for its containing AdaptationSet
	 *
	 * @typedef {Object} SegmentInformation
	 * @property {Object|undefined} template
	 *           Contains the attributes for the SegmentTemplate node
	 * @property {Object[]|undefined} segmentTimeline
	 *           Contains a list of atrributes for each S node within the SegmentTimeline node
	 * @property {Object|undefined} list
	 *           Contains the attributes for the SegmentList node
	 * @property {Object|undefined} base
	 *           Contains the attributes for the SegmentBase node
	 */
	
	/**
	 * Returns all available Segment information contained within the AdaptationSet node
	 *
	 * @param {Node} adaptationSet
	 *        The AdaptationSet node to get Segment information from
	 * @return {SegmentInformation}
	 *         The Segment information contained within the provided AdaptationSet
	 */
	
	var getSegmentInformation = function getSegmentInformation(adaptationSet) {
	  var segmentTemplate = findChildren(adaptationSet, 'SegmentTemplate')[0];
	  var segmentList = findChildren(adaptationSet, 'SegmentList')[0];
	  var segmentUrls = segmentList && findChildren(segmentList, 'SegmentURL').map(function (s) {
	    return merge({
	      tag: 'SegmentURL'
	    }, parseAttributes(s));
	  });
	  var segmentBase = findChildren(adaptationSet, 'SegmentBase')[0];
	  var segmentTimelineParentNode = segmentList || segmentTemplate;
	  var segmentTimeline = segmentTimelineParentNode && findChildren(segmentTimelineParentNode, 'SegmentTimeline')[0];
	  var segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
	  var segmentInitialization = segmentInitializationParentNode && findChildren(segmentInitializationParentNode, 'Initialization')[0]; // SegmentTemplate is handled slightly differently, since it can have both
	  // @initialization and an <Initialization> node.  @initialization can be templated,
	  // while the node can have a url and range specified.  If the <SegmentTemplate> has
	  // both @initialization and an <Initialization> subelement we opt to override with
	  // the node, as this interaction is not defined in the spec.
	
	  var template = segmentTemplate && parseAttributes(segmentTemplate);
	
	  if (template && segmentInitialization) {
	    template.initialization = segmentInitialization && parseAttributes(segmentInitialization);
	  } else if (template && template.initialization) {
	    // If it is @initialization we convert it to an object since this is the format that
	    // later functions will rely on for the initialization segment.  This is only valid
	    // for <SegmentTemplate>
	    template.initialization = {
	      sourceURL: template.initialization
	    };
	  }
	
	  var segmentInfo = {
	    template: template,
	    segmentTimeline: segmentTimeline && findChildren(segmentTimeline, 'S').map(function (s) {
	      return parseAttributes(s);
	    }),
	    list: segmentList && merge(parseAttributes(segmentList), {
	      segmentUrls: segmentUrls,
	      initialization: parseAttributes(segmentInitialization)
	    }),
	    base: segmentBase && merge(parseAttributes(segmentBase), {
	      initialization: parseAttributes(segmentInitialization)
	    })
	  };
	  Object.keys(segmentInfo).forEach(function (key) {
	    if (!segmentInfo[key]) {
	      delete segmentInfo[key];
	    }
	  });
	  return segmentInfo;
	};
	/**
	 * Contains Segment information and attributes needed to construct a Playlist object
	 * from a Representation
	 *
	 * @typedef {Object} RepresentationInformation
	 * @property {SegmentInformation} segmentInfo
	 *           Segment information for this Representation
	 * @property {Object} attributes
	 *           Inherited attributes for this Representation
	 */
	
	/**
	 * Maps a Representation node to an object containing Segment information and attributes
	 *
	 * @name inheritBaseUrlsCallback
	 * @function
	 * @param {Node} representation
	 *        Representation node from the mpd
	 * @return {RepresentationInformation}
	 *         Representation information needed to construct a Playlist object
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping Representation nodes to
	 * Segment information and attributes using inherited BaseURL nodes.
	 *
	 * @param {Object} adaptationSetAttributes
	 *        Contains attributes inherited by the AdaptationSet
	 * @param {string[]} adaptationSetBaseUrls
	 *        Contains list of resolved base urls inherited by the AdaptationSet
	 * @param {SegmentInformation} adaptationSetSegmentInfo
	 *        Contains Segment information for the AdaptationSet
	 * @return {inheritBaseUrlsCallback}
	 *         Callback map function
	 */
	
	var inheritBaseUrls = function inheritBaseUrls(adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo) {
	  return function (representation) {
	    var repBaseUrlElements = findChildren(representation, 'BaseURL');
	    var repBaseUrls = buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
	    var attributes = merge(adaptationSetAttributes, parseAttributes(representation));
	    var representationSegmentInfo = getSegmentInformation(representation);
	    return repBaseUrls.map(function (baseUrl) {
	      return {
	        segmentInfo: merge(adaptationSetSegmentInfo, representationSegmentInfo),
	        attributes: merge(attributes, {
	          baseUrl: baseUrl
	        })
	      };
	    });
	  };
	};
	/**
	 * Tranforms a series of content protection nodes to
	 * an object containing pssh data by key system
	 *
	 * @param {Node[]} contentProtectionNodes
	 *        Content protection nodes
	 * @return {Object}
	 *        Object containing pssh data by key system
	 */
	
	var generateKeySystemInformation = function generateKeySystemInformation(contentProtectionNodes) {
	  return contentProtectionNodes.reduce(function (acc, node) {
	    var attributes = parseAttributes(node); // Although it could be argued that according to the UUID RFC spec the UUID string (a-f chars) should be generated
	    // as a lowercase string it also mentions it should be treated as case-insensitive on input. Since the key system
	    // UUIDs in the keySystemsMap are hardcoded as lowercase in the codebase there isn't any reason not to do
	    // .toLowerCase() on the input UUID string from the manifest (at least I could not think of one).
	
	    if (attributes.schemeIdUri) {
	      attributes.schemeIdUri = attributes.schemeIdUri.toLowerCase();
	    }
	
	    var keySystem = keySystemsMap[attributes.schemeIdUri];
	
	    if (keySystem) {
	      acc[keySystem] = {
	        attributes: attributes
	      };
	      var psshNode = findChildren(node, 'cenc:pssh')[0];
	
	      if (psshNode) {
	        var pssh = getContent(psshNode);
	        acc[keySystem].pssh = pssh && decodeB64ToUint8Array__default['default'](pssh);
	      }
	    }
	
	    return acc;
	  }, {});
	}; // defined in ANSI_SCTE 214-1 2016
	
	
	var parseCaptionServiceMetadata = function parseCaptionServiceMetadata(service) {
	  // 608 captions
	  if (service.schemeIdUri === 'urn:scte:dash:cc:cea-608:2015') {
	    var values = typeof service.value !== 'string' ? [] : service.value.split(';');
	    return values.map(function (value) {
	      var channel;
	      var language; // default language to value
	
	      language = value;
	
	      if (/^CC\d=/.test(value)) {
	        var _value$split = value.split('=');
	
	        channel = _value$split[0];
	        language = _value$split[1];
	      } else if (/^CC\d$/.test(value)) {
	        channel = value;
	      }
	
	      return {
	        channel: channel,
	        language: language
	      };
	    });
	  } else if (service.schemeIdUri === 'urn:scte:dash:cc:cea-708:2015') {
	    var _values = typeof service.value !== 'string' ? [] : service.value.split(';');
	
	    return _values.map(function (value) {
	      var flags = {
	        // service or channel number 1-63
	        'channel': undefined,
	        // language is a 3ALPHA per ISO 639.2/B
	        // field is required
	        'language': undefined,
	        // BIT 1/0 or ?
	        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
	        'aspectRatio': 1,
	        // BIT 1/0
	        // easy reader flag indicated the text is tailed to the needs of beginning readers
	        // default 0, or off
	        'easyReader': 0,
	        // BIT 1/0
	        // If 3d metadata is present (CEA-708.1) then 1
	        // default 0
	        '3D': 0
	      };
	
	      if (/=/.test(value)) {
	        var _value$split2 = value.split('='),
	            channel = _value$split2[0],
	            _value$split2$ = _value$split2[1],
	            opts = _value$split2$ === void 0 ? '' : _value$split2$;
	
	        flags.channel = channel;
	        flags.language = value;
	        opts.split(',').forEach(function (opt) {
	          var _opt$split = opt.split(':'),
	              name = _opt$split[0],
	              val = _opt$split[1];
	
	          if (name === 'lang') {
	            flags.language = val; // er for easyReadery
	          } else if (name === 'er') {
	            flags.easyReader = Number(val); // war for wide aspect ratio
	          } else if (name === 'war') {
	            flags.aspectRatio = Number(val);
	          } else if (name === '3D') {
	            flags['3D'] = Number(val);
	          }
	        });
	      } else {
	        flags.language = value;
	      }
	
	      if (flags.channel) {
	        flags.channel = 'SERVICE' + flags.channel;
	      }
	
	      return flags;
	    });
	  }
	};
	/**
	 * Maps an AdaptationSet node to a list of Representation information objects
	 *
	 * @name toRepresentationsCallback
	 * @function
	 * @param {Node} adaptationSet
	 *        AdaptationSet node from the mpd
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representaion information
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping AdaptationSet nodes to a list of
	 * Representation information objects
	 *
	 * @param {Object} periodAttributes
	 *        Contains attributes inherited by the Period
	 * @param {string[]} periodBaseUrls
	 *        Contains list of resolved base urls inherited by the Period
	 * @param {string[]} periodSegmentInfo
	 *        Contains Segment Information at the period level
	 * @return {toRepresentationsCallback}
	 *         Callback map function
	 */
	
	var toRepresentations = function toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo) {
	  return function (adaptationSet) {
	    var adaptationSetAttributes = parseAttributes(adaptationSet);
	    var adaptationSetBaseUrls = buildBaseUrls(periodBaseUrls, findChildren(adaptationSet, 'BaseURL'));
	    var role = findChildren(adaptationSet, 'Role')[0];
	    var roleAttributes = {
	      role: parseAttributes(role)
	    };
	    var attrs = merge(periodAttributes, adaptationSetAttributes, roleAttributes);
	    var accessibility = findChildren(adaptationSet, 'Accessibility')[0];
	    var captionServices = parseCaptionServiceMetadata(parseAttributes(accessibility));
	
	    if (captionServices) {
	      attrs = merge(attrs, {
	        captionServices: captionServices
	      });
	    }
	
	    var label = findChildren(adaptationSet, 'Label')[0];
	
	    if (label && label.childNodes.length) {
	      var labelVal = label.childNodes[0].nodeValue.trim();
	      attrs = merge(attrs, {
	        label: labelVal
	      });
	    }
	
	    var contentProtection = generateKeySystemInformation(findChildren(adaptationSet, 'ContentProtection'));
	
	    if (Object.keys(contentProtection).length) {
	      attrs = merge(attrs, {
	        contentProtection: contentProtection
	      });
	    }
	
	    var segmentInfo = getSegmentInformation(adaptationSet);
	    var representations = findChildren(adaptationSet, 'Representation');
	    var adaptationSetSegmentInfo = merge(periodSegmentInfo, segmentInfo);
	    return flatten(representations.map(inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
	  };
	};
	/**
	 * Contains all period information for mapping nodes onto adaptation sets.
	 *
	 * @typedef {Object} PeriodInformation
	 * @property {Node} period.node
	 *           Period node from the mpd
	 * @property {Object} period.attributes
	 *           Parsed period attributes from node plus any added
	 */
	
	/**
	 * Maps a PeriodInformation object to a list of Representation information objects for all
	 * AdaptationSet nodes contained within the Period.
	 *
	 * @name toAdaptationSetsCallback
	 * @function
	 * @param {PeriodInformation} period
	 *        Period object containing necessary period information
	 * @param {number} periodStart
	 *        Start time of the Period within the mpd
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representaion information
	 */
	
	/**
	 * Returns a callback for Array.prototype.map for mapping Period nodes to a list of
	 * Representation information objects
	 *
	 * @param {Object} mpdAttributes
	 *        Contains attributes inherited by the mpd
	 * @param {string[]} mpdBaseUrls
	 *        Contains list of resolved base urls inherited by the mpd
	 * @return {toAdaptationSetsCallback}
	 *         Callback map function
	 */
	
	var toAdaptationSets = function toAdaptationSets(mpdAttributes, mpdBaseUrls) {
	  return function (period, index) {
	    var periodBaseUrls = buildBaseUrls(mpdBaseUrls, findChildren(period.node, 'BaseURL'));
	    var periodAttributes = merge(mpdAttributes, {
	      periodStart: period.attributes.start
	    });
	
	    if (typeof period.attributes.duration === 'number') {
	      periodAttributes.periodDuration = period.attributes.duration;
	    }
	
	    var adaptationSets = findChildren(period.node, 'AdaptationSet');
	    var periodSegmentInfo = getSegmentInformation(period.node);
	    return flatten(adaptationSets.map(toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
	  };
	};
	/**
	 * Gets Period@start property for a given period.
	 *
	 * @param {Object} options
	 *        Options object
	 * @param {Object} options.attributes
	 *        Period attributes
	 * @param {Object} [options.priorPeriodAttributes]
	 *        Prior period attributes (if prior period is available)
	 * @param {string} options.mpdType
	 *        The MPD@type these periods came from
	 * @return {number|null}
	 *         The period start, or null if it's an early available period or error
	 */
	
	var getPeriodStart = function getPeriodStart(_ref) {
	  var attributes = _ref.attributes,
	      priorPeriodAttributes = _ref.priorPeriodAttributes,
	      mpdType = _ref.mpdType;
	
	  // Summary of period start time calculation from DASH spec section 5.3.2.1
	  //
	  // A period's start is the first period's start + time elapsed after playing all
	  // prior periods to this one. Periods continue one after the other in time (without
	  // gaps) until the end of the presentation.
	  //
	  // The value of Period@start should be:
	  // 1. if Period@start is present: value of Period@start
	  // 2. if previous period exists and it has @duration: previous Period@start +
	  //    previous Period@duration
	  // 3. if this is first period and MPD@type is 'static': 0
	  // 4. in all other cases, consider the period an "early available period" (note: not
	  //    currently supported)
	  // (1)
	  if (typeof attributes.start === 'number') {
	    return attributes.start;
	  } // (2)
	
	
	  if (priorPeriodAttributes && typeof priorPeriodAttributes.start === 'number' && typeof priorPeriodAttributes.duration === 'number') {
	    return priorPeriodAttributes.start + priorPeriodAttributes.duration;
	  } // (3)
	
	
	  if (!priorPeriodAttributes && mpdType === 'static') {
	    return 0;
	  } // (4)
	  // There is currently no logic for calculating the Period@start value if there is
	  // no Period@start or prior Period@start and Period@duration available. This is not made
	  // explicit by the DASH interop guidelines or the DASH spec, however, since there's
	  // nothing about any other resolution strategies, it's implied. Thus, this case should
	  // be considered an early available period, or error, and null should suffice for both
	  // of those cases.
	
	
	  return null;
	};
	/**
	 * Traverses the mpd xml tree to generate a list of Representation information objects
	 * that have inherited attributes from parent nodes
	 *
	 * @param {Node} mpd
	 *        The root node of the mpd
	 * @param {Object} options
	 *        Available options for inheritAttributes
	 * @param {string} options.manifestUri
	 *        The uri source of the mpd
	 * @param {number} options.NOW
	 *        Current time per DASH IOP.  Default is current time in ms since epoch
	 * @param {number} options.clientOffset
	 *        Client time difference from NOW (in milliseconds)
	 * @return {RepresentationInformation[]}
	 *         List of objects containing Representation information
	 */
	
	var inheritAttributes = function inheritAttributes(mpd, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      _options$manifestUri = _options.manifestUri,
	      manifestUri = _options$manifestUri === void 0 ? '' : _options$manifestUri,
	      _options$NOW = _options.NOW,
	      NOW = _options$NOW === void 0 ? Date.now() : _options$NOW,
	      _options$clientOffset = _options.clientOffset,
	      clientOffset = _options$clientOffset === void 0 ? 0 : _options$clientOffset;
	  var periodNodes = findChildren(mpd, 'Period');
	
	  if (!periodNodes.length) {
	    throw new Error(errors.INVALID_NUMBER_OF_PERIOD);
	  }
	
	  var locations = findChildren(mpd, 'Location');
	  var mpdAttributes = parseAttributes(mpd);
	  var mpdBaseUrls = buildBaseUrls([manifestUri], findChildren(mpd, 'BaseURL')); // See DASH spec section 5.3.1.2, Semantics of MPD element. Default type to 'static'.
	
	  mpdAttributes.type = mpdAttributes.type || 'static';
	  mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
	  mpdAttributes.NOW = NOW;
	  mpdAttributes.clientOffset = clientOffset;
	
	  if (locations.length) {
	    mpdAttributes.locations = locations.map(getContent);
	  }
	
	  var periods = []; // Since toAdaptationSets acts on individual periods right now, the simplest approach to
	  // adding properties that require looking at prior periods is to parse attributes and add
	  // missing ones before toAdaptationSets is called. If more such properties are added, it
	  // may be better to refactor toAdaptationSets.
	
	  periodNodes.forEach(function (node, index) {
	    var attributes = parseAttributes(node); // Use the last modified prior period, as it may contain added information necessary
	    // for this period.
	
	    var priorPeriod = periods[index - 1];
	    attributes.start = getPeriodStart({
	      attributes: attributes,
	      priorPeriodAttributes: priorPeriod ? priorPeriod.attributes : null,
	      mpdType: mpdAttributes.type
	    });
	    periods.push({
	      node: node,
	      attributes: attributes
	    });
	  });
	  return {
	    locations: mpdAttributes.locations,
	    representationInfo: flatten(periods.map(toAdaptationSets(mpdAttributes, mpdBaseUrls)))
	  };
	};
	
	var stringToMpdXml = function stringToMpdXml(manifestString) {
	  if (manifestString === '') {
	    throw new Error(errors.DASH_EMPTY_MANIFEST);
	  }
	
	  var parser = new xmldom.DOMParser();
	  var xml;
	  var mpd;
	
	  try {
	    xml = parser.parseFromString(manifestString, 'application/xml');
	    mpd = xml && xml.documentElement.tagName === 'MPD' ? xml.documentElement : null;
	  } catch (e) {// ie 11 throwsw on invalid xml
	  }
	
	  if (!mpd || mpd && mpd.getElementsByTagName('parsererror').length > 0) {
	    throw new Error(errors.DASH_INVALID_XML);
	  }
	
	  return mpd;
	};
	
	/**
	 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
	 *
	 * @param {string} mpd
	 *        XML string of the MPD manifest
	 * @return {Object|null}
	 *         Attributes of UTCTiming node specified in the manifest. Null if none found
	 */
	
	var parseUTCTimingScheme = function parseUTCTimingScheme(mpd) {
	  var UTCTimingNode = findChildren(mpd, 'UTCTiming')[0];
	
	  if (!UTCTimingNode) {
	    return null;
	  }
	
	  var attributes = parseAttributes(UTCTimingNode);
	
	  switch (attributes.schemeIdUri) {
	    case 'urn:mpeg:dash:utc:http-head:2014':
	    case 'urn:mpeg:dash:utc:http-head:2012':
	      attributes.method = 'HEAD';
	      break;
	
	    case 'urn:mpeg:dash:utc:http-xsdate:2014':
	    case 'urn:mpeg:dash:utc:http-iso:2014':
	    case 'urn:mpeg:dash:utc:http-xsdate:2012':
	    case 'urn:mpeg:dash:utc:http-iso:2012':
	      attributes.method = 'GET';
	      break;
	
	    case 'urn:mpeg:dash:utc:direct:2014':
	    case 'urn:mpeg:dash:utc:direct:2012':
	      attributes.method = 'DIRECT';
	      attributes.value = Date.parse(attributes.value);
	      break;
	
	    case 'urn:mpeg:dash:utc:http-ntp:2014':
	    case 'urn:mpeg:dash:utc:ntp:2014':
	    case 'urn:mpeg:dash:utc:sntp:2014':
	    default:
	      throw new Error(errors.UNSUPPORTED_UTC_TIMING_SCHEME);
	  }
	
	  return attributes;
	};
	
	var VERSION = version;
	/*
	 * Given a DASH manifest string and options, parses the DASH manifest into an object in the
	 * form outputed by m3u8-parser and accepted by videojs/http-streaming.
	 *
	 * For live DASH manifests, if `previousManifest` is provided in options, then the newly
	 * parsed DASH manifest will have its media sequence and discontinuity sequence values
	 * updated to reflect its position relative to the prior manifest.
	 *
	 * @param {string} manifestString - the DASH manifest as a string
	 * @param {options} [options] - any options
	 *
	 * @return {Object} the manifest object
	 */
	
	var parse = function parse(manifestString, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var parsedManifestInfo = inheritAttributes(stringToMpdXml(manifestString), options);
	  var playlists = toPlaylists(parsedManifestInfo.representationInfo);
	  return toM3u8({
	    dashPlaylists: playlists,
	    locations: parsedManifestInfo.locations,
	    sidxMapping: options.sidxMapping,
	    previousManifest: options.previousManifest
	  });
	};
	/**
	 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
	 *
	 * @param {string} manifestString
	 *        XML string of the MPD manifest
	 * @return {Object|null}
	 *         Attributes of UTCTiming node specified in the manifest. Null if none found
	 */
	
	
	var parseUTCTiming = function parseUTCTiming(manifestString) {
	  return parseUTCTimingScheme(stringToMpdXml(manifestString));
	};
	
	exports.VERSION = VERSION;
	exports.addSidxSegmentsToPlaylist = addSidxSegmentsToPlaylist$1;
	exports.generateSidxKey = generateSidxKey;
	exports.inheritAttributes = inheritAttributes;
	exports.parse = parse;
	exports.parseUTCTiming = parseUTCTiming;
	exports.stringToMpdXml = stringToMpdXml;
	exports.toM3u8 = toM3u8;
	exports.toPlaylists = toPlaylists;


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	var getUint64 = __webpack_require__(571).getUint64;
	
	var parseSidx = function(data) {
	  var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	      result = {
	        version: data[0],
	        flags: new Uint8Array(data.subarray(1, 4)),
	        references: [],
	        referenceId: view.getUint32(4),
	        timescale: view.getUint32(8)
	      },
	    i = 12;
	
	  if (result.version === 0) {
	    result.earliestPresentationTime = view.getUint32(i);
	    result.firstOffset = view.getUint32(i + 4);
	    i += 8;
	  } else {
	    // read 64 bits
	    result.earliestPresentationTime = getUint64(data.subarray(i));
	    result.firstOffset = getUint64(data.subarray(i + 8));
	    i += 16;
	  }
	
	  i += 2; // reserved
	
	  var referenceCount = view.getUint16(i);
	
	  i += 2; // start of references
	
	  for (; referenceCount > 0; i += 12, referenceCount--) {
	    result.references.push({
	      referenceType: (data[i] & 0x80) >>> 7,
	      referencedSize: view.getUint32(i) & 0x7FFFFFFF,
	      subsegmentDuration: view.getUint32(i + 4),
	      startsWithSap: !!(data[i + 8] & 0x80),
	      sapType: (data[i + 8] & 0x70) >>> 4,
	      sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
	    });
	  }
	
	  return result;
	};
	
	
	module.exports = parseSidx;


/***/ },
/* 570 */
/***/ function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) Brightcove
	 * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
	 */
	var
	  ONE_SECOND_IN_TS = 90000, // 90kHz clock
	  secondsToVideoTs,
	  secondsToAudioTs,
	  videoTsToSeconds,
	  audioTsToSeconds,
	  audioTsToVideoTs,
	  videoTsToAudioTs,
	  metadataTsToSeconds;
	
	secondsToVideoTs = function(seconds) {
	  return seconds * ONE_SECOND_IN_TS;
	};
	
	secondsToAudioTs = function(seconds, sampleRate) {
	  return seconds * sampleRate;
	};
	
	videoTsToSeconds = function(timestamp) {
	  return timestamp / ONE_SECOND_IN_TS;
	};
	
	audioTsToSeconds = function(timestamp, sampleRate) {
	  return timestamp / sampleRate;
	};
	
	audioTsToVideoTs = function(timestamp, sampleRate) {
	  return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
	};
	
	videoTsToAudioTs = function(timestamp, sampleRate) {
	  return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
	};
	
	/**
	 * Adjust ID3 tag or caption timing information by the timeline pts values
	 * (if keepOriginalTimestamps is false) and convert to seconds
	 */
	metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
	  return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
	};
	
	module.exports = {
	  ONE_SECOND_IN_TS: ONE_SECOND_IN_TS,
	  secondsToVideoTs: secondsToVideoTs,
	  secondsToAudioTs: secondsToAudioTs,
	  videoTsToSeconds: videoTsToSeconds,
	  audioTsToSeconds: audioTsToSeconds,
	  audioTsToVideoTs: audioTsToVideoTs,
	  videoTsToAudioTs: videoTsToAudioTs,
	  metadataTsToSeconds: metadataTsToSeconds
	};


/***/ },
/* 571 */
/***/ function(module, exports) {

	var MAX_UINT32 = Math.pow(2, 32);
	
	var getUint64 = function(uint8) {
	  var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
	  var value;
	
	  if (dv.getBigUint64) {
	    value = dv.getBigUint64(0);
	
	    if (value < Number.MAX_SAFE_INTEGER) {
	      return Number(value);
	    }
	
	    return value;
	  }
	
	  return (dv.getUint32(0) * MAX_UINT32) + dv.getUint32(4);
	};
	
	module.exports = {
	  getUint64: getUint64,
	  MAX_UINT32: MAX_UINT32
	};


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(240);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(240);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(42);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(10);
	var assign = __webpack_require__(14);
	
	var ReactPropTypesSecret = __webpack_require__(576);
	var checkPropTypes = __webpack_require__(574);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 576 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(706);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(592);


/***/ },
/* 579 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(25);
	
	var focusNode = __webpack_require__(231);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(95);
	var ExecutionEnvironment = __webpack_require__(30);
	var FallbackCompositionState = __webpack_require__(587);
	var SyntheticCompositionEvent = __webpack_require__(624);
	var SyntheticInputEvent = __webpack_require__(627);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(242);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactInstrumentation = __webpack_require__(43);
	
	var camelizeStyleName = __webpack_require__(545);
	var dangerousStyleValue = __webpack_require__(633);
	var hyphenateStyleName = __webpack_require__(552);
	var memoizeStringOnly = __webpack_require__(555);
	var warning = __webpack_require__(10);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(94);
	var EventPropagators = __webpack_require__(95);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactUpdates = __webpack_require__(50);
	var SyntheticEvent = __webpack_require__(55);
	
	var inputValueTracking = __webpack_require__(258);
	var getEventTarget = __webpack_require__(174);
	var isEventSupported = __webpack_require__(175);
	var isTextInputElement = __webpack_require__(260);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var DOMLazyTree = __webpack_require__(82);
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createNodesFromMarkup = __webpack_require__(548);
	var emptyFunction = __webpack_require__(42);
	var invariant = __webpack_require__(4);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 585 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(95);
	var ReactDOMComponentTree = __webpack_require__(25);
	var SyntheticMouseEvent = __webpack_require__(122);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(75);
	
	var getTextContentAccessor = __webpack_require__(257);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(83);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(84);
	
	var instantiateReactComponent = __webpack_require__(259);
	var KeyEscapeUtils = __webpack_require__(166);
	var shouldUpdateReactComponent = __webpack_require__(176);
	var traverseAllChildren = __webpack_require__(262);
	var warning = __webpack_require__(10);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(272);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(239)))

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(162);
	var ReactDOMIDOperations = __webpack_require__(597);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var React = __webpack_require__(88);
	var ReactComponentEnvironment = __webpack_require__(168);
	var ReactCurrentOwner = __webpack_require__(56);
	var ReactErrorUtils = __webpack_require__(169);
	var ReactInstanceMap = __webpack_require__(96);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactNodeTypes = __webpack_require__(252);
	var ReactReconciler = __webpack_require__(84);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(118);
	var invariant = __webpack_require__(4);
	var shallowEqual = __webpack_require__(158);
	var shouldUpdateReactComponent = __webpack_require__(176);
	var warning = __webpack_require__(10);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactDefaultInjection = __webpack_require__(605);
	var ReactMount = __webpack_require__(251);
	var ReactReconciler = __webpack_require__(84);
	var ReactUpdates = __webpack_require__(50);
	var ReactVersion = __webpack_require__(618);
	
	var findDOMNode = __webpack_require__(634);
	var getHostComponentFromComposite = __webpack_require__(256);
	var renderSubtreeIntoContainer = __webpack_require__(641);
	var warning = __webpack_require__(10);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var AutoFocusUtils = __webpack_require__(580);
	var CSSPropertyOperations = __webpack_require__(582);
	var DOMLazyTree = __webpack_require__(82);
	var DOMNamespaces = __webpack_require__(163);
	var DOMProperty = __webpack_require__(83);
	var DOMPropertyOperations = __webpack_require__(244);
	var EventPluginHub = __webpack_require__(94);
	var EventPluginRegistry = __webpack_require__(164);
	var ReactBrowserEventEmitter = __webpack_require__(121);
	var ReactDOMComponentFlags = __webpack_require__(245);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactDOMInput = __webpack_require__(598);
	var ReactDOMOption = __webpack_require__(599);
	var ReactDOMSelect = __webpack_require__(246);
	var ReactDOMTextarea = __webpack_require__(602);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactMultiChild = __webpack_require__(611);
	var ReactServerRenderingTransaction = __webpack_require__(616);
	
	var emptyFunction = __webpack_require__(42);
	var escapeTextContentForBrowser = __webpack_require__(124);
	var invariant = __webpack_require__(4);
	var isEventSupported = __webpack_require__(175);
	var shallowEqual = __webpack_require__(158);
	var inputValueTracking = __webpack_require__(258);
	var validateDOMNesting = __webpack_require__(177);
	var warning = __webpack_require__(10);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(177);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(82);
	var ReactDOMComponentTree = __webpack_require__(25);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 596 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(162);
	var ReactDOMComponentTree = __webpack_require__(25);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var DOMPropertyOperations = __webpack_require__(244);
	var LinkedValueUtils = __webpack_require__(167);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactUpdates = __webpack_require__(50);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(10);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var React = __webpack_require__(88);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactDOMSelect = __webpack_require__(246);
	
	var warning = __webpack_require__(10);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var getNodeForCharacterOffset = __webpack_require__(638);
	var getTextContentAccessor = __webpack_require__(257);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var DOMChildrenOperations = __webpack_require__(162);
	var DOMLazyTree = __webpack_require__(82);
	var ReactDOMComponentTree = __webpack_require__(25);
	
	var escapeTextContentForBrowser = __webpack_require__(124);
	var invariant = __webpack_require__(4);
	var validateDOMNesting = __webpack_require__(177);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var LinkedValueUtils = __webpack_require__(167);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactUpdates = __webpack_require__(50);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(10);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactUpdates = __webpack_require__(50);
	var Transaction = __webpack_require__(123);
	
	var emptyFunction = __webpack_require__(42);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(579);
	var BeforeInputEventPlugin = __webpack_require__(581);
	var ChangeEventPlugin = __webpack_require__(583);
	var DefaultEventPluginOrder = __webpack_require__(585);
	var EnterLeaveEventPlugin = __webpack_require__(586);
	var HTMLDOMPropertyConfig = __webpack_require__(588);
	var ReactComponentBrowserEnvironment = __webpack_require__(590);
	var ReactDOMComponent = __webpack_require__(593);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactDOMEmptyComponent = __webpack_require__(595);
	var ReactDOMTreeTraversal = __webpack_require__(603);
	var ReactDOMTextComponent = __webpack_require__(601);
	var ReactDefaultBatchingStrategy = __webpack_require__(604);
	var ReactEventListener = __webpack_require__(608);
	var ReactInjection = __webpack_require__(609);
	var ReactReconcileTransaction = __webpack_require__(614);
	var SVGDOMPropertyConfig = __webpack_require__(619);
	var SelectEventPlugin = __webpack_require__(620);
	var SimpleEventPlugin = __webpack_require__(621);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 606 */
273,
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(94);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var EventListener = __webpack_require__(230);
	var ExecutionEnvironment = __webpack_require__(30);
	var PooledClass = __webpack_require__(75);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactUpdates = __webpack_require__(50);
	
	var getEventTarget = __webpack_require__(174);
	var getUnboundedScrollPosition = __webpack_require__(550);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(83);
	var EventPluginHub = __webpack_require__(94);
	var EventPluginUtils = __webpack_require__(165);
	var ReactComponentEnvironment = __webpack_require__(168);
	var ReactEmptyComponent = __webpack_require__(247);
	var ReactBrowserEventEmitter = __webpack_require__(121);
	var ReactHostComponent = __webpack_require__(249);
	var ReactUpdates = __webpack_require__(50);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(632);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactComponentEnvironment = __webpack_require__(168);
	var ReactInstanceMap = __webpack_require__(96);
	var ReactInstrumentation = __webpack_require__(43);
	
	var ReactCurrentOwner = __webpack_require__(56);
	var ReactReconciler = __webpack_require__(84);
	var ReactChildReconciler = __webpack_require__(589);
	
	var emptyFunction = __webpack_require__(42);
	var flattenChildren = __webpack_require__(635);
	var invariant = __webpack_require__(4);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 613 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var CallbackQueue = __webpack_require__(243);
	var PooledClass = __webpack_require__(75);
	var ReactBrowserEventEmitter = __webpack_require__(121);
	var ReactInputSelection = __webpack_require__(250);
	var ReactInstrumentation = __webpack_require__(43);
	var Transaction = __webpack_require__(123);
	var ReactUpdateQueue = __webpack_require__(170);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(612);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(75);
	var Transaction = __webpack_require__(123);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactServerUpdateQueue = __webpack_require__(617);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(170);
	
	var warning = __webpack_require__(10);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 618 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 619 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(95);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactInputSelection = __webpack_require__(250);
	var SyntheticEvent = __webpack_require__(55);
	
	var getActiveElement = __webpack_require__(232);
	var isTextInputElement = __webpack_require__(260);
	var shallowEqual = __webpack_require__(158);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var EventListener = __webpack_require__(230);
	var EventPropagators = __webpack_require__(95);
	var ReactDOMComponentTree = __webpack_require__(25);
	var SyntheticAnimationEvent = __webpack_require__(622);
	var SyntheticClipboardEvent = __webpack_require__(623);
	var SyntheticEvent = __webpack_require__(55);
	var SyntheticFocusEvent = __webpack_require__(626);
	var SyntheticKeyboardEvent = __webpack_require__(628);
	var SyntheticMouseEvent = __webpack_require__(122);
	var SyntheticDragEvent = __webpack_require__(625);
	var SyntheticTouchEvent = __webpack_require__(629);
	var SyntheticTransitionEvent = __webpack_require__(630);
	var SyntheticUIEvent = __webpack_require__(97);
	var SyntheticWheelEvent = __webpack_require__(631);
	
	var emptyFunction = __webpack_require__(42);
	var getEventCharCode = __webpack_require__(172);
	var invariant = __webpack_require__(4);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(122);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(97);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(97);
	
	var getEventCharCode = __webpack_require__(172);
	var getEventKey = __webpack_require__(636);
	var getEventModifierState = __webpack_require__(173);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(97);
	
	var getEventModifierState = __webpack_require__(173);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(55);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(122);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 632 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(242);
	var warning = __webpack_require__(10);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(56);
	var ReactDOMComponentTree = __webpack_require__(25);
	var ReactInstanceMap = __webpack_require__(96);
	
	var getHostComponentFromComposite = __webpack_require__(256);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(10);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(166);
	var traverseAllChildren = __webpack_require__(262);
	var warning = __webpack_require__(10);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(272);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(239)))

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(172);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 637 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 638 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(124);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(251);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(14);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(645);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(643)();
	}


/***/ },
/* 645 */
576,
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(264);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(265);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _InternalPropTypes = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _InternalPropTypes = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(236);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(120);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(180);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(76);
	
	var _RouterContext = __webpack_require__(126);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _RouterUtils = __webpack_require__(266);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(126);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(178);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(126);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(557);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(268);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(86);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(178);
	
	var _makeStateWithLocation = __webpack_require__(269);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(86);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(236);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(268);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(86);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(81);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(267);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(180);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(62);
	
	var _RouterUtils = __webpack_require__(266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(178);
	
	var _makeStateWithLocation = __webpack_require__(269);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(86);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(120);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(180);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(560);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(573).enable();
	  window.Promise = __webpack_require__(572);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(731);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(14);


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isomorphicFetch = __webpack_require__(93);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _PinyinSpeaker = __webpack_require__(670);
	
	var _PinyinSpeaker2 = _interopRequireDefault(_PinyinSpeaker);
	
	var _BiShunCanvas = __webpack_require__(672);
	
	var _BiShunCanvas2 = _interopRequireDefault(_BiShunCanvas);
	
	var _BuShouSpeaker = __webpack_require__(669);
	
	var _BuShouSpeaker2 = _interopRequireDefault(_BuShouSpeaker);
	
	__webpack_require__(537);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BishunPlayer = function (_Component) {
	    _inherits(BishunPlayer, _Component);
	
	    function BishunPlayer(props) {
	        _classCallCheck(this, BishunPlayer);
	
	        var _this = _possibleConstructorReturn(this, (BishunPlayer.__proto__ || Object.getPrototypeOf(BishunPlayer)).call(this, props));
	
	        _this.canvasSupportError = function (e) {
	            // console.log("canvas创建失败.......", e)
	            _this.setState({ isSupportCanvas: false });
	        };
	
	        _this.getBiShunData = function (text) {
	            var url = '//bishunfile.qiaoxuesi.com/' + encodeURI(encodeURI(text)) + '/canvasData.json';
	            var that = _this;
	            (0, _isomorphicFetch2.default)(url).then(function (response) {
	                if (response.status !== 200) {
	                    that.setState({ isSupportCanvas: false });
	                    console.log("获取笔画的canvas数据，存在一个问题，状态码为：" + response.status);
	                    return null;
	                }
	                // console.log("response.....",response)
	                //检查响应文本
	                response.json().then(function (data) {
	                    that.setState({ textData: data, isShowBishun: true });
	                    // console.log("服务器响应的数据....", data)
	                });
	            }).catch(function (err) {
	                console.log("Fetch错误:" + err);
	            });
	        };
	
	        _this.getTextDetailInfo = function (text) {
	            var url = '//bishunfile.qiaoxuesi.com/' + encodeURI(encodeURI(text)) + '/bishun.json?random=' + Math.floor(Math.random() * 10000000);
	            var that = _this;
	            (0, _isomorphicFetch2.default)(url).then(function (response) {
	                if (response.status !== 200) {
	                    that.setState({ isSupportCanvas: false });
	                    console.log("获取汉字信息，存在一个问题，状态码为222：" + response.status);
	                    return;
	                }
	                //检查响应文本
	                response.json().then(function (data) {
	                    var bihuaCount = data.bihuaCount,
	                        bishun = data.bishun,
	                        bushou = data.bushou,
	                        pinyin = data.pinyin,
	                        structure = data.structure;
	
	                    var src = '//bishunfile.qiaoxuesi.com//' + encodeURI(encodeURI(text)) + '/pinyin';
	                    that.setState({
	                        textInfo: data,
	                        bihuaCount: bihuaCount,
	                        bishun: bishun,
	                        bushou: bushou,
	                        pinyin: pinyin,
	                        structure: structure,
	                        currentText: text,
	                        audioSrc: src,
	                        controlIndex: -1
	                    });
	                    // console.log("服务器响应的汉字具体数据....", data)
	                });
	            }).catch(function (err) {
	                console.log("Fetch错误:" + err);
	            });
	        };
	
	        _this.loop = function (_ref) {
	            var loop = _ref.loop;
	            var controlIndex = _this.state.controlIndex;
	
	            if (loop) {
	                _this.setState({ controlIndex: controlIndex + 1 });
	            } else {
	                // controlIndex = -1
	                _this.setState({ controlIndex: -1, loop: false, ifLast: true });
	            }
	        };
	
	        _this.delComp = function () {
	            var onBishunPlayerClosed = _this.props.onBishunPlayerClosed;
	
	            onBishunPlayerClosed();
	        };
	
	        _this.controlSpeed = function (speed) {
	            // console.log("speed.....", speed)
	            var speedTemplate = ["fast", "normal", "slow"];
	            var obj = {};
	            switch (speed) {
	                case "fast":
	                    obj.bushouSpeed = 1000;
	                    break;
	                case "normal":
	                    obj.bushouSpeed = 1500;
	                    break;
	                default:
	                    obj.bushouSpeed = 2000;
	            }
	            // console.log("obj.....", obj)
	            _this.setState({ obj: obj });
	            //
	        };
	
	        _this.state = {
	            textData: null,
	            textInfo: null,
	            //笔画数量
	            bihuaCount: "",
	            //笔顺
	            bishun: "",
	            //拼音
	            pinyin: [],
	            //汉字结构
	            structure: "",
	            //当前的汉字
	            currentText: "",
	            //音频路径的前缀
	            audioSrc: "",
	            bishunColor: "#969696",
	            //控制笔画结构的颜色
	            controlIndex: -1,
	            isShowBishun: false,
	            //偏旁部首是否是第一轮播放结束
	            ifLast: false,
	            //当前浏览器是否支持canvas  默认支持
	            isSupportCanvas: true,
	            //偏旁播放速度 默认1000毫秒
	            bushouSpeed: 1000
	        };
	        return _this;
	    }
	
	    _createClass(BishunPlayer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var word = this.props.word;
	
	            if (word) {
	                this.getBiShunData(word);
	                this.getTextDetailInfo(word);
	            }
	        }
	
	        //canvas 创建失败
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // console.log('BiShunPlayer卸载.....')
	            this.setState({ isShowBishun: false });
	        }
	
	        //获取笔顺canvas动画数据
	
	
	        //获取汉字具体信息
	
	
	        //每个笔画开始的回调函数
	
	        //销毁播放器组件
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                pinyin = _state.pinyin,
	                textData = _state.textData,
	                bishun = _state.bishun,
	                isShowBishun = _state.isShowBishun,
	                isSupportCanvas = _state.isSupportCanvas,
	                controlIndex = _state.controlIndex,
	                audioSrc = _state.audioSrc,
	                ifLast = _state.ifLast,
	                bushouSpeed = _state.bushouSpeed;
	
	            var arrBiShun = bishun.split(",");
	            var word = this.props.word;
	            // console.log("word.....", word)
	            // console.log(typeof word)
	
	            var jif = "";
	            if (word) {
	                jif = 'https://bishungif.qiaoxuexi.com/' + encodeURI(encodeURI(word)) + '.gif-publish';
	            }
	            // console.log("jif.......",jif)
	            return _react2.default.createElement(
	                'div',
	                { className: 'topArea' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'audioBigBox_gk' },
	                    pinyin.length ? pinyin.map(function (item, index) {
	                        return _react2.default.createElement(_PinyinSpeaker2.default, {
	                            audioSrc: audioSrc,
	                            key: "pinyinItem" + index, pinyin: item,
	                            index: index
	                        });
	                    }) : "",
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'delete_comp', onClick: this.delComp },
	                        _react2.default.createElement('img', { style: { width: "100%" }, src: 'https://img.qiaoxuesi.com/market/indexImg/1527506508187.PNG', alt: '' })
	                    )
	                ),
	                isSupportCanvas ? _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            textAlign: "center",
	                            margin: pinyin.length > 3 ? "0 auto" : "20px auto",
	                            paddingBottom: "20px",
	                            position: "relative"
	                        } },
	                    isShowBishun && textData && _react2.default.createElement(_BiShunCanvas2.default, {
	                        splitDelay: 1000,
	                        splitCallback: this.loop,
	                        fillColor: '#417BEE',
	                        crossColor: '#417BEE',
	                        textFillColor: '#cad8e4',
	                        canvasData: textData,
	                        width: 200,
	                        failCallback: this.canvasSupportError
	                    }),
	                    isShowBishun && !textData && _react2.default.createElement('img', { src: 'gif', alt: '' }),
	                    !isShowBishun && _react2.default.createElement(
	                        'div',
	                        { style: { height: '200px', lineHeight: "200px" } },
	                        '\u6B63\u5728\u52A0\u8F7D\u4E2D...'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: {
	                                marginTop: "15px",
	                                display: "flex",
	                                justifyContent: "center",
	                                flexWrap: "wrap",
	                                width: "65%",
	                                margin: "0 auto"
	                            } },
	                        arrBiShun.length > 0 ? arrBiShun.map(function (item, index) {
	                            // console.log(arrBiShun,'arrBiShun')
	                            var condition = controlIndex === index;
	                            var color = condition ? "green" : "#B4B4B4";
	                            // console.log(condition,'condition')
	                            return _react2.default.createElement(
	                                'span',
	                                {
	                                    style: { color: color, marginRight: "5px" },
	                                    key: "bishun" + index },
	                                item,
	                                !ifLast && _react2.default.createElement(_BuShouSpeaker2.default, {
	                                    controlIndex: controlIndex,
	                                    isCurrent: condition,
	                                    BuShou: item })
	                            );
	                        }) : ""
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'controlSpeed' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'speedBtn',
	                                onClick: function onClick() {
	                                    _this2.controlSpeed("fast");
	                                } },
	                            '\u5FEB'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'speedBtn',
	                                onClick: function onClick() {
	                                    _this2.controlSpeed("normal");
	                                } },
	                            '\u4E2D'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'speedBtn',
	                                onClick: function onClick() {
	                                    _this2.controlSpeed("slow");
	                                } },
	                            '\u6162'
	                        )
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    { style: { width: "200px", margin: "40px auto" } },
	                    _react2.default.createElement('img', { style: { width: "100%" },
	                        src: jif, alt: '' })
	                )
	            );
	        }
	    }]);
	
	    return BishunPlayer;
	}(_react.Component);
	
	exports.default = BishunPlayer;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var audioDemo = "https://bishunfile.qiaoxuesi.com/";
	
	var BuShouAudio = {
	    "点": audioDemo + encodeURI("点") + ".mp3",
	    "横": audioDemo + encodeURI("横") + ".mp3",
	    "横钩": audioDemo + encodeURI("横钩") + ".mp3",
	    "横撇": audioDemo + encodeURI("横撇") + ".mp3",
	    "横撇弯钩": audioDemo + encodeURI("横撇弯钩") + ".mp3",
	    "横斜钩": audioDemo + encodeURI("横斜钩") + ".mp3",
	    "横折": audioDemo + encodeURI("横折") + ".mp3",
	    "横折钩": audioDemo + encodeURI("横折钩") + ".mp3",
	    "横折弯": audioDemo + encodeURI("横折弯") + ".mp3",
	    "横折弯钩": audioDemo + encodeURI("横折弯钩") + ".mp3",
	    "横折折撇": audioDemo + encodeURI("横折折撇") + ".mp3",
	    "横折折折钩": audioDemo + encodeURI("横折折折钩") + ".mp3",
	    "捺": audioDemo + encodeURI("捺") + ".mp3",
	    "撇": audioDemo + encodeURI("撇") + ".mp3",
	    "撇点": audioDemo + encodeURI("撇点") + ".mp3",
	    "撇折": audioDemo + encodeURI("撇折") + ".mp3",
	    "竖": audioDemo + encodeURI("竖") + ".mp3",
	    "竖钩": audioDemo + encodeURI("竖钩") + ".mp3",
	    "竖提": audioDemo + encodeURI("竖提") + ".mp3",
	    "竖弯": audioDemo + encodeURI("竖弯") + ".mp3",
	    "竖弯钩": audioDemo + encodeURI("竖弯钩") + ".mp3",
	    "竖折": audioDemo + encodeURI("竖折") + ".mp3",
	    "竖折撇": audioDemo + encodeURI("竖折撇") + ".mp3",
	    "竖折折钩": audioDemo + encodeURI("竖折折钩") + ".mp3",
	    "提": audioDemo + encodeURI("提") + ".mp3",
	    "弯钩": audioDemo + encodeURI("弯钩") + ".mp3",
	    "弯折": audioDemo + encodeURI("弯折") + ".mp3",
	    "斜钩": audioDemo + encodeURI("斜钩") + ".mp3",
	    "折撇": audioDemo + encodeURI("折撇") + ".mp3",
	    "折折钩": audioDemo + encodeURI("折折钩") + ".mp3",
	    "横折提": audioDemo + encodeURI("横折提") + ".mp3",
	    // "竖折撇或竖折折": audioDemo + encodeURI("竖折撇或竖折折") + ".mp3",
	    "竖折折": audioDemo + encodeURI("竖折折") + ".mp3",
	    "横折折勾": audioDemo + encodeURI("横折折勾") + ".mp3"
	};
	
	var PinyinSpeaker = function (_Component) {
	    _inherits(PinyinSpeaker, _Component);
	
	    function PinyinSpeaker(props) {
	        _classCallCheck(this, PinyinSpeaker);
	
	        var _this = _possibleConstructorReturn(this, (PinyinSpeaker.__proto__ || Object.getPrototypeOf(PinyinSpeaker)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(PinyinSpeaker, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	
	            if (this.refs.music) {
	                this.refs.music.addEventListener("WeixinJSBridgeReady", function () {
	                    this.refs.music.audio.play();
	                }, false);
	            }
	        }
	
	        //销毁组件
	
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {}
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                BuShou = _props.BuShou,
	                isCurrent = _props.isCurrent;
	            // console.log(isCurrent,'isCurrent')
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    isCurrent ? _react2.default.createElement(
	                        "audio",
	                        {
	                            ref: isCurrent ? "music" : ""
	                            // autoPlay={isCurrent}
	                            , autoPlay: true,
	                            src: BuShouAudio[BuShou]
	                        },
	                        "\u8BE5\u6D4F\u89C8\u5668\u6682\u4E0D\u652F\u6301\u97F3\u9891"
	                    ) : ""
	                )
	            );
	        }
	    }]);
	
	    return PinyinSpeaker;
	}(_react.Component);
	
	exports.default = PinyinSpeaker;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PinyinSpeaker = function (_Component) {
	    _inherits(PinyinSpeaker, _Component);
	
	    function PinyinSpeaker(props) {
	        _classCallCheck(this, PinyinSpeaker);
	
	        var _this = _possibleConstructorReturn(this, (PinyinSpeaker.__proto__ || Object.getPrototypeOf(PinyinSpeaker)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(PinyinSpeaker, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {}
	
	        //销毁组件
	
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            // console.log('componentDidUnMount.....')
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                pinyin = _props.pinyin,
	                index = _props.index,
	                audioSrc = _props.audioSrc;
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: "audioBox_gk" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "audioPinyin" },
	                    pinyin
	                ),
	                _react2.default.createElement(
	                    "div",
	                    {
	                        onClick: function onClick() {
	                            if (index === 0) {
	                                _this2.refs.audio0.play();
	                            } else if (index === 1) {
	                                _this2.refs.audio1.play();
	                            } else if (index === 2) {
	                                _this2.refs.audio2.play();
	                            } else if (index === 3) {
	                                _this2.refs.audio3.play();
	                            } else if (index === 4) {
	                                _this2.refs.audio4.play();
	                            } else if (index === 5) {
	                                _this2.refs.audio5.play();
	                            } else if (index === 6) {
	                                _this2.refs.audio6.play();
	                            }
	                        },
	                        className: "textAudion" },
	                    _react2.default.createElement("img", {
	                        style: { width: "100%" },
	                        src: "https://img.qiaoxuesi.com/market/indexImg/1527126873904.PNG",
	                        alt: "\u5C0F\u5587\u53ED" }),
	                    _react2.default.createElement(
	                        "audio",
	                        { ref: "audio" + index,
	                            src: "" + audioSrc + index + ".mp3?v=" + new Date().getTime() },
	                        "\u8BE5\u6D4F\u89C8\u5668\u6682\u4E0D\u652F\u6301\u97F3\u9891"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PinyinSpeaker;
	}(_react.Component);
	
	exports.default = PinyinSpeaker;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(538);
	
	var _BishunPlayer = __webpack_require__(668);
	
	var _BishunPlayer2 = _interopRequireDefault(_BishunPlayer);
	
	var _reactHelmet = __webpack_require__(85);
	
	var _isomorphicFetch = __webpack_require__(93);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _video = __webpack_require__(302);
	
	var _video2 = _interopRequireDefault(_video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WordList = function (_Component) {
	    _inherits(WordList, _Component);
	
	    function WordList(props) {
	        _classCallCheck(this, WordList);
	
	        //获取书的索引
	        var _this = _possibleConstructorReturn(this, (WordList.__proto__ || Object.getPrototypeOf(WordList)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var _props$params = props.params,
	            presspinyin = _props$params.presspinyin,
	            bookId = _props$params.bookId,
	            wordId = _props$params.wordId;
	        //获取当前书的数据
	
	        _this.currentBookData = window.AllBooksForPress.filter(function (m) {
	            return m.presspinyin === presspinyin;
	        })[0]["books"][bookId];
	        // let {book_data: {lesson, courseBanner}, name} = this.currentBookData;
	        // console.log("this.currentBookData........", this.currentBookData)
	        _this.state = {
	            //显示de汉字
	            currentWord: '',
	            //当前汉字的数组
	            // currentWords: lesson[wordId].words,
	            currentWords: [],
	            //当前书本的名字
	            // currentBookName: name,
	            currentBookName: null,
	            //当前课程的名字
	            // currentLessonName: lesson[wordId].name,
	            currentLessonName: null,
	            //课程封面图
	            currentCoverImg: null,
	            // currentCoverImg: courseBanner,
	            videoUrl: null,
	            isUseVideoPlay: presspinyin === 'chuangyou' || presspinyin === 'sichuangchuangyou' ? true : false,
	            isHaveVideo: false,
	            detail: null
	        };
	        return _this;
	    }
	
	    _createClass(WordList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // console.log("componentDidMount........")
	            this.getWordList();
	        }
	
	        //卸载书本组件
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {}
	        // console.log('卸载书本组卷........')
	
	        //点击某个汉字 ，将亲北京色变为灰色
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                currentWord = _state.currentWord,
	                currentBookName = _state.currentBookName,
	                currentWords = _state.currentWords,
	                currentLessonName = _state.currentLessonName,
	                currentCoverImg = _state.currentCoverImg,
	                isHaveVideo = _state.isHaveVideo,
	                videoUrl = _state.videoUrl,
	                isUseVideoPlay = _state.isUseVideoPlay,
	                detail = _state.detail;
	            // let currentBookName=detail.book_name;
	            //分别为书本的索引和课时的索引
	
	            console.log("currentWord.....", currentLessonName);
	            // console.log("videoUrl.....", detail.course_banner)
	            return _react2.default.createElement(
	                'div',
	                { className: 'TextBoxArea' },
	                _react2.default.createElement(
	                    _reactHelmet.Helmet,
	                    null,
	                    _react2.default.createElement('meta', { name: 'gankao_sharable', content: '1' }),
	                    _react2.default.createElement('meta', { name: 'wx_share_title', content: currentBookName }),
	                    _react2.default.createElement('meta', { name: 'wx_share_content', content: currentLessonName }),
	                    _react2.default.createElement('meta', { name: 'wx_share_link', content: window.location.href }),
	                    _react2.default.createElement('meta', { name: 'wx_share_imgurl', content: currentCoverImg }),
	                    _react2.default.createElement(
	                        'title',
	                        null,
	                        currentBookName
	                    )
	                ),
	                !currentWord && _react2.default.createElement(
	                    'div',
	                    { className: 'bookCover' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'leftCoverImg' },
	                        _react2.default.createElement('img', {
	                            style: { height: "170px", border: "1px solid rgb(251, 245, 245)" },
	                            src: currentCoverImg,
	                            alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'lesson_name_gk' },
	                        currentLessonName
	                    )
	                ),
	                _react2.default.createElement('div', { style: { height: "10px", backgroundColor: "rgb(248, 248, 248)" } }),
	                isUseVideoPlay ? _react2.default.createElement(
	                    'div',
	                    { style: { margin: '10px 10px 0', overflow: 'hidden' } },
	                    currentWord && _react2.default.createElement(
	                        'div',
	                        null,
	                        currentWord && videoUrl !== null ? _react2.default.createElement('video', { id: 'custom-video',
	                            className: 'video-js',
	                            controls: true,
	                            preload: 'auto',
	                            style: { width: '100%' }
	                        }) : _react2.default.createElement(
	                            'div',
	                            { style: { textAlign: 'center' } },
	                            '\u89C6\u9891\u52A0\u8F7D\u2026\u2026'
	                        )
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    null,
	                    currentWord && _react2.default.createElement(_BishunPlayer2.default, {
	                        key: 'bishunplayer_' + this.state.currentWord,
	                        onBishunPlayerClosed: this.handleOnBishunPlayerClosed,
	                        word: currentWord
	                    })
	                ),
	                currentWord && _react2.default.createElement('div', { style: {
	                        height: "1px", position: "fixed", right: "0",
	                        left: "0", top: isHaveVideo ? "230px" : "338px", maxWidth: "768px",
	                        margin: "0 auto", boxShadow: "0 2px 4px #E5E5E5"
	                    } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'WordList',
	                        style: {
	                            top: isHaveVideo ? "270px" : currentWord ? "345px" : "215px",
	                            paddingTop: !isHaveVideo ? "40px" : "unset"
	                        } },
	                    currentWords.length > 0 ? currentWords.map(function (item, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            {
	                                onClick: function onClick() {
	                                    _this2.handleClickWord(item.word.trim(), item && (item.course ? item.course : 0));
	                                    _this2.setState({ currentWord: item.word.trim() });
	                                },
	                                className: 'textItemBox',
	                                key: "lesson" + index },
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    style: {
	                                        backgroundImage: item.isReaded ? "url(https://img.qiaoxuesi.com/market/indexImg/1528448292881.PNG)" : "url(https://img.qiaoxuesi.com/market/indexImg/1527057138792.PNG)"
	
	                                    },
	                                    className: 'textItem' },
	                                item.word
	                            )
	                        );
	                    }) : _react2.default.createElement(
	                        'div',
	                        { style: { color: "#666", fontSize: "24px", textAlign: "center" } },
	                        '\u52A0\u8F7D\u4E2D\u2026\u2026'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WordList;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.handleOnBishunPlayerClosed = function () {
	        _this3.setState({ currentWord: '' });
	    };
	
	    this.handleClickWord = function (word, courseid) {
	        var _state2 = _this3.state,
	            isUseVideoPlay = _state2.isUseVideoPlay,
	            currentWords = _state2.currentWords;
	        // console.log("word....", word)
	        // let {book_data: {lesson}} = this.currentBookData;
	
	        var wordId = _this3.props.params.wordId;
	        // let tmpWords = lesson[wordId].words;
	
	        var tmpWords = currentWords;
	        console.log("tmpWords.....", tmpWords);
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = tmpWords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var i = _step.value;
	
	                if (i.word.trim() === word) {
	                    i.isReaded = true;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        if (isUseVideoPlay) {
	            //汉字视频
	            var videoApiUrl = "https://www.gankao.com/api/video/playchinese";
	            (0, _isomorphicFetch2.default)(videoApiUrl, {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'application/json;charset=UTF-8'
	                },
	                body: JSON.stringify({
	                    char: word,
	                    courseid: courseid
	                })
	            }).then(function (res) {
	                res.json().then(function (videoData) {
	                    var playUrl = void 0;
	                    if (videoData.status === 200) {
	                        playUrl = videoData.data.videoUrl.normal;
	                        _this3.setState({ videoUrl: playUrl, isHaveVideo: true });
	
	                        var src = playUrl,
	                            height = 100,
	                            width = 100;
	                        _this3.player = (0, _video2.default)("custom-video", {
	                            height: height,
	                            width: width,
	                            bigPlayButton: true,
	                            textTrackDisplay: false,
	                            errorDisplay: false,
	                            controlBar: true,
	                            type: "application/x-mpegURL",
	                            color: 'Blue',
	                            constructor: true
	                        }, function () {
	                            this.play();
	                        });
	                        _this3.player.src({ src: src });
	                    } else {
	                        _this3.setState({ isHaveVideo: false });
	                    }
	                });
	            });
	        }
	
	        _this3.setState({ currentWords: tmpWords });
	    };
	
	    this.getWordList = function () {
	        (0, _isomorphicFetch2.default)('https://www.gankao.com/api/newWord/word?lesson_id=' + _this3.props.params.wordId, {
	            method: 'GET',
	            headers: {
	                'Content-Type': 'application/json'
	            }
	        }).then(function (res) {
	            return res.json();
	        }).then(function (data) {
	            if (data && data.status === 200) {
	                // console.log("获取单词列表成功:", data.data.detail);
	                var bookDetail = data.data.detail;
	                _this3.setState({
	                    currentWords: data.data.data,
	                    detail: bookDetail,
	                    currentBookName: bookDetail.book_name,
	                    currentLessonName: bookDetail.lesson_name,
	                    currentCoverImg: bookDetail.course_banner
	                });
	            }
	        }).catch(function (err) {
	            console.log('获取单词列表失败:', err);
	        });
	    };
	};
	
	exports.default = WordList;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * props参数说明
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * canvasData    必    从服务器取得的笔顺背景、填充数据
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * failCallback  必    canvas创建失败时调用
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * id            单页面使用超过1次后必    canvas计数器，页面存在多个该组件时使用，默认0，传入1时canvas的id为BSCanvas1
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * width         选    canvas宽度，默认100
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * mode          选    预设的播放模式，默认custom；有fast,slow可选，选择时覆盖drawDelay、splitDelay、loopDelay参数
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * drawDelay     选    一个笔顺填充动画的速率（ms），默认100，越大动画越慢
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * splitDelay    选    笔顺间的间隔（ms），默认500
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * loopDelay     选    循环的间隔（ms），默认1000
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * fillColor     选    动画填充的颜色，默认#333
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * bgColor       选    背景填充的颜色，默认#fff
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * crossColor    选    分割线的颜色，默认#aaa
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * textFillColor 选    文字背景填充颜色， 默认#fff
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * splitCallback 选    每一个笔画开始前调用，参数loop:boolean，true：笔画循环中，false：一整个笔顺流程结束
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * borderWidth   选    边框的宽度，默认1, 0时隐藏
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * */
	
	var BiShunCanvas = function (_React$Component) {
	    _inherits(BiShunCanvas, _React$Component);
	
	    function BiShunCanvas(props) {
	        _classCallCheck(this, BiShunCanvas);
	
	        // console.log("props.....",props)
	        var _this = _possibleConstructorReturn(this, (BiShunCanvas.__proto__ || Object.getPrototypeOf(BiShunCanvas)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var _props$id = props.id,
	            id = _props$id === undefined ? 0 : _props$id,
	            _props$mode = props.mode,
	            mode = _props$mode === undefined ? 'custom' : _props$mode,
	            _props$drawDelay = props.drawDelay,
	            drawDelay = _props$drawDelay === undefined ? 100 : _props$drawDelay,
	            _props$splitDelay = props.splitDelay,
	            splitDelay = _props$splitDelay === undefined ? 500 : _props$splitDelay,
	            _props$loopDelay = props.loopDelay,
	            loopDelay = _props$loopDelay === undefined ? 800 : _props$loopDelay;
	
	        _this.state = {
	            id: 'BSCanvas' + id,
	            drawDelay: mode === 'custom' ? drawDelay : mode === 'fast' ? 90 : 120,
	            splitDelay: mode === 'custom' ? splitDelay : mode === 'fast' ? 300 : 1000,
	            loopDelay: mode === 'custom' ? loopDelay : mode === 'fast' ? 300 : 1000
	        };
	        _this.unMounted = false;
	        return _this;
	    }
	
	    _createClass(BiShunCanvas, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var failCallback = this.props.failCallback;
	
	            var canvas = document.getElementById(this.state.id); //获得画布元素
	            var ctx = canvas.getContext('2d'); //获得画笔
	            if (!ctx) failCallback();else this.drawContainer(ctx);
	        }
	        //销毁组件
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.unMounted = true;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // console.log("nextProps.........",nextProps)
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$width = this.props.width,
	                width = _props$width === undefined ? 100 : _props$width;
	
	            return _react2.default.createElement('canvas', { id: this.state.id, width: width, height: width });
	        }
	    }]);
	
	    return BiShunCanvas;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.drawContainer = function (ctx) {
	        var _props = _this2.props,
	            _props$width2 = _props.width,
	            width = _props$width2 === undefined ? 100 : _props$width2,
	            _props$bgColor = _props.bgColor,
	            bgColor = _props$bgColor === undefined ? '#fff' : _props$bgColor,
	            _props$borderWidth = _props.borderWidth,
	            borderWidth = _props$borderWidth === undefined ? 1 : _props$borderWidth,
	            _props$crossColor = _props.crossColor,
	            crossColor = _props$crossColor === undefined ? '#aaa' : _props$crossColor;
	
	
	        ctx.fillStyle = bgColor;
	        ctx.fillRect(0, 0, width, width); //fillRect(x,y,width,height) 方法定义了矩形当前的填充方式。
	        if (borderWidth) {
	            ctx.lineWidth = 1;
	            ctx.strokeStyle = "#bbb"; //线的颜色
	            ctx.strokeRect(0, 0, width, width);
	        }
	        ctx.lineWidth = borderWidth;
	        ctx.strokeStyle = crossColor;
	        ctx.setLineDash([5, 8]); //shixianbufen
	        ctx.beginPath();
	        ctx.moveTo(width / 2, 0); //线条开始坐标
	        ctx.lineTo(width / 2, width); //线条结束坐标
	        ctx.moveTo(0, width / 2);
	        ctx.lineTo(width, width / 2);
	        ctx.setLineDash([5, 10]);
	        ctx.moveTo(0, 0);
	        ctx.lineTo(width, width);
	        ctx.moveTo(0, width);
	        ctx.lineTo(width, 0);
	        ctx.stroke();
	
	        _this2.drawText(ctx);
	    };
	
	    this.drawText = function (ctx) {
	        var _props2 = _this2.props,
	            canvasData = _props2.canvasData,
	            _props2$width = _props2.width,
	            width = _props2$width === undefined ? 100 : _props2$width,
	            _props2$textFillColor = _props2.textFillColor,
	            textFillColor = _props2$textFillColor === undefined ? '#fff' : _props2$textFillColor;
	        var textBg = canvasData.textBg;
	
	
	        ctx.lineWidth = 2;
	        ctx.setLineDash([1]);
	        ctx.strokeStyle = "#cad8e4";
	        ctx.fillStyle = '#cad8e4';
	        var GroupLen = textBg.length;
	        while (GroupLen--) {
	            ctx.beginPath();
	            var len = 0;
	            while (len < textBg[GroupLen].length) {
	                var x = textBg[GroupLen][len][0] * width / 760;
	                var y = textBg[GroupLen][len][1] * width / 760;
	                if (len === 0) ctx.moveTo(x, y);else ctx.lineTo(x, y);
	                len++;
	            }
	            ctx.closePath();
	            ctx.fillStyle = textFillColor;
	            ctx.fill();
	            ctx.stroke();
	        }
	        ctx.beginPath();
	        ctx.closePath();
	        ctx.stroke();
	
	        _this2.drawTextTimeount = setTimeout(function () {
	            _this2.fillAnimation(ctx, 0, 0);
	        }, 500);
	    };
	
	    this.fillAnimation = function (ctx, groupIndex, partIndex) {
	        if (_this2.unMounted) return null;
	
	        var _props3 = _this2.props,
	            canvasData = _props3.canvasData,
	            _props3$width = _props3.width,
	            width = _props3$width === undefined ? 100 : _props3$width,
	            _props3$fillColor = _props3.fillColor,
	            fillColor = _props3$fillColor === undefined ? '#333' : _props3$fillColor,
	            splitCallback = _props3.splitCallback;
	        var _state = _this2.state,
	            drawDelay = _state.drawDelay,
	            splitDelay = _state.splitDelay,
	            loopDelay = _state.loopDelay;
	        var textFill = canvasData.textFill;
	
	
	        ctx.setLineDash([]);
	        ctx.lineWidth = 2;
	        ctx.strokeStyle = fillColor;
	        ctx.lineJoin = "round";
	        ctx.lineCap = "round";
	
	        if (splitCallback && !textFill[groupIndex]) splitCallback({ loop: false });else if (splitCallback && partIndex === 0) splitCallback({ loop: true });
	
	        if (groupIndex >= textFill.length) {
	            _this2.loopTimeount = setTimeout(function () {
	                _this2.drawContainer(ctx);
	            }, loopDelay);
	        } else {
	            var prePartIndex = partIndex;
	            partIndex = Math.min(textFill[groupIndex].length, partIndex + 50);
	
	            var len = prePartIndex;
	            while (len < partIndex) {
	                var x = textFill[groupIndex][len][0] * width / 760;
	                var y = textFill[groupIndex][len][1] * width / 760;
	                if (len === prePartIndex) ctx.moveTo(x, y);else ctx.lineTo(x, y);
	                len++;
	            }
	            ctx.stroke();
	
	            if (partIndex >= textFill[groupIndex].length) {
	                _this2.fillTimeount = setTimeout(function () {
	                    _this2.fillAnimation(ctx, groupIndex + 1, 0);
	                }, splitDelay);
	            } else {
	                _this2.fillTimeount = setTimeout(function () {
	                    _this2.fillAnimation(ctx, groupIndex, partIndex);
	                }, drawDelay);
	            }
	        }
	    };
	};
	
	exports.default = BiShunCanvas;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(87);
	
	var _lodash = __webpack_require__(566);
	
	__webpack_require__(539);
	
	var _reactHelmet = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import * as Router from "lodash";
	// import {Router} from'react-router'
	var WordList = function (_Component) {
	    _inherits(WordList, _Component);
	
	    function WordList(props) {
	        _classCallCheck(this, WordList);
	
	        var _this = _possibleConstructorReturn(this, (WordList.__proto__ || Object.getPrototypeOf(WordList)).call(this, props));
	
	        _this.hanZi = function (currentBookData, nowWords) {
	            var data = currentBookData;
	            //出版社提供所有的汉字
	            var arrWords = [];
	            //当前抓取到的汉字
	            nowWords = nowWords.replace(/[ ]/g, "").split("");
	            //出版社汉字 我们这边没有抓取到的
	            var noHaveWords = [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var d = _step.value;
	                    var _iteratorNormalCompletion3 = true;
	                    var _didIteratorError3 = false;
	                    var _iteratorError3 = undefined;
	
	                    try {
	                        for (var _iterator3 = d.books[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                            var _i = _step3.value;
	
	                            // console.log(i)
	                            var _iteratorNormalCompletion4 = true;
	                            var _didIteratorError4 = false;
	                            var _iteratorError4 = undefined;
	
	                            try {
	                                for (var _iterator4 = _i.book_data.lesson[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                                    var j = _step4.value;
	
	                                    // console.log(j)
	                                    var _iteratorNormalCompletion5 = true;
	                                    var _didIteratorError5 = false;
	                                    var _iteratorError5 = undefined;
	
	                                    try {
	                                        for (var _iterator5 = j.words[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                                            var h = _step5.value;
	
	                                            // console.log(h)
	                                            arrWords.push(h.word);
	                                        }
	                                    } catch (err) {
	                                        _didIteratorError5 = true;
	                                        _iteratorError5 = err;
	                                    } finally {
	                                        try {
	                                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                                                _iterator5.return();
	                                            }
	                                        } finally {
	                                            if (_didIteratorError5) {
	                                                throw _iteratorError5;
	                                            }
	                                        }
	                                    }
	                                }
	                            } catch (err) {
	                                _didIteratorError4 = true;
	                                _iteratorError4 = err;
	                            } finally {
	                                try {
	                                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                                        _iterator4.return();
	                                    }
	                                } finally {
	                                    if (_didIteratorError4) {
	                                        throw _iteratorError4;
	                                    }
	                                }
	                            }
	                        }
	                    } catch (err) {
	                        _didIteratorError3 = true;
	                        _iteratorError3 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                                _iterator3.return();
	                            }
	                        } finally {
	                            if (_didIteratorError3) {
	                                throw _iteratorError3;
	                            }
	                        }
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = arrWords[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var i = _step2.value;
	
	                    var a = nowWords.indexOf(i);
	                    if (a < 0) {
	                        noHaveWords.push(i);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            var obj = {};
	            obj.hanZi = noHaveWords.join();
	            obj.arrHanZi = noHaveWords;
	            // console.log("未抓取到的汉字.......")
	            // console.log(obj)
	            return obj;
	        };
	
	        _this.getBooksByPress = function () {
	            fetch('https://www.gankao.com/api/newWord/getBooksByPress?press=' + _this.props.params.presspinyin, {
	                method: 'GET',
	                headers: {
	                    'Content-Type': 'application/json'
	                }
	            }).then(function (res) {
	                return res.json();
	            }).then(function (data) {
	                // console.log("获取出版社列表成功:", data.data);
	                if (data && data.status === 200) {
	                    // this.bishun_data = data.data;
	                    _this.setState({});
	                    _this.setState({ bookData: data.data, pressname: data.data[0].pressName });
	                }
	            }).catch(function (err) {
	                console.log('获取出版社列表失败:1', err);
	            });
	        };
	
	        _this.state = {
	            bookData: [],
	            pressname: ''
	        };
	        return _this;
	    }
	
	    _createClass(WordList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var word = "一 乙二 十 丁 蟋 蟀 吟 吱 舔 豫 跺 晾 瞪 瞅眶睹 厂 七  哦 卜 橙 人 入 八 九 几 儿 蒲 了 力 乃 刀 又三 于 干 亏 士 工 土 才 寸 下 大 丈 与 万 上 小 口 巾 山 千 乞 川 亿 个 勺 久 凡 及 夕 丸 么广亡门 义 之 尸 弓 己 已 子 卫 也 女 飞 刃 习 叉 马 乡丰 王 井 开 夫 天 无 元专 云 扎 艺 木 五 支 厅 不 太 犬 区 历 尤 友 匹 车 巨 牙 屯 比 互 切 瓦止少 日 中 冈 贝 内 水 见 午 牛 手 毛 气 升 长仁 什 片 仆 化 仇 币 仍 仅 斤 爪 反 介 父 从 今 凶 分乏公 仓 月 氏 勿 欠 风 丹 匀 乌 凤 勾 文 六 方 火 为 斗 忆 订 计户 认 心 尺 引 丑 巴 孔 队 办 以 允予劝 双 书 幻玉 刊 示 末 未 击 打 巧正 扑 扒 功 扔 去 甘 世 古 节 本 术 可 丙 左 厉 右 石 布 龙 平 灭 轧 东卡北 占 业 旧 帅 归 且 旦 目 叶 甲 申 叮 电 号田 由 史 只 央 兄 叼 叫 另 叨 叹 四 生 失 禾 丘 付 仗代仙 们 仪 白 仔 他 斥 瓜 乎 丛 令 用 甩 印 乐 句 匆 册 犯 外 处冬 鸟 务 包 饥 主 市 立 闪 兰 半 汁汇头 汉 宁 穴 它 讨 写 让 礼 训 必 议 讯 记 永 司 尼 民 出 辽 奶 奴 加 召 皮 边 发孕 圣 对 台 矛 纠母幼 丝式 刑 动 扛 寺 吉 扣 考托 老 执 巩 圾 扩 扫 地 扬 场 耳 共 芒 亚 芝 朽 朴 机 权 过 臣 再 协 西压厌 在 有 百 存 而 页 匠 夸 夺 灰 达 列 死 成夹 轨 邪 划 迈 毕 至 此 贞 师 尘 尖 劣 光 当 早 吐 吓虫曲 团 同 吊 吃 因 吸 吗 屿 帆 岁 回 岂 刚 则 肉 网 年 朱 先 丢舌 竹 迁 乔 伟 传 乒 乓 休 伍 伏 优伐延 件 任 伤 价 份 华 仰 仿 伙 伪 自 血 向 似 后 行 舟 全 会 杀 合 兆 企 众 爷 伞创 肌 朵 杂 危 旬旨负 各 名 多 争 色 壮 冲 冰 庄 庆 亦 刘 齐 交 次 衣 产 决 充 妄 闭 问 闯 羊 并 关 米 灯 州 汗 污江池汤 忙 兴 宇 守 宅 字 安 讲 军 许 论 农 讽 设 访 寻 那 迅 尽 导 异 孙 阵 阳 收 阶 阴 防 奸 如 妇 好她妈 戏 羽 观 欢买 红 纤 级 约 纪 驰 巡寿 弄 麦 形 进 戒 吞 远违 运 扶 抚 坛 技 坏 扰 拒 找 批 扯 址 走 抄 坝 贡 攻 赤 折 抓 扮 抢 孝均抛 投 坟 抗 坑 坊 抖 护 壳 志 扭 块 声 把 报却 劫 芽 花 芹 芬 苍 芳 严 芦 劳 克 苏 杆 杠 杜 材 村杏极 李 杨 求 更 束 豆 两 丽 医 辰 励 否 还 歼 来 连 步 坚 旱 盯呈 时 吴 助 县 里 呆 园 旷 围 呀 吨足邮 男 困 吵 串 员 听 吩 吹 呜 吧 吼 别 岗 帐 财 针 钉 告 我 乱 利 秃 秀 私 每 兵估 体 何 但 伸 作伯伶 佣 低 你 住 位 伴 身 皂 佛 近 彻 役 返 余 希 坐 谷 妥 含 邻 岔 肝 肚 肠 龟 免 狂 犹 角 删 条卵岛迎 饭 饮 系 言 冻 状 亩 况 床 库 疗 应 冷 这 序 辛 弃 冶 忘 闲 间 闷 判 灶 灿 弟 汪 沙 汽 沃 泛 沟没沈 沉 怀 忧 快完 宋 宏 牢 究 穷 灾 良 证 启 评 补 初 社 识 诉 诊 词 译 君 灵 即 层 尿 尾 迟 局 改张忌 际 陆 阿 陈 阻 附 妙 妖 妨 努忍 劲 鸡 驱 纯 纱 纳 纲 驳 纵 纷 纸 纹 纺 驴 纽奉 玩 环 武 青 责 现 表规 抹 拢 拔 拣 担 坦 押 抽 拐 拖 拍 者 顶 拆 拥 抵 拘 势 抱 垃 拉 拦 拌幸招 坡 披 拨 择 抬 其 取 苦 若 茂 苹 苗 英 范直 茄 茎 茅 林 枝 杯 柜 析 板 松 枪 构 杰 述 枕 丧 或画卧 事 刺 枣 雨 卖 矿 码 厕 奔 奇 奋 态 欧 垄 妻 轰 顷 转 斩 轮软 到 非 叔 肯 齿 些 虎 虏 肾 贤 尚旺具 果 味 昆 国 昌 畅 明 易 昂 典 固 忠 咐 呼 鸣 咏 呢 岸 岩 帖 罗 帜 岭 凯 败 贩购 图 钓 制 知 垂牧物 乖 刮 秆 和 季 委 佳 侍 供 使 例 版 侄 侦 侧 凭 侨 佩 货 依 的 迫 质 欣 征 往 爬 彼 径 所 舍金命斧 爸 采 受 乳 贪 念 贫 肤 肺 肢 肿 胀 朋 股 肥 服 胁 周 昏 鱼 兔 狐 忽 狗 备 饰 饱 饲 变 京 享 店夜庙 府 底 剂 郊废 净 盲 放 刻 育 闸 闹 郑 券 卷 单 炒 炊 炕 炎 炉 沫 浅 法 泄 河 沾 泪 油 泊 沿 泡注泻 泳 泥 沸 波 泼 泽 治 怖 性 怕怜 怪 学 宝 宗 定 宜 审 宙 官 空 帘 实 试 郎 诗 肩 房 诚 衬 衫 视话诞 询 该 详 建 肃 录 隶 居 届 刷 屈 弦 承 孟 孤 陕降 限 妹 姑 姐 姓 始 驾 参 艰 线 练 组 细 驶 织终驻 驼 绍 经 贯奏 春 帮 珍 玻 毒 型 挂封 持 项 垮 挎 城 挠 政 赴 赵 挡 挺 括 拴 拾 挑 指 垫 挣 挤 拼 挖 按 挥挪某 甚 革 荐 巷 带 草 茧 茶 荒 茫 荡 荣 故 胡南 药 标 枯 柄 栋 相 查 柏 柳 柱 柿 栏 树 要 咸 威 歪研砖 厘 厚 砌 砍 面 耐 耍 牵 残 殃 轻 鸦 皆 背 战 点 临 览 竖 省削 尝 是 盼 眨 哄 显 哑 冒 映 星 昨畏趴 胃 贵 界 虹 虾 蚁 思 蚂 虽 品 咽 骂 哗 咱 响 哈 咬 咳 哪 炭 峡 罚 贱 贴 骨 钞钟 钢 钥 钩 卸 缸拜看 矩 怎 牲 选 适 秒 香 种 秋 科 重 复 竿 段 便 俩 贷 顺 修 保 促 侮 俭 俗 俘 信 皇 泉 鬼 侵 追俊盾待 律 很 须 叙 剑 逃 食 盆 胆 胜 胞 胖 脉 勉 狭 狮 独 狡 狱 狠 贸 怨 急 饶 蚀 饺 饼 弯 将 奖 哀 亭亮度 迹 庭 疮 疯疫 疤 姿 亲 音 帝 施 闻 阀 阁 差 养 美 姜 叛 送 类 迷 前 首 逆 总 炼 炸 炮 烂 剃 洁洪洒 浇 浊 洞 测 洗 活 派 洽 染 济洋 洲 浑 浓 津 恒 恢 恰 恼 恨 举 觉 宣 室 宫 宪 突 穿 窃 客 冠 语扁袄 祖 神 祝 误 诱 说 诵 垦 退 既 屋 昼 费 陡 眉 孩除 险 院 娃 姥 姨 姻 娇 怒 架 贺 盈 勇 怠 柔 垒绑绒 结 绕 骄 绘 给 络 骆 绝 绞 统耕 耗 艳 泰 珠 班 素 蚕顽 盏 匪 捞 栽 捕 振 载 赶 起 盐 捎 捏 埋 捉 捆 捐 损 都 哲 逝 捡 换 挽热恐 壶 挨 耻 耽 恭 莲 莫 荷 获 晋 恶 真 框 桂档 桐 株 桥 桃 格 校 核 样 根 索 哥 速 逗 栗 配 翅 辱唇夏 础 破 原 套 逐 烈 殊 顾 轿 较 顿 毙 致 柴 桌 虑 监 紧 党 晒眠 晓 鸭 晃 晌 晕 蚊 哨 哭 恩 唤 啊唉罢 峰 圆 贼 贿 钱 钳 钻 铁 铃 铅 缺 氧 特 牺 造 乘 敌 秤 租 积 秧 秩 称 秘 透 笔笑 笋 债 借 值 倚倾倒 倘 俱 倡 候 俯 倍 倦 健 臭 射 躬 息 徒 徐 舰 舱 般 航 途 拿 爹 爱 颂 翁 脆 脂 胸 胳 脏 胶 脑狸狼逢 留 皱 饿 恋 桨 浆 衰 高 席 准 座 脊 症 病 疾 疼 疲 效 离 唐 资 凉 站 剖 竞 部 旁 旅 畜 阅 羞 瓶拳粉 料 益 兼 烤烘 烦 烧 烛 烟 递 涛 浙 涝 酒 涉 消 浩 海 涂 浴 浮 流 润 浪 浸 涨 烫 涌 悟 悄 悔 悦害宽 家 宵 宴 宾 窄 容 宰 案 请 朗诸 读 扇 袜 袖 袍 被 祥 课 谁 调 冤 谅 谈 谊 剥 恳 展 剧 屑 弱 陵陶陷 陪 娱 娘 通 能 难 预 桑 绢 绣 验 继球 理 捧 堵 描 域 掩 捷排 掉 堆 推 掀 授 教 掏 掠 培 接 控 探 据 掘 职 基 著 勒 黄 萌 萝 菌 菜萄菊 萍 菠 营 械 梦 梢 梅 检 梳 梯 桶 救 副 票戚 爽 聋 袭 盛 雪 辅 辆 虚 雀 堂 常 匙 晨 睁 眯 眼 悬野啦 晚 啄 距 跃 略 蛇 累 唱 患 唯 崖 崭 崇 圈 铜 铲 银 甜 梨 犁移 笨 笼 笛 符 第 敏 做 袋 悠 偿 偶偷您 售 停 偏 假 得 衔 盘 船 斜 盒 鸽 悉 欲 彩 领 脚  脸 脱 象 够 猜 猪 猎 猫 猛馅 馆 凑 减 毫 麻痒痕 廊 康 庸 鹿 盗 章 竟 商 族 旋 望 率 着 盖 粘 粗 粒 断 剪 兽 清 添 淋 淹 渠 渐 混 渔 淘 液 淡深婆梁 渗 情 惜 惭 悼 惧 惕 惊 惨 惯 寇 寄 宿 窑 密 谋 谎 祸 谜 逮 敢 屠 弹 随 蛋 隆 隐 婚 婶 颈 绩 绪续骑 绳 维 绵 绸绿琴 斑 替 款 堪 搭 塔 越趁 趋 超 提 堤 博 揭 喜 插 揪 搜 煮 援 裁 搁 搂 搅 握 揉 斯 期 欺 联 散惹葬 葛 董 葡 敬 葱 落 朝 辜 葵 棒 棋 植 森 椅椒 棵 棍 棉 棚 棕 惠 惑 逼 厨 厦 硬 确 雁 殖 裂 雄 暂雅辈 悲 紫 辉 敞 赏 掌 晴 暑 最 量 喷 晶 喇 遇 喊 景 践 跌 跑 遗蛙 蛛 蜓 喝 喂 喘 喉 幅 帽 赌 赔 黑铸铺 链 销 锁 锄 锅 锈 锋 锐 短 智 毯 鹅 剩 稍 程 稀 税 筐 等 筑 策 筛 筒 答 筋 筝傲 傅 牌 堡 集 焦傍储 奥 街 惩 御 循 艇 舒 番 释 禽 腊 脾 腔 鲁 猾 猴 然 馋 装 蛮 就 痛 童 阔 善 羡 普 粪 尊 道 曾焰港湖 渣 湿 温 渴 滑 湾 渡 游 滋 溉 愤 慌 惰 愧 愉 慨 割 寒 富 窜 窝 窗 遍 裕 裤 裙 谢 谣 谦 属 屡 强粥疏 隔 隙 絮 嫂登 缎 缓 编 骗 缘瑞 魂 肆 摄 摸 填 搏 塌鼓 摆 携 搬 摇 搞 塘 摊 蒜 勤 鹊 蓝 墓 幕 蓬 蓄 蒙 蒸 献 禁 楚 想 槐 榆楼概 赖 酬 感 碍 碑 碎 碰 碗 碌 雷 零 雾 雹 输督 龄 鉴 睛 睡 睬 鄙 愚 暖 盟 歇 暗 照 跨 跳 跪 路 跟遣蛾 蜂 嗓 置 罪 罩 错 锡 锣 锤 锦 键 锯 矮 辞 稠 愁 筹 签 简 毁舅 鼠 催 傻 像 躲 微 愈 遥 腰 腥 腹腾腿 触 解 酱 痰 廉 新 韵 意 粮 数 煎 塑 慈 煤 煌 满 漠 源 滤 滥 滔 溪 溜 滚 滨 粱滩 慎 誉 塞 谨 福群殿 辟 障 嫌 嫁 叠 缝 缠静 碧 璃 墙 撇 嘉 摧 截誓 境 摘 摔 聚 蔽 慕 暮 蔑 模 榴 榜 榨 歌 遭 酷 酿 酸 磁 愿 需 弊 裳 颗嗽蜻 蜡 蝇 蜘 赚 锹 锻 舞 稳 算 箩 管 僚 鼻 魄貌 膜 膊 膀 鲜 疑 馒 裹 敲 豪 膏 遮 腐 瘦 辣 竭 端 旗精歉 熄 熔 漆 漂 漫 滴 演 漏 慢 寨 赛 察 蜜 谱 嫩 翠 熊 凳 骡 缩慧 撕 撒 趣 趟 撑 播 撞撤 增 聪 鞋 蕉 蔬 横 槽 樱 橡 飘 醋 醉 震 霉 瞒 题 暴 瞎 影 踢 踏 踩 踪蝶蝴 嘱 墨 镇 靠 稻 黎 稿 稼 箱 箭 篇 僵 躺 僻德 艘 膝 膛 熟 摩 颜 毅 糊 遵 潜 潮 懂 额 慰 劈操 燕 薯 薪 薄 颠 橘 整融 醒 餐 嘴 蹄 器 赠 默 镜 赞 篮 邀 衡 膨 雕 磨 凝 辨 辩 糖 糕 燃 澡 激懒壁 避 缴戴 擦 鞠 藏 霜 霞 瞧 蹈螺 穗 繁 辫 赢 糟 糠 燥 臂 翼 骤鞭 覆 蹦 镰 翻 鹰警 攀 蹲 颤 瓣 爆 疆壤 耀 躁 嚼 嚷 籍 魔 灌蠢 霸 露囊罐篷枫杉椰骏猩鹤羚蚯蚓螃蟹 橙哦蒲蟋蟀吟吱舔豫跺晾瞪瞅眶睹蝌蚪鲤 鲫 鲨 籽 嘻 屎 屁 艾 邓 妆 咨 腻 邦 陀 厢 窟 窿 帚 簸 箕 炬 龇鼾鼎黯黧麓鹭鹫鹦鹉鹃鹂鸿鸳鸯鸥鳞鳖鳍鳄鳃鲸鲍魏魁鬓髻髓骚骋骇驮馨馍饵饯颖颓频颐颌颊颇颅颁韭靴靡霹辗辕辑辍轼轴躯蹿蹭蹬蹒蹑蹋踱踮跷跛跚跋赭赐赋赊贮账豹豕豌谭谧谚谙谓谐诺诳诲诬诫 毽 萤 脖";
	            var pressData = (0, _lodash.filter)(window.AllBooksForPress || [], function (m) {
	                return m.presspinyin === _this2.props.params.presspinyin;
	            });
	            if (pressData.length === 0) {}
	            //TODO: show error on page...
	
	            // console.log("pressData.....", pressData)
	            var _pressData$ = pressData[0],
	                pressname = _pressData$.pressname,
	                books = _pressData$.books;
	            // this.setState({bookData: books, pressname})
	
	            this.hanZi(window.AllBooksForPress, word);
	            this.getBooksByPress();
	        }
	
	        /**
	         *过滤汉字
	         * @param currentBookData  当前书本的所有json数据
	         * @param nowWords         当前系统抓取到的汉字
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                bookData = _state.bookData,
	                pressname = _state.pressname;
	            var presspinyin = this.props.params.presspinyin;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'bookListBox' },
	                this.props.children && this.props.children,
	                !this.props.children && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactHelmet.Helmet,
	                        null,
	                        _react2.default.createElement(
	                            'title',
	                            null,
	                            pressname
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'bookListGk' },
	                        bookData.map(function (item, index) {
	                            // console.log(item,222)
	                            return _react2.default.createElement(
	                                _reactRouter.Link
	                                //     to={{
	                                //     pathname:`/press/${presspinyin}/book/${index}/subject/${item.name}`,
	                                // }}
	                                ,
	                                { to: '/press/' + presspinyin + '/book/' + item.id,
	                                    key: "bookItem" + item.id
	                                },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bookItem' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'bookImg', style: { width: '90px', marginRight: "15px" } },
	                                        _react2.default.createElement('img', { style: { width: "100%", height: "100%" }, src: item.courseBanner,
	                                            alt: '\u56FE\u4E66\u5C01\u9762' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'bookInfo' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'version', style: { fontSize: "14px", color: "black" } },
	                                            '\u8BED\u6587(\u4EBA\u6559\u7248)'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'grade', style: { color: "#999999", fontSize: "13px" } },
	                                            item.name
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'clickIcon' },
	                                        '>'
	                                    )
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WordList;
	}(_react.Component);
	
	exports.default = WordList;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * props参数说明
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * canvasData    必    从服务器取得的笔顺背景、填充数据
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * failCallback  必    canvas创建失败时调用
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * id            单页面使用超过1次后必    canvas计数器，页面存在多个该组件时使用，默认0，传入1时canvas的id为BSCanvas1
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * width         选    canvas宽度，默认100
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * mode          选    预设的播放模式，默认custom；有fast,slow可选，选择时覆盖drawDelay、splitDelay、loopDelay参数
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * drawDelay     选    一个笔顺填充动画的速率（ms），默认100，越大动画越慢
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * splitDelay    选    笔顺间的间隔（ms），默认500
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * loopDelay     选    循环的间隔（ms），默认1000
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * fillColor     选    动画填充的颜色，默认#333
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * bgColor       选    背景填充的颜色，默认#fff
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * crossColor    选    分割线的颜色，默认#aaa
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * textFillColor 选    文字背景填充颜色， 默认#fff
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * splitCallback 选    每一个笔画开始前调用，参数loop:boolean，true：笔画循环中，false：一整个笔顺流程结束
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * borderWidth   选    边框的宽度，默认1, 0时隐藏
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * */
	
	var BiShunCanvas = function (_React$Component) {
	    _inherits(BiShunCanvas, _React$Component);
	
	    function BiShunCanvas(props) {
	        _classCallCheck(this, BiShunCanvas);
	
	        var _this = _possibleConstructorReturn(this, (BiShunCanvas.__proto__ || Object.getPrototypeOf(BiShunCanvas)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        console.log("props.....kll", props);
	        var _props$id = props.id,
	            id = _props$id === undefined ? 0 : _props$id,
	            _props$mode = props.mode,
	            mode = _props$mode === undefined ? 'custom' : _props$mode,
	            _props$drawDelay = props.drawDelay,
	            drawDelay = _props$drawDelay === undefined ? 100 : _props$drawDelay,
	            _props$splitDelay = props.splitDelay,
	            splitDelay = _props$splitDelay === undefined ? 500 : _props$splitDelay,
	            _props$loopDelay = props.loopDelay,
	            loopDelay = _props$loopDelay === undefined ? 800 : _props$loopDelay;
	
	        _this.state = {
	            id: 'BSCanvas' + id,
	            drawDelay: mode === 'custom' ? drawDelay : mode === 'fast' ? 90 : 120,
	            splitDelay: mode === 'custom' ? splitDelay : mode === 'fast' ? 300 : 1000,
	            loopDelay: mode === 'custom' ? loopDelay : mode === 'fast' ? 300 : 1000
	        };
	        _this.unMounted = false;
	        return _this;
	    }
	
	    _createClass(BiShunCanvas, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var failCallback = this.props.failCallback;
	
	            var canvas = document.getElementById(this.state.id); //获得画布元素
	            var ctx = canvas.getContext('2d'); //获得画笔
	            if (!ctx) failCallback();else this.drawContainer(ctx);
	        }
	        //销毁组件
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.unMounted = true;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // console.log("nextProps.........",nextProps)
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$width = this.props.width,
	                width = _props$width === undefined ? 100 : _props$width;
	
	            return _react2.default.createElement('canvas', { id: this.state.id, width: width, height: width });
	        }
	    }]);
	
	    return BiShunCanvas;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.drawContainer = function (ctx) {
	        var _props = _this2.props,
	            _props$width2 = _props.width,
	            width = _props$width2 === undefined ? 100 : _props$width2,
	            _props$bgColor = _props.bgColor,
	            bgColor = _props$bgColor === undefined ? '#fff' : _props$bgColor,
	            _props$borderWidth = _props.borderWidth,
	            borderWidth = _props$borderWidth === undefined ? 1 : _props$borderWidth,
	            _props$crossColor = _props.crossColor,
	            crossColor = _props$crossColor === undefined ? '#aaa' : _props$crossColor;
	
	
	        ctx.fillStyle = bgColor;
	        ctx.fillRect(0, 0, width, width); //fillRect(x,y,width,height) 方法定义了矩形当前的填充方式。
	        if (borderWidth) {
	            ctx.lineWidth = 1;
	            ctx.strokeStyle = "#bbb"; //线的颜色
	            ctx.strokeRect(0, 0, width, width);
	        }
	        ctx.lineWidth = borderWidth;
	        ctx.strokeStyle = crossColor;
	        ctx.setLineDash([5, 8]); //shixianbufen
	        ctx.beginPath();
	        ctx.moveTo(width / 2, 0); //线条开始坐标
	        ctx.lineTo(width / 2, width); //线条结束坐标
	        ctx.moveTo(0, width / 2);
	        ctx.lineTo(width, width / 2);
	        ctx.setLineDash([5, 10]);
	        ctx.moveTo(0, 0);
	        ctx.lineTo(width, width);
	        ctx.moveTo(0, width);
	        ctx.lineTo(width, 0);
	        ctx.stroke();
	
	        _this2.drawText(ctx);
	    };
	
	    this.drawText = function (ctx) {
	        var _props2 = _this2.props,
	            canvasData = _props2.canvasData,
	            _props2$width = _props2.width,
	            width = _props2$width === undefined ? 100 : _props2$width,
	            _props2$textFillColor = _props2.textFillColor,
	            textFillColor = _props2$textFillColor === undefined ? '#fff' : _props2$textFillColor;
	        var textBg = canvasData.textBg;
	        // console.log(textBg);
	
	        ctx.lineWidth = 2;
	        ctx.setLineDash([1]);
	        ctx.strokeStyle = "#cad8e4";
	        ctx.fillStyle = '#cad8e4';
	        var GroupLen = textBg.length;
	        while (GroupLen--) {
	            ctx.beginPath();
	            var len = 0;
	            while (len < textBg[GroupLen].length) {
	                var x = textBg[GroupLen][len][0] * width / 760;
	                var y = textBg[GroupLen][len][1] * width / 760;
	                if (len === 0) ctx.moveTo(x, y);else ctx.lineTo(x, y);
	                len++;
	            }
	            ctx.closePath();
	            ctx.fillStyle = textFillColor;
	            ctx.fill();
	            ctx.stroke();
	        }
	        ctx.beginPath();
	        ctx.closePath();
	        ctx.stroke();
	
	        _this2.drawTextTimeount = setTimeout(function () {
	            _this2.fillAnimation(ctx, 0, 0);
	        }, 500);
	    };
	
	    this.fillAnimation = function (ctx, groupIndex, partIndex) {
	        if (_this2.unMounted) return null;
	
	        var _props3 = _this2.props,
	            canvasData = _props3.canvasData,
	            _props3$width = _props3.width,
	            width = _props3$width === undefined ? 100 : _props3$width,
	            _props3$fillColor = _props3.fillColor,
	            fillColor = _props3$fillColor === undefined ? '#333' : _props3$fillColor,
	            splitCallback = _props3.splitCallback;
	        var _state = _this2.state,
	            drawDelay = _state.drawDelay,
	            splitDelay = _state.splitDelay,
	            loopDelay = _state.loopDelay;
	        var textFill = canvasData.textFill;
	
	
	        ctx.setLineDash([]);
	        ctx.lineWidth = 2;
	        ctx.strokeStyle = fillColor;
	        ctx.lineJoin = "round";
	        ctx.lineCap = "round";
	
	        if (splitCallback && !textFill[groupIndex]) splitCallback({ loop: false });else if (splitCallback && partIndex === 0) splitCallback({ loop: true });
	
	        if (groupIndex >= textFill.length) {
	            _this2.loopTimeount = setTimeout(function () {
	                _this2.drawContainer(ctx);
	            }, loopDelay);
	        } else {
	            var prePartIndex = partIndex;
	            partIndex = Math.min(textFill[groupIndex].length, partIndex + 50);
	
	            var len = prePartIndex;
	            while (len < partIndex) {
	                var x = textFill[groupIndex][len][0] * width / 760;
	                var y = textFill[groupIndex][len][1] * width / 760;
	                if (len === prePartIndex) ctx.moveTo(x, y);else ctx.lineTo(x, y);
	                len++;
	            }
	            ctx.stroke();
	
	            if (partIndex >= textFill[groupIndex].length) {
	                _this2.fillTimeount = setTimeout(function () {
	                    _this2.fillAnimation(ctx, groupIndex + 1, 0);
	                }, splitDelay);
	            } else {
	                _this2.fillTimeount = setTimeout(function () {
	                    _this2.fillAnimation(ctx, groupIndex, partIndex);
	                }, drawDelay);
	            }
	        }
	    };
	};
	
	exports.default = BiShunCanvas;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(87);
	
	var _reactHelmet = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GanKao = function (_Component) {
	    _inherits(GanKao, _Component);
	
	    function GanKao(props) {
	        _classCallCheck(this, GanKao);
	
	        var _this = _possibleConstructorReturn(this, (GanKao.__proto__ || Object.getPrototypeOf(GanKao)).call(this, props));
	
	        _this.bishun_data = window.AllBooksForPress;
	        _this.state = {
	            srcString: 'http://www.gankao.com/p-lubo/tag/tbsz'
	        };
	        return _this;
	    }
	
	    _createClass(GanKao, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //跨域
	            if (document.domain != 'gankao.com') {
	                document.domain = 'gankao.com';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'bookListBox' },
	                _react2.default.createElement(
	                    'style',
	                    null,
	                    '\n                    .tab li a.active{\n                        color:#11B5FF;\n                        border-bottom: 2px solid #11B5FF;\n                        border-radius: 2px;\n                    }\n                    .tab{\n                        border-bottom: 1px solid #E2F4FF;\n                        padding:0 0 5px 0;\n                        display:flex;\n                        justify-content:space-around;\n                        align-items:center;\n                    }\n                    .tab li a{\n                        padding:10px 0;\n                        color: #666;\n                    }\n                '
	                ),
	                _react2.default.createElement(_reactHelmet.Helmet, { title: '\u7B14\u987A\u4E66\u6CD5' }),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tab' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/Word', activeClassName: 'active' },
	                            '\u6C49\u5B57\u7B14\u987A'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/TongBuShuFa', activeClassName: 'active' },
	                            '\u540C\u6B65\u7B14\u987A'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/TongBu', activeClassName: 'active' },
	                            '\u540C\u6B65\u4E66\u6CD5'
	                        )
	                    )
	                ),
	                this.props.children && this.props.children,
	                !this.props.children && _react2.default.createElement(
	                    'div',
	                    null,
	                    this.bishun_data.map(function (item, index) {
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            { key: "press" + index, to: '/press/' + item.presspinyin },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'pressItem' },
	                                item.pressname
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return GanKao;
	}(_react.Component);
	
	exports.default = GanKao;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PinyinSpeaker = function (_Component) {
	    _inherits(PinyinSpeaker, _Component);
	
	    function PinyinSpeaker(props) {
	        _classCallCheck(this, PinyinSpeaker);
	
	        var _this = _possibleConstructorReturn(this, (PinyinSpeaker.__proto__ || Object.getPrototypeOf(PinyinSpeaker)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(PinyinSpeaker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	
	        //销毁组件
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // console.log('componentDidUnMount.....')
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                pinyin = _props.pinyin,
	                index = _props.index,
	                audioSrc = _props.audioSrc;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { color: '#333', fontSize: '20px', marginRight: '5px' } },
	                    pinyin
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        onClick: function onClick() {
	                            if (index === 0) {
	                                _this2.refs.audio0.play();
	                            } else if (index === 1) {
	                                _this2.refs.audio1.play();
	                            } else if (index === 2) {
	                                _this2.refs.audio2.play();
	                            } else if (index === 3) {
	                                _this2.refs.audio3.play();
	                            } else if (index === 4) {
	                                _this2.refs.audio4.play();
	                            } else if (index === 5) {
	                                _this2.refs.audio5.play();
	                            } else if (index === 6) {
	                                _this2.refs.audio6.play();
	                            }
	                        },
	                        className: 'textAudion', style: { textAlign: 'center', margin: '5px auto' } },
	                    _react2.default.createElement('img', {
	                        style: { width: "100%" },
	                        src: 'https://img.qiaoxuesi.com/files/250_a.png',
	                        alt: '\u5C0F\u5587\u53ED' }),
	                    _react2.default.createElement(
	                        'audio',
	                        { ref: 'audio' + index
	                            //                ?v=${new Date().getTime()}    避免缓存带来的数据影响新的数据
	                            , src: '' + audioSrc + index + '.mp3?v=' + new Date().getTime() },
	                        '\u8BE5\u6D4F\u89C8\u5668\u6682\u4E0D\u652F\u6301\u97F3\u9891'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PinyinSpeaker;
	}(_react.Component);
	
	exports.default = PinyinSpeaker;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isomorphicFetch = __webpack_require__(93);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _BiShunCanvas = __webpack_require__(674);
	
	var _BiShunCanvas2 = _interopRequireDefault(_BiShunCanvas);
	
	var _PinyinSpeaker = __webpack_require__(676);
	
	var _PinyinSpeaker2 = _interopRequireDefault(_PinyinSpeaker);
	
	var _videoReact = __webpack_require__(719);
	
	var _video = __webpack_require__(302);
	
	var _video2 = _interopRequireDefault(_video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var wordStyles = _react2.default.createElement(
	    "style",
	    null,
	    "\n    .searchText{\n        display:flex;\n        justify-content:center;\n        align-items:center;\n        background: #F8F8F8;\n        width:90%;\n        border-radius: 35px;\n        margin:20px auto;\n        padding:3px;\n    }\n    .searchText img{\n        width:15px;\n        height:15px;\n    }\n    .searchText input{\n        width:90%;\n        height:30px;\n        border:unset;\n        background: #F8F8F8;\n        font-size: 14px;\n        outline:none;\n    }\n    .searchText input::placeholder{\n        color: #CBCBCB;\n    }\n    .blueBac{\n        background: rgb(226, 244, 255);\n        padding: 20px;\n    }\n    .whiteBac{\n        background: rgb(255, 255, 255);\n        width: 90%;\n        margin: auto;\n        border-radius: 10px;\n        padding: 15px;\n    }\n    .title{\n        color:#333;\n        font-weight: bold;\n        border-bottom: 4px solid #2bbdff;\n        border-radius: 6px;\n        display: inline;\n    }\n    .subtitle{\n        font-size: 14px;\n        color: #999999;\n    }\n    .detail{\n        background: rgb(229, 244, 255);\n        width: 94%;\n        margin-top: 20px;\n        padding:15px 10px;\n        border-radius: 5px;\n    }\n    .detail > div:first-child{\n        display:flex;\n        justify-content:space-between;\n    }\n    .detail > div:last-child{\n        margin-top:15px;\n        letter-spacing:4px;\n    }\n//  \u89C6\u9891\u64AD\u653E\n    .video-js .vjs-big-play-button{\n        left:0 !important;\n    }\n    .video-js button{\n        right:0 !important;\n        margin:auto !important;\n        top:40% !important;\n        width:100%;\n        // display:none !important\n    }\n    .video-js .vjs-tech{\n        background:#fff;\n    }\n    // .video-js .vjs-play-control{\n    //     // display:none !important\n    //     width:100%;\n    // }\n    // .video-js .vjs-fullscreen-control{\n    //     // display:none !important\n    //     width:100%;\n    // }\n    // .video-js .vjs-volume-control{\n    //     width:100%;\n    // }\n\n"
	);
	
	var Word = function (_React$Component) {
	    _inherits(Word, _React$Component);
	
	    function Word(props) {
	        _classCallCheck(this, Word);
	
	        var _this = _possibleConstructorReturn(this, (Word.__proto__ || Object.getPrototypeOf(Word)).call(this, props));
	
	        _this.queryData = function (text) {
	            _this.getBiShunData(text);
	            _this.getTextDetailInfo(text);
	            _this.getVideoUrl(text);
	        };
	
	        _this.getBiShunData = function (text) {
	            var url = "//bishunfile.qiaoxuesi.com/" + encodeURI(encodeURI(text)) + "/canvasData.json";
	            var that = _this;
	            (0, _isomorphicFetch2.default)(url).then(function (response) {
	                if (response.status !== 200) {
	                    alert('没有查询到任何内容');
	                    return null;
	                }
	                //检查响应文本
	                response.json().then(function (data) {
	                    that.setState({ textBiShunData: data });
	                });
	            }).catch(function (err) {
	                console.log("Fetch错误:" + err);
	            });
	        };
	
	        _this.getTextDetailInfo = function (text) {
	            var url = "//bishunfile.qiaoxuesi.com/" + encodeURI(encodeURI(text)) + "/bishun.json?random=" + Math.floor(Math.random() * 10000000);
	            (0, _isomorphicFetch2.default)(url).then(function (response) {
	                if (response.status !== 200) {
	                    return;
	                }
	                //检查响应文本
	                response.json().then(function (data) {
	                    console.log(data);
	                    _this.setState({ textInfo: data });
	                });
	            }).catch(function (err) {
	                console.log("Fetch错误:" + err);
	            });
	        };
	
	        _this.loop = function (_ref) {
	            var loop = _ref.loop;
	            var controlIndex = _this.state.controlIndex;
	
	            if (loop) {
	                _this.setState({ controlIndex: controlIndex + 1 });
	            } else {
	                _this.setState({ controlIndex: -1, loop: false, ifLast: true });
	            }
	        };
	
	        _this.getVideoUrl = function (text) {
	            (0, _isomorphicFetch2.default)("https://www.gankao.com/api/video/playchinese", {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'application/json;charset=UTF-8'
	                },
	                body: JSON.stringify({ char: text })
	            }).then(function (res) {
	                res.json().then(function (videoData) {
	                    if (videoData.status === 200) {
	                        _this.setState({
	                            videoUrl: videoData.data.videoUrl.normal,
	                            courseID: videoData.data.videoUrl.course_id,
	                            sectionID: videoData.data.videoUrl.section_id
	                        });
	                        var videoWidth = _this.state.videoWidth;
	
	                        var src = videoData.data.videoUrl.normal,
	                            height = videoWidth / 4 * 2 - 27,
	                            width = videoWidth / 5 * 4 - 5.5;
	                        _this.player = (0, _video2.default)("video", {
	                            height: height,
	                            width: width,
	                            bigPlayButton: true,
	                            textTrackDisplay: false,
	                            errorDisplay: false,
	                            controlBar: true,
	                            type: "application/x-mpegURL",
	                            color: 'Blue',
	                            constructor: true
	                        }, function () {
	                            this.play();
	                        });
	                        _this.player.src({ src: src });
	                    } else {
	                        _this.setState({ videoUrl: null });
	                    }
	                });
	            });
	        };
	
	        _this.render = function () {
	            var _this$state = _this.state,
	                text = _this$state.text,
	                textBiShunData = _this$state.textBiShunData,
	                textInfo = _this$state.textInfo,
	                videoUrl = _this$state.videoUrl,
	                videoWidth = _this$state.videoWidth;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                wordStyles,
	                _react2.default.createElement(
	                    "div",
	                    { className: 'searchText' },
	                    _react2.default.createElement("input", { type: "text", placeholder: '请输入单个汉字', defaultValue: text, onChange: function onChange(e) {
	                            _this.setState({ text: e.target.value });
	                        } }),
	                    _react2.default.createElement("img", { src: "//img.qiaoxuesi.com/files/804_search.png", alt: "", onClick: function onClick() {
	                            if (text.length === 1 && /^[\u4e00-\u9fa5]+$/i.test(text)) {
	                                _this.setState({ text: null });
	                                // this.getVideoUrl(text)
	                                _this.queryData(text);
	                            } else {
	                                alert('请输入单个汉字');
	                            }
	                        } })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: 'blueBac' },
	                    _react2.default.createElement(
	                        "div",
	                        { className: 'whiteBac' },
	                        _react2.default.createElement(
	                            "div",
	                            { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	                            _react2.default.createElement(
	                                "div",
	                                { className: 'title', style: { alignSelf: 'flex-start' } },
	                                "\u793A\u4F8B"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                    "div",
	                                    { style: { display: 'flex', justifyContent: 'space-evenly' } },
	                                    textInfo && textInfo.pinyin.length && textInfo.pinyin.map(function (item, index) {
	                                        return _react2.default.createElement(_PinyinSpeaker2.default, {
	                                            audioSrc: "//bishunfile.qiaoxuesi.com//" + encodeURI(encodeURI(text)) + "/pinyin",
	                                            key: "pinyinItem" + index, pinyin: item,
	                                            index: index });
	                                    })
	                                ),
	                                textBiShunData && _react2.default.createElement(_BiShunCanvas2.default, { key: text,
	                                    splitDelay: 1000,
	                                    splitCallback: _this.loop,
	                                    fillColor: '#2ABDFF',
	                                    crossColor: '#DAF4FF',
	                                    textFillColor: '#E5E5E5',
	                                    width: 220,
	                                    canvasData: textBiShunData })
	                            ),
	                            _react2.default.createElement("img", { src: "https://img.qiaoxuesi.com/files/359_lianxi.png", alt: "", style: { width: '40px' } })
	                        ),
	                        textInfo && _react2.default.createElement(
	                            "div",
	                            { className: 'detail' },
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: 'subtitle' },
	                                        "\u7ED3\u6784\uFF1A"
	                                    ),
	                                    textInfo.structure
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: 'subtitle' },
	                                        "\u90E8\u9996\uFF1A"
	                                    ),
	                                    textInfo.bushou
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: 'subtitle' },
	                                        "\u7B14\u753B\uFF1A"
	                                    ),
	                                    textInfo.bihuaCount,
	                                    "\u753B"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                    "span",
	                                    { style: { letterSpacing: 'unset' } },
	                                    "\u7B14\u987A\uFF1A"
	                                ),
	                                textInfo.bishun
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: 'whiteBac', style: { margin: '20px auto' } },
	                        _react2.default.createElement(
	                            "div",
	                            { className: 'title' },
	                            "\u89C6\u9891\u7CBE\u8BB2"
	                        ),
	                        videoUrl ? _react2.default.createElement(
	                            "div",
	                            { style: { marginTop: '20px', maxWidth: videoWidth + "px" } },
	                            _react2.default.createElement("video", { id: "video", className: "video-js vjs-default-skin ", controls: true, style: { maxWidth: videoWidth / 5 * 4 - 5.5 + "px" },
	                                poster: 'https://img.qiaoxuesi.com/files/11_pp.png' })
	                        ) : _react2.default.createElement(
	                            "div",
	                            null,
	                            "\u6CA1\u6709\u89C6\u9891"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: 'whiteBac' },
	                        _react2.default.createElement(
	                            "div",
	                            { className: 'title' },
	                            "\u91CA\u4E49"
	                        ),
	                        _react2.default.createElement("div", { style: { marginTop: '20px' } })
	                    )
	                )
	            );
	        };
	
	        console.log(props, 'ppp');
	        _this.state = {
	            text: '都',
	            textBiShunData: null,
	            textInfo: null,
	            controlIndex: -1,
	            videoUrl: null,
	            courseID: null,
	            sectionID: null,
	            videoWidth: document.body.offsetWidth
	        };
	        return _this;
	    }
	
	    _createClass(Word, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var text = this.state.text;
	
	            this.queryData(text);
	        }
	
	        //每个笔画开始的回调函数
	
	    }]);
	
	    return Word;
	}(_react2.default.Component);
	
	exports.default = Word;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(87);
	
	__webpack_require__(540);
	
	var _reactHelmet = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WordList = function (_Component) {
	    _inherits(WordList, _Component);
	
	    function WordList(props) {
	        _classCallCheck(this, WordList);
	
	        var _this = _possibleConstructorReturn(this, (WordList.__proto__ || Object.getPrototypeOf(WordList)).call(this, props));
	
	        _this.bishun_data = window.AllBooksForPress;
	        // console.log(this.bishun_data);
	        _this.state = {
	            srcString: 'http://www.gankao.com/p-lubo/tag/tbsz'
	        };
	        return _this;
	    }
	
	    _createClass(WordList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //跨域
	            if (document.domain != 'gankao.com') {
	                document.domain = 'gankao.com';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'bookListBox' },
	                _react2.default.createElement(_reactHelmet.Helmet, { title: '\u7B14\u987A\u4E66\u6CD5' }),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'topNav container', id: 'nav' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/WordDetail', activeClassName: 'active' },
	                            '\u6C49\u5B57\u7B14\u987A'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/TongBuShuFa', activeClassName: 'active' },
	                            '\u540C\u6B65\u7B14\u987A'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/TongBu', activeClassName: 'active' },
	                            '\u540C\u6B65\u4E66\u6CD5'
	                        )
	                    )
	                ),
	                this.props.children && this.props.children,
	                !this.props.children && _react2.default.createElement(
	                    'div',
	                    null,
	                    this.bishun_data.map(function (item, index) {
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            { key: "press" + index, to: '/press/' + item.presspinyin },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'pressItem' },
	                                item.pressname
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return WordList;
	}(_react.Component);
	
	exports.default = WordList;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(87);
	
	__webpack_require__(541);
	
	var _reactHelmet = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WordList = function (_Component) {
	    _inherits(WordList, _Component);
	
	    function WordList(props) {
	        _classCallCheck(this, WordList);
	
	        // this.bishun_data = window.AllBooksForPress;
	        var _this = _possibleConstructorReturn(this, (WordList.__proto__ || Object.getPrototypeOf(WordList)).call(this, props));
	
	        _this.getPressList = function () {
	            fetch('https://www.gankao.com/api/newWord/press', {
	                method: 'GET',
	                headers: {
	                    'Content-Type': 'application/json'
	                }
	            }).then(function (res) {
	                return res.json();
	            }).then(function (data) {
	                // console.log("获取出版社列表成功:", data);
	                if (data && data.status === 200) {
	                    _this.bishun_data = data.data;
	                    _this.setState({});
	                }
	            }).catch(function (err) {
	                console.log('获取出版社列表失败:', err);
	            });
	        };
	
	        _this.bishun_data = [];
	        // console.log(this.bishun_data);
	        _this.state = {
	            srcString: 'http://www.gankao.com/p-lubo/tag/tbsz',
	            current: 1
	        };
	        return _this;
	    }
	
	    _createClass(WordList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getPressList();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // console.log("this.props.children........", this.props.children)
	            var srcString = this.state.srcString;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'bookListBox' },
	                _react2.default.createElement(
	                    _reactHelmet.Helmet,
	                    null,
	                    _react2.default.createElement(
	                        'title',
	                        null,
	                        '\u7B14\u987A\u4E66\u6CD5'
	                    )
	                ),
	                this.props.children && this.props.children,
	                !this.props.children && _react2.default.createElement(
	                    'div',
	                    null,
	                    this.bishun_data.map(function (item, index) {
	                        // console.log(item, 111);
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            { key: "press" + index, to: '/press/' + item.pinyin },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'pressItem' },
	                                item.name
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return WordList;
	}(_react.Component);
	
	exports.default = WordList;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(87);
	
	__webpack_require__(542);
	
	var _reactHelmet = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingleBook = function (_Component) {
	    _inherits(SingleBook, _Component);
	
	    function SingleBook(props) {
	        _classCallCheck(this, SingleBook);
	
	        //出版社名称和课本索引
	        var _this = _possibleConstructorReturn(this, (SingleBook.__proto__ || Object.getPrototypeOf(SingleBook)).call(this, props));
	
	        _this.getLessonList = function () {
	            fetch('https://www.gankao.com/api/newWord/lesson?book_id=' + _this.props.params.bookId, {
	                method: 'GET',
	                headers: {
	                    'Content-Type': 'application/json'
	                }
	            }).then(function (res) {
	                return res.json();
	            }).then(function (data) {
	                if (data && data.status === 200) {
	                    // console.log("获取课本列表成功:", data.data);
	                    _this.setState({
	                        lessonData: data.data.data,
	                        wordCounts: data.data.wordCounts,
	                        bookDetail: data.data.bookDetail
	                    });
	                }
	            }).catch(function (err) {
	                console.log('获取课本列表失败:', err);
	            });
	        };
	
	        var _this$props$params = _this.props.params,
	            presspinyin = _this$props$params.presspinyin,
	            bookId = _this$props$params.bookId;
	        //获取当前书本的信息
	
	        _this.courseData = window.AllBooksForPress.filter(function (m) {
	            return m.presspinyin === presspinyin;
	        })[0]["books"][bookId];
	        _this.state = {
	            lessonData: [],
	            wordCounts: null,
	            bookDetail: {}
	        };
	        return _this;
	    }
	
	    _createClass(SingleBook, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getLessonList();
	        }
	    }, {
	        key: 'render',
	
	
	        /**
	         * 根据订单id获取订单详细数据
	         * @param  {[number]} id [订单ID]
	         * @return {[order]}    [订单详细信息]
	         */
	        value: function render() {
	            var _state = this.state,
	                lessonData = _state.lessonData,
	                wordCounts = _state.wordCounts,
	                bookDetail = _state.bookDetail;
	            // console.log(bookDetail, 222);
	
	            var courseName = bookDetail.name;
	            var courseBanner = bookDetail.course_banner;
	            // let {book_data: {  lessonIcon,}} = this.courseData;
	            var _props$params = this.props.params,
	                presspinyin = _props$params.presspinyin,
	                bookId = _props$params.bookId;
	
	            //计算这本书总共多少个汉字wq
	            // let wordCounts = lesson.reduce((pre, next) => {
	            //     return pre + next["words"].length;
	            // }, 0)
	            // console.log("window.location.href....",window.location.href)
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'App' },
	                _react2.default.createElement(
	                    _reactHelmet.Helmet,
	                    null,
	                    _react2.default.createElement('meta', { name: 'gankao_sharable', content: '1' }),
	                    _react2.default.createElement('meta', { name: 'wx_share_title', content: courseName }),
	                    _react2.default.createElement('meta', { name: 'wx_share_content', content: bookDetail.course_desc }),
	                    _react2.default.createElement('meta', { name: 'wx_share_link', content: window.location.href }),
	                    _react2.default.createElement('meta', { name: 'wx_share_imgurl', content: courseBanner }),
	                    _react2.default.createElement(
	                        'title',
	                        null,
	                        courseName
	                    )
	                ),
	                this.props.children && this.props.children,
	                !this.props.children && _react2.default.createElement(
	                    'div',
	                    { style: { backgroundColor: "white", padding: "10px 15px" } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'courseTitleArea' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'leftCourseImg' },
	                            _react2.default.createElement('img', { style: { height: "150px", border: "1px solid #fbf5f5" }, src: courseBanner, alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'rightTextDesc' },
	                            _react2.default.createElement(
	                                'h1',
	                                { style: { fontSize: "16px", color: "#000000" } },
	                                courseName
	                            ),
	                            wordCounts && _react2.default.createElement(
	                                'div',
	                                { style: { color: "#B4B4B4", fontSize: "14px", marginTop: "5px" } },
	                                wordCounts,
	                                '\u4E2A\u5B57'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                {
	                                    style: {
	                                        color: "#B4B4B4",
	                                        fontSize: "12px",
	                                        marginTop: "5px"
	                                    } },
	                                bookDetail.course_desc
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { style: { clear: "both" } }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'catalogList' },
	                        lessonData.map(function (item, index) {
	                            // console.log(item,333)
	                            return _react2.default.createElement(
	                                _reactRouter.Link
	                                //     to={{
	                                //     pathname:`press/${presspinyin}/book/${bookId}/word/${index}/subject/:${item.name}`,
	                                // }}
	                                ,
	                                { to: 'press/' + presspinyin + '/book/' + bookId + '/word/' + item.id,
	                                    key: "course" + item.id },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'catalogItem' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'imgIcon',
	                                            style: { marginRight: "20px", width: "35px", lineHeight: "100%" } },
	                                        _react2.default.createElement('img', { style: { width: "100%" }, src: bookDetail.lesson_icon, alt: '' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'textBox' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { style: { color: "#000000", fontSize: "14px" } },
	                                            item.name
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { style: { color: "#969696", fontSize: "12px" } },
	                                            item.word_count,
	                                            '\u4E2A\u5B57'
	                                        )
	                                    )
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SingleBook;
	}(_react.Component);
	
	exports.default = SingleBook;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * props参数说明
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * canvasData    必    从服务器取得的笔顺背景、填充数据
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * failCallback  必    canvas创建失败时调用
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * id            单页面使用超过1次后必    canvas计数器，页面存在多个该组件时使用，默认0，传入1时canvas的id为BSCanvas1
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * width         选    canvas宽度，默认100
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * mode          选    预设的播放模式，默认custom；有fast,slow可选，选择时覆盖drawDelay、splitDelay、loopDelay参数
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * drawDelay     选    一个笔顺填充动画的速率（ms），默认100，越大动画越慢
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * splitDelay    选    笔顺间的间隔（ms），默认500
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * loopDelay     选    循环的间隔（ms），默认1000
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * fillColor     选    动画填充的颜色，默认#333
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * bgColor       选    背景填充的颜色，默认#fff
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * crossColor    选    分割线的颜色，默认#aaa
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * textFillColor 选    文字背景填充颜色， 默认#fff
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * splitCallback 选    每一个笔画开始前调用，参数loop:boolean，true：笔画循环中，false：一整个笔顺流程结束
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * borderWidth   选    边框的宽度，默认1, 0时隐藏
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * */
	
	var BiShunCanvas = function (_React$Component) {
	    _inherits(BiShunCanvas, _React$Component);
	
	    function BiShunCanvas(props) {
	        _classCallCheck(this, BiShunCanvas);
	
	        // console.log("props.....kll",props)
	        var _this = _possibleConstructorReturn(this, (BiShunCanvas.__proto__ || Object.getPrototypeOf(BiShunCanvas)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var _props$id = props.id,
	            id = _props$id === undefined ? 0 : _props$id,
	            _props$mode = props.mode,
	            mode = _props$mode === undefined ? 'custom' : _props$mode,
	            _props$drawDelay = props.drawDelay,
	            drawDelay = _props$drawDelay === undefined ? 100 : _props$drawDelay,
	            _props$splitDelay = props.splitDelay,
	            splitDelay = _props$splitDelay === undefined ? 500 : _props$splitDelay,
	            _props$loopDelay = props.loopDelay,
	            loopDelay = _props$loopDelay === undefined ? 800 : _props$loopDelay;
	
	        _this.state = {
	            id: 'BSCanvas' + id,
	            drawDelay: mode === 'custom' ? drawDelay : mode === 'fast' ? 90 : 120,
	            splitDelay: mode === 'custom' ? splitDelay : mode === 'fast' ? 300 : 1000,
	            loopDelay: mode === 'custom' ? loopDelay : mode === 'fast' ? 300 : 1000
	        };
	        _this.unMounted = false;
	        return _this;
	    }
	
	    _createClass(BiShunCanvas, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var failCallback = this.props.failCallback;
	
	            var canvas = document.getElementById(this.state.id); //获得画布元素
	            var ctx = canvas.getContext('2d'); //获得画笔
	            if (!ctx) failCallback();else this.drawContainer(ctx);
	        }
	        //销毁组件
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.unMounted = true;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // console.log("nextProps.........",nextProps)
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$width = this.props.width,
	                width = _props$width === undefined ? 100 : _props$width;
	
	            return _react2.default.createElement('canvas', { id: this.state.id, width: width, height: width });
	        }
	    }]);
	
	    return BiShunCanvas;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.drawContainer = function (ctx) {
	        var _props = _this2.props,
	            _props$width2 = _props.width,
	            width = _props$width2 === undefined ? 100 : _props$width2,
	            _props$bgColor = _props.bgColor,
	            bgColor = _props$bgColor === undefined ? '#fff' : _props$bgColor,
	            _props$borderWidth = _props.borderWidth,
	            borderWidth = _props$borderWidth === undefined ? 1 : _props$borderWidth,
	            _props$crossColor = _props.crossColor,
	            crossColor = _props$crossColor === undefined ? '#aaa' : _props$crossColor;
	
	
	        ctx.fillStyle = bgColor;
	        ctx.fillRect(0, 0, width, width); //fillRect(x,y,width,height) 方法定义了矩形当前的填充方式。
	        if (borderWidth) {
	            ctx.lineWidth = 1;
	            ctx.strokeStyle = "#bbb"; //线的颜色
	            ctx.strokeRect(0, 0, width, width);
	        }
	        ctx.lineWidth = borderWidth;
	        ctx.strokeStyle = crossColor;
	        ctx.setLineDash([5, 8]); //shixianbufen
	        ctx.beginPath();
	        ctx.moveTo(width / 2, 0); //线条开始坐标
	        ctx.lineTo(width / 2, width); //线条结束坐标
	        ctx.moveTo(0, width / 2);
	        ctx.lineTo(width, width / 2);
	        ctx.setLineDash([5, 10]);
	        ctx.moveTo(0, 0);
	        ctx.lineTo(width, width);
	        ctx.moveTo(0, width);
	        ctx.lineTo(width, 0);
	        ctx.stroke();
	
	        _this2.drawText(ctx);
	    };
	
	    this.drawText = function (ctx) {
	        var _props2 = _this2.props,
	            canvasData = _props2.canvasData,
	            _props2$width = _props2.width,
	            width = _props2$width === undefined ? 100 : _props2$width,
	            _props2$textFillColor = _props2.textFillColor,
	            textFillColor = _props2$textFillColor === undefined ? '#fff' : _props2$textFillColor;
	        var textBg = canvasData.textBg;
	        // console.log(textBg);
	
	        ctx.lineWidth = 2;
	        ctx.setLineDash([1]);
	        ctx.strokeStyle = "#cad8e4";
	        ctx.fillStyle = '#cad8e4';
	        var GroupLen = textBg.length;
	        while (GroupLen--) {
	            ctx.beginPath();
	            var len = 0;
	            while (len < textBg[GroupLen].length) {
	                var x = textBg[GroupLen][len][0] * width / 760;
	                var y = textBg[GroupLen][len][1] * width / 760;
	                if (len === 0) ctx.moveTo(x, y);else ctx.lineTo(x, y);
	                len++;
	            }
	            ctx.closePath();
	            ctx.fillStyle = textFillColor;
	            ctx.fill();
	            ctx.stroke();
	        }
	        ctx.beginPath();
	        ctx.closePath();
	        ctx.stroke();
	
	        _this2.drawTextTimeount = setTimeout(function () {
	            _this2.fillAnimation(ctx, 0, 0);
	        }, 500);
	    };
	
	    this.fillAnimation = function (ctx, groupIndex, partIndex) {
	        if (_this2.unMounted) return null;
	
	        var _props3 = _this2.props,
	            canvasData = _props3.canvasData,
	            _props3$width = _props3.width,
	            width = _props3$width === undefined ? 100 : _props3$width,
	            _props3$fillColor = _props3.fillColor,
	            fillColor = _props3$fillColor === undefined ? '#333' : _props3$fillColor,
	            splitCallback = _props3.splitCallback;
	        var _state = _this2.state,
	            drawDelay = _state.drawDelay,
	            splitDelay = _state.splitDelay,
	            loopDelay = _state.loopDelay;
	        var textFill = canvasData.textFill;
	
	
	        ctx.setLineDash([]);
	        ctx.lineWidth = 2;
	        ctx.strokeStyle = fillColor;
	        ctx.lineJoin = "round";
	        ctx.lineCap = "round";
	
	        if (splitCallback && !textFill[groupIndex]) splitCallback({ loop: false });else if (splitCallback && partIndex === 0) splitCallback({ loop: true });
	
	        if (groupIndex >= textFill.length) {
	            _this2.loopTimeount = setTimeout(function () {
	                _this2.drawContainer(ctx);
	            }, loopDelay);
	        } else {
	            var prePartIndex = partIndex;
	            partIndex = Math.min(textFill[groupIndex].length, partIndex + 50);
	
	            var len = prePartIndex;
	            while (len < partIndex) {
	                var x = textFill[groupIndex][len][0] * width / 760;
	                var y = textFill[groupIndex][len][1] * width / 760;
	                if (len === prePartIndex) ctx.moveTo(x, y);else ctx.lineTo(x, y);
	                len++;
	            }
	            ctx.stroke();
	
	            if (partIndex >= textFill[groupIndex].length) {
	                _this2.fillTimeount = setTimeout(function () {
	                    _this2.fillAnimation(ctx, groupIndex + 1, 0);
	                }, splitDelay);
	            } else {
	                _this2.fillTimeount = setTimeout(function () {
	                    _this2.fillAnimation(ctx, groupIndex, partIndex);
	                }, drawDelay);
	            }
	        }
	    };
	};
	
	exports.default = BiShunCanvas;

/***/ },
/* 682 */
669,
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(330);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CCPlayer = function (_Component) {
	    _inherits(CCPlayer, _Component);
	
	    function CCPlayer(props) {
	        var _this3 = this;
	
	        _classCallCheck(this, CCPlayer);
	
	        var _this2 = _possibleConstructorReturn(this, (CCPlayer.__proto__ || Object.getPrototypeOf(CCPlayer)).call(this, props));
	
	        _this2.generateNonceString = function (length) {
	            var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	            var maxPos = chars.length;
	            var noceStr = '';
	            for (var i = 0; i < (length || 32); i++) {
	                noceStr += chars.charAt(Math.floor(Math.random() * maxPos));
	            }
	            return noceStr;
	        };
	
	        _this2.appOptionsWrapper = function (jsOptions) {
	            if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
	                if (window.__appOptionsWrapper) {
	                    return window.__appOptionsWrapper(jsOptions);
	                }
	                if (navigator.userAgent.toLowerCase().indexOf('android') !== -1) {
	                    var jsOptions_copy = Object.assign({}, jsOptions);
	                    for (var key in jsOptions_copy) {
	                        if (jsOptions_copy[key] instanceof Function) {
	                            (function () {
	                                var newFunString = key + '_' + _this2.generateNonceString(10);
	                                var oldFun = jsOptions_copy[key];
	                                window[newFunString] = function () {
	                                    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
	                                        params[_key] = arguments[_key];
	                                    }
	
	                                    _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                                        return _regenerator2.default.wrap(function _callee$(_context) {
	                                            while (1) {
	                                                switch (_context.prev = _context.next) {
	                                                    case 0:
	                                                        _context.next = 2;
	                                                        return oldFun.apply(undefined, params);
	
	                                                    case 2:
	                                                    case 'end':
	                                                        return _context.stop();
	                                                }
	                                            }
	                                        }, _callee, _this3);
	                                    }))();
	                                };
	                                jsOptions_copy[key] = newFunString;
	                            })();
	                        }
	                    }
	                    return JSON.stringify(jsOptions_copy);
	                }
	            }
	            return jsOptions;
	        };
	
	        _this2.updateDataTotalDuration = function (current, totalDuration) {
	            console.log(current, totalDuration);
	            _this2.setState({ totalDuration: totalDuration });
	        };
	
	        _this2.listener = function () {
	            var timeCounter = _this2.props.timeCounter;
	            var played = _this2.state.played;
	
	            var oVideo = null;
	
	            if (timeCounter) {
	                var playerContainer = _this2.refs.playerContainer;
	                oVideo = playerContainer.getElementsByTagName('video')[0];
	                var timer = _this2.timer;
	                var _this = _this2;
	
	                if (oVideo) {
	                    _this2.setState({ played: true });
	                    var videoTotalDuration = Math.floor(oVideo.duration);
	
	                    if (window.__videoplay_listenVideoTimeupdate) {
	                        window.__videoplay_listenVideoTimeupdate("workPlayer", _this2.updateDataTotalDuration.bind(_this2));
	                    }
	                    oVideo.addEventListener('play', function () {
	                        timer = setInterval(function () {
	                            var totalDuration = _this.state.totalDuration;
	
	                            if (totalDuration || totalDuration === 0) timeCounter(totalDuration);
	                        }, 10000);
	                    });
	                    oVideo.addEventListener('playing', function () {
	                        if (!timer) {
	                            timer = setInterval(function () {
	                                var totalDuration = _this.state.totalDuration;
	
	                                if (totalDuration || totalDuration === 0) timeCounter(totalDuration);
	                            }, 10000);
	                        }
	                    });
	
	                    oVideo.addEventListener('pause', function () {
	                        clearInterval(timer);
	                    });
	                    oVideo.addEventListener('ended', function () {
	                        clearInterval(timer);
	                    });
	
	                    // this.setState({totalDuration: videoTotalDuration})
	                }
	            }
	
	            if (!oVideo && !played) {
	                setTimeout(function () {
	                    _this2.listener();
	                }, 300);
	                return false;
	            }
	        };
	
	        _this2.on_cc_player_init = function (vid, objectID) {
	            var thisMovie = function thisMovie(movieName) {
	                if (navigator.appName.indexOf('Microsoft') !== -1) {
	                    return window[movieName];
	                } else {
	                    return document[movieName];
	                }
	            };
	            var player = thisMovie(objectID);
	            if (player) {
	                _this2.setState({ played: true });
	                var config = {
	                    rightmenu_enable: 0
	                };
	                player.setConfig(config);
	            }
	        };
	
	        _this2.on_spark_player_start = function () {
	            var timeCounter = _this2.props.timeCounter;
	
	            if (timeCounter) {
	                _this2.timer = setInterval(function () {
	                    timeCounter(_this2.state.totalDuration);
	                }, 10000);
	            }
	        };
	
	        _this2.on_spark_player_pause = function () {
	            var timeCounter = _this2.props.timeCounter;
	
	            if (timeCounter) clearInterval(_this2.timer);
	        };
	
	        _this2.on_spark_player_resume = function () {
	            var timeCounter = _this2.props.timeCounter;
	
	            if (timeCounter && !_this2.timer) {
	                _this2.timer = setInterval(function () {
	                    timeCounter(_this2.state.totalDuration);
	                }, 10000);
	            }
	        };
	
	        _this2.on_spark_player_stop = function () {
	            var timeCounter = _this2.props.timeCounter;
	
	            if (timeCounter) clearInterval(_this2.timer);
	        };
	
	        _this2.handleVideoClick = function () {
	            var _this2$props = _this2.props,
	                courseID = _this2$props.courseID,
	                sectionID = _this2$props.sectionID;
	
	            var jsBridgeApp = (window.parent || window).JsBridgeApp;
	            var userAgent = navigator.userAgent.toLowerCase();
	            var isGankaoHD = userAgent.indexOf('gankaohd') > -1;
	            var isFeishuo = userAgent.indexOf('feishuo') > -1;
	
	            if (jsBridgeApp && jsBridgeApp.openCourseVideo && (isGankaoHD || isFeishuo)) {
	                if (courseID && sectionID) {
	                    var options = _this2.appOptionsWrapper({
	                        courseID: courseID,
	                        sectionID: sectionID,
	                        recommend: 1
	                    });
	                    jsBridgeApp.openCourseVideo(options);
	                }
	            }
	        };
	
	        _this2.state = {
	            played: false,
	            height: '500',
	            parentNode: 'JYVideoPlayContainer' + Math.round(Math.random() * 10000),
	            totalDuration: null
	        };
	        _this2.timer = null;
	        return _this2;
	    }
	
	    /**
	     * 生成指定长度的随机字符串
	     * @param {number} length - 字符串长度
	     * @returns {string} 随机字符串
	     */
	
	
	    /**
	     * 包装 JS 选项，处理 Android 设备上的函数序列化
	     * @param {Object} jsOptions - 原始选项对象
	     * @returns {string|Object} 处理后的选项对象
	     */
	
	
	    _createClass(CCPlayer, [{
	        key: 'componentWillMount',
	
	
	        /**
	         * 组件挂载前的生命周期方法，用于初始化视频播放器相关的全局事件监听
	         * 设置播放器的各种回调函数到window对象上，包括：
	         * - 播放器初始化
	         * - 播放开始
	         * - 播放暂停
	         * - 播放恢复
	         * - 播放停止
	         * 同时绑定视频时长更新的监听器
	         */
	        value: function componentWillMount() {
	            if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
	                window.on_cc_player_init = this.on_cc_player_init;
	                window.on_spark_player_start = this.on_spark_player_start;
	                window.on_spark_player_pause = this.on_spark_player_pause;
	                window.on_spark_player_resume = this.on_spark_player_resume;
	                window.on_spark_player_stop = this.on_spark_player_stop;
	                if (window.__videoplay_listenVideoTimeupdate) window.__videoplay_listenVideoTimeupdate("workPlayer", this.updateDataTotalDuration.bind(this));
	            }
	        }
	
	        /**
	         * 组件挂载后初始化 CC 视频播放器
	         * 创建 script 标签并插入播放器容器，根据容器宽度计算播放器高度
	         * 处理播放器 URL 参数，替换高度和父节点参数
	         * 如果未播放过，设置延时监听器
	         * 
	         * @param {Object} props.url - CC视频播放器的URL
	         * @param {boolean} state.played - 视频是否已播放标记
	         * @param {string} state.parentNode - 父节点参数
	         */
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this4 = this;
	
	            var _props$url = this.props.url,
	                url = _props$url === undefined ? '' : _props$url;
	            var _state = this.state,
	                played = _state.played,
	                parentNode = _state.parentNode;
	
	            var script = document.createElement('script');
	            var playerContainer = this.refs.playerContainer;
	            var width = playerContainer.offsetWidth;
	            var height = Math.ceil(width * 509 / 857);
	            playerContainer.appendChild(script);
	
	            if (url) url = url.replace(/height=[0-9]*/, 'height=' + height).replace(/parentNode=.*?&/igm, 'parentNode=' + parentNode + '&');
	            script.src = url;
	            // 测试用
	            // script.src = `https://p.bokecc.com/player?vid=2FFD1B1C770C891A9C33DC5901307461&siteid=1936D297411C3A27&autoStart=true&width=${width}&height=${height}&playerid=6ED7421AB96B522E&playertype=1`
	
	            //计时器
	            if (!played) {
	                setTimeout(function () {
	                    _this4.listener();
	                }, 300);
	            }
	        }
	
	        /**
	         * 组件卸载时的生命周期方法
	         * 清除定时器，防止内存泄漏
	         */
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.timer) {
	                clearInterval(this.timer);
	                this.timer = null;
	            }
	        }
	
	        /**
	         * 更新音频总时长
	         * @param {number} current - 当前播放时间(秒)
	         * @param {number} totalDuration - 音频总时长(秒)
	         * @memberof CCPlayer
	         */
	
	
	        /**
	         * 监听视频播放事件并处理计时逻辑
	         * 
	         * 该方法负责:
	         * - 获取视频元素并添加事件监听
	         * - 在视频播放时每10秒更新播放时长计数
	         * - 在视频暂停或结束时清除计时器
	         * - 如果未找到视频元素则延迟300ms重试
	         * 
	         * @private
	         * @returns {boolean} 如果未找到视频元素返回false
	         */
	
	
	        /**
	         * 初始化CC视频播放器的回调函数
	         * @param {string} vid - CC视频的唯一标识符
	         * @param {string} objectID - 播放器DOM元素的ID
	         * @description 根据浏览器类型获取播放器实例，设置播放状态并禁用右键菜单
	         * @private
	         */
	
	
	        /**
	         * 开始播放时的回调函数
	         * 如果存在 timeCounter 属性，每10秒调用一次并传入总时长
	         * @private
	         * @param {void}
	         * @returns {void}
	         */
	
	        /**
	         * 暂停播放器时的回调函数
	         * 如果存在计时器，则清除计时器
	         * @param {void}
	         * @returns {void}
	         * @private
	         */
	
	        /**
	         * 恢复播放器时的回调函数
	         * 如果存在计时器属性且当前没有计时器在运行,
	         * 则每10秒触发一次计时器回调,传入总时长
	         * @private
	         */
	
	        /**
	         * 停止播放器时的回调函数
	         * 如果存在计时器，则清除计时器
	         * @param {void}
	         * @returns {void}
	         * @private
	         */
	
	
	        /**
	         * 处理视频点击事件
	         * 检查是否在特定应用中，如果是则使用原生播放器
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$style = this.props.style,
	                style = _props$style === undefined ? { width: '100%' } : _props$style;
	            var parentNode = this.state.parentNode;
	
	            if (typeof window !== 'undefined' && navigator.userAgent.indexOf('gankaoHD') > -1) {
	                style.width = 'calc(100% * 0.9)';
	                style.margin = 'auto';
	            }
	            return _react2.default.createElement('div', {
	                style: Object.assign({}, style),
	                ref: 'playerContainer',
	                id: parentNode,
	                onClick: this.handleVideoClick
	            });
	        }
	    }]);
	
	    return CCPlayer;
	}(_react.Component);
	
	exports.default = CCPlayer;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PinyinSpeaker = function (_Component) {
	    _inherits(PinyinSpeaker, _Component);
	
	    function PinyinSpeaker(props) {
	        _classCallCheck(this, PinyinSpeaker);
	
	        var _this = _possibleConstructorReturn(this, (PinyinSpeaker.__proto__ || Object.getPrototypeOf(PinyinSpeaker)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(PinyinSpeaker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	
	        //销毁组件
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // console.log('componentDidUnMount.....')
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                pinyin = _props.pinyin,
	                index = _props.index,
	                audioSrc = _props.audioSrc;
	
	            return _react2.default.createElement(
	                'div',
	                { style: {
	                        display: 'flex',
	                        marginRight: '10px'
	                    } },
	                _react2.default.createElement(
	                    'div',
	                    { style: {
	                            color: '#417BEE',
	                            fontSize: '24px',
	                            marginRight: '5px'
	                        } },
	                    pinyin
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        onClick: function onClick() {
	                            if (index === 0) {
	                                _this2.refs.audio0.play();
	                            } else if (index === 1) {
	                                _this2.refs.audio1.play();
	                            } else if (index === 2) {
	                                _this2.refs.audio2.play();
	                            } else if (index === 3) {
	                                _this2.refs.audio3.play();
	                            } else if (index === 4) {
	                                _this2.refs.audio4.play();
	                            } else if (index === 5) {
	                                _this2.refs.audio5.play();
	                            } else if (index === 6) {
	                                _this2.refs.audio6.play();
	                            }
	                        },
	                        className: 'textAudion' },
	                    _react2.default.createElement('img', {
	                        style: { width: "100%" },
	                        src: 'https://img.qiaoxuesi.com/market/indexImg/1527126873904.PNG',
	                        alt: '\u5C0F\u5587\u53ED' }),
	                    _react2.default.createElement(
	                        'audio',
	                        { ref: 'audio' + index
	                            //                ?v=${new Date().getTime()}    避免缓存带来的数据影响新的数据
	                            , src: '' + audioSrc + index + '.mp3?v=' + new Date().getTime() },
	                        '\u8BE5\u6D4F\u89C8\u5668\u6682\u4E0D\u652F\u6301\u97F3\u9891'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PinyinSpeaker;
	}(_react.Component);
	
	exports.default = PinyinSpeaker;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WordDetail = function (_React$Component) {
	    _inherits(WordDetail, _React$Component);
	
	    function WordDetail(props) {
	        _classCallCheck(this, WordDetail);
	
	        var _this = _possibleConstructorReturn(this, (WordDetail.__proto__ || Object.getPrototypeOf(WordDetail)).call(this, props));
	
	        _this.state = {
	            srcString: 'https://www.gankao.com/p-lubo/tag/tbsz'
	        };
	        return _this;
	    }
	
	    _createClass(WordDetail, [{
	        key: 'render',
	        value: function render() {
	            var srcString = this.state.srcString;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel_iframe', style: { width: '100%', height: '100%', border: '0' } },
	                        _react2.default.createElement('iframe', { src: srcString, sandbox: 'allow-same-origin allow-scripts allow-popups allow-forms allow-modals' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WordDetail;
	}(_react2.default.Component);
	
	exports.default = WordDetail;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WordDetail = function (_React$Component) {
	    _inherits(WordDetail, _React$Component);
	
	    function WordDetail(props) {
	        _classCallCheck(this, WordDetail);
	
	        var _this = _possibleConstructorReturn(this, (WordDetail.__proto__ || Object.getPrototypeOf(WordDetail)).call(this, props));
	
	        _this.state = {
	            srcString: '#/press/renjiao?_k=isyr6f'
	        };
	        return _this;
	    }
	
	    _createClass(WordDetail, [{
	        key: 'render',
	        value: function render() {
	            var srcString = this.state.srcString;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel_iframe', style: {
	                                width: '100%',
	                                height: '100%',
	                                border: '0',
	                                background: '#fff',
	                                WebkitOverflowScrolling: 'touch',
	                                overflowY: 'scroll'
	                            } },
	                        _react2.default.createElement('iframe', { src: srcString })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WordDetail;
	}(_react2.default.Component);
	
	exports.default = WordDetail;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(157);
	
	var _x = __webpack_require__(707);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _isomorphicFetch = __webpack_require__(93);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _BiShunCanvas = __webpack_require__(681);
	
	var _BiShunCanvas2 = _interopRequireDefault(_BiShunCanvas);
	
	var _PinyinSpeaker = __webpack_require__(684);
	
	var _PinyinSpeaker2 = _interopRequireDefault(_PinyinSpeaker);
	
	var _BuShouSpeaker = __webpack_require__(682);
	
	var _BuShouSpeaker2 = _interopRequireDefault(_BuShouSpeaker);
	
	var _CCPlayer = __webpack_require__(683);
	
	var _CCPlayer2 = _interopRequireDefault(_CCPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Videojs from "video.js";
	
	var WordDetail = function (_React$Component) {
	    _inherits(WordDetail, _React$Component);
	
	    function WordDetail(props) {
	        _classCallCheck(this, WordDetail);
	
	        var _this2 = _possibleConstructorReturn(this, (WordDetail.__proto__ || Object.getPrototypeOf(WordDetail)).call(this, props));
	
	        _this2.handChange = function (e) {
	            _this2.setState({
	                text: e.target.value
	            });
	        };
	
	        _this2.handleKeyDown = function (e) {
	            // 检测是否按下回车键 (keyCode 13)
	            if (e.key === 'Enter' || e.keyCode === 13) {
	                _this2.handClick();
	            }
	        };
	
	        _this2.getBiShunData = function (text) {
	            var url = '//bishunfile.qiaoxuesi.com/' + encodeURI(encodeURI(text)) + '/canvasData.json';
	            var that = _this2;
	            (0, _isomorphicFetch2.default)(url).then(function (response) {
	                if (response.status !== 200) {
	                    that.setState({ isSupportCanvas: false });
	                    return null;
	                }
	                //检查响应文本
	                response.json().then(function (data) {
	                    that.setState({ textData: data, isShowBishun: true });
	                });
	            }).catch(function (err) {
	                console.log("Fetch错误:" + err);
	            });
	        };
	
	        _this2.getTextDetailInfo = function (text) {
	            //     ?random=${Math.floor(Math.random() * 10000000)}  添加随机数，避免缓存
	            var url = '//bishunfile.qiaoxuesi.com/' + encodeURI(encodeURI(text)) + '/bishun.json?random=' + Math.floor(Math.random() * 10000000);
	            var _this = _this2;
	            (0, _isomorphicFetch2.default)(url).then(function (response) {
	                if (response.status !== 200) {
	                    return;
	                }
	                //检查响应文本
	                response.json().then(function (data) {
	                    var bihuaCount = data.bihuaCount,
	                        bishun = data.bishun,
	                        bushou = data.bushou,
	                        pinyin = data.pinyin,
	                        structure = data.structure;
	
	                    var src = '//bishunfile.qiaoxuesi.com//' + encodeURI(encodeURI(text)) + '/pinyin';
	                    _this.setState({
	                        words: data,
	                        textInfo: data,
	                        bihuaCount: bihuaCount,
	                        bishun: bishun,
	                        bushou: bushou,
	                        pinyin: pinyin,
	                        structure: structure,
	                        currentText: text,
	                        audioSrc: src,
	                        controlIndex: -1
	                    });
	                });
	            }).catch(function (err) {
	                console.log("Fetch错误:" + err);
	            });
	        };
	
	        _this2.getVideoUrl = function (text) {
	            var _this = _this2;
	            _this.setState({ videoLoading: false });
	            (0, _isomorphicFetch2.default)("https://www.gankao.com/api/video/playchinese", {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'application/json;charset=UTF-8'
	                },
	                body: JSON.stringify({
	                    char: text
	                })
	            }).then(function (res) {
	                res.json().then(function (videoData) {
	                    if (videoData.status === 200) {
	                        _this.setState({ videoLoading: true });
	
	                        // console.log(videoData.data.videoUrl.normal, '====12')
	                        _this.setState({
	                            // videoUrl: videoData.data.videoUrl.normal,
	                            courseID: videoData.data.videoUrl.course_id,
	                            sectionID: videoData.data.videoUrl.section_id
	                        });
	                        // ---
	                        var newVideoPlayerUrl = null;
	                        // newVideoPlayerUrl=`https://www.gankao.com/ccplay_gankao_wrap?gkv=0.23&courseId=${videoData.data.videoUrl.course_id}&height=230px&m3u8_H=https%3A%2F%2Fvideo1.qiaoxuesi.com%2Fv_221008_162956lmFIKyRp_H.m3u8%3Fpm3u8%2F0%26e%3D1733400595%26token%3DnSqgk5YvwwprYlc-XT1qJcN_JwkKWHpNpCAci6kI%3AxDABYiRq6VJqn3YMb16j1kx27ZY%3D&m3u8_M=https%3A%2F%2Fvideo1.qiaoxuesi.com%2Fv_221008_162956lmFIKyRp_H.m3u8%3Fpm3u8%2F0%26e%3D1733400595%26token%3DnSqgk5YvwwprYlc-XT1qJcN_JwkKWHpNpCAci6kI%3AxDABYiRq6VJqn3YMb16j1kx27ZY%3D&nocover=1&parentNode=JYvideoPlayContainer&sectionId=571707&timestamp=1733378995&videoSource=qiniu&width=100%&vsign=b404ba45dae5ae87e997c51e0d64251c&hiddenFullscreenBt=1`
	                        newVideoPlayerUrl = 'https://www.gankao.com/ccplay_gankao_wrap?gkv=0.23&nocover=1&parentNode=videoplayer_container2&courseId=' + videoData.data.videoUrl.course_id + '&sectionId=' + videoData.data.videoUrl.section_id + '&width=100%&height=100%&videoSource=qiniu&m3u8_H=' + encodeURIComponent(videoData.data.videoUrl.normal);
	                        console.log(newVideoPlayerUrl, 'newVideoPlayerUrl====');
	
	                        // 检查是否在原生应用中，如果是则添加隐藏全屏按钮参数
	                        var userAgent = navigator.userAgent.toLowerCase();
	                        var isGankaoHD = userAgent.indexOf('gankaohd') > -1;
	                        var isFeishuo = userAgent.indexOf('feishuo') > -1;
	
	                        if (isGankaoHD || isFeishuo) {
	                            // 为原生应用添加隐藏全屏按钮参数
	                            newVideoPlayerUrl += '&hiddenFullscreenBt=1';
	                        }
	
	                        _this.setState({
	                            videoUrl: newVideoPlayerUrl
	                        });
	                    }
	                });
	            });
	        };
	
	        _this2.handClick = function () {
	            var text = _this2.state.text;
	
	            _this2.setState({
	                textData: '',
	                loading: true,
	                ifLast: false,
	                videoUrl: null
	            });
	            clearTimeout(_this2.getTextTimeouter);
	            if (_this2.player) {
	                _this2.player.dispose();
	            }
	
	            _this2.getTextTimeouter = setTimeout(function () {
	                _this2.getTextDetailInfo(text);
	                _this2.getBiShunData(text);
	                _this2.getVideoUrl(text);
	                _this2.setState({ loading: false });
	            }, 100);
	        };
	
	        _this2.loop = function (_ref) {
	            var loop = _ref.loop;
	            var controlIndex = _this2.state.controlIndex;
	
	            if (loop) {
	                _this2.setState({ controlIndex: controlIndex + 1 });
	            } else {
	                _this2.setState({ controlIndex: -1, loop: false, ifLast: true });
	            }
	        };
	
	        _this2.controlSpeed = function (speed) {
	            var speedTemplate = ["fast", "normal", "slow"];
	            var obj = {};
	            switch (speed) {
	                case "fast":
	                    obj.bushouSpeed = 1000;
	                    break;
	                case "normal":
	                    obj.bushouSpeed = 1500;
	                    break;
	                default:
	                    obj.bushouSpeed = 2000;
	            }
	            _this2.setState({ obj: obj });
	            //
	        };
	
	        _this2.canvasSupportError = function (e) {
	            _this2.setState({ isSupportCanvas: false, isShowBishun: false });
	        };
	
	        _this2.handOpenCourseVideo = function (courseID, sectionID) {
	            window.JsBridgeApp.openCourseVideo(JSON.stringify({ courseID: courseID, sectionID: sectionID, recommend: 1 }));
	        };
	
	        _this2.render = function () {
	            var _this2$state = _this2.state,
	                text = _this2$state.text,
	                bushou = _this2$state.bushou,
	                bihuaCount = _this2$state.bihuaCount,
	                structure = _this2$state.structure,
	                bishun = _this2$state.bishun,
	                pinyin = _this2$state.pinyin,
	                audioSrc = _this2$state.audioSrc,
	                isShowBishun = _this2$state.isShowBishun,
	                controlIndex = _this2$state.controlIndex,
	                ifLast = _this2$state.ifLast,
	                videoUrl = _this2$state.videoUrl,
	                textData = _this2$state.textData,
	                courseID = _this2$state.courseID,
	                sectionID = _this2$state.sectionID,
	                videoLoading = _this2$state.videoLoading,
	                loading = _this2$state.loading;
	            // console.log(videoUrl, 'videoUrl====', videoLoading)
	            // console.log(textData, 'textData====kllll', )
	
	            var arrBiShun = bishun.split(",");
	            var HD = window.navigator.userAgent.indexOf('HD');
	            var jif = "";
	            if (text) {
	                jif = 'https://bishungif.qiaoxuesi.com/' + encodeURI(encodeURI(text)) + '.gif-publish';
	                // console.log(jif,'jjj')
	            }
	
	            // console.log(text,'text===',textData,'textData')
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'bookListBox' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'searcher'
	                            // onClick={this.handClick}
	                        },
	                        _react2.default.createElement('input', { className: 'searcher-text',
	                            placeholder: '\u53EA\u80FD\u8F93\u5165\u4E00\u4E2A\u6C49\u5B57.....',
	                            defaultValue: text,
	                            onChange: _this2.handChange,
	                            onKeyDown: _this2.handleKeyDown }),
	                        _react2.default.createElement('img', { src: _x2.default, onClick: _this2.handClick })
	                    ),
	                    text.length > 1 && _react2.default.createElement(
	                        'div',
	                        { style: { margin: '0 20px', color: 'red' } },
	                        '\u53EA\u80FD\u8F93\u5165\u4E00\u4E2A\u6C49\u5B57!'
	                    ),
	                    textData === '' && loading && _react2.default.createElement(
	                        'div',
	                        { style: { margin: '10px auto', padding: '15px', textAlign: 'center', color: '#417BEE', fontWeight: 'bold' } },
	                        '\u52A0\u8F7D\u4E2D...'
	                    ),
	                    textData === '' && !loading && _react2.default.createElement(
	                        'div',
	                        { style: { margin: '0 20px', color: 'red', textAlign: 'center' } },
	                        '\u6682\u65E0\u5185\u5BB9\uFF01'
	                    )
	                ),
	                text.length > 1 || textData === '' ? _react2.default.createElement('div', null) : _react2.default.createElement(
	                    'div',
	                    { className: 'bookListBox' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'center' } },
	                            pinyin.length ? pinyin.map(function (item, index) {
	                                return _react2.default.createElement(_PinyinSpeaker2.default, {
	                                    audioSrc: audioSrc,
	                                    key: "pinyinItem" + index, pinyin: item,
	                                    index: index });
	                            }) : ""
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { style: { textAlign: "center", position: "relative" } },
	                                textData ? _react2.default.createElement(_BiShunCanvas2.default, {
	                                    key: text,
	                                    splitDelay: 1000 // 笔画间隔时间
	                                    , splitCallback: _this2.loop // 每画一笔的回调
	                                    , fillColor: '#417BEE' // 笔画填充颜色
	                                    , crossColor: '#417BEE' // 笔画轮廓颜色
	                                    , textFillColor: '#cad8e4' // 文字填充颜色
	                                    , width: 200 // 画布宽度
	                                    , canvasData: textData // 笔顺数据
	                                    , isPlaying: true // 自动播放笔顺
	                                    , failCallback: _this2.canvasSupportError,
	                                    readStroke: true // 读笔画
	                                }) : _react2.default.createElement(
	                                    'div',
	                                    { style: { width: "200px", margin: "20px auto" } },
	                                    _react2.default.createElement('img', { style: { width: "100%" }, src: jif, alt: '' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: {
	                                        marginTop: "15px", display: "flex", justifyContent: "center",
	                                        flexWrap: "wrap", width: "65%", margin: "0 auto 10px"
	                                    } },
	                                arrBiShun.length > 0 ? arrBiShun.map(function (item, index) {
	                                    // console.log(ifLast, 'ifLast====')
	                                    var condition = controlIndex === index;
	                                    var color = condition ? "green" : "#B4B4B4";
	                                    return _react2.default.createElement(
	                                        'span',
	                                        {
	                                            style: { color: color, marginRight: "5px" },
	                                            key: "bishuns" + index },
	                                        item,
	                                        !ifLast && _react2.default.createElement(_BuShouSpeaker2.default, {
	                                            controlIndex: controlIndex,
	                                            isCurrent: condition,
	                                            BuShou: item })
	                                    );
	                                }) : ""
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'controlSpeed' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'speedBtn', onClick: function onClick() {
	                                            _this2.controlSpeed("fast");
	                                        } },
	                                    '\u5FEB'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'speedBtn', onClick: function onClick() {
	                                            _this2.controlSpeed("normal");
	                                        } },
	                                    '\u4E2D'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'speedBtn', onClick: function onClick() {
	                                            _this2.controlSpeed("slow");
	                                        } },
	                                    '\u6162'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'basicInfo' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                '\u57FA\u672C\u4FE1\u606F'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    '\u90E8\u9996\uFF1A',
	                                    bushou
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    '\u7B14\u753B\u6570\uFF1A',
	                                    bihuaCount
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    '\u5B57\u7684\u7ED3\u6784\uFF1A',
	                                    structure
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    '\u5B57\u7684\u7B14\u987A\uFF1A',
	                                    bishun
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'videoInfo' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                '\u89C6\u9891\u7CBE\u8BB2'
	                            ),
	                            videoUrl ? _react2.default.createElement(_CCPlayer2.default, {
	                                courseID: courseID,
	                                sectionID: sectionID,
	                                url: videoUrl }) : _react2.default.createElement(
	                                'div',
	                                { style: { textAlign: 'center', marginTop: '20%' } },
	                                '\u89C6\u9891\u52A0\u8F7D\u4E2D......'
	                            )
	                        )
	                    )
	                )
	            );
	        };
	
	        _this2.getTextTimeouter = null;
	        _this2.state = {
	            //搜索数据
	            words: [],
	            //搜索的关键字
	            text: '人',
	            bushou: '',
	            textInfo: null,
	            //笔画数量
	            bihuaCount: "",
	            //笔顺
	            bishun: "",
	            //拼音
	            pinyin: [],
	            //汉字结构
	            structure: "",
	            //音频路径的前缀
	            audioSrc: "",
	            bishunColor: "#969696",
	            //控制笔画结构的颜色
	            controlIndex: -1,
	            //是否显示笔顺
	            isShowBishun: true,
	            //偏旁部首是否是第一轮播放结束
	            ifLast: false,
	            //当前浏览器是否支持canvas  默认支持
	            isSupportCanvas: true,
	            //偏旁播放速度 默认1000毫秒
	            bushouSpeed: 1000,
	
	            current: 1,
	            courseID: null,
	            sectionID: null,
	            videoUrl: null,
	            videoLoading: false,
	            loading: false
	        };
	        return _this2;
	    }
	
	    _createClass(WordDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var text = this.state.text;
	
	            this.getTextDetailInfo(text);
	            this.getBiShunData(text);
	            this.getVideoUrl(text);
	        }
	
	        // 添加键盘事件处理函数
	
	
	        //获取笔顺canvas动画数据
	
	        //获取汉字
	
	
	        //视频
	
	
	        //点击搜索
	
	        //每个笔画开始的回调函数
	
	        //canvas 创建失败
	
	    }]);
	
	    return WordDetail;
	}(_react2.default.Component);
	
	exports.default = WordDetail;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(329);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(578);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(87);
	
	var _SingleBook = __webpack_require__(680);
	
	var _SingleBook2 = _interopRequireDefault(_SingleBook);
	
	var _WordList = __webpack_require__(671);
	
	var _WordList2 = _interopRequireDefault(_WordList);
	
	var _BookList = __webpack_require__(673);
	
	var _BookList2 = _interopRequireDefault(_BookList);
	
	var _PressList = __webpack_require__(679);
	
	var _PressList2 = _interopRequireDefault(_PressList);
	
	var _GankaoApp = __webpack_require__(678);
	
	var _GankaoApp2 = _interopRequireDefault(_GankaoApp);
	
	var _WordDetail = __webpack_require__(687);
	
	var _WordDetail2 = _interopRequireDefault(_WordDetail);
	
	__webpack_require__(543);
	
	var _isomorphicFetch = __webpack_require__(93);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _TongBu = __webpack_require__(685);
	
	var _TongBu2 = _interopRequireDefault(_TongBu);
	
	var _TongBuShuFa = __webpack_require__(686);
	
	var _TongBuShuFa2 = _interopRequireDefault(_TongBuShuFa);
	
	var _GanKao = __webpack_require__(675);
	
	var _GanKao2 = _interopRequireDefault(_GanKao);
	
	var _Word = __webpack_require__(677);
	
	var _Word2 = _interopRequireDefault(_Word);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// `//bishunfile.qiaoxuesi.com/book_data.json?v=${Math.random()}`
	(0, _isomorphicFetch2.default)('//bishunfile.qiaoxuesi.com/book_data.json?v=' + Math.random(), {
	    method: 'GET'
	}).then(function (response) {
	    if (response.status !== 200) {
	        console.log("初始化获取全局数据,存在一个问题，状态码为：" + response.status);
	        return;
	    }
	    response.json().then(function (data) {
	        window.AllBooksForPress = data;
	        var route = _react2.default.createElement(
	            _reactRouter.Router,
	            { history: _reactRouter.hashHistory },
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: '/', components: _PressList2.default },
	                _react2.default.createElement(
	                    _reactRouter.Route,
	                    { path: '/press/:presspinyin', component: _BookList2.default },
	                    _react2.default.createElement(
	                        _reactRouter.Route,
	                        { path: '/press/:presspinyin/book/:bookId', components: _SingleBook2.default },
	                        _react2.default.createElement(_reactRouter.Route, { path: '/press/:presspinyin/book/:bookId/word/:wordId', components: _WordList2.default })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: '/gankao', components: _GankaoApp2.default },
	                _react2.default.createElement(_reactRouter.Route, { path: '/WordDetail', component: _WordDetail2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/TongBu', component: _TongBu2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/TongBuShuFa', component: _TongBuShuFa2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: '/gankao2', components: _GanKao2.default },
	                _react2.default.createElement(_reactRouter.Route, { path: '/Word', component: _Word2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/TongBu', component: _TongBu2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: '/TongBuShuFa', component: _TongBuShuFa2.default })
	            )
	        );
	        _reactDom2.default.render(route, document.getElementById('root'));
	    });
	}).catch(function (err) {
	    console.log("Fetch错误:" + err);
	});

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(536));
	var shallowEqual = _interopDefault(__webpack_require__(705));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 690 */
166,
/* 691 */
[733, 98],
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(691);
	var ReactElement = __webpack_require__(89);
	
	var emptyFunction = __webpack_require__(42);
	var traverseAllChildren = __webpack_require__(701);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(89);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(89),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(241);
	
	module.exports = factory(isValidElement);

/***/ },
/* 695 */
618,
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(271),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(89),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(274);
	var factory = __webpack_require__(533);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 697 */
637,
/* 698 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(98);
	
	var ReactElement = __webpack_require__(89);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(98);
	
	var ReactCurrentOwner = __webpack_require__(56);
	var REACT_ELEMENT_TYPE = __webpack_require__(273);
	
	var getIteratorFn = __webpack_require__(697);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(690);
	var warning = __webpack_require__(10);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _objectSpread = __webpack_require__(308);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
	
	/**
	 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
	 *
	 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
	 * during build.
	 * @param {number} code
	 */
	function formatProdErrorMessage(code) {
	  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
	}
	
	// Inlined version of the `symbol-observable` polyfill
	var $$observable = (function () {
	  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
	})();
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var randomString = function randomString() {
	  return Math.random().toString(36).substring(7).split('').join('.');
	};
	
	var ActionTypes = {
	  INIT: "@@redux/INIT" + randomString(),
	  REPLACE: "@@redux/REPLACE" + randomString(),
	  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
	    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
	  }
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = obj;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
	function miniKindOf(val) {
	  if (val === void 0) return 'undefined';
	  if (val === null) return 'null';
	  var type = typeof val;
	
	  switch (type) {
	    case 'boolean':
	    case 'string':
	    case 'number':
	    case 'symbol':
	    case 'function':
	      {
	        return type;
	      }
	  }
	
	  if (Array.isArray(val)) return 'array';
	  if (isDate(val)) return 'date';
	  if (isError(val)) return 'error';
	  var constructorName = ctorName(val);
	
	  switch (constructorName) {
	    case 'Symbol':
	    case 'Promise':
	    case 'WeakMap':
	    case 'WeakSet':
	    case 'Map':
	    case 'Set':
	      return constructorName;
	  } // other
	
	
	  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
	}
	
	function ctorName(val) {
	  return typeof val.constructor === 'function' ? val.constructor.name : null;
	}
	
	function isError(val) {
	  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
	}
	
	function isDate(val) {
	  if (val instanceof Date) return true;
	  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
	}
	
	function kindOf(val) {
	  var typeOfVal = typeof val;
	
	  if (false) {
	    typeOfVal = miniKindOf(val);
	  }
	
	  return typeOfVal;
	}
	
	/**
	 * @deprecated
	 *
	 * **We recommend using the `configureStore` method
	 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
	 *
	 * Redux Toolkit is our recommended approach for writing Redux logic today,
	 * including store setup, reducers, data fetching, and more.
	 *
	 * **For more details, please read this Redux docs page:**
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
	 * simplifies setup and helps avoid common bugs.
	 *
	 * You should not be using the `redux` core package by itself today, except for learning purposes.
	 * The `createStore` method from the core `redux` package will not be removed, but we encourage
	 * all users to migrate to using Redux Toolkit for all Redux code.
	 *
	 * If you want to use `createStore` without this visual deprecation warning, use
	 * the `legacy_createStore` import instead:
	 *
	 * `import { legacy_createStore as createStore} from 'redux'`
	 *
	 */
	
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
	    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
	  }
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	  /**
	   * This makes a shallow copy of currentListeners so we can use
	   * nextListeners as a temporary list while dispatching.
	   *
	   * This prevents any bugs around consumers calling
	   * subscribe/unsubscribe in the middle of a dispatch.
	   */
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	
	
	  function getState() {
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	    }
	
	    var isSubscribed = true;
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
	      }
	
	      isSubscribed = false;
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	      currentListeners = null;
	    };
	  }
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	
	
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
	    }
	
	    if (isDispatching) {
	      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	
	
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
	    }
	
	    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
	    // Any reducers that existed in both the new and old rootReducer
	    // will receive the previous state. This effectively populates
	    // the new state tree with any relevant data from the old one.
	
	    dispatch({
	      type: ActionTypes.REPLACE
	    });
	  }
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	
	
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object' || observer === null) {
	          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  } // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	
	
	  dispatch({
	    type: ActionTypes.INIT
	  });
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	/**
	 * Creates a Redux store that holds the state tree.
	 *
	 * **We recommend using `configureStore` from the
	 * `@reduxjs/toolkit` package**, which replaces `createStore`:
	 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
	 *
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	var legacy_createStore = createStore;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, {
	      type: ActionTypes.INIT
	    });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
	    }
	
	    if (typeof reducer(undefined, {
	      type: ActionTypes.PROBE_UNKNOWN_ACTION()
	    }) === 'undefined') {
	      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
	    }
	  });
	}
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning("No reducer provided for key \"" + key + "\"");
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	
	  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
	  // keys multiple times.
	
	  var unexpectedKeyCache;
	
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError;
	
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination(state, action) {
	    if (state === void 0) {
	      state = {};
	    }
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	
	      if (typeof nextStateForKey === 'undefined') {
	        var actionType = action && action.type;
	        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
	      }
	
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	
	    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass an action creator as the first argument,
	 * and get a dispatch wrapped function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
	  }
	
	  var boundActionCreators = {};
	
	  for (var key in actionCreators) {
	    var actionCreator = actionCreators[key];
	
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      var store = createStore.apply(void 0, arguments);
	
	      var _dispatch = function dispatch() {
	        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(void 0, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(void 0, chain)(store.dispatch);
	      return _objectSpread__default['default'](_objectSpread__default['default']({}, store), {}, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;
	exports.applyMiddleware = applyMiddleware;
	exports.bindActionCreators = bindActionCreators;
	exports.combineReducers = combineReducers;
	exports.compose = compose;
	exports.createStore = createStore;
	exports.legacy_createStore = legacy_createStore;


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(276);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 704 */
/***/ function(module, exports) {

	module.exports = SafeParseTuple
	
	function SafeParseTuple(obj, reviver) {
	    var json
	    var error = null
	
	    try {
	        json = JSON.parse(obj, reviver)
	    } catch (err) {
	        error = err
	    }
	
	    return [error, json]
	}


/***/ },
/* 705 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 706 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 707 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAqCAYAAADBNhlmAAAAAXNSR0IArs4c6QAABTVJREFUWAnNmV1oXEUUx927WVZaiQmKNNHWFwVBQoNobVHRhCo2Im0fjCBKyDdI9UFoiy8FUbDNi4gvzRdpMKhEH7IFwTSprdhozINWxYqIfahijKAJalaTNBt//9uZ9e69e7ubZHfNwOTMzPn63zNfZzaRa1ZZhoeHr5udnd2D2u5IJLJ1ZWWlGlpNP0Wdpv5MvUQ9BW+0s7MzSXvNJZKvZm9vbwMOD1Dr0Ynnqfc3cuPRaPT1tra203nqZIjlBNjT03MPGl0AeyhD80pnCTJNBBU1B5kq6BZqjJpRkBkF6OHW1tYvMxg5OqEAceYA7ij6B702cDRFTeBspLm5+VvaK14+epG+vr6aVCq1l/F91Ls8fC2Dlzs6Ol7y63lkMppZAQ4NDZXPz8+/heRjHulzZWVlh4jAp56xnE0+8kGENAM7rDDg3qPflM/6DAA04M5hrEYGMfYnxlox9q51sBYK0GewcxzdTdLH7hT9ulwgHa8zFJxkMvk2Yy446EWitnO94OSDaX2TZXE/zR/Vx5ciegIaCJL4tmQAZKceQ6HBMH+A3tvS0nLBCq+XspO/0AcTvZ+MrSdYr0euZjeNHnA7Wdh2ff0Ri8V2FRKcF0R3d7c2zsdUTbc2Ti2z9DU0UNIRJHJdlus4TnOxwMkHYD6HPGv8OUT0mGkHiBtBwvz48vLySXERPst6qQtIFnhAa4+NM4XZu43peoCf8btxI8jUPu9hHPK0i9YkEDo/vb68GNJ+IwMDAxWLi4u/MhJDaYLoaaeVrLAez+NsOzVZWVl5Y2Njo67HdHEA10DPXk0jaU7pGtbnprm5uYf9bjXFj9hBdm7CtktFORu9PoMAmdatAgOd5279vlTArJ/y8vKvaOuoUdl2hfz3VxmIcjmd7MpISl5Yc8s4nZFji8ULQlPsAiSC/wtAA2ZaFAwuFjPmkvRB7R0sdRtgbsqms9HvWwDdyGULr1+4WH2P71/8PgQwNLx+4WL0eeNEieBNsg3NCvCSmHzFZq6829QuZeHsq8F3VD6hF/2+dVGP2UHuY6XpJS34T/ukfcrv3OFwfp/By4ahN0RJC1FzfQJusaKi4kO/c4fDeY7Bj8RA6L7+/n6bXfhlC97XewWAtcbwOGfiX34n7jFD/veGGAhHmObQ3MyvXIB+l7VBcPSCDBQXYHt7ewKBCXEBWU+GUfSpJoN/Gl87DKIzYFCGHSguQDPqzc1OAPKOgHSBBpjaWsDphadlpavuxTDTaYDkgZ8g/JoRvB56cnBw8IYwxbWOk39uAVyCulk28HmETPqzMHtpgBJgFx1EYdQI376wsDBZyEiyAbcvLS1NYt/NWvA1xkvvVeMvK8kAqMyCL3sSxW8kTVsH9yRTsj+r9ioG+dCn2IAT2LzVqtG+mcvBvUXsmJ8GLmcJYExT/A71UfVVAH2W3X6YL9ZDJ++CLT0htFt3WSVs/QO4a03/Anbr2SRuymVlLM0KUEzdkVxD+k3lBStsqN7OIzzAE/xO852P53aJ+J2A2IvuPqp+HbPlMmBeoXOc8Q+o9gwMBRkK0FrUgx5DAvqAHbNUkaCtZEMZUQQZ5XNV1Dg1oyA7Bbjn7AxoA7LGx3OBzAnQejFv5wP066j2kWXZYTQFY5x6NNubNx+QeQO0CLQ+icYe+rup24hAFf1qqGzN0J6hranXL6unidjvtENLLpCrBhjqaR2Mq4HcEAD1bWEgNwzAbCBZLmMZB/U6Zqkgqk1NTb/F43H9e+O8MXjLhoqg/Ur9L4YzeD/JdNYMx8ptCPov2YQyR+QSco4AAAAASUVORK5CYII="

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	// see https://tools.ietf.org/html/rfc1808
	
	(function (root) {
	  var URL_REGEX =
	    /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
	  var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
	  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
	  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
	
	  var URLToolkit = {
	    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
	    // E.g
	    // With opts.alwaysNormalize = false (default, spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
	    // With opts.alwaysNormalize = true (not spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
	    buildAbsoluteURL: function (baseURL, relativeURL, opts) {
	      opts = opts || {};
	      // remove any remaining space and CRLF
	      baseURL = baseURL.trim();
	      relativeURL = relativeURL.trim();
	      if (!relativeURL) {
	        // 2a) If the embedded URL is entirely empty, it inherits the
	        // entire base URL (i.e., is set equal to the base URL)
	        // and we are done.
	        if (!opts.alwaysNormalize) {
	          return baseURL;
	        }
	        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
	        if (!basePartsForNormalise) {
	          throw new Error('Error trying to parse base URL.');
	        }
	        basePartsForNormalise.path = URLToolkit.normalizePath(
	          basePartsForNormalise.path
	        );
	        return URLToolkit.buildURLFromParts(basePartsForNormalise);
	      }
	      var relativeParts = URLToolkit.parseURL(relativeURL);
	      if (!relativeParts) {
	        throw new Error('Error trying to parse relative URL.');
	      }
	      if (relativeParts.scheme) {
	        // 2b) If the embedded URL starts with a scheme name, it is
	        // interpreted as an absolute URL and we are done.
	        if (!opts.alwaysNormalize) {
	          return relativeURL;
	        }
	        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
	        return URLToolkit.buildURLFromParts(relativeParts);
	      }
	      var baseParts = URLToolkit.parseURL(baseURL);
	      if (!baseParts) {
	        throw new Error('Error trying to parse base URL.');
	      }
	      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
	        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
	        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
	        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
	        baseParts.netLoc = pathParts[1];
	        baseParts.path = pathParts[2];
	      }
	      if (baseParts.netLoc && !baseParts.path) {
	        baseParts.path = '/';
	      }
	      var builtParts = {
	        // 2c) Otherwise, the embedded URL inherits the scheme of
	        // the base URL.
	        scheme: baseParts.scheme,
	        netLoc: relativeParts.netLoc,
	        path: null,
	        params: relativeParts.params,
	        query: relativeParts.query,
	        fragment: relativeParts.fragment,
	      };
	      if (!relativeParts.netLoc) {
	        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
	        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
	        // (if any) of the base URL.
	        builtParts.netLoc = baseParts.netLoc;
	        // 4) If the embedded URL path is preceded by a slash "/", the
	        // path is not relative and we skip to Step 7.
	        if (relativeParts.path[0] !== '/') {
	          if (!relativeParts.path) {
	            // 5) If the embedded URL path is empty (and not preceded by a
	            // slash), then the embedded URL inherits the base URL path
	            builtParts.path = baseParts.path;
	            // 5a) if the embedded URL's <params> is non-empty, we skip to
	            // step 7; otherwise, it inherits the <params> of the base
	            // URL (if any) and
	            if (!relativeParts.params) {
	              builtParts.params = baseParts.params;
	              // 5b) if the embedded URL's <query> is non-empty, we skip to
	              // step 7; otherwise, it inherits the <query> of the base
	              // URL (if any) and we skip to step 7.
	              if (!relativeParts.query) {
	                builtParts.query = baseParts.query;
	              }
	            }
	          } else {
	            // 6) The last segment of the base URL's path (anything
	            // following the rightmost slash "/", or the entire path if no
	            // slash is present) is removed and the embedded URL's path is
	            // appended in its place.
	            var baseURLPath = baseParts.path;
	            var newPath =
	              baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) +
	              relativeParts.path;
	            builtParts.path = URLToolkit.normalizePath(newPath);
	          }
	        }
	      }
	      if (builtParts.path === null) {
	        builtParts.path = opts.alwaysNormalize
	          ? URLToolkit.normalizePath(relativeParts.path)
	          : relativeParts.path;
	      }
	      return URLToolkit.buildURLFromParts(builtParts);
	    },
	    parseURL: function (url) {
	      var parts = URL_REGEX.exec(url);
	      if (!parts) {
	        return null;
	      }
	      return {
	        scheme: parts[1] || '',
	        netLoc: parts[2] || '',
	        path: parts[3] || '',
	        params: parts[4] || '',
	        query: parts[5] || '',
	        fragment: parts[6] || '',
	      };
	    },
	    normalizePath: function (path) {
	      // The following operations are
	      // then applied, in order, to the new path:
	      // 6a) All occurrences of "./", where "." is a complete path
	      // segment, are removed.
	      // 6b) If the path ends with "." as a complete path segment,
	      // that "." is removed.
	      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
	      // 6c) All occurrences of "<segment>/../", where <segment> is a
	      // complete path segment not equal to "..", are removed.
	      // Removal of these path segments is performed iteratively,
	      // removing the leftmost matching pattern on each iteration,
	      // until no matching pattern remains.
	      // 6d) If the path ends with "<segment>/..", where <segment> is a
	      // complete path segment not equal to "..", that
	      // "<segment>/.." is removed.
	      while (
	        path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length
	      ) {}
	      return path.split('').reverse().join('');
	    },
	    buildURLFromParts: function (parts) {
	      return (
	        parts.scheme +
	        parts.netLoc +
	        parts.path +
	        parts.params +
	        parts.query +
	        parts.fragment
	      );
	    },
	  };
	
	  if (true)
	    module.exports = URLToolkit;
	  else if (typeof define === 'function' && define.amd)
	    define([], function () {
	      return URLToolkit;
	    });
	  else if (typeof exports === 'object') exports['URLToolkit'] = URLToolkit;
	  else root['URLToolkit'] = URLToolkit;
	})(this);


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(58));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _redux = __webpack_require__(702);
	
	var _reducers = _interopRequireDefault(__webpack_require__(300));
	
	var playerActions = _interopRequireWildcard(__webpack_require__(128));
	
	var videoActions = _interopRequireWildcard(__webpack_require__(181));
	
	var Manager =
	/*#__PURE__*/
	function () {
	  function Manager(store) {
	    (0, _classCallCheck2["default"])(this, Manager);
	    this.store = store || (0, _redux.createStore)(_reducers["default"]);
	    this.video = null;
	    this.rootElement = null;
	  }
	
	  (0, _createClass2["default"])(Manager, [{
	    key: "getActions",
	    value: function getActions() {
	      var manager = this;
	      var dispatch = this.store.dispatch;
	      var actions = (0, _objectSpread2["default"])({}, playerActions, videoActions);
	
	      function bindActionCreator(actionCreator) {
	        return function bindAction() {
	          // eslint-disable-next-line prefer-rest-params
	          var action = actionCreator.apply(manager, arguments);
	
	          if (typeof action !== 'undefined') {
	            dispatch(action);
	          }
	        };
	      }
	
	      return Object.keys(actions).filter(function (key) {
	        return typeof actions[key] === 'function';
	      }).reduce(function (boundActions, key) {
	        boundActions[key] = bindActionCreator(actions[key]);
	        return boundActions;
	      }, {});
	    }
	  }, {
	    key: "getState",
	    value: function getState() {
	      return this.store.getState();
	    } // subscribe state change
	
	  }, {
	    key: "subscribeToStateChange",
	    value: function subscribeToStateChange(listener, getState) {
	      if (!getState) {
	        getState = this.getState.bind(this);
	      }
	
	      var prevState = getState();
	
	      var handleChange = function handleChange() {
	        var state = getState();
	
	        if (state === prevState) {
	          return;
	        }
	
	        var prevStateCopy = prevState;
	        prevState = state;
	        listener(state, prevStateCopy);
	      };
	
	      return this.store.subscribe(handleChange);
	    } // subscribe to operation state change
	
	  }, {
	    key: "subscribeToOperationStateChange",
	    value: function subscribeToOperationStateChange(listener) {
	      var _this = this;
	
	      return this.subscribeToStateChange(listener, function () {
	        return _this.getState().operation;
	      });
	    } // subscribe to player state change
	
	  }, {
	    key: "subscribeToPlayerStateChange",
	    value: function subscribeToPlayerStateChange(listener) {
	      var _this2 = this;
	
	      return this.subscribeToStateChange(listener, function () {
	        return _this2.getState().player;
	      });
	    }
	  }]);
	  return Manager;
	}();
	
	exports["default"] = Manager;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(58));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(99));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(130));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Manager = _interopRequireDefault(__webpack_require__(709));
	
	var _BigPlayButton = _interopRequireDefault(__webpack_require__(278));
	
	var _LoadingSpinner = _interopRequireDefault(__webpack_require__(280));
	
	var _PosterImage = _interopRequireDefault(__webpack_require__(281));
	
	var _Video = _interopRequireDefault(__webpack_require__(283));
	
	var _Bezel = _interopRequireDefault(__webpack_require__(277));
	
	var _Shortcut = _interopRequireDefault(__webpack_require__(282));
	
	var _ControlBar = _interopRequireDefault(__webpack_require__(284));
	
	var browser = _interopRequireWildcard(__webpack_require__(722));
	
	var _dom = __webpack_require__(129);
	
	var _utils = __webpack_require__(51);
	
	var _fullscreen = _interopRequireDefault(__webpack_require__(301));
	
	var propTypes = {
	  children: _propTypes["default"].any,
	  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  fluid: _propTypes["default"].bool,
	  muted: _propTypes["default"].bool,
	  playsInline: _propTypes["default"].bool,
	  aspectRatio: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  videoId: _propTypes["default"].string,
	  startTime: _propTypes["default"].number,
	  loop: _propTypes["default"].bool,
	  autoPlay: _propTypes["default"].bool,
	  src: _propTypes["default"].string,
	  poster: _propTypes["default"].string,
	  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
	  onLoadStart: _propTypes["default"].func,
	  onWaiting: _propTypes["default"].func,
	  onCanPlay: _propTypes["default"].func,
	  onCanPlayThrough: _propTypes["default"].func,
	  onPlaying: _propTypes["default"].func,
	  onEnded: _propTypes["default"].func,
	  onSeeking: _propTypes["default"].func,
	  onSeeked: _propTypes["default"].func,
	  onPlay: _propTypes["default"].func,
	  onPause: _propTypes["default"].func,
	  onProgress: _propTypes["default"].func,
	  onDurationChange: _propTypes["default"].func,
	  onError: _propTypes["default"].func,
	  onSuspend: _propTypes["default"].func,
	  onAbort: _propTypes["default"].func,
	  onEmptied: _propTypes["default"].func,
	  onStalled: _propTypes["default"].func,
	  onLoadedMetadata: _propTypes["default"].func,
	  onLoadedData: _propTypes["default"].func,
	  onTimeUpdate: _propTypes["default"].func,
	  onRateChange: _propTypes["default"].func,
	  onVolumeChange: _propTypes["default"].func,
	  store: _propTypes["default"].object
	};
	var defaultProps = {
	  fluid: true,
	  muted: false,
	  playsInline: false,
	  preload: 'auto',
	  aspectRatio: 'auto'
	};
	
	var Player =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Player, _Component);
	
	  function Player(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Player);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Player).call(this, props));
	    _this.controlsHideTimer = null;
	    _this.video = null; // the Video component
	
	    _this.manager = new _Manager["default"](props.store);
	    _this.actions = _this.manager.getActions();
	
	    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
	
	    _this.getStyle = _this.getStyle.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getChildren = _this.getChildren.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this)), 250);
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.startControlsTimer = _this.startControlsTimer.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFullScreenChange = _this.handleFullScreenChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Player, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.handleResize();
	      window.addEventListener('resize', this.handleResize);
	
	      _fullscreen["default"].addEventListener(this.handleFullScreenChange);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // Remove event listener
	      window.removeEventListener('resize', this.handleResize);
	
	      _fullscreen["default"].removeEventListener(this.handleFullScreenChange);
	
	      if (this.controlsHideTimer) {
	        window.clearTimeout(this.controlsHideTimer);
	      }
	    }
	  }, {
	    key: "getDefaultChildren",
	    value: function getDefaultChildren(originalChildren) {
	      var _this2 = this;
	
	      return [_react["default"].createElement(_Video["default"], {
	        ref: function ref(c) {
	          _this2.video = c;
	          _this2.manager.video = _this2.video;
	        },
	        key: "video",
	        order: 0.0
	      }, originalChildren), _react["default"].createElement(_PosterImage["default"], {
	        key: "poster-image",
	        order: 1.0
	      }), _react["default"].createElement(_LoadingSpinner["default"], {
	        key: "loading-spinner",
	        order: 2.0
	      }), _react["default"].createElement(_Bezel["default"], {
	        key: "bezel",
	        order: 3.0
	      }), _react["default"].createElement(_BigPlayButton["default"], {
	        key: "big-play-button",
	        order: 4.0
	      }), _react["default"].createElement(_ControlBar["default"], {
	        key: "control-bar",
	        order: 5.0
	      }), _react["default"].createElement(_Shortcut["default"], {
	        key: "shortcut",
	        order: 99.0
	      })];
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren(props) {
	      var _ = props.className,
	          originalChildren = props.children,
	          propsWithoutChildren = (0, _objectWithoutProperties2["default"])(props, ["className", "children"]);
	
	      var children = _react["default"].Children.toArray(this.props.children).filter(function (e) {
	        return !(0, _utils.isVideoChild)(e);
	      });
	
	      var defaultChildren = this.getDefaultChildren(originalChildren);
	      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
	    }
	  }, {
	    key: "setWidthOrHeight",
	    value: function setWidthOrHeight(style, name, value) {
	      var styleVal;
	
	      if (typeof value === 'string') {
	        if (value === 'auto') {
	          styleVal = 'auto';
	        } else if (value.match(/\d+%/)) {
	          styleVal = value;
	        }
	      } else if (typeof value === 'number') {
	        styleVal = "".concat(value, "px");
	      }
	
	      Object.assign(style, (0, _defineProperty2["default"])({}, name, styleVal));
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle() {
	      var _this$props = this.props,
	          fluid = _this$props.fluid,
	          propsAspectRatio = _this$props.aspectRatio,
	          propsHeight = _this$props.height,
	          propsWidth = _this$props.width;
	
	      var _this$manager$getStat = this.manager.getState(),
	          player = _this$manager$getStat.player;
	
	      var style = {};
	      var width;
	      var height;
	      var aspectRatio; // The aspect ratio is either used directly or to calculate width and height.
	
	      if (propsAspectRatio !== undefined && propsAspectRatio !== 'auto') {
	        // Use any aspectRatio that's been specifically set
	        aspectRatio = propsAspectRatio;
	      } else if (player.videoWidth) {
	        // Otherwise try to get the aspect ratio from the video metadata
	        aspectRatio = "".concat(player.videoWidth, ":").concat(player.videoHeight);
	      } else {
	        // Or use a default. The video element's is 2:1, but 16:9 is more common.
	        aspectRatio = '16:9';
	      } // Get the ratio as a decimal we can use to calculate dimensions
	
	
	      var ratioParts = aspectRatio.split(':');
	      var ratioMultiplier = ratioParts[1] / ratioParts[0];
	
	      if (propsWidth !== undefined) {
	        // Use any width that's been specifically set
	        width = propsWidth;
	      } else if (propsHeight !== undefined) {
	        // Or calulate the width from the aspect ratio if a height has been set
	        width = propsHeight / ratioMultiplier;
	      } else {
	        // Or use the video's metadata, or use the video el's default of 300
	        width = player.videoWidth || 400;
	      }
	
	      if (propsHeight !== undefined) {
	        // Use any height that's been specifically set
	        height = propsHeight;
	      } else {
	        // Otherwise calculate the height from the ratio and the width
	        height = width * ratioMultiplier;
	      }
	
	      if (fluid) {
	        style.paddingTop = "".concat(ratioMultiplier * 100, "%");
	      } else {
	        // If Width contains "auto", set "auto" in style
	        this.setWidthOrHeight(style, 'width', width);
	        this.setWidthOrHeight(style, 'height', height);
	      }
	
	      return style;
	    } // get redux state
	    // { player, operation }
	
	  }, {
	    key: "getState",
	    value: function getState() {
	      return this.manager.getState();
	    } // get playback rate
	
	  }, {
	    key: "play",
	    // play the video
	    value: function play() {
	      this.video.play();
	    } // pause the video
	
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.video.pause();
	    } // Change the video source and re-load the video:
	
	  }, {
	    key: "load",
	    value: function load() {
	      this.video.load();
	    } // Add a new text track to the video
	
	  }, {
	    key: "addTextTrack",
	    value: function addTextTrack() {
	      var _this$video;
	
	      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
	    } // Check if your browser can play different types of video:
	
	  }, {
	    key: "canPlayType",
	    value: function canPlayType() {
	      var _this$video2;
	
	      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
	    } // seek video by time
	
	  }, {
	    key: "seek",
	    value: function seek(time) {
	      this.video.seek(time);
	    } // jump forward x seconds
	
	  }, {
	    key: "forward",
	    value: function forward(seconds) {
	      this.video.forward(seconds);
	    } // jump back x seconds
	
	  }, {
	    key: "replay",
	    value: function replay(seconds) {
	      this.video.replay(seconds);
	    } // enter or exist full screen
	
	  }, {
	    key: "toggleFullscreen",
	    value: function toggleFullscreen() {
	      this.video.toggleFullscreen();
	    } // subscribe to player state change
	
	  }, {
	    key: "subscribeToStateChange",
	    value: function subscribeToStateChange(listener) {
	      return this.manager.subscribeToPlayerStateChange(listener);
	    } // player resize
	
	  }, {
	    key: "handleResize",
	    value: function handleResize() {}
	  }, {
	    key: "handleFullScreenChange",
	    value: function handleFullScreenChange(event) {
	      if (event.target === this.manager.rootElement) {
	        this.actions.handleFullscreenChange(_fullscreen["default"].isFullscreen);
	      }
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: "startControlsTimer",
	    value: function startControlsTimer() {
	      var _this3 = this;
	
	      var controlBarActiveTime = 3000;
	
	      _react["default"].Children.forEach(this.props.children, function (element) {
	        if (!_react["default"].isValidElement(element) || element.type !== _ControlBar["default"]) {
	          return;
	        }
	
	        var autoHideTime = element.props.autoHideTime;
	
	        if (typeof autoHideTime === 'number') {
	          controlBarActiveTime = autoHideTime;
	        }
	      });
	
	      this.actions.userActivate(true);
	      clearTimeout(this.controlsHideTimer);
	      this.controlsHideTimer = setTimeout(function () {
	        _this3.actions.userActivate(false);
	      }, controlBarActiveTime);
	    }
	  }, {
	    key: "handleStateChange",
	    value: function handleStateChange(state, prevState) {
	      if (state.isFullscreen !== prevState.isFullscreen) {
	        this.handleResize(); // focus root when switching fullscreen mode to avoid confusion #276
	
	        (0, _dom.focusNode)(this.manager.rootElement);
	      }
	
	      this.forceUpdate(); // re-render
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      this.actions.activate(true);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.actions.activate(false);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var fluid = this.props.fluid;
	
	      var _this$manager$getStat2 = this.manager.getState(),
	          player = _this$manager$getStat2.player;
	
	      var paused = player.paused,
	          hasStarted = player.hasStarted,
	          waiting = player.waiting,
	          seeking = player.seeking,
	          isFullscreen = player.isFullscreen,
	          userActivity = player.userActivity;
	      var props = (0, _objectSpread2["default"])({}, this.props, {
	        player: player,
	        actions: this.actions,
	        manager: this.manager,
	        store: this.manager.store,
	        video: this.video ? this.video.video : null
	      });
	      var children = this.getChildren(props);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])({
	          'video-react-controls-enabled': true,
	          'video-react-has-started': hasStarted,
	          'video-react-paused': paused,
	          'video-react-playing': !paused,
	          'video-react-waiting': waiting,
	          'video-react-seeking': seeking,
	          'video-react-fluid': fluid,
	          'video-react-fullscreen': isFullscreen,
	          'video-react-user-inactive': !userActivity,
	          'video-react-user-active': userActivity,
	          'video-react-workinghover': !browser.IS_IOS
	        }, 'video-react', this.props.className),
	        style: this.getStyle(),
	        ref: function ref(c) {
	          _this4.manager.rootElement = c;
	        },
	        role: "region",
	        onTouchStart: this.handleMouseDown,
	        onMouseDown: this.handleMouseDown,
	        onTouchMove: this.handleMouseMove,
	        onMouseMove: this.handleMouseMove,
	        onKeyDown: this.handleKeyDown,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        tabIndex: "-1"
	      }, children);
	    }
	  }, {
	    key: "playbackRate",
	    get: function get() {
	      return this.video.playbackRate;
	    } // set playback rate
	    // speed of video
	    ,
	    set: function set(rate) {
	      this.video.playbackRate = rate;
	    }
	  }, {
	    key: "muted",
	    get: function get() {
	      return this.video.muted;
	    },
	    set: function set(val) {
	      this.video.muted = val;
	    }
	  }, {
	    key: "volume",
	    get: function get() {
	      return this.video.volume;
	    },
	    set: function set(val) {
	      this.video.volume = val;
	    } // video width
	
	  }, {
	    key: "videoWidth",
	    get: function get() {
	      return this.video.videoWidth;
	    } // video height
	
	  }, {
	    key: "videoHeight",
	    get: function get() {
	      return this.video.videoHeight;
	    }
	  }]);
	  return Player;
	}(_react.Component);
	
	exports["default"] = Player;
	Player.contextTypes = {
	  store: _propTypes["default"].object
	};
	Player.propTypes = propTypes;
	Player.defaultProps = defaultProps;
	Player.displayName = 'Player';

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _MenuButton = _interopRequireDefault(__webpack_require__(184));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  actions: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  offMenuText: _propTypes["default"].string,
	  showOffMenu: _propTypes["default"].bool,
	  kinds: _propTypes["default"].array
	};
	var defaultProps = {
	  offMenuText: 'Off',
	  showOffMenu: true,
	  kinds: ['captions', 'subtitles'] // `kind`s of TextTrack to look for to associate it with this menu.
	
	};
	
	var ClosedCaptionButton =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ClosedCaptionButton, _Component);
	
	  function ClosedCaptionButton(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ClosedCaptionButton);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClosedCaptionButton).call(this, props, context));
	    _this.getTextTrackItems = _this.getTextTrackItems.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.updateState = _this.updateState.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.state = _this.getTextTrackItems();
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ClosedCaptionButton, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateState();
	    }
	  }, {
	    key: "getTextTrackItems",
	    value: function getTextTrackItems() {
	      var _this$props = this.props,
	          kinds = _this$props.kinds,
	          player = _this$props.player,
	          offMenuText = _this$props.offMenuText,
	          showOffMenu = _this$props.showOffMenu;
	      var textTracks = player.textTracks,
	          activeTextTrack = player.activeTextTrack;
	      var textTrackItems = {
	        items: [],
	        selectedIndex: 0
	      };
	      var tracks = Array.from(textTracks || []);
	
	      if (tracks.length === 0) {
	        return textTrackItems;
	      }
	
	      if (showOffMenu) {
	        textTrackItems.items.push({
	          label: offMenuText || 'Off',
	          value: null
	        });
	      }
	
	      tracks.forEach(function (textTrack) {
	        // ignore invalid text track kind
	        if (kinds.length && !kinds.includes(textTrack.kind)) {
	          return;
	        }
	
	        textTrackItems.items.push({
	          label: textTrack.label,
	          value: textTrack.language
	        });
	      });
	      textTrackItems.selectedIndex = textTrackItems.items.findIndex(function (item) {
	        return activeTextTrack && activeTextTrack.language === item.value;
	      });
	
	      if (textTrackItems.selectedIndex === -1) {
	        textTrackItems.selectedIndex = 0;
	      }
	
	      return textTrackItems;
	    }
	  }, {
	    key: "updateState",
	    value: function updateState() {
	      var textTrackItems = this.getTextTrackItems();
	
	      if (textTrackItems.selectedIndex !== this.state.selectedIndex || !this.textTrackItemsAreEqual(textTrackItems.items, this.state.items)) {
	        this.setState(textTrackItems);
	      }
	    }
	  }, {
	    key: "textTrackItemsAreEqual",
	    value: function textTrackItemsAreEqual(items1, items2) {
	      if (items1.length !== items2.length) {
	        return false;
	      }
	
	      for (var i = 0; i < items1.length; i++) {
	        if (!items2[i] || items1[i].label !== items2[i].label || items1[i].value !== items2[i].value) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: "handleSelectItem",
	    value: function handleSelectItem(index) {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions,
	          showOffMenu = _this$props2.showOffMenu;
	      var textTracks = player.textTracks; // For the 'subtitles-off' button, the first condition will never match
	      // so all subtitles will be turned off
	
	      Array.from(textTracks).forEach(function (textTrack, i) {
	        // if it shows the `Off` menu, the first item is `Off`
	        if (index === (showOffMenu ? i + 1 : i)) {
	          textTrack.mode = 'showing';
	          actions.activateTextTrack(textTrack);
	        } else {
	          textTrack.mode = 'hidden';
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$state = this.state,
	          items = _this$state.items,
	          selectedIndex = _this$state.selectedIndex;
	      return _react["default"].createElement(_MenuButton["default"], {
	        className: (0, _classnames["default"])('video-react-closed-caption', this.props.className),
	        onSelectItem: this.handleSelectItem,
	        items: items,
	        selectedIndex: selectedIndex
	      }, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }, "Closed Caption"));
	    }
	  }]);
	  return ClosedCaptionButton;
	}(_react.Component);
	
	ClosedCaptionButton.propTypes = propTypes;
	ClosedCaptionButton.defaultProps = defaultProps;
	ClosedCaptionButton.displayName = 'ClosedCaptionButton';
	var _default = ClosedCaptionButton;
	exports["default"] = _default;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(183));
	
	var _utils = __webpack_require__(51);
	
	var PlaybackRate =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PlaybackRate, _Component);
	
	  function PlaybackRate(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PlaybackRate);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRate).call(this, props, context));
	    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PlaybackRate, [{
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(_PlaybackRateMenuButton["default"], this.props);
	    }
	  }]);
	  return PlaybackRate;
	}(_react.Component);
	
	exports["default"] = PlaybackRate;
	PlaybackRate.displayName = 'PlaybackRate';

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var propTypes = {
	  children: _propTypes["default"].any
	};
	
	var Menu =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Menu, _Component);
	
	  function Menu(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Menu);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Menu, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault(); // event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement("div", {
	        className: "video-react-menu video-react-lock-showing",
	        role: "presentation",
	        onClick: this.handleClick
	      }, _react["default"].createElement("ul", {
	        className: "video-react-menu-content"
	      }, this.props.children));
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	exports["default"] = Menu;
	Menu.propTypes = propTypes;
	Menu.displayName = 'Menu';

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  item: _propTypes["default"].object,
	  index: _propTypes["default"].number,
	  activateIndex: _propTypes["default"].number,
	  onSelectItem: _propTypes["default"].func
	};
	
	var MenuItem =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(MenuItem, _Component);
	
	  function MenuItem(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, MenuItem);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(MenuItem, [{
	    key: "handleClick",
	    value: function handleClick() {
	      var _this$props = this.props,
	          index = _this$props.index,
	          onSelectItem = _this$props.onSelectItem;
	      onSelectItem(index);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          item = _this$props2.item,
	          index = _this$props2.index,
	          activateIndex = _this$props2.activateIndex;
	      return _react["default"].createElement("li", {
	        className: (0, _classnames["default"])({
	          'video-react-menu-item': true,
	          'video-react-selected': index === activateIndex
	        }),
	        role: "menuitem",
	        onClick: this.handleClick
	      }, item.label, _react["default"].createElement("span", {
	        className: "video-react-control-text"
	      }));
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	exports["default"] = MenuItem;
	MenuItem.propTypes = propTypes;
	MenuItem.displayName = 'MenuItem';

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var propTypes = {
	  player: _propTypes["default"].object,
	  children: _propTypes["default"].any
	};
	
	var Popup =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Popup, _Component);
	
	  function Popup(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Popup);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Popup).call(this, props, context));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Popup, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault(); // event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return _react["default"].createElement("div", {
	        className: "video-react-menu",
	        onClick: this.handleClick
	      }, _react["default"].createElement("div", {
	        className: "video-react-menu-content"
	      }, children));
	    }
	  }]);
	  return Popup;
	}(_react.Component);
	
	exports["default"] = Popup;
	Popup.propTypes = propTypes;
	Popup.displayName = 'Popup';

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = PopupButton;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(57));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(58));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ClickableComponent = _interopRequireDefault(__webpack_require__(279));
	
	var _Popup = _interopRequireDefault(__webpack_require__(715));
	
	var propTypes = {
	  inline: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func.isRequired,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  inline: true
	};
	
	function PopupButton(props) {
	  var inline = props.inline,
	      className = props.className;
	  var ps = (0, _objectSpread2["default"])({}, props);
	  delete ps.children;
	  delete ps.inline;
	  delete ps.className;
	  return _react["default"].createElement(_ClickableComponent["default"], (0, _extends2["default"])({
	    className: (0, _classnames["default"])(className, {
	      'video-react-menu-button-inline': !!inline,
	      'video-react-menu-button-popup': !inline
	    }, 'video-react-control video-react-button video-react-menu-button')
	  }, ps), _react["default"].createElement(_Popup["default"], props));
	}
	
	PopupButton.propTypes = propTypes;
	PopupButton.defaultProps = defaultProps;
	PopupButton.displayName = 'PopupButton';

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(57));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(16));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(17));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(21));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(18));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Slider = _interopRequireDefault(__webpack_require__(182));
	
	var _VolumeLevel = _interopRequireDefault(__webpack_require__(718));
	
	var propTypes = {
	  actions: _propTypes["default"].object,
	  player: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func
	};
	
	var VolumeBar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(VolumeBar, _Component);
	
	  function VolumeBar(props, context) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, VolumeBar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeBar).call(this, props, context));
	    _this.state = {
	      percentage: '0%'
	    };
	    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.checkMuted = _this.checkMuted.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
	    return _this;
	  }
	
	  (0, _createClass2["default"])(VolumeBar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "getPercent",
	    value: function getPercent() {
	      var player = this.props.player;
	
	      if (player.muted) {
	        return 0;
	      }
	
	      return player.volume;
	    }
	  }, {
	    key: "checkMuted",
	    value: function checkMuted() {
	      var _this$props = this.props,
	          player = _this$props.player,
	          actions = _this$props.actions;
	
	      if (player.muted) {
	        actions.mute(false);
	      }
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(event) {
	      var actions = this.props.actions;
	      this.checkMuted();
	      var distance = this.slider.calculateDistance(event);
	      actions.changeVolume(distance);
	    }
	  }, {
	    key: "stepForward",
	    value: function stepForward() {
	      var _this$props2 = this.props,
	          player = _this$props2.player,
	          actions = _this$props2.actions;
	      this.checkMuted();
	      actions.changeVolume(player.volume + 0.1);
	    }
	  }, {
	    key: "stepBack",
	    value: function stepBack() {
	      var _this$props3 = this.props,
	          player = _this$props3.player,
	          actions = _this$props3.actions;
	      this.checkMuted();
	      actions.changeVolume(player.volume - 0.1);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(e) {
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(e) {
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: "handlePercentageChange",
	    value: function handlePercentageChange(percentage) {
	      if (percentage !== this.state.percentage) {
	        this.setState({
	          percentage: percentage
	        });
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          player = _this$props4.player,
	          className = _this$props4.className;
	      var volume = (player.volume * 100).toFixed(2);
	      return _react["default"].createElement(_Slider["default"], (0, _extends2["default"])({
	        ref: function ref(c) {
	          _this2.slider = c;
	        },
	        label: "volume level",
	        valuenow: volume,
	        valuetext: "".concat(volume, "%"),
	        onMouseMove: this.handleMouseMove,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        sliderActive: this.handleFocus,
	        sliderInactive: this.handleBlur,
	        getPercent: this.getPercent,
	        onPercentageChange: this.handlePercentageChange,
	        stepForward: this.stepForward,
	        stepBack: this.stepBack
	      }, this.props, {
	        className: (0, _classnames["default"])(className, 'video-react-volume-bar video-react-slider-bar')
	      }), _react["default"].createElement(_VolumeLevel["default"], this.props));
	    }
	  }]);
	  return VolumeBar;
	}(_react.Component);
	
	VolumeBar.propTypes = propTypes;
	VolumeBar.displayName = 'VolumeBar';
	var _default = VolumeBar;
	exports["default"] = _default;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var propTypes = {
	  percentage: _propTypes["default"].string,
	  vertical: _propTypes["default"].bool,
	  className: _propTypes["default"].string
	};
	var defaultProps = {
	  percentage: '100%',
	  vertical: false
	};
	
	function VolumeLevel(_ref) {
	  var percentage = _ref.percentage,
	      vertical = _ref.vertical,
	      className = _ref.className;
	  var style = {};
	
	  if (vertical) {
	    style.height = percentage;
	  } else {
	    style.width = percentage;
	  }
	
	  return _react["default"].createElement("div", {
	    className: (0, _classnames["default"])(className, 'video-react-volume-level'),
	    style: style
	  }, _react["default"].createElement("span", {
	    className: "video-react-control-text"
	  }));
	}
	
	VolumeLevel.propTypes = propTypes;
	VolumeLevel.defaultProps = defaultProps;
	VolumeLevel.displayName = 'VolumeLevel';
	var _default = VolumeLevel;
	exports["default"] = _default;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(20);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Player", {
	  enumerable: true,
	  get: function get() {
	    return _Player["default"];
	  }
	});
	Object.defineProperty(exports, "Video", {
	  enumerable: true,
	  get: function get() {
	    return _Video["default"];
	  }
	});
	Object.defineProperty(exports, "BigPlayButton", {
	  enumerable: true,
	  get: function get() {
	    return _BigPlayButton["default"];
	  }
	});
	Object.defineProperty(exports, "LoadingSpinner", {
	  enumerable: true,
	  get: function get() {
	    return _LoadingSpinner["default"];
	  }
	});
	Object.defineProperty(exports, "PosterImage", {
	  enumerable: true,
	  get: function get() {
	    return _PosterImage["default"];
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider["default"];
	  }
	});
	Object.defineProperty(exports, "Bezel", {
	  enumerable: true,
	  get: function get() {
	    return _Bezel["default"];
	  }
	});
	Object.defineProperty(exports, "Shortcut", {
	  enumerable: true,
	  get: function get() {
	    return _Shortcut["default"];
	  }
	});
	Object.defineProperty(exports, "ControlBar", {
	  enumerable: true,
	  get: function get() {
	    return _ControlBar["default"];
	  }
	});
	Object.defineProperty(exports, "PlayToggle", {
	  enumerable: true,
	  get: function get() {
	    return _PlayToggle["default"];
	  }
	});
	Object.defineProperty(exports, "ForwardControl", {
	  enumerable: true,
	  get: function get() {
	    return _ForwardControl["default"];
	  }
	});
	Object.defineProperty(exports, "ReplayControl", {
	  enumerable: true,
	  get: function get() {
	    return _ReplayControl["default"];
	  }
	});
	Object.defineProperty(exports, "FullscreenToggle", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenToggle["default"];
	  }
	});
	Object.defineProperty(exports, "ProgressControl", {
	  enumerable: true,
	  get: function get() {
	    return _ProgressControl["default"];
	  }
	});
	Object.defineProperty(exports, "SeekBar", {
	  enumerable: true,
	  get: function get() {
	    return _SeekBar["default"];
	  }
	});
	Object.defineProperty(exports, "PlayProgressBar", {
	  enumerable: true,
	  get: function get() {
	    return _PlayProgressBar["default"];
	  }
	});
	Object.defineProperty(exports, "LoadProgressBar", {
	  enumerable: true,
	  get: function get() {
	    return _LoadProgressBar["default"];
	  }
	});
	Object.defineProperty(exports, "MouseTimeDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _MouseTimeDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "VolumeMenuButton", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeMenuButton["default"];
	  }
	});
	Object.defineProperty(exports, "PlaybackRateMenuButton", {
	  enumerable: true,
	  get: function get() {
	    return _PlaybackRateMenuButton["default"];
	  }
	});
	Object.defineProperty(exports, "PlaybackRate", {
	  enumerable: true,
	  get: function get() {
	    return _PlaybackRate["default"];
	  }
	});
	Object.defineProperty(exports, "ClosedCaptionButton", {
	  enumerable: true,
	  get: function get() {
	    return _ClosedCaptionButton["default"];
	  }
	});
	Object.defineProperty(exports, "RemainingTimeDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _RemainingTimeDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "CurrentTimeDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _CurrentTimeDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "DurationDisplay", {
	  enumerable: true,
	  get: function get() {
	    return _DurationDisplay["default"];
	  }
	});
	Object.defineProperty(exports, "TimeDivider", {
	  enumerable: true,
	  get: function get() {
	    return _TimeDivider["default"];
	  }
	});
	Object.defineProperty(exports, "MenuButton", {
	  enumerable: true,
	  get: function get() {
	    return _MenuButton["default"];
	  }
	});
	Object.defineProperty(exports, "playerReducer", {
	  enumerable: true,
	  get: function get() {
	    return _reducers.playerReducer;
	  }
	});
	Object.defineProperty(exports, "operationReducer", {
	  enumerable: true,
	  get: function get() {
	    return _reducers.operationReducer;
	  }
	});
	exports.videoActions = exports.playerActions = void 0;
	
	var _Player = _interopRequireDefault(__webpack_require__(710));
	
	var _Video = _interopRequireDefault(__webpack_require__(283));
	
	var _BigPlayButton = _interopRequireDefault(__webpack_require__(278));
	
	var _LoadingSpinner = _interopRequireDefault(__webpack_require__(280));
	
	var _PosterImage = _interopRequireDefault(__webpack_require__(281));
	
	var _Slider = _interopRequireDefault(__webpack_require__(182));
	
	var _Bezel = _interopRequireDefault(__webpack_require__(277));
	
	var _Shortcut = _interopRequireDefault(__webpack_require__(282));
	
	var _ControlBar = _interopRequireDefault(__webpack_require__(284));
	
	var _PlayToggle = _interopRequireDefault(__webpack_require__(291));
	
	var _ForwardControl = _interopRequireDefault(__webpack_require__(285));
	
	var _ReplayControl = _interopRequireDefault(__webpack_require__(293));
	
	var _FullscreenToggle = _interopRequireDefault(__webpack_require__(287));
	
	var _ProgressControl = _interopRequireDefault(__webpack_require__(292));
	
	var _SeekBar = _interopRequireDefault(__webpack_require__(294));
	
	var _PlayProgressBar = _interopRequireDefault(__webpack_require__(290));
	
	var _LoadProgressBar = _interopRequireDefault(__webpack_require__(288));
	
	var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(289));
	
	var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(295));
	
	var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(183));
	
	var _PlaybackRate = _interopRequireDefault(__webpack_require__(712));
	
	var _ClosedCaptionButton = _interopRequireDefault(__webpack_require__(711));
	
	var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(298));
	
	var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(296));
	
	var _DurationDisplay = _interopRequireDefault(__webpack_require__(297));
	
	var _TimeDivider = _interopRequireDefault(__webpack_require__(299));
	
	var _MenuButton = _interopRequireDefault(__webpack_require__(184));
	
	var playerActions = _interopRequireWildcard(__webpack_require__(128));
	
	exports.playerActions = playerActions;
	
	var videoActions = _interopRequireWildcard(__webpack_require__(181));
	
	exports.videoActions = videoActions;
	
	var _reducers = __webpack_require__(300);

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = operation;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(58));
	
	var _player = __webpack_require__(128);
	
	var initialState = {
	  count: 0,
	  operation: {
	    action: '',
	    source: ''
	  }
	};
	
	function operation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	
	  switch (action.type) {
	    case _player.OPERATE:
	      return (0, _objectSpread2["default"])({}, state, {
	        count: state.count + 1,
	        operation: (0, _objectSpread2["default"])({}, state.operation, action.operation)
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = player;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(58));
	
	var _video = __webpack_require__(181);
	
	var _player = __webpack_require__(128);
	
	var initialState = {
	  currentSrc: null,
	  duration: 0,
	  currentTime: 0,
	  seekingTime: 0,
	  buffered: null,
	  waiting: false,
	  seeking: false,
	  paused: true,
	  autoPaused: false,
	  ended: false,
	  playbackRate: 1,
	  muted: false,
	  volume: 1,
	  readyState: 0,
	  networkState: 0,
	  videoWidth: 0,
	  videoHeight: 0,
	  hasStarted: false,
	  userActivity: true,
	  isActive: false,
	  isFullscreen: false,
	  activeTextTrack: null
	};
	
	function player() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	
	  switch (action.type) {
	    case _player.USER_ACTIVATE:
	      return (0, _objectSpread2["default"])({}, state, {
	        userActivity: action.activity
	      });
	
	    case _player.PLAYER_ACTIVATE:
	      return (0, _objectSpread2["default"])({}, state, {
	        isActive: action.activity
	      });
	
	    case _player.FULLSCREEN_CHANGE:
	      return (0, _objectSpread2["default"])({}, state, {
	        isFullscreen: !!action.isFullscreen
	      });
	
	    case _video.SEEKING_TIME:
	      return (0, _objectSpread2["default"])({}, state, {
	        seekingTime: action.time
	      });
	
	    case _video.END_SEEKING:
	      return (0, _objectSpread2["default"])({}, state, {
	        seekingTime: 0
	      });
	
	    case _video.LOAD_START:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        hasStarted: false,
	        ended: false
	      });
	
	    case _video.CAN_PLAY:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        waiting: false
	      });
	
	    case _video.WAITING:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        waiting: true
	      });
	
	    case _video.CAN_PLAY_THROUGH:
	    case _video.PLAYING:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        waiting: false
	      });
	
	    case _video.PLAY:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        ended: false,
	        paused: false,
	        autoPaused: false,
	        waiting: false,
	        hasStarted: true
	      });
	
	    case _video.PAUSE:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        paused: true
	      });
	
	    case _video.END:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        ended: true
	      });
	
	    case _video.SEEKING:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        seeking: true
	      });
	
	    case _video.SEEKED:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        seeking: false
	      });
	
	    case _video.ERROR:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
	        error: 'UNKNOWN ERROR',
	        ended: true
	      });
	
	    case _video.DURATION_CHANGE:
	    case _video.TIME_UPDATE:
	    case _video.VOLUME_CHANGE:
	    case _video.PROGRESS_CHANGE:
	    case _video.RATE_CHANGE:
	    case _video.SUSPEND:
	    case _video.ABORT:
	    case _video.EMPTIED:
	    case _video.STALLED:
	    case _video.LOADED_META_DATA:
	    case _video.LOADED_DATA:
	    case _video.RESIZE:
	      return (0, _objectSpread2["default"])({}, state, action.videoProps);
	
	    case _video.ACTIVATE_TEXT_TRACK:
	      return (0, _objectSpread2["default"])({}, state, {
	        activeTextTrack: action.textTrack
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 722 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = void 0;
	var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : ''; // const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
	// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
	
	/*
	 * Device is an iPhone
	 *
	 * @type {Boolean}
	 * @constant
	 * @private
	 */
	
	var IS_IPAD = /iPad/i.test(USER_AGENT); // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
	// to identify iPhones, we need to exclude iPads.
	// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
	
	exports.IS_IPAD = IS_IPAD;
	var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	exports.IS_IPHONE = IS_IPHONE;
	var IS_IPOD = /iPod/i.test(USER_AGENT);
	exports.IS_IPOD = IS_IPOD;
	var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
	exports.IS_IOS = IS_IOS;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(724);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 724 */
576,
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	// Default exports for Node. Export the extended versions of VTTCue and
	// VTTRegion in Node since we likely want the capability to convert back and
	// forth between JSON. If we don't then it's not that big of a deal since we're
	// off browser.
	
	var window = __webpack_require__(54);
	
	var vttjs = module.exports = {
	  WebVTT: __webpack_require__(726),
	  VTTCue: __webpack_require__(727),
	  VTTRegion: __webpack_require__(728)
	};
	
	window.vttjs = vttjs;
	window.WebVTT = vttjs.WebVTT;
	
	var cueShim = vttjs.VTTCue;
	var regionShim = vttjs.VTTRegion;
	var nativeVTTCue = window.VTTCue;
	var nativeVTTRegion = window.VTTRegion;
	
	vttjs.shim = function() {
	  window.VTTCue = cueShim;
	  window.VTTRegion = regionShim;
	};
	
	vttjs.restore = function() {
	  window.VTTCue = nativeVTTCue;
	  window.VTTRegion = nativeVTTRegion;
	};
	
	if (!window.VTTCue) {
	  vttjs.shim();
	}


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */
	/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */
	var document = __webpack_require__(233);
	
	var _objCreate = Object.create || (function() {
	  function F() {}
	  return function(o) {
	    if (arguments.length !== 1) {
	      throw new Error('Object.create shim only accepts one parameter.');
	    }
	    F.prototype = o;
	    return new F();
	  };
	})();
	
	// Creates a new ParserError object from an errorData object. The errorData
	// object should have default code and message properties. The default message
	// property can be overriden by passing in a message parameter.
	// See ParsingError.Errors below for acceptable errors.
	function ParsingError(errorData, message) {
	  this.name = "ParsingError";
	  this.code = errorData.code;
	  this.message = message || errorData.message;
	}
	ParsingError.prototype = _objCreate(Error.prototype);
	ParsingError.prototype.constructor = ParsingError;
	
	// ParsingError metadata for acceptable ParsingErrors.
	ParsingError.Errors = {
	  BadSignature: {
	    code: 0,
	    message: "Malformed WebVTT signature."
	  },
	  BadTimeStamp: {
	    code: 1,
	    message: "Malformed time stamp."
	  }
	};
	
	// Try to parse input as a time stamp.
	function parseTimeStamp(input) {
	
	  function computeSeconds(h, m, s, f) {
	    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
	  }
	
	  var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
	  if (!m) {
	    return null;
	  }
	
	  if (m[3]) {
	    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
	    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
	  } else if (m[1] > 59) {
	    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
	    // First position is hours as it's over 59.
	    return computeSeconds(m[1], m[2], 0,  m[4]);
	  } else {
	    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
	    return computeSeconds(0, m[1], m[2], m[4]);
	  }
	}
	
	// A settings object holds key/value pairs and will ignore anything but the first
	// assignment to a specific key.
	function Settings() {
	  this.values = _objCreate(null);
	}
	
	Settings.prototype = {
	  // Only accept the first assignment to any key.
	  set: function(k, v) {
	    if (!this.get(k) && v !== "") {
	      this.values[k] = v;
	    }
	  },
	  // Return the value for a key, or a default value.
	  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
	  // a number of possible default values as properties where 'defaultKey' is
	  // the key of the property that will be chosen; otherwise it's assumed to be
	  // a single value.
	  get: function(k, dflt, defaultKey) {
	    if (defaultKey) {
	      return this.has(k) ? this.values[k] : dflt[defaultKey];
	    }
	    return this.has(k) ? this.values[k] : dflt;
	  },
	  // Check whether we have a value for a key.
	  has: function(k) {
	    return k in this.values;
	  },
	  // Accept a setting if its one of the given alternatives.
	  alt: function(k, v, a) {
	    for (var n = 0; n < a.length; ++n) {
	      if (v === a[n]) {
	        this.set(k, v);
	        break;
	      }
	    }
	  },
	  // Accept a setting if its a valid (signed) integer.
	  integer: function(k, v) {
	    if (/^-?\d+$/.test(v)) { // integer
	      this.set(k, parseInt(v, 10));
	    }
	  },
	  // Accept a setting if its a valid percentage.
	  percent: function(k, v) {
	    var m;
	    if ((m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/))) {
	      v = parseFloat(v);
	      if (v >= 0 && v <= 100) {
	        this.set(k, v);
	        return true;
	      }
	    }
	    return false;
	  }
	};
	
	// Helper function to parse input into groups separated by 'groupDelim', and
	// interprete each group as a key/value pair separated by 'keyValueDelim'.
	function parseOptions(input, callback, keyValueDelim, groupDelim) {
	  var groups = groupDelim ? input.split(groupDelim) : [input];
	  for (var i in groups) {
	    if (typeof groups[i] !== "string") {
	      continue;
	    }
	    var kv = groups[i].split(keyValueDelim);
	    if (kv.length !== 2) {
	      continue;
	    }
	    var k = kv[0].trim();
	    var v = kv[1].trim();
	    callback(k, v);
	  }
	}
	
	function parseCue(input, cue, regionList) {
	  // Remember the original input if we need to throw an error.
	  var oInput = input;
	  // 4.1 WebVTT timestamp
	  function consumeTimeStamp() {
	    var ts = parseTimeStamp(input);
	    if (ts === null) {
	      throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                            "Malformed timestamp: " + oInput);
	    }
	    // Remove time stamp from input.
	    input = input.replace(/^[^\sa-zA-Z-]+/, "");
	    return ts;
	  }
	
	  // 4.4.2 WebVTT cue settings
	  function consumeCueSettings(input, cue) {
	    var settings = new Settings();
	
	    parseOptions(input, function (k, v) {
	      switch (k) {
	      case "region":
	        // Find the last region we parsed with the same region id.
	        for (var i = regionList.length - 1; i >= 0; i--) {
	          if (regionList[i].id === v) {
	            settings.set(k, regionList[i].region);
	            break;
	          }
	        }
	        break;
	      case "vertical":
	        settings.alt(k, v, ["rl", "lr"]);
	        break;
	      case "line":
	        var vals = v.split(","),
	            vals0 = vals[0];
	        settings.integer(k, vals0);
	        settings.percent(k, vals0) ? settings.set("snapToLines", false) : null;
	        settings.alt(k, vals0, ["auto"]);
	        if (vals.length === 2) {
	          settings.alt("lineAlign", vals[1], ["start", "center", "end"]);
	        }
	        break;
	      case "position":
	        vals = v.split(",");
	        settings.percent(k, vals[0]);
	        if (vals.length === 2) {
	          settings.alt("positionAlign", vals[1], ["start", "center", "end"]);
	        }
	        break;
	      case "size":
	        settings.percent(k, v);
	        break;
	      case "align":
	        settings.alt(k, v, ["start", "center", "end", "left", "right"]);
	        break;
	      }
	    }, /:/, /\s/);
	
	    // Apply default values for any missing fields.
	    cue.region = settings.get("region", null);
	    cue.vertical = settings.get("vertical", "");
	    try {
	      cue.line = settings.get("line", "auto");
	    } catch (e) {}
	    cue.lineAlign = settings.get("lineAlign", "start");
	    cue.snapToLines = settings.get("snapToLines", true);
	    cue.size = settings.get("size", 100);
	    // Safari still uses the old middle value and won't accept center
	    try {
	      cue.align = settings.get("align", "center");
	    } catch (e) {
	      cue.align = settings.get("align", "middle");
	    }
	    try {
	      cue.position = settings.get("position", "auto");
	    } catch (e) {
	      cue.position = settings.get("position", {
	        start: 0,
	        left: 0,
	        center: 50,
	        middle: 50,
	        end: 100,
	        right: 100
	      }, cue.align);
	    }
	
	
	    cue.positionAlign = settings.get("positionAlign", {
	      start: "start",
	      left: "start",
	      center: "center",
	      middle: "center",
	      end: "end",
	      right: "end"
	    }, cue.align);
	  }
	
	  function skipWhitespace() {
	    input = input.replace(/^\s+/, "");
	  }
	
	  // 4.1 WebVTT cue timings.
	  skipWhitespace();
	  cue.startTime = consumeTimeStamp();   // (1) collect cue start time
	  skipWhitespace();
	  if (input.substr(0, 3) !== "-->") {     // (3) next characters must match "-->"
	    throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                           "Malformed time stamp (time stamps must be separated by '-->'): " +
	                           oInput);
	  }
	  input = input.substr(3);
	  skipWhitespace();
	  cue.endTime = consumeTimeStamp();     // (5) collect cue end time
	
	  // 4.1 WebVTT cue settings list.
	  skipWhitespace();
	  consumeCueSettings(input, cue);
	}
	
	// When evaluating this file as part of a Webpack bundle for server
	// side rendering, `document` is an empty object.
	var TEXTAREA_ELEMENT = document.createElement && document.createElement("textarea");
	
	var TAG_NAME = {
	  c: "span",
	  i: "i",
	  b: "b",
	  u: "u",
	  ruby: "ruby",
	  rt: "rt",
	  v: "span",
	  lang: "span"
	};
	
	// 5.1 default text color
	// 5.2 default text background color is equivalent to text color with bg_ prefix
	var DEFAULT_COLOR_CLASS = {
	  white: 'rgba(255,255,255,1)',
	  lime: 'rgba(0,255,0,1)',
	  cyan: 'rgba(0,255,255,1)',
	  red: 'rgba(255,0,0,1)',
	  yellow: 'rgba(255,255,0,1)',
	  magenta: 'rgba(255,0,255,1)',
	  blue: 'rgba(0,0,255,1)',
	  black: 'rgba(0,0,0,1)'
	};
	
	var TAG_ANNOTATION = {
	  v: "title",
	  lang: "lang"
	};
	
	var NEEDS_PARENT = {
	  rt: "ruby"
	};
	
	// Parse content into a document fragment.
	function parseContent(window, input) {
	  function nextToken() {
	    // Check for end-of-string.
	    if (!input) {
	      return null;
	    }
	
	    // Consume 'n' characters from the input.
	    function consume(result) {
	      input = input.substr(result.length);
	      return result;
	    }
	
	    var m = input.match(/^([^<]*)(<[^>]*>?)?/);
	    // If there is some text before the next tag, return it, otherwise return
	    // the tag.
	    return consume(m[1] ? m[1] : m[2]);
	  }
	
	  function unescape(s) {
	    TEXTAREA_ELEMENT.innerHTML = s;
	    s = TEXTAREA_ELEMENT.textContent;
	    TEXTAREA_ELEMENT.textContent = "";
	    return s;
	  }
	
	  function shouldAdd(current, element) {
	    return !NEEDS_PARENT[element.localName] ||
	           NEEDS_PARENT[element.localName] === current.localName;
	  }
	
	  // Create an element for this tag.
	  function createElement(type, annotation) {
	    var tagName = TAG_NAME[type];
	    if (!tagName) {
	      return null;
	    }
	    var element = window.document.createElement(tagName);
	    var name = TAG_ANNOTATION[type];
	    if (name && annotation) {
	      element[name] = annotation.trim();
	    }
	    return element;
	  }
	
	  var rootDiv = window.document.createElement("div"),
	      current = rootDiv,
	      t,
	      tagStack = [];
	
	  while ((t = nextToken()) !== null) {
	    if (t[0] === '<') {
	      if (t[1] === "/") {
	        // If the closing tag matches, move back up to the parent node.
	        if (tagStack.length &&
	            tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
	          tagStack.pop();
	          current = current.parentNode;
	        }
	        // Otherwise just ignore the end tag.
	        continue;
	      }
	      var ts = parseTimeStamp(t.substr(1, t.length - 2));
	      var node;
	      if (ts) {
	        // Timestamps are lead nodes as well.
	        node = window.document.createProcessingInstruction("timestamp", ts);
	        current.appendChild(node);
	        continue;
	      }
	      var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
	      // If we can't parse the tag, skip to the next tag.
	      if (!m) {
	        continue;
	      }
	      // Try to construct an element, and ignore the tag if we couldn't.
	      node = createElement(m[1], m[3]);
	      if (!node) {
	        continue;
	      }
	      // Determine if the tag should be added based on the context of where it
	      // is placed in the cuetext.
	      if (!shouldAdd(current, node)) {
	        continue;
	      }
	      // Set the class list (as a list of classes, separated by space).
	      if (m[2]) {
	        var classes = m[2].split('.');
	
	        classes.forEach(function(cl) {
	          var bgColor = /^bg_/.test(cl);
	          // slice out `bg_` if it's a background color
	          var colorName = bgColor ? cl.slice(3) : cl;
	
	          if (DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
	            var propName = bgColor ? 'background-color' : 'color';
	            var propValue = DEFAULT_COLOR_CLASS[colorName];
	
	            node.style[propName] = propValue;
	          }
	        });
	
	        node.className = classes.join(' ');
	      }
	      // Append the node to the current node, and enter the scope of the new
	      // node.
	      tagStack.push(m[1]);
	      current.appendChild(node);
	      current = node;
	      continue;
	    }
	
	    // Text nodes are leaf nodes.
	    current.appendChild(window.document.createTextNode(unescape(t)));
	  }
	
	  return rootDiv;
	}
	
	// This is a list of all the Unicode characters that have a strong
	// right-to-left category. What this means is that these characters are
	// written right-to-left for sure. It was generated by pulling all the strong
	// right-to-left characters out of the Unicode data table. That table can
	// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
	var strongRTLRanges = [[0x5be, 0x5be], [0x5c0, 0x5c0], [0x5c3, 0x5c3], [0x5c6, 0x5c6],
	 [0x5d0, 0x5ea], [0x5f0, 0x5f4], [0x608, 0x608], [0x60b, 0x60b], [0x60d, 0x60d],
	 [0x61b, 0x61b], [0x61e, 0x64a], [0x66d, 0x66f], [0x671, 0x6d5], [0x6e5, 0x6e6],
	 [0x6ee, 0x6ef], [0x6fa, 0x70d], [0x70f, 0x710], [0x712, 0x72f], [0x74d, 0x7a5],
	 [0x7b1, 0x7b1], [0x7c0, 0x7ea], [0x7f4, 0x7f5], [0x7fa, 0x7fa], [0x800, 0x815],
	 [0x81a, 0x81a], [0x824, 0x824], [0x828, 0x828], [0x830, 0x83e], [0x840, 0x858],
	 [0x85e, 0x85e], [0x8a0, 0x8a0], [0x8a2, 0x8ac], [0x200f, 0x200f],
	 [0xfb1d, 0xfb1d], [0xfb1f, 0xfb28], [0xfb2a, 0xfb36], [0xfb38, 0xfb3c],
	 [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfbc1],
	 [0xfbd3, 0xfd3d], [0xfd50, 0xfd8f], [0xfd92, 0xfdc7], [0xfdf0, 0xfdfc],
	 [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10800, 0x10805], [0x10808, 0x10808],
	 [0x1080a, 0x10835], [0x10837, 0x10838], [0x1083c, 0x1083c], [0x1083f, 0x10855],
	 [0x10857, 0x1085f], [0x10900, 0x1091b], [0x10920, 0x10939], [0x1093f, 0x1093f],
	 [0x10980, 0x109b7], [0x109be, 0x109bf], [0x10a00, 0x10a00], [0x10a10, 0x10a13],
	 [0x10a15, 0x10a17], [0x10a19, 0x10a33], [0x10a40, 0x10a47], [0x10a50, 0x10a58],
	 [0x10a60, 0x10a7f], [0x10b00, 0x10b35], [0x10b40, 0x10b55], [0x10b58, 0x10b72],
	 [0x10b78, 0x10b7f], [0x10c00, 0x10c48], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f],
	 [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32],
	 [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42],
	 [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f],
	 [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59],
	 [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62],
	 [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77],
	 [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b],
	 [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x10fffd, 0x10fffd]];
	
	function isStrongRTLChar(charCode) {
	  for (var i = 0; i < strongRTLRanges.length; i++) {
	    var currentRange = strongRTLRanges[i];
	    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function determineBidi(cueDiv) {
	  var nodeStack = [],
	      text = "",
	      charCode;
	
	  if (!cueDiv || !cueDiv.childNodes) {
	    return "ltr";
	  }
	
	  function pushNodes(nodeStack, node) {
	    for (var i = node.childNodes.length - 1; i >= 0; i--) {
	      nodeStack.push(node.childNodes[i]);
	    }
	  }
	
	  function nextTextNode(nodeStack) {
	    if (!nodeStack || !nodeStack.length) {
	      return null;
	    }
	
	    var node = nodeStack.pop(),
	        text = node.textContent || node.innerText;
	    if (text) {
	      // TODO: This should match all unicode type B characters (paragraph
	      // separator characters). See issue #115.
	      var m = text.match(/^.*(\n|\r)/);
	      if (m) {
	        nodeStack.length = 0;
	        return m[0];
	      }
	      return text;
	    }
	    if (node.tagName === "ruby") {
	      return nextTextNode(nodeStack);
	    }
	    if (node.childNodes) {
	      pushNodes(nodeStack, node);
	      return nextTextNode(nodeStack);
	    }
	  }
	
	  pushNodes(nodeStack, cueDiv);
	  while ((text = nextTextNode(nodeStack))) {
	    for (var i = 0; i < text.length; i++) {
	      charCode = text.charCodeAt(i);
	      if (isStrongRTLChar(charCode)) {
	        return "rtl";
	      }
	    }
	  }
	  return "ltr";
	}
	
	function computeLinePos(cue) {
	  if (typeof cue.line === "number" &&
	      (cue.snapToLines || (cue.line >= 0 && cue.line <= 100))) {
	    return cue.line;
	  }
	  if (!cue.track || !cue.track.textTrackList ||
	      !cue.track.textTrackList.mediaElement) {
	    return -1;
	  }
	  var track = cue.track,
	      trackList = track.textTrackList,
	      count = 0;
	  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
	    if (trackList[i].mode === "showing") {
	      count++;
	    }
	  }
	  return ++count * -1;
	}
	
	function StyleBox() {
	}
	
	// Apply styles to a div. If there is no div passed then it defaults to the
	// div on 'this'.
	StyleBox.prototype.applyStyles = function(styles, div) {
	  div = div || this.div;
	  for (var prop in styles) {
	    if (styles.hasOwnProperty(prop)) {
	      div.style[prop] = styles[prop];
	    }
	  }
	};
	
	StyleBox.prototype.formatStyle = function(val, unit) {
	  return val === 0 ? 0 : val + unit;
	};
	
	// Constructs the computed display state of the cue (a div). Places the div
	// into the overlay which should be a block level element (usually a div).
	function CueStyleBox(window, cue, styleOptions) {
	  StyleBox.call(this);
	  this.cue = cue;
	
	  // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
	  // have inline positioning and will function as the cue background box.
	  this.cueDiv = parseContent(window, cue.text);
	  var styles = {
	    color: "rgba(255, 255, 255, 1)",
	    backgroundColor:  "rgba(0, 0, 0, 0.8)",
	    position: "relative",
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    display: "inline",
	    writingMode: cue.vertical === "" ? "horizontal-tb"
	                                     : cue.vertical === "lr" ? "vertical-lr"
	                                                             : "vertical-rl",
	    unicodeBidi: "plaintext"
	  };
	
	  this.applyStyles(styles, this.cueDiv);
	
	  // Create an absolutely positioned div that will be used to position the cue
	  // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
	  // mirrors of them except middle instead of center on Safari.
	  this.div = window.document.createElement("div");
	  styles = {
	    direction: determineBidi(this.cueDiv),
	    writingMode: cue.vertical === "" ? "horizontal-tb"
	                                     : cue.vertical === "lr" ? "vertical-lr"
	                                                             : "vertical-rl",
	    unicodeBidi: "plaintext",
	    textAlign: cue.align === "middle" ? "center" : cue.align,
	    font: styleOptions.font,
	    whiteSpace: "pre-line",
	    position: "absolute"
	  };
	
	  this.applyStyles(styles);
	  this.div.appendChild(this.cueDiv);
	
	  // Calculate the distance from the reference edge of the viewport to the text
	  // position of the cue box. The reference edge will be resolved later when
	  // the box orientation styles are applied.
	  var textPos = 0;
	  switch (cue.positionAlign) {
	  case "start":
	  case "line-left":
	    textPos = cue.position;
	    break;
	  case "center":
	    textPos = cue.position - (cue.size / 2);
	    break;
	  case "end":
	  case "line-right":
	    textPos = cue.position - cue.size;
	    break;
	  }
	
	  // Horizontal box orientation; textPos is the distance from the left edge of the
	  // area to the left edge of the box and cue.size is the distance extending to
	  // the right from there.
	  if (cue.vertical === "") {
	    this.applyStyles({
	      left:  this.formatStyle(textPos, "%"),
	      width: this.formatStyle(cue.size, "%")
	    });
	  // Vertical box orientation; textPos is the distance from the top edge of the
	  // area to the top edge of the box and cue.size is the height extending
	  // downwards from there.
	  } else {
	    this.applyStyles({
	      top: this.formatStyle(textPos, "%"),
	      height: this.formatStyle(cue.size, "%")
	    });
	  }
	
	  this.move = function(box) {
	    this.applyStyles({
	      top: this.formatStyle(box.top, "px"),
	      bottom: this.formatStyle(box.bottom, "px"),
	      left: this.formatStyle(box.left, "px"),
	      right: this.formatStyle(box.right, "px"),
	      height: this.formatStyle(box.height, "px"),
	      width: this.formatStyle(box.width, "px")
	    });
	  };
	}
	CueStyleBox.prototype = _objCreate(StyleBox.prototype);
	CueStyleBox.prototype.constructor = CueStyleBox;
	
	// Represents the co-ordinates of an Element in a way that we can easily
	// compute things with such as if it overlaps or intersects with another Element.
	// Can initialize it with either a StyleBox or another BoxPosition.
	function BoxPosition(obj) {
	  // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
	  // was passed in and we need to copy the results of 'getBoundingClientRect'
	  // as the object returned is readonly. All co-ordinate values are in reference
	  // to the viewport origin (top left).
	  var lh, height, width, top;
	  if (obj.div) {
	    height = obj.div.offsetHeight;
	    width = obj.div.offsetWidth;
	    top = obj.div.offsetTop;
	
	    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) &&
	                rects.getClientRects && rects.getClientRects();
	    obj = obj.div.getBoundingClientRect();
	    // In certain cases the outter div will be slightly larger then the sum of
	    // the inner div's lines. This could be due to bold text, etc, on some platforms.
	    // In this case we should get the average line height and use that. This will
	    // result in the desired behaviour.
	    lh = rects ? Math.max((rects[0] && rects[0].height) || 0, obj.height / rects.length)
	               : 0;
	
	  }
	  this.left = obj.left;
	  this.right = obj.right;
	  this.top = obj.top || top;
	  this.height = obj.height || height;
	  this.bottom = obj.bottom || (top + (obj.height || height));
	  this.width = obj.width || width;
	  this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
	}
	
	// Move the box along a particular axis. Optionally pass in an amount to move
	// the box. If no amount is passed then the default is the line height of the
	// box.
	BoxPosition.prototype.move = function(axis, toMove) {
	  toMove = toMove !== undefined ? toMove : this.lineHeight;
	  switch (axis) {
	  case "+x":
	    this.left += toMove;
	    this.right += toMove;
	    break;
	  case "-x":
	    this.left -= toMove;
	    this.right -= toMove;
	    break;
	  case "+y":
	    this.top += toMove;
	    this.bottom += toMove;
	    break;
	  case "-y":
	    this.top -= toMove;
	    this.bottom -= toMove;
	    break;
	  }
	};
	
	// Check if this box overlaps another box, b2.
	BoxPosition.prototype.overlaps = function(b2) {
	  return this.left < b2.right &&
	         this.right > b2.left &&
	         this.top < b2.bottom &&
	         this.bottom > b2.top;
	};
	
	// Check if this box overlaps any other boxes in boxes.
	BoxPosition.prototype.overlapsAny = function(boxes) {
	  for (var i = 0; i < boxes.length; i++) {
	    if (this.overlaps(boxes[i])) {
	      return true;
	    }
	  }
	  return false;
	};
	
	// Check if this box is within another box.
	BoxPosition.prototype.within = function(container) {
	  return this.top >= container.top &&
	         this.bottom <= container.bottom &&
	         this.left >= container.left &&
	         this.right <= container.right;
	};
	
	// Check if this box is entirely within the container or it is overlapping
	// on the edge opposite of the axis direction passed. For example, if "+x" is
	// passed and the box is overlapping on the left edge of the container, then
	// return true.
	BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
	  switch (axis) {
	  case "+x":
	    return this.left < container.left;
	  case "-x":
	    return this.right > container.right;
	  case "+y":
	    return this.top < container.top;
	  case "-y":
	    return this.bottom > container.bottom;
	  }
	};
	
	// Find the percentage of the area that this box is overlapping with another
	// box.
	BoxPosition.prototype.intersectPercentage = function(b2) {
	  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)),
	      y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)),
	      intersectArea = x * y;
	  return intersectArea / (this.height * this.width);
	};
	
	// Convert the positions from this box to CSS compatible positions using
	// the reference container's positions. This has to be done because this
	// box's positions are in reference to the viewport origin, whereas, CSS
	// values are in referecne to their respective edges.
	BoxPosition.prototype.toCSSCompatValues = function(reference) {
	  return {
	    top: this.top - reference.top,
	    bottom: reference.bottom - this.bottom,
	    left: this.left - reference.left,
	    right: reference.right - this.right,
	    height: this.height,
	    width: this.width
	  };
	};
	
	// Get an object that represents the box's position without anything extra.
	// Can pass a StyleBox, HTMLElement, or another BoxPositon.
	BoxPosition.getSimpleBoxPosition = function(obj) {
	  var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
	  var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
	  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
	
	  obj = obj.div ? obj.div.getBoundingClientRect() :
	                obj.tagName ? obj.getBoundingClientRect() : obj;
	  var ret = {
	    left: obj.left,
	    right: obj.right,
	    top: obj.top || top,
	    height: obj.height || height,
	    bottom: obj.bottom || (top + (obj.height || height)),
	    width: obj.width || width
	  };
	  return ret;
	};
	
	// Move a StyleBox to its specified, or next best, position. The containerBox
	// is the box that contains the StyleBox, such as a div. boxPositions are
	// a list of other boxes that the styleBox can't overlap with.
	function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
	
	  // Find the best position for a cue box, b, on the video. The axis parameter
	  // is a list of axis, the order of which, it will move the box along. For example:
	  // Passing ["+x", "-x"] will move the box first along the x axis in the positive
	  // direction. If it doesn't find a good position for it there it will then move
	  // it along the x axis in the negative direction.
	  function findBestPosition(b, axis) {
	    var bestPosition,
	        specifiedPosition = new BoxPosition(b),
	        percentage = 1; // Highest possible so the first thing we get is better.
	
	    for (var i = 0; i < axis.length; i++) {
	      while (b.overlapsOppositeAxis(containerBox, axis[i]) ||
	             (b.within(containerBox) && b.overlapsAny(boxPositions))) {
	        b.move(axis[i]);
	      }
	      // We found a spot where we aren't overlapping anything. This is our
	      // best position.
	      if (b.within(containerBox)) {
	        return b;
	      }
	      var p = b.intersectPercentage(containerBox);
	      // If we're outside the container box less then we were on our last try
	      // then remember this position as the best position.
	      if (percentage > p) {
	        bestPosition = new BoxPosition(b);
	        percentage = p;
	      }
	      // Reset the box position to the specified position.
	      b = new BoxPosition(specifiedPosition);
	    }
	    return bestPosition || specifiedPosition;
	  }
	
	  var boxPosition = new BoxPosition(styleBox),
	      cue = styleBox.cue,
	      linePos = computeLinePos(cue),
	      axis = [];
	
	  // If we have a line number to align the cue to.
	  if (cue.snapToLines) {
	    var size;
	    switch (cue.vertical) {
	    case "":
	      axis = [ "+y", "-y" ];
	      size = "height";
	      break;
	    case "rl":
	      axis = [ "+x", "-x" ];
	      size = "width";
	      break;
	    case "lr":
	      axis = [ "-x", "+x" ];
	      size = "width";
	      break;
	    }
	
	    var step = boxPosition.lineHeight,
	        position = step * Math.round(linePos),
	        maxPosition = containerBox[size] + step,
	        initialAxis = axis[0];
	
	    // If the specified intial position is greater then the max position then
	    // clamp the box to the amount of steps it would take for the box to
	    // reach the max position.
	    if (Math.abs(position) > maxPosition) {
	      position = position < 0 ? -1 : 1;
	      position *= Math.ceil(maxPosition / step) * step;
	    }
	
	    // If computed line position returns negative then line numbers are
	    // relative to the bottom of the video instead of the top. Therefore, we
	    // need to increase our initial position by the length or width of the
	    // video, depending on the writing direction, and reverse our axis directions.
	    if (linePos < 0) {
	      position += cue.vertical === "" ? containerBox.height : containerBox.width;
	      axis = axis.reverse();
	    }
	
	    // Move the box to the specified position. This may not be its best
	    // position.
	    boxPosition.move(initialAxis, position);
	
	  } else {
	    // If we have a percentage line value for the cue.
	    var calculatedPercentage = (boxPosition.lineHeight / containerBox.height) * 100;
	
	    switch (cue.lineAlign) {
	    case "center":
	      linePos -= (calculatedPercentage / 2);
	      break;
	    case "end":
	      linePos -= calculatedPercentage;
	      break;
	    }
	
	    // Apply initial line position to the cue box.
	    switch (cue.vertical) {
	    case "":
	      styleBox.applyStyles({
	        top: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "rl":
	      styleBox.applyStyles({
	        left: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "lr":
	      styleBox.applyStyles({
	        right: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    }
	
	    axis = [ "+y", "-x", "+x", "-y" ];
	
	    // Get the box position again after we've applied the specified positioning
	    // to it.
	    boxPosition = new BoxPosition(styleBox);
	  }
	
	  var bestPosition = findBestPosition(boxPosition, axis);
	  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
	}
	
	function WebVTT() {
	  // Nothing
	}
	
	// Helper to allow strings to be decoded instead of the default binary utf8 data.
	WebVTT.StringDecoder = function() {
	  return {
	    decode: function(data) {
	      if (!data) {
	        return "";
	      }
	      if (typeof data !== "string") {
	        throw new Error("Error - expected string data.");
	      }
	      return decodeURIComponent(encodeURIComponent(data));
	    }
	  };
	};
	
	WebVTT.convertCueToDOMTree = function(window, cuetext) {
	  if (!window || !cuetext) {
	    return null;
	  }
	  return parseContent(window, cuetext);
	};
	
	var FONT_SIZE_PERCENT = 0.05;
	var FONT_STYLE = "sans-serif";
	var CUE_BACKGROUND_PADDING = "1.5%";
	
	// Runs the processing model over the cues and regions passed to it.
	// @param overlay A block level element (usually a div) that the computed cues
	//                and regions will be placed into.
	WebVTT.processCues = function(window, cues, overlay) {
	  if (!window || !cues || !overlay) {
	    return null;
	  }
	
	  // Remove all previous children.
	  while (overlay.firstChild) {
	    overlay.removeChild(overlay.firstChild);
	  }
	
	  var paddedOverlay = window.document.createElement("div");
	  paddedOverlay.style.position = "absolute";
	  paddedOverlay.style.left = "0";
	  paddedOverlay.style.right = "0";
	  paddedOverlay.style.top = "0";
	  paddedOverlay.style.bottom = "0";
	  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
	  overlay.appendChild(paddedOverlay);
	
	  // Determine if we need to compute the display states of the cues. This could
	  // be the case if a cue's state has been changed since the last computation or
	  // if it has not been computed yet.
	  function shouldCompute(cues) {
	    for (var i = 0; i < cues.length; i++) {
	      if (cues[i].hasBeenReset || !cues[i].displayState) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  // We don't need to recompute the cues' display states. Just reuse them.
	  if (!shouldCompute(cues)) {
	    for (var i = 0; i < cues.length; i++) {
	      paddedOverlay.appendChild(cues[i].displayState);
	    }
	    return;
	  }
	
	  var boxPositions = [],
	      containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay),
	      fontSize = Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100;
	  var styleOptions = {
	    font: fontSize + "px " + FONT_STYLE
	  };
	
	  (function() {
	    var styleBox, cue;
	
	    for (var i = 0; i < cues.length; i++) {
	      cue = cues[i];
	
	      // Compute the intial position and styles of the cue div.
	      styleBox = new CueStyleBox(window, cue, styleOptions);
	      paddedOverlay.appendChild(styleBox.div);
	
	      // Move the cue div to it's correct line position.
	      moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);
	
	      // Remember the computed div so that we don't have to recompute it later
	      // if we don't have too.
	      cue.displayState = styleBox.div;
	
	      boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
	    }
	  })();
	};
	
	WebVTT.Parser = function(window, vttjs, decoder) {
	  if (!decoder) {
	    decoder = vttjs;
	    vttjs = {};
	  }
	  if (!vttjs) {
	    vttjs = {};
	  }
	
	  this.window = window;
	  this.vttjs = vttjs;
	  this.state = "INITIAL";
	  this.buffer = "";
	  this.decoder = decoder || new TextDecoder("utf8");
	  this.regionList = [];
	};
	
	WebVTT.Parser.prototype = {
	  // If the error is a ParsingError then report it to the consumer if
	  // possible. If it's not a ParsingError then throw it like normal.
	  reportOrThrowError: function(e) {
	    if (e instanceof ParsingError) {
	      this.onparsingerror && this.onparsingerror(e);
	    } else {
	      throw e;
	    }
	  },
	  parse: function (data) {
	    var self = this;
	
	    // If there is no data then we won't decode it, but will just try to parse
	    // whatever is in buffer already. This may occur in circumstances, for
	    // example when flush() is called.
	    if (data) {
	      // Try to decode the data that we received.
	      self.buffer += self.decoder.decode(data, {stream: true});
	    }
	
	    function collectNextLine() {
	      var buffer = self.buffer;
	      var pos = 0;
	      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
	        ++pos;
	      }
	      var line = buffer.substr(0, pos);
	      // Advance the buffer early in case we fail below.
	      if (buffer[pos] === '\r') {
	        ++pos;
	      }
	      if (buffer[pos] === '\n') {
	        ++pos;
	      }
	      self.buffer = buffer.substr(pos);
	      return line;
	    }
	
	    // 3.4 WebVTT region and WebVTT region settings syntax
	    function parseRegion(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function (k, v) {
	        switch (k) {
	        case "id":
	          settings.set(k, v);
	          break;
	        case "width":
	          settings.percent(k, v);
	          break;
	        case "lines":
	          settings.integer(k, v);
	          break;
	        case "regionanchor":
	        case "viewportanchor":
	          var xy = v.split(',');
	          if (xy.length !== 2) {
	            break;
	          }
	          // We have to make sure both x and y parse, so use a temporary
	          // settings object here.
	          var anchor = new Settings();
	          anchor.percent("x", xy[0]);
	          anchor.percent("y", xy[1]);
	          if (!anchor.has("x") || !anchor.has("y")) {
	            break;
	          }
	          settings.set(k + "X", anchor.get("x"));
	          settings.set(k + "Y", anchor.get("y"));
	          break;
	        case "scroll":
	          settings.alt(k, v, ["up"]);
	          break;
	        }
	      }, /=/, /\s/);
	
	      // Create the region, using default values for any values that were not
	      // specified.
	      if (settings.has("id")) {
	        var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
	        region.width = settings.get("width", 100);
	        region.lines = settings.get("lines", 3);
	        region.regionAnchorX = settings.get("regionanchorX", 0);
	        region.regionAnchorY = settings.get("regionanchorY", 100);
	        region.viewportAnchorX = settings.get("viewportanchorX", 0);
	        region.viewportAnchorY = settings.get("viewportanchorY", 100);
	        region.scroll = settings.get("scroll", "");
	        // Register the region.
	        self.onregion && self.onregion(region);
	        // Remember the VTTRegion for later in case we parse any VTTCues that
	        // reference it.
	        self.regionList.push({
	          id: settings.get("id"),
	          region: region
	        });
	      }
	    }
	
	    // draft-pantos-http-live-streaming-20
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
	    // 3.5 WebVTT
	    function parseTimestampMap(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function(k, v) {
	        switch(k) {
	        case "MPEGT":
	          settings.integer(k + 'S', v);
	          break;
	        case "LOCA":
	          settings.set(k + 'L', parseTimeStamp(v));
	          break;
	        }
	      }, /[^\d]:/, /,/);
	
	      self.ontimestampmap && self.ontimestampmap({
	        "MPEGTS": settings.get("MPEGTS"),
	        "LOCAL": settings.get("LOCAL")
	      });
	    }
	
	    // 3.2 WebVTT metadata header syntax
	    function parseHeader(input) {
	      if (input.match(/X-TIMESTAMP-MAP/)) {
	        // This line contains HLS X-TIMESTAMP-MAP metadata
	        parseOptions(input, function(k, v) {
	          switch(k) {
	          case "X-TIMESTAMP-MAP":
	            parseTimestampMap(v);
	            break;
	          }
	        }, /=/);
	      } else {
	        parseOptions(input, function (k, v) {
	          switch (k) {
	          case "Region":
	            // 3.3 WebVTT region metadata header syntax
	            parseRegion(v);
	            break;
	          }
	        }, /:/);
	      }
	
	    }
	
	    // 5.1 WebVTT file parsing.
	    try {
	      var line;
	      if (self.state === "INITIAL") {
	        // We can't start parsing until we have the first line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        line = collectNextLine();
	
	        var m = line.match(/^WEBVTT([ \t].*)?$/);
	        if (!m || !m[0]) {
	          throw new ParsingError(ParsingError.Errors.BadSignature);
	        }
	
	        self.state = "HEADER";
	      }
	
	      var alreadyCollectedLine = false;
	      while (self.buffer) {
	        // We can't parse a line until we have the full line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        if (!alreadyCollectedLine) {
	          line = collectNextLine();
	        } else {
	          alreadyCollectedLine = false;
	        }
	
	        switch (self.state) {
	        case "HEADER":
	          // 13-18 - Allow a header (metadata) under the WEBVTT line.
	          if (/:/.test(line)) {
	            parseHeader(line);
	          } else if (!line) {
	            // An empty line terminates the header and starts the body (cues).
	            self.state = "ID";
	          }
	          continue;
	        case "NOTE":
	          // Ignore NOTE blocks.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        case "ID":
	          // Check for the start of NOTE blocks.
	          if (/^NOTE($|[ \t])/.test(line)) {
	            self.state = "NOTE";
	            break;
	          }
	          // 19-29 - Allow any number of line terminators, then initialize new cue values.
	          if (!line) {
	            continue;
	          }
	          self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
	          // Safari still uses the old middle value and won't accept center
	          try {
	            self.cue.align = "center";
	          } catch (e) {
	            self.cue.align = "middle";
	          }
	          self.state = "CUE";
	          // 30-39 - Check if self line contains an optional identifier or timing data.
	          if (line.indexOf("-->") === -1) {
	            self.cue.id = line;
	            continue;
	          }
	          // Process line as start of a cue.
	          /*falls through*/
	        case "CUE":
	          // 40 - Collect cue timings and settings.
	          try {
	            parseCue(line, self.cue, self.regionList);
	          } catch (e) {
	            self.reportOrThrowError(e);
	            // In case of an error ignore rest of the cue.
	            self.cue = null;
	            self.state = "BADCUE";
	            continue;
	          }
	          self.state = "CUETEXT";
	          continue;
	        case "CUETEXT":
	          var hasSubstring = line.indexOf("-->") !== -1;
	          // 34 - If we have an empty line then report the cue.
	          // 35 - If we have the special substring '-->' then report the cue,
	          // but do not collect the line as we need to process the current
	          // one as a new cue.
	          if (!line || hasSubstring && (alreadyCollectedLine = true)) {
	            // We are done parsing self cue.
	            self.oncue && self.oncue(self.cue);
	            self.cue = null;
	            self.state = "ID";
	            continue;
	          }
	          if (self.cue.text) {
	            self.cue.text += "\n";
	          }
	          self.cue.text += line.replace(/\u2028/g, '\n').replace(/u2029/g, '\n');
	          continue;
	        case "BADCUE": // BADCUE
	          // 54-62 - Collect and discard the remaining cue.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        }
	      }
	    } catch (e) {
	      self.reportOrThrowError(e);
	
	      // If we are currently parsing a cue, report what we have.
	      if (self.state === "CUETEXT" && self.cue && self.oncue) {
	        self.oncue(self.cue);
	      }
	      self.cue = null;
	      // Enter BADWEBVTT state if header was not parsed correctly otherwise
	      // another exception occurred so enter BADCUE state.
	      self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
	    }
	    return this;
	  },
	  flush: function () {
	    var self = this;
	    try {
	      // Finish decoding the stream.
	      self.buffer += self.decoder.decode();
	      // Synthesize the end of the current cue or region.
	      if (self.cue || self.state === "HEADER") {
	        self.buffer += "\n\n";
	        self.parse();
	      }
	      // If we've flushed, parsed, and we're still on the INITIAL state then
	      // that means we don't have enough of the stream to parse the first
	      // line.
	      if (self.state === "INITIAL") {
	        throw new ParsingError(ParsingError.Errors.BadSignature);
	      }
	    } catch(e) {
	      self.reportOrThrowError(e);
	    }
	    self.onflush && self.onflush();
	    return this;
	  }
	};
	
	module.exports = WebVTT;


/***/ },
/* 727 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var autoKeyword = "auto";
	var directionSetting = {
	  "": 1,
	  "lr": 1,
	  "rl": 1
	};
	var alignSetting = {
	  "start": 1,
	  "center": 1,
	  "end": 1,
	  "left": 1,
	  "right": 1,
	  "auto": 1,
	  "line-left": 1,
	  "line-right": 1
	};
	
	function findDirectionSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var dir = directionSetting[value.toLowerCase()];
	  return dir ? value.toLowerCase() : false;
	}
	
	function findAlignSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var align = alignSetting[value.toLowerCase()];
	  return align ? value.toLowerCase() : false;
	}
	
	function VTTCue(startTime, endTime, text) {
	  /**
	   * Shim implementation specific properties. These properties are not in
	   * the spec.
	   */
	
	  // Lets us know when the VTTCue's data has changed in such a way that we need
	  // to recompute its display state. This lets us compute its display state
	  // lazily.
	  this.hasBeenReset = false;
	
	  /**
	   * VTTCue and TextTrackCue properties
	   * http://dev.w3.org/html5/webvtt/#vttcue-interface
	   */
	
	  var _id = "";
	  var _pauseOnExit = false;
	  var _startTime = startTime;
	  var _endTime = endTime;
	  var _text = text;
	  var _region = null;
	  var _vertical = "";
	  var _snapToLines = true;
	  var _line = "auto";
	  var _lineAlign = "start";
	  var _position = "auto";
	  var _positionAlign = "auto";
	  var _size = 100;
	  var _align = "center";
	
	  Object.defineProperties(this, {
	    "id": {
	      enumerable: true,
	      get: function() {
	        return _id;
	      },
	      set: function(value) {
	        _id = "" + value;
	      }
	    },
	
	    "pauseOnExit": {
	      enumerable: true,
	      get: function() {
	        return _pauseOnExit;
	      },
	      set: function(value) {
	        _pauseOnExit = !!value;
	      }
	    },
	
	    "startTime": {
	      enumerable: true,
	      get: function() {
	        return _startTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Start time must be set to a number.");
	        }
	        _startTime = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "endTime": {
	      enumerable: true,
	      get: function() {
	        return _endTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("End time must be set to a number.");
	        }
	        _endTime = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "text": {
	      enumerable: true,
	      get: function() {
	        return _text;
	      },
	      set: function(value) {
	        _text = "" + value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "region": {
	      enumerable: true,
	      get: function() {
	        return _region;
	      },
	      set: function(value) {
	        _region = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "vertical": {
	      enumerable: true,
	      get: function() {
	        return _vertical;
	      },
	      set: function(value) {
	        var setting = findDirectionSetting(value);
	        // Have to check for false because the setting an be an empty string.
	        if (setting === false) {
	          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
	        }
	        _vertical = setting;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "snapToLines": {
	      enumerable: true,
	      get: function() {
	        return _snapToLines;
	      },
	      set: function(value) {
	        _snapToLines = !!value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "line": {
	      enumerable: true,
	      get: function() {
	        return _line;
	      },
	      set: function(value) {
	        if (typeof value !== "number" && value !== autoKeyword) {
	          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
	        }
	        _line = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "lineAlign": {
	      enumerable: true,
	      get: function() {
	        return _lineAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          console.warn("lineAlign: an invalid or illegal string was specified.");
	        } else {
	          _lineAlign = setting;
	          this.hasBeenReset = true;
	        }
	      }
	    },
	
	    "position": {
	      enumerable: true,
	      get: function() {
	        return _position;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Position must be between 0 and 100.");
	        }
	        _position = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "positionAlign": {
	      enumerable: true,
	      get: function() {
	        return _positionAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          console.warn("positionAlign: an invalid or illegal string was specified.");
	        } else {
	          _positionAlign = setting;
	          this.hasBeenReset = true;
	        }
	      }
	    },
	
	    "size": {
	      enumerable: true,
	      get: function() {
	        return _size;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Size must be between 0 and 100.");
	        }
	        _size = value;
	        this.hasBeenReset = true;
	      }
	    },
	
	    "align": {
	      enumerable: true,
	      get: function() {
	        return _align;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
	        }
	        _align = setting;
	        this.hasBeenReset = true;
	      }
	    }
	  });
	
	  /**
	   * Other <track> spec defined properties
	   */
	
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
	  this.displayState = undefined;
	}
	
	/**
	 * VTTCue methods
	 */
	
	VTTCue.prototype.getCueAsHTML = function() {
	  // Assume WebVTT.convertCueToDOMTree is on the global.
	  return WebVTT.convertCueToDOMTree(window, this.text);
	};
	
	module.exports = VTTCue;


/***/ },
/* 728 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var scrollSetting = {
	  "": true,
	  "up": true
	};
	
	function findScrollSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var scroll = scrollSetting[value.toLowerCase()];
	  return scroll ? value.toLowerCase() : false;
	}
	
	function isValidPercentValue(value) {
	  return typeof value === "number" && (value >= 0 && value <= 100);
	}
	
	// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
	function VTTRegion() {
	  var _width = 100;
	  var _lines = 3;
	  var _regionAnchorX = 0;
	  var _regionAnchorY = 100;
	  var _viewportAnchorX = 0;
	  var _viewportAnchorY = 100;
	  var _scroll = "";
	
	  Object.defineProperties(this, {
	    "width": {
	      enumerable: true,
	      get: function() {
	        return _width;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("Width must be between 0 and 100.");
	        }
	        _width = value;
	      }
	    },
	    "lines": {
	      enumerable: true,
	      get: function() {
	        return _lines;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Lines must be set to a number.");
	        }
	        _lines = value;
	      }
	    },
	    "regionAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorX must be between 0 and 100.");
	        }
	        _regionAnchorY = value;
	      }
	    },
	    "regionAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorX;
	      },
	      set: function(value) {
	        if(!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorY must be between 0 and 100.");
	        }
	        _regionAnchorX = value;
	      }
	    },
	    "viewportAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorY must be between 0 and 100.");
	        }
	        _viewportAnchorY = value;
	      }
	    },
	    "viewportAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorX;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorX must be between 0 and 100.");
	        }
	        _viewportAnchorX = value;
	      }
	    },
	    "scroll": {
	      enumerable: true,
	      get: function() {
	        return _scroll;
	      },
	      set: function(value) {
	        var setting = findScrollSetting(value);
	        // Have to check for false as an empty string is a legal value.
	        if (setting === false) {
	          console.warn("Scroll: an invalid or illegal string was specified.");
	        } else {
	          _scroll = setting;
	        }
	      }
	    }
	  });
	}
	
	module.exports = VTTRegion;


/***/ },
/* 729 */
49,
/* 730 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 731 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 732 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.77a682d5.js